(function(){"use strict";try{if(typeof document!="undefined"){var r=document.createElement("style");r.appendChild(document.createTextNode('.dp__input_wrap{position:relative;width:100%;box-sizing:unset}.dp__input_wrap:focus{border-color:var(--dp-border-color-hover);outline:none}.dp__input{background-color:var(--dp-background-color);border-radius:var(--dp-border-radius);font-family:var(--dp-font-family);border:1px solid var(--dp-border-color);outline:none;transition:border-color .2s cubic-bezier(.645,.045,.355,1);width:100%;font-size:var(--dp-font-size);line-height:calc(var(--dp-font-size)*1.5);padding:var(--dp-input-padding);color:var(--dp-text-color);box-sizing:border-box}.dp__input::-moz-placeholder{opacity:.7}.dp__input::placeholder{opacity:.7}.dp__input:hover{border-color:var(--dp-border-color-hover)}.dp__input_reg{caret-color:#0000}.dp__input_focus{border-color:var(--dp-border-color-hover)}.dp__disabled{background:var(--dp-disabled-color)}.dp__disabled::-moz-placeholder{color:var(--dp-disabled-color-text)}.dp__disabled::placeholder{color:var(--dp-disabled-color-text)}.dp__input_icons{display:inline-block;width:var(--dp-font-size);height:var(--dp-font-size);stroke-width:0;font-size:var(--dp-font-size);line-height:calc(var(--dp-font-size)*1.5);padding:6px 12px;color:var(--dp-icon-color);box-sizing:content-box}.dp__input_icon{cursor:pointer;position:absolute;top:50%;inset-inline-start:0;transform:translateY(-50%);color:var(--dp-icon-color)}.dp__clear_icon{position:absolute;top:50%;inset-inline-end:0;transform:translateY(-50%);cursor:pointer;color:var(--dp-icon-color)}.dp__input_icon_pad{padding-inline-start:var(--dp-input-icon-padding)}.dp__input_valid{box-shadow:0 0 var(--dp-border-radius) var(--dp-success-color);border-color:var(--dp-success-color)}.dp__input_valid:hover{border-color:var(--dp-success-color)}.dp__input_invalid{box-shadow:0 0 var(--dp-border-radius) var(--dp-danger-color);border-color:var(--dp-danger-color)}.dp__input_invalid:hover{border-color:var(--dp-danger-color)}.dp__menu{background:var(--dp-background-color);border-radius:var(--dp-border-radius);min-width:var(--dp-menu-min-width);font-family:var(--dp-font-family);font-size:var(--dp-font-size);-webkit-user-select:none;-moz-user-select:none;user-select:none;border:1px solid var(--dp-menu-border-color);box-sizing:border-box}.dp__menu:after{box-sizing:border-box}.dp__menu:before{box-sizing:border-box}.dp__menu:focus{border:1px solid var(--dp-menu-border-color);outline:none}.dp--menu-wrapper{position:absolute;z-index:99999}.dp__menu_inner{padding:var(--dp-menu-padding)}.dp--menu--inner-stretched{padding:6px 0}.dp__menu_index{z-index:99999}.dp__menu_readonly,.dp__menu_disabled{position:absolute;top:0;right:0;bottom:0;left:0;z-index:999999}.dp__menu_disabled{background:rgba(255,255,255,.5);cursor:not-allowed}.dp__menu_readonly{background:rgba(0,0,0,0);cursor:default}.dp__arrow_top{left:50%;top:0;height:12px;width:12px;background-color:var(--dp-background-color);position:absolute;border-inline-end:1px solid var(--dp-menu-border-color);border-top:1px solid var(--dp-menu-border-color);transform:translate(-50%,-50%) rotate(-45deg)}.dp__arrow_bottom{left:50%;bottom:0;height:12px;width:12px;background-color:var(--dp-background-color);position:absolute;border-inline-end:1px solid var(--dp-menu-border-color);border-bottom:1px solid var(--dp-menu-border-color);transform:translate(-50%,50%) rotate(45deg)}.dp__action_extra{text-align:center;padding:2px 0}.dp--preset-dates{padding:5px;border-inline-end:1px solid var(--dp-border-color)}@media only screen and (width <= 600px){.dp--preset-dates{display:flex;align-self:center;border:none;overflow-x:auto;max-width:calc(var(--dp-menu-width) - var(--dp-action-row-padding)*2)}}.dp__sidebar_left{padding:5px;border-inline-end:1px solid var(--dp-border-color)}.dp__sidebar_right{padding:5px;margin-inline-end:1px solid var(--dp-border-color)}.dp--preset-range{display:block;width:100%;padding:5px;text-align:left;white-space:nowrap;color:var(--dp-text-color);border-radius:var(--dp-border-radius);transition:var(--dp-common-transition)}.dp--preset-range:hover{background-color:var(--dp-hover-color);color:var(--dp-hover-text-color);cursor:pointer}@media only screen and (width <= 600px){.dp--preset-range{border:1px solid var(--dp-border-color);margin:0 3px}.dp--preset-range:first-child{margin-left:0}.dp--preset-range:last-child{margin-right:0}}.dp__menu_content_wrapper{display:flex}@media only screen and (width <= 600px){.dp__menu_content_wrapper{flex-direction:column-reverse}}.dp__calendar_header{position:relative;display:flex;justify-content:center;align-items:center;color:var(--dp-text-color);white-space:nowrap;font-weight:700}.dp__calendar_header_item{text-align:center;flex-grow:1;height:var(--dp-cell-size);padding:var(--dp-cell-padding);width:var(--dp-cell-size);box-sizing:border-box}.dp__calendar_row{display:flex;justify-content:center;align-items:center;margin:var(--dp-row-margin)}.dp__calendar_item{text-align:center;flex-grow:1;box-sizing:border-box;color:var(--dp-text-color)}.dp__calendar{position:relative}.dp__calendar_header_cell{border-bottom:thin solid var(--dp-border-color);padding:var(--dp-calendar-header-cell-padding)}.dp__cell_inner{display:flex;align-items:center;text-align:center;justify-content:center;border-radius:var(--dp-cell-border-radius);height:var(--dp-cell-size);padding:var(--dp-cell-padding);width:var(--dp-cell-size);border:1px solid rgba(0,0,0,0);box-sizing:border-box;position:relative}.dp__cell_inner:hover{transition:all .2s}.dp__cell_auto_range_start,.dp__date_hover_start:hover,.dp__range_start{border-end-end-radius:0;border-start-end-radius:0}.dp__cell_auto_range_end,.dp__date_hover_end:hover,.dp__range_end{border-end-start-radius:0;border-start-start-radius:0}.dp__range_end,.dp__range_start,.dp__active_date{background:var(--dp-primary-color);color:var(--dp-primary-text-color)}.dp__cell_auto_range_end,.dp__cell_auto_range_start{border-top:1px dashed var(--dp-primary-color);border-bottom:1px dashed var(--dp-primary-color)}.dp__date_hover_end:hover,.dp__date_hover_start:hover,.dp__date_hover:hover{background:var(--dp-hover-color);color:var(--dp-hover-text-color)}.dp__cell_offset{color:var(--dp-secondary-color)}.dp__cell_disabled{color:var(--dp-secondary-color);cursor:not-allowed}.dp__range_between{background:var(--dp-range-between-dates-background-color);color:var(--dp-range-between-dates-text-color);border-radius:0;border:1px solid var(--dp-range-between-border-color)}.dp__range_between_week{background:var(--dp-primary-color);color:var(--dp-primary-text-color);border-radius:0;border-top:1px solid var(--dp-primary-color);border-bottom:1px solid var(--dp-primary-color)}.dp__today{border:1px solid var(--dp-primary-color)}.dp__week_num{color:var(--dp-secondary-color);text-align:center}.dp__cell_auto_range{border-radius:0;border-top:1px dashed var(--dp-primary-color);border-bottom:1px dashed var(--dp-primary-color)}.dp__cell_auto_range_start{border-inline-start:1px dashed var(--dp-primary-color)}.dp__cell_auto_range_end{border-inline-end:1px dashed var(--dp-primary-color)}.dp__calendar_header_separator{width:100%;height:1px;background:var(--dp-border-color)}.dp__calendar_next{margin-inline-start:var(--dp-multi-calendars-spacing)}.dp__marker_line,.dp__marker_dot{height:5px;background-color:var(--dp-marker-color);position:absolute;bottom:0}.dp__marker_dot{width:5px;border-radius:50%;left:50%;transform:translate(-50%)}.dp__marker_line{width:100%;left:0}.dp__marker_tooltip{position:absolute;border-radius:var(--dp-border-radius);background-color:var(--dp-tooltip-color);padding:5px;border:1px solid var(--dp-border-color);z-index:99999;box-sizing:border-box;cursor:default}.dp__tooltip_content{white-space:nowrap}.dp__tooltip_text{display:flex;align-items:center;flex-flow:row nowrap;color:var(--dp-text-color)}.dp__tooltip_mark{height:5px;width:5px;border-radius:50%;background-color:var(--dp-text-color);color:var(--dp-text-color);margin-inline-end:5px}.dp__arrow_bottom_tp{bottom:0;height:8px;width:8px;background-color:var(--dp-tooltip-color);position:absolute;border-inline-end:1px solid var(--dp-border-color);border-bottom:1px solid var(--dp-border-color);transform:translate(-50%,50%) rotate(45deg)}.dp__instance_calendar{position:relative;width:100%}@media only screen and (width <= 600px){.dp__flex_display{flex-direction:column}}.dp__cell_highlight{background-color:var(--dp-highlight-color)}.dp__month_year_row{display:flex;align-items:center;height:var(--dp-month-year-row-height);color:var(--dp-text-color);box-sizing:border-box}.dp__inner_nav{display:flex;align-items:center;justify-content:center;cursor:pointer;height:var(--dp-month-year-row-button-size);width:var(--dp-month-year-row-button-size);color:var(--dp-icon-color);text-align:center;border-radius:50%}.dp__inner_nav svg{height:var(--dp-button-icon-height);width:var(--dp-button-icon-height)}.dp__inner_nav:hover{background:var(--dp-hover-color);color:var(--dp-hover-icon-color)}[dir=rtl] .dp__inner_nav{transform:rotate(180deg)}.dp__inner_nav_disabled:hover,.dp__inner_nav_disabled{background:var(--dp-disabled-color);color:var(--dp-disabled-color-text);cursor:not-allowed}.dp--year-select,.dp__month_year_select{text-align:center;cursor:pointer;height:var(--dp-month-year-row-height);display:flex;align-items:center;justify-content:center;border-radius:var(--dp-border-radius);box-sizing:border-box;color:var(--dp-text-color)}.dp--year-select:hover,.dp__month_year_select:hover{background:var(--dp-hover-color);color:var(--dp-hover-text-color);transition:var(--dp-common-transition)}.dp__month_year_select{width:50%}.dp--year-select{width:100%}.dp__month_year_wrap{display:flex;width:100%}.dp__year_disable_select{justify-content:space-around}.dp__overlay{width:100%;background:var(--dp-background-color);transition:opacity 1s ease-out;z-index:99999;font-family:var(--dp-font-family);color:var(--dp-text-color);box-sizing:border-box}.dp--overlay-absolute{position:absolute;height:100%;top:0;left:0}.dp--overlay-relative{position:relative}.dp__overlay_container::-webkit-scrollbar-track{box-shadow:var(--dp-scroll-bar-background);background-color:var(--dp-scroll-bar-background)}.dp__overlay_container::-webkit-scrollbar{width:5px;background-color:var(--dp-scroll-bar-background)}.dp__overlay_container::-webkit-scrollbar-thumb{background-color:var(--dp-scroll-bar-color);border-radius:10px}.dp__overlay:focus{border:none;outline:none}.dp__container_flex{display:flex}.dp__container_block{display:block}.dp__overlay_container{flex-direction:column;overflow-y:auto}.dp__time_picker_overlay_container{height:100%}.dp__overlay_row{padding:0;box-sizing:border-box;display:flex;margin-inline:auto auto;flex-wrap:wrap;max-width:100%;width:100%;align-items:center}.dp__flex_row{flex:1}.dp__overlay_col{box-sizing:border-box;width:33%;padding:var(--dp-overlay-col-padding);white-space:nowrap}.dp__overlay_cell_pad{padding:var(--dp-common-padding) 0}.dp__overlay_cell_active{cursor:pointer;border-radius:var(--dp-border-radius);text-align:center;background:var(--dp-primary-color);color:var(--dp-primary-text-color)}.dp__overlay_cell{cursor:pointer;border-radius:var(--dp-border-radius);text-align:center}.dp__overlay_cell:hover{background:var(--dp-hover-color);color:var(--dp-hover-text-color);transition:var(--dp-common-transition)}.dp__cell_in_between{background:var(--dp-hover-color);color:var(--dp-hover-text-color)}.dp__over_action_scroll{right:5px;box-sizing:border-box}.dp__overlay_cell_disabled{cursor:not-allowed;background:var(--dp-disabled-color)}.dp__overlay_cell_disabled:hover{background:var(--dp-disabled-color)}.dp__overlay_cell_active_disabled{cursor:not-allowed;background:var(--dp-primary-disabled-color)}.dp__overlay_cell_active_disabled:hover{background:var(--dp-primary-disabled-color)}.dp__btn,.dp--qr-btn,.dp--time-invalid,.dp--time-overlay-btn{border:none;font:inherit;transition:var(--dp-common-transition);line-height:normal}.dp--tp-wrap{max-width:var(--dp-menu-min-width)}.dp__time_input{width:100%;display:flex;align-items:center;justify-content:center;-webkit-user-select:none;-moz-user-select:none;user-select:none;font-family:var(--dp-font-family);color:var(--dp-text-color)}.dp__time_col_reg_block{padding:0 20px}.dp__time_col_reg_inline{padding:0 10px}.dp__time_col_reg_with_button{padding:0 15px}.dp__time_col_sec{padding:0 10px}.dp__time_col_sec_with_button{padding:0 5px}.dp__time_col{text-align:center;display:flex;align-items:center;justify-content:center;flex-direction:column}.dp__time_col_block{font-size:var(--dp-time-font-size)}.dp__time_display{cursor:pointer;color:var(--dp-text-color);border-radius:var(--dp-border-radius);display:flex;align-items:center;justify-content:center}.dp__time_display:hover:enabled{background:var(--dp-hover-color);color:var(--dp-hover-text-color)}.dp__time_display_block{padding:0 3px}.dp__time_display_inline{padding:5px}.dp__time_picker_inline_container{display:flex;width:100%;justify-content:center}.dp__inc_dec_button{padding:5px;margin:0;height:var(--dp-time-inc-dec-button-size);width:var(--dp-time-inc-dec-button-size);display:flex;align-items:center;justify-content:center;cursor:pointer;border-radius:50%;color:var(--dp-icon-color);box-sizing:border-box}.dp__inc_dec_button svg{height:var(--dp-time-inc-dec-button-size);width:var(--dp-time-inc-dec-button-size)}.dp__inc_dec_button:hover{background:var(--dp-hover-color);color:var(--dp-primary-color)}.dp__inc_dec_button_inline{width:100%;padding:0;height:8px;cursor:pointer;display:flex;align-items:center}.dp__inc_dec_button_disabled:hover,.dp__inc_dec_button_disabled{background:var(--dp-disabled-color);color:var(--dp-disabled-color-text);cursor:not-allowed}.dp__pm_am_button{background:var(--dp-primary-color);color:var(--dp-primary-text-color);border:none;padding:var(--dp-common-padding);border-radius:var(--dp-border-radius);cursor:pointer}.dp__tp_inline_btn_bar{width:100%;height:4px;background-color:var(--dp-secondary-color);transition:var(--dp-common-transition);border-collapse:collapse}.dp__tp_inline_btn_top:hover .dp__tp_btn_in_r{background-color:var(--dp-primary-color);transform:rotate(12deg) scale(1.15) translateY(-2px)}.dp__tp_inline_btn_top:hover .dp__tp_btn_in_l,.dp__tp_inline_btn_bottom:hover .dp__tp_btn_in_r{background-color:var(--dp-primary-color);transform:rotate(-12deg) scale(1.15) translateY(-2px)}.dp__tp_inline_btn_bottom:hover .dp__tp_btn_in_l{background-color:var(--dp-primary-color);transform:rotate(12deg) scale(1.15) translateY(-2px)}.dp--time-overlay-btn{background:none}.dp--time-invalid{background-color:var(--dp-disabled-color)}.dp__action_row{display:flex;align-items:center;width:100%;padding:var(--dp-action-row-padding);box-sizing:border-box;color:var(--dp-text-color);flex-flow:row nowrap}.dp__action_row svg{height:var(--dp-button-icon-height);width:auto}.dp__selection_preview{display:block;color:var(--dp-text-color);font-size:var(--dp-preview-font-size);overflow:hidden;white-space:nowrap;text-overflow:ellipsis}.dp__action_buttons{display:flex;flex:0;align-items:center;justify-content:flex-end;margin-inline-start:auto}.dp__action_button{display:inline-flex;align-items:center;background:rgba(0,0,0,0);border:1px solid rgba(0,0,0,0);padding:var(--dp-action-buttons-padding);line-height:var(--dp-action-button-height);margin-inline-start:3px;height:var(--dp-action-button-height);cursor:pointer;border-radius:var(--dp-border-radius);font-size:var(--dp-preview-font-size);font-family:var(--dp-font-family)}.dp__action_select{background:var(--dp-primary-color);color:var(--dp-primary-text-color)}.dp__action_select:hover{background:var(--dp-primary-color);transition:var(--dp-action-row-transtion)}.dp__action_select:disabled{background:var(--dp-primary-disabled-color);cursor:not-allowed}.dp__action_cancel{color:var(--dp-text-color);border:1px solid var(--dp-border-color)}.dp__action_cancel:hover{border-color:var(--dp-primary-color);transition:var(--dp-action-row-transtion)}.dp-quarter-picker-wrap{display:flex;flex-direction:column;height:100%;min-width:var(--dp-menu-min-width)}.dp--qr-btn{width:100%;padding:var(--dp-common-padding)}.dp--qr-btn:not(.dp--highlighted,.dp--qr-btn-active,.dp--qr-btn-disabled,.dp--qr-btn-between){background:none}.dp--qr-btn:hover:not(.dp--qr-btn-active,.dp--qr-btn-disabled){background:var(--dp-hover-color);color:var(--dp-hover-text-color);transition:var(--dp-common-transition)}.dp--quarter-items{display:flex;flex-direction:column;flex:1;width:100%;height:100%;justify-content:space-evenly}.dp--qr-btn-active{background:var(--dp-primary-color);color:var(--dp-primary-text-color)}.dp--qr-btn-between{background:var(--dp-hover-color);color:var(--dp-hover-text-color)}.dp--qr-btn-disabled{cursor:not-allowed;background:var(--dp-disabled-color)}.dp--qr-btn-disabled:hover{background:var(--dp-disabled-color)}.dp__btn,.dp--time-overlay-btn,.dp--time-invalid,.dp--qr-btn{border:none;font:inherit;transition:var(--dp-common-transition);line-height:normal}.dp--year-mode-picker{display:flex;width:100%;align-items:center;justify-content:space-between;height:var(--dp-cell-size)}:root{--dp-common-transition: all .1s ease-in;--dp-menu-padding: 6px 8px;--dp-animation-duration: .1s;--dp-menu-appear-transition-timing: cubic-bezier(.4, 0, 1, 1);--dp-transition-timing: ease-out;--dp-action-row-transtion: all .2s ease-in;--dp-font-family: -apple-system, blinkmacsystemfont, "Segoe UI", roboto, oxygen, ubuntu, cantarell, "Open Sans", "Helvetica Neue", sans-serif;--dp-border-radius: 4px;--dp-cell-border-radius: 4px;--dp-transition-length: 22px;--dp-transition-timing-general: .1s;--dp-button-height: 35px;--dp-month-year-row-height: 35px;--dp-month-year-row-button-size: 25px;--dp-button-icon-height: 20px;--dp-calendar-wrap-padding: 0 5px;--dp-cell-size: 35px;--dp-cell-padding: 5px;--dp-common-padding: 10px;--dp-input-icon-padding: 35px;--dp-input-padding: 6px 30px 6px 12px;--dp-menu-min-width: 260px;--dp-action-buttons-padding: 1px 6px;--dp-row-margin: 5px 0;--dp-calendar-header-cell-padding: .5rem;--dp-multi-calendars-spacing: 10px;--dp-overlay-col-padding: 3px;--dp-time-inc-dec-button-size: 32px;--dp-font-size: 1rem;--dp-preview-font-size: .8rem;--dp-time-font-size: 2rem;--dp-action-button-height: 22px;--dp-action-row-padding: 8px}.dp__theme_light{--dp-background-color: #fff;--dp-text-color: #212121;--dp-hover-color: #f3f3f3;--dp-hover-text-color: #212121;--dp-hover-icon-color: #959595;--dp-primary-color: #1976d2;--dp-primary-disabled-color: #6bacea;--dp-primary-text-color: #f8f5f5;--dp-secondary-color: #c0c4cc;--dp-border-color: #ddd;--dp-menu-border-color: #ddd;--dp-border-color-hover: #aaaeb7;--dp-disabled-color: #f6f6f6;--dp-scroll-bar-background: #f3f3f3;--dp-scroll-bar-color: #959595;--dp-success-color: #76d275;--dp-success-color-disabled: #a3d9b1;--dp-icon-color: #959595;--dp-danger-color: #ff6f60;--dp-marker-color: #ff6f60;--dp-tooltip-color: #fafafa;--dp-disabled-color-text: #8e8e8e;--dp-highlight-color: rgb(25 118 210 / 10%);--dp-range-between-dates-background-color: var(--dp-hover-color, #f3f3f3);--dp-range-between-dates-text-color: var(--dp-hover-text-color, #212121);--dp-range-between-border-color: var(--dp-hover-color, #f3f3f3)}.dp__flex{display:flex;align-items:center}.dp__btn{background:none}.dp__main{font-family:var(--dp-font-family);-webkit-user-select:none;-moz-user-select:none;user-select:none;box-sizing:border-box;position:relative;width:100%}.dp__pointer{cursor:pointer}.dp__icon{stroke:currentcolor;fill:currentcolor}.dp__button{width:100%;text-align:center;color:var(--dp-icon-color);cursor:pointer;display:flex;align-items:center;place-content:center center;padding:var(--dp-common-padding);box-sizing:border-box;height:var(--dp-button-height)}.dp__button.dp__overlay_action{position:absolute;bottom:0}.dp__button:hover{background:var(--dp-hover-color);color:var(--dp-hover-icon-color)}.dp__button svg{height:var(--dp-button-icon-height);width:auto}.dp__button_bottom{border-bottom-left-radius:var(--dp-border-radius);border-bottom-right-radius:var(--dp-border-radius)}.dp__flex_display{display:flex}.dp__flex_display_with_input{flex-direction:column;align-items:flex-start}.dp__relative{position:relative}.calendar-next-enter-active,.calendar-next-leave-active,.calendar-prev-enter-active,.calendar-prev-leave-active{transition:all var(--dp-transition-timing-general) ease-out}.calendar-next-enter-from{opacity:0;transform:translate(var(--dp-transition-length))}.calendar-next-leave-to,.calendar-prev-enter-from{opacity:0;transform:translate(calc(var(--dp-transition-length) * -1))}.calendar-prev-leave-to{opacity:0;transform:translate(var(--dp-transition-length))}.dp-menu-appear-bottom-enter-active,.dp-menu-appear-bottom-leave-active,.dp-menu-appear-top-enter-active,.dp-menu-appear-top-leave-active,.dp-slide-up-enter-active,.dp-slide-up-leave-active,.dp-slide-down-enter-active,.dp-slide-down-leave-active{transition:all var(--dp-animation-duration) var(--dp-transition-timing)}.dp-menu-appear-top-enter-from,.dp-menu-appear-top-leave-to,.dp-slide-down-leave-to,.dp-slide-up-enter-from{opacity:0;transform:translateY(var(--dp-transition-length))}.dp-menu-appear-bottom-enter-from,.dp-menu-appear-bottom-leave-to,.dp-slide-down-enter-from,.dp-slide-up-leave-to{opacity:0;transform:translateY(calc(var(--dp-transition-length) * -1))}.dp--arrow-btn-nav{transition:var(--dp-common-transition)}.dp--highlighted{background-color:var(--dp-highlight-color)}:root{--dp-font-family: -apple-system, blinkmacsystemfont, "Segoe UI", roboto, oxygen, ubuntu, cantarell, "Open Sans", "Helvetica Neue", sans-serif;--dp-border-radius: 4px;--dp-cell-border-radius: 4px;--dp-common-transition: all .1s ease-in;--dp-button-height: 35px;--dp-month-year-row-height: 35px;--dp-month-year-row-button-size: 35px;--dp-button-icon-height: 20px;--dp-cell-size: 35px;--dp-cell-padding: 5px;--dp-common-padding: 10px;--dp-input-icon-padding: 35px;--dp-input-padding: 6px 30px 6px 12px;--dp-menu-min-width: 260px;--dp-action-buttons-padding: 2px 5px;--dp-row-margin: 5px 0;--dp-calendar-header-cell-padding: .5rem;--dp-two-calendars-spacing: 10px;--dp-overlay-col-padding: 3px;--dp-time-inc-dec-button-size: 32px;--dp-menu-padding: 6px 8px;--dp-font-size: 1rem;--dp-preview-font-size: .8rem;--dp-time-font-size: .8rem;--dp-animation-duration: .1s;--dp-menu-appear-transition-timing: cubic-bezier( .4, 0, 1, 1 );--dp-transition-timing: ease-out}.dp__theme_light{--dp-background-color: #ffffff;--dp-text-color: #212121;--dp-hover-color: #f3f3f3;--dp-hover-text-color: #212121;--dp-hover-icon-color: #959595;--dp-primary-color: #1976d2;--dp-primary-disabled-color: #6bacea;--dp-primary-text-color: #f8f5f5;--dp-secondary-color: #c0c4cc;--dp-border-color: #ddd;--dp-menu-border-color: #ddd;--dp-border-color-hover: #aaaeb7;--dp-disabled-color: #f6f6f6;--dp-scroll-bar-background: #f3f3f3;--dp-scroll-bar-color: #959595;--dp-success-color: #76d275;--dp-success-color-disabled: #a3d9b1;--dp-icon-color: #959595;--dp-danger-color: #ff6f60;--dp-marker-color: #ff6f60;--dp-tooltip-color: #fafafa;--dp-disabled-color-text: #8e8e8e;--dp-highlight-color: rgb(25 118 210 / 10%);--dp-range-between-dates-background-color: var(--dp-hover-color, #f3f3f3);--dp-range-between-dates-text-color: var(--dp-hover-text-color, #212121);--dp-range-between-border-color: var(--dp-hover-color, #f3f3f3)}.dp__theme_dark{--dp-background-color: #212121;--dp-text-color: #fff;--dp-hover-color: #484848;--dp-hover-text-color: #fff;--dp-hover-icon-color: #959595;--dp-primary-color: #005cb2;--dp-primary-disabled-color: #61a8ea;--dp-primary-text-color: #fff;--dp-secondary-color: #a9a9a9;--dp-border-color: #2d2d2d;--dp-menu-border-color: #2d2d2d;--dp-border-color-hover: #aaaeb7;--dp-disabled-color: #737373;--dp-disabled-color-text: #d0d0d0;--dp-scroll-bar-background: #212121;--dp-scroll-bar-color: #484848;--dp-success-color: #00701a;--dp-success-color-disabled: #428f59;--dp-icon-color: #959595;--dp-danger-color: #e53935;--dp-marker-color: #e53935;--dp-tooltip-color: #3e3e3e;--dp-highlight-color: rgb(0 92 178 / 20%);--dp-range-between-dates-background-color: var(--dp-hover-color, #484848);--dp-range-between-dates-text-color: var(--dp-hover-text-color, #fff);--dp-range-between-border-color: var(--dp-hover-color, #fff)}.iframe-container{position:relative;padding-bottom:56.25%;height:0;overflow:hidden;max-width:100%}.iframe-container iframe{position:absolute;top:0;left:0;width:100%;height:100%}')),document.head.appendChild(r)}}catch(o){console.error("vite-plugin-css-injected-by-js",o)}})();
import { h as L9, getCurrentInstance as uI, computed as N, inject as N9, defineAsyncComponent as hI, openBlock as d, createBlock as Q, unref as u, normalizeProps as P, mergeProps as H, createCommentVNode as v, ref as W, watch as ot, resolveDynamicComponent as mt, withCtx as ke, renderSlot as ee, createElementBlock as y, toDisplayString as G, guardReactiveProps as X, createElementVNode as D, toHandlers as S9, onMounted as at, onUnmounted as $r, toRef as ia, createVNode as be, Fragment as ge, renderList as Ie, toRaw as i1, useAttrs as KL, normalizeClass as Pe, reactive as u1, defineComponent as dt, useSlots as Lr, nextTick as Gt, isRef as C9, createSlots as kt, Teleport as QL, Transition as Rr, render as Hb, withKeys as Ae, withModifiers as Ue, normalizeStyle as yt, createTextVNode as wt, onBeforeUpdate as JL, withDirectives as Zt, vShow as Yt, getCurrentScope as eS, onScopeDispose as tS, resolveComponent as Dx, isReactive as aS } from "vue";
var w1 = {
  xmlns: "http://www.w3.org/2000/svg",
  width: 24,
  height: 24,
  viewBox: "0 0 24 24",
  fill: "none",
  stroke: "currentColor",
  "stroke-width": 2,
  "stroke-linecap": "round",
  "stroke-linejoin": "round"
};
const nS = (e) => e.replace(/([a-z0-9])([A-Z])/g, "$1-$2").toLowerCase();
const r = (e, t) => ({ size: a, strokeWidth: o = 2, absoluteStrokeWidth: n, color: i, class: l, ...c }, { attrs: s, slots: h }) => L9(
  "svg",
  {
    ...w1,
    width: a || w1.width,
    height: a || w1.height,
    stroke: i || w1.stroke,
    "stroke-width": n ? Number(o) * 24 / Number(a) : o,
    ...s,
    class: ["lucide", `lucide-${nS(e)}`],
    ...c
  },
  [...t.map((m) => L9(...m)), ...h.default ? [h.default()] : []]
);
const T1 = r("AArrowDownIcon", [
  ["path", { d: "M3.5 13h6", key: "p1my2r" }],
  ["path", { d: "m2 16 4.5-9 4.5 9", key: "ndf0b3" }],
  ["path", { d: "M18 7v9", key: "pknjwm" }],
  ["path", { d: "m14 12 4 4 4-4", key: "buelq4" }]
]);
const D1 = r("AArrowUpIcon", [
  ["path", { d: "M3.5 13h6", key: "p1my2r" }],
  ["path", { d: "m2 16 4.5-9 4.5 9", key: "ndf0b3" }],
  ["path", { d: "M18 16V7", key: "ty0viw" }],
  ["path", { d: "m14 11 4-4 4 4", key: "1pu57t" }]
]);
const _1 = r("ALargeSmallIcon", [
  ["path", { d: "M21 14h-5", key: "1vh23k" }],
  ["path", { d: "M16 16v-3.5a2.5 2.5 0 0 1 5 0V16", key: "1wh10o" }],
  ["path", { d: "M4.5 13h6", key: "dfilno" }],
  ["path", { d: "m3 16 4.5-9 4.5 9", key: "2dxa0e" }]
]);
const B1 = r("AccessibilityIcon", [
  ["circle", { cx: "16", cy: "4", r: "1", key: "1grugj" }],
  ["path", { d: "m18 19 1-7-6 1", key: "r0i19z" }],
  ["path", { d: "m5 8 3-3 5.5 3-2.36 3.5", key: "9ptxx2" }],
  ["path", { d: "M4.24 14.5a5 5 0 0 0 6.88 6", key: "10kmtu" }],
  ["path", { d: "M13.76 17.5a5 5 0 0 0-6.88-6", key: "2qq6rc" }]
]);
const z1 = r("ActivityIcon", [
  ["path", { d: "M22 12h-4l-3 9L9 3l-3 9H2", key: "d5dnw9" }]
]);
const H1 = r("AirVentIcon", [
  [
    "path",
    {
      d: "M6 12H4a2 2 0 0 1-2-2V5a2 2 0 0 1 2-2h16a2 2 0 0 1 2 2v5a2 2 0 0 1-2 2h-2",
      key: "larmp2"
    }
  ],
  ["path", { d: "M6 8h12", key: "6g4wlu" }],
  ["path", { d: "M18.3 17.7a2.5 2.5 0 0 1-3.16 3.83 2.53 2.53 0 0 1-1.14-2V12", key: "1bo8pg" }],
  ["path", { d: "M6.6 15.6A2 2 0 1 0 10 17v-5", key: "t9h90c" }]
]);
const j1 = r("AirplayIcon", [
  [
    "path",
    {
      d: "M5 17H4a2 2 0 0 1-2-2V5a2 2 0 0 1 2-2h16a2 2 0 0 1 2 2v10a2 2 0 0 1-2 2h-1",
      key: "ns4c3b"
    }
  ],
  ["path", { d: "m12 15 5 6H7Z", key: "14qnn2" }]
]);
const da = r("AlarmClockCheckIcon", [
  ["circle", { cx: "12", cy: "13", r: "8", key: "3y4lt7" }],
  ["path", { d: "M5 3 2 6", key: "18tl5t" }],
  ["path", { d: "m22 6-3-3", key: "1opdir" }],
  ["path", { d: "M6.38 18.7 4 21", key: "17xu3x" }],
  ["path", { d: "M17.64 18.67 20 21", key: "kv2oe2" }],
  ["path", { d: "m9 13 2 2 4-4", key: "6343dt" }]
]);
const sa = r("AlarmClockMinusIcon", [
  ["circle", { cx: "12", cy: "13", r: "8", key: "3y4lt7" }],
  ["path", { d: "M5 3 2 6", key: "18tl5t" }],
  ["path", { d: "m22 6-3-3", key: "1opdir" }],
  ["path", { d: "M6.38 18.7 4 21", key: "17xu3x" }],
  ["path", { d: "M17.64 18.67 20 21", key: "kv2oe2" }],
  ["path", { d: "M9 13h6", key: "1uhe8q" }]
]);
const V1 = r("AlarmClockOffIcon", [
  ["path", { d: "M6.87 6.87a8 8 0 1 0 11.26 11.26", key: "3on8tj" }],
  ["path", { d: "M19.9 14.25a8 8 0 0 0-9.15-9.15", key: "15ghsc" }],
  ["path", { d: "m22 6-3-3", key: "1opdir" }],
  ["path", { d: "M6.26 18.67 4 21", key: "yzmioq" }],
  ["path", { d: "m2 2 20 20", key: "1ooewy" }],
  ["path", { d: "M4 4 2 6", key: "1ycko6" }]
]);
const ua = r("AlarmClockPlusIcon", [
  ["circle", { cx: "12", cy: "13", r: "8", key: "3y4lt7" }],
  ["path", { d: "M5 3 2 6", key: "18tl5t" }],
  ["path", { d: "m22 6-3-3", key: "1opdir" }],
  ["path", { d: "M6.38 18.7 4 21", key: "17xu3x" }],
  ["path", { d: "M17.64 18.67 20 21", key: "kv2oe2" }],
  ["path", { d: "M12 10v6", key: "1bos4e" }],
  ["path", { d: "M9 13h6", key: "1uhe8q" }]
]);
const O1 = r("AlarmClockIcon", [
  ["circle", { cx: "12", cy: "13", r: "8", key: "3y4lt7" }],
  ["path", { d: "M12 9v4l2 2", key: "1c63tq" }],
  ["path", { d: "M5 3 2 6", key: "18tl5t" }],
  ["path", { d: "m22 6-3-3", key: "1opdir" }],
  ["path", { d: "M6.38 18.7 4 21", key: "17xu3x" }],
  ["path", { d: "M17.64 18.67 20 21", key: "kv2oe2" }]
]);
const $1 = r("AlarmSmokeIcon", [
  ["path", { d: "M4 8a2 2 0 0 1-2-2V3h20v3a2 2 0 0 1-2 2Z", key: "2c4fvq" }],
  ["path", { d: "m19 8-.8 3c-.1.6-.6 1-1.2 1H7c-.6 0-1.1-.4-1.2-1L5 8", key: "1vrndv" }],
  ["path", { d: "M16 21c0-2.5 2-2.5 2-5", key: "1o3eny" }],
  ["path", { d: "M11 21c0-2.5 2-2.5 2-5", key: "1sicvv" }],
  ["path", { d: "M6 21c0-2.5 2-2.5 2-5", key: "i3w1gp" }]
]);
const R1 = r("AlbumIcon", [
  ["rect", { width: "18", height: "18", x: "3", y: "3", rx: "2", ry: "2", key: "1m3agn" }],
  ["polyline", { points: "11 3 11 11 14 8 17 11 17 3", key: "1wcwz3" }]
]);
const F1 = r("AlignCenterHorizontalIcon", [
  ["path", { d: "M2 12h20", key: "9i4pu4" }],
  ["path", { d: "M10 16v4a2 2 0 0 1-2 2H6a2 2 0 0 1-2-2v-4", key: "11f1s0" }],
  ["path", { d: "M10 8V4a2 2 0 0 0-2-2H6a2 2 0 0 0-2 2v4", key: "t14dx9" }],
  ["path", { d: "M20 16v1a2 2 0 0 1-2 2h-2a2 2 0 0 1-2-2v-1", key: "1w07xs" }],
  ["path", { d: "M14 8V7c0-1.1.9-2 2-2h2a2 2 0 0 1 2 2v1", key: "1apec2" }]
]);
const U1 = r("AlignCenterVerticalIcon", [
  ["path", { d: "M12 2v20", key: "t6zp3m" }],
  ["path", { d: "M8 10H4a2 2 0 0 1-2-2V6c0-1.1.9-2 2-2h4", key: "14d6g8" }],
  ["path", { d: "M16 10h4a2 2 0 0 0 2-2V6a2 2 0 0 0-2-2h-4", key: "1e2lrw" }],
  ["path", { d: "M8 20H7a2 2 0 0 1-2-2v-2c0-1.1.9-2 2-2h1", key: "1fkdwx" }],
  ["path", { d: "M16 14h1a2 2 0 0 1 2 2v2a2 2 0 0 1-2 2h-1", key: "1euafb" }]
]);
const E1 = r("AlignCenterIcon", [
  ["line", { x1: "21", x2: "3", y1: "6", y2: "6", key: "1fp77t" }],
  ["line", { x1: "17", x2: "7", y1: "12", y2: "12", key: "rsh8ii" }],
  ["line", { x1: "19", x2: "5", y1: "18", y2: "18", key: "1t0tuv" }]
]);
const W1 = r("AlignEndHorizontalIcon", [
  ["rect", { width: "6", height: "16", x: "4", y: "2", rx: "2", key: "z5wdxg" }],
  ["rect", { width: "6", height: "9", x: "14", y: "9", rx: "2", key: "um7a8w" }],
  ["path", { d: "M22 22H2", key: "19qnx5" }]
]);
const N1 = r("AlignEndVerticalIcon", [
  ["rect", { width: "16", height: "6", x: "2", y: "4", rx: "2", key: "10wcwx" }],
  ["rect", { width: "9", height: "6", x: "9", y: "14", rx: "2", key: "4p5bwg" }],
  ["path", { d: "M22 22V2", key: "12ipfv" }]
]);
const Z1 = r("AlignHorizontalDistributeCenterIcon", [
  ["rect", { width: "6", height: "14", x: "4", y: "5", rx: "2", key: "1wwnby" }],
  ["rect", { width: "6", height: "10", x: "14", y: "7", rx: "2", key: "1fe6j6" }],
  ["path", { d: "M17 22v-5", key: "4b6g73" }],
  ["path", { d: "M17 7V2", key: "hnrr36" }],
  ["path", { d: "M7 22v-3", key: "1r4jpn" }],
  ["path", { d: "M7 5V2", key: "liy1u9" }]
]);
const Y1 = r("AlignHorizontalDistributeEndIcon", [
  ["rect", { width: "6", height: "14", x: "4", y: "5", rx: "2", key: "1wwnby" }],
  ["rect", { width: "6", height: "10", x: "14", y: "7", rx: "2", key: "1fe6j6" }],
  ["path", { d: "M10 2v20", key: "uyc634" }],
  ["path", { d: "M20 2v20", key: "1tx262" }]
]);
const G1 = r("AlignHorizontalDistributeStartIcon", [
  ["rect", { width: "6", height: "14", x: "4", y: "5", rx: "2", key: "1wwnby" }],
  ["rect", { width: "6", height: "10", x: "14", y: "7", rx: "2", key: "1fe6j6" }],
  ["path", { d: "M4 2v20", key: "gtpd5x" }],
  ["path", { d: "M14 2v20", key: "tg6bpw" }]
]);
const X1 = r("AlignHorizontalJustifyCenterIcon", [
  ["rect", { width: "6", height: "14", x: "2", y: "5", rx: "2", key: "dy24zr" }],
  ["rect", { width: "6", height: "10", x: "16", y: "7", rx: "2", key: "13zkjt" }],
  ["path", { d: "M12 2v20", key: "t6zp3m" }]
]);
const K1 = r("AlignHorizontalJustifyEndIcon", [
  ["rect", { width: "6", height: "14", x: "2", y: "5", rx: "2", key: "dy24zr" }],
  ["rect", { width: "6", height: "10", x: "12", y: "7", rx: "2", key: "1ht384" }],
  ["path", { d: "M22 2v20", key: "40qfg1" }]
]);
const Q1 = r("AlignHorizontalJustifyStartIcon", [
  ["rect", { width: "6", height: "14", x: "6", y: "5", rx: "2", key: "hsirpf" }],
  ["rect", { width: "6", height: "10", x: "16", y: "7", rx: "2", key: "13zkjt" }],
  ["path", { d: "M2 2v20", key: "1ivd8o" }]
]);
const J1 = r("AlignHorizontalSpaceAroundIcon", [
  ["rect", { width: "6", height: "10", x: "9", y: "7", rx: "2", key: "yn7j0q" }],
  ["path", { d: "M4 22V2", key: "tsjzd3" }],
  ["path", { d: "M20 22V2", key: "1bnhr8" }]
]);
const ei = r("AlignHorizontalSpaceBetweenIcon", [
  ["rect", { width: "6", height: "14", x: "3", y: "5", rx: "2", key: "j77dae" }],
  ["rect", { width: "6", height: "10", x: "15", y: "7", rx: "2", key: "bq30hj" }],
  ["path", { d: "M3 2v20", key: "1d2pfg" }],
  ["path", { d: "M21 2v20", key: "p059bm" }]
]);
const ti = r("AlignJustifyIcon", [
  ["line", { x1: "3", x2: "21", y1: "6", y2: "6", key: "4m8b97" }],
  ["line", { x1: "3", x2: "21", y1: "12", y2: "12", key: "10d38w" }],
  ["line", { x1: "3", x2: "21", y1: "18", y2: "18", key: "kwyyxn" }]
]);
const ai = r("AlignLeftIcon", [
  ["line", { x1: "21", x2: "3", y1: "6", y2: "6", key: "1fp77t" }],
  ["line", { x1: "15", x2: "3", y1: "12", y2: "12", key: "v6grx8" }],
  ["line", { x1: "17", x2: "3", y1: "18", y2: "18", key: "1awlsn" }]
]);
const ni = r("AlignRightIcon", [
  ["line", { x1: "21", x2: "3", y1: "6", y2: "6", key: "1fp77t" }],
  ["line", { x1: "21", x2: "9", y1: "12", y2: "12", key: "1uyos4" }],
  ["line", { x1: "21", x2: "7", y1: "18", y2: "18", key: "1g9eri" }]
]);
const oi = r("AlignStartHorizontalIcon", [
  ["rect", { width: "6", height: "16", x: "4", y: "6", rx: "2", key: "1n4dg1" }],
  ["rect", { width: "6", height: "9", x: "14", y: "6", rx: "2", key: "17khns" }],
  ["path", { d: "M22 2H2", key: "fhrpnj" }]
]);
const ri = r("AlignStartVerticalIcon", [
  ["rect", { width: "9", height: "6", x: "6", y: "14", rx: "2", key: "lpm2y7" }],
  ["rect", { width: "16", height: "6", x: "6", y: "4", rx: "2", key: "rdj6ps" }],
  ["path", { d: "M2 2v20", key: "1ivd8o" }]
]);
const ii = r("AlignVerticalDistributeCenterIcon", [
  ["path", { d: "M22 17h-3", key: "1lwga1" }],
  ["path", { d: "M22 7h-5", key: "o2endc" }],
  ["path", { d: "M5 17H2", key: "1gx9xc" }],
  ["path", { d: "M7 7H2", key: "6bq26l" }],
  ["rect", { x: "5", y: "14", width: "14", height: "6", rx: "2", key: "1qrzuf" }],
  ["rect", { x: "7", y: "4", width: "10", height: "6", rx: "2", key: "we8e9z" }]
]);
const li = r("AlignVerticalDistributeEndIcon", [
  ["rect", { width: "14", height: "6", x: "5", y: "14", rx: "2", key: "jmoj9s" }],
  ["rect", { width: "10", height: "6", x: "7", y: "4", rx: "2", key: "aza5on" }],
  ["path", { d: "M2 20h20", key: "owomy5" }],
  ["path", { d: "M2 10h20", key: "1ir3d8" }]
]);
const ci = r("AlignVerticalDistributeStartIcon", [
  ["rect", { width: "14", height: "6", x: "5", y: "14", rx: "2", key: "jmoj9s" }],
  ["rect", { width: "10", height: "6", x: "7", y: "4", rx: "2", key: "aza5on" }],
  ["path", { d: "M2 14h20", key: "myj16y" }],
  ["path", { d: "M2 4h20", key: "mda7wb" }]
]);
const di = r("AlignVerticalJustifyCenterIcon", [
  ["rect", { width: "14", height: "6", x: "5", y: "16", rx: "2", key: "1i8z2d" }],
  ["rect", { width: "10", height: "6", x: "7", y: "2", rx: "2", key: "ypihtt" }],
  ["path", { d: "M2 12h20", key: "9i4pu4" }]
]);
const si = r("AlignVerticalJustifyEndIcon", [
  ["rect", { width: "14", height: "6", x: "5", y: "12", rx: "2", key: "4l4tp2" }],
  ["rect", { width: "10", height: "6", x: "7", y: "2", rx: "2", key: "ypihtt" }],
  ["path", { d: "M2 22h20", key: "272qi7" }]
]);
const ui = r("AlignVerticalJustifyStartIcon", [
  ["rect", { width: "14", height: "6", x: "5", y: "16", rx: "2", key: "1i8z2d" }],
  ["rect", { width: "10", height: "6", x: "7", y: "6", rx: "2", key: "13squh" }],
  ["path", { d: "M2 2h20", key: "1ennik" }]
]);
const hi = r("AlignVerticalSpaceAroundIcon", [
  ["rect", { width: "10", height: "6", x: "7", y: "9", rx: "2", key: "b1zbii" }],
  ["path", { d: "M22 20H2", key: "1p1f7z" }],
  ["path", { d: "M22 4H2", key: "1b7qnq" }]
]);
const pi = r("AlignVerticalSpaceBetweenIcon", [
  ["rect", { width: "14", height: "6", x: "5", y: "15", rx: "2", key: "1w91an" }],
  ["rect", { width: "10", height: "6", x: "7", y: "3", rx: "2", key: "17wqzy" }],
  ["path", { d: "M2 21h20", key: "1nyx9w" }],
  ["path", { d: "M2 3h20", key: "91anmk" }]
]);
const yi = r("AmbulanceIcon", [
  ["path", { d: "M10 10H6", key: "1bsnug" }],
  ["path", { d: "M14 18V6a2 2 0 0 0-2-2H4a2 2 0 0 0-2 2v11a1 1 0 0 0 1 1h2", key: "wrbu53" }],
  [
    "path",
    {
      d: "M19 18h2a1 1 0 0 0 1-1v-3.28a1 1 0 0 0-.684-.948l-1.923-.641a1 1 0 0 1-.578-.502l-1.539-3.076A1 1 0 0 0 16.382 8H14",
      key: "lrkjwd"
    }
  ],
  ["path", { d: "M8 8v4", key: "1fwk8c" }],
  ["path", { d: "M9 18h6", key: "x1upvd" }],
  ["circle", { cx: "17", cy: "18", r: "2", key: "332jqn" }],
  ["circle", { cx: "7", cy: "18", r: "2", key: "19iecd" }]
]);
const ki = r("AmpersandIcon", [
  [
    "path",
    {
      d: "M17.5 12c0 4.4-3.6 8-8 8A4.5 4.5 0 0 1 5 15.5c0-6 8-4 8-8.5a3 3 0 1 0-6 0c0 3 2.5 8.5 12 13",
      key: "1o9ehi"
    }
  ],
  ["path", { d: "M16 12h3", key: "4uvgyw" }]
]);
const fi = r("AmpersandsIcon", [
  [
    "path",
    {
      d: "M10 17c-5-3-7-7-7-9a2 2 0 0 1 4 0c0 2.5-5 2.5-5 6 0 1.7 1.3 3 3 3 2.8 0 5-2.2 5-5",
      key: "12lh1k"
    }
  ],
  [
    "path",
    {
      d: "M22 17c-5-3-7-7-7-9a2 2 0 0 1 4 0c0 2.5-5 2.5-5 6 0 1.7 1.3 3 3 3 2.8 0 5-2.2 5-5",
      key: "173c68"
    }
  ]
]);
const vi = r("AnchorIcon", [
  ["path", { d: "M12 22V8", key: "qkxhtm" }],
  ["path", { d: "M5 12H2a10 10 0 0 0 20 0h-3", key: "1hv3nh" }],
  ["circle", { cx: "12", cy: "5", r: "3", key: "rqqgnr" }]
]);
const mi = r("AngryIcon", [
  ["circle", { cx: "12", cy: "12", r: "10", key: "1mglay" }],
  ["path", { d: "M16 16s-1.5-2-4-2-4 2-4 2", key: "epbg0q" }],
  ["path", { d: "M7.5 8 10 9", key: "olxxln" }],
  ["path", { d: "m14 9 2.5-1", key: "1j6cij" }],
  ["path", { d: "M9 10h0", key: "1vxvly" }],
  ["path", { d: "M15 10h0", key: "1j6oav" }]
]);
const gi = r("AnnoyedIcon", [
  ["circle", { cx: "12", cy: "12", r: "10", key: "1mglay" }],
  ["path", { d: "M8 15h8", key: "45n4r" }],
  ["path", { d: "M8 9h2", key: "1g203m" }],
  ["path", { d: "M14 9h2", key: "116p9w" }]
]);
const Mi = r("AntennaIcon", [
  ["path", { d: "M2 12 7 2", key: "117k30" }],
  ["path", { d: "m7 12 5-10", key: "1tvx22" }],
  ["path", { d: "m12 12 5-10", key: "ev1o1a" }],
  ["path", { d: "m17 12 5-10", key: "1e4ti3" }],
  ["path", { d: "M4.5 7h15", key: "vlsxkz" }],
  ["path", { d: "M12 16v6", key: "c8a4gj" }]
]);
const xi = r("AnvilIcon", [
  ["path", { d: "M7 10H6a4 4 0 0 1-4-4 1 1 0 0 1 1-1h4", key: "1hjpb6" }],
  [
    "path",
    { d: "M7 5a1 1 0 0 1 1-1h13a1 1 0 0 1 1 1 7 7 0 0 1-7 7H8a1 1 0 0 1-1-1z", key: "1qn45f" }
  ],
  ["path", { d: "M9 12v5", key: "3anwtq" }],
  ["path", { d: "M15 12v5", key: "5xh3zn" }],
  [
    "path",
    { d: "M5 20a3 3 0 0 1 3-3h8a3 3 0 0 1 3 3 1 1 0 0 1-1 1H6a1 1 0 0 1-1-1", key: "1fi4x8" }
  ]
]);
const bi = r("ApertureIcon", [
  ["circle", { cx: "12", cy: "12", r: "10", key: "1mglay" }],
  ["path", { d: "m14.31 8 5.74 9.94", key: "1y6ab4" }],
  ["path", { d: "M9.69 8h11.48", key: "1wxppr" }],
  ["path", { d: "m7.38 12 5.74-9.94", key: "1grp0k" }],
  ["path", { d: "M9.69 16 3.95 6.06", key: "libnyf" }],
  ["path", { d: "M14.31 16H2.83", key: "x5fava" }],
  ["path", { d: "m16.62 12-5.74 9.94", key: "1vwawt" }]
]);
const wi = r("AppWindowMacIcon", [
  ["rect", { width: "20", height: "16", x: "2", y: "4", rx: "2", key: "18n3k1" }],
  ["path", { d: "M6 8h.01", key: "x9i8wu" }],
  ["path", { d: "M10 8h.01", key: "1r9ogq" }],
  ["path", { d: "M14 8h.01", key: "1primd" }]
]);
const Ii = r("AppWindowIcon", [
  ["rect", { x: "2", y: "4", width: "20", height: "16", rx: "2", key: "izxlao" }],
  ["path", { d: "M10 4v4", key: "pp8u80" }],
  ["path", { d: "M2 8h20", key: "d11cs7" }],
  ["path", { d: "M6 4v4", key: "1svtjw" }]
]);
const Li = r("AppleIcon", [
  [
    "path",
    {
      d: "M12 20.94c1.5 0 2.75 1.06 4 1.06 3 0 6-8 6-12.22A4.91 4.91 0 0 0 17 5c-2.22 0-4 1.44-5 2-1-.56-2.78-2-5-2a4.9 4.9 0 0 0-5 4.78C2 14 5 22 8 22c1.25 0 2.5-1.06 4-1.06Z",
      key: "3s7exb"
    }
  ],
  ["path", { d: "M10 2c1 .5 2 2 2 5", key: "fcco2y" }]
]);
const Si = r("ArchiveRestoreIcon", [
  ["rect", { width: "20", height: "5", x: "2", y: "3", rx: "1", key: "1wp1u1" }],
  ["path", { d: "M4 8v11a2 2 0 0 0 2 2h2", key: "tvwodi" }],
  ["path", { d: "M20 8v11a2 2 0 0 1-2 2h-2", key: "1gkqxj" }],
  ["path", { d: "m9 15 3-3 3 3", key: "1pd0qc" }],
  ["path", { d: "M12 12v9", key: "192myk" }]
]);
const Ci = r("ArchiveXIcon", [
  ["rect", { width: "20", height: "5", x: "2", y: "3", rx: "1", key: "1wp1u1" }],
  ["path", { d: "M4 8v11a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V8", key: "1s80jp" }],
  ["path", { d: "m9.5 17 5-5", key: "nakeu6" }],
  ["path", { d: "m9.5 12 5 5", key: "1hccrj" }]
]);
const Ai = r("ArchiveIcon", [
  ["rect", { width: "20", height: "5", x: "2", y: "3", rx: "1", key: "1wp1u1" }],
  ["path", { d: "M4 8v11a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V8", key: "1s80jp" }],
  ["path", { d: "M10 12h4", key: "a56b0p" }]
]);
const Pi = r("AreaChartIcon", [
  ["path", { d: "M3 3v18h18", key: "1s2lah" }],
  ["path", { d: "M7 12v5h12V8l-5 5-4-4Z", key: "zxz28u" }]
]);
const qi = r("ArmchairIcon", [
  ["path", { d: "M19 9V6a2 2 0 0 0-2-2H7a2 2 0 0 0-2 2v3", key: "irtipd" }],
  [
    "path",
    {
      d: "M3 16a2 2 0 0 0 2 2h14a2 2 0 0 0 2-2v-5a2 2 0 0 0-4 0v2H7v-2a2 2 0 0 0-4 0Z",
      key: "1e01m0"
    }
  ],
  ["path", { d: "M5 18v2", key: "ppbyun" }],
  ["path", { d: "M19 18v2", key: "gy7782" }]
]);
const Ti = r("ArrowBigDownDashIcon", [
  ["path", { d: "M15 5H9", key: "1tp3ed" }],
  ["path", { d: "M15 9v3h4l-7 7-7-7h4V9z", key: "ncdc4b" }]
]);
const Di = r("ArrowBigDownIcon", [
  ["path", { d: "M15 6v6h4l-7 7-7-7h4V6h6z", key: "1thax2" }]
]);
const _i = r("ArrowBigLeftDashIcon", [
  ["path", { d: "M19 15V9", key: "1hci5f" }],
  ["path", { d: "M15 15h-3v4l-7-7 7-7v4h3v6z", key: "16tjna" }]
]);
const Bi = r("ArrowBigLeftIcon", [
  ["path", { d: "M18 15h-6v4l-7-7 7-7v4h6v6z", key: "lbrdak" }]
]);
const zi = r("ArrowBigRightDashIcon", [
  ["path", { d: "M5 9v6", key: "158jrl" }],
  ["path", { d: "M9 9h3V5l7 7-7 7v-4H9V9z", key: "1sg2xn" }]
]);
const Hi = r("ArrowBigRightIcon", [
  ["path", { d: "M6 9h6V5l7 7-7 7v-4H6V9z", key: "7fvt9c" }]
]);
const ji = r("ArrowBigUpDashIcon", [
  ["path", { d: "M9 19h6", key: "456am0" }],
  ["path", { d: "M9 15v-3H5l7-7 7 7h-4v3H9z", key: "1r2uve" }]
]);
const Vi = r("ArrowBigUpIcon", [
  ["path", { d: "M9 18v-6H5l7-7 7 7h-4v6H9z", key: "1x06kx" }]
]);
const Oi = r("ArrowDown01Icon", [
  ["path", { d: "m3 16 4 4 4-4", key: "1co6wj" }],
  ["path", { d: "M7 20V4", key: "1yoxec" }],
  ["rect", { x: "15", y: "4", width: "4", height: "6", ry: "2", key: "1bwicg" }],
  ["path", { d: "M17 20v-6h-2", key: "1qp1so" }],
  ["path", { d: "M15 20h4", key: "1j968p" }]
]);
const $i = r("ArrowDown10Icon", [
  ["path", { d: "m3 16 4 4 4-4", key: "1co6wj" }],
  ["path", { d: "M7 20V4", key: "1yoxec" }],
  ["path", { d: "M17 10V4h-2", key: "zcsr5x" }],
  ["path", { d: "M15 10h4", key: "id2lce" }],
  ["rect", { x: "15", y: "14", width: "4", height: "6", ry: "2", key: "33xykx" }]
]);
const ha = r("ArrowDownAZIcon", [
  ["path", { d: "m3 16 4 4 4-4", key: "1co6wj" }],
  ["path", { d: "M7 20V4", key: "1yoxec" }],
  ["path", { d: "M20 8h-5", key: "1vsyxs" }],
  ["path", { d: "M15 10V6.5a2.5 2.5 0 0 1 5 0V10", key: "ag13bf" }],
  ["path", { d: "M15 14h5l-5 6h5", key: "ur5jdg" }]
]);
const Ri = r("ArrowDownFromLineIcon", [
  ["path", { d: "M19 3H5", key: "1236rx" }],
  ["path", { d: "M12 21V7", key: "gj6g52" }],
  ["path", { d: "m6 15 6 6 6-6", key: "h15q88" }]
]);
const Fi = r("ArrowDownLeftIcon", [
  ["path", { d: "M17 7 7 17", key: "15tmo1" }],
  ["path", { d: "M17 17H7V7", key: "1org7z" }]
]);
const Ui = r("ArrowDownNarrowWideIcon", [
  ["path", { d: "m3 16 4 4 4-4", key: "1co6wj" }],
  ["path", { d: "M7 20V4", key: "1yoxec" }],
  ["path", { d: "M11 4h4", key: "6d7r33" }],
  ["path", { d: "M11 8h7", key: "djye34" }],
  ["path", { d: "M11 12h10", key: "1438ji" }]
]);
const Ei = r("ArrowDownRightIcon", [
  ["path", { d: "m7 7 10 10", key: "1fmybs" }],
  ["path", { d: "M17 7v10H7", key: "6fjiku" }]
]);
const Wi = r("ArrowDownToDotIcon", [
  ["path", { d: "M12 2v14", key: "jyx4ut" }],
  ["path", { d: "m19 9-7 7-7-7", key: "1oe3oy" }],
  ["circle", { cx: "12", cy: "21", r: "1", key: "o0uj5v" }]
]);
const Ni = r("ArrowDownToLineIcon", [
  ["path", { d: "M12 17V3", key: "1cwfxf" }],
  ["path", { d: "m6 11 6 6 6-6", key: "12ii2o" }],
  ["path", { d: "M19 21H5", key: "150jfl" }]
]);
const Zi = r("ArrowDownUpIcon", [
  ["path", { d: "m3 16 4 4 4-4", key: "1co6wj" }],
  ["path", { d: "M7 20V4", key: "1yoxec" }],
  ["path", { d: "m21 8-4-4-4 4", key: "1c9v7m" }],
  ["path", { d: "M17 4v16", key: "7dpous" }]
]);
const pa = r("ArrowDownWideNarrowIcon", [
  ["path", { d: "m3 16 4 4 4-4", key: "1co6wj" }],
  ["path", { d: "M7 20V4", key: "1yoxec" }],
  ["path", { d: "M11 4h10", key: "1w87gc" }],
  ["path", { d: "M11 8h7", key: "djye34" }],
  ["path", { d: "M11 12h4", key: "q8tih4" }]
]);
const ya = r("ArrowDownZAIcon", [
  ["path", { d: "m3 16 4 4 4-4", key: "1co6wj" }],
  ["path", { d: "M7 4v16", key: "1glfcx" }],
  ["path", { d: "M15 4h5l-5 6h5", key: "8asdl1" }],
  ["path", { d: "M15 20v-3.5a2.5 2.5 0 0 1 5 0V20", key: "r6l5cz" }],
  ["path", { d: "M20 18h-5", key: "18j1r2" }]
]);
const Yi = r("ArrowDownIcon", [
  ["path", { d: "M12 5v14", key: "s699le" }],
  ["path", { d: "m19 12-7 7-7-7", key: "1idqje" }]
]);
const Gi = r("ArrowLeftFromLineIcon", [
  ["path", { d: "m9 6-6 6 6 6", key: "7v63n9" }],
  ["path", { d: "M3 12h14", key: "13k4hi" }],
  ["path", { d: "M21 19V5", key: "b4bplr" }]
]);
const Xi = r("ArrowLeftRightIcon", [
  ["path", { d: "M8 3 4 7l4 4", key: "9rb6wj" }],
  ["path", { d: "M4 7h16", key: "6tx8e3" }],
  ["path", { d: "m16 21 4-4-4-4", key: "siv7j2" }],
  ["path", { d: "M20 17H4", key: "h6l3hr" }]
]);
const Ki = r("ArrowLeftToLineIcon", [
  ["path", { d: "M3 19V5", key: "rwsyhb" }],
  ["path", { d: "m13 6-6 6 6 6", key: "1yhaz7" }],
  ["path", { d: "M7 12h14", key: "uoisry" }]
]);
const Qi = r("ArrowLeftIcon", [
  ["path", { d: "m12 19-7-7 7-7", key: "1l729n" }],
  ["path", { d: "M19 12H5", key: "x3x0zl" }]
]);
const Ji = r("ArrowRightFromLineIcon", [
  ["path", { d: "M3 5v14", key: "1nt18q" }],
  ["path", { d: "M21 12H7", key: "13ipq5" }],
  ["path", { d: "m15 18 6-6-6-6", key: "6tx3qv" }]
]);
const el = r("ArrowRightLeftIcon", [
  ["path", { d: "m16 3 4 4-4 4", key: "1x1c3m" }],
  ["path", { d: "M20 7H4", key: "zbl0bi" }],
  ["path", { d: "m8 21-4-4 4-4", key: "h9nckh" }],
  ["path", { d: "M4 17h16", key: "g4d7ey" }]
]);
const tl = r("ArrowRightToLineIcon", [
  ["path", { d: "M17 12H3", key: "8awo09" }],
  ["path", { d: "m11 18 6-6-6-6", key: "8c2y43" }],
  ["path", { d: "M21 5v14", key: "nzette" }]
]);
const al = r("ArrowRightIcon", [
  ["path", { d: "M5 12h14", key: "1ays0h" }],
  ["path", { d: "m12 5 7 7-7 7", key: "xquz4c" }]
]);
const nl = r("ArrowUp01Icon", [
  ["path", { d: "m3 8 4-4 4 4", key: "11wl7u" }],
  ["path", { d: "M7 4v16", key: "1glfcx" }],
  ["rect", { x: "15", y: "4", width: "4", height: "6", ry: "2", key: "1bwicg" }],
  ["path", { d: "M17 20v-6h-2", key: "1qp1so" }],
  ["path", { d: "M15 20h4", key: "1j968p" }]
]);
const ol = r("ArrowUp10Icon", [
  ["path", { d: "m3 8 4-4 4 4", key: "11wl7u" }],
  ["path", { d: "M7 4v16", key: "1glfcx" }],
  ["path", { d: "M17 10V4h-2", key: "zcsr5x" }],
  ["path", { d: "M15 10h4", key: "id2lce" }],
  ["rect", { x: "15", y: "14", width: "4", height: "6", ry: "2", key: "33xykx" }]
]);
const ka = r("ArrowUpAZIcon", [
  ["path", { d: "m3 8 4-4 4 4", key: "11wl7u" }],
  ["path", { d: "M7 4v16", key: "1glfcx" }],
  ["path", { d: "M20 8h-5", key: "1vsyxs" }],
  ["path", { d: "M15 10V6.5a2.5 2.5 0 0 1 5 0V10", key: "ag13bf" }],
  ["path", { d: "M15 14h5l-5 6h5", key: "ur5jdg" }]
]);
const rl = r("ArrowUpDownIcon", [
  ["path", { d: "m21 16-4 4-4-4", key: "f6ql7i" }],
  ["path", { d: "M17 20V4", key: "1ejh1v" }],
  ["path", { d: "m3 8 4-4 4 4", key: "11wl7u" }],
  ["path", { d: "M7 4v16", key: "1glfcx" }]
]);
const il = r("ArrowUpFromDotIcon", [
  ["path", { d: "m5 9 7-7 7 7", key: "1hw5ic" }],
  ["path", { d: "M12 16V2", key: "ywoabb" }],
  ["circle", { cx: "12", cy: "21", r: "1", key: "o0uj5v" }]
]);
const ll = r("ArrowUpFromLineIcon", [
  ["path", { d: "m18 9-6-6-6 6", key: "kcunyi" }],
  ["path", { d: "M12 3v14", key: "7cf3v8" }],
  ["path", { d: "M5 21h14", key: "11awu3" }]
]);
const cl = r("ArrowUpLeftIcon", [
  ["path", { d: "M7 17V7h10", key: "11bw93" }],
  ["path", { d: "M17 17 7 7", key: "2786uv" }]
]);
const fa = r("ArrowUpNarrowWideIcon", [
  ["path", { d: "m3 8 4-4 4 4", key: "11wl7u" }],
  ["path", { d: "M7 4v16", key: "1glfcx" }],
  ["path", { d: "M11 12h4", key: "q8tih4" }],
  ["path", { d: "M11 16h7", key: "uosisv" }],
  ["path", { d: "M11 20h10", key: "jvxblo" }]
]);
const dl = r("ArrowUpRightIcon", [
  ["path", { d: "M7 7h10v10", key: "1tivn9" }],
  ["path", { d: "M7 17 17 7", key: "1vkiza" }]
]);
const sl = r("ArrowUpToLineIcon", [
  ["path", { d: "M5 3h14", key: "7usisc" }],
  ["path", { d: "m18 13-6-6-6 6", key: "1kf1n9" }],
  ["path", { d: "M12 7v14", key: "1akyts" }]
]);
const ul = r("ArrowUpWideNarrowIcon", [
  ["path", { d: "m3 8 4-4 4 4", key: "11wl7u" }],
  ["path", { d: "M7 4v16", key: "1glfcx" }],
  ["path", { d: "M11 12h10", key: "1438ji" }],
  ["path", { d: "M11 16h7", key: "uosisv" }],
  ["path", { d: "M11 20h4", key: "1krc32" }]
]);
const va = r("ArrowUpZAIcon", [
  ["path", { d: "m3 8 4-4 4 4", key: "11wl7u" }],
  ["path", { d: "M7 4v16", key: "1glfcx" }],
  ["path", { d: "M15 4h5l-5 6h5", key: "8asdl1" }],
  ["path", { d: "M15 20v-3.5a2.5 2.5 0 0 1 5 0V20", key: "r6l5cz" }],
  ["path", { d: "M20 18h-5", key: "18j1r2" }]
]);
const hl = r("ArrowUpIcon", [
  ["path", { d: "m5 12 7-7 7 7", key: "hav0vg" }],
  ["path", { d: "M12 19V5", key: "x0mq9r" }]
]);
const pl = r("ArrowsUpFromLineIcon", [
  ["path", { d: "m4 6 3-3 3 3", key: "9aidw8" }],
  ["path", { d: "M7 17V3", key: "19qxw1" }],
  ["path", { d: "m14 6 3-3 3 3", key: "6iy689" }],
  ["path", { d: "M17 17V3", key: "o0fmgi" }],
  ["path", { d: "M4 21h16", key: "1h09gz" }]
]);
const yl = r("AsteriskIcon", [
  ["path", { d: "M12 6v12", key: "1vza4d" }],
  ["path", { d: "M17.196 9 6.804 15", key: "1ah31z" }],
  ["path", { d: "m6.804 9 10.392 6", key: "1b6pxd" }]
]);
const kl = r("AtSignIcon", [
  ["circle", { cx: "12", cy: "12", r: "4", key: "4exip2" }],
  ["path", { d: "M16 8v5a3 3 0 0 0 6 0v-1a10 10 0 1 0-4 8", key: "7n84p3" }]
]);
const fl = r("AtomIcon", [
  ["circle", { cx: "12", cy: "12", r: "1", key: "41hilf" }],
  [
    "path",
    {
      d: "M20.2 20.2c2.04-2.03.02-7.36-4.5-11.9-4.54-4.52-9.87-6.54-11.9-4.5-2.04 2.03-.02 7.36 4.5 11.9 4.54 4.52 9.87 6.54 11.9 4.5Z",
      key: "1l2ple"
    }
  ],
  [
    "path",
    {
      d: "M15.7 15.7c4.52-4.54 6.54-9.87 4.5-11.9-2.03-2.04-7.36-.02-11.9 4.5-4.52 4.54-6.54 9.87-4.5 11.9 2.03 2.04 7.36.02 11.9-4.5Z",
      key: "1wam0m"
    }
  ]
]);
const vl = r("AudioLinesIcon", [
  ["path", { d: "M2 10v3", key: "1fnikh" }],
  ["path", { d: "M6 6v11", key: "11sgs0" }],
  ["path", { d: "M10 3v18", key: "yhl04a" }],
  ["path", { d: "M14 8v7", key: "3a1oy3" }],
  ["path", { d: "M18 5v13", key: "123xd1" }],
  ["path", { d: "M22 10v3", key: "154ddg" }]
]);
const ml = r("AudioWaveformIcon", [
  [
    "path",
    {
      d: "M2 13a2 2 0 0 0 2-2V7a2 2 0 0 1 4 0v13a2 2 0 0 0 4 0V4a2 2 0 0 1 4 0v13a2 2 0 0 0 4 0v-4a2 2 0 0 1 2-2",
      key: "57tc96"
    }
  ]
]);
const gl = r("AwardIcon", [
  ["circle", { cx: "12", cy: "8", r: "6", key: "1vp47v" }],
  ["path", { d: "M15.477 12.89 17 22l-5-3-5 3 1.523-9.11", key: "em7aur" }]
]);
const Ml = r("AxeIcon", [
  ["path", { d: "m14 12-8.5 8.5a2.12 2.12 0 1 1-3-3L11 9", key: "csbz4o" }],
  ["path", { d: "M15 13 9 7l4-4 6 6h3a8 8 0 0 1-7 7z", key: "113wfo" }]
]);
const ma = r("Axis3dIcon", [
  ["path", { d: "M4 4v16h16", key: "1s015l" }],
  ["path", { d: "m4 20 7-7", key: "17qe9y" }]
]);
const xl = r("BabyIcon", [
  ["path", { d: "M9 12h.01", key: "157uk2" }],
  ["path", { d: "M15 12h.01", key: "1k8ypt" }],
  ["path", { d: "M10 16c.5.3 1.2.5 2 .5s1.5-.2 2-.5", key: "1u7htd" }],
  [
    "path",
    {
      d: "M19 6.3a9 9 0 0 1 1.8 3.9 2 2 0 0 1 0 3.6 9 9 0 0 1-17.6 0 2 2 0 0 1 0-3.6A9 9 0 0 1 12 3c2 0 3.5 1.1 3.5 2.5s-.9 2.5-2 2.5c-.8 0-1.5-.4-1.5-1",
      key: "5yv0yz"
    }
  ]
]);
const bl = r("BackpackIcon", [
  [
    "path",
    { d: "M4 10a4 4 0 0 1 4-4h8a4 4 0 0 1 4 4v10a2 2 0 0 1-2 2H6a2 2 0 0 1-2-2Z", key: "wvr1b5" }
  ],
  ["path", { d: "M9 6V4a2 2 0 0 1 2-2h2a2 2 0 0 1 2 2v2", key: "donm21" }],
  ["path", { d: "M8 21v-5a2 2 0 0 1 2-2h4a2 2 0 0 1 2 2v5", key: "xk3gvk" }],
  ["path", { d: "M8 10h8", key: "c7uz4u" }],
  ["path", { d: "M8 18h8", key: "1no2b1" }]
]);
const wl = r("BadgeAlertIcon", [
  [
    "path",
    {
      d: "M3.85 8.62a4 4 0 0 1 4.78-4.77 4 4 0 0 1 6.74 0 4 4 0 0 1 4.78 4.78 4 4 0 0 1 0 6.74 4 4 0 0 1-4.77 4.78 4 4 0 0 1-6.75 0 4 4 0 0 1-4.78-4.77 4 4 0 0 1 0-6.76Z",
      key: "3c2336"
    }
  ],
  ["line", { x1: "12", x2: "12", y1: "8", y2: "12", key: "1pkeuh" }],
  ["line", { x1: "12", x2: "12.01", y1: "16", y2: "16", key: "4dfq90" }]
]);
const Il = r("BadgeCentIcon", [
  [
    "path",
    {
      d: "M3.85 8.62a4 4 0 0 1 4.78-4.77 4 4 0 0 1 6.74 0 4 4 0 0 1 4.78 4.78 4 4 0 0 1 0 6.74 4 4 0 0 1-4.77 4.78 4 4 0 0 1-6.75 0 4 4 0 0 1-4.78-4.77 4 4 0 0 1 0-6.76Z",
      key: "3c2336"
    }
  ],
  ["path", { d: "M12 7v10", key: "jspqdw" }],
  ["path", { d: "M15.4 10a4 4 0 1 0 0 4", key: "2eqtx8" }]
]);
const ga = r("BadgeCheckIcon", [
  [
    "path",
    {
      d: "M3.85 8.62a4 4 0 0 1 4.78-4.77 4 4 0 0 1 6.74 0 4 4 0 0 1 4.78 4.78 4 4 0 0 1 0 6.74 4 4 0 0 1-4.77 4.78 4 4 0 0 1-6.75 0 4 4 0 0 1-4.78-4.77 4 4 0 0 1 0-6.76Z",
      key: "3c2336"
    }
  ],
  ["path", { d: "m9 12 2 2 4-4", key: "dzmm74" }]
]);
const Ll = r("BadgeDollarSignIcon", [
  [
    "path",
    {
      d: "M3.85 8.62a4 4 0 0 1 4.78-4.77 4 4 0 0 1 6.74 0 4 4 0 0 1 4.78 4.78 4 4 0 0 1 0 6.74 4 4 0 0 1-4.77 4.78 4 4 0 0 1-6.75 0 4 4 0 0 1-4.78-4.77 4 4 0 0 1 0-6.76Z",
      key: "3c2336"
    }
  ],
  ["path", { d: "M16 8h-6a2 2 0 1 0 0 4h4a2 2 0 1 1 0 4H8", key: "1h4pet" }],
  ["path", { d: "M12 18V6", key: "zqpxq5" }]
]);
const Sl = r("BadgeEuroIcon", [
  [
    "path",
    {
      d: "M3.85 8.62a4 4 0 0 1 4.78-4.77 4 4 0 0 1 6.74 0 4 4 0 0 1 4.78 4.78 4 4 0 0 1 0 6.74 4 4 0 0 1-4.77 4.78 4 4 0 0 1-6.75 0 4 4 0 0 1-4.78-4.77 4 4 0 0 1 0-6.76Z",
      key: "3c2336"
    }
  ],
  ["path", { d: "M7 12h5", key: "gblrwe" }],
  ["path", { d: "M15 9.4a4 4 0 1 0 0 5.2", key: "1makmb" }]
]);
const Cl = r("BadgeHelpIcon", [
  [
    "path",
    {
      d: "M3.85 8.62a4 4 0 0 1 4.78-4.77 4 4 0 0 1 6.74 0 4 4 0 0 1 4.78 4.78 4 4 0 0 1 0 6.74 4 4 0 0 1-4.77 4.78 4 4 0 0 1-6.75 0 4 4 0 0 1-4.78-4.77 4 4 0 0 1 0-6.76Z",
      key: "3c2336"
    }
  ],
  ["path", { d: "M9.09 9a3 3 0 0 1 5.83 1c0 2-3 3-3 3", key: "1u773s" }],
  ["line", { x1: "12", x2: "12.01", y1: "17", y2: "17", key: "io3f8k" }]
]);
const Al = r("BadgeIndianRupeeIcon", [
  [
    "path",
    {
      d: "M3.85 8.62a4 4 0 0 1 4.78-4.77 4 4 0 0 1 6.74 0 4 4 0 0 1 4.78 4.78 4 4 0 0 1 0 6.74 4 4 0 0 1-4.77 4.78 4 4 0 0 1-6.75 0 4 4 0 0 1-4.78-4.77 4 4 0 0 1 0-6.76Z",
      key: "3c2336"
    }
  ],
  ["path", { d: "M8 8h8", key: "1bis0t" }],
  ["path", { d: "M8 12h8", key: "1wcyev" }],
  ["path", { d: "m13 17-5-1h1a4 4 0 0 0 0-8", key: "nu2bwa" }]
]);
const Pl = r("BadgeInfoIcon", [
  [
    "path",
    {
      d: "M3.85 8.62a4 4 0 0 1 4.78-4.77 4 4 0 0 1 6.74 0 4 4 0 0 1 4.78 4.78 4 4 0 0 1 0 6.74 4 4 0 0 1-4.77 4.78 4 4 0 0 1-6.75 0 4 4 0 0 1-4.78-4.77 4 4 0 0 1 0-6.76Z",
      key: "3c2336"
    }
  ],
  ["line", { x1: "12", x2: "12", y1: "16", y2: "12", key: "1y1yb1" }],
  ["line", { x1: "12", x2: "12.01", y1: "8", y2: "8", key: "110wyk" }]
]);
const ql = r("BadgeJapaneseYenIcon", [
  [
    "path",
    {
      d: "M3.85 8.62a4 4 0 0 1 4.78-4.77 4 4 0 0 1 6.74 0 4 4 0 0 1 4.78 4.78 4 4 0 0 1 0 6.74 4 4 0 0 1-4.77 4.78 4 4 0 0 1-6.75 0 4 4 0 0 1-4.78-4.77 4 4 0 0 1 0-6.76Z",
      key: "3c2336"
    }
  ],
  ["path", { d: "m9 8 3 3v7", key: "17yadx" }],
  ["path", { d: "m12 11 3-3", key: "p4cfq1" }],
  ["path", { d: "M9 12h6", key: "1c52cq" }],
  ["path", { d: "M9 16h6", key: "8wimt3" }]
]);
const Tl = r("BadgeMinusIcon", [
  [
    "path",
    {
      d: "M3.85 8.62a4 4 0 0 1 4.78-4.77 4 4 0 0 1 6.74 0 4 4 0 0 1 4.78 4.78 4 4 0 0 1 0 6.74 4 4 0 0 1-4.77 4.78 4 4 0 0 1-6.75 0 4 4 0 0 1-4.78-4.77 4 4 0 0 1 0-6.76Z",
      key: "3c2336"
    }
  ],
  ["line", { x1: "8", x2: "16", y1: "12", y2: "12", key: "1jonct" }]
]);
const Dl = r("BadgePercentIcon", [
  [
    "path",
    {
      d: "M3.85 8.62a4 4 0 0 1 4.78-4.77 4 4 0 0 1 6.74 0 4 4 0 0 1 4.78 4.78 4 4 0 0 1 0 6.74 4 4 0 0 1-4.77 4.78 4 4 0 0 1-6.75 0 4 4 0 0 1-4.78-4.77 4 4 0 0 1 0-6.76Z",
      key: "3c2336"
    }
  ],
  ["path", { d: "m15 9-6 6", key: "1uzhvr" }],
  ["path", { d: "M9 9h.01", key: "1q5me6" }],
  ["path", { d: "M15 15h.01", key: "lqbp3k" }]
]);
const _l = r("BadgePlusIcon", [
  [
    "path",
    {
      d: "M3.85 8.62a4 4 0 0 1 4.78-4.77 4 4 0 0 1 6.74 0 4 4 0 0 1 4.78 4.78 4 4 0 0 1 0 6.74 4 4 0 0 1-4.77 4.78 4 4 0 0 1-6.75 0 4 4 0 0 1-4.78-4.77 4 4 0 0 1 0-6.76Z",
      key: "3c2336"
    }
  ],
  ["line", { x1: "12", x2: "12", y1: "8", y2: "16", key: "10p56q" }],
  ["line", { x1: "8", x2: "16", y1: "12", y2: "12", key: "1jonct" }]
]);
const Bl = r("BadgePoundSterlingIcon", [
  [
    "path",
    {
      d: "M3.85 8.62a4 4 0 0 1 4.78-4.77 4 4 0 0 1 6.74 0 4 4 0 0 1 4.78 4.78 4 4 0 0 1 0 6.74 4 4 0 0 1-4.77 4.78 4 4 0 0 1-6.75 0 4 4 0 0 1-4.78-4.77 4 4 0 0 1 0-6.76Z",
      key: "3c2336"
    }
  ],
  ["path", { d: "M8 12h4", key: "qz6y1c" }],
  ["path", { d: "M10 16V9.5a2.5 2.5 0 0 1 5 0", key: "3mlbjk" }],
  ["path", { d: "M8 16h7", key: "sbedsn" }]
]);
const zl = r("BadgeRussianRubleIcon", [
  [
    "path",
    {
      d: "M3.85 8.62a4 4 0 0 1 4.78-4.77 4 4 0 0 1 6.74 0 4 4 0 0 1 4.78 4.78 4 4 0 0 1 0 6.74 4 4 0 0 1-4.77 4.78 4 4 0 0 1-6.75 0 4 4 0 0 1-4.78-4.77 4 4 0 0 1 0-6.76Z",
      key: "3c2336"
    }
  ],
  ["path", { d: "M9 16h5", key: "1syiyw" }],
  ["path", { d: "M9 12h5a2 2 0 1 0 0-4h-3v9", key: "1ge9c1" }]
]);
const Hl = r("BadgeSwissFrancIcon", [
  [
    "path",
    {
      d: "M3.85 8.62a4 4 0 0 1 4.78-4.77 4 4 0 0 1 6.74 0 4 4 0 0 1 4.78 4.78 4 4 0 0 1 0 6.74 4 4 0 0 1-4.77 4.78 4 4 0 0 1-6.75 0 4 4 0 0 1-4.78-4.77 4 4 0 0 1 0-6.76Z",
      key: "3c2336"
    }
  ],
  ["path", { d: "M11 17V8h4", key: "1bfq6y" }],
  ["path", { d: "M11 12h3", key: "2eqnfz" }],
  ["path", { d: "M9 16h4", key: "1skf3a" }]
]);
const jl = r("BadgeXIcon", [
  [
    "path",
    {
      d: "M3.85 8.62a4 4 0 0 1 4.78-4.77 4 4 0 0 1 6.74 0 4 4 0 0 1 4.78 4.78 4 4 0 0 1 0 6.74 4 4 0 0 1-4.77 4.78 4 4 0 0 1-6.75 0 4 4 0 0 1-4.78-4.77 4 4 0 0 1 0-6.76Z",
      key: "3c2336"
    }
  ],
  ["line", { x1: "15", x2: "9", y1: "9", y2: "15", key: "f7djnv" }],
  ["line", { x1: "9", x2: "15", y1: "9", y2: "15", key: "1shsy8" }]
]);
const Vl = r("BadgeIcon", [
  [
    "path",
    {
      d: "M3.85 8.62a4 4 0 0 1 4.78-4.77 4 4 0 0 1 6.74 0 4 4 0 0 1 4.78 4.78 4 4 0 0 1 0 6.74 4 4 0 0 1-4.77 4.78 4 4 0 0 1-6.75 0 4 4 0 0 1-4.78-4.77 4 4 0 0 1 0-6.76Z",
      key: "3c2336"
    }
  ]
]);
const Ol = r("BaggageClaimIcon", [
  ["path", { d: "M22 18H6a2 2 0 0 1-2-2V7a2 2 0 0 0-2-2", key: "4irg2o" }],
  ["path", { d: "M17 14V4a2 2 0 0 0-2-2h-1a2 2 0 0 0-2 2v10", key: "14fcyx" }],
  ["rect", { width: "13", height: "8", x: "8", y: "6", rx: "1", key: "o6oiis" }],
  ["circle", { cx: "18", cy: "20", r: "2", key: "t9985n" }],
  ["circle", { cx: "9", cy: "20", r: "2", key: "e5v82j" }]
]);
const $l = r("BanIcon", [
  ["circle", { cx: "12", cy: "12", r: "10", key: "1mglay" }],
  ["path", { d: "m4.9 4.9 14.2 14.2", key: "1m5liu" }]
]);
const Rl = r("BananaIcon", [
  ["path", { d: "M4 13c3.5-2 8-2 10 2a5.5 5.5 0 0 1 8 5", key: "1cscit" }],
  [
    "path",
    {
      d: "M5.15 17.89c5.52-1.52 8.65-6.89 7-12C11.55 4 11.5 2 13 2c3.22 0 5 5.5 5 8 0 6.5-4.2 12-10.49 12C5.11 22 2 22 2 20c0-1.5 1.14-1.55 3.15-2.11Z",
      key: "1y1nbv"
    }
  ]
]);
const Fl = r("BanknoteIcon", [
  ["rect", { width: "20", height: "12", x: "2", y: "6", rx: "2", key: "9lu3g6" }],
  ["circle", { cx: "12", cy: "12", r: "2", key: "1c9p78" }],
  ["path", { d: "M6 12h.01M18 12h.01", key: "113zkx" }]
]);
const Ul = r("BarChart2Icon", [
  ["line", { x1: "18", x2: "18", y1: "20", y2: "10", key: "1xfpm4" }],
  ["line", { x1: "12", x2: "12", y1: "20", y2: "4", key: "be30l9" }],
  ["line", { x1: "6", x2: "6", y1: "20", y2: "14", key: "1r4le6" }]
]);
const El = r("BarChart3Icon", [
  ["path", { d: "M3 3v18h18", key: "1s2lah" }],
  ["path", { d: "M18 17V9", key: "2bz60n" }],
  ["path", { d: "M13 17V5", key: "1frdt8" }],
  ["path", { d: "M8 17v-3", key: "17ska0" }]
]);
const Wl = r("BarChart4Icon", [
  ["path", { d: "M3 3v18h18", key: "1s2lah" }],
  ["path", { d: "M13 17V9", key: "1fwyjl" }],
  ["path", { d: "M18 17V5", key: "sfb6ij" }],
  ["path", { d: "M8 17v-3", key: "17ska0" }]
]);
const Nl = r("BarChartBigIcon", [
  ["path", { d: "M3 3v18h18", key: "1s2lah" }],
  ["rect", { width: "4", height: "7", x: "7", y: "10", rx: "1", key: "14u6mf" }],
  ["rect", { width: "4", height: "12", x: "15", y: "5", rx: "1", key: "b3pek6" }]
]);
const Zl = r("BarChartHorizontalBigIcon", [
  ["path", { d: "M3 3v18h18", key: "1s2lah" }],
  ["rect", { width: "12", height: "4", x: "7", y: "5", rx: "1", key: "936jl1" }],
  ["rect", { width: "7", height: "4", x: "7", y: "13", rx: "1", key: "jqfkpy" }]
]);
const Yl = r("BarChartHorizontalIcon", [
  ["path", { d: "M3 3v18h18", key: "1s2lah" }],
  ["path", { d: "M7 16h8", key: "srdodz" }],
  ["path", { d: "M7 11h12", key: "127s9w" }],
  ["path", { d: "M7 6h3", key: "w9rmul" }]
]);
const Gl = r("BarChartIcon", [
  ["line", { x1: "12", x2: "12", y1: "20", y2: "10", key: "1vz5eb" }],
  ["line", { x1: "18", x2: "18", y1: "20", y2: "4", key: "cun8e5" }],
  ["line", { x1: "6", x2: "6", y1: "20", y2: "16", key: "hq0ia6" }]
]);
const Xl = r("BarcodeIcon", [
  ["path", { d: "M3 5v14", key: "1nt18q" }],
  ["path", { d: "M8 5v14", key: "1ybrkv" }],
  ["path", { d: "M12 5v14", key: "s699le" }],
  ["path", { d: "M17 5v14", key: "ycjyhj" }],
  ["path", { d: "M21 5v14", key: "nzette" }]
]);
const Kl = r("BaselineIcon", [
  ["path", { d: "M4 20h16", key: "14thso" }],
  ["path", { d: "m6 16 6-12 6 12", key: "1b4byz" }],
  ["path", { d: "M8 12h8", key: "1wcyev" }]
]);
const Ql = r("BathIcon", [
  [
    "path",
    {
      d: "M9 6 6.5 3.5a1.5 1.5 0 0 0-1-.5C4.683 3 4 3.683 4 4.5V17a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2v-5",
      key: "1r8yf5"
    }
  ],
  ["line", { x1: "10", x2: "8", y1: "5", y2: "7", key: "h5g8z4" }],
  ["line", { x1: "2", x2: "22", y1: "12", y2: "12", key: "1dnqot" }],
  ["line", { x1: "7", x2: "7", y1: "19", y2: "21", key: "16jp00" }],
  ["line", { x1: "17", x2: "17", y1: "19", y2: "21", key: "1pxrnk" }]
]);
const Jl = r("BatteryChargingIcon", [
  ["path", { d: "M15 7h1a2 2 0 0 1 2 2v6a2 2 0 0 1-2 2h-2", key: "1sdynx" }],
  ["path", { d: "M6 7H4a2 2 0 0 0-2 2v6a2 2 0 0 0 2 2h1", key: "1gkd3k" }],
  ["path", { d: "m11 7-3 5h4l-3 5", key: "b4a64w" }],
  ["line", { x1: "22", x2: "22", y1: "11", y2: "13", key: "4dh1rd" }]
]);
const ec = r("BatteryFullIcon", [
  ["rect", { width: "16", height: "10", x: "2", y: "7", rx: "2", ry: "2", key: "1w10f2" }],
  ["line", { x1: "22", x2: "22", y1: "11", y2: "13", key: "4dh1rd" }],
  ["line", { x1: "6", x2: "6", y1: "11", y2: "13", key: "1wd6dw" }],
  ["line", { x1: "10", x2: "10", y1: "11", y2: "13", key: "haxvl5" }],
  ["line", { x1: "14", x2: "14", y1: "11", y2: "13", key: "c6fn6x" }]
]);
const tc = r("BatteryLowIcon", [
  ["rect", { width: "16", height: "10", x: "2", y: "7", rx: "2", ry: "2", key: "1w10f2" }],
  ["line", { x1: "22", x2: "22", y1: "11", y2: "13", key: "4dh1rd" }],
  ["line", { x1: "6", x2: "6", y1: "11", y2: "13", key: "1wd6dw" }]
]);
const ac = r("BatteryMediumIcon", [
  ["rect", { width: "16", height: "10", x: "2", y: "7", rx: "2", ry: "2", key: "1w10f2" }],
  ["line", { x1: "22", x2: "22", y1: "11", y2: "13", key: "4dh1rd" }],
  ["line", { x1: "6", x2: "6", y1: "11", y2: "13", key: "1wd6dw" }],
  ["line", { x1: "10", x2: "10", y1: "11", y2: "13", key: "haxvl5" }]
]);
const nc = r("BatteryWarningIcon", [
  ["path", { d: "M14 7h2a2 2 0 0 1 2 2v6c0 1-1 2-2 2h-2", key: "1if82c" }],
  ["path", { d: "M6 7H4a2 2 0 0 0-2 2v6c0 1 1 2 2 2h2", key: "2pdlyl" }],
  ["line", { x1: "22", x2: "22", y1: "11", y2: "13", key: "4dh1rd" }],
  ["line", { x1: "10", x2: "10", y1: "7", y2: "13", key: "1uzyus" }],
  ["line", { x1: "10", x2: "10", y1: "17", y2: "17.01", key: "1y8k4g" }]
]);
const oc = r("BatteryIcon", [
  ["rect", { width: "16", height: "10", x: "2", y: "7", rx: "2", ry: "2", key: "1w10f2" }],
  ["line", { x1: "22", x2: "22", y1: "11", y2: "13", key: "4dh1rd" }]
]);
const rc = r("BeakerIcon", [
  ["path", { d: "M4.5 3h15", key: "c7n0jr" }],
  ["path", { d: "M6 3v16a2 2 0 0 0 2 2h8a2 2 0 0 0 2-2V3", key: "m1uhx7" }],
  ["path", { d: "M6 14h12", key: "4cwo0f" }]
]);
const ic = r("BeanOffIcon", [
  [
    "path",
    {
      d: "M9 9c-.64.64-1.521.954-2.402 1.165A6 6 0 0 0 8 22a13.96 13.96 0 0 0 9.9-4.1",
      key: "bq3udt"
    }
  ],
  ["path", { d: "M10.75 5.093A6 6 0 0 1 22 8c0 2.411-.61 4.68-1.683 6.66", key: "17ccse" }],
  [
    "path",
    {
      d: "M5.341 10.62a4 4 0 0 0 6.487 1.208M10.62 5.341a4.015 4.015 0 0 1 2.039 2.04",
      key: "18zqgq"
    }
  ],
  ["line", { x1: "2", x2: "22", y1: "2", y2: "22", key: "a6p6uj" }]
]);
const lc = r("BeanIcon", [
  [
    "path",
    {
      d: "M10.165 6.598C9.954 7.478 9.64 8.36 9 9c-.64.64-1.521.954-2.402 1.165A6 6 0 0 0 8 22c7.732 0 14-6.268 14-14a6 6 0 0 0-11.835-1.402Z",
      key: "1tvzk7"
    }
  ],
  ["path", { d: "M5.341 10.62a4 4 0 1 0 5.279-5.28", key: "2cyri2" }]
]);
const cc = r("BedDoubleIcon", [
  ["path", { d: "M2 20v-8a2 2 0 0 1 2-2h16a2 2 0 0 1 2 2v8", key: "1k78r4" }],
  ["path", { d: "M4 10V6a2 2 0 0 1 2-2h12a2 2 0 0 1 2 2v4", key: "fb3tl2" }],
  ["path", { d: "M12 4v6", key: "1dcgq2" }],
  ["path", { d: "M2 18h20", key: "ajqnye" }]
]);
const dc = r("BedSingleIcon", [
  ["path", { d: "M3 20v-8a2 2 0 0 1 2-2h14a2 2 0 0 1 2 2v8", key: "1wm6mi" }],
  ["path", { d: "M5 10V6a2 2 0 0 1 2-2h10a2 2 0 0 1 2 2v4", key: "4k93s5" }],
  ["path", { d: "M3 18h18", key: "1h113x" }]
]);
const sc = r("BedIcon", [
  ["path", { d: "M2 4v16", key: "vw9hq8" }],
  ["path", { d: "M2 8h18a2 2 0 0 1 2 2v10", key: "1dgv2r" }],
  ["path", { d: "M2 17h20", key: "18nfp3" }],
  ["path", { d: "M6 8v9", key: "1yriud" }]
]);
const uc = r("BeefIcon", [
  ["circle", { cx: "12.5", cy: "8.5", r: "2.5", key: "9738u8" }],
  [
    "path",
    {
      d: "M12.5 2a6.5 6.5 0 0 0-6.22 4.6c-1.1 3.13-.78 3.9-3.18 6.08A3 3 0 0 0 5 18c4 0 8.4-1.8 11.4-4.3A6.5 6.5 0 0 0 12.5 2Z",
      key: "o0f6za"
    }
  ],
  [
    "path",
    {
      d: "m18.5 6 2.19 4.5a6.48 6.48 0 0 1 .31 2 6.49 6.49 0 0 1-2.6 5.2C15.4 20.2 11 22 7 22a3 3 0 0 1-2.68-1.66L2.4 16.5",
      key: "k7p6i0"
    }
  ]
]);
const hc = r("BeerOffIcon", [
  ["path", { d: "M13 13v5", key: "igwfh0" }],
  ["path", { d: "M17 11.47V8", key: "16yw0g" }],
  ["path", { d: "M17 11h1a3 3 0 0 1 2.745 4.211", key: "1xbt65" }],
  ["path", { d: "m2 2 20 20", key: "1ooewy" }],
  ["path", { d: "M5 8v12a2 2 0 0 0 2 2h8a2 2 0 0 0 2-2v-3", key: "c55o3e" }],
  [
    "path",
    { d: "M7.536 7.535C6.766 7.649 6.154 8 5.5 8a2.5 2.5 0 0 1-1.768-4.268", key: "1ydug7" }
  ],
  [
    "path",
    {
      d: "M8.727 3.204C9.306 2.767 9.885 2 11 2c1.56 0 2 1.5 3 1.5s1.72-.5 2.5-.5a1 1 0 1 1 0 5c-.78 0-1.5-.5-2.5-.5a3.149 3.149 0 0 0-.842.12",
      key: "q81o7q"
    }
  ],
  ["path", { d: "M9 14.6V18", key: "20ek98" }]
]);
const pc = r("BeerIcon", [
  ["path", { d: "M17 11h1a3 3 0 0 1 0 6h-1", key: "1yp76v" }],
  ["path", { d: "M9 12v6", key: "1u1cab" }],
  ["path", { d: "M13 12v6", key: "1sugkk" }],
  [
    "path",
    {
      d: "M14 7.5c-1 0-1.44.5-3 .5s-2-.5-3-.5-1.72.5-2.5.5a2.5 2.5 0 0 1 0-5c.78 0 1.57.5 2.5.5S9.44 2 11 2s2 1.5 3 1.5 1.72-.5 2.5-.5a2.5 2.5 0 0 1 0 5c-.78 0-1.5-.5-2.5-.5Z",
      key: "1510fo"
    }
  ],
  ["path", { d: "M5 8v12a2 2 0 0 0 2 2h8a2 2 0 0 0 2-2V8", key: "19jb7n" }]
]);
const yc = r("BellDotIcon", [
  [
    "path",
    {
      d: "M19.4 14.9C20.2 16.4 21 17 21 17H3s3-2 3-9c0-3.3 2.7-6 6-6 .7 0 1.3.1 1.9.3",
      key: "xcehk"
    }
  ],
  ["path", { d: "M10.3 21a1.94 1.94 0 0 0 3.4 0", key: "qgo35s" }],
  ["circle", { cx: "18", cy: "8", r: "3", key: "1g0gzu" }]
]);
const kc = r("BellElectricIcon", [
  ["path", { d: "M18.8 4A6.3 8.7 0 0 1 20 9", key: "xve1fh" }],
  ["path", { d: "M9 9h.01", key: "1q5me6" }],
  ["circle", { cx: "9", cy: "9", r: "7", key: "p2h5vp" }],
  ["rect", { width: "10", height: "6", x: "4", y: "16", rx: "2", key: "17f3te" }],
  ["path", { d: "M14 19c3 0 4.6-1.6 4.6-1.6", key: "n7odp6" }],
  ["circle", { cx: "20", cy: "16", r: "2", key: "1v9bxh" }]
]);
const fc = r("BellMinusIcon", [
  [
    "path",
    { d: "M18.4 12c.8 3.8 2.6 5 2.6 5H3s3-2 3-9c0-3.3 2.7-6 6-6 1.8 0 3.4.8 4.5 2", key: "eck70s" }
  ],
  ["path", { d: "M10.3 21a1.94 1.94 0 0 0 3.4 0", key: "qgo35s" }],
  ["path", { d: "M15 8h6", key: "8ybuxh" }]
]);
const vc = r("BellOffIcon", [
  ["path", { d: "M8.7 3A6 6 0 0 1 18 8a21.3 21.3 0 0 0 .6 5", key: "o7mx20" }],
  ["path", { d: "M17 17H3s3-2 3-9a4.67 4.67 0 0 1 .3-1.7", key: "16f1lm" }],
  ["path", { d: "M10.3 21a1.94 1.94 0 0 0 3.4 0", key: "qgo35s" }],
  ["path", { d: "m2 2 20 20", key: "1ooewy" }]
]);
const mc = r("BellPlusIcon", [
  [
    "path",
    {
      d: "M19.3 14.8C20.1 16.4 21 17 21 17H3s3-2 3-9c0-3.3 2.7-6 6-6 1 0 1.9.2 2.8.7",
      key: "guizqy"
    }
  ],
  ["path", { d: "M10.3 21a1.94 1.94 0 0 0 3.4 0", key: "qgo35s" }],
  ["path", { d: "M15 8h6", key: "8ybuxh" }],
  ["path", { d: "M18 5v6", key: "g5ayrv" }]
]);
const gc = r("BellRingIcon", [
  ["path", { d: "M6 8a6 6 0 0 1 12 0c0 7 3 9 3 9H3s3-2 3-9", key: "1qo2s2" }],
  ["path", { d: "M10.3 21a1.94 1.94 0 0 0 3.4 0", key: "qgo35s" }],
  ["path", { d: "M4 2C2.8 3.7 2 5.7 2 8", key: "tap9e0" }],
  ["path", { d: "M22 8c0-2.3-.8-4.3-2-6", key: "5bb3ad" }]
]);
const Mc = r("BellIcon", [
  ["path", { d: "M6 8a6 6 0 0 1 12 0c0 7 3 9 3 9H3s3-2 3-9", key: "1qo2s2" }],
  ["path", { d: "M10.3 21a1.94 1.94 0 0 0 3.4 0", key: "qgo35s" }]
]);
const Ma = r("BetweenHorizontalEndIcon", [
  ["rect", { width: "13", height: "7", x: "3", y: "3", rx: "1", key: "11xb64" }],
  ["path", { d: "m22 15-3-3 3-3", key: "26chmm" }],
  ["rect", { width: "13", height: "7", x: "3", y: "14", rx: "1", key: "k6ky7n" }]
]);
const xa = r("BetweenHorizontalStartIcon", [
  ["rect", { width: "13", height: "7", x: "8", y: "3", rx: "1", key: "pkso9a" }],
  ["path", { d: "m2 9 3 3-3 3", key: "1agib5" }],
  ["rect", { width: "13", height: "7", x: "8", y: "14", rx: "1", key: "1q5fc1" }]
]);
const xc = r("BetweenVerticalEndIcon", [
  ["rect", { width: "7", height: "13", x: "3", y: "3", rx: "1", key: "1fdu0f" }],
  ["path", { d: "m9 22 3-3 3 3", key: "17z65a" }],
  ["rect", { width: "7", height: "13", x: "14", y: "3", rx: "1", key: "1squn4" }]
]);
const bc = r("BetweenVerticalStartIcon", [
  ["rect", { width: "7", height: "13", x: "3", y: "8", rx: "1", key: "1fjrkv" }],
  ["path", { d: "m15 2-3 3-3-3", key: "1uh6eb" }],
  ["rect", { width: "7", height: "13", x: "14", y: "8", rx: "1", key: "w3fjg8" }]
]);
const wc = r("BikeIcon", [
  ["circle", { cx: "18.5", cy: "17.5", r: "3.5", key: "15x4ox" }],
  ["circle", { cx: "5.5", cy: "17.5", r: "3.5", key: "1noe27" }],
  ["circle", { cx: "15", cy: "5", r: "1", key: "19l28e" }],
  ["path", { d: "M12 17.5V14l-3-3 4-3 2 3h2", key: "1npguv" }]
]);
const Ic = r("BinaryIcon", [
  ["rect", { x: "14", y: "14", width: "4", height: "6", rx: "2", key: "p02svl" }],
  ["rect", { x: "6", y: "4", width: "4", height: "6", rx: "2", key: "xm4xkj" }],
  ["path", { d: "M6 20h4", key: "1i6q5t" }],
  ["path", { d: "M14 10h4", key: "ru81e7" }],
  ["path", { d: "M6 14h2v6", key: "16z9wg" }],
  ["path", { d: "M14 4h2v6", key: "1idq9u" }]
]);
const Lc = r("BiohazardIcon", [
  ["circle", { cx: "12", cy: "11.9", r: "2", key: "e8h31w" }],
  ["path", { d: "M6.7 3.4c-.9 2.5 0 5.2 2.2 6.7C6.5 9 3.7 9.6 2 11.6", key: "17bolr" }],
  ["path", { d: "m8.9 10.1 1.4.8", key: "15ezny" }],
  ["path", { d: "M17.3 3.4c.9 2.5 0 5.2-2.2 6.7 2.4-1.2 5.2-.6 6.9 1.5", key: "wtwa5u" }],
  ["path", { d: "m15.1 10.1-1.4.8", key: "1r0b28" }],
  ["path", { d: "M16.7 20.8c-2.6-.4-4.6-2.6-4.7-5.3-.2 2.6-2.1 4.8-4.7 5.2", key: "m7qszh" }],
  ["path", { d: "M12 13.9v1.6", key: "zfyyim" }],
  ["path", { d: "M13.5 5.4c-1-.2-2-.2-3 0", key: "1bi9q0" }],
  ["path", { d: "M17 16.4c.7-.7 1.2-1.6 1.5-2.5", key: "1rhjqw" }],
  ["path", { d: "M5.5 13.9c.3.9.8 1.8 1.5 2.5", key: "8gsud3" }]
]);
const Sc = r("BirdIcon", [
  ["path", { d: "M16 7h.01", key: "1kdx03" }],
  ["path", { d: "M3.4 18H12a8 8 0 0 0 8-8V7a4 4 0 0 0-7.28-2.3L2 20", key: "oj1oa8" }],
  ["path", { d: "m20 7 2 .5-2 .5", key: "12nv4d" }],
  ["path", { d: "M10 18v3", key: "1yea0a" }],
  ["path", { d: "M14 17.75V21", key: "1pymcb" }],
  ["path", { d: "M7 18a6 6 0 0 0 3.84-10.61", key: "1npnn0" }]
]);
const Cc = r("BitcoinIcon", [
  [
    "path",
    {
      d: "M11.767 19.089c4.924.868 6.14-6.025 1.216-6.894m-1.216 6.894L5.86 18.047m5.908 1.042-.347 1.97m1.563-8.864c4.924.869 6.14-6.025 1.215-6.893m-1.215 6.893-3.94-.694m5.155-6.2L8.29 4.26m5.908 1.042.348-1.97M7.48 20.364l3.126-17.727",
      key: "yr8idg"
    }
  ]
]);
const Ac = r("BlendIcon", [
  ["circle", { cx: "9", cy: "9", r: "7", key: "p2h5vp" }],
  ["circle", { cx: "15", cy: "15", r: "7", key: "19ennj" }]
]);
const Pc = r("BlindsIcon", [
  ["path", { d: "M3 3h18", key: "o7r712" }],
  ["path", { d: "M20 7H8", key: "gd2fo2" }],
  ["path", { d: "M20 11H8", key: "1ynp89" }],
  ["path", { d: "M10 19h10", key: "19hjk5" }],
  ["path", { d: "M8 15h12", key: "1yqzne" }],
  ["path", { d: "M4 3v14", key: "fggqzn" }],
  ["circle", { cx: "4", cy: "19", r: "2", key: "p3m9r0" }]
]);
const qc = r("BlocksIcon", [
  ["rect", { width: "7", height: "7", x: "14", y: "3", rx: "1", key: "6d4xhi" }],
  [
    "path",
    {
      d: "M10 21V8a1 1 0 0 0-1-1H4a1 1 0 0 0-1 1v12a1 1 0 0 0 1 1h12a1 1 0 0 0 1-1v-5a1 1 0 0 0-1-1H3",
      key: "1fpvtg"
    }
  ]
]);
const Tc = r("BluetoothConnectedIcon", [
  ["path", { d: "m7 7 10 10-5 5V2l5 5L7 17", key: "1q5490" }],
  ["line", { x1: "18", x2: "21", y1: "12", y2: "12", key: "1rsjjs" }],
  ["line", { x1: "3", x2: "6", y1: "12", y2: "12", key: "11yl8c" }]
]);
const Dc = r("BluetoothOffIcon", [
  ["path", { d: "m17 17-5 5V12l-5 5", key: "v5aci6" }],
  ["path", { d: "m2 2 20 20", key: "1ooewy" }],
  ["path", { d: "M14.5 9.5 17 7l-5-5v4.5", key: "1kddfz" }]
]);
const _c = r("BluetoothSearchingIcon", [
  ["path", { d: "m7 7 10 10-5 5V2l5 5L7 17", key: "1q5490" }],
  ["path", { d: "M20.83 14.83a4 4 0 0 0 0-5.66", key: "k8tn1j" }],
  ["path", { d: "M18 12h.01", key: "yjnet6" }]
]);
const Bc = r("BluetoothIcon", [
  ["path", { d: "m7 7 10 10-5 5V2l5 5L7 17", key: "1q5490" }]
]);
const zc = r("BoldIcon", [
  ["path", { d: "M14 12a4 4 0 0 0 0-8H6v8", key: "v2sylx" }],
  ["path", { d: "M15 20a4 4 0 0 0 0-8H6v8Z", key: "1ef5ya" }]
]);
const Hc = r("BoltIcon", [
  [
    "path",
    {
      d: "M21 16V8a2 2 0 0 0-1-1.73l-7-4a2 2 0 0 0-2 0l-7 4A2 2 0 0 0 3 8v8a2 2 0 0 0 1 1.73l7 4a2 2 0 0 0 2 0l7-4A2 2 0 0 0 21 16z",
      key: "yt0hxn"
    }
  ],
  ["circle", { cx: "12", cy: "12", r: "4", key: "4exip2" }]
]);
const jc = r("BombIcon", [
  ["circle", { cx: "11", cy: "13", r: "9", key: "hd149" }],
  [
    "path",
    {
      d: "M14.35 4.65 16.3 2.7a2.41 2.41 0 0 1 3.4 0l1.6 1.6a2.4 2.4 0 0 1 0 3.4l-1.95 1.95",
      key: "jp4j1b"
    }
  ],
  ["path", { d: "m22 2-1.5 1.5", key: "ay92ug" }]
]);
const Vc = r("BoneIcon", [
  [
    "path",
    {
      d: "M17 10c.7-.7 1.69 0 2.5 0a2.5 2.5 0 1 0 0-5 .5.5 0 0 1-.5-.5 2.5 2.5 0 1 0-5 0c0 .81.7 1.8 0 2.5l-7 7c-.7.7-1.69 0-2.5 0a2.5 2.5 0 0 0 0 5c.28 0 .5.22.5.5a2.5 2.5 0 1 0 5 0c0-.81-.7-1.8 0-2.5Z",
      key: "w610uw"
    }
  ]
]);
const Oc = r("BookAIcon", [
  ["path", { d: "M4 19.5v-15A2.5 2.5 0 0 1 6.5 2H20v20H6.5a2.5 2.5 0 0 1 0-5H20", key: "t4utmx" }],
  ["path", { d: "m8 13 4-7 4 7", key: "4rari8" }],
  ["path", { d: "M9.1 11h5.7", key: "1gkovt" }]
]);
const $c = r("BookAudioIcon", [
  ["path", { d: "M4 19.5v-15A2.5 2.5 0 0 1 6.5 2H20v20H6.5a2.5 2.5 0 0 1 0-5H20", key: "t4utmx" }],
  ["path", { d: "M8 8v3", key: "1qzp49" }],
  ["path", { d: "M12 6v7", key: "1f6ttz" }],
  ["path", { d: "M16 8v3", key: "gejaml" }]
]);
const Rc = r("BookCheckIcon", [
  ["path", { d: "M4 19.5v-15A2.5 2.5 0 0 1 6.5 2H20v20H6.5a2.5 2.5 0 0 1 0-5H20", key: "t4utmx" }],
  ["path", { d: "m9 9.5 2 2 4-4", key: "1dth82" }]
]);
const Fc = r("BookCopyIcon", [
  ["path", { d: "M2 16V4a2 2 0 0 1 2-2h11", key: "spzkk5" }],
  ["path", { d: "M5 14H4a2 2 0 1 0 0 4h1", key: "16gqf9" }],
  ["path", { d: "M22 18H11a2 2 0 1 0 0 4h11V6H11a2 2 0 0 0-2 2v12", key: "1owzki" }]
]);
const ba = r("BookDashedIcon", [
  ["path", { d: "M20 22h-2", key: "1rpnb6" }],
  ["path", { d: "M20 15v2h-2", key: "fph276" }],
  ["path", { d: "M4 19.5V15", key: "6gr39e" }],
  ["path", { d: "M20 8v3", key: "deu0bs" }],
  ["path", { d: "M18 2h2v2", key: "180o53" }],
  ["path", { d: "M4 11V9", key: "v3xsx8" }],
  ["path", { d: "M12 2h2", key: "cvn524" }],
  ["path", { d: "M12 22h2", key: "kn7ki6" }],
  ["path", { d: "M12 17h2", key: "13u4lk" }],
  ["path", { d: "M8 22H6.5a2.5 2.5 0 0 1 0-5H8", key: "fiseg2" }],
  ["path", { d: "M4 5v-.5A2.5 2.5 0 0 1 6.5 2H8", key: "wywhs9" }]
]);
const Uc = r("BookDownIcon", [
  ["path", { d: "M4 19.5v-15A2.5 2.5 0 0 1 6.5 2H20v20H6.5a2.5 2.5 0 0 1 0-5H20", key: "t4utmx" }],
  ["path", { d: "M12 13V7", key: "h0r20n" }],
  ["path", { d: "m9 10 3 3 3-3", key: "zt5b4y" }]
]);
const Ec = r("BookHeadphonesIcon", [
  ["path", { d: "M4 19.5v-15A2.5 2.5 0 0 1 6.5 2H20v20H6.5a2.5 2.5 0 0 1 0-5H20", key: "t4utmx" }],
  ["circle", { cx: "9", cy: "12", r: "1", key: "1vctgf" }],
  ["path", { d: "M8 12v-2a4 4 0 0 1 8 0v2", key: "1vsqkj" }],
  ["circle", { cx: "15", cy: "12", r: "1", key: "1tmaij" }]
]);
const Wc = r("BookHeartIcon", [
  ["path", { d: "M4 19.5v-15A2.5 2.5 0 0 1 6.5 2H20v20H6.5a2.5 2.5 0 0 1 0-5H20", key: "t4utmx" }],
  [
    "path",
    {
      d: "M16 8.2C16 7 15 6 13.8 6c-.8 0-1.4.3-1.8.9-.4-.6-1-.9-1.8-.9C9 6 8 7 8 8.2c0 .6.3 1.2.7 1.6h0C10 11.1 12 13 12 13s2-1.9 3.3-3.1h0c.4-.4.7-1 .7-1.7z",
      key: "1dlbw1"
    }
  ]
]);
const Nc = r("BookImageIcon", [
  ["path", { d: "M4 19.5v-15A2.5 2.5 0 0 1 6.5 2H20v20H6.5a2.5 2.5 0 0 1 0-5H20", key: "t4utmx" }],
  ["circle", { cx: "10", cy: "8", r: "2", key: "2qkj4p" }],
  ["path", { d: "m20 13.7-2.1-2.1c-.8-.8-2-.8-2.8 0L9.7 17", key: "160say" }]
]);
const Zc = r("BookKeyIcon", [
  ["path", { d: "M4 19.5v-15A2.5 2.5 0 0 1 6.5 2H14", key: "1gfsgw" }],
  ["path", { d: "M20 8v14H6.5a2.5 2.5 0 0 1 0-5H20", key: "zb0ngp" }],
  ["circle", { cx: "14", cy: "8", r: "2", key: "u49eql" }],
  ["path", { d: "m20 2-4.5 4.5", key: "1sppr8" }],
  ["path", { d: "m19 3 1 1", key: "ze14oc" }]
]);
const Yc = r("BookLockIcon", [
  ["path", { d: "M4 19.5v-15A2.5 2.5 0 0 1 6.5 2H10", key: "18wgow" }],
  ["path", { d: "M20 15v7H6.5a2.5 2.5 0 0 1 0-5H20", key: "dpch1j" }],
  ["rect", { width: "8", height: "5", x: "12", y: "6", rx: "1", key: "9nqwug" }],
  ["path", { d: "M18 6V4a2 2 0 1 0-4 0v2", key: "1aquzs" }]
]);
const Gc = r("BookMarkedIcon", [
  ["path", { d: "M4 19.5v-15A2.5 2.5 0 0 1 6.5 2H20v20H6.5a2.5 2.5 0 0 1 0-5H20", key: "t4utmx" }],
  ["polyline", { points: "10 2 10 10 13 7 16 10 16 2", key: "13o6vz" }]
]);
const Xc = r("BookMinusIcon", [
  ["path", { d: "M4 19.5v-15A2.5 2.5 0 0 1 6.5 2H20v20H6.5a2.5 2.5 0 0 1 0-5H20", key: "t4utmx" }],
  ["path", { d: "M9 10h6", key: "9gxzsh" }]
]);
const Kc = r("BookOpenCheckIcon", [
  ["path", { d: "M8 3H2v15h7c1.7 0 3 1.3 3 3V7c0-2.2-1.8-4-4-4Z", key: "1i8u0n" }],
  ["path", { d: "m16 12 2 2 4-4", key: "mdajum" }],
  ["path", { d: "M22 6V3h-6c-2.2 0-4 1.8-4 4v14c0-1.7 1.3-3 3-3h7v-2.3", key: "jb5l51" }]
]);
const Qc = r("BookOpenTextIcon", [
  ["path", { d: "M2 3h6a4 4 0 0 1 4 4v14a3 3 0 0 0-3-3H2z", key: "vv98re" }],
  ["path", { d: "M22 3h-6a4 4 0 0 0-4 4v14a3 3 0 0 1 3-3h7z", key: "1cyq3y" }],
  ["path", { d: "M6 8h2", key: "30oboj" }],
  ["path", { d: "M6 12h2", key: "32wvfc" }],
  ["path", { d: "M16 8h2", key: "msurwy" }],
  ["path", { d: "M16 12h2", key: "7q9ll5" }]
]);
const Jc = r("BookOpenIcon", [
  ["path", { d: "M2 3h6a4 4 0 0 1 4 4v14a3 3 0 0 0-3-3H2z", key: "vv98re" }],
  ["path", { d: "M22 3h-6a4 4 0 0 0-4 4v14a3 3 0 0 1 3-3h7z", key: "1cyq3y" }]
]);
const e2 = r("BookPlusIcon", [
  ["path", { d: "M4 19.5v-15A2.5 2.5 0 0 1 6.5 2H20v20H6.5a2.5 2.5 0 0 1 0-5H20", key: "t4utmx" }],
  ["path", { d: "M9 10h6", key: "9gxzsh" }],
  ["path", { d: "M12 7v6", key: "lw1j43" }]
]);
const t2 = r("BookTextIcon", [
  ["path", { d: "M4 19.5v-15A2.5 2.5 0 0 1 6.5 2H20v20H6.5a2.5 2.5 0 0 1 0-5H20", key: "t4utmx" }],
  ["path", { d: "M8 7h6", key: "1f0q6e" }],
  ["path", { d: "M8 11h8", key: "vwpz6n" }]
]);
const a2 = r("BookTypeIcon", [
  ["path", { d: "M4 19.5v-15A2.5 2.5 0 0 1 6.5 2H20v20H6.5a2.5 2.5 0 0 1 0-5H20", key: "t4utmx" }],
  ["path", { d: "M16 8V6H8v2", key: "x8j6u4" }],
  ["path", { d: "M12 6v7", key: "1f6ttz" }],
  ["path", { d: "M10 13h4", key: "ytezjc" }]
]);
const n2 = r("BookUp2Icon", [
  ["path", { d: "M4 19.5v-15A2.5 2.5 0 0 1 6.5 2", key: "1lorq7" }],
  ["path", { d: "M18 2h2v20H6.5a2.5 2.5 0 0 1 0-5H20", key: "1nfm9i" }],
  ["path", { d: "M12 13V7", key: "h0r20n" }],
  ["path", { d: "m9 10 3-3 3 3", key: "11gsxs" }],
  ["path", { d: "m9 5 3-3 3 3", key: "l8vdw6" }]
]);
const o2 = r("BookUpIcon", [
  ["path", { d: "M4 19.5v-15A2.5 2.5 0 0 1 6.5 2H20v20H6.5a2.5 2.5 0 0 1 0-5H20", key: "t4utmx" }],
  ["path", { d: "M12 13V7", key: "h0r20n" }],
  ["path", { d: "m9 10 3-3 3 3", key: "11gsxs" }]
]);
const r2 = r("BookUserIcon", [
  ["path", { d: "M4 19.5v-15A2.5 2.5 0 0 1 6.5 2H20v20H6.5a2.5 2.5 0 0 1 0-5H20", key: "t4utmx" }],
  ["circle", { cx: "12", cy: "8", r: "2", key: "1822b1" }],
  ["path", { d: "M15 13a3 3 0 1 0-6 0", key: "10j68g" }]
]);
const i2 = r("BookXIcon", [
  ["path", { d: "M4 19.5v-15A2.5 2.5 0 0 1 6.5 2H20v20H6.5a2.5 2.5 0 0 1 0-5H20", key: "t4utmx" }],
  ["path", { d: "m14.5 7-5 5", key: "dy991v" }],
  ["path", { d: "m9.5 7 5 5", key: "s45iea" }]
]);
const l2 = r("BookIcon", [
  ["path", { d: "M4 19.5v-15A2.5 2.5 0 0 1 6.5 2H20v20H6.5a2.5 2.5 0 0 1 0-5H20", key: "t4utmx" }]
]);
const c2 = r("BookmarkCheckIcon", [
  ["path", { d: "m19 21-7-4-7 4V5a2 2 0 0 1 2-2h10a2 2 0 0 1 2 2Z", key: "169p4p" }],
  ["path", { d: "m9 10 2 2 4-4", key: "1gnqz4" }]
]);
const d2 = r("BookmarkMinusIcon", [
  ["path", { d: "m19 21-7-4-7 4V5a2 2 0 0 1 2-2h10a2 2 0 0 1 2 2v16z", key: "1fy3hk" }],
  ["line", { x1: "15", x2: "9", y1: "10", y2: "10", key: "1gty7f" }]
]);
const s2 = r("BookmarkPlusIcon", [
  ["path", { d: "m19 21-7-4-7 4V5a2 2 0 0 1 2-2h10a2 2 0 0 1 2 2v16z", key: "1fy3hk" }],
  ["line", { x1: "12", x2: "12", y1: "7", y2: "13", key: "1cppfj" }],
  ["line", { x1: "15", x2: "9", y1: "10", y2: "10", key: "1gty7f" }]
]);
const u2 = r("BookmarkXIcon", [
  ["path", { d: "m19 21-7-4-7 4V5a2 2 0 0 1 2-2h10a2 2 0 0 1 2 2Z", key: "169p4p" }],
  ["path", { d: "m14.5 7.5-5 5", key: "3lb6iw" }],
  ["path", { d: "m9.5 7.5 5 5", key: "ko136h" }]
]);
const h2 = r("BookmarkIcon", [
  ["path", { d: "m19 21-7-4-7 4V5a2 2 0 0 1 2-2h10a2 2 0 0 1 2 2v16z", key: "1fy3hk" }]
]);
const p2 = r("BoomBoxIcon", [
  ["path", { d: "M4 9V5a2 2 0 0 1 2-2h12a2 2 0 0 1 2 2v4", key: "vvzvr1" }],
  ["path", { d: "M8 8v1", key: "xcqmfk" }],
  ["path", { d: "M12 8v1", key: "1rj8u4" }],
  ["path", { d: "M16 8v1", key: "1q12zr" }],
  ["rect", { width: "20", height: "12", x: "2", y: "9", rx: "2", key: "igpb89" }],
  ["circle", { cx: "8", cy: "15", r: "2", key: "fa4a8s" }],
  ["circle", { cx: "16", cy: "15", r: "2", key: "14c3ya" }]
]);
const y2 = r("BotMessageSquareIcon", [
  ["path", { d: "M12 6V2H8", key: "1155em" }],
  ["path", { d: "m8 18-4 4V8a2 2 0 0 1 2-2h12a2 2 0 0 1 2 2v8a2 2 0 0 1-2 2Z", key: "w2lp3e" }],
  ["path", { d: "M2 12h2", key: "1t8f8n" }],
  ["path", { d: "M9 11v2", key: "1ueba0" }],
  ["path", { d: "M15 11v2", key: "i11awn" }],
  ["path", { d: "M20 12h2", key: "1q8mjw" }]
]);
const k2 = r("BotIcon", [
  ["path", { d: "M12 8V4H8", key: "hb8ula" }],
  ["rect", { width: "16", height: "12", x: "4", y: "8", rx: "2", key: "enze0r" }],
  ["path", { d: "M2 14h2", key: "vft8re" }],
  ["path", { d: "M20 14h2", key: "4cs60a" }],
  ["path", { d: "M15 13v2", key: "1xurst" }],
  ["path", { d: "M9 13v2", key: "rq6x2g" }]
]);
const f2 = r("BoxSelectIcon", [
  ["path", { d: "M5 3a2 2 0 0 0-2 2", key: "y57alp" }],
  ["path", { d: "M19 3a2 2 0 0 1 2 2", key: "18rm91" }],
  ["path", { d: "M21 19a2 2 0 0 1-2 2", key: "1j7049" }],
  ["path", { d: "M5 21a2 2 0 0 1-2-2", key: "sbafld" }],
  ["path", { d: "M9 3h1", key: "1yesri" }],
  ["path", { d: "M9 21h1", key: "15o7lz" }],
  ["path", { d: "M14 3h1", key: "1ec4yj" }],
  ["path", { d: "M14 21h1", key: "v9vybs" }],
  ["path", { d: "M3 9v1", key: "1r0deq" }],
  ["path", { d: "M21 9v1", key: "mxsmne" }],
  ["path", { d: "M3 14v1", key: "vnatye" }],
  ["path", { d: "M21 14v1", key: "169vum" }]
]);
const v2 = r("BoxIcon", [
  [
    "path",
    {
      d: "M21 8a2 2 0 0 0-1-1.73l-7-4a2 2 0 0 0-2 0l-7 4A2 2 0 0 0 3 8v8a2 2 0 0 0 1 1.73l7 4a2 2 0 0 0 2 0l7-4A2 2 0 0 0 21 16Z",
      key: "hh9hay"
    }
  ],
  ["path", { d: "m3.3 7 8.7 5 8.7-5", key: "g66t2b" }],
  ["path", { d: "M12 22V12", key: "d0xqtd" }]
]);
const m2 = r("BoxesIcon", [
  [
    "path",
    {
      d: "M2.97 12.92A2 2 0 0 0 2 14.63v3.24a2 2 0 0 0 .97 1.71l3 1.8a2 2 0 0 0 2.06 0L12 19v-5.5l-5-3-4.03 2.42Z",
      key: "lc1i9w"
    }
  ],
  ["path", { d: "m7 16.5-4.74-2.85", key: "1o9zyk" }],
  ["path", { d: "m7 16.5 5-3", key: "va8pkn" }],
  ["path", { d: "M7 16.5v5.17", key: "jnp8gn" }],
  [
    "path",
    {
      d: "M12 13.5V19l3.97 2.38a2 2 0 0 0 2.06 0l3-1.8a2 2 0 0 0 .97-1.71v-3.24a2 2 0 0 0-.97-1.71L17 10.5l-5 3Z",
      key: "8zsnat"
    }
  ],
  ["path", { d: "m17 16.5-5-3", key: "8arw3v" }],
  ["path", { d: "m17 16.5 4.74-2.85", key: "8rfmw" }],
  ["path", { d: "M17 16.5v5.17", key: "k6z78m" }],
  [
    "path",
    {
      d: "M7.97 4.42A2 2 0 0 0 7 6.13v4.37l5 3 5-3V6.13a2 2 0 0 0-.97-1.71l-3-1.8a2 2 0 0 0-2.06 0l-3 1.8Z",
      key: "1xygjf"
    }
  ],
  ["path", { d: "M12 8 7.26 5.15", key: "1vbdud" }],
  ["path", { d: "m12 8 4.74-2.85", key: "3rx089" }],
  ["path", { d: "M12 13.5V8", key: "1io7kd" }]
]);
const wa = r("BracesIcon", [
  [
    "path",
    { d: "M8 3H7a2 2 0 0 0-2 2v5a2 2 0 0 1-2 2 2 2 0 0 1 2 2v5c0 1.1.9 2 2 2h1", key: "ezmyqa" }
  ],
  [
    "path",
    {
      d: "M16 21h1a2 2 0 0 0 2-2v-5c0-1.1.9-2 2-2a2 2 0 0 1-2-2V5a2 2 0 0 0-2-2h-1",
      key: "e1hn23"
    }
  ]
]);
const g2 = r("BracketsIcon", [
  ["path", { d: "M16 3h3v18h-3", key: "1yor1f" }],
  ["path", { d: "M8 21H5V3h3", key: "1qrfwo" }]
]);
const M2 = r("BrainCircuitIcon", [
  [
    "path",
    {
      d: "M12 5a3 3 0 1 0-5.997.125 4 4 0 0 0-2.526 5.77 4 4 0 0 0 .556 6.588A4 4 0 1 0 12 18Z",
      key: "l5xja"
    }
  ],
  ["path", { d: "M9 13a4.5 4.5 0 0 0 3-4", key: "10igwf" }],
  ["path", { d: "M6.003 5.125A3 3 0 0 0 6.401 6.5", key: "105sqy" }],
  ["path", { d: "M3.477 10.896a4 4 0 0 1 .585-.396", key: "ql3yin" }],
  ["path", { d: "M6 18a4 4 0 0 1-1.967-.516", key: "2e4loj" }],
  ["path", { d: "M12 13h4", key: "1ku699" }],
  ["path", { d: "M12 18h6a2 2 0 0 1 2 2v1", key: "105ag5" }],
  ["path", { d: "M12 8h8", key: "1lhi5i" }],
  ["path", { d: "M16 8V5a2 2 0 0 1 2-2", key: "u6izg6" }],
  ["circle", { cx: "16", cy: "13", r: ".5", key: "ry7gng" }],
  ["circle", { cx: "18", cy: "3", r: ".5", key: "1aiba7" }],
  ["circle", { cx: "20", cy: "21", r: ".5", key: "yhc1fs" }],
  ["circle", { cx: "20", cy: "8", r: ".5", key: "1e43v0" }]
]);
const x2 = r("BrainCogIcon", [
  [
    "path",
    {
      d: "M12 5a3 3 0 1 0-5.997.142 4 4 0 0 0-2.526 5.77 4 4 0 0 0 .556 6.588 4 4 0 0 0 7.636 2.106 3.2 3.2 0 0 0 .164-.546c.028-.13.306-.13.335 0a3.2 3.2 0 0 0 .163.546 4 4 0 0 0 7.636-2.106 4 4 0 0 0 .556-6.588 4 4 0 0 0-2.526-5.77A3 3 0 1 0 12 5",
      key: "1kgmhc"
    }
  ],
  ["path", { d: "M17.599 6.5a3 3 0 0 0 .399-1.375", key: "tmeiqw" }],
  ["path", { d: "M6.003 5.125A3 3 0 0 0 6.401 6.5", key: "105sqy" }],
  ["path", { d: "M3.477 10.896a4 4 0 0 1 .585-.396", key: "ql3yin" }],
  ["path", { d: "M19.938 10.5a4 4 0 0 1 .585.396", key: "1qfode" }],
  ["path", { d: "M6 18a4 4 0 0 1-1.967-.516", key: "2e4loj" }],
  ["path", { d: "M19.967 17.484A4 4 0 0 1 18 18", key: "159ez6" }],
  ["circle", { cx: "12", cy: "12", r: "3", key: "1v7zrd" }],
  ["path", { d: "m15.7 10.4-.9.4", key: "ayzo6p" }],
  ["path", { d: "m9.2 13.2-.9.4", key: "1uzb3g" }],
  ["path", { d: "m13.6 15.7-.4-.9", key: "11ifqf" }],
  ["path", { d: "m10.8 9.2-.4-.9", key: "1pmk2v" }],
  ["path", { d: "m15.7 13.5-.9-.4", key: "7ng02m" }],
  ["path", { d: "m9.2 10.9-.9-.4", key: "1x66zd" }],
  ["path", { d: "m10.5 15.7.4-.9", key: "3js94g" }],
  ["path", { d: "m13.1 9.2.4-.9", key: "18n7mc" }]
]);
const b2 = r("BrainIcon", [
  [
    "path",
    {
      d: "M12 5a3 3 0 1 0-5.997.125 4 4 0 0 0-2.526 5.77 4 4 0 0 0 .556 6.588A4 4 0 1 0 12 18Z",
      key: "l5xja"
    }
  ],
  [
    "path",
    {
      d: "M12 5a3 3 0 1 1 5.997.125 4 4 0 0 1 2.526 5.77 4 4 0 0 1-.556 6.588A4 4 0 1 1 12 18Z",
      key: "ep3f8r"
    }
  ],
  ["path", { d: "M15 13a4.5 4.5 0 0 1-3-4 4.5 4.5 0 0 1-3 4", key: "1p4c4q" }],
  ["path", { d: "M17.599 6.5a3 3 0 0 0 .399-1.375", key: "tmeiqw" }],
  ["path", { d: "M6.003 5.125A3 3 0 0 0 6.401 6.5", key: "105sqy" }],
  ["path", { d: "M3.477 10.896a4 4 0 0 1 .585-.396", key: "ql3yin" }],
  ["path", { d: "M19.938 10.5a4 4 0 0 1 .585.396", key: "1qfode" }],
  ["path", { d: "M6 18a4 4 0 0 1-1.967-.516", key: "2e4loj" }],
  ["path", { d: "M19.967 17.484A4 4 0 0 1 18 18", key: "159ez6" }]
]);
const w2 = r("BrickWallIcon", [
  ["rect", { width: "18", height: "18", x: "3", y: "3", rx: "2", key: "afitv7" }],
  ["path", { d: "M12 9v6", key: "199k2o" }],
  ["path", { d: "M16 15v6", key: "8rj2es" }],
  ["path", { d: "M16 3v6", key: "1j6rpj" }],
  ["path", { d: "M3 15h18", key: "5xshup" }],
  ["path", { d: "M3 9h18", key: "1pudct" }],
  ["path", { d: "M8 15v6", key: "1stoo3" }],
  ["path", { d: "M8 3v6", key: "vlvjmk" }]
]);
const I2 = r("BriefcaseBusinessIcon", [
  ["path", { d: "M12 12h.01", key: "1mp3jc" }],
  ["path", { d: "M16 6V4a2 2 0 0 0-2-2h-4a2 2 0 0 0-2 2v2", key: "1ksdt3" }],
  ["path", { d: "M22 13a18.15 18.15 0 0 1-20 0", key: "12hx5q" }],
  ["rect", { width: "20", height: "14", x: "2", y: "6", rx: "2", key: "i6l2r4" }]
]);
const L2 = r("BriefcaseMedicalIcon", [
  ["path", { d: "M12 11v4", key: "a6ujw6" }],
  ["path", { d: "M14 13h-4", key: "1pl8zg" }],
  ["path", { d: "M16 6V4a2 2 0 0 0-2-2h-4a2 2 0 0 0-2 2v2", key: "1ksdt3" }],
  ["path", { d: "M18 6v14", key: "1mu4gy" }],
  ["path", { d: "M6 6v14", key: "1s15cj" }],
  ["rect", { width: "20", height: "14", x: "2", y: "6", rx: "2", key: "i6l2r4" }]
]);
const S2 = r("BriefcaseIcon", [
  ["path", { d: "M16 20V4a2 2 0 0 0-2-2h-4a2 2 0 0 0-2 2v16", key: "jecpp" }],
  ["rect", { width: "20", height: "14", x: "2", y: "6", rx: "2", key: "i6l2r4" }]
]);
const C2 = r("BringToFrontIcon", [
  ["rect", { x: "8", y: "8", width: "8", height: "8", rx: "2", key: "yj20xf" }],
  ["path", { d: "M4 10a2 2 0 0 1-2-2V4a2 2 0 0 1 2-2h4a2 2 0 0 1 2 2", key: "1ltk23" }],
  ["path", { d: "M14 20a2 2 0 0 0 2 2h4a2 2 0 0 0 2-2v-4a2 2 0 0 0-2-2", key: "1q24h9" }]
]);
const A2 = r("BrushIcon", [
  ["path", { d: "m9.06 11.9 8.07-8.06a2.85 2.85 0 1 1 4.03 4.03l-8.06 8.08", key: "1styjt" }],
  [
    "path",
    {
      d: "M7.07 14.94c-1.66 0-3 1.35-3 3.02 0 1.33-2.5 1.52-2 2.02 1.08 1.1 2.49 2.02 4 2.02 2.2 0 4-1.8 4-4.04a3.01 3.01 0 0 0-3-3.02z",
      key: "z0l1mu"
    }
  ]
]);
const P2 = r("BugOffIcon", [
  ["path", { d: "M15 7.13V6a3 3 0 0 0-5.14-2.1L8 2", key: "vl8zik" }],
  ["path", { d: "M14.12 3.88 16 2", key: "qol33r" }],
  ["path", { d: "M22 13h-4v-2a4 4 0 0 0-4-4h-1.3", key: "1ou0bd" }],
  ["path", { d: "M20.97 5c0 2.1-1.6 3.8-3.5 4", key: "18gb23" }],
  ["path", { d: "m2 2 20 20", key: "1ooewy" }],
  ["path", { d: "M7.7 7.7A4 4 0 0 0 6 11v3a6 6 0 0 0 11.13 3.13", key: "1njkjs" }],
  ["path", { d: "M12 20v-8", key: "i3yub9" }],
  ["path", { d: "M6 13H2", key: "82j7cp" }],
  ["path", { d: "M3 21c0-2.1 1.7-3.9 3.8-4", key: "4p0ekp" }]
]);
const q2 = r("BugPlayIcon", [
  [
    "path",
    {
      d: "M12.765 21.522a.5.5 0 0 1-.765-.424v-8.196a.5.5 0 0 1 .765-.424l5.878 3.674a1 1 0 0 1 0 1.696z",
      key: "17shqo"
    }
  ],
  ["path", { d: "M14.12 3.88 16 2", key: "qol33r" }],
  ["path", { d: "M18 11a4 4 0 0 0-4-4h-4a4 4 0 0 0-4 4v3a6.1 6.1 0 0 0 2 4.5", key: "1tjixy" }],
  ["path", { d: "M20.97 5c0 2.1-1.6 3.8-3.5 4", key: "18gb23" }],
  ["path", { d: "M3 21c0-2.1 1.7-3.9 3.8-4", key: "4p0ekp" }],
  ["path", { d: "M6 13H2", key: "82j7cp" }],
  ["path", { d: "M6.53 9C4.6 8.8 3 7.1 3 5", key: "32zzws" }],
  ["path", { d: "m8 2 1.88 1.88", key: "fmnt4t" }],
  ["path", { d: "M9 7.13v-1a3.003 3.003 0 1 1 6 0v1", key: "d7y7pr" }]
]);
const T2 = r("BugIcon", [
  ["path", { d: "m8 2 1.88 1.88", key: "fmnt4t" }],
  ["path", { d: "M14.12 3.88 16 2", key: "qol33r" }],
  ["path", { d: "M9 7.13v-1a3.003 3.003 0 1 1 6 0v1", key: "d7y7pr" }],
  [
    "path",
    {
      d: "M12 20c-3.3 0-6-2.7-6-6v-3a4 4 0 0 1 4-4h4a4 4 0 0 1 4 4v3c0 3.3-2.7 6-6 6",
      key: "xs1cw7"
    }
  ],
  ["path", { d: "M12 20v-9", key: "1qisl0" }],
  ["path", { d: "M6.53 9C4.6 8.8 3 7.1 3 5", key: "32zzws" }],
  ["path", { d: "M6 13H2", key: "82j7cp" }],
  ["path", { d: "M3 21c0-2.1 1.7-3.9 3.8-4", key: "4p0ekp" }],
  ["path", { d: "M20.97 5c0 2.1-1.6 3.8-3.5 4", key: "18gb23" }],
  ["path", { d: "M22 13h-4", key: "1jl80f" }],
  ["path", { d: "M17.2 17c2.1.1 3.8 1.9 3.8 4", key: "k3fwyw" }]
]);
const D2 = r("Building2Icon", [
  ["path", { d: "M6 22V4a2 2 0 0 1 2-2h8a2 2 0 0 1 2 2v18Z", key: "1b4qmf" }],
  ["path", { d: "M6 12H4a2 2 0 0 0-2 2v6a2 2 0 0 0 2 2h2", key: "i71pzd" }],
  ["path", { d: "M18 9h2a2 2 0 0 1 2 2v9a2 2 0 0 1-2 2h-2", key: "10jefs" }],
  ["path", { d: "M10 6h4", key: "1itunk" }],
  ["path", { d: "M10 10h4", key: "tcdvrf" }],
  ["path", { d: "M10 14h4", key: "kelpxr" }],
  ["path", { d: "M10 18h4", key: "1ulq68" }]
]);
const _2 = r("BuildingIcon", [
  ["rect", { width: "16", height: "20", x: "4", y: "2", rx: "2", ry: "2", key: "76otgf" }],
  ["path", { d: "M9 22v-4h6v4", key: "r93iot" }],
  ["path", { d: "M8 6h.01", key: "1dz90k" }],
  ["path", { d: "M16 6h.01", key: "1x0f13" }],
  ["path", { d: "M12 6h.01", key: "1vi96p" }],
  ["path", { d: "M12 10h.01", key: "1nrarc" }],
  ["path", { d: "M12 14h.01", key: "1etili" }],
  ["path", { d: "M16 10h.01", key: "1m94wz" }],
  ["path", { d: "M16 14h.01", key: "1gbofw" }],
  ["path", { d: "M8 10h.01", key: "19clt8" }],
  ["path", { d: "M8 14h.01", key: "6423bh" }]
]);
const B2 = r("BusFrontIcon", [
  ["path", { d: "M4 6 2 7", key: "1mqr15" }],
  ["path", { d: "M10 6h4", key: "1itunk" }],
  ["path", { d: "m22 7-2-1", key: "1umjhc" }],
  ["rect", { width: "16", height: "16", x: "4", y: "3", rx: "2", key: "1wxw4b" }],
  ["path", { d: "M4 11h16", key: "mpoxn0" }],
  ["path", { d: "M8 15h.01", key: "a7atzg" }],
  ["path", { d: "M16 15h.01", key: "rnfrdf" }],
  ["path", { d: "M6 19v2", key: "1loha6" }],
  ["path", { d: "M18 21v-2", key: "sqyl04" }]
]);
const z2 = r("BusIcon", [
  ["path", { d: "M8 6v6", key: "18i7km" }],
  ["path", { d: "M15 6v6", key: "1sg6z9" }],
  ["path", { d: "M2 12h19.6", key: "de5uta" }],
  [
    "path",
    {
      d: "M18 18h3s.5-1.7.8-2.8c.1-.4.2-.8.2-1.2 0-.4-.1-.8-.2-1.2l-1.4-5C20.1 6.8 19.1 6 18 6H4a2 2 0 0 0-2 2v10h3",
      key: "1wwztk"
    }
  ],
  ["circle", { cx: "7", cy: "18", r: "2", key: "19iecd" }],
  ["path", { d: "M9 18h5", key: "lrx6i" }],
  ["circle", { cx: "16", cy: "18", r: "2", key: "1v4tcr" }]
]);
const H2 = r("CableCarIcon", [
  ["path", { d: "M10 3h.01", key: "lbucoy" }],
  ["path", { d: "M14 2h.01", key: "1k8aa1" }],
  ["path", { d: "m2 9 20-5", key: "1kz0j5" }],
  ["path", { d: "M12 12V6.5", key: "1vbrij" }],
  ["rect", { width: "16", height: "10", x: "4", y: "12", rx: "3", key: "if91er" }],
  ["path", { d: "M9 12v5", key: "3anwtq" }],
  ["path", { d: "M15 12v5", key: "5xh3zn" }],
  ["path", { d: "M4 17h16", key: "g4d7ey" }]
]);
const j2 = r("CableIcon", [
  ["path", { d: "M4 9a2 2 0 0 1-2-2V5h6v2a2 2 0 0 1-2 2Z", key: "1s6oa5" }],
  ["path", { d: "M3 5V3", key: "1k5hjh" }],
  ["path", { d: "M7 5V3", key: "1t1388" }],
  ["path", { d: "M19 15V6.5a3.5 3.5 0 0 0-7 0v11a3.5 3.5 0 0 1-7 0V9", key: "1ytv72" }],
  ["path", { d: "M17 21v-2", key: "ds4u3f" }],
  ["path", { d: "M21 21v-2", key: "eo0ou" }],
  ["path", { d: "M22 19h-6v-2a2 2 0 0 1 2-2h2a2 2 0 0 1 2 2Z", key: "sdz6o8" }]
]);
const V2 = r("CakeSliceIcon", [
  ["circle", { cx: "9", cy: "7", r: "2", key: "1305pl" }],
  [
    "path",
    { d: "M7.2 7.9 3 11v9c0 .6.4 1 1 1h16c.6 0 1-.4 1-1v-9c0-2-3-6-7-8l-3.6 2.6", key: "xle13f" }
  ],
  ["path", { d: "M16 13H3", key: "1wpj08" }],
  ["path", { d: "M16 17H3", key: "3lvfcd" }]
]);
const O2 = r("CakeIcon", [
  ["path", { d: "M20 21v-8a2 2 0 0 0-2-2H6a2 2 0 0 0-2 2v8", key: "1w3rig" }],
  ["path", { d: "M4 16s.5-1 2-1 2.5 2 4 2 2.5-2 4-2 2.5 2 4 2 2-1 2-1", key: "n2jgmb" }],
  ["path", { d: "M2 21h20", key: "1nyx9w" }],
  ["path", { d: "M7 8v3", key: "1qtyvj" }],
  ["path", { d: "M12 8v3", key: "hwp4zt" }],
  ["path", { d: "M17 8v3", key: "1i6e5u" }],
  ["path", { d: "M7 4h0.01", key: "hsw7lv" }],
  ["path", { d: "M12 4h0.01", key: "1e3d8f" }],
  ["path", { d: "M17 4h0.01", key: "p7cxgy" }]
]);
const $2 = r("CalculatorIcon", [
  ["rect", { width: "16", height: "20", x: "4", y: "2", rx: "2", key: "1nb95v" }],
  ["line", { x1: "8", x2: "16", y1: "6", y2: "6", key: "x4nwl0" }],
  ["line", { x1: "16", x2: "16", y1: "14", y2: "18", key: "wjye3r" }],
  ["path", { d: "M16 10h.01", key: "1m94wz" }],
  ["path", { d: "M12 10h.01", key: "1nrarc" }],
  ["path", { d: "M8 10h.01", key: "19clt8" }],
  ["path", { d: "M12 14h.01", key: "1etili" }],
  ["path", { d: "M8 14h.01", key: "6423bh" }],
  ["path", { d: "M12 18h.01", key: "mhygvu" }],
  ["path", { d: "M8 18h.01", key: "lrp35t" }]
]);
const R2 = r("CalendarCheck2Icon", [
  ["path", { d: "M8 2v4", key: "1cmpym" }],
  ["path", { d: "M16 2v4", key: "4m81vk" }],
  ["path", { d: "M21 14V6a2 2 0 0 0-2-2H5a2 2 0 0 0-2 2v14a2 2 0 0 0 2 2h8", key: "bce9hv" }],
  ["path", { d: "M3 10h18", key: "8toen8" }],
  ["path", { d: "m16 20 2 2 4-4", key: "13tcca" }]
]);
const F2 = r("CalendarCheckIcon", [
  ["path", { d: "M8 2v4", key: "1cmpym" }],
  ["path", { d: "M16 2v4", key: "4m81vk" }],
  ["rect", { width: "18", height: "18", x: "3", y: "4", rx: "2", key: "1hopcy" }],
  ["path", { d: "M3 10h18", key: "8toen8" }],
  ["path", { d: "m9 16 2 2 4-4", key: "19s6y9" }]
]);
const U2 = r("CalendarClockIcon", [
  ["path", { d: "M21 7.5V6a2 2 0 0 0-2-2H5a2 2 0 0 0-2 2v14a2 2 0 0 0 2 2h3.5", key: "1osxxc" }],
  ["path", { d: "M16 2v4", key: "4m81vk" }],
  ["path", { d: "M8 2v4", key: "1cmpym" }],
  ["path", { d: "M3 10h5", key: "r794hk" }],
  ["path", { d: "M17.5 17.5 16 16.3V14", key: "akvzfd" }],
  ["circle", { cx: "16", cy: "16", r: "6", key: "qoo3c4" }]
]);
const E2 = r("CalendarDaysIcon", [
  ["path", { d: "M8 2v4", key: "1cmpym" }],
  ["path", { d: "M16 2v4", key: "4m81vk" }],
  ["rect", { width: "18", height: "18", x: "3", y: "4", rx: "2", key: "1hopcy" }],
  ["path", { d: "M3 10h18", key: "8toen8" }],
  ["path", { d: "M8 14h.01", key: "6423bh" }],
  ["path", { d: "M12 14h.01", key: "1etili" }],
  ["path", { d: "M16 14h.01", key: "1gbofw" }],
  ["path", { d: "M8 18h.01", key: "lrp35t" }],
  ["path", { d: "M12 18h.01", key: "mhygvu" }],
  ["path", { d: "M16 18h.01", key: "kzsmim" }]
]);
const W2 = r("CalendarFoldIcon", [
  ["path", { d: "M8 2v4", key: "1cmpym" }],
  ["path", { d: "M16 2v4", key: "4m81vk" }],
  ["path", { d: "M21 17V6a2 2 0 0 0-2-2H5a2 2 0 0 0-2 2v14a2 2 0 0 0 2 2h11Z", key: "kg77oy" }],
  ["path", { d: "M3 10h18", key: "8toen8" }],
  ["path", { d: "M15 22v-4a2 2 0 0 1 2-2h4", key: "1gnbqr" }]
]);
const N2 = r("CalendarHeartIcon", [
  ["path", { d: "M3 10h18V6a2 2 0 0 0-2-2H5a2 2 0 0 0-2 2v14a2 2 0 0 0 2 2h7", key: "136lmk" }],
  ["path", { d: "M8 2v4", key: "1cmpym" }],
  ["path", { d: "M16 2v4", key: "4m81vk" }],
  [
    "path",
    {
      d: "M21.29 14.7a2.43 2.43 0 0 0-2.65-.52c-.3.12-.57.3-.8.53l-.34.34-.35-.34a2.43 2.43 0 0 0-2.65-.53c-.3.12-.56.3-.79.53-.95.94-1 2.53.2 3.74L17.5 22l3.6-3.55c1.2-1.21 1.14-2.8.19-3.74Z",
      key: "1t7hil"
    }
  ]
]);
const Z2 = r("CalendarMinus2Icon", [
  ["path", { d: "M8 2v4", key: "1cmpym" }],
  ["path", { d: "M16 2v4", key: "4m81vk" }],
  ["rect", { width: "18", height: "18", x: "3", y: "4", rx: "2", key: "1hopcy" }],
  ["path", { d: "M3 10h18", key: "8toen8" }],
  ["path", { d: "M10 16h4", key: "17e571" }]
]);
const Y2 = r("CalendarMinusIcon", [
  ["path", { d: "M8 2v4", key: "1cmpym" }],
  ["path", { d: "M16 2v4", key: "4m81vk" }],
  ["path", { d: "M21 13V6a2 2 0 0 0-2-2H5a2 2 0 0 0-2 2v14a2 2 0 0 0 2 2h8", key: "3spt84" }],
  ["path", { d: "M3 10h18", key: "8toen8" }],
  ["path", { d: "M16 19h6", key: "xwg31i" }]
]);
const G2 = r("CalendarOffIcon", [
  ["path", { d: "M4.2 4.2A2 2 0 0 0 3 6v14a2 2 0 0 0 2 2h14a2 2 0 0 0 1.82-1.18", key: "16swn3" }],
  ["path", { d: "M21 15.5V6a2 2 0 0 0-2-2H9.5", key: "yhw86o" }],
  ["path", { d: "M16 2v4", key: "4m81vk" }],
  ["path", { d: "M3 10h7", key: "1wap6i" }],
  ["path", { d: "M21 10h-5.5", key: "quycpq" }],
  ["path", { d: "m2 2 20 20", key: "1ooewy" }]
]);
const X2 = r("CalendarPlus2Icon", [
  ["path", { d: "M8 2v4", key: "1cmpym" }],
  ["path", { d: "M16 2v4", key: "4m81vk" }],
  ["rect", { width: "18", height: "18", x: "3", y: "4", rx: "2", key: "1hopcy" }],
  ["path", { d: "M3 10h18", key: "8toen8" }],
  ["path", { d: "M10 16h4", key: "17e571" }],
  ["path", { d: "M12 14v4", key: "1thi36" }]
]);
const K2 = r("CalendarPlusIcon", [
  ["path", { d: "M8 2v4", key: "1cmpym" }],
  ["path", { d: "M16 2v4", key: "4m81vk" }],
  ["path", { d: "M21 13V6a2 2 0 0 0-2-2H5a2 2 0 0 0-2 2v14a2 2 0 0 0 2 2h8", key: "3spt84" }],
  ["path", { d: "M3 10h18", key: "8toen8" }],
  ["path", { d: "M16 19h6", key: "xwg31i" }],
  ["path", { d: "M19 16v6", key: "tddt3s" }]
]);
const Q2 = r("CalendarRangeIcon", [
  ["rect", { width: "18", height: "18", x: "3", y: "4", rx: "2", key: "1hopcy" }],
  ["path", { d: "M16 2v4", key: "4m81vk" }],
  ["path", { d: "M3 10h18", key: "8toen8" }],
  ["path", { d: "M8 2v4", key: "1cmpym" }],
  ["path", { d: "M17 14h-6", key: "bkmgh3" }],
  ["path", { d: "M13 18H7", key: "bb0bb7" }],
  ["path", { d: "M7 14h.01", key: "1qa3f1" }],
  ["path", { d: "M17 18h.01", key: "1bdyru" }]
]);
const J2 = r("CalendarSearchIcon", [
  ["path", { d: "M21 12V6a2 2 0 0 0-2-2H5a2 2 0 0 0-2 2v14a2 2 0 0 0 2 2h7.5", key: "1e09qw" }],
  ["path", { d: "M16 2v4", key: "4m81vk" }],
  ["path", { d: "M8 2v4", key: "1cmpym" }],
  ["path", { d: "M3 10h18", key: "8toen8" }],
  ["circle", { cx: "18", cy: "18", r: "3", key: "1xkwt0" }],
  ["path", { d: "m22 22-1.5-1.5", key: "1x83k4" }]
]);
const ed = r("CalendarX2Icon", [
  ["path", { d: "M8 2v4", key: "1cmpym" }],
  ["path", { d: "M16 2v4", key: "4m81vk" }],
  ["path", { d: "M21 13V6a2 2 0 0 0-2-2H5a2 2 0 0 0-2 2v14a2 2 0 0 0 2 2h8", key: "3spt84" }],
  ["path", { d: "M3 10h18", key: "8toen8" }],
  ["path", { d: "m17 22 5-5", key: "1k6ppv" }],
  ["path", { d: "m17 17 5 5", key: "p7ous7" }]
]);
const td = r("CalendarXIcon", [
  ["path", { d: "M8 2v4", key: "1cmpym" }],
  ["path", { d: "M16 2v4", key: "4m81vk" }],
  ["rect", { width: "18", height: "18", x: "3", y: "4", rx: "2", key: "1hopcy" }],
  ["path", { d: "M3 10h18", key: "8toen8" }],
  ["path", { d: "m14 14-4 4", key: "rymu2i" }],
  ["path", { d: "m10 14 4 4", key: "3sz06r" }]
]);
const ad = r("CalendarIcon", [
  ["path", { d: "M8 2v4", key: "1cmpym" }],
  ["path", { d: "M16 2v4", key: "4m81vk" }],
  ["rect", { width: "18", height: "18", x: "3", y: "4", rx: "2", key: "1hopcy" }],
  ["path", { d: "M3 10h18", key: "8toen8" }]
]);
const nd = r("CameraOffIcon", [
  ["line", { x1: "2", x2: "22", y1: "2", y2: "22", key: "a6p6uj" }],
  ["path", { d: "M7 7H4a2 2 0 0 0-2 2v9a2 2 0 0 0 2 2h16", key: "qmtpty" }],
  ["path", { d: "M9.5 4h5L17 7h3a2 2 0 0 1 2 2v7.5", key: "1ufyfc" }],
  ["path", { d: "M14.121 15.121A3 3 0 1 1 9.88 10.88", key: "11zox6" }]
]);
const od = r("CameraIcon", [
  [
    "path",
    {
      d: "M14.5 4h-5L7 7H4a2 2 0 0 0-2 2v9a2 2 0 0 0 2 2h16a2 2 0 0 0 2-2V9a2 2 0 0 0-2-2h-3l-2.5-3z",
      key: "1tc9qg"
    }
  ],
  ["circle", { cx: "12", cy: "13", r: "3", key: "1vg3eu" }]
]);
const rd = r("CandlestickChartIcon", [
  ["path", { d: "M9 5v4", key: "14uxtq" }],
  ["rect", { width: "4", height: "6", x: "7", y: "9", rx: "1", key: "f4fvz0" }],
  ["path", { d: "M9 15v2", key: "r5rk32" }],
  ["path", { d: "M17 3v2", key: "1l2re6" }],
  ["rect", { width: "4", height: "8", x: "15", y: "5", rx: "1", key: "z38je5" }],
  ["path", { d: "M17 13v3", key: "5l0wba" }],
  ["path", { d: "M3 3v18h18", key: "1s2lah" }]
]);
const id = r("CandyCaneIcon", [
  [
    "path",
    {
      d: "M5.7 21a2 2 0 0 1-3.5-2l8.6-14a6 6 0 0 1 10.4 6 2 2 0 1 1-3.464-2 2 2 0 1 0-3.464-2Z",
      key: "isaq8g"
    }
  ],
  ["path", { d: "M17.75 7 15 2.1", key: "12x7e8" }],
  ["path", { d: "M10.9 4.8 13 9", key: "100a87" }],
  ["path", { d: "m7.9 9.7 2 4.4", key: "ntfhaj" }],
  ["path", { d: "M4.9 14.7 7 18.9", key: "1x43jy" }]
]);
const ld = r("CandyOffIcon", [
  ["path", { d: "m8.5 8.5-1 1a4.95 4.95 0 0 0 7 7l1-1", key: "1ff4ui" }],
  [
    "path",
    { d: "M11.843 6.187A4.947 4.947 0 0 1 16.5 7.5a4.947 4.947 0 0 1 1.313 4.657", key: "1sbrv4" }
  ],
  ["path", { d: "M14 16.5V14", key: "1maf8j" }],
  ["path", { d: "M14 6.5v1.843", key: "1a6u6t" }],
  ["path", { d: "M10 10v7.5", key: "80pj65" }],
  [
    "path",
    {
      d: "m16 7 1-5 1.367.683A3 3 0 0 0 19.708 3H21v1.292a3 3 0 0 0 .317 1.341L22 7l-5 1",
      key: "11a9mt"
    }
  ],
  [
    "path",
    {
      d: "m8 17-1 5-1.367-.683A3 3 0 0 0 4.292 21H3v-1.292a3 3 0 0 0-.317-1.341L2 17l5-1",
      key: "3mjmon"
    }
  ],
  ["line", { x1: "2", x2: "22", y1: "2", y2: "22", key: "a6p6uj" }]
]);
const cd = r("CandyIcon", [
  ["path", { d: "m9.5 7.5-2 2a4.95 4.95 0 1 0 7 7l2-2a4.95 4.95 0 1 0-7-7Z", key: "ue6khb" }],
  ["path", { d: "M14 6.5v10", key: "5xnk7c" }],
  ["path", { d: "M10 7.5v10", key: "1uew51" }],
  [
    "path",
    { d: "m16 7 1-5 1.37.68A3 3 0 0 0 19.7 3H21v1.3c0 .46.1.92.32 1.33L22 7l-5 1", key: "b9cp6k" }
  ],
  [
    "path",
    { d: "m8 17-1 5-1.37-.68A3 3 0 0 0 4.3 21H3v-1.3a3 3 0 0 0-.32-1.33L2 17l5-1", key: "5lney8" }
  ]
]);
const dd = r("CannabisIcon", [
  ["path", { d: "M12 22v-4", key: "1utk9m" }],
  [
    "path",
    {
      d: "M7 12c-1.5 0-4.5 1.5-5 3 3.5 1.5 6 1 6 1-1.5 1.5-2 3.5-2 5 2.5 0 4.5-1.5 6-3 1.5 1.5 3.5 3 6 3 0-1.5-.5-3.5-2-5 0 0 2.5.5 6-1-.5-1.5-3.5-3-5-3 1.5-1 4-4 4-6-2.5 0-5.5 1.5-7 3 0-2.5-.5-5-2-7-1.5 2-2 4.5-2 7-1.5-1.5-4.5-3-7-3 0 2 2.5 5 4 6",
      key: "1mezod"
    }
  ]
]);
const sd = r("CaptionsOffIcon", [
  ["path", { d: "M10.5 5H19a2 2 0 0 1 2 2v8.5", key: "jqtk4d" }],
  ["path", { d: "M17 11h-.5", key: "1961ue" }],
  ["path", { d: "M19 19H5a2 2 0 0 1-2-2V7a2 2 0 0 1 2-2", key: "1keqsi" }],
  ["path", { d: "m2 2 20 20", key: "1ooewy" }],
  ["path", { d: "M7 11h4", key: "1o1z6v" }],
  ["path", { d: "M7 15h2.5", key: "1ina1g" }]
]);
const Ia = r("CaptionsIcon", [
  ["rect", { width: "18", height: "14", x: "3", y: "5", rx: "2", ry: "2", key: "12ruh7" }],
  ["path", { d: "M7 15h4M15 15h2M7 11h2M13 11h4", key: "1ueiar" }]
]);
const ud = r("CarFrontIcon", [
  [
    "path",
    { d: "m21 8-2 2-1.5-3.7A2 2 0 0 0 15.646 5H8.4a2 2 0 0 0-1.903 1.257L5 10 3 8", key: "1imjwt" }
  ],
  ["path", { d: "M7 14h.01", key: "1qa3f1" }],
  ["path", { d: "M17 14h.01", key: "7oqj8z" }],
  ["rect", { width: "18", height: "8", x: "3", y: "10", rx: "2", key: "a7itu8" }],
  ["path", { d: "M5 18v2", key: "ppbyun" }],
  ["path", { d: "M19 18v2", key: "gy7782" }]
]);
const hd = r("CarTaxiFrontIcon", [
  ["path", { d: "M10 2h4", key: "n1abiw" }],
  [
    "path",
    { d: "m21 8-2 2-1.5-3.7A2 2 0 0 0 15.646 5H8.4a2 2 0 0 0-1.903 1.257L5 10 3 8", key: "1imjwt" }
  ],
  ["path", { d: "M7 14h.01", key: "1qa3f1" }],
  ["path", { d: "M17 14h.01", key: "7oqj8z" }],
  ["rect", { width: "18", height: "8", x: "3", y: "10", rx: "2", key: "a7itu8" }],
  ["path", { d: "M5 18v2", key: "ppbyun" }],
  ["path", { d: "M19 18v2", key: "gy7782" }]
]);
const pd = r("CarIcon", [
  [
    "path",
    {
      d: "M19 17h2c.6 0 1-.4 1-1v-3c0-.9-.7-1.7-1.5-1.9C18.7 10.6 16 10 16 10s-1.3-1.4-2.2-2.3c-.5-.4-1.1-.7-1.8-.7H5c-.6 0-1.1.4-1.4.9l-1.4 2.9A3.7 3.7 0 0 0 2 12v4c0 .6.4 1 1 1h2",
      key: "5owen"
    }
  ],
  ["circle", { cx: "7", cy: "17", r: "2", key: "u2ysq9" }],
  ["path", { d: "M9 17h6", key: "r8uit2" }],
  ["circle", { cx: "17", cy: "17", r: "2", key: "axvx0g" }]
]);
const yd = r("CaravanIcon", [
  ["rect", { width: "4", height: "4", x: "2", y: "9", key: "1vcvhd" }],
  ["rect", { width: "4", height: "10", x: "10", y: "9", key: "1b7ev2" }],
  ["path", { d: "M18 19V9a4 4 0 0 0-4-4H6a4 4 0 0 0-4 4v8a2 2 0 0 0 2 2h2", key: "19jm3t" }],
  ["circle", { cx: "8", cy: "19", r: "2", key: "t8fc5s" }],
  ["path", { d: "M10 19h12v-2", key: "1yu2qx" }]
]);
const kd = r("CarrotIcon", [
  [
    "path",
    {
      d: "M2.27 21.7s9.87-3.5 12.73-6.36a4.5 4.5 0 0 0-6.36-6.37C5.77 11.84 2.27 21.7 2.27 21.7zM8.64 14l-2.05-2.04M15.34 15l-2.46-2.46",
      key: "rfqxbe"
    }
  ],
  ["path", { d: "M22 9s-1.33-2-3.5-2C16.86 7 15 9 15 9s1.33 2 3.5 2S22 9 22 9z", key: "6b25w4" }],
  ["path", { d: "M15 2s-2 1.33-2 3.5S15 9 15 9s2-1.84 2-3.5C17 3.33 15 2 15 2z", key: "fn65lo" }]
]);
const fd = r("CaseLowerIcon", [
  ["circle", { cx: "7", cy: "12", r: "3", key: "12clwm" }],
  ["path", { d: "M10 9v6", key: "17i7lo" }],
  ["circle", { cx: "17", cy: "12", r: "3", key: "gl7c2s" }],
  ["path", { d: "M14 7v8", key: "dl84cr" }]
]);
const vd = r("CaseSensitiveIcon", [
  ["path", { d: "m3 15 4-8 4 8", key: "1vwr6u" }],
  ["path", { d: "M4 13h6", key: "1r9ots" }],
  ["circle", { cx: "18", cy: "12", r: "3", key: "1kchzo" }],
  ["path", { d: "M21 9v6", key: "anns31" }]
]);
const md = r("CaseUpperIcon", [
  ["path", { d: "m3 15 4-8 4 8", key: "1vwr6u" }],
  ["path", { d: "M4 13h6", key: "1r9ots" }],
  ["path", { d: "M15 11h4.5a2 2 0 0 1 0 4H15V7h4a2 2 0 0 1 0 4", key: "1sqfas" }]
]);
const gd = r("CassetteTapeIcon", [
  ["rect", { width: "20", height: "16", x: "2", y: "4", rx: "2", key: "18n3k1" }],
  ["circle", { cx: "8", cy: "10", r: "2", key: "1xl4ub" }],
  ["path", { d: "M8 12h8", key: "1wcyev" }],
  ["circle", { cx: "16", cy: "10", r: "2", key: "r14t7q" }],
  ["path", { d: "m6 20 .7-2.9A1.4 1.4 0 0 1 8.1 16h7.8a1.4 1.4 0 0 1 1.4 1l.7 3", key: "l01ucn" }]
]);
const Md = r("CastIcon", [
  ["path", { d: "M2 8V6a2 2 0 0 1 2-2h16a2 2 0 0 1 2 2v12a2 2 0 0 1-2 2h-6", key: "3zrzxg" }],
  ["path", { d: "M2 12a9 9 0 0 1 8 8", key: "g6cvee" }],
  ["path", { d: "M2 16a5 5 0 0 1 4 4", key: "1y1dii" }],
  ["line", { x1: "2", x2: "2.01", y1: "20", y2: "20", key: "xu2jvo" }]
]);
const xd = r("CastleIcon", [
  ["path", { d: "M22 20v-9H2v9a2 2 0 0 0 2 2h16a2 2 0 0 0 2-2Z", key: "109fe4" }],
  ["path", { d: "M18 11V4H6v7", key: "mon5oj" }],
  ["path", { d: "M15 22v-4a3 3 0 0 0-3-3v0a3 3 0 0 0-3 3v4", key: "jdggr9" }],
  ["path", { d: "M22 11V9", key: "3zbp94" }],
  ["path", { d: "M2 11V9", key: "1x5rnq" }],
  ["path", { d: "M6 4V2", key: "1rsq15" }],
  ["path", { d: "M18 4V2", key: "1jsdo1" }],
  ["path", { d: "M10 4V2", key: "75d9ly" }],
  ["path", { d: "M14 4V2", key: "8nj3z6" }]
]);
const bd = r("CatIcon", [
  [
    "path",
    {
      d: "M12 5c.67 0 1.35.09 2 .26 1.78-2 5.03-2.84 6.42-2.26 1.4.58-.42 7-.42 7 .57 1.07 1 2.24 1 3.44C21 17.9 16.97 21 12 21s-9-3-9-7.56c0-1.25.5-2.4 1-3.44 0 0-1.89-6.42-.5-7 1.39-.58 4.72.23 6.5 2.23A9.04 9.04 0 0 1 12 5Z",
      key: "x6xyqk"
    }
  ],
  ["path", { d: "M8 14v.5", key: "1nzgdb" }],
  ["path", { d: "M16 14v.5", key: "1lajdz" }],
  ["path", { d: "M11.25 16.25h1.5L12 17l-.75-.75Z", key: "12kq1m" }]
]);
const wd = r("CctvIcon", [
  [
    "path",
    {
      d: "M16.75 12h3.632a1 1 0 0 1 .894 1.447l-2.034 4.069a1 1 0 0 1-1.708.134l-2.124-2.97",
      key: "ir91b5"
    }
  ],
  [
    "path",
    {
      d: "M17.106 9.053a1 1 0 0 1 .447 1.341l-3.106 6.211a1 1 0 0 1-1.342.447L3.61 12.3a2.92 2.92 0 0 1-1.3-3.91L3.69 5.6a2.92 2.92 0 0 1 3.92-1.3z",
      key: "jlp8i1"
    }
  ],
  ["path", { d: "M2 19h3.76a2 2 0 0 0 1.8-1.1L9 15", key: "19bib8" }],
  ["path", { d: "M2 21v-4", key: "l40lih" }],
  ["path", { d: "M7 9h.01", key: "19b3jx" }]
]);
const Id = r("CheckCheckIcon", [
  ["path", { d: "M18 6 7 17l-5-5", key: "116fxf" }],
  ["path", { d: "m22 10-7.5 7.5L13 16", key: "ke71qq" }]
]);
const Ld = r("CheckIcon", [["path", { d: "M20 6 9 17l-5-5", key: "1gmf2c" }]]);
const Sd = r("ChefHatIcon", [
  [
    "path",
    {
      d: "M17 21a1 1 0 0 0 1-1v-5.35c0-.457.316-.844.727-1.041a4 4 0 0 0-2.134-7.589 5 5 0 0 0-9.186 0 4 4 0 0 0-2.134 7.588c.411.198.727.585.727 1.041V20a1 1 0 0 0 1 1Z",
      key: "1qvrer"
    }
  ],
  ["path", { d: "M6 17h12", key: "1jwigz" }]
]);
const Cd = r("CherryIcon", [
  ["path", { d: "M2 17a5 5 0 0 0 10 0c0-2.76-2.5-5-5-3-2.5-2-5 .24-5 3Z", key: "cvxqlc" }],
  ["path", { d: "M12 17a5 5 0 0 0 10 0c0-2.76-2.5-5-5-3-2.5-2-5 .24-5 3Z", key: "1ostrc" }],
  ["path", { d: "M7 14c3.22-2.91 4.29-8.75 5-12 1.66 2.38 4.94 9 5 12", key: "hqx58h" }],
  ["path", { d: "M22 9c-4.29 0-7.14-2.33-10-7 5.71 0 10 4.67 10 7Z", key: "eykp1o" }]
]);
const Ad = r("ChevronDownIcon", [
  ["path", { d: "m6 9 6 6 6-6", key: "qrunsl" }]
]);
const Pd = r("ChevronFirstIcon", [
  ["path", { d: "m17 18-6-6 6-6", key: "1yerx2" }],
  ["path", { d: "M7 6v12", key: "1p53r6" }]
]);
const qd = r("ChevronLastIcon", [
  ["path", { d: "m7 18 6-6-6-6", key: "lwmzdw" }],
  ["path", { d: "M17 6v12", key: "1o0aio" }]
]);
const Td = r("ChevronLeftIcon", [
  ["path", { d: "m15 18-6-6 6-6", key: "1wnfg3" }]
]);
const Dd = r("ChevronRightIcon", [
  ["path", { d: "m9 18 6-6-6-6", key: "mthhwq" }]
]);
const _d = r("ChevronUpIcon", [
  ["path", { d: "m18 15-6-6-6 6", key: "153udz" }]
]);
const Bd = r("ChevronsDownUpIcon", [
  ["path", { d: "m7 20 5-5 5 5", key: "13a0gw" }],
  ["path", { d: "m7 4 5 5 5-5", key: "1kwcof" }]
]);
const zd = r("ChevronsDownIcon", [
  ["path", { d: "m7 6 5 5 5-5", key: "1lc07p" }],
  ["path", { d: "m7 13 5 5 5-5", key: "1d48rs" }]
]);
const Hd = r("ChevronsLeftRightIcon", [
  ["path", { d: "m9 7-5 5 5 5", key: "j5w590" }],
  ["path", { d: "m15 7 5 5-5 5", key: "1bl6da" }]
]);
const jd = r("ChevronsLeftIcon", [
  ["path", { d: "m11 17-5-5 5-5", key: "13zhaf" }],
  ["path", { d: "m18 17-5-5 5-5", key: "h8a8et" }]
]);
const Vd = r("ChevronsRightLeftIcon", [
  ["path", { d: "m20 17-5-5 5-5", key: "30x0n2" }],
  ["path", { d: "m4 17 5-5-5-5", key: "16spf4" }]
]);
const Od = r("ChevronsRightIcon", [
  ["path", { d: "m6 17 5-5-5-5", key: "xnjwq" }],
  ["path", { d: "m13 17 5-5-5-5", key: "17xmmf" }]
]);
const $d = r("ChevronsUpDownIcon", [
  ["path", { d: "m7 15 5 5 5-5", key: "1hf1tw" }],
  ["path", { d: "m7 9 5-5 5 5", key: "sgt6xg" }]
]);
const Rd = r("ChevronsUpIcon", [
  ["path", { d: "m17 11-5-5-5 5", key: "e8nh98" }],
  ["path", { d: "m17 18-5-5-5 5", key: "2avn1x" }]
]);
const Fd = r("ChromeIcon", [
  ["circle", { cx: "12", cy: "12", r: "10", key: "1mglay" }],
  ["circle", { cx: "12", cy: "12", r: "4", key: "4exip2" }],
  ["line", { x1: "21.17", x2: "12", y1: "8", y2: "8", key: "a0cw5f" }],
  ["line", { x1: "3.95", x2: "8.54", y1: "6.06", y2: "14", key: "1kftof" }],
  ["line", { x1: "10.88", x2: "15.46", y1: "21.94", y2: "14", key: "1ymyh8" }]
]);
const Ud = r("ChurchIcon", [
  ["path", { d: "m18 7 4 2v11a2 2 0 0 1-2 2H4a2 2 0 0 1-2-2V9l4-2", key: "gy5gyo" }],
  ["path", { d: "M14 22v-4a2 2 0 0 0-2-2v0a2 2 0 0 0-2 2v4", key: "cpkuc4" }],
  ["path", { d: "M18 22V5l-6-3-6 3v17", key: "1hsnhq" }],
  ["path", { d: "M12 7v5", key: "ma6bk" }],
  ["path", { d: "M10 9h4", key: "u4k05v" }]
]);
const Ed = r("CigaretteOffIcon", [
  ["line", { x1: "2", x2: "22", y1: "2", y2: "22", key: "a6p6uj" }],
  ["path", { d: "M12 12H2v4h14", key: "91gsaq" }],
  ["path", { d: "M22 12v4", key: "142cbu" }],
  ["path", { d: "M18 12h-.5", key: "12ymji" }],
  ["path", { d: "M7 12v4", key: "jqww69" }],
  ["path", { d: "M18 8c0-2.5-2-2.5-2-5", key: "1il607" }],
  ["path", { d: "M22 8c0-2.5-2-2.5-2-5", key: "1gah44" }]
]);
const Wd = r("CigaretteIcon", [
  ["path", { d: "M18 12H2v4h16", key: "2rt1hm" }],
  ["path", { d: "M22 12v4", key: "142cbu" }],
  ["path", { d: "M7 12v4", key: "jqww69" }],
  ["path", { d: "M18 8c0-2.5-2-2.5-2-5", key: "1il607" }],
  ["path", { d: "M22 8c0-2.5-2-2.5-2-5", key: "1gah44" }]
]);
const La = r("CircleAlertIcon", [
  ["circle", { cx: "12", cy: "12", r: "10", key: "1mglay" }],
  ["line", { x1: "12", x2: "12", y1: "8", y2: "12", key: "1pkeuh" }],
  ["line", { x1: "12", x2: "12.01", y1: "16", y2: "16", key: "4dfq90" }]
]);
const Sa = r("CircleArrowDownIcon", [
  ["circle", { cx: "12", cy: "12", r: "10", key: "1mglay" }],
  ["path", { d: "M12 8v8", key: "napkw2" }],
  ["path", { d: "m8 12 4 4 4-4", key: "k98ssh" }]
]);
const Ca = r("CircleArrowLeftIcon", [
  ["circle", { cx: "12", cy: "12", r: "10", key: "1mglay" }],
  ["path", { d: "M16 12H8", key: "1fr5h0" }],
  ["path", { d: "m12 8-4 4 4 4", key: "15vm53" }]
]);
const Aa = r("CircleArrowOutDownLeftIcon", [
  ["path", { d: "M2 12a10 10 0 1 1 10 10", key: "1yn6ov" }],
  ["path", { d: "m2 22 10-10", key: "28ilpk" }],
  ["path", { d: "M8 22H2v-6", key: "sulq54" }]
]);
const Pa = r("CircleArrowOutDownRightIcon", [
  ["path", { d: "M12 22a10 10 0 1 1 10-10", key: "130bv5" }],
  ["path", { d: "M22 22 12 12", key: "131aw7" }],
  ["path", { d: "M22 16v6h-6", key: "1gvm70" }]
]);
const qa = r("CircleArrowOutUpLeftIcon", [
  ["path", { d: "M2 8V2h6", key: "hiwtdz" }],
  ["path", { d: "m2 2 10 10", key: "1oh8rs" }],
  ["path", { d: "M12 2A10 10 0 1 1 2 12", key: "rrk4fa" }]
]);
const Ta = r("CircleArrowOutUpRightIcon", [
  ["path", { d: "M22 12A10 10 0 1 1 12 2", key: "1fm58d" }],
  ["path", { d: "M22 2 12 12", key: "yg2myt" }],
  ["path", { d: "M16 2h6v6", key: "zan5cs" }]
]);
const Da = r("CircleArrowRightIcon", [
  ["circle", { cx: "12", cy: "12", r: "10", key: "1mglay" }],
  ["path", { d: "M8 12h8", key: "1wcyev" }],
  ["path", { d: "m12 16 4-4-4-4", key: "1i9zcv" }]
]);
const _a = r("CircleArrowUpIcon", [
  ["circle", { cx: "12", cy: "12", r: "10", key: "1mglay" }],
  ["path", { d: "m16 12-4-4-4 4", key: "177agl" }],
  ["path", { d: "M12 16V8", key: "1sbj14" }]
]);
const Ba = r("CircleCheckBigIcon", [
  ["path", { d: "M22 11.08V12a10 10 0 1 1-5.93-9.14", key: "g774vq" }],
  ["path", { d: "m9 11 3 3L22 4", key: "1pflzl" }]
]);
const za = r("CircleCheckIcon", [
  ["circle", { cx: "12", cy: "12", r: "10", key: "1mglay" }],
  ["path", { d: "m9 12 2 2 4-4", key: "dzmm74" }]
]);
const Ha = r("CircleChevronDownIcon", [
  ["circle", { cx: "12", cy: "12", r: "10", key: "1mglay" }],
  ["path", { d: "m16 10-4 4-4-4", key: "894hmk" }]
]);
const ja = r("CircleChevronLeftIcon", [
  ["circle", { cx: "12", cy: "12", r: "10", key: "1mglay" }],
  ["path", { d: "m14 16-4-4 4-4", key: "ojs7w8" }]
]);
const Va = r("CircleChevronRightIcon", [
  ["circle", { cx: "12", cy: "12", r: "10", key: "1mglay" }],
  ["path", { d: "m10 8 4 4-4 4", key: "1wy4r4" }]
]);
const Oa = r("CircleChevronUpIcon", [
  ["circle", { cx: "12", cy: "12", r: "10", key: "1mglay" }],
  ["path", { d: "m8 14 4-4 4 4", key: "fy2ptz" }]
]);
const Nd = r("CircleDashedIcon", [
  ["path", { d: "M10.1 2.182a10 10 0 0 1 3.8 0", key: "5ilxe3" }],
  ["path", { d: "M13.9 21.818a10 10 0 0 1-3.8 0", key: "11zvb9" }],
  ["path", { d: "M17.609 3.721a10 10 0 0 1 2.69 2.7", key: "1iw5b2" }],
  ["path", { d: "M2.182 13.9a10 10 0 0 1 0-3.8", key: "c0bmvh" }],
  ["path", { d: "M20.279 17.609a10 10 0 0 1-2.7 2.69", key: "1ruxm7" }],
  ["path", { d: "M21.818 10.1a10 10 0 0 1 0 3.8", key: "qkgqxc" }],
  ["path", { d: "M3.721 6.391a10 10 0 0 1 2.7-2.69", key: "1mcia2" }],
  ["path", { d: "M6.391 20.279a10 10 0 0 1-2.69-2.7", key: "1fvljs" }]
]);
const $a = r("CircleDivideIcon", [
  ["line", { x1: "8", x2: "16", y1: "12", y2: "12", key: "1jonct" }],
  ["line", { x1: "12", x2: "12", y1: "16", y2: "16", key: "aqc6ln" }],
  ["line", { x1: "12", x2: "12", y1: "8", y2: "8", key: "1mkcni" }],
  ["circle", { cx: "12", cy: "12", r: "10", key: "1mglay" }]
]);
const Zd = r("CircleDollarSignIcon", [
  ["circle", { cx: "12", cy: "12", r: "10", key: "1mglay" }],
  ["path", { d: "M16 8h-6a2 2 0 1 0 0 4h4a2 2 0 1 1 0 4H8", key: "1h4pet" }],
  ["path", { d: "M12 18V6", key: "zqpxq5" }]
]);
const Yd = r("CircleDotDashedIcon", [
  ["path", { d: "M10.1 2.18a9.93 9.93 0 0 1 3.8 0", key: "1qdqn0" }],
  ["path", { d: "M17.6 3.71a9.95 9.95 0 0 1 2.69 2.7", key: "1bq7p6" }],
  ["path", { d: "M21.82 10.1a9.93 9.93 0 0 1 0 3.8", key: "1rlaqf" }],
  ["path", { d: "M20.29 17.6a9.95 9.95 0 0 1-2.7 2.69", key: "1xk03u" }],
  ["path", { d: "M13.9 21.82a9.94 9.94 0 0 1-3.8 0", key: "l7re25" }],
  ["path", { d: "M6.4 20.29a9.95 9.95 0 0 1-2.69-2.7", key: "1v18p6" }],
  ["path", { d: "M2.18 13.9a9.93 9.93 0 0 1 0-3.8", key: "xdo6bj" }],
  ["path", { d: "M3.71 6.4a9.95 9.95 0 0 1 2.7-2.69", key: "1jjmaz" }],
  ["circle", { cx: "12", cy: "12", r: "1", key: "41hilf" }]
]);
const Gd = r("CircleDotIcon", [
  ["circle", { cx: "12", cy: "12", r: "10", key: "1mglay" }],
  ["circle", { cx: "12", cy: "12", r: "1", key: "41hilf" }]
]);
const Xd = r("CircleEllipsisIcon", [
  ["circle", { cx: "12", cy: "12", r: "10", key: "1mglay" }],
  ["path", { d: "M17 12h.01", key: "1m0b6t" }],
  ["path", { d: "M12 12h.01", key: "1mp3jc" }],
  ["path", { d: "M7 12h.01", key: "eqddd0" }]
]);
const Kd = r("CircleEqualIcon", [
  ["path", { d: "M7 10h10", key: "1101jm" }],
  ["path", { d: "M7 14h10", key: "1mhdw3" }],
  ["circle", { cx: "12", cy: "12", r: "10", key: "1mglay" }]
]);
const Qd = r("CircleFadingPlusIcon", [
  ["path", { d: "M12 2a10 10 0 0 1 7.38 16.75", key: "175t95" }],
  ["path", { d: "M12 8v8", key: "napkw2" }],
  ["path", { d: "M16 12H8", key: "1fr5h0" }],
  ["path", { d: "M2.5 8.875a10 10 0 0 0-.5 3", key: "1vce0s" }],
  ["path", { d: "M2.83 16a10 10 0 0 0 2.43 3.4", key: "o3fkw4" }],
  ["path", { d: "M4.636 5.235a10 10 0 0 1 .891-.857", key: "1szpfk" }],
  ["path", { d: "M8.644 21.42a10 10 0 0 0 7.631-.38", key: "9yhvd4" }]
]);
const Ra = r("CircleGaugeIcon", [
  ["path", { d: "M15.6 2.7a10 10 0 1 0 5.7 5.7", key: "1e0p6d" }],
  ["circle", { cx: "12", cy: "12", r: "2", key: "1c9p78" }],
  ["path", { d: "M13.4 10.6 19 5", key: "1kr7tw" }]
]);
const Fa = r("CircleHelpIcon", [
  ["circle", { cx: "12", cy: "12", r: "10", key: "1mglay" }],
  ["path", { d: "M9.09 9a3 3 0 0 1 5.83 1c0 2-3 3-3 3", key: "1u773s" }],
  ["path", { d: "M12 17h.01", key: "p32p05" }]
]);
const Ua = r("CircleMinusIcon", [
  ["circle", { cx: "12", cy: "12", r: "10", key: "1mglay" }],
  ["path", { d: "M8 12h8", key: "1wcyev" }]
]);
const Jd = r("CircleOffIcon", [
  ["path", { d: "m2 2 20 20", key: "1ooewy" }],
  ["path", { d: "M8.35 2.69A10 10 0 0 1 21.3 15.65", key: "1pfsoa" }],
  ["path", { d: "M19.08 19.08A10 10 0 1 1 4.92 4.92", key: "1ablyi" }]
]);
const Ea = r("CircleParkingOffIcon", [
  ["circle", { cx: "12", cy: "12", r: "10", key: "1mglay" }],
  ["path", { d: "m5 5 14 14", key: "11anup" }],
  ["path", { d: "M13 13a3 3 0 1 0 0-6H9v2", key: "uoagbd" }],
  ["path", { d: "M9 17v-2.34", key: "a9qo08" }]
]);
const Wa = r("CircleParkingIcon", [
  ["circle", { cx: "12", cy: "12", r: "10", key: "1mglay" }],
  ["path", { d: "M9 17V7h4a3 3 0 0 1 0 6H9", key: "1dfk2c" }]
]);
const Na = r("CirclePauseIcon", [
  ["circle", { cx: "12", cy: "12", r: "10", key: "1mglay" }],
  ["line", { x1: "10", x2: "10", y1: "15", y2: "9", key: "c1nkhi" }],
  ["line", { x1: "14", x2: "14", y1: "15", y2: "9", key: "h65svq" }]
]);
const Za = r("CirclePercentIcon", [
  ["circle", { cx: "12", cy: "12", r: "10", key: "1mglay" }],
  ["path", { d: "m15 9-6 6", key: "1uzhvr" }],
  ["path", { d: "M9 9h.01", key: "1q5me6" }],
  ["path", { d: "M15 15h.01", key: "lqbp3k" }]
]);
const Ya = r("CirclePlayIcon", [
  ["circle", { cx: "12", cy: "12", r: "10", key: "1mglay" }],
  ["polygon", { points: "10 8 16 12 10 16 10 8", key: "1cimsy" }]
]);
const Ga = r("CirclePlusIcon", [
  ["circle", { cx: "12", cy: "12", r: "10", key: "1mglay" }],
  ["path", { d: "M8 12h8", key: "1wcyev" }],
  ["path", { d: "M12 8v8", key: "napkw2" }]
]);
const Xa = r("CirclePowerIcon", [
  ["circle", { cx: "12", cy: "12", r: "10", key: "1mglay" }],
  ["path", { d: "M12 12V7", key: "1tf3mz" }],
  ["path", { d: "M16 9a5 5 0 1 1-8 0", key: "174bae" }]
]);
const Ka = r("CircleSlash2Icon", [
  ["circle", { cx: "12", cy: "12", r: "10", key: "1mglay" }],
  ["path", { d: "M22 2 2 22", key: "y4kqgn" }]
]);
const es = r("CircleSlashIcon", [
  ["line", { x1: "9", x2: "15", y1: "15", y2: "9", key: "1dfufj" }],
  ["circle", { cx: "12", cy: "12", r: "10", key: "1mglay" }]
]);
const Qa = r("CircleStopIcon", [
  ["circle", { cx: "12", cy: "12", r: "10", key: "1mglay" }],
  ["rect", { width: "6", height: "6", x: "9", y: "9", key: "1wrtvo" }]
]);
const Ja = r("CircleUserRoundIcon", [
  ["path", { d: "M18 20a6 6 0 0 0-12 0", key: "1qehca" }],
  ["circle", { cx: "12", cy: "10", r: "4", key: "1h16sb" }],
  ["circle", { cx: "12", cy: "12", r: "10", key: "1mglay" }]
]);
const en = r("CircleUserIcon", [
  ["circle", { cx: "12", cy: "12", r: "10", key: "1mglay" }],
  ["circle", { cx: "12", cy: "10", r: "3", key: "ilqhr7" }],
  ["path", { d: "M7 20.662V19a2 2 0 0 1 2-2h6a2 2 0 0 1 2 2v1.662", key: "154egf" }]
]);
const tn = r("CircleXIcon", [
  ["circle", { cx: "12", cy: "12", r: "10", key: "1mglay" }],
  ["path", { d: "m15 9-6 6", key: "1uzhvr" }],
  ["path", { d: "m9 9 6 6", key: "z0biqf" }]
]);
const ts = r("CircleIcon", [
  ["circle", { cx: "12", cy: "12", r: "10", key: "1mglay" }]
]);
const as = r("CircuitBoardIcon", [
  ["rect", { width: "18", height: "18", x: "3", y: "3", rx: "2", key: "afitv7" }],
  ["path", { d: "M11 9h4a2 2 0 0 0 2-2V3", key: "1ve2rv" }],
  ["circle", { cx: "9", cy: "9", r: "2", key: "af1f0g" }],
  ["path", { d: "M7 21v-4a2 2 0 0 1 2-2h4", key: "1fwkro" }],
  ["circle", { cx: "15", cy: "15", r: "2", key: "3i40o0" }]
]);
const ns = r("CitrusIcon", [
  [
    "path",
    {
      d: "M21.66 17.67a1.08 1.08 0 0 1-.04 1.6A12 12 0 0 1 4.73 2.38a1.1 1.1 0 0 1 1.61-.04z",
      key: "4ite01"
    }
  ],
  ["path", { d: "M19.65 15.66A8 8 0 0 1 8.35 4.34", key: "1gxipu" }],
  ["path", { d: "m14 10-5.5 5.5", key: "92pfem" }],
  ["path", { d: "M14 17.85V10H6.15", key: "xqmtsk" }]
]);
const os = r("ClapperboardIcon", [
  [
    "path",
    { d: "M20.2 6 3 11l-.9-2.4c-.3-1.1.3-2.2 1.3-2.5l13.5-4c1.1-.3 2.2.3 2.5 1.3Z", key: "1tn4o7" }
  ],
  ["path", { d: "m6.2 5.3 3.1 3.9", key: "iuk76l" }],
  ["path", { d: "m12.4 3.4 3.1 4", key: "6hsd6n" }],
  ["path", { d: "M3 11h18v8a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2Z", key: "ltgou9" }]
]);
const rs = r("ClipboardCheckIcon", [
  ["rect", { width: "8", height: "4", x: "8", y: "2", rx: "1", ry: "1", key: "tgr4d6" }],
  [
    "path",
    {
      d: "M16 4h2a2 2 0 0 1 2 2v14a2 2 0 0 1-2 2H6a2 2 0 0 1-2-2V6a2 2 0 0 1 2-2h2",
      key: "116196"
    }
  ],
  ["path", { d: "m9 14 2 2 4-4", key: "df797q" }]
]);
const is = r("ClipboardCopyIcon", [
  ["rect", { width: "8", height: "4", x: "8", y: "2", rx: "1", ry: "1", key: "tgr4d6" }],
  ["path", { d: "M8 4H6a2 2 0 0 0-2 2v14a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2v-2", key: "4jdomd" }],
  ["path", { d: "M16 4h2a2 2 0 0 1 2 2v4", key: "3hqy98" }],
  ["path", { d: "M21 14H11", key: "1bme5i" }],
  ["path", { d: "m15 10-4 4 4 4", key: "5dvupr" }]
]);
const ls = r("ClipboardListIcon", [
  ["rect", { width: "8", height: "4", x: "8", y: "2", rx: "1", ry: "1", key: "tgr4d6" }],
  [
    "path",
    {
      d: "M16 4h2a2 2 0 0 1 2 2v14a2 2 0 0 1-2 2H6a2 2 0 0 1-2-2V6a2 2 0 0 1 2-2h2",
      key: "116196"
    }
  ],
  ["path", { d: "M12 11h4", key: "1jrz19" }],
  ["path", { d: "M12 16h4", key: "n85exb" }],
  ["path", { d: "M8 11h.01", key: "1dfujw" }],
  ["path", { d: "M8 16h.01", key: "18s6g9" }]
]);
const cs = r("ClipboardMinusIcon", [
  ["rect", { width: "8", height: "4", x: "8", y: "2", rx: "1", ry: "1", key: "tgr4d6" }],
  [
    "path",
    {
      d: "M16 4h2a2 2 0 0 1 2 2v14a2 2 0 0 1-2 2H6a2 2 0 0 1-2-2V6a2 2 0 0 1 2-2h2",
      key: "116196"
    }
  ],
  ["path", { d: "M9 14h6", key: "159ibu" }]
]);
const ds = r("ClipboardPasteIcon", [
  [
    "path",
    { d: "M15 2H9a1 1 0 0 0-1 1v2c0 .6.4 1 1 1h6c.6 0 1-.4 1-1V3c0-.6-.4-1-1-1Z", key: "1pp7kr" }
  ],
  [
    "path",
    {
      d: "M8 4H6a2 2 0 0 0-2 2v14a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2M16 4h2a2 2 0 0 1 2 2v2M11 14h10",
      key: "2ik1ml"
    }
  ],
  ["path", { d: "m17 10 4 4-4 4", key: "vp2hj1" }]
]);
const an = r("ClipboardPenLineIcon", [
  ["rect", { width: "8", height: "4", x: "8", y: "2", rx: "1", key: "1oijnt" }],
  ["path", { d: "M8 4H6a2 2 0 0 0-2 2v14a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2v-.5", key: "1but9f" }],
  ["path", { d: "M16 4h2a2 2 0 0 1 1.73 1", key: "1p8n7l" }],
  ["path", { d: "M8 18h1", key: "13wk12" }],
  ["path", { d: "M18.4 9.6a2 2 0 0 1 3 3L17 17l-4 1 1-4Z", key: "yg2pdb" }]
]);
const nn = r("ClipboardPenIcon", [
  ["rect", { width: "8", height: "4", x: "8", y: "2", rx: "1", key: "1oijnt" }],
  ["path", { d: "M10.4 12.6a2 2 0 0 1 3 3L8 21l-4 1 1-4Z", key: "hnx206" }],
  ["path", { d: "M16 4h2a2 2 0 0 1 2 2v14a2 2 0 0 1-2 2h-5.5", key: "cereej" }],
  ["path", { d: "M4 13.5V6a2 2 0 0 1 2-2h2", key: "5ua5vh" }]
]);
const ss = r("ClipboardPlusIcon", [
  ["rect", { width: "8", height: "4", x: "8", y: "2", rx: "1", ry: "1", key: "tgr4d6" }],
  [
    "path",
    {
      d: "M16 4h2a2 2 0 0 1 2 2v14a2 2 0 0 1-2 2H6a2 2 0 0 1-2-2V6a2 2 0 0 1 2-2h2",
      key: "116196"
    }
  ],
  ["path", { d: "M9 14h6", key: "159ibu" }],
  ["path", { d: "M12 17v-6", key: "1y8rbf" }]
]);
const us = r("ClipboardTypeIcon", [
  ["rect", { width: "8", height: "4", x: "8", y: "2", rx: "1", ry: "1", key: "tgr4d6" }],
  [
    "path",
    {
      d: "M16 4h2a2 2 0 0 1 2 2v14a2 2 0 0 1-2 2H6a2 2 0 0 1-2-2V6a2 2 0 0 1 2-2h2",
      key: "116196"
    }
  ],
  ["path", { d: "M9 12v-1h6v1", key: "iehl6m" }],
  ["path", { d: "M11 17h2", key: "12w5me" }],
  ["path", { d: "M12 11v6", key: "1bwqyc" }]
]);
const hs = r("ClipboardXIcon", [
  ["rect", { width: "8", height: "4", x: "8", y: "2", rx: "1", ry: "1", key: "tgr4d6" }],
  [
    "path",
    {
      d: "M16 4h2a2 2 0 0 1 2 2v14a2 2 0 0 1-2 2H6a2 2 0 0 1-2-2V6a2 2 0 0 1 2-2h2",
      key: "116196"
    }
  ],
  ["path", { d: "m15 11-6 6", key: "1toa9n" }],
  ["path", { d: "m9 11 6 6", key: "wlibny" }]
]);
const ps = r("ClipboardIcon", [
  ["rect", { width: "8", height: "4", x: "8", y: "2", rx: "1", ry: "1", key: "tgr4d6" }],
  [
    "path",
    {
      d: "M16 4h2a2 2 0 0 1 2 2v14a2 2 0 0 1-2 2H6a2 2 0 0 1-2-2V6a2 2 0 0 1 2-2h2",
      key: "116196"
    }
  ]
]);
const ys = r("Clock1Icon", [
  ["circle", { cx: "12", cy: "12", r: "10", key: "1mglay" }],
  ["polyline", { points: "12 6 12 12 14.5 8", key: "12zbmj" }]
]);
const ks = r("Clock10Icon", [
  ["circle", { cx: "12", cy: "12", r: "10", key: "1mglay" }],
  ["polyline", { points: "12 6 12 12 8 10", key: "atfzqc" }]
]);
const fs = r("Clock11Icon", [
  ["circle", { cx: "12", cy: "12", r: "10", key: "1mglay" }],
  ["polyline", { points: "12 6 12 12 9.5 8", key: "l5bg6f" }]
]);
const vs = r("Clock12Icon", [
  ["circle", { cx: "12", cy: "12", r: "10", key: "1mglay" }],
  ["polyline", { points: "12 6 12 12", key: "1fub01" }]
]);
const ms = r("Clock2Icon", [
  ["circle", { cx: "12", cy: "12", r: "10", key: "1mglay" }],
  ["polyline", { points: "12 6 12 12 16 10", key: "1g230d" }]
]);
const gs = r("Clock3Icon", [
  ["circle", { cx: "12", cy: "12", r: "10", key: "1mglay" }],
  ["polyline", { points: "12 6 12 12 16.5 12", key: "1aq6pp" }]
]);
const Ms = r("Clock4Icon", [
  ["circle", { cx: "12", cy: "12", r: "10", key: "1mglay" }],
  ["polyline", { points: "12 6 12 12 16 14", key: "68esgv" }]
]);
const xs = r("Clock5Icon", [
  ["circle", { cx: "12", cy: "12", r: "10", key: "1mglay" }],
  ["polyline", { points: "12 6 12 12 14.5 16", key: "1pcbox" }]
]);
const bs = r("Clock6Icon", [
  ["circle", { cx: "12", cy: "12", r: "10", key: "1mglay" }],
  ["polyline", { points: "12 6 12 12 12 16.5", key: "hb2qv6" }]
]);
const ws = r("Clock7Icon", [
  ["circle", { cx: "12", cy: "12", r: "10", key: "1mglay" }],
  ["polyline", { points: "12 6 12 12 9.5 16", key: "ka3394" }]
]);
const Is = r("Clock8Icon", [
  ["circle", { cx: "12", cy: "12", r: "10", key: "1mglay" }],
  ["polyline", { points: "12 6 12 12 8 14", key: "tmc9b4" }]
]);
const Ls = r("Clock9Icon", [
  ["circle", { cx: "12", cy: "12", r: "10", key: "1mglay" }],
  ["polyline", { points: "12 6 12 12 7.5 12", key: "1k60p0" }]
]);
const Ss = r("ClockIcon", [
  ["circle", { cx: "12", cy: "12", r: "10", key: "1mglay" }],
  ["polyline", { points: "12 6 12 12 16 14", key: "68esgv" }]
]);
const Cs = r("CloudCogIcon", [
  ["circle", { cx: "12", cy: "17", r: "3", key: "1spfwm" }],
  ["path", { d: "M4.2 15.1A7 7 0 1 1 15.71 8h1.79a4.5 4.5 0 0 1 2.5 8.2", key: "zaobp" }],
  ["path", { d: "m15.7 18.4-.9-.3", key: "4qxpbn" }],
  ["path", { d: "m9.2 15.9-.9-.3", key: "17q7o2" }],
  ["path", { d: "m10.6 20.7.3-.9", key: "1pf4s2" }],
  ["path", { d: "m13.1 14.2.3-.9", key: "1mnuqm" }],
  ["path", { d: "m13.6 20.7-.4-1", key: "1jpd1m" }],
  ["path", { d: "m10.8 14.3-.4-1", key: "17ugyy" }],
  ["path", { d: "m8.3 18.6 1-.4", key: "s42vdx" }],
  ["path", { d: "m14.7 15.8 1-.4", key: "2wizun" }]
]);
const on = r("CloudDownloadIcon", [
  ["path", { d: "M4 14.899A7 7 0 1 1 15.71 8h1.79a4.5 4.5 0 0 1 2.5 8.242", key: "1pljnt" }],
  ["path", { d: "M12 12v9", key: "192myk" }],
  ["path", { d: "m8 17 4 4 4-4", key: "1ul180" }]
]);
const As = r("CloudDrizzleIcon", [
  ["path", { d: "M4 14.899A7 7 0 1 1 15.71 8h1.79a4.5 4.5 0 0 1 2.5 8.242", key: "1pljnt" }],
  ["path", { d: "M8 19v1", key: "1dk2by" }],
  ["path", { d: "M8 14v1", key: "84yxot" }],
  ["path", { d: "M16 19v1", key: "v220m7" }],
  ["path", { d: "M16 14v1", key: "g12gj6" }],
  ["path", { d: "M12 21v1", key: "q8vafk" }],
  ["path", { d: "M12 16v1", key: "1mx6rx" }]
]);
const Ps = r("CloudFogIcon", [
  ["path", { d: "M4 14.899A7 7 0 1 1 15.71 8h1.79a4.5 4.5 0 0 1 2.5 8.242", key: "1pljnt" }],
  ["path", { d: "M16 17H7", key: "pygtm1" }],
  ["path", { d: "M17 21H9", key: "1u2q02" }]
]);
const qs = r("CloudHailIcon", [
  ["path", { d: "M4 14.899A7 7 0 1 1 15.71 8h1.79a4.5 4.5 0 0 1 2.5 8.242", key: "1pljnt" }],
  ["path", { d: "M16 14v2", key: "a1is7l" }],
  ["path", { d: "M8 14v2", key: "1e9m6t" }],
  ["path", { d: "M16 20h.01", key: "xwek51" }],
  ["path", { d: "M8 20h.01", key: "1vjney" }],
  ["path", { d: "M12 16v2", key: "z66u1j" }],
  ["path", { d: "M12 22h.01", key: "1urd7a" }]
]);
const Ts = r("CloudLightningIcon", [
  ["path", { d: "M6 16.326A7 7 0 1 1 15.71 8h1.79a4.5 4.5 0 0 1 .5 8.973", key: "1cez44" }],
  ["path", { d: "m13 12-3 5h4l-3 5", key: "1t22er" }]
]);
const Ds = r("CloudMoonRainIcon", [
  [
    "path",
    {
      d: "M10.083 9A6.002 6.002 0 0 1 16 4a4.243 4.243 0 0 0 6 6c0 2.22-1.206 4.16-3 5.197",
      key: "u82z8m"
    }
  ],
  ["path", { d: "M3 20a5 5 0 1 1 8.9-4H13a3 3 0 0 1 2 5.24", key: "1qmrp3" }],
  ["path", { d: "M11 20v2", key: "174qtz" }],
  ["path", { d: "M7 19v2", key: "12npes" }]
]);
const _s = r("CloudMoonIcon", [
  ["path", { d: "M13 16a3 3 0 1 1 0 6H7a5 5 0 1 1 4.9-6Z", key: "p44pc9" }],
  ["path", { d: "M10.1 9A6 6 0 0 1 16 4a4.24 4.24 0 0 0 6 6 6 6 0 0 1-3 5.197", key: "16nha0" }]
]);
const Bs = r("CloudOffIcon", [
  ["path", { d: "m2 2 20 20", key: "1ooewy" }],
  ["path", { d: "M5.782 5.782A7 7 0 0 0 9 19h8.5a4.5 4.5 0 0 0 1.307-.193", key: "yfwify" }],
  [
    "path",
    { d: "M21.532 16.5A4.5 4.5 0 0 0 17.5 10h-1.79A7.008 7.008 0 0 0 10 5.07", key: "jlfiyv" }
  ]
]);
const zs = r("CloudRainWindIcon", [
  ["path", { d: "M4 14.899A7 7 0 1 1 15.71 8h1.79a4.5 4.5 0 0 1 2.5 8.242", key: "1pljnt" }],
  ["path", { d: "m9.2 22 3-7", key: "sb5f6j" }],
  ["path", { d: "m9 13-3 7", key: "500co5" }],
  ["path", { d: "m17 13-3 7", key: "8t2fiy" }]
]);
const Hs = r("CloudRainIcon", [
  ["path", { d: "M4 14.899A7 7 0 1 1 15.71 8h1.79a4.5 4.5 0 0 1 2.5 8.242", key: "1pljnt" }],
  ["path", { d: "M16 14v6", key: "1j4efv" }],
  ["path", { d: "M8 14v6", key: "17c4r9" }],
  ["path", { d: "M12 16v6", key: "c8a4gj" }]
]);
const js = r("CloudSnowIcon", [
  ["path", { d: "M4 14.899A7 7 0 1 1 15.71 8h1.79a4.5 4.5 0 0 1 2.5 8.242", key: "1pljnt" }],
  ["path", { d: "M8 15h.01", key: "a7atzg" }],
  ["path", { d: "M8 19h.01", key: "puxtts" }],
  ["path", { d: "M12 17h.01", key: "p32p05" }],
  ["path", { d: "M12 21h.01", key: "h35vbk" }],
  ["path", { d: "M16 15h.01", key: "rnfrdf" }],
  ["path", { d: "M16 19h.01", key: "1vcnzz" }]
]);
const Vs = r("CloudSunRainIcon", [
  ["path", { d: "M12 2v2", key: "tus03m" }],
  ["path", { d: "m4.93 4.93 1.41 1.41", key: "149t6j" }],
  ["path", { d: "M20 12h2", key: "1q8mjw" }],
  ["path", { d: "m19.07 4.93-1.41 1.41", key: "1shlcs" }],
  ["path", { d: "M15.947 12.65a4 4 0 0 0-5.925-4.128", key: "dpwdj0" }],
  ["path", { d: "M3 20a5 5 0 1 1 8.9-4H13a3 3 0 0 1 2 5.24", key: "1qmrp3" }],
  ["path", { d: "M11 20v2", key: "174qtz" }],
  ["path", { d: "M7 19v2", key: "12npes" }]
]);
const Os = r("CloudSunIcon", [
  ["path", { d: "M12 2v2", key: "tus03m" }],
  ["path", { d: "m4.93 4.93 1.41 1.41", key: "149t6j" }],
  ["path", { d: "M20 12h2", key: "1q8mjw" }],
  ["path", { d: "m19.07 4.93-1.41 1.41", key: "1shlcs" }],
  ["path", { d: "M15.947 12.65a4 4 0 0 0-5.925-4.128", key: "dpwdj0" }],
  ["path", { d: "M13 22H7a5 5 0 1 1 4.9-6H13a3 3 0 0 1 0 6Z", key: "s09mg5" }]
]);
const rn = r("CloudUploadIcon", [
  ["path", { d: "M4 14.899A7 7 0 1 1 15.71 8h1.79a4.5 4.5 0 0 1 2.5 8.242", key: "1pljnt" }],
  ["path", { d: "M12 12v9", key: "192myk" }],
  ["path", { d: "m16 16-4-4-4 4", key: "119tzi" }]
]);
const $s = r("CloudIcon", [
  ["path", { d: "M17.5 19H9a7 7 0 1 1 6.71-9h1.79a4.5 4.5 0 1 1 0 9Z", key: "p7xjir" }]
]);
const Rs = r("CloudyIcon", [
  ["path", { d: "M17.5 21H9a7 7 0 1 1 6.71-9h1.79a4.5 4.5 0 1 1 0 9Z", key: "gqqjvc" }],
  ["path", { d: "M22 10a3 3 0 0 0-3-3h-2.207a5.502 5.502 0 0 0-10.702.5", key: "1p2s76" }]
]);
const Fs = r("CloverIcon", [
  ["path", { d: "M16.17 7.83 2 22", key: "t58vo8" }],
  [
    "path",
    {
      d: "M4.02 12a2.827 2.827 0 1 1 3.81-4.17A2.827 2.827 0 1 1 12 4.02a2.827 2.827 0 1 1 4.17 3.81A2.827 2.827 0 1 1 19.98 12a2.827 2.827 0 1 1-3.81 4.17A2.827 2.827 0 1 1 12 19.98a2.827 2.827 0 1 1-4.17-3.81A1 1 0 1 1 4 12",
      key: "17k36q"
    }
  ],
  ["path", { d: "m7.83 7.83 8.34 8.34", key: "1d7sxk" }]
]);
const Us = r("ClubIcon", [
  [
    "path",
    {
      d: "M17.28 9.05a5.5 5.5 0 1 0-10.56 0A5.5 5.5 0 1 0 12 17.66a5.5 5.5 0 1 0 5.28-8.6Z",
      key: "27yuqz"
    }
  ],
  ["path", { d: "M12 17.66L12 22", key: "ogfahf" }]
]);
const ln = r("CodeXmlIcon", [
  ["path", { d: "m18 16 4-4-4-4", key: "1inbqp" }],
  ["path", { d: "m6 8-4 4 4 4", key: "15zrgr" }],
  ["path", { d: "m14.5 4-5 16", key: "e7oirm" }]
]);
const Es = r("CodeIcon", [
  ["polyline", { points: "16 18 22 12 16 6", key: "z7tu5w" }],
  ["polyline", { points: "8 6 2 12 8 18", key: "1eg1df" }]
]);
const Ws = r("CodepenIcon", [
  ["polygon", { points: "12 2 22 8.5 22 15.5 12 22 2 15.5 2 8.5 12 2", key: "srzb37" }],
  ["line", { x1: "12", x2: "12", y1: "22", y2: "15.5", key: "1t73f2" }],
  ["polyline", { points: "22 8.5 12 15.5 2 8.5", key: "ajlxae" }],
  ["polyline", { points: "2 15.5 12 8.5 22 15.5", key: "susrui" }],
  ["line", { x1: "12", x2: "12", y1: "2", y2: "8.5", key: "2cldga" }]
]);
const Ns = r("CodesandboxIcon", [
  [
    "path",
    {
      d: "M21 16V8a2 2 0 0 0-1-1.73l-7-4a2 2 0 0 0-2 0l-7 4A2 2 0 0 0 3 8v8a2 2 0 0 0 1 1.73l7 4a2 2 0 0 0 2 0l7-4A2 2 0 0 0 21 16z",
      key: "yt0hxn"
    }
  ],
  ["polyline", { points: "7.5 4.21 12 6.81 16.5 4.21", key: "fabo96" }],
  ["polyline", { points: "7.5 19.79 7.5 14.6 3 12", key: "z377f1" }],
  ["polyline", { points: "21 12 16.5 14.6 16.5 19.79", key: "9nrev1" }],
  ["polyline", { points: "3.27 6.96 12 12.01 20.73 6.96", key: "1180pa" }],
  ["line", { x1: "12", x2: "12", y1: "22.08", y2: "12", key: "3z3uq6" }]
]);
const Zs = r("CoffeeIcon", [
  ["path", { d: "M17 8h1a4 4 0 1 1 0 8h-1", key: "jx4kbh" }],
  ["path", { d: "M3 8h14v9a4 4 0 0 1-4 4H7a4 4 0 0 1-4-4Z", key: "1bxrl0" }],
  ["line", { x1: "6", x2: "6", y1: "2", y2: "4", key: "1cr9l3" }],
  ["line", { x1: "10", x2: "10", y1: "2", y2: "4", key: "170wym" }],
  ["line", { x1: "14", x2: "14", y1: "2", y2: "4", key: "1c5f70" }]
]);
const Ys = r("CogIcon", [
  ["path", { d: "M12 20a8 8 0 1 0 0-16 8 8 0 0 0 0 16Z", key: "sobvz5" }],
  ["path", { d: "M12 14a2 2 0 1 0 0-4 2 2 0 0 0 0 4Z", key: "11i496" }],
  ["path", { d: "M12 2v2", key: "tus03m" }],
  ["path", { d: "M12 22v-2", key: "1osdcq" }],
  ["path", { d: "m17 20.66-1-1.73", key: "eq3orb" }],
  ["path", { d: "M11 10.27 7 3.34", key: "16pf9h" }],
  ["path", { d: "m20.66 17-1.73-1", key: "sg0v6f" }],
  ["path", { d: "m3.34 7 1.73 1", key: "1ulond" }],
  ["path", { d: "M14 12h8", key: "4f43i9" }],
  ["path", { d: "M2 12h2", key: "1t8f8n" }],
  ["path", { d: "m20.66 7-1.73 1", key: "1ow05n" }],
  ["path", { d: "m3.34 17 1.73-1", key: "nuk764" }],
  ["path", { d: "m17 3.34-1 1.73", key: "2wel8s" }],
  ["path", { d: "m11 13.73-4 6.93", key: "794ttg" }]
]);
const Gs = r("CoinsIcon", [
  ["circle", { cx: "8", cy: "8", r: "6", key: "3yglwk" }],
  ["path", { d: "M18.09 10.37A6 6 0 1 1 10.34 18", key: "t5s6rm" }],
  ["path", { d: "M7 6h1v4", key: "1obek4" }],
  ["path", { d: "m16.71 13.88.7.71-2.82 2.82", key: "1rbuyh" }]
]);
const cn = r("Columns2Icon", [
  ["rect", { width: "18", height: "18", x: "3", y: "3", rx: "2", key: "afitv7" }],
  ["path", { d: "M12 3v18", key: "108xh3" }]
]);
const dn = r("Columns3Icon", [
  ["rect", { width: "18", height: "18", x: "3", y: "3", rx: "2", key: "afitv7" }],
  ["path", { d: "M9 3v18", key: "fh3hqa" }],
  ["path", { d: "M15 3v18", key: "14nvp0" }]
]);
const Xs = r("Columns4Icon", [
  ["rect", { width: "18", height: "18", x: "3", y: "3", rx: "2", key: "afitv7" }],
  ["path", { d: "M7.5 3v18", key: "w0wo6v" }],
  ["path", { d: "M12 3v18", key: "108xh3" }],
  ["path", { d: "M16.5 3v18", key: "10tjh1" }]
]);
const Ks = r("CombineIcon", [
  ["rect", { width: "8", height: "8", x: "2", y: "2", rx: "2", key: "z1hh3n" }],
  ["path", { d: "M14 2c1.1 0 2 .9 2 2v4c0 1.1-.9 2-2 2", key: "83orz6" }],
  ["path", { d: "M20 2c1.1 0 2 .9 2 2v4c0 1.1-.9 2-2 2", key: "k86dmt" }],
  ["path", { d: "M10 18H5c-1.7 0-3-1.3-3-3v-1", key: "6vokjl" }],
  ["polyline", { points: "7 21 10 18 7 15", key: "1k02g0" }],
  ["rect", { width: "8", height: "8", x: "14", y: "14", rx: "2", key: "1fa9i4" }]
]);
const Qs = r("CommandIcon", [
  [
    "path",
    { d: "M15 6v12a3 3 0 1 0 3-3H6a3 3 0 1 0 3 3V6a3 3 0 1 0-3 3h12a3 3 0 1 0-3-3", key: "11bfej" }
  ]
]);
const Js = r("CompassIcon", [
  ["circle", { cx: "12", cy: "12", r: "10", key: "1mglay" }],
  ["polygon", { points: "16.24 7.76 14.12 14.12 7.76 16.24 9.88 9.88 16.24 7.76", key: "m9r19z" }]
]);
const e0 = r("ComponentIcon", [
  ["path", { d: "M5.5 8.5 9 12l-3.5 3.5L2 12l3.5-3.5Z", key: "1kciei" }],
  ["path", { d: "m12 2 3.5 3.5L12 9 8.5 5.5 12 2Z", key: "1ome0g" }],
  ["path", { d: "M18.5 8.5 22 12l-3.5 3.5L15 12l3.5-3.5Z", key: "vbupec" }],
  ["path", { d: "m12 15 3.5 3.5L12 22l-3.5-3.5L12 15Z", key: "16csic" }]
]);
const t0 = r("ComputerIcon", [
  ["rect", { width: "14", height: "8", x: "5", y: "2", rx: "2", key: "wc9tft" }],
  ["rect", { width: "20", height: "8", x: "2", y: "14", rx: "2", key: "w68u3i" }],
  ["path", { d: "M6 18h2", key: "rwmk9e" }],
  ["path", { d: "M12 18h6", key: "aqd8w3" }]
]);
const a0 = r("ConciergeBellIcon", [
  [
    "path",
    { d: "M3 20a1 1 0 0 1-1-1v-1a2 2 0 0 1 2-2h16a2 2 0 0 1 2 2v1a1 1 0 0 1-1 1Z", key: "1pvr1r" }
  ],
  ["path", { d: "M20 16a8 8 0 1 0-16 0", key: "1pa543" }],
  ["path", { d: "M12 4v4", key: "1bq03y" }],
  ["path", { d: "M10 4h4", key: "1xpv9s" }]
]);
const n0 = r("ConeIcon", [
  ["path", { d: "m20.9 18.55-8-15.98a1 1 0 0 0-1.8 0l-8 15.98", key: "53pte7" }],
  ["ellipse", { cx: "12", cy: "19", rx: "9", ry: "3", key: "1ji25f" }]
]);
const o0 = r("ConstructionIcon", [
  ["rect", { x: "2", y: "6", width: "20", height: "8", rx: "1", key: "1estib" }],
  ["path", { d: "M17 14v7", key: "7m2elx" }],
  ["path", { d: "M7 14v7", key: "1cm7wv" }],
  ["path", { d: "M17 3v3", key: "1v4jwn" }],
  ["path", { d: "M7 3v3", key: "7o6guu" }],
  ["path", { d: "M10 14 2.3 6.3", key: "1023jk" }],
  ["path", { d: "m14 6 7.7 7.7", key: "1s8pl2" }],
  ["path", { d: "m8 6 8 8", key: "hl96qh" }]
]);
const sn = r("ContactRoundIcon", [
  ["path", { d: "M16 18a4 4 0 0 0-8 0", key: "1lzouq" }],
  ["circle", { cx: "12", cy: "11", r: "3", key: "itu57m" }],
  ["rect", { width: "18", height: "18", x: "3", y: "4", rx: "2", key: "1hopcy" }],
  ["line", { x1: "8", x2: "8", y1: "2", y2: "4", key: "1ff9gb" }],
  ["line", { x1: "16", x2: "16", y1: "2", y2: "4", key: "1ufoma" }]
]);
const r0 = r("ContactIcon", [
  ["path", { d: "M17 18a2 2 0 0 0-2-2H9a2 2 0 0 0-2 2", key: "1mghuy" }],
  ["rect", { width: "18", height: "18", x: "3", y: "4", rx: "2", key: "1hopcy" }],
  ["circle", { cx: "12", cy: "10", r: "2", key: "1yojzk" }],
  ["line", { x1: "8", x2: "8", y1: "2", y2: "4", key: "1ff9gb" }],
  ["line", { x1: "16", x2: "16", y1: "2", y2: "4", key: "1ufoma" }]
]);
const i0 = r("ContainerIcon", [
  [
    "path",
    {
      d: "M22 7.7c0-.6-.4-1.2-.8-1.5l-6.3-3.9a1.72 1.72 0 0 0-1.7 0l-10.3 6c-.5.2-.9.8-.9 1.4v6.6c0 .5.4 1.2.8 1.5l6.3 3.9a1.72 1.72 0 0 0 1.7 0l10.3-6c.5-.3.9-1 .9-1.5Z",
      key: "1t2lqe"
    }
  ],
  ["path", { d: "M10 21.9V14L2.1 9.1", key: "o7czzq" }],
  ["path", { d: "m10 14 11.9-6.9", key: "zm5e20" }],
  ["path", { d: "M14 19.8v-8.1", key: "159ecu" }],
  ["path", { d: "M18 17.5V9.4", key: "11uown" }]
]);
const l0 = r("ContrastIcon", [
  ["circle", { cx: "12", cy: "12", r: "10", key: "1mglay" }],
  ["path", { d: "M12 18a6 6 0 0 0 0-12v12z", key: "j4l70d" }]
]);
const c0 = r("CookieIcon", [
  ["path", { d: "M12 2a10 10 0 1 0 10 10 4 4 0 0 1-5-5 4 4 0 0 1-5-5", key: "laymnq" }],
  ["path", { d: "M8.5 8.5v.01", key: "ue8clq" }],
  ["path", { d: "M16 15.5v.01", key: "14dtrp" }],
  ["path", { d: "M12 12v.01", key: "u5ubse" }],
  ["path", { d: "M11 17v.01", key: "1hyl5a" }],
  ["path", { d: "M7 14v.01", key: "uct60s" }]
]);
const d0 = r("CookingPotIcon", [
  ["path", { d: "M2 12h20", key: "9i4pu4" }],
  ["path", { d: "M20 12v8a2 2 0 0 1-2 2H6a2 2 0 0 1-2-2v-8", key: "u0tga0" }],
  ["path", { d: "m4 8 16-4", key: "16g0ng" }],
  [
    "path",
    {
      d: "m8.86 6.78-.45-1.81a2 2 0 0 1 1.45-2.43l1.94-.48a2 2 0 0 1 2.43 1.46l.45 1.8",
      key: "12cejc"
    }
  ]
]);
const s0 = r("CopyCheckIcon", [
  ["path", { d: "m12 15 2 2 4-4", key: "2c609p" }],
  ["rect", { width: "14", height: "14", x: "8", y: "8", rx: "2", ry: "2", key: "17jyea" }],
  ["path", { d: "M4 16c-1.1 0-2-.9-2-2V4c0-1.1.9-2 2-2h10c1.1 0 2 .9 2 2", key: "zix9uf" }]
]);
const u0 = r("CopyMinusIcon", [
  ["line", { x1: "12", x2: "18", y1: "15", y2: "15", key: "1nscbv" }],
  ["rect", { width: "14", height: "14", x: "8", y: "8", rx: "2", ry: "2", key: "17jyea" }],
  ["path", { d: "M4 16c-1.1 0-2-.9-2-2V4c0-1.1.9-2 2-2h10c1.1 0 2 .9 2 2", key: "zix9uf" }]
]);
const h0 = r("CopyPlusIcon", [
  ["line", { x1: "15", x2: "15", y1: "12", y2: "18", key: "1p7wdc" }],
  ["line", { x1: "12", x2: "18", y1: "15", y2: "15", key: "1nscbv" }],
  ["rect", { width: "14", height: "14", x: "8", y: "8", rx: "2", ry: "2", key: "17jyea" }],
  ["path", { d: "M4 16c-1.1 0-2-.9-2-2V4c0-1.1.9-2 2-2h10c1.1 0 2 .9 2 2", key: "zix9uf" }]
]);
const p0 = r("CopySlashIcon", [
  ["line", { x1: "12", x2: "18", y1: "18", y2: "12", key: "ebkxgr" }],
  ["rect", { width: "14", height: "14", x: "8", y: "8", rx: "2", ry: "2", key: "17jyea" }],
  ["path", { d: "M4 16c-1.1 0-2-.9-2-2V4c0-1.1.9-2 2-2h10c1.1 0 2 .9 2 2", key: "zix9uf" }]
]);
const y0 = r("CopyXIcon", [
  ["line", { x1: "12", x2: "18", y1: "12", y2: "18", key: "1rg63v" }],
  ["line", { x1: "12", x2: "18", y1: "18", y2: "12", key: "ebkxgr" }],
  ["rect", { width: "14", height: "14", x: "8", y: "8", rx: "2", ry: "2", key: "17jyea" }],
  ["path", { d: "M4 16c-1.1 0-2-.9-2-2V4c0-1.1.9-2 2-2h10c1.1 0 2 .9 2 2", key: "zix9uf" }]
]);
const k0 = r("CopyIcon", [
  ["rect", { width: "14", height: "14", x: "8", y: "8", rx: "2", ry: "2", key: "17jyea" }],
  ["path", { d: "M4 16c-1.1 0-2-.9-2-2V4c0-1.1.9-2 2-2h10c1.1 0 2 .9 2 2", key: "zix9uf" }]
]);
const f0 = r("CopyleftIcon", [
  ["circle", { cx: "12", cy: "12", r: "10", key: "1mglay" }],
  ["path", { d: "M9.17 14.83a4 4 0 1 0 0-5.66", key: "1sveal" }]
]);
const v0 = r("CopyrightIcon", [
  ["circle", { cx: "12", cy: "12", r: "10", key: "1mglay" }],
  ["path", { d: "M14.83 14.83a4 4 0 1 1 0-5.66", key: "1i56pz" }]
]);
const m0 = r("CornerDownLeftIcon", [
  ["polyline", { points: "9 10 4 15 9 20", key: "r3jprv" }],
  ["path", { d: "M20 4v7a4 4 0 0 1-4 4H4", key: "6o5b7l" }]
]);
const g0 = r("CornerDownRightIcon", [
  ["polyline", { points: "15 10 20 15 15 20", key: "1q7qjw" }],
  ["path", { d: "M4 4v7a4 4 0 0 0 4 4h12", key: "z08zvw" }]
]);
const M0 = r("CornerLeftDownIcon", [
  ["polyline", { points: "14 15 9 20 4 15", key: "nkc4i" }],
  ["path", { d: "M20 4h-7a4 4 0 0 0-4 4v12", key: "nbpdq2" }]
]);
const x0 = r("CornerLeftUpIcon", [
  ["polyline", { points: "14 9 9 4 4 9", key: "m9oyvo" }],
  ["path", { d: "M20 20h-7a4 4 0 0 1-4-4V4", key: "1blwi3" }]
]);
const b0 = r("CornerRightDownIcon", [
  ["polyline", { points: "10 15 15 20 20 15", key: "axus6l" }],
  ["path", { d: "M4 4h7a4 4 0 0 1 4 4v12", key: "wcbgct" }]
]);
const w0 = r("CornerRightUpIcon", [
  ["polyline", { points: "10 9 15 4 20 9", key: "1lr6px" }],
  ["path", { d: "M4 20h7a4 4 0 0 0 4-4V4", key: "1plgdj" }]
]);
const I0 = r("CornerUpLeftIcon", [
  ["polyline", { points: "9 14 4 9 9 4", key: "881910" }],
  ["path", { d: "M20 20v-7a4 4 0 0 0-4-4H4", key: "1nkjon" }]
]);
const L0 = r("CornerUpRightIcon", [
  ["polyline", { points: "15 14 20 9 15 4", key: "1tbx3s" }],
  ["path", { d: "M4 20v-7a4 4 0 0 1 4-4h12", key: "1lu4f8" }]
]);
const S0 = r("CpuIcon", [
  ["rect", { width: "16", height: "16", x: "4", y: "4", rx: "2", key: "14l7u7" }],
  ["rect", { width: "6", height: "6", x: "9", y: "9", rx: "1", key: "5aljv4" }],
  ["path", { d: "M15 2v2", key: "13l42r" }],
  ["path", { d: "M15 20v2", key: "15mkzm" }],
  ["path", { d: "M2 15h2", key: "1gxd5l" }],
  ["path", { d: "M2 9h2", key: "1bbxkp" }],
  ["path", { d: "M20 15h2", key: "19e6y8" }],
  ["path", { d: "M20 9h2", key: "19tzq7" }],
  ["path", { d: "M9 2v2", key: "165o2o" }],
  ["path", { d: "M9 20v2", key: "i2bqo8" }]
]);
const C0 = r("CreativeCommonsIcon", [
  ["circle", { cx: "12", cy: "12", r: "10", key: "1mglay" }],
  [
    "path",
    { d: "M10 9.3a2.8 2.8 0 0 0-3.5 1 3.1 3.1 0 0 0 0 3.4 2.7 2.7 0 0 0 3.5 1", key: "1ss3eq" }
  ],
  [
    "path",
    { d: "M17 9.3a2.8 2.8 0 0 0-3.5 1 3.1 3.1 0 0 0 0 3.4 2.7 2.7 0 0 0 3.5 1", key: "1od56t" }
  ]
]);
const A0 = r("CreditCardIcon", [
  ["rect", { width: "20", height: "14", x: "2", y: "5", rx: "2", key: "ynyp8z" }],
  ["line", { x1: "2", x2: "22", y1: "10", y2: "10", key: "1b3vmo" }]
]);
const P0 = r("CroissantIcon", [
  [
    "path",
    {
      d: "m4.6 13.11 5.79-3.21c1.89-1.05 4.79 1.78 3.71 3.71l-3.22 5.81C8.8 23.16.79 15.23 4.6 13.11Z",
      key: "1ozxlb"
    }
  ],
  [
    "path",
    {
      d: "m10.5 9.5-1-2.29C9.2 6.48 8.8 6 8 6H4.5C2.79 6 2 6.5 2 8.5a7.71 7.71 0 0 0 2 4.83",
      key: "ffuyb5"
    }
  ],
  ["path", { d: "M8 6c0-1.55.24-4-2-4-2 0-2.5 2.17-2.5 4", key: "osnpzi" }],
  [
    "path",
    {
      d: "m14.5 13.5 2.29 1c.73.3 1.21.7 1.21 1.5v3.5c0 1.71-.5 2.5-2.5 2.5a7.71 7.71 0 0 1-4.83-2",
      key: "1vubaw"
    }
  ],
  ["path", { d: "M18 16c1.55 0 4-.24 4 2 0 2-2.17 2.5-4 2.5", key: "wxr772" }]
]);
const q0 = r("CropIcon", [
  ["path", { d: "M6 2v14a2 2 0 0 0 2 2h14", key: "ron5a4" }],
  ["path", { d: "M18 22V8a2 2 0 0 0-2-2H2", key: "7s9ehn" }]
]);
const T0 = r("CrossIcon", [
  [
    "path",
    {
      d: "M11 2a2 2 0 0 0-2 2v5H4a2 2 0 0 0-2 2v2c0 1.1.9 2 2 2h5v5c0 1.1.9 2 2 2h2a2 2 0 0 0 2-2v-5h5a2 2 0 0 0 2-2v-2a2 2 0 0 0-2-2h-5V4a2 2 0 0 0-2-2h-2z",
      key: "1t5g7j"
    }
  ]
]);
const D0 = r("CrosshairIcon", [
  ["circle", { cx: "12", cy: "12", r: "10", key: "1mglay" }],
  ["line", { x1: "22", x2: "18", y1: "12", y2: "12", key: "l9bcsi" }],
  ["line", { x1: "6", x2: "2", y1: "12", y2: "12", key: "13hhkx" }],
  ["line", { x1: "12", x2: "12", y1: "6", y2: "2", key: "10w3f3" }],
  ["line", { x1: "12", x2: "12", y1: "22", y2: "18", key: "15g9kq" }]
]);
const _0 = r("CrownIcon", [
  [
    "path",
    {
      d: "M11.562 3.266a.5.5 0 0 1 .876 0L15.39 8.87a1 1 0 0 0 1.516.294L21.183 5.5a.5.5 0 0 1 .798.519l-2.834 10.246a1 1 0 0 1-.956.734H5.81a1 1 0 0 1-.957-.734L2.02 6.02a.5.5 0 0 1 .798-.519l4.276 3.664a1 1 0 0 0 1.516-.294z",
      key: "1vdc57"
    }
  ],
  ["path", { d: "M5 21h14", key: "11awu3" }]
]);
const B0 = r("CuboidIcon", [
  [
    "path",
    {
      d: "m21.12 6.4-6.05-4.06a2 2 0 0 0-2.17-.05L2.95 8.41a2 2 0 0 0-.95 1.7v5.82a2 2 0 0 0 .88 1.66l6.05 4.07a2 2 0 0 0 2.17.05l9.95-6.12a2 2 0 0 0 .95-1.7V8.06a2 2 0 0 0-.88-1.66Z",
      key: "1u2ovd"
    }
  ],
  ["path", { d: "M10 22v-8L2.25 9.15", key: "11pn4q" }],
  ["path", { d: "m10 14 11.77-6.87", key: "1kt1wh" }]
]);
const z0 = r("CupSodaIcon", [
  ["path", { d: "m6 8 1.75 12.28a2 2 0 0 0 2 1.72h4.54a2 2 0 0 0 2-1.72L18 8", key: "8166m8" }],
  ["path", { d: "M5 8h14", key: "pcz4l3" }],
  ["path", { d: "M7 15a6.47 6.47 0 0 1 5 0 6.47 6.47 0 0 0 5 0", key: "yjz344" }],
  ["path", { d: "m12 8 1-6h2", key: "3ybfa4" }]
]);
const H0 = r("CurrencyIcon", [
  ["circle", { cx: "12", cy: "12", r: "8", key: "46899m" }],
  ["line", { x1: "3", x2: "6", y1: "3", y2: "6", key: "1jkytn" }],
  ["line", { x1: "21", x2: "18", y1: "3", y2: "6", key: "14zfjt" }],
  ["line", { x1: "3", x2: "6", y1: "21", y2: "18", key: "iusuec" }],
  ["line", { x1: "21", x2: "18", y1: "21", y2: "18", key: "yj2dd7" }]
]);
const j0 = r("CylinderIcon", [
  ["ellipse", { cx: "12", cy: "5", rx: "9", ry: "3", key: "msslwz" }],
  ["path", { d: "M3 5v14a9 3 0 0 0 18 0V5", key: "aqi0yr" }]
]);
const V0 = r("DatabaseBackupIcon", [
  ["ellipse", { cx: "12", cy: "5", rx: "9", ry: "3", key: "msslwz" }],
  ["path", { d: "M3 12a9 3 0 0 0 5 2.69", key: "1ui2ym" }],
  ["path", { d: "M21 9.3V5", key: "6k6cib" }],
  ["path", { d: "M3 5v14a9 3 0 0 0 6.47 2.88", key: "i62tjy" }],
  ["path", { d: "M12 12v4h4", key: "1bxaet" }],
  [
    "path",
    {
      d: "M13 20a5 5 0 0 0 9-3 4.5 4.5 0 0 0-4.5-4.5c-1.33 0-2.54.54-3.41 1.41L12 16",
      key: "1f4ei9"
    }
  ]
]);
const O0 = r("DatabaseZapIcon", [
  ["ellipse", { cx: "12", cy: "5", rx: "9", ry: "3", key: "msslwz" }],
  ["path", { d: "M3 5V19A9 3 0 0 0 15 21.84", key: "14ibmq" }],
  ["path", { d: "M21 5V8", key: "1marbg" }],
  ["path", { d: "M21 12L18 17H22L19 22", key: "zafso" }],
  ["path", { d: "M3 12A9 3 0 0 0 14.59 14.87", key: "1y4wr8" }]
]);
const $0 = r("DatabaseIcon", [
  ["ellipse", { cx: "12", cy: "5", rx: "9", ry: "3", key: "msslwz" }],
  ["path", { d: "M3 5V19A9 3 0 0 0 21 19V5", key: "1wlel7" }],
  ["path", { d: "M3 12A9 3 0 0 0 21 12", key: "mv7ke4" }]
]);
const R0 = r("DeleteIcon", [
  ["path", { d: "M20 5H9l-7 7 7 7h11a2 2 0 0 0 2-2V7a2 2 0 0 0-2-2Z", key: "1oy587" }],
  ["line", { x1: "18", x2: "12", y1: "9", y2: "15", key: "1olkx5" }],
  ["line", { x1: "12", x2: "18", y1: "9", y2: "15", key: "1n50pc" }]
]);
const F0 = r("DessertIcon", [
  ["circle", { cx: "12", cy: "4", r: "2", key: "muu5ef" }],
  [
    "path",
    {
      d: "M10.2 3.2C5.5 4 2 8.1 2 13a2 2 0 0 0 4 0v-1a2 2 0 0 1 4 0v4a2 2 0 0 0 4 0v-4a2 2 0 0 1 4 0v1a2 2 0 0 0 4 0c0-4.9-3.5-9-8.2-9.8",
      key: "lfo06j"
    }
  ],
  ["path", { d: "M3.2 14.8a9 9 0 0 0 17.6 0", key: "12xarc" }]
]);
const U0 = r("DiameterIcon", [
  ["circle", { cx: "19", cy: "19", r: "2", key: "17f5cg" }],
  ["circle", { cx: "5", cy: "5", r: "2", key: "1gwv83" }],
  ["path", { d: "M6.48 3.66a10 10 0 0 1 13.86 13.86", key: "xr8kdq" }],
  ["path", { d: "m6.41 6.41 11.18 11.18", key: "uhpjw7" }],
  ["path", { d: "M3.66 6.48a10 10 0 0 0 13.86 13.86", key: "cldpwv" }]
]);
const un = r("DiamondPercentIcon", [
  [
    "path",
    {
      d: "M2.7 10.3a2.41 2.41 0 0 0 0 3.41l7.59 7.59a2.41 2.41 0 0 0 3.41 0l7.59-7.59a2.41 2.41 0 0 0 0-3.41L13.7 2.71a2.41 2.41 0 0 0-3.41 0Z",
      key: "1tpxz2"
    }
  ],
  ["path", { d: "M9.2 9.2h.01", key: "1b7bvt" }],
  ["path", { d: "m14.5 9.5-5 5", key: "17q4r4" }],
  ["path", { d: "M14.7 14.8h.01", key: "17nsh4" }]
]);
const E0 = r("DiamondIcon", [
  [
    "path",
    {
      d: "M2.7 10.3a2.41 2.41 0 0 0 0 3.41l7.59 7.59a2.41 2.41 0 0 0 3.41 0l7.59-7.59a2.41 2.41 0 0 0 0-3.41l-7.59-7.59a2.41 2.41 0 0 0-3.41 0Z",
      key: "1f1r0c"
    }
  ]
]);
const W0 = r("Dice1Icon", [
  ["rect", { width: "18", height: "18", x: "3", y: "3", rx: "2", ry: "2", key: "1m3agn" }],
  ["path", { d: "M12 12h.01", key: "1mp3jc" }]
]);
const N0 = r("Dice2Icon", [
  ["rect", { width: "18", height: "18", x: "3", y: "3", rx: "2", ry: "2", key: "1m3agn" }],
  ["path", { d: "M15 9h.01", key: "x1ddxp" }],
  ["path", { d: "M9 15h.01", key: "fzyn71" }]
]);
const Z0 = r("Dice3Icon", [
  ["rect", { width: "18", height: "18", x: "3", y: "3", rx: "2", ry: "2", key: "1m3agn" }],
  ["path", { d: "M16 8h.01", key: "cr5u4v" }],
  ["path", { d: "M12 12h.01", key: "1mp3jc" }],
  ["path", { d: "M8 16h.01", key: "18s6g9" }]
]);
const Y0 = r("Dice4Icon", [
  ["rect", { width: "18", height: "18", x: "3", y: "3", rx: "2", ry: "2", key: "1m3agn" }],
  ["path", { d: "M16 8h.01", key: "cr5u4v" }],
  ["path", { d: "M8 8h.01", key: "1e4136" }],
  ["path", { d: "M8 16h.01", key: "18s6g9" }],
  ["path", { d: "M16 16h.01", key: "1f9h7w" }]
]);
const G0 = r("Dice5Icon", [
  ["rect", { width: "18", height: "18", x: "3", y: "3", rx: "2", ry: "2", key: "1m3agn" }],
  ["path", { d: "M16 8h.01", key: "cr5u4v" }],
  ["path", { d: "M8 8h.01", key: "1e4136" }],
  ["path", { d: "M8 16h.01", key: "18s6g9" }],
  ["path", { d: "M16 16h.01", key: "1f9h7w" }],
  ["path", { d: "M12 12h.01", key: "1mp3jc" }]
]);
const X0 = r("Dice6Icon", [
  ["rect", { width: "18", height: "18", x: "3", y: "3", rx: "2", ry: "2", key: "1m3agn" }],
  ["path", { d: "M16 8h.01", key: "cr5u4v" }],
  ["path", { d: "M16 12h.01", key: "1l6xoz" }],
  ["path", { d: "M16 16h.01", key: "1f9h7w" }],
  ["path", { d: "M8 8h.01", key: "1e4136" }],
  ["path", { d: "M8 12h.01", key: "czm47f" }],
  ["path", { d: "M8 16h.01", key: "18s6g9" }]
]);
const K0 = r("DicesIcon", [
  ["rect", { width: "12", height: "12", x: "2", y: "10", rx: "2", ry: "2", key: "6agr2n" }],
  [
    "path",
    { d: "m17.92 14 3.5-3.5a2.24 2.24 0 0 0 0-3l-5-4.92a2.24 2.24 0 0 0-3 0L10 6", key: "1o487t" }
  ],
  ["path", { d: "M6 18h.01", key: "uhywen" }],
  ["path", { d: "M10 14h.01", key: "ssrbsk" }],
  ["path", { d: "M15 6h.01", key: "cblpky" }],
  ["path", { d: "M18 9h.01", key: "2061c0" }]
]);
const Q0 = r("DiffIcon", [
  ["path", { d: "M12 3v14", key: "7cf3v8" }],
  ["path", { d: "M5 10h14", key: "elsbfy" }],
  ["path", { d: "M5 21h14", key: "11awu3" }]
]);
const J0 = r("Disc2Icon", [
  ["circle", { cx: "12", cy: "12", r: "10", key: "1mglay" }],
  ["circle", { cx: "12", cy: "12", r: "4", key: "4exip2" }],
  ["path", { d: "M12 12h.01", key: "1mp3jc" }]
]);
const eu = r("Disc3Icon", [
  ["circle", { cx: "12", cy: "12", r: "10", key: "1mglay" }],
  ["path", { d: "M6 12c0-1.7.7-3.2 1.8-4.2", key: "oqkarx" }],
  ["circle", { cx: "12", cy: "12", r: "2", key: "1c9p78" }],
  ["path", { d: "M18 12c0 1.7-.7 3.2-1.8 4.2", key: "1eah9h" }]
]);
const tu = r("DiscAlbumIcon", [
  ["rect", { width: "18", height: "18", x: "3", y: "3", rx: "2", key: "afitv7" }],
  ["circle", { cx: "12", cy: "12", r: "5", key: "nd82uf" }],
  ["path", { d: "M12 12h.01", key: "1mp3jc" }]
]);
const au = r("DiscIcon", [
  ["circle", { cx: "12", cy: "12", r: "10", key: "1mglay" }],
  ["circle", { cx: "12", cy: "12", r: "2", key: "1c9p78" }]
]);
const nu = r("DivideIcon", [
  ["circle", { cx: "12", cy: "6", r: "1", key: "1bh7o1" }],
  ["line", { x1: "5", x2: "19", y1: "12", y2: "12", key: "13b5wn" }],
  ["circle", { cx: "12", cy: "18", r: "1", key: "lqb9t5" }]
]);
const ou = r("DnaOffIcon", [
  ["path", { d: "M15 2c-1.35 1.5-2.092 3-2.5 4.5M9 22c1.35-1.5 2.092-3 2.5-4.5", key: "sxiaad" }],
  ["path", { d: "M2 15c3.333-3 6.667-3 10-3m10-3c-1.5 1.35-3 2.092-4.5 2.5", key: "yn4bs1" }],
  ["path", { d: "m17 6-2.5-2.5", key: "5cdfhj" }],
  ["path", { d: "m14 8-1.5-1.5", key: "1ohn8i" }],
  ["path", { d: "m7 18 2.5 2.5", key: "16tu1a" }],
  ["path", { d: "m3.5 14.5.5.5", key: "hapbhd" }],
  ["path", { d: "m20 9 .5.5", key: "1n7z02" }],
  ["path", { d: "m6.5 12.5 1 1", key: "cs35ky" }],
  ["path", { d: "m16.5 10.5 1 1", key: "696xn5" }],
  ["path", { d: "m10 16 1.5 1.5", key: "11lckj" }],
  ["line", { x1: "2", x2: "22", y1: "2", y2: "22", key: "a6p6uj" }]
]);
const ru = r("DnaIcon", [
  ["path", { d: "M2 15c6.667-6 13.333 0 20-6", key: "1pyr53" }],
  ["path", { d: "M9 22c1.798-1.998 2.518-3.995 2.807-5.993", key: "q3hbxp" }],
  ["path", { d: "M15 2c-1.798 1.998-2.518 3.995-2.807 5.993", key: "80uv8i" }],
  ["path", { d: "m17 6-2.5-2.5", key: "5cdfhj" }],
  ["path", { d: "m14 8-1-1", key: "15nbz5" }],
  ["path", { d: "m7 18 2.5 2.5", key: "16tu1a" }],
  ["path", { d: "m3.5 14.5.5.5", key: "hapbhd" }],
  ["path", { d: "m20 9 .5.5", key: "1n7z02" }],
  ["path", { d: "m6.5 12.5 1 1", key: "cs35ky" }],
  ["path", { d: "m16.5 10.5 1 1", key: "696xn5" }],
  ["path", { d: "m10 16 1.5 1.5", key: "11lckj" }]
]);
const iu = r("DockIcon", [
  ["path", { d: "M2 8h20", key: "d11cs7" }],
  ["rect", { width: "20", height: "16", x: "2", y: "4", rx: "2", key: "18n3k1" }],
  ["path", { d: "M6 16h12", key: "u522kt" }]
]);
const lu = r("DogIcon", [
  [
    "path",
    {
      d: "M10 5.172C10 3.782 8.423 2.679 6.5 3c-2.823.47-4.113 6.006-4 7 .08.703 1.725 1.722 3.656 1 1.261-.472 1.96-1.45 2.344-2.5",
      key: "19br0u"
    }
  ],
  [
    "path",
    {
      d: "M14.267 5.172c0-1.39 1.577-2.493 3.5-2.172 2.823.47 4.113 6.006 4 7-.08.703-1.725 1.722-3.656 1-1.261-.472-1.855-1.45-2.239-2.5",
      key: "11n1an"
    }
  ],
  ["path", { d: "M8 14v.5", key: "1nzgdb" }],
  ["path", { d: "M16 14v.5", key: "1lajdz" }],
  ["path", { d: "M11.25 16.25h1.5L12 17l-.75-.75Z", key: "12kq1m" }],
  [
    "path",
    {
      d: "M4.42 11.247A13.152 13.152 0 0 0 4 14.556C4 18.728 7.582 21 12 21s8-2.272 8-6.444c0-1.061-.162-2.2-.493-3.309m-9.243-6.082A8.801 8.801 0 0 1 12 5c.78 0 1.5.108 2.161.306",
      key: "wsu29d"
    }
  ]
]);
const cu = r("DollarSignIcon", [
  ["line", { x1: "12", x2: "12", y1: "2", y2: "22", key: "7eqyqh" }],
  ["path", { d: "M17 5H9.5a3.5 3.5 0 0 0 0 7h5a3.5 3.5 0 0 1 0 7H6", key: "1b0p4s" }]
]);
const du = r("DonutIcon", [
  [
    "path",
    {
      d: "M20.5 10a2.5 2.5 0 0 1-2.4-3H18a2.95 2.95 0 0 1-2.6-4.4 10 10 0 1 0 6.3 7.1c-.3.2-.8.3-1.2.3",
      key: "19sr3x"
    }
  ],
  ["circle", { cx: "12", cy: "12", r: "3", key: "1v7zrd" }]
]);
const su = r("DoorClosedIcon", [
  ["path", { d: "M18 20V6a2 2 0 0 0-2-2H8a2 2 0 0 0-2 2v14", key: "36qu9e" }],
  ["path", { d: "M2 20h20", key: "owomy5" }],
  ["path", { d: "M14 12v.01", key: "xfcn54" }]
]);
const uu = r("DoorOpenIcon", [
  ["path", { d: "M13 4h3a2 2 0 0 1 2 2v14", key: "hrm0s9" }],
  ["path", { d: "M2 20h3", key: "1gaodv" }],
  ["path", { d: "M13 20h9", key: "s90cdi" }],
  ["path", { d: "M10 12v.01", key: "vx6srw" }],
  [
    "path",
    {
      d: "M13 4.562v16.157a1 1 0 0 1-1.242.97L5 20V5.562a2 2 0 0 1 1.515-1.94l4-1A2 2 0 0 1 13 4.561Z",
      key: "199qr4"
    }
  ]
]);
const hu = r("DotIcon", [
  ["circle", { cx: "12.1", cy: "12.1", r: "1", key: "18d7e5" }]
]);
const pu = r("DownloadIcon", [
  ["path", { d: "M21 15v4a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2v-4", key: "ih7n3h" }],
  ["polyline", { points: "7 10 12 15 17 10", key: "2ggqvy" }],
  ["line", { x1: "12", x2: "12", y1: "15", y2: "3", key: "1vk2je" }]
]);
const yu = r("DraftingCompassIcon", [
  ["circle", { cx: "12", cy: "5", r: "2", key: "f1ur92" }],
  ["path", { d: "m3 21 8.02-14.26", key: "1ssaw4" }],
  ["path", { d: "m12.99 6.74 1.93 3.44", key: "iwagvd" }],
  ["path", { d: "M19 12c-3.87 4-10.13 4-14 0", key: "1tsu18" }],
  ["path", { d: "m21 21-2.16-3.84", key: "vylbct" }]
]);
const ku = r("DramaIcon", [
  ["path", { d: "M10 11h.01", key: "d2at3l" }],
  ["path", { d: "M14 6h.01", key: "k028ub" }],
  ["path", { d: "M18 6h.01", key: "1v4wsw" }],
  ["path", { d: "M6.5 13.1h.01", key: "1748ia" }],
  ["path", { d: "M22 5c0 9-4 12-6 12s-6-3-6-12c0-2 2-3 6-3s6 1 6 3", key: "172yzv" }],
  ["path", { d: "M17.4 9.9c-.8.8-2 .8-2.8 0", key: "1obv0w" }],
  [
    "path",
    {
      d: "M10.1 7.1C9 7.2 7.7 7.7 6 8.6c-3.5 2-4.7 3.9-3.7 5.6 4.5 7.8 9.5 8.4 11.2 7.4.9-.5 1.9-2.1 1.9-4.7",
      key: "rqjl8i"
    }
  ],
  ["path", { d: "M9.1 16.5c.3-1.1 1.4-1.7 2.4-1.4", key: "1mr6wy" }]
]);
const fu = r("DribbbleIcon", [
  ["circle", { cx: "12", cy: "12", r: "10", key: "1mglay" }],
  ["path", { d: "M19.13 5.09C15.22 9.14 10 10.44 2.25 10.94", key: "hpej1" }],
  ["path", { d: "M21.75 12.84c-6.62-1.41-12.14 1-16.38 6.32", key: "1tr44o" }],
  ["path", { d: "M8.56 2.75c4.37 6 6 9.42 8 17.72", key: "kbh691" }]
]);
const vu = r("DrillIcon", [
  [
    "path",
    { d: "M14 9c0 .6-.4 1-1 1H4a2 2 0 0 1-2-2V4a2 2 0 0 1 2-2h9c.6 0 1 .4 1 1Z", key: "b6nnkj" }
  ],
  ["path", { d: "M18 6h4", key: "66u95g" }],
  ["path", { d: "M14 4h3a1 1 0 0 1 1 1v2a1 1 0 0 1-1 1h-3", key: "105ega" }],
  ["path", { d: "m5 10-2 8", key: "xt2lic" }],
  ["path", { d: "M12 10v3c0 .6-.4 1-1 1H8", key: "mwpjnk" }],
  ["path", { d: "m7 18 2-8", key: "1bzku2" }],
  [
    "path",
    { d: "M5 22c-1.7 0-3-1.3-3-3 0-.6.4-1 1-1h7c.6 0 1 .4 1 1v2c0 .6-.4 1-1 1Z", key: "117add" }
  ]
]);
const mu = r("DropletIcon", [
  [
    "path",
    {
      d: "M12 22a7 7 0 0 0 7-7c0-2-1-3.9-3-5.5s-3.5-4-4-6.5c-.5 2.5-2 4.9-4 6.5C6 11.1 5 13 5 15a7 7 0 0 0 7 7z",
      key: "c7niix"
    }
  ]
]);
const gu = r("DropletsIcon", [
  [
    "path",
    {
      d: "M7 16.3c2.2 0 4-1.83 4-4.05 0-1.16-.57-2.26-1.71-3.19S7.29 6.75 7 5.3c-.29 1.45-1.14 2.84-2.29 3.76S3 11.1 3 12.25c0 2.22 1.8 4.05 4 4.05z",
      key: "1ptgy4"
    }
  ],
  [
    "path",
    {
      d: "M12.56 6.6A10.97 10.97 0 0 0 14 3.02c.5 2.5 2 4.9 4 6.5s3 3.5 3 5.5a6.98 6.98 0 0 1-11.91 4.97",
      key: "1sl1rz"
    }
  ]
]);
const Mu = r("DrumIcon", [
  ["path", { d: "m2 2 8 8", key: "1v6059" }],
  ["path", { d: "m22 2-8 8", key: "173r8a" }],
  ["ellipse", { cx: "12", cy: "9", rx: "10", ry: "5", key: "liohsx" }],
  ["path", { d: "M7 13.4v7.9", key: "1yi6u9" }],
  ["path", { d: "M12 14v8", key: "1tn2tj" }],
  ["path", { d: "M17 13.4v7.9", key: "eqz2v3" }],
  ["path", { d: "M2 9v8a10 5 0 0 0 20 0V9", key: "1750ul" }]
]);
const xu = r("DrumstickIcon", [
  [
    "path",
    { d: "M15.4 15.63a7.875 6 135 1 1 6.23-6.23 4.5 3.43 135 0 0-6.23 6.23", key: "1dtqwm" }
  ],
  [
    "path",
    {
      d: "m8.29 12.71-2.6 2.6a2.5 2.5 0 1 0-1.65 4.65A2.5 2.5 0 1 0 8.7 18.3l2.59-2.59",
      key: "1oq1fw"
    }
  ]
]);
const bu = r("DumbbellIcon", [
  ["path", { d: "m6.5 6.5 11 11", key: "f7oqzb" }],
  ["path", { d: "m21 21-1-1", key: "cpc6if" }],
  ["path", { d: "m3 3 1 1", key: "d3rpuf" }],
  ["path", { d: "m18 22 4-4", key: "1e32o6" }],
  ["path", { d: "m2 6 4-4", key: "189tqz" }],
  ["path", { d: "m3 10 7-7", key: "1bxui2" }],
  ["path", { d: "m14 21 7-7", key: "16x78n" }]
]);
const wu = r("EarOffIcon", [
  ["path", { d: "M6 18.5a3.5 3.5 0 1 0 7 0c0-1.57.92-2.52 2.04-3.46", key: "1qngmn" }],
  ["path", { d: "M6 8.5c0-.75.13-1.47.36-2.14", key: "b06bma" }],
  ["path", { d: "M8.8 3.15A6.5 6.5 0 0 1 19 8.5c0 1.63-.44 2.81-1.09 3.76", key: "g10hsz" }],
  ["path", { d: "M12.5 6A2.5 2.5 0 0 1 15 8.5M10 13a2 2 0 0 0 1.82-1.18", key: "ygzou7" }],
  ["line", { x1: "2", x2: "22", y1: "2", y2: "22", key: "a6p6uj" }]
]);
const Iu = r("EarIcon", [
  ["path", { d: "M6 8.5a6.5 6.5 0 1 1 13 0c0 6-6 6-6 10a3.5 3.5 0 1 1-7 0", key: "1dfaln" }],
  ["path", { d: "M15 8.5a2.5 2.5 0 0 0-5 0v1a2 2 0 1 1 0 4", key: "1qnva7" }]
]);
const Lu = r("EarthLockIcon", [
  ["path", { d: "M7 3.34V5a3 3 0 0 0 3 3", key: "w732o8" }],
  ["path", { d: "M11 21.95V18a2 2 0 0 0-2-2 2 2 0 0 1-2-2v-1a2 2 0 0 0-2-2H2.05", key: "f02343" }],
  ["path", { d: "M21.54 15H17a2 2 0 0 0-2 2v4.54", key: "1djwo0" }],
  ["path", { d: "M12 2a10 10 0 1 0 9.54 13", key: "zjsr6q" }],
  ["path", { d: "M20 6V4a2 2 0 1 0-4 0v2", key: "1of5e8" }],
  ["rect", { width: "8", height: "5", x: "14", y: "6", rx: "1", key: "1fmf51" }]
]);
const hn = r("EarthIcon", [
  ["path", { d: "M21.54 15H17a2 2 0 0 0-2 2v4.54", key: "1djwo0" }],
  [
    "path",
    {
      d: "M7 3.34V5a3 3 0 0 0 3 3v0a2 2 0 0 1 2 2v0c0 1.1.9 2 2 2v0a2 2 0 0 0 2-2v0c0-1.1.9-2 2-2h3.17",
      key: "1fi5u6"
    }
  ],
  [
    "path",
    { d: "M11 21.95V18a2 2 0 0 0-2-2v0a2 2 0 0 1-2-2v-1a2 2 0 0 0-2-2H2.05", key: "xsiumc" }
  ],
  ["circle", { cx: "12", cy: "12", r: "10", key: "1mglay" }]
]);
const Su = r("EclipseIcon", [
  ["circle", { cx: "12", cy: "12", r: "10", key: "1mglay" }],
  ["path", { d: "M12 2a7 7 0 1 0 10 10", key: "1yuj32" }]
]);
const Cu = r("EggFriedIcon", [
  ["circle", { cx: "11.5", cy: "12.5", r: "3.5", key: "1cl1mi" }],
  [
    "path",
    {
      d: "M3 8c0-3.5 2.5-6 6.5-6 5 0 4.83 3 7.5 5s5 2 5 6c0 4.5-2.5 6.5-7 6.5-2.5 0-2.5 2.5-6 2.5s-7-2-7-5.5c0-3 1.5-3 1.5-5C3.5 10 3 9 3 8Z",
      key: "165ef9"
    }
  ]
]);
const Au = r("EggOffIcon", [
  [
    "path",
    {
      d: "M6.399 6.399C5.362 8.157 4.65 10.189 4.5 12c-.37 4.43 1.27 9.95 7.5 10 3.256-.026 5.259-1.547 6.375-3.625",
      key: "6et380"
    }
  ],
  [
    "path",
    {
      d: "M19.532 13.875A14.07 14.07 0 0 0 19.5 12c-.36-4.34-3.95-9.96-7.5-10-1.04.012-2.082.502-3.046 1.297",
      key: "gcdc3f"
    }
  ],
  ["line", { x1: "2", x2: "22", y1: "2", y2: "22", key: "a6p6uj" }]
]);
const Pu = r("EggIcon", [
  [
    "path",
    {
      d: "M12 22c6.23-.05 7.87-5.57 7.5-10-.36-4.34-3.95-9.96-7.5-10-3.55.04-7.14 5.66-7.5 10-.37 4.43 1.27 9.95 7.5 10z",
      key: "1c39pg"
    }
  ]
]);
const pn = r("EllipsisVerticalIcon", [
  ["circle", { cx: "12", cy: "12", r: "1", key: "41hilf" }],
  ["circle", { cx: "12", cy: "5", r: "1", key: "gxeob9" }],
  ["circle", { cx: "12", cy: "19", r: "1", key: "lyex9k" }]
]);
const yn = r("EllipsisIcon", [
  ["circle", { cx: "12", cy: "12", r: "1", key: "41hilf" }],
  ["circle", { cx: "19", cy: "12", r: "1", key: "1wjl8i" }],
  ["circle", { cx: "5", cy: "12", r: "1", key: "1pcz8c" }]
]);
const qu = r("EqualNotIcon", [
  ["line", { x1: "5", x2: "19", y1: "9", y2: "9", key: "1nwqeh" }],
  ["line", { x1: "5", x2: "19", y1: "15", y2: "15", key: "g8yjpy" }],
  ["line", { x1: "19", x2: "5", y1: "5", y2: "19", key: "1x9vlm" }]
]);
const Tu = r("EqualIcon", [
  ["line", { x1: "5", x2: "19", y1: "9", y2: "9", key: "1nwqeh" }],
  ["line", { x1: "5", x2: "19", y1: "15", y2: "15", key: "g8yjpy" }]
]);
const Du = r("EraserIcon", [
  [
    "path",
    {
      d: "m7 21-4.3-4.3c-1-1-1-2.5 0-3.4l9.6-9.6c1-1 2.5-1 3.4 0l5.6 5.6c1 1 1 2.5 0 3.4L13 21",
      key: "182aya"
    }
  ],
  ["path", { d: "M22 21H7", key: "t4ddhn" }],
  ["path", { d: "m5 11 9 9", key: "1mo9qw" }]
]);
const _u = r("EuroIcon", [
  ["path", { d: "M4 10h12", key: "1y6xl8" }],
  ["path", { d: "M4 14h9", key: "1loblj" }],
  [
    "path",
    {
      d: "M19 6a7.7 7.7 0 0 0-5.2-2A7.9 7.9 0 0 0 6 12c0 4.4 3.5 8 7.8 8 2 0 3.8-.8 5.2-2",
      key: "1j6lzo"
    }
  ]
]);
const Bu = r("ExpandIcon", [
  ["path", { d: "m21 21-6-6m6 6v-4.8m0 4.8h-4.8", key: "1c15vz" }],
  ["path", { d: "M3 16.2V21m0 0h4.8M3 21l6-6", key: "1fsnz2" }],
  ["path", { d: "M21 7.8V3m0 0h-4.8M21 3l-6 6", key: "hawz9i" }],
  ["path", { d: "M3 7.8V3m0 0h4.8M3 3l6 6", key: "u9ee12" }]
]);
const zu = r("ExternalLinkIcon", [
  ["path", { d: "M15 3h6v6", key: "1q9fwt" }],
  ["path", { d: "M10 14 21 3", key: "gplh6r" }],
  ["path", { d: "M18 13v6a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2V8a2 2 0 0 1 2-2h6", key: "a6xqqp" }]
]);
const Hu = r("EyeOffIcon", [
  ["path", { d: "M9.88 9.88a3 3 0 1 0 4.24 4.24", key: "1jxqfv" }],
  [
    "path",
    {
      d: "M10.73 5.08A10.43 10.43 0 0 1 12 5c7 0 10 7 10 7a13.16 13.16 0 0 1-1.67 2.68",
      key: "9wicm4"
    }
  ],
  [
    "path",
    { d: "M6.61 6.61A13.526 13.526 0 0 0 2 12s3 7 10 7a9.74 9.74 0 0 0 5.39-1.61", key: "1jreej" }
  ],
  ["line", { x1: "2", x2: "22", y1: "2", y2: "22", key: "a6p6uj" }]
]);
const ju = r("EyeIcon", [
  ["path", { d: "M2 12s3-7 10-7 10 7 10 7-3 7-10 7-10-7-10-7Z", key: "rwhkz3" }],
  ["circle", { cx: "12", cy: "12", r: "3", key: "1v7zrd" }]
]);
const Vu = r("FacebookIcon", [
  [
    "path",
    { d: "M18 2h-3a5 5 0 0 0-5 5v3H7v4h3v8h4v-8h3l1-4h-4V7a1 1 0 0 1 1-1h3z", key: "1jg4f8" }
  ]
]);
const Ou = r("FactoryIcon", [
  [
    "path",
    {
      d: "M2 20a2 2 0 0 0 2 2h16a2 2 0 0 0 2-2V8l-7 5V8l-7 5V4a2 2 0 0 0-2-2H4a2 2 0 0 0-2 2Z",
      key: "159hny"
    }
  ],
  ["path", { d: "M17 18h1", key: "uldtlt" }],
  ["path", { d: "M12 18h1", key: "s9uhes" }],
  ["path", { d: "M7 18h1", key: "1neino" }]
]);
const $u = r("FanIcon", [
  [
    "path",
    {
      d: "M10.827 16.379a6.082 6.082 0 0 1-8.618-7.002l5.412 1.45a6.082 6.082 0 0 1 7.002-8.618l-1.45 5.412a6.082 6.082 0 0 1 8.618 7.002l-5.412-1.45a6.082 6.082 0 0 1-7.002 8.618l1.45-5.412Z",
      key: "484a7f"
    }
  ],
  ["path", { d: "M12 12v.01", key: "u5ubse" }]
]);
const Ru = r("FastForwardIcon", [
  ["polygon", { points: "13 19 22 12 13 5 13 19", key: "587y9g" }],
  ["polygon", { points: "2 19 11 12 2 5 2 19", key: "3pweh0" }]
]);
const Fu = r("FeatherIcon", [
  ["path", { d: "M20.24 12.24a6 6 0 0 0-8.49-8.49L5 10.5V19h8.5z", key: "u4sw5n" }],
  ["line", { x1: "16", x2: "2", y1: "8", y2: "22", key: "1c47m2" }],
  ["line", { x1: "17.5", x2: "9", y1: "15", y2: "15", key: "2fj3pr" }]
]);
const Uu = r("FenceIcon", [
  ["path", { d: "M4 3 2 5v15c0 .6.4 1 1 1h2c.6 0 1-.4 1-1V5Z", key: "1n2rgs" }],
  ["path", { d: "M6 8h4", key: "utf9t1" }],
  ["path", { d: "M6 18h4", key: "12yh4b" }],
  ["path", { d: "m12 3-2 2v15c0 .6.4 1 1 1h2c.6 0 1-.4 1-1V5Z", key: "3ha7mj" }],
  ["path", { d: "M14 8h4", key: "1r8wg2" }],
  ["path", { d: "M14 18h4", key: "1t3kbu" }],
  ["path", { d: "m20 3-2 2v15c0 .6.4 1 1 1h2c.6 0 1-.4 1-1V5Z", key: "dfd4e2" }]
]);
const Eu = r("FerrisWheelIcon", [
  ["circle", { cx: "12", cy: "12", r: "2", key: "1c9p78" }],
  ["path", { d: "M12 2v4", key: "3427ic" }],
  ["path", { d: "m6.8 15-3.5 2", key: "hjy98k" }],
  ["path", { d: "m20.7 7-3.5 2", key: "f08gto" }],
  ["path", { d: "M6.8 9 3.3 7", key: "1aevh4" }],
  ["path", { d: "m20.7 17-3.5-2", key: "1liqo3" }],
  ["path", { d: "m9 22 3-8 3 8", key: "wees03" }],
  ["path", { d: "M8 22h8", key: "rmew8v" }],
  ["path", { d: "M18 18.7a9 9 0 1 0-12 0", key: "dhzg4g" }]
]);
const Wu = r("FigmaIcon", [
  ["path", { d: "M5 5.5A3.5 3.5 0 0 1 8.5 2H12v7H8.5A3.5 3.5 0 0 1 5 5.5z", key: "1340ok" }],
  ["path", { d: "M12 2h3.5a3.5 3.5 0 1 1 0 7H12V2z", key: "1hz3m3" }],
  ["path", { d: "M12 12.5a3.5 3.5 0 1 1 7 0 3.5 3.5 0 1 1-7 0z", key: "1oz8n2" }],
  ["path", { d: "M5 19.5A3.5 3.5 0 0 1 8.5 16H12v3.5a3.5 3.5 0 1 1-7 0z", key: "1ff65i" }],
  ["path", { d: "M5 12.5A3.5 3.5 0 0 1 8.5 9H12v7H8.5A3.5 3.5 0 0 1 5 12.5z", key: "pdip6e" }]
]);
const Nu = r("FileArchiveIcon", [
  ["path", { d: "M16 22h2a2 2 0 0 0 2-2V7l-5-5H6a2 2 0 0 0-2 2v18", key: "1oywqq" }],
  ["path", { d: "M14 2v4a2 2 0 0 0 2 2h4", key: "tnqrlb" }],
  ["circle", { cx: "10", cy: "20", r: "2", key: "1xzdoj" }],
  ["path", { d: "M10 7V6", key: "dljcrl" }],
  ["path", { d: "M10 12v-1", key: "v7bkov" }],
  ["path", { d: "M10 18v-2", key: "1cjy8d" }]
]);
const Zu = r("FileAudio2Icon", [
  ["path", { d: "M4 22h14a2 2 0 0 0 2-2V7l-5-5H6a2 2 0 0 0-2 2v2", key: "17k7jt" }],
  ["path", { d: "M14 2v4a2 2 0 0 0 2 2h4", key: "tnqrlb" }],
  ["circle", { cx: "3", cy: "17", r: "1", key: "vo6nti" }],
  ["path", { d: "M2 17v-3a4 4 0 0 1 8 0v3", key: "1ggdre" }],
  ["circle", { cx: "9", cy: "17", r: "1", key: "bc1fq4" }]
]);
const Yu = r("FileAudioIcon", [
  ["path", { d: "M17.5 22h.5a2 2 0 0 0 2-2V7l-5-5H6a2 2 0 0 0-2 2v3", key: "rslqgf" }],
  ["path", { d: "M14 2v4a2 2 0 0 0 2 2h4", key: "tnqrlb" }],
  [
    "path",
    {
      d: "M2 19a2 2 0 1 1 4 0v1a2 2 0 1 1-4 0v-4a6 6 0 0 1 12 0v4a2 2 0 1 1-4 0v-1a2 2 0 1 1 4 0",
      key: "9f7x3i"
    }
  ]
]);
const kn = r("FileAxis3dIcon", [
  ["path", { d: "M15 2H6a2 2 0 0 0-2 2v16a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V7Z", key: "1rqfz7" }],
  ["path", { d: "M14 2v4a2 2 0 0 0 2 2h4", key: "tnqrlb" }],
  ["path", { d: "m8 18 4-4", key: "12zab0" }],
  ["path", { d: "M8 10v8h8", key: "tlaukw" }]
]);
const Gu = r("FileBadge2Icon", [
  ["path", { d: "M15 2H6a2 2 0 0 0-2 2v16a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V7Z", key: "1rqfz7" }],
  ["circle", { cx: "12", cy: "10", r: "3", key: "ilqhr7" }],
  ["path", { d: "M14 2v4a2 2 0 0 0 2 2h4", key: "tnqrlb" }],
  ["path", { d: "m14 12.5 1 5.5-3-1-3 1 1-5.5", key: "14xlky" }]
]);
const Xu = r("FileBadgeIcon", [
  ["path", { d: "M12 22h6a2 2 0 0 0 2-2V7l-5-5H6a2 2 0 0 0-2 2v3", key: "12ixgl" }],
  ["path", { d: "M14 2v4a2 2 0 0 0 2 2h4", key: "tnqrlb" }],
  ["path", { d: "M5 17a3 3 0 1 0 0-6 3 3 0 0 0 0 6Z", key: "u0c8gj" }],
  ["path", { d: "M7 16.5 8 22l-3-1-3 1 1-5.5", key: "5gm2nr" }]
]);
const Ku = r("FileBarChart2Icon", [
  ["path", { d: "M15 2H6a2 2 0 0 0-2 2v16a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V7Z", key: "1rqfz7" }],
  ["path", { d: "M14 2v4a2 2 0 0 0 2 2h4", key: "tnqrlb" }],
  ["path", { d: "M8 18v-1", key: "zg0ygc" }],
  ["path", { d: "M12 18v-6", key: "17g6i2" }],
  ["path", { d: "M16 18v-3", key: "j5jt4h" }]
]);
const Qu = r("FileBarChartIcon", [
  ["path", { d: "M15 2H6a2 2 0 0 0-2 2v16a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V7Z", key: "1rqfz7" }],
  ["path", { d: "M14 2v4a2 2 0 0 0 2 2h4", key: "tnqrlb" }],
  ["path", { d: "M8 18v-2", key: "qcmpov" }],
  ["path", { d: "M12 18v-4", key: "q1q25u" }],
  ["path", { d: "M16 18v-6", key: "15y0np" }]
]);
const Ju = r("FileBoxIcon", [
  ["path", { d: "M14.5 22H18a2 2 0 0 0 2-2V7l-5-5H6a2 2 0 0 0-2 2v4", key: "16lz6z" }],
  ["path", { d: "M14 2v4a2 2 0 0 0 2 2h4", key: "tnqrlb" }],
  [
    "path",
    {
      d: "M3 13.1a2 2 0 0 0-1 1.76v3.24a2 2 0 0 0 .97 1.78L6 21.7a2 2 0 0 0 2.03.01L11 19.9a2 2 0 0 0 1-1.76V14.9a2 2 0 0 0-.97-1.78L8 11.3a2 2 0 0 0-2.03-.01Z",
      key: "99pj1s"
    }
  ],
  ["path", { d: "M7 17v5", key: "1yj1jh" }],
  ["path", { d: "M11.7 14.2 7 17l-4.7-2.8", key: "1yk8tc" }]
]);
const eh = r("FileCheck2Icon", [
  ["path", { d: "M4 22h14a2 2 0 0 0 2-2V7l-5-5H6a2 2 0 0 0-2 2v4", key: "1pf5j1" }],
  ["path", { d: "M14 2v4a2 2 0 0 0 2 2h4", key: "tnqrlb" }],
  ["path", { d: "m3 15 2 2 4-4", key: "1lhrkk" }]
]);
const th = r("FileCheckIcon", [
  ["path", { d: "M15 2H6a2 2 0 0 0-2 2v16a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V7Z", key: "1rqfz7" }],
  ["path", { d: "M14 2v4a2 2 0 0 0 2 2h4", key: "tnqrlb" }],
  ["path", { d: "m9 15 2 2 4-4", key: "1grp1n" }]
]);
const ah = r("FileClockIcon", [
  ["path", { d: "M16 22h2a2 2 0 0 0 2-2V7l-5-5H6a2 2 0 0 0-2 2v3", key: "37hlfg" }],
  ["path", { d: "M14 2v4a2 2 0 0 0 2 2h4", key: "tnqrlb" }],
  ["circle", { cx: "8", cy: "16", r: "6", key: "10v15b" }],
  ["path", { d: "M9.5 17.5 8 16.25V14", key: "1o80t2" }]
]);
const nh = r("FileCode2Icon", [
  ["path", { d: "M4 22h14a2 2 0 0 0 2-2V7l-5-5H6a2 2 0 0 0-2 2v4", key: "1pf5j1" }],
  ["path", { d: "M14 2v4a2 2 0 0 0 2 2h4", key: "tnqrlb" }],
  ["path", { d: "m5 12-3 3 3 3", key: "oke12k" }],
  ["path", { d: "m9 18 3-3-3-3", key: "112psh" }]
]);
const oh = r("FileCodeIcon", [
  ["path", { d: "M15 2H6a2 2 0 0 0-2 2v16a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V7Z", key: "1rqfz7" }],
  ["path", { d: "M14 2v4a2 2 0 0 0 2 2h4", key: "tnqrlb" }],
  ["path", { d: "m10 13-2 2 2 2", key: "17smn8" }],
  ["path", { d: "m14 17 2-2-2-2", key: "14mezr" }]
]);
const fn = r("FileCogIcon", [
  ["path", { d: "M4 22h14a2 2 0 0 0 2-2V7l-5-5H6a2 2 0 0 0-2 2v2", key: "17k7jt" }],
  ["path", { d: "M14 2v4a2 2 0 0 0 2 2h4", key: "tnqrlb" }],
  ["circle", { cx: "6", cy: "14", r: "3", key: "a1xfv6" }],
  ["path", { d: "M6 10v1", key: "xs0f9j" }],
  ["path", { d: "M6 17v1", key: "idyhc0" }],
  ["path", { d: "M10 14H9", key: "m5fm2q" }],
  ["path", { d: "M3 14H2", key: "19ot09" }],
  ["path", { d: "m9 11-.88.88", key: "lhul2b" }],
  ["path", { d: "M3.88 16.12 3 17", key: "169z9n" }],
  ["path", { d: "m9 17-.88-.88", key: "5io96w" }],
  ["path", { d: "M3.88 11.88 3 11", key: "1ynhy1" }]
]);
const rh = r("FileDiffIcon", [
  ["path", { d: "M15 2H6a2 2 0 0 0-2 2v16a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V7Z", key: "1rqfz7" }],
  ["path", { d: "M9 10h6", key: "9gxzsh" }],
  ["path", { d: "M12 13V7", key: "h0r20n" }],
  ["path", { d: "M9 17h6", key: "r8uit2" }]
]);
const ih = r("FileDigitIcon", [
  ["path", { d: "M4 22h14a2 2 0 0 0 2-2V7l-5-5H6a2 2 0 0 0-2 2v4", key: "1pf5j1" }],
  ["path", { d: "M14 2v4a2 2 0 0 0 2 2h4", key: "tnqrlb" }],
  ["rect", { width: "4", height: "6", x: "2", y: "12", rx: "2", key: "jm304g" }],
  ["path", { d: "M10 12h2v6", key: "12zw74" }],
  ["path", { d: "M10 18h4", key: "1ulq68" }]
]);
const lh = r("FileDownIcon", [
  ["path", { d: "M15 2H6a2 2 0 0 0-2 2v16a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V7Z", key: "1rqfz7" }],
  ["path", { d: "M14 2v4a2 2 0 0 0 2 2h4", key: "tnqrlb" }],
  ["path", { d: "M12 18v-6", key: "17g6i2" }],
  ["path", { d: "m9 15 3 3 3-3", key: "1npd3o" }]
]);
const ch = r("FileHeartIcon", [
  ["path", { d: "M4 22h14a2 2 0 0 0 2-2V7l-5-5H6a2 2 0 0 0-2 2v2", key: "17k7jt" }],
  ["path", { d: "M14 2v4a2 2 0 0 0 2 2h4", key: "tnqrlb" }],
  [
    "path",
    {
      d: "M10.29 10.7a2.43 2.43 0 0 0-2.66-.52c-.29.12-.56.3-.78.53l-.35.34-.35-.34a2.43 2.43 0 0 0-2.65-.53c-.3.12-.56.3-.79.53-.95.94-1 2.53.2 3.74L6.5 18l3.6-3.55c1.2-1.21 1.14-2.8.19-3.74Z",
      key: "1c1fso"
    }
  ]
]);
const dh = r("FileImageIcon", [
  ["path", { d: "M15 2H6a2 2 0 0 0-2 2v16a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V7Z", key: "1rqfz7" }],
  ["path", { d: "M14 2v4a2 2 0 0 0 2 2h4", key: "tnqrlb" }],
  ["circle", { cx: "10", cy: "12", r: "2", key: "737tya" }],
  ["path", { d: "m20 17-1.296-1.296a2.41 2.41 0 0 0-3.408 0L9 22", key: "wt3hpn" }]
]);
const sh = r("FileInputIcon", [
  ["path", { d: "M4 22h14a2 2 0 0 0 2-2V7l-5-5H6a2 2 0 0 0-2 2v4", key: "1pf5j1" }],
  ["path", { d: "M14 2v4a2 2 0 0 0 2 2h4", key: "tnqrlb" }],
  ["path", { d: "M2 15h10", key: "jfw4w8" }],
  ["path", { d: "m9 18 3-3-3-3", key: "112psh" }]
]);
const uh = r("FileJson2Icon", [
  ["path", { d: "M4 22h14a2 2 0 0 0 2-2V7l-5-5H6a2 2 0 0 0-2 2v4", key: "1pf5j1" }],
  ["path", { d: "M14 2v4a2 2 0 0 0 2 2h4", key: "tnqrlb" }],
  [
    "path",
    { d: "M4 12a1 1 0 0 0-1 1v1a1 1 0 0 1-1 1 1 1 0 0 1 1 1v1a1 1 0 0 0 1 1", key: "fq0c9t" }
  ],
  [
    "path",
    { d: "M8 18a1 1 0 0 0 1-1v-1a1 1 0 0 1 1-1 1 1 0 0 1-1-1v-1a1 1 0 0 0-1-1", key: "4gibmv" }
  ]
]);
const hh = r("FileJsonIcon", [
  ["path", { d: "M15 2H6a2 2 0 0 0-2 2v16a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V7Z", key: "1rqfz7" }],
  ["path", { d: "M14 2v4a2 2 0 0 0 2 2h4", key: "tnqrlb" }],
  [
    "path",
    { d: "M10 12a1 1 0 0 0-1 1v1a1 1 0 0 1-1 1 1 1 0 0 1 1 1v1a1 1 0 0 0 1 1", key: "1oajmo" }
  ],
  [
    "path",
    { d: "M14 18a1 1 0 0 0 1-1v-1a1 1 0 0 1 1-1 1 1 0 0 1-1-1v-1a1 1 0 0 0-1-1", key: "mpwhp6" }
  ]
]);
const ph = r("FileKey2Icon", [
  ["path", { d: "M4 22h14a2 2 0 0 0 2-2V7l-5-5H6a2 2 0 0 0-2 2v6", key: "rc0qvx" }],
  ["path", { d: "M14 2v4a2 2 0 0 0 2 2h4", key: "tnqrlb" }],
  ["circle", { cx: "4", cy: "16", r: "2", key: "1ehqvc" }],
  ["path", { d: "m10 10-4.5 4.5", key: "7fwrp6" }],
  ["path", { d: "m9 11 1 1", key: "wa6s5q" }]
]);
const yh = r("FileKeyIcon", [
  ["path", { d: "M15 2H6a2 2 0 0 0-2 2v16a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V7Z", key: "1rqfz7" }],
  ["circle", { cx: "10", cy: "16", r: "2", key: "4ckbqe" }],
  ["path", { d: "m16 10-4.5 4.5", key: "7p3ebg" }],
  ["path", { d: "m15 11 1 1", key: "1bsyx3" }]
]);
const kh = r("FileLineChartIcon", [
  ["path", { d: "M15 2H6a2 2 0 0 0-2 2v16a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V7Z", key: "1rqfz7" }],
  ["path", { d: "M14 2v4a2 2 0 0 0 2 2h4", key: "tnqrlb" }],
  ["path", { d: "m16 13-3.5 3.5-2-2L8 17", key: "zz7yod" }]
]);
const fh = r("FileLock2Icon", [
  ["path", { d: "M4 22h14a2 2 0 0 0 2-2V7l-5-5H6a2 2 0 0 0-2 2v1", key: "jmtmu2" }],
  ["path", { d: "M14 2v4a2 2 0 0 0 2 2h4", key: "tnqrlb" }],
  ["rect", { width: "8", height: "5", x: "2", y: "13", rx: "1", key: "10y5wo" }],
  ["path", { d: "M8 13v-2a2 2 0 1 0-4 0v2", key: "1pdxzg" }]
]);
const vh = r("FileLockIcon", [
  ["path", { d: "M15 2H6a2 2 0 0 0-2 2v16a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V7Z", key: "1rqfz7" }],
  ["rect", { width: "8", height: "6", x: "8", y: "12", rx: "1", key: "3yr8at" }],
  ["path", { d: "M10 12v-2a2 2 0 1 1 4 0v2", key: "j4i8d" }]
]);
const mh = r("FileMinus2Icon", [
  ["path", { d: "M4 22h14a2 2 0 0 0 2-2V7l-5-5H6a2 2 0 0 0-2 2v4", key: "1pf5j1" }],
  ["path", { d: "M14 2v4a2 2 0 0 0 2 2h4", key: "tnqrlb" }],
  ["path", { d: "M3 15h6", key: "4e2qda" }]
]);
const gh = r("FileMinusIcon", [
  ["path", { d: "M15 2H6a2 2 0 0 0-2 2v16a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V7Z", key: "1rqfz7" }],
  ["path", { d: "M14 2v4a2 2 0 0 0 2 2h4", key: "tnqrlb" }],
  ["path", { d: "M9 15h6", key: "cctwl0" }]
]);
const Mh = r("FileMusicIcon", [
  ["circle", { cx: "14", cy: "16", r: "2", key: "1bzzi3" }],
  ["circle", { cx: "6", cy: "18", r: "2", key: "1fncim" }],
  ["path", { d: "M4 12.4V4a2 2 0 0 1 2-2h8.5L20 7.5V20a2 2 0 0 1-2 2h-7.5", key: "skc018" }],
  ["path", { d: "M8 18v-7.7L16 9v7", key: "1oie6o" }]
]);
const xh = r("FileOutputIcon", [
  ["path", { d: "M14 2v4a2 2 0 0 0 2 2h4", key: "tnqrlb" }],
  ["path", { d: "M4 7V4a2 2 0 0 1 2-2 2 2 0 0 0-2 2", key: "1vk7w2" }],
  ["path", { d: "M4.063 20.999a2 2 0 0 0 2 1L18 22a2 2 0 0 0 2-2V7l-5-5H6", key: "1jink5" }],
  ["path", { d: "m5 11-3 3", key: "1dgrs4" }],
  ["path", { d: "m5 17-3-3h10", key: "1mvvaf" }]
]);
const vn = r("FilePenLineIcon", [
  ["path", { d: "m18 5-3-3H6a2 2 0 0 0-2 2v16a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2", key: "h0fsxq" }],
  ["path", { d: "M8 18h1", key: "13wk12" }],
  ["path", { d: "M18.4 9.6a2 2 0 1 1 3 3L17 17l-4 1 1-4Z", key: "dyo8mm" }]
]);
const mn = r("FilePenIcon", [
  ["path", { d: "M12 22h6a2 2 0 0 0 2-2V7l-5-5H6a2 2 0 0 0-2 2v10", key: "x7tsz2" }],
  ["path", { d: "M14 2v4a2 2 0 0 0 2 2h4", key: "tnqrlb" }],
  ["path", { d: "M10.4 12.6a2 2 0 1 1 3 3L8 21l-4 1 1-4Z", key: "o3xyfb" }]
]);
const bh = r("FilePieChartIcon", [
  ["path", { d: "M14 2v4a2 2 0 0 0 2 2h4", key: "tnqrlb" }],
  ["path", { d: "M16 22h2a2 2 0 0 0 2-2V7l-5-5H6a2 2 0 0 0-2 2v3.5", key: "13ddob" }],
  ["path", { d: "M4.017 11.512a6 6 0 1 0 8.466 8.475", key: "s6vs5t" }],
  ["path", { d: "M8 16v-6a6 6 0 0 1 6 6z", key: "zfixgv" }]
]);
const wh = r("FilePlus2Icon", [
  ["path", { d: "M4 22h14a2 2 0 0 0 2-2V7l-5-5H6a2 2 0 0 0-2 2v4", key: "1pf5j1" }],
  ["path", { d: "M14 2v4a2 2 0 0 0 2 2h4", key: "tnqrlb" }],
  ["path", { d: "M3 15h6", key: "4e2qda" }],
  ["path", { d: "M6 12v6", key: "1u72j0" }]
]);
const Ih = r("FilePlusIcon", [
  ["path", { d: "M15 2H6a2 2 0 0 0-2 2v16a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V7Z", key: "1rqfz7" }],
  ["path", { d: "M14 2v4a2 2 0 0 0 2 2h4", key: "tnqrlb" }],
  ["path", { d: "M9 15h6", key: "cctwl0" }],
  ["path", { d: "M12 18v-6", key: "17g6i2" }]
]);
const Lh = r("FileQuestionIcon", [
  ["path", { d: "M12 17h.01", key: "p32p05" }],
  ["path", { d: "M15 2H6a2 2 0 0 0-2 2v16a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V7z", key: "1mlx9k" }],
  ["path", { d: "M9.1 9a3 3 0 0 1 5.82 1c0 2-3 3-3 3", key: "mhlwft" }]
]);
const Sh = r("FileScanIcon", [
  ["path", { d: "M20 10V7l-5-5H6a2 2 0 0 0-2 2v16a2 2 0 0 0 2 2h4", key: "1rdf37" }],
  ["path", { d: "M14 2v4a2 2 0 0 0 2 2h4", key: "tnqrlb" }],
  ["path", { d: "M16 14a2 2 0 0 0-2 2", key: "ceaadl" }],
  ["path", { d: "M20 14a2 2 0 0 1 2 2", key: "1ny6zw" }],
  ["path", { d: "M20 22a2 2 0 0 0 2-2", key: "1l9q4k" }],
  ["path", { d: "M16 22a2 2 0 0 1-2-2", key: "1wqh5n" }]
]);
const Ch = r("FileSearch2Icon", [
  ["path", { d: "M15 2H6a2 2 0 0 0-2 2v16a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V7Z", key: "1rqfz7" }],
  ["path", { d: "M14 2v4a2 2 0 0 0 2 2h4", key: "tnqrlb" }],
  ["circle", { cx: "11.5", cy: "14.5", r: "2.5", key: "1bq0ko" }],
  ["path", { d: "M13.3 16.3 15 18", key: "2quom7" }]
]);
const Ah = r("FileSearchIcon", [
  ["path", { d: "M14 2v4a2 2 0 0 0 2 2h4", key: "tnqrlb" }],
  [
    "path",
    { d: "M4.268 21a2 2 0 0 0 1.727 1H18a2 2 0 0 0 2-2V7l-5-5H6a2 2 0 0 0-2 2v3", key: "ms7g94" }
  ],
  ["path", { d: "m9 18-1.5-1.5", key: "1j6qii" }],
  ["circle", { cx: "5", cy: "14", r: "3", key: "ufru5t" }]
]);
const Ph = r("FileSlidersIcon", [
  ["path", { d: "M15 2H6a2 2 0 0 0-2 2v16a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V7Z", key: "1rqfz7" }],
  ["path", { d: "M14 2v4a2 2 0 0 0 2 2h4", key: "tnqrlb" }],
  ["path", { d: "M8 12h8", key: "1wcyev" }],
  ["path", { d: "M10 11v2", key: "1s651w" }],
  ["path", { d: "M8 17h8", key: "wh5c61" }],
  ["path", { d: "M14 16v2", key: "12fp5e" }]
]);
const qh = r("FileSpreadsheetIcon", [
  ["path", { d: "M15 2H6a2 2 0 0 0-2 2v16a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V7Z", key: "1rqfz7" }],
  ["path", { d: "M14 2v4a2 2 0 0 0 2 2h4", key: "tnqrlb" }],
  ["path", { d: "M8 13h2", key: "yr2amv" }],
  ["path", { d: "M14 13h2", key: "un5t4a" }],
  ["path", { d: "M8 17h2", key: "2yhykz" }],
  ["path", { d: "M14 17h2", key: "10kma7" }]
]);
const Th = r("FileStackIcon", [
  ["path", { d: "M21 7h-3a2 2 0 0 1-2-2V2", key: "9rb54x" }],
  [
    "path",
    {
      d: "M21 6v6.5c0 .8-.7 1.5-1.5 1.5h-7c-.8 0-1.5-.7-1.5-1.5v-9c0-.8.7-1.5 1.5-1.5H17Z",
      key: "1059l0"
    }
  ],
  ["path", { d: "M7 8v8.8c0 .3.2.6.4.8.2.2.5.4.8.4H15", key: "16874u" }],
  ["path", { d: "M3 12v8.8c0 .3.2.6.4.8.2.2.5.4.8.4H11", key: "k2ox98" }]
]);
const Dh = r("FileSymlinkIcon", [
  ["path", { d: "m10 18 3-3-3-3", key: "18f6ys" }],
  ["path", { d: "M14 2v4a2 2 0 0 0 2 2h4", key: "tnqrlb" }],
  [
    "path",
    {
      d: "M4 11V4a2 2 0 0 1 2-2h9l5 5v13a2 2 0 0 1-2 2H6a2 2 0 0 1-2-2v-3a2 2 0 0 1 2-2h7",
      key: "50q2rw"
    }
  ]
]);
const _h = r("FileTerminalIcon", [
  ["path", { d: "M15 2H6a2 2 0 0 0-2 2v16a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V7Z", key: "1rqfz7" }],
  ["path", { d: "M14 2v4a2 2 0 0 0 2 2h4", key: "tnqrlb" }],
  ["path", { d: "m8 16 2-2-2-2", key: "10vzyd" }],
  ["path", { d: "M12 18h4", key: "1wd2n7" }]
]);
const Bh = r("FileTextIcon", [
  ["path", { d: "M15 2H6a2 2 0 0 0-2 2v16a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V7Z", key: "1rqfz7" }],
  ["path", { d: "M14 2v4a2 2 0 0 0 2 2h4", key: "tnqrlb" }],
  ["path", { d: "M10 9H8", key: "b1mrlr" }],
  ["path", { d: "M16 13H8", key: "t4e002" }],
  ["path", { d: "M16 17H8", key: "z1uh3a" }]
]);
const zh = r("FileType2Icon", [
  ["path", { d: "M4 22h14a2 2 0 0 0 2-2V7l-5-5H6a2 2 0 0 0-2 2v4", key: "1pf5j1" }],
  ["path", { d: "M14 2v4a2 2 0 0 0 2 2h4", key: "tnqrlb" }],
  ["path", { d: "M2 13v-1h6v1", key: "1dh9dg" }],
  ["path", { d: "M5 12v6", key: "150t9c" }],
  ["path", { d: "M4 18h2", key: "1xrofg" }]
]);
const Hh = r("FileTypeIcon", [
  ["path", { d: "M15 2H6a2 2 0 0 0-2 2v16a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V7Z", key: "1rqfz7" }],
  ["path", { d: "M14 2v4a2 2 0 0 0 2 2h4", key: "tnqrlb" }],
  ["path", { d: "M9 13v-1h6v1", key: "1bb014" }],
  ["path", { d: "M12 12v6", key: "3ahymv" }],
  ["path", { d: "M11 18h2", key: "12mj7e" }]
]);
const jh = r("FileUpIcon", [
  ["path", { d: "M15 2H6a2 2 0 0 0-2 2v16a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V7Z", key: "1rqfz7" }],
  ["path", { d: "M14 2v4a2 2 0 0 0 2 2h4", key: "tnqrlb" }],
  ["path", { d: "M12 12v6", key: "3ahymv" }],
  ["path", { d: "m15 15-3-3-3 3", key: "15xj92" }]
]);
const Vh = r("FileVideo2Icon", [
  ["path", { d: "M4 22h14a2 2 0 0 0 2-2V7l-5-5H6a2 2 0 0 0-2 2v4", key: "1pf5j1" }],
  ["path", { d: "M14 2v4a2 2 0 0 0 2 2h4", key: "tnqrlb" }],
  ["rect", { width: "8", height: "6", x: "2", y: "12", rx: "1", key: "1a6c1e" }],
  ["path", { d: "m10 15.5 4 2.5v-6l-4 2.5", key: "t7cp39" }]
]);
const Oh = r("FileVideoIcon", [
  ["path", { d: "M15 2H6a2 2 0 0 0-2 2v16a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V7Z", key: "1rqfz7" }],
  ["path", { d: "M14 2v4a2 2 0 0 0 2 2h4", key: "tnqrlb" }],
  ["path", { d: "m10 11 5 3-5 3v-6Z", key: "7ntvm4" }]
]);
const $h = r("FileVolume2Icon", [
  ["path", { d: "M15 2H6a2 2 0 0 0-2 2v16a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V7Z", key: "1rqfz7" }],
  ["path", { d: "M14 2v4a2 2 0 0 0 2 2h4", key: "tnqrlb" }],
  ["path", { d: "M8 15h.01", key: "a7atzg" }],
  ["path", { d: "M11.5 13.5a2.5 2.5 0 0 1 0 3", key: "1fccat" }],
  ["path", { d: "M15 12a5 5 0 0 1 0 6", key: "ps46cm" }]
]);
const Rh = r("FileVolumeIcon", [
  ["path", { d: "M11 11a5 5 0 0 1 0 6", key: "193qb2" }],
  ["path", { d: "M14 2v4a2 2 0 0 0 2 2h4", key: "tnqrlb" }],
  [
    "path",
    { d: "M4.268 21A2 2 0 0 0 6 22h12a2 2 0 0 0 2-2V7l-5-5H6a2 2 0 0 0-2 2v3", key: "1x9xgf" }
  ],
  ["path", { d: "m7 10-3 2H2v4h2l3 2z", key: "1ln807" }]
]);
const Fh = r("FileWarningIcon", [
  ["path", { d: "M15 2H6a2 2 0 0 0-2 2v16a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V7Z", key: "1rqfz7" }],
  ["path", { d: "M12 9v4", key: "juzpu7" }],
  ["path", { d: "M12 17h.01", key: "p32p05" }]
]);
const Uh = r("FileX2Icon", [
  ["path", { d: "M4 22h14a2 2 0 0 0 2-2V7l-5-5H6a2 2 0 0 0-2 2v4", key: "1pf5j1" }],
  ["path", { d: "M14 2v4a2 2 0 0 0 2 2h4", key: "tnqrlb" }],
  ["path", { d: "m8 12.5-5 5", key: "b853mi" }],
  ["path", { d: "m3 12.5 5 5", key: "1qls4r" }]
]);
const Eh = r("FileXIcon", [
  ["path", { d: "M15 2H6a2 2 0 0 0-2 2v16a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V7Z", key: "1rqfz7" }],
  ["path", { d: "M14 2v4a2 2 0 0 0 2 2h4", key: "tnqrlb" }],
  ["path", { d: "m14.5 12.5-5 5", key: "b62r18" }],
  ["path", { d: "m9.5 12.5 5 5", key: "1rk7el" }]
]);
const Wh = r("FileIcon", [
  ["path", { d: "M15 2H6a2 2 0 0 0-2 2v16a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V7Z", key: "1rqfz7" }],
  ["path", { d: "M14 2v4a2 2 0 0 0 2 2h4", key: "tnqrlb" }]
]);
const Nh = r("FilesIcon", [
  ["path", { d: "M20 7h-3a2 2 0 0 1-2-2V2", key: "x099mo" }],
  ["path", { d: "M9 18a2 2 0 0 1-2-2V4a2 2 0 0 1 2-2h7l4 4v10a2 2 0 0 1-2 2Z", key: "18t6ie" }],
  ["path", { d: "M3 7.6v12.8A1.6 1.6 0 0 0 4.6 22h9.8", key: "1nja0z" }]
]);
const Zh = r("FilmIcon", [
  ["rect", { width: "18", height: "18", x: "3", y: "3", rx: "2", key: "afitv7" }],
  ["path", { d: "M7 3v18", key: "bbkbws" }],
  ["path", { d: "M3 7.5h4", key: "zfgn84" }],
  ["path", { d: "M3 12h18", key: "1i2n21" }],
  ["path", { d: "M3 16.5h4", key: "1230mu" }],
  ["path", { d: "M17 3v18", key: "in4fa5" }],
  ["path", { d: "M17 7.5h4", key: "myr1c1" }],
  ["path", { d: "M17 16.5h4", key: "go4c1d" }]
]);
const Yh = r("FilterXIcon", [
  ["path", { d: "M13.013 3H2l8 9.46V19l4 2v-8.54l.9-1.055", key: "1fi1da" }],
  ["path", { d: "m22 3-5 5", key: "12jva0" }],
  ["path", { d: "m17 3 5 5", key: "k36vhe" }]
]);
const Gh = r("FilterIcon", [
  ["polygon", { points: "22 3 2 3 10 12.46 10 19 14 21 14 12.46 22 3", key: "1yg77f" }]
]);
const Xh = r("FingerprintIcon", [
  ["path", { d: "M12 10a2 2 0 0 0-2 2c0 1.02-.1 2.51-.26 4", key: "1nerag" }],
  ["path", { d: "M14 13.12c0 2.38 0 6.38-1 8.88", key: "o46ks0" }],
  ["path", { d: "M17.29 21.02c.12-.6.43-2.3.5-3.02", key: "ptglia" }],
  ["path", { d: "M2 12a10 10 0 0 1 18-6", key: "ydlgp0" }],
  ["path", { d: "M2 16h.01", key: "1gqxmh" }],
  ["path", { d: "M21.8 16c.2-2 .131-5.354 0-6", key: "drycrb" }],
  ["path", { d: "M5 19.5C5.5 18 6 15 6 12a6 6 0 0 1 .34-2", key: "1tidbn" }],
  ["path", { d: "M8.65 22c.21-.66.45-1.32.57-2", key: "13wd9y" }],
  ["path", { d: "M9 6.8a6 6 0 0 1 9 5.2v2", key: "1fr1j5" }]
]);
const Kh = r("FireExtinguisherIcon", [
  ["path", { d: "M15 6.5V3a1 1 0 0 0-1-1h-2a1 1 0 0 0-1 1v3.5", key: "sqyvz" }],
  ["path", { d: "M9 18h8", key: "i7pszb" }],
  ["path", { d: "M18 3h-3", key: "7idoqj" }],
  ["path", { d: "M11 3a6 6 0 0 0-6 6v11", key: "1v5je3" }],
  ["path", { d: "M5 13h4", key: "svpcxo" }],
  ["path", { d: "M17 10a4 4 0 0 0-8 0v10a2 2 0 0 0 2 2h4a2 2 0 0 0 2-2Z", key: "vsjego" }]
]);
const Qh = r("FishOffIcon", [
  [
    "path",
    {
      d: "M18 12.47v.03m0-.5v.47m-.475 5.056A6.744 6.744 0 0 1 15 18c-3.56 0-7.56-2.53-8.5-6 .348-1.28 1.114-2.433 2.121-3.38m3.444-2.088A8.802 8.802 0 0 1 15 6c3.56 0 6.06 2.54 7 6-.309 1.14-.786 2.177-1.413 3.058",
      key: "1j1hse"
    }
  ],
  [
    "path",
    {
      d: "M7 10.67C7 8 5.58 5.97 2.73 5.5c-1 1.5-1 5 .23 6.5-1.24 1.5-1.24 5-.23 6.5C5.58 18.03 7 16 7 13.33m7.48-4.372A9.77 9.77 0 0 1 16 6.07m0 11.86a9.77 9.77 0 0 1-1.728-3.618",
      key: "1q46z8"
    }
  ],
  [
    "path",
    {
      d: "m16.01 17.93-.23 1.4A2 2 0 0 1 13.8 21H9.5a5.96 5.96 0 0 0 1.49-3.98M8.53 3h5.27a2 2 0 0 1 1.98 1.67l.23 1.4M2 2l20 20",
      key: "1407gh"
    }
  ]
]);
const Jh = r("FishSymbolIcon", [
  ["path", { d: "M2 16s9-15 20-4C11 23 2 8 2 8", key: "h4oh4o" }]
]);
const ep = r("FishIcon", [
  [
    "path",
    {
      d: "M6.5 12c.94-3.46 4.94-6 8.5-6 3.56 0 6.06 2.54 7 6-.94 3.47-3.44 6-7 6s-7.56-2.53-8.5-6Z",
      key: "15baut"
    }
  ],
  ["path", { d: "M18 12v.5", key: "18hhni" }],
  ["path", { d: "M16 17.93a9.77 9.77 0 0 1 0-11.86", key: "16dt7o" }],
  [
    "path",
    {
      d: "M7 10.67C7 8 5.58 5.97 2.73 5.5c-1 1.5-1 5 .23 6.5-1.24 1.5-1.24 5-.23 6.5C5.58 18.03 7 16 7 13.33",
      key: "l9di03"
    }
  ],
  [
    "path",
    { d: "M10.46 7.26C10.2 5.88 9.17 4.24 8 3h5.8a2 2 0 0 1 1.98 1.67l.23 1.4", key: "1kjonw" }
  ],
  [
    "path",
    { d: "m16.01 17.93-.23 1.4A2 2 0 0 1 13.8 21H9.5a5.96 5.96 0 0 0 1.49-3.98", key: "1zlm23" }
  ]
]);
const tp = r("FlagOffIcon", [
  ["path", { d: "M8 2c3 0 5 2 8 2s4-1 4-1v11", key: "9rwyz9" }],
  ["path", { d: "M4 22V4", key: "1plyxx" }],
  ["path", { d: "M4 15s1-1 4-1 5 2 8 2", key: "1myooe" }],
  ["line", { x1: "2", x2: "22", y1: "2", y2: "22", key: "a6p6uj" }]
]);
const ap = r("FlagTriangleLeftIcon", [
  ["path", { d: "M17 22V2L7 7l10 5", key: "1rmf0r" }]
]);
const np = r("FlagTriangleRightIcon", [
  ["path", { d: "M7 22V2l10 5-10 5", key: "17n18y" }]
]);
const op = r("FlagIcon", [
  ["path", { d: "M4 15s1-1 4-1 5 2 8 2 4-1 4-1V3s-1 1-4 1-5-2-8-2-4 1-4 1z", key: "i9b6wo" }],
  ["line", { x1: "4", x2: "4", y1: "22", y2: "15", key: "1cm3nv" }]
]);
const rp = r("FlameKindlingIcon", [
  [
    "path",
    {
      d: "M12 2c1 3 2.5 3.5 3.5 4.5A5 5 0 0 1 17 10a5 5 0 1 1-10 0c0-.3 0-.6.1-.9a2 2 0 1 0 3.3-2C8 4.5 11 2 12 2Z",
      key: "1ir223"
    }
  ],
  ["path", { d: "m5 22 14-4", key: "1brv4h" }],
  ["path", { d: "m5 18 14 4", key: "lgyyje" }]
]);
const ip = r("FlameIcon", [
  [
    "path",
    {
      d: "M8.5 14.5A2.5 2.5 0 0 0 11 12c0-1.38-.5-2-1-3-1.072-2.143-.224-4.054 2-6 .5 2.5 2 4.9 4 6.5 2 1.6 3 3.5 3 5.5a7 7 0 1 1-14 0c0-1.153.433-2.294 1-3a2.5 2.5 0 0 0 2.5 2.5z",
      key: "96xj49"
    }
  ]
]);
const lp = r("FlashlightOffIcon", [
  ["path", { d: "M16 16v4a2 2 0 0 1-2 2h-4a2 2 0 0 1-2-2V10c0-2-2-2-2-4", key: "1r120k" }],
  ["path", { d: "M7 2h11v4c0 2-2 2-2 4v1", key: "dz1920" }],
  ["line", { x1: "11", x2: "18", y1: "6", y2: "6", key: "bi1vpe" }],
  ["line", { x1: "2", x2: "22", y1: "2", y2: "22", key: "a6p6uj" }]
]);
const cp = r("FlashlightIcon", [
  [
    "path",
    {
      d: "M18 6c0 2-2 2-2 4v10a2 2 0 0 1-2 2h-4a2 2 0 0 1-2-2V10c0-2-2-2-2-4V2h12z",
      key: "1orkel"
    }
  ],
  ["line", { x1: "6", x2: "18", y1: "6", y2: "6", key: "1z11jq" }],
  ["line", { x1: "12", x2: "12", y1: "12", y2: "12", key: "1f4yc1" }]
]);
const dp = r("FlaskConicalOffIcon", [
  [
    "path",
    {
      d: "M10 10 4.72 20.55a1 1 0 0 0 .9 1.45h12.76a1 1 0 0 0 .9-1.45l-1.272-2.542",
      key: "59ek9y"
    }
  ],
  ["path", { d: "M10 2v2.343", key: "15t272" }],
  ["path", { d: "M14 2v6.343", key: "sxr80q" }],
  ["path", { d: "M8.5 2h7", key: "csnxdl" }],
  ["path", { d: "M7 16h9", key: "t5njau" }],
  ["line", { x1: "2", x2: "22", y1: "2", y2: "22", key: "a6p6uj" }]
]);
const sp = r("FlaskConicalIcon", [
  [
    "path",
    {
      d: "M10 2v7.527a2 2 0 0 1-.211.896L4.72 20.55a1 1 0 0 0 .9 1.45h12.76a1 1 0 0 0 .9-1.45l-5.069-10.127A2 2 0 0 1 14 9.527V2",
      key: "pzvekw"
    }
  ],
  ["path", { d: "M8.5 2h7", key: "csnxdl" }],
  ["path", { d: "M7 16h10", key: "wp8him" }]
]);
const up = r("FlaskRoundIcon", [
  ["path", { d: "M10 2v7.31", key: "5d1hyh" }],
  ["path", { d: "M14 9.3V1.99", key: "14k4l0" }],
  ["path", { d: "M8.5 2h7", key: "csnxdl" }],
  ["path", { d: "M14 9.3a6.5 6.5 0 1 1-4 0", key: "1r8fvy" }],
  ["path", { d: "M5.52 16h12.96", key: "46hh1i" }]
]);
const hp = r("FlipHorizontal2Icon", [
  ["path", { d: "m3 7 5 5-5 5V7", key: "couhi7" }],
  ["path", { d: "m21 7-5 5 5 5V7", key: "6ouia7" }],
  ["path", { d: "M12 20v2", key: "1lh1kg" }],
  ["path", { d: "M12 14v2", key: "8jcxud" }],
  ["path", { d: "M12 8v2", key: "1woqiv" }],
  ["path", { d: "M12 2v2", key: "tus03m" }]
]);
const pp = r("FlipHorizontalIcon", [
  ["path", { d: "M8 3H5a2 2 0 0 0-2 2v14c0 1.1.9 2 2 2h3", key: "1i73f7" }],
  ["path", { d: "M16 3h3a2 2 0 0 1 2 2v14a2 2 0 0 1-2 2h-3", key: "saxlbk" }],
  ["path", { d: "M12 20v2", key: "1lh1kg" }],
  ["path", { d: "M12 14v2", key: "8jcxud" }],
  ["path", { d: "M12 8v2", key: "1woqiv" }],
  ["path", { d: "M12 2v2", key: "tus03m" }]
]);
const yp = r("FlipVertical2Icon", [
  ["path", { d: "m17 3-5 5-5-5h10", key: "1ftt6x" }],
  ["path", { d: "m17 21-5-5-5 5h10", key: "1m0wmu" }],
  ["path", { d: "M4 12H2", key: "rhcxmi" }],
  ["path", { d: "M10 12H8", key: "s88cx1" }],
  ["path", { d: "M16 12h-2", key: "10asgb" }],
  ["path", { d: "M22 12h-2", key: "14jgyd" }]
]);
const kp = r("FlipVerticalIcon", [
  ["path", { d: "M21 8V5a2 2 0 0 0-2-2H5a2 2 0 0 0-2 2v3", key: "14bfxa" }],
  ["path", { d: "M21 16v3a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2v-3", key: "14rx03" }],
  ["path", { d: "M4 12H2", key: "rhcxmi" }],
  ["path", { d: "M10 12H8", key: "s88cx1" }],
  ["path", { d: "M16 12h-2", key: "10asgb" }],
  ["path", { d: "M22 12h-2", key: "14jgyd" }]
]);
const fp = r("Flower2Icon", [
  [
    "path",
    {
      d: "M12 5a3 3 0 1 1 3 3m-3-3a3 3 0 1 0-3 3m3-3v1M9 8a3 3 0 1 0 3 3M9 8h1m5 0a3 3 0 1 1-3 3m3-3h-1m-2 3v-1",
      key: "3pnvol"
    }
  ],
  ["circle", { cx: "12", cy: "8", r: "2", key: "1822b1" }],
  ["path", { d: "M12 10v12", key: "6ubwww" }],
  ["path", { d: "M12 22c4.2 0 7-1.667 7-5-4.2 0-7 1.667-7 5Z", key: "9hd38g" }],
  ["path", { d: "M12 22c-4.2 0-7-1.667-7-5 4.2 0 7 1.667 7 5Z", key: "ufn41s" }]
]);
const vp = r("FlowerIcon", [
  ["circle", { cx: "12", cy: "12", r: "3", key: "1v7zrd" }],
  [
    "path",
    {
      d: "M12 16.5A4.5 4.5 0 1 1 7.5 12 4.5 4.5 0 1 1 12 7.5a4.5 4.5 0 1 1 4.5 4.5 4.5 4.5 0 1 1-4.5 4.5",
      key: "14wa3c"
    }
  ],
  ["path", { d: "M12 7.5V9", key: "1oy5b0" }],
  ["path", { d: "M7.5 12H9", key: "eltsq1" }],
  ["path", { d: "M16.5 12H15", key: "vk5kw4" }],
  ["path", { d: "M12 16.5V15", key: "k7eayi" }],
  ["path", { d: "m8 8 1.88 1.88", key: "nxy4qf" }],
  ["path", { d: "M14.12 9.88 16 8", key: "1lst6k" }],
  ["path", { d: "m8 16 1.88-1.88", key: "h2eex1" }],
  ["path", { d: "M14.12 14.12 16 16", key: "uqkrx3" }]
]);
const mp = r("FocusIcon", [
  ["circle", { cx: "12", cy: "12", r: "3", key: "1v7zrd" }],
  ["path", { d: "M3 7V5a2 2 0 0 1 2-2h2", key: "aa7l1z" }],
  ["path", { d: "M17 3h2a2 2 0 0 1 2 2v2", key: "4qcy5o" }],
  ["path", { d: "M21 17v2a2 2 0 0 1-2 2h-2", key: "6vwrx8" }],
  ["path", { d: "M7 21H5a2 2 0 0 1-2-2v-2", key: "ioqczr" }]
]);
const gp = r("FoldHorizontalIcon", [
  ["path", { d: "M2 12h6", key: "1wqiqv" }],
  ["path", { d: "M22 12h-6", key: "1eg9hc" }],
  ["path", { d: "M12 2v2", key: "tus03m" }],
  ["path", { d: "M12 8v2", key: "1woqiv" }],
  ["path", { d: "M12 14v2", key: "8jcxud" }],
  ["path", { d: "M12 20v2", key: "1lh1kg" }],
  ["path", { d: "m19 9-3 3 3 3", key: "12ol22" }],
  ["path", { d: "m5 15 3-3-3-3", key: "1kdhjc" }]
]);
const Mp = r("FoldVerticalIcon", [
  ["path", { d: "M12 22v-6", key: "6o8u61" }],
  ["path", { d: "M12 8V2", key: "1wkif3" }],
  ["path", { d: "M4 12H2", key: "rhcxmi" }],
  ["path", { d: "M10 12H8", key: "s88cx1" }],
  ["path", { d: "M16 12h-2", key: "10asgb" }],
  ["path", { d: "M22 12h-2", key: "14jgyd" }],
  ["path", { d: "m15 19-3-3-3 3", key: "e37ymu" }],
  ["path", { d: "m15 5-3 3-3-3", key: "19d6lf" }]
]);
const xp = r("FolderArchiveIcon", [
  ["circle", { cx: "15", cy: "19", r: "2", key: "u2pros" }],
  [
    "path",
    {
      d: "M20.9 19.8A2 2 0 0 0 22 18V8a2 2 0 0 0-2-2h-7.9a2 2 0 0 1-1.69-.9L9.6 3.9A2 2 0 0 0 7.93 3H4a2 2 0 0 0-2 2v13a2 2 0 0 0 2 2h5.1",
      key: "1jj40k"
    }
  ],
  ["path", { d: "M15 11v-1", key: "cntcp" }],
  ["path", { d: "M15 17v-2", key: "1279jj" }]
]);
const bp = r("FolderCheckIcon", [
  [
    "path",
    {
      d: "M20 20a2 2 0 0 0 2-2V8a2 2 0 0 0-2-2h-7.9a2 2 0 0 1-1.69-.9L9.6 3.9A2 2 0 0 0 7.93 3H4a2 2 0 0 0-2 2v13a2 2 0 0 0 2 2Z",
      key: "1kt360"
    }
  ],
  ["path", { d: "m9 13 2 2 4-4", key: "6343dt" }]
]);
const wp = r("FolderClockIcon", [
  ["circle", { cx: "16", cy: "16", r: "6", key: "qoo3c4" }],
  [
    "path",
    {
      d: "M7 20H4a2 2 0 0 1-2-2V5a2 2 0 0 1 2-2h3.9a2 2 0 0 1 1.69.9l.81 1.2a2 2 0 0 0 1.67.9H20a2 2 0 0 1 2 2",
      key: "1urifu"
    }
  ],
  ["path", { d: "M16 14v2l1 1", key: "xth2jh" }]
]);
const Ip = r("FolderClosedIcon", [
  [
    "path",
    {
      d: "M20 20a2 2 0 0 0 2-2V8a2 2 0 0 0-2-2h-7.9a2 2 0 0 1-1.69-.9L9.6 3.9A2 2 0 0 0 7.93 3H4a2 2 0 0 0-2 2v13a2 2 0 0 0 2 2Z",
      key: "1kt360"
    }
  ],
  ["path", { d: "M2 10h20", key: "1ir3d8" }]
]);
const gn = r("FolderCogIcon", [
  ["circle", { cx: "18", cy: "18", r: "3", key: "1xkwt0" }],
  [
    "path",
    {
      d: "M10.3 20H4a2 2 0 0 1-2-2V5a2 2 0 0 1 2-2h3.9a2 2 0 0 1 1.69.9l.81 1.2a2 2 0 0 0 1.67.9H20a2 2 0 0 1 2 2v3.3",
      key: "1k8050"
    }
  ],
  ["path", { d: "m21.7 19.4-.9-.3", key: "1qgwi9" }],
  ["path", { d: "m15.2 16.9-.9-.3", key: "1t7mvx" }],
  ["path", { d: "m16.6 21.7.3-.9", key: "1j67ps" }],
  ["path", { d: "m19.1 15.2.3-.9", key: "18r7jp" }],
  ["path", { d: "m19.6 21.7-.4-1", key: "z2vh2" }],
  ["path", { d: "m16.8 15.3-.4-1", key: "1ei7r6" }],
  ["path", { d: "m14.3 19.6 1-.4", key: "11sv9r" }],
  ["path", { d: "m20.7 16.8 1-.4", key: "19m87a" }]
]);
const Lp = r("FolderDotIcon", [
  [
    "path",
    {
      d: "M4 20h16a2 2 0 0 0 2-2V8a2 2 0 0 0-2-2h-7.93a2 2 0 0 1-1.66-.9l-.82-1.2A2 2 0 0 0 7.93 3H4a2 2 0 0 0-2 2v13c0 1.1.9 2 2 2Z",
      key: "1fr9dc"
    }
  ],
  ["circle", { cx: "12", cy: "13", r: "1", key: "49l61u" }]
]);
const Sp = r("FolderDownIcon", [
  [
    "path",
    {
      d: "M20 20a2 2 0 0 0 2-2V8a2 2 0 0 0-2-2h-7.9a2 2 0 0 1-1.69-.9L9.6 3.9A2 2 0 0 0 7.93 3H4a2 2 0 0 0-2 2v13a2 2 0 0 0 2 2Z",
      key: "1kt360"
    }
  ],
  ["path", { d: "M12 10v6", key: "1bos4e" }],
  ["path", { d: "m15 13-3 3-3-3", key: "6j2sf0" }]
]);
const Cp = r("FolderGit2Icon", [
  [
    "path",
    {
      d: "M9 20H4a2 2 0 0 1-2-2V5a2 2 0 0 1 2-2h3.9a2 2 0 0 1 1.69.9l.81 1.2a2 2 0 0 0 1.67.9H20a2 2 0 0 1 2 2v5",
      key: "1w6njk"
    }
  ],
  ["circle", { cx: "13", cy: "12", r: "2", key: "1j92g6" }],
  ["path", { d: "M18 19c-2.8 0-5-2.2-5-5v8", key: "pkpw2h" }],
  ["circle", { cx: "20", cy: "19", r: "2", key: "1obnsp" }]
]);
const Ap = r("FolderGitIcon", [
  ["circle", { cx: "12", cy: "13", r: "2", key: "1c1ljs" }],
  [
    "path",
    {
      d: "M20 20a2 2 0 0 0 2-2V8a2 2 0 0 0-2-2h-7.9a2 2 0 0 1-1.69-.9L9.6 3.9A2 2 0 0 0 7.93 3H4a2 2 0 0 0-2 2v13a2 2 0 0 0 2 2Z",
      key: "1kt360"
    }
  ],
  ["path", { d: "M14 13h3", key: "1dgedf" }],
  ["path", { d: "M7 13h3", key: "1pygq7" }]
]);
const Pp = r("FolderHeartIcon", [
  [
    "path",
    {
      d: "M11 20H4a2 2 0 0 1-2-2V5a2 2 0 0 1 2-2h3.9a2 2 0 0 1 1.69.9l.81 1.2a2 2 0 0 0 1.67.9H20a2 2 0 0 1 2 2v1.5",
      key: "6hud8k"
    }
  ],
  [
    "path",
    {
      d: "M13.9 17.45c-1.2-1.2-1.14-2.8-.2-3.73a2.43 2.43 0 0 1 3.44 0l.36.34.34-.34a2.43 2.43 0 0 1 3.45-.01v0c.95.95 1 2.53-.2 3.74L17.5 21Z",
      key: "vgq86i"
    }
  ]
]);
const qp = r("FolderInputIcon", [
  [
    "path",
    {
      d: "M2 9V5a2 2 0 0 1 2-2h3.9a2 2 0 0 1 1.69.9l.81 1.2a2 2 0 0 0 1.67.9H20a2 2 0 0 1 2 2v10a2 2 0 0 1-2 2H4a2 2 0 0 1-2-2v-1",
      key: "fm4g5t"
    }
  ],
  ["path", { d: "M2 13h10", key: "pgb2dq" }],
  ["path", { d: "m9 16 3-3-3-3", key: "6m91ic" }]
]);
const Tp = r("FolderKanbanIcon", [
  [
    "path",
    {
      d: "M4 20h16a2 2 0 0 0 2-2V8a2 2 0 0 0-2-2h-7.93a2 2 0 0 1-1.66-.9l-.82-1.2A2 2 0 0 0 7.93 3H4a2 2 0 0 0-2 2v13c0 1.1.9 2 2 2Z",
      key: "1fr9dc"
    }
  ],
  ["path", { d: "M8 10v4", key: "tgpxqk" }],
  ["path", { d: "M12 10v2", key: "hh53o1" }],
  ["path", { d: "M16 10v6", key: "1d6xys" }]
]);
const Dp = r("FolderKeyIcon", [
  ["circle", { cx: "16", cy: "20", r: "2", key: "1vifvg" }],
  [
    "path",
    {
      d: "M10 20H4a2 2 0 0 1-2-2V5a2 2 0 0 1 2-2h3.9a2 2 0 0 1 1.69.9l.81 1.2a2 2 0 0 0 1.67.9H20a2 2 0 0 1 2 2v2",
      key: "3hgo9p"
    }
  ],
  ["path", { d: "m22 14-4.5 4.5", key: "1ef6z8" }],
  ["path", { d: "m21 15 1 1", key: "1ejcpy" }]
]);
const _p = r("FolderLockIcon", [
  ["rect", { width: "8", height: "5", x: "14", y: "17", rx: "1", key: "19aais" }],
  [
    "path",
    {
      d: "M10 20H4a2 2 0 0 1-2-2V5a2 2 0 0 1 2-2h3.9a2 2 0 0 1 1.69.9l.81 1.2a2 2 0 0 0 1.67.9H20a2 2 0 0 1 2 2v2.5",
      key: "1w6v7t"
    }
  ],
  ["path", { d: "M20 17v-2a2 2 0 1 0-4 0v2", key: "pwaxnr" }]
]);
const Bp = r("FolderMinusIcon", [
  ["path", { d: "M9 13h6", key: "1uhe8q" }],
  [
    "path",
    {
      d: "M20 20a2 2 0 0 0 2-2V8a2 2 0 0 0-2-2h-7.9a2 2 0 0 1-1.69-.9L9.6 3.9A2 2 0 0 0 7.93 3H4a2 2 0 0 0-2 2v13a2 2 0 0 0 2 2Z",
      key: "1kt360"
    }
  ]
]);
const zp = r("FolderOpenDotIcon", [
  [
    "path",
    {
      d: "m6 14 1.45-2.9A2 2 0 0 1 9.24 10H20a2 2 0 0 1 1.94 2.5l-1.55 6a2 2 0 0 1-1.94 1.5H4a2 2 0 0 1-2-2V5c0-1.1.9-2 2-2h3.93a2 2 0 0 1 1.66.9l.82 1.2a2 2 0 0 0 1.66.9H18a2 2 0 0 1 2 2v2",
      key: "1nmvlm"
    }
  ],
  ["circle", { cx: "14", cy: "15", r: "1", key: "1gm4qj" }]
]);
const Hp = r("FolderOpenIcon", [
  [
    "path",
    {
      d: "m6 14 1.5-2.9A2 2 0 0 1 9.24 10H20a2 2 0 0 1 1.94 2.5l-1.54 6a2 2 0 0 1-1.95 1.5H4a2 2 0 0 1-2-2V5a2 2 0 0 1 2-2h3.9a2 2 0 0 1 1.69.9l.81 1.2a2 2 0 0 0 1.67.9H18a2 2 0 0 1 2 2v2",
      key: "usdka0"
    }
  ]
]);
const jp = r("FolderOutputIcon", [
  [
    "path",
    {
      d: "M2 7.5V5a2 2 0 0 1 2-2h3.9a2 2 0 0 1 1.69.9l.81 1.2a2 2 0 0 0 1.67.9H20a2 2 0 0 1 2 2v10a2 2 0 0 1-2 2H4a2 2 0 0 1-2-1.5",
      key: "1yk7aj"
    }
  ],
  ["path", { d: "M2 13h10", key: "pgb2dq" }],
  ["path", { d: "m5 10-3 3 3 3", key: "1r8ie0" }]
]);
const Mn = r("FolderPenIcon", [
  ["path", { d: "M8.4 10.6a2 2 0 0 1 3 3L6 19l-4 1 1-4Z", key: "dakro8" }],
  [
    "path",
    {
      d: "M2 11.5V5a2 2 0 0 1 2-2h3.9c.7 0 1.3.3 1.7.9l.8 1.2c.4.6 1 .9 1.7.9H20a2 2 0 0 1 2 2v10a2 2 0 0 1-2 2h-9.5",
      key: "a8xqs0"
    }
  ]
]);
const Vp = r("FolderPlusIcon", [
  ["path", { d: "M12 10v6", key: "1bos4e" }],
  ["path", { d: "M9 13h6", key: "1uhe8q" }],
  [
    "path",
    {
      d: "M20 20a2 2 0 0 0 2-2V8a2 2 0 0 0-2-2h-7.9a2 2 0 0 1-1.69-.9L9.6 3.9A2 2 0 0 0 7.93 3H4a2 2 0 0 0-2 2v13a2 2 0 0 0 2 2Z",
      key: "1kt360"
    }
  ]
]);
const Op = r("FolderRootIcon", [
  [
    "path",
    {
      d: "M4 20h16a2 2 0 0 0 2-2V8a2 2 0 0 0-2-2h-7.93a2 2 0 0 1-1.66-.9l-.82-1.2A2 2 0 0 0 7.93 3H4a2 2 0 0 0-2 2v13c0 1.1.9 2 2 2Z",
      key: "1fr9dc"
    }
  ],
  ["circle", { cx: "12", cy: "13", r: "2", key: "1c1ljs" }],
  ["path", { d: "M12 15v5", key: "11xva1" }]
]);
const $p = r("FolderSearch2Icon", [
  ["circle", { cx: "11.5", cy: "12.5", r: "2.5", key: "1ea5ju" }],
  [
    "path",
    {
      d: "M20 20a2 2 0 0 0 2-2V8a2 2 0 0 0-2-2h-7.9a2 2 0 0 1-1.69-.9L9.6 3.9A2 2 0 0 0 7.93 3H4a2 2 0 0 0-2 2v13a2 2 0 0 0 2 2Z",
      key: "1kt360"
    }
  ],
  ["path", { d: "M13.3 14.3 15 16", key: "1y4v1n" }]
]);
const Rp = r("FolderSearchIcon", [
  ["circle", { cx: "17", cy: "17", r: "3", key: "18b49y" }],
  [
    "path",
    {
      d: "M10.7 20H4a2 2 0 0 1-2-2V5a2 2 0 0 1 2-2h3.9a2 2 0 0 1 1.69.9l.81 1.2a2 2 0 0 0 1.67.9H20a2 2 0 0 1 2 2v4.1",
      key: "1bw5m7"
    }
  ],
  ["path", { d: "m21 21-1.5-1.5", key: "3sg1j" }]
]);
const Fp = r("FolderSymlinkIcon", [
  [
    "path",
    {
      d: "M2 9V5a2 2 0 0 1 2-2h3.9a2 2 0 0 1 1.69.9l.81 1.2a2 2 0 0 0 1.67.9H20a2 2 0 0 1 2 2v10a2 2 0 0 1-2 2H4a2 2 0 0 1-2-2v-3a2 2 0 0 1 2-2h7",
      key: "x1c07l"
    }
  ],
  ["path", { d: "m8 16 3-3-3-3", key: "rlqrt1" }]
]);
const Up = r("FolderSyncIcon", [
  [
    "path",
    {
      d: "M9 20H4a2 2 0 0 1-2-2V5a2 2 0 0 1 2-2h3.9a2 2 0 0 1 1.69.9l.81 1.2a2 2 0 0 0 1.67.9H20a2 2 0 0 1 2 2v.5",
      key: "1dkoa9"
    }
  ],
  ["path", { d: "M12 10v4h4", key: "1czhmt" }],
  ["path", { d: "m12 14 1.535-1.605a5 5 0 0 1 8 1.5", key: "lvuxfi" }],
  ["path", { d: "M22 22v-4h-4", key: "1ewp4q" }],
  ["path", { d: "m22 18-1.535 1.605a5 5 0 0 1-8-1.5", key: "14ync0" }]
]);
const Ep = r("FolderTreeIcon", [
  [
    "path",
    {
      d: "M20 10a1 1 0 0 0 1-1V6a1 1 0 0 0-1-1h-2.5a1 1 0 0 1-.8-.4l-.9-1.2A1 1 0 0 0 15 3h-2a1 1 0 0 0-1 1v5a1 1 0 0 0 1 1Z",
      key: "hod4my"
    }
  ],
  [
    "path",
    {
      d: "M20 21a1 1 0 0 0 1-1v-3a1 1 0 0 0-1-1h-2.9a1 1 0 0 1-.88-.55l-.42-.85a1 1 0 0 0-.92-.6H13a1 1 0 0 0-1 1v5a1 1 0 0 0 1 1Z",
      key: "w4yl2u"
    }
  ],
  ["path", { d: "M3 5a2 2 0 0 0 2 2h3", key: "f2jnh7" }],
  ["path", { d: "M3 3v13a2 2 0 0 0 2 2h3", key: "k8epm1" }]
]);
const Wp = r("FolderUpIcon", [
  [
    "path",
    {
      d: "M20 20a2 2 0 0 0 2-2V8a2 2 0 0 0-2-2h-7.9a2 2 0 0 1-1.69-.9L9.6 3.9A2 2 0 0 0 7.93 3H4a2 2 0 0 0-2 2v13a2 2 0 0 0 2 2Z",
      key: "1kt360"
    }
  ],
  ["path", { d: "M12 10v6", key: "1bos4e" }],
  ["path", { d: "m9 13 3-3 3 3", key: "1pxg3c" }]
]);
const Np = r("FolderXIcon", [
  [
    "path",
    {
      d: "M20 20a2 2 0 0 0 2-2V8a2 2 0 0 0-2-2h-7.9a2 2 0 0 1-1.69-.9L9.6 3.9A2 2 0 0 0 7.93 3H4a2 2 0 0 0-2 2v13a2 2 0 0 0 2 2Z",
      key: "1kt360"
    }
  ],
  ["path", { d: "m9.5 10.5 5 5", key: "ra9qjz" }],
  ["path", { d: "m14.5 10.5-5 5", key: "l2rkpq" }]
]);
const Zp = r("FolderIcon", [
  [
    "path",
    {
      d: "M20 20a2 2 0 0 0 2-2V8a2 2 0 0 0-2-2h-7.9a2 2 0 0 1-1.69-.9L9.6 3.9A2 2 0 0 0 7.93 3H4a2 2 0 0 0-2 2v13a2 2 0 0 0 2 2Z",
      key: "1kt360"
    }
  ]
]);
const Yp = r("FoldersIcon", [
  [
    "path",
    {
      d: "M20 17a2 2 0 0 0 2-2V9a2 2 0 0 0-2-2h-3.9a2 2 0 0 1-1.69-.9l-.81-1.2a2 2 0 0 0-1.67-.9H8a2 2 0 0 0-2 2v9a2 2 0 0 0 2 2Z",
      key: "4u7rpt"
    }
  ],
  ["path", { d: "M2 8v11a2 2 0 0 0 2 2h14", key: "1eicx1" }]
]);
const Gp = r("FootprintsIcon", [
  [
    "path",
    {
      d: "M4 16v-2.38C4 11.5 2.97 10.5 3 8c.03-2.72 1.49-6 4.5-6C9.37 2 10 3.8 10 5.5c0 3.11-2 5.66-2 8.68V16a2 2 0 1 1-4 0Z",
      key: "1dudjm"
    }
  ],
  [
    "path",
    {
      d: "M20 20v-2.38c0-2.12 1.03-3.12 1-5.62-.03-2.72-1.49-6-4.5-6C14.63 6 14 7.8 14 9.5c0 3.11 2 5.66 2 8.68V20a2 2 0 1 0 4 0Z",
      key: "l2t8xc"
    }
  ],
  ["path", { d: "M16 17h4", key: "1dejxt" }],
  ["path", { d: "M4 13h4", key: "1bwh8b" }]
]);
const Xp = r("ForkliftIcon", [
  ["path", { d: "M12 12H5a2 2 0 0 0-2 2v5", key: "7zsz91" }],
  ["circle", { cx: "13", cy: "19", r: "2", key: "wjnkru" }],
  ["circle", { cx: "5", cy: "19", r: "2", key: "v8kfzx" }],
  ["path", { d: "M8 19h3m5-17v17h6M6 12V7c0-1.1.9-2 2-2h3l5 5", key: "13bk1p" }]
]);
const Kp = r("ForwardIcon", [
  ["polyline", { points: "15 17 20 12 15 7", key: "1w3sku" }],
  ["path", { d: "M4 18v-2a4 4 0 0 1 4-4h12", key: "jmiej9" }]
]);
const Qp = r("FrameIcon", [
  ["line", { x1: "22", x2: "2", y1: "6", y2: "6", key: "15w7dq" }],
  ["line", { x1: "22", x2: "2", y1: "18", y2: "18", key: "1ip48p" }],
  ["line", { x1: "6", x2: "6", y1: "2", y2: "22", key: "a2lnyx" }],
  ["line", { x1: "18", x2: "18", y1: "2", y2: "22", key: "8vb6jd" }]
]);
const Jp = r("FramerIcon", [
  ["path", { d: "M5 16V9h14V2H5l14 14h-7m-7 0 7 7v-7m-7 0h7", key: "1a2nng" }]
]);
const ey = r("FrownIcon", [
  ["circle", { cx: "12", cy: "12", r: "10", key: "1mglay" }],
  ["path", { d: "M16 16s-1.5-2-4-2-4 2-4 2", key: "epbg0q" }],
  ["line", { x1: "9", x2: "9.01", y1: "9", y2: "9", key: "yxxnd0" }],
  ["line", { x1: "15", x2: "15.01", y1: "9", y2: "9", key: "1p4y9e" }]
]);
const ty = r("FuelIcon", [
  ["line", { x1: "3", x2: "15", y1: "22", y2: "22", key: "xegly4" }],
  ["line", { x1: "4", x2: "14", y1: "9", y2: "9", key: "xcnuvu" }],
  ["path", { d: "M14 22V4a2 2 0 0 0-2-2H6a2 2 0 0 0-2 2v18", key: "16j0yd" }],
  [
    "path",
    {
      d: "M14 13h2a2 2 0 0 1 2 2v2a2 2 0 0 0 2 2h0a2 2 0 0 0 2-2V9.83a2 2 0 0 0-.59-1.42L18 5",
      key: "8ur5zv"
    }
  ]
]);
const ay = r("FullscreenIcon", [
  ["path", { d: "M3 7V5a2 2 0 0 1 2-2h2", key: "aa7l1z" }],
  ["path", { d: "M17 3h2a2 2 0 0 1 2 2v2", key: "4qcy5o" }],
  ["path", { d: "M21 17v2a2 2 0 0 1-2 2h-2", key: "6vwrx8" }],
  ["path", { d: "M7 21H5a2 2 0 0 1-2-2v-2", key: "ioqczr" }],
  ["rect", { width: "10", height: "8", x: "7", y: "8", rx: "1", key: "vys8me" }]
]);
const ny = r("GalleryHorizontalEndIcon", [
  ["path", { d: "M2 7v10", key: "a2pl2d" }],
  ["path", { d: "M6 5v14", key: "1kq3d7" }],
  ["rect", { width: "12", height: "18", x: "10", y: "3", rx: "2", key: "13i7bc" }]
]);
const oy = r("GalleryHorizontalIcon", [
  ["path", { d: "M2 3v18", key: "pzttux" }],
  ["rect", { width: "12", height: "18", x: "6", y: "3", rx: "2", key: "btr8bg" }],
  ["path", { d: "M22 3v18", key: "6jf3v" }]
]);
const ry = r("GalleryThumbnailsIcon", [
  ["rect", { width: "18", height: "14", x: "3", y: "3", rx: "2", key: "74y24f" }],
  ["path", { d: "M4 21h1", key: "16zlid" }],
  ["path", { d: "M9 21h1", key: "15o7lz" }],
  ["path", { d: "M14 21h1", key: "v9vybs" }],
  ["path", { d: "M19 21h1", key: "edywat" }]
]);
const iy = r("GalleryVerticalEndIcon", [
  ["path", { d: "M7 2h10", key: "nczekb" }],
  ["path", { d: "M5 6h14", key: "u2x4p" }],
  ["rect", { width: "18", height: "12", x: "3", y: "10", rx: "2", key: "l0tzu3" }]
]);
const ly = r("GalleryVerticalIcon", [
  ["path", { d: "M3 2h18", key: "15qxfx" }],
  ["rect", { width: "18", height: "12", x: "3", y: "6", rx: "2", key: "1439r6" }],
  ["path", { d: "M3 22h18", key: "8prr45" }]
]);
const cy = r("Gamepad2Icon", [
  ["line", { x1: "6", x2: "10", y1: "11", y2: "11", key: "1gktln" }],
  ["line", { x1: "8", x2: "8", y1: "9", y2: "13", key: "qnk9ow" }],
  ["line", { x1: "15", x2: "15.01", y1: "12", y2: "12", key: "krot7o" }],
  ["line", { x1: "18", x2: "18.01", y1: "10", y2: "10", key: "1lcuu1" }],
  [
    "path",
    {
      d: "M17.32 5H6.68a4 4 0 0 0-3.978 3.59c-.006.052-.01.101-.017.152C2.604 9.416 2 14.456 2 16a3 3 0 0 0 3 3c1 0 1.5-.5 2-1l1.414-1.414A2 2 0 0 1 9.828 16h4.344a2 2 0 0 1 1.414.586L17 18c.5.5 1 1 2 1a3 3 0 0 0 3-3c0-1.545-.604-6.584-.685-7.258-.007-.05-.011-.1-.017-.151A4 4 0 0 0 17.32 5z",
      key: "mfqc10"
    }
  ]
]);
const dy = r("GamepadIcon", [
  ["line", { x1: "6", x2: "10", y1: "12", y2: "12", key: "161bw2" }],
  ["line", { x1: "8", x2: "8", y1: "10", y2: "14", key: "1i6ji0" }],
  ["line", { x1: "15", x2: "15.01", y1: "13", y2: "13", key: "dqpgro" }],
  ["line", { x1: "18", x2: "18.01", y1: "11", y2: "11", key: "meh2c" }],
  ["rect", { width: "20", height: "12", x: "2", y: "6", rx: "2", key: "9lu3g6" }]
]);
const sy = r("GanttChartIcon", [
  ["path", { d: "M8 6h10", key: "9lnwnk" }],
  ["path", { d: "M6 12h9", key: "1g9pqf" }],
  ["path", { d: "M11 18h7", key: "c8dzvl" }]
]);
const uy = r("GaugeIcon", [
  ["path", { d: "m12 14 4-4", key: "9kzdfg" }],
  ["path", { d: "M3.34 19a10 10 0 1 1 17.32 0", key: "19p75a" }]
]);
const hy = r("GavelIcon", [
  ["path", { d: "m14.5 12.5-8 8a2.119 2.119 0 1 1-3-3l8-8", key: "15492f" }],
  ["path", { d: "m16 16 6-6", key: "vzrcl6" }],
  ["path", { d: "m8 8 6-6", key: "18bi4p" }],
  ["path", { d: "m9 7 8 8", key: "5jnvq1" }],
  ["path", { d: "m21 11-8-8", key: "z4y7zo" }]
]);
const py = r("GemIcon", [
  ["path", { d: "M6 3h12l4 6-10 13L2 9Z", key: "1pcd5k" }],
  ["path", { d: "M11 3 8 9l4 13 4-13-3-6", key: "1fcu3u" }],
  ["path", { d: "M2 9h20", key: "16fsjt" }]
]);
const yy = r("GhostIcon", [
  ["path", { d: "M9 10h.01", key: "qbtxuw" }],
  ["path", { d: "M15 10h.01", key: "1qmjsl" }],
  [
    "path",
    {
      d: "M12 2a8 8 0 0 0-8 8v12l3-3 2.5 2.5L12 19l2.5 2.5L17 19l3 3V10a8 8 0 0 0-8-8z",
      key: "uwwb07"
    }
  ]
]);
const ky = r("GiftIcon", [
  ["rect", { x: "3", y: "8", width: "18", height: "4", rx: "1", key: "bkv52" }],
  ["path", { d: "M12 8v13", key: "1c76mn" }],
  ["path", { d: "M19 12v7a2 2 0 0 1-2 2H7a2 2 0 0 1-2-2v-7", key: "6wjy6b" }],
  [
    "path",
    {
      d: "M7.5 8a2.5 2.5 0 0 1 0-5A4.8 8 0 0 1 12 8a4.8 8 0 0 1 4.5-5 2.5 2.5 0 0 1 0 5",
      key: "1ihvrl"
    }
  ]
]);
const fy = r("GitBranchPlusIcon", [
  ["path", { d: "M6 3v12", key: "qpgusn" }],
  ["path", { d: "M18 9a3 3 0 1 0 0-6 3 3 0 0 0 0 6z", key: "1d02ji" }],
  ["path", { d: "M6 21a3 3 0 1 0 0-6 3 3 0 0 0 0 6z", key: "chk6ph" }],
  ["path", { d: "M15 6a9 9 0 0 0-9 9", key: "or332x" }],
  ["path", { d: "M18 15v6", key: "9wciyi" }],
  ["path", { d: "M21 18h-6", key: "139f0c" }]
]);
const vy = r("GitBranchIcon", [
  ["line", { x1: "6", x2: "6", y1: "3", y2: "15", key: "17qcm7" }],
  ["circle", { cx: "18", cy: "6", r: "3", key: "1h7g24" }],
  ["circle", { cx: "6", cy: "18", r: "3", key: "fqmcym" }],
  ["path", { d: "M18 9a9 9 0 0 1-9 9", key: "n2h4wq" }]
]);
const xn = r("GitCommitHorizontalIcon", [
  ["circle", { cx: "12", cy: "12", r: "3", key: "1v7zrd" }],
  ["line", { x1: "3", x2: "9", y1: "12", y2: "12", key: "1dyftd" }],
  ["line", { x1: "15", x2: "21", y1: "12", y2: "12", key: "oup4p8" }]
]);
const my = r("GitCommitVerticalIcon", [
  ["path", { d: "M12 3v6", key: "1holv5" }],
  ["circle", { cx: "12", cy: "12", r: "3", key: "1v7zrd" }],
  ["path", { d: "M12 15v6", key: "a9ows0" }]
]);
const gy = r("GitCompareArrowsIcon", [
  ["circle", { cx: "5", cy: "6", r: "3", key: "1qnov2" }],
  ["path", { d: "M12 6h5a2 2 0 0 1 2 2v7", key: "1yj91y" }],
  ["path", { d: "m15 9-3-3 3-3", key: "1lwv8l" }],
  ["circle", { cx: "19", cy: "18", r: "3", key: "1qljk2" }],
  ["path", { d: "M12 18H7a2 2 0 0 1-2-2V9", key: "16sdep" }],
  ["path", { d: "m9 15 3 3-3 3", key: "1m3kbl" }]
]);
const My = r("GitCompareIcon", [
  ["circle", { cx: "18", cy: "18", r: "3", key: "1xkwt0" }],
  ["circle", { cx: "6", cy: "6", r: "3", key: "1lh9wr" }],
  ["path", { d: "M13 6h3a2 2 0 0 1 2 2v7", key: "1yeb86" }],
  ["path", { d: "M11 18H8a2 2 0 0 1-2-2V9", key: "19pyzm" }]
]);
const xy = r("GitForkIcon", [
  ["circle", { cx: "12", cy: "18", r: "3", key: "1mpf1b" }],
  ["circle", { cx: "6", cy: "6", r: "3", key: "1lh9wr" }],
  ["circle", { cx: "18", cy: "6", r: "3", key: "1h7g24" }],
  ["path", { d: "M18 9v2c0 .6-.4 1-1 1H7c-.6 0-1-.4-1-1V9", key: "1uq4wg" }],
  ["path", { d: "M12 12v3", key: "158kv8" }]
]);
const by = r("GitGraphIcon", [
  ["circle", { cx: "5", cy: "6", r: "3", key: "1qnov2" }],
  ["path", { d: "M5 9v6", key: "158jrl" }],
  ["circle", { cx: "5", cy: "18", r: "3", key: "104gr9" }],
  ["path", { d: "M12 3v18", key: "108xh3" }],
  ["circle", { cx: "19", cy: "6", r: "3", key: "108a5v" }],
  ["path", { d: "M16 15.7A9 9 0 0 0 19 9", key: "1e3vqb" }]
]);
const wy = r("GitMergeIcon", [
  ["circle", { cx: "18", cy: "18", r: "3", key: "1xkwt0" }],
  ["circle", { cx: "6", cy: "6", r: "3", key: "1lh9wr" }],
  ["path", { d: "M6 21V9a9 9 0 0 0 9 9", key: "7kw0sc" }]
]);
const Iy = r("GitPullRequestArrowIcon", [
  ["circle", { cx: "5", cy: "6", r: "3", key: "1qnov2" }],
  ["path", { d: "M5 9v12", key: "ih889a" }],
  ["circle", { cx: "19", cy: "18", r: "3", key: "1qljk2" }],
  ["path", { d: "m15 9-3-3 3-3", key: "1lwv8l" }],
  ["path", { d: "M12 6h5a2 2 0 0 1 2 2v7", key: "1yj91y" }]
]);
const Ly = r("GitPullRequestClosedIcon", [
  ["circle", { cx: "6", cy: "6", r: "3", key: "1lh9wr" }],
  ["path", { d: "M6 9v12", key: "1sc30k" }],
  ["path", { d: "m21 3-6 6", key: "16nqsk" }],
  ["path", { d: "m21 9-6-6", key: "9j17rh" }],
  ["path", { d: "M18 11.5V15", key: "65xf6f" }],
  ["circle", { cx: "18", cy: "18", r: "3", key: "1xkwt0" }]
]);
const Sy = r("GitPullRequestCreateArrowIcon", [
  ["circle", { cx: "5", cy: "6", r: "3", key: "1qnov2" }],
  ["path", { d: "M5 9v12", key: "ih889a" }],
  ["path", { d: "m15 9-3-3 3-3", key: "1lwv8l" }],
  ["path", { d: "M12 6h5a2 2 0 0 1 2 2v3", key: "1rbwk6" }],
  ["path", { d: "M19 15v6", key: "10aioa" }],
  ["path", { d: "M22 18h-6", key: "1d5gi5" }]
]);
const Cy = r("GitPullRequestCreateIcon", [
  ["circle", { cx: "6", cy: "6", r: "3", key: "1lh9wr" }],
  ["path", { d: "M6 9v12", key: "1sc30k" }],
  ["path", { d: "M13 6h3a2 2 0 0 1 2 2v3", key: "1jb6z3" }],
  ["path", { d: "M18 15v6", key: "9wciyi" }],
  ["path", { d: "M21 18h-6", key: "139f0c" }]
]);
const Ay = r("GitPullRequestDraftIcon", [
  ["circle", { cx: "18", cy: "18", r: "3", key: "1xkwt0" }],
  ["circle", { cx: "6", cy: "6", r: "3", key: "1lh9wr" }],
  ["path", { d: "M18 6V5", key: "1oao2s" }],
  ["path", { d: "M18 11v-1", key: "11c8tz" }],
  ["line", { x1: "6", x2: "6", y1: "9", y2: "21", key: "rroup" }]
]);
const Py = r("GitPullRequestIcon", [
  ["circle", { cx: "18", cy: "18", r: "3", key: "1xkwt0" }],
  ["circle", { cx: "6", cy: "6", r: "3", key: "1lh9wr" }],
  ["path", { d: "M13 6h3a2 2 0 0 1 2 2v7", key: "1yeb86" }],
  ["line", { x1: "6", x2: "6", y1: "9", y2: "21", key: "rroup" }]
]);
const qy = r("GithubIcon", [
  [
    "path",
    {
      d: "M15 22v-4a4.8 4.8 0 0 0-1-3.5c3 0 6-2 6-5.5.08-1.25-.27-2.48-1-3.5.28-1.15.28-2.35 0-3.5 0 0-1 0-3 1.5-2.64-.5-5.36-.5-8 0C6 2 5 2 5 2c-.3 1.15-.3 2.35 0 3.5A5.403 5.403 0 0 0 4 9c0 3.5 3 5.5 6 5.5-.39.49-.68 1.05-.85 1.65-.17.6-.22 1.23-.15 1.85v4",
      key: "tonef"
    }
  ],
  ["path", { d: "M9 18c-4.51 2-5-2-7-2", key: "9comsn" }]
]);
const Ty = r("GitlabIcon", [
  [
    "path",
    {
      d: "m22 13.29-3.33-10a.42.42 0 0 0-.14-.18.38.38 0 0 0-.22-.11.39.39 0 0 0-.23.07.42.42 0 0 0-.14.18l-2.26 6.67H8.32L6.1 3.26a.42.42 0 0 0-.1-.18.38.38 0 0 0-.26-.08.39.39 0 0 0-.23.07.42.42 0 0 0-.14.18L2 13.29a.74.74 0 0 0 .27.83L12 21l9.69-6.88a.71.71 0 0 0 .31-.83Z",
      key: "148pdi"
    }
  ]
]);
const Dy = r("GlassWaterIcon", [
  [
    "path",
    { d: "M15.2 22H8.8a2 2 0 0 1-2-1.79L5 3h14l-1.81 17.21A2 2 0 0 1 15.2 22Z", key: "48rfw3" }
  ],
  ["path", { d: "M6 12a5 5 0 0 1 6 0 5 5 0 0 0 6 0", key: "mjntcy" }]
]);
const _y = r("GlassesIcon", [
  ["circle", { cx: "6", cy: "15", r: "4", key: "vux9w4" }],
  ["circle", { cx: "18", cy: "15", r: "4", key: "18o8ve" }],
  ["path", { d: "M14 15a2 2 0 0 0-2-2 2 2 0 0 0-2 2", key: "1ag4bs" }],
  ["path", { d: "M2.5 13 5 7c.7-1.3 1.4-2 3-2", key: "1hm1gs" }],
  ["path", { d: "M21.5 13 19 7c-.7-1.3-1.5-2-3-2", key: "1r31ai" }]
]);
const By = r("GlobeLockIcon", [
  [
    "path",
    {
      d: "M15.686 15A14.5 14.5 0 0 1 12 22a14.5 14.5 0 0 1 0-20 10 10 0 1 0 9.542 13",
      key: "qkt0x6"
    }
  ],
  ["path", { d: "M2 12h8.5", key: "ovaggd" }],
  ["path", { d: "M20 6V4a2 2 0 1 0-4 0v2", key: "1of5e8" }],
  ["rect", { width: "8", height: "5", x: "14", y: "6", rx: "1", key: "1fmf51" }]
]);
const zy = r("GlobeIcon", [
  ["circle", { cx: "12", cy: "12", r: "10", key: "1mglay" }],
  ["path", { d: "M12 2a14.5 14.5 0 0 0 0 20 14.5 14.5 0 0 0 0-20", key: "13o1zl" }],
  ["path", { d: "M2 12h20", key: "9i4pu4" }]
]);
const Hy = r("GoalIcon", [
  ["path", { d: "M12 13V2l8 4-8 4", key: "5wlwwj" }],
  ["path", { d: "M20.561 10.222a9 9 0 1 1-12.55-5.29", key: "1c0wjv" }],
  ["path", { d: "M8.002 9.997a5 5 0 1 0 8.9 2.02", key: "gb1g7m" }]
]);
const jy = r("GrabIcon", [
  ["path", { d: "M18 11.5V9a2 2 0 0 0-2-2v0a2 2 0 0 0-2 2v1.4", key: "n5nng" }],
  ["path", { d: "M14 10V8a2 2 0 0 0-2-2v0a2 2 0 0 0-2 2v2", key: "185i9d" }],
  ["path", { d: "M10 9.9V9a2 2 0 0 0-2-2v0a2 2 0 0 0-2 2v5", key: "11pz95" }],
  ["path", { d: "M6 14v0a2 2 0 0 0-2-2v0a2 2 0 0 0-2 2v0", key: "16yk7l" }],
  [
    "path",
    { d: "M18 11v0a2 2 0 1 1 4 0v3a8 8 0 0 1-8 8h-4a8 8 0 0 1-8-8 2 2 0 1 1 4 0", key: "nzvb1c" }
  ]
]);
const Vy = r("GraduationCapIcon", [
  [
    "path",
    {
      d: "M21.42 10.922a1 1 0 0 0-.019-1.838L12.83 5.18a2 2 0 0 0-1.66 0L2.6 9.08a1 1 0 0 0 0 1.832l8.57 3.908a2 2 0 0 0 1.66 0z",
      key: "j76jl0"
    }
  ],
  ["path", { d: "M22 10v6", key: "1lu8f3" }],
  ["path", { d: "M6 12.5V16a6 3 0 0 0 12 0v-3.5", key: "1r8lef" }]
]);
const Oy = r("GrapeIcon", [
  ["path", { d: "M22 5V2l-5.89 5.89", key: "1eenpo" }],
  ["circle", { cx: "16.6", cy: "15.89", r: "3", key: "xjtalx" }],
  ["circle", { cx: "8.11", cy: "7.4", r: "3", key: "u2fv6i" }],
  ["circle", { cx: "12.35", cy: "11.65", r: "3", key: "i6i8g7" }],
  ["circle", { cx: "13.91", cy: "5.85", r: "3", key: "6ye0dv" }],
  ["circle", { cx: "18.15", cy: "10.09", r: "3", key: "snx9no" }],
  ["circle", { cx: "6.56", cy: "13.2", r: "3", key: "17x4xg" }],
  ["circle", { cx: "10.8", cy: "17.44", r: "3", key: "1hogw9" }],
  ["circle", { cx: "5", cy: "19", r: "3", key: "1sn6vo" }]
]);
const bn = r("Grid2x2Icon", [
  ["rect", { width: "18", height: "18", x: "3", y: "3", rx: "2", key: "afitv7" }],
  ["path", { d: "M3 12h18", key: "1i2n21" }],
  ["path", { d: "M12 3v18", key: "108xh3" }]
]);
const zt = r("Grid3x3Icon", [
  ["rect", { width: "18", height: "18", x: "3", y: "3", rx: "2", key: "afitv7" }],
  ["path", { d: "M3 9h18", key: "1pudct" }],
  ["path", { d: "M3 15h18", key: "5xshup" }],
  ["path", { d: "M9 3v18", key: "fh3hqa" }],
  ["path", { d: "M15 3v18", key: "14nvp0" }]
]);
const $y = r("GripHorizontalIcon", [
  ["circle", { cx: "12", cy: "9", r: "1", key: "124mty" }],
  ["circle", { cx: "19", cy: "9", r: "1", key: "1ruzo2" }],
  ["circle", { cx: "5", cy: "9", r: "1", key: "1a8b28" }],
  ["circle", { cx: "12", cy: "15", r: "1", key: "1e56xg" }],
  ["circle", { cx: "19", cy: "15", r: "1", key: "1a92ep" }],
  ["circle", { cx: "5", cy: "15", r: "1", key: "5r1jwy" }]
]);
const Ry = r("GripVerticalIcon", [
  ["circle", { cx: "9", cy: "12", r: "1", key: "1vctgf" }],
  ["circle", { cx: "9", cy: "5", r: "1", key: "hp0tcf" }],
  ["circle", { cx: "9", cy: "19", r: "1", key: "fkjjf6" }],
  ["circle", { cx: "15", cy: "12", r: "1", key: "1tmaij" }],
  ["circle", { cx: "15", cy: "5", r: "1", key: "19l28e" }],
  ["circle", { cx: "15", cy: "19", r: "1", key: "f4zoj3" }]
]);
const Fy = r("GripIcon", [
  ["circle", { cx: "12", cy: "5", r: "1", key: "gxeob9" }],
  ["circle", { cx: "19", cy: "5", r: "1", key: "w8mnmm" }],
  ["circle", { cx: "5", cy: "5", r: "1", key: "lttvr7" }],
  ["circle", { cx: "12", cy: "12", r: "1", key: "41hilf" }],
  ["circle", { cx: "19", cy: "12", r: "1", key: "1wjl8i" }],
  ["circle", { cx: "5", cy: "12", r: "1", key: "1pcz8c" }],
  ["circle", { cx: "12", cy: "19", r: "1", key: "lyex9k" }],
  ["circle", { cx: "19", cy: "19", r: "1", key: "shf9b7" }],
  ["circle", { cx: "5", cy: "19", r: "1", key: "bfqh0e" }]
]);
const Uy = r("GroupIcon", [
  ["path", { d: "M3 7V5c0-1.1.9-2 2-2h2", key: "adw53z" }],
  ["path", { d: "M17 3h2c1.1 0 2 .9 2 2v2", key: "an4l38" }],
  ["path", { d: "M21 17v2c0 1.1-.9 2-2 2h-2", key: "144t0e" }],
  ["path", { d: "M7 21H5c-1.1 0-2-.9-2-2v-2", key: "rtnfgi" }],
  ["rect", { width: "7", height: "5", x: "7", y: "7", rx: "1", key: "1eyiv7" }],
  ["rect", { width: "7", height: "5", x: "10", y: "12", rx: "1", key: "1qlmkx" }]
]);
const Ey = r("GuitarIcon", [
  ["path", { d: "m20 7 1.7-1.7a1 1 0 0 0 0-1.4l-1.6-1.6a1 1 0 0 0-1.4 0L17 4v3Z", key: "15ixgv" }],
  ["path", { d: "m17 7-5.1 5.1", key: "l9guh7" }],
  ["circle", { cx: "11.5", cy: "12.5", r: ".5", fill: "currentColor", key: "16onso" }],
  [
    "path",
    {
      d: "M6 12a2 2 0 0 0 1.8-1.2l.4-.9C8.7 8.8 9.8 8 11 8c2.8 0 5 2.2 5 5 0 1.2-.8 2.3-1.9 2.8l-.9.4A2 2 0 0 0 12 18a4 4 0 0 1-4 4c-3.3 0-6-2.7-6-6a4 4 0 0 1 4-4",
      key: "x9fguj"
    }
  ],
  ["path", { d: "m6 16 2 2", key: "16qmzd" }]
]);
const Wy = r("HamIcon", [
  ["path", { d: "M13.144 21.144A7.274 10.445 45 1 0 2.856 10.856", key: "1k1t7q" }],
  [
    "path",
    {
      d: "M13.144 21.144A7.274 4.365 45 0 0 2.856 10.856a7.274 4.365 45 0 0 10.288 10.288",
      key: "153t1g"
    }
  ],
  [
    "path",
    {
      d: "M16.565 10.435 18.6 8.4a2.501 2.501 0 1 0 1.65-4.65 2.5 2.5 0 1 0-4.66 1.66l-2.024 2.025",
      key: "gzrt0n"
    }
  ],
  ["path", { d: "m8.5 16.5-1-1", key: "otr954" }]
]);
const Ny = r("HammerIcon", [
  ["path", { d: "m15 12-8.373 8.373a1 1 0 1 1-3-3L12 9", key: "eefl8a" }],
  ["path", { d: "m18 15 4-4", key: "16gjal" }],
  [
    "path",
    {
      d: "m21.5 11.5-1.914-1.914A2 2 0 0 1 19 8.172V7l-2.26-2.26a6 6 0 0 0-4.202-1.756L9 2.96l.92.82A6.18 6.18 0 0 1 12 8.4V10l2 2h1.172a2 2 0 0 1 1.414.586L18.5 14.5",
      key: "b7pghm"
    }
  ]
]);
const Zy = r("HandCoinsIcon", [
  ["path", { d: "M11 15h2a2 2 0 1 0 0-4h-3c-.6 0-1.1.2-1.4.6L3 17", key: "geh8rc" }],
  [
    "path",
    {
      d: "m7 21 1.6-1.4c.3-.4.8-.6 1.4-.6h4c1.1 0 2.1-.4 2.8-1.2l4.6-4.4a2 2 0 0 0-2.75-2.91l-4.2 3.9",
      key: "1fto5m"
    }
  ],
  ["path", { d: "m2 16 6 6", key: "1pfhp9" }],
  ["circle", { cx: "16", cy: "9", r: "2.9", key: "1n0dlu" }],
  ["circle", { cx: "6", cy: "5", r: "3", key: "151irh" }]
]);
const Yy = r("HandHeartIcon", [
  ["path", { d: "M11 14h2a2 2 0 1 0 0-4h-3c-.6 0-1.1.2-1.4.6L3 16", key: "1ifwr1" }],
  [
    "path",
    {
      d: "m7 20 1.6-1.4c.3-.4.8-.6 1.4-.6h4c1.1 0 2.1-.4 2.8-1.2l4.6-4.4a2 2 0 0 0-2.75-2.91l-4.2 3.9",
      key: "17abbs"
    }
  ],
  ["path", { d: "m2 15 6 6", key: "10dquu" }],
  [
    "path",
    {
      d: "M19.5 8.5c.7-.7 1.5-1.6 1.5-2.7A2.73 2.73 0 0 0 16 4a2.78 2.78 0 0 0-5 1.8c0 1.2.8 2 1.5 2.8L16 12Z",
      key: "1h3036"
    }
  ]
]);
const wn = r("HandHelpingIcon", [
  ["path", { d: "M11 12h2a2 2 0 1 0 0-4h-3c-.6 0-1.1.2-1.4.6L3 14", key: "1j4xps" }],
  [
    "path",
    {
      d: "m7 18 1.6-1.4c.3-.4.8-.6 1.4-.6h4c1.1 0 2.1-.4 2.8-1.2l4.6-4.4a2 2 0 0 0-2.75-2.91l-4.2 3.9",
      key: "uospg8"
    }
  ],
  ["path", { d: "m2 13 6 6", key: "16e5sb" }]
]);
const Gy = r("HandMetalIcon", [
  ["path", { d: "M18 12.5V10a2 2 0 0 0-2-2v0a2 2 0 0 0-2 2v1.4", key: "7eki13" }],
  ["path", { d: "M14 11V9a2 2 0 1 0-4 0v2", key: "94qvcw" }],
  ["path", { d: "M10 10.5V5a2 2 0 1 0-4 0v9", key: "m1ah89" }],
  [
    "path",
    {
      d: "m7 15-1.76-1.76a2 2 0 0 0-2.83 2.82l3.6 3.6C7.5 21.14 9.2 22 12 22h2a8 8 0 0 0 8-8V7a2 2 0 1 0-4 0v5",
      key: "t1skq1"
    }
  ]
]);
const Xy = r("HandPlatterIcon", [
  ["path", { d: "M12 3V2", key: "ar7q03" }],
  ["path", { d: "M5 10a7.1 7.1 0 0 1 14 0", key: "1t9y3n" }],
  ["path", { d: "M4 10h16", key: "img6z1" }],
  ["path", { d: "M2 14h12a2 2 0 1 1 0 4h-2", key: "loyjft" }],
  [
    "path",
    {
      d: "m15.4 17.4 3.2-2.8a2 2 0 0 1 2.8 2.9l-3.6 3.3c-.7.8-1.7 1.2-2.8 1.2h-4c-1.1 0-2.1-.4-2.8-1.2L5 18",
      key: "1rixiy"
    }
  ],
  ["path", { d: "M5 14v7H2", key: "3mujks" }]
]);
const Ky = r("HandIcon", [
  ["path", { d: "M18 11V6a2 2 0 0 0-2-2v0a2 2 0 0 0-2 2v0", key: "aigmz7" }],
  ["path", { d: "M14 10V4a2 2 0 0 0-2-2v0a2 2 0 0 0-2 2v2", key: "1n6bmn" }],
  ["path", { d: "M10 10.5V6a2 2 0 0 0-2-2v0a2 2 0 0 0-2 2v8", key: "a9iiix" }],
  [
    "path",
    {
      d: "M18 8a2 2 0 1 1 4 0v6a8 8 0 0 1-8 8h-2c-2.8 0-4.5-.86-5.99-2.34l-3.6-3.6a2 2 0 0 1 2.83-2.82L7 15",
      key: "1s1gnw"
    }
  ]
]);
const Qy = r("HandshakeIcon", [
  ["path", { d: "m11 17 2 2a1 1 0 1 0 3-3", key: "efffak" }],
  [
    "path",
    {
      d: "m14 14 2.5 2.5a1 1 0 1 0 3-3l-3.88-3.88a3 3 0 0 0-4.24 0l-.88.88a1 1 0 1 1-3-3l2.81-2.81a5.79 5.79 0 0 1 7.06-.87l.47.28a2 2 0 0 0 1.42.25L21 4",
      key: "9pr0kb"
    }
  ],
  ["path", { d: "m21 3 1 11h-2", key: "1tisrp" }],
  ["path", { d: "M3 3 2 14l6.5 6.5a1 1 0 1 0 3-3", key: "1uvwmv" }],
  ["path", { d: "M3 4h8", key: "1ep09j" }]
]);
const Jy = r("HardDriveDownloadIcon", [
  ["path", { d: "M12 2v8", key: "1q4o3n" }],
  ["path", { d: "m16 6-4 4-4-4", key: "6wukr" }],
  ["rect", { width: "20", height: "8", x: "2", y: "14", rx: "2", key: "w68u3i" }],
  ["path", { d: "M6 18h.01", key: "uhywen" }],
  ["path", { d: "M10 18h.01", key: "h775k" }]
]);
const ek = r("HardDriveUploadIcon", [
  ["path", { d: "m16 6-4-4-4 4", key: "13yo43" }],
  ["path", { d: "M12 2v8", key: "1q4o3n" }],
  ["rect", { width: "20", height: "8", x: "2", y: "14", rx: "2", key: "w68u3i" }],
  ["path", { d: "M6 18h.01", key: "uhywen" }],
  ["path", { d: "M10 18h.01", key: "h775k" }]
]);
const tk = r("HardDriveIcon", [
  ["line", { x1: "22", x2: "2", y1: "12", y2: "12", key: "1y58io" }],
  [
    "path",
    {
      d: "M5.45 5.11 2 12v6a2 2 0 0 0 2 2h16a2 2 0 0 0 2-2v-6l-3.45-6.89A2 2 0 0 0 16.76 4H7.24a2 2 0 0 0-1.79 1.11z",
      key: "oot6mr"
    }
  ],
  ["line", { x1: "6", x2: "6.01", y1: "16", y2: "16", key: "sgf278" }],
  ["line", { x1: "10", x2: "10.01", y1: "16", y2: "16", key: "1l4acy" }]
]);
const ak = r("HardHatIcon", [
  [
    "path",
    {
      d: "M2 18a1 1 0 0 0 1 1h18a1 1 0 0 0 1-1v-2a1 1 0 0 0-1-1H3a1 1 0 0 0-1 1v2z",
      key: "1dej2m"
    }
  ],
  ["path", { d: "M10 10V5a1 1 0 0 1 1-1h2a1 1 0 0 1 1 1v5", key: "1p9q5i" }],
  ["path", { d: "M4 15v-3a6 6 0 0 1 6-6h0", key: "1uc279" }],
  ["path", { d: "M14 6h0a6 6 0 0 1 6 6v3", key: "1j9mnm" }]
]);
const nk = r("HashIcon", [
  ["line", { x1: "4", x2: "20", y1: "9", y2: "9", key: "4lhtct" }],
  ["line", { x1: "4", x2: "20", y1: "15", y2: "15", key: "vyu0kd" }],
  ["line", { x1: "10", x2: "8", y1: "3", y2: "21", key: "1ggp8o" }],
  ["line", { x1: "16", x2: "14", y1: "3", y2: "21", key: "weycgp" }]
]);
const ok = r("HazeIcon", [
  ["path", { d: "m5.2 6.2 1.4 1.4", key: "17imol" }],
  ["path", { d: "M2 13h2", key: "13gyu8" }],
  ["path", { d: "M20 13h2", key: "16rner" }],
  ["path", { d: "m17.4 7.6 1.4-1.4", key: "t4xlah" }],
  ["path", { d: "M22 17H2", key: "1gtaj3" }],
  ["path", { d: "M22 21H2", key: "1gy6en" }],
  ["path", { d: "M16 13a4 4 0 0 0-8 0", key: "1dyczq" }],
  ["path", { d: "M12 5V2.5", key: "1vytko" }]
]);
const rk = r("HdmiPortIcon", [
  [
    "path",
    {
      d: "M22 9a1 1 0 0 0-1-1H3a1 1 0 0 0-1 1v4a1 1 0 0 0 1 1h1l2 2h12l2-2h1a1 1 0 0 0 1-1Z",
      key: "2128wb"
    }
  ],
  ["path", { d: "M7.5 12h9", key: "1t0ckc" }]
]);
const ik = r("Heading1Icon", [
  ["path", { d: "M4 12h8", key: "17cfdx" }],
  ["path", { d: "M4 18V6", key: "1rz3zl" }],
  ["path", { d: "M12 18V6", key: "zqpxq5" }],
  ["path", { d: "m17 12 3-2v8", key: "1hhhft" }]
]);
const lk = r("Heading2Icon", [
  ["path", { d: "M4 12h8", key: "17cfdx" }],
  ["path", { d: "M4 18V6", key: "1rz3zl" }],
  ["path", { d: "M12 18V6", key: "zqpxq5" }],
  ["path", { d: "M21 18h-4c0-4 4-3 4-6 0-1.5-2-2.5-4-1", key: "9jr5yi" }]
]);
const ck = r("Heading3Icon", [
  ["path", { d: "M4 12h8", key: "17cfdx" }],
  ["path", { d: "M4 18V6", key: "1rz3zl" }],
  ["path", { d: "M12 18V6", key: "zqpxq5" }],
  ["path", { d: "M17.5 10.5c1.7-1 3.5 0 3.5 1.5a2 2 0 0 1-2 2", key: "68ncm8" }],
  ["path", { d: "M17 17.5c2 1.5 4 .3 4-1.5a2 2 0 0 0-2-2", key: "1ejuhz" }]
]);
const dk = r("Heading4Icon", [
  ["path", { d: "M4 12h8", key: "17cfdx" }],
  ["path", { d: "M4 18V6", key: "1rz3zl" }],
  ["path", { d: "M12 18V6", key: "zqpxq5" }],
  ["path", { d: "M17 10v4h4", key: "13sv97" }],
  ["path", { d: "M21 10v8", key: "1kdml4" }]
]);
const sk = r("Heading5Icon", [
  ["path", { d: "M4 12h8", key: "17cfdx" }],
  ["path", { d: "M4 18V6", key: "1rz3zl" }],
  ["path", { d: "M12 18V6", key: "zqpxq5" }],
  ["path", { d: "M17 13v-3h4", key: "1nvgqp" }],
  [
    "path",
    { d: "M17 17.7c.4.2.8.3 1.3.3 1.5 0 2.7-1.1 2.7-2.5S19.8 13 18.3 13H17", key: "2nebdn" }
  ]
]);
const uk = r("Heading6Icon", [
  ["path", { d: "M4 12h8", key: "17cfdx" }],
  ["path", { d: "M4 18V6", key: "1rz3zl" }],
  ["path", { d: "M12 18V6", key: "zqpxq5" }],
  ["circle", { cx: "19", cy: "16", r: "2", key: "15mx69" }],
  ["path", { d: "M20 10c-2 2-3 3.5-3 6", key: "f35dl0" }]
]);
const hk = r("HeadingIcon", [
  ["path", { d: "M6 12h12", key: "8npq4p" }],
  ["path", { d: "M6 20V4", key: "1w1bmo" }],
  ["path", { d: "M18 20V4", key: "o2hl4u" }]
]);
const pk = r("HeadphonesIcon", [
  [
    "path",
    {
      d: "M3 14h3a2 2 0 0 1 2 2v3a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2v-7a9 9 0 0 1 18 0v7a2 2 0 0 1-2 2h-1a2 2 0 0 1-2-2v-3a2 2 0 0 1 2-2h3",
      key: "1xhozi"
    }
  ]
]);
const yk = r("HeadsetIcon", [
  [
    "path",
    {
      d: "M3 11h3a2 2 0 0 1 2 2v3a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2v-5Zm0 0a9 9 0 1 1 18 0m0 0v5a2 2 0 0 1-2 2h-1a2 2 0 0 1-2-2v-3a2 2 0 0 1 2-2h3Z",
      key: "12oyoe"
    }
  ],
  ["path", { d: "M21 16v2a4 4 0 0 1-4 4h-5", key: "1x7m43" }]
]);
const kk = r("HeartCrackIcon", [
  [
    "path",
    {
      d: "M19 14c1.49-1.46 3-3.21 3-5.5A5.5 5.5 0 0 0 16.5 3c-1.76 0-3 .5-4.5 2-1.5-1.5-2.74-2-4.5-2A5.5 5.5 0 0 0 2 8.5c0 2.3 1.5 4.05 3 5.5l7 7Z",
      key: "c3ymky"
    }
  ],
  ["path", { d: "m12 13-1-1 2-2-3-3 2-2", key: "xjdxli" }]
]);
const fk = r("HeartHandshakeIcon", [
  [
    "path",
    {
      d: "M19 14c1.49-1.46 3-3.21 3-5.5A5.5 5.5 0 0 0 16.5 3c-1.76 0-3 .5-4.5 2-1.5-1.5-2.74-2-4.5-2A5.5 5.5 0 0 0 2 8.5c0 2.3 1.5 4.05 3 5.5l7 7Z",
      key: "c3ymky"
    }
  ],
  [
    "path",
    {
      d: "M12 5 9.04 7.96a2.17 2.17 0 0 0 0 3.08v0c.82.82 2.13.85 3 .07l2.07-1.9a2.82 2.82 0 0 1 3.79 0l2.96 2.66",
      key: "12sd6o"
    }
  ],
  ["path", { d: "m18 15-2-2", key: "60u0ii" }],
  ["path", { d: "m15 18-2-2", key: "6p76be" }]
]);
const vk = r("HeartOffIcon", [
  ["line", { x1: "2", y1: "2", x2: "22", y2: "22", key: "1w4vcy" }],
  [
    "path",
    { d: "M16.5 16.5 12 21l-7-7c-1.5-1.45-3-3.2-3-5.5a5.5 5.5 0 0 1 2.14-4.35", key: "3mpagl" }
  ],
  [
    "path",
    {
      d: "M8.76 3.1c1.15.22 2.13.78 3.24 1.9 1.5-1.5 2.74-2 4.5-2A5.5 5.5 0 0 1 22 8.5c0 2.12-1.3 3.78-2.67 5.17",
      key: "1gh3v3"
    }
  ]
]);
const mk = r("HeartPulseIcon", [
  [
    "path",
    {
      d: "M19 14c1.49-1.46 3-3.21 3-5.5A5.5 5.5 0 0 0 16.5 3c-1.76 0-3 .5-4.5 2-1.5-1.5-2.74-2-4.5-2A5.5 5.5 0 0 0 2 8.5c0 2.3 1.5 4.05 3 5.5l7 7Z",
      key: "c3ymky"
    }
  ],
  ["path", { d: "M3.22 12H9.5l.5-1 2 4.5 2-7 1.5 3.5h5.27", key: "1uw2ng" }]
]);
const gk = r("HeartIcon", [
  [
    "path",
    {
      d: "M19 14c1.49-1.46 3-3.21 3-5.5A5.5 5.5 0 0 0 16.5 3c-1.76 0-3 .5-4.5 2-1.5-1.5-2.74-2-4.5-2A5.5 5.5 0 0 0 2 8.5c0 2.3 1.5 4.05 3 5.5l7 7Z",
      key: "c3ymky"
    }
  ]
]);
const Mk = r("HeaterIcon", [
  ["path", { d: "M11 8c2-3-2-3 0-6", key: "1ldv5m" }],
  ["path", { d: "M15.5 8c2-3-2-3 0-6", key: "1otqoz" }],
  ["path", { d: "M6 10h.01", key: "1lbq93" }],
  ["path", { d: "M6 14h.01", key: "zudwn7" }],
  ["path", { d: "M10 16v-4", key: "1c25yv" }],
  ["path", { d: "M14 16v-4", key: "1dkbt8" }],
  ["path", { d: "M18 16v-4", key: "1yg9me" }],
  [
    "path",
    { d: "M20 6a2 2 0 0 1 2 2v10a2 2 0 0 1-2 2H4a2 2 0 0 1-2-2V8a2 2 0 0 1 2-2h3", key: "1ubg90" }
  ],
  ["path", { d: "M5 20v2", key: "1abpe8" }],
  ["path", { d: "M19 20v2", key: "kqn6ft" }]
]);
const xk = r("HexagonIcon", [
  [
    "path",
    {
      d: "M21 16V8a2 2 0 0 0-1-1.73l-7-4a2 2 0 0 0-2 0l-7 4A2 2 0 0 0 3 8v8a2 2 0 0 0 1 1.73l7 4a2 2 0 0 0 2 0l7-4A2 2 0 0 0 21 16z",
      key: "yt0hxn"
    }
  ]
]);
const bk = r("HighlighterIcon", [
  ["path", { d: "m9 11-6 6v3h9l3-3", key: "1a3l36" }],
  ["path", { d: "m22 12-4.6 4.6a2 2 0 0 1-2.8 0l-5.2-5.2a2 2 0 0 1 0-2.8L14 4", key: "14a9rk" }]
]);
const wk = r("HistoryIcon", [
  ["path", { d: "M3 12a9 9 0 1 0 9-9 9.75 9.75 0 0 0-6.74 2.74L3 8", key: "1357e3" }],
  ["path", { d: "M3 3v5h5", key: "1xhq8a" }],
  ["path", { d: "M12 7v5l4 2", key: "1fdv2h" }]
]);
const Ik = r("HomeIcon", [
  ["path", { d: "m3 9 9-7 9 7v11a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2z", key: "y5dka4" }],
  ["polyline", { points: "9 22 9 12 15 12 15 22", key: "e2us08" }]
]);
const Lk = r("HopOffIcon", [
  ["path", { d: "M10.82 16.12c1.69.6 3.91.79 5.18.85.28.01.53-.09.7-.27", key: "qyzcap" }],
  [
    "path",
    {
      d: "M11.14 20.57c.52.24 2.44 1.12 4.08 1.37.46.06.86-.25.9-.71.12-1.52-.3-3.43-.5-4.28",
      key: "y078lb"
    }
  ],
  ["path", { d: "M16.13 21.05c1.65.63 3.68.84 4.87.91a.9.9 0 0 0 .7-.26", key: "1utre3" }],
  [
    "path",
    {
      d: "M17.99 5.52a20.83 20.83 0 0 1 3.15 4.5.8.8 0 0 1-.68 1.13c-1.17.1-2.5.02-3.9-.25",
      key: "17o9hm"
    }
  ],
  ["path", { d: "M20.57 11.14c.24.52 1.12 2.44 1.37 4.08.04.3-.08.59-.31.75", key: "1d1n4p" }],
  [
    "path",
    {
      d: "M4.93 4.93a10 10 0 0 0-.67 13.4c.35.43.96.4 1.17-.12.69-1.71 1.07-5.07 1.07-6.71 1.34.45 3.1.9 4.88.62a.85.85 0 0 0 .48-.24",
      key: "9uv3tt"
    }
  ],
  [
    "path",
    {
      d: "M5.52 17.99c1.05.95 2.91 2.42 4.5 3.15a.8.8 0 0 0 1.13-.68c.2-2.34-.33-5.3-1.57-8.28",
      key: "1292wz"
    }
  ],
  [
    "path",
    {
      d: "M8.35 2.68a10 10 0 0 1 9.98 1.58c.43.35.4.96-.12 1.17-1.5.6-4.3.98-6.07 1.05",
      key: "7ozu9p"
    }
  ],
  ["path", { d: "m2 2 20 20", key: "1ooewy" }]
]);
const Sk = r("HopIcon", [
  [
    "path",
    {
      d: "M10.82 16.12c1.69.6 3.91.79 5.18.85.55.03 1-.42.97-.97-.06-1.27-.26-3.5-.85-5.18",
      key: "18lxf1"
    }
  ],
  [
    "path",
    {
      d: "M11.5 6.5c1.64 0 5-.38 6.71-1.07.52-.2.55-.82.12-1.17A10 10 0 0 0 4.26 18.33c.35.43.96.4 1.17-.12.69-1.71 1.07-5.07 1.07-6.71 1.34.45 3.1.9 4.88.62a.88.88 0 0 0 .73-.74c.3-2.14-.15-3.5-.61-4.88",
      key: "vtfxrw"
    }
  ],
  [
    "path",
    {
      d: "M15.62 16.95c.2.85.62 2.76.5 4.28a.77.77 0 0 1-.9.7 16.64 16.64 0 0 1-4.08-1.36",
      key: "13hl71"
    }
  ],
  [
    "path",
    {
      d: "M16.13 21.05c1.65.63 3.68.84 4.87.91a.9.9 0 0 0 .96-.96 17.68 17.68 0 0 0-.9-4.87",
      key: "1sl8oj"
    }
  ],
  [
    "path",
    {
      d: "M16.94 15.62c.86.2 2.77.62 4.29.5a.77.77 0 0 0 .7-.9 16.64 16.64 0 0 0-1.36-4.08",
      key: "19c6kt"
    }
  ],
  [
    "path",
    {
      d: "M17.99 5.52a20.82 20.82 0 0 1 3.15 4.5.8.8 0 0 1-.68 1.13c-2.33.2-5.3-.32-8.27-1.57",
      key: "85ghs3"
    }
  ],
  ["path", { d: "M4.93 4.93 3 3a.7.7 0 0 1 0-1", key: "x087yj" }],
  [
    "path",
    {
      d: "M9.58 12.18c1.24 2.98 1.77 5.95 1.57 8.28a.8.8 0 0 1-1.13.68 20.82 20.82 0 0 1-4.5-3.15",
      key: "11xdqo"
    }
  ]
]);
const Ck = r("HospitalIcon", [
  ["path", { d: "M12 6v4", key: "16clxf" }],
  ["path", { d: "M14 14h-4", key: "esezmu" }],
  ["path", { d: "M14 18h-4", key: "16mqa2" }],
  ["path", { d: "M14 8h-4", key: "z8ypaz" }],
  [
    "path",
    {
      d: "M18 12h2a2 2 0 0 1 2 2v6a2 2 0 0 1-2 2H4a2 2 0 0 1-2-2v-9a2 2 0 0 1 2-2h2",
      key: "b1k337"
    }
  ],
  ["path", { d: "M18 22V4a2 2 0 0 0-2-2H8a2 2 0 0 0-2 2v18", key: "16g51d" }]
]);
const Ak = r("HotelIcon", [
  ["path", { d: "M10 22v-6.57", key: "1wmca3" }],
  ["path", { d: "M12 11h.01", key: "z322tv" }],
  ["path", { d: "M12 7h.01", key: "1ivr5q" }],
  ["path", { d: "M14 15.43V22", key: "1q2vjd" }],
  ["path", { d: "M15 16a5 5 0 0 0-6 0", key: "o9wqvi" }],
  ["path", { d: "M16 11h.01", key: "xkw8gn" }],
  ["path", { d: "M16 7h.01", key: "1kdx03" }],
  ["path", { d: "M8 11h.01", key: "1dfujw" }],
  ["path", { d: "M8 7h.01", key: "1vti4s" }],
  ["rect", { x: "4", y: "2", width: "16", height: "20", rx: "2", key: "1uxh74" }]
]);
const Pk = r("HourglassIcon", [
  ["path", { d: "M5 22h14", key: "ehvnwv" }],
  ["path", { d: "M5 2h14", key: "pdyrp9" }],
  [
    "path",
    {
      d: "M17 22v-4.172a2 2 0 0 0-.586-1.414L12 12l-4.414 4.414A2 2 0 0 0 7 17.828V22",
      key: "1d314k"
    }
  ],
  [
    "path",
    { d: "M7 2v4.172a2 2 0 0 0 .586 1.414L12 12l4.414-4.414A2 2 0 0 0 17 6.172V2", key: "1vvvr6" }
  ]
]);
const In = r("IceCreamBowlIcon", [
  [
    "path",
    {
      d: "M12 17c5 0 8-2.69 8-6H4c0 3.31 3 6 8 6m-4 4h8m-4-3v3M5.14 11a3.5 3.5 0 1 1 6.71 0",
      key: "1uxfcu"
    }
  ],
  ["path", { d: "M12.14 11a3.5 3.5 0 1 1 6.71 0", key: "4k3m1s" }],
  ["path", { d: "M15.5 6.5a3.5 3.5 0 1 0-7 0", key: "zmuahr" }]
]);
const Ln = r("IceCreamConeIcon", [
  ["path", { d: "m7 11 4.08 10.35a1 1 0 0 0 1.84 0L17 11", key: "1v6356" }],
  ["path", { d: "M17 7A5 5 0 0 0 7 7", key: "151p3v" }],
  ["path", { d: "M17 7a2 2 0 0 1 0 4H7a2 2 0 0 1 0-4", key: "1sdaij" }]
]);
const qk = r("ImageDownIcon", [
  [
    "path",
    {
      d: "M10.3 21H5a2 2 0 0 1-2-2V5a2 2 0 0 1 2-2h14a2 2 0 0 1 2 2v10l-3.1-3.1a2 2 0 0 0-2.814.014L6 21",
      key: "9csbqa"
    }
  ],
  ["path", { d: "m14 19 3 3v-5.5", key: "9ldu5r" }],
  ["path", { d: "m17 22 3-3", key: "1nkfve" }],
  ["circle", { cx: "9", cy: "9", r: "2", key: "af1f0g" }]
]);
const Tk = r("ImageMinusIcon", [
  ["path", { d: "M21 9v10a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2V5a2 2 0 0 1 2-2h7", key: "m87ecr" }],
  ["line", { x1: "16", x2: "22", y1: "5", y2: "5", key: "ez7e4s" }],
  ["circle", { cx: "9", cy: "9", r: "2", key: "af1f0g" }],
  ["path", { d: "m21 15-3.086-3.086a2 2 0 0 0-2.828 0L6 21", key: "1xmnt7" }]
]);
const Dk = r("ImageOffIcon", [
  ["line", { x1: "2", x2: "22", y1: "2", y2: "22", key: "a6p6uj" }],
  ["path", { d: "M10.41 10.41a2 2 0 1 1-2.83-2.83", key: "1bzlo9" }],
  ["line", { x1: "13.5", x2: "6", y1: "13.5", y2: "21", key: "1q0aeu" }],
  ["line", { x1: "18", x2: "21", y1: "12", y2: "15", key: "5mozeu" }],
  [
    "path",
    {
      d: "M3.59 3.59A1.99 1.99 0 0 0 3 5v14a2 2 0 0 0 2 2h14c.55 0 1.052-.22 1.41-.59",
      key: "mmje98"
    }
  ],
  ["path", { d: "M21 15V5a2 2 0 0 0-2-2H9", key: "43el77" }]
]);
const _k = r("ImagePlusIcon", [
  ["path", { d: "M21 12v7a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2V5a2 2 0 0 1 2-2h7", key: "31hg93" }],
  ["line", { x1: "16", x2: "22", y1: "5", y2: "5", key: "ez7e4s" }],
  ["line", { x1: "19", x2: "19", y1: "2", y2: "8", key: "1gkr8c" }],
  ["circle", { cx: "9", cy: "9", r: "2", key: "af1f0g" }],
  ["path", { d: "m21 15-3.086-3.086a2 2 0 0 0-2.828 0L6 21", key: "1xmnt7" }]
]);
const Bk = r("ImageUpIcon", [
  [
    "path",
    {
      d: "M10.3 21H5a2 2 0 0 1-2-2V5a2 2 0 0 1 2-2h14a2 2 0 0 1 2 2v10l-3.1-3.1a2 2 0 0 0-2.814.014L6 21",
      key: "9csbqa"
    }
  ],
  ["path", { d: "m14 19.5 3-3 3 3", key: "9vmjn0" }],
  ["path", { d: "M17 22v-5.5", key: "1aa6fl" }],
  ["circle", { cx: "9", cy: "9", r: "2", key: "af1f0g" }]
]);
const zk = r("ImageIcon", [
  ["rect", { width: "18", height: "18", x: "3", y: "3", rx: "2", ry: "2", key: "1m3agn" }],
  ["circle", { cx: "9", cy: "9", r: "2", key: "af1f0g" }],
  ["path", { d: "m21 15-3.086-3.086a2 2 0 0 0-2.828 0L6 21", key: "1xmnt7" }]
]);
const Hk = r("ImagesIcon", [
  ["path", { d: "M18 22H4a2 2 0 0 1-2-2V6", key: "pblm9e" }],
  ["path", { d: "m22 13-1.296-1.296a2.41 2.41 0 0 0-3.408 0L11 18", key: "nf6bnh" }],
  ["circle", { cx: "12", cy: "8", r: "2", key: "1822b1" }],
  ["rect", { width: "16", height: "16", x: "6", y: "2", rx: "2", key: "12espp" }]
]);
const jk = r("ImportIcon", [
  ["path", { d: "M12 3v12", key: "1x0j5s" }],
  ["path", { d: "m8 11 4 4 4-4", key: "1dohi6" }],
  [
    "path",
    {
      d: "M8 5H4a2 2 0 0 0-2 2v10a2 2 0 0 0 2 2h16a2 2 0 0 0 2-2V7a2 2 0 0 0-2-2h-4",
      key: "1ywtjm"
    }
  ]
]);
const Vk = r("InboxIcon", [
  ["polyline", { points: "22 12 16 12 14 15 10 15 8 12 2 12", key: "o97t9d" }],
  [
    "path",
    {
      d: "M5.45 5.11 2 12v6a2 2 0 0 0 2 2h16a2 2 0 0 0 2-2v-6l-3.45-6.89A2 2 0 0 0 16.76 4H7.24a2 2 0 0 0-1.79 1.11z",
      key: "oot6mr"
    }
  ]
]);
const Sn = r("IndentDecreaseIcon", [
  ["polyline", { points: "7 8 3 12 7 16", key: "2j60jr" }],
  ["line", { x1: "21", x2: "11", y1: "12", y2: "12", key: "1fxxak" }],
  ["line", { x1: "21", x2: "11", y1: "6", y2: "6", key: "asgu94" }],
  ["line", { x1: "21", x2: "11", y1: "18", y2: "18", key: "13dsj7" }]
]);
const Cn = r("IndentIncreaseIcon", [
  ["polyline", { points: "3 8 7 12 3 16", key: "f3rxhf" }],
  ["line", { x1: "21", x2: "11", y1: "12", y2: "12", key: "1fxxak" }],
  ["line", { x1: "21", x2: "11", y1: "6", y2: "6", key: "asgu94" }],
  ["line", { x1: "21", x2: "11", y1: "18", y2: "18", key: "13dsj7" }]
]);
const Ok = r("IndianRupeeIcon", [
  ["path", { d: "M6 3h12", key: "ggurg9" }],
  ["path", { d: "M6 8h12", key: "6g4wlu" }],
  ["path", { d: "m6 13 8.5 8", key: "u1kupk" }],
  ["path", { d: "M6 13h3", key: "wdp6ag" }],
  ["path", { d: "M9 13c6.667 0 6.667-10 0-10", key: "1nkvk2" }]
]);
const $k = r("InfinityIcon", [
  [
    "path",
    {
      d: "M12 12c-2-2.67-4-4-6-4a4 4 0 1 0 0 8c2 0 4-1.33 6-4Zm0 0c2 2.67 4 4 6 4a4 4 0 0 0 0-8c-2 0-4 1.33-6 4Z",
      key: "1z0uae"
    }
  ]
]);
const Rk = r("InfoIcon", [
  ["circle", { cx: "12", cy: "12", r: "10", key: "1mglay" }],
  ["path", { d: "M12 16v-4", key: "1dtifu" }],
  ["path", { d: "M12 8h.01", key: "e9boi3" }]
]);
const Fk = r("InspectionPanelIcon", [
  ["rect", { width: "18", height: "18", x: "3", y: "3", rx: "2", key: "afitv7" }],
  ["path", { d: "M7 7h.01", key: "7u93v4" }],
  ["path", { d: "M17 7h.01", key: "14a9sn" }],
  ["path", { d: "M7 17h.01", key: "19xn7k" }],
  ["path", { d: "M17 17h.01", key: "1sd3ek" }]
]);
const Uk = r("InstagramIcon", [
  ["rect", { width: "20", height: "20", x: "2", y: "2", rx: "5", ry: "5", key: "2e1cvw" }],
  ["path", { d: "M16 11.37A4 4 0 1 1 12.63 8 4 4 0 0 1 16 11.37z", key: "9exkf1" }],
  ["line", { x1: "17.5", x2: "17.51", y1: "6.5", y2: "6.5", key: "r4j83e" }]
]);
const Ek = r("ItalicIcon", [
  ["line", { x1: "19", x2: "10", y1: "4", y2: "4", key: "15jd3p" }],
  ["line", { x1: "14", x2: "5", y1: "20", y2: "20", key: "bu0au3" }],
  ["line", { x1: "15", x2: "9", y1: "4", y2: "20", key: "uljnxc" }]
]);
const Wk = r("IterationCcwIcon", [
  ["path", { d: "M20 10c0-4.4-3.6-8-8-8s-8 3.6-8 8 3.6 8 8 8h8", key: "4znkd0" }],
  ["polyline", { points: "16 14 20 18 16 22", key: "11njsm" }]
]);
const Nk = r("IterationCwIcon", [
  ["path", { d: "M4 10c0-4.4 3.6-8 8-8s8 3.6 8 8-3.6 8-8 8H4", key: "tuf4su" }],
  ["polyline", { points: "8 22 4 18 8 14", key: "evkj9s" }]
]);
const Zk = r("JapaneseYenIcon", [
  ["path", { d: "M12 9.5V21m0-11.5L6 3m6 6.5L18 3", key: "2ej80x" }],
  ["path", { d: "M6 15h12", key: "1hwgt5" }],
  ["path", { d: "M6 11h12", key: "wf4gp6" }]
]);
const Yk = r("JoystickIcon", [
  [
    "path",
    {
      d: "M21 17a2 2 0 0 0-2-2H5a2 2 0 0 0-2 2v2a2 2 0 0 0 2 2h14a2 2 0 0 0 2-2v-2Z",
      key: "jg2n2t"
    }
  ],
  ["path", { d: "M6 15v-2", key: "gd6mvg" }],
  ["path", { d: "M12 15V9", key: "8c7uyn" }],
  ["circle", { cx: "12", cy: "6", r: "3", key: "1gm2ql" }]
]);
const Gk = r("KanbanIcon", [
  ["path", { d: "M6 5v11", key: "mdvv1e" }],
  ["path", { d: "M12 5v6", key: "14ar3b" }],
  ["path", { d: "M18 5v14", key: "7ji314" }]
]);
const Xk = r("KeyRoundIcon", [
  ["path", { d: "M2 18v3c0 .6.4 1 1 1h4v-3h3v-3h2l1.4-1.4a6.5 6.5 0 1 0-4-4Z", key: "167ctg" }],
  ["circle", { cx: "16.5", cy: "7.5", r: ".5", fill: "currentColor", key: "w0ekpg" }]
]);
const Kk = r("KeySquareIcon", [
  [
    "path",
    {
      d: "M12.4 2.7c.9-.9 2.5-.9 3.4 0l5.5 5.5c.9.9.9 2.5 0 3.4l-3.7 3.7c-.9.9-2.5.9-3.4 0L8.7 9.8c-.9-.9-.9-2.5 0-3.4Z",
      key: "9li5bk"
    }
  ],
  ["path", { d: "m14 7 3 3", key: "1r5n42" }],
  ["path", { d: "M9.4 10.6 2 18v3c0 .6.4 1 1 1h4v-3h3v-3h2l1.4-1.4", key: "1ym3zm" }]
]);
const Qk = r("KeyIcon", [
  ["circle", { cx: "7.5", cy: "15.5", r: "5.5", key: "yqb3hr" }],
  ["path", { d: "m21 2-9.6 9.6", key: "1j0ho8" }],
  ["path", { d: "m15.5 7.5 3 3L22 7l-3-3", key: "1rn1fs" }]
]);
const Jk = r("KeyboardMusicIcon", [
  ["rect", { width: "20", height: "16", x: "2", y: "4", rx: "2", key: "18n3k1" }],
  ["path", { d: "M6 8h4", key: "utf9t1" }],
  ["path", { d: "M14 8h.01", key: "1primd" }],
  ["path", { d: "M18 8h.01", key: "emo2bl" }],
  ["path", { d: "M2 12h20", key: "9i4pu4" }],
  ["path", { d: "M6 12v4", key: "dy92yo" }],
  ["path", { d: "M10 12v4", key: "1fxnav" }],
  ["path", { d: "M14 12v4", key: "1hft58" }],
  ["path", { d: "M18 12v4", key: "tjjnbz" }]
]);
const e4 = r("KeyboardIcon", [
  ["path", { d: "M10 8h.01", key: "1r9ogq" }],
  ["path", { d: "M12 12h.01", key: "1mp3jc" }],
  ["path", { d: "M14 8h.01", key: "1primd" }],
  ["path", { d: "M16 12h.01", key: "1l6xoz" }],
  ["path", { d: "M18 8h.01", key: "emo2bl" }],
  ["path", { d: "M6 8h.01", key: "x9i8wu" }],
  ["path", { d: "M7 16h10", key: "wp8him" }],
  ["path", { d: "M8 12h.01", key: "czm47f" }],
  ["rect", { width: "20", height: "16", x: "2", y: "4", rx: "2", key: "18n3k1" }]
]);
const t4 = r("LampCeilingIcon", [
  ["path", { d: "M12 2v5", key: "nd4vlx" }],
  ["path", { d: "M6 7h12l4 9H2l4-9Z", key: "123d64" }],
  ["path", { d: "M9.17 16a3 3 0 1 0 5.66 0", key: "1061mw" }]
]);
const a4 = r("LampDeskIcon", [
  ["path", { d: "m14 5-3 3 2 7 8-8-7-2Z", key: "1b0msb" }],
  ["path", { d: "m14 5-3 3-3-3 3-3 3 3Z", key: "1uemms" }],
  ["path", { d: "M9.5 6.5 4 12l3 6", key: "1bx08v" }],
  ["path", { d: "M3 22v-2c0-1.1.9-2 2-2h4a2 2 0 0 1 2 2v2H3Z", key: "wap775" }]
]);
const n4 = r("LampFloorIcon", [
  ["path", { d: "M9 2h6l3 7H6l3-7Z", key: "wcx6mj" }],
  ["path", { d: "M12 9v13", key: "3n1su1" }],
  ["path", { d: "M9 22h6", key: "1rlq3v" }]
]);
const o4 = r("LampWallDownIcon", [
  ["path", { d: "M11 13h6l3 7H8l3-7Z", key: "9n3qlo" }],
  ["path", { d: "M14 13V8a2 2 0 0 0-2-2H8", key: "1hu4hb" }],
  ["path", { d: "M4 9h2a2 2 0 0 0 2-2V5a2 2 0 0 0-2-2H4v6Z", key: "s053bc" }]
]);
const r4 = r("LampWallUpIcon", [
  ["path", { d: "M11 4h6l3 7H8l3-7Z", key: "11x1ee" }],
  ["path", { d: "M14 11v5a2 2 0 0 1-2 2H8", key: "eutp5o" }],
  ["path", { d: "M4 15h2a2 2 0 0 1 2 2v2a2 2 0 0 1-2 2H4v-6Z", key: "1iuthr" }]
]);
const i4 = r("LampIcon", [
  ["path", { d: "M8 2h8l4 10H4L8 2Z", key: "9dma5w" }],
  ["path", { d: "M12 12v6", key: "3ahymv" }],
  ["path", { d: "M8 22v-2c0-1.1.9-2 2-2h4a2 2 0 0 1 2 2v2H8Z", key: "mwf4oh" }]
]);
const l4 = r("LandPlotIcon", [
  ["path", { d: "m12 8 6-3-6-3v10", key: "mvpnpy" }],
  [
    "path",
    {
      d: "m8 11.99-5.5 3.14a1 1 0 0 0 0 1.74l8.5 4.86a2 2 0 0 0 2 0l8.5-4.86a1 1 0 0 0 0-1.74L16 12",
      key: "ek95tt"
    }
  ],
  ["path", { d: "m6.49 12.85 11.02 6.3", key: "1kt42w" }],
  ["path", { d: "M17.51 12.85 6.5 19.15", key: "v55bdg" }]
]);
const c4 = r("LandmarkIcon", [
  ["line", { x1: "3", x2: "21", y1: "22", y2: "22", key: "j8o0r" }],
  ["line", { x1: "6", x2: "6", y1: "18", y2: "11", key: "10tf0k" }],
  ["line", { x1: "10", x2: "10", y1: "18", y2: "11", key: "54lgf6" }],
  ["line", { x1: "14", x2: "14", y1: "18", y2: "11", key: "380y" }],
  ["line", { x1: "18", x2: "18", y1: "18", y2: "11", key: "1kevvc" }],
  ["polygon", { points: "12 2 20 7 4 7", key: "jkujk7" }]
]);
const d4 = r("LanguagesIcon", [
  ["path", { d: "m5 8 6 6", key: "1wu5hv" }],
  ["path", { d: "m4 14 6-6 2-3", key: "1k1g8d" }],
  ["path", { d: "M2 5h12", key: "or177f" }],
  ["path", { d: "M7 2h1", key: "1t2jsx" }],
  ["path", { d: "m22 22-5-10-5 10", key: "don7ne" }],
  ["path", { d: "M14 18h6", key: "1m8k6r" }]
]);
const An = r("LaptopMinimalIcon", [
  ["rect", { width: "18", height: "12", x: "3", y: "4", rx: "2", ry: "2", key: "1qhy41" }],
  ["line", { x1: "2", x2: "22", y1: "20", y2: "20", key: "ni3hll" }]
]);
const s4 = r("LaptopIcon", [
  [
    "path",
    {
      d: "M20 16V7a2 2 0 0 0-2-2H6a2 2 0 0 0-2 2v9m16 0H4m16 0 1.28 2.55a1 1 0 0 1-.9 1.45H3.62a1 1 0 0 1-.9-1.45L4 16",
      key: "tarvll"
    }
  ]
]);
const u4 = r("LassoSelectIcon", [
  ["path", { d: "M7 22a5 5 0 0 1-2-4", key: "umushi" }],
  ["path", { d: "M7 16.93c.96.43 1.96.74 2.99.91", key: "ybbtv3" }],
  [
    "path",
    {
      d: "M3.34 14A6.8 6.8 0 0 1 2 10c0-4.42 4.48-8 10-8s10 3.58 10 8a7.19 7.19 0 0 1-.33 2",
      key: "gt5e1w"
    }
  ],
  ["path", { d: "M5 18a2 2 0 1 0 0-4 2 2 0 0 0 0 4z", key: "bq3ynw" }],
  [
    "path",
    {
      d: "M14.33 22h-.09a.35.35 0 0 1-.24-.32v-10a.34.34 0 0 1 .33-.34c.08 0 .15.03.21.08l7.34 6a.33.33 0 0 1-.21.59h-4.49l-2.57 3.85a.35.35 0 0 1-.28.14v0z",
      key: "1bawls"
    }
  ]
]);
const h4 = r("LassoIcon", [
  ["path", { d: "M7 22a5 5 0 0 1-2-4", key: "umushi" }],
  [
    "path",
    {
      d: "M3.3 14A6.8 6.8 0 0 1 2 10c0-4.4 4.5-8 10-8s10 3.6 10 8-4.5 8-10 8a12 12 0 0 1-5-1",
      key: "146dds"
    }
  ],
  ["path", { d: "M5 18a2 2 0 1 0 0-4 2 2 0 0 0 0 4z", key: "bq3ynw" }]
]);
const p4 = r("LaughIcon", [
  ["circle", { cx: "12", cy: "12", r: "10", key: "1mglay" }],
  ["path", { d: "M18 13a6 6 0 0 1-6 5 6 6 0 0 1-6-5h12Z", key: "b2q4dd" }],
  ["line", { x1: "9", x2: "9.01", y1: "9", y2: "9", key: "yxxnd0" }],
  ["line", { x1: "15", x2: "15.01", y1: "9", y2: "9", key: "1p4y9e" }]
]);
const y4 = r("Layers2Icon", [
  [
    "path",
    {
      d: "m16.02 12 5.48 3.13a1 1 0 0 1 0 1.74L13 21.74a2 2 0 0 1-2 0l-8.5-4.87a1 1 0 0 1 0-1.74L7.98 12",
      key: "1cuww1"
    }
  ],
  [
    "path",
    {
      d: "M13 13.74a2 2 0 0 1-2 0L2.5 8.87a1 1 0 0 1 0-1.74L11 2.26a2 2 0 0 1 2 0l8.5 4.87a1 1 0 0 1 0 1.74Z",
      key: "pdlvxu"
    }
  ]
]);
const k4 = r("Layers3Icon", [
  [
    "path",
    {
      d: "m12.83 2.18a2 2 0 0 0-1.66 0L2.6 6.08a1 1 0 0 0 0 1.83l8.58 3.91a2 2 0 0 0 1.66 0l8.58-3.9a1 1 0 0 0 0-1.83Z",
      key: "8b97xw"
    }
  ],
  [
    "path",
    {
      d: "m6.08 9.5-3.5 1.6a1 1 0 0 0 0 1.81l8.6 3.91a2 2 0 0 0 1.65 0l8.58-3.9a1 1 0 0 0 0-1.83l-3.5-1.59",
      key: "1e5n1m"
    }
  ],
  [
    "path",
    {
      d: "m6.08 14.5-3.5 1.6a1 1 0 0 0 0 1.81l8.6 3.91a2 2 0 0 0 1.65 0l8.58-3.9a1 1 0 0 0 0-1.83l-3.5-1.59",
      key: "1iwflc"
    }
  ]
]);
const f4 = r("LayersIcon", [
  [
    "path",
    {
      d: "m12.83 2.18a2 2 0 0 0-1.66 0L2.6 6.08a1 1 0 0 0 0 1.83l8.58 3.91a2 2 0 0 0 1.66 0l8.58-3.9a1 1 0 0 0 0-1.83Z",
      key: "8b97xw"
    }
  ],
  ["path", { d: "m22 17.65-9.17 4.16a2 2 0 0 1-1.66 0L2 17.65", key: "dd6zsq" }],
  ["path", { d: "m22 12.65-9.17 4.16a2 2 0 0 1-1.66 0L2 12.65", key: "ep9fru" }]
]);
const v4 = r("LayoutDashboardIcon", [
  ["rect", { width: "7", height: "9", x: "3", y: "3", rx: "1", key: "10lvy0" }],
  ["rect", { width: "7", height: "5", x: "14", y: "3", rx: "1", key: "16une8" }],
  ["rect", { width: "7", height: "9", x: "14", y: "12", rx: "1", key: "1hutg5" }],
  ["rect", { width: "7", height: "5", x: "3", y: "16", rx: "1", key: "ldoo1y" }]
]);
const m4 = r("LayoutGridIcon", [
  ["rect", { width: "7", height: "7", x: "3", y: "3", rx: "1", key: "1g98yp" }],
  ["rect", { width: "7", height: "7", x: "14", y: "3", rx: "1", key: "6d4xhi" }],
  ["rect", { width: "7", height: "7", x: "14", y: "14", rx: "1", key: "nxv5o0" }],
  ["rect", { width: "7", height: "7", x: "3", y: "14", rx: "1", key: "1bb6yr" }]
]);
const g4 = r("LayoutListIcon", [
  ["rect", { width: "7", height: "7", x: "3", y: "3", rx: "1", key: "1g98yp" }],
  ["rect", { width: "7", height: "7", x: "3", y: "14", rx: "1", key: "1bb6yr" }],
  ["path", { d: "M14 4h7", key: "3xa0d5" }],
  ["path", { d: "M14 9h7", key: "1icrd9" }],
  ["path", { d: "M14 15h7", key: "1mj8o2" }],
  ["path", { d: "M14 20h7", key: "11slyb" }]
]);
const M4 = r("LayoutPanelLeftIcon", [
  ["rect", { width: "7", height: "18", x: "3", y: "3", rx: "1", key: "2obqm" }],
  ["rect", { width: "7", height: "7", x: "14", y: "3", rx: "1", key: "6d4xhi" }],
  ["rect", { width: "7", height: "7", x: "14", y: "14", rx: "1", key: "nxv5o0" }]
]);
const x4 = r("LayoutPanelTopIcon", [
  ["rect", { width: "18", height: "7", x: "3", y: "3", rx: "1", key: "f1a2em" }],
  ["rect", { width: "7", height: "7", x: "3", y: "14", rx: "1", key: "1bb6yr" }],
  ["rect", { width: "7", height: "7", x: "14", y: "14", rx: "1", key: "nxv5o0" }]
]);
const b4 = r("LayoutTemplateIcon", [
  ["rect", { width: "18", height: "7", x: "3", y: "3", rx: "1", key: "f1a2em" }],
  ["rect", { width: "9", height: "7", x: "3", y: "14", rx: "1", key: "jqznyg" }],
  ["rect", { width: "5", height: "7", x: "16", y: "14", rx: "1", key: "q5h2i8" }]
]);
const w4 = r("LeafIcon", [
  [
    "path",
    {
      d: "M11 20A7 7 0 0 1 9.8 6.1C15.5 5 17 4.48 19 2c1 2 2 4.18 2 8 0 5.5-4.78 10-10 10Z",
      key: "nnexq3"
    }
  ],
  ["path", { d: "M2 21c0-3 1.85-5.36 5.08-6C9.5 14.52 12 13 13 12", key: "mt58a7" }]
]);
const I4 = r("LeafyGreenIcon", [
  [
    "path",
    {
      d: "M2 22c1.25-.987 2.27-1.975 3.9-2.2a5.56 5.56 0 0 1 3.8 1.5 4 4 0 0 0 6.187-2.353 3.5 3.5 0 0 0 3.69-5.116A3.5 3.5 0 0 0 20.95 8 3.5 3.5 0 1 0 16 3.05a3.5 3.5 0 0 0-5.831 1.373 3.5 3.5 0 0 0-5.116 3.69 4 4 0 0 0-2.348 6.155C3.499 15.42 4.409 16.712 4.2 18.1 3.926 19.743 3.014 20.732 2 22",
      key: "1134nt"
    }
  ],
  ["path", { d: "M2 22 17 7", key: "1q7jp2" }]
]);
const L4 = r("LibraryBigIcon", [
  ["rect", { width: "8", height: "18", x: "3", y: "3", rx: "1", key: "oynpb5" }],
  ["path", { d: "M7 3v18", key: "bbkbws" }],
  [
    "path",
    {
      d: "M20.4 18.9c.2.5-.1 1.1-.6 1.3l-1.9.7c-.5.2-1.1-.1-1.3-.6L11.1 5.1c-.2-.5.1-1.1.6-1.3l1.9-.7c.5-.2 1.1.1 1.3.6Z",
      key: "1qboyk"
    }
  ]
]);
const S4 = r("LibraryIcon", [
  ["path", { d: "m16 6 4 14", key: "ji33uf" }],
  ["path", { d: "M12 6v14", key: "1n7gus" }],
  ["path", { d: "M8 8v12", key: "1gg7y9" }],
  ["path", { d: "M4 4v16", key: "6qkkli" }]
]);
const C4 = r("LifeBuoyIcon", [
  ["circle", { cx: "12", cy: "12", r: "10", key: "1mglay" }],
  ["path", { d: "m4.93 4.93 4.24 4.24", key: "1ymg45" }],
  ["path", { d: "m14.83 9.17 4.24-4.24", key: "1cb5xl" }],
  ["path", { d: "m14.83 14.83 4.24 4.24", key: "q42g0n" }],
  ["path", { d: "m9.17 14.83-4.24 4.24", key: "bqpfvv" }],
  ["circle", { cx: "12", cy: "12", r: "4", key: "4exip2" }]
]);
const A4 = r("LigatureIcon", [
  ["path", { d: "M8 20V8c0-2.2 1.8-4 4-4 1.5 0 2.8.8 3.5 2", key: "1rtphz" }],
  ["path", { d: "M6 12h4", key: "a4o3ry" }],
  ["path", { d: "M14 12h2v8", key: "c1fccl" }],
  ["path", { d: "M6 20h4", key: "1i6q5t" }],
  ["path", { d: "M14 20h4", key: "lzx1xo" }]
]);
const P4 = r("LightbulbOffIcon", [
  ["path", { d: "M16.8 11.2c.8-.9 1.2-2 1.2-3.2a6 6 0 0 0-9.3-5", key: "1fkcox" }],
  ["path", { d: "m2 2 20 20", key: "1ooewy" }],
  ["path", { d: "M6.3 6.3a4.67 4.67 0 0 0 1.2 5.2c.7.7 1.3 1.5 1.5 2.5", key: "10m8kw" }],
  ["path", { d: "M9 18h6", key: "x1upvd" }],
  ["path", { d: "M10 22h4", key: "ceow96" }]
]);
const q4 = r("LightbulbIcon", [
  [
    "path",
    {
      d: "M15 14c.2-1 .7-1.7 1.5-2.5 1-.9 1.5-2.2 1.5-3.5A6 6 0 0 0 6 8c0 1 .2 2.2 1.5 3.5.7.7 1.3 1.5 1.5 2.5",
      key: "1gvzjb"
    }
  ],
  ["path", { d: "M9 18h6", key: "x1upvd" }],
  ["path", { d: "M10 22h4", key: "ceow96" }]
]);
const T4 = r("LineChartIcon", [
  ["path", { d: "M3 3v18h18", key: "1s2lah" }],
  ["path", { d: "m19 9-5 5-4-4-3 3", key: "2osh9i" }]
]);
const D4 = r("Link2OffIcon", [
  ["path", { d: "M9 17H7A5 5 0 0 1 7 7", key: "10o201" }],
  ["path", { d: "M15 7h2a5 5 0 0 1 4 8", key: "1d3206" }],
  ["line", { x1: "8", x2: "12", y1: "12", y2: "12", key: "rvw6j4" }],
  ["line", { x1: "2", x2: "22", y1: "2", y2: "22", key: "a6p6uj" }]
]);
const _4 = r("Link2Icon", [
  ["path", { d: "M9 17H7A5 5 0 0 1 7 7h2", key: "8i5ue5" }],
  ["path", { d: "M15 7h2a5 5 0 1 1 0 10h-2", key: "1b9ql8" }],
  ["line", { x1: "8", x2: "16", y1: "12", y2: "12", key: "1jonct" }]
]);
const B4 = r("LinkIcon", [
  ["path", { d: "M10 13a5 5 0 0 0 7.54.54l3-3a5 5 0 0 0-7.07-7.07l-1.72 1.71", key: "1cjeqo" }],
  ["path", { d: "M14 11a5 5 0 0 0-7.54-.54l-3 3a5 5 0 0 0 7.07 7.07l1.71-1.71", key: "19qd67" }]
]);
const z4 = r("LinkedinIcon", [
  [
    "path",
    {
      d: "M16 8a6 6 0 0 1 6 6v7h-4v-7a2 2 0 0 0-2-2 2 2 0 0 0-2 2v7h-4v-7a6 6 0 0 1 6-6z",
      key: "c2jq9f"
    }
  ],
  ["rect", { width: "4", height: "12", x: "2", y: "9", key: "mk3on5" }],
  ["circle", { cx: "4", cy: "4", r: "2", key: "bt5ra8" }]
]);
const H4 = r("ListChecksIcon", [
  ["path", { d: "m3 17 2 2 4-4", key: "1jhpwq" }],
  ["path", { d: "m3 7 2 2 4-4", key: "1obspn" }],
  ["path", { d: "M13 6h8", key: "15sg57" }],
  ["path", { d: "M13 12h8", key: "h98zly" }],
  ["path", { d: "M13 18h8", key: "oe0vm4" }]
]);
const j4 = r("ListCollapseIcon", [
  ["path", { d: "m3 10 2.5-2.5L3 5", key: "i6eama" }],
  ["path", { d: "m3 19 2.5-2.5L3 14", key: "w2gmor" }],
  ["path", { d: "M10 6h11", key: "c7qv1k" }],
  ["path", { d: "M10 12h11", key: "6m4ad9" }],
  ["path", { d: "M10 18h11", key: "11hvi2" }]
]);
const V4 = r("ListEndIcon", [
  ["path", { d: "M16 12H3", key: "1a2rj7" }],
  ["path", { d: "M16 6H3", key: "1wxfjs" }],
  ["path", { d: "M10 18H3", key: "13769t" }],
  ["path", { d: "M21 6v10a2 2 0 0 1-2 2h-5", key: "ilrcs8" }],
  ["path", { d: "m16 16-2 2 2 2", key: "kkc6pm" }]
]);
const O4 = r("ListFilterIcon", [
  ["path", { d: "M3 6h18", key: "d0wm0j" }],
  ["path", { d: "M7 12h10", key: "b7w52i" }],
  ["path", { d: "M10 18h4", key: "1ulq68" }]
]);
const $4 = r("ListMinusIcon", [
  ["path", { d: "M11 12H3", key: "51ecnj" }],
  ["path", { d: "M16 6H3", key: "1wxfjs" }],
  ["path", { d: "M16 18H3", key: "12xzn7" }],
  ["path", { d: "M21 12h-6", key: "bt1uis" }]
]);
const R4 = r("ListMusicIcon", [
  ["path", { d: "M21 15V6", key: "h1cx4g" }],
  ["path", { d: "M18.5 18a2.5 2.5 0 1 0 0-5 2.5 2.5 0 0 0 0 5Z", key: "8saifv" }],
  ["path", { d: "M12 12H3", key: "18klou" }],
  ["path", { d: "M16 6H3", key: "1wxfjs" }],
  ["path", { d: "M12 18H3", key: "11ftsu" }]
]);
const F4 = r("ListOrderedIcon", [
  ["line", { x1: "10", x2: "21", y1: "6", y2: "6", key: "76qw6h" }],
  ["line", { x1: "10", x2: "21", y1: "12", y2: "12", key: "16nom4" }],
  ["line", { x1: "10", x2: "21", y1: "18", y2: "18", key: "u3jurt" }],
  ["path", { d: "M4 6h1v4", key: "cnovpq" }],
  ["path", { d: "M4 10h2", key: "16xx2s" }],
  ["path", { d: "M6 18H4c0-1 2-2 2-3s-1-1.5-2-1", key: "m9a95d" }]
]);
const U4 = r("ListPlusIcon", [
  ["path", { d: "M11 12H3", key: "51ecnj" }],
  ["path", { d: "M16 6H3", key: "1wxfjs" }],
  ["path", { d: "M16 18H3", key: "12xzn7" }],
  ["path", { d: "M18 9v6", key: "1twb98" }],
  ["path", { d: "M21 12h-6", key: "bt1uis" }]
]);
const E4 = r("ListRestartIcon", [
  ["path", { d: "M21 6H3", key: "1jwq7v" }],
  ["path", { d: "M7 12H3", key: "13ou7f" }],
  ["path", { d: "M7 18H3", key: "1sijw9" }],
  [
    "path",
    {
      d: "M12 18a5 5 0 0 0 9-3 4.5 4.5 0 0 0-4.5-4.5c-1.33 0-2.54.54-3.41 1.41L11 14",
      key: "qth677"
    }
  ],
  ["path", { d: "M11 10v4h4", key: "172dkj" }]
]);
const W4 = r("ListStartIcon", [
  ["path", { d: "M16 12H3", key: "1a2rj7" }],
  ["path", { d: "M16 18H3", key: "12xzn7" }],
  ["path", { d: "M10 6H3", key: "lf8lx7" }],
  ["path", { d: "M21 18V8a2 2 0 0 0-2-2h-5", key: "1hghli" }],
  ["path", { d: "m16 8-2-2 2-2", key: "160uvd" }]
]);
const N4 = r("ListTodoIcon", [
  ["rect", { x: "3", y: "5", width: "6", height: "6", rx: "1", key: "1defrl" }],
  ["path", { d: "m3 17 2 2 4-4", key: "1jhpwq" }],
  ["path", { d: "M13 6h8", key: "15sg57" }],
  ["path", { d: "M13 12h8", key: "h98zly" }],
  ["path", { d: "M13 18h8", key: "oe0vm4" }]
]);
const Z4 = r("ListTreeIcon", [
  ["path", { d: "M21 12h-8", key: "1bmf0i" }],
  ["path", { d: "M21 6H8", key: "1pqkrb" }],
  ["path", { d: "M21 18h-8", key: "1tm79t" }],
  ["path", { d: "M3 6v4c0 1.1.9 2 2 2h3", key: "1ywdgy" }],
  ["path", { d: "M3 10v6c0 1.1.9 2 2 2h3", key: "2wc746" }]
]);
const Y4 = r("ListVideoIcon", [
  ["path", { d: "M12 12H3", key: "18klou" }],
  ["path", { d: "M16 6H3", key: "1wxfjs" }],
  ["path", { d: "M12 18H3", key: "11ftsu" }],
  ["path", { d: "m16 12 5 3-5 3v-6Z", key: "zpskkp" }]
]);
const G4 = r("ListXIcon", [
  ["path", { d: "M11 12H3", key: "51ecnj" }],
  ["path", { d: "M16 6H3", key: "1wxfjs" }],
  ["path", { d: "M16 18H3", key: "12xzn7" }],
  ["path", { d: "m19 10-4 4", key: "1tz659" }],
  ["path", { d: "m15 10 4 4", key: "1n7nei" }]
]);
const X4 = r("ListIcon", [
  ["line", { x1: "8", x2: "21", y1: "6", y2: "6", key: "7ey8pc" }],
  ["line", { x1: "8", x2: "21", y1: "12", y2: "12", key: "rjfblc" }],
  ["line", { x1: "8", x2: "21", y1: "18", y2: "18", key: "c3b1m8" }],
  ["line", { x1: "3", x2: "3.01", y1: "6", y2: "6", key: "1g7gq3" }],
  ["line", { x1: "3", x2: "3.01", y1: "12", y2: "12", key: "1pjlvk" }],
  ["line", { x1: "3", x2: "3.01", y1: "18", y2: "18", key: "28t2mc" }]
]);
const Pn = r("LoaderCircleIcon", [
  ["path", { d: "M21 12a9 9 0 1 1-6.219-8.56", key: "13zald" }]
]);
const K4 = r("LoaderIcon", [
  ["line", { x1: "12", x2: "12", y1: "2", y2: "6", key: "gza1u7" }],
  ["line", { x1: "12", x2: "12", y1: "18", y2: "22", key: "1qhbu9" }],
  ["line", { x1: "4.93", x2: "7.76", y1: "4.93", y2: "7.76", key: "xae44r" }],
  ["line", { x1: "16.24", x2: "19.07", y1: "16.24", y2: "19.07", key: "bxnmvf" }],
  ["line", { x1: "2", x2: "6", y1: "12", y2: "12", key: "89khin" }],
  ["line", { x1: "18", x2: "22", y1: "12", y2: "12", key: "pb8tfm" }],
  ["line", { x1: "4.93", x2: "7.76", y1: "19.07", y2: "16.24", key: "1uxjnu" }],
  ["line", { x1: "16.24", x2: "19.07", y1: "7.76", y2: "4.93", key: "6duxfx" }]
]);
const Q4 = r("LocateFixedIcon", [
  ["line", { x1: "2", x2: "5", y1: "12", y2: "12", key: "bvdh0s" }],
  ["line", { x1: "19", x2: "22", y1: "12", y2: "12", key: "1tbv5k" }],
  ["line", { x1: "12", x2: "12", y1: "2", y2: "5", key: "11lu5j" }],
  ["line", { x1: "12", x2: "12", y1: "19", y2: "22", key: "x3vr5v" }],
  ["circle", { cx: "12", cy: "12", r: "7", key: "fim9np" }],
  ["circle", { cx: "12", cy: "12", r: "3", key: "1v7zrd" }]
]);
const J4 = r("LocateOffIcon", [
  ["line", { x1: "2", x2: "5", y1: "12", y2: "12", key: "bvdh0s" }],
  ["line", { x1: "19", x2: "22", y1: "12", y2: "12", key: "1tbv5k" }],
  ["line", { x1: "12", x2: "12", y1: "2", y2: "5", key: "11lu5j" }],
  ["line", { x1: "12", x2: "12", y1: "19", y2: "22", key: "x3vr5v" }],
  [
    "path",
    {
      d: "M7.11 7.11C5.83 8.39 5 10.1 5 12c0 3.87 3.13 7 7 7 1.9 0 3.61-.83 4.89-2.11",
      key: "1oh7ia"
    }
  ],
  [
    "path",
    {
      d: "M18.71 13.96c.19-.63.29-1.29.29-1.96 0-3.87-3.13-7-7-7-.67 0-1.33.1-1.96.29",
      key: "3qdecy"
    }
  ],
  ["line", { x1: "2", x2: "22", y1: "2", y2: "22", key: "a6p6uj" }]
]);
const ef = r("LocateIcon", [
  ["line", { x1: "2", x2: "5", y1: "12", y2: "12", key: "bvdh0s" }],
  ["line", { x1: "19", x2: "22", y1: "12", y2: "12", key: "1tbv5k" }],
  ["line", { x1: "12", x2: "12", y1: "2", y2: "5", key: "11lu5j" }],
  ["line", { x1: "12", x2: "12", y1: "19", y2: "22", key: "x3vr5v" }],
  ["circle", { cx: "12", cy: "12", r: "7", key: "fim9np" }]
]);
const qn = r("LockKeyholeOpenIcon", [
  ["circle", { cx: "12", cy: "16", r: "1", key: "1au0dj" }],
  ["rect", { width: "18", height: "12", x: "3", y: "10", rx: "2", key: "l0tzu3" }],
  ["path", { d: "M7 10V7a5 5 0 0 1 9.33-2.5", key: "car5b7" }]
]);
const tf = r("LockKeyholeIcon", [
  ["circle", { cx: "12", cy: "16", r: "1", key: "1au0dj" }],
  ["rect", { x: "3", y: "10", width: "18", height: "12", rx: "2", key: "6s8ecr" }],
  ["path", { d: "M7 10V7a5 5 0 0 1 10 0v3", key: "1pqi11" }]
]);
const Tn = r("LockOpenIcon", [
  ["rect", { width: "18", height: "11", x: "3", y: "11", rx: "2", ry: "2", key: "1w4ew1" }],
  ["path", { d: "M7 11V7a5 5 0 0 1 9.9-1", key: "1mm8w8" }]
]);
const af = r("LockIcon", [
  ["rect", { width: "18", height: "11", x: "3", y: "11", rx: "2", ry: "2", key: "1w4ew1" }],
  ["path", { d: "M7 11V7a5 5 0 0 1 10 0v4", key: "fwvmzm" }]
]);
const nf = r("LogInIcon", [
  ["path", { d: "M15 3h4a2 2 0 0 1 2 2v14a2 2 0 0 1-2 2h-4", key: "u53s6r" }],
  ["polyline", { points: "10 17 15 12 10 7", key: "1ail0h" }],
  ["line", { x1: "15", x2: "3", y1: "12", y2: "12", key: "v6grx8" }]
]);
const of = r("LogOutIcon", [
  ["path", { d: "M9 21H5a2 2 0 0 1-2-2V5a2 2 0 0 1 2-2h4", key: "1uf3rs" }],
  ["polyline", { points: "16 17 21 12 16 7", key: "1gabdz" }],
  ["line", { x1: "21", x2: "9", y1: "12", y2: "12", key: "1uyos4" }]
]);
const rf = r("LollipopIcon", [
  ["circle", { cx: "11", cy: "11", r: "8", key: "4ej97u" }],
  ["path", { d: "m21 21-4.3-4.3", key: "1qie3q" }],
  ["path", { d: "M11 11a2 2 0 0 0 4 0 4 4 0 0 0-8 0 6 6 0 0 0 12 0", key: "107gwy" }]
]);
const lf = r("LuggageIcon", [
  [
    "path",
    {
      d: "M6 20h0a2 2 0 0 1-2-2V8a2 2 0 0 1 2-2h12a2 2 0 0 1 2 2v10a2 2 0 0 1-2 2h0",
      key: "1h5fkc"
    }
  ],
  ["path", { d: "M8 18V4a2 2 0 0 1 2-2h4a2 2 0 0 1 2 2v14", key: "1l99gc" }],
  ["path", { d: "M10 20h4", key: "ni2waw" }],
  ["circle", { cx: "16", cy: "20", r: "2", key: "1vifvg" }],
  ["circle", { cx: "8", cy: "20", r: "2", key: "ckkr5m" }]
]);
const cf = r("MagnetIcon", [
  [
    "path",
    {
      d: "m6 15-4-4 6.75-6.77a7.79 7.79 0 0 1 11 11L13 22l-4-4 6.39-6.36a2.14 2.14 0 0 0-3-3L6 15",
      key: "1i3lhw"
    }
  ],
  ["path", { d: "m5 8 4 4", key: "j6kj7e" }],
  ["path", { d: "m12 15 4 4", key: "lnac28" }]
]);
const df = r("MailCheckIcon", [
  ["path", { d: "M22 13V6a2 2 0 0 0-2-2H4a2 2 0 0 0-2 2v12c0 1.1.9 2 2 2h8", key: "12jkf8" }],
  ["path", { d: "m22 7-8.97 5.7a1.94 1.94 0 0 1-2.06 0L2 7", key: "1ocrg3" }],
  ["path", { d: "m16 19 2 2 4-4", key: "1b14m6" }]
]);
const sf = r("MailMinusIcon", [
  ["path", { d: "M22 15V6a2 2 0 0 0-2-2H4a2 2 0 0 0-2 2v12c0 1.1.9 2 2 2h8", key: "fuxbkv" }],
  ["path", { d: "m22 7-8.97 5.7a1.94 1.94 0 0 1-2.06 0L2 7", key: "1ocrg3" }],
  ["path", { d: "M16 19h6", key: "xwg31i" }]
]);
const uf = r("MailOpenIcon", [
  [
    "path",
    {
      d: "M21.2 8.4c.5.38.8.97.8 1.6v10a2 2 0 0 1-2 2H4a2 2 0 0 1-2-2V10a2 2 0 0 1 .8-1.6l8-6a2 2 0 0 1 2.4 0l8 6Z",
      key: "1jhwl8"
    }
  ],
  ["path", { d: "m22 10-8.97 5.7a1.94 1.94 0 0 1-2.06 0L2 10", key: "1qfld7" }]
]);
const hf = r("MailPlusIcon", [
  ["path", { d: "M22 13V6a2 2 0 0 0-2-2H4a2 2 0 0 0-2 2v12c0 1.1.9 2 2 2h8", key: "12jkf8" }],
  ["path", { d: "m22 7-8.97 5.7a1.94 1.94 0 0 1-2.06 0L2 7", key: "1ocrg3" }],
  ["path", { d: "M19 16v6", key: "tddt3s" }],
  ["path", { d: "M16 19h6", key: "xwg31i" }]
]);
const pf = r("MailQuestionIcon", [
  ["path", { d: "M22 10.5V6a2 2 0 0 0-2-2H4a2 2 0 0 0-2 2v12c0 1.1.9 2 2 2h12.5", key: "e61zoh" }],
  ["path", { d: "m22 7-8.97 5.7a1.94 1.94 0 0 1-2.06 0L2 7", key: "1ocrg3" }],
  [
    "path",
    {
      d: "M18 15.28c.2-.4.5-.8.9-1a2.1 2.1 0 0 1 2.6.4c.3.4.5.8.5 1.3 0 1.3-2 2-2 2",
      key: "7z9rxb"
    }
  ],
  ["path", { d: "M20 22v.01", key: "12bgn6" }]
]);
const yf = r("MailSearchIcon", [
  ["path", { d: "M22 12.5V6a2 2 0 0 0-2-2H4a2 2 0 0 0-2 2v12c0 1.1.9 2 2 2h7.5", key: "w80f2v" }],
  ["path", { d: "m22 7-8.97 5.7a1.94 1.94 0 0 1-2.06 0L2 7", key: "1ocrg3" }],
  ["path", { d: "M18 21a3 3 0 1 0 0-6 3 3 0 0 0 0 6v0Z", key: "mgbru4" }],
  ["circle", { cx: "18", cy: "18", r: "3", key: "1xkwt0" }],
  ["path", { d: "m22 22-1.5-1.5", key: "1x83k4" }]
]);
const kf = r("MailWarningIcon", [
  ["path", { d: "M22 10.5V6a2 2 0 0 0-2-2H4a2 2 0 0 0-2 2v12c0 1.1.9 2 2 2h12.5", key: "e61zoh" }],
  ["path", { d: "m22 7-8.97 5.7a1.94 1.94 0 0 1-2.06 0L2 7", key: "1ocrg3" }],
  ["path", { d: "M20 14v4", key: "1hm744" }],
  ["path", { d: "M20 22v.01", key: "12bgn6" }]
]);
const ff = r("MailXIcon", [
  ["path", { d: "M22 13V6a2 2 0 0 0-2-2H4a2 2 0 0 0-2 2v12c0 1.1.9 2 2 2h9", key: "1j9vog" }],
  ["path", { d: "m22 7-8.97 5.7a1.94 1.94 0 0 1-2.06 0L2 7", key: "1ocrg3" }],
  ["path", { d: "m17 17 4 4", key: "1b3523" }],
  ["path", { d: "m21 17-4 4", key: "uinynz" }]
]);
const vf = r("MailIcon", [
  ["rect", { width: "20", height: "16", x: "2", y: "4", rx: "2", key: "18n3k1" }],
  ["path", { d: "m22 7-8.97 5.7a1.94 1.94 0 0 1-2.06 0L2 7", key: "1ocrg3" }]
]);
const mf = r("MailboxIcon", [
  [
    "path",
    {
      d: "M22 17a2 2 0 0 1-2 2H4a2 2 0 0 1-2-2V9.5C2 7 4 5 6.5 5H18c2.2 0 4 1.8 4 4v8Z",
      key: "1lbycx"
    }
  ],
  ["polyline", { points: "15,9 18,9 18,11", key: "1pm9c0" }],
  ["path", { d: "M6.5 5C9 5 11 7 11 9.5V17a2 2 0 0 1-2 2v0", key: "n6nfvi" }],
  ["line", { x1: "6", x2: "7", y1: "10", y2: "10", key: "1e2scm" }]
]);
const gf = r("MailsIcon", [
  ["rect", { width: "16", height: "13", x: "6", y: "4", rx: "2", key: "1drq3f" }],
  ["path", { d: "m22 7-7.1 3.78c-.57.3-1.23.3-1.8 0L6 7", key: "xn252p" }],
  ["path", { d: "M2 8v11c0 1.1.9 2 2 2h14", key: "n13cji" }]
]);
const Mf = r("MapPinOffIcon", [
  [
    "path",
    { d: "M5.43 5.43A8.06 8.06 0 0 0 4 10c0 6 8 12 8 12a29.94 29.94 0 0 0 5-5", key: "12a8pk" }
  ],
  [
    "path",
    {
      d: "M19.18 13.52A8.66 8.66 0 0 0 20 10a8 8 0 0 0-8-8 7.88 7.88 0 0 0-3.52.82",
      key: "1r9f6y"
    }
  ],
  [
    "path",
    { d: "M9.13 9.13A2.78 2.78 0 0 0 9 10a3 3 0 0 0 3 3 2.78 2.78 0 0 0 .87-.13", key: "erynq7" }
  ],
  ["path", { d: "M14.9 9.25a3 3 0 0 0-2.15-2.16", key: "1hwwmx" }],
  ["line", { x1: "2", x2: "22", y1: "2", y2: "22", key: "a6p6uj" }]
]);
const xf = r("MapPinIcon", [
  ["path", { d: "M20 10c0 6-8 12-8 12s-8-6-8-12a8 8 0 0 1 16 0Z", key: "2oe9fu" }],
  ["circle", { cx: "12", cy: "10", r: "3", key: "ilqhr7" }]
]);
const bf = r("MapPinnedIcon", [
  ["path", { d: "M18 8c0 4.5-6 9-6 9s-6-4.5-6-9a6 6 0 0 1 12 0", key: "yrbn30" }],
  ["circle", { cx: "12", cy: "8", r: "2", key: "1822b1" }],
  [
    "path",
    {
      d: "M8.835 14H5a1 1 0 0 0-.9.7l-2 6c-.1.1-.1.2-.1.3 0 .6.4 1 1 1h18c.6 0 1-.4 1-1 0-.1 0-.2-.1-.3l-2-6a1 1 0 0 0-.9-.7h-3.835",
      key: "112zkj"
    }
  ]
]);
const wf = r("MapIcon", [
  [
    "path",
    {
      d: "M14.106 5.553a2 2 0 0 0 1.788 0l3.659-1.83A1 1 0 0 1 21 4.619v12.764a1 1 0 0 1-.553.894l-4.553 2.277a2 2 0 0 1-1.788 0l-4.212-2.106a2 2 0 0 0-1.788 0l-3.659 1.83A1 1 0 0 1 3 19.381V6.618a1 1 0 0 1 .553-.894l4.553-2.277a2 2 0 0 1 1.788 0z",
      key: "169xi5"
    }
  ],
  ["path", { d: "M15 5.764v15", key: "1pn4in" }],
  ["path", { d: "M9 3.236v15", key: "1uimfh" }]
]);
const If = r("MartiniIcon", [
  ["path", { d: "M8 22h8", key: "rmew8v" }],
  ["path", { d: "M12 11v11", key: "ur9y6a" }],
  ["path", { d: "m19 3-7 8-7-8Z", key: "1sgpiw" }]
]);
const Lf = r("Maximize2Icon", [
  ["polyline", { points: "15 3 21 3 21 9", key: "mznyad" }],
  ["polyline", { points: "9 21 3 21 3 15", key: "1avn1i" }],
  ["line", { x1: "21", x2: "14", y1: "3", y2: "10", key: "ota7mn" }],
  ["line", { x1: "3", x2: "10", y1: "21", y2: "14", key: "1atl0r" }]
]);
const Sf = r("MaximizeIcon", [
  ["path", { d: "M8 3H5a2 2 0 0 0-2 2v3", key: "1dcmit" }],
  ["path", { d: "M21 8V5a2 2 0 0 0-2-2h-3", key: "1e4gt3" }],
  ["path", { d: "M3 16v3a2 2 0 0 0 2 2h3", key: "wsl5sc" }],
  ["path", { d: "M16 21h3a2 2 0 0 0 2-2v-3", key: "18trek" }]
]);
const Cf = r("MedalIcon", [
  [
    "path",
    {
      d: "M7.21 15 2.66 7.14a2 2 0 0 1 .13-2.2L4.4 2.8A2 2 0 0 1 6 2h12a2 2 0 0 1 1.6.8l1.6 2.14a2 2 0 0 1 .14 2.2L16.79 15",
      key: "143lza"
    }
  ],
  ["path", { d: "M11 12 5.12 2.2", key: "qhuxz6" }],
  ["path", { d: "m13 12 5.88-9.8", key: "hbye0f" }],
  ["path", { d: "M8 7h8", key: "i86dvs" }],
  ["circle", { cx: "12", cy: "17", r: "5", key: "qbz8iq" }],
  ["path", { d: "M12 18v-2h-.5", key: "fawc4q" }]
]);
const Af = r("MegaphoneOffIcon", [
  ["path", { d: "M9.26 9.26 3 11v3l14.14 3.14", key: "3429n" }],
  ["path", { d: "M21 15.34V6l-7.31 2.03", key: "4o1dh8" }],
  ["path", { d: "M11.6 16.8a3 3 0 1 1-5.8-1.6", key: "1yl0tm" }],
  ["line", { x1: "2", x2: "22", y1: "2", y2: "22", key: "a6p6uj" }]
]);
const Pf = r("MegaphoneIcon", [
  ["path", { d: "m3 11 18-5v12L3 14v-3z", key: "n962bs" }],
  ["path", { d: "M11.6 16.8a3 3 0 1 1-5.8-1.6", key: "1yl0tm" }]
]);
const qf = r("MehIcon", [
  ["circle", { cx: "12", cy: "12", r: "10", key: "1mglay" }],
  ["line", { x1: "8", x2: "16", y1: "15", y2: "15", key: "1xb1d9" }],
  ["line", { x1: "9", x2: "9.01", y1: "9", y2: "9", key: "yxxnd0" }],
  ["line", { x1: "15", x2: "15.01", y1: "9", y2: "9", key: "1p4y9e" }]
]);
const Tf = r("MemoryStickIcon", [
  ["path", { d: "M6 19v-3", key: "1nvgqn" }],
  ["path", { d: "M10 19v-3", key: "iu8nkm" }],
  ["path", { d: "M14 19v-3", key: "kcehxu" }],
  ["path", { d: "M18 19v-3", key: "1vh91z" }],
  ["path", { d: "M8 11V9", key: "63erz4" }],
  ["path", { d: "M16 11V9", key: "fru6f3" }],
  ["path", { d: "M12 11V9", key: "ha00sb" }],
  ["path", { d: "M2 15h20", key: "16ne18" }],
  [
    "path",
    {
      d: "M2 7a2 2 0 0 1 2-2h16a2 2 0 0 1 2 2v1.1a2 2 0 0 0 0 3.837V17a2 2 0 0 1-2 2H4a2 2 0 0 1-2-2v-5.1a2 2 0 0 0 0-3.837Z",
      key: "lhddv3"
    }
  ]
]);
const Df = r("MenuIcon", [
  ["line", { x1: "4", x2: "20", y1: "12", y2: "12", key: "1e0a9i" }],
  ["line", { x1: "4", x2: "20", y1: "6", y2: "6", key: "1owob3" }],
  ["line", { x1: "4", x2: "20", y1: "18", y2: "18", key: "yk5zj1" }]
]);
const _f = r("MergeIcon", [
  ["path", { d: "m8 6 4-4 4 4", key: "ybng9g" }],
  ["path", { d: "M12 2v10.3a4 4 0 0 1-1.172 2.872L4 22", key: "1hyw0i" }],
  ["path", { d: "m20 22-5-5", key: "1m27yz" }]
]);
const Bf = r("MessageCircleCodeIcon", [
  ["path", { d: "M7.9 20A9 9 0 1 0 4 16.1L2 22Z", key: "vv11sd" }],
  ["path", { d: "m10 10-2 2 2 2", key: "p6et6i" }],
  ["path", { d: "m14 10 2 2-2 2", key: "1kkmpt" }]
]);
const zf = r("MessageCircleDashedIcon", [
  ["path", { d: "M13.5 3.1c-.5 0-1-.1-1.5-.1s-1 .1-1.5.1", key: "16ll65" }],
  ["path", { d: "M19.3 6.8a10.45 10.45 0 0 0-2.1-2.1", key: "1nq77a" }],
  ["path", { d: "M20.9 13.5c.1-.5.1-1 .1-1.5s-.1-1-.1-1.5", key: "1sf7wn" }],
  ["path", { d: "M17.2 19.3a10.45 10.45 0 0 0 2.1-2.1", key: "x1hs5g" }],
  ["path", { d: "M10.5 20.9c.5.1 1 .1 1.5.1s1-.1 1.5-.1", key: "19m18z" }],
  ["path", { d: "M3.5 17.5 2 22l4.5-1.5", key: "1f36qi" }],
  ["path", { d: "M3.1 10.5c0 .5-.1 1-.1 1.5s.1 1 .1 1.5", key: "1vz3ju" }],
  ["path", { d: "M6.8 4.7a10.45 10.45 0 0 0-2.1 2.1", key: "19f9do" }]
]);
const Hf = r("MessageCircleHeartIcon", [
  ["path", { d: "M7.9 20A9 9 0 1 0 4 16.1L2 22Z", key: "vv11sd" }],
  [
    "path",
    {
      d: "M15.8 9.2a2.5 2.5 0 0 0-3.5 0l-.3.4-.35-.3a2.42 2.42 0 1 0-3.2 3.6l3.6 3.5 3.6-3.5c1.2-1.2 1.1-2.7.2-3.7",
      key: "43lnbm"
    }
  ]
]);
const jf = r("MessageCircleMoreIcon", [
  ["path", { d: "M7.9 20A9 9 0 1 0 4 16.1L2 22Z", key: "vv11sd" }],
  ["path", { d: "M8 12h.01", key: "czm47f" }],
  ["path", { d: "M12 12h.01", key: "1mp3jc" }],
  ["path", { d: "M16 12h.01", key: "1l6xoz" }]
]);
const Vf = r("MessageCircleOffIcon", [
  ["path", { d: "M20.5 14.9A9 9 0 0 0 9.1 3.5", key: "1iebmn" }],
  ["path", { d: "m2 2 20 20", key: "1ooewy" }],
  ["path", { d: "M5.6 5.6C3 8.3 2.2 12.5 4 16l-2 6 6-2c3.4 1.8 7.6 1.1 10.3-1.7", key: "1ov8ce" }]
]);
const Of = r("MessageCirclePlusIcon", [
  ["path", { d: "M7.9 20A9 9 0 1 0 4 16.1L2 22Z", key: "vv11sd" }],
  ["path", { d: "M8 12h8", key: "1wcyev" }],
  ["path", { d: "M12 8v8", key: "napkw2" }]
]);
const $f = r("MessageCircleQuestionIcon", [
  ["path", { d: "M7.9 20A9 9 0 1 0 4 16.1L2 22Z", key: "vv11sd" }],
  ["path", { d: "M9.09 9a3 3 0 0 1 5.83 1c0 2-3 3-3 3", key: "1u773s" }],
  ["path", { d: "M12 17h.01", key: "p32p05" }]
]);
const Rf = r("MessageCircleReplyIcon", [
  ["path", { d: "M7.9 20A9 9 0 1 0 4 16.1L2 22Z", key: "vv11sd" }],
  ["path", { d: "m10 15-3-3 3-3", key: "1pgupc" }],
  ["path", { d: "M7 12h7a2 2 0 0 1 2 2v1", key: "1gheu4" }]
]);
const Ff = r("MessageCircleWarningIcon", [
  ["path", { d: "M7.9 20A9 9 0 1 0 4 16.1L2 22Z", key: "vv11sd" }],
  ["path", { d: "M12 8v4", key: "1got3b" }],
  ["path", { d: "M12 16h.01", key: "1drbdi" }]
]);
const Uf = r("MessageCircleXIcon", [
  ["path", { d: "M7.9 20A9 9 0 1 0 4 16.1L2 22Z", key: "vv11sd" }],
  ["path", { d: "m15 9-6 6", key: "1uzhvr" }],
  ["path", { d: "m9 9 6 6", key: "z0biqf" }]
]);
const Ef = r("MessageCircleIcon", [
  ["path", { d: "M7.9 20A9 9 0 1 0 4 16.1L2 22Z", key: "vv11sd" }]
]);
const Wf = r("MessageSquareCodeIcon", [
  ["path", { d: "M21 15a2 2 0 0 1-2 2H7l-4 4V5a2 2 0 0 1 2-2h14a2 2 0 0 1 2 2z", key: "1lielz" }],
  ["path", { d: "m10 8-2 2 2 2", key: "19bv1o" }],
  ["path", { d: "m14 8 2 2-2 2", key: "1whylv" }]
]);
const Nf = r("MessageSquareDashedIcon", [
  ["path", { d: "M3 6V5c0-1.1.9-2 2-2h2", key: "9usibi" }],
  ["path", { d: "M11 3h3", key: "1c3ji7" }],
  ["path", { d: "M18 3h1c1.1 0 2 .9 2 2", key: "19esxn" }],
  ["path", { d: "M21 9v2", key: "p14lih" }],
  ["path", { d: "M21 15c0 1.1-.9 2-2 2h-1", key: "1fo1j8" }],
  ["path", { d: "M14 17h-3", key: "1w4p2m" }],
  ["path", { d: "m7 17-4 4v-5", key: "ph9x1h" }],
  ["path", { d: "M3 12v-2", key: "856n1q" }]
]);
const Zf = r("MessageSquareDiffIcon", [
  ["path", { d: "m5 19-2 2V5a2 2 0 0 1 2-2h14a2 2 0 0 1 2 2v10a2 2 0 0 1-2 2", key: "1xuzuj" }],
  ["path", { d: "M9 10h6", key: "9gxzsh" }],
  ["path", { d: "M12 7v6", key: "lw1j43" }],
  ["path", { d: "M9 17h6", key: "r8uit2" }]
]);
const Yf = r("MessageSquareDotIcon", [
  ["path", { d: "M11.7 3H5a2 2 0 0 0-2 2v16l4-4h12a2 2 0 0 0 2-2v-2.7", key: "uodpkb" }],
  ["circle", { cx: "18", cy: "6", r: "3", key: "1h7g24" }]
]);
const Gf = r("MessageSquareHeartIcon", [
  ["path", { d: "M21 15a2 2 0 0 1-2 2H7l-4 4V5a2 2 0 0 1 2-2h14a2 2 0 0 1 2 2z", key: "1lielz" }],
  [
    "path",
    {
      d: "M14.8 7.5a1.84 1.84 0 0 0-2.6 0l-.2.3-.3-.3a1.84 1.84 0 1 0-2.4 2.8L12 13l2.7-2.7c.9-.9.8-2.1.1-2.8",
      key: "1blaws"
    }
  ]
]);
const Xf = r("MessageSquareMoreIcon", [
  ["path", { d: "M21 15a2 2 0 0 1-2 2H7l-4 4V5a2 2 0 0 1 2-2h14a2 2 0 0 1 2 2z", key: "1lielz" }],
  ["path", { d: "M8 10h.01", key: "19clt8" }],
  ["path", { d: "M12 10h.01", key: "1nrarc" }],
  ["path", { d: "M16 10h.01", key: "1m94wz" }]
]);
const Kf = r("MessageSquareOffIcon", [
  ["path", { d: "M21 15V5a2 2 0 0 0-2-2H9", key: "43el77" }],
  ["path", { d: "m2 2 20 20", key: "1ooewy" }],
  ["path", { d: "M3.6 3.6c-.4.3-.6.8-.6 1.4v16l4-4h10", key: "pwpm4a" }]
]);
const Qf = r("MessageSquarePlusIcon", [
  ["path", { d: "M21 15a2 2 0 0 1-2 2H7l-4 4V5a2 2 0 0 1 2-2h14a2 2 0 0 1 2 2z", key: "1lielz" }],
  ["path", { d: "M12 7v6", key: "lw1j43" }],
  ["path", { d: "M9 10h6", key: "9gxzsh" }]
]);
const Jf = r("MessageSquareQuoteIcon", [
  ["path", { d: "M21 15a2 2 0 0 1-2 2H7l-4 4V5a2 2 0 0 1 2-2h14a2 2 0 0 1 2 2z", key: "1lielz" }],
  ["path", { d: "M8 12a2 2 0 0 0 2-2V8H8", key: "1jfesj" }],
  ["path", { d: "M14 12a2 2 0 0 0 2-2V8h-2", key: "1dq9mh" }]
]);
const ev = r("MessageSquareReplyIcon", [
  ["path", { d: "M21 15a2 2 0 0 1-2 2H7l-4 4V5a2 2 0 0 1 2-2h14a2 2 0 0 1 2 2z", key: "1lielz" }],
  ["path", { d: "m10 7-3 3 3 3", key: "1eugdv" }],
  ["path", { d: "M17 13v-1a2 2 0 0 0-2-2H7", key: "ernfh3" }]
]);
const tv = r("MessageSquareShareIcon", [
  ["path", { d: "M21 12v3a2 2 0 0 1-2 2H7l-4 4V5a2 2 0 0 1 2-2h7", key: "tqtdkg" }],
  ["path", { d: "M16 3h5v5", key: "1806ms" }],
  ["path", { d: "m16 8 5-5", key: "15mbrl" }]
]);
const av = r("MessageSquareTextIcon", [
  ["path", { d: "M21 15a2 2 0 0 1-2 2H7l-4 4V5a2 2 0 0 1 2-2h14a2 2 0 0 1 2 2z", key: "1lielz" }],
  ["path", { d: "M13 8H7", key: "14i4kc" }],
  ["path", { d: "M17 12H7", key: "16if0g" }]
]);
const nv = r("MessageSquareWarningIcon", [
  ["path", { d: "M21 15a2 2 0 0 1-2 2H7l-4 4V5a2 2 0 0 1 2-2h14a2 2 0 0 1 2 2z", key: "1lielz" }],
  ["path", { d: "M12 7v2", key: "stiyo7" }],
  ["path", { d: "M12 13h.01", key: "y0uutt" }]
]);
const ov = r("MessageSquareXIcon", [
  ["path", { d: "M21 15a2 2 0 0 1-2 2H7l-4 4V5a2 2 0 0 1 2-2h14a2 2 0 0 1 2 2z", key: "1lielz" }],
  ["path", { d: "m14.5 7.5-5 5", key: "3lb6iw" }],
  ["path", { d: "m9.5 7.5 5 5", key: "ko136h" }]
]);
const rv = r("MessageSquareIcon", [
  ["path", { d: "M21 15a2 2 0 0 1-2 2H7l-4 4V5a2 2 0 0 1 2-2h14a2 2 0 0 1 2 2z", key: "1lielz" }]
]);
const iv = r("MessagesSquareIcon", [
  ["path", { d: "M14 9a2 2 0 0 1-2 2H6l-4 4V4c0-1.1.9-2 2-2h8a2 2 0 0 1 2 2z", key: "jj09z8" }],
  ["path", { d: "M18 9h2a2 2 0 0 1 2 2v11l-4-4h-6a2 2 0 0 1-2-2v-1", key: "1cx29u" }]
]);
const lv = r("MicOffIcon", [
  ["line", { x1: "2", x2: "22", y1: "2", y2: "22", key: "a6p6uj" }],
  ["path", { d: "M18.89 13.23A7.12 7.12 0 0 0 19 12v-2", key: "80xlxr" }],
  ["path", { d: "M5 10v2a7 7 0 0 0 12 5", key: "p2k8kg" }],
  ["path", { d: "M15 9.34V5a3 3 0 0 0-5.68-1.33", key: "1gzdoj" }],
  ["path", { d: "M9 9v3a3 3 0 0 0 5.12 2.12", key: "r2i35w" }],
  ["line", { x1: "12", x2: "12", y1: "19", y2: "22", key: "x3vr5v" }]
]);
const Dn = r("MicVocalIcon", [
  ["path", { d: "m12 8-9.04 9.06a2.82 2.82 0 1 0 3.98 3.98L16 12", key: "zoua8r" }],
  ["circle", { cx: "17", cy: "7", r: "5", key: "1fomce" }]
]);
const cv = r("MicIcon", [
  ["path", { d: "M12 2a3 3 0 0 0-3 3v7a3 3 0 0 0 6 0V5a3 3 0 0 0-3-3Z", key: "131961" }],
  ["path", { d: "M19 10v2a7 7 0 0 1-14 0v-2", key: "1vc78b" }],
  ["line", { x1: "12", x2: "12", y1: "19", y2: "22", key: "x3vr5v" }]
]);
const dv = r("MicroscopeIcon", [
  ["path", { d: "M6 18h8", key: "1borvv" }],
  ["path", { d: "M3 22h18", key: "8prr45" }],
  ["path", { d: "M14 22a7 7 0 1 0 0-14h-1", key: "1jwaiy" }],
  ["path", { d: "M9 14h2", key: "197e7h" }],
  ["path", { d: "M9 12a2 2 0 0 1-2-2V6h6v4a2 2 0 0 1-2 2Z", key: "1bmzmy" }],
  ["path", { d: "M12 6V3a1 1 0 0 0-1-1H9a1 1 0 0 0-1 1v3", key: "1drr47" }]
]);
const sv = r("MicrowaveIcon", [
  ["rect", { width: "20", height: "15", x: "2", y: "4", rx: "2", key: "2no95f" }],
  ["rect", { width: "8", height: "7", x: "6", y: "8", rx: "1", key: "zh9wx" }],
  ["path", { d: "M18 8v7", key: "o5zi4n" }],
  ["path", { d: "M6 19v2", key: "1loha6" }],
  ["path", { d: "M18 19v2", key: "1dawf0" }]
]);
const uv = r("MilestoneIcon", [
  ["path", { d: "M18 6H5a2 2 0 0 0-2 2v3a2 2 0 0 0 2 2h13l4-3.5L18 6Z", key: "1mp5s7" }],
  ["path", { d: "M12 13v8", key: "1l5pq0" }],
  ["path", { d: "M12 3v3", key: "1n5kay" }]
]);
const hv = r("MilkOffIcon", [
  ["path", { d: "M8 2h8", key: "1ssgc1" }],
  [
    "path",
    {
      d: "M9 2v1.343M15 2v2.789a4 4 0 0 0 .672 2.219l.656.984a4 4 0 0 1 .672 2.22v1.131M7.8 7.8l-.128.192A4 4 0 0 0 7 10.212V20a2 2 0 0 0 2 2h6a2 2 0 0 0 2-2v-3",
      key: "y0ejgx"
    }
  ],
  ["path", { d: "M7 15a6.47 6.47 0 0 1 5 0 6.472 6.472 0 0 0 3.435.435", key: "iaxqsy" }],
  ["line", { x1: "2", x2: "22", y1: "2", y2: "22", key: "a6p6uj" }]
]);
const pv = r("MilkIcon", [
  ["path", { d: "M8 2h8", key: "1ssgc1" }],
  [
    "path",
    {
      d: "M9 2v2.789a4 4 0 0 1-.672 2.219l-.656.984A4 4 0 0 0 7 10.212V20a2 2 0 0 0 2 2h6a2 2 0 0 0 2-2v-9.789a4 4 0 0 0-.672-2.219l-.656-.984A4 4 0 0 1 15 4.788V2",
      key: "qtp12x"
    }
  ],
  ["path", { d: "M7 15a6.472 6.472 0 0 1 5 0 6.47 6.47 0 0 0 5 0", key: "ygeh44" }]
]);
const yv = r("Minimize2Icon", [
  ["polyline", { points: "4 14 10 14 10 20", key: "11kfnr" }],
  ["polyline", { points: "20 10 14 10 14 4", key: "rlmsce" }],
  ["line", { x1: "14", x2: "21", y1: "10", y2: "3", key: "o5lafz" }],
  ["line", { x1: "3", x2: "10", y1: "21", y2: "14", key: "1atl0r" }]
]);
const kv = r("MinimizeIcon", [
  ["path", { d: "M8 3v3a2 2 0 0 1-2 2H3", key: "hohbtr" }],
  ["path", { d: "M21 8h-3a2 2 0 0 1-2-2V3", key: "5jw1f3" }],
  ["path", { d: "M3 16h3a2 2 0 0 1 2 2v3", key: "198tvr" }],
  ["path", { d: "M16 21v-3a2 2 0 0 1 2-2h3", key: "ph8mxp" }]
]);
const fv = r("MinusIcon", [["path", { d: "M5 12h14", key: "1ays0h" }]]);
const vv = r("MonitorCheckIcon", [
  ["path", { d: "m9 10 2 2 4-4", key: "1gnqz4" }],
  ["rect", { width: "20", height: "14", x: "2", y: "3", rx: "2", key: "48i651" }],
  ["path", { d: "M12 17v4", key: "1riwvh" }],
  ["path", { d: "M8 21h8", key: "1ev6f3" }]
]);
const mv = r("MonitorDotIcon", [
  ["circle", { cx: "19", cy: "6", r: "3", key: "108a5v" }],
  ["path", { d: "M22 12v3a2 2 0 0 1-2 2H4a2 2 0 0 1-2-2V5a2 2 0 0 1 2-2h9", key: "1fet9y" }],
  ["path", { d: "M12 17v4", key: "1riwvh" }],
  ["path", { d: "M8 21h8", key: "1ev6f3" }]
]);
const gv = r("MonitorDownIcon", [
  ["path", { d: "M12 13V7", key: "h0r20n" }],
  ["path", { d: "m15 10-3 3-3-3", key: "lzhmyn" }],
  ["rect", { width: "20", height: "14", x: "2", y: "3", rx: "2", key: "48i651" }],
  ["path", { d: "M12 17v4", key: "1riwvh" }],
  ["path", { d: "M8 21h8", key: "1ev6f3" }]
]);
const Mv = r("MonitorOffIcon", [
  ["path", { d: "M17 17H4a2 2 0 0 1-2-2V5c0-1.5 1-2 1-2", key: "k0q8oc" }],
  ["path", { d: "M22 15V5a2 2 0 0 0-2-2H9", key: "cp1ac0" }],
  ["path", { d: "M8 21h8", key: "1ev6f3" }],
  ["path", { d: "M12 17v4", key: "1riwvh" }],
  ["path", { d: "m2 2 20 20", key: "1ooewy" }]
]);
const xv = r("MonitorPauseIcon", [
  ["path", { d: "M10 13V7", key: "1u13u9" }],
  ["path", { d: "M14 13V7", key: "1vj9om" }],
  ["rect", { width: "20", height: "14", x: "2", y: "3", rx: "2", key: "48i651" }],
  ["path", { d: "M12 17v4", key: "1riwvh" }],
  ["path", { d: "M8 21h8", key: "1ev6f3" }]
]);
const bv = r("MonitorPlayIcon", [
  ["path", { d: "m10 7 5 3-5 3Z", key: "29ljg6" }],
  ["rect", { width: "20", height: "14", x: "2", y: "3", rx: "2", key: "48i651" }],
  ["path", { d: "M12 17v4", key: "1riwvh" }],
  ["path", { d: "M8 21h8", key: "1ev6f3" }]
]);
const wv = r("MonitorSmartphoneIcon", [
  ["path", { d: "M18 8V6a2 2 0 0 0-2-2H4a2 2 0 0 0-2 2v7a2 2 0 0 0 2 2h8", key: "10dyio" }],
  ["path", { d: "M10 19v-3.96 3.15", key: "1irgej" }],
  ["path", { d: "M7 19h5", key: "qswx4l" }],
  ["rect", { width: "6", height: "10", x: "16", y: "12", rx: "2", key: "1egngj" }]
]);
const Iv = r("MonitorSpeakerIcon", [
  ["path", { d: "M5.5 20H8", key: "1k40s5" }],
  ["path", { d: "M17 9h.01", key: "1j24nn" }],
  ["rect", { width: "10", height: "16", x: "12", y: "4", rx: "2", key: "ixliua" }],
  ["path", { d: "M8 6H4a2 2 0 0 0-2 2v6a2 2 0 0 0 2 2h4", key: "1mp6e1" }],
  ["circle", { cx: "17", cy: "15", r: "1", key: "tqvash" }]
]);
const Lv = r("MonitorStopIcon", [
  ["path", { d: "M12 17v4", key: "1riwvh" }],
  ["path", { d: "M8 21h8", key: "1ev6f3" }],
  ["rect", { x: "2", y: "3", width: "20", height: "14", rx: "2", key: "x3v2xh" }],
  ["rect", { x: "9", y: "7", width: "6", height: "6", rx: "1", key: "5m2oou" }]
]);
const Sv = r("MonitorUpIcon", [
  ["path", { d: "m9 10 3-3 3 3", key: "11gsxs" }],
  ["path", { d: "M12 13V7", key: "h0r20n" }],
  ["rect", { width: "20", height: "14", x: "2", y: "3", rx: "2", key: "48i651" }],
  ["path", { d: "M12 17v4", key: "1riwvh" }],
  ["path", { d: "M8 21h8", key: "1ev6f3" }]
]);
const Cv = r("MonitorXIcon", [
  ["path", { d: "m14.5 12.5-5-5", key: "1jahn5" }],
  ["path", { d: "m9.5 12.5 5-5", key: "1k2t7b" }],
  ["rect", { width: "20", height: "14", x: "2", y: "3", rx: "2", key: "48i651" }],
  ["path", { d: "M12 17v4", key: "1riwvh" }],
  ["path", { d: "M8 21h8", key: "1ev6f3" }]
]);
const Av = r("MonitorIcon", [
  ["rect", { width: "20", height: "14", x: "2", y: "3", rx: "2", key: "48i651" }],
  ["line", { x1: "8", x2: "16", y1: "21", y2: "21", key: "1svkeh" }],
  ["line", { x1: "12", x2: "12", y1: "17", y2: "21", key: "vw1qmm" }]
]);
const Pv = r("MoonStarIcon", [
  ["path", { d: "M12 3a6 6 0 0 0 9 9 9 9 0 1 1-9-9Z", key: "a7tn18" }],
  ["path", { d: "M19 3v4", key: "vgv24u" }],
  ["path", { d: "M21 5h-4", key: "1wcg1f" }]
]);
const qv = r("MoonIcon", [
  ["path", { d: "M12 3a6 6 0 0 0 9 9 9 9 0 1 1-9-9Z", key: "a7tn18" }]
]);
const Tv = r("MountainSnowIcon", [
  ["path", { d: "m8 3 4 8 5-5 5 15H2L8 3z", key: "otkl63" }],
  [
    "path",
    { d: "M4.14 15.08c2.62-1.57 5.24-1.43 7.86.42 2.74 1.94 5.49 2 8.23.19", key: "1pvmmp" }
  ]
]);
const Dv = r("MountainIcon", [
  ["path", { d: "m8 3 4 8 5-5 5 15H2L8 3z", key: "otkl63" }]
]);
const _v = r("MouseOffIcon", [
  ["path", { d: "M12 6v.343", key: "1gyhex" }],
  ["path", { d: "M18.218 18.218A7 7 0 0 1 5 15V9a7 7 0 0 1 .782-3.218", key: "ukzz01" }],
  ["path", { d: "M19 13.343V9A7 7 0 0 0 8.56 2.902", key: "104jy9" }],
  ["path", { d: "M22 22 2 2", key: "1r8tn9" }]
]);
const Bv = r("MousePointer2Icon", [
  ["path", { d: "m4 4 7.07 17 2.51-7.39L21 11.07z", key: "1vqm48" }]
]);
const zv = r("MousePointerClickIcon", [
  ["path", { d: "m9 9 5 12 1.8-5.2L21 14Z", key: "1b76lo" }],
  ["path", { d: "M7.2 2.2 8 5.1", key: "1cfko1" }],
  ["path", { d: "m5.1 8-2.9-.8", key: "1go3kf" }],
  ["path", { d: "M14 4.1 12 6", key: "ita8i4" }],
  ["path", { d: "m6 12-1.9 2", key: "mnht97" }]
]);
const Hv = r("MousePointerIcon", [
  ["path", { d: "m3 3 7.07 16.97 2.51-7.39 7.39-2.51L3 3z", key: "y2ucgo" }],
  ["path", { d: "m13 13 6 6", key: "1nhxnf" }]
]);
const jv = r("MouseIcon", [
  ["rect", { x: "5", y: "2", width: "14", height: "20", rx: "7", key: "11ol66" }],
  ["path", { d: "M12 6v4", key: "16clxf" }]
]);
const _n = r("Move3dIcon", [
  ["path", { d: "M5 3v16h16", key: "1mqmf9" }],
  ["path", { d: "m5 19 6-6", key: "jh6hbb" }],
  ["path", { d: "m2 6 3-3 3 3", key: "tkyvxa" }],
  ["path", { d: "m18 16 3 3-3 3", key: "1d4glt" }]
]);
const Vv = r("MoveDiagonal2Icon", [
  ["polyline", { points: "5 11 5 5 11 5", key: "ncfzxk" }],
  ["polyline", { points: "19 13 19 19 13 19", key: "1mk7hk" }],
  ["line", { x1: "5", x2: "19", y1: "5", y2: "19", key: "mcyte3" }]
]);
const Ov = r("MoveDiagonalIcon", [
  ["polyline", { points: "13 5 19 5 19 11", key: "11219e" }],
  ["polyline", { points: "11 19 5 19 5 13", key: "sfq3wq" }],
  ["line", { x1: "19", x2: "5", y1: "5", y2: "19", key: "1x9vlm" }]
]);
const $v = r("MoveDownLeftIcon", [
  ["path", { d: "M11 19H5V13", key: "1akmht" }],
  ["path", { d: "M19 5L5 19", key: "72u4yj" }]
]);
const Rv = r("MoveDownRightIcon", [
  ["path", { d: "M19 13V19H13", key: "10vkzq" }],
  ["path", { d: "M5 5L19 19", key: "5zm2fv" }]
]);
const Fv = r("MoveDownIcon", [
  ["path", { d: "M8 18L12 22L16 18", key: "cskvfv" }],
  ["path", { d: "M12 2V22", key: "r89rzk" }]
]);
const Uv = r("MoveHorizontalIcon", [
  ["polyline", { points: "18 8 22 12 18 16", key: "1hqrds" }],
  ["polyline", { points: "6 8 2 12 6 16", key: "f0ernq" }],
  ["line", { x1: "2", x2: "22", y1: "12", y2: "12", key: "1dnqot" }]
]);
const Ev = r("MoveLeftIcon", [
  ["path", { d: "M6 8L2 12L6 16", key: "kyvwex" }],
  ["path", { d: "M2 12H22", key: "1m8cig" }]
]);
const Wv = r("MoveRightIcon", [
  ["path", { d: "M18 8L22 12L18 16", key: "1r0oui" }],
  ["path", { d: "M2 12H22", key: "1m8cig" }]
]);
const Nv = r("MoveUpLeftIcon", [
  ["path", { d: "M5 11V5H11", key: "3q78g9" }],
  ["path", { d: "M5 5L19 19", key: "5zm2fv" }]
]);
const Zv = r("MoveUpRightIcon", [
  ["path", { d: "M13 5H19V11", key: "1n1gyv" }],
  ["path", { d: "M19 5L5 19", key: "72u4yj" }]
]);
const Yv = r("MoveUpIcon", [
  ["path", { d: "M8 6L12 2L16 6", key: "1yvkyx" }],
  ["path", { d: "M12 2V22", key: "r89rzk" }]
]);
const Gv = r("MoveVerticalIcon", [
  ["polyline", { points: "8 18 12 22 16 18", key: "1uutw3" }],
  ["polyline", { points: "8 6 12 2 16 6", key: "d60sxy" }],
  ["line", { x1: "12", x2: "12", y1: "2", y2: "22", key: "7eqyqh" }]
]);
const Xv = r("MoveIcon", [
  ["polyline", { points: "5 9 2 12 5 15", key: "1r5uj5" }],
  ["polyline", { points: "9 5 12 2 15 5", key: "5v383o" }],
  ["polyline", { points: "15 19 12 22 9 19", key: "g7qi8m" }],
  ["polyline", { points: "19 9 22 12 19 15", key: "tpp73q" }],
  ["line", { x1: "2", x2: "22", y1: "12", y2: "12", key: "1dnqot" }],
  ["line", { x1: "12", x2: "12", y1: "2", y2: "22", key: "7eqyqh" }]
]);
const Kv = r("Music2Icon", [
  ["circle", { cx: "8", cy: "18", r: "4", key: "1fc0mg" }],
  ["path", { d: "M12 18V2l7 4", key: "g04rme" }]
]);
const Qv = r("Music3Icon", [
  ["circle", { cx: "12", cy: "18", r: "4", key: "m3r9ws" }],
  ["path", { d: "M16 18V2", key: "40x2m5" }]
]);
const Jv = r("Music4Icon", [
  ["path", { d: "M9 18V5l12-2v13", key: "1jmyc2" }],
  ["path", { d: "m9 9 12-2", key: "1e64n2" }],
  ["circle", { cx: "6", cy: "18", r: "3", key: "fqmcym" }],
  ["circle", { cx: "18", cy: "16", r: "3", key: "1hluhg" }]
]);
const em = r("MusicIcon", [
  ["path", { d: "M9 18V5l12-2v13", key: "1jmyc2" }],
  ["circle", { cx: "6", cy: "18", r: "3", key: "fqmcym" }],
  ["circle", { cx: "18", cy: "16", r: "3", key: "1hluhg" }]
]);
const tm = r("Navigation2OffIcon", [
  ["path", { d: "M9.31 9.31 5 21l7-4 7 4-1.17-3.17", key: "qoq2o2" }],
  ["path", { d: "M14.53 8.88 12 2l-1.17 3.17", key: "k3sjzy" }],
  ["line", { x1: "2", x2: "22", y1: "2", y2: "22", key: "a6p6uj" }]
]);
const am = r("Navigation2Icon", [
  ["polygon", { points: "12 2 19 21 12 17 5 21 12 2", key: "x8c0qg" }]
]);
const nm = r("NavigationOffIcon", [
  ["path", { d: "M8.43 8.43 3 11l8 2 2 8 2.57-5.43", key: "1vdtb7" }],
  ["path", { d: "M17.39 11.73 22 2l-9.73 4.61", key: "tya3r6" }],
  ["line", { x1: "2", x2: "22", y1: "2", y2: "22", key: "a6p6uj" }]
]);
const om = r("NavigationIcon", [
  ["polygon", { points: "3 11 22 2 13 21 11 13 3 11", key: "1ltx0t" }]
]);
const rm = r("NetworkIcon", [
  ["rect", { x: "16", y: "16", width: "6", height: "6", rx: "1", key: "4q2zg0" }],
  ["rect", { x: "2", y: "16", width: "6", height: "6", rx: "1", key: "8cvhb9" }],
  ["rect", { x: "9", y: "2", width: "6", height: "6", rx: "1", key: "1egb70" }],
  ["path", { d: "M5 16v-3a1 1 0 0 1 1-1h12a1 1 0 0 1 1 1v3", key: "1jsf9p" }],
  ["path", { d: "M12 12V8", key: "2874zd" }]
]);
const im = r("NewspaperIcon", [
  [
    "path",
    {
      d: "M4 22h16a2 2 0 0 0 2-2V4a2 2 0 0 0-2-2H8a2 2 0 0 0-2 2v16a2 2 0 0 1-2 2Zm0 0a2 2 0 0 1-2-2v-9c0-1.1.9-2 2-2h2",
      key: "7pis2x"
    }
  ],
  ["path", { d: "M18 14h-8", key: "sponae" }],
  ["path", { d: "M15 18h-5", key: "95g1m2" }],
  ["path", { d: "M10 6h8v4h-8V6Z", key: "smlsk5" }]
]);
const lm = r("NfcIcon", [
  ["path", { d: "M6 8.32a7.43 7.43 0 0 1 0 7.36", key: "9iaqei" }],
  ["path", { d: "M9.46 6.21a11.76 11.76 0 0 1 0 11.58", key: "1yha7l" }],
  ["path", { d: "M12.91 4.1a15.91 15.91 0 0 1 .01 15.8", key: "4iu2gk" }],
  ["path", { d: "M16.37 2a20.16 20.16 0 0 1 0 20", key: "sap9u2" }]
]);
const cm = r("NotebookPenIcon", [
  ["path", { d: "M13.4 2H6a2 2 0 0 0-2 2v16a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2v-7.4", key: "re6nr2" }],
  ["path", { d: "M2 6h4", key: "aawbzj" }],
  ["path", { d: "M2 10h4", key: "l0bgd4" }],
  ["path", { d: "M2 14h4", key: "1gsvsf" }],
  ["path", { d: "M2 18h4", key: "1bu2t1" }],
  ["path", { d: "M18.4 2.6a2.17 2.17 0 0 1 3 3L16 11l-4 1 1-4Z", key: "1dba1m" }]
]);
const dm = r("NotebookTabsIcon", [
  ["path", { d: "M2 6h4", key: "aawbzj" }],
  ["path", { d: "M2 10h4", key: "l0bgd4" }],
  ["path", { d: "M2 14h4", key: "1gsvsf" }],
  ["path", { d: "M2 18h4", key: "1bu2t1" }],
  ["rect", { width: "16", height: "20", x: "4", y: "2", rx: "2", key: "1nb95v" }],
  ["path", { d: "M15 2v20", key: "dcj49h" }],
  ["path", { d: "M15 7h5", key: "1xj5lc" }],
  ["path", { d: "M15 12h5", key: "w5shd9" }],
  ["path", { d: "M15 17h5", key: "1qaofu" }]
]);
const sm = r("NotebookTextIcon", [
  ["path", { d: "M2 6h4", key: "aawbzj" }],
  ["path", { d: "M2 10h4", key: "l0bgd4" }],
  ["path", { d: "M2 14h4", key: "1gsvsf" }],
  ["path", { d: "M2 18h4", key: "1bu2t1" }],
  ["rect", { width: "16", height: "20", x: "4", y: "2", rx: "2", key: "1nb95v" }],
  ["path", { d: "M9.5 8h5", key: "11mslq" }],
  ["path", { d: "M9.5 12H16", key: "ktog6x" }],
  ["path", { d: "M9.5 16H14", key: "p1seyn" }]
]);
const um = r("NotebookIcon", [
  ["path", { d: "M2 6h4", key: "aawbzj" }],
  ["path", { d: "M2 10h4", key: "l0bgd4" }],
  ["path", { d: "M2 14h4", key: "1gsvsf" }],
  ["path", { d: "M2 18h4", key: "1bu2t1" }],
  ["rect", { width: "16", height: "20", x: "4", y: "2", rx: "2", key: "1nb95v" }],
  ["path", { d: "M16 2v20", key: "rotuqe" }]
]);
const hm = r("NotepadTextDashedIcon", [
  ["path", { d: "M8 2v4", key: "1cmpym" }],
  ["path", { d: "M12 2v4", key: "3427ic" }],
  ["path", { d: "M16 2v4", key: "4m81vk" }],
  ["path", { d: "M16 4h2a2 2 0 0 1 2 2v2", key: "j91f56" }],
  ["path", { d: "M20 12v2", key: "w8o0tu" }],
  ["path", { d: "M20 18v2a2 2 0 0 1-2 2h-1", key: "1c9ggx" }],
  ["path", { d: "M13 22h-2", key: "191ugt" }],
  ["path", { d: "M7 22H6a2 2 0 0 1-2-2v-2", key: "1rt9px" }],
  ["path", { d: "M4 14v-2", key: "1v0sqh" }],
  ["path", { d: "M4 8V6a2 2 0 0 1 2-2h2", key: "1mwabg" }],
  ["path", { d: "M8 10h6", key: "3oa6kw" }],
  ["path", { d: "M8 14h8", key: "1fgep2" }],
  ["path", { d: "M8 18h5", key: "17enja" }]
]);
const pm = r("NotepadTextIcon", [
  ["path", { d: "M8 2v4", key: "1cmpym" }],
  ["path", { d: "M12 2v4", key: "3427ic" }],
  ["path", { d: "M16 2v4", key: "4m81vk" }],
  ["rect", { width: "16", height: "18", x: "4", y: "4", rx: "2", key: "1u9h20" }],
  ["path", { d: "M8 10h6", key: "3oa6kw" }],
  ["path", { d: "M8 14h8", key: "1fgep2" }],
  ["path", { d: "M8 18h5", key: "17enja" }]
]);
const ym = r("NutOffIcon", [
  ["path", { d: "M12 4V2", key: "1k5q1u" }],
  [
    "path",
    {
      d: "M5 10v4a7.004 7.004 0 0 0 5.277 6.787c.412.104.802.292 1.102.592L12 22l.621-.621c.3-.3.69-.488 1.102-.592a7.01 7.01 0 0 0 4.125-2.939",
      key: "1xcvy9"
    }
  ],
  ["path", { d: "M19 10v3.343", key: "163tfc" }],
  [
    "path",
    {
      d: "M12 12c-1.349-.573-1.905-1.005-2.5-2-.546.902-1.048 1.353-2.5 2-1.018-.644-1.46-1.08-2-2-1.028.71-1.69.918-3 1 1.081-1.048 1.757-2.03 2-3 .194-.776.84-1.551 1.79-2.21m11.654 5.997c.887-.457 1.28-.891 1.556-1.787 1.032.916 1.683 1.157 3 1-1.297-1.036-1.758-2.03-2-3-.5-2-4-4-8-4-.74 0-1.461.068-2.15.192",
      key: "17914v"
    }
  ],
  ["line", { x1: "2", x2: "22", y1: "2", y2: "22", key: "a6p6uj" }]
]);
const km = r("NutIcon", [
  ["path", { d: "M12 4V2", key: "1k5q1u" }],
  [
    "path",
    {
      d: "M5 10v4a7.004 7.004 0 0 0 5.277 6.787c.412.104.802.292 1.102.592L12 22l.621-.621c.3-.3.69-.488 1.102-.592A7.003 7.003 0 0 0 19 14v-4",
      key: "1tgyif"
    }
  ],
  [
    "path",
    {
      d: "M12 4C8 4 4.5 6 4 8c-.243.97-.919 1.952-2 3 1.31-.082 1.972-.29 3-1 .54.92.982 1.356 2 2 1.452-.647 1.954-1.098 2.5-2 .595.995 1.151 1.427 2.5 2 1.31-.621 1.862-1.058 2.5-2 .629.977 1.162 1.423 2.5 2 1.209-.548 1.68-.967 2-2 1.032.916 1.683 1.157 3 1-1.297-1.036-1.758-2.03-2-3-.5-2-4-4-8-4Z",
      key: "tnsqj"
    }
  ]
]);
const Bn = r("OctagonAlertIcon", [
  [
    "polygon",
    {
      points: "7.86 2 16.14 2 22 7.86 22 16.14 16.14 22 7.86 22 2 16.14 2 7.86 7.86 2",
      key: "h1p8hx"
    }
  ],
  ["line", { x1: "12", x2: "12", y1: "8", y2: "12", key: "1pkeuh" }],
  ["line", { x1: "12", x2: "12.01", y1: "16", y2: "16", key: "4dfq90" }]
]);
const zn = r("OctagonPauseIcon", [
  ["path", { d: "M10 15V9", key: "1lckn7" }],
  ["path", { d: "M14 15V9", key: "1muqhk" }],
  ["path", { d: "M7.714 2h8.572L22 7.714v8.572L16.286 22H7.714L2 16.286V7.714z", key: "p5imkh" }]
]);
const Hn = r("OctagonXIcon", [
  [
    "polygon",
    {
      points: "7.86 2 16.14 2 22 7.86 22 16.14 16.14 22 7.86 22 2 16.14 2 7.86 7.86 2",
      key: "h1p8hx"
    }
  ],
  ["path", { d: "m15 9-6 6", key: "1uzhvr" }],
  ["path", { d: "m9 9 6 6", key: "z0biqf" }]
]);
const fm = r("OctagonIcon", [
  [
    "polygon",
    {
      points: "7.86 2 16.14 2 22 7.86 22 16.14 16.14 22 7.86 22 2 16.14 2 7.86 7.86 2",
      key: "h1p8hx"
    }
  ]
]);
const vm = r("OptionIcon", [
  ["path", { d: "M3 3h6l6 18h6", key: "ph9rgk" }],
  ["path", { d: "M14 3h7", key: "16f0ms" }]
]);
const mm = r("OrbitIcon", [
  ["circle", { cx: "12", cy: "12", r: "3", key: "1v7zrd" }],
  ["circle", { cx: "19", cy: "5", r: "2", key: "mhkx31" }],
  ["circle", { cx: "5", cy: "19", r: "2", key: "v8kfzx" }],
  ["path", { d: "M10.4 21.9a10 10 0 0 0 9.941-15.416", key: "eohfx2" }],
  ["path", { d: "M13.5 2.1a10 10 0 0 0-9.841 15.416", key: "19pvbm" }]
]);
const gm = r("Package2Icon", [
  ["path", { d: "M3 9h18v10a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2V9Z", key: "1ront0" }],
  ["path", { d: "m3 9 2.45-4.9A2 2 0 0 1 7.24 3h9.52a2 2 0 0 1 1.8 1.1L21 9", key: "19h2x1" }],
  ["path", { d: "M12 3v6", key: "1holv5" }]
]);
const Mm = r("PackageCheckIcon", [
  ["path", { d: "m16 16 2 2 4-4", key: "gfu2re" }],
  [
    "path",
    {
      d: "M21 10V8a2 2 0 0 0-1-1.73l-7-4a2 2 0 0 0-2 0l-7 4A2 2 0 0 0 3 8v8a2 2 0 0 0 1 1.73l7 4a2 2 0 0 0 2 0l2-1.14",
      key: "e7tb2h"
    }
  ],
  ["path", { d: "m7.5 4.27 9 5.15", key: "1c824w" }],
  ["polyline", { points: "3.29 7 12 12 20.71 7", key: "ousv84" }],
  ["line", { x1: "12", x2: "12", y1: "22", y2: "12", key: "a4e8g8" }]
]);
const xm = r("PackageMinusIcon", [
  ["path", { d: "M16 16h6", key: "100bgy" }],
  [
    "path",
    {
      d: "M21 10V8a2 2 0 0 0-1-1.73l-7-4a2 2 0 0 0-2 0l-7 4A2 2 0 0 0 3 8v8a2 2 0 0 0 1 1.73l7 4a2 2 0 0 0 2 0l2-1.14",
      key: "e7tb2h"
    }
  ],
  ["path", { d: "m7.5 4.27 9 5.15", key: "1c824w" }],
  ["polyline", { points: "3.29 7 12 12 20.71 7", key: "ousv84" }],
  ["line", { x1: "12", x2: "12", y1: "22", y2: "12", key: "a4e8g8" }]
]);
const bm = r("PackageOpenIcon", [
  ["path", { d: "M12 22v-9", key: "x3hkom" }],
  [
    "path",
    {
      d: "M15.17 2.21a1.67 1.67 0 0 1 1.63 0L21 4.57a1.93 1.93 0 0 1 0 3.36L8.82 14.79a1.655 1.655 0 0 1-1.64 0L3 12.43a1.93 1.93 0 0 1 0-3.36z",
      key: "2ntwy6"
    }
  ],
  [
    "path",
    {
      d: "M20 13v3.87a2.06 2.06 0 0 1-1.11 1.83l-6 3.08a1.93 1.93 0 0 1-1.78 0l-6-3.08A2.06 2.06 0 0 1 4 16.87V13",
      key: "1pmm1c"
    }
  ],
  [
    "path",
    {
      d: "M21 12.43a1.93 1.93 0 0 0 0-3.36L8.83 2.2a1.64 1.64 0 0 0-1.63 0L3 4.57a1.93 1.93 0 0 0 0 3.36l12.18 6.86a1.636 1.636 0 0 0 1.63 0z",
      key: "12ttoo"
    }
  ]
]);
const wm = r("PackagePlusIcon", [
  ["path", { d: "M16 16h6", key: "100bgy" }],
  ["path", { d: "M19 13v6", key: "85cyf1" }],
  [
    "path",
    {
      d: "M21 10V8a2 2 0 0 0-1-1.73l-7-4a2 2 0 0 0-2 0l-7 4A2 2 0 0 0 3 8v8a2 2 0 0 0 1 1.73l7 4a2 2 0 0 0 2 0l2-1.14",
      key: "e7tb2h"
    }
  ],
  ["path", { d: "m7.5 4.27 9 5.15", key: "1c824w" }],
  ["polyline", { points: "3.29 7 12 12 20.71 7", key: "ousv84" }],
  ["line", { x1: "12", x2: "12", y1: "22", y2: "12", key: "a4e8g8" }]
]);
const Im = r("PackageSearchIcon", [
  [
    "path",
    {
      d: "M21 10V8a2 2 0 0 0-1-1.73l-7-4a2 2 0 0 0-2 0l-7 4A2 2 0 0 0 3 8v8a2 2 0 0 0 1 1.73l7 4a2 2 0 0 0 2 0l2-1.14",
      key: "e7tb2h"
    }
  ],
  ["path", { d: "m7.5 4.27 9 5.15", key: "1c824w" }],
  ["polyline", { points: "3.29 7 12 12 20.71 7", key: "ousv84" }],
  ["line", { x1: "12", x2: "12", y1: "22", y2: "12", key: "a4e8g8" }],
  ["circle", { cx: "18.5", cy: "15.5", r: "2.5", key: "b5zd12" }],
  ["path", { d: "M20.27 17.27 22 19", key: "1l4muz" }]
]);
const Lm = r("PackageXIcon", [
  [
    "path",
    {
      d: "M21 10V8a2 2 0 0 0-1-1.73l-7-4a2 2 0 0 0-2 0l-7 4A2 2 0 0 0 3 8v8a2 2 0 0 0 1 1.73l7 4a2 2 0 0 0 2 0l2-1.14",
      key: "e7tb2h"
    }
  ],
  ["path", { d: "m7.5 4.27 9 5.15", key: "1c824w" }],
  ["polyline", { points: "3.29 7 12 12 20.71 7", key: "ousv84" }],
  ["line", { x1: "12", x2: "12", y1: "22", y2: "12", key: "a4e8g8" }],
  ["path", { d: "m17 13 5 5m-5 0 5-5", key: "im3w4b" }]
]);
const Sm = r("PackageIcon", [
  ["path", { d: "m7.5 4.27 9 5.15", key: "1c824w" }],
  [
    "path",
    {
      d: "M21 8a2 2 0 0 0-1-1.73l-7-4a2 2 0 0 0-2 0l-7 4A2 2 0 0 0 3 8v8a2 2 0 0 0 1 1.73l7 4a2 2 0 0 0 2 0l7-4A2 2 0 0 0 21 16Z",
      key: "hh9hay"
    }
  ],
  ["path", { d: "m3.3 7 8.7 5 8.7-5", key: "g66t2b" }],
  ["path", { d: "M12 22V12", key: "d0xqtd" }]
]);
const Cm = r("PaintBucketIcon", [
  [
    "path",
    { d: "m19 11-8-8-8.6 8.6a2 2 0 0 0 0 2.8l5.2 5.2c.8.8 2 .8 2.8 0L19 11Z", key: "irua1i" }
  ],
  ["path", { d: "m5 2 5 5", key: "1lls2c" }],
  ["path", { d: "M2 13h15", key: "1hkzvu" }],
  ["path", { d: "M22 20a2 2 0 1 1-4 0c0-1.6 1.7-2.4 2-4 .3 1.6 2 2.4 2 4Z", key: "xk76lq" }]
]);
const Am = r("PaintRollerIcon", [
  ["rect", { width: "16", height: "6", x: "2", y: "2", rx: "2", key: "jcyz7m" }],
  ["path", { d: "M10 16v-2a2 2 0 0 1 2-2h8a2 2 0 0 0 2-2V7a2 2 0 0 0-2-2h-2", key: "1b9h7c" }],
  ["rect", { width: "4", height: "6", x: "8", y: "16", rx: "1", key: "d6e7yl" }]
]);
const Pm = r("Paintbrush2Icon", [
  [
    "path",
    { d: "M14 19.9V16h3a2 2 0 0 0 2-2v-2H5v2c0 1.1.9 2 2 2h3v3.9a2 2 0 1 0 4 0Z", key: "1c8kta" }
  ],
  ["path", { d: "M6 12V2h12v10", key: "1esbnf" }],
  ["path", { d: "M14 2v4", key: "qmzblu" }],
  ["path", { d: "M10 2v2", key: "7u0qdc" }]
]);
const qm = r("PaintbrushIcon", [
  [
    "path",
    {
      d: "M18.37 2.63 14 7l-1.59-1.59a2 2 0 0 0-2.82 0L8 7l9 9 1.59-1.59a2 2 0 0 0 0-2.82L17 10l4.37-4.37a2.12 2.12 0 1 0-3-3Z",
      key: "m6k5sh"
    }
  ],
  ["path", { d: "M9 8c-2 3-4 3.5-7 4l8 10c2-1 6-5 6-7", key: "arzq70" }],
  ["path", { d: "M14.5 17.5 4.5 15", key: "s7fvrz" }]
]);
const Tm = r("PaletteIcon", [
  ["circle", { cx: "13.5", cy: "6.5", r: ".5", fill: "currentColor", key: "1okk4w" }],
  ["circle", { cx: "17.5", cy: "10.5", r: ".5", fill: "currentColor", key: "f64h9f" }],
  ["circle", { cx: "8.5", cy: "7.5", r: ".5", fill: "currentColor", key: "fotxhn" }],
  ["circle", { cx: "6.5", cy: "12.5", r: ".5", fill: "currentColor", key: "qy21gx" }],
  [
    "path",
    {
      d: "M12 2C6.5 2 2 6.5 2 12s4.5 10 10 10c.926 0 1.648-.746 1.648-1.688 0-.437-.18-.835-.437-1.125-.29-.289-.438-.652-.438-1.125a1.64 1.64 0 0 1 1.668-1.668h1.996c3.051 0 5.555-2.503 5.555-5.554C21.965 6.012 17.461 2 12 2z",
      key: "12rzf8"
    }
  ]
]);
const Dm = r("PanelBottomCloseIcon", [
  ["rect", { width: "18", height: "18", x: "3", y: "3", rx: "2", key: "afitv7" }],
  ["path", { d: "M3 15h18", key: "5xshup" }],
  ["path", { d: "m15 8-3 3-3-3", key: "1oxy1z" }]
]);
const jn = r("PanelBottomDashedIcon", [
  ["rect", { width: "18", height: "18", x: "3", y: "3", rx: "2", key: "afitv7" }],
  ["path", { d: "M14 15h1", key: "171nev" }],
  ["path", { d: "M19 15h2", key: "1vnucp" }],
  ["path", { d: "M3 15h2", key: "8bym0q" }],
  ["path", { d: "M9 15h1", key: "1tg3ks" }]
]);
const _m = r("PanelBottomOpenIcon", [
  ["rect", { width: "18", height: "18", x: "3", y: "3", rx: "2", key: "afitv7" }],
  ["path", { d: "M3 15h18", key: "5xshup" }],
  ["path", { d: "m9 10 3-3 3 3", key: "11gsxs" }]
]);
const Bm = r("PanelBottomIcon", [
  ["rect", { width: "18", height: "18", x: "3", y: "3", rx: "2", key: "afitv7" }],
  ["path", { d: "M3 15h18", key: "5xshup" }]
]);
const Vn = r("PanelLeftCloseIcon", [
  ["rect", { width: "18", height: "18", x: "3", y: "3", rx: "2", key: "afitv7" }],
  ["path", { d: "M9 3v18", key: "fh3hqa" }],
  ["path", { d: "m16 15-3-3 3-3", key: "14y99z" }]
]);
const On = r("PanelLeftDashedIcon", [
  ["rect", { width: "18", height: "18", x: "3", y: "3", rx: "2", key: "afitv7" }],
  ["path", { d: "M9 14v1", key: "askpd8" }],
  ["path", { d: "M9 19v2", key: "16tejx" }],
  ["path", { d: "M9 3v2", key: "1noubl" }],
  ["path", { d: "M9 9v1", key: "19ebxg" }]
]);
const $n = r("PanelLeftOpenIcon", [
  ["rect", { width: "18", height: "18", x: "3", y: "3", rx: "2", key: "afitv7" }],
  ["path", { d: "M9 3v18", key: "fh3hqa" }],
  ["path", { d: "m14 9 3 3-3 3", key: "8010ee" }]
]);
const Rn = r("PanelLeftIcon", [
  ["rect", { width: "18", height: "18", x: "3", y: "3", rx: "2", key: "afitv7" }],
  ["path", { d: "M9 3v18", key: "fh3hqa" }]
]);
const zm = r("PanelRightCloseIcon", [
  ["rect", { width: "18", height: "18", x: "3", y: "3", rx: "2", key: "afitv7" }],
  ["path", { d: "M15 3v18", key: "14nvp0" }],
  ["path", { d: "m8 9 3 3-3 3", key: "12hl5m" }]
]);
const Fn = r("PanelRightDashedIcon", [
  ["rect", { width: "18", height: "18", x: "3", y: "3", rx: "2", key: "afitv7" }],
  ["path", { d: "M15 14v1", key: "ilsfch" }],
  ["path", { d: "M15 19v2", key: "1fst2f" }],
  ["path", { d: "M15 3v2", key: "z204g4" }],
  ["path", { d: "M15 9v1", key: "z2a8b1" }]
]);
const Hm = r("PanelRightOpenIcon", [
  ["rect", { width: "18", height: "18", x: "3", y: "3", rx: "2", key: "afitv7" }],
  ["path", { d: "M15 3v18", key: "14nvp0" }],
  ["path", { d: "m10 15-3-3 3-3", key: "1pgupc" }]
]);
const jm = r("PanelRightIcon", [
  ["rect", { width: "18", height: "18", x: "3", y: "3", rx: "2", key: "afitv7" }],
  ["path", { d: "M15 3v18", key: "14nvp0" }]
]);
const Vm = r("PanelTopCloseIcon", [
  ["rect", { width: "18", height: "18", x: "3", y: "3", rx: "2", key: "afitv7" }],
  ["path", { d: "M3 9h18", key: "1pudct" }],
  ["path", { d: "m9 16 3-3 3 3", key: "1idcnm" }]
]);
const Un = r("PanelTopDashedIcon", [
  ["rect", { width: "18", height: "18", x: "3", y: "3", rx: "2", key: "afitv7" }],
  ["path", { d: "M14 9h1", key: "l0svgy" }],
  ["path", { d: "M19 9h2", key: "te2zfg" }],
  ["path", { d: "M3 9h2", key: "1h4ldw" }],
  ["path", { d: "M9 9h1", key: "15jzuz" }]
]);
const Om = r("PanelTopOpenIcon", [
  ["rect", { width: "18", height: "18", x: "3", y: "3", rx: "2", key: "afitv7" }],
  ["path", { d: "M3 9h18", key: "1pudct" }],
  ["path", { d: "m15 14-3 3-3-3", key: "g215vf" }]
]);
const $m = r("PanelTopIcon", [
  ["rect", { width: "18", height: "18", x: "3", y: "3", rx: "2", key: "afitv7" }],
  ["path", { d: "M3 9h18", key: "1pudct" }]
]);
const Rm = r("PanelsLeftBottomIcon", [
  ["rect", { width: "18", height: "18", x: "3", y: "3", rx: "2", key: "afitv7" }],
  ["path", { d: "M9 3v18", key: "fh3hqa" }],
  ["path", { d: "M9 15h12", key: "5ijen5" }]
]);
const Fm = r("PanelsRightBottomIcon", [
  ["rect", { width: "18", height: "18", x: "3", y: "3", rx: "2", key: "afitv7" }],
  ["path", { d: "M3 15h12", key: "1wkqb3" }],
  ["path", { d: "M15 3v18", key: "14nvp0" }]
]);
const En = r("PanelsTopLeftIcon", [
  ["rect", { width: "18", height: "18", x: "3", y: "3", rx: "2", key: "afitv7" }],
  ["path", { d: "M3 9h18", key: "1pudct" }],
  ["path", { d: "M9 21V9", key: "1oto5p" }]
]);
const Um = r("PaperclipIcon", [
  [
    "path",
    {
      d: "m21.44 11.05-9.19 9.19a6 6 0 0 1-8.49-8.49l8.57-8.57A4 4 0 1 1 18 8.84l-8.59 8.57a2 2 0 0 1-2.83-2.83l8.49-8.48",
      key: "1u3ebp"
    }
  ]
]);
const Em = r("ParenthesesIcon", [
  ["path", { d: "M8 21s-4-3-4-9 4-9 4-9", key: "uto9ud" }],
  ["path", { d: "M16 3s4 3 4 9-4 9-4 9", key: "4w2vsq" }]
]);
const Wm = r("ParkingMeterIcon", [
  ["path", { d: "M9 9a3 3 0 1 1 6 0", key: "jdoeu8" }],
  ["path", { d: "M12 12v3", key: "158kv8" }],
  ["path", { d: "M11 15h2", key: "199qp6" }],
  [
    "path",
    {
      d: "M19 9a7 7 0 1 0-13.6 2.3C6.4 14.4 8 19 8 19h8s1.6-4.6 2.6-7.7c.3-.8.4-1.5.4-2.3",
      key: "1l50wn"
    }
  ],
  ["path", { d: "M12 19v3", key: "npa21l" }]
]);
const Nm = r("PartyPopperIcon", [
  ["path", { d: "M5.8 11.3 2 22l10.7-3.79", key: "gwxi1d" }],
  ["path", { d: "M4 3h.01", key: "1vcuye" }],
  ["path", { d: "M22 8h.01", key: "1mrtc2" }],
  ["path", { d: "M15 2h.01", key: "1cjtqr" }],
  ["path", { d: "M22 20h.01", key: "1mrys2" }],
  [
    "path",
    {
      d: "m22 2-2.24.75a2.9 2.9 0 0 0-1.96 3.12v0c.1.86-.57 1.63-1.45 1.63h-.38c-.86 0-1.6.6-1.76 1.44L14 10",
      key: "bpx1uq"
    }
  ],
  [
    "path",
    { d: "m22 13-.82-.33c-.86-.34-1.82.2-1.98 1.11v0c-.11.7-.72 1.22-1.43 1.22H17", key: "1pd0s7" }
  ],
  [
    "path",
    { d: "m11 2 .33.82c.34.86-.2 1.82-1.11 1.98v0C9.52 4.9 9 5.52 9 6.23V7", key: "zq5xbz" }
  ],
  [
    "path",
    {
      d: "M11 13c1.93 1.93 2.83 4.17 2 5-.83.83-3.07-.07-5-2-1.93-1.93-2.83-4.17-2-5 .83-.83 3.07.07 5 2Z",
      key: "4kbmks"
    }
  ]
]);
const Zm = r("PauseIcon", [
  ["rect", { x: "14", y: "4", width: "4", height: "16", rx: "1", key: "zuxfzm" }],
  ["rect", { x: "6", y: "4", width: "4", height: "16", rx: "1", key: "1okwgv" }]
]);
const Ym = r("PawPrintIcon", [
  ["circle", { cx: "11", cy: "4", r: "2", key: "vol9p0" }],
  ["circle", { cx: "18", cy: "8", r: "2", key: "17gozi" }],
  ["circle", { cx: "20", cy: "16", r: "2", key: "1v9bxh" }],
  [
    "path",
    {
      d: "M9 10a5 5 0 0 1 5 5v3.5a3.5 3.5 0 0 1-6.84 1.045Q6.52 17.48 4.46 16.84A3.5 3.5 0 0 1 5.5 10Z",
      key: "1ydw1z"
    }
  ]
]);
const Gm = r("PcCaseIcon", [
  ["rect", { width: "14", height: "20", x: "5", y: "2", rx: "2", key: "1uq1d7" }],
  ["path", { d: "M15 14h.01", key: "1kp3bh" }],
  ["path", { d: "M9 6h6", key: "dgm16u" }],
  ["path", { d: "M9 10h6", key: "9gxzsh" }]
]);
const Wn = r("PenLineIcon", [
  ["path", { d: "M12 20h9", key: "t2du7b" }],
  ["path", { d: "M16.5 3.5a2.12 2.12 0 0 1 3 3L7 19l-4 1 1-4Z", key: "ymcmye" }]
]);
const Xm = r("PenToolIcon", [
  [
    "path",
    {
      d: "M15.707 21.293a1 1 0 0 1-1.414 0l-1.586-1.586a1 1 0 0 1 0-1.414l5.586-5.586a1 1 0 0 1 1.414 0l1.586 1.586a1 1 0 0 1 0 1.414z",
      key: "nt11vn"
    }
  ],
  [
    "path",
    {
      d: "m18 13-1.375-6.874a1 1 0 0 0-.746-.776L3.235 2.028a1 1 0 0 0-1.207 1.207L5.35 15.879a1 1 0 0 0 .776.746L13 18",
      key: "15qc1e"
    }
  ],
  ["path", { d: "m2.3 2.3 7.286 7.286", key: "1wuzzi" }],
  ["circle", { cx: "11", cy: "11", r: "2", key: "xmgehs" }]
]);
const Nn = r("PenIcon", [
  ["path", { d: "M17 3a2.85 2.83 0 1 1 4 4L7.5 20.5 2 22l1.5-5.5Z", key: "5qss01" }]
]);
const Km = r("PencilLineIcon", [
  ["path", { d: "M12 20h9", key: "t2du7b" }],
  ["path", { d: "M16.5 3.5a2.12 2.12 0 0 1 3 3L7 19l-4 1 1-4Z", key: "ymcmye" }],
  ["path", { d: "m15 5 3 3", key: "1w25hb" }]
]);
const Qm = r("PencilRulerIcon", [
  ["path", { d: "m15 5 4 4", key: "1mk7zo" }],
  [
    "path",
    { d: "M13 7 8.7 2.7a2.41 2.41 0 0 0-3.4 0L2.7 5.3a2.41 2.41 0 0 0 0 3.4L7 13", key: "orapub" }
  ],
  ["path", { d: "m8 6 2-2", key: "115y1s" }],
  ["path", { d: "m2 22 5.5-1.5L21.17 6.83a2.82 2.82 0 0 0-4-4L3.5 16.5Z", key: "hes763" }],
  ["path", { d: "m18 16 2-2", key: "ee94s4" }],
  [
    "path",
    {
      d: "m17 11 4.3 4.3c.94.94.94 2.46 0 3.4l-2.6 2.6c-.94.94-2.46.94-3.4 0L11 17",
      key: "cfq27r"
    }
  ]
]);
const Jm = r("PencilIcon", [
  ["path", { d: "M17 3a2.85 2.83 0 1 1 4 4L7.5 20.5 2 22l1.5-5.5Z", key: "5qss01" }],
  ["path", { d: "m15 5 4 4", key: "1mk7zo" }]
]);
const e5 = r("PentagonIcon", [
  [
    "path",
    {
      d: "M3.5 8.7c-.7.5-1 1.4-.7 2.2l2.8 8.7c.3.8 1 1.4 1.9 1.4h9.1c.9 0 1.6-.6 1.9-1.4l2.8-8.7c.3-.8 0-1.7-.7-2.2l-7.4-5.3a2.1 2.1 0 0 0-2.4 0Z",
      key: "hsj90r"
    }
  ]
]);
const t5 = r("PercentIcon", [
  ["line", { x1: "19", x2: "5", y1: "5", y2: "19", key: "1x9vlm" }],
  ["circle", { cx: "6.5", cy: "6.5", r: "2.5", key: "4mh3h7" }],
  ["circle", { cx: "17.5", cy: "17.5", r: "2.5", key: "1mdrzq" }]
]);
const a5 = r("PersonStandingIcon", [
  ["circle", { cx: "12", cy: "5", r: "1", key: "gxeob9" }],
  ["path", { d: "m9 20 3-6 3 6", key: "se2kox" }],
  ["path", { d: "m6 8 6 2 6-2", key: "4o3us4" }],
  ["path", { d: "M12 10v4", key: "1kjpxc" }]
]);
const n5 = r("PhoneCallIcon", [
  [
    "path",
    {
      d: "M22 16.92v3a2 2 0 0 1-2.18 2 19.79 19.79 0 0 1-8.63-3.07 19.5 19.5 0 0 1-6-6 19.79 19.79 0 0 1-3.07-8.67A2 2 0 0 1 4.11 2h3a2 2 0 0 1 2 1.72 12.84 12.84 0 0 0 .7 2.81 2 2 0 0 1-.45 2.11L8.09 9.91a16 16 0 0 0 6 6l1.27-1.27a2 2 0 0 1 2.11-.45 12.84 12.84 0 0 0 2.81.7A2 2 0 0 1 22 16.92z",
      key: "foiqr5"
    }
  ],
  ["path", { d: "M14.05 2a9 9 0 0 1 8 7.94", key: "vmijpz" }],
  ["path", { d: "M14.05 6A5 5 0 0 1 18 10", key: "13nbpp" }]
]);
const o5 = r("PhoneForwardedIcon", [
  ["polyline", { points: "18 2 22 6 18 10", key: "6vjanh" }],
  ["line", { x1: "14", x2: "22", y1: "6", y2: "6", key: "1jsywh" }],
  [
    "path",
    {
      d: "M22 16.92v3a2 2 0 0 1-2.18 2 19.79 19.79 0 0 1-8.63-3.07 19.5 19.5 0 0 1-6-6 19.79 19.79 0 0 1-3.07-8.67A2 2 0 0 1 4.11 2h3a2 2 0 0 1 2 1.72 12.84 12.84 0 0 0 .7 2.81 2 2 0 0 1-.45 2.11L8.09 9.91a16 16 0 0 0 6 6l1.27-1.27a2 2 0 0 1 2.11-.45 12.84 12.84 0 0 0 2.81.7A2 2 0 0 1 22 16.92z",
      key: "foiqr5"
    }
  ]
]);
const r5 = r("PhoneIncomingIcon", [
  ["polyline", { points: "16 2 16 8 22 8", key: "1ygljm" }],
  ["line", { x1: "22", x2: "16", y1: "2", y2: "8", key: "1xzwqn" }],
  [
    "path",
    {
      d: "M22 16.92v3a2 2 0 0 1-2.18 2 19.79 19.79 0 0 1-8.63-3.07 19.5 19.5 0 0 1-6-6 19.79 19.79 0 0 1-3.07-8.67A2 2 0 0 1 4.11 2h3a2 2 0 0 1 2 1.72 12.84 12.84 0 0 0 .7 2.81 2 2 0 0 1-.45 2.11L8.09 9.91a16 16 0 0 0 6 6l1.27-1.27a2 2 0 0 1 2.11-.45 12.84 12.84 0 0 0 2.81.7A2 2 0 0 1 22 16.92z",
      key: "foiqr5"
    }
  ]
]);
const i5 = r("PhoneMissedIcon", [
  ["line", { x1: "22", x2: "16", y1: "2", y2: "8", key: "1xzwqn" }],
  ["line", { x1: "16", x2: "22", y1: "2", y2: "8", key: "13zxdn" }],
  [
    "path",
    {
      d: "M22 16.92v3a2 2 0 0 1-2.18 2 19.79 19.79 0 0 1-8.63-3.07 19.5 19.5 0 0 1-6-6 19.79 19.79 0 0 1-3.07-8.67A2 2 0 0 1 4.11 2h3a2 2 0 0 1 2 1.72 12.84 12.84 0 0 0 .7 2.81 2 2 0 0 1-.45 2.11L8.09 9.91a16 16 0 0 0 6 6l1.27-1.27a2 2 0 0 1 2.11-.45 12.84 12.84 0 0 0 2.81.7A2 2 0 0 1 22 16.92z",
      key: "foiqr5"
    }
  ]
]);
const l5 = r("PhoneOffIcon", [
  [
    "path",
    {
      d: "M10.68 13.31a16 16 0 0 0 3.41 2.6l1.27-1.27a2 2 0 0 1 2.11-.45 12.84 12.84 0 0 0 2.81.7 2 2 0 0 1 1.72 2v3a2 2 0 0 1-2.18 2 19.79 19.79 0 0 1-8.63-3.07 19.42 19.42 0 0 1-3.33-2.67m-2.67-3.34a19.79 19.79 0 0 1-3.07-8.63A2 2 0 0 1 4.11 2h3a2 2 0 0 1 2 1.72 12.84 12.84 0 0 0 .7 2.81 2 2 0 0 1-.45 2.11L8.09 9.91",
      key: "z86iuo"
    }
  ],
  ["line", { x1: "22", x2: "2", y1: "2", y2: "22", key: "11kh81" }]
]);
const c5 = r("PhoneOutgoingIcon", [
  ["polyline", { points: "22 8 22 2 16 2", key: "1g204g" }],
  ["line", { x1: "16", x2: "22", y1: "8", y2: "2", key: "1ggias" }],
  [
    "path",
    {
      d: "M22 16.92v3a2 2 0 0 1-2.18 2 19.79 19.79 0 0 1-8.63-3.07 19.5 19.5 0 0 1-6-6 19.79 19.79 0 0 1-3.07-8.67A2 2 0 0 1 4.11 2h3a2 2 0 0 1 2 1.72 12.84 12.84 0 0 0 .7 2.81 2 2 0 0 1-.45 2.11L8.09 9.91a16 16 0 0 0 6 6l1.27-1.27a2 2 0 0 1 2.11-.45 12.84 12.84 0 0 0 2.81.7A2 2 0 0 1 22 16.92z",
      key: "foiqr5"
    }
  ]
]);
const d5 = r("PhoneIcon", [
  [
    "path",
    {
      d: "M22 16.92v3a2 2 0 0 1-2.18 2 19.79 19.79 0 0 1-8.63-3.07 19.5 19.5 0 0 1-6-6 19.79 19.79 0 0 1-3.07-8.67A2 2 0 0 1 4.11 2h3a2 2 0 0 1 2 1.72 12.84 12.84 0 0 0 .7 2.81 2 2 0 0 1-.45 2.11L8.09 9.91a16 16 0 0 0 6 6l1.27-1.27a2 2 0 0 1 2.11-.45 12.84 12.84 0 0 0 2.81.7A2 2 0 0 1 22 16.92z",
      key: "foiqr5"
    }
  ]
]);
const s5 = r("PiIcon", [
  ["line", { x1: "9", x2: "9", y1: "4", y2: "20", key: "ovs5a5" }],
  ["path", { d: "M4 7c0-1.7 1.3-3 3-3h13", key: "10pag4" }],
  ["path", { d: "M18 20c-1.7 0-3-1.3-3-3V4", key: "1gaosr" }]
]);
const u5 = r("PianoIcon", [
  [
    "path",
    {
      d: "M18.5 8c-1.4 0-2.6-.8-3.2-2A6.87 6.87 0 0 0 2 9v11a2 2 0 0 0 2 2h16a2 2 0 0 0 2-2v-8.5C22 9.6 20.4 8 18.5 8",
      key: "lag0yf"
    }
  ],
  ["path", { d: "M2 14h20", key: "myj16y" }],
  ["path", { d: "M6 14v4", key: "9ng0ue" }],
  ["path", { d: "M10 14v4", key: "1v8uk5" }],
  ["path", { d: "M14 14v4", key: "1tqops" }],
  ["path", { d: "M18 14v4", key: "18uqwm" }]
]);
const h5 = r("PickaxeIcon", [
  ["path", { d: "M14.531 12.469 6.619 20.38a1 1 0 1 1-3-3l7.912-7.912", key: "we99rg" }],
  [
    "path",
    {
      d: "M15.686 4.314A12.5 12.5 0 0 0 5.461 2.958 1 1 0 0 0 5.58 4.71a22 22 0 0 1 6.318 3.393",
      key: "1w6hck"
    }
  ],
  [
    "path",
    {
      d: "M17.7 3.7a1 1 0 0 0-1.4 0l-4.6 4.6a1 1 0 0 0 0 1.4l2.6 2.6a1 1 0 0 0 1.4 0l4.6-4.6a1 1 0 0 0 0-1.4z",
      key: "15hgfx"
    }
  ],
  [
    "path",
    {
      d: "M19.686 8.314a12.501 12.501 0 0 1 1.356 10.225 1 1 0 0 1-1.751-.119 22 22 0 0 0-3.393-6.319",
      key: "452b4h"
    }
  ]
]);
const p5 = r("PictureInPicture2Icon", [
  ["path", { d: "M21 9V6a2 2 0 0 0-2-2H4a2 2 0 0 0-2 2v10c0 1.1.9 2 2 2h4", key: "daa4of" }],
  ["rect", { width: "10", height: "7", x: "12", y: "13", rx: "2", key: "1nb8gs" }]
]);
const y5 = r("PictureInPictureIcon", [
  [
    "path",
    {
      d: "M8 4.5v5H3m-1-6 6 6m13 0v-3c0-1.16-.84-2-2-2h-7m-9 9v2c0 1.05.95 2 2 2h3",
      key: "bcd8fb"
    }
  ],
  ["rect", { width: "10", height: "7", x: "12", y: "13.5", ry: "2", key: "136fx3" }]
]);
const k5 = r("PieChartIcon", [
  ["path", { d: "M21.21 15.89A10 10 0 1 1 8 2.83", key: "k2fpak" }],
  ["path", { d: "M22 12A10 10 0 0 0 12 2v10z", key: "1rfc4y" }]
]);
const f5 = r("PiggyBankIcon", [
  [
    "path",
    {
      d: "M19 5c-1.5 0-2.8 1.4-3 2-3.5-1.5-11-.3-11 5 0 1.8 0 3 2 4.5V20h4v-2h3v2h4v-4c1-.5 1.7-1 2-2h2v-4h-2c0-1-.5-1.5-1-2h0V5z",
      key: "uf6l00"
    }
  ],
  ["path", { d: "M2 9v1c0 1.1.9 2 2 2h1", key: "nm575m" }],
  ["path", { d: "M16 11h0", key: "k2aug8" }]
]);
const v5 = r("PilcrowLeftIcon", [
  ["path", { d: "M14 3v11", key: "mlfb7b" }],
  ["path", { d: "M14 9h-3a3 3 0 0 1 0-6h9", key: "1ulc19" }],
  ["path", { d: "M18 3v11", key: "1phi0r" }],
  ["path", { d: "M22 18H2l4-4", key: "yt65j9" }],
  ["path", { d: "m6 22-4-4", key: "6jgyf5" }]
]);
const m5 = r("PilcrowRightIcon", [
  ["path", { d: "M10 3v11", key: "o3l5kj" }],
  ["path", { d: "M10 9H7a1 1 0 0 1 0-6h8", key: "1wb1nc" }],
  ["path", { d: "M14 3v11", key: "mlfb7b" }],
  ["path", { d: "m18 14 4 4H2", key: "4r8io1" }],
  ["path", { d: "m22 18-4 4", key: "1hjjrd" }]
]);
const g5 = r("PilcrowIcon", [
  ["path", { d: "M13 4v16", key: "8vvj80" }],
  ["path", { d: "M17 4v16", key: "7dpous" }],
  ["path", { d: "M19 4H9.5a4.5 4.5 0 0 0 0 9H13", key: "sh4n9v" }]
]);
const M5 = r("PillIcon", [
  [
    "path",
    { d: "m10.5 20.5 10-10a4.95 4.95 0 1 0-7-7l-10 10a4.95 4.95 0 1 0 7 7Z", key: "wa1lgi" }
  ],
  ["path", { d: "m8.5 8.5 7 7", key: "rvfmvr" }]
]);
const x5 = r("PinOffIcon", [
  ["line", { x1: "2", x2: "22", y1: "2", y2: "22", key: "a6p6uj" }],
  ["line", { x1: "12", x2: "12", y1: "17", y2: "22", key: "1jrz49" }],
  ["path", { d: "M9 9v1.76a2 2 0 0 1-1.11 1.79l-1.78.9A2 2 0 0 0 5 15.24V17h12", key: "13x2n8" }],
  ["path", { d: "M15 9.34V6h1a2 2 0 0 0 0-4H7.89", key: "reo3ki" }]
]);
const b5 = r("PinIcon", [
  ["line", { x1: "12", x2: "12", y1: "17", y2: "22", key: "1jrz49" }],
  [
    "path",
    {
      d: "M5 17h14v-1.76a2 2 0 0 0-1.11-1.79l-1.78-.9A2 2 0 0 1 15 10.76V6h1a2 2 0 0 0 0-4H8a2 2 0 0 0 0 4h1v4.76a2 2 0 0 1-1.11 1.79l-1.78.9A2 2 0 0 0 5 15.24Z",
      key: "13yl11"
    }
  ]
]);
const w5 = r("PipetteIcon", [
  ["path", { d: "m2 22 1-1h3l9-9", key: "1sre89" }],
  ["path", { d: "M3 21v-3l9-9", key: "hpe2y6" }],
  [
    "path",
    {
      d: "m15 6 3.4-3.4a2.1 2.1 0 1 1 3 3L18 9l.4.4a2.1 2.1 0 1 1-3 3l-3.8-3.8a2.1 2.1 0 1 1 3-3l.4.4Z",
      key: "196du1"
    }
  ]
]);
const I5 = r("PizzaIcon", [
  ["path", { d: "M15 11h.01", key: "rns66s" }],
  ["path", { d: "M11 15h.01", key: "k85uqc" }],
  ["path", { d: "M16 16h.01", key: "1f9h7w" }],
  ["path", { d: "m2 16 20 6-6-20A20 20 0 0 0 2 16", key: "e4slt2" }],
  ["path", { d: "M5.71 17.11a17.04 17.04 0 0 1 11.4-11.4", key: "rerf8f" }]
]);
const L5 = r("PlaneLandingIcon", [
  ["path", { d: "M2 22h20", key: "272qi7" }],
  [
    "path",
    {
      d: "M3.77 10.77 2 9l2-4.5 1.1.55c.55.28.9.84.9 1.45s.35 1.17.9 1.45L8 8.5l3-6 1.05.53a2 2 0 0 1 1.09 1.52l.72 5.4a2 2 0 0 0 1.09 1.52l4.4 2.2c.42.22.78.55 1.01.96l.6 1.03c.49.88-.06 1.98-1.06 2.1l-1.18.15c-.47.06-.95-.02-1.37-.24L4.29 11.15a2 2 0 0 1-.52-.38Z",
      key: "1ma21e"
    }
  ]
]);
const S5 = r("PlaneTakeoffIcon", [
  ["path", { d: "M2 22h20", key: "272qi7" }],
  [
    "path",
    {
      d: "M6.36 17.4 4 17l-2-4 1.1-.55a2 2 0 0 1 1.8 0l.17.1a2 2 0 0 0 1.8 0L8 12 5 6l.9-.45a2 2 0 0 1 2.09.2l4.02 3a2 2 0 0 0 2.1.2l4.19-2.06a2.41 2.41 0 0 1 1.73-.17L21 7a1.4 1.4 0 0 1 .87 1.99l-.38.76c-.23.46-.6.84-1.07 1.08L7.58 17.2a2 2 0 0 1-1.22.18Z",
      key: "fkigj9"
    }
  ]
]);
const C5 = r("PlaneIcon", [
  [
    "path",
    {
      d: "M17.8 19.2 16 11l3.5-3.5C21 6 21.5 4 21 3c-1-.5-3 0-4.5 1.5L13 8 4.8 6.2c-.5-.1-.9.1-1.1.5l-.3.5c-.2.5-.1 1 .3 1.3L9 12l-2 3H4l-1 1 3 2 2 3 1-1v-3l3-2 3.5 5.3c.3.4.8.5 1.3.3l.5-.2c.4-.3.6-.7.5-1.2z",
      key: "1v9wt8"
    }
  ]
]);
const A5 = r("PlayIcon", [
  ["polygon", { points: "6 3 20 12 6 21 6 3", key: "1oa8hb" }]
]);
const P5 = r("Plug2Icon", [
  ["path", { d: "M9 2v6", key: "17ngun" }],
  ["path", { d: "M15 2v6", key: "s7yy2p" }],
  ["path", { d: "M12 17v5", key: "bb1du9" }],
  ["path", { d: "M5 8h14", key: "pcz4l3" }],
  ["path", { d: "M6 11V8h12v3a6 6 0 1 1-12 0v0Z", key: "nd4hoy" }]
]);
const q5 = r("PlugZap2Icon", [
  ["path", { d: "m13 2-2 2.5h3L12 7", key: "1me98u" }],
  ["path", { d: "M10 14v-3", key: "1mllf3" }],
  ["path", { d: "M14 14v-3", key: "1l3fkq" }],
  ["path", { d: "M11 19c-1.7 0-3-1.3-3-3v-2h8v2c0 1.7-1.3 3-3 3Z", key: "jd5pat" }],
  ["path", { d: "M12 22v-3", key: "kmzjlo" }]
]);
const T5 = r("PlugZapIcon", [
  [
    "path",
    { d: "M6.3 20.3a2.4 2.4 0 0 0 3.4 0L12 18l-6-6-2.3 2.3a2.4 2.4 0 0 0 0 3.4Z", key: "goz73y" }
  ],
  ["path", { d: "m2 22 3-3", key: "19mgm9" }],
  ["path", { d: "M7.5 13.5 10 11", key: "7xgeeb" }],
  ["path", { d: "M10.5 16.5 13 14", key: "10btkg" }],
  ["path", { d: "m18 3-4 4h6l-4 4", key: "16psg9" }]
]);
const D5 = r("PlugIcon", [
  ["path", { d: "M12 22v-5", key: "1ega77" }],
  ["path", { d: "M9 8V2", key: "14iosj" }],
  ["path", { d: "M15 8V2", key: "18g5xt" }],
  ["path", { d: "M18 8v5a4 4 0 0 1-4 4h-4a4 4 0 0 1-4-4V8Z", key: "osxo6l" }]
]);
const _5 = r("PlusIcon", [
  ["path", { d: "M5 12h14", key: "1ays0h" }],
  ["path", { d: "M12 5v14", key: "s699le" }]
]);
const B5 = r("PocketKnifeIcon", [
  ["path", { d: "M3 2v1c0 1 2 1 2 2S3 6 3 7s2 1 2 2-2 1-2 2 2 1 2 2", key: "19w3oe" }],
  ["path", { d: "M18 6h.01", key: "1v4wsw" }],
  ["path", { d: "M6 18h.01", key: "uhywen" }],
  ["path", { d: "M20.83 8.83a4 4 0 0 0-5.66-5.66l-12 12a4 4 0 1 0 5.66 5.66Z", key: "6fykxj" }],
  ["path", { d: "M18 11.66V22a4 4 0 0 0 4-4V6", key: "1utzek" }]
]);
const z5 = r("PocketIcon", [
  [
    "path",
    {
      d: "M4 3h16a2 2 0 0 1 2 2v6a10 10 0 0 1-10 10A10 10 0 0 1 2 11V5a2 2 0 0 1 2-2z",
      key: "1mz881"
    }
  ],
  ["polyline", { points: "8 10 12 14 16 10", key: "w4mbv5" }]
]);
const H5 = r("PodcastIcon", [
  ["path", { d: "M16.85 18.58a9 9 0 1 0-9.7 0", key: "d71mpg" }],
  ["path", { d: "M8 14a5 5 0 1 1 8 0", key: "fc81rn" }],
  ["circle", { cx: "12", cy: "11", r: "1", key: "1gvufo" }],
  ["path", { d: "M13 17a1 1 0 1 0-2 0l.5 4.5a.5.5 0 1 0 1 0Z", key: "za5kbj" }]
]);
const j5 = r("PointerOffIcon", [
  ["path", { d: "M10 4.5V4a2 2 0 0 0-2.41-1.957", key: "jsi14n" }],
  ["path", { d: "M13.9 8.4a2 2 0 0 0-1.26-1.295", key: "hirc7f" }],
  [
    "path",
    { d: "M21.7 16.2A8 8 0 0 0 22 14v-3a2 2 0 1 0-4 0v-1a2 2 0 0 0-3.63-1.158", key: "1jxb2e" }
  ],
  [
    "path",
    {
      d: "m7 15-1.8-1.8a2 2 0 0 0-2.79 2.86L6 19.7a7.74 7.74 0 0 0 6 2.3h2a8 8 0 0 0 5.657-2.343",
      key: "10r7hm"
    }
  ],
  ["path", { d: "M6 6v8", key: "tv5xkp" }],
  ["path", { d: "m2 2 20 20", key: "1ooewy" }]
]);
const V5 = r("PointerIcon", [
  ["path", { d: "M22 14a8 8 0 0 1-8 8", key: "56vcr3" }],
  ["path", { d: "M18 11v-1a2 2 0 0 0-2-2v0a2 2 0 0 0-2 2v0", key: "1pp0yd" }],
  ["path", { d: "M14 10V9a2 2 0 0 0-2-2v0a2 2 0 0 0-2 2v1", key: "u654g" }],
  ["path", { d: "M10 9.5V4a2 2 0 0 0-2-2v0a2 2 0 0 0-2 2v10", key: "1e2dtv" }],
  [
    "path",
    {
      d: "M18 11a2 2 0 1 1 4 0v3a8 8 0 0 1-8 8h-2c-2.8 0-4.5-.86-5.99-2.34l-3.6-3.6a2 2 0 0 1 2.83-2.82L7 15",
      key: "g6ys72"
    }
  ]
]);
const O5 = r("PopcornIcon", [
  [
    "path",
    {
      d: "M18 8a2 2 0 0 0 0-4 2 2 0 0 0-4 0 2 2 0 0 0-4 0 2 2 0 0 0-4 0 2 2 0 0 0 0 4",
      key: "10td1f"
    }
  ],
  ["path", { d: "M10 22 9 8", key: "yjptiv" }],
  ["path", { d: "m14 22 1-14", key: "8jwc8b" }],
  [
    "path",
    {
      d: "M20 8c.5 0 .9.4.8 1l-2.6 12c-.1.5-.7 1-1.2 1H7c-.6 0-1.1-.4-1.2-1L3.2 9c-.1-.6.3-1 .8-1Z",
      key: "1qo33t"
    }
  ]
]);
const $5 = r("PopsicleIcon", [
  [
    "path",
    {
      d: "M18.6 14.4c.8-.8.8-2 0-2.8l-8.1-8.1a4.95 4.95 0 1 0-7.1 7.1l8.1 8.1c.9.7 2.1.7 2.9-.1Z",
      key: "1o68ps"
    }
  ],
  ["path", { d: "m22 22-5.5-5.5", key: "17o70y" }]
]);
const R5 = r("PoundSterlingIcon", [
  ["path", { d: "M18 7c0-5.333-8-5.333-8 0", key: "1prm2n" }],
  ["path", { d: "M10 7v14", key: "18tmcs" }],
  ["path", { d: "M6 21h12", key: "4dkmi1" }],
  ["path", { d: "M6 13h10", key: "ybwr4a" }]
]);
const F5 = r("PowerOffIcon", [
  ["path", { d: "M18.36 6.64A9 9 0 0 1 20.77 15", key: "dxknvb" }],
  ["path", { d: "M6.16 6.16a9 9 0 1 0 12.68 12.68", key: "1x7qb5" }],
  ["path", { d: "M12 2v4", key: "3427ic" }],
  ["path", { d: "m2 2 20 20", key: "1ooewy" }]
]);
const U5 = r("PowerIcon", [
  ["path", { d: "M12 2v10", key: "mnfbl" }],
  ["path", { d: "M18.4 6.6a9 9 0 1 1-12.77.04", key: "obofu9" }]
]);
const E5 = r("PresentationIcon", [
  ["path", { d: "M2 3h20", key: "91anmk" }],
  ["path", { d: "M21 3v11a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2V3", key: "2k9sn8" }],
  ["path", { d: "m7 21 5-5 5 5", key: "bip4we" }]
]);
const W5 = r("PrinterIcon", [
  ["polyline", { points: "6 9 6 2 18 2 18 9", key: "1306q4" }],
  [
    "path",
    {
      d: "M6 18H4a2 2 0 0 1-2-2v-5a2 2 0 0 1 2-2h16a2 2 0 0 1 2 2v5a2 2 0 0 1-2 2h-2",
      key: "143wyd"
    }
  ],
  ["rect", { width: "12", height: "8", x: "6", y: "14", key: "5ipwut" }]
]);
const N5 = r("ProjectorIcon", [
  ["path", { d: "M5 7 3 5", key: "1yys58" }],
  ["path", { d: "M9 6V3", key: "1ptz9u" }],
  ["path", { d: "m13 7 2-2", key: "1w3vmq" }],
  ["circle", { cx: "9", cy: "13", r: "3", key: "1mma13" }],
  [
    "path",
    {
      d: "M11.83 12H20a2 2 0 0 1 2 2v4a2 2 0 0 1-2 2H4a2 2 0 0 1-2-2v-4a2 2 0 0 1 2-2h2.17",
      key: "2frwzc"
    }
  ],
  ["path", { d: "M16 16h2", key: "dnq2od" }]
]);
const Z5 = r("ProportionsIcon", [
  ["rect", { width: "20", height: "16", x: "2", y: "4", rx: "2", key: "18n3k1" }],
  ["path", { d: "M12 9v11", key: "1fnkrn" }],
  ["path", { d: "M2 9h13a2 2 0 0 1 2 2v9", key: "11z3ex" }]
]);
const Y5 = r("PuzzleIcon", [
  [
    "path",
    {
      d: "M19.439 7.85c-.049.322.059.648.289.878l1.568 1.568c.47.47.706 1.087.706 1.704s-.235 1.233-.706 1.704l-1.611 1.611a.98.98 0 0 1-.837.276c-.47-.07-.802-.48-.968-.925a2.501 2.501 0 1 0-3.214 3.214c.446.166.855.497.925.968a.979.979 0 0 1-.276.837l-1.61 1.61a2.404 2.404 0 0 1-1.705.707 2.402 2.402 0 0 1-1.704-.706l-1.568-1.568a1.026 1.026 0 0 0-.877-.29c-.493.074-.84.504-1.02.968a2.5 2.5 0 1 1-3.237-3.237c.464-.18.894-.527.967-1.02a1.026 1.026 0 0 0-.289-.877l-1.568-1.568A2.402 2.402 0 0 1 1.998 12c0-.617.236-1.234.706-1.704L4.23 8.77c.24-.24.581-.353.917-.303.515.077.877.528 1.073 1.01a2.5 2.5 0 1 0 3.259-3.259c-.482-.196-.933-.558-1.01-1.073-.05-.336.062-.676.303-.917l1.525-1.525A2.402 2.402 0 0 1 12 1.998c.617 0 1.234.236 1.704.706l1.568 1.568c.23.23.556.338.877.29.493-.074.84-.504 1.02-.968a2.5 2.5 0 1 1 3.237 3.237c-.464.18-.894.527-.967 1.02Z",
      key: "i0oyt7"
    }
  ]
]);
const G5 = r("PyramidIcon", [
  [
    "path",
    {
      d: "M2.5 16.88a1 1 0 0 1-.32-1.43l9-13.02a1 1 0 0 1 1.64 0l9 13.01a1 1 0 0 1-.32 1.44l-8.51 4.86a2 2 0 0 1-1.98 0Z",
      key: "aenxs0"
    }
  ],
  ["path", { d: "M12 2v20", key: "t6zp3m" }]
]);
const X5 = r("QrCodeIcon", [
  ["rect", { width: "5", height: "5", x: "3", y: "3", rx: "1", key: "1tu5fj" }],
  ["rect", { width: "5", height: "5", x: "16", y: "3", rx: "1", key: "1v8r4q" }],
  ["rect", { width: "5", height: "5", x: "3", y: "16", rx: "1", key: "1x03jg" }],
  ["path", { d: "M21 16h-3a2 2 0 0 0-2 2v3", key: "177gqh" }],
  ["path", { d: "M21 21v.01", key: "ents32" }],
  ["path", { d: "M12 7v3a2 2 0 0 1-2 2H7", key: "8crl2c" }],
  ["path", { d: "M3 12h.01", key: "nlz23k" }],
  ["path", { d: "M12 3h.01", key: "n36tog" }],
  ["path", { d: "M12 16v.01", key: "133mhm" }],
  ["path", { d: "M16 12h1", key: "1slzba" }],
  ["path", { d: "M21 12v.01", key: "1lwtk9" }],
  ["path", { d: "M12 21v-1", key: "1880an" }]
]);
const K5 = r("QuoteIcon", [
  [
    "path",
    {
      d: "M3 21c3 0 7-1 7-8V5c0-1.25-.756-2.017-2-2H4c-1.25 0-2 .75-2 1.972V11c0 1.25.75 2 2 2 1 0 1 0 1 1v1c0 1-1 2-2 2s-1 .008-1 1.031V20c0 1 0 1 1 1z",
      key: "4rm80e"
    }
  ],
  [
    "path",
    {
      d: "M15 21c3 0 7-1 7-8V5c0-1.25-.757-2.017-2-2h-4c-1.25 0-2 .75-2 1.972V11c0 1.25.75 2 2 2h.75c0 2.25.25 4-2.75 4v3c0 1 0 1 1 1z",
      key: "10za9r"
    }
  ]
]);
const Q5 = r("RabbitIcon", [
  ["path", { d: "M13 16a3 3 0 0 1 2.24 5", key: "1epib5" }],
  ["path", { d: "M18 12h.01", key: "yjnet6" }],
  [
    "path",
    {
      d: "M18 21h-8a4 4 0 0 1-4-4 7 7 0 0 1 7-7h.2L9.6 6.4a1 1 0 1 1 2.8-2.8L15.8 7h.2c3.3 0 6 2.7 6 6v1a2 2 0 0 1-2 2h-1a3 3 0 0 0-3 3",
      key: "ue9ozu"
    }
  ],
  ["path", { d: "M20 8.54V4a2 2 0 1 0-4 0v3", key: "49iql8" }],
  ["path", { d: "M7.612 12.524a3 3 0 1 0-1.6 4.3", key: "1e33i0" }]
]);
const J5 = r("RadarIcon", [
  ["path", { d: "M19.07 4.93A10 10 0 0 0 6.99 3.34", key: "z3du51" }],
  ["path", { d: "M4 6h.01", key: "oypzma" }],
  ["path", { d: "M2.29 9.62A10 10 0 1 0 21.31 8.35", key: "qzzz0" }],
  ["path", { d: "M16.24 7.76A6 6 0 1 0 8.23 16.67", key: "1yjesh" }],
  ["path", { d: "M12 18h.01", key: "mhygvu" }],
  ["path", { d: "M17.99 11.66A6 6 0 0 1 15.77 16.67", key: "1u2y91" }],
  ["circle", { cx: "12", cy: "12", r: "2", key: "1c9p78" }],
  ["path", { d: "m13.41 10.59 5.66-5.66", key: "mhq4k0" }]
]);
const e3 = r("RadiationIcon", [
  ["path", { d: "M12 12h0.01", key: "6ztbls" }],
  [
    "path",
    {
      d: "M7.5 4.2c-.3-.5-.9-.7-1.3-.4C3.9 5.5 2.3 8.1 2 11c-.1.5.4 1 1 1h5c0-1.5.8-2.8 2-3.4-1.1-1.9-2-3.5-2.5-4.4z",
      key: "wy49g3"
    }
  ],
  [
    "path",
    {
      d: "M21 12c.6 0 1-.4 1-1-.3-2.9-1.8-5.5-4.1-7.1-.4-.3-1.1-.2-1.3.3-.6.9-1.5 2.5-2.6 4.3 1.2.7 2 2 2 3.5h5z",
      key: "vklnvr"
    }
  ],
  [
    "path",
    {
      d: "M7.5 19.8c-.3.5-.1 1.1.4 1.3 2.6 1.2 5.6 1.2 8.2 0 .5-.2.7-.8.4-1.3-.5-.9-1.4-2.5-2.5-4.3-1.2.7-2.8.7-4 0-1.1 1.8-2 3.4-2.5 4.3z",
      key: "wkdf1o"
    }
  ]
]);
const t3 = r("RadicalIcon", [
  ["path", { d: "M3 12h4l3 9 4-17h7", key: "bpxjrx" }]
]);
const a3 = r("RadioReceiverIcon", [
  ["path", { d: "M5 16v2", key: "g5qcv5" }],
  ["path", { d: "M19 16v2", key: "1gbaio" }],
  ["rect", { width: "20", height: "8", x: "2", y: "8", rx: "2", key: "vjsjur" }],
  ["path", { d: "M18 12h0", key: "1ucjzd" }]
]);
const n3 = r("RadioTowerIcon", [
  ["path", { d: "M4.9 16.1C1 12.2 1 5.8 4.9 1.9", key: "s0qx1y" }],
  ["path", { d: "M7.8 4.7a6.14 6.14 0 0 0-.8 7.5", key: "1idnkw" }],
  ["circle", { cx: "12", cy: "9", r: "2", key: "1092wv" }],
  ["path", { d: "M16.2 4.8c2 2 2.26 5.11.8 7.47", key: "ojru2q" }],
  ["path", { d: "M19.1 1.9a9.96 9.96 0 0 1 0 14.1", key: "rhi7fg" }],
  ["path", { d: "M9.5 18h5", key: "mfy3pd" }],
  ["path", { d: "m8 22 4-11 4 11", key: "25yftu" }]
]);
const o3 = r("RadioIcon", [
  ["path", { d: "M4.9 19.1C1 15.2 1 8.8 4.9 4.9", key: "1vaf9d" }],
  ["path", { d: "M7.8 16.2c-2.3-2.3-2.3-6.1 0-8.5", key: "u1ii0m" }],
  ["circle", { cx: "12", cy: "12", r: "2", key: "1c9p78" }],
  ["path", { d: "M16.2 7.8c2.3 2.3 2.3 6.1 0 8.5", key: "1j5fej" }],
  ["path", { d: "M19.1 4.9C23 8.8 23 15.1 19.1 19", key: "10b0cb" }]
]);
const r3 = r("RadiusIcon", [
  ["path", { d: "M20.34 17.52a10 10 0 1 0-2.82 2.82", key: "fydyku" }],
  ["circle", { cx: "19", cy: "19", r: "2", key: "17f5cg" }],
  ["path", { d: "m13.41 13.41 4.18 4.18", key: "1gqbwc" }],
  ["circle", { cx: "12", cy: "12", r: "2", key: "1c9p78" }]
]);
const i3 = r("RailSymbolIcon", [
  ["path", { d: "M5 15h14", key: "m0yey3" }],
  ["path", { d: "M5 9h14", key: "7tsvo6" }],
  ["path", { d: "m14 20-5-5 6-6-5-5", key: "1jo42i" }]
]);
const l3 = r("RainbowIcon", [
  ["path", { d: "M22 17a10 10 0 0 0-20 0", key: "ozegv" }],
  ["path", { d: "M6 17a6 6 0 0 1 12 0", key: "5giftw" }],
  ["path", { d: "M10 17a2 2 0 0 1 4 0", key: "gnsikk" }]
]);
const c3 = r("RatIcon", [
  [
    "path",
    {
      d: "M17 5c0-1.7-1.3-3-3-3s-3 1.3-3 3c0 .8.3 1.5.8 2H11c-3.9 0-7 3.1-7 7v0c0 2.2 1.8 4 4 4",
      key: "16aj0u"
    }
  ],
  [
    "path",
    {
      d: "M16.8 3.9c.3-.3.6-.5 1-.7 1.5-.6 3.3.1 3.9 1.6.6 1.5-.1 3.3-1.6 3.9l1.6 2.8c.2.3.2.7.2 1-.2.8-.9 1.2-1.7 1.1 0 0-1.6-.3-2.7-.6H17c-1.7 0-3 1.3-3 3",
      key: "1crdmb"
    }
  ],
  ["path", { d: "M13.2 18a3 3 0 0 0-2.2-5", key: "1ol3lk" }],
  ["path", { d: "M13 22H4a2 2 0 0 1 0-4h12", key: "bt3f23" }],
  ["path", { d: "M16 9h.01", key: "1bdo4e" }]
]);
const d3 = r("RatioIcon", [
  ["rect", { width: "12", height: "20", x: "6", y: "2", rx: "2", key: "1oxtiu" }],
  ["rect", { width: "20", height: "12", x: "2", y: "6", rx: "2", key: "9lu3g6" }]
]);
const s3 = r("ReceiptCentIcon", [
  [
    "path",
    { d: "M4 2v20l2-1 2 1 2-1 2 1 2-1 2 1 2-1 2 1V2l-2 1-2-1-2 1-2-1-2 1-2-1-2 1Z", key: "q3az6g" }
  ],
  ["path", { d: "M12 6.5v11", key: "ecfhkf" }],
  ["path", { d: "M15 9.4a4 4 0 1 0 0 5.2", key: "1makmb" }]
]);
const u3 = r("ReceiptEuroIcon", [
  [
    "path",
    { d: "M4 2v20l2-1 2 1 2-1 2 1 2-1 2 1 2-1 2 1V2l-2 1-2-1-2 1-2-1-2 1-2-1-2 1Z", key: "q3az6g" }
  ],
  ["path", { d: "M8 12h5", key: "1g6qi8" }],
  ["path", { d: "M16 9.5a4 4 0 1 0 0 5.2", key: "b2px4r" }]
]);
const h3 = r("ReceiptIndianRupeeIcon", [
  [
    "path",
    { d: "M4 2v20l2-1 2 1 2-1 2 1 2-1 2 1 2-1 2 1V2l-2 1-2-1-2 1-2-1-2 1-2-1-2 1Z", key: "q3az6g" }
  ],
  ["path", { d: "M8 7h8", key: "i86dvs" }],
  ["path", { d: "M12 17.5 8 15h1a4 4 0 0 0 0-8", key: "grpkl4" }],
  ["path", { d: "M8 11h8", key: "vwpz6n" }]
]);
const p3 = r("ReceiptJapaneseYenIcon", [
  [
    "path",
    { d: "M4 2v20l2-1 2 1 2-1 2 1 2-1 2 1 2-1 2 1V2l-2 1-2-1-2 1-2-1-2 1-2-1-2 1Z", key: "q3az6g" }
  ],
  ["path", { d: "m12 10 3-3", key: "1mc12w" }],
  ["path", { d: "m9 7 3 3v7.5", key: "39i0xv" }],
  ["path", { d: "M9 11h6", key: "1fldmi" }],
  ["path", { d: "M9 15h6", key: "cctwl0" }]
]);
const y3 = r("ReceiptPoundSterlingIcon", [
  [
    "path",
    { d: "M4 2v20l2-1 2 1 2-1 2 1 2-1 2 1 2-1 2 1V2l-2 1-2-1-2 1-2-1-2 1-2-1-2 1Z", key: "q3az6g" }
  ],
  ["path", { d: "M8 13h5", key: "1k9z8w" }],
  ["path", { d: "M10 17V9.5a2.5 2.5 0 0 1 5 0", key: "1dzgp0" }],
  ["path", { d: "M8 17h7", key: "8mjdqu" }]
]);
const k3 = r("ReceiptRussianRubleIcon", [
  [
    "path",
    { d: "M4 2v20l2-1 2 1 2-1 2 1 2-1 2 1 2-1 2 1V2l-2 1-2-1-2 1-2-1-2 1-2-1-2 1Z", key: "q3az6g" }
  ],
  ["path", { d: "M8 15h5", key: "vxg57a" }],
  ["path", { d: "M8 11h5a2 2 0 1 0 0-4h-3v10", key: "1usi5u" }]
]);
const f3 = r("ReceiptSwissFrancIcon", [
  [
    "path",
    { d: "M4 2v20l2-1 2 1 2-1 2 1 2-1 2 1 2-1 2 1V2l-2 1-2-1-2 1-2-1-2 1-2-1-2 1Z", key: "q3az6g" }
  ],
  ["path", { d: "M10 17V7h5", key: "k7jq18" }],
  ["path", { d: "M10 11h4", key: "1i0mka" }],
  ["path", { d: "M8 15h5", key: "vxg57a" }]
]);
const v3 = r("ReceiptTextIcon", [
  [
    "path",
    { d: "M4 2v20l2-1 2 1 2-1 2 1 2-1 2 1 2-1 2 1V2l-2 1-2-1-2 1-2-1-2 1-2-1-2 1Z", key: "q3az6g" }
  ],
  ["path", { d: "M14 8H8", key: "1l3xfs" }],
  ["path", { d: "M16 12H8", key: "1fr5h0" }],
  ["path", { d: "M13 16H8", key: "wsln4y" }]
]);
const m3 = r("ReceiptIcon", [
  [
    "path",
    { d: "M4 2v20l2-1 2 1 2-1 2 1 2-1 2 1 2-1 2 1V2l-2 1-2-1-2 1-2-1-2 1-2-1-2 1Z", key: "q3az6g" }
  ],
  ["path", { d: "M16 8h-6a2 2 0 1 0 0 4h4a2 2 0 1 1 0 4H8", key: "1h4pet" }],
  ["path", { d: "M12 17.5v-11", key: "1jc1ny" }]
]);
const Zn = r("RectangleEllipsisIcon", [
  ["rect", { width: "20", height: "12", x: "2", y: "6", rx: "2", key: "9lu3g6" }],
  ["path", { d: "M12 12h.01", key: "1mp3jc" }],
  ["path", { d: "M17 12h.01", key: "1m0b6t" }],
  ["path", { d: "M7 12h.01", key: "eqddd0" }]
]);
const g3 = r("RectangleHorizontalIcon", [
  ["rect", { width: "20", height: "12", x: "2", y: "6", rx: "2", key: "9lu3g6" }]
]);
const M3 = r("RectangleVerticalIcon", [
  ["rect", { width: "12", height: "20", x: "6", y: "2", rx: "2", key: "1oxtiu" }]
]);
const x3 = r("RecycleIcon", [
  [
    "path",
    {
      d: "M7 19H4.815a1.83 1.83 0 0 1-1.57-.881 1.785 1.785 0 0 1-.004-1.784L7.196 9.5",
      key: "x6z5xu"
    }
  ],
  [
    "path",
    {
      d: "M11 19h8.203a1.83 1.83 0 0 0 1.556-.89 1.784 1.784 0 0 0 0-1.775l-1.226-2.12",
      key: "1x4zh5"
    }
  ],
  ["path", { d: "m14 16-3 3 3 3", key: "f6jyew" }],
  ["path", { d: "M8.293 13.596 7.196 9.5 3.1 10.598", key: "wf1obh" }],
  [
    "path",
    {
      d: "m9.344 5.811 1.093-1.892A1.83 1.83 0 0 1 11.985 3a1.784 1.784 0 0 1 1.546.888l3.943 6.843",
      key: "9tzpgr"
    }
  ],
  ["path", { d: "m13.378 9.633 4.096 1.098 1.097-4.096", key: "1oe83g" }]
]);
const b3 = r("Redo2Icon", [
  ["path", { d: "m15 14 5-5-5-5", key: "12vg1m" }],
  ["path", { d: "M20 9H9.5A5.5 5.5 0 0 0 4 14.5v0A5.5 5.5 0 0 0 9.5 20H13", key: "19mnr4" }]
]);
const w3 = r("RedoDotIcon", [
  ["circle", { cx: "12", cy: "17", r: "1", key: "1ixnty" }],
  ["path", { d: "M21 7v6h-6", key: "3ptur4" }],
  ["path", { d: "M3 17a9 9 0 0 1 9-9 9 9 0 0 1 6 2.3l3 2.7", key: "1kgawr" }]
]);
const I3 = r("RedoIcon", [
  ["path", { d: "M21 7v6h-6", key: "3ptur4" }],
  ["path", { d: "M3 17a9 9 0 0 1 9-9 9 9 0 0 1 6 2.3l3 2.7", key: "1kgawr" }]
]);
const L3 = r("RefreshCcwDotIcon", [
  ["path", { d: "M3 2v6h6", key: "18ldww" }],
  ["path", { d: "M21 12A9 9 0 0 0 6 5.3L3 8", key: "1pbrqz" }],
  ["path", { d: "M21 22v-6h-6", key: "usdfbe" }],
  ["path", { d: "M3 12a9 9 0 0 0 15 6.7l3-2.7", key: "1hosoe" }],
  ["circle", { cx: "12", cy: "12", r: "1", key: "41hilf" }]
]);
const S3 = r("RefreshCcwIcon", [
  ["path", { d: "M21 12a9 9 0 0 0-9-9 9.75 9.75 0 0 0-6.74 2.74L3 8", key: "14sxne" }],
  ["path", { d: "M3 3v5h5", key: "1xhq8a" }],
  ["path", { d: "M3 12a9 9 0 0 0 9 9 9.75 9.75 0 0 0 6.74-2.74L21 16", key: "1hlbsb" }],
  ["path", { d: "M16 16h5v5", key: "ccwih5" }]
]);
const C3 = r("RefreshCwOffIcon", [
  ["path", { d: "M21 8L18.74 5.74A9.75 9.75 0 0 0 12 3C11 3 10.03 3.16 9.13 3.47", key: "1krf6h" }],
  ["path", { d: "M8 16H3v5", key: "1cv678" }],
  ["path", { d: "M3 12C3 9.51 4 7.26 5.64 5.64", key: "ruvoct" }],
  ["path", { d: "m3 16 2.26 2.26A9.75 9.75 0 0 0 12 21c2.49 0 4.74-1 6.36-2.64", key: "19q130" }],
  ["path", { d: "M21 12c0 1-.16 1.97-.47 2.87", key: "4w8emr" }],
  ["path", { d: "M21 3v5h-5", key: "1q7to0" }],
  ["path", { d: "M22 22 2 2", key: "1r8tn9" }]
]);
const A3 = r("RefreshCwIcon", [
  ["path", { d: "M3 12a9 9 0 0 1 9-9 9.75 9.75 0 0 1 6.74 2.74L21 8", key: "v9h5vc" }],
  ["path", { d: "M21 3v5h-5", key: "1q7to0" }],
  ["path", { d: "M21 12a9 9 0 0 1-9 9 9.75 9.75 0 0 1-6.74-2.74L3 16", key: "3uifl3" }],
  ["path", { d: "M8 16H3v5", key: "1cv678" }]
]);
const P3 = r("RefrigeratorIcon", [
  [
    "path",
    { d: "M5 6a4 4 0 0 1 4-4h6a4 4 0 0 1 4 4v14a2 2 0 0 1-2 2H7a2 2 0 0 1-2-2V6Z", key: "fpq118" }
  ],
  ["path", { d: "M5 10h14", key: "elsbfy" }],
  ["path", { d: "M15 7v6", key: "1nx30x" }]
]);
const q3 = r("RegexIcon", [
  ["path", { d: "M17 3v10", key: "15fgeh" }],
  ["path", { d: "m12.67 5.5 8.66 5", key: "1gpheq" }],
  ["path", { d: "m12.67 10.5 8.66-5", key: "1dkfa6" }],
  [
    "path",
    { d: "M9 17a2 2 0 0 0-2-2H5a2 2 0 0 0-2 2v2a2 2 0 0 0 2 2h2a2 2 0 0 0 2-2v-2z", key: "swwfx4" }
  ]
]);
const T3 = r("RemoveFormattingIcon", [
  ["path", { d: "M4 7V4h16v3", key: "9msm58" }],
  ["path", { d: "M5 20h6", key: "1h6pxn" }],
  ["path", { d: "M13 4 8 20", key: "kqq6aj" }],
  ["path", { d: "m15 15 5 5", key: "me55sn" }],
  ["path", { d: "m20 15-5 5", key: "11p7ol" }]
]);
const D3 = r("Repeat1Icon", [
  ["path", { d: "m17 2 4 4-4 4", key: "nntrym" }],
  ["path", { d: "M3 11v-1a4 4 0 0 1 4-4h14", key: "84bu3i" }],
  ["path", { d: "m7 22-4-4 4-4", key: "1wqhfi" }],
  ["path", { d: "M21 13v1a4 4 0 0 1-4 4H3", key: "1rx37r" }],
  ["path", { d: "M11 10h1v4", key: "70cz1p" }]
]);
const _3 = r("Repeat2Icon", [
  ["path", { d: "m2 9 3-3 3 3", key: "1ltn5i" }],
  ["path", { d: "M13 18H7a2 2 0 0 1-2-2V6", key: "1r6tfw" }],
  ["path", { d: "m22 15-3 3-3-3", key: "4rnwn2" }],
  ["path", { d: "M11 6h6a2 2 0 0 1 2 2v10", key: "2f72bc" }]
]);
const B3 = r("RepeatIcon", [
  ["path", { d: "m17 2 4 4-4 4", key: "nntrym" }],
  ["path", { d: "M3 11v-1a4 4 0 0 1 4-4h14", key: "84bu3i" }],
  ["path", { d: "m7 22-4-4 4-4", key: "1wqhfi" }],
  ["path", { d: "M21 13v1a4 4 0 0 1-4 4H3", key: "1rx37r" }]
]);
const z3 = r("ReplaceAllIcon", [
  ["path", { d: "M14 4c0-1.1.9-2 2-2", key: "1mvvbw" }],
  ["path", { d: "M20 2c1.1 0 2 .9 2 2", key: "1mj6oe" }],
  ["path", { d: "M22 8c0 1.1-.9 2-2 2", key: "v1wql3" }],
  ["path", { d: "M16 10c-1.1 0-2-.9-2-2", key: "821ux0" }],
  ["path", { d: "m3 7 3 3 3-3", key: "x25e72" }],
  ["path", { d: "M6 10V5c0-1.7 1.3-3 3-3h1", key: "13af7h" }],
  ["rect", { width: "8", height: "8", x: "2", y: "14", rx: "2", key: "17ihk4" }],
  ["path", { d: "M14 14c1.1 0 2 .9 2 2v4c0 1.1-.9 2-2 2", key: "1w9p8c" }],
  ["path", { d: "M20 14c1.1 0 2 .9 2 2v4c0 1.1-.9 2-2 2", key: "m45eaa" }]
]);
const H3 = r("ReplaceIcon", [
  ["path", { d: "M14 4c0-1.1.9-2 2-2", key: "1mvvbw" }],
  ["path", { d: "M20 2c1.1 0 2 .9 2 2", key: "1mj6oe" }],
  ["path", { d: "M22 8c0 1.1-.9 2-2 2", key: "v1wql3" }],
  ["path", { d: "M16 10c-1.1 0-2-.9-2-2", key: "821ux0" }],
  ["path", { d: "m3 7 3 3 3-3", key: "x25e72" }],
  ["path", { d: "M6 10V5c0-1.7 1.3-3 3-3h1", key: "13af7h" }],
  ["rect", { width: "8", height: "8", x: "2", y: "14", rx: "2", key: "17ihk4" }]
]);
const j3 = r("ReplyAllIcon", [
  ["polyline", { points: "7 17 2 12 7 7", key: "t83bqg" }],
  ["polyline", { points: "12 17 7 12 12 7", key: "1g4ajm" }],
  ["path", { d: "M22 18v-2a4 4 0 0 0-4-4H7", key: "1fcyog" }]
]);
const V3 = r("ReplyIcon", [
  ["polyline", { points: "9 17 4 12 9 7", key: "hvgpf2" }],
  ["path", { d: "M20 18v-2a4 4 0 0 0-4-4H4", key: "5vmcpk" }]
]);
const O3 = r("RewindIcon", [
  ["polygon", { points: "11 19 2 12 11 5 11 19", key: "14yba5" }],
  ["polygon", { points: "22 19 13 12 22 5 22 19", key: "1pi1cj" }]
]);
const $3 = r("RibbonIcon", [
  [
    "path",
    {
      d: "M17.75 9.01c-.52 2.08-1.83 3.64-3.18 5.49l-2.6 3.54-2.97 4-3.5-2.54 3.85-4.97c-1.86-2.61-2.8-3.77-3.16-5.44",
      key: "1njedg"
    }
  ],
  [
    "path",
    {
      d: "M17.75 9.01A7 7 0 0 0 6.2 9.1C6.06 8.5 6 7.82 6 7c0-3.5 2.83-5 5.98-5C15.24 2 18 3.5 18 7c0 .73-.09 1.4-.25 2.01Z",
      key: "10len7"
    }
  ],
  ["path", { d: "m9.35 14.53 2.64-3.31", key: "1wfi09" }],
  ["path", { d: "m11.97 18.04 2.99 4 3.54-2.54-3.93-5", key: "1ezyge" }],
  ["path", { d: "M14 8c0 1-1 2-2.01 3.22C11 10 10 9 10 8a2 2 0 1 1 4 0", key: "aw0zq5" }]
]);
const R3 = r("RocketIcon", [
  [
    "path",
    {
      d: "M4.5 16.5c-1.5 1.26-2 5-2 5s3.74-.5 5-2c.71-.84.7-2.13-.09-2.91a2.18 2.18 0 0 0-2.91-.09z",
      key: "m3kijz"
    }
  ],
  [
    "path",
    {
      d: "m12 15-3-3a22 22 0 0 1 2-3.95A12.88 12.88 0 0 1 22 2c0 2.72-.78 7.5-6 11a22.35 22.35 0 0 1-4 2z",
      key: "1fmvmk"
    }
  ],
  ["path", { d: "M9 12H4s.55-3.03 2-4c1.62-1.08 5 0 5 0", key: "1f8sc4" }],
  ["path", { d: "M12 15v5s3.03-.55 4-2c1.08-1.62 0-5 0-5", key: "qeys4" }]
]);
const F3 = r("RockingChairIcon", [
  ["polyline", { points: "3.5 2 6.5 12.5 18 12.5", key: "y3iy52" }],
  ["line", { x1: "9.5", x2: "5.5", y1: "12.5", y2: "20", key: "19vg5i" }],
  ["line", { x1: "15", x2: "18.5", y1: "12.5", y2: "20", key: "1inpmv" }],
  ["path", { d: "M2.75 18a13 13 0 0 0 18.5 0", key: "1nquas" }]
]);
const U3 = r("RollerCoasterIcon", [
  ["path", { d: "M6 19V5", key: "1r845m" }],
  ["path", { d: "M10 19V6.8", key: "9j2tfs" }],
  ["path", { d: "M14 19v-7.8", key: "10s8qv" }],
  ["path", { d: "M18 5v4", key: "1tajlv" }],
  ["path", { d: "M18 19v-6", key: "ielfq3" }],
  ["path", { d: "M22 19V9", key: "158nzp" }],
  ["path", { d: "M2 19V9a4 4 0 0 1 4-4c2 0 4 1.33 6 4s4 4 6 4a4 4 0 1 0-3-6.65", key: "1930oh" }]
]);
const Yn = r("Rotate3dIcon", [
  [
    "path",
    {
      d: "M16.466 7.5C15.643 4.237 13.952 2 12 2 9.239 2 7 6.477 7 12s2.239 10 5 10c.342 0 .677-.069 1-.2",
      key: "10n0gc"
    }
  ],
  ["path", { d: "m15.194 13.707 3.814 1.86-1.86 3.814", key: "16shm9" }],
  [
    "path",
    {
      d: "M19 15.57c-1.804.885-4.274 1.43-7 1.43-5.523 0-10-2.239-10-5s4.477-5 10-5c4.838 0 8.873 1.718 9.8 4",
      key: "1lxi77"
    }
  ]
]);
const E3 = r("RotateCcwSquareIcon", [
  ["path", { d: "M20 9V7a2 2 0 0 0-2-2h-6", key: "19z8uc" }],
  ["path", { d: "m15 2-3 3 3 3", key: "177bxs" }],
  ["path", { d: "M20 13v5a2 2 0 0 1-2 2H6a2 2 0 0 1-2-2V7a2 2 0 0 1 2-2h2", key: "d36hnl" }]
]);
const W3 = r("RotateCcwIcon", [
  ["path", { d: "M3 12a9 9 0 1 0 9-9 9.75 9.75 0 0 0-6.74 2.74L3 8", key: "1357e3" }],
  ["path", { d: "M3 3v5h5", key: "1xhq8a" }]
]);
const N3 = r("RotateCwSquareIcon", [
  ["path", { d: "M12 5H6a2 2 0 0 0-2 2v3", key: "l96uqu" }],
  ["path", { d: "m9 8 3-3-3-3", key: "1gzgc3" }],
  ["path", { d: "M4 14v4a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V7a2 2 0 0 0-2-2h-2", key: "1w2k5h" }]
]);
const Z3 = r("RotateCwIcon", [
  ["path", { d: "M21 12a9 9 0 1 1-9-9c2.52 0 4.93 1 6.74 2.74L21 8", key: "1p45f6" }],
  ["path", { d: "M21 3v5h-5", key: "1q7to0" }]
]);
const Y3 = r("RouteOffIcon", [
  ["circle", { cx: "6", cy: "19", r: "3", key: "1kj8tv" }],
  ["path", { d: "M9 19h8.5c.4 0 .9-.1 1.3-.2", key: "1effex" }],
  ["path", { d: "M5.2 5.2A3.5 3.53 0 0 0 6.5 12H12", key: "k9y2ds" }],
  ["path", { d: "m2 2 20 20", key: "1ooewy" }],
  ["path", { d: "M21 15.3a3.5 3.5 0 0 0-3.3-3.3", key: "11nlu2" }],
  ["path", { d: "M15 5h-4.3", key: "6537je" }],
  ["circle", { cx: "18", cy: "5", r: "3", key: "gq8acd" }]
]);
const G3 = r("RouteIcon", [
  ["circle", { cx: "6", cy: "19", r: "3", key: "1kj8tv" }],
  ["path", { d: "M9 19h8.5a3.5 3.5 0 0 0 0-7h-11a3.5 3.5 0 0 1 0-7H15", key: "1d8sl" }],
  ["circle", { cx: "18", cy: "5", r: "3", key: "gq8acd" }]
]);
const X3 = r("RouterIcon", [
  ["rect", { width: "20", height: "8", x: "2", y: "14", rx: "2", key: "w68u3i" }],
  ["path", { d: "M6.01 18H6", key: "19vcac" }],
  ["path", { d: "M10.01 18H10", key: "uamcmx" }],
  ["path", { d: "M15 10v4", key: "qjz1xs" }],
  ["path", { d: "M17.84 7.17a4 4 0 0 0-5.66 0", key: "1rif40" }],
  ["path", { d: "M20.66 4.34a8 8 0 0 0-11.31 0", key: "6a5xfq" }]
]);
const Gn = r("Rows2Icon", [
  ["rect", { width: "18", height: "18", x: "3", y: "3", rx: "2", key: "afitv7" }],
  ["path", { d: "M3 12h18", key: "1i2n21" }]
]);
const Xn = r("Rows3Icon", [
  ["rect", { width: "18", height: "18", x: "3", y: "3", rx: "2", key: "afitv7" }],
  ["path", { d: "M21 9H3", key: "1338ky" }],
  ["path", { d: "M21 15H3", key: "9uk58r" }]
]);
const K3 = r("Rows4Icon", [
  ["rect", { width: "18", height: "18", x: "3", y: "3", rx: "2", key: "afitv7" }],
  ["path", { d: "M21 7.5H3", key: "1hm9pq" }],
  ["path", { d: "M21 12H3", key: "2avoz0" }],
  ["path", { d: "M21 16.5H3", key: "n7jzkj" }]
]);
const Q3 = r("RssIcon", [
  ["path", { d: "M4 11a9 9 0 0 1 9 9", key: "pv89mb" }],
  ["path", { d: "M4 4a16 16 0 0 1 16 16", key: "k0647b" }],
  ["circle", { cx: "5", cy: "19", r: "1", key: "bfqh0e" }]
]);
const J3 = r("RulerIcon", [
  [
    "path",
    {
      d: "M21.3 15.3a2.4 2.4 0 0 1 0 3.4l-2.6 2.6a2.4 2.4 0 0 1-3.4 0L2.7 8.7a2.41 2.41 0 0 1 0-3.4l2.6-2.6a2.41 2.41 0 0 1 3.4 0Z",
      key: "icamh8"
    }
  ],
  ["path", { d: "m14.5 12.5 2-2", key: "inckbg" }],
  ["path", { d: "m11.5 9.5 2-2", key: "fmmyf7" }],
  ["path", { d: "m8.5 6.5 2-2", key: "vc6u1g" }],
  ["path", { d: "m17.5 15.5 2-2", key: "wo5hmg" }]
]);
const eg = r("RussianRubleIcon", [
  ["path", { d: "M6 11h8a4 4 0 0 0 0-8H9v18", key: "18ai8t" }],
  ["path", { d: "M6 15h8", key: "1y8f6l" }]
]);
const tg = r("SailboatIcon", [
  ["path", { d: "M22 18H2a4 4 0 0 0 4 4h12a4 4 0 0 0 4-4Z", key: "1404fh" }],
  ["path", { d: "M21 14 10 2 3 14h18Z", key: "1nzg7v" }],
  ["path", { d: "M10 2v16", key: "1labyt" }]
]);
const ag = r("SaladIcon", [
  ["path", { d: "M7 21h10", key: "1b0cd5" }],
  ["path", { d: "M12 21a9 9 0 0 0 9-9H3a9 9 0 0 0 9 9Z", key: "4rw317" }],
  [
    "path",
    {
      d: "M11.38 12a2.4 2.4 0 0 1-.4-4.77 2.4 2.4 0 0 1 3.2-2.77 2.4 2.4 0 0 1 3.47-.63 2.4 2.4 0 0 1 3.37 3.37 2.4 2.4 0 0 1-1.1 3.7 2.51 2.51 0 0 1 .03 1.1",
      key: "10xrj0"
    }
  ],
  ["path", { d: "m13 12 4-4", key: "1hckqy" }],
  ["path", { d: "M10.9 7.25A3.99 3.99 0 0 0 4 10c0 .73.2 1.41.54 2", key: "1p4srx" }]
]);
const ng = r("SandwichIcon", [
  ["path", { d: "M3 11v3a1 1 0 0 0 1 1h16a1 1 0 0 0 1-1v-3", key: "34v9d7" }],
  [
    "path",
    {
      d: "M12 19H4a1 1 0 0 1-1-1v-2a1 1 0 0 1 1-1h16a1 1 0 0 1 1 1v2a1 1 0 0 1-1 1h-3.83",
      key: "1k5vfb"
    }
  ],
  ["path", { d: "m3 11 7.77-6.04a2 2 0 0 1 2.46 0L21 11H3Z", key: "1oe7l6" }],
  ["path", { d: "M12.97 19.77 7 15h12.5l-3.75 4.5a2 2 0 0 1-2.78.27Z", key: "1ts2ri" }]
]);
const og = r("SatelliteDishIcon", [
  ["path", { d: "M4 10a7.31 7.31 0 0 0 10 10Z", key: "1fzpp3" }],
  ["path", { d: "m9 15 3-3", key: "88sc13" }],
  ["path", { d: "M17 13a6 6 0 0 0-6-6", key: "15cc6u" }],
  ["path", { d: "M21 13A10 10 0 0 0 11 3", key: "11nf8s" }]
]);
const rg = r("SatelliteIcon", [
  ["path", { d: "M13 7 9 3 5 7l4 4", key: "vyckw6" }],
  ["path", { d: "m17 11 4 4-4 4-4-4", key: "rchckc" }],
  ["path", { d: "m8 12 4 4 6-6-4-4Z", key: "1sshf7" }],
  ["path", { d: "m16 8 3-3", key: "x428zp" }],
  ["path", { d: "M9 21a6 6 0 0 0-6-6", key: "1iajcf" }]
]);
const ig = r("SaveAllIcon", [
  ["path", { d: "M6 4a2 2 0 0 1 2-2h10l4 4v10.2a2 2 0 0 1-2 1.8H8a2 2 0 0 1-2-2Z", key: "1unput" }],
  ["path", { d: "M10 2v4h6", key: "1p5sg6" }],
  ["path", { d: "M18 18v-7h-8v7", key: "1oniuk" }],
  ["path", { d: "M18 22H4a2 2 0 0 1-2-2V6", key: "pblm9e" }]
]);
const lg = r("SaveIcon", [
  ["path", { d: "M19 21H5a2 2 0 0 1-2-2V5a2 2 0 0 1 2-2h11l5 5v11a2 2 0 0 1-2 2z", key: "1owoqh" }],
  ["polyline", { points: "17 21 17 13 7 13 7 21", key: "1md35c" }],
  ["polyline", { points: "7 3 7 8 15 8", key: "8nz8an" }]
]);
const Kn = r("Scale3dIcon", [
  ["circle", { cx: "19", cy: "19", r: "2", key: "17f5cg" }],
  ["circle", { cx: "5", cy: "5", r: "2", key: "1gwv83" }],
  ["path", { d: "M5 7v12h12", key: "vtaa4r" }],
  ["path", { d: "m5 19 6-6", key: "jh6hbb" }]
]);
const cg = r("ScaleIcon", [
  ["path", { d: "m16 16 3-8 3 8c-.87.65-1.92 1-3 1s-2.13-.35-3-1Z", key: "7g6ntu" }],
  ["path", { d: "m2 16 3-8 3 8c-.87.65-1.92 1-3 1s-2.13-.35-3-1Z", key: "ijws7r" }],
  ["path", { d: "M7 21h10", key: "1b0cd5" }],
  ["path", { d: "M12 3v18", key: "108xh3" }],
  ["path", { d: "M3 7h2c2 0 5-1 7-2 2 1 5 2 7 2h2", key: "3gwbw2" }]
]);
const dg = r("ScalingIcon", [
  ["path", { d: "M12 3H5a2 2 0 0 0-2 2v14a2 2 0 0 0 2 2h14a2 2 0 0 0 2-2v-7", key: "1m0v6g" }],
  ["path", { d: "M14 15H9v-5", key: "pi4jk9" }],
  ["path", { d: "M16 3h5v5", key: "1806ms" }],
  ["path", { d: "M21 3 9 15", key: "15kdhq" }]
]);
const sg = r("ScanBarcodeIcon", [
  ["path", { d: "M3 7V5a2 2 0 0 1 2-2h2", key: "aa7l1z" }],
  ["path", { d: "M17 3h2a2 2 0 0 1 2 2v2", key: "4qcy5o" }],
  ["path", { d: "M21 17v2a2 2 0 0 1-2 2h-2", key: "6vwrx8" }],
  ["path", { d: "M7 21H5a2 2 0 0 1-2-2v-2", key: "ioqczr" }],
  ["path", { d: "M8 7v10", key: "23sfjj" }],
  ["path", { d: "M12 7v10", key: "jspqdw" }],
  ["path", { d: "M17 7v10", key: "578dap" }]
]);
const ug = r("ScanEyeIcon", [
  ["path", { d: "M3 7V5a2 2 0 0 1 2-2h2", key: "aa7l1z" }],
  ["path", { d: "M17 3h2a2 2 0 0 1 2 2v2", key: "4qcy5o" }],
  ["path", { d: "M21 17v2a2 2 0 0 1-2 2h-2", key: "6vwrx8" }],
  ["path", { d: "M7 21H5a2 2 0 0 1-2-2v-2", key: "ioqczr" }],
  ["circle", { cx: "12", cy: "12", r: "1", key: "41hilf" }],
  ["path", { d: "M5 12s2.5-5 7-5 7 5 7 5-2.5 5-7 5-7-5-7-5", key: "nhuolu" }]
]);
const hg = r("ScanFaceIcon", [
  ["path", { d: "M3 7V5a2 2 0 0 1 2-2h2", key: "aa7l1z" }],
  ["path", { d: "M17 3h2a2 2 0 0 1 2 2v2", key: "4qcy5o" }],
  ["path", { d: "M21 17v2a2 2 0 0 1-2 2h-2", key: "6vwrx8" }],
  ["path", { d: "M7 21H5a2 2 0 0 1-2-2v-2", key: "ioqczr" }],
  ["path", { d: "M8 14s1.5 2 4 2 4-2 4-2", key: "1y1vjs" }],
  ["path", { d: "M9 9h.01", key: "1q5me6" }],
  ["path", { d: "M15 9h.01", key: "x1ddxp" }]
]);
const pg = r("ScanLineIcon", [
  ["path", { d: "M3 7V5a2 2 0 0 1 2-2h2", key: "aa7l1z" }],
  ["path", { d: "M17 3h2a2 2 0 0 1 2 2v2", key: "4qcy5o" }],
  ["path", { d: "M21 17v2a2 2 0 0 1-2 2h-2", key: "6vwrx8" }],
  ["path", { d: "M7 21H5a2 2 0 0 1-2-2v-2", key: "ioqczr" }],
  ["path", { d: "M7 12h10", key: "b7w52i" }]
]);
const yg = r("ScanSearchIcon", [
  ["path", { d: "M3 7V5a2 2 0 0 1 2-2h2", key: "aa7l1z" }],
  ["path", { d: "M17 3h2a2 2 0 0 1 2 2v2", key: "4qcy5o" }],
  ["path", { d: "M21 17v2a2 2 0 0 1-2 2h-2", key: "6vwrx8" }],
  ["path", { d: "M7 21H5a2 2 0 0 1-2-2v-2", key: "ioqczr" }],
  ["circle", { cx: "12", cy: "12", r: "3", key: "1v7zrd" }],
  ["path", { d: "m16 16-1.9-1.9", key: "1dq9hf" }]
]);
const kg = r("ScanTextIcon", [
  ["path", { d: "M3 7V5a2 2 0 0 1 2-2h2", key: "aa7l1z" }],
  ["path", { d: "M17 3h2a2 2 0 0 1 2 2v2", key: "4qcy5o" }],
  ["path", { d: "M21 17v2a2 2 0 0 1-2 2h-2", key: "6vwrx8" }],
  ["path", { d: "M7 21H5a2 2 0 0 1-2-2v-2", key: "ioqczr" }],
  ["path", { d: "M7 8h8", key: "1jbsf9" }],
  ["path", { d: "M7 12h10", key: "b7w52i" }],
  ["path", { d: "M7 16h6", key: "1vyc9m" }]
]);
const fg = r("ScanIcon", [
  ["path", { d: "M3 7V5a2 2 0 0 1 2-2h2", key: "aa7l1z" }],
  ["path", { d: "M17 3h2a2 2 0 0 1 2 2v2", key: "4qcy5o" }],
  ["path", { d: "M21 17v2a2 2 0 0 1-2 2h-2", key: "6vwrx8" }],
  ["path", { d: "M7 21H5a2 2 0 0 1-2-2v-2", key: "ioqczr" }]
]);
const vg = r("ScatterChartIcon", [
  ["circle", { cx: "7.5", cy: "7.5", r: ".5", fill: "currentColor", key: "kqv944" }],
  ["circle", { cx: "18.5", cy: "5.5", r: ".5", fill: "currentColor", key: "lysivs" }],
  ["circle", { cx: "11.5", cy: "11.5", r: ".5", fill: "currentColor", key: "byv1b8" }],
  ["circle", { cx: "7.5", cy: "16.5", r: ".5", fill: "currentColor", key: "nkw3mc" }],
  ["circle", { cx: "17.5", cy: "14.5", r: ".5", fill: "currentColor", key: "1gjh6j" }],
  ["path", { d: "M3 3v18h18", key: "1s2lah" }]
]);
const mg = r("SchoolIcon", [
  ["path", { d: "M14 22v-4a2 2 0 1 0-4 0v4", key: "hhkicm" }],
  ["path", { d: "m18 10 4 2v8a2 2 0 0 1-2 2H4a2 2 0 0 1-2-2v-8l4-2", key: "1vwozw" }],
  ["path", { d: "M18 5v17", key: "1sw6gf" }],
  ["path", { d: "m4 6 8-4 8 4", key: "1q0ilc" }],
  ["path", { d: "M6 5v17", key: "1xfsm0" }],
  ["circle", { cx: "12", cy: "9", r: "2", key: "1092wv" }]
]);
const gg = r("ScissorsLineDashedIcon", [
  ["path", { d: "M5.42 9.42 8 12", key: "12pkuq" }],
  ["circle", { cx: "4", cy: "8", r: "2", key: "107mxr" }],
  ["path", { d: "m14 6-8.58 8.58", key: "gvzu5l" }],
  ["circle", { cx: "4", cy: "16", r: "2", key: "1ehqvc" }],
  ["path", { d: "M10.8 14.8 14 18", key: "ax7m9r" }],
  ["path", { d: "M16 12h-2", key: "10asgb" }],
  ["path", { d: "M22 12h-2", key: "14jgyd" }]
]);
const Mg = r("ScissorsIcon", [
  ["circle", { cx: "6", cy: "6", r: "3", key: "1lh9wr" }],
  ["path", { d: "M8.12 8.12 12 12", key: "1alkpv" }],
  ["path", { d: "M20 4 8.12 15.88", key: "xgtan2" }],
  ["circle", { cx: "6", cy: "18", r: "3", key: "fqmcym" }],
  ["path", { d: "M14.8 14.8 20 20", key: "ptml3r" }]
]);
const xg = r("ScreenShareOffIcon", [
  ["path", { d: "M13 3H4a2 2 0 0 0-2 2v10a2 2 0 0 0 2 2h16a2 2 0 0 0 2-2v-3", key: "i8wdob" }],
  ["path", { d: "M8 21h8", key: "1ev6f3" }],
  ["path", { d: "M12 17v4", key: "1riwvh" }],
  ["path", { d: "m22 3-5 5", key: "12jva0" }],
  ["path", { d: "m17 3 5 5", key: "k36vhe" }]
]);
const bg = r("ScreenShareIcon", [
  ["path", { d: "M13 3H4a2 2 0 0 0-2 2v10a2 2 0 0 0 2 2h16a2 2 0 0 0 2-2v-3", key: "i8wdob" }],
  ["path", { d: "M8 21h8", key: "1ev6f3" }],
  ["path", { d: "M12 17v4", key: "1riwvh" }],
  ["path", { d: "m17 8 5-5", key: "fqif7o" }],
  ["path", { d: "M17 3h5v5", key: "1o3tu8" }]
]);
const wg = r("ScrollTextIcon", [
  [
    "path",
    { d: "M8 21h12a2 2 0 0 0 2-2v-2H10v2a2 2 0 1 1-4 0V5a2 2 0 1 0-4 0v3h4", key: "13a6an" }
  ],
  ["path", { d: "M19 17V5a2 2 0 0 0-2-2H4", key: "zz82l3" }],
  ["path", { d: "M15 8h-5", key: "1khuty" }],
  ["path", { d: "M15 12h-5", key: "r7krc0" }]
]);
const Ig = r("ScrollIcon", [
  [
    "path",
    { d: "M8 21h12a2 2 0 0 0 2-2v-2H10v2a2 2 0 1 1-4 0V5a2 2 0 1 0-4 0v3h4", key: "13a6an" }
  ],
  ["path", { d: "M19 17V5a2 2 0 0 0-2-2H4", key: "zz82l3" }]
]);
const Lg = r("SearchCheckIcon", [
  ["path", { d: "m8 11 2 2 4-4", key: "1sed1v" }],
  ["circle", { cx: "11", cy: "11", r: "8", key: "4ej97u" }],
  ["path", { d: "m21 21-4.3-4.3", key: "1qie3q" }]
]);
const Sg = r("SearchCodeIcon", [
  ["path", { d: "m9 9-2 2 2 2", key: "17gsfh" }],
  ["path", { d: "m13 13 2-2-2-2", key: "186z8k" }],
  ["circle", { cx: "11", cy: "11", r: "8", key: "4ej97u" }],
  ["path", { d: "m21 21-4.3-4.3", key: "1qie3q" }]
]);
const Cg = r("SearchSlashIcon", [
  ["path", { d: "m13.5 8.5-5 5", key: "1cs55j" }],
  ["circle", { cx: "11", cy: "11", r: "8", key: "4ej97u" }],
  ["path", { d: "m21 21-4.3-4.3", key: "1qie3q" }]
]);
const Ag = r("SearchXIcon", [
  ["path", { d: "m13.5 8.5-5 5", key: "1cs55j" }],
  ["path", { d: "m8.5 8.5 5 5", key: "a8mexj" }],
  ["circle", { cx: "11", cy: "11", r: "8", key: "4ej97u" }],
  ["path", { d: "m21 21-4.3-4.3", key: "1qie3q" }]
]);
const Pg = r("SearchIcon", [
  ["circle", { cx: "11", cy: "11", r: "8", key: "4ej97u" }],
  ["path", { d: "m21 21-4.3-4.3", key: "1qie3q" }]
]);
const Qn = r("SendHorizontalIcon", [
  ["path", { d: "m3 3 3 9-3 9 19-9Z", key: "1aobqy" }],
  ["path", { d: "M6 12h16", key: "s4cdu5" }]
]);
const qg = r("SendToBackIcon", [
  ["rect", { x: "14", y: "14", width: "8", height: "8", rx: "2", key: "1b0bso" }],
  ["rect", { x: "2", y: "2", width: "8", height: "8", rx: "2", key: "1x09vl" }],
  ["path", { d: "M7 14v1a2 2 0 0 0 2 2h1", key: "pao6x6" }],
  ["path", { d: "M14 7h1a2 2 0 0 1 2 2v1", key: "19tdru" }]
]);
const Tg = r("SendIcon", [
  ["path", { d: "m22 2-7 20-4-9-9-4Z", key: "1q3vgg" }],
  ["path", { d: "M22 2 11 13", key: "nzbqef" }]
]);
const Dg = r("SeparatorHorizontalIcon", [
  ["line", { x1: "3", x2: "21", y1: "12", y2: "12", key: "10d38w" }],
  ["polyline", { points: "8 8 12 4 16 8", key: "zo8t4w" }],
  ["polyline", { points: "16 16 12 20 8 16", key: "1oyrid" }]
]);
const _g = r("SeparatorVerticalIcon", [
  ["line", { x1: "12", x2: "12", y1: "3", y2: "21", key: "1efggb" }],
  ["polyline", { points: "8 8 4 12 8 16", key: "bnfmv4" }],
  ["polyline", { points: "16 16 20 12 16 8", key: "u90052" }]
]);
const Bg = r("ServerCogIcon", [
  ["circle", { cx: "12", cy: "12", r: "3", key: "1v7zrd" }],
  [
    "path",
    {
      d: "M4.5 10H4a2 2 0 0 1-2-2V4a2 2 0 0 1 2-2h16a2 2 0 0 1 2 2v4a2 2 0 0 1-2 2h-.5",
      key: "tn8das"
    }
  ],
  [
    "path",
    {
      d: "M4.5 14H4a2 2 0 0 0-2 2v4a2 2 0 0 0 2 2h16a2 2 0 0 0 2-2v-4a2 2 0 0 0-2-2h-.5",
      key: "1g2pve"
    }
  ],
  ["path", { d: "M6 6h.01", key: "1utrut" }],
  ["path", { d: "M6 18h.01", key: "uhywen" }],
  ["path", { d: "m15.7 13.4-.9-.3", key: "1jwmzr" }],
  ["path", { d: "m9.2 10.9-.9-.3", key: "qapnim" }],
  ["path", { d: "m10.6 15.7.3-.9", key: "quwk0k" }],
  ["path", { d: "m13.6 15.7-.4-1", key: "cb9xp7" }],
  ["path", { d: "m10.8 9.3-.4-1", key: "1uaiz5" }],
  ["path", { d: "m8.3 13.6 1-.4", key: "s6srou" }],
  ["path", { d: "m14.7 10.8 1-.4", key: "4d31cq" }],
  ["path", { d: "m13.4 8.3-.3.9", key: "1bm987" }]
]);
const zg = r("ServerCrashIcon", [
  [
    "path",
    {
      d: "M6 10H4a2 2 0 0 1-2-2V4a2 2 0 0 1 2-2h16a2 2 0 0 1 2 2v4a2 2 0 0 1-2 2h-2",
      key: "4b9dqc"
    }
  ],
  [
    "path",
    {
      d: "M6 14H4a2 2 0 0 0-2 2v4a2 2 0 0 0 2 2h16a2 2 0 0 0 2-2v-4a2 2 0 0 0-2-2h-2",
      key: "22nnkd"
    }
  ],
  ["path", { d: "M6 6h.01", key: "1utrut" }],
  ["path", { d: "M6 18h.01", key: "uhywen" }],
  ["path", { d: "m13 6-4 6h6l-4 6", key: "14hqih" }]
]);
const Hg = r("ServerOffIcon", [
  ["path", { d: "M7 2h13a2 2 0 0 1 2 2v4a2 2 0 0 1-2 2h-5", key: "bt2siv" }],
  ["path", { d: "M10 10 2.5 2.5C2 2 2 2.5 2 5v3a2 2 0 0 0 2 2h6z", key: "1hjrv1" }],
  ["path", { d: "M22 17v-1a2 2 0 0 0-2-2h-1", key: "1iynyr" }],
  ["path", { d: "M4 14a2 2 0 0 0-2 2v4a2 2 0 0 0 2 2h16.5l1-.5.5.5-8-8H4z", key: "161ggg" }],
  ["path", { d: "M6 18h.01", key: "uhywen" }],
  ["path", { d: "m2 2 20 20", key: "1ooewy" }]
]);
const jg = r("ServerIcon", [
  ["rect", { width: "20", height: "8", x: "2", y: "2", rx: "2", ry: "2", key: "ngkwjq" }],
  ["rect", { width: "20", height: "8", x: "2", y: "14", rx: "2", ry: "2", key: "iecqi9" }],
  ["line", { x1: "6", x2: "6.01", y1: "6", y2: "6", key: "16zg32" }],
  ["line", { x1: "6", x2: "6.01", y1: "18", y2: "18", key: "nzw8ys" }]
]);
const Vg = r("Settings2Icon", [
  ["path", { d: "M20 7h-9", key: "3s1dr2" }],
  ["path", { d: "M14 17H5", key: "gfn3mx" }],
  ["circle", { cx: "17", cy: "17", r: "3", key: "18b49y" }],
  ["circle", { cx: "7", cy: "7", r: "3", key: "dfmy0x" }]
]);
const Og = r("SettingsIcon", [
  [
    "path",
    {
      d: "M12.22 2h-.44a2 2 0 0 0-2 2v.18a2 2 0 0 1-1 1.73l-.43.25a2 2 0 0 1-2 0l-.15-.08a2 2 0 0 0-2.73.73l-.22.38a2 2 0 0 0 .73 2.73l.15.1a2 2 0 0 1 1 1.72v.51a2 2 0 0 1-1 1.74l-.15.09a2 2 0 0 0-.73 2.73l.22.38a2 2 0 0 0 2.73.73l.15-.08a2 2 0 0 1 2 0l.43.25a2 2 0 0 1 1 1.73V20a2 2 0 0 0 2 2h.44a2 2 0 0 0 2-2v-.18a2 2 0 0 1 1-1.73l.43-.25a2 2 0 0 1 2 0l.15.08a2 2 0 0 0 2.73-.73l.22-.39a2 2 0 0 0-.73-2.73l-.15-.08a2 2 0 0 1-1-1.74v-.5a2 2 0 0 1 1-1.74l.15-.09a2 2 0 0 0 .73-2.73l-.22-.38a2 2 0 0 0-2.73-.73l-.15.08a2 2 0 0 1-2 0l-.43-.25a2 2 0 0 1-1-1.73V4a2 2 0 0 0-2-2z",
      key: "1qme2f"
    }
  ],
  ["circle", { cx: "12", cy: "12", r: "3", key: "1v7zrd" }]
]);
const $g = r("ShapesIcon", [
  [
    "path",
    {
      d: "M8.3 10a.7.7 0 0 1-.626-1.079L11.4 3a.7.7 0 0 1 1.198-.043L16.3 8.9a.7.7 0 0 1-.572 1.1Z",
      key: "1bo67w"
    }
  ],
  ["rect", { x: "3", y: "14", width: "7", height: "7", rx: "1", key: "1bkyp8" }],
  ["circle", { cx: "17.5", cy: "17.5", r: "3.5", key: "w3z12y" }]
]);
const Rg = r("Share2Icon", [
  ["circle", { cx: "18", cy: "5", r: "3", key: "gq8acd" }],
  ["circle", { cx: "6", cy: "12", r: "3", key: "w7nqdw" }],
  ["circle", { cx: "18", cy: "19", r: "3", key: "1xt0gg" }],
  ["line", { x1: "8.59", x2: "15.42", y1: "13.51", y2: "17.49", key: "47mynk" }],
  ["line", { x1: "15.41", x2: "8.59", y1: "6.51", y2: "10.49", key: "1n3mei" }]
]);
const Fg = r("ShareIcon", [
  ["path", { d: "M4 12v8a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2v-8", key: "1b2hhj" }],
  ["polyline", { points: "16 6 12 2 8 6", key: "m901s6" }],
  ["line", { x1: "12", x2: "12", y1: "2", y2: "15", key: "1p0rca" }]
]);
const Ug = r("SheetIcon", [
  ["rect", { width: "18", height: "18", x: "3", y: "3", rx: "2", ry: "2", key: "1m3agn" }],
  ["line", { x1: "3", x2: "21", y1: "9", y2: "9", key: "1vqk6q" }],
  ["line", { x1: "3", x2: "21", y1: "15", y2: "15", key: "o2sbyz" }],
  ["line", { x1: "9", x2: "9", y1: "9", y2: "21", key: "1ib60c" }],
  ["line", { x1: "15", x2: "15", y1: "9", y2: "21", key: "1n26ft" }]
]);
const Eg = r("ShellIcon", [
  [
    "path",
    {
      d: "M14 11a2 2 0 1 1-4 0 4 4 0 0 1 8 0 6 6 0 0 1-12 0 8 8 0 0 1 16 0 10 10 0 1 1-20 0 11.93 11.93 0 0 1 2.42-7.22 2 2 0 1 1 3.16 2.44",
      key: "1cn552"
    }
  ]
]);
const Wg = r("ShieldAlertIcon", [
  [
    "path",
    {
      d: "M20 13c0 5-3.5 7.5-7.66 8.95a1 1 0 0 1-.67-.01C7.5 20.5 4 18 4 13V6a1 1 0 0 1 1-1c2 0 4.5-1.2 6.24-2.72a1.17 1.17 0 0 1 1.52 0C14.51 3.81 17 5 19 5a1 1 0 0 1 1 1z",
      key: "oel41y"
    }
  ],
  ["path", { d: "M12 8v4", key: "1got3b" }],
  ["path", { d: "M12 16h.01", key: "1drbdi" }]
]);
const Ng = r("ShieldBanIcon", [
  [
    "path",
    {
      d: "M20 13c0 5-3.5 7.5-7.66 8.95a1 1 0 0 1-.67-.01C7.5 20.5 4 18 4 13V6a1 1 0 0 1 1-1c2 0 4.5-1.2 6.24-2.72a1.17 1.17 0 0 1 1.52 0C14.51 3.81 17 5 19 5a1 1 0 0 1 1 1z",
      key: "oel41y"
    }
  ],
  ["path", { d: "m4.243 5.21 14.39 12.472", key: "1c9a7c" }]
]);
const Zg = r("ShieldCheckIcon", [
  [
    "path",
    {
      d: "M20 13c0 5-3.5 7.5-7.66 8.95a1 1 0 0 1-.67-.01C7.5 20.5 4 18 4 13V6a1 1 0 0 1 1-1c2 0 4.5-1.2 6.24-2.72a1.17 1.17 0 0 1 1.52 0C14.51 3.81 17 5 19 5a1 1 0 0 1 1 1z",
      key: "oel41y"
    }
  ],
  ["path", { d: "m9 12 2 2 4-4", key: "dzmm74" }]
]);
const Yg = r("ShieldEllipsisIcon", [
  [
    "path",
    {
      d: "M20 13c0 5-3.5 7.5-7.66 8.95a1 1 0 0 1-.67-.01C7.5 20.5 4 18 4 13V6a1 1 0 0 1 1-1c2 0 4.5-1.2 6.24-2.72a1.17 1.17 0 0 1 1.52 0C14.51 3.81 17 5 19 5a1 1 0 0 1 1 1z",
      key: "oel41y"
    }
  ],
  ["path", { d: "M8 12h.01", key: "czm47f" }],
  ["path", { d: "M12 12h.01", key: "1mp3jc" }],
  ["path", { d: "M16 12h.01", key: "1l6xoz" }]
]);
const Gg = r("ShieldHalfIcon", [
  [
    "path",
    {
      d: "M20 13c0 5-3.5 7.5-7.66 8.95a1 1 0 0 1-.67-.01C7.5 20.5 4 18 4 13V6a1 1 0 0 1 1-1c2 0 4.5-1.2 6.24-2.72a1.17 1.17 0 0 1 1.52 0C14.51 3.81 17 5 19 5a1 1 0 0 1 1 1z",
      key: "oel41y"
    }
  ],
  ["path", { d: "M12 22V2", key: "zs6s6o" }]
]);
const Xg = r("ShieldMinusIcon", [
  [
    "path",
    {
      d: "M20 13c0 5-3.5 7.5-7.66 8.95a1 1 0 0 1-.67-.01C7.5 20.5 4 18 4 13V6a1 1 0 0 1 1-1c2 0 4.5-1.2 6.24-2.72a1.17 1.17 0 0 1 1.52 0C14.51 3.81 17 5 19 5a1 1 0 0 1 1 1z",
      key: "oel41y"
    }
  ],
  ["path", { d: "M9 12h6", key: "1c52cq" }]
]);
const Kg = r("ShieldOffIcon", [
  ["path", { d: "m2 2 20 20", key: "1ooewy" }],
  [
    "path",
    {
      d: "M5 5a1 1 0 0 0-1 1v7c0 5 3.5 7.5 7.67 8.94a1 1 0 0 0 .67.01c2.35-.82 4.48-1.97 5.9-3.71",
      key: "1jlk70"
    }
  ],
  [
    "path",
    {
      d: "M9.309 3.652A12.252 12.252 0 0 0 11.24 2.28a1.17 1.17 0 0 1 1.52 0C14.51 3.81 17 5 19 5a1 1 0 0 1 1 1v7a9.784 9.784 0 0 1-.08 1.264",
      key: "18rp1v"
    }
  ]
]);
const Qg = r("ShieldPlusIcon", [
  [
    "path",
    {
      d: "M20 13c0 5-3.5 7.5-7.66 8.95a1 1 0 0 1-.67-.01C7.5 20.5 4 18 4 13V6a1 1 0 0 1 1-1c2 0 4.5-1.2 6.24-2.72a1.17 1.17 0 0 1 1.52 0C14.51 3.81 17 5 19 5a1 1 0 0 1 1 1z",
      key: "oel41y"
    }
  ],
  ["path", { d: "M9 12h6", key: "1c52cq" }],
  ["path", { d: "M12 9v6", key: "199k2o" }]
]);
const Jg = r("ShieldQuestionIcon", [
  [
    "path",
    {
      d: "M20 13c0 5-3.5 7.5-7.66 8.95a1 1 0 0 1-.67-.01C7.5 20.5 4 18 4 13V6a1 1 0 0 1 1-1c2 0 4.5-1.2 6.24-2.72a1.17 1.17 0 0 1 1.52 0C14.51 3.81 17 5 19 5a1 1 0 0 1 1 1z",
      key: "oel41y"
    }
  ],
  ["path", { d: "M9.1 9a3 3 0 0 1 5.82 1c0 2-3 3-3 3", key: "mhlwft" }],
  ["path", { d: "M12 17h.01", key: "p32p05" }]
]);
const Jn = r("ShieldXIcon", [
  [
    "path",
    {
      d: "M20 13c0 5-3.5 7.5-7.66 8.95a1 1 0 0 1-.67-.01C7.5 20.5 4 18 4 13V6a1 1 0 0 1 1-1c2 0 4.5-1.2 6.24-2.72a1.17 1.17 0 0 1 1.52 0C14.51 3.81 17 5 19 5a1 1 0 0 1 1 1z",
      key: "oel41y"
    }
  ],
  ["path", { d: "m14.5 9.5-5 5", key: "17q4r4" }],
  ["path", { d: "m9.5 9.5 5 5", key: "18nt4w" }]
]);
const e6 = r("ShieldIcon", [
  [
    "path",
    {
      d: "M20 13c0 5-3.5 7.5-7.66 8.95a1 1 0 0 1-.67-.01C7.5 20.5 4 18 4 13V6a1 1 0 0 1 1-1c2 0 4.5-1.2 6.24-2.72a1.17 1.17 0 0 1 1.52 0C14.51 3.81 17 5 19 5a1 1 0 0 1 1 1z",
      key: "oel41y"
    }
  ]
]);
const t6 = r("ShipWheelIcon", [
  ["circle", { cx: "12", cy: "12", r: "8", key: "46899m" }],
  ["path", { d: "M12 2v7.5", key: "1e5rl5" }],
  ["path", { d: "m19 5-5.23 5.23", key: "1ezxxf" }],
  ["path", { d: "M22 12h-7.5", key: "le1719" }],
  ["path", { d: "m19 19-5.23-5.23", key: "p3fmgn" }],
  ["path", { d: "M12 14.5V22", key: "dgcmos" }],
  ["path", { d: "M10.23 13.77 5 19", key: "qwopd4" }],
  ["path", { d: "M9.5 12H2", key: "r7bup8" }],
  ["path", { d: "M10.23 10.23 5 5", key: "k2y7lj" }],
  ["circle", { cx: "12", cy: "12", r: "2.5", key: "ix0uyj" }]
]);
const a6 = r("ShipIcon", [
  [
    "path",
    {
      d: "M2 21c.6.5 1.2 1 2.5 1 2.5 0 2.5-2 5-2 1.3 0 1.9.5 2.5 1 .6.5 1.2 1 2.5 1 2.5 0 2.5-2 5-2 1.3 0 1.9.5 2.5 1",
      key: "iegodh"
    }
  ],
  [
    "path",
    { d: "M19.38 20A11.6 11.6 0 0 0 21 14l-9-4-9 4c0 2.9.94 5.34 2.81 7.76", key: "fp8vka" }
  ],
  ["path", { d: "M19 13V7a2 2 0 0 0-2-2H7a2 2 0 0 0-2 2v6", key: "qpkstq" }],
  ["path", { d: "M12 10v4", key: "1kjpxc" }],
  ["path", { d: "M12 2v3", key: "qbqxhf" }]
]);
const n6 = r("ShirtIcon", [
  [
    "path",
    {
      d: "M20.38 3.46 16 2a4 4 0 0 1-8 0L3.62 3.46a2 2 0 0 0-1.34 2.23l.58 3.47a1 1 0 0 0 .99.84H6v10c0 1.1.9 2 2 2h8a2 2 0 0 0 2-2V10h2.15a1 1 0 0 0 .99-.84l.58-3.47a2 2 0 0 0-1.34-2.23z",
      key: "1wgbhj"
    }
  ]
]);
const o6 = r("ShoppingBagIcon", [
  ["path", { d: "M6 2 3 6v14a2 2 0 0 0 2 2h14a2 2 0 0 0 2-2V6l-3-4Z", key: "hou9p0" }],
  ["path", { d: "M3 6h18", key: "d0wm0j" }],
  ["path", { d: "M16 10a4 4 0 0 1-8 0", key: "1ltviw" }]
]);
const r6 = r("ShoppingBasketIcon", [
  ["path", { d: "m15 11-1 9", key: "5wnq3a" }],
  ["path", { d: "m19 11-4-7", key: "cnml18" }],
  ["path", { d: "M2 11h20", key: "3eubbj" }],
  ["path", { d: "m3.5 11 1.6 7.4a2 2 0 0 0 2 1.6h9.8a2 2 0 0 0 2-1.6l1.7-7.4", key: "yiazzp" }],
  ["path", { d: "M4.5 15.5h15", key: "13mye1" }],
  ["path", { d: "m5 11 4-7", key: "116ra9" }],
  ["path", { d: "m9 11 1 9", key: "1ojof7" }]
]);
const i6 = r("ShoppingCartIcon", [
  ["circle", { cx: "8", cy: "21", r: "1", key: "jimo8o" }],
  ["circle", { cx: "19", cy: "21", r: "1", key: "13723u" }],
  [
    "path",
    {
      d: "M2.05 2.05h2l2.66 12.42a2 2 0 0 0 2 1.58h9.78a2 2 0 0 0 1.95-1.57l1.65-7.43H5.12",
      key: "9zh506"
    }
  ]
]);
const l6 = r("ShovelIcon", [
  ["path", { d: "M2 22v-5l5-5 5 5-5 5z", key: "1fh25c" }],
  ["path", { d: "M9.5 14.5 16 8", key: "1smz5x" }],
  [
    "path",
    { d: "m17 2 5 5-.5.5a3.53 3.53 0 0 1-5 0s0 0 0 0a3.53 3.53 0 0 1 0-5L17 2", key: "1q8uv5" }
  ]
]);
const c6 = r("ShowerHeadIcon", [
  ["path", { d: "m4 4 2.5 2.5", key: "uv2vmf" }],
  ["path", { d: "M13.5 6.5a4.95 4.95 0 0 0-7 7", key: "frdkwv" }],
  ["path", { d: "M15 5 5 15", key: "1ag8rq" }],
  ["path", { d: "M14 17v.01", key: "eokfpp" }],
  ["path", { d: "M10 16v.01", key: "14uyyl" }],
  ["path", { d: "M13 13v.01", key: "1v1k97" }],
  ["path", { d: "M16 10v.01", key: "5169yg" }],
  ["path", { d: "M11 20v.01", key: "cj92p8" }],
  ["path", { d: "M17 14v.01", key: "11cswd" }],
  ["path", { d: "M20 11v.01", key: "19e0od" }]
]);
const d6 = r("ShrinkIcon", [
  ["path", { d: "m15 15 6 6m-6-6v4.8m0-4.8h4.8", key: "17vawe" }],
  ["path", { d: "M9 19.8V15m0 0H4.2M9 15l-6 6", key: "chjx8e" }],
  ["path", { d: "M15 4.2V9m0 0h4.8M15 9l6-6", key: "lav6yq" }],
  ["path", { d: "M9 4.2V9m0 0H4.2M9 9 3 3", key: "1pxi2q" }]
]);
const s6 = r("ShrubIcon", [
  ["path", { d: "M12 22v-7l-2-2", key: "eqv9mc" }],
  [
    "path",
    { d: "M17 8v.8A6 6 0 0 1 13.8 20v0H10v0A6.5 6.5 0 0 1 7 8h0a5 5 0 0 1 10 0Z", key: "12jcau" }
  ],
  ["path", { d: "m14 14-2 2", key: "847xa2" }]
]);
const u6 = r("ShuffleIcon", [
  ["path", { d: "M2 18h1.4c1.3 0 2.5-.6 3.3-1.7l6.1-8.6c.7-1.1 2-1.7 3.3-1.7H22", key: "1wmou1" }],
  ["path", { d: "m18 2 4 4-4 4", key: "pucp1d" }],
  ["path", { d: "M2 6h1.9c1.5 0 2.9.9 3.6 2.2", key: "10bdb2" }],
  ["path", { d: "M22 18h-5.9c-1.3 0-2.6-.7-3.3-1.8l-.5-.8", key: "vgxac0" }],
  ["path", { d: "m18 14 4 4-4 4", key: "10pe0f" }]
]);
const h6 = r("SigmaIcon", [
  ["path", { d: "M18 7V4H6l6 8-6 8h12v-3", key: "zis8ev" }]
]);
const p6 = r("SignalHighIcon", [
  ["path", { d: "M2 20h.01", key: "4haj6o" }],
  ["path", { d: "M7 20v-4", key: "j294jx" }],
  ["path", { d: "M12 20v-8", key: "i3yub9" }],
  ["path", { d: "M17 20V8", key: "1tkaf5" }]
]);
const y6 = r("SignalLowIcon", [
  ["path", { d: "M2 20h.01", key: "4haj6o" }],
  ["path", { d: "M7 20v-4", key: "j294jx" }]
]);
const k6 = r("SignalMediumIcon", [
  ["path", { d: "M2 20h.01", key: "4haj6o" }],
  ["path", { d: "M7 20v-4", key: "j294jx" }],
  ["path", { d: "M12 20v-8", key: "i3yub9" }]
]);
const f6 = r("SignalZeroIcon", [
  ["path", { d: "M2 20h.01", key: "4haj6o" }]
]);
const v6 = r("SignalIcon", [
  ["path", { d: "M2 20h.01", key: "4haj6o" }],
  ["path", { d: "M7 20v-4", key: "j294jx" }],
  ["path", { d: "M12 20v-8", key: "i3yub9" }],
  ["path", { d: "M17 20V8", key: "1tkaf5" }],
  ["path", { d: "M22 4v16", key: "sih9yq" }]
]);
const m6 = r("SignpostBigIcon", [
  ["path", { d: "M10 9H4L2 7l2-2h6", key: "1hq7x2" }],
  ["path", { d: "M14 5h6l2 2-2 2h-6", key: "bv62ej" }],
  ["path", { d: "M10 22V4a2 2 0 1 1 4 0v18", key: "eqpcf2" }],
  ["path", { d: "M8 22h8", key: "rmew8v" }]
]);
const g6 = r("SignpostIcon", [
  ["path", { d: "M12 3v3", key: "1n5kay" }],
  ["path", { d: "M18.5 13h-13L2 9.5 5.5 6h13L22 9.5Z", key: "27os56" }],
  ["path", { d: "M12 13v8", key: "1l5pq0" }]
]);
const M6 = r("SirenIcon", [
  ["path", { d: "M7 18v-6a5 5 0 1 1 10 0v6", key: "pcx96s" }],
  [
    "path",
    { d: "M5 21a1 1 0 0 0 1 1h12a1 1 0 0 0 1-1v-1a2 2 0 0 0-2-2H7a2 2 0 0 0-2 2z", key: "1b4s83" }
  ],
  ["path", { d: "M21 12h1", key: "jtio3y" }],
  ["path", { d: "M18.5 4.5 18 5", key: "g5sp9y" }],
  ["path", { d: "M2 12h1", key: "1uaihz" }],
  ["path", { d: "M12 2v1", key: "11qlp1" }],
  ["path", { d: "m4.929 4.929.707.707", key: "1i51kw" }],
  ["path", { d: "M12 12v6", key: "3ahymv" }]
]);
const x6 = r("SkipBackIcon", [
  ["polygon", { points: "19 20 9 12 19 4 19 20", key: "o2sva" }],
  ["line", { x1: "5", x2: "5", y1: "19", y2: "5", key: "1ocqjk" }]
]);
const b6 = r("SkipForwardIcon", [
  ["polygon", { points: "5 4 15 12 5 20 5 4", key: "16p6eg" }],
  ["line", { x1: "19", x2: "19", y1: "5", y2: "19", key: "futhcm" }]
]);
const w6 = r("SkullIcon", [
  ["circle", { cx: "9", cy: "12", r: "1", key: "1vctgf" }],
  ["circle", { cx: "15", cy: "12", r: "1", key: "1tmaij" }],
  ["path", { d: "M8 20v2h8v-2", key: "ded4og" }],
  ["path", { d: "m12.5 17-.5-1-.5 1h1z", key: "3me087" }],
  ["path", { d: "M16 20a2 2 0 0 0 1.56-3.25 8 8 0 1 0-11.12 0A2 2 0 0 0 8 20", key: "xq9p5u" }]
]);
const I6 = r("SlackIcon", [
  ["rect", { width: "3", height: "8", x: "13", y: "2", rx: "1.5", key: "diqz80" }],
  ["path", { d: "M19 8.5V10h1.5A1.5 1.5 0 1 0 19 8.5", key: "183iwg" }],
  ["rect", { width: "3", height: "8", x: "8", y: "14", rx: "1.5", key: "hqg7r1" }],
  ["path", { d: "M5 15.5V14H3.5A1.5 1.5 0 1 0 5 15.5", key: "76g71w" }],
  ["rect", { width: "8", height: "3", x: "14", y: "13", rx: "1.5", key: "1kmz0a" }],
  ["path", { d: "M15.5 19H14v1.5a1.5 1.5 0 1 0 1.5-1.5", key: "jc4sz0" }],
  ["rect", { width: "8", height: "3", x: "2", y: "8", rx: "1.5", key: "1omvl4" }],
  ["path", { d: "M8.5 5H10V3.5A1.5 1.5 0 1 0 8.5 5", key: "16f3cl" }]
]);
const L6 = r("SlashIcon", [["path", { d: "M22 2 2 22", key: "y4kqgn" }]]);
const S6 = r("SliceIcon", [
  ["path", { d: "m8 14-6 6h9v-3", key: "zo3j9a" }],
  ["path", { d: "M18.37 3.63 8 14l3 3L21.37 6.63a2.12 2.12 0 1 0-3-3Z", key: "1dzx0j" }]
]);
const C6 = r("SlidersHorizontalIcon", [
  ["line", { x1: "21", x2: "14", y1: "4", y2: "4", key: "obuewd" }],
  ["line", { x1: "10", x2: "3", y1: "4", y2: "4", key: "1q6298" }],
  ["line", { x1: "21", x2: "12", y1: "12", y2: "12", key: "1iu8h1" }],
  ["line", { x1: "8", x2: "3", y1: "12", y2: "12", key: "ntss68" }],
  ["line", { x1: "21", x2: "16", y1: "20", y2: "20", key: "14d8ph" }],
  ["line", { x1: "12", x2: "3", y1: "20", y2: "20", key: "m0wm8r" }],
  ["line", { x1: "14", x2: "14", y1: "2", y2: "6", key: "14e1ph" }],
  ["line", { x1: "8", x2: "8", y1: "10", y2: "14", key: "1i6ji0" }],
  ["line", { x1: "16", x2: "16", y1: "18", y2: "22", key: "1lctlv" }]
]);
const eo = r("SlidersVerticalIcon", [
  ["line", { x1: "4", x2: "4", y1: "21", y2: "14", key: "1p332r" }],
  ["line", { x1: "4", x2: "4", y1: "10", y2: "3", key: "gb41h5" }],
  ["line", { x1: "12", x2: "12", y1: "21", y2: "12", key: "hf2csr" }],
  ["line", { x1: "12", x2: "12", y1: "8", y2: "3", key: "1kfi7u" }],
  ["line", { x1: "20", x2: "20", y1: "21", y2: "16", key: "1lhrwl" }],
  ["line", { x1: "20", x2: "20", y1: "12", y2: "3", key: "16vvfq" }],
  ["line", { x1: "2", x2: "6", y1: "14", y2: "14", key: "1uebub" }],
  ["line", { x1: "10", x2: "14", y1: "8", y2: "8", key: "1yglbp" }],
  ["line", { x1: "18", x2: "22", y1: "16", y2: "16", key: "1jxqpz" }]
]);
const A6 = r("SmartphoneChargingIcon", [
  ["rect", { width: "14", height: "20", x: "5", y: "2", rx: "2", ry: "2", key: "1yt0o3" }],
  ["path", { d: "M12.667 8 10 12h4l-2.667 4", key: "h9lk2d" }]
]);
const P6 = r("SmartphoneNfcIcon", [
  ["rect", { width: "7", height: "12", x: "2", y: "6", rx: "1", key: "5nje8w" }],
  ["path", { d: "M13 8.32a7.43 7.43 0 0 1 0 7.36", key: "1g306n" }],
  ["path", { d: "M16.46 6.21a11.76 11.76 0 0 1 0 11.58", key: "uqvjvo" }],
  ["path", { d: "M19.91 4.1a15.91 15.91 0 0 1 .01 15.8", key: "ujntz3" }]
]);
const q6 = r("SmartphoneIcon", [
  ["rect", { width: "14", height: "20", x: "5", y: "2", rx: "2", ry: "2", key: "1yt0o3" }],
  ["path", { d: "M12 18h.01", key: "mhygvu" }]
]);
const T6 = r("SmilePlusIcon", [
  ["path", { d: "M22 11v1a10 10 0 1 1-9-10", key: "ew0xw9" }],
  ["path", { d: "M8 14s1.5 2 4 2 4-2 4-2", key: "1y1vjs" }],
  ["line", { x1: "9", x2: "9.01", y1: "9", y2: "9", key: "yxxnd0" }],
  ["line", { x1: "15", x2: "15.01", y1: "9", y2: "9", key: "1p4y9e" }],
  ["path", { d: "M16 5h6", key: "1vod17" }],
  ["path", { d: "M19 2v6", key: "4bpg5p" }]
]);
const D6 = r("SmileIcon", [
  ["circle", { cx: "12", cy: "12", r: "10", key: "1mglay" }],
  ["path", { d: "M8 14s1.5 2 4 2 4-2 4-2", key: "1y1vjs" }],
  ["line", { x1: "9", x2: "9.01", y1: "9", y2: "9", key: "yxxnd0" }],
  ["line", { x1: "15", x2: "15.01", y1: "9", y2: "9", key: "1p4y9e" }]
]);
const _6 = r("SnailIcon", [
  ["path", { d: "M2 13a6 6 0 1 0 12 0 4 4 0 1 0-8 0 2 2 0 0 0 4 0", key: "hneq2s" }],
  ["circle", { cx: "10", cy: "13", r: "8", key: "194lz3" }],
  ["path", { d: "M2 21h12c4.4 0 8-3.6 8-8V7a2 2 0 1 0-4 0v6", key: "ixqyt7" }],
  ["path", { d: "M18 3 19.1 5.2", key: "9tjm43" }],
  ["path", { d: "M22 3 20.9 5.2", key: "j3odrs" }]
]);
const B6 = r("SnowflakeIcon", [
  ["line", { x1: "2", x2: "22", y1: "12", y2: "12", key: "1dnqot" }],
  ["line", { x1: "12", x2: "12", y1: "2", y2: "22", key: "7eqyqh" }],
  ["path", { d: "m20 16-4-4 4-4", key: "rquw4f" }],
  ["path", { d: "m4 8 4 4-4 4", key: "12s3z9" }],
  ["path", { d: "m16 4-4 4-4-4", key: "1tumq1" }],
  ["path", { d: "m8 20 4-4 4 4", key: "9p200w" }]
]);
const z6 = r("SofaIcon", [
  ["path", { d: "M20 9V6a2 2 0 0 0-2-2H6a2 2 0 0 0-2 2v3", key: "1dgpiv" }],
  [
    "path",
    {
      d: "M2 11v5a2 2 0 0 0 2 2h16a2 2 0 0 0 2-2v-5a2 2 0 0 0-4 0v2H6v-2a2 2 0 0 0-4 0Z",
      key: "u5qfb7"
    }
  ],
  ["path", { d: "M4 18v2", key: "jwo5n2" }],
  ["path", { d: "M20 18v2", key: "1ar1qi" }],
  ["path", { d: "M12 4v9", key: "oqhhn3" }]
]);
const H6 = r("SoupIcon", [
  ["path", { d: "M12 21a9 9 0 0 0 9-9H3a9 9 0 0 0 9 9Z", key: "4rw317" }],
  ["path", { d: "M7 21h10", key: "1b0cd5" }],
  ["path", { d: "M19.5 12 22 6", key: "shfsr5" }],
  [
    "path",
    {
      d: "M16.25 3c.27.1.8.53.75 1.36-.06.83-.93 1.2-1 2.02-.05.78.34 1.24.73 1.62",
      key: "rpc6vp"
    }
  ],
  [
    "path",
    {
      d: "M11.25 3c.27.1.8.53.74 1.36-.05.83-.93 1.2-.98 2.02-.06.78.33 1.24.72 1.62",
      key: "1lf63m"
    }
  ],
  [
    "path",
    { d: "M6.25 3c.27.1.8.53.75 1.36-.06.83-.93 1.2-1 2.02-.05.78.34 1.24.74 1.62", key: "97tijn" }
  ]
]);
const j6 = r("SpaceIcon", [
  ["path", { d: "M22 17v1c0 .5-.5 1-1 1H3c-.5 0-1-.5-1-1v-1", key: "lt2kga" }]
]);
const V6 = r("SpadeIcon", [
  [
    "path",
    {
      d: "M5 9c-1.5 1.5-3 3.2-3 5.5A5.5 5.5 0 0 0 7.5 20c1.8 0 3-.5 4.5-2 1.5 1.5 2.7 2 4.5 2a5.5 5.5 0 0 0 5.5-5.5c0-2.3-1.5-4-3-5.5l-7-7-7 7Z",
      key: "40bo9n"
    }
  ],
  ["path", { d: "M12 18v4", key: "jadmvz" }]
]);
const O6 = r("SparkleIcon", [
  [
    "path",
    {
      d: "m12 3-1.9 5.8a2 2 0 0 1-1.287 1.288L3 12l5.8 1.9a2 2 0 0 1 1.288 1.287L12 21l1.9-5.8a2 2 0 0 1 1.287-1.288L21 12l-5.8-1.9a2 2 0 0 1-1.288-1.287Z",
      key: "nraa5p"
    }
  ]
]);
const to = r("SparklesIcon", [
  [
    "path",
    {
      d: "m12 3-1.912 5.813a2 2 0 0 1-1.275 1.275L3 12l5.813 1.912a2 2 0 0 1 1.275 1.275L12 21l1.912-5.813a2 2 0 0 1 1.275-1.275L21 12l-5.813-1.912a2 2 0 0 1-1.275-1.275L12 3Z",
      key: "17u4zn"
    }
  ],
  ["path", { d: "M5 3v4", key: "bklmnn" }],
  ["path", { d: "M19 17v4", key: "iiml17" }],
  ["path", { d: "M3 5h4", key: "nem4j1" }],
  ["path", { d: "M17 19h4", key: "lbex7p" }]
]);
const $6 = r("SpeakerIcon", [
  ["rect", { width: "16", height: "20", x: "4", y: "2", rx: "2", key: "1nb95v" }],
  ["path", { d: "M12 6h.01", key: "1vi96p" }],
  ["circle", { cx: "12", cy: "14", r: "4", key: "1jruaj" }],
  ["path", { d: "M12 14h.01", key: "1etili" }]
]);
const R6 = r("SpeechIcon", [
  [
    "path",
    {
      d: "M8.8 20v-4.1l1.9.2a2.3 2.3 0 0 0 2.164-2.1V8.3A5.37 5.37 0 0 0 2 8.25c0 2.8.656 3.054 1 4.55a5.77 5.77 0 0 1 .029 2.758L2 20",
      key: "11atix"
    }
  ],
  ["path", { d: "M19.8 17.8a7.5 7.5 0 0 0 .003-10.603", key: "yol142" }],
  ["path", { d: "M17 15a3.5 3.5 0 0 0-.025-4.975", key: "ssbmkc" }]
]);
const F6 = r("SpellCheck2Icon", [
  ["path", { d: "m6 16 6-12 6 12", key: "1b4byz" }],
  ["path", { d: "M8 12h8", key: "1wcyev" }],
  [
    "path",
    {
      d: "M4 21c1.1 0 1.1-1 2.3-1s1.1 1 2.3 1c1.1 0 1.1-1 2.3-1 1.1 0 1.1 1 2.3 1 1.1 0 1.1-1 2.3-1 1.1 0 1.1 1 2.3 1 1.1 0 1.1-1 2.3-1",
      key: "8mdmtu"
    }
  ]
]);
const U6 = r("SpellCheckIcon", [
  ["path", { d: "m6 16 6-12 6 12", key: "1b4byz" }],
  ["path", { d: "M8 12h8", key: "1wcyev" }],
  ["path", { d: "m16 20 2 2 4-4", key: "13tcca" }]
]);
const E6 = r("SplineIcon", [
  ["circle", { cx: "19", cy: "5", r: "2", key: "mhkx31" }],
  ["circle", { cx: "5", cy: "19", r: "2", key: "v8kfzx" }],
  ["path", { d: "M5 17A12 12 0 0 1 17 5", key: "1okkup" }]
]);
const W6 = r("SplitIcon", [
  ["path", { d: "M16 3h5v5", key: "1806ms" }],
  ["path", { d: "M8 3H3v5", key: "15dfkv" }],
  ["path", { d: "M12 22v-8.3a4 4 0 0 0-1.172-2.872L3 3", key: "1qrqzj" }],
  ["path", { d: "m15 9 6-6", key: "ko1vev" }]
]);
const N6 = r("SprayCanIcon", [
  ["path", { d: "M3 3h.01", key: "159qn6" }],
  ["path", { d: "M7 5h.01", key: "1hq22a" }],
  ["path", { d: "M11 7h.01", key: "1osv80" }],
  ["path", { d: "M3 7h.01", key: "1xzrh3" }],
  ["path", { d: "M7 9h.01", key: "19b3jx" }],
  ["path", { d: "M3 11h.01", key: "1eifu7" }],
  ["rect", { width: "4", height: "4", x: "15", y: "5", key: "mri9e4" }],
  ["path", { d: "m19 9 2 2v10c0 .6-.4 1-1 1h-6c-.6 0-1-.4-1-1V11l2-2", key: "aib6hk" }],
  ["path", { d: "m13 14 8-2", key: "1d7bmk" }],
  ["path", { d: "m13 19 8-2", key: "1y2vml" }]
]);
const Z6 = r("SproutIcon", [
  ["path", { d: "M7 20h10", key: "e6iznv" }],
  ["path", { d: "M10 20c5.5-2.5.8-6.4 3-10", key: "161w41" }],
  [
    "path",
    {
      d: "M9.5 9.4c1.1.8 1.8 2.2 2.3 3.7-2 .4-3.5.4-4.8-.3-1.2-.6-2.3-1.9-3-4.2 2.8-.5 4.4 0 5.5.8z",
      key: "9gtqwd"
    }
  ],
  [
    "path",
    {
      d: "M14.1 6a7 7 0 0 0-1.1 4c1.9-.1 3.3-.6 4.3-1.4 1-1 1.6-2.3 1.7-4.6-2.7.1-4 1-4.9 2z",
      key: "bkxnd2"
    }
  ]
]);
const ao = r("SquareActivityIcon", [
  ["rect", { width: "18", height: "18", x: "3", y: "3", rx: "2", key: "afitv7" }],
  ["path", { d: "M17 12h-2l-2 5-2-10-2 5H7", key: "15hlnc" }]
]);
const no = r("SquareArrowDownLeftIcon", [
  ["rect", { width: "18", height: "18", x: "3", y: "3", rx: "2", key: "afitv7" }],
  ["path", { d: "m16 8-8 8", key: "166keh" }],
  ["path", { d: "M16 16H8V8", key: "1w2ppm" }]
]);
const oo = r("SquareArrowDownRightIcon", [
  ["rect", { width: "18", height: "18", x: "3", y: "3", rx: "2", key: "afitv7" }],
  ["path", { d: "m8 8 8 8", key: "1imecy" }],
  ["path", { d: "M16 8v8H8", key: "1lbpgo" }]
]);
const ro = r("SquareArrowDownIcon", [
  ["rect", { width: "18", height: "18", x: "3", y: "3", rx: "2", key: "afitv7" }],
  ["path", { d: "M12 8v8", key: "napkw2" }],
  ["path", { d: "m8 12 4 4 4-4", key: "k98ssh" }]
]);
const io = r("SquareArrowLeftIcon", [
  ["rect", { width: "18", height: "18", x: "3", y: "3", rx: "2", key: "afitv7" }],
  ["path", { d: "m12 8-4 4 4 4", key: "15vm53" }],
  ["path", { d: "M16 12H8", key: "1fr5h0" }]
]);
const lo = r("SquareArrowOutDownLeftIcon", [
  ["path", { d: "M13 21h6a2 2 0 0 0 2-2V5a2 2 0 0 0-2-2H5a2 2 0 0 0-2 2v6", key: "14qz4y" }],
  ["path", { d: "m3 21 9-9", key: "1jfql5" }],
  ["path", { d: "M9 21H3v-6", key: "wtvkvv" }]
]);
const co = r("SquareArrowOutDownRightIcon", [
  ["path", { d: "M21 11V5a2 2 0 0 0-2-2H5a2 2 0 0 0-2 2v14a2 2 0 0 0 2 2h6", key: "14rsvq" }],
  ["path", { d: "m21 21-9-9", key: "1et2py" }],
  ["path", { d: "M21 15v6h-6", key: "1jko0i" }]
]);
const so = r("SquareArrowOutUpLeftIcon", [
  ["path", { d: "M13 3h6a2 2 0 0 1 2 2v14a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2v-6", key: "14mv1t" }],
  ["path", { d: "m3 3 9 9", key: "rks13r" }],
  ["path", { d: "M3 9V3h6", key: "ira0h2" }]
]);
const uo = r("SquareArrowOutUpRightIcon", [
  ["path", { d: "M21 13v6a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2V5a2 2 0 0 1 2-2h6", key: "y09zxi" }],
  ["path", { d: "m21 3-9 9", key: "mpx6sq" }],
  ["path", { d: "M15 3h6v6", key: "1q9fwt" }]
]);
const ho = r("SquareArrowRightIcon", [
  ["rect", { width: "18", height: "18", x: "3", y: "3", rx: "2", key: "afitv7" }],
  ["path", { d: "M8 12h8", key: "1wcyev" }],
  ["path", { d: "m12 16 4-4-4-4", key: "1i9zcv" }]
]);
const po = r("SquareArrowUpLeftIcon", [
  ["rect", { width: "18", height: "18", x: "3", y: "3", rx: "2", key: "afitv7" }],
  ["path", { d: "M8 16V8h8", key: "19xb1h" }],
  ["path", { d: "M16 16 8 8", key: "1qdy8n" }]
]);
const yo = r("SquareArrowUpRightIcon", [
  ["rect", { width: "18", height: "18", x: "3", y: "3", rx: "2", key: "afitv7" }],
  ["path", { d: "M8 8h8v8", key: "b65dnt" }],
  ["path", { d: "m8 16 8-8", key: "13b9ih" }]
]);
const ko = r("SquareArrowUpIcon", [
  ["rect", { width: "18", height: "18", x: "3", y: "3", rx: "2", key: "afitv7" }],
  ["path", { d: "m16 12-4-4-4 4", key: "177agl" }],
  ["path", { d: "M12 16V8", key: "1sbj14" }]
]);
const fo = r("SquareAsteriskIcon", [
  ["rect", { width: "18", height: "18", x: "3", y: "3", rx: "2", key: "afitv7" }],
  ["path", { d: "M12 8v8", key: "napkw2" }],
  ["path", { d: "m8.5 14 7-4", key: "12hpby" }],
  ["path", { d: "m8.5 10 7 4", key: "wwy2dy" }]
]);
const vo = r("SquareBottomDashedScissorsIcon", [
  [
    "path",
    { d: "M4 22a2 2 0 0 1-2-2V4a2 2 0 0 1 2-2h16a2 2 0 0 1 2 2v16a2 2 0 0 1-2 2", key: "1vzg26" }
  ],
  ["path", { d: "M10 22H8", key: "euku7a" }],
  ["path", { d: "M16 22h-2", key: "18d249" }],
  ["circle", { cx: "8", cy: "8", r: "2", key: "14cg06" }],
  ["path", { d: "M9.414 9.414 12 12", key: "qz4lzr" }],
  ["path", { d: "M14.8 14.8 18 18", key: "11flf1" }],
  ["circle", { cx: "8", cy: "16", r: "2", key: "1acxsx" }],
  ["path", { d: "m18 6-8.586 8.586", key: "11kzk1" }]
]);
const mo = r("SquareCheckBigIcon", [
  ["path", { d: "m9 11 3 3L22 4", key: "1pflzl" }],
  ["path", { d: "M21 12v7a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2V5a2 2 0 0 1 2-2h11", key: "1jnkn4" }]
]);
const go = r("SquareCheckIcon", [
  ["rect", { width: "18", height: "18", x: "3", y: "3", rx: "2", key: "afitv7" }],
  ["path", { d: "m9 12 2 2 4-4", key: "dzmm74" }]
]);
const Mo = r("SquareChevronDownIcon", [
  ["rect", { width: "18", height: "18", x: "3", y: "3", rx: "2", key: "afitv7" }],
  ["path", { d: "m16 10-4 4-4-4", key: "894hmk" }]
]);
const xo = r("SquareChevronLeftIcon", [
  ["rect", { width: "18", height: "18", x: "3", y: "3", rx: "2", key: "afitv7" }],
  ["path", { d: "m14 16-4-4 4-4", key: "ojs7w8" }]
]);
const bo = r("SquareChevronRightIcon", [
  ["rect", { width: "18", height: "18", x: "3", y: "3", rx: "2", key: "afitv7" }],
  ["path", { d: "m10 8 4 4-4 4", key: "1wy4r4" }]
]);
const wo = r("SquareChevronUpIcon", [
  ["rect", { width: "18", height: "18", x: "3", y: "3", rx: "2", key: "afitv7" }],
  ["path", { d: "m8 14 4-4 4 4", key: "fy2ptz" }]
]);
const Io = r("SquareCodeIcon", [
  ["rect", { width: "18", height: "18", x: "3", y: "3", rx: "2", key: "afitv7" }],
  ["path", { d: "m10 10-2 2 2 2", key: "p6et6i" }],
  ["path", { d: "m14 14 2-2-2-2", key: "m075q2" }]
]);
const Y6 = r("SquareDashedBottomCodeIcon", [
  ["path", { d: "m10 10-2 2 2 2", key: "p6et6i" }],
  ["path", { d: "m14 14 2-2-2-2", key: "m075q2" }],
  [
    "path",
    { d: "M5 21a2 2 0 0 1-2-2V5a2 2 0 0 1 2-2h14a2 2 0 0 1 2 2v14a2 2 0 0 1-2 2", key: "as5y1o" }
  ],
  ["path", { d: "M9 21h1", key: "15o7lz" }],
  ["path", { d: "M14 21h1", key: "v9vybs" }]
]);
const G6 = r("SquareDashedBottomIcon", [
  [
    "path",
    { d: "M5 21a2 2 0 0 1-2-2V5a2 2 0 0 1 2-2h14a2 2 0 0 1 2 2v14a2 2 0 0 1-2 2", key: "as5y1o" }
  ],
  ["path", { d: "M9 21h1", key: "15o7lz" }],
  ["path", { d: "M14 21h1", key: "v9vybs" }]
]);
const Lo = r("SquareDashedKanbanIcon", [
  ["path", { d: "M8 7v7", key: "1x2jlm" }],
  ["path", { d: "M12 7v4", key: "xawao1" }],
  ["path", { d: "M16 7v9", key: "1hp2iy" }],
  ["path", { d: "M5 3a2 2 0 0 0-2 2", key: "y57alp" }],
  ["path", { d: "M9 3h1", key: "1yesri" }],
  ["path", { d: "M14 3h1", key: "1ec4yj" }],
  ["path", { d: "M19 3a2 2 0 0 1 2 2", key: "18rm91" }],
  ["path", { d: "M21 9v1", key: "mxsmne" }],
  ["path", { d: "M21 14v1", key: "169vum" }],
  ["path", { d: "M21 19a2 2 0 0 1-2 2", key: "1j7049" }],
  ["path", { d: "M14 21h1", key: "v9vybs" }],
  ["path", { d: "M9 21h1", key: "15o7lz" }],
  ["path", { d: "M5 21a2 2 0 0 1-2-2", key: "sbafld" }],
  ["path", { d: "M3 14v1", key: "vnatye" }],
  ["path", { d: "M3 9v1", key: "1r0deq" }]
]);
const So = r("SquareDashedMousePointerIcon", [
  ["path", { d: "M5 3a2 2 0 0 0-2 2", key: "y57alp" }],
  ["path", { d: "M19 3a2 2 0 0 1 2 2", key: "18rm91" }],
  ["path", { d: "m12 12 4 10 1.7-4.3L22 16Z", key: "64ilsv" }],
  ["path", { d: "M5 21a2 2 0 0 1-2-2", key: "sbafld" }],
  ["path", { d: "M9 3h1", key: "1yesri" }],
  ["path", { d: "M9 21h2", key: "1qve2z" }],
  ["path", { d: "M14 3h1", key: "1ec4yj" }],
  ["path", { d: "M3 9v1", key: "1r0deq" }],
  ["path", { d: "M21 9v2", key: "p14lih" }],
  ["path", { d: "M3 14v1", key: "vnatye" }]
]);
const Co = r("SquareDivideIcon", [
  ["rect", { width: "18", height: "18", x: "3", y: "3", rx: "2", ry: "2", key: "1m3agn" }],
  ["line", { x1: "8", x2: "16", y1: "12", y2: "12", key: "1jonct" }],
  ["line", { x1: "12", x2: "12", y1: "16", y2: "16", key: "aqc6ln" }],
  ["line", { x1: "12", x2: "12", y1: "8", y2: "8", key: "1mkcni" }]
]);
const Ao = r("SquareDotIcon", [
  ["rect", { width: "18", height: "18", x: "3", y: "3", rx: "2", key: "afitv7" }],
  ["circle", { cx: "12", cy: "12", r: "1", key: "41hilf" }]
]);
const Po = r("SquareEqualIcon", [
  ["rect", { width: "18", height: "18", x: "3", y: "3", rx: "2", key: "afitv7" }],
  ["path", { d: "M7 10h10", key: "1101jm" }],
  ["path", { d: "M7 14h10", key: "1mhdw3" }]
]);
const qo = r("SquareFunctionIcon", [
  ["rect", { width: "18", height: "18", x: "3", y: "3", rx: "2", ry: "2", key: "1m3agn" }],
  ["path", { d: "M9 17c2 0 2.8-1 2.8-2.8V10c0-2 1-3.3 3.2-3", key: "m1af9g" }],
  ["path", { d: "M9 11.2h5.7", key: "3zgcl2" }]
]);
const To = r("SquareGanttChartIcon", [
  ["rect", { width: "18", height: "18", x: "3", y: "3", rx: "2", key: "afitv7" }],
  ["path", { d: "M9 8h7", key: "kbo1nt" }],
  ["path", { d: "M8 12h6", key: "ikassy" }],
  ["path", { d: "M11 16h5", key: "oq65wt" }]
]);
const Do = r("SquareKanbanIcon", [
  ["rect", { width: "18", height: "18", x: "3", y: "3", rx: "2", key: "afitv7" }],
  ["path", { d: "M8 7v7", key: "1x2jlm" }],
  ["path", { d: "M12 7v4", key: "xawao1" }],
  ["path", { d: "M16 7v9", key: "1hp2iy" }]
]);
const _o = r("SquareLibraryIcon", [
  ["rect", { width: "18", height: "18", x: "3", y: "3", rx: "2", key: "afitv7" }],
  ["path", { d: "M7 7v10", key: "d5nglc" }],
  ["path", { d: "M11 7v10", key: "pptsnr" }],
  ["path", { d: "m15 7 2 10", key: "1m7qm5" }]
]);
const Bo = r("SquareMIcon", [
  ["rect", { width: "18", height: "18", x: "3", y: "3", rx: "2", key: "afitv7" }],
  ["path", { d: "M8 16V8l4 4 4-4v8", key: "141u4e" }]
]);
const zo = r("SquareMenuIcon", [
  ["rect", { width: "18", height: "18", x: "3", y: "3", rx: "2", key: "afitv7" }],
  ["path", { d: "M7 8h10", key: "1jw688" }],
  ["path", { d: "M7 12h10", key: "b7w52i" }],
  ["path", { d: "M7 16h10", key: "wp8him" }]
]);
const Ho = r("SquareMinusIcon", [
  ["rect", { width: "18", height: "18", x: "3", y: "3", rx: "2", key: "afitv7" }],
  ["path", { d: "M8 12h8", key: "1wcyev" }]
]);
const jo = r("SquareMousePointerIcon", [
  ["path", { d: "M21 11V5a2 2 0 0 0-2-2H5a2 2 0 0 0-2 2v14a2 2 0 0 0 2 2h6", key: "14rsvq" }],
  ["path", { d: "m12 12 4 10 1.7-4.3L22 16Z", key: "64ilsv" }]
]);
const Vo = r("SquareParkingOffIcon", [
  ["path", { d: "M3.6 3.6A2 2 0 0 1 5 3h14a2 2 0 0 1 2 2v14a2 2 0 0 1-.59 1.41", key: "9l1ft6" }],
  ["path", { d: "M3 8.7V19a2 2 0 0 0 2 2h10.3", key: "17knke" }],
  ["path", { d: "m2 2 20 20", key: "1ooewy" }],
  ["path", { d: "M13 13a3 3 0 1 0 0-6H9v2", key: "uoagbd" }],
  ["path", { d: "M9 17v-2.3", key: "1jxgo2" }]
]);
const Oo = r("SquareParkingIcon", [
  ["rect", { width: "18", height: "18", x: "3", y: "3", rx: "2", key: "afitv7" }],
  ["path", { d: "M9 17V7h4a3 3 0 0 1 0 6H9", key: "1dfk2c" }]
]);
const vt = r("SquarePenIcon", [
  ["path", { d: "M12 3H5a2 2 0 0 0-2 2v14a2 2 0 0 0 2 2h14a2 2 0 0 0 2-2v-7", key: "1m0v6g" }],
  ["path", { d: "M18.375 2.625a2.121 2.121 0 1 1 3 3L12 15l-4 1 1-4Z", key: "1lpok0" }]
]);
const $o = r("SquarePercentIcon", [
  ["rect", { width: "18", height: "18", x: "3", y: "3", rx: "2", key: "afitv7" }],
  ["path", { d: "m15 9-6 6", key: "1uzhvr" }],
  ["path", { d: "M9 9h.01", key: "1q5me6" }],
  ["path", { d: "M15 15h.01", key: "lqbp3k" }]
]);
const Ro = r("SquarePiIcon", [
  ["rect", { width: "18", height: "18", x: "3", y: "3", rx: "2", key: "afitv7" }],
  ["path", { d: "M7 7h10", key: "udp07y" }],
  ["path", { d: "M10 7v10", key: "i1d9ee" }],
  ["path", { d: "M16 17a2 2 0 0 1-2-2V7", key: "ftwdc7" }]
]);
const Fo = r("SquarePilcrowIcon", [
  ["rect", { width: "18", height: "18", x: "3", y: "3", rx: "2", key: "afitv7" }],
  ["path", { d: "M12 12H9.5a2.5 2.5 0 0 1 0-5H17", key: "1l9586" }],
  ["path", { d: "M12 7v10", key: "jspqdw" }],
  ["path", { d: "M16 7v10", key: "lavkr4" }]
]);
const Uo = r("SquarePlayIcon", [
  ["rect", { width: "18", height: "18", x: "3", y: "3", rx: "2", key: "afitv7" }],
  ["path", { d: "m9 8 6 4-6 4Z", key: "f1r3lt" }]
]);
const Eo = r("SquarePlusIcon", [
  ["rect", { width: "18", height: "18", x: "3", y: "3", rx: "2", key: "afitv7" }],
  ["path", { d: "M8 12h8", key: "1wcyev" }],
  ["path", { d: "M12 8v8", key: "napkw2" }]
]);
const Wo = r("SquarePowerIcon", [
  ["rect", { width: "18", height: "18", x: "3", y: "3", rx: "2", key: "afitv7" }],
  ["path", { d: "M12 7v5", key: "ma6bk" }],
  ["path", { d: "M8 9a5.14 5.14 0 0 0 4 8 4.95 4.95 0 0 0 4-8", key: "15eubv" }]
]);
const X6 = r("SquareRadicalIcon", [
  ["path", { d: "M7 12h2l2 5 2-10h4", key: "1fxv6h" }],
  ["rect", { x: "3", y: "3", width: "18", height: "18", rx: "2", key: "h1oib" }]
]);
const No = r("SquareScissorsIcon", [
  ["rect", { width: "20", height: "20", x: "2", y: "2", rx: "2", key: "1btzen" }],
  ["circle", { cx: "8", cy: "8", r: "2", key: "14cg06" }],
  ["path", { d: "M9.414 9.414 12 12", key: "qz4lzr" }],
  ["path", { d: "M14.8 14.8 18 18", key: "11flf1" }],
  ["circle", { cx: "8", cy: "16", r: "2", key: "1acxsx" }],
  ["path", { d: "m18 6-8.586 8.586", key: "11kzk1" }]
]);
const Zo = r("SquareSigmaIcon", [
  ["rect", { width: "18", height: "18", x: "3", y: "3", rx: "2", key: "afitv7" }],
  ["path", { d: "M16 8.9V7H8l4 5-4 5h8v-1.9", key: "9nih0i" }]
]);
const Yo = r("SquareSlashIcon", [
  ["rect", { width: "18", height: "18", x: "3", y: "3", rx: "2", key: "afitv7" }],
  ["line", { x1: "9", x2: "15", y1: "15", y2: "9", key: "1dfufj" }]
]);
const Go = r("SquareSplitHorizontalIcon", [
  ["path", { d: "M8 19H5c-1 0-2-1-2-2V7c0-1 1-2 2-2h3", key: "lubmu8" }],
  ["path", { d: "M16 5h3c1 0 2 1 2 2v10c0 1-1 2-2 2h-3", key: "1ag34g" }],
  ["line", { x1: "12", x2: "12", y1: "4", y2: "20", key: "1tx1rr" }]
]);
const Xo = r("SquareSplitVerticalIcon", [
  ["path", { d: "M5 8V5c0-1 1-2 2-2h10c1 0 2 1 2 2v3", key: "1pi83i" }],
  ["path", { d: "M19 16v3c0 1-1 2-2 2H7c-1 0-2-1-2-2v-3", key: "ido5k7" }],
  ["line", { x1: "4", x2: "20", y1: "12", y2: "12", key: "1e0a9i" }]
]);
const K6 = r("SquareStackIcon", [
  ["path", { d: "M4 10c-1.1 0-2-.9-2-2V4c0-1.1.9-2 2-2h4c1.1 0 2 .9 2 2", key: "4i38lg" }],
  ["path", { d: "M10 16c-1.1 0-2-.9-2-2v-4c0-1.1.9-2 2-2h4c1.1 0 2 .9 2 2", key: "mlte4a" }],
  ["rect", { width: "8", height: "8", x: "14", y: "14", rx: "2", key: "1fa9i4" }]
]);
const Ko = r("SquareTerminalIcon", [
  ["path", { d: "m7 11 2-2-2-2", key: "1lz0vl" }],
  ["path", { d: "M11 13h4", key: "1p7l4v" }],
  ["rect", { width: "18", height: "18", x: "3", y: "3", rx: "2", ry: "2", key: "1m3agn" }]
]);
const Qo = r("SquareUserRoundIcon", [
  ["path", { d: "M18 21a6 6 0 0 0-12 0", key: "kaz2du" }],
  ["circle", { cx: "12", cy: "11", r: "4", key: "1gt34v" }],
  ["rect", { width: "18", height: "18", x: "3", y: "3", rx: "2", key: "afitv7" }]
]);
const Jo = r("SquareUserIcon", [
  ["rect", { width: "18", height: "18", x: "3", y: "3", rx: "2", key: "afitv7" }],
  ["circle", { cx: "12", cy: "10", r: "3", key: "ilqhr7" }],
  ["path", { d: "M7 21v-2a2 2 0 0 1 2-2h6a2 2 0 0 1 2 2v2", key: "1m6ac2" }]
]);
const er = r("SquareXIcon", [
  ["rect", { width: "18", height: "18", x: "3", y: "3", rx: "2", ry: "2", key: "1m3agn" }],
  ["path", { d: "m15 9-6 6", key: "1uzhvr" }],
  ["path", { d: "m9 9 6 6", key: "z0biqf" }]
]);
const Q6 = r("SquareIcon", [
  ["rect", { width: "18", height: "18", x: "3", y: "3", rx: "2", key: "afitv7" }]
]);
const J6 = r("SquircleIcon", [
  ["path", { d: "M12 3c7.2 0 9 1.8 9 9s-1.8 9-9 9-9-1.8-9-9 1.8-9 9-9", key: "garfkc" }]
]);
const e8 = r("SquirrelIcon", [
  ["path", { d: "M15.236 22a3 3 0 0 0-2.2-5", key: "21bitc" }],
  ["path", { d: "M16 20a3 3 0 0 1 3-3h1a2 2 0 0 0 2-2v-2a4 4 0 0 0-4-4V4", key: "oh0fg0" }],
  ["path", { d: "M18 13h.01", key: "9veqaj" }],
  [
    "path",
    {
      d: "M18 6a4 4 0 0 0-4 4 7 7 0 0 0-7 7c0-5 4-5 4-10.5a4.5 4.5 0 1 0-9 0 2.5 2.5 0 0 0 5 0C7 10 3 11 3 17c0 2.8 2.2 5 5 5h10",
      key: "980v8a"
    }
  ]
]);
const t8 = r("StampIcon", [
  ["path", { d: "M5 22h14", key: "ehvnwv" }],
  [
    "path",
    {
      d: "M19.27 13.73A2.5 2.5 0 0 0 17.5 13h-11A2.5 2.5 0 0 0 4 15.5V17a1 1 0 0 0 1 1h14a1 1 0 0 0 1-1v-1.5c0-.66-.26-1.3-.73-1.77Z",
      key: "1sy9ra"
    }
  ],
  [
    "path",
    { d: "M14 13V8.5C14 7 15 7 15 5a3 3 0 0 0-3-3c-1.66 0-3 1-3 3s1 2 1 3.5V13", key: "cnxgux" }
  ]
]);
const a8 = r("StarHalfIcon", [
  ["path", { d: "M12 17.8 5.8 21 7 14.1 2 9.3l7-1L12 2", key: "nare05" }]
]);
const n8 = r("StarOffIcon", [
  ["path", { d: "M8.34 8.34 2 9.27l5 4.87L5.82 21 12 17.77 18.18 21l-.59-3.43", key: "16m0ql" }],
  ["path", { d: "M18.42 12.76 22 9.27l-6.91-1L12 2l-1.44 2.91", key: "1vt8nq" }],
  ["line", { x1: "2", x2: "22", y1: "2", y2: "22", key: "a6p6uj" }]
]);
const o8 = r("StarIcon", [
  [
    "polygon",
    {
      points: "12 2 15.09 8.26 22 9.27 17 14.14 18.18 21.02 12 17.77 5.82 21.02 7 14.14 2 9.27 8.91 8.26 12 2",
      key: "8f66p6"
    }
  ]
]);
const r8 = r("StepBackIcon", [
  ["line", { x1: "18", x2: "18", y1: "20", y2: "4", key: "cun8e5" }],
  ["polygon", { points: "14,20 4,12 14,4", key: "ypakod" }]
]);
const i8 = r("StepForwardIcon", [
  ["line", { x1: "6", x2: "6", y1: "4", y2: "20", key: "fy8qot" }],
  ["polygon", { points: "10,4 20,12 10,20", key: "1mc1pf" }]
]);
const l8 = r("StethoscopeIcon", [
  [
    "path",
    {
      d: "M4.8 2.3A.3.3 0 1 0 5 2H4a2 2 0 0 0-2 2v5a6 6 0 0 0 6 6v0a6 6 0 0 0 6-6V4a2 2 0 0 0-2-2h-1a.2.2 0 1 0 .3.3",
      key: "1jd90r"
    }
  ],
  ["path", { d: "M8 15v1a6 6 0 0 0 6 6v0a6 6 0 0 0 6-6v-4", key: "126ukv" }],
  ["circle", { cx: "20", cy: "10", r: "2", key: "ts1r5v" }]
]);
const c8 = r("StickerIcon", [
  [
    "path",
    { d: "M15.5 3H5a2 2 0 0 0-2 2v14c0 1.1.9 2 2 2h14a2 2 0 0 0 2-2V8.5L15.5 3Z", key: "1wis1t" }
  ],
  ["path", { d: "M14 3v4a2 2 0 0 0 2 2h4", key: "36rjfy" }],
  ["path", { d: "M8 13h0", key: "jdup5h" }],
  ["path", { d: "M16 13h0", key: "l4i2ga" }],
  ["path", { d: "M10 16s.8 1 2 1c1.3 0 2-1 2-1", key: "1vvgv3" }]
]);
const d8 = r("StickyNoteIcon", [
  ["path", { d: "M16 3H5a2 2 0 0 0-2 2v14a2 2 0 0 0 2 2h14a2 2 0 0 0 2-2V8Z", key: "qazsjp" }],
  ["path", { d: "M15 3v4a2 2 0 0 0 2 2h4", key: "40519r" }]
]);
const s8 = r("StoreIcon", [
  ["path", { d: "m2 7 4.41-4.41A2 2 0 0 1 7.83 2h8.34a2 2 0 0 1 1.42.59L22 7", key: "ztvudi" }],
  ["path", { d: "M4 12v8a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2v-8", key: "1b2hhj" }],
  ["path", { d: "M15 22v-4a2 2 0 0 0-2-2h-2a2 2 0 0 0-2 2v4", key: "2ebpfo" }],
  ["path", { d: "M2 7h20", key: "1fcdvo" }],
  [
    "path",
    {
      d: "M22 7v3a2 2 0 0 1-2 2v0a2.7 2.7 0 0 1-1.59-.63.7.7 0 0 0-.82 0A2.7 2.7 0 0 1 16 12a2.7 2.7 0 0 1-1.59-.63.7.7 0 0 0-.82 0A2.7 2.7 0 0 1 12 12a2.7 2.7 0 0 1-1.59-.63.7.7 0 0 0-.82 0A2.7 2.7 0 0 1 8 12a2.7 2.7 0 0 1-1.59-.63.7.7 0 0 0-.82 0A2.7 2.7 0 0 1 4 12v0a2 2 0 0 1-2-2V7",
      key: "jon5kx"
    }
  ]
]);
const u8 = r("StretchHorizontalIcon", [
  ["rect", { width: "20", height: "6", x: "2", y: "4", rx: "2", key: "qdearl" }],
  ["rect", { width: "20", height: "6", x: "2", y: "14", rx: "2", key: "1xrn6j" }]
]);
const h8 = r("StretchVerticalIcon", [
  ["rect", { width: "6", height: "20", x: "4", y: "2", rx: "2", key: "19qu7m" }],
  ["rect", { width: "6", height: "20", x: "14", y: "2", rx: "2", key: "24v0nk" }]
]);
const p8 = r("StrikethroughIcon", [
  ["path", { d: "M16 4H9a3 3 0 0 0-2.83 4", key: "43sutm" }],
  ["path", { d: "M14 12a4 4 0 0 1 0 8H6", key: "nlfj13" }],
  ["line", { x1: "4", x2: "20", y1: "12", y2: "12", key: "1e0a9i" }]
]);
const y8 = r("SubscriptIcon", [
  ["path", { d: "m4 5 8 8", key: "1eunvl" }],
  ["path", { d: "m12 5-8 8", key: "1ah0jp" }],
  [
    "path",
    {
      d: "M20 19h-4c0-1.5.44-2 1.5-2.5S20 15.33 20 14c0-.47-.17-.93-.48-1.29a2.11 2.11 0 0 0-2.62-.44c-.42.24-.74.62-.9 1.07",
      key: "e8ta8j"
    }
  ]
]);
const k8 = r("SunDimIcon", [
  ["circle", { cx: "12", cy: "12", r: "4", key: "4exip2" }],
  ["path", { d: "M12 4h.01", key: "1ujb9j" }],
  ["path", { d: "M20 12h.01", key: "1ykeid" }],
  ["path", { d: "M12 20h.01", key: "zekei9" }],
  ["path", { d: "M4 12h.01", key: "158zrr" }],
  ["path", { d: "M17.657 6.343h.01", key: "31pqzk" }],
  ["path", { d: "M17.657 17.657h.01", key: "jehnf4" }],
  ["path", { d: "M6.343 17.657h.01", key: "gdk6ow" }],
  ["path", { d: "M6.343 6.343h.01", key: "1uurf0" }]
]);
const f8 = r("SunMediumIcon", [
  ["circle", { cx: "12", cy: "12", r: "4", key: "4exip2" }],
  ["path", { d: "M12 3v1", key: "1asbbs" }],
  ["path", { d: "M12 20v1", key: "1wcdkc" }],
  ["path", { d: "M3 12h1", key: "lp3yf2" }],
  ["path", { d: "M20 12h1", key: "1vloll" }],
  ["path", { d: "m18.364 5.636-.707.707", key: "1hakh0" }],
  ["path", { d: "m6.343 17.657-.707.707", key: "18m9nf" }],
  ["path", { d: "m5.636 5.636.707.707", key: "1xv1c5" }],
  ["path", { d: "m17.657 17.657.707.707", key: "vl76zb" }]
]);
const v8 = r("SunMoonIcon", [
  ["path", { d: "M12 8a2.83 2.83 0 0 0 4 4 4 4 0 1 1-4-4", key: "1fu5g2" }],
  ["path", { d: "M12 2v2", key: "tus03m" }],
  ["path", { d: "M12 20v2", key: "1lh1kg" }],
  ["path", { d: "m4.9 4.9 1.4 1.4", key: "b9915j" }],
  ["path", { d: "m17.7 17.7 1.4 1.4", key: "qc3ed3" }],
  ["path", { d: "M2 12h2", key: "1t8f8n" }],
  ["path", { d: "M20 12h2", key: "1q8mjw" }],
  ["path", { d: "m6.3 17.7-1.4 1.4", key: "5gca6" }],
  ["path", { d: "m19.1 4.9-1.4 1.4", key: "wpu9u6" }]
]);
const m8 = r("SunSnowIcon", [
  ["path", { d: "M10 9a3 3 0 1 0 0 6", key: "6zmtdl" }],
  ["path", { d: "M2 12h1", key: "1uaihz" }],
  ["path", { d: "M14 21V3", key: "1llu3z" }],
  ["path", { d: "M10 4V3", key: "pkzwkn" }],
  ["path", { d: "M10 21v-1", key: "1u8rkd" }],
  ["path", { d: "m3.64 18.36.7-.7", key: "105rm9" }],
  ["path", { d: "m4.34 6.34-.7-.7", key: "d3unjp" }],
  ["path", { d: "M14 12h8", key: "4f43i9" }],
  ["path", { d: "m17 4-3 3", key: "15jcng" }],
  ["path", { d: "m14 17 3 3", key: "6tlq38" }],
  ["path", { d: "m21 15-3-3 3-3", key: "1nlnje" }]
]);
const g8 = r("SunIcon", [
  ["circle", { cx: "12", cy: "12", r: "4", key: "4exip2" }],
  ["path", { d: "M12 2v2", key: "tus03m" }],
  ["path", { d: "M12 20v2", key: "1lh1kg" }],
  ["path", { d: "m4.93 4.93 1.41 1.41", key: "149t6j" }],
  ["path", { d: "m17.66 17.66 1.41 1.41", key: "ptbguv" }],
  ["path", { d: "M2 12h2", key: "1t8f8n" }],
  ["path", { d: "M20 12h2", key: "1q8mjw" }],
  ["path", { d: "m6.34 17.66-1.41 1.41", key: "1m8zz5" }],
  ["path", { d: "m19.07 4.93-1.41 1.41", key: "1shlcs" }]
]);
const M8 = r("SunriseIcon", [
  ["path", { d: "M12 2v8", key: "1q4o3n" }],
  ["path", { d: "m4.93 10.93 1.41 1.41", key: "2a7f42" }],
  ["path", { d: "M2 18h2", key: "j10viu" }],
  ["path", { d: "M20 18h2", key: "wocana" }],
  ["path", { d: "m19.07 10.93-1.41 1.41", key: "15zs5n" }],
  ["path", { d: "M22 22H2", key: "19qnx5" }],
  ["path", { d: "m8 6 4-4 4 4", key: "ybng9g" }],
  ["path", { d: "M16 18a4 4 0 0 0-8 0", key: "1lzouq" }]
]);
const x8 = r("SunsetIcon", [
  ["path", { d: "M12 10V2", key: "16sf7g" }],
  ["path", { d: "m4.93 10.93 1.41 1.41", key: "2a7f42" }],
  ["path", { d: "M2 18h2", key: "j10viu" }],
  ["path", { d: "M20 18h2", key: "wocana" }],
  ["path", { d: "m19.07 10.93-1.41 1.41", key: "15zs5n" }],
  ["path", { d: "M22 22H2", key: "19qnx5" }],
  ["path", { d: "m16 6-4 4-4-4", key: "6wukr" }],
  ["path", { d: "M16 18a4 4 0 0 0-8 0", key: "1lzouq" }]
]);
const b8 = r("SuperscriptIcon", [
  ["path", { d: "m4 19 8-8", key: "hr47gm" }],
  ["path", { d: "m12 19-8-8", key: "1dhhmo" }],
  [
    "path",
    {
      d: "M20 12h-4c0-1.5.442-2 1.5-2.5S20 8.334 20 7.002c0-.472-.17-.93-.484-1.29a2.105 2.105 0 0 0-2.617-.436c-.42.239-.738.614-.899 1.06",
      key: "1dfcux"
    }
  ]
]);
const w8 = r("SwatchBookIcon", [
  ["path", { d: "M11 17a4 4 0 0 1-8 0V5a2 2 0 0 1 2-2h4a2 2 0 0 1 2 2Z", key: "1ldrpk" }],
  ["path", { d: "M16.7 13H19a2 2 0 0 1 2 2v4a2 2 0 0 1-2 2H7", key: "11i5po" }],
  ["path", { d: "M 7 17h0.01", key: "10821z" }],
  [
    "path",
    {
      d: "m11 8 2.3-2.3a2.4 2.4 0 0 1 3.404.004L18.6 7.6a2.4 2.4 0 0 1 .026 3.434L9.9 19.8",
      key: "o2gii7"
    }
  ]
]);
const I8 = r("SwissFrancIcon", [
  ["path", { d: "M10 21V3h8", key: "br2l0g" }],
  ["path", { d: "M6 16h9", key: "2py0wn" }],
  ["path", { d: "M10 9.5h7", key: "13dmhz" }]
]);
const L8 = r("SwitchCameraIcon", [
  ["path", { d: "M11 19H4a2 2 0 0 1-2-2V7a2 2 0 0 1 2-2h5", key: "mtk2lu" }],
  ["path", { d: "M13 5h7a2 2 0 0 1 2 2v10a2 2 0 0 1-2 2h-5", key: "120jsl" }],
  ["circle", { cx: "12", cy: "12", r: "3", key: "1v7zrd" }],
  ["path", { d: "m18 22-3-3 3-3", key: "kgdoj7" }],
  ["path", { d: "m6 2 3 3-3 3", key: "1fnbkv" }]
]);
const S8 = r("SwordIcon", [
  ["polyline", { points: "14.5 17.5 3 6 3 3 6 3 17.5 14.5", key: "1hfsw2" }],
  ["line", { x1: "13", x2: "19", y1: "19", y2: "13", key: "1vrmhu" }],
  ["line", { x1: "16", x2: "20", y1: "16", y2: "20", key: "1bron3" }],
  ["line", { x1: "19", x2: "21", y1: "21", y2: "19", key: "13pww6" }]
]);
const C8 = r("SwordsIcon", [
  ["polyline", { points: "14.5 17.5 3 6 3 3 6 3 17.5 14.5", key: "1hfsw2" }],
  ["line", { x1: "13", x2: "19", y1: "19", y2: "13", key: "1vrmhu" }],
  ["line", { x1: "16", x2: "20", y1: "16", y2: "20", key: "1bron3" }],
  ["line", { x1: "19", x2: "21", y1: "21", y2: "19", key: "13pww6" }],
  ["polyline", { points: "14.5 6.5 18 3 21 3 21 6 17.5 9.5", key: "hbey2j" }],
  ["line", { x1: "5", x2: "9", y1: "14", y2: "18", key: "1hf58s" }],
  ["line", { x1: "7", x2: "4", y1: "17", y2: "20", key: "pidxm4" }],
  ["line", { x1: "3", x2: "5", y1: "19", y2: "21", key: "1pehsh" }]
]);
const A8 = r("SyringeIcon", [
  ["path", { d: "m18 2 4 4", key: "22kx64" }],
  ["path", { d: "m17 7 3-3", key: "1w1zoj" }],
  ["path", { d: "M19 9 8.7 19.3c-1 1-2.5 1-3.4 0l-.6-.6c-1-1-1-2.5 0-3.4L15 5", key: "1exhtz" }],
  ["path", { d: "m9 11 4 4", key: "rovt3i" }],
  ["path", { d: "m5 19-3 3", key: "59f2uf" }],
  ["path", { d: "m14 4 6 6", key: "yqp9t2" }]
]);
const P8 = r("Table2Icon", [
  [
    "path",
    {
      d: "M9 3H5a2 2 0 0 0-2 2v4m6-6h10a2 2 0 0 1 2 2v4M9 3v18m0 0h10a2 2 0 0 0 2-2V9M9 21H5a2 2 0 0 1-2-2V9m0 0h18",
      key: "gugj83"
    }
  ]
]);
const q8 = r("TableCellsMergeIcon", [
  ["path", { d: "M12 21v-6", key: "lihzve" }],
  ["path", { d: "M12 9V3", key: "da5inc" }],
  ["path", { d: "M3 15h18", key: "5xshup" }],
  ["path", { d: "M3 9h18", key: "1pudct" }],
  ["rect", { width: "18", height: "18", x: "3", y: "3", rx: "2", key: "afitv7" }]
]);
const T8 = r("TableCellsSplitIcon", [
  ["path", { d: "M12 15V9", key: "8c7uyn" }],
  ["path", { d: "M3 15h18", key: "5xshup" }],
  ["path", { d: "M3 9h18", key: "1pudct" }],
  ["rect", { width: "18", height: "18", x: "3", y: "3", rx: "2", key: "afitv7" }]
]);
const D8 = r("TableColumnsSplitIcon", [
  ["path", { d: "M14 14v2", key: "w2a1xv" }],
  ["path", { d: "M14 20v2", key: "1lq872" }],
  ["path", { d: "M14 2v2", key: "6buw04" }],
  ["path", { d: "M14 8v2", key: "i67w9a" }],
  ["path", { d: "M2 15h8", key: "82wtch" }],
  ["path", { d: "M2 3h6a2 2 0 0 1 2 2v14a2 2 0 0 1-2 2H2", key: "up0l64" }],
  ["path", { d: "M2 9h8", key: "yelfik" }],
  ["path", { d: "M22 15h-4", key: "1es58f" }],
  ["path", { d: "M22 3h-2a2 2 0 0 0-2 2v14a2 2 0 0 0 2 2h2", key: "pdjoqf" }],
  ["path", { d: "M22 9h-4", key: "1luja7" }],
  ["path", { d: "M5 3v18", key: "14hmio" }]
]);
const _8 = r("TablePropertiesIcon", [
  ["path", { d: "M15 3v18", key: "14nvp0" }],
  ["rect", { width: "18", height: "18", x: "3", y: "3", rx: "2", key: "afitv7" }],
  ["path", { d: "M21 9H3", key: "1338ky" }],
  ["path", { d: "M21 15H3", key: "9uk58r" }]
]);
const B8 = r("TableRowsSplitIcon", [
  ["path", { d: "M14 10h2", key: "1lstlu" }],
  ["path", { d: "M15 22v-8", key: "1fwwgm" }],
  ["path", { d: "M15 2v4", key: "1044rn" }],
  ["path", { d: "M2 10h2", key: "1r8dkt" }],
  ["path", { d: "M20 10h2", key: "1ug425" }],
  ["path", { d: "M3 19h18", key: "awlh7x" }],
  ["path", { d: "M3 22v-6a2 2 135 0 1 2-2h14a2 2 45 0 1 2 2v6", key: "ibqhof" }],
  ["path", { d: "M3 2v2a2 2 45 0 0 2 2h14a2 2 135 0 0 2-2V2", key: "1uenja" }],
  ["path", { d: "M8 10h2", key: "66od0" }],
  ["path", { d: "M9 22v-8", key: "fmnu31" }],
  ["path", { d: "M9 2v4", key: "j1yeou" }]
]);
const z8 = r("TableIcon", [
  ["path", { d: "M12 3v18", key: "108xh3" }],
  ["rect", { width: "18", height: "18", x: "3", y: "3", rx: "2", key: "afitv7" }],
  ["path", { d: "M3 9h18", key: "1pudct" }],
  ["path", { d: "M3 15h18", key: "5xshup" }]
]);
const H8 = r("TabletSmartphoneIcon", [
  ["rect", { width: "10", height: "14", x: "3", y: "8", rx: "2", key: "1vrsiq" }],
  ["path", { d: "M5 4a2 2 0 0 1 2-2h12a2 2 0 0 1 2 2v16a2 2 0 0 1-2 2h-2.4", key: "1j4zmg" }],
  ["path", { d: "M8 18h.01", key: "lrp35t" }]
]);
const j8 = r("TabletIcon", [
  ["rect", { width: "16", height: "20", x: "4", y: "2", rx: "2", ry: "2", key: "76otgf" }],
  ["line", { x1: "12", x2: "12.01", y1: "18", y2: "18", key: "1dp563" }]
]);
const V8 = r("TabletsIcon", [
  ["circle", { cx: "7", cy: "7", r: "5", key: "x29byf" }],
  ["circle", { cx: "17", cy: "17", r: "5", key: "1op1d2" }],
  ["path", { d: "M12 17h10", key: "ls21zv" }],
  ["path", { d: "m3.46 10.54 7.08-7.08", key: "1rehiu" }]
]);
const O8 = r("TagIcon", [
  [
    "path",
    {
      d: "M12.586 2.586A2 2 0 0 0 11.172 2H4a2 2 0 0 0-2 2v7.172a2 2 0 0 0 .586 1.414l8.704 8.704a2.426 2.426 0 0 0 3.42 0l6.58-6.58a2.426 2.426 0 0 0 0-3.42z",
      key: "vktsd0"
    }
  ],
  ["circle", { cx: "7.5", cy: "7.5", r: ".5", fill: "currentColor", key: "kqv944" }]
]);
const $8 = r("TagsIcon", [
  ["path", { d: "m15 5 6.3 6.3a2.4 2.4 0 0 1 0 3.4L17 19", key: "1cbfv1" }],
  [
    "path",
    {
      d: "M9.586 5.586A2 2 0 0 0 8.172 5H3a1 1 0 0 0-1 1v5.172a2 2 0 0 0 .586 1.414L8.29 18.29a2.426 2.426 0 0 0 3.42 0l3.58-3.58a2.426 2.426 0 0 0 0-3.42z",
      key: "135mg7"
    }
  ],
  ["circle", { cx: "6.5", cy: "9.5", r: ".5", fill: "currentColor", key: "5pm5xn" }]
]);
const R8 = r("Tally1Icon", [["path", { d: "M4 4v16", key: "6qkkli" }]]);
const F8 = r("Tally2Icon", [
  ["path", { d: "M4 4v16", key: "6qkkli" }],
  ["path", { d: "M9 4v16", key: "81ygyz" }]
]);
const U8 = r("Tally3Icon", [
  ["path", { d: "M4 4v16", key: "6qkkli" }],
  ["path", { d: "M9 4v16", key: "81ygyz" }],
  ["path", { d: "M14 4v16", key: "12vmem" }]
]);
const E8 = r("Tally4Icon", [
  ["path", { d: "M4 4v16", key: "6qkkli" }],
  ["path", { d: "M9 4v16", key: "81ygyz" }],
  ["path", { d: "M14 4v16", key: "12vmem" }],
  ["path", { d: "M19 4v16", key: "8ij5ei" }]
]);
const W8 = r("Tally5Icon", [
  ["path", { d: "M4 4v16", key: "6qkkli" }],
  ["path", { d: "M9 4v16", key: "81ygyz" }],
  ["path", { d: "M14 4v16", key: "12vmem" }],
  ["path", { d: "M19 4v16", key: "8ij5ei" }],
  ["path", { d: "M22 6 2 18", key: "h9moai" }]
]);
const N8 = r("TangentIcon", [
  ["circle", { cx: "17", cy: "4", r: "2", key: "y5j2s2" }],
  ["path", { d: "M15.59 5.41 5.41 15.59", key: "l0vprr" }],
  ["circle", { cx: "4", cy: "17", r: "2", key: "9p4efm" }],
  ["path", { d: "M12 22s-4-9-1.5-11.5S22 12 22 12", key: "1twk4o" }]
]);
const Z8 = r("TargetIcon", [
  ["circle", { cx: "12", cy: "12", r: "10", key: "1mglay" }],
  ["circle", { cx: "12", cy: "12", r: "6", key: "1vlfrh" }],
  ["circle", { cx: "12", cy: "12", r: "2", key: "1c9p78" }]
]);
const Y8 = r("TelescopeIcon", [
  [
    "path",
    {
      d: "m10.065 12.493-6.18 1.318a.934.934 0 0 1-1.108-.702l-.537-2.15a1.07 1.07 0 0 1 .691-1.265l13.504-4.44",
      key: "k4qptu"
    }
  ],
  ["path", { d: "m13.56 11.747 4.332-.924", key: "19l80z" }],
  ["path", { d: "m16 21-3.105-6.21", key: "7oh9d" }],
  [
    "path",
    {
      d: "M16.485 5.94a2 2 0 0 1 1.455-2.425l1.09-.272a1 1 0 0 1 1.212.727l1.515 6.06a1 1 0 0 1-.727 1.213l-1.09.272a2 2 0 0 1-2.425-1.455z",
      key: "m7xp4m"
    }
  ],
  ["path", { d: "m6.158 8.633 1.114 4.456", key: "74o979" }],
  ["path", { d: "m8 21 3.105-6.21", key: "1fvxut" }],
  ["circle", { cx: "12", cy: "13", r: "2", key: "1c1ljs" }]
]);
const G8 = r("TentTreeIcon", [
  ["circle", { cx: "4", cy: "4", r: "2", key: "bt5ra8" }],
  ["path", { d: "m14 5 3-3 3 3", key: "1sorif" }],
  ["path", { d: "m14 10 3-3 3 3", key: "1jyi9h" }],
  ["path", { d: "M17 14V2", key: "8ymqnk" }],
  ["path", { d: "M17 14H7l-5 8h20Z", key: "13ar7p" }],
  ["path", { d: "M8 14v8", key: "1ghmqk" }],
  ["path", { d: "m9 14 5 8", key: "13pgi6" }]
]);
const X8 = r("TentIcon", [
  ["path", { d: "M3.5 21 14 3", key: "1szst5" }],
  ["path", { d: "M20.5 21 10 3", key: "1310c3" }],
  ["path", { d: "M15.5 21 12 15l-3.5 6", key: "1ddtfw" }],
  ["path", { d: "M2 21h20", key: "1nyx9w" }]
]);
const K8 = r("TerminalIcon", [
  ["polyline", { points: "4 17 10 11 4 5", key: "akl6gq" }],
  ["line", { x1: "12", x2: "20", y1: "19", y2: "19", key: "q2wloq" }]
]);
const tr = r("TestTubeDiagonalIcon", [
  [
    "path",
    { d: "M21 7 6.82 21.18a2.83 2.83 0 0 1-3.99-.01v0a2.83 2.83 0 0 1 0-4L17 3", key: "dg8b2p" }
  ],
  ["path", { d: "m16 2 6 6", key: "1gw87d" }],
  ["path", { d: "M12 16H4", key: "1cjfip" }]
]);
const Q8 = r("TestTubeIcon", [
  ["path", { d: "M14.5 2v17.5c0 1.4-1.1 2.5-2.5 2.5h0c-1.4 0-2.5-1.1-2.5-2.5V2", key: "187lwq" }],
  ["path", { d: "M8.5 2h7", key: "csnxdl" }],
  ["path", { d: "M14.5 16h-5", key: "1ox875" }]
]);
const J8 = r("TestTubesIcon", [
  ["path", { d: "M9 2v17.5A2.5 2.5 0 0 1 6.5 22v0A2.5 2.5 0 0 1 4 19.5V2", key: "12z67u" }],
  ["path", { d: "M20 2v17.5a2.5 2.5 0 0 1-2.5 2.5v0a2.5 2.5 0 0 1-2.5-2.5V2", key: "1q2nfy" }],
  ["path", { d: "M3 2h7", key: "7s29d5" }],
  ["path", { d: "M14 2h7", key: "7sicin" }],
  ["path", { d: "M9 16H4", key: "1bfye3" }],
  ["path", { d: "M20 16h-5", key: "ddnjpe" }]
]);
const e7 = r("TextCursorInputIcon", [
  ["path", { d: "M5 4h1a3 3 0 0 1 3 3 3 3 0 0 1 3-3h1", key: "18xjzo" }],
  ["path", { d: "M13 20h-1a3 3 0 0 1-3-3 3 3 0 0 1-3 3H5", key: "fj48gi" }],
  ["path", { d: "M5 16H4a2 2 0 0 1-2-2v-4a2 2 0 0 1 2-2h1", key: "1n9rhb" }],
  ["path", { d: "M13 8h7a2 2 0 0 1 2 2v4a2 2 0 0 1-2 2h-7", key: "13ksps" }],
  ["path", { d: "M9 7v10", key: "1vc8ob" }]
]);
const t7 = r("TextCursorIcon", [
  ["path", { d: "M17 22h-1a4 4 0 0 1-4-4V6a4 4 0 0 1 4-4h1", key: "uvaxm9" }],
  ["path", { d: "M7 22h1a4 4 0 0 0 4-4v-1", key: "11xy8d" }],
  ["path", { d: "M7 2h1a4 4 0 0 1 4 4v1", key: "1uw06m" }]
]);
const a7 = r("TextQuoteIcon", [
  ["path", { d: "M17 6H3", key: "16j9eg" }],
  ["path", { d: "M21 12H8", key: "scolzb" }],
  ["path", { d: "M21 18H8", key: "1wfozv" }],
  ["path", { d: "M3 12v6", key: "fv4c87" }]
]);
const n7 = r("TextSearchIcon", [
  ["path", { d: "M21 6H3", key: "1jwq7v" }],
  ["path", { d: "M10 12H3", key: "1ulcyk" }],
  ["path", { d: "M10 18H3", key: "13769t" }],
  ["circle", { cx: "17", cy: "15", r: "3", key: "1upz2a" }],
  ["path", { d: "m21 19-1.9-1.9", key: "dwi7p8" }]
]);
const ar = r("TextSelectIcon", [
  ["path", { d: "M5 3a2 2 0 0 0-2 2", key: "y57alp" }],
  ["path", { d: "M19 3a2 2 0 0 1 2 2", key: "18rm91" }],
  ["path", { d: "M21 19a2 2 0 0 1-2 2", key: "1j7049" }],
  ["path", { d: "M5 21a2 2 0 0 1-2-2", key: "sbafld" }],
  ["path", { d: "M9 3h1", key: "1yesri" }],
  ["path", { d: "M9 21h1", key: "15o7lz" }],
  ["path", { d: "M14 3h1", key: "1ec4yj" }],
  ["path", { d: "M14 21h1", key: "v9vybs" }],
  ["path", { d: "M3 9v1", key: "1r0deq" }],
  ["path", { d: "M21 9v1", key: "mxsmne" }],
  ["path", { d: "M3 14v1", key: "vnatye" }],
  ["path", { d: "M21 14v1", key: "169vum" }],
  ["line", { x1: "7", x2: "15", y1: "8", y2: "8", key: "1758g8" }],
  ["line", { x1: "7", x2: "17", y1: "12", y2: "12", key: "197423" }],
  ["line", { x1: "7", x2: "13", y1: "16", y2: "16", key: "37cgm6" }]
]);
const o7 = r("TextIcon", [
  ["path", { d: "M17 6.1H3", key: "wptmhv" }],
  ["path", { d: "M21 12.1H3", key: "1j38uz" }],
  ["path", { d: "M15.1 18H3", key: "1nb16a" }]
]);
const r7 = r("TheaterIcon", [
  ["path", { d: "M2 10s3-3 3-8", key: "3xiif0" }],
  ["path", { d: "M22 10s-3-3-3-8", key: "ioaa5q" }],
  ["path", { d: "M10 2c0 4.4-3.6 8-8 8", key: "16fkpi" }],
  ["path", { d: "M14 2c0 4.4 3.6 8 8 8", key: "b9eulq" }],
  ["path", { d: "M2 10s2 2 2 5", key: "1au1lb" }],
  ["path", { d: "M22 10s-2 2-2 5", key: "qi2y5e" }],
  ["path", { d: "M8 15h8", key: "45n4r" }],
  ["path", { d: "M2 22v-1a2 2 0 0 1 2-2h4a2 2 0 0 1 2 2v1", key: "1vsc2m" }],
  ["path", { d: "M14 22v-1a2 2 0 0 1 2-2h4a2 2 0 0 1 2 2v1", key: "hrha4u" }]
]);
const i7 = r("ThermometerSnowflakeIcon", [
  ["path", { d: "M2 12h10", key: "19562f" }],
  ["path", { d: "M9 4v16", key: "81ygyz" }],
  ["path", { d: "m3 9 3 3-3 3", key: "1sas0l" }],
  ["path", { d: "M12 6 9 9 6 6", key: "pfrgxu" }],
  ["path", { d: "m6 18 3-3 1.5 1.5", key: "1e277p" }],
  ["path", { d: "M20 4v10.54a4 4 0 1 1-4 0V4a2 2 0 0 1 4 0Z", key: "iof6y5" }]
]);
const l7 = r("ThermometerSunIcon", [
  ["path", { d: "M12 9a4 4 0 0 0-2 7.5", key: "1jvsq6" }],
  ["path", { d: "M12 3v2", key: "1w22ol" }],
  ["path", { d: "m6.6 18.4-1.4 1.4", key: "w2yidj" }],
  ["path", { d: "M20 4v10.54a4 4 0 1 1-4 0V4a2 2 0 0 1 4 0Z", key: "iof6y5" }],
  ["path", { d: "M4 13H2", key: "118le4" }],
  ["path", { d: "M6.34 7.34 4.93 5.93", key: "1brd51" }]
]);
const c7 = r("ThermometerIcon", [
  ["path", { d: "M14 4v10.54a4 4 0 1 1-4 0V4a2 2 0 0 1 4 0Z", key: "17jzev" }]
]);
const d7 = r("ThumbsDownIcon", [
  ["path", { d: "M17 14V2", key: "8ymqnk" }],
  [
    "path",
    {
      d: "M9 18.12 10 14H4.17a2 2 0 0 1-1.92-2.56l2.33-8A2 2 0 0 1 6.5 2H20a2 2 0 0 1 2 2v8a2 2 0 0 1-2 2h-2.76a2 2 0 0 0-1.79 1.11L12 22h0a3.13 3.13 0 0 1-3-3.88Z",
      key: "s6e0r"
    }
  ]
]);
const s7 = r("ThumbsUpIcon", [
  ["path", { d: "M7 10v12", key: "1qc93n" }],
  [
    "path",
    {
      d: "M15 5.88 14 10h5.83a2 2 0 0 1 1.92 2.56l-2.33 8A2 2 0 0 1 17.5 22H4a2 2 0 0 1-2-2v-8a2 2 0 0 1 2-2h2.76a2 2 0 0 0 1.79-1.11L12 2h0a3.13 3.13 0 0 1 3 3.88Z",
      key: "y3tblf"
    }
  ]
]);
const u7 = r("TicketCheckIcon", [
  [
    "path",
    {
      d: "M2 9a3 3 0 0 1 0 6v2a2 2 0 0 0 2 2h16a2 2 0 0 0 2-2v-2a3 3 0 0 1 0-6V7a2 2 0 0 0-2-2H4a2 2 0 0 0-2 2Z",
      key: "qn84l0"
    }
  ],
  ["path", { d: "m9 12 2 2 4-4", key: "dzmm74" }]
]);
const h7 = r("TicketMinusIcon", [
  [
    "path",
    {
      d: "M2 9a3 3 0 0 1 0 6v2a2 2 0 0 0 2 2h16a2 2 0 0 0 2-2v-2a3 3 0 0 1 0-6V7a2 2 0 0 0-2-2H4a2 2 0 0 0-2 2Z",
      key: "qn84l0"
    }
  ],
  ["path", { d: "M9 12h6", key: "1c52cq" }]
]);
const p7 = r("TicketPercentIcon", [
  [
    "path",
    {
      d: "M2 9a3 3 0 1 1 0 6v2a2 2 0 0 0 2 2h16a2 2 0 0 0 2-2v-2a3 3 0 1 1 0-6V7a2 2 0 0 0-2-2H4a2 2 0 0 0-2 2Z",
      key: "1l48ns"
    }
  ],
  ["path", { d: "M9 9h.01", key: "1q5me6" }],
  ["path", { d: "m15 9-6 6", key: "1uzhvr" }],
  ["path", { d: "M15 15h.01", key: "lqbp3k" }]
]);
const y7 = r("TicketPlusIcon", [
  [
    "path",
    {
      d: "M2 9a3 3 0 0 1 0 6v2a2 2 0 0 0 2 2h16a2 2 0 0 0 2-2v-2a3 3 0 0 1 0-6V7a2 2 0 0 0-2-2H4a2 2 0 0 0-2 2Z",
      key: "qn84l0"
    }
  ],
  ["path", { d: "M9 12h6", key: "1c52cq" }],
  ["path", { d: "M12 9v6", key: "199k2o" }]
]);
const k7 = r("TicketSlashIcon", [
  [
    "path",
    {
      d: "M2 9a3 3 0 0 1 0 6v2a2 2 0 0 0 2 2h16a2 2 0 0 0 2-2v-2a3 3 0 0 1 0-6V7a2 2 0 0 0-2-2H4a2 2 0 0 0-2 2Z",
      key: "qn84l0"
    }
  ],
  ["path", { d: "m9.5 14.5 5-5", key: "qviqfa" }]
]);
const f7 = r("TicketXIcon", [
  [
    "path",
    {
      d: "M2 9a3 3 0 0 1 0 6v2a2 2 0 0 0 2 2h16a2 2 0 0 0 2-2v-2a3 3 0 0 1 0-6V7a2 2 0 0 0-2-2H4a2 2 0 0 0-2 2Z",
      key: "qn84l0"
    }
  ],
  ["path", { d: "m9.5 14.5 5-5", key: "qviqfa" }],
  ["path", { d: "m9.5 9.5 5 5", key: "18nt4w" }]
]);
const v7 = r("TicketIcon", [
  [
    "path",
    {
      d: "M2 9a3 3 0 0 1 0 6v2a2 2 0 0 0 2 2h16a2 2 0 0 0 2-2v-2a3 3 0 0 1 0-6V7a2 2 0 0 0-2-2H4a2 2 0 0 0-2 2Z",
      key: "qn84l0"
    }
  ],
  ["path", { d: "M13 5v2", key: "dyzc3o" }],
  ["path", { d: "M13 17v2", key: "1ont0d" }],
  ["path", { d: "M13 11v2", key: "1wjjxi" }]
]);
const m7 = r("TimerOffIcon", [
  ["path", { d: "M10 2h4", key: "n1abiw" }],
  ["path", { d: "M4.6 11a8 8 0 0 0 1.7 8.7 8 8 0 0 0 8.7 1.7", key: "10he05" }],
  ["path", { d: "M7.4 7.4a8 8 0 0 1 10.3 1 8 8 0 0 1 .9 10.2", key: "15f7sh" }],
  ["path", { d: "m2 2 20 20", key: "1ooewy" }],
  ["path", { d: "M12 12v-2", key: "fwoke6" }]
]);
const g7 = r("TimerResetIcon", [
  ["path", { d: "M10 2h4", key: "n1abiw" }],
  ["path", { d: "M12 14v-4", key: "1evpnu" }],
  ["path", { d: "M4 13a8 8 0 0 1 8-7 8 8 0 1 1-5.3 14L4 17.6", key: "1ts96g" }],
  ["path", { d: "M9 17H4v5", key: "8t5av" }]
]);
const M7 = r("TimerIcon", [
  ["line", { x1: "10", x2: "14", y1: "2", y2: "2", key: "14vaq8" }],
  ["line", { x1: "12", x2: "15", y1: "14", y2: "11", key: "17fdiu" }],
  ["circle", { cx: "12", cy: "14", r: "8", key: "1e1u0o" }]
]);
const x7 = r("ToggleLeftIcon", [
  ["rect", { width: "20", height: "12", x: "2", y: "6", rx: "6", ry: "6", key: "f2vt7d" }],
  ["circle", { cx: "8", cy: "12", r: "2", key: "1nvbw3" }]
]);
const b7 = r("ToggleRightIcon", [
  ["rect", { width: "20", height: "12", x: "2", y: "6", rx: "6", ry: "6", key: "f2vt7d" }],
  ["circle", { cx: "16", cy: "12", r: "2", key: "4ma0v8" }]
]);
const w7 = r("TornadoIcon", [
  ["path", { d: "M21 4H3", key: "1hwok0" }],
  ["path", { d: "M18 8H6", key: "41n648" }],
  ["path", { d: "M19 12H9", key: "1g4lpz" }],
  ["path", { d: "M16 16h-6", key: "1j5d54" }],
  ["path", { d: "M11 20H9", key: "39obr8" }]
]);
const I7 = r("TorusIcon", [
  ["ellipse", { cx: "12", cy: "11", rx: "3", ry: "2", key: "1b2qxu" }],
  ["ellipse", { cx: "12", cy: "12.5", rx: "10", ry: "8.5", key: "h8emeu" }]
]);
const L7 = r("TouchpadOffIcon", [
  ["path", { d: "M4 4a2 2 0 0 0-2 2v12a2 2 0 0 0 2 2h16", key: "lnt0bk" }],
  ["path", { d: "M2 14h12", key: "d8icqz" }],
  ["path", { d: "M22 14h-2", key: "jrx26d" }],
  ["path", { d: "M12 20v-6", key: "1rm09r" }],
  ["path", { d: "m2 2 20 20", key: "1ooewy" }],
  ["path", { d: "M22 16V6a2 2 0 0 0-2-2H10", key: "11y8e4" }]
]);
const S7 = r("TouchpadIcon", [
  ["rect", { width: "20", height: "16", x: "2", y: "4", rx: "2", key: "18n3k1" }],
  ["path", { d: "M2 14h20", key: "myj16y" }],
  ["path", { d: "M12 20v-6", key: "1rm09r" }]
]);
const C7 = r("TowerControlIcon", [
  [
    "path",
    { d: "M18.2 12.27 20 6H4l1.8 6.27a1 1 0 0 0 .95.73h10.5a1 1 0 0 0 .96-.73Z", key: "1pledb" }
  ],
  ["path", { d: "M8 13v9", key: "hmv0ci" }],
  ["path", { d: "M16 22v-9", key: "ylnf1u" }],
  ["path", { d: "m9 6 1 7", key: "dpdgam" }],
  ["path", { d: "m15 6-1 7", key: "ls7zgu" }],
  ["path", { d: "M12 6V2", key: "1pj48d" }],
  ["path", { d: "M13 2h-2", key: "mj6ths" }]
]);
const A7 = r("ToyBrickIcon", [
  ["rect", { width: "18", height: "12", x: "3", y: "8", rx: "1", key: "158fvp" }],
  ["path", { d: "M10 8V5c0-.6-.4-1-1-1H6a1 1 0 0 0-1 1v3", key: "s0042v" }],
  ["path", { d: "M19 8V5c0-.6-.4-1-1-1h-3a1 1 0 0 0-1 1v3", key: "9wmeh2" }]
]);
const P7 = r("TractorIcon", [
  ["path", { d: "m10 11 11 .9c.6 0 .9.5.8 1.1l-.8 5h-1", key: "2w242w" }],
  ["path", { d: "M16 18h-5", key: "bq60fd" }],
  ["path", { d: "M18 5a1 1 0 0 0-1 1v5.573", key: "1kv8ia" }],
  ["path", { d: "M3 4h9l1 7.246", key: "d639it" }],
  ["path", { d: "M4 11V4", key: "9ft8pt" }],
  ["path", { d: "M7 15h.01", key: "k5ht0j" }],
  ["path", { d: "M8 10.1V4", key: "1jgyzo" }],
  ["circle", { cx: "18", cy: "18", r: "2", key: "1emm8v" }],
  ["circle", { cx: "7", cy: "15", r: "5", key: "ddtuc" }]
]);
const q7 = r("TrafficConeIcon", [
  ["path", { d: "M9.3 6.2a4.55 4.55 0 0 0 5.4 0", key: "flyxqv" }],
  ["path", { d: "M7.9 10.7c.9.8 2.4 1.3 4.1 1.3s3.2-.5 4.1-1.3", key: "1nlxxg" }],
  [
    "path",
    {
      d: "M13.9 3.5a1.93 1.93 0 0 0-3.8-.1l-3 10c-.1.2-.1.4-.1.6 0 1.7 2.2 3 5 3s5-1.3 5-3c0-.2 0-.4-.1-.5Z",
      key: "vz7x1l"
    }
  ],
  [
    "path",
    {
      d: "m7.5 12.2-4.7 2.7c-.5.3-.8.7-.8 1.1s.3.8.8 1.1l7.6 4.5c.9.5 2.1.5 3 0l7.6-4.5c.7-.3 1-.7 1-1.1s-.3-.8-.8-1.1l-4.7-2.8",
      key: "1xfzlw"
    }
  ]
]);
const T7 = r("TrainFrontTunnelIcon", [
  ["path", { d: "M2 22V12a10 10 0 1 1 20 0v10", key: "o0fyp0" }],
  ["path", { d: "M15 6.8v1.4a3 2.8 0 1 1-6 0V6.8", key: "m8q3n9" }],
  ["path", { d: "M10 15h.01", key: "44in9x" }],
  ["path", { d: "M14 15h.01", key: "5mohn5" }],
  ["path", { d: "M10 19a4 4 0 0 1-4-4v-3a6 6 0 1 1 12 0v3a4 4 0 0 1-4 4Z", key: "hckbmu" }],
  ["path", { d: "m9 19-2 3", key: "iij7hm" }],
  ["path", { d: "m15 19 2 3", key: "npx8sa" }]
]);
const D7 = r("TrainFrontIcon", [
  ["path", { d: "M8 3.1V7a4 4 0 0 0 8 0V3.1", key: "1v71zp" }],
  ["path", { d: "m9 15-1-1", key: "1yrq24" }],
  ["path", { d: "m15 15 1-1", key: "1t0d6s" }],
  ["path", { d: "M9 19c-2.8 0-5-2.2-5-5v-4a8 8 0 0 1 16 0v4c0 2.8-2.2 5-5 5Z", key: "1p0hjs" }],
  ["path", { d: "m8 19-2 3", key: "13i0xs" }],
  ["path", { d: "m16 19 2 3", key: "xo31yx" }]
]);
const _7 = r("TrainTrackIcon", [
  ["path", { d: "M2 17 17 2", key: "18b09t" }],
  ["path", { d: "m2 14 8 8", key: "1gv9hu" }],
  ["path", { d: "m5 11 8 8", key: "189pqp" }],
  ["path", { d: "m8 8 8 8", key: "1imecy" }],
  ["path", { d: "m11 5 8 8", key: "ummqn6" }],
  ["path", { d: "m14 2 8 8", key: "1vk7dn" }],
  ["path", { d: "M7 22 22 7", key: "15mb1i" }]
]);
const nr = r("TramFrontIcon", [
  ["rect", { width: "16", height: "16", x: "4", y: "3", rx: "2", key: "1wxw4b" }],
  ["path", { d: "M4 11h16", key: "mpoxn0" }],
  ["path", { d: "M12 3v8", key: "1h2ygw" }],
  ["path", { d: "m8 19-2 3", key: "13i0xs" }],
  ["path", { d: "m18 22-2-3", key: "1p0ohu" }],
  ["path", { d: "M8 15h.01", key: "a7atzg" }],
  ["path", { d: "M16 15h.01", key: "rnfrdf" }]
]);
const B7 = r("Trash2Icon", [
  ["path", { d: "M3 6h18", key: "d0wm0j" }],
  ["path", { d: "M19 6v14c0 1-1 2-2 2H7c-1 0-2-1-2-2V6", key: "4alrt4" }],
  ["path", { d: "M8 6V4c0-1 1-2 2-2h4c1 0 2 1 2 2v2", key: "v07s0e" }],
  ["line", { x1: "10", x2: "10", y1: "11", y2: "17", key: "1uufr5" }],
  ["line", { x1: "14", x2: "14", y1: "11", y2: "17", key: "xtxkd" }]
]);
const z7 = r("TrashIcon", [
  ["path", { d: "M3 6h18", key: "d0wm0j" }],
  ["path", { d: "M19 6v14c0 1-1 2-2 2H7c-1 0-2-1-2-2V6", key: "4alrt4" }],
  ["path", { d: "M8 6V4c0-1 1-2 2-2h4c1 0 2 1 2 2v2", key: "v07s0e" }]
]);
const H7 = r("TreeDeciduousIcon", [
  [
    "path",
    {
      d: "M8 19a4 4 0 0 1-2.24-7.32A3.5 3.5 0 0 1 9 6.03V6a3 3 0 1 1 6 0v.04a3.5 3.5 0 0 1 3.24 5.65A4 4 0 0 1 16 19Z",
      key: "oadzkq"
    }
  ],
  ["path", { d: "M12 19v3", key: "npa21l" }]
]);
const or = r("TreePalmIcon", [
  ["path", { d: "M13 8c0-2.76-2.46-5-5.5-5S2 5.24 2 8h2l1-1 1 1h4", key: "foxbe7" }],
  [
    "path",
    { d: "M13 7.14A5.82 5.82 0 0 1 16.5 6c3.04 0 5.5 2.24 5.5 5h-3l-1-1-1 1h-3", key: "18arnh" }
  ],
  [
    "path",
    {
      d: "M5.89 9.71c-2.15 2.15-2.3 5.47-.35 7.43l4.24-4.25.7-.7.71-.71 2.12-2.12c-1.95-1.96-5.27-1.8-7.42.35",
      key: "ywahnh"
    }
  ],
  ["path", { d: "M11 15.5c.5 2.5-.17 4.5-1 6.5h4c2-5.5-.5-12-1-14", key: "ft0feo" }]
]);
const j7 = r("TreePineIcon", [
  [
    "path",
    {
      d: "m17 14 3 3.3a1 1 0 0 1-.7 1.7H4.7a1 1 0 0 1-.7-1.7L7 14h-.3a1 1 0 0 1-.7-1.7L9 9h-.2A1 1 0 0 1 8 7.3L12 3l4 4.3a1 1 0 0 1-.8 1.7H15l3 3.3a1 1 0 0 1-.7 1.7H17Z",
      key: "cpyugq"
    }
  ],
  ["path", { d: "M12 22v-3", key: "kmzjlo" }]
]);
const V7 = r("TreesIcon", [
  [
    "path",
    { d: "M10 10v.2A3 3 0 0 1 8.9 16v0H5v0h0a3 3 0 0 1-1-5.8V10a3 3 0 0 1 6 0Z", key: "yh07w9" }
  ],
  ["path", { d: "M7 16v6", key: "1a82de" }],
  ["path", { d: "M13 19v3", key: "13sx9i" }],
  [
    "path",
    {
      d: "M12 19h8.3a1 1 0 0 0 .7-1.7L18 14h.3a1 1 0 0 0 .7-1.7L16 9h.2a1 1 0 0 0 .8-1.7L13 3l-1.4 1.5",
      key: "1sj9kv"
    }
  ]
]);
const O7 = r("TrelloIcon", [
  ["rect", { width: "18", height: "18", x: "3", y: "3", rx: "2", ry: "2", key: "1m3agn" }],
  ["rect", { width: "3", height: "9", x: "7", y: "7", key: "14n3xi" }],
  ["rect", { width: "3", height: "5", x: "14", y: "7", key: "s4azjd" }]
]);
const $7 = r("TrendingDownIcon", [
  ["polyline", { points: "22 17 13.5 8.5 8.5 13.5 2 7", key: "1r2t7k" }],
  ["polyline", { points: "16 17 22 17 22 11", key: "11uiuu" }]
]);
const R7 = r("TrendingUpIcon", [
  ["polyline", { points: "22 7 13.5 15.5 8.5 10.5 2 17", key: "126l90" }],
  ["polyline", { points: "16 7 22 7 22 13", key: "kwv8wd" }]
]);
const rr = r("TriangleAlertIcon", [
  [
    "path",
    {
      d: "m21.73 18-8-14a2 2 0 0 0-3.48 0l-8 14A2 2 0 0 0 4 21h16a2 2 0 0 0 1.73-3",
      key: "wmoenq"
    }
  ],
  ["path", { d: "M12 9v4", key: "juzpu7" }],
  ["path", { d: "M12 17h.01", key: "p32p05" }]
]);
const F7 = r("TriangleRightIcon", [
  [
    "path",
    {
      d: "M22 18a2 2 0 0 1-2 2H3c-1.1 0-1.3-.6-.4-1.3L20.4 4.3c.9-.7 1.6-.4 1.6.7Z",
      key: "183wce"
    }
  ]
]);
const U7 = r("TriangleIcon", [
  [
    "path",
    { d: "M13.73 4a2 2 0 0 0-3.46 0l-8 14A2 2 0 0 0 4 21h16a2 2 0 0 0 1.73-3Z", key: "14u9p9" }
  ]
]);
const E7 = r("TrophyIcon", [
  ["path", { d: "M6 9H4.5a2.5 2.5 0 0 1 0-5H6", key: "17hqa7" }],
  ["path", { d: "M18 9h1.5a2.5 2.5 0 0 0 0-5H18", key: "lmptdp" }],
  ["path", { d: "M4 22h16", key: "57wxv0" }],
  ["path", { d: "M10 14.66V17c0 .55-.47.98-.97 1.21C7.85 18.75 7 20.24 7 22", key: "1nw9bq" }],
  ["path", { d: "M14 14.66V17c0 .55.47.98.97 1.21C16.15 18.75 17 20.24 17 22", key: "1np0yb" }],
  ["path", { d: "M18 2H6v7a6 6 0 0 0 12 0V2Z", key: "u46fv3" }]
]);
const W7 = r("TruckIcon", [
  ["path", { d: "M14 18V6a2 2 0 0 0-2-2H4a2 2 0 0 0-2 2v11a1 1 0 0 0 1 1h2", key: "wrbu53" }],
  ["path", { d: "M15 18H9", key: "1lyqi6" }],
  [
    "path",
    {
      d: "M19 18h2a1 1 0 0 0 1-1v-3.65a1 1 0 0 0-.22-.624l-3.48-4.35A1 1 0 0 0 17.52 8H14",
      key: "lysw3i"
    }
  ],
  ["circle", { cx: "17", cy: "18", r: "2", key: "332jqn" }],
  ["circle", { cx: "7", cy: "18", r: "2", key: "19iecd" }]
]);
const N7 = r("TurtleIcon", [
  [
    "path",
    {
      d: "m12 10 2 4v3a1 1 0 0 0 1 1h2a1 1 0 0 0 1-1v-3a8 8 0 1 0-16 0v3a1 1 0 0 0 1 1h2a1 1 0 0 0 1-1v-3l2-4h4Z",
      key: "1lbbv7"
    }
  ],
  ["path", { d: "M4.82 7.9 8 10", key: "m9wose" }],
  ["path", { d: "M15.18 7.9 12 10", key: "p8dp2u" }],
  ["path", { d: "M16.93 10H20a2 2 0 0 1 0 4H2", key: "12nsm7" }]
]);
const Z7 = r("Tv2Icon", [
  ["path", { d: "M7 21h10", key: "1b0cd5" }],
  ["rect", { width: "20", height: "14", x: "2", y: "3", rx: "2", key: "48i651" }]
]);
const Y7 = r("TvIcon", [
  ["rect", { width: "20", height: "15", x: "2", y: "7", rx: "2", ry: "2", key: "10ag99" }],
  ["polyline", { points: "17 2 12 7 7 2", key: "11pgbg" }]
]);
const G7 = r("TwitchIcon", [
  ["path", { d: "M21 2H3v16h5v4l4-4h5l4-4V2zm-10 9V7m5 4V7", key: "c0yzno" }]
]);
const X7 = r("TwitterIcon", [
  [
    "path",
    {
      d: "M22 4s-.7 2.1-2 3.4c1.6 10-9.4 17.3-18 11.6 2.2.1 4.4-.6 6-2C3 15.5.5 9.6 3 5c2.2 2.6 5.6 4.1 9 4-.9-4.2 4-6.6 7-3.8 1.1 0 3-1.2 3-1.2z",
      key: "pff0z6"
    }
  ]
]);
const K7 = r("TypeIcon", [
  ["polyline", { points: "4 7 4 4 20 4 20 7", key: "1nosan" }],
  ["line", { x1: "9", x2: "15", y1: "20", y2: "20", key: "swin9y" }],
  ["line", { x1: "12", x2: "12", y1: "4", y2: "20", key: "1tx1rr" }]
]);
const Q7 = r("UmbrellaOffIcon", [
  ["path", { d: "M12 2v1", key: "11qlp1" }],
  ["path", { d: "M15.5 21a1.85 1.85 0 0 1-3.5-1v-8H2a10 10 0 0 1 3.428-6.575", key: "eki10q" }],
  ["path", { d: "M17.5 12H22A10 10 0 0 0 9.004 3.455", key: "n2ayka" }],
  ["path", { d: "m2 2 20 20", key: "1ooewy" }]
]);
const J7 = r("UmbrellaIcon", [
  ["path", { d: "M22 12a10.06 10.06 1 0 0-20 0Z", key: "1teyop" }],
  ["path", { d: "M12 12v8a2 2 0 0 0 4 0", key: "ulpmoc" }],
  ["path", { d: "M12 2v1", key: "11qlp1" }]
]);
const eM = r("UnderlineIcon", [
  ["path", { d: "M6 4v6a6 6 0 0 0 12 0V4", key: "9kb039" }],
  ["line", { x1: "4", x2: "20", y1: "20", y2: "20", key: "nun2al" }]
]);
const tM = r("Undo2Icon", [
  ["path", { d: "M9 14 4 9l5-5", key: "102s5s" }],
  ["path", { d: "M4 9h10.5a5.5 5.5 0 0 1 5.5 5.5v0a5.5 5.5 0 0 1-5.5 5.5H11", key: "llx8ln" }]
]);
const aM = r("UndoDotIcon", [
  ["circle", { cx: "12", cy: "17", r: "1", key: "1ixnty" }],
  ["path", { d: "M3 7v6h6", key: "1v2h90" }],
  ["path", { d: "M21 17a9 9 0 0 0-9-9 9 9 0 0 0-6 2.3L3 13", key: "1r6uu6" }]
]);
const nM = r("UndoIcon", [
  ["path", { d: "M3 7v6h6", key: "1v2h90" }],
  ["path", { d: "M21 17a9 9 0 0 0-9-9 9 9 0 0 0-6 2.3L3 13", key: "1r6uu6" }]
]);
const oM = r("UnfoldHorizontalIcon", [
  ["path", { d: "M16 12h6", key: "15xry1" }],
  ["path", { d: "M8 12H2", key: "1jqql6" }],
  ["path", { d: "M12 2v2", key: "tus03m" }],
  ["path", { d: "M12 8v2", key: "1woqiv" }],
  ["path", { d: "M12 14v2", key: "8jcxud" }],
  ["path", { d: "M12 20v2", key: "1lh1kg" }],
  ["path", { d: "m19 15 3-3-3-3", key: "wjy7rq" }],
  ["path", { d: "m5 9-3 3 3 3", key: "j64kie" }]
]);
const rM = r("UnfoldVerticalIcon", [
  ["path", { d: "M12 22v-6", key: "6o8u61" }],
  ["path", { d: "M12 8V2", key: "1wkif3" }],
  ["path", { d: "M4 12H2", key: "rhcxmi" }],
  ["path", { d: "M10 12H8", key: "s88cx1" }],
  ["path", { d: "M16 12h-2", key: "10asgb" }],
  ["path", { d: "M22 12h-2", key: "14jgyd" }],
  ["path", { d: "m15 19-3 3-3-3", key: "11eu04" }],
  ["path", { d: "m15 5-3-3-3 3", key: "itvq4r" }]
]);
const iM = r("UngroupIcon", [
  ["rect", { width: "8", height: "6", x: "5", y: "4", rx: "1", key: "nzclkv" }],
  ["rect", { width: "8", height: "6", x: "11", y: "14", rx: "1", key: "4tytwb" }]
]);
const ir = r("UniversityIcon", [
  ["circle", { cx: "12", cy: "10", r: "1", key: "1gnqs8" }],
  ["path", { d: "M22 20V8h-4l-6-4-6 4H2v12a2 2 0 0 0 2 2h16a2 2 0 0 0 2-2", key: "1qj5sn" }],
  ["path", { d: "M6 17v.01", key: "roodi6" }],
  ["path", { d: "M6 13v.01", key: "67c122" }],
  ["path", { d: "M18 17v.01", key: "12ktxm" }],
  ["path", { d: "M18 13v.01", key: "tn1rt1" }],
  ["path", { d: "M14 22v-5a2 2 0 0 0-2-2v0a2 2 0 0 0-2 2v5", key: "jfgdp0" }]
]);
const lM = r("Unlink2Icon", [
  ["path", { d: "M15 7h2a5 5 0 0 1 0 10h-2m-6 0H7A5 5 0 0 1 7 7h2", key: "1re2ne" }]
]);
const cM = r("UnlinkIcon", [
  [
    "path",
    {
      d: "m18.84 12.25 1.72-1.71h-.02a5.004 5.004 0 0 0-.12-7.07 5.006 5.006 0 0 0-6.95 0l-1.72 1.71",
      key: "yqzxt4"
    }
  ],
  [
    "path",
    {
      d: "m5.17 11.75-1.71 1.71a5.004 5.004 0 0 0 .12 7.07 5.006 5.006 0 0 0 6.95 0l1.71-1.71",
      key: "4qinb0"
    }
  ],
  ["line", { x1: "8", x2: "8", y1: "2", y2: "5", key: "1041cp" }],
  ["line", { x1: "2", x2: "5", y1: "8", y2: "8", key: "14m1p5" }],
  ["line", { x1: "16", x2: "16", y1: "19", y2: "22", key: "rzdirn" }],
  ["line", { x1: "19", x2: "22", y1: "16", y2: "16", key: "ox905f" }]
]);
const dM = r("UnplugIcon", [
  ["path", { d: "m19 5 3-3", key: "yk6iyv" }],
  ["path", { d: "m2 22 3-3", key: "19mgm9" }],
  [
    "path",
    { d: "M6.3 20.3a2.4 2.4 0 0 0 3.4 0L12 18l-6-6-2.3 2.3a2.4 2.4 0 0 0 0 3.4Z", key: "goz73y" }
  ],
  ["path", { d: "M7.5 13.5 10 11", key: "7xgeeb" }],
  ["path", { d: "M10.5 16.5 13 14", key: "10btkg" }],
  [
    "path",
    { d: "m12 6 6 6 2.3-2.3a2.4 2.4 0 0 0 0-3.4l-2.6-2.6a2.4 2.4 0 0 0-3.4 0Z", key: "1snsnr" }
  ]
]);
const sM = r("UploadIcon", [
  ["path", { d: "M21 15v4a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2v-4", key: "ih7n3h" }],
  ["polyline", { points: "17 8 12 3 7 8", key: "t8dd8p" }],
  ["line", { x1: "12", x2: "12", y1: "3", y2: "15", key: "widbto" }]
]);
const uM = r("UsbIcon", [
  ["circle", { cx: "10", cy: "7", r: "1", key: "dypaad" }],
  ["circle", { cx: "4", cy: "20", r: "1", key: "22iqad" }],
  ["path", { d: "M4.7 19.3 19 5", key: "1enqfc" }],
  ["path", { d: "m21 3-3 1 2 2Z", key: "d3ov82" }],
  ["path", { d: "M9.26 7.68 5 12l2 5", key: "1esawj" }],
  ["path", { d: "m10 14 5 2 3.5-3.5", key: "v8oal5" }],
  ["path", { d: "m18 12 1-1 1 1-1 1Z", key: "1bh22v" }]
]);
const hM = r("UserCheckIcon", [
  ["path", { d: "M16 21v-2a4 4 0 0 0-4-4H6a4 4 0 0 0-4 4v2", key: "1yyitq" }],
  ["circle", { cx: "9", cy: "7", r: "4", key: "nufk8" }],
  ["polyline", { points: "16 11 18 13 22 9", key: "1pwet4" }]
]);
const pM = r("UserCogIcon", [
  ["circle", { cx: "18", cy: "15", r: "3", key: "gjjjvw" }],
  ["circle", { cx: "9", cy: "7", r: "4", key: "nufk8" }],
  ["path", { d: "M10 15H6a4 4 0 0 0-4 4v2", key: "1nfge6" }],
  ["path", { d: "m21.7 16.4-.9-.3", key: "12j9ji" }],
  ["path", { d: "m15.2 13.9-.9-.3", key: "1fdjdi" }],
  ["path", { d: "m16.6 18.7.3-.9", key: "heedtr" }],
  ["path", { d: "m19.1 12.2.3-.9", key: "1af3ki" }],
  ["path", { d: "m19.6 18.7-.4-1", key: "1x9vze" }],
  ["path", { d: "m16.8 12.3-.4-1", key: "vqeiwj" }],
  ["path", { d: "m14.3 16.6 1-.4", key: "1qlj63" }],
  ["path", { d: "m20.7 13.8 1-.4", key: "1v5t8k" }]
]);
const yM = r("UserMinusIcon", [
  ["path", { d: "M16 21v-2a4 4 0 0 0-4-4H6a4 4 0 0 0-4 4v2", key: "1yyitq" }],
  ["circle", { cx: "9", cy: "7", r: "4", key: "nufk8" }],
  ["line", { x1: "22", x2: "16", y1: "11", y2: "11", key: "1shjgl" }]
]);
const kM = r("UserPlusIcon", [
  ["path", { d: "M16 21v-2a4 4 0 0 0-4-4H6a4 4 0 0 0-4 4v2", key: "1yyitq" }],
  ["circle", { cx: "9", cy: "7", r: "4", key: "nufk8" }],
  ["line", { x1: "19", x2: "19", y1: "8", y2: "14", key: "1bvyxn" }],
  ["line", { x1: "22", x2: "16", y1: "11", y2: "11", key: "1shjgl" }]
]);
const lr = r("UserRoundCheckIcon", [
  ["path", { d: "M2 21a8 8 0 0 1 13.292-6", key: "bjp14o" }],
  ["circle", { cx: "10", cy: "8", r: "5", key: "o932ke" }],
  ["path", { d: "m16 19 2 2 4-4", key: "1b14m6" }]
]);
const cr = r("UserRoundCogIcon", [
  ["path", { d: "M2 21a8 8 0 0 1 10.434-7.62", key: "1yezr2" }],
  ["circle", { cx: "10", cy: "8", r: "5", key: "o932ke" }],
  ["circle", { cx: "18", cy: "18", r: "3", key: "1xkwt0" }],
  ["path", { d: "m19.5 14.3-.4.9", key: "1eb35c" }],
  ["path", { d: "m16.9 20.8-.4.9", key: "dfjc4z" }],
  ["path", { d: "m21.7 19.5-.9-.4", key: "q4dx6b" }],
  ["path", { d: "m15.2 16.9-.9-.4", key: "1r0w5f" }],
  ["path", { d: "m21.7 16.5-.9.4", key: "1knoei" }],
  ["path", { d: "m15.2 19.1-.9.4", key: "j188fs" }],
  ["path", { d: "m19.5 21.7-.4-.9", key: "1tonu5" }],
  ["path", { d: "m16.9 15.2-.4-.9", key: "699xu" }]
]);
const dr = r("UserRoundMinusIcon", [
  ["path", { d: "M2 21a8 8 0 0 1 13.292-6", key: "bjp14o" }],
  ["circle", { cx: "10", cy: "8", r: "5", key: "o932ke" }],
  ["path", { d: "M22 19h-6", key: "vcuq98" }]
]);
const sr = r("UserRoundPlusIcon", [
  ["path", { d: "M2 21a8 8 0 0 1 13.292-6", key: "bjp14o" }],
  ["circle", { cx: "10", cy: "8", r: "5", key: "o932ke" }],
  ["path", { d: "M19 16v6", key: "tddt3s" }],
  ["path", { d: "M22 19h-6", key: "vcuq98" }]
]);
const fM = r("UserRoundSearchIcon", [
  ["circle", { cx: "10", cy: "8", r: "5", key: "o932ke" }],
  ["path", { d: "M2 21a8 8 0 0 1 10.434-7.62", key: "1yezr2" }],
  ["circle", { cx: "18", cy: "18", r: "3", key: "1xkwt0" }],
  ["path", { d: "m22 22-1.9-1.9", key: "1e5ubv" }]
]);
const ur = r("UserRoundXIcon", [
  ["path", { d: "M2 21a8 8 0 0 1 11.873-7", key: "74fkxq" }],
  ["circle", { cx: "10", cy: "8", r: "5", key: "o932ke" }],
  ["path", { d: "m17 17 5 5", key: "p7ous7" }],
  ["path", { d: "m22 17-5 5", key: "gqnmv0" }]
]);
const hr = r("UserRoundIcon", [
  ["circle", { cx: "12", cy: "8", r: "5", key: "1hypcn" }],
  ["path", { d: "M20 21a8 8 0 0 0-16 0", key: "rfgkzh" }]
]);
const vM = r("UserSearchIcon", [
  ["circle", { cx: "10", cy: "7", r: "4", key: "e45bow" }],
  ["path", { d: "M10.3 15H7a4 4 0 0 0-4 4v2", key: "3bnktk" }],
  ["circle", { cx: "17", cy: "17", r: "3", key: "18b49y" }],
  ["path", { d: "m21 21-1.9-1.9", key: "1g2n9r" }]
]);
const mM = r("UserXIcon", [
  ["path", { d: "M16 21v-2a4 4 0 0 0-4-4H6a4 4 0 0 0-4 4v2", key: "1yyitq" }],
  ["circle", { cx: "9", cy: "7", r: "4", key: "nufk8" }],
  ["line", { x1: "17", x2: "22", y1: "8", y2: "13", key: "3nzzx3" }],
  ["line", { x1: "22", x2: "17", y1: "8", y2: "13", key: "1swrse" }]
]);
const gM = r("UserIcon", [
  ["path", { d: "M19 21v-2a4 4 0 0 0-4-4H9a4 4 0 0 0-4 4v2", key: "975kel" }],
  ["circle", { cx: "12", cy: "7", r: "4", key: "17ys0d" }]
]);
const pr = r("UsersRoundIcon", [
  ["path", { d: "M18 21a8 8 0 0 0-16 0", key: "3ypg7q" }],
  ["circle", { cx: "10", cy: "8", r: "5", key: "o932ke" }],
  ["path", { d: "M22 20c0-3.37-2-6.5-4-8a5 5 0 0 0-.45-8.3", key: "10s06x" }]
]);
const MM = r("UsersIcon", [
  ["path", { d: "M16 21v-2a4 4 0 0 0-4-4H6a4 4 0 0 0-4 4v2", key: "1yyitq" }],
  ["circle", { cx: "9", cy: "7", r: "4", key: "nufk8" }],
  ["path", { d: "M22 21v-2a4 4 0 0 0-3-3.87", key: "kshegd" }],
  ["path", { d: "M16 3.13a4 4 0 0 1 0 7.75", key: "1da9ce" }]
]);
const xM = r("UtensilsCrossedIcon", [
  ["path", { d: "m16 2-2.3 2.3a3 3 0 0 0 0 4.2l1.8 1.8a3 3 0 0 0 4.2 0L22 8", key: "n7qcjb" }],
  [
    "path",
    { d: "M15 15 3.3 3.3a4.2 4.2 0 0 0 0 6l7.3 7.3c.7.7 2 .7 2.8 0L15 15Zm0 0 7 7", key: "d0u48b" }
  ],
  ["path", { d: "m2.1 21.8 6.4-6.3", key: "yn04lh" }],
  ["path", { d: "m19 5-7 7", key: "194lzd" }]
]);
const bM = r("UtensilsIcon", [
  ["path", { d: "M3 2v7c0 1.1.9 2 2 2h4a2 2 0 0 0 2-2V2", key: "cjf0a3" }],
  ["path", { d: "M7 2v20", key: "1473qp" }],
  ["path", { d: "M21 15V2v0a5 5 0 0 0-5 5v6c0 1.1.9 2 2 2h3Zm0 0v7", key: "1ogz0v" }]
]);
const wM = r("UtilityPoleIcon", [
  ["path", { d: "M12 2v20", key: "t6zp3m" }],
  ["path", { d: "M2 5h20", key: "1fs1ex" }],
  ["path", { d: "M3 3v2", key: "9imdir" }],
  ["path", { d: "M7 3v2", key: "n0os7" }],
  ["path", { d: "M17 3v2", key: "1l2re6" }],
  ["path", { d: "M21 3v2", key: "1duuac" }],
  ["path", { d: "m19 5-7 7-7-7", key: "133zxf" }]
]);
const IM = r("VariableIcon", [
  ["path", { d: "M8 21s-4-3-4-9 4-9 4-9", key: "uto9ud" }],
  ["path", { d: "M16 3s4 3 4 9-4 9-4 9", key: "4w2vsq" }],
  ["line", { x1: "15", x2: "9", y1: "9", y2: "15", key: "f7djnv" }],
  ["line", { x1: "9", x2: "15", y1: "9", y2: "15", key: "1shsy8" }]
]);
const LM = r("VaultIcon", [
  ["rect", { width: "18", height: "18", x: "3", y: "3", rx: "2", key: "afitv7" }],
  ["circle", { cx: "7.5", cy: "7.5", r: ".5", fill: "currentColor", key: "kqv944" }],
  ["path", { d: "m7.9 7.9 2.7 2.7", key: "hpeyl3" }],
  ["circle", { cx: "16.5", cy: "7.5", r: ".5", fill: "currentColor", key: "w0ekpg" }],
  ["path", { d: "m13.4 10.6 2.7-2.7", key: "264c1n" }],
  ["circle", { cx: "7.5", cy: "16.5", r: ".5", fill: "currentColor", key: "nkw3mc" }],
  ["path", { d: "m7.9 16.1 2.7-2.7", key: "p81g5e" }],
  ["circle", { cx: "16.5", cy: "16.5", r: ".5", fill: "currentColor", key: "fubopw" }],
  ["path", { d: "m13.4 13.4 2.7 2.7", key: "abhel3" }],
  ["circle", { cx: "12", cy: "12", r: "2", key: "1c9p78" }]
]);
const SM = r("VeganIcon", [
  ["path", { d: "M2 2a26.6 26.6 0 0 1 10 20c.9-6.82 1.5-9.5 4-14", key: "qiv7li" }],
  ["path", { d: "M16 8c4 0 6-2 6-6-4 0-6 2-6 6", key: "n7eohy" }],
  ["path", { d: "M17.41 3.6a10 10 0 1 0 3 3", key: "1dion0" }]
]);
const CM = r("VenetianMaskIcon", [
  [
    "path",
    {
      d: "M2 12a5 5 0 0 0 5 5 8 8 0 0 1 5 2 8 8 0 0 1 5-2 5 5 0 0 0 5-5V7h-5a8 8 0 0 0-5 2 8 8 0 0 0-5-2H2Z",
      key: "1g6z3j"
    }
  ],
  ["path", { d: "M6 11c1.5 0 3 .5 3 2-2 0-3 0-3-2Z", key: "c2lwnf" }],
  ["path", { d: "M18 11c-1.5 0-3 .5-3 2 2 0 3 0 3-2Z", key: "njd9zo" }]
]);
const AM = r("VibrateOffIcon", [
  ["path", { d: "m2 8 2 2-2 2 2 2-2 2", key: "sv1b1" }],
  ["path", { d: "m22 8-2 2 2 2-2 2 2 2", key: "101i4y" }],
  ["path", { d: "M8 8v10c0 .55.45 1 1 1h6c.55 0 1-.45 1-1v-2", key: "1hbad5" }],
  ["path", { d: "M16 10.34V6c0-.55-.45-1-1-1h-4.34", key: "1x5tf0" }],
  ["line", { x1: "2", x2: "22", y1: "2", y2: "22", key: "a6p6uj" }]
]);
const PM = r("VibrateIcon", [
  ["path", { d: "m2 8 2 2-2 2 2 2-2 2", key: "sv1b1" }],
  ["path", { d: "m22 8-2 2 2 2-2 2 2 2", key: "101i4y" }],
  ["rect", { width: "8", height: "14", x: "8", y: "5", rx: "1", key: "1oyrl4" }]
]);
const qM = r("VideoOffIcon", [
  ["path", { d: "M10.66 6H14a2 2 0 0 1 2 2v2.34l1 1L22 8v8", key: "ubwiq0" }],
  ["path", { d: "M16 16a2 2 0 0 1-2 2H4a2 2 0 0 1-2-2V8a2 2 0 0 1 2-2h2l10 10Z", key: "1l10zd" }],
  ["line", { x1: "2", x2: "22", y1: "2", y2: "22", key: "a6p6uj" }]
]);
const TM = r("VideoIcon", [
  ["path", { d: "m22 8-6 4 6 4V8Z", key: "50v9me" }],
  ["rect", { width: "14", height: "12", x: "2", y: "6", rx: "2", ry: "2", key: "1rqjg6" }]
]);
const DM = r("VideotapeIcon", [
  ["rect", { width: "20", height: "16", x: "2", y: "4", rx: "2", key: "18n3k1" }],
  ["path", { d: "M2 8h20", key: "d11cs7" }],
  ["circle", { cx: "8", cy: "14", r: "2", key: "1k2qr5" }],
  ["path", { d: "M8 12h8", key: "1wcyev" }],
  ["circle", { cx: "16", cy: "14", r: "2", key: "14k7lr" }]
]);
const _M = r("ViewIcon", [
  [
    "path",
    { d: "M5 12s2.545-5 7-5c4.454 0 7 5 7 5s-2.546 5-7 5c-4.455 0-7-5-7-5z", key: "vptub8" }
  ],
  ["path", { d: "M12 13a1 1 0 1 0 0-2 1 1 0 0 0 0 2z", key: "10lhjs" }],
  ["path", { d: "M21 17v2a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2v-2", key: "mrq65r" }],
  ["path", { d: "M21 7V5a2 2 0 0 0-2-2H5a2 2 0 0 0-2 2v2", key: "be3xqs" }]
]);
const BM = r("VoicemailIcon", [
  ["circle", { cx: "6", cy: "12", r: "4", key: "1ehtga" }],
  ["circle", { cx: "18", cy: "12", r: "4", key: "4vafl8" }],
  ["line", { x1: "6", x2: "18", y1: "16", y2: "16", key: "pmt8us" }]
]);
const zM = r("Volume1Icon", [
  ["polygon", { points: "11 5 6 9 2 9 2 15 6 15 11 19 11 5", key: "16drj5" }],
  ["path", { d: "M15.54 8.46a5 5 0 0 1 0 7.07", key: "ltjumu" }]
]);
const HM = r("Volume2Icon", [
  ["polygon", { points: "11 5 6 9 2 9 2 15 6 15 11 19 11 5", key: "16drj5" }],
  ["path", { d: "M15.54 8.46a5 5 0 0 1 0 7.07", key: "ltjumu" }],
  ["path", { d: "M19.07 4.93a10 10 0 0 1 0 14.14", key: "1kegas" }]
]);
const jM = r("VolumeXIcon", [
  ["polygon", { points: "11 5 6 9 2 9 2 15 6 15 11 19 11 5", key: "16drj5" }],
  ["line", { x1: "22", x2: "16", y1: "9", y2: "15", key: "1ewh16" }],
  ["line", { x1: "16", x2: "22", y1: "9", y2: "15", key: "5ykzw1" }]
]);
const VM = r("VolumeIcon", [
  ["polygon", { points: "11 5 6 9 2 9 2 15 6 15 11 19 11 5", key: "16drj5" }]
]);
const OM = r("VoteIcon", [
  ["path", { d: "m9 12 2 2 4-4", key: "dzmm74" }],
  ["path", { d: "M5 7c0-1.1.9-2 2-2h10a2 2 0 0 1 2 2v12H5V7Z", key: "1ezoue" }],
  ["path", { d: "M22 19H2", key: "nuriw5" }]
]);
const $M = r("WalletCardsIcon", [
  ["rect", { width: "18", height: "18", x: "3", y: "3", rx: "2", key: "afitv7" }],
  ["path", { d: "M3 9a2 2 0 0 1 2-2h14a2 2 0 0 1 2 2", key: "4125el" }],
  [
    "path",
    {
      d: "M3 11h3c.8 0 1.6.3 2.1.9l1.1.9c1.6 1.6 4.1 1.6 5.7 0l1.1-.9c.5-.5 1.3-.9 2.1-.9H21",
      key: "1dpki6"
    }
  ]
]);
const yr = r("WalletMinimalIcon", [
  ["path", { d: "M17 14h.01", key: "7oqj8z" }],
  [
    "path",
    {
      d: "M7 7h12a2 2 0 0 1 2 2v10a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2V5a2 2 0 0 1 2-2h14",
      key: "u1rqew"
    }
  ]
]);
const RM = r("WalletIcon", [
  [
    "path",
    {
      d: "M19 7V4a1 1 0 0 0-1-1H5a2 2 0 0 0 0 4h15a1 1 0 0 1 1 1v4h-3a2 2 0 0 0 0 4h3a1 1 0 0 0 1-1v-2a1 1 0 0 0-1-1",
      key: "18etb6"
    }
  ],
  ["path", { d: "M3 5v14a2 2 0 0 0 2 2h15a1 1 0 0 0 1-1v-4", key: "xoc0q4" }]
]);
const FM = r("WallpaperIcon", [
  ["circle", { cx: "8", cy: "9", r: "2", key: "gjzl9d" }],
  [
    "path",
    {
      d: "m9 17 6.1-6.1a2 2 0 0 1 2.81.01L22 15V5a2 2 0 0 0-2-2H4a2 2 0 0 0-2 2v10a2 2 0 0 0 2 2h16a2 2 0 0 0 2-2",
      key: "69xh40"
    }
  ],
  ["path", { d: "M8 21h8", key: "1ev6f3" }],
  ["path", { d: "M12 17v4", key: "1riwvh" }]
]);
const kr = r("WandSparklesIcon", [
  [
    "path",
    {
      d: "m21.64 3.64-1.28-1.28a1.21 1.21 0 0 0-1.72 0L2.36 18.64a1.21 1.21 0 0 0 0 1.72l1.28 1.28a1.2 1.2 0 0 0 1.72 0L21.64 5.36a1.2 1.2 0 0 0 0-1.72",
      key: "ul74o6"
    }
  ],
  ["path", { d: "m14 7 3 3", key: "1r5n42" }],
  ["path", { d: "M5 6v4", key: "ilb8ba" }],
  ["path", { d: "M19 14v4", key: "blhpug" }],
  ["path", { d: "M10 2v2", key: "7u0qdc" }],
  ["path", { d: "M7 8H3", key: "zfb6yr" }],
  ["path", { d: "M21 16h-4", key: "1cnmox" }],
  ["path", { d: "M11 3H9", key: "1obp7u" }]
]);
const UM = r("WandIcon", [
  ["path", { d: "M15 4V2", key: "z1p9b7" }],
  ["path", { d: "M15 16v-2", key: "px0unx" }],
  ["path", { d: "M8 9h2", key: "1g203m" }],
  ["path", { d: "M20 9h2", key: "19tzq7" }],
  ["path", { d: "M17.8 11.8 19 13", key: "yihg8r" }],
  ["path", { d: "M15 9h0", key: "kg5t1u" }],
  ["path", { d: "M17.8 6.2 19 5", key: "fd4us0" }],
  ["path", { d: "m3 21 9-9", key: "1jfql5" }],
  ["path", { d: "M12.2 6.2 11 5", key: "i3da3b" }]
]);
const EM = r("WarehouseIcon", [
  [
    "path",
    {
      d: "M22 8.35V20a2 2 0 0 1-2 2H4a2 2 0 0 1-2-2V8.35A2 2 0 0 1 3.26 6.5l8-3.2a2 2 0 0 1 1.48 0l8 3.2A2 2 0 0 1 22 8.35Z",
      key: "gksnxg"
    }
  ],
  ["path", { d: "M6 18h12", key: "9pbo8z" }],
  ["path", { d: "M6 14h12", key: "4cwo0f" }],
  ["rect", { width: "12", height: "12", x: "6", y: "10", key: "apd30q" }]
]);
const WM = r("WashingMachineIcon", [
  ["path", { d: "M3 6h3", key: "155dbl" }],
  ["path", { d: "M17 6h.01", key: "e2y6kg" }],
  ["rect", { width: "18", height: "20", x: "3", y: "2", rx: "2", key: "od3kk9" }],
  ["circle", { cx: "12", cy: "13", r: "5", key: "nlbqau" }],
  ["path", { d: "M12 18a2.5 2.5 0 0 0 0-5 2.5 2.5 0 0 1 0-5", key: "17lach" }]
]);
const NM = r("WatchIcon", [
  ["circle", { cx: "12", cy: "12", r: "6", key: "1vlfrh" }],
  ["polyline", { points: "12 10 12 12 13 13", key: "19dquz" }],
  [
    "path",
    { d: "m16.13 7.66-.81-4.05a2 2 0 0 0-2-1.61h-2.68a2 2 0 0 0-2 1.61l-.78 4.05", key: "18k57s" }
  ],
  ["path", { d: "m7.88 16.36.8 4a2 2 0 0 0 2 1.61h2.72a2 2 0 0 0 2-1.61l.81-4.05", key: "16ny36" }]
]);
const ZM = r("WavesIcon", [
  [
    "path",
    {
      d: "M2 6c.6.5 1.2 1 2.5 1C7 7 7 5 9.5 5c2.6 0 2.4 2 5 2 2.5 0 2.5-2 5-2 1.3 0 1.9.5 2.5 1",
      key: "knzxuh"
    }
  ],
  [
    "path",
    {
      d: "M2 12c.6.5 1.2 1 2.5 1 2.5 0 2.5-2 5-2 2.6 0 2.4 2 5 2 2.5 0 2.5-2 5-2 1.3 0 1.9.5 2.5 1",
      key: "2jd2cc"
    }
  ],
  [
    "path",
    {
      d: "M2 18c.6.5 1.2 1 2.5 1 2.5 0 2.5-2 5-2 2.6 0 2.4 2 5 2 2.5 0 2.5-2 5-2 1.3 0 1.9.5 2.5 1",
      key: "rd2r6e"
    }
  ]
]);
const YM = r("WaypointsIcon", [
  ["circle", { cx: "12", cy: "4.5", r: "2.5", key: "r5ysbb" }],
  ["path", { d: "m10.2 6.3-3.9 3.9", key: "1nzqf6" }],
  ["circle", { cx: "4.5", cy: "12", r: "2.5", key: "jydg6v" }],
  ["path", { d: "M7 12h10", key: "b7w52i" }],
  ["circle", { cx: "19.5", cy: "12", r: "2.5", key: "1piiel" }],
  ["path", { d: "m13.8 17.7 3.9-3.9", key: "1wyg1y" }],
  ["circle", { cx: "12", cy: "19.5", r: "2.5", key: "13o1pw" }]
]);
const GM = r("WebcamIcon", [
  ["circle", { cx: "12", cy: "10", r: "8", key: "1gshiw" }],
  ["circle", { cx: "12", cy: "10", r: "3", key: "ilqhr7" }],
  ["path", { d: "M7 22h10", key: "10w4w3" }],
  ["path", { d: "M12 22v-4", key: "1utk9m" }]
]);
const XM = r("WebhookOffIcon", [
  ["path", { d: "M17 17h-5c-1.09-.02-1.94.92-2.5 1.9A3 3 0 1 1 2.57 15", key: "1tvl6x" }],
  ["path", { d: "M9 3.4a4 4 0 0 1 6.52.66", key: "q04jfq" }],
  ["path", { d: "m6 17 3.1-5.8a2.5 2.5 0 0 0 .057-2.05", key: "azowf0" }],
  ["path", { d: "M20.3 20.3a4 4 0 0 1-2.3.7", key: "5joiws" }],
  ["path", { d: "M18.6 13a4 4 0 0 1 3.357 3.414", key: "cangb8" }],
  ["path", { d: "m12 6 .6 1", key: "tpjl1n" }],
  ["path", { d: "m2 2 20 20", key: "1ooewy" }]
]);
const KM = r("WebhookIcon", [
  [
    "path",
    {
      d: "M18 16.98h-5.99c-1.1 0-1.95.94-2.48 1.9A4 4 0 0 1 2 17c.01-.7.2-1.4.57-2",
      key: "q3hayz"
    }
  ],
  ["path", { d: "m6 17 3.13-5.78c.53-.97.1-2.18-.5-3.1a4 4 0 1 1 6.89-4.06", key: "1go1hn" }],
  ["path", { d: "m12 6 3.13 5.73C15.66 12.7 16.9 13 18 13a4 4 0 0 1 0 8", key: "qlwsc0" }]
]);
const QM = r("WeightIcon", [
  ["circle", { cx: "12", cy: "5", r: "3", key: "rqqgnr" }],
  [
    "path",
    {
      d: "M6.5 8a2 2 0 0 0-1.905 1.46L2.1 18.5A2 2 0 0 0 4 21h16a2 2 0 0 0 1.925-2.54L19.4 9.5A2 2 0 0 0 17.48 8Z",
      key: "56o5sh"
    }
  ]
]);
const JM = r("WheatOffIcon", [
  ["path", { d: "m2 22 10-10", key: "28ilpk" }],
  ["path", { d: "m16 8-1.17 1.17", key: "1qqm82" }],
  [
    "path",
    {
      d: "M3.47 12.53 5 11l1.53 1.53a3.5 3.5 0 0 1 0 4.94L5 19l-1.53-1.53a3.5 3.5 0 0 1 0-4.94Z",
      key: "1rdhi6"
    }
  ],
  [
    "path",
    { d: "m8 8-.53.53a3.5 3.5 0 0 0 0 4.94L9 15l1.53-1.53c.55-.55.88-1.25.98-1.97", key: "4wz8re" }
  ],
  [
    "path",
    { d: "M10.91 5.26c.15-.26.34-.51.56-.73L13 3l1.53 1.53a3.5 3.5 0 0 1 .28 4.62", key: "rves66" }
  ],
  ["path", { d: "M20 2h2v2a4 4 0 0 1-4 4h-2V6a4 4 0 0 1 4-4Z", key: "19rau1" }],
  [
    "path",
    {
      d: "M11.47 17.47 13 19l-1.53 1.53a3.5 3.5 0 0 1-4.94 0L5 19l1.53-1.53a3.5 3.5 0 0 1 4.94 0Z",
      key: "tc8ph9"
    }
  ],
  [
    "path",
    {
      d: "m16 16-.53.53a3.5 3.5 0 0 1-4.94 0L9 15l1.53-1.53a3.49 3.49 0 0 1 1.97-.98",
      key: "ak46r"
    }
  ],
  [
    "path",
    {
      d: "M18.74 13.09c.26-.15.51-.34.73-.56L21 11l-1.53-1.53a3.5 3.5 0 0 0-4.62-.28",
      key: "1tw520"
    }
  ],
  ["line", { x1: "2", x2: "22", y1: "2", y2: "22", key: "a6p6uj" }]
]);
const ex = r("WheatIcon", [
  ["path", { d: "M2 22 16 8", key: "60hf96" }],
  [
    "path",
    {
      d: "M3.47 12.53 5 11l1.53 1.53a3.5 3.5 0 0 1 0 4.94L5 19l-1.53-1.53a3.5 3.5 0 0 1 0-4.94Z",
      key: "1rdhi6"
    }
  ],
  [
    "path",
    {
      d: "M7.47 8.53 9 7l1.53 1.53a3.5 3.5 0 0 1 0 4.94L9 15l-1.53-1.53a3.5 3.5 0 0 1 0-4.94Z",
      key: "1sdzmb"
    }
  ],
  [
    "path",
    {
      d: "M11.47 4.53 13 3l1.53 1.53a3.5 3.5 0 0 1 0 4.94L13 11l-1.53-1.53a3.5 3.5 0 0 1 0-4.94Z",
      key: "eoatbi"
    }
  ],
  ["path", { d: "M20 2h2v2a4 4 0 0 1-4 4h-2V6a4 4 0 0 1 4-4Z", key: "19rau1" }],
  [
    "path",
    {
      d: "M11.47 17.47 13 19l-1.53 1.53a3.5 3.5 0 0 1-4.94 0L5 19l1.53-1.53a3.5 3.5 0 0 1 4.94 0Z",
      key: "tc8ph9"
    }
  ],
  [
    "path",
    {
      d: "M15.47 13.47 17 15l-1.53 1.53a3.5 3.5 0 0 1-4.94 0L9 15l1.53-1.53a3.5 3.5 0 0 1 4.94 0Z",
      key: "2m8kc5"
    }
  ],
  [
    "path",
    {
      d: "M19.47 9.47 21 11l-1.53 1.53a3.5 3.5 0 0 1-4.94 0L13 11l1.53-1.53a3.5 3.5 0 0 1 4.94 0Z",
      key: "vex3ng"
    }
  ]
]);
const tx = r("WholeWordIcon", [
  ["circle", { cx: "7", cy: "12", r: "3", key: "12clwm" }],
  ["path", { d: "M10 9v6", key: "17i7lo" }],
  ["circle", { cx: "17", cy: "12", r: "3", key: "gl7c2s" }],
  ["path", { d: "M14 7v8", key: "dl84cr" }],
  ["path", { d: "M22 17v1c0 .5-.5 1-1 1H3c-.5 0-1-.5-1-1v-1", key: "lt2kga" }]
]);
const ax = r("WifiOffIcon", [
  ["path", { d: "M12 20h.01", key: "zekei9" }],
  ["path", { d: "M8.5 16.429a5 5 0 0 1 7 0", key: "1bycff" }],
  ["path", { d: "M5 12.859a10 10 0 0 1 5.17-2.69", key: "1dl1wf" }],
  ["path", { d: "M19 12.859a10 10 0 0 0-2.007-1.523", key: "4k23kn" }],
  ["path", { d: "M2 8.82a15 15 0 0 1 4.177-2.643", key: "1grhjp" }],
  ["path", { d: "M22 8.82a15 15 0 0 0-11.288-3.764", key: "z3jwby" }],
  ["path", { d: "m2 2 20 20", key: "1ooewy" }]
]);
const nx = r("WifiIcon", [
  ["path", { d: "M12 20h.01", key: "zekei9" }],
  ["path", { d: "M2 8.82a15 15 0 0 1 20 0", key: "dnpr2z" }],
  ["path", { d: "M5 12.859a10 10 0 0 1 14 0", key: "1x1e6c" }],
  ["path", { d: "M8.5 16.429a5 5 0 0 1 7 0", key: "1bycff" }]
]);
const ox = r("WindIcon", [
  ["path", { d: "M17.7 7.7a2.5 2.5 0 1 1 1.8 4.3H2", key: "1k4u03" }],
  ["path", { d: "M9.6 4.6A2 2 0 1 1 11 8H2", key: "b7d0fd" }],
  ["path", { d: "M12.6 19.4A2 2 0 1 0 14 16H2", key: "1p5cb3" }]
]);
const rx = r("WineOffIcon", [
  ["path", { d: "M8 22h8", key: "rmew8v" }],
  ["path", { d: "M7 10h3m7 0h-1.343", key: "v48bem" }],
  ["path", { d: "M12 15v7", key: "t2xh3l" }],
  [
    "path",
    {
      d: "M7.307 7.307A12.33 12.33 0 0 0 7 10a5 5 0 0 0 7.391 4.391M8.638 2.981C8.75 2.668 8.872 2.34 9 2h6c1.5 4 2 6 2 8 0 .407-.05.809-.145 1.198",
      key: "1ymjlu"
    }
  ],
  ["line", { x1: "2", x2: "22", y1: "2", y2: "22", key: "a6p6uj" }]
]);
const ix = r("WineIcon", [
  ["path", { d: "M8 22h8", key: "rmew8v" }],
  ["path", { d: "M7 10h10", key: "1101jm" }],
  ["path", { d: "M12 15v7", key: "t2xh3l" }],
  [
    "path",
    { d: "M12 15a5 5 0 0 0 5-5c0-2-.5-4-2-8H9c-1.5 4-2 6-2 8a5 5 0 0 0 5 5Z", key: "10ffi3" }
  ]
]);
const lx = r("WorkflowIcon", [
  ["rect", { width: "8", height: "8", x: "3", y: "3", rx: "2", key: "by2w9f" }],
  ["path", { d: "M7 11v4a2 2 0 0 0 2 2h4", key: "xkn7yn" }],
  ["rect", { width: "8", height: "8", x: "13", y: "13", rx: "2", key: "1cgmvn" }]
]);
const cx = r("WormIcon", [
  ["path", { d: "m19 12-1.5 3", key: "9bcu4o" }],
  ["path", { d: "M19.63 18.81 22 20", key: "121v98" }],
  [
    "path",
    {
      d: "M6.47 8.23a1.68 1.68 0 0 1 2.44 1.93l-.64 2.08a6.76 6.76 0 0 0 10.16 7.67l.42-.27a1 1 0 1 0-2.73-4.21l-.42.27a1.76 1.76 0 0 1-2.63-1.99l.64-2.08A6.66 6.66 0 0 0 3.94 3.9l-.7.4a1 1 0 1 0 2.55 4.34z",
      key: "1tij6q"
    }
  ]
]);
const dx = r("WrapTextIcon", [
  ["line", { x1: "3", x2: "21", y1: "6", y2: "6", key: "4m8b97" }],
  ["path", { d: "M3 12h15a3 3 0 1 1 0 6h-4", key: "1cl7v7" }],
  ["polyline", { points: "16 16 14 18 16 20", key: "1jznyi" }],
  ["line", { x1: "3", x2: "10", y1: "18", y2: "18", key: "1h33wv" }]
]);
const sx = r("WrenchIcon", [
  [
    "path",
    {
      d: "M14.7 6.3a1 1 0 0 0 0 1.4l1.6 1.6a1 1 0 0 0 1.4 0l3.77-3.77a6 6 0 0 1-7.94 7.94l-6.91 6.91a2.12 2.12 0 0 1-3-3l6.91-6.91a6 6 0 0 1 7.94-7.94l-3.76 3.76z",
      key: "cbrjhi"
    }
  ]
]);
const ux = r("XIcon", [
  ["path", { d: "M18 6 6 18", key: "1bl5f8" }],
  ["path", { d: "m6 6 12 12", key: "d8bk6v" }]
]);
const hx = r("YoutubeIcon", [
  [
    "path",
    {
      d: "M2.5 17a24.12 24.12 0 0 1 0-10 2 2 0 0 1 1.4-1.4 49.56 49.56 0 0 1 16.2 0A2 2 0 0 1 21.5 7a24.12 24.12 0 0 1 0 10 2 2 0 0 1-1.4 1.4 49.55 49.55 0 0 1-16.2 0A2 2 0 0 1 2.5 17",
      key: "1q2vi4"
    }
  ],
  ["path", { d: "m10 15 5-3-5-3z", key: "1jp15x" }]
]);
const px = r("ZapOffIcon", [
  ["path", { d: "M10.513 4.856 13.12 2.17a.5.5 0 0 1 .86.46l-1.377 4.317", key: "193nxd" }],
  ["path", { d: "M15.656 10H20a1 1 0 0 1 .78 1.63l-1.72 1.773", key: "27a7lr" }],
  [
    "path",
    {
      d: "M16.273 16.273 10.88 21.83a.5.5 0 0 1-.86-.46l1.92-6.02A1 1 0 0 0 11 14H4a1 1 0 0 1-.78-1.63l4.507-4.643",
      key: "1e0qe9"
    }
  ],
  ["path", { d: "m2 2 20 20", key: "1ooewy" }]
]);
const yx = r("ZapIcon", [
  [
    "path",
    {
      d: "M4 14a1 1 0 0 1-.78-1.63l9.9-10.2a.5.5 0 0 1 .86.46l-1.92 6.02A1 1 0 0 0 13 10h7a1 1 0 0 1 .78 1.63l-9.9 10.2a.5.5 0 0 1-.86-.46l1.92-6.02A1 1 0 0 0 11 14z",
      key: "1xq2db"
    }
  ]
]);
const kx = r("ZoomInIcon", [
  ["circle", { cx: "11", cy: "11", r: "8", key: "4ej97u" }],
  ["line", { x1: "21", x2: "16.65", y1: "21", y2: "16.65", key: "13gj7c" }],
  ["line", { x1: "11", x2: "11", y1: "8", y2: "14", key: "1vmskp" }],
  ["line", { x1: "8", x2: "14", y1: "11", y2: "11", key: "durymu" }]
]);
const fx = r("ZoomOutIcon", [
  ["circle", { cx: "11", cy: "11", r: "8", key: "4ej97u" }],
  ["line", { x1: "21", x2: "16.65", y1: "21", y2: "16.65", key: "13gj7c" }],
  ["line", { x1: "8", x2: "14", y1: "11", y2: "11", key: "durymu" }]
]);
const oS = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  AArrowDown: T1,
  AArrowUp: D1,
  ALargeSmall: _1,
  Accessibility: B1,
  Activity: z1,
  AirVent: H1,
  Airplay: j1,
  AlarmClock: O1,
  AlarmClockCheck: da,
  AlarmClockMinus: sa,
  AlarmClockOff: V1,
  AlarmClockPlus: ua,
  AlarmSmoke: $1,
  Album: R1,
  AlignCenter: E1,
  AlignCenterHorizontal: F1,
  AlignCenterVertical: U1,
  AlignEndHorizontal: W1,
  AlignEndVertical: N1,
  AlignHorizontalDistributeCenter: Z1,
  AlignHorizontalDistributeEnd: Y1,
  AlignHorizontalDistributeStart: G1,
  AlignHorizontalJustifyCenter: X1,
  AlignHorizontalJustifyEnd: K1,
  AlignHorizontalJustifyStart: Q1,
  AlignHorizontalSpaceAround: J1,
  AlignHorizontalSpaceBetween: ei,
  AlignJustify: ti,
  AlignLeft: ai,
  AlignRight: ni,
  AlignStartHorizontal: oi,
  AlignStartVertical: ri,
  AlignVerticalDistributeCenter: ii,
  AlignVerticalDistributeEnd: li,
  AlignVerticalDistributeStart: ci,
  AlignVerticalJustifyCenter: di,
  AlignVerticalJustifyEnd: si,
  AlignVerticalJustifyStart: ui,
  AlignVerticalSpaceAround: hi,
  AlignVerticalSpaceBetween: pi,
  Ambulance: yi,
  Ampersand: ki,
  Ampersands: fi,
  Anchor: vi,
  Angry: mi,
  Annoyed: gi,
  Antenna: Mi,
  Anvil: xi,
  Aperture: bi,
  AppWindow: Ii,
  AppWindowMac: wi,
  Apple: Li,
  Archive: Ai,
  ArchiveRestore: Si,
  ArchiveX: Ci,
  AreaChart: Pi,
  Armchair: qi,
  ArrowBigDown: Di,
  ArrowBigDownDash: Ti,
  ArrowBigLeft: Bi,
  ArrowBigLeftDash: _i,
  ArrowBigRight: Hi,
  ArrowBigRightDash: zi,
  ArrowBigUp: Vi,
  ArrowBigUpDash: ji,
  ArrowDown: Yi,
  ArrowDown01: Oi,
  ArrowDown10: $i,
  ArrowDownAZ: ha,
  ArrowDownFromLine: Ri,
  ArrowDownLeft: Fi,
  ArrowDownNarrowWide: Ui,
  ArrowDownRight: Ei,
  ArrowDownToDot: Wi,
  ArrowDownToLine: Ni,
  ArrowDownUp: Zi,
  ArrowDownWideNarrow: pa,
  ArrowDownZA: ya,
  ArrowLeft: Qi,
  ArrowLeftFromLine: Gi,
  ArrowLeftRight: Xi,
  ArrowLeftToLine: Ki,
  ArrowRight: al,
  ArrowRightFromLine: Ji,
  ArrowRightLeft: el,
  ArrowRightToLine: tl,
  ArrowUp: hl,
  ArrowUp01: nl,
  ArrowUp10: ol,
  ArrowUpAZ: ka,
  ArrowUpDown: rl,
  ArrowUpFromDot: il,
  ArrowUpFromLine: ll,
  ArrowUpLeft: cl,
  ArrowUpNarrowWide: fa,
  ArrowUpRight: dl,
  ArrowUpToLine: sl,
  ArrowUpWideNarrow: ul,
  ArrowUpZA: va,
  ArrowsUpFromLine: pl,
  Asterisk: yl,
  AtSign: kl,
  Atom: fl,
  AudioLines: vl,
  AudioWaveform: ml,
  Award: gl,
  Axe: Ml,
  Axis3d: ma,
  Baby: xl,
  Backpack: bl,
  Badge: Vl,
  BadgeAlert: wl,
  BadgeCent: Il,
  BadgeCheck: ga,
  BadgeDollarSign: Ll,
  BadgeEuro: Sl,
  BadgeHelp: Cl,
  BadgeIndianRupee: Al,
  BadgeInfo: Pl,
  BadgeJapaneseYen: ql,
  BadgeMinus: Tl,
  BadgePercent: Dl,
  BadgePlus: _l,
  BadgePoundSterling: Bl,
  BadgeRussianRuble: zl,
  BadgeSwissFranc: Hl,
  BadgeX: jl,
  BaggageClaim: Ol,
  Ban: $l,
  Banana: Rl,
  Banknote: Fl,
  BarChart: Gl,
  BarChart2: Ul,
  BarChart3: El,
  BarChart4: Wl,
  BarChartBig: Nl,
  BarChartHorizontal: Yl,
  BarChartHorizontalBig: Zl,
  Barcode: Xl,
  Baseline: Kl,
  Bath: Ql,
  Battery: oc,
  BatteryCharging: Jl,
  BatteryFull: ec,
  BatteryLow: tc,
  BatteryMedium: ac,
  BatteryWarning: nc,
  Beaker: rc,
  Bean: lc,
  BeanOff: ic,
  Bed: sc,
  BedDouble: cc,
  BedSingle: dc,
  Beef: uc,
  Beer: pc,
  BeerOff: hc,
  Bell: Mc,
  BellDot: yc,
  BellElectric: kc,
  BellMinus: fc,
  BellOff: vc,
  BellPlus: mc,
  BellRing: gc,
  BetweenHorizontalEnd: Ma,
  BetweenHorizontalStart: xa,
  BetweenVerticalEnd: xc,
  BetweenVerticalStart: bc,
  Bike: wc,
  Binary: Ic,
  Biohazard: Lc,
  Bird: Sc,
  Bitcoin: Cc,
  Blend: Ac,
  Blinds: Pc,
  Blocks: qc,
  Bluetooth: Bc,
  BluetoothConnected: Tc,
  BluetoothOff: Dc,
  BluetoothSearching: _c,
  Bold: zc,
  Bolt: Hc,
  Bomb: jc,
  Bone: Vc,
  Book: l2,
  BookA: Oc,
  BookAudio: $c,
  BookCheck: Rc,
  BookCopy: Fc,
  BookDashed: ba,
  BookDown: Uc,
  BookHeadphones: Ec,
  BookHeart: Wc,
  BookImage: Nc,
  BookKey: Zc,
  BookLock: Yc,
  BookMarked: Gc,
  BookMinus: Xc,
  BookOpen: Jc,
  BookOpenCheck: Kc,
  BookOpenText: Qc,
  BookPlus: e2,
  BookText: t2,
  BookType: a2,
  BookUp: o2,
  BookUp2: n2,
  BookUser: r2,
  BookX: i2,
  Bookmark: h2,
  BookmarkCheck: c2,
  BookmarkMinus: d2,
  BookmarkPlus: s2,
  BookmarkX: u2,
  BoomBox: p2,
  Bot: k2,
  BotMessageSquare: y2,
  Box: v2,
  BoxSelect: f2,
  Boxes: m2,
  Braces: wa,
  Brackets: g2,
  Brain: b2,
  BrainCircuit: M2,
  BrainCog: x2,
  BrickWall: w2,
  Briefcase: S2,
  BriefcaseBusiness: I2,
  BriefcaseMedical: L2,
  BringToFront: C2,
  Brush: A2,
  Bug: T2,
  BugOff: P2,
  BugPlay: q2,
  Building: _2,
  Building2: D2,
  Bus: z2,
  BusFront: B2,
  Cable: j2,
  CableCar: H2,
  Cake: O2,
  CakeSlice: V2,
  Calculator: $2,
  Calendar: ad,
  CalendarCheck: F2,
  CalendarCheck2: R2,
  CalendarClock: U2,
  CalendarDays: E2,
  CalendarFold: W2,
  CalendarHeart: N2,
  CalendarMinus: Y2,
  CalendarMinus2: Z2,
  CalendarOff: G2,
  CalendarPlus: K2,
  CalendarPlus2: X2,
  CalendarRange: Q2,
  CalendarSearch: J2,
  CalendarX: td,
  CalendarX2: ed,
  Camera: od,
  CameraOff: nd,
  CandlestickChart: rd,
  Candy: cd,
  CandyCane: id,
  CandyOff: ld,
  Cannabis: dd,
  Captions: Ia,
  CaptionsOff: sd,
  Car: pd,
  CarFront: ud,
  CarTaxiFront: hd,
  Caravan: yd,
  Carrot: kd,
  CaseLower: fd,
  CaseSensitive: vd,
  CaseUpper: md,
  CassetteTape: gd,
  Cast: Md,
  Castle: xd,
  Cat: bd,
  Cctv: wd,
  Check: Ld,
  CheckCheck: Id,
  ChefHat: Sd,
  Cherry: Cd,
  ChevronDown: Ad,
  ChevronFirst: Pd,
  ChevronLast: qd,
  ChevronLeft: Td,
  ChevronRight: Dd,
  ChevronUp: _d,
  ChevronsDown: zd,
  ChevronsDownUp: Bd,
  ChevronsLeft: jd,
  ChevronsLeftRight: Hd,
  ChevronsRight: Od,
  ChevronsRightLeft: Vd,
  ChevronsUp: Rd,
  ChevronsUpDown: $d,
  Chrome: Fd,
  Church: Ud,
  Cigarette: Wd,
  CigaretteOff: Ed,
  Circle: ts,
  CircleAlert: La,
  CircleArrowDown: Sa,
  CircleArrowLeft: Ca,
  CircleArrowOutDownLeft: Aa,
  CircleArrowOutDownRight: Pa,
  CircleArrowOutUpLeft: qa,
  CircleArrowOutUpRight: Ta,
  CircleArrowRight: Da,
  CircleArrowUp: _a,
  CircleCheck: za,
  CircleCheckBig: Ba,
  CircleChevronDown: Ha,
  CircleChevronLeft: ja,
  CircleChevronRight: Va,
  CircleChevronUp: Oa,
  CircleDashed: Nd,
  CircleDivide: $a,
  CircleDollarSign: Zd,
  CircleDot: Gd,
  CircleDotDashed: Yd,
  CircleEllipsis: Xd,
  CircleEqual: Kd,
  CircleFadingPlus: Qd,
  CircleGauge: Ra,
  CircleHelp: Fa,
  CircleMinus: Ua,
  CircleOff: Jd,
  CircleParking: Wa,
  CircleParkingOff: Ea,
  CirclePause: Na,
  CirclePercent: Za,
  CirclePlay: Ya,
  CirclePlus: Ga,
  CirclePower: Xa,
  CircleSlash: es,
  CircleSlash2: Ka,
  CircleStop: Qa,
  CircleUser: en,
  CircleUserRound: Ja,
  CircleX: tn,
  CircuitBoard: as,
  Citrus: ns,
  Clapperboard: os,
  Clipboard: ps,
  ClipboardCheck: rs,
  ClipboardCopy: is,
  ClipboardList: ls,
  ClipboardMinus: cs,
  ClipboardPaste: ds,
  ClipboardPen: nn,
  ClipboardPenLine: an,
  ClipboardPlus: ss,
  ClipboardType: us,
  ClipboardX: hs,
  Clock: Ss,
  Clock1: ys,
  Clock10: ks,
  Clock11: fs,
  Clock12: vs,
  Clock2: ms,
  Clock3: gs,
  Clock4: Ms,
  Clock5: xs,
  Clock6: bs,
  Clock7: ws,
  Clock8: Is,
  Clock9: Ls,
  Cloud: $s,
  CloudCog: Cs,
  CloudDownload: on,
  CloudDrizzle: As,
  CloudFog: Ps,
  CloudHail: qs,
  CloudLightning: Ts,
  CloudMoon: _s,
  CloudMoonRain: Ds,
  CloudOff: Bs,
  CloudRain: Hs,
  CloudRainWind: zs,
  CloudSnow: js,
  CloudSun: Os,
  CloudSunRain: Vs,
  CloudUpload: rn,
  Cloudy: Rs,
  Clover: Fs,
  Club: Us,
  Code: Es,
  CodeXml: ln,
  Codepen: Ws,
  Codesandbox: Ns,
  Coffee: Zs,
  Cog: Ys,
  Coins: Gs,
  Columns2: cn,
  Columns3: dn,
  Columns4: Xs,
  Combine: Ks,
  Command: Qs,
  Compass: Js,
  Component: e0,
  Computer: t0,
  ConciergeBell: a0,
  Cone: n0,
  Construction: o0,
  Contact: r0,
  ContactRound: sn,
  Container: i0,
  Contrast: l0,
  Cookie: c0,
  CookingPot: d0,
  Copy: k0,
  CopyCheck: s0,
  CopyMinus: u0,
  CopyPlus: h0,
  CopySlash: p0,
  CopyX: y0,
  Copyleft: f0,
  Copyright: v0,
  CornerDownLeft: m0,
  CornerDownRight: g0,
  CornerLeftDown: M0,
  CornerLeftUp: x0,
  CornerRightDown: b0,
  CornerRightUp: w0,
  CornerUpLeft: I0,
  CornerUpRight: L0,
  Cpu: S0,
  CreativeCommons: C0,
  CreditCard: A0,
  Croissant: P0,
  Crop: q0,
  Cross: T0,
  Crosshair: D0,
  Crown: _0,
  Cuboid: B0,
  CupSoda: z0,
  Currency: H0,
  Cylinder: j0,
  Database: $0,
  DatabaseBackup: V0,
  DatabaseZap: O0,
  Delete: R0,
  Dessert: F0,
  Diameter: U0,
  Diamond: E0,
  DiamondPercent: un,
  Dice1: W0,
  Dice2: N0,
  Dice3: Z0,
  Dice4: Y0,
  Dice5: G0,
  Dice6: X0,
  Dices: K0,
  Diff: Q0,
  Disc: au,
  Disc2: J0,
  Disc3: eu,
  DiscAlbum: tu,
  Divide: nu,
  Dna: ru,
  DnaOff: ou,
  Dock: iu,
  Dog: lu,
  DollarSign: cu,
  Donut: du,
  DoorClosed: su,
  DoorOpen: uu,
  Dot: hu,
  Download: pu,
  DraftingCompass: yu,
  Drama: ku,
  Dribbble: fu,
  Drill: vu,
  Droplet: mu,
  Droplets: gu,
  Drum: Mu,
  Drumstick: xu,
  Dumbbell: bu,
  Ear: Iu,
  EarOff: wu,
  Earth: hn,
  EarthLock: Lu,
  Eclipse: Su,
  Egg: Pu,
  EggFried: Cu,
  EggOff: Au,
  Ellipsis: yn,
  EllipsisVertical: pn,
  Equal: Tu,
  EqualNot: qu,
  Eraser: Du,
  Euro: _u,
  Expand: Bu,
  ExternalLink: zu,
  Eye: ju,
  EyeOff: Hu,
  Facebook: Vu,
  Factory: Ou,
  Fan: $u,
  FastForward: Ru,
  Feather: Fu,
  Fence: Uu,
  FerrisWheel: Eu,
  Figma: Wu,
  File: Wh,
  FileArchive: Nu,
  FileAudio: Yu,
  FileAudio2: Zu,
  FileAxis3d: kn,
  FileBadge: Xu,
  FileBadge2: Gu,
  FileBarChart: Qu,
  FileBarChart2: Ku,
  FileBox: Ju,
  FileCheck: th,
  FileCheck2: eh,
  FileClock: ah,
  FileCode: oh,
  FileCode2: nh,
  FileCog: fn,
  FileDiff: rh,
  FileDigit: ih,
  FileDown: lh,
  FileHeart: ch,
  FileImage: dh,
  FileInput: sh,
  FileJson: hh,
  FileJson2: uh,
  FileKey: yh,
  FileKey2: ph,
  FileLineChart: kh,
  FileLock: vh,
  FileLock2: fh,
  FileMinus: gh,
  FileMinus2: mh,
  FileMusic: Mh,
  FileOutput: xh,
  FilePen: mn,
  FilePenLine: vn,
  FilePieChart: bh,
  FilePlus: Ih,
  FilePlus2: wh,
  FileQuestion: Lh,
  FileScan: Sh,
  FileSearch: Ah,
  FileSearch2: Ch,
  FileSliders: Ph,
  FileSpreadsheet: qh,
  FileStack: Th,
  FileSymlink: Dh,
  FileTerminal: _h,
  FileText: Bh,
  FileType: Hh,
  FileType2: zh,
  FileUp: jh,
  FileVideo: Oh,
  FileVideo2: Vh,
  FileVolume: Rh,
  FileVolume2: $h,
  FileWarning: Fh,
  FileX: Eh,
  FileX2: Uh,
  Files: Nh,
  Film: Zh,
  Filter: Gh,
  FilterX: Yh,
  Fingerprint: Xh,
  FireExtinguisher: Kh,
  Fish: ep,
  FishOff: Qh,
  FishSymbol: Jh,
  Flag: op,
  FlagOff: tp,
  FlagTriangleLeft: ap,
  FlagTriangleRight: np,
  Flame: ip,
  FlameKindling: rp,
  Flashlight: cp,
  FlashlightOff: lp,
  FlaskConical: sp,
  FlaskConicalOff: dp,
  FlaskRound: up,
  FlipHorizontal: pp,
  FlipHorizontal2: hp,
  FlipVertical: kp,
  FlipVertical2: yp,
  Flower: vp,
  Flower2: fp,
  Focus: mp,
  FoldHorizontal: gp,
  FoldVertical: Mp,
  Folder: Zp,
  FolderArchive: xp,
  FolderCheck: bp,
  FolderClock: wp,
  FolderClosed: Ip,
  FolderCog: gn,
  FolderDot: Lp,
  FolderDown: Sp,
  FolderGit: Ap,
  FolderGit2: Cp,
  FolderHeart: Pp,
  FolderInput: qp,
  FolderKanban: Tp,
  FolderKey: Dp,
  FolderLock: _p,
  FolderMinus: Bp,
  FolderOpen: Hp,
  FolderOpenDot: zp,
  FolderOutput: jp,
  FolderPen: Mn,
  FolderPlus: Vp,
  FolderRoot: Op,
  FolderSearch: Rp,
  FolderSearch2: $p,
  FolderSymlink: Fp,
  FolderSync: Up,
  FolderTree: Ep,
  FolderUp: Wp,
  FolderX: Np,
  Folders: Yp,
  Footprints: Gp,
  Forklift: Xp,
  Forward: Kp,
  Frame: Qp,
  Framer: Jp,
  Frown: ey,
  Fuel: ty,
  Fullscreen: ay,
  GalleryHorizontal: oy,
  GalleryHorizontalEnd: ny,
  GalleryThumbnails: ry,
  GalleryVertical: ly,
  GalleryVerticalEnd: iy,
  Gamepad: dy,
  Gamepad2: cy,
  GanttChart: sy,
  Gauge: uy,
  Gavel: hy,
  Gem: py,
  Ghost: yy,
  Gift: ky,
  GitBranch: vy,
  GitBranchPlus: fy,
  GitCommitHorizontal: xn,
  GitCommitVertical: my,
  GitCompare: My,
  GitCompareArrows: gy,
  GitFork: xy,
  GitGraph: by,
  GitMerge: wy,
  GitPullRequest: Py,
  GitPullRequestArrow: Iy,
  GitPullRequestClosed: Ly,
  GitPullRequestCreate: Cy,
  GitPullRequestCreateArrow: Sy,
  GitPullRequestDraft: Ay,
  Github: qy,
  Gitlab: Ty,
  GlassWater: Dy,
  Glasses: _y,
  Globe: zy,
  GlobeLock: By,
  Goal: Hy,
  Grab: jy,
  GraduationCap: Vy,
  Grape: Oy,
  Grid2x2: bn,
  Grid3x3: zt,
  Grip: Fy,
  GripHorizontal: $y,
  GripVertical: Ry,
  Group: Uy,
  Guitar: Ey,
  Ham: Wy,
  Hammer: Ny,
  Hand: Ky,
  HandCoins: Zy,
  HandHeart: Yy,
  HandHelping: wn,
  HandMetal: Gy,
  HandPlatter: Xy,
  Handshake: Qy,
  HardDrive: tk,
  HardDriveDownload: Jy,
  HardDriveUpload: ek,
  HardHat: ak,
  Hash: nk,
  Haze: ok,
  HdmiPort: rk,
  Heading: hk,
  Heading1: ik,
  Heading2: lk,
  Heading3: ck,
  Heading4: dk,
  Heading5: sk,
  Heading6: uk,
  Headphones: pk,
  Headset: yk,
  Heart: gk,
  HeartCrack: kk,
  HeartHandshake: fk,
  HeartOff: vk,
  HeartPulse: mk,
  Heater: Mk,
  Hexagon: xk,
  Highlighter: bk,
  History: wk,
  Home: Ik,
  Hop: Sk,
  HopOff: Lk,
  Hospital: Ck,
  Hotel: Ak,
  Hourglass: Pk,
  IceCreamBowl: In,
  IceCreamCone: Ln,
  Image: zk,
  ImageDown: qk,
  ImageMinus: Tk,
  ImageOff: Dk,
  ImagePlus: _k,
  ImageUp: Bk,
  Images: Hk,
  Import: jk,
  Inbox: Vk,
  IndentDecrease: Sn,
  IndentIncrease: Cn,
  IndianRupee: Ok,
  Infinity: $k,
  Info: Rk,
  InspectionPanel: Fk,
  Instagram: Uk,
  Italic: Ek,
  IterationCcw: Wk,
  IterationCw: Nk,
  JapaneseYen: Zk,
  Joystick: Yk,
  Kanban: Gk,
  Key: Qk,
  KeyRound: Xk,
  KeySquare: Kk,
  Keyboard: e4,
  KeyboardMusic: Jk,
  Lamp: i4,
  LampCeiling: t4,
  LampDesk: a4,
  LampFloor: n4,
  LampWallDown: o4,
  LampWallUp: r4,
  LandPlot: l4,
  Landmark: c4,
  Languages: d4,
  Laptop: s4,
  LaptopMinimal: An,
  Lasso: h4,
  LassoSelect: u4,
  Laugh: p4,
  Layers: f4,
  Layers2: y4,
  Layers3: k4,
  LayoutDashboard: v4,
  LayoutGrid: m4,
  LayoutList: g4,
  LayoutPanelLeft: M4,
  LayoutPanelTop: x4,
  LayoutTemplate: b4,
  Leaf: w4,
  LeafyGreen: I4,
  Library: S4,
  LibraryBig: L4,
  LifeBuoy: C4,
  Ligature: A4,
  Lightbulb: q4,
  LightbulbOff: P4,
  LineChart: T4,
  Link: B4,
  Link2: _4,
  Link2Off: D4,
  Linkedin: z4,
  List: X4,
  ListChecks: H4,
  ListCollapse: j4,
  ListEnd: V4,
  ListFilter: O4,
  ListMinus: $4,
  ListMusic: R4,
  ListOrdered: F4,
  ListPlus: U4,
  ListRestart: E4,
  ListStart: W4,
  ListTodo: N4,
  ListTree: Z4,
  ListVideo: Y4,
  ListX: G4,
  Loader: K4,
  LoaderCircle: Pn,
  Locate: ef,
  LocateFixed: Q4,
  LocateOff: J4,
  Lock: af,
  LockKeyhole: tf,
  LockKeyholeOpen: qn,
  LockOpen: Tn,
  LogIn: nf,
  LogOut: of,
  Lollipop: rf,
  Luggage: lf,
  Magnet: cf,
  Mail: vf,
  MailCheck: df,
  MailMinus: sf,
  MailOpen: uf,
  MailPlus: hf,
  MailQuestion: pf,
  MailSearch: yf,
  MailWarning: kf,
  MailX: ff,
  Mailbox: mf,
  Mails: gf,
  Map: wf,
  MapPin: xf,
  MapPinOff: Mf,
  MapPinned: bf,
  Martini: If,
  Maximize: Sf,
  Maximize2: Lf,
  Medal: Cf,
  Megaphone: Pf,
  MegaphoneOff: Af,
  Meh: qf,
  MemoryStick: Tf,
  Menu: Df,
  Merge: _f,
  MessageCircle: Ef,
  MessageCircleCode: Bf,
  MessageCircleDashed: zf,
  MessageCircleHeart: Hf,
  MessageCircleMore: jf,
  MessageCircleOff: Vf,
  MessageCirclePlus: Of,
  MessageCircleQuestion: $f,
  MessageCircleReply: Rf,
  MessageCircleWarning: Ff,
  MessageCircleX: Uf,
  MessageSquare: rv,
  MessageSquareCode: Wf,
  MessageSquareDashed: Nf,
  MessageSquareDiff: Zf,
  MessageSquareDot: Yf,
  MessageSquareHeart: Gf,
  MessageSquareMore: Xf,
  MessageSquareOff: Kf,
  MessageSquarePlus: Qf,
  MessageSquareQuote: Jf,
  MessageSquareReply: ev,
  MessageSquareShare: tv,
  MessageSquareText: av,
  MessageSquareWarning: nv,
  MessageSquareX: ov,
  MessagesSquare: iv,
  Mic: cv,
  MicOff: lv,
  MicVocal: Dn,
  Microscope: dv,
  Microwave: sv,
  Milestone: uv,
  Milk: pv,
  MilkOff: hv,
  Minimize: kv,
  Minimize2: yv,
  Minus: fv,
  Monitor: Av,
  MonitorCheck: vv,
  MonitorDot: mv,
  MonitorDown: gv,
  MonitorOff: Mv,
  MonitorPause: xv,
  MonitorPlay: bv,
  MonitorSmartphone: wv,
  MonitorSpeaker: Iv,
  MonitorStop: Lv,
  MonitorUp: Sv,
  MonitorX: Cv,
  Moon: qv,
  MoonStar: Pv,
  Mountain: Dv,
  MountainSnow: Tv,
  Mouse: jv,
  MouseOff: _v,
  MousePointer: Hv,
  MousePointer2: Bv,
  MousePointerClick: zv,
  Move: Xv,
  Move3d: _n,
  MoveDiagonal: Ov,
  MoveDiagonal2: Vv,
  MoveDown: Fv,
  MoveDownLeft: $v,
  MoveDownRight: Rv,
  MoveHorizontal: Uv,
  MoveLeft: Ev,
  MoveRight: Wv,
  MoveUp: Yv,
  MoveUpLeft: Nv,
  MoveUpRight: Zv,
  MoveVertical: Gv,
  Music: em,
  Music2: Kv,
  Music3: Qv,
  Music4: Jv,
  Navigation: om,
  Navigation2: am,
  Navigation2Off: tm,
  NavigationOff: nm,
  Network: rm,
  Newspaper: im,
  Nfc: lm,
  Notebook: um,
  NotebookPen: cm,
  NotebookTabs: dm,
  NotebookText: sm,
  NotepadText: pm,
  NotepadTextDashed: hm,
  Nut: km,
  NutOff: ym,
  Octagon: fm,
  OctagonAlert: Bn,
  OctagonPause: zn,
  OctagonX: Hn,
  Option: vm,
  Orbit: mm,
  Package: Sm,
  Package2: gm,
  PackageCheck: Mm,
  PackageMinus: xm,
  PackageOpen: bm,
  PackagePlus: wm,
  PackageSearch: Im,
  PackageX: Lm,
  PaintBucket: Cm,
  PaintRoller: Am,
  Paintbrush: qm,
  Paintbrush2: Pm,
  Palette: Tm,
  PanelBottom: Bm,
  PanelBottomClose: Dm,
  PanelBottomDashed: jn,
  PanelBottomOpen: _m,
  PanelLeft: Rn,
  PanelLeftClose: Vn,
  PanelLeftDashed: On,
  PanelLeftOpen: $n,
  PanelRight: jm,
  PanelRightClose: zm,
  PanelRightDashed: Fn,
  PanelRightOpen: Hm,
  PanelTop: $m,
  PanelTopClose: Vm,
  PanelTopDashed: Un,
  PanelTopOpen: Om,
  PanelsLeftBottom: Rm,
  PanelsRightBottom: Fm,
  PanelsTopLeft: En,
  Paperclip: Um,
  Parentheses: Em,
  ParkingMeter: Wm,
  PartyPopper: Nm,
  Pause: Zm,
  PawPrint: Ym,
  PcCase: Gm,
  Pen: Nn,
  PenLine: Wn,
  PenTool: Xm,
  Pencil: Jm,
  PencilLine: Km,
  PencilRuler: Qm,
  Pentagon: e5,
  Percent: t5,
  PersonStanding: a5,
  Phone: d5,
  PhoneCall: n5,
  PhoneForwarded: o5,
  PhoneIncoming: r5,
  PhoneMissed: i5,
  PhoneOff: l5,
  PhoneOutgoing: c5,
  Pi: s5,
  Piano: u5,
  Pickaxe: h5,
  PictureInPicture: y5,
  PictureInPicture2: p5,
  PieChart: k5,
  PiggyBank: f5,
  Pilcrow: g5,
  PilcrowLeft: v5,
  PilcrowRight: m5,
  Pill: M5,
  Pin: b5,
  PinOff: x5,
  Pipette: w5,
  Pizza: I5,
  Plane: C5,
  PlaneLanding: L5,
  PlaneTakeoff: S5,
  Play: A5,
  Plug: D5,
  Plug2: P5,
  PlugZap: T5,
  PlugZap2: q5,
  Plus: _5,
  Pocket: z5,
  PocketKnife: B5,
  Podcast: H5,
  Pointer: V5,
  PointerOff: j5,
  Popcorn: O5,
  Popsicle: $5,
  PoundSterling: R5,
  Power: U5,
  PowerOff: F5,
  Presentation: E5,
  Printer: W5,
  Projector: N5,
  Proportions: Z5,
  Puzzle: Y5,
  Pyramid: G5,
  QrCode: X5,
  Quote: K5,
  Rabbit: Q5,
  Radar: J5,
  Radiation: e3,
  Radical: t3,
  Radio: o3,
  RadioReceiver: a3,
  RadioTower: n3,
  Radius: r3,
  RailSymbol: i3,
  Rainbow: l3,
  Rat: c3,
  Ratio: d3,
  Receipt: m3,
  ReceiptCent: s3,
  ReceiptEuro: u3,
  ReceiptIndianRupee: h3,
  ReceiptJapaneseYen: p3,
  ReceiptPoundSterling: y3,
  ReceiptRussianRuble: k3,
  ReceiptSwissFranc: f3,
  ReceiptText: v3,
  RectangleEllipsis: Zn,
  RectangleHorizontal: g3,
  RectangleVertical: M3,
  Recycle: x3,
  Redo: I3,
  Redo2: b3,
  RedoDot: w3,
  RefreshCcw: S3,
  RefreshCcwDot: L3,
  RefreshCw: A3,
  RefreshCwOff: C3,
  Refrigerator: P3,
  Regex: q3,
  RemoveFormatting: T3,
  Repeat: B3,
  Repeat1: D3,
  Repeat2: _3,
  Replace: H3,
  ReplaceAll: z3,
  Reply: V3,
  ReplyAll: j3,
  Rewind: O3,
  Ribbon: $3,
  Rocket: R3,
  RockingChair: F3,
  RollerCoaster: U3,
  Rotate3d: Yn,
  RotateCcw: W3,
  RotateCcwSquare: E3,
  RotateCw: Z3,
  RotateCwSquare: N3,
  Route: G3,
  RouteOff: Y3,
  Router: X3,
  Rows2: Gn,
  Rows3: Xn,
  Rows4: K3,
  Rss: Q3,
  Ruler: J3,
  RussianRuble: eg,
  Sailboat: tg,
  Salad: ag,
  Sandwich: ng,
  Satellite: rg,
  SatelliteDish: og,
  Save: lg,
  SaveAll: ig,
  Scale: cg,
  Scale3d: Kn,
  Scaling: dg,
  Scan: fg,
  ScanBarcode: sg,
  ScanEye: ug,
  ScanFace: hg,
  ScanLine: pg,
  ScanSearch: yg,
  ScanText: kg,
  ScatterChart: vg,
  School: mg,
  Scissors: Mg,
  ScissorsLineDashed: gg,
  ScreenShare: bg,
  ScreenShareOff: xg,
  Scroll: Ig,
  ScrollText: wg,
  Search: Pg,
  SearchCheck: Lg,
  SearchCode: Sg,
  SearchSlash: Cg,
  SearchX: Ag,
  Send: Tg,
  SendHorizontal: Qn,
  SendToBack: qg,
  SeparatorHorizontal: Dg,
  SeparatorVertical: _g,
  Server: jg,
  ServerCog: Bg,
  ServerCrash: zg,
  ServerOff: Hg,
  Settings: Og,
  Settings2: Vg,
  Shapes: $g,
  Share: Fg,
  Share2: Rg,
  Sheet: Ug,
  Shell: Eg,
  Shield: e6,
  ShieldAlert: Wg,
  ShieldBan: Ng,
  ShieldCheck: Zg,
  ShieldEllipsis: Yg,
  ShieldHalf: Gg,
  ShieldMinus: Xg,
  ShieldOff: Kg,
  ShieldPlus: Qg,
  ShieldQuestion: Jg,
  ShieldX: Jn,
  Ship: a6,
  ShipWheel: t6,
  Shirt: n6,
  ShoppingBag: o6,
  ShoppingBasket: r6,
  ShoppingCart: i6,
  Shovel: l6,
  ShowerHead: c6,
  Shrink: d6,
  Shrub: s6,
  Shuffle: u6,
  Sigma: h6,
  Signal: v6,
  SignalHigh: p6,
  SignalLow: y6,
  SignalMedium: k6,
  SignalZero: f6,
  Signpost: g6,
  SignpostBig: m6,
  Siren: M6,
  SkipBack: x6,
  SkipForward: b6,
  Skull: w6,
  Slack: I6,
  Slash: L6,
  Slice: S6,
  SlidersHorizontal: C6,
  SlidersVertical: eo,
  Smartphone: q6,
  SmartphoneCharging: A6,
  SmartphoneNfc: P6,
  Smile: D6,
  SmilePlus: T6,
  Snail: _6,
  Snowflake: B6,
  Sofa: z6,
  Soup: H6,
  Space: j6,
  Spade: V6,
  Sparkle: O6,
  Sparkles: to,
  Speaker: $6,
  Speech: R6,
  SpellCheck: U6,
  SpellCheck2: F6,
  Spline: E6,
  Split: W6,
  SprayCan: N6,
  Sprout: Z6,
  Square: Q6,
  SquareActivity: ao,
  SquareArrowDown: ro,
  SquareArrowDownLeft: no,
  SquareArrowDownRight: oo,
  SquareArrowLeft: io,
  SquareArrowOutDownLeft: lo,
  SquareArrowOutDownRight: co,
  SquareArrowOutUpLeft: so,
  SquareArrowOutUpRight: uo,
  SquareArrowRight: ho,
  SquareArrowUp: ko,
  SquareArrowUpLeft: po,
  SquareArrowUpRight: yo,
  SquareAsterisk: fo,
  SquareBottomDashedScissors: vo,
  SquareCheck: go,
  SquareCheckBig: mo,
  SquareChevronDown: Mo,
  SquareChevronLeft: xo,
  SquareChevronRight: bo,
  SquareChevronUp: wo,
  SquareCode: Io,
  SquareDashedBottom: G6,
  SquareDashedBottomCode: Y6,
  SquareDashedKanban: Lo,
  SquareDashedMousePointer: So,
  SquareDivide: Co,
  SquareDot: Ao,
  SquareEqual: Po,
  SquareFunction: qo,
  SquareGanttChart: To,
  SquareKanban: Do,
  SquareLibrary: _o,
  SquareM: Bo,
  SquareMenu: zo,
  SquareMinus: Ho,
  SquareMousePointer: jo,
  SquareParking: Oo,
  SquareParkingOff: Vo,
  SquarePen: vt,
  SquarePercent: $o,
  SquarePi: Ro,
  SquarePilcrow: Fo,
  SquarePlay: Uo,
  SquarePlus: Eo,
  SquarePower: Wo,
  SquareRadical: X6,
  SquareScissors: No,
  SquareSigma: Zo,
  SquareSlash: Yo,
  SquareSplitHorizontal: Go,
  SquareSplitVertical: Xo,
  SquareStack: K6,
  SquareTerminal: Ko,
  SquareUser: Jo,
  SquareUserRound: Qo,
  SquareX: er,
  Squircle: J6,
  Squirrel: e8,
  Stamp: t8,
  Star: o8,
  StarHalf: a8,
  StarOff: n8,
  StepBack: r8,
  StepForward: i8,
  Stethoscope: l8,
  Sticker: c8,
  StickyNote: d8,
  Store: s8,
  StretchHorizontal: u8,
  StretchVertical: h8,
  Strikethrough: p8,
  Subscript: y8,
  Sun: g8,
  SunDim: k8,
  SunMedium: f8,
  SunMoon: v8,
  SunSnow: m8,
  Sunrise: M8,
  Sunset: x8,
  Superscript: b8,
  SwatchBook: w8,
  SwissFranc: I8,
  SwitchCamera: L8,
  Sword: S8,
  Swords: C8,
  Syringe: A8,
  Table: z8,
  Table2: P8,
  TableCellsMerge: q8,
  TableCellsSplit: T8,
  TableColumnsSplit: D8,
  TableProperties: _8,
  TableRowsSplit: B8,
  Tablet: j8,
  TabletSmartphone: H8,
  Tablets: V8,
  Tag: O8,
  Tags: $8,
  Tally1: R8,
  Tally2: F8,
  Tally3: U8,
  Tally4: E8,
  Tally5: W8,
  Tangent: N8,
  Target: Z8,
  Telescope: Y8,
  Tent: X8,
  TentTree: G8,
  Terminal: K8,
  TestTube: Q8,
  TestTubeDiagonal: tr,
  TestTubes: J8,
  Text: o7,
  TextCursor: t7,
  TextCursorInput: e7,
  TextQuote: a7,
  TextSearch: n7,
  TextSelect: ar,
  Theater: r7,
  Thermometer: c7,
  ThermometerSnowflake: i7,
  ThermometerSun: l7,
  ThumbsDown: d7,
  ThumbsUp: s7,
  Ticket: v7,
  TicketCheck: u7,
  TicketMinus: h7,
  TicketPercent: p7,
  TicketPlus: y7,
  TicketSlash: k7,
  TicketX: f7,
  Timer: M7,
  TimerOff: m7,
  TimerReset: g7,
  ToggleLeft: x7,
  ToggleRight: b7,
  Tornado: w7,
  Torus: I7,
  Touchpad: S7,
  TouchpadOff: L7,
  TowerControl: C7,
  ToyBrick: A7,
  Tractor: P7,
  TrafficCone: q7,
  TrainFront: D7,
  TrainFrontTunnel: T7,
  TrainTrack: _7,
  TramFront: nr,
  Trash: z7,
  Trash2: B7,
  TreeDeciduous: H7,
  TreePalm: or,
  TreePine: j7,
  Trees: V7,
  Trello: O7,
  TrendingDown: $7,
  TrendingUp: R7,
  Triangle: U7,
  TriangleAlert: rr,
  TriangleRight: F7,
  Trophy: E7,
  Truck: W7,
  Turtle: N7,
  Tv: Y7,
  Tv2: Z7,
  Twitch: G7,
  Twitter: X7,
  Type: K7,
  Umbrella: J7,
  UmbrellaOff: Q7,
  Underline: eM,
  Undo: nM,
  Undo2: tM,
  UndoDot: aM,
  UnfoldHorizontal: oM,
  UnfoldVertical: rM,
  Ungroup: iM,
  University: ir,
  Unlink: cM,
  Unlink2: lM,
  Unplug: dM,
  Upload: sM,
  Usb: uM,
  User: gM,
  UserCheck: hM,
  UserCog: pM,
  UserMinus: yM,
  UserPlus: kM,
  UserRound: hr,
  UserRoundCheck: lr,
  UserRoundCog: cr,
  UserRoundMinus: dr,
  UserRoundPlus: sr,
  UserRoundSearch: fM,
  UserRoundX: ur,
  UserSearch: vM,
  UserX: mM,
  Users: MM,
  UsersRound: pr,
  Utensils: bM,
  UtensilsCrossed: xM,
  UtilityPole: wM,
  Variable: IM,
  Vault: LM,
  Vegan: SM,
  VenetianMask: CM,
  Vibrate: PM,
  VibrateOff: AM,
  Video: TM,
  VideoOff: qM,
  Videotape: DM,
  View: _M,
  Voicemail: BM,
  Volume: VM,
  Volume1: zM,
  Volume2: HM,
  VolumeX: jM,
  Vote: OM,
  Wallet: RM,
  WalletCards: $M,
  WalletMinimal: yr,
  Wallpaper: FM,
  Wand: UM,
  WandSparkles: kr,
  Warehouse: EM,
  WashingMachine: WM,
  Watch: NM,
  Waves: ZM,
  Waypoints: YM,
  Webcam: GM,
  Webhook: KM,
  WebhookOff: XM,
  Weight: QM,
  Wheat: ex,
  WheatOff: JM,
  WholeWord: tx,
  Wifi: nx,
  WifiOff: ax,
  Wind: ox,
  Wine: ix,
  WineOff: rx,
  Workflow: lx,
  Worm: cx,
  WrapText: dx,
  Wrench: sx,
  X: ux,
  Youtube: hx,
  Zap: yx,
  ZapOff: px,
  ZoomIn: kx,
  ZoomOut: fx
}, Symbol.toStringTag, { value: "Module" }));
const pI = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  AArrowDown: T1,
  AArrowDownIcon: T1,
  AArrowUp: D1,
  AArrowUpIcon: D1,
  ALargeSmall: _1,
  ALargeSmallIcon: _1,
  Accessibility: B1,
  AccessibilityIcon: B1,
  Activity: z1,
  ActivityIcon: z1,
  ActivitySquare: ao,
  ActivitySquareIcon: ao,
  AirVent: H1,
  AirVentIcon: H1,
  Airplay: j1,
  AirplayIcon: j1,
  AlarmCheck: da,
  AlarmCheckIcon: da,
  AlarmClock: O1,
  AlarmClockCheck: da,
  AlarmClockCheckIcon: da,
  AlarmClockIcon: O1,
  AlarmClockMinus: sa,
  AlarmClockMinusIcon: sa,
  AlarmClockOff: V1,
  AlarmClockOffIcon: V1,
  AlarmClockPlus: ua,
  AlarmClockPlusIcon: ua,
  AlarmMinus: sa,
  AlarmMinusIcon: sa,
  AlarmPlus: ua,
  AlarmPlusIcon: ua,
  AlarmSmoke: $1,
  AlarmSmokeIcon: $1,
  Album: R1,
  AlbumIcon: R1,
  AlertCircle: La,
  AlertCircleIcon: La,
  AlertOctagon: Bn,
  AlertOctagonIcon: Bn,
  AlertTriangle: rr,
  AlertTriangleIcon: rr,
  AlignCenter: E1,
  AlignCenterHorizontal: F1,
  AlignCenterHorizontalIcon: F1,
  AlignCenterIcon: E1,
  AlignCenterVertical: U1,
  AlignCenterVerticalIcon: U1,
  AlignEndHorizontal: W1,
  AlignEndHorizontalIcon: W1,
  AlignEndVertical: N1,
  AlignEndVerticalIcon: N1,
  AlignHorizontalDistributeCenter: Z1,
  AlignHorizontalDistributeCenterIcon: Z1,
  AlignHorizontalDistributeEnd: Y1,
  AlignHorizontalDistributeEndIcon: Y1,
  AlignHorizontalDistributeStart: G1,
  AlignHorizontalDistributeStartIcon: G1,
  AlignHorizontalJustifyCenter: X1,
  AlignHorizontalJustifyCenterIcon: X1,
  AlignHorizontalJustifyEnd: K1,
  AlignHorizontalJustifyEndIcon: K1,
  AlignHorizontalJustifyStart: Q1,
  AlignHorizontalJustifyStartIcon: Q1,
  AlignHorizontalSpaceAround: J1,
  AlignHorizontalSpaceAroundIcon: J1,
  AlignHorizontalSpaceBetween: ei,
  AlignHorizontalSpaceBetweenIcon: ei,
  AlignJustify: ti,
  AlignJustifyIcon: ti,
  AlignLeft: ai,
  AlignLeftIcon: ai,
  AlignRight: ni,
  AlignRightIcon: ni,
  AlignStartHorizontal: oi,
  AlignStartHorizontalIcon: oi,
  AlignStartVertical: ri,
  AlignStartVerticalIcon: ri,
  AlignVerticalDistributeCenter: ii,
  AlignVerticalDistributeCenterIcon: ii,
  AlignVerticalDistributeEnd: li,
  AlignVerticalDistributeEndIcon: li,
  AlignVerticalDistributeStart: ci,
  AlignVerticalDistributeStartIcon: ci,
  AlignVerticalJustifyCenter: di,
  AlignVerticalJustifyCenterIcon: di,
  AlignVerticalJustifyEnd: si,
  AlignVerticalJustifyEndIcon: si,
  AlignVerticalJustifyStart: ui,
  AlignVerticalJustifyStartIcon: ui,
  AlignVerticalSpaceAround: hi,
  AlignVerticalSpaceAroundIcon: hi,
  AlignVerticalSpaceBetween: pi,
  AlignVerticalSpaceBetweenIcon: pi,
  Ambulance: yi,
  AmbulanceIcon: yi,
  Ampersand: ki,
  AmpersandIcon: ki,
  Ampersands: fi,
  AmpersandsIcon: fi,
  Anchor: vi,
  AnchorIcon: vi,
  Angry: mi,
  AngryIcon: mi,
  Annoyed: gi,
  AnnoyedIcon: gi,
  Antenna: Mi,
  AntennaIcon: Mi,
  Anvil: xi,
  AnvilIcon: xi,
  Aperture: bi,
  ApertureIcon: bi,
  AppWindow: Ii,
  AppWindowIcon: Ii,
  AppWindowMac: wi,
  AppWindowMacIcon: wi,
  Apple: Li,
  AppleIcon: Li,
  Archive: Ai,
  ArchiveIcon: Ai,
  ArchiveRestore: Si,
  ArchiveRestoreIcon: Si,
  ArchiveX: Ci,
  ArchiveXIcon: Ci,
  AreaChart: Pi,
  AreaChartIcon: Pi,
  Armchair: qi,
  ArmchairIcon: qi,
  ArrowBigDown: Di,
  ArrowBigDownDash: Ti,
  ArrowBigDownDashIcon: Ti,
  ArrowBigDownIcon: Di,
  ArrowBigLeft: Bi,
  ArrowBigLeftDash: _i,
  ArrowBigLeftDashIcon: _i,
  ArrowBigLeftIcon: Bi,
  ArrowBigRight: Hi,
  ArrowBigRightDash: zi,
  ArrowBigRightDashIcon: zi,
  ArrowBigRightIcon: Hi,
  ArrowBigUp: Vi,
  ArrowBigUpDash: ji,
  ArrowBigUpDashIcon: ji,
  ArrowBigUpIcon: Vi,
  ArrowDown: Yi,
  ArrowDown01: Oi,
  ArrowDown01Icon: Oi,
  ArrowDown10: $i,
  ArrowDown10Icon: $i,
  ArrowDownAZ: ha,
  ArrowDownAZIcon: ha,
  ArrowDownAz: ha,
  ArrowDownAzIcon: ha,
  ArrowDownCircle: Sa,
  ArrowDownCircleIcon: Sa,
  ArrowDownFromLine: Ri,
  ArrowDownFromLineIcon: Ri,
  ArrowDownIcon: Yi,
  ArrowDownLeft: Fi,
  ArrowDownLeftFromCircle: Aa,
  ArrowDownLeftFromCircleIcon: Aa,
  ArrowDownLeftFromSquare: lo,
  ArrowDownLeftFromSquareIcon: lo,
  ArrowDownLeftIcon: Fi,
  ArrowDownLeftSquare: no,
  ArrowDownLeftSquareIcon: no,
  ArrowDownNarrowWide: Ui,
  ArrowDownNarrowWideIcon: Ui,
  ArrowDownRight: Ei,
  ArrowDownRightFromCircle: Pa,
  ArrowDownRightFromCircleIcon: Pa,
  ArrowDownRightFromSquare: co,
  ArrowDownRightFromSquareIcon: co,
  ArrowDownRightIcon: Ei,
  ArrowDownRightSquare: oo,
  ArrowDownRightSquareIcon: oo,
  ArrowDownSquare: ro,
  ArrowDownSquareIcon: ro,
  ArrowDownToDot: Wi,
  ArrowDownToDotIcon: Wi,
  ArrowDownToLine: Ni,
  ArrowDownToLineIcon: Ni,
  ArrowDownUp: Zi,
  ArrowDownUpIcon: Zi,
  ArrowDownWideNarrow: pa,
  ArrowDownWideNarrowIcon: pa,
  ArrowDownZA: ya,
  ArrowDownZAIcon: ya,
  ArrowDownZa: ya,
  ArrowDownZaIcon: ya,
  ArrowLeft: Qi,
  ArrowLeftCircle: Ca,
  ArrowLeftCircleIcon: Ca,
  ArrowLeftFromLine: Gi,
  ArrowLeftFromLineIcon: Gi,
  ArrowLeftIcon: Qi,
  ArrowLeftRight: Xi,
  ArrowLeftRightIcon: Xi,
  ArrowLeftSquare: io,
  ArrowLeftSquareIcon: io,
  ArrowLeftToLine: Ki,
  ArrowLeftToLineIcon: Ki,
  ArrowRight: al,
  ArrowRightCircle: Da,
  ArrowRightCircleIcon: Da,
  ArrowRightFromLine: Ji,
  ArrowRightFromLineIcon: Ji,
  ArrowRightIcon: al,
  ArrowRightLeft: el,
  ArrowRightLeftIcon: el,
  ArrowRightSquare: ho,
  ArrowRightSquareIcon: ho,
  ArrowRightToLine: tl,
  ArrowRightToLineIcon: tl,
  ArrowUp: hl,
  ArrowUp01: nl,
  ArrowUp01Icon: nl,
  ArrowUp10: ol,
  ArrowUp10Icon: ol,
  ArrowUpAZ: ka,
  ArrowUpAZIcon: ka,
  ArrowUpAz: ka,
  ArrowUpAzIcon: ka,
  ArrowUpCircle: _a,
  ArrowUpCircleIcon: _a,
  ArrowUpDown: rl,
  ArrowUpDownIcon: rl,
  ArrowUpFromDot: il,
  ArrowUpFromDotIcon: il,
  ArrowUpFromLine: ll,
  ArrowUpFromLineIcon: ll,
  ArrowUpIcon: hl,
  ArrowUpLeft: cl,
  ArrowUpLeftFromCircle: qa,
  ArrowUpLeftFromCircleIcon: qa,
  ArrowUpLeftFromSquare: so,
  ArrowUpLeftFromSquareIcon: so,
  ArrowUpLeftIcon: cl,
  ArrowUpLeftSquare: po,
  ArrowUpLeftSquareIcon: po,
  ArrowUpNarrowWide: fa,
  ArrowUpNarrowWideIcon: fa,
  ArrowUpRight: dl,
  ArrowUpRightFromCircle: Ta,
  ArrowUpRightFromCircleIcon: Ta,
  ArrowUpRightFromSquare: uo,
  ArrowUpRightFromSquareIcon: uo,
  ArrowUpRightIcon: dl,
  ArrowUpRightSquare: yo,
  ArrowUpRightSquareIcon: yo,
  ArrowUpSquare: ko,
  ArrowUpSquareIcon: ko,
  ArrowUpToLine: sl,
  ArrowUpToLineIcon: sl,
  ArrowUpWideNarrow: ul,
  ArrowUpWideNarrowIcon: ul,
  ArrowUpZA: va,
  ArrowUpZAIcon: va,
  ArrowUpZa: va,
  ArrowUpZaIcon: va,
  ArrowsUpFromLine: pl,
  ArrowsUpFromLineIcon: pl,
  Asterisk: yl,
  AsteriskIcon: yl,
  AsteriskSquare: fo,
  AsteriskSquareIcon: fo,
  AtSign: kl,
  AtSignIcon: kl,
  Atom: fl,
  AtomIcon: fl,
  AudioLines: vl,
  AudioLinesIcon: vl,
  AudioWaveform: ml,
  AudioWaveformIcon: ml,
  Award: gl,
  AwardIcon: gl,
  Axe: Ml,
  AxeIcon: Ml,
  Axis3D: ma,
  Axis3DIcon: ma,
  Axis3d: ma,
  Axis3dIcon: ma,
  Baby: xl,
  BabyIcon: xl,
  Backpack: bl,
  BackpackIcon: bl,
  Badge: Vl,
  BadgeAlert: wl,
  BadgeAlertIcon: wl,
  BadgeCent: Il,
  BadgeCentIcon: Il,
  BadgeCheck: ga,
  BadgeCheckIcon: ga,
  BadgeDollarSign: Ll,
  BadgeDollarSignIcon: Ll,
  BadgeEuro: Sl,
  BadgeEuroIcon: Sl,
  BadgeHelp: Cl,
  BadgeHelpIcon: Cl,
  BadgeIcon: Vl,
  BadgeIndianRupee: Al,
  BadgeIndianRupeeIcon: Al,
  BadgeInfo: Pl,
  BadgeInfoIcon: Pl,
  BadgeJapaneseYen: ql,
  BadgeJapaneseYenIcon: ql,
  BadgeMinus: Tl,
  BadgeMinusIcon: Tl,
  BadgePercent: Dl,
  BadgePercentIcon: Dl,
  BadgePlus: _l,
  BadgePlusIcon: _l,
  BadgePoundSterling: Bl,
  BadgePoundSterlingIcon: Bl,
  BadgeRussianRuble: zl,
  BadgeRussianRubleIcon: zl,
  BadgeSwissFranc: Hl,
  BadgeSwissFrancIcon: Hl,
  BadgeX: jl,
  BadgeXIcon: jl,
  BaggageClaim: Ol,
  BaggageClaimIcon: Ol,
  Ban: $l,
  BanIcon: $l,
  Banana: Rl,
  BananaIcon: Rl,
  Banknote: Fl,
  BanknoteIcon: Fl,
  BarChart: Gl,
  BarChart2: Ul,
  BarChart2Icon: Ul,
  BarChart3: El,
  BarChart3Icon: El,
  BarChart4: Wl,
  BarChart4Icon: Wl,
  BarChartBig: Nl,
  BarChartBigIcon: Nl,
  BarChartHorizontal: Yl,
  BarChartHorizontalBig: Zl,
  BarChartHorizontalBigIcon: Zl,
  BarChartHorizontalIcon: Yl,
  BarChartIcon: Gl,
  Barcode: Xl,
  BarcodeIcon: Xl,
  Baseline: Kl,
  BaselineIcon: Kl,
  Bath: Ql,
  BathIcon: Ql,
  Battery: oc,
  BatteryCharging: Jl,
  BatteryChargingIcon: Jl,
  BatteryFull: ec,
  BatteryFullIcon: ec,
  BatteryIcon: oc,
  BatteryLow: tc,
  BatteryLowIcon: tc,
  BatteryMedium: ac,
  BatteryMediumIcon: ac,
  BatteryWarning: nc,
  BatteryWarningIcon: nc,
  Beaker: rc,
  BeakerIcon: rc,
  Bean: lc,
  BeanIcon: lc,
  BeanOff: ic,
  BeanOffIcon: ic,
  Bed: sc,
  BedDouble: cc,
  BedDoubleIcon: cc,
  BedIcon: sc,
  BedSingle: dc,
  BedSingleIcon: dc,
  Beef: uc,
  BeefIcon: uc,
  Beer: pc,
  BeerIcon: pc,
  BeerOff: hc,
  BeerOffIcon: hc,
  Bell: Mc,
  BellDot: yc,
  BellDotIcon: yc,
  BellElectric: kc,
  BellElectricIcon: kc,
  BellIcon: Mc,
  BellMinus: fc,
  BellMinusIcon: fc,
  BellOff: vc,
  BellOffIcon: vc,
  BellPlus: mc,
  BellPlusIcon: mc,
  BellRing: gc,
  BellRingIcon: gc,
  BetweenHorizonalEnd: Ma,
  BetweenHorizonalEndIcon: Ma,
  BetweenHorizonalStart: xa,
  BetweenHorizonalStartIcon: xa,
  BetweenHorizontalEnd: Ma,
  BetweenHorizontalEndIcon: Ma,
  BetweenHorizontalStart: xa,
  BetweenHorizontalStartIcon: xa,
  BetweenVerticalEnd: xc,
  BetweenVerticalEndIcon: xc,
  BetweenVerticalStart: bc,
  BetweenVerticalStartIcon: bc,
  Bike: wc,
  BikeIcon: wc,
  Binary: Ic,
  BinaryIcon: Ic,
  Biohazard: Lc,
  BiohazardIcon: Lc,
  Bird: Sc,
  BirdIcon: Sc,
  Bitcoin: Cc,
  BitcoinIcon: Cc,
  Blend: Ac,
  BlendIcon: Ac,
  Blinds: Pc,
  BlindsIcon: Pc,
  Blocks: qc,
  BlocksIcon: qc,
  Bluetooth: Bc,
  BluetoothConnected: Tc,
  BluetoothConnectedIcon: Tc,
  BluetoothIcon: Bc,
  BluetoothOff: Dc,
  BluetoothOffIcon: Dc,
  BluetoothSearching: _c,
  BluetoothSearchingIcon: _c,
  Bold: zc,
  BoldIcon: zc,
  Bolt: Hc,
  BoltIcon: Hc,
  Bomb: jc,
  BombIcon: jc,
  Bone: Vc,
  BoneIcon: Vc,
  Book: l2,
  BookA: Oc,
  BookAIcon: Oc,
  BookAudio: $c,
  BookAudioIcon: $c,
  BookCheck: Rc,
  BookCheckIcon: Rc,
  BookCopy: Fc,
  BookCopyIcon: Fc,
  BookDashed: ba,
  BookDashedIcon: ba,
  BookDown: Uc,
  BookDownIcon: Uc,
  BookHeadphones: Ec,
  BookHeadphonesIcon: Ec,
  BookHeart: Wc,
  BookHeartIcon: Wc,
  BookIcon: l2,
  BookImage: Nc,
  BookImageIcon: Nc,
  BookKey: Zc,
  BookKeyIcon: Zc,
  BookLock: Yc,
  BookLockIcon: Yc,
  BookMarked: Gc,
  BookMarkedIcon: Gc,
  BookMinus: Xc,
  BookMinusIcon: Xc,
  BookOpen: Jc,
  BookOpenCheck: Kc,
  BookOpenCheckIcon: Kc,
  BookOpenIcon: Jc,
  BookOpenText: Qc,
  BookOpenTextIcon: Qc,
  BookPlus: e2,
  BookPlusIcon: e2,
  BookTemplate: ba,
  BookTemplateIcon: ba,
  BookText: t2,
  BookTextIcon: t2,
  BookType: a2,
  BookTypeIcon: a2,
  BookUp: o2,
  BookUp2: n2,
  BookUp2Icon: n2,
  BookUpIcon: o2,
  BookUser: r2,
  BookUserIcon: r2,
  BookX: i2,
  BookXIcon: i2,
  Bookmark: h2,
  BookmarkCheck: c2,
  BookmarkCheckIcon: c2,
  BookmarkIcon: h2,
  BookmarkMinus: d2,
  BookmarkMinusIcon: d2,
  BookmarkPlus: s2,
  BookmarkPlusIcon: s2,
  BookmarkX: u2,
  BookmarkXIcon: u2,
  BoomBox: p2,
  BoomBoxIcon: p2,
  Bot: k2,
  BotIcon: k2,
  BotMessageSquare: y2,
  BotMessageSquareIcon: y2,
  Box: v2,
  BoxIcon: v2,
  BoxSelect: f2,
  BoxSelectIcon: f2,
  Boxes: m2,
  BoxesIcon: m2,
  Braces: wa,
  BracesIcon: wa,
  Brackets: g2,
  BracketsIcon: g2,
  Brain: b2,
  BrainCircuit: M2,
  BrainCircuitIcon: M2,
  BrainCog: x2,
  BrainCogIcon: x2,
  BrainIcon: b2,
  BrickWall: w2,
  BrickWallIcon: w2,
  Briefcase: S2,
  BriefcaseBusiness: I2,
  BriefcaseBusinessIcon: I2,
  BriefcaseIcon: S2,
  BriefcaseMedical: L2,
  BriefcaseMedicalIcon: L2,
  BringToFront: C2,
  BringToFrontIcon: C2,
  Brush: A2,
  BrushIcon: A2,
  Bug: T2,
  BugIcon: T2,
  BugOff: P2,
  BugOffIcon: P2,
  BugPlay: q2,
  BugPlayIcon: q2,
  Building: _2,
  Building2: D2,
  Building2Icon: D2,
  BuildingIcon: _2,
  Bus: z2,
  BusFront: B2,
  BusFrontIcon: B2,
  BusIcon: z2,
  Cable: j2,
  CableCar: H2,
  CableCarIcon: H2,
  CableIcon: j2,
  Cake: O2,
  CakeIcon: O2,
  CakeSlice: V2,
  CakeSliceIcon: V2,
  Calculator: $2,
  CalculatorIcon: $2,
  Calendar: ad,
  CalendarCheck: F2,
  CalendarCheck2: R2,
  CalendarCheck2Icon: R2,
  CalendarCheckIcon: F2,
  CalendarClock: U2,
  CalendarClockIcon: U2,
  CalendarDays: E2,
  CalendarDaysIcon: E2,
  CalendarFold: W2,
  CalendarFoldIcon: W2,
  CalendarHeart: N2,
  CalendarHeartIcon: N2,
  CalendarIcon: ad,
  CalendarMinus: Y2,
  CalendarMinus2: Z2,
  CalendarMinus2Icon: Z2,
  CalendarMinusIcon: Y2,
  CalendarOff: G2,
  CalendarOffIcon: G2,
  CalendarPlus: K2,
  CalendarPlus2: X2,
  CalendarPlus2Icon: X2,
  CalendarPlusIcon: K2,
  CalendarRange: Q2,
  CalendarRangeIcon: Q2,
  CalendarSearch: J2,
  CalendarSearchIcon: J2,
  CalendarX: td,
  CalendarX2: ed,
  CalendarX2Icon: ed,
  CalendarXIcon: td,
  Camera: od,
  CameraIcon: od,
  CameraOff: nd,
  CameraOffIcon: nd,
  CandlestickChart: rd,
  CandlestickChartIcon: rd,
  Candy: cd,
  CandyCane: id,
  CandyCaneIcon: id,
  CandyIcon: cd,
  CandyOff: ld,
  CandyOffIcon: ld,
  Cannabis: dd,
  CannabisIcon: dd,
  Captions: Ia,
  CaptionsIcon: Ia,
  CaptionsOff: sd,
  CaptionsOffIcon: sd,
  Car: pd,
  CarFront: ud,
  CarFrontIcon: ud,
  CarIcon: pd,
  CarTaxiFront: hd,
  CarTaxiFrontIcon: hd,
  Caravan: yd,
  CaravanIcon: yd,
  Carrot: kd,
  CarrotIcon: kd,
  CaseLower: fd,
  CaseLowerIcon: fd,
  CaseSensitive: vd,
  CaseSensitiveIcon: vd,
  CaseUpper: md,
  CaseUpperIcon: md,
  CassetteTape: gd,
  CassetteTapeIcon: gd,
  Cast: Md,
  CastIcon: Md,
  Castle: xd,
  CastleIcon: xd,
  Cat: bd,
  CatIcon: bd,
  Cctv: wd,
  CctvIcon: wd,
  Check: Ld,
  CheckCheck: Id,
  CheckCheckIcon: Id,
  CheckCircle: Ba,
  CheckCircle2: za,
  CheckCircle2Icon: za,
  CheckCircleIcon: Ba,
  CheckIcon: Ld,
  CheckSquare: mo,
  CheckSquare2: go,
  CheckSquare2Icon: go,
  CheckSquareIcon: mo,
  ChefHat: Sd,
  ChefHatIcon: Sd,
  Cherry: Cd,
  CherryIcon: Cd,
  ChevronDown: Ad,
  ChevronDownCircle: Ha,
  ChevronDownCircleIcon: Ha,
  ChevronDownIcon: Ad,
  ChevronDownSquare: Mo,
  ChevronDownSquareIcon: Mo,
  ChevronFirst: Pd,
  ChevronFirstIcon: Pd,
  ChevronLast: qd,
  ChevronLastIcon: qd,
  ChevronLeft: Td,
  ChevronLeftCircle: ja,
  ChevronLeftCircleIcon: ja,
  ChevronLeftIcon: Td,
  ChevronLeftSquare: xo,
  ChevronLeftSquareIcon: xo,
  ChevronRight: Dd,
  ChevronRightCircle: Va,
  ChevronRightCircleIcon: Va,
  ChevronRightIcon: Dd,
  ChevronRightSquare: bo,
  ChevronRightSquareIcon: bo,
  ChevronUp: _d,
  ChevronUpCircle: Oa,
  ChevronUpCircleIcon: Oa,
  ChevronUpIcon: _d,
  ChevronUpSquare: wo,
  ChevronUpSquareIcon: wo,
  ChevronsDown: zd,
  ChevronsDownIcon: zd,
  ChevronsDownUp: Bd,
  ChevronsDownUpIcon: Bd,
  ChevronsLeft: jd,
  ChevronsLeftIcon: jd,
  ChevronsLeftRight: Hd,
  ChevronsLeftRightIcon: Hd,
  ChevronsRight: Od,
  ChevronsRightIcon: Od,
  ChevronsRightLeft: Vd,
  ChevronsRightLeftIcon: Vd,
  ChevronsUp: Rd,
  ChevronsUpDown: $d,
  ChevronsUpDownIcon: $d,
  ChevronsUpIcon: Rd,
  Chrome: Fd,
  ChromeIcon: Fd,
  Church: Ud,
  ChurchIcon: Ud,
  Cigarette: Wd,
  CigaretteIcon: Wd,
  CigaretteOff: Ed,
  CigaretteOffIcon: Ed,
  Circle: ts,
  CircleAlert: La,
  CircleAlertIcon: La,
  CircleArrowDown: Sa,
  CircleArrowDownIcon: Sa,
  CircleArrowLeft: Ca,
  CircleArrowLeftIcon: Ca,
  CircleArrowOutDownLeft: Aa,
  CircleArrowOutDownLeftIcon: Aa,
  CircleArrowOutDownRight: Pa,
  CircleArrowOutDownRightIcon: Pa,
  CircleArrowOutUpLeft: qa,
  CircleArrowOutUpLeftIcon: qa,
  CircleArrowOutUpRight: Ta,
  CircleArrowOutUpRightIcon: Ta,
  CircleArrowRight: Da,
  CircleArrowRightIcon: Da,
  CircleArrowUp: _a,
  CircleArrowUpIcon: _a,
  CircleCheck: za,
  CircleCheckBig: Ba,
  CircleCheckBigIcon: Ba,
  CircleCheckIcon: za,
  CircleChevronDown: Ha,
  CircleChevronDownIcon: Ha,
  CircleChevronLeft: ja,
  CircleChevronLeftIcon: ja,
  CircleChevronRight: Va,
  CircleChevronRightIcon: Va,
  CircleChevronUp: Oa,
  CircleChevronUpIcon: Oa,
  CircleDashed: Nd,
  CircleDashedIcon: Nd,
  CircleDivide: $a,
  CircleDivideIcon: $a,
  CircleDollarSign: Zd,
  CircleDollarSignIcon: Zd,
  CircleDot: Gd,
  CircleDotDashed: Yd,
  CircleDotDashedIcon: Yd,
  CircleDotIcon: Gd,
  CircleEllipsis: Xd,
  CircleEllipsisIcon: Xd,
  CircleEqual: Kd,
  CircleEqualIcon: Kd,
  CircleFadingPlus: Qd,
  CircleFadingPlusIcon: Qd,
  CircleGauge: Ra,
  CircleGaugeIcon: Ra,
  CircleHelp: Fa,
  CircleHelpIcon: Fa,
  CircleIcon: ts,
  CircleMinus: Ua,
  CircleMinusIcon: Ua,
  CircleOff: Jd,
  CircleOffIcon: Jd,
  CircleParking: Wa,
  CircleParkingIcon: Wa,
  CircleParkingOff: Ea,
  CircleParkingOffIcon: Ea,
  CirclePause: Na,
  CirclePauseIcon: Na,
  CirclePercent: Za,
  CirclePercentIcon: Za,
  CirclePlay: Ya,
  CirclePlayIcon: Ya,
  CirclePlus: Ga,
  CirclePlusIcon: Ga,
  CirclePower: Xa,
  CirclePowerIcon: Xa,
  CircleSlash: es,
  CircleSlash2: Ka,
  CircleSlash2Icon: Ka,
  CircleSlashIcon: es,
  CircleSlashed: Ka,
  CircleSlashedIcon: Ka,
  CircleStop: Qa,
  CircleStopIcon: Qa,
  CircleUser: en,
  CircleUserIcon: en,
  CircleUserRound: Ja,
  CircleUserRoundIcon: Ja,
  CircleX: tn,
  CircleXIcon: tn,
  CircuitBoard: as,
  CircuitBoardIcon: as,
  Citrus: ns,
  CitrusIcon: ns,
  Clapperboard: os,
  ClapperboardIcon: os,
  Clipboard: ps,
  ClipboardCheck: rs,
  ClipboardCheckIcon: rs,
  ClipboardCopy: is,
  ClipboardCopyIcon: is,
  ClipboardEdit: nn,
  ClipboardEditIcon: nn,
  ClipboardIcon: ps,
  ClipboardList: ls,
  ClipboardListIcon: ls,
  ClipboardMinus: cs,
  ClipboardMinusIcon: cs,
  ClipboardPaste: ds,
  ClipboardPasteIcon: ds,
  ClipboardPen: nn,
  ClipboardPenIcon: nn,
  ClipboardPenLine: an,
  ClipboardPenLineIcon: an,
  ClipboardPlus: ss,
  ClipboardPlusIcon: ss,
  ClipboardSignature: an,
  ClipboardSignatureIcon: an,
  ClipboardType: us,
  ClipboardTypeIcon: us,
  ClipboardX: hs,
  ClipboardXIcon: hs,
  Clock: Ss,
  Clock1: ys,
  Clock10: ks,
  Clock10Icon: ks,
  Clock11: fs,
  Clock11Icon: fs,
  Clock12: vs,
  Clock12Icon: vs,
  Clock1Icon: ys,
  Clock2: ms,
  Clock2Icon: ms,
  Clock3: gs,
  Clock3Icon: gs,
  Clock4: Ms,
  Clock4Icon: Ms,
  Clock5: xs,
  Clock5Icon: xs,
  Clock6: bs,
  Clock6Icon: bs,
  Clock7: ws,
  Clock7Icon: ws,
  Clock8: Is,
  Clock8Icon: Is,
  Clock9: Ls,
  Clock9Icon: Ls,
  ClockIcon: Ss,
  Cloud: $s,
  CloudCog: Cs,
  CloudCogIcon: Cs,
  CloudDownload: on,
  CloudDownloadIcon: on,
  CloudDrizzle: As,
  CloudDrizzleIcon: As,
  CloudFog: Ps,
  CloudFogIcon: Ps,
  CloudHail: qs,
  CloudHailIcon: qs,
  CloudIcon: $s,
  CloudLightning: Ts,
  CloudLightningIcon: Ts,
  CloudMoon: _s,
  CloudMoonIcon: _s,
  CloudMoonRain: Ds,
  CloudMoonRainIcon: Ds,
  CloudOff: Bs,
  CloudOffIcon: Bs,
  CloudRain: Hs,
  CloudRainIcon: Hs,
  CloudRainWind: zs,
  CloudRainWindIcon: zs,
  CloudSnow: js,
  CloudSnowIcon: js,
  CloudSun: Os,
  CloudSunIcon: Os,
  CloudSunRain: Vs,
  CloudSunRainIcon: Vs,
  CloudUpload: rn,
  CloudUploadIcon: rn,
  Cloudy: Rs,
  CloudyIcon: Rs,
  Clover: Fs,
  CloverIcon: Fs,
  Club: Us,
  ClubIcon: Us,
  Code: Es,
  Code2: ln,
  Code2Icon: ln,
  CodeIcon: Es,
  CodeSquare: Io,
  CodeSquareIcon: Io,
  CodeXml: ln,
  CodeXmlIcon: ln,
  Codepen: Ws,
  CodepenIcon: Ws,
  Codesandbox: Ns,
  CodesandboxIcon: Ns,
  Coffee: Zs,
  CoffeeIcon: Zs,
  Cog: Ys,
  CogIcon: Ys,
  Coins: Gs,
  CoinsIcon: Gs,
  Columns: cn,
  Columns2: cn,
  Columns2Icon: cn,
  Columns3: dn,
  Columns3Icon: dn,
  Columns4: Xs,
  Columns4Icon: Xs,
  ColumnsIcon: cn,
  Combine: Ks,
  CombineIcon: Ks,
  Command: Qs,
  CommandIcon: Qs,
  Compass: Js,
  CompassIcon: Js,
  Component: e0,
  ComponentIcon: e0,
  Computer: t0,
  ComputerIcon: t0,
  ConciergeBell: a0,
  ConciergeBellIcon: a0,
  Cone: n0,
  ConeIcon: n0,
  Construction: o0,
  ConstructionIcon: o0,
  Contact: r0,
  Contact2: sn,
  Contact2Icon: sn,
  ContactIcon: r0,
  ContactRound: sn,
  ContactRoundIcon: sn,
  Container: i0,
  ContainerIcon: i0,
  Contrast: l0,
  ContrastIcon: l0,
  Cookie: c0,
  CookieIcon: c0,
  CookingPot: d0,
  CookingPotIcon: d0,
  Copy: k0,
  CopyCheck: s0,
  CopyCheckIcon: s0,
  CopyIcon: k0,
  CopyMinus: u0,
  CopyMinusIcon: u0,
  CopyPlus: h0,
  CopyPlusIcon: h0,
  CopySlash: p0,
  CopySlashIcon: p0,
  CopyX: y0,
  CopyXIcon: y0,
  Copyleft: f0,
  CopyleftIcon: f0,
  Copyright: v0,
  CopyrightIcon: v0,
  CornerDownLeft: m0,
  CornerDownLeftIcon: m0,
  CornerDownRight: g0,
  CornerDownRightIcon: g0,
  CornerLeftDown: M0,
  CornerLeftDownIcon: M0,
  CornerLeftUp: x0,
  CornerLeftUpIcon: x0,
  CornerRightDown: b0,
  CornerRightDownIcon: b0,
  CornerRightUp: w0,
  CornerRightUpIcon: w0,
  CornerUpLeft: I0,
  CornerUpLeftIcon: I0,
  CornerUpRight: L0,
  CornerUpRightIcon: L0,
  Cpu: S0,
  CpuIcon: S0,
  CreativeCommons: C0,
  CreativeCommonsIcon: C0,
  CreditCard: A0,
  CreditCardIcon: A0,
  Croissant: P0,
  CroissantIcon: P0,
  Crop: q0,
  CropIcon: q0,
  Cross: T0,
  CrossIcon: T0,
  Crosshair: D0,
  CrosshairIcon: D0,
  Crown: _0,
  CrownIcon: _0,
  Cuboid: B0,
  CuboidIcon: B0,
  CupSoda: z0,
  CupSodaIcon: z0,
  CurlyBraces: wa,
  CurlyBracesIcon: wa,
  Currency: H0,
  CurrencyIcon: H0,
  Cylinder: j0,
  CylinderIcon: j0,
  Database: $0,
  DatabaseBackup: V0,
  DatabaseBackupIcon: V0,
  DatabaseIcon: $0,
  DatabaseZap: O0,
  DatabaseZapIcon: O0,
  Delete: R0,
  DeleteIcon: R0,
  Dessert: F0,
  DessertIcon: F0,
  Diameter: U0,
  DiameterIcon: U0,
  Diamond: E0,
  DiamondIcon: E0,
  DiamondPercent: un,
  DiamondPercentIcon: un,
  Dice1: W0,
  Dice1Icon: W0,
  Dice2: N0,
  Dice2Icon: N0,
  Dice3: Z0,
  Dice3Icon: Z0,
  Dice4: Y0,
  Dice4Icon: Y0,
  Dice5: G0,
  Dice5Icon: G0,
  Dice6: X0,
  Dice6Icon: X0,
  Dices: K0,
  DicesIcon: K0,
  Diff: Q0,
  DiffIcon: Q0,
  Disc: au,
  Disc2: J0,
  Disc2Icon: J0,
  Disc3: eu,
  Disc3Icon: eu,
  DiscAlbum: tu,
  DiscAlbumIcon: tu,
  DiscIcon: au,
  Divide: nu,
  DivideCircle: $a,
  DivideCircleIcon: $a,
  DivideIcon: nu,
  DivideSquare: Co,
  DivideSquareIcon: Co,
  Dna: ru,
  DnaIcon: ru,
  DnaOff: ou,
  DnaOffIcon: ou,
  Dock: iu,
  DockIcon: iu,
  Dog: lu,
  DogIcon: lu,
  DollarSign: cu,
  DollarSignIcon: cu,
  Donut: du,
  DonutIcon: du,
  DoorClosed: su,
  DoorClosedIcon: su,
  DoorOpen: uu,
  DoorOpenIcon: uu,
  Dot: hu,
  DotIcon: hu,
  DotSquare: Ao,
  DotSquareIcon: Ao,
  Download: pu,
  DownloadCloud: on,
  DownloadCloudIcon: on,
  DownloadIcon: pu,
  DraftingCompass: yu,
  DraftingCompassIcon: yu,
  Drama: ku,
  DramaIcon: ku,
  Dribbble: fu,
  DribbbleIcon: fu,
  Drill: vu,
  DrillIcon: vu,
  Droplet: mu,
  DropletIcon: mu,
  Droplets: gu,
  DropletsIcon: gu,
  Drum: Mu,
  DrumIcon: Mu,
  Drumstick: xu,
  DrumstickIcon: xu,
  Dumbbell: bu,
  DumbbellIcon: bu,
  Ear: Iu,
  EarIcon: Iu,
  EarOff: wu,
  EarOffIcon: wu,
  Earth: hn,
  EarthIcon: hn,
  EarthLock: Lu,
  EarthLockIcon: Lu,
  Eclipse: Su,
  EclipseIcon: Su,
  Edit: vt,
  Edit2: Nn,
  Edit2Icon: Nn,
  Edit3: Wn,
  Edit3Icon: Wn,
  EditIcon: vt,
  Egg: Pu,
  EggFried: Cu,
  EggFriedIcon: Cu,
  EggIcon: Pu,
  EggOff: Au,
  EggOffIcon: Au,
  Ellipsis: yn,
  EllipsisIcon: yn,
  EllipsisVertical: pn,
  EllipsisVerticalIcon: pn,
  Equal: Tu,
  EqualIcon: Tu,
  EqualNot: qu,
  EqualNotIcon: qu,
  EqualSquare: Po,
  EqualSquareIcon: Po,
  Eraser: Du,
  EraserIcon: Du,
  Euro: _u,
  EuroIcon: _u,
  Expand: Bu,
  ExpandIcon: Bu,
  ExternalLink: zu,
  ExternalLinkIcon: zu,
  Eye: ju,
  EyeIcon: ju,
  EyeOff: Hu,
  EyeOffIcon: Hu,
  Facebook: Vu,
  FacebookIcon: Vu,
  Factory: Ou,
  FactoryIcon: Ou,
  Fan: $u,
  FanIcon: $u,
  FastForward: Ru,
  FastForwardIcon: Ru,
  Feather: Fu,
  FeatherIcon: Fu,
  Fence: Uu,
  FenceIcon: Uu,
  FerrisWheel: Eu,
  FerrisWheelIcon: Eu,
  Figma: Wu,
  FigmaIcon: Wu,
  File: Wh,
  FileArchive: Nu,
  FileArchiveIcon: Nu,
  FileAudio: Yu,
  FileAudio2: Zu,
  FileAudio2Icon: Zu,
  FileAudioIcon: Yu,
  FileAxis3D: kn,
  FileAxis3DIcon: kn,
  FileAxis3d: kn,
  FileAxis3dIcon: kn,
  FileBadge: Xu,
  FileBadge2: Gu,
  FileBadge2Icon: Gu,
  FileBadgeIcon: Xu,
  FileBarChart: Qu,
  FileBarChart2: Ku,
  FileBarChart2Icon: Ku,
  FileBarChartIcon: Qu,
  FileBox: Ju,
  FileBoxIcon: Ju,
  FileCheck: th,
  FileCheck2: eh,
  FileCheck2Icon: eh,
  FileCheckIcon: th,
  FileClock: ah,
  FileClockIcon: ah,
  FileCode: oh,
  FileCode2: nh,
  FileCode2Icon: nh,
  FileCodeIcon: oh,
  FileCog: fn,
  FileCog2: fn,
  FileCog2Icon: fn,
  FileCogIcon: fn,
  FileDiff: rh,
  FileDiffIcon: rh,
  FileDigit: ih,
  FileDigitIcon: ih,
  FileDown: lh,
  FileDownIcon: lh,
  FileEdit: mn,
  FileEditIcon: mn,
  FileHeart: ch,
  FileHeartIcon: ch,
  FileIcon: Wh,
  FileImage: dh,
  FileImageIcon: dh,
  FileInput: sh,
  FileInputIcon: sh,
  FileJson: hh,
  FileJson2: uh,
  FileJson2Icon: uh,
  FileJsonIcon: hh,
  FileKey: yh,
  FileKey2: ph,
  FileKey2Icon: ph,
  FileKeyIcon: yh,
  FileLineChart: kh,
  FileLineChartIcon: kh,
  FileLock: vh,
  FileLock2: fh,
  FileLock2Icon: fh,
  FileLockIcon: vh,
  FileMinus: gh,
  FileMinus2: mh,
  FileMinus2Icon: mh,
  FileMinusIcon: gh,
  FileMusic: Mh,
  FileMusicIcon: Mh,
  FileOutput: xh,
  FileOutputIcon: xh,
  FilePen: mn,
  FilePenIcon: mn,
  FilePenLine: vn,
  FilePenLineIcon: vn,
  FilePieChart: bh,
  FilePieChartIcon: bh,
  FilePlus: Ih,
  FilePlus2: wh,
  FilePlus2Icon: wh,
  FilePlusIcon: Ih,
  FileQuestion: Lh,
  FileQuestionIcon: Lh,
  FileScan: Sh,
  FileScanIcon: Sh,
  FileSearch: Ah,
  FileSearch2: Ch,
  FileSearch2Icon: Ch,
  FileSearchIcon: Ah,
  FileSignature: vn,
  FileSignatureIcon: vn,
  FileSliders: Ph,
  FileSlidersIcon: Ph,
  FileSpreadsheet: qh,
  FileSpreadsheetIcon: qh,
  FileStack: Th,
  FileStackIcon: Th,
  FileSymlink: Dh,
  FileSymlinkIcon: Dh,
  FileTerminal: _h,
  FileTerminalIcon: _h,
  FileText: Bh,
  FileTextIcon: Bh,
  FileType: Hh,
  FileType2: zh,
  FileType2Icon: zh,
  FileTypeIcon: Hh,
  FileUp: jh,
  FileUpIcon: jh,
  FileVideo: Oh,
  FileVideo2: Vh,
  FileVideo2Icon: Vh,
  FileVideoIcon: Oh,
  FileVolume: Rh,
  FileVolume2: $h,
  FileVolume2Icon: $h,
  FileVolumeIcon: Rh,
  FileWarning: Fh,
  FileWarningIcon: Fh,
  FileX: Eh,
  FileX2: Uh,
  FileX2Icon: Uh,
  FileXIcon: Eh,
  Files: Nh,
  FilesIcon: Nh,
  Film: Zh,
  FilmIcon: Zh,
  Filter: Gh,
  FilterIcon: Gh,
  FilterX: Yh,
  FilterXIcon: Yh,
  Fingerprint: Xh,
  FingerprintIcon: Xh,
  FireExtinguisher: Kh,
  FireExtinguisherIcon: Kh,
  Fish: ep,
  FishIcon: ep,
  FishOff: Qh,
  FishOffIcon: Qh,
  FishSymbol: Jh,
  FishSymbolIcon: Jh,
  Flag: op,
  FlagIcon: op,
  FlagOff: tp,
  FlagOffIcon: tp,
  FlagTriangleLeft: ap,
  FlagTriangleLeftIcon: ap,
  FlagTriangleRight: np,
  FlagTriangleRightIcon: np,
  Flame: ip,
  FlameIcon: ip,
  FlameKindling: rp,
  FlameKindlingIcon: rp,
  Flashlight: cp,
  FlashlightIcon: cp,
  FlashlightOff: lp,
  FlashlightOffIcon: lp,
  FlaskConical: sp,
  FlaskConicalIcon: sp,
  FlaskConicalOff: dp,
  FlaskConicalOffIcon: dp,
  FlaskRound: up,
  FlaskRoundIcon: up,
  FlipHorizontal: pp,
  FlipHorizontal2: hp,
  FlipHorizontal2Icon: hp,
  FlipHorizontalIcon: pp,
  FlipVertical: kp,
  FlipVertical2: yp,
  FlipVertical2Icon: yp,
  FlipVerticalIcon: kp,
  Flower: vp,
  Flower2: fp,
  Flower2Icon: fp,
  FlowerIcon: vp,
  Focus: mp,
  FocusIcon: mp,
  FoldHorizontal: gp,
  FoldHorizontalIcon: gp,
  FoldVertical: Mp,
  FoldVerticalIcon: Mp,
  Folder: Zp,
  FolderArchive: xp,
  FolderArchiveIcon: xp,
  FolderCheck: bp,
  FolderCheckIcon: bp,
  FolderClock: wp,
  FolderClockIcon: wp,
  FolderClosed: Ip,
  FolderClosedIcon: Ip,
  FolderCog: gn,
  FolderCog2: gn,
  FolderCog2Icon: gn,
  FolderCogIcon: gn,
  FolderDot: Lp,
  FolderDotIcon: Lp,
  FolderDown: Sp,
  FolderDownIcon: Sp,
  FolderEdit: Mn,
  FolderEditIcon: Mn,
  FolderGit: Ap,
  FolderGit2: Cp,
  FolderGit2Icon: Cp,
  FolderGitIcon: Ap,
  FolderHeart: Pp,
  FolderHeartIcon: Pp,
  FolderIcon: Zp,
  FolderInput: qp,
  FolderInputIcon: qp,
  FolderKanban: Tp,
  FolderKanbanIcon: Tp,
  FolderKey: Dp,
  FolderKeyIcon: Dp,
  FolderLock: _p,
  FolderLockIcon: _p,
  FolderMinus: Bp,
  FolderMinusIcon: Bp,
  FolderOpen: Hp,
  FolderOpenDot: zp,
  FolderOpenDotIcon: zp,
  FolderOpenIcon: Hp,
  FolderOutput: jp,
  FolderOutputIcon: jp,
  FolderPen: Mn,
  FolderPenIcon: Mn,
  FolderPlus: Vp,
  FolderPlusIcon: Vp,
  FolderRoot: Op,
  FolderRootIcon: Op,
  FolderSearch: Rp,
  FolderSearch2: $p,
  FolderSearch2Icon: $p,
  FolderSearchIcon: Rp,
  FolderSymlink: Fp,
  FolderSymlinkIcon: Fp,
  FolderSync: Up,
  FolderSyncIcon: Up,
  FolderTree: Ep,
  FolderTreeIcon: Ep,
  FolderUp: Wp,
  FolderUpIcon: Wp,
  FolderX: Np,
  FolderXIcon: Np,
  Folders: Yp,
  FoldersIcon: Yp,
  Footprints: Gp,
  FootprintsIcon: Gp,
  Forklift: Xp,
  ForkliftIcon: Xp,
  FormInput: Zn,
  FormInputIcon: Zn,
  Forward: Kp,
  ForwardIcon: Kp,
  Frame: Qp,
  FrameIcon: Qp,
  Framer: Jp,
  FramerIcon: Jp,
  Frown: ey,
  FrownIcon: ey,
  Fuel: ty,
  FuelIcon: ty,
  Fullscreen: ay,
  FullscreenIcon: ay,
  FunctionSquare: qo,
  FunctionSquareIcon: qo,
  GalleryHorizontal: oy,
  GalleryHorizontalEnd: ny,
  GalleryHorizontalEndIcon: ny,
  GalleryHorizontalIcon: oy,
  GalleryThumbnails: ry,
  GalleryThumbnailsIcon: ry,
  GalleryVertical: ly,
  GalleryVerticalEnd: iy,
  GalleryVerticalEndIcon: iy,
  GalleryVerticalIcon: ly,
  Gamepad: dy,
  Gamepad2: cy,
  Gamepad2Icon: cy,
  GamepadIcon: dy,
  GanttChart: sy,
  GanttChartIcon: sy,
  GanttChartSquare: To,
  GanttChartSquareIcon: To,
  Gauge: uy,
  GaugeCircle: Ra,
  GaugeCircleIcon: Ra,
  GaugeIcon: uy,
  Gavel: hy,
  GavelIcon: hy,
  Gem: py,
  GemIcon: py,
  Ghost: yy,
  GhostIcon: yy,
  Gift: ky,
  GiftIcon: ky,
  GitBranch: vy,
  GitBranchIcon: vy,
  GitBranchPlus: fy,
  GitBranchPlusIcon: fy,
  GitCommit: xn,
  GitCommitHorizontal: xn,
  GitCommitHorizontalIcon: xn,
  GitCommitIcon: xn,
  GitCommitVertical: my,
  GitCommitVerticalIcon: my,
  GitCompare: My,
  GitCompareArrows: gy,
  GitCompareArrowsIcon: gy,
  GitCompareIcon: My,
  GitFork: xy,
  GitForkIcon: xy,
  GitGraph: by,
  GitGraphIcon: by,
  GitMerge: wy,
  GitMergeIcon: wy,
  GitPullRequest: Py,
  GitPullRequestArrow: Iy,
  GitPullRequestArrowIcon: Iy,
  GitPullRequestClosed: Ly,
  GitPullRequestClosedIcon: Ly,
  GitPullRequestCreate: Cy,
  GitPullRequestCreateArrow: Sy,
  GitPullRequestCreateArrowIcon: Sy,
  GitPullRequestCreateIcon: Cy,
  GitPullRequestDraft: Ay,
  GitPullRequestDraftIcon: Ay,
  GitPullRequestIcon: Py,
  Github: qy,
  GithubIcon: qy,
  Gitlab: Ty,
  GitlabIcon: Ty,
  GlassWater: Dy,
  GlassWaterIcon: Dy,
  Glasses: _y,
  GlassesIcon: _y,
  Globe: zy,
  Globe2: hn,
  Globe2Icon: hn,
  GlobeIcon: zy,
  GlobeLock: By,
  GlobeLockIcon: By,
  Goal: Hy,
  GoalIcon: Hy,
  Grab: jy,
  GrabIcon: jy,
  GraduationCap: Vy,
  GraduationCapIcon: Vy,
  Grape: Oy,
  GrapeIcon: Oy,
  Grid: zt,
  Grid2X2: bn,
  Grid2X2Icon: bn,
  Grid2x2: bn,
  Grid2x2Icon: bn,
  Grid3X3: zt,
  Grid3X3Icon: zt,
  Grid3x3: zt,
  Grid3x3Icon: zt,
  GridIcon: zt,
  Grip: Fy,
  GripHorizontal: $y,
  GripHorizontalIcon: $y,
  GripIcon: Fy,
  GripVertical: Ry,
  GripVerticalIcon: Ry,
  Group: Uy,
  GroupIcon: Uy,
  Guitar: Ey,
  GuitarIcon: Ey,
  Ham: Wy,
  HamIcon: Wy,
  Hammer: Ny,
  HammerIcon: Ny,
  Hand: Ky,
  HandCoins: Zy,
  HandCoinsIcon: Zy,
  HandHeart: Yy,
  HandHeartIcon: Yy,
  HandHelping: wn,
  HandHelpingIcon: wn,
  HandIcon: Ky,
  HandMetal: Gy,
  HandMetalIcon: Gy,
  HandPlatter: Xy,
  HandPlatterIcon: Xy,
  Handshake: Qy,
  HandshakeIcon: Qy,
  HardDrive: tk,
  HardDriveDownload: Jy,
  HardDriveDownloadIcon: Jy,
  HardDriveIcon: tk,
  HardDriveUpload: ek,
  HardDriveUploadIcon: ek,
  HardHat: ak,
  HardHatIcon: ak,
  Hash: nk,
  HashIcon: nk,
  Haze: ok,
  HazeIcon: ok,
  HdmiPort: rk,
  HdmiPortIcon: rk,
  Heading: hk,
  Heading1: ik,
  Heading1Icon: ik,
  Heading2: lk,
  Heading2Icon: lk,
  Heading3: ck,
  Heading3Icon: ck,
  Heading4: dk,
  Heading4Icon: dk,
  Heading5: sk,
  Heading5Icon: sk,
  Heading6: uk,
  Heading6Icon: uk,
  HeadingIcon: hk,
  Headphones: pk,
  HeadphonesIcon: pk,
  Headset: yk,
  HeadsetIcon: yk,
  Heart: gk,
  HeartCrack: kk,
  HeartCrackIcon: kk,
  HeartHandshake: fk,
  HeartHandshakeIcon: fk,
  HeartIcon: gk,
  HeartOff: vk,
  HeartOffIcon: vk,
  HeartPulse: mk,
  HeartPulseIcon: mk,
  Heater: Mk,
  HeaterIcon: Mk,
  HelpCircle: Fa,
  HelpCircleIcon: Fa,
  HelpingHand: wn,
  HelpingHandIcon: wn,
  Hexagon: xk,
  HexagonIcon: xk,
  Highlighter: bk,
  HighlighterIcon: bk,
  History: wk,
  HistoryIcon: wk,
  Home: Ik,
  HomeIcon: Ik,
  Hop: Sk,
  HopIcon: Sk,
  HopOff: Lk,
  HopOffIcon: Lk,
  Hospital: Ck,
  HospitalIcon: Ck,
  Hotel: Ak,
  HotelIcon: Ak,
  Hourglass: Pk,
  HourglassIcon: Pk,
  IceCream: Ln,
  IceCream2: In,
  IceCream2Icon: In,
  IceCreamBowl: In,
  IceCreamBowlIcon: In,
  IceCreamCone: Ln,
  IceCreamConeIcon: Ln,
  IceCreamIcon: Ln,
  Image: zk,
  ImageDown: qk,
  ImageDownIcon: qk,
  ImageIcon: zk,
  ImageMinus: Tk,
  ImageMinusIcon: Tk,
  ImageOff: Dk,
  ImageOffIcon: Dk,
  ImagePlus: _k,
  ImagePlusIcon: _k,
  ImageUp: Bk,
  ImageUpIcon: Bk,
  Images: Hk,
  ImagesIcon: Hk,
  Import: jk,
  ImportIcon: jk,
  Inbox: Vk,
  InboxIcon: Vk,
  Indent: Cn,
  IndentDecrease: Sn,
  IndentDecreaseIcon: Sn,
  IndentIcon: Cn,
  IndentIncrease: Cn,
  IndentIncreaseIcon: Cn,
  IndianRupee: Ok,
  IndianRupeeIcon: Ok,
  Infinity: $k,
  InfinityIcon: $k,
  Info: Rk,
  InfoIcon: Rk,
  Inspect: jo,
  InspectIcon: jo,
  InspectionPanel: Fk,
  InspectionPanelIcon: Fk,
  Instagram: Uk,
  InstagramIcon: Uk,
  Italic: Ek,
  ItalicIcon: Ek,
  IterationCcw: Wk,
  IterationCcwIcon: Wk,
  IterationCw: Nk,
  IterationCwIcon: Nk,
  JapaneseYen: Zk,
  JapaneseYenIcon: Zk,
  Joystick: Yk,
  JoystickIcon: Yk,
  Kanban: Gk,
  KanbanIcon: Gk,
  KanbanSquare: Do,
  KanbanSquareDashed: Lo,
  KanbanSquareDashedIcon: Lo,
  KanbanSquareIcon: Do,
  Key: Qk,
  KeyIcon: Qk,
  KeyRound: Xk,
  KeyRoundIcon: Xk,
  KeySquare: Kk,
  KeySquareIcon: Kk,
  Keyboard: e4,
  KeyboardIcon: e4,
  KeyboardMusic: Jk,
  KeyboardMusicIcon: Jk,
  Lamp: i4,
  LampCeiling: t4,
  LampCeilingIcon: t4,
  LampDesk: a4,
  LampDeskIcon: a4,
  LampFloor: n4,
  LampFloorIcon: n4,
  LampIcon: i4,
  LampWallDown: o4,
  LampWallDownIcon: o4,
  LampWallUp: r4,
  LampWallUpIcon: r4,
  LandPlot: l4,
  LandPlotIcon: l4,
  Landmark: c4,
  LandmarkIcon: c4,
  Languages: d4,
  LanguagesIcon: d4,
  Laptop: s4,
  Laptop2: An,
  Laptop2Icon: An,
  LaptopIcon: s4,
  LaptopMinimal: An,
  LaptopMinimalIcon: An,
  Lasso: h4,
  LassoIcon: h4,
  LassoSelect: u4,
  LassoSelectIcon: u4,
  Laugh: p4,
  LaughIcon: p4,
  Layers: f4,
  Layers2: y4,
  Layers2Icon: y4,
  Layers3: k4,
  Layers3Icon: k4,
  LayersIcon: f4,
  Layout: En,
  LayoutDashboard: v4,
  LayoutDashboardIcon: v4,
  LayoutGrid: m4,
  LayoutGridIcon: m4,
  LayoutIcon: En,
  LayoutList: g4,
  LayoutListIcon: g4,
  LayoutPanelLeft: M4,
  LayoutPanelLeftIcon: M4,
  LayoutPanelTop: x4,
  LayoutPanelTopIcon: x4,
  LayoutTemplate: b4,
  LayoutTemplateIcon: b4,
  Leaf: w4,
  LeafIcon: w4,
  LeafyGreen: I4,
  LeafyGreenIcon: I4,
  Library: S4,
  LibraryBig: L4,
  LibraryBigIcon: L4,
  LibraryIcon: S4,
  LibrarySquare: _o,
  LibrarySquareIcon: _o,
  LifeBuoy: C4,
  LifeBuoyIcon: C4,
  Ligature: A4,
  LigatureIcon: A4,
  Lightbulb: q4,
  LightbulbIcon: q4,
  LightbulbOff: P4,
  LightbulbOffIcon: P4,
  LineChart: T4,
  LineChartIcon: T4,
  Link: B4,
  Link2: _4,
  Link2Icon: _4,
  Link2Off: D4,
  Link2OffIcon: D4,
  LinkIcon: B4,
  Linkedin: z4,
  LinkedinIcon: z4,
  List: X4,
  ListChecks: H4,
  ListChecksIcon: H4,
  ListCollapse: j4,
  ListCollapseIcon: j4,
  ListEnd: V4,
  ListEndIcon: V4,
  ListFilter: O4,
  ListFilterIcon: O4,
  ListIcon: X4,
  ListMinus: $4,
  ListMinusIcon: $4,
  ListMusic: R4,
  ListMusicIcon: R4,
  ListOrdered: F4,
  ListOrderedIcon: F4,
  ListPlus: U4,
  ListPlusIcon: U4,
  ListRestart: E4,
  ListRestartIcon: E4,
  ListStart: W4,
  ListStartIcon: W4,
  ListTodo: N4,
  ListTodoIcon: N4,
  ListTree: Z4,
  ListTreeIcon: Z4,
  ListVideo: Y4,
  ListVideoIcon: Y4,
  ListX: G4,
  ListXIcon: G4,
  Loader: K4,
  Loader2: Pn,
  Loader2Icon: Pn,
  LoaderCircle: Pn,
  LoaderCircleIcon: Pn,
  LoaderIcon: K4,
  Locate: ef,
  LocateFixed: Q4,
  LocateFixedIcon: Q4,
  LocateIcon: ef,
  LocateOff: J4,
  LocateOffIcon: J4,
  Lock: af,
  LockIcon: af,
  LockKeyhole: tf,
  LockKeyholeIcon: tf,
  LockKeyholeOpen: qn,
  LockKeyholeOpenIcon: qn,
  LockOpen: Tn,
  LockOpenIcon: Tn,
  LogIn: nf,
  LogInIcon: nf,
  LogOut: of,
  LogOutIcon: of,
  Lollipop: rf,
  LollipopIcon: rf,
  LucideAArrowDown: T1,
  LucideAArrowUp: D1,
  LucideALargeSmall: _1,
  LucideAccessibility: B1,
  LucideActivity: z1,
  LucideActivitySquare: ao,
  LucideAirVent: H1,
  LucideAirplay: j1,
  LucideAlarmCheck: da,
  LucideAlarmClock: O1,
  LucideAlarmClockCheck: da,
  LucideAlarmClockMinus: sa,
  LucideAlarmClockOff: V1,
  LucideAlarmClockPlus: ua,
  LucideAlarmMinus: sa,
  LucideAlarmPlus: ua,
  LucideAlarmSmoke: $1,
  LucideAlbum: R1,
  LucideAlertCircle: La,
  LucideAlertOctagon: Bn,
  LucideAlertTriangle: rr,
  LucideAlignCenter: E1,
  LucideAlignCenterHorizontal: F1,
  LucideAlignCenterVertical: U1,
  LucideAlignEndHorizontal: W1,
  LucideAlignEndVertical: N1,
  LucideAlignHorizontalDistributeCenter: Z1,
  LucideAlignHorizontalDistributeEnd: Y1,
  LucideAlignHorizontalDistributeStart: G1,
  LucideAlignHorizontalJustifyCenter: X1,
  LucideAlignHorizontalJustifyEnd: K1,
  LucideAlignHorizontalJustifyStart: Q1,
  LucideAlignHorizontalSpaceAround: J1,
  LucideAlignHorizontalSpaceBetween: ei,
  LucideAlignJustify: ti,
  LucideAlignLeft: ai,
  LucideAlignRight: ni,
  LucideAlignStartHorizontal: oi,
  LucideAlignStartVertical: ri,
  LucideAlignVerticalDistributeCenter: ii,
  LucideAlignVerticalDistributeEnd: li,
  LucideAlignVerticalDistributeStart: ci,
  LucideAlignVerticalJustifyCenter: di,
  LucideAlignVerticalJustifyEnd: si,
  LucideAlignVerticalJustifyStart: ui,
  LucideAlignVerticalSpaceAround: hi,
  LucideAlignVerticalSpaceBetween: pi,
  LucideAmbulance: yi,
  LucideAmpersand: ki,
  LucideAmpersands: fi,
  LucideAnchor: vi,
  LucideAngry: mi,
  LucideAnnoyed: gi,
  LucideAntenna: Mi,
  LucideAnvil: xi,
  LucideAperture: bi,
  LucideAppWindow: Ii,
  LucideAppWindowMac: wi,
  LucideApple: Li,
  LucideArchive: Ai,
  LucideArchiveRestore: Si,
  LucideArchiveX: Ci,
  LucideAreaChart: Pi,
  LucideArmchair: qi,
  LucideArrowBigDown: Di,
  LucideArrowBigDownDash: Ti,
  LucideArrowBigLeft: Bi,
  LucideArrowBigLeftDash: _i,
  LucideArrowBigRight: Hi,
  LucideArrowBigRightDash: zi,
  LucideArrowBigUp: Vi,
  LucideArrowBigUpDash: ji,
  LucideArrowDown: Yi,
  LucideArrowDown01: Oi,
  LucideArrowDown10: $i,
  LucideArrowDownAZ: ha,
  LucideArrowDownAz: ha,
  LucideArrowDownCircle: Sa,
  LucideArrowDownFromLine: Ri,
  LucideArrowDownLeft: Fi,
  LucideArrowDownLeftFromCircle: Aa,
  LucideArrowDownLeftFromSquare: lo,
  LucideArrowDownLeftSquare: no,
  LucideArrowDownNarrowWide: Ui,
  LucideArrowDownRight: Ei,
  LucideArrowDownRightFromCircle: Pa,
  LucideArrowDownRightFromSquare: co,
  LucideArrowDownRightSquare: oo,
  LucideArrowDownSquare: ro,
  LucideArrowDownToDot: Wi,
  LucideArrowDownToLine: Ni,
  LucideArrowDownUp: Zi,
  LucideArrowDownWideNarrow: pa,
  LucideArrowDownZA: ya,
  LucideArrowDownZa: ya,
  LucideArrowLeft: Qi,
  LucideArrowLeftCircle: Ca,
  LucideArrowLeftFromLine: Gi,
  LucideArrowLeftRight: Xi,
  LucideArrowLeftSquare: io,
  LucideArrowLeftToLine: Ki,
  LucideArrowRight: al,
  LucideArrowRightCircle: Da,
  LucideArrowRightFromLine: Ji,
  LucideArrowRightLeft: el,
  LucideArrowRightSquare: ho,
  LucideArrowRightToLine: tl,
  LucideArrowUp: hl,
  LucideArrowUp01: nl,
  LucideArrowUp10: ol,
  LucideArrowUpAZ: ka,
  LucideArrowUpAz: ka,
  LucideArrowUpCircle: _a,
  LucideArrowUpDown: rl,
  LucideArrowUpFromDot: il,
  LucideArrowUpFromLine: ll,
  LucideArrowUpLeft: cl,
  LucideArrowUpLeftFromCircle: qa,
  LucideArrowUpLeftFromSquare: so,
  LucideArrowUpLeftSquare: po,
  LucideArrowUpNarrowWide: fa,
  LucideArrowUpRight: dl,
  LucideArrowUpRightFromCircle: Ta,
  LucideArrowUpRightFromSquare: uo,
  LucideArrowUpRightSquare: yo,
  LucideArrowUpSquare: ko,
  LucideArrowUpToLine: sl,
  LucideArrowUpWideNarrow: ul,
  LucideArrowUpZA: va,
  LucideArrowUpZa: va,
  LucideArrowsUpFromLine: pl,
  LucideAsterisk: yl,
  LucideAsteriskSquare: fo,
  LucideAtSign: kl,
  LucideAtom: fl,
  LucideAudioLines: vl,
  LucideAudioWaveform: ml,
  LucideAward: gl,
  LucideAxe: Ml,
  LucideAxis3D: ma,
  LucideAxis3d: ma,
  LucideBaby: xl,
  LucideBackpack: bl,
  LucideBadge: Vl,
  LucideBadgeAlert: wl,
  LucideBadgeCent: Il,
  LucideBadgeCheck: ga,
  LucideBadgeDollarSign: Ll,
  LucideBadgeEuro: Sl,
  LucideBadgeHelp: Cl,
  LucideBadgeIndianRupee: Al,
  LucideBadgeInfo: Pl,
  LucideBadgeJapaneseYen: ql,
  LucideBadgeMinus: Tl,
  LucideBadgePercent: Dl,
  LucideBadgePlus: _l,
  LucideBadgePoundSterling: Bl,
  LucideBadgeRussianRuble: zl,
  LucideBadgeSwissFranc: Hl,
  LucideBadgeX: jl,
  LucideBaggageClaim: Ol,
  LucideBan: $l,
  LucideBanana: Rl,
  LucideBanknote: Fl,
  LucideBarChart: Gl,
  LucideBarChart2: Ul,
  LucideBarChart3: El,
  LucideBarChart4: Wl,
  LucideBarChartBig: Nl,
  LucideBarChartHorizontal: Yl,
  LucideBarChartHorizontalBig: Zl,
  LucideBarcode: Xl,
  LucideBaseline: Kl,
  LucideBath: Ql,
  LucideBattery: oc,
  LucideBatteryCharging: Jl,
  LucideBatteryFull: ec,
  LucideBatteryLow: tc,
  LucideBatteryMedium: ac,
  LucideBatteryWarning: nc,
  LucideBeaker: rc,
  LucideBean: lc,
  LucideBeanOff: ic,
  LucideBed: sc,
  LucideBedDouble: cc,
  LucideBedSingle: dc,
  LucideBeef: uc,
  LucideBeer: pc,
  LucideBeerOff: hc,
  LucideBell: Mc,
  LucideBellDot: yc,
  LucideBellElectric: kc,
  LucideBellMinus: fc,
  LucideBellOff: vc,
  LucideBellPlus: mc,
  LucideBellRing: gc,
  LucideBetweenHorizonalEnd: Ma,
  LucideBetweenHorizonalStart: xa,
  LucideBetweenHorizontalEnd: Ma,
  LucideBetweenHorizontalStart: xa,
  LucideBetweenVerticalEnd: xc,
  LucideBetweenVerticalStart: bc,
  LucideBike: wc,
  LucideBinary: Ic,
  LucideBiohazard: Lc,
  LucideBird: Sc,
  LucideBitcoin: Cc,
  LucideBlend: Ac,
  LucideBlinds: Pc,
  LucideBlocks: qc,
  LucideBluetooth: Bc,
  LucideBluetoothConnected: Tc,
  LucideBluetoothOff: Dc,
  LucideBluetoothSearching: _c,
  LucideBold: zc,
  LucideBolt: Hc,
  LucideBomb: jc,
  LucideBone: Vc,
  LucideBook: l2,
  LucideBookA: Oc,
  LucideBookAudio: $c,
  LucideBookCheck: Rc,
  LucideBookCopy: Fc,
  LucideBookDashed: ba,
  LucideBookDown: Uc,
  LucideBookHeadphones: Ec,
  LucideBookHeart: Wc,
  LucideBookImage: Nc,
  LucideBookKey: Zc,
  LucideBookLock: Yc,
  LucideBookMarked: Gc,
  LucideBookMinus: Xc,
  LucideBookOpen: Jc,
  LucideBookOpenCheck: Kc,
  LucideBookOpenText: Qc,
  LucideBookPlus: e2,
  LucideBookTemplate: ba,
  LucideBookText: t2,
  LucideBookType: a2,
  LucideBookUp: o2,
  LucideBookUp2: n2,
  LucideBookUser: r2,
  LucideBookX: i2,
  LucideBookmark: h2,
  LucideBookmarkCheck: c2,
  LucideBookmarkMinus: d2,
  LucideBookmarkPlus: s2,
  LucideBookmarkX: u2,
  LucideBoomBox: p2,
  LucideBot: k2,
  LucideBotMessageSquare: y2,
  LucideBox: v2,
  LucideBoxSelect: f2,
  LucideBoxes: m2,
  LucideBraces: wa,
  LucideBrackets: g2,
  LucideBrain: b2,
  LucideBrainCircuit: M2,
  LucideBrainCog: x2,
  LucideBrickWall: w2,
  LucideBriefcase: S2,
  LucideBriefcaseBusiness: I2,
  LucideBriefcaseMedical: L2,
  LucideBringToFront: C2,
  LucideBrush: A2,
  LucideBug: T2,
  LucideBugOff: P2,
  LucideBugPlay: q2,
  LucideBuilding: _2,
  LucideBuilding2: D2,
  LucideBus: z2,
  LucideBusFront: B2,
  LucideCable: j2,
  LucideCableCar: H2,
  LucideCake: O2,
  LucideCakeSlice: V2,
  LucideCalculator: $2,
  LucideCalendar: ad,
  LucideCalendarCheck: F2,
  LucideCalendarCheck2: R2,
  LucideCalendarClock: U2,
  LucideCalendarDays: E2,
  LucideCalendarFold: W2,
  LucideCalendarHeart: N2,
  LucideCalendarMinus: Y2,
  LucideCalendarMinus2: Z2,
  LucideCalendarOff: G2,
  LucideCalendarPlus: K2,
  LucideCalendarPlus2: X2,
  LucideCalendarRange: Q2,
  LucideCalendarSearch: J2,
  LucideCalendarX: td,
  LucideCalendarX2: ed,
  LucideCamera: od,
  LucideCameraOff: nd,
  LucideCandlestickChart: rd,
  LucideCandy: cd,
  LucideCandyCane: id,
  LucideCandyOff: ld,
  LucideCannabis: dd,
  LucideCaptions: Ia,
  LucideCaptionsOff: sd,
  LucideCar: pd,
  LucideCarFront: ud,
  LucideCarTaxiFront: hd,
  LucideCaravan: yd,
  LucideCarrot: kd,
  LucideCaseLower: fd,
  LucideCaseSensitive: vd,
  LucideCaseUpper: md,
  LucideCassetteTape: gd,
  LucideCast: Md,
  LucideCastle: xd,
  LucideCat: bd,
  LucideCctv: wd,
  LucideCheck: Ld,
  LucideCheckCheck: Id,
  LucideCheckCircle: Ba,
  LucideCheckCircle2: za,
  LucideCheckSquare: mo,
  LucideCheckSquare2: go,
  LucideChefHat: Sd,
  LucideCherry: Cd,
  LucideChevronDown: Ad,
  LucideChevronDownCircle: Ha,
  LucideChevronDownSquare: Mo,
  LucideChevronFirst: Pd,
  LucideChevronLast: qd,
  LucideChevronLeft: Td,
  LucideChevronLeftCircle: ja,
  LucideChevronLeftSquare: xo,
  LucideChevronRight: Dd,
  LucideChevronRightCircle: Va,
  LucideChevronRightSquare: bo,
  LucideChevronUp: _d,
  LucideChevronUpCircle: Oa,
  LucideChevronUpSquare: wo,
  LucideChevronsDown: zd,
  LucideChevronsDownUp: Bd,
  LucideChevronsLeft: jd,
  LucideChevronsLeftRight: Hd,
  LucideChevronsRight: Od,
  LucideChevronsRightLeft: Vd,
  LucideChevronsUp: Rd,
  LucideChevronsUpDown: $d,
  LucideChrome: Fd,
  LucideChurch: Ud,
  LucideCigarette: Wd,
  LucideCigaretteOff: Ed,
  LucideCircle: ts,
  LucideCircleAlert: La,
  LucideCircleArrowDown: Sa,
  LucideCircleArrowLeft: Ca,
  LucideCircleArrowOutDownLeft: Aa,
  LucideCircleArrowOutDownRight: Pa,
  LucideCircleArrowOutUpLeft: qa,
  LucideCircleArrowOutUpRight: Ta,
  LucideCircleArrowRight: Da,
  LucideCircleArrowUp: _a,
  LucideCircleCheck: za,
  LucideCircleCheckBig: Ba,
  LucideCircleChevronDown: Ha,
  LucideCircleChevronLeft: ja,
  LucideCircleChevronRight: Va,
  LucideCircleChevronUp: Oa,
  LucideCircleDashed: Nd,
  LucideCircleDivide: $a,
  LucideCircleDollarSign: Zd,
  LucideCircleDot: Gd,
  LucideCircleDotDashed: Yd,
  LucideCircleEllipsis: Xd,
  LucideCircleEqual: Kd,
  LucideCircleFadingPlus: Qd,
  LucideCircleGauge: Ra,
  LucideCircleHelp: Fa,
  LucideCircleMinus: Ua,
  LucideCircleOff: Jd,
  LucideCircleParking: Wa,
  LucideCircleParkingOff: Ea,
  LucideCirclePause: Na,
  LucideCirclePercent: Za,
  LucideCirclePlay: Ya,
  LucideCirclePlus: Ga,
  LucideCirclePower: Xa,
  LucideCircleSlash: es,
  LucideCircleSlash2: Ka,
  LucideCircleSlashed: Ka,
  LucideCircleStop: Qa,
  LucideCircleUser: en,
  LucideCircleUserRound: Ja,
  LucideCircleX: tn,
  LucideCircuitBoard: as,
  LucideCitrus: ns,
  LucideClapperboard: os,
  LucideClipboard: ps,
  LucideClipboardCheck: rs,
  LucideClipboardCopy: is,
  LucideClipboardEdit: nn,
  LucideClipboardList: ls,
  LucideClipboardMinus: cs,
  LucideClipboardPaste: ds,
  LucideClipboardPen: nn,
  LucideClipboardPenLine: an,
  LucideClipboardPlus: ss,
  LucideClipboardSignature: an,
  LucideClipboardType: us,
  LucideClipboardX: hs,
  LucideClock: Ss,
  LucideClock1: ys,
  LucideClock10: ks,
  LucideClock11: fs,
  LucideClock12: vs,
  LucideClock2: ms,
  LucideClock3: gs,
  LucideClock4: Ms,
  LucideClock5: xs,
  LucideClock6: bs,
  LucideClock7: ws,
  LucideClock8: Is,
  LucideClock9: Ls,
  LucideCloud: $s,
  LucideCloudCog: Cs,
  LucideCloudDownload: on,
  LucideCloudDrizzle: As,
  LucideCloudFog: Ps,
  LucideCloudHail: qs,
  LucideCloudLightning: Ts,
  LucideCloudMoon: _s,
  LucideCloudMoonRain: Ds,
  LucideCloudOff: Bs,
  LucideCloudRain: Hs,
  LucideCloudRainWind: zs,
  LucideCloudSnow: js,
  LucideCloudSun: Os,
  LucideCloudSunRain: Vs,
  LucideCloudUpload: rn,
  LucideCloudy: Rs,
  LucideClover: Fs,
  LucideClub: Us,
  LucideCode: Es,
  LucideCode2: ln,
  LucideCodeSquare: Io,
  LucideCodeXml: ln,
  LucideCodepen: Ws,
  LucideCodesandbox: Ns,
  LucideCoffee: Zs,
  LucideCog: Ys,
  LucideCoins: Gs,
  LucideColumns: cn,
  LucideColumns2: cn,
  LucideColumns3: dn,
  LucideColumns4: Xs,
  LucideCombine: Ks,
  LucideCommand: Qs,
  LucideCompass: Js,
  LucideComponent: e0,
  LucideComputer: t0,
  LucideConciergeBell: a0,
  LucideCone: n0,
  LucideConstruction: o0,
  LucideContact: r0,
  LucideContact2: sn,
  LucideContactRound: sn,
  LucideContainer: i0,
  LucideContrast: l0,
  LucideCookie: c0,
  LucideCookingPot: d0,
  LucideCopy: k0,
  LucideCopyCheck: s0,
  LucideCopyMinus: u0,
  LucideCopyPlus: h0,
  LucideCopySlash: p0,
  LucideCopyX: y0,
  LucideCopyleft: f0,
  LucideCopyright: v0,
  LucideCornerDownLeft: m0,
  LucideCornerDownRight: g0,
  LucideCornerLeftDown: M0,
  LucideCornerLeftUp: x0,
  LucideCornerRightDown: b0,
  LucideCornerRightUp: w0,
  LucideCornerUpLeft: I0,
  LucideCornerUpRight: L0,
  LucideCpu: S0,
  LucideCreativeCommons: C0,
  LucideCreditCard: A0,
  LucideCroissant: P0,
  LucideCrop: q0,
  LucideCross: T0,
  LucideCrosshair: D0,
  LucideCrown: _0,
  LucideCuboid: B0,
  LucideCupSoda: z0,
  LucideCurlyBraces: wa,
  LucideCurrency: H0,
  LucideCylinder: j0,
  LucideDatabase: $0,
  LucideDatabaseBackup: V0,
  LucideDatabaseZap: O0,
  LucideDelete: R0,
  LucideDessert: F0,
  LucideDiameter: U0,
  LucideDiamond: E0,
  LucideDiamondPercent: un,
  LucideDice1: W0,
  LucideDice2: N0,
  LucideDice3: Z0,
  LucideDice4: Y0,
  LucideDice5: G0,
  LucideDice6: X0,
  LucideDices: K0,
  LucideDiff: Q0,
  LucideDisc: au,
  LucideDisc2: J0,
  LucideDisc3: eu,
  LucideDiscAlbum: tu,
  LucideDivide: nu,
  LucideDivideCircle: $a,
  LucideDivideSquare: Co,
  LucideDna: ru,
  LucideDnaOff: ou,
  LucideDock: iu,
  LucideDog: lu,
  LucideDollarSign: cu,
  LucideDonut: du,
  LucideDoorClosed: su,
  LucideDoorOpen: uu,
  LucideDot: hu,
  LucideDotSquare: Ao,
  LucideDownload: pu,
  LucideDownloadCloud: on,
  LucideDraftingCompass: yu,
  LucideDrama: ku,
  LucideDribbble: fu,
  LucideDrill: vu,
  LucideDroplet: mu,
  LucideDroplets: gu,
  LucideDrum: Mu,
  LucideDrumstick: xu,
  LucideDumbbell: bu,
  LucideEar: Iu,
  LucideEarOff: wu,
  LucideEarth: hn,
  LucideEarthLock: Lu,
  LucideEclipse: Su,
  LucideEdit: vt,
  LucideEdit2: Nn,
  LucideEdit3: Wn,
  LucideEgg: Pu,
  LucideEggFried: Cu,
  LucideEggOff: Au,
  LucideEllipsis: yn,
  LucideEllipsisVertical: pn,
  LucideEqual: Tu,
  LucideEqualNot: qu,
  LucideEqualSquare: Po,
  LucideEraser: Du,
  LucideEuro: _u,
  LucideExpand: Bu,
  LucideExternalLink: zu,
  LucideEye: ju,
  LucideEyeOff: Hu,
  LucideFacebook: Vu,
  LucideFactory: Ou,
  LucideFan: $u,
  LucideFastForward: Ru,
  LucideFeather: Fu,
  LucideFence: Uu,
  LucideFerrisWheel: Eu,
  LucideFigma: Wu,
  LucideFile: Wh,
  LucideFileArchive: Nu,
  LucideFileAudio: Yu,
  LucideFileAudio2: Zu,
  LucideFileAxis3D: kn,
  LucideFileAxis3d: kn,
  LucideFileBadge: Xu,
  LucideFileBadge2: Gu,
  LucideFileBarChart: Qu,
  LucideFileBarChart2: Ku,
  LucideFileBox: Ju,
  LucideFileCheck: th,
  LucideFileCheck2: eh,
  LucideFileClock: ah,
  LucideFileCode: oh,
  LucideFileCode2: nh,
  LucideFileCog: fn,
  LucideFileCog2: fn,
  LucideFileDiff: rh,
  LucideFileDigit: ih,
  LucideFileDown: lh,
  LucideFileEdit: mn,
  LucideFileHeart: ch,
  LucideFileImage: dh,
  LucideFileInput: sh,
  LucideFileJson: hh,
  LucideFileJson2: uh,
  LucideFileKey: yh,
  LucideFileKey2: ph,
  LucideFileLineChart: kh,
  LucideFileLock: vh,
  LucideFileLock2: fh,
  LucideFileMinus: gh,
  LucideFileMinus2: mh,
  LucideFileMusic: Mh,
  LucideFileOutput: xh,
  LucideFilePen: mn,
  LucideFilePenLine: vn,
  LucideFilePieChart: bh,
  LucideFilePlus: Ih,
  LucideFilePlus2: wh,
  LucideFileQuestion: Lh,
  LucideFileScan: Sh,
  LucideFileSearch: Ah,
  LucideFileSearch2: Ch,
  LucideFileSignature: vn,
  LucideFileSliders: Ph,
  LucideFileSpreadsheet: qh,
  LucideFileStack: Th,
  LucideFileSymlink: Dh,
  LucideFileTerminal: _h,
  LucideFileText: Bh,
  LucideFileType: Hh,
  LucideFileType2: zh,
  LucideFileUp: jh,
  LucideFileVideo: Oh,
  LucideFileVideo2: Vh,
  LucideFileVolume: Rh,
  LucideFileVolume2: $h,
  LucideFileWarning: Fh,
  LucideFileX: Eh,
  LucideFileX2: Uh,
  LucideFiles: Nh,
  LucideFilm: Zh,
  LucideFilter: Gh,
  LucideFilterX: Yh,
  LucideFingerprint: Xh,
  LucideFireExtinguisher: Kh,
  LucideFish: ep,
  LucideFishOff: Qh,
  LucideFishSymbol: Jh,
  LucideFlag: op,
  LucideFlagOff: tp,
  LucideFlagTriangleLeft: ap,
  LucideFlagTriangleRight: np,
  LucideFlame: ip,
  LucideFlameKindling: rp,
  LucideFlashlight: cp,
  LucideFlashlightOff: lp,
  LucideFlaskConical: sp,
  LucideFlaskConicalOff: dp,
  LucideFlaskRound: up,
  LucideFlipHorizontal: pp,
  LucideFlipHorizontal2: hp,
  LucideFlipVertical: kp,
  LucideFlipVertical2: yp,
  LucideFlower: vp,
  LucideFlower2: fp,
  LucideFocus: mp,
  LucideFoldHorizontal: gp,
  LucideFoldVertical: Mp,
  LucideFolder: Zp,
  LucideFolderArchive: xp,
  LucideFolderCheck: bp,
  LucideFolderClock: wp,
  LucideFolderClosed: Ip,
  LucideFolderCog: gn,
  LucideFolderCog2: gn,
  LucideFolderDot: Lp,
  LucideFolderDown: Sp,
  LucideFolderEdit: Mn,
  LucideFolderGit: Ap,
  LucideFolderGit2: Cp,
  LucideFolderHeart: Pp,
  LucideFolderInput: qp,
  LucideFolderKanban: Tp,
  LucideFolderKey: Dp,
  LucideFolderLock: _p,
  LucideFolderMinus: Bp,
  LucideFolderOpen: Hp,
  LucideFolderOpenDot: zp,
  LucideFolderOutput: jp,
  LucideFolderPen: Mn,
  LucideFolderPlus: Vp,
  LucideFolderRoot: Op,
  LucideFolderSearch: Rp,
  LucideFolderSearch2: $p,
  LucideFolderSymlink: Fp,
  LucideFolderSync: Up,
  LucideFolderTree: Ep,
  LucideFolderUp: Wp,
  LucideFolderX: Np,
  LucideFolders: Yp,
  LucideFootprints: Gp,
  LucideForklift: Xp,
  LucideFormInput: Zn,
  LucideForward: Kp,
  LucideFrame: Qp,
  LucideFramer: Jp,
  LucideFrown: ey,
  LucideFuel: ty,
  LucideFullscreen: ay,
  LucideFunctionSquare: qo,
  LucideGalleryHorizontal: oy,
  LucideGalleryHorizontalEnd: ny,
  LucideGalleryThumbnails: ry,
  LucideGalleryVertical: ly,
  LucideGalleryVerticalEnd: iy,
  LucideGamepad: dy,
  LucideGamepad2: cy,
  LucideGanttChart: sy,
  LucideGanttChartSquare: To,
  LucideGauge: uy,
  LucideGaugeCircle: Ra,
  LucideGavel: hy,
  LucideGem: py,
  LucideGhost: yy,
  LucideGift: ky,
  LucideGitBranch: vy,
  LucideGitBranchPlus: fy,
  LucideGitCommit: xn,
  LucideGitCommitHorizontal: xn,
  LucideGitCommitVertical: my,
  LucideGitCompare: My,
  LucideGitCompareArrows: gy,
  LucideGitFork: xy,
  LucideGitGraph: by,
  LucideGitMerge: wy,
  LucideGitPullRequest: Py,
  LucideGitPullRequestArrow: Iy,
  LucideGitPullRequestClosed: Ly,
  LucideGitPullRequestCreate: Cy,
  LucideGitPullRequestCreateArrow: Sy,
  LucideGitPullRequestDraft: Ay,
  LucideGithub: qy,
  LucideGitlab: Ty,
  LucideGlassWater: Dy,
  LucideGlasses: _y,
  LucideGlobe: zy,
  LucideGlobe2: hn,
  LucideGlobeLock: By,
  LucideGoal: Hy,
  LucideGrab: jy,
  LucideGraduationCap: Vy,
  LucideGrape: Oy,
  LucideGrid: zt,
  LucideGrid2X2: bn,
  LucideGrid2x2: bn,
  LucideGrid3X3: zt,
  LucideGrid3x3: zt,
  LucideGrip: Fy,
  LucideGripHorizontal: $y,
  LucideGripVertical: Ry,
  LucideGroup: Uy,
  LucideGuitar: Ey,
  LucideHam: Wy,
  LucideHammer: Ny,
  LucideHand: Ky,
  LucideHandCoins: Zy,
  LucideHandHeart: Yy,
  LucideHandHelping: wn,
  LucideHandMetal: Gy,
  LucideHandPlatter: Xy,
  LucideHandshake: Qy,
  LucideHardDrive: tk,
  LucideHardDriveDownload: Jy,
  LucideHardDriveUpload: ek,
  LucideHardHat: ak,
  LucideHash: nk,
  LucideHaze: ok,
  LucideHdmiPort: rk,
  LucideHeading: hk,
  LucideHeading1: ik,
  LucideHeading2: lk,
  LucideHeading3: ck,
  LucideHeading4: dk,
  LucideHeading5: sk,
  LucideHeading6: uk,
  LucideHeadphones: pk,
  LucideHeadset: yk,
  LucideHeart: gk,
  LucideHeartCrack: kk,
  LucideHeartHandshake: fk,
  LucideHeartOff: vk,
  LucideHeartPulse: mk,
  LucideHeater: Mk,
  LucideHelpCircle: Fa,
  LucideHelpingHand: wn,
  LucideHexagon: xk,
  LucideHighlighter: bk,
  LucideHistory: wk,
  LucideHome: Ik,
  LucideHop: Sk,
  LucideHopOff: Lk,
  LucideHospital: Ck,
  LucideHotel: Ak,
  LucideHourglass: Pk,
  LucideIceCream: Ln,
  LucideIceCream2: In,
  LucideIceCreamBowl: In,
  LucideIceCreamCone: Ln,
  LucideImage: zk,
  LucideImageDown: qk,
  LucideImageMinus: Tk,
  LucideImageOff: Dk,
  LucideImagePlus: _k,
  LucideImageUp: Bk,
  LucideImages: Hk,
  LucideImport: jk,
  LucideInbox: Vk,
  LucideIndent: Cn,
  LucideIndentDecrease: Sn,
  LucideIndentIncrease: Cn,
  LucideIndianRupee: Ok,
  LucideInfinity: $k,
  LucideInfo: Rk,
  LucideInspect: jo,
  LucideInspectionPanel: Fk,
  LucideInstagram: Uk,
  LucideItalic: Ek,
  LucideIterationCcw: Wk,
  LucideIterationCw: Nk,
  LucideJapaneseYen: Zk,
  LucideJoystick: Yk,
  LucideKanban: Gk,
  LucideKanbanSquare: Do,
  LucideKanbanSquareDashed: Lo,
  LucideKey: Qk,
  LucideKeyRound: Xk,
  LucideKeySquare: Kk,
  LucideKeyboard: e4,
  LucideKeyboardMusic: Jk,
  LucideLamp: i4,
  LucideLampCeiling: t4,
  LucideLampDesk: a4,
  LucideLampFloor: n4,
  LucideLampWallDown: o4,
  LucideLampWallUp: r4,
  LucideLandPlot: l4,
  LucideLandmark: c4,
  LucideLanguages: d4,
  LucideLaptop: s4,
  LucideLaptop2: An,
  LucideLaptopMinimal: An,
  LucideLasso: h4,
  LucideLassoSelect: u4,
  LucideLaugh: p4,
  LucideLayers: f4,
  LucideLayers2: y4,
  LucideLayers3: k4,
  LucideLayout: En,
  LucideLayoutDashboard: v4,
  LucideLayoutGrid: m4,
  LucideLayoutList: g4,
  LucideLayoutPanelLeft: M4,
  LucideLayoutPanelTop: x4,
  LucideLayoutTemplate: b4,
  LucideLeaf: w4,
  LucideLeafyGreen: I4,
  LucideLibrary: S4,
  LucideLibraryBig: L4,
  LucideLibrarySquare: _o,
  LucideLifeBuoy: C4,
  LucideLigature: A4,
  LucideLightbulb: q4,
  LucideLightbulbOff: P4,
  LucideLineChart: T4,
  LucideLink: B4,
  LucideLink2: _4,
  LucideLink2Off: D4,
  LucideLinkedin: z4,
  LucideList: X4,
  LucideListChecks: H4,
  LucideListCollapse: j4,
  LucideListEnd: V4,
  LucideListFilter: O4,
  LucideListMinus: $4,
  LucideListMusic: R4,
  LucideListOrdered: F4,
  LucideListPlus: U4,
  LucideListRestart: E4,
  LucideListStart: W4,
  LucideListTodo: N4,
  LucideListTree: Z4,
  LucideListVideo: Y4,
  LucideListX: G4,
  LucideLoader: K4,
  LucideLoader2: Pn,
  LucideLoaderCircle: Pn,
  LucideLocate: ef,
  LucideLocateFixed: Q4,
  LucideLocateOff: J4,
  LucideLock: af,
  LucideLockKeyhole: tf,
  LucideLockKeyholeOpen: qn,
  LucideLockOpen: Tn,
  LucideLogIn: nf,
  LucideLogOut: of,
  LucideLollipop: rf,
  LucideLuggage: lf,
  LucideMSquare: Bo,
  LucideMagnet: cf,
  LucideMail: vf,
  LucideMailCheck: df,
  LucideMailMinus: sf,
  LucideMailOpen: uf,
  LucideMailPlus: hf,
  LucideMailQuestion: pf,
  LucideMailSearch: yf,
  LucideMailWarning: kf,
  LucideMailX: ff,
  LucideMailbox: mf,
  LucideMails: gf,
  LucideMap: wf,
  LucideMapPin: xf,
  LucideMapPinOff: Mf,
  LucideMapPinned: bf,
  LucideMartini: If,
  LucideMaximize: Sf,
  LucideMaximize2: Lf,
  LucideMedal: Cf,
  LucideMegaphone: Pf,
  LucideMegaphoneOff: Af,
  LucideMeh: qf,
  LucideMemoryStick: Tf,
  LucideMenu: Df,
  LucideMenuSquare: zo,
  LucideMerge: _f,
  LucideMessageCircle: Ef,
  LucideMessageCircleCode: Bf,
  LucideMessageCircleDashed: zf,
  LucideMessageCircleHeart: Hf,
  LucideMessageCircleMore: jf,
  LucideMessageCircleOff: Vf,
  LucideMessageCirclePlus: Of,
  LucideMessageCircleQuestion: $f,
  LucideMessageCircleReply: Rf,
  LucideMessageCircleWarning: Ff,
  LucideMessageCircleX: Uf,
  LucideMessageSquare: rv,
  LucideMessageSquareCode: Wf,
  LucideMessageSquareDashed: Nf,
  LucideMessageSquareDiff: Zf,
  LucideMessageSquareDot: Yf,
  LucideMessageSquareHeart: Gf,
  LucideMessageSquareMore: Xf,
  LucideMessageSquareOff: Kf,
  LucideMessageSquarePlus: Qf,
  LucideMessageSquareQuote: Jf,
  LucideMessageSquareReply: ev,
  LucideMessageSquareShare: tv,
  LucideMessageSquareText: av,
  LucideMessageSquareWarning: nv,
  LucideMessageSquareX: ov,
  LucideMessagesSquare: iv,
  LucideMic: cv,
  LucideMic2: Dn,
  LucideMicOff: lv,
  LucideMicVocal: Dn,
  LucideMicroscope: dv,
  LucideMicrowave: sv,
  LucideMilestone: uv,
  LucideMilk: pv,
  LucideMilkOff: hv,
  LucideMinimize: kv,
  LucideMinimize2: yv,
  LucideMinus: fv,
  LucideMinusCircle: Ua,
  LucideMinusSquare: Ho,
  LucideMonitor: Av,
  LucideMonitorCheck: vv,
  LucideMonitorDot: mv,
  LucideMonitorDown: gv,
  LucideMonitorOff: Mv,
  LucideMonitorPause: xv,
  LucideMonitorPlay: bv,
  LucideMonitorSmartphone: wv,
  LucideMonitorSpeaker: Iv,
  LucideMonitorStop: Lv,
  LucideMonitorUp: Sv,
  LucideMonitorX: Cv,
  LucideMoon: qv,
  LucideMoonStar: Pv,
  LucideMoreHorizontal: yn,
  LucideMoreVertical: pn,
  LucideMountain: Dv,
  LucideMountainSnow: Tv,
  LucideMouse: jv,
  LucideMouseOff: _v,
  LucideMousePointer: Hv,
  LucideMousePointer2: Bv,
  LucideMousePointerClick: zv,
  LucideMousePointerSquareDashed: So,
  LucideMove: Xv,
  LucideMove3D: _n,
  LucideMove3d: _n,
  LucideMoveDiagonal: Ov,
  LucideMoveDiagonal2: Vv,
  LucideMoveDown: Fv,
  LucideMoveDownLeft: $v,
  LucideMoveDownRight: Rv,
  LucideMoveHorizontal: Uv,
  LucideMoveLeft: Ev,
  LucideMoveRight: Wv,
  LucideMoveUp: Yv,
  LucideMoveUpLeft: Nv,
  LucideMoveUpRight: Zv,
  LucideMoveVertical: Gv,
  LucideMusic: em,
  LucideMusic2: Kv,
  LucideMusic3: Qv,
  LucideMusic4: Jv,
  LucideNavigation: om,
  LucideNavigation2: am,
  LucideNavigation2Off: tm,
  LucideNavigationOff: nm,
  LucideNetwork: rm,
  LucideNewspaper: im,
  LucideNfc: lm,
  LucideNotebook: um,
  LucideNotebookPen: cm,
  LucideNotebookTabs: dm,
  LucideNotebookText: sm,
  LucideNotepadText: pm,
  LucideNotepadTextDashed: hm,
  LucideNut: km,
  LucideNutOff: ym,
  LucideOctagon: fm,
  LucideOctagonAlert: Bn,
  LucideOctagonPause: zn,
  LucideOctagonX: Hn,
  LucideOption: vm,
  LucideOrbit: mm,
  LucideOutdent: Sn,
  LucidePackage: Sm,
  LucidePackage2: gm,
  LucidePackageCheck: Mm,
  LucidePackageMinus: xm,
  LucidePackageOpen: bm,
  LucidePackagePlus: wm,
  LucidePackageSearch: Im,
  LucidePackageX: Lm,
  LucidePaintBucket: Cm,
  LucidePaintRoller: Am,
  LucidePaintbrush: qm,
  LucidePaintbrush2: Pm,
  LucidePalette: Tm,
  LucidePalmtree: or,
  LucidePanelBottom: Bm,
  LucidePanelBottomClose: Dm,
  LucidePanelBottomDashed: jn,
  LucidePanelBottomInactive: jn,
  LucidePanelBottomOpen: _m,
  LucidePanelLeft: Rn,
  LucidePanelLeftClose: Vn,
  LucidePanelLeftDashed: On,
  LucidePanelLeftInactive: On,
  LucidePanelLeftOpen: $n,
  LucidePanelRight: jm,
  LucidePanelRightClose: zm,
  LucidePanelRightDashed: Fn,
  LucidePanelRightInactive: Fn,
  LucidePanelRightOpen: Hm,
  LucidePanelTop: $m,
  LucidePanelTopClose: Vm,
  LucidePanelTopDashed: Un,
  LucidePanelTopInactive: Un,
  LucidePanelTopOpen: Om,
  LucidePanelsLeftBottom: Rm,
  LucidePanelsLeftRight: dn,
  LucidePanelsRightBottom: Fm,
  LucidePanelsTopBottom: Xn,
  LucidePanelsTopLeft: En,
  LucidePaperclip: Um,
  LucideParentheses: Em,
  LucideParkingCircle: Wa,
  LucideParkingCircleOff: Ea,
  LucideParkingMeter: Wm,
  LucideParkingSquare: Oo,
  LucideParkingSquareOff: Vo,
  LucidePartyPopper: Nm,
  LucidePause: Zm,
  LucidePauseCircle: Na,
  LucidePauseOctagon: zn,
  LucidePawPrint: Ym,
  LucidePcCase: Gm,
  LucidePen: Nn,
  LucidePenBox: vt,
  LucidePenLine: Wn,
  LucidePenSquare: vt,
  LucidePenTool: Xm,
  LucidePencil: Jm,
  LucidePencilLine: Km,
  LucidePencilRuler: Qm,
  LucidePentagon: e5,
  LucidePercent: t5,
  LucidePercentCircle: Za,
  LucidePercentDiamond: un,
  LucidePercentSquare: $o,
  LucidePersonStanding: a5,
  LucidePhone: d5,
  LucidePhoneCall: n5,
  LucidePhoneForwarded: o5,
  LucidePhoneIncoming: r5,
  LucidePhoneMissed: i5,
  LucidePhoneOff: l5,
  LucidePhoneOutgoing: c5,
  LucidePi: s5,
  LucidePiSquare: Ro,
  LucidePiano: u5,
  LucidePickaxe: h5,
  LucidePictureInPicture: y5,
  LucidePictureInPicture2: p5,
  LucidePieChart: k5,
  LucidePiggyBank: f5,
  LucidePilcrow: g5,
  LucidePilcrowLeft: v5,
  LucidePilcrowRight: m5,
  LucidePilcrowSquare: Fo,
  LucidePill: M5,
  LucidePin: b5,
  LucidePinOff: x5,
  LucidePipette: w5,
  LucidePizza: I5,
  LucidePlane: C5,
  LucidePlaneLanding: L5,
  LucidePlaneTakeoff: S5,
  LucidePlay: A5,
  LucidePlayCircle: Ya,
  LucidePlaySquare: Uo,
  LucidePlug: D5,
  LucidePlug2: P5,
  LucidePlugZap: T5,
  LucidePlugZap2: q5,
  LucidePlus: _5,
  LucidePlusCircle: Ga,
  LucidePlusSquare: Eo,
  LucidePocket: z5,
  LucidePocketKnife: B5,
  LucidePodcast: H5,
  LucidePointer: V5,
  LucidePointerOff: j5,
  LucidePopcorn: O5,
  LucidePopsicle: $5,
  LucidePoundSterling: R5,
  LucidePower: U5,
  LucidePowerCircle: Xa,
  LucidePowerOff: F5,
  LucidePowerSquare: Wo,
  LucidePresentation: E5,
  LucidePrinter: W5,
  LucideProjector: N5,
  LucideProportions: Z5,
  LucidePuzzle: Y5,
  LucidePyramid: G5,
  LucideQrCode: X5,
  LucideQuote: K5,
  LucideRabbit: Q5,
  LucideRadar: J5,
  LucideRadiation: e3,
  LucideRadical: t3,
  LucideRadio: o3,
  LucideRadioReceiver: a3,
  LucideRadioTower: n3,
  LucideRadius: r3,
  LucideRailSymbol: i3,
  LucideRainbow: l3,
  LucideRat: c3,
  LucideRatio: d3,
  LucideReceipt: m3,
  LucideReceiptCent: s3,
  LucideReceiptEuro: u3,
  LucideReceiptIndianRupee: h3,
  LucideReceiptJapaneseYen: p3,
  LucideReceiptPoundSterling: y3,
  LucideReceiptRussianRuble: k3,
  LucideReceiptSwissFranc: f3,
  LucideReceiptText: v3,
  LucideRectangleEllipsis: Zn,
  LucideRectangleHorizontal: g3,
  LucideRectangleVertical: M3,
  LucideRecycle: x3,
  LucideRedo: I3,
  LucideRedo2: b3,
  LucideRedoDot: w3,
  LucideRefreshCcw: S3,
  LucideRefreshCcwDot: L3,
  LucideRefreshCw: A3,
  LucideRefreshCwOff: C3,
  LucideRefrigerator: P3,
  LucideRegex: q3,
  LucideRemoveFormatting: T3,
  LucideRepeat: B3,
  LucideRepeat1: D3,
  LucideRepeat2: _3,
  LucideReplace: H3,
  LucideReplaceAll: z3,
  LucideReply: V3,
  LucideReplyAll: j3,
  LucideRewind: O3,
  LucideRibbon: $3,
  LucideRocket: R3,
  LucideRockingChair: F3,
  LucideRollerCoaster: U3,
  LucideRotate3D: Yn,
  LucideRotate3d: Yn,
  LucideRotateCcw: W3,
  LucideRotateCcwSquare: E3,
  LucideRotateCw: Z3,
  LucideRotateCwSquare: N3,
  LucideRoute: G3,
  LucideRouteOff: Y3,
  LucideRouter: X3,
  LucideRows: Gn,
  LucideRows2: Gn,
  LucideRows3: Xn,
  LucideRows4: K3,
  LucideRss: Q3,
  LucideRuler: J3,
  LucideRussianRuble: eg,
  LucideSailboat: tg,
  LucideSalad: ag,
  LucideSandwich: ng,
  LucideSatellite: rg,
  LucideSatelliteDish: og,
  LucideSave: lg,
  LucideSaveAll: ig,
  LucideScale: cg,
  LucideScale3D: Kn,
  LucideScale3d: Kn,
  LucideScaling: dg,
  LucideScan: fg,
  LucideScanBarcode: sg,
  LucideScanEye: ug,
  LucideScanFace: hg,
  LucideScanLine: pg,
  LucideScanSearch: yg,
  LucideScanText: kg,
  LucideScatterChart: vg,
  LucideSchool: mg,
  LucideSchool2: ir,
  LucideScissors: Mg,
  LucideScissorsLineDashed: gg,
  LucideScissorsSquare: No,
  LucideScissorsSquareDashedBottom: vo,
  LucideScreenShare: bg,
  LucideScreenShareOff: xg,
  LucideScroll: Ig,
  LucideScrollText: wg,
  LucideSearch: Pg,
  LucideSearchCheck: Lg,
  LucideSearchCode: Sg,
  LucideSearchSlash: Cg,
  LucideSearchX: Ag,
  LucideSend: Tg,
  LucideSendHorizonal: Qn,
  LucideSendHorizontal: Qn,
  LucideSendToBack: qg,
  LucideSeparatorHorizontal: Dg,
  LucideSeparatorVertical: _g,
  LucideServer: jg,
  LucideServerCog: Bg,
  LucideServerCrash: zg,
  LucideServerOff: Hg,
  LucideSettings: Og,
  LucideSettings2: Vg,
  LucideShapes: $g,
  LucideShare: Fg,
  LucideShare2: Rg,
  LucideSheet: Ug,
  LucideShell: Eg,
  LucideShield: e6,
  LucideShieldAlert: Wg,
  LucideShieldBan: Ng,
  LucideShieldCheck: Zg,
  LucideShieldClose: Jn,
  LucideShieldEllipsis: Yg,
  LucideShieldHalf: Gg,
  LucideShieldMinus: Xg,
  LucideShieldOff: Kg,
  LucideShieldPlus: Qg,
  LucideShieldQuestion: Jg,
  LucideShieldX: Jn,
  LucideShip: a6,
  LucideShipWheel: t6,
  LucideShirt: n6,
  LucideShoppingBag: o6,
  LucideShoppingBasket: r6,
  LucideShoppingCart: i6,
  LucideShovel: l6,
  LucideShowerHead: c6,
  LucideShrink: d6,
  LucideShrub: s6,
  LucideShuffle: u6,
  LucideSidebar: Rn,
  LucideSidebarClose: Vn,
  LucideSidebarOpen: $n,
  LucideSigma: h6,
  LucideSigmaSquare: Zo,
  LucideSignal: v6,
  LucideSignalHigh: p6,
  LucideSignalLow: y6,
  LucideSignalMedium: k6,
  LucideSignalZero: f6,
  LucideSignpost: g6,
  LucideSignpostBig: m6,
  LucideSiren: M6,
  LucideSkipBack: x6,
  LucideSkipForward: b6,
  LucideSkull: w6,
  LucideSlack: I6,
  LucideSlash: L6,
  LucideSlashSquare: Yo,
  LucideSlice: S6,
  LucideSliders: eo,
  LucideSlidersHorizontal: C6,
  LucideSlidersVertical: eo,
  LucideSmartphone: q6,
  LucideSmartphoneCharging: A6,
  LucideSmartphoneNfc: P6,
  LucideSmile: D6,
  LucideSmilePlus: T6,
  LucideSnail: _6,
  LucideSnowflake: B6,
  LucideSofa: z6,
  LucideSortAsc: fa,
  LucideSortDesc: pa,
  LucideSoup: H6,
  LucideSpace: j6,
  LucideSpade: V6,
  LucideSparkle: O6,
  LucideSparkles: to,
  LucideSpeaker: $6,
  LucideSpeech: R6,
  LucideSpellCheck: U6,
  LucideSpellCheck2: F6,
  LucideSpline: E6,
  LucideSplit: W6,
  LucideSplitSquareHorizontal: Go,
  LucideSplitSquareVertical: Xo,
  LucideSprayCan: N6,
  LucideSprout: Z6,
  LucideSquare: Q6,
  LucideSquareActivity: ao,
  LucideSquareArrowDown: ro,
  LucideSquareArrowDownLeft: no,
  LucideSquareArrowDownRight: oo,
  LucideSquareArrowLeft: io,
  LucideSquareArrowOutDownLeft: lo,
  LucideSquareArrowOutDownRight: co,
  LucideSquareArrowOutUpLeft: so,
  LucideSquareArrowOutUpRight: uo,
  LucideSquareArrowRight: ho,
  LucideSquareArrowUp: ko,
  LucideSquareArrowUpLeft: po,
  LucideSquareArrowUpRight: yo,
  LucideSquareAsterisk: fo,
  LucideSquareBottomDashedScissors: vo,
  LucideSquareCheck: go,
  LucideSquareCheckBig: mo,
  LucideSquareChevronDown: Mo,
  LucideSquareChevronLeft: xo,
  LucideSquareChevronRight: bo,
  LucideSquareChevronUp: wo,
  LucideSquareCode: Io,
  LucideSquareDashedBottom: G6,
  LucideSquareDashedBottomCode: Y6,
  LucideSquareDashedKanban: Lo,
  LucideSquareDashedMousePointer: So,
  LucideSquareDivide: Co,
  LucideSquareDot: Ao,
  LucideSquareEqual: Po,
  LucideSquareFunction: qo,
  LucideSquareGanttChart: To,
  LucideSquareKanban: Do,
  LucideSquareLibrary: _o,
  LucideSquareM: Bo,
  LucideSquareMenu: zo,
  LucideSquareMinus: Ho,
  LucideSquareMousePointer: jo,
  LucideSquareParking: Oo,
  LucideSquareParkingOff: Vo,
  LucideSquarePen: vt,
  LucideSquarePercent: $o,
  LucideSquarePi: Ro,
  LucideSquarePilcrow: Fo,
  LucideSquarePlay: Uo,
  LucideSquarePlus: Eo,
  LucideSquarePower: Wo,
  LucideSquareRadical: X6,
  LucideSquareScissors: No,
  LucideSquareSigma: Zo,
  LucideSquareSlash: Yo,
  LucideSquareSplitHorizontal: Go,
  LucideSquareSplitVertical: Xo,
  LucideSquareStack: K6,
  LucideSquareTerminal: Ko,
  LucideSquareUser: Jo,
  LucideSquareUserRound: Qo,
  LucideSquareX: er,
  LucideSquircle: J6,
  LucideSquirrel: e8,
  LucideStamp: t8,
  LucideStar: o8,
  LucideStarHalf: a8,
  LucideStarOff: n8,
  LucideStars: to,
  LucideStepBack: r8,
  LucideStepForward: i8,
  LucideStethoscope: l8,
  LucideSticker: c8,
  LucideStickyNote: d8,
  LucideStopCircle: Qa,
  LucideStore: s8,
  LucideStretchHorizontal: u8,
  LucideStretchVertical: h8,
  LucideStrikethrough: p8,
  LucideSubscript: y8,
  LucideSubtitles: Ia,
  LucideSun: g8,
  LucideSunDim: k8,
  LucideSunMedium: f8,
  LucideSunMoon: v8,
  LucideSunSnow: m8,
  LucideSunrise: M8,
  LucideSunset: x8,
  LucideSuperscript: b8,
  LucideSwatchBook: w8,
  LucideSwissFranc: I8,
  LucideSwitchCamera: L8,
  LucideSword: S8,
  LucideSwords: C8,
  LucideSyringe: A8,
  LucideTable: z8,
  LucideTable2: P8,
  LucideTableCellsMerge: q8,
  LucideTableCellsSplit: T8,
  LucideTableColumnsSplit: D8,
  LucideTableProperties: _8,
  LucideTableRowsSplit: B8,
  LucideTablet: j8,
  LucideTabletSmartphone: H8,
  LucideTablets: V8,
  LucideTag: O8,
  LucideTags: $8,
  LucideTally1: R8,
  LucideTally2: F8,
  LucideTally3: U8,
  LucideTally4: E8,
  LucideTally5: W8,
  LucideTangent: N8,
  LucideTarget: Z8,
  LucideTelescope: Y8,
  LucideTent: X8,
  LucideTentTree: G8,
  LucideTerminal: K8,
  LucideTerminalSquare: Ko,
  LucideTestTube: Q8,
  LucideTestTube2: tr,
  LucideTestTubeDiagonal: tr,
  LucideTestTubes: J8,
  LucideText: o7,
  LucideTextCursor: t7,
  LucideTextCursorInput: e7,
  LucideTextQuote: a7,
  LucideTextSearch: n7,
  LucideTextSelect: ar,
  LucideTextSelection: ar,
  LucideTheater: r7,
  LucideThermometer: c7,
  LucideThermometerSnowflake: i7,
  LucideThermometerSun: l7,
  LucideThumbsDown: d7,
  LucideThumbsUp: s7,
  LucideTicket: v7,
  LucideTicketCheck: u7,
  LucideTicketMinus: h7,
  LucideTicketPercent: p7,
  LucideTicketPlus: y7,
  LucideTicketSlash: k7,
  LucideTicketX: f7,
  LucideTimer: M7,
  LucideTimerOff: m7,
  LucideTimerReset: g7,
  LucideToggleLeft: x7,
  LucideToggleRight: b7,
  LucideTornado: w7,
  LucideTorus: I7,
  LucideTouchpad: S7,
  LucideTouchpadOff: L7,
  LucideTowerControl: C7,
  LucideToyBrick: A7,
  LucideTractor: P7,
  LucideTrafficCone: q7,
  LucideTrain: nr,
  LucideTrainFront: D7,
  LucideTrainFrontTunnel: T7,
  LucideTrainTrack: _7,
  LucideTramFront: nr,
  LucideTrash: z7,
  LucideTrash2: B7,
  LucideTreeDeciduous: H7,
  LucideTreePalm: or,
  LucideTreePine: j7,
  LucideTrees: V7,
  LucideTrello: O7,
  LucideTrendingDown: $7,
  LucideTrendingUp: R7,
  LucideTriangle: U7,
  LucideTriangleAlert: rr,
  LucideTriangleRight: F7,
  LucideTrophy: E7,
  LucideTruck: W7,
  LucideTurtle: N7,
  LucideTv: Y7,
  LucideTv2: Z7,
  LucideTwitch: G7,
  LucideTwitter: X7,
  LucideType: K7,
  LucideUmbrella: J7,
  LucideUmbrellaOff: Q7,
  LucideUnderline: eM,
  LucideUndo: nM,
  LucideUndo2: tM,
  LucideUndoDot: aM,
  LucideUnfoldHorizontal: oM,
  LucideUnfoldVertical: rM,
  LucideUngroup: iM,
  LucideUniversity: ir,
  LucideUnlink: cM,
  LucideUnlink2: lM,
  LucideUnlock: Tn,
  LucideUnlockKeyhole: qn,
  LucideUnplug: dM,
  LucideUpload: sM,
  LucideUploadCloud: rn,
  LucideUsb: uM,
  LucideUser: gM,
  LucideUser2: hr,
  LucideUserCheck: hM,
  LucideUserCheck2: lr,
  LucideUserCircle: en,
  LucideUserCircle2: Ja,
  LucideUserCog: pM,
  LucideUserCog2: cr,
  LucideUserMinus: yM,
  LucideUserMinus2: dr,
  LucideUserPlus: kM,
  LucideUserPlus2: sr,
  LucideUserRound: hr,
  LucideUserRoundCheck: lr,
  LucideUserRoundCog: cr,
  LucideUserRoundMinus: dr,
  LucideUserRoundPlus: sr,
  LucideUserRoundSearch: fM,
  LucideUserRoundX: ur,
  LucideUserSearch: vM,
  LucideUserSquare: Jo,
  LucideUserSquare2: Qo,
  LucideUserX: mM,
  LucideUserX2: ur,
  LucideUsers: MM,
  LucideUsers2: pr,
  LucideUsersRound: pr,
  LucideUtensils: bM,
  LucideUtensilsCrossed: xM,
  LucideUtilityPole: wM,
  LucideVariable: IM,
  LucideVault: LM,
  LucideVegan: SM,
  LucideVenetianMask: CM,
  LucideVerified: ga,
  LucideVibrate: PM,
  LucideVibrateOff: AM,
  LucideVideo: TM,
  LucideVideoOff: qM,
  LucideVideotape: DM,
  LucideView: _M,
  LucideVoicemail: BM,
  LucideVolume: VM,
  LucideVolume1: zM,
  LucideVolume2: HM,
  LucideVolumeX: jM,
  LucideVote: OM,
  LucideWallet: RM,
  LucideWallet2: yr,
  LucideWalletCards: $M,
  LucideWalletMinimal: yr,
  LucideWallpaper: FM,
  LucideWand: UM,
  LucideWand2: kr,
  LucideWandSparkles: kr,
  LucideWarehouse: EM,
  LucideWashingMachine: WM,
  LucideWatch: NM,
  LucideWaves: ZM,
  LucideWaypoints: YM,
  LucideWebcam: GM,
  LucideWebhook: KM,
  LucideWebhookOff: XM,
  LucideWeight: QM,
  LucideWheat: ex,
  LucideWheatOff: JM,
  LucideWholeWord: tx,
  LucideWifi: nx,
  LucideWifiOff: ax,
  LucideWind: ox,
  LucideWine: ix,
  LucideWineOff: rx,
  LucideWorkflow: lx,
  LucideWorm: cx,
  LucideWrapText: dx,
  LucideWrench: sx,
  LucideX: ux,
  LucideXCircle: tn,
  LucideXOctagon: Hn,
  LucideXSquare: er,
  LucideYoutube: hx,
  LucideZap: yx,
  LucideZapOff: px,
  LucideZoomIn: kx,
  LucideZoomOut: fx,
  Luggage: lf,
  LuggageIcon: lf,
  MSquare: Bo,
  MSquareIcon: Bo,
  Magnet: cf,
  MagnetIcon: cf,
  Mail: vf,
  MailCheck: df,
  MailCheckIcon: df,
  MailIcon: vf,
  MailMinus: sf,
  MailMinusIcon: sf,
  MailOpen: uf,
  MailOpenIcon: uf,
  MailPlus: hf,
  MailPlusIcon: hf,
  MailQuestion: pf,
  MailQuestionIcon: pf,
  MailSearch: yf,
  MailSearchIcon: yf,
  MailWarning: kf,
  MailWarningIcon: kf,
  MailX: ff,
  MailXIcon: ff,
  Mailbox: mf,
  MailboxIcon: mf,
  Mails: gf,
  MailsIcon: gf,
  Map: wf,
  MapIcon: wf,
  MapPin: xf,
  MapPinIcon: xf,
  MapPinOff: Mf,
  MapPinOffIcon: Mf,
  MapPinned: bf,
  MapPinnedIcon: bf,
  Martini: If,
  MartiniIcon: If,
  Maximize: Sf,
  Maximize2: Lf,
  Maximize2Icon: Lf,
  MaximizeIcon: Sf,
  Medal: Cf,
  MedalIcon: Cf,
  Megaphone: Pf,
  MegaphoneIcon: Pf,
  MegaphoneOff: Af,
  MegaphoneOffIcon: Af,
  Meh: qf,
  MehIcon: qf,
  MemoryStick: Tf,
  MemoryStickIcon: Tf,
  Menu: Df,
  MenuIcon: Df,
  MenuSquare: zo,
  MenuSquareIcon: zo,
  Merge: _f,
  MergeIcon: _f,
  MessageCircle: Ef,
  MessageCircleCode: Bf,
  MessageCircleCodeIcon: Bf,
  MessageCircleDashed: zf,
  MessageCircleDashedIcon: zf,
  MessageCircleHeart: Hf,
  MessageCircleHeartIcon: Hf,
  MessageCircleIcon: Ef,
  MessageCircleMore: jf,
  MessageCircleMoreIcon: jf,
  MessageCircleOff: Vf,
  MessageCircleOffIcon: Vf,
  MessageCirclePlus: Of,
  MessageCirclePlusIcon: Of,
  MessageCircleQuestion: $f,
  MessageCircleQuestionIcon: $f,
  MessageCircleReply: Rf,
  MessageCircleReplyIcon: Rf,
  MessageCircleWarning: Ff,
  MessageCircleWarningIcon: Ff,
  MessageCircleX: Uf,
  MessageCircleXIcon: Uf,
  MessageSquare: rv,
  MessageSquareCode: Wf,
  MessageSquareCodeIcon: Wf,
  MessageSquareDashed: Nf,
  MessageSquareDashedIcon: Nf,
  MessageSquareDiff: Zf,
  MessageSquareDiffIcon: Zf,
  MessageSquareDot: Yf,
  MessageSquareDotIcon: Yf,
  MessageSquareHeart: Gf,
  MessageSquareHeartIcon: Gf,
  MessageSquareIcon: rv,
  MessageSquareMore: Xf,
  MessageSquareMoreIcon: Xf,
  MessageSquareOff: Kf,
  MessageSquareOffIcon: Kf,
  MessageSquarePlus: Qf,
  MessageSquarePlusIcon: Qf,
  MessageSquareQuote: Jf,
  MessageSquareQuoteIcon: Jf,
  MessageSquareReply: ev,
  MessageSquareReplyIcon: ev,
  MessageSquareShare: tv,
  MessageSquareShareIcon: tv,
  MessageSquareText: av,
  MessageSquareTextIcon: av,
  MessageSquareWarning: nv,
  MessageSquareWarningIcon: nv,
  MessageSquareX: ov,
  MessageSquareXIcon: ov,
  MessagesSquare: iv,
  MessagesSquareIcon: iv,
  Mic: cv,
  Mic2: Dn,
  Mic2Icon: Dn,
  MicIcon: cv,
  MicOff: lv,
  MicOffIcon: lv,
  MicVocal: Dn,
  MicVocalIcon: Dn,
  Microscope: dv,
  MicroscopeIcon: dv,
  Microwave: sv,
  MicrowaveIcon: sv,
  Milestone: uv,
  MilestoneIcon: uv,
  Milk: pv,
  MilkIcon: pv,
  MilkOff: hv,
  MilkOffIcon: hv,
  Minimize: kv,
  Minimize2: yv,
  Minimize2Icon: yv,
  MinimizeIcon: kv,
  Minus: fv,
  MinusCircle: Ua,
  MinusCircleIcon: Ua,
  MinusIcon: fv,
  MinusSquare: Ho,
  MinusSquareIcon: Ho,
  Monitor: Av,
  MonitorCheck: vv,
  MonitorCheckIcon: vv,
  MonitorDot: mv,
  MonitorDotIcon: mv,
  MonitorDown: gv,
  MonitorDownIcon: gv,
  MonitorIcon: Av,
  MonitorOff: Mv,
  MonitorOffIcon: Mv,
  MonitorPause: xv,
  MonitorPauseIcon: xv,
  MonitorPlay: bv,
  MonitorPlayIcon: bv,
  MonitorSmartphone: wv,
  MonitorSmartphoneIcon: wv,
  MonitorSpeaker: Iv,
  MonitorSpeakerIcon: Iv,
  MonitorStop: Lv,
  MonitorStopIcon: Lv,
  MonitorUp: Sv,
  MonitorUpIcon: Sv,
  MonitorX: Cv,
  MonitorXIcon: Cv,
  Moon: qv,
  MoonIcon: qv,
  MoonStar: Pv,
  MoonStarIcon: Pv,
  MoreHorizontal: yn,
  MoreHorizontalIcon: yn,
  MoreVertical: pn,
  MoreVerticalIcon: pn,
  Mountain: Dv,
  MountainIcon: Dv,
  MountainSnow: Tv,
  MountainSnowIcon: Tv,
  Mouse: jv,
  MouseIcon: jv,
  MouseOff: _v,
  MouseOffIcon: _v,
  MousePointer: Hv,
  MousePointer2: Bv,
  MousePointer2Icon: Bv,
  MousePointerClick: zv,
  MousePointerClickIcon: zv,
  MousePointerIcon: Hv,
  MousePointerSquareDashed: So,
  MousePointerSquareDashedIcon: So,
  Move: Xv,
  Move3D: _n,
  Move3DIcon: _n,
  Move3d: _n,
  Move3dIcon: _n,
  MoveDiagonal: Ov,
  MoveDiagonal2: Vv,
  MoveDiagonal2Icon: Vv,
  MoveDiagonalIcon: Ov,
  MoveDown: Fv,
  MoveDownIcon: Fv,
  MoveDownLeft: $v,
  MoveDownLeftIcon: $v,
  MoveDownRight: Rv,
  MoveDownRightIcon: Rv,
  MoveHorizontal: Uv,
  MoveHorizontalIcon: Uv,
  MoveIcon: Xv,
  MoveLeft: Ev,
  MoveLeftIcon: Ev,
  MoveRight: Wv,
  MoveRightIcon: Wv,
  MoveUp: Yv,
  MoveUpIcon: Yv,
  MoveUpLeft: Nv,
  MoveUpLeftIcon: Nv,
  MoveUpRight: Zv,
  MoveUpRightIcon: Zv,
  MoveVertical: Gv,
  MoveVerticalIcon: Gv,
  Music: em,
  Music2: Kv,
  Music2Icon: Kv,
  Music3: Qv,
  Music3Icon: Qv,
  Music4: Jv,
  Music4Icon: Jv,
  MusicIcon: em,
  Navigation: om,
  Navigation2: am,
  Navigation2Icon: am,
  Navigation2Off: tm,
  Navigation2OffIcon: tm,
  NavigationIcon: om,
  NavigationOff: nm,
  NavigationOffIcon: nm,
  Network: rm,
  NetworkIcon: rm,
  Newspaper: im,
  NewspaperIcon: im,
  Nfc: lm,
  NfcIcon: lm,
  Notebook: um,
  NotebookIcon: um,
  NotebookPen: cm,
  NotebookPenIcon: cm,
  NotebookTabs: dm,
  NotebookTabsIcon: dm,
  NotebookText: sm,
  NotebookTextIcon: sm,
  NotepadText: pm,
  NotepadTextDashed: hm,
  NotepadTextDashedIcon: hm,
  NotepadTextIcon: pm,
  Nut: km,
  NutIcon: km,
  NutOff: ym,
  NutOffIcon: ym,
  Octagon: fm,
  OctagonAlert: Bn,
  OctagonAlertIcon: Bn,
  OctagonIcon: fm,
  OctagonPause: zn,
  OctagonPauseIcon: zn,
  OctagonX: Hn,
  OctagonXIcon: Hn,
  Option: vm,
  OptionIcon: vm,
  Orbit: mm,
  OrbitIcon: mm,
  Outdent: Sn,
  OutdentIcon: Sn,
  Package: Sm,
  Package2: gm,
  Package2Icon: gm,
  PackageCheck: Mm,
  PackageCheckIcon: Mm,
  PackageIcon: Sm,
  PackageMinus: xm,
  PackageMinusIcon: xm,
  PackageOpen: bm,
  PackageOpenIcon: bm,
  PackagePlus: wm,
  PackagePlusIcon: wm,
  PackageSearch: Im,
  PackageSearchIcon: Im,
  PackageX: Lm,
  PackageXIcon: Lm,
  PaintBucket: Cm,
  PaintBucketIcon: Cm,
  PaintRoller: Am,
  PaintRollerIcon: Am,
  Paintbrush: qm,
  Paintbrush2: Pm,
  Paintbrush2Icon: Pm,
  PaintbrushIcon: qm,
  Palette: Tm,
  PaletteIcon: Tm,
  Palmtree: or,
  PalmtreeIcon: or,
  PanelBottom: Bm,
  PanelBottomClose: Dm,
  PanelBottomCloseIcon: Dm,
  PanelBottomDashed: jn,
  PanelBottomDashedIcon: jn,
  PanelBottomIcon: Bm,
  PanelBottomInactive: jn,
  PanelBottomInactiveIcon: jn,
  PanelBottomOpen: _m,
  PanelBottomOpenIcon: _m,
  PanelLeft: Rn,
  PanelLeftClose: Vn,
  PanelLeftCloseIcon: Vn,
  PanelLeftDashed: On,
  PanelLeftDashedIcon: On,
  PanelLeftIcon: Rn,
  PanelLeftInactive: On,
  PanelLeftInactiveIcon: On,
  PanelLeftOpen: $n,
  PanelLeftOpenIcon: $n,
  PanelRight: jm,
  PanelRightClose: zm,
  PanelRightCloseIcon: zm,
  PanelRightDashed: Fn,
  PanelRightDashedIcon: Fn,
  PanelRightIcon: jm,
  PanelRightInactive: Fn,
  PanelRightInactiveIcon: Fn,
  PanelRightOpen: Hm,
  PanelRightOpenIcon: Hm,
  PanelTop: $m,
  PanelTopClose: Vm,
  PanelTopCloseIcon: Vm,
  PanelTopDashed: Un,
  PanelTopDashedIcon: Un,
  PanelTopIcon: $m,
  PanelTopInactive: Un,
  PanelTopInactiveIcon: Un,
  PanelTopOpen: Om,
  PanelTopOpenIcon: Om,
  PanelsLeftBottom: Rm,
  PanelsLeftBottomIcon: Rm,
  PanelsLeftRight: dn,
  PanelsLeftRightIcon: dn,
  PanelsRightBottom: Fm,
  PanelsRightBottomIcon: Fm,
  PanelsTopBottom: Xn,
  PanelsTopBottomIcon: Xn,
  PanelsTopLeft: En,
  PanelsTopLeftIcon: En,
  Paperclip: Um,
  PaperclipIcon: Um,
  Parentheses: Em,
  ParenthesesIcon: Em,
  ParkingCircle: Wa,
  ParkingCircleIcon: Wa,
  ParkingCircleOff: Ea,
  ParkingCircleOffIcon: Ea,
  ParkingMeter: Wm,
  ParkingMeterIcon: Wm,
  ParkingSquare: Oo,
  ParkingSquareIcon: Oo,
  ParkingSquareOff: Vo,
  ParkingSquareOffIcon: Vo,
  PartyPopper: Nm,
  PartyPopperIcon: Nm,
  Pause: Zm,
  PauseCircle: Na,
  PauseCircleIcon: Na,
  PauseIcon: Zm,
  PauseOctagon: zn,
  PauseOctagonIcon: zn,
  PawPrint: Ym,
  PawPrintIcon: Ym,
  PcCase: Gm,
  PcCaseIcon: Gm,
  Pen: Nn,
  PenBox: vt,
  PenBoxIcon: vt,
  PenIcon: Nn,
  PenLine: Wn,
  PenLineIcon: Wn,
  PenSquare: vt,
  PenSquareIcon: vt,
  PenTool: Xm,
  PenToolIcon: Xm,
  Pencil: Jm,
  PencilIcon: Jm,
  PencilLine: Km,
  PencilLineIcon: Km,
  PencilRuler: Qm,
  PencilRulerIcon: Qm,
  Pentagon: e5,
  PentagonIcon: e5,
  Percent: t5,
  PercentCircle: Za,
  PercentCircleIcon: Za,
  PercentDiamond: un,
  PercentDiamondIcon: un,
  PercentIcon: t5,
  PercentSquare: $o,
  PercentSquareIcon: $o,
  PersonStanding: a5,
  PersonStandingIcon: a5,
  Phone: d5,
  PhoneCall: n5,
  PhoneCallIcon: n5,
  PhoneForwarded: o5,
  PhoneForwardedIcon: o5,
  PhoneIcon: d5,
  PhoneIncoming: r5,
  PhoneIncomingIcon: r5,
  PhoneMissed: i5,
  PhoneMissedIcon: i5,
  PhoneOff: l5,
  PhoneOffIcon: l5,
  PhoneOutgoing: c5,
  PhoneOutgoingIcon: c5,
  Pi: s5,
  PiIcon: s5,
  PiSquare: Ro,
  PiSquareIcon: Ro,
  Piano: u5,
  PianoIcon: u5,
  Pickaxe: h5,
  PickaxeIcon: h5,
  PictureInPicture: y5,
  PictureInPicture2: p5,
  PictureInPicture2Icon: p5,
  PictureInPictureIcon: y5,
  PieChart: k5,
  PieChartIcon: k5,
  PiggyBank: f5,
  PiggyBankIcon: f5,
  Pilcrow: g5,
  PilcrowIcon: g5,
  PilcrowLeft: v5,
  PilcrowLeftIcon: v5,
  PilcrowRight: m5,
  PilcrowRightIcon: m5,
  PilcrowSquare: Fo,
  PilcrowSquareIcon: Fo,
  Pill: M5,
  PillIcon: M5,
  Pin: b5,
  PinIcon: b5,
  PinOff: x5,
  PinOffIcon: x5,
  Pipette: w5,
  PipetteIcon: w5,
  Pizza: I5,
  PizzaIcon: I5,
  Plane: C5,
  PlaneIcon: C5,
  PlaneLanding: L5,
  PlaneLandingIcon: L5,
  PlaneTakeoff: S5,
  PlaneTakeoffIcon: S5,
  Play: A5,
  PlayCircle: Ya,
  PlayCircleIcon: Ya,
  PlayIcon: A5,
  PlaySquare: Uo,
  PlaySquareIcon: Uo,
  Plug: D5,
  Plug2: P5,
  Plug2Icon: P5,
  PlugIcon: D5,
  PlugZap: T5,
  PlugZap2: q5,
  PlugZap2Icon: q5,
  PlugZapIcon: T5,
  Plus: _5,
  PlusCircle: Ga,
  PlusCircleIcon: Ga,
  PlusIcon: _5,
  PlusSquare: Eo,
  PlusSquareIcon: Eo,
  Pocket: z5,
  PocketIcon: z5,
  PocketKnife: B5,
  PocketKnifeIcon: B5,
  Podcast: H5,
  PodcastIcon: H5,
  Pointer: V5,
  PointerIcon: V5,
  PointerOff: j5,
  PointerOffIcon: j5,
  Popcorn: O5,
  PopcornIcon: O5,
  Popsicle: $5,
  PopsicleIcon: $5,
  PoundSterling: R5,
  PoundSterlingIcon: R5,
  Power: U5,
  PowerCircle: Xa,
  PowerCircleIcon: Xa,
  PowerIcon: U5,
  PowerOff: F5,
  PowerOffIcon: F5,
  PowerSquare: Wo,
  PowerSquareIcon: Wo,
  Presentation: E5,
  PresentationIcon: E5,
  Printer: W5,
  PrinterIcon: W5,
  Projector: N5,
  ProjectorIcon: N5,
  Proportions: Z5,
  ProportionsIcon: Z5,
  Puzzle: Y5,
  PuzzleIcon: Y5,
  Pyramid: G5,
  PyramidIcon: G5,
  QrCode: X5,
  QrCodeIcon: X5,
  Quote: K5,
  QuoteIcon: K5,
  Rabbit: Q5,
  RabbitIcon: Q5,
  Radar: J5,
  RadarIcon: J5,
  Radiation: e3,
  RadiationIcon: e3,
  Radical: t3,
  RadicalIcon: t3,
  Radio: o3,
  RadioIcon: o3,
  RadioReceiver: a3,
  RadioReceiverIcon: a3,
  RadioTower: n3,
  RadioTowerIcon: n3,
  Radius: r3,
  RadiusIcon: r3,
  RailSymbol: i3,
  RailSymbolIcon: i3,
  Rainbow: l3,
  RainbowIcon: l3,
  Rat: c3,
  RatIcon: c3,
  Ratio: d3,
  RatioIcon: d3,
  Receipt: m3,
  ReceiptCent: s3,
  ReceiptCentIcon: s3,
  ReceiptEuro: u3,
  ReceiptEuroIcon: u3,
  ReceiptIcon: m3,
  ReceiptIndianRupee: h3,
  ReceiptIndianRupeeIcon: h3,
  ReceiptJapaneseYen: p3,
  ReceiptJapaneseYenIcon: p3,
  ReceiptPoundSterling: y3,
  ReceiptPoundSterlingIcon: y3,
  ReceiptRussianRuble: k3,
  ReceiptRussianRubleIcon: k3,
  ReceiptSwissFranc: f3,
  ReceiptSwissFrancIcon: f3,
  ReceiptText: v3,
  ReceiptTextIcon: v3,
  RectangleEllipsis: Zn,
  RectangleEllipsisIcon: Zn,
  RectangleHorizontal: g3,
  RectangleHorizontalIcon: g3,
  RectangleVertical: M3,
  RectangleVerticalIcon: M3,
  Recycle: x3,
  RecycleIcon: x3,
  Redo: I3,
  Redo2: b3,
  Redo2Icon: b3,
  RedoDot: w3,
  RedoDotIcon: w3,
  RedoIcon: I3,
  RefreshCcw: S3,
  RefreshCcwDot: L3,
  RefreshCcwDotIcon: L3,
  RefreshCcwIcon: S3,
  RefreshCw: A3,
  RefreshCwIcon: A3,
  RefreshCwOff: C3,
  RefreshCwOffIcon: C3,
  Refrigerator: P3,
  RefrigeratorIcon: P3,
  Regex: q3,
  RegexIcon: q3,
  RemoveFormatting: T3,
  RemoveFormattingIcon: T3,
  Repeat: B3,
  Repeat1: D3,
  Repeat1Icon: D3,
  Repeat2: _3,
  Repeat2Icon: _3,
  RepeatIcon: B3,
  Replace: H3,
  ReplaceAll: z3,
  ReplaceAllIcon: z3,
  ReplaceIcon: H3,
  Reply: V3,
  ReplyAll: j3,
  ReplyAllIcon: j3,
  ReplyIcon: V3,
  Rewind: O3,
  RewindIcon: O3,
  Ribbon: $3,
  RibbonIcon: $3,
  Rocket: R3,
  RocketIcon: R3,
  RockingChair: F3,
  RockingChairIcon: F3,
  RollerCoaster: U3,
  RollerCoasterIcon: U3,
  Rotate3D: Yn,
  Rotate3DIcon: Yn,
  Rotate3d: Yn,
  Rotate3dIcon: Yn,
  RotateCcw: W3,
  RotateCcwIcon: W3,
  RotateCcwSquare: E3,
  RotateCcwSquareIcon: E3,
  RotateCw: Z3,
  RotateCwIcon: Z3,
  RotateCwSquare: N3,
  RotateCwSquareIcon: N3,
  Route: G3,
  RouteIcon: G3,
  RouteOff: Y3,
  RouteOffIcon: Y3,
  Router: X3,
  RouterIcon: X3,
  Rows: Gn,
  Rows2: Gn,
  Rows2Icon: Gn,
  Rows3: Xn,
  Rows3Icon: Xn,
  Rows4: K3,
  Rows4Icon: K3,
  RowsIcon: Gn,
  Rss: Q3,
  RssIcon: Q3,
  Ruler: J3,
  RulerIcon: J3,
  RussianRuble: eg,
  RussianRubleIcon: eg,
  Sailboat: tg,
  SailboatIcon: tg,
  Salad: ag,
  SaladIcon: ag,
  Sandwich: ng,
  SandwichIcon: ng,
  Satellite: rg,
  SatelliteDish: og,
  SatelliteDishIcon: og,
  SatelliteIcon: rg,
  Save: lg,
  SaveAll: ig,
  SaveAllIcon: ig,
  SaveIcon: lg,
  Scale: cg,
  Scale3D: Kn,
  Scale3DIcon: Kn,
  Scale3d: Kn,
  Scale3dIcon: Kn,
  ScaleIcon: cg,
  Scaling: dg,
  ScalingIcon: dg,
  Scan: fg,
  ScanBarcode: sg,
  ScanBarcodeIcon: sg,
  ScanEye: ug,
  ScanEyeIcon: ug,
  ScanFace: hg,
  ScanFaceIcon: hg,
  ScanIcon: fg,
  ScanLine: pg,
  ScanLineIcon: pg,
  ScanSearch: yg,
  ScanSearchIcon: yg,
  ScanText: kg,
  ScanTextIcon: kg,
  ScatterChart: vg,
  ScatterChartIcon: vg,
  School: mg,
  School2: ir,
  School2Icon: ir,
  SchoolIcon: mg,
  Scissors: Mg,
  ScissorsIcon: Mg,
  ScissorsLineDashed: gg,
  ScissorsLineDashedIcon: gg,
  ScissorsSquare: No,
  ScissorsSquareDashedBottom: vo,
  ScissorsSquareDashedBottomIcon: vo,
  ScissorsSquareIcon: No,
  ScreenShare: bg,
  ScreenShareIcon: bg,
  ScreenShareOff: xg,
  ScreenShareOffIcon: xg,
  Scroll: Ig,
  ScrollIcon: Ig,
  ScrollText: wg,
  ScrollTextIcon: wg,
  Search: Pg,
  SearchCheck: Lg,
  SearchCheckIcon: Lg,
  SearchCode: Sg,
  SearchCodeIcon: Sg,
  SearchIcon: Pg,
  SearchSlash: Cg,
  SearchSlashIcon: Cg,
  SearchX: Ag,
  SearchXIcon: Ag,
  Send: Tg,
  SendHorizonal: Qn,
  SendHorizonalIcon: Qn,
  SendHorizontal: Qn,
  SendHorizontalIcon: Qn,
  SendIcon: Tg,
  SendToBack: qg,
  SendToBackIcon: qg,
  SeparatorHorizontal: Dg,
  SeparatorHorizontalIcon: Dg,
  SeparatorVertical: _g,
  SeparatorVerticalIcon: _g,
  Server: jg,
  ServerCog: Bg,
  ServerCogIcon: Bg,
  ServerCrash: zg,
  ServerCrashIcon: zg,
  ServerIcon: jg,
  ServerOff: Hg,
  ServerOffIcon: Hg,
  Settings: Og,
  Settings2: Vg,
  Settings2Icon: Vg,
  SettingsIcon: Og,
  Shapes: $g,
  ShapesIcon: $g,
  Share: Fg,
  Share2: Rg,
  Share2Icon: Rg,
  ShareIcon: Fg,
  Sheet: Ug,
  SheetIcon: Ug,
  Shell: Eg,
  ShellIcon: Eg,
  Shield: e6,
  ShieldAlert: Wg,
  ShieldAlertIcon: Wg,
  ShieldBan: Ng,
  ShieldBanIcon: Ng,
  ShieldCheck: Zg,
  ShieldCheckIcon: Zg,
  ShieldClose: Jn,
  ShieldCloseIcon: Jn,
  ShieldEllipsis: Yg,
  ShieldEllipsisIcon: Yg,
  ShieldHalf: Gg,
  ShieldHalfIcon: Gg,
  ShieldIcon: e6,
  ShieldMinus: Xg,
  ShieldMinusIcon: Xg,
  ShieldOff: Kg,
  ShieldOffIcon: Kg,
  ShieldPlus: Qg,
  ShieldPlusIcon: Qg,
  ShieldQuestion: Jg,
  ShieldQuestionIcon: Jg,
  ShieldX: Jn,
  ShieldXIcon: Jn,
  Ship: a6,
  ShipIcon: a6,
  ShipWheel: t6,
  ShipWheelIcon: t6,
  Shirt: n6,
  ShirtIcon: n6,
  ShoppingBag: o6,
  ShoppingBagIcon: o6,
  ShoppingBasket: r6,
  ShoppingBasketIcon: r6,
  ShoppingCart: i6,
  ShoppingCartIcon: i6,
  Shovel: l6,
  ShovelIcon: l6,
  ShowerHead: c6,
  ShowerHeadIcon: c6,
  Shrink: d6,
  ShrinkIcon: d6,
  Shrub: s6,
  ShrubIcon: s6,
  Shuffle: u6,
  ShuffleIcon: u6,
  Sidebar: Rn,
  SidebarClose: Vn,
  SidebarCloseIcon: Vn,
  SidebarIcon: Rn,
  SidebarOpen: $n,
  SidebarOpenIcon: $n,
  Sigma: h6,
  SigmaIcon: h6,
  SigmaSquare: Zo,
  SigmaSquareIcon: Zo,
  Signal: v6,
  SignalHigh: p6,
  SignalHighIcon: p6,
  SignalIcon: v6,
  SignalLow: y6,
  SignalLowIcon: y6,
  SignalMedium: k6,
  SignalMediumIcon: k6,
  SignalZero: f6,
  SignalZeroIcon: f6,
  Signpost: g6,
  SignpostBig: m6,
  SignpostBigIcon: m6,
  SignpostIcon: g6,
  Siren: M6,
  SirenIcon: M6,
  SkipBack: x6,
  SkipBackIcon: x6,
  SkipForward: b6,
  SkipForwardIcon: b6,
  Skull: w6,
  SkullIcon: w6,
  Slack: I6,
  SlackIcon: I6,
  Slash: L6,
  SlashIcon: L6,
  SlashSquare: Yo,
  SlashSquareIcon: Yo,
  Slice: S6,
  SliceIcon: S6,
  Sliders: eo,
  SlidersHorizontal: C6,
  SlidersHorizontalIcon: C6,
  SlidersIcon: eo,
  SlidersVertical: eo,
  SlidersVerticalIcon: eo,
  Smartphone: q6,
  SmartphoneCharging: A6,
  SmartphoneChargingIcon: A6,
  SmartphoneIcon: q6,
  SmartphoneNfc: P6,
  SmartphoneNfcIcon: P6,
  Smile: D6,
  SmileIcon: D6,
  SmilePlus: T6,
  SmilePlusIcon: T6,
  Snail: _6,
  SnailIcon: _6,
  Snowflake: B6,
  SnowflakeIcon: B6,
  Sofa: z6,
  SofaIcon: z6,
  SortAsc: fa,
  SortAscIcon: fa,
  SortDesc: pa,
  SortDescIcon: pa,
  Soup: H6,
  SoupIcon: H6,
  Space: j6,
  SpaceIcon: j6,
  Spade: V6,
  SpadeIcon: V6,
  Sparkle: O6,
  SparkleIcon: O6,
  Sparkles: to,
  SparklesIcon: to,
  Speaker: $6,
  SpeakerIcon: $6,
  Speech: R6,
  SpeechIcon: R6,
  SpellCheck: U6,
  SpellCheck2: F6,
  SpellCheck2Icon: F6,
  SpellCheckIcon: U6,
  Spline: E6,
  SplineIcon: E6,
  Split: W6,
  SplitIcon: W6,
  SplitSquareHorizontal: Go,
  SplitSquareHorizontalIcon: Go,
  SplitSquareVertical: Xo,
  SplitSquareVerticalIcon: Xo,
  SprayCan: N6,
  SprayCanIcon: N6,
  Sprout: Z6,
  SproutIcon: Z6,
  Square: Q6,
  SquareActivity: ao,
  SquareActivityIcon: ao,
  SquareArrowDown: ro,
  SquareArrowDownIcon: ro,
  SquareArrowDownLeft: no,
  SquareArrowDownLeftIcon: no,
  SquareArrowDownRight: oo,
  SquareArrowDownRightIcon: oo,
  SquareArrowLeft: io,
  SquareArrowLeftIcon: io,
  SquareArrowOutDownLeft: lo,
  SquareArrowOutDownLeftIcon: lo,
  SquareArrowOutDownRight: co,
  SquareArrowOutDownRightIcon: co,
  SquareArrowOutUpLeft: so,
  SquareArrowOutUpLeftIcon: so,
  SquareArrowOutUpRight: uo,
  SquareArrowOutUpRightIcon: uo,
  SquareArrowRight: ho,
  SquareArrowRightIcon: ho,
  SquareArrowUp: ko,
  SquareArrowUpIcon: ko,
  SquareArrowUpLeft: po,
  SquareArrowUpLeftIcon: po,
  SquareArrowUpRight: yo,
  SquareArrowUpRightIcon: yo,
  SquareAsterisk: fo,
  SquareAsteriskIcon: fo,
  SquareBottomDashedScissors: vo,
  SquareBottomDashedScissorsIcon: vo,
  SquareCheck: go,
  SquareCheckBig: mo,
  SquareCheckBigIcon: mo,
  SquareCheckIcon: go,
  SquareChevronDown: Mo,
  SquareChevronDownIcon: Mo,
  SquareChevronLeft: xo,
  SquareChevronLeftIcon: xo,
  SquareChevronRight: bo,
  SquareChevronRightIcon: bo,
  SquareChevronUp: wo,
  SquareChevronUpIcon: wo,
  SquareCode: Io,
  SquareCodeIcon: Io,
  SquareDashedBottom: G6,
  SquareDashedBottomCode: Y6,
  SquareDashedBottomCodeIcon: Y6,
  SquareDashedBottomIcon: G6,
  SquareDashedKanban: Lo,
  SquareDashedKanbanIcon: Lo,
  SquareDashedMousePointer: So,
  SquareDashedMousePointerIcon: So,
  SquareDivide: Co,
  SquareDivideIcon: Co,
  SquareDot: Ao,
  SquareDotIcon: Ao,
  SquareEqual: Po,
  SquareEqualIcon: Po,
  SquareFunction: qo,
  SquareFunctionIcon: qo,
  SquareGanttChart: To,
  SquareGanttChartIcon: To,
  SquareIcon: Q6,
  SquareKanban: Do,
  SquareKanbanIcon: Do,
  SquareLibrary: _o,
  SquareLibraryIcon: _o,
  SquareM: Bo,
  SquareMIcon: Bo,
  SquareMenu: zo,
  SquareMenuIcon: zo,
  SquareMinus: Ho,
  SquareMinusIcon: Ho,
  SquareMousePointer: jo,
  SquareMousePointerIcon: jo,
  SquareParking: Oo,
  SquareParkingIcon: Oo,
  SquareParkingOff: Vo,
  SquareParkingOffIcon: Vo,
  SquarePen: vt,
  SquarePenIcon: vt,
  SquarePercent: $o,
  SquarePercentIcon: $o,
  SquarePi: Ro,
  SquarePiIcon: Ro,
  SquarePilcrow: Fo,
  SquarePilcrowIcon: Fo,
  SquarePlay: Uo,
  SquarePlayIcon: Uo,
  SquarePlus: Eo,
  SquarePlusIcon: Eo,
  SquarePower: Wo,
  SquarePowerIcon: Wo,
  SquareRadical: X6,
  SquareRadicalIcon: X6,
  SquareScissors: No,
  SquareScissorsIcon: No,
  SquareSigma: Zo,
  SquareSigmaIcon: Zo,
  SquareSlash: Yo,
  SquareSlashIcon: Yo,
  SquareSplitHorizontal: Go,
  SquareSplitHorizontalIcon: Go,
  SquareSplitVertical: Xo,
  SquareSplitVerticalIcon: Xo,
  SquareStack: K6,
  SquareStackIcon: K6,
  SquareTerminal: Ko,
  SquareTerminalIcon: Ko,
  SquareUser: Jo,
  SquareUserIcon: Jo,
  SquareUserRound: Qo,
  SquareUserRoundIcon: Qo,
  SquareX: er,
  SquareXIcon: er,
  Squircle: J6,
  SquircleIcon: J6,
  Squirrel: e8,
  SquirrelIcon: e8,
  Stamp: t8,
  StampIcon: t8,
  Star: o8,
  StarHalf: a8,
  StarHalfIcon: a8,
  StarIcon: o8,
  StarOff: n8,
  StarOffIcon: n8,
  Stars: to,
  StarsIcon: to,
  StepBack: r8,
  StepBackIcon: r8,
  StepForward: i8,
  StepForwardIcon: i8,
  Stethoscope: l8,
  StethoscopeIcon: l8,
  Sticker: c8,
  StickerIcon: c8,
  StickyNote: d8,
  StickyNoteIcon: d8,
  StopCircle: Qa,
  StopCircleIcon: Qa,
  Store: s8,
  StoreIcon: s8,
  StretchHorizontal: u8,
  StretchHorizontalIcon: u8,
  StretchVertical: h8,
  StretchVerticalIcon: h8,
  Strikethrough: p8,
  StrikethroughIcon: p8,
  Subscript: y8,
  SubscriptIcon: y8,
  Subtitles: Ia,
  SubtitlesIcon: Ia,
  Sun: g8,
  SunDim: k8,
  SunDimIcon: k8,
  SunIcon: g8,
  SunMedium: f8,
  SunMediumIcon: f8,
  SunMoon: v8,
  SunMoonIcon: v8,
  SunSnow: m8,
  SunSnowIcon: m8,
  Sunrise: M8,
  SunriseIcon: M8,
  Sunset: x8,
  SunsetIcon: x8,
  Superscript: b8,
  SuperscriptIcon: b8,
  SwatchBook: w8,
  SwatchBookIcon: w8,
  SwissFranc: I8,
  SwissFrancIcon: I8,
  SwitchCamera: L8,
  SwitchCameraIcon: L8,
  Sword: S8,
  SwordIcon: S8,
  Swords: C8,
  SwordsIcon: C8,
  Syringe: A8,
  SyringeIcon: A8,
  Table: z8,
  Table2: P8,
  Table2Icon: P8,
  TableCellsMerge: q8,
  TableCellsMergeIcon: q8,
  TableCellsSplit: T8,
  TableCellsSplitIcon: T8,
  TableColumnsSplit: D8,
  TableColumnsSplitIcon: D8,
  TableIcon: z8,
  TableProperties: _8,
  TablePropertiesIcon: _8,
  TableRowsSplit: B8,
  TableRowsSplitIcon: B8,
  Tablet: j8,
  TabletIcon: j8,
  TabletSmartphone: H8,
  TabletSmartphoneIcon: H8,
  Tablets: V8,
  TabletsIcon: V8,
  Tag: O8,
  TagIcon: O8,
  Tags: $8,
  TagsIcon: $8,
  Tally1: R8,
  Tally1Icon: R8,
  Tally2: F8,
  Tally2Icon: F8,
  Tally3: U8,
  Tally3Icon: U8,
  Tally4: E8,
  Tally4Icon: E8,
  Tally5: W8,
  Tally5Icon: W8,
  Tangent: N8,
  TangentIcon: N8,
  Target: Z8,
  TargetIcon: Z8,
  Telescope: Y8,
  TelescopeIcon: Y8,
  Tent: X8,
  TentIcon: X8,
  TentTree: G8,
  TentTreeIcon: G8,
  Terminal: K8,
  TerminalIcon: K8,
  TerminalSquare: Ko,
  TerminalSquareIcon: Ko,
  TestTube: Q8,
  TestTube2: tr,
  TestTube2Icon: tr,
  TestTubeDiagonal: tr,
  TestTubeDiagonalIcon: tr,
  TestTubeIcon: Q8,
  TestTubes: J8,
  TestTubesIcon: J8,
  Text: o7,
  TextCursor: t7,
  TextCursorIcon: t7,
  TextCursorInput: e7,
  TextCursorInputIcon: e7,
  TextIcon: o7,
  TextQuote: a7,
  TextQuoteIcon: a7,
  TextSearch: n7,
  TextSearchIcon: n7,
  TextSelect: ar,
  TextSelectIcon: ar,
  TextSelection: ar,
  TextSelectionIcon: ar,
  Theater: r7,
  TheaterIcon: r7,
  Thermometer: c7,
  ThermometerIcon: c7,
  ThermometerSnowflake: i7,
  ThermometerSnowflakeIcon: i7,
  ThermometerSun: l7,
  ThermometerSunIcon: l7,
  ThumbsDown: d7,
  ThumbsDownIcon: d7,
  ThumbsUp: s7,
  ThumbsUpIcon: s7,
  Ticket: v7,
  TicketCheck: u7,
  TicketCheckIcon: u7,
  TicketIcon: v7,
  TicketMinus: h7,
  TicketMinusIcon: h7,
  TicketPercent: p7,
  TicketPercentIcon: p7,
  TicketPlus: y7,
  TicketPlusIcon: y7,
  TicketSlash: k7,
  TicketSlashIcon: k7,
  TicketX: f7,
  TicketXIcon: f7,
  Timer: M7,
  TimerIcon: M7,
  TimerOff: m7,
  TimerOffIcon: m7,
  TimerReset: g7,
  TimerResetIcon: g7,
  ToggleLeft: x7,
  ToggleLeftIcon: x7,
  ToggleRight: b7,
  ToggleRightIcon: b7,
  Tornado: w7,
  TornadoIcon: w7,
  Torus: I7,
  TorusIcon: I7,
  Touchpad: S7,
  TouchpadIcon: S7,
  TouchpadOff: L7,
  TouchpadOffIcon: L7,
  TowerControl: C7,
  TowerControlIcon: C7,
  ToyBrick: A7,
  ToyBrickIcon: A7,
  Tractor: P7,
  TractorIcon: P7,
  TrafficCone: q7,
  TrafficConeIcon: q7,
  Train: nr,
  TrainFront: D7,
  TrainFrontIcon: D7,
  TrainFrontTunnel: T7,
  TrainFrontTunnelIcon: T7,
  TrainIcon: nr,
  TrainTrack: _7,
  TrainTrackIcon: _7,
  TramFront: nr,
  TramFrontIcon: nr,
  Trash: z7,
  Trash2: B7,
  Trash2Icon: B7,
  TrashIcon: z7,
  TreeDeciduous: H7,
  TreeDeciduousIcon: H7,
  TreePalm: or,
  TreePalmIcon: or,
  TreePine: j7,
  TreePineIcon: j7,
  Trees: V7,
  TreesIcon: V7,
  Trello: O7,
  TrelloIcon: O7,
  TrendingDown: $7,
  TrendingDownIcon: $7,
  TrendingUp: R7,
  TrendingUpIcon: R7,
  Triangle: U7,
  TriangleAlert: rr,
  TriangleAlertIcon: rr,
  TriangleIcon: U7,
  TriangleRight: F7,
  TriangleRightIcon: F7,
  Trophy: E7,
  TrophyIcon: E7,
  Truck: W7,
  TruckIcon: W7,
  Turtle: N7,
  TurtleIcon: N7,
  Tv: Y7,
  Tv2: Z7,
  Tv2Icon: Z7,
  TvIcon: Y7,
  Twitch: G7,
  TwitchIcon: G7,
  Twitter: X7,
  TwitterIcon: X7,
  Type: K7,
  TypeIcon: K7,
  Umbrella: J7,
  UmbrellaIcon: J7,
  UmbrellaOff: Q7,
  UmbrellaOffIcon: Q7,
  Underline: eM,
  UnderlineIcon: eM,
  Undo: nM,
  Undo2: tM,
  Undo2Icon: tM,
  UndoDot: aM,
  UndoDotIcon: aM,
  UndoIcon: nM,
  UnfoldHorizontal: oM,
  UnfoldHorizontalIcon: oM,
  UnfoldVertical: rM,
  UnfoldVerticalIcon: rM,
  Ungroup: iM,
  UngroupIcon: iM,
  University: ir,
  UniversityIcon: ir,
  Unlink: cM,
  Unlink2: lM,
  Unlink2Icon: lM,
  UnlinkIcon: cM,
  Unlock: Tn,
  UnlockIcon: Tn,
  UnlockKeyhole: qn,
  UnlockKeyholeIcon: qn,
  Unplug: dM,
  UnplugIcon: dM,
  Upload: sM,
  UploadCloud: rn,
  UploadCloudIcon: rn,
  UploadIcon: sM,
  Usb: uM,
  UsbIcon: uM,
  User: gM,
  User2: hr,
  User2Icon: hr,
  UserCheck: hM,
  UserCheck2: lr,
  UserCheck2Icon: lr,
  UserCheckIcon: hM,
  UserCircle: en,
  UserCircle2: Ja,
  UserCircle2Icon: Ja,
  UserCircleIcon: en,
  UserCog: pM,
  UserCog2: cr,
  UserCog2Icon: cr,
  UserCogIcon: pM,
  UserIcon: gM,
  UserMinus: yM,
  UserMinus2: dr,
  UserMinus2Icon: dr,
  UserMinusIcon: yM,
  UserPlus: kM,
  UserPlus2: sr,
  UserPlus2Icon: sr,
  UserPlusIcon: kM,
  UserRound: hr,
  UserRoundCheck: lr,
  UserRoundCheckIcon: lr,
  UserRoundCog: cr,
  UserRoundCogIcon: cr,
  UserRoundIcon: hr,
  UserRoundMinus: dr,
  UserRoundMinusIcon: dr,
  UserRoundPlus: sr,
  UserRoundPlusIcon: sr,
  UserRoundSearch: fM,
  UserRoundSearchIcon: fM,
  UserRoundX: ur,
  UserRoundXIcon: ur,
  UserSearch: vM,
  UserSearchIcon: vM,
  UserSquare: Jo,
  UserSquare2: Qo,
  UserSquare2Icon: Qo,
  UserSquareIcon: Jo,
  UserX: mM,
  UserX2: ur,
  UserX2Icon: ur,
  UserXIcon: mM,
  Users: MM,
  Users2: pr,
  Users2Icon: pr,
  UsersIcon: MM,
  UsersRound: pr,
  UsersRoundIcon: pr,
  Utensils: bM,
  UtensilsCrossed: xM,
  UtensilsCrossedIcon: xM,
  UtensilsIcon: bM,
  UtilityPole: wM,
  UtilityPoleIcon: wM,
  Variable: IM,
  VariableIcon: IM,
  Vault: LM,
  VaultIcon: LM,
  Vegan: SM,
  VeganIcon: SM,
  VenetianMask: CM,
  VenetianMaskIcon: CM,
  Verified: ga,
  VerifiedIcon: ga,
  Vibrate: PM,
  VibrateIcon: PM,
  VibrateOff: AM,
  VibrateOffIcon: AM,
  Video: TM,
  VideoIcon: TM,
  VideoOff: qM,
  VideoOffIcon: qM,
  Videotape: DM,
  VideotapeIcon: DM,
  View: _M,
  ViewIcon: _M,
  Voicemail: BM,
  VoicemailIcon: BM,
  Volume: VM,
  Volume1: zM,
  Volume1Icon: zM,
  Volume2: HM,
  Volume2Icon: HM,
  VolumeIcon: VM,
  VolumeX: jM,
  VolumeXIcon: jM,
  Vote: OM,
  VoteIcon: OM,
  Wallet: RM,
  Wallet2: yr,
  Wallet2Icon: yr,
  WalletCards: $M,
  WalletCardsIcon: $M,
  WalletIcon: RM,
  WalletMinimal: yr,
  WalletMinimalIcon: yr,
  Wallpaper: FM,
  WallpaperIcon: FM,
  Wand: UM,
  Wand2: kr,
  Wand2Icon: kr,
  WandIcon: UM,
  WandSparkles: kr,
  WandSparklesIcon: kr,
  Warehouse: EM,
  WarehouseIcon: EM,
  WashingMachine: WM,
  WashingMachineIcon: WM,
  Watch: NM,
  WatchIcon: NM,
  Waves: ZM,
  WavesIcon: ZM,
  Waypoints: YM,
  WaypointsIcon: YM,
  Webcam: GM,
  WebcamIcon: GM,
  Webhook: KM,
  WebhookIcon: KM,
  WebhookOff: XM,
  WebhookOffIcon: XM,
  Weight: QM,
  WeightIcon: QM,
  Wheat: ex,
  WheatIcon: ex,
  WheatOff: JM,
  WheatOffIcon: JM,
  WholeWord: tx,
  WholeWordIcon: tx,
  Wifi: nx,
  WifiIcon: nx,
  WifiOff: ax,
  WifiOffIcon: ax,
  Wind: ox,
  WindIcon: ox,
  Wine: ix,
  WineIcon: ix,
  WineOff: rx,
  WineOffIcon: rx,
  Workflow: lx,
  WorkflowIcon: lx,
  Worm: cx,
  WormIcon: cx,
  WrapText: dx,
  WrapTextIcon: dx,
  Wrench: sx,
  WrenchIcon: sx,
  X: ux,
  XCircle: tn,
  XCircleIcon: tn,
  XIcon: ux,
  XOctagon: Hn,
  XOctagonIcon: Hn,
  XSquare: er,
  XSquareIcon: er,
  Youtube: hx,
  YoutubeIcon: hx,
  Zap: yx,
  ZapIcon: yx,
  ZapOff: px,
  ZapOffIcon: px,
  ZoomIn: kx,
  ZoomInIcon: kx,
  ZoomOut: fx,
  ZoomOutIcon: fx,
  icons: oS
}, Symbol.toStringTag, { value: "Module" }));
var I1 = typeof globalThis < "u" ? globalThis : typeof window < "u" ? window : typeof global < "u" ? global : typeof self < "u" ? self : {};
function _x(e) {
  return e && e.__esModule && Object.prototype.hasOwnProperty.call(e, "default") ? e.default : e;
}
function rS() {
  this.__data__ = [], this.size = 0;
}
var iS = rS;
function lS(e, t) {
  return e === t || e !== e && t !== t;
}
var h1 = lS, cS = h1;
function dS(e, t) {
  for (var a = e.length; a--; )
    if (cS(e[a][0], t))
      return a;
  return -1;
}
var Bx = dS, sS = Bx, uS = Array.prototype, hS = uS.splice;
function pS(e) {
  var t = this.__data__, a = sS(t, e);
  if (a < 0)
    return !1;
  var o = t.length - 1;
  return a == o ? t.pop() : hS.call(t, a, 1), --this.size, !0;
}
var yS = pS, kS = Bx;
function fS(e) {
  var t = this.__data__, a = kS(t, e);
  return a < 0 ? void 0 : t[a][1];
}
var vS = fS, mS = Bx;
function gS(e) {
  return mS(this.__data__, e) > -1;
}
var MS = gS, xS = Bx;
function bS(e, t) {
  var a = this.__data__, o = xS(a, e);
  return o < 0 ? (++this.size, a.push([e, t])) : a[o][1] = t, this;
}
var wS = bS, IS = iS, LS = yS, SS = vS, CS = MS, AS = wS;
function Fr(e) {
  var t = -1, a = e == null ? 0 : e.length;
  for (this.clear(); ++t < a; ) {
    var o = e[t];
    this.set(o[0], o[1]);
  }
}
Fr.prototype.clear = IS;
Fr.prototype.delete = LS;
Fr.prototype.get = SS;
Fr.prototype.has = CS;
Fr.prototype.set = AS;
var zx = Fr, PS = zx;
function qS() {
  this.__data__ = new PS(), this.size = 0;
}
var TS = qS;
function DS(e) {
  var t = this.__data__, a = t.delete(e);
  return this.size = t.size, a;
}
var _S = DS;
function BS(e) {
  return this.__data__.get(e);
}
var zS = BS;
function HS(e) {
  return this.__data__.has(e);
}
var jS = HS, VS = typeof I1 == "object" && I1 && I1.Object === Object && I1, yI = VS, OS = yI, $S = typeof self == "object" && self && self.Object === Object && self, RS = OS || $S || Function("return this")(), Rt = RS, FS = Rt, US = FS.Symbol, p1 = US, jb = p1, kI = Object.prototype, ES = kI.hasOwnProperty, WS = kI.toString, Kr = jb ? jb.toStringTag : void 0;
function NS(e) {
  var t = ES.call(e, Kr), a = e[Kr];
  try {
    e[Kr] = void 0;
    var o = !0;
  } catch {
  }
  var n = WS.call(e);
  return o && (t ? e[Kr] = a : delete e[Kr]), n;
}
var ZS = NS, YS = Object.prototype, GS = YS.toString;
function XS(e) {
  return GS.call(e);
}
var KS = XS, Vb = p1, QS = ZS, JS = KS, eC = "[object Null]", tC = "[object Undefined]", Ob = Vb ? Vb.toStringTag : void 0;
function aC(e) {
  return e == null ? e === void 0 ? tC : eC : Ob && Ob in Object(e) ? QS(e) : JS(e);
}
var Ur = aC;
function nC(e) {
  var t = typeof e;
  return e != null && (t == "object" || t == "function");
}
var Ft = nC, oC = Ur, rC = Ft, iC = "[object AsyncFunction]", lC = "[object Function]", cC = "[object GeneratorFunction]", dC = "[object Proxy]";
function sC(e) {
  if (!rC(e))
    return !1;
  var t = oC(e);
  return t == lC || t == cC || t == iC || t == dC;
}
var Z9 = sC, uC = Rt, hC = uC["__core-js_shared__"], pC = hC, o9 = pC, $b = function() {
  var e = /[^.]+$/.exec(o9 && o9.keys && o9.keys.IE_PROTO || "");
  return e ? "Symbol(src)_1." + e : "";
}();
function yC(e) {
  return !!$b && $b in e;
}
var kC = yC, fC = Function.prototype, vC = fC.toString;
function mC(e) {
  if (e != null) {
    try {
      return vC.call(e);
    } catch {
    }
    try {
      return e + "";
    } catch {
    }
  }
  return "";
}
var fI = mC, gC = Z9, MC = kC, xC = Ft, bC = fI, wC = /[\\^$.*+?()[\]{}|]/g, IC = /^\[object .+?Constructor\]$/, LC = Function.prototype, SC = Object.prototype, CC = LC.toString, AC = SC.hasOwnProperty, PC = RegExp(
  "^" + CC.call(AC).replace(wC, "\\$&").replace(/hasOwnProperty|(function).*?(?=\\\()| for .+?(?=\\\])/g, "$1.*?") + "$"
);
function qC(e) {
  if (!xC(e) || MC(e))
    return !1;
  var t = gC(e) ? PC : IC;
  return t.test(bC(e));
}
var TC = qC;
function DC(e, t) {
  return e == null ? void 0 : e[t];
}
var _C = DC, BC = TC, zC = _C;
function HC(e, t) {
  var a = zC(e, t);
  return BC(a) ? a : void 0;
}
var Sr = HC, jC = Sr, VC = Rt, OC = jC(VC, "Map"), Y9 = OC, $C = Sr, RC = $C(Object, "create"), Hx = RC, Rb = Hx;
function FC() {
  this.__data__ = Rb ? Rb(null) : {}, this.size = 0;
}
var UC = FC;
function EC(e) {
  var t = this.has(e) && delete this.__data__[e];
  return this.size -= t ? 1 : 0, t;
}
var WC = EC, NC = Hx, ZC = "__lodash_hash_undefined__", YC = Object.prototype, GC = YC.hasOwnProperty;
function XC(e) {
  var t = this.__data__;
  if (NC) {
    var a = t[e];
    return a === ZC ? void 0 : a;
  }
  return GC.call(t, e) ? t[e] : void 0;
}
var KC = XC, QC = Hx, JC = Object.prototype, eA = JC.hasOwnProperty;
function tA(e) {
  var t = this.__data__;
  return QC ? t[e] !== void 0 : eA.call(t, e);
}
var aA = tA, nA = Hx, oA = "__lodash_hash_undefined__";
function rA(e, t) {
  var a = this.__data__;
  return this.size += this.has(e) ? 0 : 1, a[e] = nA && t === void 0 ? oA : t, this;
}
var iA = rA, lA = UC, cA = WC, dA = KC, sA = aA, uA = iA;
function Er(e) {
  var t = -1, a = e == null ? 0 : e.length;
  for (this.clear(); ++t < a; ) {
    var o = e[t];
    this.set(o[0], o[1]);
  }
}
Er.prototype.clear = lA;
Er.prototype.delete = cA;
Er.prototype.get = dA;
Er.prototype.has = sA;
Er.prototype.set = uA;
var hA = Er, Fb = hA, pA = zx, yA = Y9;
function kA() {
  this.size = 0, this.__data__ = {
    hash: new Fb(),
    map: new (yA || pA)(),
    string: new Fb()
  };
}
var fA = kA;
function vA(e) {
  var t = typeof e;
  return t == "string" || t == "number" || t == "symbol" || t == "boolean" ? e !== "__proto__" : e === null;
}
var mA = vA, gA = mA;
function MA(e, t) {
  var a = e.__data__;
  return gA(t) ? a[typeof t == "string" ? "string" : "hash"] : a.map;
}
var jx = MA, xA = jx;
function bA(e) {
  var t = xA(this, e).delete(e);
  return this.size -= t ? 1 : 0, t;
}
var wA = bA, IA = jx;
function LA(e) {
  return IA(this, e).get(e);
}
var SA = LA, CA = jx;
function AA(e) {
  return CA(this, e).has(e);
}
var PA = AA, qA = jx;
function TA(e, t) {
  var a = qA(this, e), o = a.size;
  return a.set(e, t), this.size += a.size == o ? 0 : 1, this;
}
var DA = TA, _A = fA, BA = wA, zA = SA, HA = PA, jA = DA;
function Wr(e) {
  var t = -1, a = e == null ? 0 : e.length;
  for (this.clear(); ++t < a; ) {
    var o = e[t];
    this.set(o[0], o[1]);
  }
}
Wr.prototype.clear = _A;
Wr.prototype.delete = BA;
Wr.prototype.get = zA;
Wr.prototype.has = HA;
Wr.prototype.set = jA;
var G9 = Wr, VA = zx, OA = Y9, $A = G9, RA = 200;
function FA(e, t) {
  var a = this.__data__;
  if (a instanceof VA) {
    var o = a.__data__;
    if (!OA || o.length < RA - 1)
      return o.push([e, t]), this.size = ++a.size, this;
    a = this.__data__ = new $A(o);
  }
  return a.set(e, t), this.size = a.size, this;
}
var UA = FA, EA = zx, WA = TS, NA = _S, ZA = zS, YA = jS, GA = UA;
function Nr(e) {
  var t = this.__data__ = new EA(e);
  this.size = t.size;
}
Nr.prototype.clear = WA;
Nr.prototype.delete = NA;
Nr.prototype.get = ZA;
Nr.prototype.has = YA;
Nr.prototype.set = GA;
var Vx = Nr, XA = Sr, KA = function() {
  try {
    var e = XA(Object, "defineProperty");
    return e({}, "", {}), e;
  } catch {
  }
}(), vI = KA, Ub = vI;
function QA(e, t, a) {
  t == "__proto__" && Ub ? Ub(e, t, {
    configurable: !0,
    enumerable: !0,
    value: a,
    writable: !0
  }) : e[t] = a;
}
var X9 = QA, JA = X9, eP = h1;
function tP(e, t, a) {
  (a !== void 0 && !eP(e[t], a) || a === void 0 && !(t in e)) && JA(e, t, a);
}
var mI = tP;
function aP(e) {
  return function(t, a, o) {
    for (var n = -1, i = Object(t), l = o(t), c = l.length; c--; ) {
      var s = l[e ? c : ++n];
      if (a(i[s], s, i) === !1)
        break;
    }
    return t;
  };
}
var nP = aP, oP = nP, rP = oP(), gI = rP, gx = { exports: {} };
gx.exports;
(function(e, t) {
  var a = Rt, o = t && !t.nodeType && t, n = o && !0 && e && !e.nodeType && e, i = n && n.exports === o, l = i ? a.Buffer : void 0, c = l ? l.allocUnsafe : void 0;
  function s(h, m) {
    if (m)
      return h.slice();
    var p = h.length, f = c ? c(p) : new h.constructor(p);
    return h.copy(f), f;
  }
  e.exports = s;
})(gx, gx.exports);
var MI = gx.exports, iP = Rt, lP = iP.Uint8Array, xI = lP, Eb = xI;
function cP(e) {
  var t = new e.constructor(e.byteLength);
  return new Eb(t).set(new Eb(e)), t;
}
var K9 = cP, dP = K9;
function sP(e, t) {
  var a = t ? dP(e.buffer) : e.buffer;
  return new e.constructor(a, e.byteOffset, e.length);
}
var bI = sP;
function uP(e, t) {
  var a = -1, o = e.length;
  for (t || (t = Array(o)); ++a < o; )
    t[a] = e[a];
  return t;
}
var wI = uP, hP = Ft, Wb = Object.create, pP = function() {
  function e() {
  }
  return function(t) {
    if (!hP(t))
      return {};
    if (Wb)
      return Wb(t);
    e.prototype = t;
    var a = new e();
    return e.prototype = void 0, a;
  };
}(), yP = pP;
function kP(e, t) {
  return function(a) {
    return e(t(a));
  };
}
var II = kP, fP = II, vP = fP(Object.getPrototypeOf, Object), Q9 = vP, mP = Object.prototype;
function gP(e) {
  var t = e && e.constructor, a = typeof t == "function" && t.prototype || mP;
  return e === a;
}
var J9 = gP, MP = yP, xP = Q9, bP = J9;
function wP(e) {
  return typeof e.constructor == "function" && !bP(e) ? MP(xP(e)) : {};
}
var LI = wP;
function IP(e) {
  return e != null && typeof e == "object";
}
var Xt = IP, LP = Ur, SP = Xt, CP = "[object Arguments]";
function AP(e) {
  return SP(e) && LP(e) == CP;
}
var PP = AP, Nb = PP, qP = Xt, SI = Object.prototype, TP = SI.hasOwnProperty, DP = SI.propertyIsEnumerable, _P = Nb(function() {
  return arguments;
}()) ? Nb : function(e) {
  return qP(e) && TP.call(e, "callee") && !DP.call(e, "callee");
}, eb = _P, BP = Array.isArray, Lt = BP, zP = 9007199254740991;
function HP(e) {
  return typeof e == "number" && e > -1 && e % 1 == 0 && e <= zP;
}
var tb = HP, jP = Z9, VP = tb;
function OP(e) {
  return e != null && VP(e.length) && !jP(e);
}
var Zr = OP, $P = Zr, RP = Xt;
function FP(e) {
  return RP(e) && $P(e);
}
var UP = FP, Mx = { exports: {} };
function EP() {
  return !1;
}
var WP = EP;
Mx.exports;
(function(e, t) {
  var a = Rt, o = WP, n = t && !t.nodeType && t, i = n && !0 && e && !e.nodeType && e, l = i && i.exports === n, c = l ? a.Buffer : void 0, s = c ? c.isBuffer : void 0, h = s || o;
  e.exports = h;
})(Mx, Mx.exports);
var Ox = Mx.exports, NP = Ur, ZP = Q9, YP = Xt, GP = "[object Object]", XP = Function.prototype, KP = Object.prototype, CI = XP.toString, QP = KP.hasOwnProperty, JP = CI.call(Object);
function eq(e) {
  if (!YP(e) || NP(e) != GP)
    return !1;
  var t = ZP(e);
  if (t === null)
    return !0;
  var a = QP.call(t, "constructor") && t.constructor;
  return typeof a == "function" && a instanceof a && CI.call(a) == JP;
}
var tq = eq, aq = Ur, nq = tb, oq = Xt, rq = "[object Arguments]", iq = "[object Array]", lq = "[object Boolean]", cq = "[object Date]", dq = "[object Error]", sq = "[object Function]", uq = "[object Map]", hq = "[object Number]", pq = "[object Object]", yq = "[object RegExp]", kq = "[object Set]", fq = "[object String]", vq = "[object WeakMap]", mq = "[object ArrayBuffer]", gq = "[object DataView]", Mq = "[object Float32Array]", xq = "[object Float64Array]", bq = "[object Int8Array]", wq = "[object Int16Array]", Iq = "[object Int32Array]", Lq = "[object Uint8Array]", Sq = "[object Uint8ClampedArray]", Cq = "[object Uint16Array]", Aq = "[object Uint32Array]", Ye = {};
Ye[Mq] = Ye[xq] = Ye[bq] = Ye[wq] = Ye[Iq] = Ye[Lq] = Ye[Sq] = Ye[Cq] = Ye[Aq] = !0;
Ye[rq] = Ye[iq] = Ye[mq] = Ye[lq] = Ye[gq] = Ye[cq] = Ye[dq] = Ye[sq] = Ye[uq] = Ye[hq] = Ye[pq] = Ye[yq] = Ye[kq] = Ye[fq] = Ye[vq] = !1;
function Pq(e) {
  return oq(e) && nq(e.length) && !!Ye[aq(e)];
}
var qq = Pq;
function Tq(e) {
  return function(t) {
    return e(t);
  };
}
var $x = Tq, xx = { exports: {} };
xx.exports;
(function(e, t) {
  var a = yI, o = t && !t.nodeType && t, n = o && !0 && e && !e.nodeType && e, i = n && n.exports === o, l = i && a.process, c = function() {
    try {
      var s = n && n.require && n.require("util").types;
      return s || l && l.binding && l.binding("util");
    } catch {
    }
  }();
  e.exports = c;
})(xx, xx.exports);
var ab = xx.exports, Dq = qq, _q = $x, Zb = ab, Yb = Zb && Zb.isTypedArray, Bq = Yb ? _q(Yb) : Dq, nb = Bq;
function zq(e, t) {
  if (!(t === "constructor" && typeof e[t] == "function") && t != "__proto__")
    return e[t];
}
var AI = zq, Hq = X9, jq = h1, Vq = Object.prototype, Oq = Vq.hasOwnProperty;
function $q(e, t, a) {
  var o = e[t];
  (!(Oq.call(e, t) && jq(o, a)) || a === void 0 && !(t in e)) && Hq(e, t, a);
}
var PI = $q, Rq = PI, Fq = X9;
function Uq(e, t, a, o) {
  var n = !a;
  a || (a = {});
  for (var i = -1, l = t.length; ++i < l; ) {
    var c = t[i], s = o ? o(a[c], e[c], c, a, e) : void 0;
    s === void 0 && (s = e[c]), n ? Fq(a, c, s) : Rq(a, c, s);
  }
  return a;
}
var y1 = Uq;
function Eq(e, t) {
  for (var a = -1, o = Array(e); ++a < e; )
    o[a] = t(a);
  return o;
}
var Wq = Eq, Nq = 9007199254740991, Zq = /^(?:0|[1-9]\d*)$/;
function Yq(e, t) {
  var a = typeof e;
  return t = t ?? Nq, !!t && (a == "number" || a != "symbol" && Zq.test(e)) && e > -1 && e % 1 == 0 && e < t;
}
var ob = Yq, Gq = Wq, Xq = eb, Kq = Lt, Qq = Ox, Jq = ob, eT = nb, tT = Object.prototype, aT = tT.hasOwnProperty;
function nT(e, t) {
  var a = Kq(e), o = !a && Xq(e), n = !a && !o && Qq(e), i = !a && !o && !n && eT(e), l = a || o || n || i, c = l ? Gq(e.length, String) : [], s = c.length;
  for (var h in e)
    (t || aT.call(e, h)) && !(l && // Safari 9 has enumerable `arguments.length` in strict mode.
    (h == "length" || // Node.js 0.10 has enumerable non-index properties on buffers.
    n && (h == "offset" || h == "parent") || // PhantomJS 2 has enumerable non-index properties on typed arrays.
    i && (h == "buffer" || h == "byteLength" || h == "byteOffset") || // Skip index properties.
    Jq(h, s))) && c.push(h);
  return c;
}
var qI = nT;
function oT(e) {
  var t = [];
  if (e != null)
    for (var a in Object(e))
      t.push(a);
  return t;
}
var rT = oT, iT = Ft, lT = J9, cT = rT, dT = Object.prototype, sT = dT.hasOwnProperty;
function uT(e) {
  if (!iT(e))
    return cT(e);
  var t = lT(e), a = [];
  for (var o in e)
    o == "constructor" && (t || !sT.call(e, o)) || a.push(o);
  return a;
}
var hT = uT, pT = qI, yT = hT, kT = Zr;
function fT(e) {
  return kT(e) ? pT(e, !0) : yT(e);
}
var k1 = fT, vT = y1, mT = k1;
function gT(e) {
  return vT(e, mT(e));
}
var MT = gT, Gb = mI, xT = MI, bT = bI, wT = wI, IT = LI, Xb = eb, Kb = Lt, LT = UP, ST = Ox, CT = Z9, AT = Ft, PT = tq, qT = nb, Qb = AI, TT = MT;
function DT(e, t, a, o, n, i, l) {
  var c = Qb(e, a), s = Qb(t, a), h = l.get(s);
  if (h) {
    Gb(e, a, h);
    return;
  }
  var m = i ? i(c, s, a + "", e, t, l) : void 0, p = m === void 0;
  if (p) {
    var f = Kb(s), g = !f && ST(s), w = !f && !g && qT(s);
    m = s, f || g || w ? Kb(c) ? m = c : LT(c) ? m = wT(c) : g ? (p = !1, m = xT(s, !0)) : w ? (p = !1, m = bT(s, !0)) : m = [] : PT(s) || Xb(s) ? (m = c, Xb(c) ? m = TT(c) : (!AT(c) || CT(c)) && (m = IT(s))) : p = !1;
  }
  p && (l.set(s, m), n(m, s, o, i, l), l.delete(s)), Gb(e, a, m);
}
var _T = DT, BT = Vx, zT = mI, HT = gI, jT = _T, VT = Ft, OT = k1, $T = AI;
function TI(e, t, a, o, n) {
  e !== t && HT(t, function(i, l) {
    if (n || (n = new BT()), VT(i))
      jT(e, t, l, a, TI, o, n);
    else {
      var c = o ? o($T(e, l), i, l + "", e, t, n) : void 0;
      c === void 0 && (c = i), zT(e, l, c);
    }
  }, OT);
}
var rb = TI;
function RT(e) {
  return e;
}
var Rx = RT;
function FT(e, t, a) {
  switch (a.length) {
    case 0:
      return e.call(t);
    case 1:
      return e.call(t, a[0]);
    case 2:
      return e.call(t, a[0], a[1]);
    case 3:
      return e.call(t, a[0], a[1], a[2]);
  }
  return e.apply(t, a);
}
var DI = FT, UT = DI, Jb = Math.max;
function ET(e, t, a) {
  return t = Jb(t === void 0 ? e.length - 1 : t, 0), function() {
    for (var o = arguments, n = -1, i = Jb(o.length - t, 0), l = Array(i); ++n < i; )
      l[n] = o[t + n];
    n = -1;
    for (var c = Array(t + 1); ++n < t; )
      c[n] = o[n];
    return c[t] = a(l), UT(e, this, c);
  };
}
var WT = ET;
function NT(e) {
  return function() {
    return e;
  };
}
var ZT = NT, YT = ZT, ew = vI, GT = Rx, XT = ew ? function(e, t) {
  return ew(e, "toString", {
    configurable: !0,
    enumerable: !1,
    value: YT(t),
    writable: !0
  });
} : GT, KT = XT, QT = 800, JT = 16, eD = Date.now;
function tD(e) {
  var t = 0, a = 0;
  return function() {
    var o = eD(), n = JT - (o - a);
    if (a = o, n > 0) {
      if (++t >= QT)
        return arguments[0];
    } else
      t = 0;
    return e.apply(void 0, arguments);
  };
}
var aD = tD, nD = KT, oD = aD, rD = oD(nD), iD = rD, lD = Rx, cD = WT, dD = iD;
function sD(e, t) {
  return dD(cD(e, t, lD), e + "");
}
var _I = sD, uD = h1, hD = Zr, pD = ob, yD = Ft;
function kD(e, t, a) {
  if (!yD(a))
    return !1;
  var o = typeof t;
  return (o == "number" ? hD(a) && pD(t, a.length) : o == "string" && t in a) ? uD(a[t], e) : !1;
}
var fD = kD, vD = _I, mD = fD;
function gD(e) {
  return vD(function(t, a) {
    var o = -1, n = a.length, i = n > 1 ? a[n - 1] : void 0, l = n > 2 ? a[2] : void 0;
    for (i = e.length > 3 && typeof i == "function" ? (n--, i) : void 0, l && mD(a[0], a[1], l) && (i = n < 3 ? void 0 : i, n = 1), t = Object(t); ++o < n; ) {
      var c = a[o];
      c && e(t, c, o, i);
    }
    return t;
  });
}
var BI = gD, MD = rb, xD = BI, bD = xD(function(e, t, a) {
  MD(e, t, a);
}), wD = bD;
const Fx = /* @__PURE__ */ _x(wD);
function Te({ props: e, locals: t, defaults: a }) {
  const n = uI().type.__name, i = N(() => a.pt || {}), l = N(
    () => {
      var h, m, p, f;
      return ((m = (h = e.themeConfig) == null ? void 0 : h[n]) == null ? void 0 : m.pt) || ((f = (p = N9("one-ui-config")) == null ? void 0 : p[n]) == null ? void 0 : f.pt) || {};
    }
  ), c = N(() => e.pt || {});
  return { ep: N(() => ID({
    defaults: i.value,
    theme: l.value,
    local: c.value,
    props: e,
    locals: t != null && t.value ? t.value : t
  })) };
}
function ID({ defaults: e, theme: t, local: a, props: o, locals: n }) {
  const i = Fx({}, e, t, a), l = {};
  for (const [c, s] of Object.entries(i))
    l[c] = {
      ...s.propsStatic,
      classList: []
    }, s._common && LD({
      elementResult: l[c],
      commonConfig: s._common
    }), s.propsStateBased && SD({
      elementResult: l[c],
      propsStateBased: s.propsStateBased,
      props: o,
      locals: n
    }), s.props && (l[c] = {
      ...l[c],
      ...s.props
    }), l[c].classList && (l[c].class = l[c].classList.join(" ")), delete l[c].classList;
  return l;
}
function LD({ elementResult: e, commonConfig: t }) {
  typeof t == "string" && t.length > 0 ? e.classList.push(t) : typeof t == "object" && Object.assign(e, t);
}
function SD({ elementResult: e, propsStateBased: t, props: a, locals: o }) {
  for (const [n, i] of Object.entries(t)) {
    const l = zI({ key: n, props: a, locals: o });
    if (l !== void 0 && i[l] !== void 0) {
      const c = i[l];
      typeof c._common == "string" && c._common.length > 0 ? e.classList.push(c._common) : typeof c._common == "object" && Object.assign(e, c._common), typeof c == "string" && c.length > 0 ? e.classList.push(c) : typeof c == "object" && CD({
        elementResult: e,
        stateConfig: c,
        props: a,
        locals: o
      });
    }
  }
}
function CD({ elementResult: e, stateConfig: t, props: a, locals: o }) {
  for (const [n, i] of Object.entries(t))
    if (n !== "_common") {
      const l = zI({ key: n, props: a, locals: o }), c = i[l];
      l !== void 0 && c !== void 0 ? typeof c == "string" && c.length > 0 ? e.classList.push(c) : c && (c.class && c.class.length > 0 && e.classList.push(c.class), c.props && Object.assign(e, c.props)) : n == "class" ? e.classList.push(i) : e[n] = i;
    }
}
function zI({ key: e, props: t, locals: a }) {
  var n, i, l;
  return ((i = (n = a == null ? void 0 : a[e]) == null ? void 0 : n.value) == null ? void 0 : i.toString()) || ((l = t[e]) == null ? void 0 : l.toString());
}
const AD = {
  composer: {
    props: {
      name: {
        default: !1,
        control: "input"
      },
      lucide: {
        default: "Loader2",
        control: "input"
      },
      lucideSize: {
        default: 24,
        control: "input"
      },
      lucideColor: {
        default: "currentColor",
        control: "input"
      },
      lucideStrokeWidth: {
        default: 2,
        control: "input"
      },
      lucideAbsoluteStrokeWidth: {
        default: !1,
        control: "switch"
      },
      lucideDefaultClass: {
        default: "lucide-icon",
        control: "input"
      },
      spin: {
        default: !0,
        control: "switch"
      }
    }
  },
  pt: {
    root: {
      propsStateBased: {
        spin: {
          true: "animate-spin",
          false: ""
        }
      }
    }
  }
}, We = {
  __name: "Icon",
  props: {
    name: {
      type: [String, Boolean],
      default: !1
    },
    lucide: {
      type: [String, Boolean],
      default: !1
    },
    lucideSize: {
      type: Number,
      default: 24
    },
    lucideColor: {
      type: String,
      default: "currentColor"
    },
    lucideStrokeWidth: {
      type: Number,
      default: 2
    },
    lucideAbsoluteStrokeWidth: {
      type: Boolean,
      default: !1
    },
    lucideDefaultClass: {
      type: String,
      default: "lucide-icon"
    },
    lucideFill: {
      type: String,
      default: null
    },
    spin: {
      type: Boolean,
      default: !1
    }
  },
  setup(e) {
    const t = /* @__PURE__ */ Object.assign({ "../../icons/Progress.svg": () => import("./Progress-0e7f1674.js") }), a = e, { ep: o } = Te({ props: a, defaults: AD }), n = N(() => {
      if (a.lucide)
        return pI[a.lucide];
      if (a.name) {
        const l = `${a.name}.svg`;
        return console.log({ icons: t, iconFileName: l }), console.log(t[`../icons/${l}`]), hI(() => t[`../../icons/${l}`]());
      } else
        return !1;
    }), i = N(() => a.lucide ? {
      size: a.lucideSize,
      color: a.lucideColor,
      strokeWidth: a.lucideStrokeWidth,
      absoluteStrokeWidth: a.lucideAbsoluteStrokeWidth,
      defaultClass: a.lucideDefaultClass,
      ...a.lucideFill && { fill: a.lucideFill }
      // experimental - https://lucide.dev/guide/advanced/filled-icons
    } : {});
    return (l, c) => n.value ? (d(), Q(u(n), P(H({ key: 0 }, { ...u(o).root, ...i.value })), null, 16)) : v("", !0);
  }
}, PD = {
  composer: {
    compositions: [
      { id: "default", name: "default" },
      { id: "variant", name: "variant" },
      { id: "kind", name: "kind" },
      { id: "size", name: "size" },
      { id: "rounded", name: "rounded" },
      { id: "icon", name: "icon" }
    ],
    tags: ["platforma", "atlaseek"],
    props: {
      variant: {
        options: ["primary", "secondary", "form", "black", "white", "success", "error", "disabled"],
        default: "primary",
        control: "select"
      },
      kind: {
        options: ["solid", "ghost", "naked", "plain"],
        default: "solid",
        control: "select"
      },
      disabled: {
        default: !1,
        control: "switch"
      },
      glass: {
        options: [!1, !0],
        default: !1,
        control: "switch"
      },
      shake: {
        default: !1,
        control: "switch"
      },
      label: {
        default: !1,
        control: "input"
      },
      labelSecondary: {
        default: !1,
        control: "input"
      },
      doubleAction: {
        default: !1,
        control: "switch"
      },
      size: {
        options: [24, 20, 16, 14, 12, 11, 10, 9, 8, 7, 6, 5],
        default: 11,
        control: "select"
      },
      circle: {
        options: [!0, !1],
        default: !1,
        control: "switch"
      },
      padding: {
        options: ["none", "small", "default", "large"],
        default: "default",
        control: "select"
      },
      rounded: {
        options: ["none", "md", "lg", "xl", "full"],
        default: "full",
        control: "select"
      },
      // context: {
      //   options: ["dark", "neutral", "light"],
      //   default: "light",
      //   control: "select",
      // },
      locale: {
        options: ["en", "cs", "ar", "kr"],
        default: "en",
        control: "select"
      },
      progress: {
        default: !1,
        control: "switch"
      },
      icon: {
        default: !1,
        control: "input"
      },
      iconStart: {
        default: !1,
        control: "input"
      },
      iconEnd: {
        default: !1,
        control: "input"
      },
      iconSet: {
        options: ["lucide"],
        default: "lucide",
        control: "select"
      },
      iconStrokeWidth: {
        options: [0.5, 0.75, 1, 1.25, 1.5, 1.75, 2, 2.25, 2.5, 2.75, 3, 3.5, 4, 5],
        default: 2,
        control: "select"
      },
      iconAnimate: {
        default: !1,
        control: "switch"
      }
    }
  },
  pt: {
    root: {
      _common: "group inline-flex flex-row items-center gap-2 font-element font-semibold transition-all duration-300 ease-in-out cursor-pointer",
      propsStateBased: {
        align: {
          start: "justify-start",
          center: "justify-center",
          end: "justify-end"
        },
        rounded: {
          none: "rounded-none",
          md: "rounded-md",
          lg: "rounded-lg",
          xl: "rounded-xl",
          full: "rounded-full"
        },
        // size: {
        //   24: "h-24 px-14 text-2xl",
        //   20: "h-20 px-10 text-2xl",
        //   16: "h-16 px-8 text-2xl",
        //   14: "h-14 px-7 text-xl",
        //   12: "h-12 px-6 text-xl",
        //   11: "h-11 px-5 text-lg", // default
        //   10: "h-10 px-4 text-base",
        //   9: "h-9 px-4 text-base",
        //   8: "h-8 px-3.5 text-base",
        //   7: "h-7 px-3.5 text-sm",
        //   6: "h-6 px-3 text-sm",
        //   5: "h-5 px-2.5 text-xs",
        // },
        circle: {
          true: {
            _common: "aspect-square",
            size: {
              24: "h-24 text-2xl",
              20: "h-20 text-2xl",
              16: "h-16 text-2xl",
              14: "h-14 text-xl",
              12: "h-12 text-xl",
              11: "h-11 text-lg",
              // default
              10: "h-10 text-base",
              9: "h-9 text-base",
              8: "h-8 text-base",
              7: "h-7 text-sm",
              6: "h-6 text-sm",
              5: "h-5 text-xs"
            }
          },
          false: {
            _common: "aspect-auto",
            size: {
              24: "h-24 px-14 text-2xl",
              20: "h-20 px-10 text-2xl",
              16: "h-16 px-8 text-2xl",
              14: "h-14 px-7 text-xl",
              12: "h-12 px-6 text-xl",
              11: "h-11 px-5 text-lg",
              // default
              10: "h-10 px-4 text-base",
              9: "h-9 px-4 text-base",
              8: "h-8 px-3.5 text-base",
              7: "h-7 px-3.5 text-sm",
              6: "h-6 px-3 text-sm",
              5: "h-5 px-2.5 text-xs"
            }
          }
        },
        fullWidth: {
          true: "!w-full"
        },
        fullHeight: {
          true: "!h-full"
        },
        kind: {
          ghost: "outline outline-2 -outline-offset-2",
          plain: "!px-0"
        },
        glass: {
          true: "bg-opacity-50 backdrop-blur-sm"
        },
        variant: {
          primary: {
            kind: {
              solid: "bg-neutral-800 context-dark:bg-neutral-500 hover:bg-neutral-600 active:bg-neutral-900 text-white dark:bg-neutral-50 dark:text-neutral-900 dark:hover:bg-neutral-300 dark:active:bg-neutral-500",
              ghost: "text-neutral-900 outline-neutral-900 hover:outline-neutral-400 active:outline-neutral-900 dark:text-neutral-50 dark:outline-neutral-50 dark:hover:outline-neutral-700 dark:active:outline-neutral-900",
              naked: "text-neutral-900 hover:text-white hover:bg-neutral-900 dark:text-neutral-50 dark:hover:bg-neutral-50 dark:hover:text-neutral-900 active:bg-neutral-500 dark:active:bg-neutral-400",
              plain: "text-neutral-900 dark:text-neutral-50 hover:text-neutral-400 active:text-neutral-900 dark:hover:text-neutral-500 dark:active:text-neutral-700"
            }
          },
          secondary: {
            kind: {
              solid: "text-neutral-900 bg-neutral-200 hover:bg-neutral-300 active:bg-neutral-400 dark:bg-neutral-800 dark:text-neutral-50 dark:hover:bg-neutral-700 dark:active:bg-neutral-900",
              ghost: "text-neutral-900 outline-neutral-200 hover:outline-neutral-400 active:outline-neutral-600 dark:text-neutral-50 dark:outline-neutral-600 dark:hover:outline-neutral-800 dark:active:outline-neutral-900",
              naked: "text-neutral-400 hover:bg-neutral-200 dark:hover:bg-neutral-800 active:bg-neutral-300 dark:active:bg-neutral-900",
              plain: "text-neutral-400 hover:text-neutral-600 active:text-neutral-900"
            }
          },
          form: {
            kind: {
              solid: "text-neutral-500 bg-neutral-100 hover:bg-neutral-200 active:bg-neutral-300 dark:bg-neutral-900 dark:hover:bg-neutral-800 dark:active:bg-neutral-900",
              ghost: "text-neutral-500 outline-neutral-200 hover:outline-neutral-400 active:outline-neutral-600 dark:outline-neutral-800 dark:hover:outline-neutral-900",
              naked: "text-neutral-500 hover:bg-neutral-200 active:bg-neutral-300 dark:hover:bg-neutral-800 dark:active:bg-neutral-900",
              plain: "text-neutral-500 hover:text-neutral-600 active:text-neutral-900"
            }
          },
          black: {
            kind: {
              solid: "bg-neutral-900 context-dark:bg-neutral-500 hover:bg-neutral-600 active:bg-neutral-900 text-white dark:hover:bg-neutral-800",
              ghost: "text-neutral-900 outline-neutral-900 hover:outline-neutral-400 active:outline-neutral-900",
              naked: "text-neutral-900 hover:bg-neutral-900 hover:bg-opacity-50",
              plain: "text-neutral-900 hover:text-neutral-400 active:text-neutral-900"
            }
          },
          white: {
            kind: {
              solid: "bg-white context-dark:bg-neutral-500 hover:bg-neutral-200 active:bg-neutral-400 text-neutral-900",
              ghost: "text-white outline-white hover:outline-neutral-400 active:outline-neutral-900",
              naked: "text-white hover:bg-white hover:bg-opacity-20 active:bg-opacity-40",
              plain: "text-white hover:opacity-50 active:opacity-80"
            }
          },
          success: {
            kind: {
              solid: "text-success-900 bg-success-500 hover:bg-success-400 active:bg-success-500",
              ghost: "text-success-900 dark:text-success-500 outline-success-500 hover:outline-success-400 active:outline-success-600",
              naked: "text-success-500 hover:bg-success-200 active:bg-success-300",
              plain: "text-success-500 hover:text-success-600 active:text-success-400"
            }
          },
          error: {
            kind: {
              solid: "text-red-900 bg-red-500 hover:bg-red-400 active:bg-red-500",
              ghost: "text-red-900 dark:text-red-500 outline-red-500 hover:outline-red-300 active:outline-red-600",
              naked: "text-red-500 hover:bg-red-100 dark:hover:bg-red-900 active:bg-red-200",
              plain: "text-red-500 hover:text-red-700 active:text-red-500"
            }
          },
          disabled: {
            _common: "cursor-not-allowed",
            // _common applied to all
            kind: {
              solid: "bg-neutral-100 text-neutral-300 dark:bg-neutral-900 dark:text-neutral-700",
              ghost: "bg-transparent outline-neutral-200 text-neutral-200 dark:outline-neutral-900 dark:text-neutral-700",
              naked: "bg-transparent text-neutral-200 dark:text-neutral-700",
              plain: "bg-transparent text-neutral-200 dark:text-neutral-700"
            }
          }
        }
      }
    },
    text: {
      _common: "whitespace-nowrap"
    },
    progressIcon: {
      propsStateBased: {
        size: {
          24: { class: "w-8 h-8 -ml-1 mr-2 opacity-40", lucideStrokeWidth: 3 },
          20: { class: "w-8 h-8 -ml-1 mr-2 opacity-40", lucideStrokeWidth: 3 },
          16: { class: "w-8 h-8 -ml-1 mr-2 opacity-40", lucideStrokeWidth: 3 },
          14: { class: "w-6 h-6 -ml-1 mr-1 opacity-40", lucideStrokeWidth: 4 },
          12: { class: "w-6 h-6 -ml-2 mr-1 opacity-40", lucideStrokeWidth: 4 },
          11: { class: "w-5 h-5 -ml-2 mr-0 opacity-40", lucideStrokeWidth: 4 },
          10: { class: "w-5 h-5 -ml-2 mr-0 opacity-40", lucideStrokeWidth: 4 },
          9: { class: "w-5 h-5 -ml-2 mr-0 opacity-40", lucideStrokeWidth: 4 },
          8: { class: "w-5 h-5 -ml-1.5 -mr-0.5 opacity-40", lucideStrokeWidth: 4 },
          7: { class: "w-4 h-4 -ml-2 -mr-0.5 opacity-40", lucideStrokeWidth: 4 },
          6: { class: "w-4 h-4 -ml-1.5 -mr-0.5 opacity-40", lucideStrokeWidth: 4 },
          5: { class: "w-3 h-3 -ml-1 -mr-1 opacity-40", lucideStrokeWidth: 4 }
        }
      }
    },
    icon: {
      propsStateBased: {
        size: {
          24: { class: "w-8 h-8" },
          20: { class: "w-8 h-8" },
          16: { class: "w-8 h-8" },
          14: { class: "w-6 h-6" },
          12: { class: "w-6 h-6" },
          11: { class: "w-5 h-5" },
          10: { class: "w-5 h-5" },
          9: { class: "w-5 h-5" },
          8: { class: "w-5 h-5" },
          7: { class: "w-4 h-4" },
          6: { class: "w-4 h-4" },
          5: { class: "w-3 h-3" }
        }
      }
    },
    iconStart: {
      propsStateBased: {
        size: {
          24: { class: "w-8 h-8 -ml-1 mr-2" },
          20: { class: "w-8 h-8 -ml-1 mr-2" },
          16: { class: "w-8 h-8 -ml-1 mr-2" },
          14: { class: "w-6 h-6 -ml-1 mr-1" },
          12: { class: "w-6 h-6 -ml-2 mr-1" },
          11: { class: "w-5 h-5 -ml-2 mr-0" },
          10: { class: "w-5 h-5 -ml-2 mr-0" },
          9: { class: "w-5 h-5 -ml-2 mr-0" },
          8: { class: "w-5 h-5 -ml-1.5 -mr-0.5" },
          7: { class: "w-4 h-4 -ml-2 -mr-0.5" },
          6: { class: "w-4 h-4 -ml-1.5 -mr-0.5" },
          5: { class: "w-3 h-3 -ml-1 -mr-1" }
        }
      }
    },
    iconEnd: {
      _common: "",
      propsStateBased: {
        size: {
          24: { class: "w-8 h-8 -mr-1 ml-2" },
          20: { class: "w-8 h-8 -mr-1 ml-2" },
          16: { class: "w-8 h-8 -mr-1 ml-2" },
          14: { class: "w-6 h-6 -mr-1 ml-1" },
          12: { class: "w-6 h-6 -mr-2 ml-1" },
          11: { class: "w-5 h-5 -mr-2 ml-0" },
          10: { class: "w-5 h-5 -mr-2 ml-0" },
          9: { class: "w-5 h-5 -mr-2 ml-0" },
          8: { class: "w-5 h-5 -mr-1.5 -ml-0.5" },
          7: { class: "w-4 h-4 -mr-2 -ml-0.5" },
          6: { class: "w-4 h-4 -mr-1.5 -ml-0.5" },
          5: { class: "w-3 h-3 -mr-1 -ml-1" }
        },
        iconAnimate: {
          true: "group-hover:transform group-hover:translate-x-1 group-active:translate-x-2 ease-in-out duration-300 transition-all"
        }
      }
    }
  }
}, qD = {
  text: {
    "element-button": "tlačítko",
    "element-chip": "čip"
  }
}, TD = {
  text: {
    "element-button": "button",
    "element-tag": "tag",
    "element-chip": "chip"
  }
}, DD = {
  text: {
    "element-button": "زرّ"
  }
}, _D = {
  text: {
    "element-button": "버튼"
  }
}, Ux = {
  data: { cs: qD, en: TD, ar: DD, kr: _D },
  available: ["cs", "en", "ar", "kr"],
  lang: "en",
  overrides: {},
  get(e, t, a) {
    let o = a || this.lang, n = e;
    if (this.overrides[e] ? n = this.overrides[e][o] : this.data[o] != null && this.data[o].text[e] != null && (n = this.data[o].text[e]), t)
      for (let i = 0; i < t.length; i++)
        n = n.replace("%" + i, t[i]);
    return n;
  },
  gets(e) {
    return this.data[this.lang] != null && this.data[this.lang].text[e] != null ? this.data[this.lang].text[e] : e;
  },
  setLang(e) {
    return console.log("Selecting lang", e), this.available.indexOf(e) == -1 ? !1 : (this.lang = e, !0);
  }
}, bt = {
  __name: "Button",
  props: {
    // contains overrides for all components
    themeConfig: {
      type: Object
    },
    // contains overrides for this component only
    pt: {
      type: Object
    },
    variant: {
      type: String,
      default: "primary"
    },
    kind: {
      type: String,
      default: "solid"
    },
    glass: {
      type: Boolean,
      default: !1
    },
    label: {
      type: [String, Boolean],
      default: !1
    },
    labelSecondary: {
      type: [String, Boolean],
      default: !1
    },
    doubleAction: {
      type: Boolean,
      default: !1
    },
    size: {
      type: Number,
      default: 11
    },
    circle: {
      type: Boolean,
      default: !1
    },
    fullWidth: {
      type: Boolean,
      default: !1
    },
    fullHeight: {
      type: Boolean,
      default: !1
    },
    padding: {
      type: String,
      default: "default"
    },
    rounded: {
      type: String,
      default: "full"
    },
    align: {
      type: String,
      default: "center"
    },
    context: {
      type: String
    },
    locale: {
      type: String,
      default: "en"
    },
    progress: {
      type: Boolean,
      default: !1
    },
    // only icon, no label
    icon: {
      type: [String, Object, Boolean],
      default: !1
    },
    iconStart: {
      type: [String, Object, Boolean],
      default: !1
    },
    iconEnd: {
      type: [String, Object, Boolean],
      default: !1
    },
    iconSet: {
      type: String,
      default: "lucide"
    },
    iconStrokeWidth: {
      type: Number,
      default: 2
    },
    iconAnimate: {
      type: Boolean,
      default: !1
    },
    // overrides variant to disabled
    disabled: {
      type: Boolean,
      default: !1
    },
    shake: {
      type: Boolean,
      default: !1
    },
    tag: {
      type: String,
      default: "button"
      // button | a
    }
  },
  emits: ["action"],
  setup(e, { emit: t }) {
    const a = e, o = t, n = N(() => a.disabled ? "disabled" : a.variant), i = N(() => ({
      variant: n
    })), { ep: l } = Te({
      props: {
        ...a
        // variant: props.disabled ? "disabled" : props.variant,
      },
      defaults: PD,
      locals: i
    }), c = W(a.label || !1), s = W(0);
    ot(
      () => a.label,
      (m) => {
        c.value = m;
      },
      {
        immediate: !0
      }
    );
    function h() {
      a.disabled || (a.doubleAction ? (s.value++, s.value == 1 ? c.value = a.labelSecondary : s.value == 2 && (o("action"), s.value = 0)) : o("action"));
    }
    return (m, p) => (d(), Q(mt(e.tag), H(u(l).root, {
      class: [{ "animate-shake": e.shake }],
      onClick: h
    }), {
      default: ke(() => [
        ee(m.$slots, "default", {}, () => [
          e.progress ? (d(), Q(We, H({ key: 0 }, u(l).progressIcon, {
            class: "animate-spin",
            lucide: "Loader2"
          }), null, 16)) : v("", !0),
          e.iconStart && e.iconSet == "lucide" && typeof e.iconStart == "string" ? (d(), Q(We, H({ key: 1 }, u(l).iconStart, {
            lucide: e.iconStart,
            "lucide-stroke-width": e.iconStrokeWidth
          }), null, 16, ["lucide", "lucide-stroke-width"])) : v("", !0),
          typeof e.iconStart == "object" ? (d(), Q(mt(e.iconStart), P(H({ key: 2 }, u(l).iconStart)), null, 16)) : v("", !0),
          e.icon && e.iconSet == "lucide" && typeof e.icon == "string" ? (d(), Q(We, H({ key: 3 }, u(l).icon, {
            lucide: e.icon,
            "lucide-stroke-width": e.iconStrokeWidth
          }), null, 16, ["lucide", "lucide-stroke-width"])) : v("", !0),
          typeof e.icon == "object" ? (d(), Q(mt(e.icon), P(H({ key: 4 }, u(l).icon)), null, 16)) : v("", !0),
          c.value && !e.icon ? (d(), y("span", P(H({ key: 5 }, u(l).text)), G(c.value), 17)) : e.icon ? v("", !0) : (d(), y("span", P(H({ key: 6 }, u(l).text)), G(u(Ux).get("element-button", null, e.locale)), 17)),
          e.iconEnd && !e.icon && e.iconSet == "lucide" && typeof e.iconEnd == "string" ? (d(), Q(We, H({ key: 7 }, u(l).iconEnd, {
            lucide: e.iconEnd,
            "lucide-stroke-width": e.iconStrokeWidth
          }), null, 16, ["lucide", "lucide-stroke-width"])) : v("", !0),
          typeof e.iconEnd == "object" ? (d(), Q(mt(e.iconEnd), P(H({ key: 8 }, u(l).iconEnd)), null, 16)) : v("", !0)
        ])
      ]),
      _: 3
    }, 16, ["class"]));
  }
}, BD = {
  composer: {
    props: {
      modelValue: {
        default: !0,
        control: "switch"
      },
      size: {
        default: 6,
        // TODO: set 11
        control: "select",
        options: [14, 12, 11, 10, 9, 8, 7, 6, 5]
      },
      rounded: {
        default: "md",
        options: ["full", "md"],
        control: "select"
      },
      disabled: {
        default: !1,
        control: "switch"
      },
      label: {
        default: "label",
        control: "input"
      },
      labelStart: {
        default: "label",
        control: "input"
      },
      labelEnd: {
        default: "label",
        control: "input"
      },
      sublabelStart: {
        default: "sublabel",
        control: "input"
      },
      sublabelEnd: {
        default: "sublabel",
        control: "input"
      },
      caption: {
        default: "caption with additional information",
        control: "input"
      }
    }
  },
  pt: {
    root: {},
    checkboxWrap: {
      _common: "flex flex-row items-center justify-start gap-4"
    },
    checkbox: {
      _common: "cursor-pointer flex flex-row items-center justify-center relative",
      propsStateBased: {
        modelValue: {
          true: {
            _common: "bg-neutral-800"
          },
          false: {
            _common: "bg-neutral-200 dark:bg-neutral-900 dark:border dark:border-neutral-800"
          }
        },
        rounded: {
          full: {
            _common: "rounded-full",
            size: {
              14: "h-14 w-14",
              12: "h-12 w-12",
              11: "h-11 w-11",
              // default
              10: "h-10 w-10",
              9: "h-9 w-9",
              8: "h-8 w-8",
              7: "h-7 w-7",
              6: "h-6 w-6",
              5: "h-5 w-5"
            }
          },
          md: {
            size: {
              14: "h-14 w-14 rounded-xl",
              12: "h-12 w-12 rounded-xl",
              11: "h-11 w-11 rounded-xl",
              // default
              10: "h-10 w-10 rounded-lg",
              9: "h-9 w-9 rounded-lg",
              8: "h-8 w-8 rounded-lg",
              7: "h-7 w-7 rounded-lg",
              6: "h-6 w-6 rounded-lg",
              5: "h-5 w-5 rounded-md"
            }
          }
        }
      }
    },
    checkboxCheck: {
      _common: "text-white",
      propsStateBased: {
        size: {
          14: {
            class: "w-10 h-10",
            lucideStrokeWidth: 3
          },
          12: {
            class: "w-8 h-8",
            lucideStrokeWidth: 4
          },
          11: {
            class: "w-7 h-7",
            lucideStrokeWidth: 4
          },
          10: {
            class: "w-6 h-6",
            lucideStrokeWidth: 4
          },
          9: {
            class: "w-5 h-5",
            lucideStrokeWidth: 4.5
          },
          8: {
            class: "w-5 h-5",
            lucideStrokeWidth: 4.5
          },
          7: {
            class: "w-5 h-5",
            lucideStrokeWidth: 4.5
          },
          6: {
            class: "w-4 h-4",
            lucideStrokeWidth: 4.5
          },
          5: {
            class: "w-3.5 h-3.5",
            lucideStrokeWidth: 4.5
          }
        }
      }
    },
    labelOuter: {
      _common: "inline-block text-lg font-bold text-neutral-600 dark:text-neutral-200 font-element"
    },
    labelStart: {
      _common: "inline-block text-lg font-bold text-neutral-600 dark:text-neutral-200 font-element"
    },
    labelStartWrap: {
      _common: "flex flex-col gap-0"
    },
    labelEndWrap: {
      _common: "flex flex-col gap-0"
    },
    labelEnd: {
      _common: "inline-block text-lg font-bold text-neutral-600 dark:text-neutral-200 font-element"
    },
    sublabelStart: {
      _common: "leading-3 text-sm text-neutral-500"
    },
    sublabelEnd: {
      _common: "leading-3 text-sm text-neutral-500"
    }
  }
}, zD = {
  key: 0,
  class: "flex flex-col"
}, HD = {
  key: 0,
  class: "mb-1 flex flex-row items-end justify-between"
}, jD = {
  key: 1,
  class: ""
}, VD = { class: "mt-1 text-sm text-neutral-400" }, HI = {
  __name: "Checkbox",
  props: {
    globalConfig: {
      type: Object
    },
    pt: {
      type: Object
    },
    modelValue: {
      type: Boolean,
      default: !1
    },
    disabled: {
      type: Boolean,
      default: !1
    },
    mode: {
      type: String,
      default: "edit"
    },
    label: {
      type: [String, Boolean],
      default: !1
    },
    labelStart: {
      type: [String, Boolean],
      default: !1
    },
    labelEnd: {
      type: [String, Boolean],
      default: !1
    },
    sublabelStart: {
      type: [String, Boolean],
      default: !1
    },
    sublabelEnd: {
      type: [String, Boolean],
      default: !1
    },
    caption: {
      type: [String, Boolean],
      default: !1
    },
    size: {
      type: Number,
      default: 11
    },
    rounded: {
      type: String,
      default: "full"
    },
    context: {
      type: String,
      validator: function(e) {
        return ["dark", "neutral", "light"].indexOf(e) !== -1;
      }
    }
  },
  emits: ["update:modelValue"],
  setup(e, { emit: t }) {
    const a = e, o = t, { ep: n } = Te({ props: a, locals: {}, defaults: BD });
    function i() {
      o("update:modelValue", !a.modelValue);
    }
    return (l, c) => (d(), y("div", P(X(u(n).root)), [
      a.mode == "edit" ? (d(), y("div", zD, [
        a.label ? (d(), y("div", HD, [
          a.label ? (d(), y("span", P(H({ key: 0 }, u(n).labelOuter)), G(a.label), 17)) : v("", !0)
        ])) : v("", !0),
        D("div", P(X(u(n).checkboxWrap)), [
          a.labelStart || a.sublabelStart ? (d(), y("div", P(H({ key: 0 }, u(n).labelStartWrap)), [
            a.labelStart ? (d(), y("span", P(H({ key: 0 }, u(n).labelStart)), G(a.labelStart), 17)) : v("", !0),
            a.sublabelStart ? (d(), y("span", P(H({ key: 1 }, u(n).sublabelStart)), G(a.sublabelStart), 17)) : v("", !0)
          ], 16)) : v("", !0),
          D("div", H(u(n).checkbox, { onClick: i }), [
            e.modelValue === !0 ? (d(), Q(We, H({ key: 0 }, u(n).checkboxCheck, { lucide: "Check" }), null, 16)) : v("", !0)
          ], 16),
          a.labelEnd || a.sublabelEnd ? (d(), y("div", P(H({ key: 1 }, u(n).labelEndWrap)), [
            a.labelEnd ? (d(), y("span", P(H({ key: 0 }, u(n).labelEnd)), G(a.labelEnd), 17)) : v("", !0),
            a.sublabelEnd ? (d(), y("span", P(H({ key: 1 }, u(n).sublabelEnd)), G(a.sublabelEnd), 17)) : v("", !0)
          ], 16)) : v("", !0)
        ], 16),
        e.caption || l.$slots.caption ? (d(), y("div", jD, [
          ee(l.$slots, "caption", {}, () => [
            D("p", VD, G(e.caption), 1)
          ])
        ])) : v("", !0)
      ])) : v("", !0)
    ], 16));
  }
}, OD = {
  composer: {
    compositions: [
      { id: "default", name: "default" },
      { id: "variant", name: "variant" },
      { id: "kind", name: "kind" },
      { id: "size", name: "size" },
      { id: "rounded", name: "rounded" },
      { id: "icon", name: "icon" }
    ],
    // tags: ["platforma", "atlaseek"],
    props: {
      variant: {
        options: ["primary", "secondary", "form", "black", "white", "success", "error", "disabled"],
        default: "primary",
        control: "select"
      },
      kind: {
        options: ["solid", "ghost", "naked", "plain"],
        default: "solid",
        control: "select"
      },
      glass: {
        options: [!1, !0],
        default: !1,
        control: "switch"
      },
      label: {
        default: !1,
        control: "input"
      },
      labelSecondary: {
        default: !1,
        control: "input"
      },
      doubleAction: {
        default: !1,
        control: "switch"
      },
      size: {
        options: [24, 20, 16, 14, 12, 11, 10, 9, 8, 7, 6, 5],
        default: 11,
        control: "select"
      },
      circle: {
        options: [!0, !1],
        default: !1,
        control: "switch"
      },
      padding: {
        options: ["none", "small", "default", "large"],
        default: "default",
        control: "select"
      },
      rounded: {
        options: ["none", "md", "lg", "xl", "full"],
        default: "full",
        control: "select"
      },
      // context: {
      //   options: ["dark", "neutral", "light"],
      //   default: "light",
      //   control: "select",
      // },
      locale: {
        options: ["en", "cs", "ar", "kr"],
        default: "en",
        control: "select"
      },
      progress: {
        default: !1,
        control: "switch"
      },
      icon: {
        default: !1,
        control: "input"
      },
      iconStart: {
        default: !1,
        control: "input"
      },
      iconEnd: {
        default: !1,
        control: "input"
      },
      iconSet: {
        options: ["lucide"],
        default: "lucide",
        control: "select"
      },
      iconStrokeWidth: {
        options: [0.5, 0.75, 1, 1.25, 1.5, 1.75, 2, 2.25, 2.5, 2.75, 3, 3.5, 4, 5],
        default: 2,
        control: "select"
      },
      iconAnimate: {
        default: !1,
        control: "switch"
      },
      disabled: {
        default: !1,
        control: "switch"
      },
      showX: {
        default: !0,
        control: "switch"
      }
    }
  },
  pt: {
    root: {
      _common: "group inline-flex flex-row justify-center items-center gap-2 font-element  transition-all duration-300 ease-in-out select-none",
      propsStateBased: {
        clickable: {
          true: "cursor-pointer",
          false: ""
        },
        rounded: {
          none: "rounded-none",
          md: "rounded-md",
          lg: "rounded-lg",
          xl: "rounded-xl",
          full: "rounded-full"
        },
        // size: {
        //   24: "h-24 px-14 text-2xl",
        //   20: "h-20 px-10 text-2xl",
        //   16: "h-16 px-8 text-2xl",
        //   14: "h-14 px-7 text-xl",
        //   12: "h-12 px-6 text-xl",
        //   11: "h-11 px-5 text-lg", // default
        //   10: "h-10 px-4 text-base",
        //   9: "h-9 px-4 text-base",
        //   8: "h-8 px-3.5 text-base",
        //   7: "h-7 px-3.5 text-sm",
        //   6: "h-6 px-3 text-sm",
        //   5: "h-5 px-2.5 text-xs",
        // },
        circle: {
          true: {
            _common: "aspect-square",
            size: {
              24: "h-24 text-2xl",
              20: "h-20 text-2xl",
              16: "h-16 text-2xl",
              14: "h-14 text-xl",
              12: "h-12 text-xl",
              11: "h-11 text-lg",
              // default
              10: "h-10 text-base",
              9: "h-9 text-base",
              8: "h-8 text-base",
              7: "h-7 text-sm",
              6: "h-6 text-sm",
              5: "h-5 text-xs"
            }
          },
          false: {
            _common: "aspect-auto",
            size: {
              24: "h-24 px-14 text-2xl",
              20: "h-20 px-10 text-2xl",
              16: "h-16 px-8 text-2xl",
              14: "h-14 px-7 text-xl",
              12: "h-12 px-6 text-xl",
              11: "h-11 px-5 text-lg",
              // default
              10: "h-10 px-4 text-base",
              9: "h-9 px-4 text-base",
              8: "h-8 px-3.5 text-base",
              7: "h-7 px-3.5 text-sm",
              6: "h-6 px-2.5 text-sm",
              5: "h-5 px-2.5 text-xs"
            }
          }
        },
        fullWidth: {
          true: "!w-full"
        },
        fullHeight: {
          true: "!h-full"
        },
        kind: {
          ghost: "outline outline-2 -outline-offset-2",
          plain: "!px-0"
        },
        glass: {
          true: "bg-opacity-50 backdrop-blur-sm"
        },
        variant: {
          primary: {
            kind: {
              solid: "bg-neutral-800 context-dark:bg-neutral-500 hover:bg-neutral-600 active:bg-neutral-900 text-white dark:bg-neutral-50 dark:text-neutral-900 dark:hover:bg-neutral-300 dark:active:bg-neutral-500",
              ghost: "text-neutral-900 outline-neutral-900 hover:outline-neutral-400 active:outline-neutral-900 dark:text-neutral-50 dark:outline-neutral-50 dark:hover:outline-neutral-700 dark:active:outline-neutral-900",
              naked: "text-neutral-900 hover:text-white hover:bg-neutral-900 dark:text-neutral-50 dark:hover:bg-neutral-50 dark:hover:text-neutral-900 active:bg-neutral-500 dark:active:bg-neutral-400",
              plain: "text-neutral-900 dark:text-neutral-50 hover:text-neutral-400 active:text-neutral-900 dark:hover:text-neutral-500 dark:active:text-neutral-700"
            }
          },
          secondary: {
            kind: {
              solid: "text-neutral-900 bg-neutral-200 hover:bg-neutral-300 active:bg-neutral-400 dark:bg-neutral-800 dark:text-neutral-50 dark:hover:bg-neutral-700 dark:active:bg-neutral-900",
              ghost: "text-neutral-900 outline-neutral-200 hover:outline-neutral-400 active:outline-neutral-600 dark:text-neutral-50 dark:outline-neutral-600 dark:hover:outline-neutral-800 dark:active:outline-neutral-900",
              naked: "text-neutral-400 hover:bg-neutral-200 dark:hover:bg-neutral-800 active:bg-neutral-300 dark:active:bg-neutral-900",
              plain: "text-neutral-400 hover:text-neutral-600 active:text-neutral-900"
            }
          },
          form: {
            kind: {
              solid: "text-neutral-500 bg-neutral-100 hover:bg-neutral-200 active:bg-neutral-300 dark:bg-neutral-900 dark:hover:bg-neutral-800 dark:active:bg-neutral-900",
              ghost: "text-neutral-500 outline-neutral-200 hover:outline-neutral-400 active:outline-neutral-600 dark:outline-neutral-800 dark:hover:outline-neutral-900",
              naked: "text-neutral-500 hover:bg-neutral-200 active:bg-neutral-300 dark:hover:bg-neutral-800 dark:active:bg-neutral-900",
              plain: "text-neutral-500 hover:text-neutral-600 active:text-neutral-900"
            }
          },
          black: {
            kind: {
              solid: "bg-neutral-900 context-dark:bg-neutral-500 hover:bg-neutral-600 active:bg-neutral-900 text-white dark:hover:bg-neutral-800",
              ghost: "text-neutral-900 outline-neutral-900 hover:outline-neutral-400 active:outline-neutral-900",
              naked: "text-neutral-900 hover:bg-neutral-900 hover:bg-opacity-50",
              plain: "text-neutral-900 hover:text-neutral-400 active:text-neutral-900"
            }
          },
          white: {
            kind: {
              solid: "bg-white context-dark:bg-neutral-500 hover:bg-neutral-200 active:bg-neutral-400 text-neutral-900",
              ghost: "text-white outline-white hover:outline-neutral-400 active:outline-neutral-900",
              naked: "text-white hover:bg-white hover:bg-opacity-20 active:bg-opacity-40",
              plain: "text-white hover:opacity-50 active:opacity-80"
            }
          },
          success: {
            kind: {
              solid: "text-success-900 bg-success-500 hover:bg-success-400 active:bg-success-500",
              ghost: "text-success-900 dark:text-success-500 outline-success-500 hover:outline-success-400 active:outline-success-600",
              naked: "text-success-500 hover:bg-success-200 active:bg-success-300",
              plain: "text-success-500 hover:text-success-600 active:text-success-400"
            }
          },
          error: {
            kind: {
              solid: "text-red-900 bg-red-500 hover:bg-red-400 active:bg-red-500",
              ghost: "text-red-900 dark:text-red-500 outline-red-500 hover:outline-red-300 active:outline-red-600",
              naked: "text-red-500 hover:bg-red-100 dark:hover:bg-red-900 active:bg-red-200",
              plain: "text-red-500 hover:text-red-700 active:text-red-500"
            }
          },
          disabled: {
            _common: "cursor-not-allowed",
            // _common applied to all
            kind: {
              solid: "bg-neutral-100 text-neutral-300 dark:bg-neutral-900 dark:text-neutral-700",
              ghost: "bg-transparent outline-neutral-200 text-neutral-200 dark:outline-neutral-900 dark:text-neutral-700",
              naked: "bg-transparent text-neutral-200 dark:text-neutral-700",
              plain: "bg-transparent text-neutral-200 dark:text-neutral-700"
            }
          }
        }
      }
    },
    text: {
      _common: "whitespace-nowrap"
    },
    progressIcon: {
      propsStateBased: {
        size: {
          24: { class: "w-8 h-8 -ml-1 mr-2 opacity-40", lucideStrokeWidth: 3 },
          20: { class: "w-8 h-8 -ml-1 mr-2 opacity-40", lucideStrokeWidth: 3 },
          16: { class: "w-8 h-8 -ml-1 mr-2 opacity-40", lucideStrokeWidth: 3 },
          14: { class: "w-6 h-6 -ml-1 mr-1 opacity-40", lucideStrokeWidth: 4 },
          12: { class: "w-6 h-6 -ml-2 mr-1 opacity-40", lucideStrokeWidth: 4 },
          11: { class: "w-5 h-5 -ml-2 mr-0 opacity-40", lucideStrokeWidth: 4 },
          10: { class: "w-5 h-5 -ml-2 mr-0 opacity-40", lucideStrokeWidth: 4 },
          9: { class: "w-5 h-5 -ml-2 mr-0 opacity-40", lucideStrokeWidth: 4 },
          8: { class: "w-5 h-5 -ml-1.5 -mr-0.5 opacity-40", lucideStrokeWidth: 4 },
          7: { class: "w-4 h-4 -ml-2 -mr-0.5 opacity-40", lucideStrokeWidth: 4 },
          6: { class: "w-4 h-4 -ml-1.5 -mr-0.5 opacity-40", lucideStrokeWidth: 4 },
          5: { class: "w-3 h-3 -ml-1 -mr-1 opacity-40", lucideStrokeWidth: 4 }
        }
      }
    },
    icon: {
      propsStateBased: {
        size: {
          24: { class: "w-8 h-8" },
          20: { class: "w-8 h-8" },
          16: { class: "w-8 h-8" },
          14: { class: "w-6 h-6" },
          12: { class: "w-6 h-6" },
          11: { class: "w-5 h-5" },
          10: { class: "w-5 h-5" },
          9: { class: "w-5 h-5" },
          8: { class: "w-5 h-5" },
          7: { class: "w-4 h-4" },
          6: { class: "w-4 h-4" },
          5: { class: "w-3 h-3" }
        }
      }
    },
    iconStart: {
      propsStateBased: {
        size: {
          24: { class: "w-8 h-8 -ml-1 mr-2" },
          20: { class: "w-8 h-8 -ml-1 mr-2" },
          16: { class: "w-8 h-8 -ml-1 mr-2" },
          14: { class: "w-6 h-6 -ml-1 mr-1" },
          12: { class: "w-6 h-6 -ml-2 mr-1" },
          11: { class: "w-5 h-5 -ml-2 mr-0" },
          10: { class: "w-5 h-5 -ml-2 mr-0" },
          9: { class: "w-5 h-5 -ml-2 mr-0" },
          8: { class: "w-5 h-5 -ml-1.5 -mr-0.5" },
          7: { class: "w-4 h-4 -ml-2 -mr-0.5" },
          6: { class: "w-4 h-4 -ml-1.5 -mr-0.5" },
          5: { class: "w-3 h-3 -ml-1 -mr-1" }
        }
      }
    },
    iconEnd: {
      _common: "",
      propsStateBased: {
        size: {
          24: { class: "w-8 h-8 -mr-1 ml-2" },
          20: { class: "w-8 h-8 -mr-1 ml-2" },
          16: { class: "w-8 h-8 -mr-1 ml-2" },
          14: { class: "w-6 h-6 -mr-1 ml-1" },
          12: { class: "w-6 h-6 -mr-2 ml-1" },
          11: { class: "w-5 h-5 -mr-2 ml-0" },
          10: { class: "w-5 h-5 -mr-2 ml-0" },
          9: { class: "w-5 h-5 -mr-2 ml-0" },
          8: { class: "w-5 h-5 -mr-1.5 -ml-0.5" },
          7: { class: "w-4 h-4 -mr-2 -ml-0.5" },
          6: { class: "w-4 h-4 -mr-1.5 -ml-0.5" },
          5: { class: "w-3 h-3 -mr-1 -ml-1" }
        },
        iconAnimate: {
          true: "group-hover:transform group-hover:translate-x-1 group-active:translate-x-2 ease-in-out duration-300 transition-all"
        }
      }
    },
    iconX: {
      _common: "cursor-pointer",
      propsStateBased: {
        size: {
          24: { class: "w-8 h-8", lucideStrokeWidth: 3 },
          20: { class: "w-8 h-8", lucideStrokeWidth: 3 },
          16: { class: "w-8 h-8", lucideStrokeWidth: 3 },
          14: { class: "w-6 h-6", lucideStrokeWidth: 4 },
          12: { class: "w-6 h-6", lucideStrokeWidth: 4 },
          11: { class: "w-5 h-5", lucideStrokeWidth: 4 },
          10: { class: "w-5 h-5", lucideStrokeWidth: 4 },
          9: { class: "w-5 h-5", lucideStrokeWidth: 3 },
          8: { class: "w-4 h-4", lucideStrokeWidth: 3.5 },
          7: { class: "w-4 h-4", lucideStrokeWidth: 3 },
          6: { class: "w-4 h-4", lucideStrokeWidth: 3 },
          5: { class: "w-3 h-3", lucideStrokeWidth: 4 }
        }
      }
    }
  }
}, bx = {
  __name: "Chip",
  props: {
    // contains overrides for all components
    themeConfig: {
      type: Object
    },
    // contains overrides for this component only
    pt: {
      type: Object
    },
    variant: {
      type: String,
      default: "primary"
    },
    kind: {
      type: String,
      default: "solid"
    },
    glass: {
      type: Boolean,
      default: !1
    },
    label: {
      type: [String, Boolean],
      default: !1
    },
    labelSecondary: {
      type: [String, Boolean],
      default: !1
    },
    doubleAction: {
      type: Boolean,
      default: !1
    },
    size: {
      type: Number,
      default: 11
    },
    circle: {
      type: Boolean,
      default: !1
    },
    fullWidth: {
      type: Boolean,
      default: !1
    },
    fullHeight: {
      type: Boolean,
      default: !1
    },
    padding: {
      type: String,
      default: "default"
    },
    rounded: {
      type: String,
      default: "full"
    },
    context: {
      type: String
    },
    locale: {
      type: String,
      default: "en"
    },
    progress: {
      type: Boolean,
      default: !1
    },
    // only icon, no label
    icon: {
      type: [String, Boolean],
      default: !1
    },
    iconStart: {
      type: [String, Boolean],
      default: !1
    },
    iconEnd: {
      type: [String, Boolean],
      default: !1
    },
    iconSet: {
      type: String,
      default: "lucide"
    },
    iconStrokeWidth: {
      type: Number,
      default: 2
    },
    iconAnimate: {
      type: Boolean,
      default: !1
    },
    disabled: {
      type: Boolean,
      default: !1
    },
    showX: {
      type: Boolean,
      default: !1
    },
    clickable: {
      type: Boolean,
      default: !1
    }
  },
  emits: ["action", "actionX"],
  setup(e, { emit: t }) {
    const a = e, o = t, { ep: n } = Te({ props: a, defaults: OD }), i = W(a.label || !1), l = W(0);
    ot(
      () => a.label,
      (h) => {
        i.value = h;
      },
      {
        immediate: !0
      }
    );
    function c() {
      a.disabled || (a.doubleAction ? (l.value++, l.value == 1 ? i.value = a.labelSecondary : l.value == 2 && (o("action"), l.value = 0)) : o("action"));
    }
    function s() {
      a.disabled || o("actionX");
    }
    return (h, m) => (d(), y("div", H(u(n).root, { onClick: c }), [
      ee(h.$slots, "default", {}, () => [
        e.progress ? (d(), Q(We, H({ key: 0 }, u(n).progressIcon, {
          class: "animate-spin",
          lucide: "Loader2"
        }), null, 16)) : v("", !0),
        e.iconStart && e.iconSet == "lucide" ? (d(), Q(We, H({ key: 1 }, u(n).iconStart, {
          lucide: e.iconStart,
          "lucide-stroke-width": e.iconStrokeWidth
        }), null, 16, ["lucide", "lucide-stroke-width"])) : v("", !0),
        e.icon && e.iconSet == "lucide" ? (d(), Q(We, H({ key: 2 }, u(n).icon, {
          lucide: e.icon,
          "lucide-stroke-width": e.iconStrokeWidth
        }), null, 16, ["lucide", "lucide-stroke-width"])) : v("", !0),
        i.value && !e.icon ? (d(), y("span", P(H({ key: 3 }, u(n).text)), G(i.value), 17)) : e.icon ? v("", !0) : (d(), y("span", P(H({ key: 4 }, u(n).text)), G(u(Ux).get("element-chip", null, e.locale)), 17)),
        e.iconEnd && !e.icon && e.iconSet == "lucide" ? (d(), Q(We, H({ key: 5 }, u(n).iconEnd, {
          lucide: e.iconEnd,
          "lucide-stroke-width": e.iconStrokeWidth
        }), null, 16, ["lucide", "lucide-stroke-width"])) : v("", !0),
        e.showX ? (d(), Q(We, H({ key: 6 }, u(n).iconX, {
          lucide: "X",
          onClick: s
        }), null, 16)) : v("", !0)
      ])
    ], 16));
  }
}, $D = {
  composer: {
    props: {
      label: {
        default: "label",
        control: "input"
      },
      modelValue: {
        default: [],
        control: "input"
      },
      placeholder: {
        default: "select something",
        control: "input"
      },
      options: {
        default: [
          {
            label: "option 1",
            labelSecondary: "label 2",
            sublabel: "sublabel 1",
            value: "option-1"
          },
          {
            label: "option 2",
            sublabel: "sublabel 2",
            value: "option-2"
          },
          {
            label: "option 3",
            sublabel: "sublabel 3",
            value: "option-3",
            disabled: !0
          },
          {
            label: "option 4",
            value: "option-4"
          }
        ],
        control: "input"
      },
      caption: {
        default: "caption with additional information",
        control: "input"
      },
      // status: {
      //   default: false, //"error",
      //   control: "select",
      //   options: [false, "success", "error", "progress"],
      // },
      size: {
        default: 11,
        control: "select",
        options: [24, 20, 16, 14, 12, 11, 10, 9, 8]
      },
      // statusMessage: {
      //   default: "status message",
      //   control: "input",
      // },
      disabled: {
        default: !1,
        control: "switch"
      },
      layout: {
        default: "vertical",
        control: "select",
        options: ["horizontal", "vertical", "grid"]
      },
      fullWidth: {
        default: !1,
        options: [!0, !1],
        control: "switch"
      }
    }
  },
  pt: {
    options: {
      _common: "gap-2",
      propsStateBased: {
        layout: {
          horizontal: "flex flex-row",
          vertical: "flex flex-col",
          grid: "grid grid-cols-2 gap-2"
        },
        fullWidth: {
          true: "w-full",
          false: "min-w-[300px]"
        }
      }
    },
    option: {
      _common: "flex grow flex-row justify-between overflow-hidden transition-all duration-300 ease-in-out w-full",
      propsStateBased: {
        size: {
          24: "h-24 rounded-xl",
          20: "h-20 rounded-xl",
          16: "h-16 rounded-xl",
          14: "h-14 rounded-xl",
          12: "h-12 rounded-xl",
          11: "h-11 rounded-xl",
          // default
          10: "h-10 rounded-lg",
          9: "h-9 rounded-lg",
          8: "h-8 rounded-lg"
        },
        filled: {
          true: "bg-neutral-100",
          false: "outline outline-neutral-300 dark:outline-neutral-800"
        },
        disabled: {
          true: "dark:bg-neutral-800 cursor-not-allowed",
          false: {
            _common: "cursor-pointer",
            filled: {
              true: "hover:bg-neutral-200",
              false: "hover:outline-neutral-400"
            }
          }
        }
      }
    },
    optionSelected: {
      _common: "flex grow flex-row justify-between overflow-hidden transition-all duration-300 ease-in-out w-full",
      propsStateBased: {
        size: {
          24: "h-24 rounded-xl",
          20: "h-20 rounded-xl",
          16: "h-16 rounded-xl",
          14: "h-14 rounded-xl",
          12: "h-12 rounded-xl",
          11: "h-11 rounded-xl",
          // default
          10: "h-10 rounded-lg",
          9: "h-9 rounded-lg",
          8: "h-8 rounded-lg"
        },
        filled: {
          true: "outline outline-2 outline-neutral-500 bg-neutral-100 dark:bg-neutral-800 dark:outline-neutral-400",
          false: "outline outline-2 outline-neutral-500 dark:outline-neutral-200"
        }
      }
    },
    optionDisabled: {
      _common: "flex grow flex-row justify-between overflow-hidden transition-all duration-300 ease-in-out w-full",
      propsStateBased: {
        size: {
          24: "h-24 rounded-xl",
          20: "h-20 rounded-xl",
          16: "h-16 rounded-xl",
          14: "h-14 rounded-xl",
          12: "h-12 rounded-xl",
          11: "h-11 rounded-xl",
          // default
          10: "h-10 rounded-lg",
          9: "h-9 rounded-lg",
          8: "h-8 rounded-lg"
        },
        filled: {
          true: "bg-neutral-50",
          false: "outline outline-2 outline-neutral-50"
        }
      }
    },
    optionLabels: {
      _common: "flex flex-col px-4 gap-0 justify-center",
      propsStateBased: {
        layout: {
          horizontal: "",
          vertical: "",
          grid: "w-full items-center"
        }
      }
    },
    optionLabel: {
      _common: "font-bold",
      propsStateBased: {
        disabled: {
          true: "text-neutral-200 dark:text-neutral-600",
          false: "text-neutral-900 dark:text-neutral-100"
        }
      }
    },
    optionLabelSecondary: {
      _common: "font-bold",
      propsStateBased: {
        disabled: {
          true: "text-neutral-200",
          false: "text-neutral-900"
        }
      }
    },
    optionSublabel: {
      _common: "leading-3 text-xs",
      propsStateBased: {
        disabled: {
          true: "text-neutral-200",
          false: "text-neutral-400"
        }
      }
    },
    labelOuter: {
      _common: "inline-block text-base font-bold text-neutral-600 dark:text-neutral-500 font-element"
    },
    innerElementsLeft: {
      _common: "flex flex-row",
      propsStateBased: {
        size: {
          14: "ml-1.5 gap-1.5 py-1.5",
          12: "ml-1.5 gap-1.5 py-1.5",
          11: "ml-1.5 gap-1.5 py-1.5",
          10: "ml-1 gap-1 py-1",
          9: "ml-1 gap-1 py-1",
          8: "ml-1 gap-1 py-1"
        }
      }
    },
    innerElementsRight: {
      _common: "flex flex-row h-full items-center px-4",
      propsStateBased: {}
    },
    modeViewValue: {
      _common: "text-neutral-900 dark:text-neutral-100"
    }
  }
}, RD = {
  composer: {
    props: {
      label: {
        default: "label",
        control: "input"
      },
      caption: {
        default: "caption with additional information",
        control: "input"
      },
      placeholder: {
        default: "placeholder",
        control: "input"
      },
      prefix: {
        default: !1,
        //"https://",
        control: "input"
      },
      suffix: {
        default: !1,
        //"CZK",
        control: "input"
      },
      status: {
        default: !1,
        //"error",
        control: "select",
        options: [!1, "success", "error", "progress"]
      },
      size: {
        default: 11,
        control: "select",
        options: [14, 12, 11, 10, 9, 8]
      },
      statusMessage: {
        default: "status message",
        control: "input"
      },
      disabled: {
        default: !1,
        control: "switch"
      },
      fullWidth: {
        default: !1,
        options: [!1, !0],
        control: "switch"
      },
      long: {
        default: !1,
        options: [!1, !0],
        control: "switch"
      }
    }
  },
  pt: {
    container: {
      _common: "border flex flex-row overflow-hidden",
      propsStateBased: {
        fullWidth: {
          true: "w-full"
        },
        long: {
          false: {
            size: {
              14: "h-14 rounded-xl",
              12: "h-12 rounded-xl",
              11: "h-11 rounded-xl",
              // default
              10: "h-10 rounded-lg",
              9: "h-9 rounded-lg",
              8: "h-8 rounded-lg"
            }
          },
          true: {
            size: {
              14: "h-14 rounded-xl",
              12: "h-12 rounded-xl",
              11: "min-h-24 rounded-xl",
              // default
              10: "h-10 rounded-lg",
              9: "h-9 rounded-lg",
              8: "h-8 rounded-lg"
            }
          }
        },
        focused: {
          true: {
            _common: "shadow-[0px_0px_0px_1px]",
            status: {
              false: "border-neutral-400 shadow-neutral-400",
              success: "border-neutral-400 shadow-neutral-400",
              error: "border-critical-500 shadow-critical-500",
              progress: "border-neutral-400 shadow-neutral-400"
            }
          },
          false: {
            status: {
              false: "border-neutral-300 dark:border-neutral-700",
              success: "border-neutral-300 dark:border-neutral-700",
              error: "border-critical-500",
              progress: "border-neutral-300 dark:border-neutral-700"
            }
          }
        },
        disabled: {
          true: "bg-neutral-100 dark:bg-neutral-800"
        },
        multiPosition: {
          first: "rounded-b-none",
          middle: "!rounded-none -my-px",
          last: "rounded-t-none"
        }
      }
    },
    labelOuter: {
      _common: "inline-block text-base font-bold text-neutral-600 dark:text-neutral-500 font-element"
    },
    labelInner: {
      // _common: "absolute left-1.5 text-neutral-600 dark:text-neutral-200",
      _common: "left-1.5 text-neutral-600 dark:text-neutral-500 text-sm font-bold pt-0.5",
      propsStateBased: {
        // focused: {
        //   true: "top-1",
        //   false: "top-5",
        // },
      }
    },
    labelLang: {
      _common: "text-sm font-normal text-neutral-600 dark:text-neutral-700 font-element absolute right-0.5 top-0.5"
    },
    inputFieldWithPlaceholder: {
      _common: "relative h-full min-w-[10rem] overflow-x-hidden"
    },
    placeholder: {
      _common: "flex flex-row items-center justify-start absolute inset-0 font-normal text-neutral-300 dark:text-neutral-700 pointer-events-none font-element whitespace-nowrap",
      propsStateBased: {
        focused: {
          // true: "top-1",
          // false: "top-5",
        }
      }
    },
    inputField: {
      _common: "text-neutral-900 dark:text-neutral-100",
      propsStateBased: {
        mode: {
          edit: "",
          view: "whitespace-pre-wrap"
        },
        long: {
          false: "flex flex-row items-center justify-start absolute inset-0 my-1.5 whitespace-nowrap",
          true: "h-full my-1.5"
        }
      }
    },
    innerElementsLeft: {
      _common: "flex flex-row",
      propsStateBased: {
        size: {
          14: "ml-1.5 gap-1.5 py-1.5",
          12: "ml-1.5 gap-1.5 py-1.5",
          11: "ml-1.5 gap-1.5 py-1.5",
          10: "ml-1 gap-1 py-1",
          9: "ml-1 gap-1 py-1",
          8: "ml-1 gap-1 py-1"
        }
      }
    },
    innerElementsRight: {
      _common: "flex flex-row",
      propsStateBased: {
        size: {
          14: "mr-1.5 gap-1.5 py-1.5",
          12: "mr-1.5 gap-1.5 py-1.5",
          11: "mr-1.5 gap-1.5 py-1.5",
          10: "mr-1 gap-1 py-1",
          9: "mr-1 gap-1 py-1",
          8: "mr-1 gap-1 py-1"
        }
      }
    },
    statusIndicator: {
      _common: "flex bg-opacity-10 px-1.5 flex-center",
      propsStateBased: {
        status: {
          success: "bg-success-600",
          error: "bg-critical-600",
          progress: "bg-neutral-600"
        },
        size: {
          14: "rounded-md",
          12: "rounded-md",
          11: "rounded-md",
          10: "rounded",
          9: "rounded",
          8: "rounded"
        }
      }
    },
    statusIndicatorIcon: {
      propsStateBased: {
        status: {
          success: {
            lucide: "Check",
            lucideStrokeWidth: 4,
            class: "w-4 text-success-700"
          },
          error: {
            lucide: "X",
            lucideStrokeWidth: 4,
            class: "w-4 text-critical-700"
          },
          progress: {
            lucide: "Loader2",
            lucideStrokeWidth: 4,
            spin: !0,
            class: "w-4 text-neutral-500"
          }
        }
      }
    },
    statusMessage: {
      _common: "font-normal text-sm font-element",
      propsStateBased: {
        status: {
          success: "text-success-600",
          error: "text-critical-600",
          progress: "text-neutral-600"
        }
      }
    },
    prefixContainer: {
      _common: "flex h-full flex-center",
      propsStateBased: {
        prefixTransparent: {
          true: "pl-3",
          false: "px-3 bg-neutral-100 dark:bg-neutral-800"
        }
      }
    },
    prefixText: {
      _common: "font-semibold text-neutral-400"
    },
    suffixContainer: {
      _common: "flex h-full bg-neutral-100 dark:bg-neutral-800 px-3 flex-center"
    },
    suffixText: {
      _common: "font-semibold text-neutral-400 dark:text-neutral-400"
    },
    modeViewValue: {
      _common: "text-neutral-900 dark:text-neutral-100"
    }
  }
};
function A9(e, t, a) {
  var o, n, i, l, c;
  t == null && (t = 100);
  function s() {
    var m = Date.now() - l;
    m < t && m >= 0 ? o = setTimeout(s, t - m) : (o = null, a || (c = e.apply(i, n), i = n = null));
  }
  var h = function() {
    i = this, n = arguments, l = Date.now();
    var m = a && !o;
    return o || (o = setTimeout(s, t)), m && (c = e.apply(i, n), i = n = null), c;
  };
  return h.clear = function() {
    o && (clearTimeout(o), o = null);
  }, h.flush = function() {
    o && (c = e.apply(i, n), i = n = null, clearTimeout(o), o = null);
  }, h;
}
A9.debounce = A9;
var ib = A9;
const Ex = (e, t) => {
  const a = e.__vccOpts || e;
  for (const [o, n] of t)
    a[o] = n;
  return a;
}, FD = {
  name: "OneDatatypeString",
  props: {
    modelValue: {
      type: [String, Number, Boolean],
      default: ""
    },
    multiline: {
      type: Boolean,
      default: !1
    },
    lowercase: {
      type: Boolean,
      default: !1
    },
    nospace: {
      type: Boolean,
      default: !1
    },
    regex: {
      type: [String, Boolean],
      default: !1
    },
    disabled: {
      type: Boolean,
      default: !1
    },
    mode: {
      type: String,
      default: "edit"
      // view | edit
    },
    focus: {
      type: Boolean,
      default: !1
    },
    // parse value as float
    float: {
      type: Boolean,
      default: !1
    },
    // parse value as int
    int: {
      type: Boolean,
      default: !1
    },
    container: {
      type: String,
      default: "p",
      validator: (e) => ["p", "input"].includes(e)
    },
    type: {
      type: String,
      default: "text",
      validator: (e) => ["text", "password"].includes(e)
    }
  },
  emits: [
    "update:modelValue",
    "input",
    "keydown",
    "keyup",
    "focus",
    "blur",
    "paste",
    "enter",
    "mouseup"
  ],
  data() {
    return {
      focused: !1,
      savedSelection: null,
      focusedByKey: !1
    };
  },
  computed: {
    showTagParagraph() {
      return this.container === "p";
    },
    showTagInput() {
      return this.container === "input";
    },
    contenteditable() {
      return this.disabled ? !1 : this.mode == "edit";
    },
    listeners() {
      return {
        ...this.$attrs,
        input: this.onInput,
        keydown: this.onKeyDown,
        keyup: this.onKeyUp,
        focus: this.onFocus,
        blur: this.onBlur,
        paste: this.onPaste,
        mouseup: this.onMouseUp
      };
    }
  },
  watch: {
    modelValue: {
      handler() {
        (!this.focused || this.modelValue === "") && this.setValue();
      }
    },
    focus: {
      handler() {
        this.focus ? this.$nextTick(() => {
          this.$refs.editable.focus();
        }) : this.$nextTick(() => {
          this.$refs.editable && this.$refs.editable.blur();
        });
      },
      immediate: !0
    }
  },
  mounted() {
    this.setValue();
  },
  methods: {
    doFocus({ key: e }) {
      this.$refs.editable.focus(), this.focusedByKey = !!e;
    },
    setValue() {
      this.container === "input" ? this.$refs.editable.value = this.modelValue : this.$refs.editable.innerText = this.modelValue;
    },
    onPaste(e) {
      e.preventDefault(), e.stopPropagation();
      let t = e.clipboardData.getData("text/plain");
      if (console.log({ clipboardText: t }), this.savedSelection = this.getCurrentSelection(), this.container === "input") {
        this.$refs.editable.value = t;
        return;
      }
      var a, o;
      if (window.getSelection) {
        if (a = window.getSelection(), a.getRangeAt && a.rangeCount) {
          o = a.getRangeAt(0), o.deleteContents();
          const n = document.createDocumentFragment();
          t.split(/\n/).forEach((i) => {
            const l = document.createElement("div");
            i === "" ? l.innerHTML = "&nbsp;" : l.appendChild(document.createTextNode(i)), n.appendChild(l);
          }), o.insertNode(n);
        }
      } else
        document.selection && document.selection.createRange && document.selection.createRange().pasteHTML(
          t.split(/\n/).map((i) => i === "" ? "<div>&nbsp;</div>" : `<div>${i}</div>`).join("")
        );
      this.restoreSelection(this.savedSelection);
    },
    getCurrentSelection() {
      let e;
      if (window.getSelection) {
        if (e = window.getSelection(), e.getRangeAt && e.rangeCount)
          return e.getRangeAt(0);
      } else if (document.selection && document.selection.createRange)
        return document.selection.createRange();
      return null;
    },
    restoreSelection(e) {
      let t;
      e && (window.getSelection ? (t = window.getSelection(), t.collapseToEnd(this.$refs.editable), t.addRange(e)) : document.selection && e.select && e.select());
    },
    onKeyDown(e) {
      this.disabled || this.$emit("keydown", e);
    },
    onKeyUp(e) {
      if (e.key == "Enter" && this.$emit("enter", e), this.$emit("keyup", e), !this.disabled)
        if (!this.valid(e))
          e.preventDefault(), e.stopPropagation();
        else {
          const t = this.container === "p" ? e.target.innerText : e.target.value;
          this.$emit("update:modelValue", this.format(t));
        }
    },
    onInput(e) {
    },
    onFocus(e) {
      this.$emit("focus", e), this.focused = !0;
    },
    onBlur(e) {
      this.$emit("blur", e), this.focused = !1;
    },
    onMouseUp(e) {
      this.$emit("mouseup", e);
    },
    // formatters
    // it would be great to make the formatting live & visible, but it is a lot of work, so fuck it for now.
    format(e) {
      let t = e;
      return this.lowercase && (t = t.toLowerCase()), this.nospace && (t = t.replace(/\s/g, "")), t === "" && (t = null), t === "true" && (t = !0), t === "false" && (t = !1), this.int && (t = parseInt(t)), this.float && (t = parseFloat(t)), t != null && t.trim && (t = t.trim()), t;
    },
    // validators
    valid(e) {
      if (!this.disabled)
        return this.validateSpace(e) && this.validateEnter(e) && this.validateRegex(e);
    },
    validateSpace(e) {
      return this.nospace ? e.keyCode !== 32 : !0;
    },
    validateEnter(e) {
      return this.multiline ? !0 : e.keyCode !== 13;
    },
    validateRegex(e) {
      return this.regex && ![8, 46, 9, 37, 38, 39, 40].includes(e.keyCode) && !([65, 67, 86].includes(e.keyCode) && (e.metaKey || e.ctrlKey)) ? new RegExp(`${this.regex}`).test(e.key) : !0;
    }
  }
}, UD = ["contenteditable"], ED = ["type"];
function WD(e, t, a, o, n, i) {
  return i.showTagParagraph ? (d(), y("p", H({
    key: 0,
    ref: "editable",
    contenteditable: i.contenteditable
  }, S9(i.listeners, !0), {
    class: ["font-element outline-none focus:outline-none", [{ lowercase: a.lowercase }, { disabled: a.disabled }, `mode-${a.mode}`]]
  }), null, 16, UD)) : i.showTagInput ? (d(), y("input", H({
    key: 1,
    ref: "editable",
    type: a.type
  }, S9(i.listeners, !0), {
    class: ["font-element bg-transparent outline-none focus:outline-none", [{ lowercase: a.lowercase }, { disabled: a.disabled }, `mode-${a.mode}`]],
    autocomplete: "type === 'password' ? 'current-password' : 'off'",
    autocapitalize: "none",
    spellcheck: "false"
  }), null, 16, ED)) : v("", !0);
}
const jI = /* @__PURE__ */ Ex(FD, [["render", WD]]);
function VI(e, t) {
  const a = (n) => {
    n.key === e && (n.preventDefault(), n.stopPropagation(), t("down"));
  }, o = (n) => {
    n.key === e && (n.preventDefault(), n.stopPropagation(), t("up"));
  };
  at(() => {
    window.addEventListener("keydown", a), window.addEventListener("keyup", o);
  }), $r(() => {
    window.removeEventListener("keydown", a), window.removeEventListener("keyup", o);
  });
}
const ND = {
  key: 0,
  class: "flex flex-col"
}, ZD = {
  key: 0,
  class: "mb-1 flex flex-row items-end justify-between"
}, YD = { class: "flex flex-row items-end gap-2" }, GD = {
  key: 1,
  class: "mb-1"
}, XD = { class: "flex flex-row gap-1.5" }, KD = { key: 0 }, QD = { class: "relative flex w-full flex-col justify-center px-1.5 py-0" }, JD = { key: 0 }, e_ = { key: 0 }, t_ = { key: 1 }, a_ = { key: 0 }, n_ = {
  key: 1,
  class: ""
}, o_ = { class: "mt-1 text-sm text-neutral-400 dark:text-neutral-700" }, r_ = {
  key: 1,
  class: "flex flex-col"
}, Wx = {
  __name: "Input",
  props: {
    globalConfig: {
      type: Object
    },
    pt: {
      type: Object
    },
    modelValue: {
      type: [String, Number]
    },
    langs: {
      type: Array
    },
    prefix: {
      type: [String, Boolean],
      default: !1
    },
    suffix: {
      type: [String, Boolean],
      default: !1
    },
    long: {
      type: Boolean,
      default: !1
    },
    lowercase: {
      type: Boolean,
      default: !1
    },
    nospace: {
      type: Boolean,
      default: !1
    },
    regex: {
      type: [String, Boolean],
      default: !1
    },
    disabled: {
      type: Boolean,
      default: !1
    },
    placeholder: {
      type: [String, Object, Boolean],
      default: !1
    },
    mode: {
      type: String,
      default: "edit"
    },
    label: {
      type: [String, Boolean],
      default: !1
    },
    labelInside: {
      type: Boolean,
      default: !1
    },
    labelLang: {
      type: [String, Boolean],
      default: !1
    },
    multiPosition: {
      type: [String, Boolean],
      default: !1,
      validator: (e) => [!1, "first", "middle", "last"].includes(e)
    },
    caption: {
      type: [String, Boolean],
      default: !1
    },
    size: {
      type: Number,
      default: 11
    },
    padding: {
      type: String,
      default: "default"
    },
    rounded: {
      type: String,
      default: "full"
    },
    context: {
      type: String,
      validator: function(e) {
        return ["dark", "neutral", "light"].indexOf(e) !== -1;
      }
    },
    locale: {
      type: String,
      default: "en"
    },
    status: {
      type: [String, Boolean],
      default: !1
    },
    statusMessage: {
      type: [String, Boolean],
      default: !1
    },
    // how long to wait with emitting input event after typing has stopped
    debounce: {
      type: Number,
      default: 750
    },
    // saving state indicator - init | saving | saved | error
    saveState: {
      // manual
      type: [String, Boolean],
      default: !1
    },
    autoState: {
      // auto -> 'formSaveState' store necessary
      type: Boolean,
      default: !1
    },
    fullWidth: {
      type: Boolean,
      default: !1
    },
    focus: {
      type: Boolean,
      default: !1
    },
    // parse value as float
    float: {
      type: Boolean,
      default: !1
    },
    // parse value as int
    int: {
      type: Boolean,
      default: !1
    },
    focusOnSlashKey: {
      type: Boolean,
      default: !1
    },
    prefixTransparent: {
      type: Boolean,
      default: !1
    },
    type: {
      type: String,
      default: "text",
      validator: (e) => ["text", "password"].includes(e)
    },
    container: {
      type: String,
      default: "p",
      validator: (e) => ["p", "input"].includes(e)
    }
  },
  emits: [
    "update:modelValue",
    "keyup",
    "keydown",
    "enter",
    "focus",
    "blur",
    "input-debounced",
    "mouseup"
  ],
  setup(e, { emit: t }) {
    const a = e, o = t, n = W(null), i = ia(a, "modelValue"), l = W(a.modelValue), c = W(!1), s = N(() => a.labelInside && a.size >= 11 ? "inside" : "outside"), h = N(() => a.placeholder && !l.value), m = ib.debounce(function(C, B) {
      L(C);
    }, a.debounce);
    function p(C) {
      o("keyup", C);
    }
    function f(C) {
      o("keydown", C);
    }
    function g(C) {
      o("enter", C);
    }
    function w() {
      c.value = !0, o("focus");
    }
    function q() {
      c.value = !1, o("blur");
    }
    function _(C) {
      o("mouseup", C);
    }
    function b(C) {
      l.value = C, j(C), m(C);
    }
    function L(C) {
      o("input-debounced", C);
    }
    function j(C) {
      o("update:modelValue", C);
    }
    const { ep: I } = Te({ props: a, locals: { focused: c }, defaults: RD });
    return a.focusOnSlashKey && VI("/", () => {
      console.log("You pressed the / key"), n.value.doFocus({ key: "/" });
    }), (C, B) => (d(), y("div", P(X(u(I).root)), [
      a.mode == "edit" ? (d(), y("div", ND, [
        a.label || e.statusMessage || C.$slots.buttonOuterTop ? (d(), y("div", ZD, [
          a.label && s.value === "outside" ? (d(), y("span", P(H({ key: 0 }, u(I).labelOuter)), G(a.label), 17)) : v("", !0),
          D("div", YD, [
            e.statusMessage ? (d(), y("span", P(H({ key: 0 }, u(I).statusMessage)), G(e.statusMessage), 17)) : v("", !0),
            C.$slots.buttonOuterTop ? (d(), y("div", GD, [
              ee(C.$slots, "buttonOuterTop", {}, () => [
                be(bt, {
                  variant: "form",
                  size: 5,
                  rounded: "full"
                })
              ])
            ])) : v("", !0)
          ])
        ])) : v("", !0),
        D("div", XD, [
          D("div", P(X(u(I).container)), [
            e.prefix || C.$slots.prefix ? (d(), y("div", P(H({ key: 0 }, u(I).prefixContainer)), [
              ee(C.$slots, "prefix", {}, () => [
                D("span", P(X(u(I).prefixText)), G(e.prefix), 17)
              ])
            ], 16)) : v("", !0),
            D("div", P(X(u(I).innerElementsLeft)), [
              C.$slots.buttonInnerLeft ? (d(), y("div", KD, [
                ee(C.$slots, "buttonInnerLeft", {}, () => [
                  be(bt, {
                    variant: "form",
                    size: 11,
                    rounded: "lg"
                  })
                ])
              ])) : v("", !0)
            ], 16),
            D("div", QD, [
              s.value == "inside" ? (d(), y("div", P(H({ key: 0 }, u(I).labelInner)), [
                a.label ? (d(), y("span", JD, G(a.label), 1)) : v("", !0)
              ], 16)) : v("", !0),
              a.labelLang ? (d(), y("span", P(H({ key: 1 }, u(I).labelLang)), G(a.labelLang), 17)) : v("", !0),
              D("div", P(X(u(I).inputFieldWithPlaceholder)), [
                h.value ? (d(), y("span", P(H({ key: 0 }, u(I).placeholder)), G(a.placeholder), 17)) : v("", !0),
                be(jI, H({
                  ref_key: "elDatatypeString",
                  ref: n
                }, u(I).inputField, {
                  modelValue: i.value,
                  multiline: e.long,
                  lowercase: e.lowercase,
                  nospace: e.nospace,
                  regex: e.regex,
                  disabled: e.disabled,
                  mode: e.mode,
                  focus: e.focus,
                  int: e.int,
                  float: e.float,
                  type: e.type,
                  container: e.container,
                  "onUpdate:modelValue": b,
                  onPaste: b,
                  onKeyup: p,
                  onKeydown: f,
                  onFocus: w,
                  onBlur: q,
                  onEnter: g,
                  onMouseup: _
                }), null, 16, ["modelValue", "multiline", "lowercase", "nospace", "regex", "disabled", "mode", "focus", "int", "float", "type", "container"])
              ], 16)
            ]),
            D("div", P(X(u(I).innerElementsRight)), [
              C.$slots.buttonInnerTop ? (d(), y("div", e_, [
                ee(C.$slots, "buttonInnerTop", {}, () => [
                  be(bt, {
                    variant: "form",
                    size: 5,
                    rounded: "full"
                  })
                ])
              ])) : v("", !0),
              C.$slots.buttonInnerRight ? (d(), y("div", t_, [
                ee(C.$slots, "buttonInnerRight", {}, () => [
                  be(bt, {
                    variant: "form",
                    size: e.size - 3,
                    rounded: "lg"
                  }, null, 8, ["size"])
                ])
              ])) : v("", !0),
              e.status ? (d(), y("div", P(H({ key: 2 }, u(I).statusIndicator)), [
                be(We, P(X(u(I).statusIndicatorIcon)), null, 16)
              ], 16)) : v("", !0)
            ], 16),
            e.suffix || C.$slots.suffix ? (d(), y("div", P(H({ key: 1 }, u(I).suffixContainer)), [
              ee(C.$slots, "suffix", {}, () => [
                D("span", P(X(u(I).suffixText)), G(e.suffix), 17)
              ])
            ], 16)) : v("", !0)
          ], 16),
          C.$slots.buttonOuterRight ? (d(), y("div", a_, [
            ee(C.$slots, "buttonOuterRight", {}, () => [
              be(bt, {
                variant: "form",
                size: 14,
                rounded: "xl"
              })
            ])
          ])) : v("", !0)
        ]),
        e.caption || C.$slots.caption ? (d(), y("div", n_, [
          ee(C.$slots, "caption", {}, () => [
            D("p", o_, G(e.caption), 1)
          ])
        ])) : v("", !0)
      ])) : v("", !0),
      a.mode == "view" ? (d(), y("div", r_, [
        a.label ? (d(), y("span", P(H({ key: 0 }, u(I).inputLabel)), G(a.label), 17)) : v("", !0),
        D("p", P(X(u(I).modeViewValue)), G(i.value), 17)
      ])) : v("", !0)
    ], 16));
  }
};
function i_(e, t) {
  for (var a = -1, o = e == null ? 0 : e.length, n = Array(o); ++a < o; )
    n[a] = t(e[a], a, e);
  return n;
}
var OI = i_, l_ = Ur, c_ = Xt, d_ = "[object Symbol]";
function s_(e) {
  return typeof e == "symbol" || c_(e) && l_(e) == d_;
}
var Nx = s_, u_ = Lt, h_ = Nx, p_ = /\.|\[(?:[^[\]]*|(["'])(?:(?!\1)[^\\]|\\.)*?\1)\]/, y_ = /^\w*$/;
function k_(e, t) {
  if (u_(e))
    return !1;
  var a = typeof e;
  return a == "number" || a == "symbol" || a == "boolean" || e == null || h_(e) ? !0 : y_.test(e) || !p_.test(e) || t != null && e in Object(t);
}
var lb = k_, $I = G9, f_ = "Expected a function";
function cb(e, t) {
  if (typeof e != "function" || t != null && typeof t != "function")
    throw new TypeError(f_);
  var a = function() {
    var o = arguments, n = t ? t.apply(this, o) : o[0], i = a.cache;
    if (i.has(n))
      return i.get(n);
    var l = e.apply(this, o);
    return a.cache = i.set(n, l) || i, l;
  };
  return a.cache = new (cb.Cache || $I)(), a;
}
cb.Cache = $I;
var v_ = cb, m_ = v_, g_ = 500;
function M_(e) {
  var t = m_(e, function(o) {
    return a.size === g_ && a.clear(), o;
  }), a = t.cache;
  return t;
}
var x_ = M_, b_ = x_, w_ = /[^.[\]]+|\[(?:(-?\d+(?:\.\d+)?)|(["'])((?:(?!\2)[^\\]|\\.)*?)\2)\]|(?=(?:\.|\[\])(?:\.|\[\]|$))/g, I_ = /\\(\\)?/g, L_ = b_(function(e) {
  var t = [];
  return e.charCodeAt(0) === 46 && t.push(""), e.replace(w_, function(a, o, n, i) {
    t.push(n ? i.replace(I_, "$1") : o || a);
  }), t;
}), S_ = L_, tw = p1, C_ = OI, A_ = Lt, P_ = Nx, q_ = 1 / 0, aw = tw ? tw.prototype : void 0, nw = aw ? aw.toString : void 0;
function RI(e) {
  if (typeof e == "string")
    return e;
  if (A_(e))
    return C_(e, RI) + "";
  if (P_(e))
    return nw ? nw.call(e) : "";
  var t = e + "";
  return t == "0" && 1 / e == -q_ ? "-0" : t;
}
var T_ = RI, D_ = T_;
function __(e) {
  return e == null ? "" : D_(e);
}
var B_ = __, z_ = Lt, H_ = lb, j_ = S_, V_ = B_;
function O_(e, t) {
  return z_(e) ? e : H_(e, t) ? [e] : j_(V_(e));
}
var FI = O_, $_ = Nx, R_ = 1 / 0;
function F_(e) {
  if (typeof e == "string" || $_(e))
    return e;
  var t = e + "";
  return t == "0" && 1 / e == -R_ ? "-0" : t;
}
var Zx = F_, U_ = FI, E_ = Zx;
function W_(e, t) {
  t = U_(t, e);
  for (var a = 0, o = t.length; e != null && a < o; )
    e = e[E_(t[a++])];
  return a && a == o ? e : void 0;
}
var db = W_, N_ = "__lodash_hash_undefined__";
function Z_(e) {
  return this.__data__.set(e, N_), this;
}
var Y_ = Z_;
function G_(e) {
  return this.__data__.has(e);
}
var X_ = G_, K_ = G9, Q_ = Y_, J_ = X_;
function wx(e) {
  var t = -1, a = e == null ? 0 : e.length;
  for (this.__data__ = new K_(); ++t < a; )
    this.add(e[t]);
}
wx.prototype.add = wx.prototype.push = Q_;
wx.prototype.has = J_;
var eB = wx;
function tB(e, t) {
  for (var a = -1, o = e == null ? 0 : e.length; ++a < o; )
    if (t(e[a], a, e))
      return !0;
  return !1;
}
var aB = tB;
function nB(e, t) {
  return e.has(t);
}
var oB = nB, rB = eB, iB = aB, lB = oB, cB = 1, dB = 2;
function sB(e, t, a, o, n, i) {
  var l = a & cB, c = e.length, s = t.length;
  if (c != s && !(l && s > c))
    return !1;
  var h = i.get(e), m = i.get(t);
  if (h && m)
    return h == t && m == e;
  var p = -1, f = !0, g = a & dB ? new rB() : void 0;
  for (i.set(e, t), i.set(t, e); ++p < c; ) {
    var w = e[p], q = t[p];
    if (o)
      var _ = l ? o(q, w, p, t, e, i) : o(w, q, p, e, t, i);
    if (_ !== void 0) {
      if (_)
        continue;
      f = !1;
      break;
    }
    if (g) {
      if (!iB(t, function(b, L) {
        if (!lB(g, L) && (w === b || n(w, b, a, o, i)))
          return g.push(L);
      })) {
        f = !1;
        break;
      }
    } else if (!(w === q || n(w, q, a, o, i))) {
      f = !1;
      break;
    }
  }
  return i.delete(e), i.delete(t), f;
}
var UI = sB;
function uB(e) {
  var t = -1, a = Array(e.size);
  return e.forEach(function(o, n) {
    a[++t] = [n, o];
  }), a;
}
var hB = uB;
function pB(e) {
  var t = -1, a = Array(e.size);
  return e.forEach(function(o) {
    a[++t] = o;
  }), a;
}
var yB = pB, ow = p1, rw = xI, kB = h1, fB = UI, vB = hB, mB = yB, gB = 1, MB = 2, xB = "[object Boolean]", bB = "[object Date]", wB = "[object Error]", IB = "[object Map]", LB = "[object Number]", SB = "[object RegExp]", CB = "[object Set]", AB = "[object String]", PB = "[object Symbol]", qB = "[object ArrayBuffer]", TB = "[object DataView]", iw = ow ? ow.prototype : void 0, r9 = iw ? iw.valueOf : void 0;
function DB(e, t, a, o, n, i, l) {
  switch (a) {
    case TB:
      if (e.byteLength != t.byteLength || e.byteOffset != t.byteOffset)
        return !1;
      e = e.buffer, t = t.buffer;
    case qB:
      return !(e.byteLength != t.byteLength || !i(new rw(e), new rw(t)));
    case xB:
    case bB:
    case LB:
      return kB(+e, +t);
    case wB:
      return e.name == t.name && e.message == t.message;
    case SB:
    case AB:
      return e == t + "";
    case IB:
      var c = vB;
    case CB:
      var s = o & gB;
      if (c || (c = mB), e.size != t.size && !s)
        return !1;
      var h = l.get(e);
      if (h)
        return h == t;
      o |= MB, l.set(e, t);
      var m = fB(c(e), c(t), o, n, i, l);
      return l.delete(e), m;
    case PB:
      if (r9)
        return r9.call(e) == r9.call(t);
  }
  return !1;
}
var _B = DB;
function BB(e, t) {
  for (var a = -1, o = t.length, n = e.length; ++a < o; )
    e[n + a] = t[a];
  return e;
}
var EI = BB, zB = EI, HB = Lt;
function jB(e, t, a) {
  var o = t(e);
  return HB(e) ? o : zB(o, a(e));
}
var WI = jB;
function VB(e, t) {
  for (var a = -1, o = e == null ? 0 : e.length, n = 0, i = []; ++a < o; ) {
    var l = e[a];
    t(l, a, e) && (i[n++] = l);
  }
  return i;
}
var OB = VB;
function $B() {
  return [];
}
var NI = $B, RB = OB, FB = NI, UB = Object.prototype, EB = UB.propertyIsEnumerable, lw = Object.getOwnPropertySymbols, WB = lw ? function(e) {
  return e == null ? [] : (e = Object(e), RB(lw(e), function(t) {
    return EB.call(e, t);
  }));
} : FB, sb = WB, NB = II, ZB = NB(Object.keys, Object), YB = ZB, GB = J9, XB = YB, KB = Object.prototype, QB = KB.hasOwnProperty;
function JB(e) {
  if (!GB(e))
    return XB(e);
  var t = [];
  for (var a in Object(e))
    QB.call(e, a) && a != "constructor" && t.push(a);
  return t;
}
var ez = JB, tz = qI, az = ez, nz = Zr;
function oz(e) {
  return nz(e) ? tz(e) : az(e);
}
var f1 = oz, rz = WI, iz = sb, lz = f1;
function cz(e) {
  return rz(e, lz, iz);
}
var ZI = cz, cw = ZI, dz = 1, sz = Object.prototype, uz = sz.hasOwnProperty;
function hz(e, t, a, o, n, i) {
  var l = a & dz, c = cw(e), s = c.length, h = cw(t), m = h.length;
  if (s != m && !l)
    return !1;
  for (var p = s; p--; ) {
    var f = c[p];
    if (!(l ? f in t : uz.call(t, f)))
      return !1;
  }
  var g = i.get(e), w = i.get(t);
  if (g && w)
    return g == t && w == e;
  var q = !0;
  i.set(e, t), i.set(t, e);
  for (var _ = l; ++p < s; ) {
    f = c[p];
    var b = e[f], L = t[f];
    if (o)
      var j = l ? o(L, b, f, t, e, i) : o(b, L, f, e, t, i);
    if (!(j === void 0 ? b === L || n(b, L, a, o, i) : j)) {
      q = !1;
      break;
    }
    _ || (_ = f == "constructor");
  }
  if (q && !_) {
    var I = e.constructor, C = t.constructor;
    I != C && "constructor" in e && "constructor" in t && !(typeof I == "function" && I instanceof I && typeof C == "function" && C instanceof C) && (q = !1);
  }
  return i.delete(e), i.delete(t), q;
}
var pz = hz, yz = Sr, kz = Rt, fz = yz(kz, "DataView"), vz = fz, mz = Sr, gz = Rt, Mz = mz(gz, "Promise"), xz = Mz, bz = Sr, wz = Rt, Iz = bz(wz, "Set"), Lz = Iz, Sz = Sr, Cz = Rt, Az = Sz(Cz, "WeakMap"), Pz = Az, P9 = vz, q9 = Y9, T9 = xz, D9 = Lz, _9 = Pz, YI = Ur, Yr = fI, dw = "[object Map]", qz = "[object Object]", sw = "[object Promise]", uw = "[object Set]", hw = "[object WeakMap]", pw = "[object DataView]", Tz = Yr(P9), Dz = Yr(q9), _z = Yr(T9), Bz = Yr(D9), zz = Yr(_9), fr = YI;
(P9 && fr(new P9(new ArrayBuffer(1))) != pw || q9 && fr(new q9()) != dw || T9 && fr(T9.resolve()) != sw || D9 && fr(new D9()) != uw || _9 && fr(new _9()) != hw) && (fr = function(e) {
  var t = YI(e), a = t == qz ? e.constructor : void 0, o = a ? Yr(a) : "";
  if (o)
    switch (o) {
      case Tz:
        return pw;
      case Dz:
        return dw;
      case _z:
        return sw;
      case Bz:
        return uw;
      case zz:
        return hw;
    }
  return t;
});
var Yx = fr, i9 = Vx, Hz = UI, jz = _B, Vz = pz, yw = Yx, kw = Lt, fw = Ox, Oz = nb, $z = 1, vw = "[object Arguments]", mw = "[object Array]", L1 = "[object Object]", Rz = Object.prototype, gw = Rz.hasOwnProperty;
function Fz(e, t, a, o, n, i) {
  var l = kw(e), c = kw(t), s = l ? mw : yw(e), h = c ? mw : yw(t);
  s = s == vw ? L1 : s, h = h == vw ? L1 : h;
  var m = s == L1, p = h == L1, f = s == h;
  if (f && fw(e)) {
    if (!fw(t))
      return !1;
    l = !0, m = !1;
  }
  if (f && !m)
    return i || (i = new i9()), l || Oz(e) ? Hz(e, t, a, o, n, i) : jz(e, t, s, a, o, n, i);
  if (!(a & $z)) {
    var g = m && gw.call(e, "__wrapped__"), w = p && gw.call(t, "__wrapped__");
    if (g || w) {
      var q = g ? e.value() : e, _ = w ? t.value() : t;
      return i || (i = new i9()), n(q, _, a, o, i);
    }
  }
  return f ? (i || (i = new i9()), Vz(e, t, a, o, n, i)) : !1;
}
var Uz = Fz, Ez = Uz, Mw = Xt;
function GI(e, t, a, o, n) {
  return e === t ? !0 : e == null || t == null || !Mw(e) && !Mw(t) ? e !== e && t !== t : Ez(e, t, a, o, GI, n);
}
var XI = GI, Wz = Vx, Nz = XI, Zz = 1, Yz = 2;
function Gz(e, t, a, o) {
  var n = a.length, i = n, l = !o;
  if (e == null)
    return !i;
  for (e = Object(e); n--; ) {
    var c = a[n];
    if (l && c[2] ? c[1] !== e[c[0]] : !(c[0] in e))
      return !1;
  }
  for (; ++n < i; ) {
    c = a[n];
    var s = c[0], h = e[s], m = c[1];
    if (l && c[2]) {
      if (h === void 0 && !(s in e))
        return !1;
    } else {
      var p = new Wz();
      if (o)
        var f = o(h, m, s, e, t, p);
      if (!(f === void 0 ? Nz(m, h, Zz | Yz, o, p) : f))
        return !1;
    }
  }
  return !0;
}
var Xz = Gz, Kz = Ft;
function Qz(e) {
  return e === e && !Kz(e);
}
var KI = Qz, Jz = KI, eH = f1;
function tH(e) {
  for (var t = eH(e), a = t.length; a--; ) {
    var o = t[a], n = e[o];
    t[a] = [o, n, Jz(n)];
  }
  return t;
}
var aH = tH;
function nH(e, t) {
  return function(a) {
    return a == null ? !1 : a[e] === t && (t !== void 0 || e in Object(a));
  };
}
var QI = nH, oH = Xz, rH = aH, iH = QI;
function lH(e) {
  var t = rH(e);
  return t.length == 1 && t[0][2] ? iH(t[0][0], t[0][1]) : function(a) {
    return a === e || oH(a, e, t);
  };
}
var cH = lH, dH = db;
function sH(e, t, a) {
  var o = e == null ? void 0 : dH(e, t);
  return o === void 0 ? a : o;
}
var uH = sH;
function hH(e, t) {
  return e != null && t in Object(e);
}
var pH = hH, yH = FI, kH = eb, fH = Lt, vH = ob, mH = tb, gH = Zx;
function MH(e, t, a) {
  t = yH(t, e);
  for (var o = -1, n = t.length, i = !1; ++o < n; ) {
    var l = gH(t[o]);
    if (!(i = e != null && a(e, l)))
      break;
    e = e[l];
  }
  return i || ++o != n ? i : (n = e == null ? 0 : e.length, !!n && mH(n) && vH(l, n) && (fH(e) || kH(e)));
}
var xH = MH, bH = pH, wH = xH;
function IH(e, t) {
  return e != null && wH(e, t, bH);
}
var LH = IH, SH = XI, CH = uH, AH = LH, PH = lb, qH = KI, TH = QI, DH = Zx, _H = 1, BH = 2;
function zH(e, t) {
  return PH(e) && qH(t) ? TH(DH(e), t) : function(a) {
    var o = CH(a, e);
    return o === void 0 && o === t ? AH(a, e) : SH(t, o, _H | BH);
  };
}
var HH = zH;
function jH(e) {
  return function(t) {
    return t == null ? void 0 : t[e];
  };
}
var VH = jH, OH = db;
function $H(e) {
  return function(t) {
    return OH(t, e);
  };
}
var RH = $H, FH = VH, UH = RH, EH = lb, WH = Zx;
function NH(e) {
  return EH(e) ? FH(WH(e)) : UH(e);
}
var ZH = NH, YH = cH, GH = HH, XH = Rx, KH = Lt, QH = ZH;
function JH(e) {
  return typeof e == "function" ? e : e == null ? XH : typeof e == "object" ? KH(e) ? GH(e[0], e[1]) : YH(e) : QH(e);
}
var ej = JH, tj = gI, aj = f1;
function nj(e, t) {
  return e && tj(e, t, aj);
}
var oj = nj, rj = Zr;
function ij(e, t) {
  return function(a, o) {
    if (a == null)
      return a;
    if (!rj(a))
      return e(a, o);
    for (var n = a.length, i = t ? n : -1, l = Object(a); (t ? i-- : ++i < n) && o(l[i], i, l) !== !1; )
      ;
    return a;
  };
}
var lj = ij, cj = oj, dj = lj, sj = dj(cj), uj = sj, hj = uj, pj = Zr;
function yj(e, t) {
  var a = -1, o = pj(e) ? Array(e.length) : [];
  return hj(e, function(n, i, l) {
    o[++a] = t(n, i, l);
  }), o;
}
var kj = yj;
function fj(e, t) {
  var a = e.length;
  for (e.sort(t); a--; )
    e[a] = e[a].value;
  return e;
}
var vj = fj, xw = Nx;
function mj(e, t) {
  if (e !== t) {
    var a = e !== void 0, o = e === null, n = e === e, i = xw(e), l = t !== void 0, c = t === null, s = t === t, h = xw(t);
    if (!c && !h && !i && e > t || i && l && s && !c && !h || o && l && s || !a && s || !n)
      return 1;
    if (!o && !i && !h && e < t || h && a && n && !o && !i || c && a && n || !l && n || !s)
      return -1;
  }
  return 0;
}
var gj = mj, Mj = gj;
function xj(e, t, a) {
  for (var o = -1, n = e.criteria, i = t.criteria, l = n.length, c = a.length; ++o < l; ) {
    var s = Mj(n[o], i[o]);
    if (s) {
      if (o >= c)
        return s;
      var h = a[o];
      return s * (h == "desc" ? -1 : 1);
    }
  }
  return e.index - t.index;
}
var bj = xj, l9 = OI, wj = db, Ij = ej, Lj = kj, Sj = vj, Cj = $x, Aj = bj, Pj = Rx, qj = Lt;
function Tj(e, t, a) {
  t.length ? t = l9(t, function(i) {
    return qj(i) ? function(l) {
      return wj(l, i.length === 1 ? i[0] : i);
    } : i;
  }) : t = [Pj];
  var o = -1;
  t = l9(t, Cj(Ij));
  var n = Lj(e, function(i, l, c) {
    var s = l9(t, function(h) {
      return h(i);
    });
    return { criteria: s, index: ++o, value: i };
  });
  return Sj(n, function(i, l) {
    return Aj(i, l, a);
  });
}
var Dj = Tj, _j = Dj, bw = Lt;
function Bj(e, t, a, o) {
  return e == null ? [] : (bw(t) || (t = t == null ? [] : [t]), a = o ? void 0 : a, bw(a) || (a = a == null ? [] : [a]), _j(e, t, a));
}
var zj = Bj;
const ub = /* @__PURE__ */ _x(zj);
function Hj(e, t) {
  for (var a = -1, o = e == null ? 0 : e.length; ++a < o && t(e[a], a, e) !== !1; )
    ;
  return e;
}
var jj = Hj, Vj = y1, Oj = f1;
function $j(e, t) {
  return e && Vj(t, Oj(t), e);
}
var Rj = $j, Fj = y1, Uj = k1;
function Ej(e, t) {
  return e && Fj(t, Uj(t), e);
}
var Wj = Ej, Nj = y1, Zj = sb;
function Yj(e, t) {
  return Nj(e, Zj(e), t);
}
var Gj = Yj, Xj = EI, Kj = Q9, Qj = sb, Jj = NI, eV = Object.getOwnPropertySymbols, tV = eV ? function(e) {
  for (var t = []; e; )
    Xj(t, Qj(e)), e = Kj(e);
  return t;
} : Jj, JI = tV, aV = y1, nV = JI;
function oV(e, t) {
  return aV(e, nV(e), t);
}
var rV = oV, iV = WI, lV = JI, cV = k1;
function dV(e) {
  return iV(e, cV, lV);
}
var sV = dV, uV = Object.prototype, hV = uV.hasOwnProperty;
function pV(e) {
  var t = e.length, a = new e.constructor(t);
  return t && typeof e[0] == "string" && hV.call(e, "index") && (a.index = e.index, a.input = e.input), a;
}
var yV = pV, kV = K9;
function fV(e, t) {
  var a = t ? kV(e.buffer) : e.buffer;
  return new e.constructor(a, e.byteOffset, e.byteLength);
}
var vV = fV, mV = /\w*$/;
function gV(e) {
  var t = new e.constructor(e.source, mV.exec(e));
  return t.lastIndex = e.lastIndex, t;
}
var MV = gV, ww = p1, Iw = ww ? ww.prototype : void 0, Lw = Iw ? Iw.valueOf : void 0;
function xV(e) {
  return Lw ? Object(Lw.call(e)) : {};
}
var bV = xV, wV = K9, IV = vV, LV = MV, SV = bV, CV = bI, AV = "[object Boolean]", PV = "[object Date]", qV = "[object Map]", TV = "[object Number]", DV = "[object RegExp]", _V = "[object Set]", BV = "[object String]", zV = "[object Symbol]", HV = "[object ArrayBuffer]", jV = "[object DataView]", VV = "[object Float32Array]", OV = "[object Float64Array]", $V = "[object Int8Array]", RV = "[object Int16Array]", FV = "[object Int32Array]", UV = "[object Uint8Array]", EV = "[object Uint8ClampedArray]", WV = "[object Uint16Array]", NV = "[object Uint32Array]";
function ZV(e, t, a) {
  var o = e.constructor;
  switch (t) {
    case HV:
      return wV(e);
    case AV:
    case PV:
      return new o(+e);
    case jV:
      return IV(e, a);
    case VV:
    case OV:
    case $V:
    case RV:
    case FV:
    case UV:
    case EV:
    case WV:
    case NV:
      return CV(e, a);
    case qV:
      return new o();
    case TV:
    case BV:
      return new o(e);
    case DV:
      return LV(e);
    case _V:
      return new o();
    case zV:
      return SV(e);
  }
}
var YV = ZV, GV = Yx, XV = Xt, KV = "[object Map]";
function QV(e) {
  return XV(e) && GV(e) == KV;
}
var JV = QV, eO = JV, tO = $x, Sw = ab, Cw = Sw && Sw.isMap, aO = Cw ? tO(Cw) : eO, nO = aO, oO = Yx, rO = Xt, iO = "[object Set]";
function lO(e) {
  return rO(e) && oO(e) == iO;
}
var cO = lO, dO = cO, sO = $x, Aw = ab, Pw = Aw && Aw.isSet, uO = Pw ? sO(Pw) : dO, hO = uO, pO = Vx, yO = jj, kO = PI, fO = Rj, vO = Wj, mO = MI, gO = wI, MO = Gj, xO = rV, bO = ZI, wO = sV, IO = Yx, LO = yV, SO = YV, CO = LI, AO = Lt, PO = Ox, qO = nO, TO = Ft, DO = hO, _O = f1, BO = k1, zO = 1, HO = 2, jO = 4, eL = "[object Arguments]", VO = "[object Array]", OO = "[object Boolean]", $O = "[object Date]", RO = "[object Error]", tL = "[object Function]", FO = "[object GeneratorFunction]", UO = "[object Map]", EO = "[object Number]", aL = "[object Object]", WO = "[object RegExp]", NO = "[object Set]", ZO = "[object String]", YO = "[object Symbol]", GO = "[object WeakMap]", XO = "[object ArrayBuffer]", KO = "[object DataView]", QO = "[object Float32Array]", JO = "[object Float64Array]", e$ = "[object Int8Array]", t$ = "[object Int16Array]", a$ = "[object Int32Array]", n$ = "[object Uint8Array]", o$ = "[object Uint8ClampedArray]", r$ = "[object Uint16Array]", i$ = "[object Uint32Array]", Ee = {};
Ee[eL] = Ee[VO] = Ee[XO] = Ee[KO] = Ee[OO] = Ee[$O] = Ee[QO] = Ee[JO] = Ee[e$] = Ee[t$] = Ee[a$] = Ee[UO] = Ee[EO] = Ee[aL] = Ee[WO] = Ee[NO] = Ee[ZO] = Ee[YO] = Ee[n$] = Ee[o$] = Ee[r$] = Ee[i$] = !0;
Ee[RO] = Ee[tL] = Ee[GO] = !1;
function vx(e, t, a, o, n, i) {
  var l, c = t & zO, s = t & HO, h = t & jO;
  if (a && (l = n ? a(e, o, n, i) : a(e)), l !== void 0)
    return l;
  if (!TO(e))
    return e;
  var m = AO(e);
  if (m) {
    if (l = LO(e), !c)
      return gO(e, l);
  } else {
    var p = IO(e), f = p == tL || p == FO;
    if (PO(e))
      return mO(e, c);
    if (p == aL || p == eL || f && !n) {
      if (l = s || f ? {} : CO(e), !c)
        return s ? xO(e, vO(l, e)) : MO(e, fO(l, e));
    } else {
      if (!Ee[p])
        return n ? e : {};
      l = SO(e, p, c);
    }
  }
  i || (i = new pO());
  var g = i.get(e);
  if (g)
    return g;
  i.set(e, l), DO(e) ? e.forEach(function(_) {
    l.add(vx(_, t, a, _, e, i));
  }) : qO(e) && e.forEach(function(_, b) {
    l.set(b, vx(_, t, a, b, e, i));
  });
  var w = h ? s ? wO : bO : s ? BO : _O, q = m ? void 0 : w(e);
  return yO(q || e, function(_, b) {
    q && (b = _, _ = e[b]), kO(l, b, vx(_, t, a, b, e, i));
  }), l;
}
var l$ = vx, c$ = l$, d$ = 1, s$ = 4;
function u$(e) {
  return c$(e, d$ | s$);
}
var h$ = u$;
const Ix = /* @__PURE__ */ _x(h$), p$ = {
  key: 0,
  class: "relative flex flex-col"
}, y$ = {
  key: 0,
  class: "mb-1 flex flex-row items-end justify-between"
}, k$ = ["onClick"], f$ = {
  key: 1,
  class: ""
}, v$ = { class: "mt-1 text-sm text-neutral-400" }, m$ = {
  key: 1,
  class: "flex flex-col"
}, g$ = { class: "mt-2 flex flex-row flex-wrap gap-2" }, M$ = ["onClick"], bG = {
  __name: "Chips",
  props: {
    globalConfig: {
      type: Object
    },
    pt: {
      type: Object
    },
    modelValue: {
      type: String
    },
    options: {
      type: Array,
      default: () => []
    },
    kind: {
      type: String,
      default: "choice"
      // choice | TODO: input | filter | action // TODO: inspo: https://m2.material.io/components/chips#action-chips
    },
    multi: {
      type: Boolean,
      // selecting mutliple chips (array)
      default: !1
    },
    disabled: {
      type: Boolean,
      default: !1
    },
    mode: {
      type: String,
      default: "edit"
    },
    label: {
      type: [String, Boolean],
      default: !1
    },
    placeholder: {
      type: [String, Boolean],
      default: !1
    },
    caption: {
      type: [String, Boolean],
      default: !1
    },
    size: {
      type: Number,
      default: 11
    },
    rounded: {
      type: String,
      default: "full"
    },
    context: {
      type: String,
      validator: function(e) {
        return ["dark", "neutral", "light"].indexOf(e) !== -1;
      }
    },
    filled: {
      type: Boolean,
      default: !1
    },
    collapsible: {
      type: Boolean,
      default: !1
    },
    layout: {
      type: String,
      default: "vertical"
      // horizontal, vertical, grid
    },
    fullWidth: {
      type: Boolean,
      default: !1
    },
    filter: {
      type: Boolean,
      default: !1
    },
    sort: {
      type: Boolean,
      default: !1
    },
    variantSelected: {
      type: String,
      default: "primary"
    },
    variantUnselected: {
      type: String,
      default: "secondary"
    }
  },
  emits: ["update:modelValue"],
  setup(e, { emit: t }) {
    const a = e, o = t, { ep: n } = Te({ props: a, locals: {}, defaults: $D }), i = W(""), l = W(!1);
    N(() => {
      const f = a.options.find((g) => g.value === a.modelValue);
      return f ? f.label : "";
    });
    const c = N(() => a.sort ? ub(a.options, [(f) => f.label.toLowerCase()], ["asc"]) : a.options), s = N(() => {
      if (!i.value)
        return c.value;
      const f = i.value.toLowerCase().trim();
      return c.value.filter((g) => {
        const w = g.label.toLowerCase().trim(), q = g.sublabel ? g.sublabel.toLowerCase().trim() : "", _ = g.value.toLowerCase().trim();
        return w.includes(f) || q.includes(f) || _.includes(f);
      });
    }), h = N(() => s.value.filter((f) => {
      var g;
      return (g = a.modelValue) == null ? void 0 : g.includes(f.value);
    }));
    function m(f) {
      if (a.disabled)
        return;
      l.value = !1;
      let g = Ix(i1(a.modelValue));
      a.multi ? (g = g || [], g.includes(f.value) ? g.splice(g.indexOf(f.value), 1) : g.push(f.value)) : g === f.value ? g = null : g = f.value, o("update:modelValue", g);
    }
    function p(f) {
      var g;
      return a.multi ? (g = a.modelValue) == null ? void 0 : g.includes(f.value) : a.modelValue === f.value;
    }
    return (f, g) => (d(), y("div", P(X(u(n).root)), [
      a.mode == "edit" ? (d(), y("div", p$, [
        a.label ? (d(), y("div", y$, [
          a.label ? (d(), y("span", P(H({ key: 0 }, u(n).labelOuter)), G(a.label), 17)) : v("", !0)
        ])) : v("", !0),
        D("div", {
          class: "flex w-full flex-row flex-wrap gap-2",
          onClick: g[0] || (g[0] = (w) => l.value = !l.value)
        }, [
          (d(!0), y(ge, null, Ie(s.value, (w) => (d(), y("div", {
            class: "",
            key: w.value,
            onClick: (q) => m(w)
          }, [
            be(bx, {
              label: w.label,
              variant: p(w) ? e.variantSelected : e.variantUnselected,
              size: e.size,
              clickable: ""
            }, null, 8, ["label", "variant", "size"])
          ], 8, k$))), 128))
        ]),
        e.caption || f.$slots.caption ? (d(), y("div", f$, [
          ee(f.$slots, "caption", {}, () => [
            D("p", v$, G(e.caption), 1)
          ])
        ])) : v("", !0)
      ])) : v("", !0),
      a.mode == "view" ? (d(), y("div", m$, [
        a.label ? (d(), y("span", P(H({ key: 0 }, u(n).inputLabel)), G(a.label), 17)) : v("", !0),
        D("div", g$, [
          (d(!0), y(ge, null, Ie(h.value, (w) => (d(), y("div", {
            class: "",
            key: w.value,
            onClick: (q) => m(w)
          }, [
            be(bx, {
              label: w.label,
              variant: "secondary",
              size: e.size,
              clickable: ""
            }, null, 8, ["label", "size"])
          ], 8, M$))), 128))
        ])
      ])) : v("", !0)
    ], 16));
  }
}, x$ = { class: "" }, b$ = { class: "mb-1 flex w-full flex-row justify-between" }, w$ = {
  key: 0,
  class: "mb-1 block text-base font-bold text-neutral-700 dark:text-neutral-600"
}, I$ = {
  key: 1,
  class: "mb-1"
}, wG = {
  __name: "InputMulti",
  props: {
    modelValue: {
      type: Object
    },
    langs: {
      type: Array
    },
    placeholders: {
      type: Array,
      default: () => []
    },
    label: {
      type: [String, Boolean],
      default: !1
    },
    long: {
      type: Boolean,
      default: !1
    },
    fullWidth: {
      type: Boolean,
      default: !1
    }
  },
  emits: [
    "update:modelValue",
    "keyup",
    "enter",
    "focus",
    "blur",
    "input-debounced",
    "mouseup"
  ],
  setup(e, { emit: t }) {
    const a = e, o = t;
    function n(c) {
      return c === 0 ? "first" : c === a.langs.length - 1 ? "last" : "middle";
    }
    function i(c, s) {
      const h = Ix(i1(a.modelValue));
      h[s] = c, o("update:modelValue", h);
    }
    function l(c, s) {
      console.log("onInputDebounced", c, s);
      const h = Ix(i1(a.modelValue));
      h[s] = c, console.log("emitting input debouced multi:", h), o("input-debounced", h);
    }
    return (c, s) => (d(), y("div", x$, [
      D("div", b$, [
        e.label ? (d(), y("span", w$, G(e.label), 1)) : v("", !0),
        c.$slots.buttonOuterTop ? (d(), y("div", I$, [
          ee(c.$slots, "buttonOuterTop", {}, () => [
            be(bt, {
              variant: "form",
              size: 5,
              rounded: "full"
            })
          ])
        ])) : v("", !0)
      ]),
      (d(!0), y(ge, null, Ie(e.langs, (h, m) => (d(), y("div", {
        class: "",
        key: h
      }, [
        be(Wx, {
          modelValue: e.modelValue[h],
          placeholder: e.placeholders[m],
          "multi-position": n(m),
          "label-lang": h,
          long: e.long,
          fullWidth: e.fullWidth,
          "onUpdate:modelValue": (p) => i(p, h),
          onKeyup: (p) => o("keyup", p, h),
          onEnter: (p) => o("enter", p, h),
          onFocus: (p) => o("focus", p, h),
          onBlur: (p) => o("blur", p, h),
          onInputDebounced: (p) => l(p, h),
          onMouseup: (p) => o("mouseup", p, h)
        }, null, 8, ["modelValue", "placeholder", "multi-position", "label-lang", "long", "fullWidth", "onUpdate:modelValue", "onKeyup", "onEnter", "onFocus", "onBlur", "onInputDebounced", "onMouseup"])
      ]))), 128))
    ]));
  }
}, L$ = {
  composer: {
    props: {
      name: {
        default: !1,
        control: "input"
      },
      lucide: {
        default: "Loader2",
        control: "input"
      },
      lucideSize: {
        default: 24,
        control: "input"
      },
      lucideColor: {
        default: "currentColor",
        control: "input"
      },
      lucideStrokeWidth: {
        default: 2,
        control: "input"
      },
      lucideAbsoluteStrokeWidth: {
        default: !1,
        control: "switch"
      },
      lucideDefaultClass: {
        default: "lucide-icon",
        control: "input"
      },
      spin: {
        default: !0,
        control: "switch"
      }
    }
  },
  pt: {
    root: {
      propsStateBased: {
        spin: {
          true: "animate-spin",
          false: ""
        }
      }
    }
  }
}, S$ = ["srcset", "type", "media"], C$ = ["src"], IG = /* @__PURE__ */ Object.assign({
  inheritAttrs: !1
  // prevents from applying classes to <picture>
}, {
  __name: "ImageCDN",
  props: {
    urlPrefix: {
      type: [Boolean, String],
      default: !1
    },
    image: {
      type: Object
      // imageId, contentType
    },
    // breakpoint overrides = max image width at widest state of given breakpoint
    // - "auto" - use tailwind breakpoints
    // - "def:400|sm:500|md:600" -> image will be nearest larger of 400px wide on default breakpoint, 500px on sm, 600px on md. lg+ stays default
    // - "lg:1080|xl:1080" -> image will never be wider than 1080px, regardless of screen size. Useful for images that are not full-width.
    breakpoints: {
      type: String
    }
  },
  emits: ["click"],
  setup(e, { emit: t }) {
    const a = e, o = t;
    Te({ props: a, defaults: L$ });
    const n = {
      // breakpoints: [240, 320, 480, 640, 720, 1080, 1280, 1440, 1920, 2560],
      breakpoints: [320, 900, 1300, 1800, 2500],
      devicePixelRatios: [1, 2, 3],
      imageTypes: [
        { mime: "image/webp", extension: "webp" },
        { mime: "image/jpeg", extension: "jpg" }
      ]
    }, i = [
      // {name: "xl", bpWidth: 1200, imgWidth: 2560},
      // {name: "lg", bpWidth: 992, imgWidth: 1280},
      // {name: "md", bpWidth: 768, imgWidth: 1080},
      // {name: "sm", bpWidth: 576, imgWidth: 1080},
      // {name: "xs", bpWidth: 375, imgWidth: 640},
      // {name: "def", bpWidth: 0, imgWidth: 480},
      { name: "xl", bpWidth: 1200, imgWidth: 2500 },
      { name: "lg", bpWidth: 992, imgWidth: 1800 },
      { name: "md", bpWidth: 768, imgWidth: 1300 },
      { name: "sm", bpWidth: 576, imgWidth: 900 },
      { name: "xs", bpWidth: 375, imgWidth: 900 },
      { name: "def", bpWidth: 0, imgWidth: 320 }
    ], l = {}.VITE_ENVIRONMENT === "local_dev" && {}.VITE_USE_EMULATOR === "false" ? {}.VITE_URL_CDN_PRODUCTION : {}.VITE_URL_CDN, c = N9("FRAMEWORK_ONE_URL_CDN_IMAGES");
    let s = null;
    a.urlPrefix ? s = a.urlPrefix : c != null && c.value ? s = c.value : s = `${l}/images`;
    const m = KL().class, p = W(null), f = N(() => {
      if (!a.breakpoints || a.breakpoints == "auto")
        return {};
      const w = a.breakpoints.split("|"), q = {};
      return w.forEach((_) => {
        const [b, L] = _.split(":");
        q[b] = parseInt(L);
      }), q;
    }), g = N(() => {
      if (!i)
        return [];
      const w = [];
      return i.forEach((q) => {
        const _ = q.name;
        let b = q.imgWidth;
        const L = f.value[q.name];
        L && (b = n.breakpoints.find((j) => j >= L)), n.imageTypes.forEach((j) => {
          const I = _ == "def" ? 0 : q.bpWidth, C = {
            type: j.mime,
            media: `(min-width: ${I}px)`
          };
          let B = [];
          n.devicePixelRatios.forEach((U) => {
            j.extension;
            const de = a.image.contentType === "image/png" ? "c_9" : "q_80", ae = `${s}/${a.image.imageId}$w_${b},${de},x_${U}`;
            B.push(`${ae} ${U}x`), j.mime == "image/jpeg" && U == 1 && !p.value && (p.value = ae);
          }), C.srcset = B.join(", "), w.push(C);
        });
      }), w;
    });
    return (w, q) => (d(), y("picture", {
      onClick: q[0] || (q[0] = (_) => o("click"))
    }, [
      (d(!0), y(ge, null, Ie(g.value, (_, b) => (d(), y("source", {
        key: b,
        srcset: _.srcset,
        type: _.type,
        media: _.media
      }, null, 8, S$))), 128)),
      D("img", {
        class: Pe(u(m)),
        src: p.value,
        type: "image/jpeg"
      }, null, 10, C$)
    ]));
  }
}), A$ = {
  composer: {
    props: {
      label: {
        default: "label",
        control: "input"
      },
      caption: {
        default: "caption with additional information",
        control: "input"
      },
      placeholder: {
        default: "placeholder",
        control: "input"
      },
      prefix: {
        default: !1,
        //"https://",
        control: "input"
      },
      suffix: {
        default: !1,
        //"CZK",
        control: "input"
      },
      status: {
        default: !1,
        //"error",
        control: "select",
        options: [!1, "success", "error", "progress"]
      },
      size: {
        default: 11,
        control: "select",
        options: [14, 12, 11, 10, 9, 8]
      },
      statusMessage: {
        default: "status message",
        control: "input"
      },
      disabled: {
        default: !1,
        control: "switch"
      },
      fullWidth: {
        default: !1,
        options: [!1, !0],
        control: "switch"
      }
    }
  },
  pt: {
    container: {
      _common: "border flex flex-row overflow-hidden",
      propsStateBased: {
        fullWidth: {
          true: "w-full"
        },
        size: {
          14: "h-14 rounded-xl",
          12: "h-12 rounded-xl",
          11: "h-11 rounded-xl",
          // default
          10: "h-10 rounded-lg",
          9: "h-9 rounded-lg",
          8: "h-8 rounded-lg"
        },
        focused: {
          true: {
            _common: "shadow-[0px_0px_0px_1px]",
            status: {
              false: "border-neutral-400 shadow-neutral-400",
              success: "border-neutral-400 shadow-neutral-400",
              error: "border-critical-500 shadow-critical-500",
              progress: "border-neutral-400 shadow-neutral-400"
            }
          },
          false: {
            status: {
              false: "border-neutral-300 dark:border-neutral-700",
              success: "border-neutral-300 dark:border-neutral-700",
              error: "border-critical-500",
              progress: "border-neutral-300 dark:border-neutral-700"
            }
          }
        },
        disabled: {
          true: "bg-neutral-100 dark:bg-neutral-800"
        },
        multiPosition: {
          first: "rounded-b-none",
          middle: "!rounded-none -my-px",
          last: "rounded-t-none"
        }
      }
    },
    labelOuter: {
      _common: "inline-block text-lg pb-2 font-bold text-neutral-600 dark:text-neutral-200 font-element"
    },
    labelInner: {
      // _common: "absolute left-1.5 text-neutral-600 dark:text-neutral-200",
      _common: "left-1.5 text-neutral-600 dark:text-neutral-200 text-sm font-bold pt-0.5",
      propsStateBased: {
        // focused: {
        //   true: "top-1",
        //   false: "top-5",
        // },
      }
    },
    labelLang: {
      _common: "text-sm font-normal text-neutral-600 dark:text-neutral-700 font-element absolute right-0.5 top-0.5"
    },
    inputFieldWithPlaceholder: {
      _common: "relative h-full min-w-[10rem]"
    },
    placeholder: {
      _common: "flex flex-row items-center justify-start absolute inset-0 font-normal text-neutral-300 dark:text-neutral-700 pointer-events-none font-element",
      propsStateBased: {
        focused: {
          // true: "top-1",
          // false: "top-5",
        }
      }
    },
    inputField: {
      _common: "flex flex-row items-center justify-start absolute inset-0  text-neutral-900 dark:text-neutral-100",
      propsStateBased: {
        mode: {
          edit: "",
          view: "whitespace-pre-wrap"
        }
      }
    },
    innerElementsLeft: {
      _common: "flex flex-row",
      propsStateBased: {
        size: {
          14: "ml-1.5 gap-1.5 py-1.5",
          12: "ml-1.5 gap-1.5 py-1.5",
          11: "ml-1.5 gap-1.5 py-1.5",
          10: "ml-1 gap-1 py-1",
          9: "ml-1 gap-1 py-1",
          8: "ml-1 gap-1 py-1"
        }
      }
    },
    innerElementsRight: {
      _common: "flex flex-row",
      propsStateBased: {
        size: {
          14: "mr-1.5 gap-1.5 py-1.5",
          12: "mr-1.5 gap-1.5 py-1.5",
          11: "mr-1.5 gap-1.5 py-1.5",
          10: "mr-1 gap-1 py-1",
          9: "mr-1 gap-1 py-1",
          8: "mr-1 gap-1 py-1"
        }
      }
    },
    statusIndicator: {
      _common: "flex bg-opacity-10 px-1.5 flex-center",
      propsStateBased: {
        status: {
          success: "bg-success-600",
          error: "bg-critical-600",
          progress: "bg-neutral-600"
        },
        size: {
          14: "rounded-md",
          12: "rounded-md",
          11: "rounded-md",
          10: "rounded",
          9: "rounded",
          8: "rounded"
        }
      }
    },
    statusIndicatorIcon: {
      propsStateBased: {
        status: {
          success: {
            lucide: "Check",
            lucideStrokeWidth: 4,
            class: "w-4 text-success-700"
          },
          error: {
            lucide: "X",
            lucideStrokeWidth: 4,
            class: "w-4 text-critical-700"
          },
          progress: {
            lucide: "Loader2",
            lucideStrokeWidth: 4,
            spin: !0,
            class: "w-4 text-neutral-500"
          }
        }
      }
    },
    statusMessage: {
      _common: "font-normal text-sm text-neutral-600 font-element"
    },
    prefixContainer: {
      _common: "flex h-full bg-neutral-100 dark:bg-neutral-800 px-3 flex-center"
    },
    prefixText: {
      _common: "font-semibold text-neutral-400"
    },
    suffixContainer: {
      _common: "flex h-full bg-neutral-100 dark:bg-neutral-800 px-3 flex-center"
    },
    suffixText: {
      _common: "font-semibold text-neutral-400 dark:text-neutral-400"
    }
  }
};
function It(e) {
  "@babel/helpers - typeof";
  return It = typeof Symbol == "function" && typeof Symbol.iterator == "symbol" ? function(t) {
    return typeof t;
  } : function(t) {
    return t && typeof Symbol == "function" && t.constructor === Symbol && t !== Symbol.prototype ? "symbol" : typeof t;
  }, It(e);
}
function we(e) {
  if (e === null || e === !0 || e === !1)
    return NaN;
  var t = Number(e);
  return isNaN(t) ? t : t < 0 ? Math.ceil(t) : Math.floor(t);
}
function ve(e, t) {
  if (t.length < e)
    throw new TypeError(e + " argument" + (e > 1 ? "s" : "") + " required, but only " + t.length + " present");
}
function xe(e) {
  ve(1, arguments);
  var t = Object.prototype.toString.call(e);
  return e instanceof Date || It(e) === "object" && t === "[object Date]" ? new Date(e.getTime()) : typeof e == "number" || t === "[object Number]" ? new Date(e) : ((typeof e == "string" || t === "[object String]") && typeof console < "u" && (console.warn("Starting with v2.0.0-beta.1 date-fns doesn't accept strings as date arguments. Please use `parseISO` to parse strings. See: https://github.com/date-fns/date-fns/blob/master/docs/upgradeGuide.md#string-arguments"), console.warn(new Error().stack)), /* @__PURE__ */ new Date(NaN));
}
function Wt(e, t) {
  ve(2, arguments);
  var a = xe(e), o = we(t);
  return isNaN(o) ? /* @__PURE__ */ new Date(NaN) : (o && a.setDate(a.getDate() + o), a);
}
function Pt(e, t) {
  ve(2, arguments);
  var a = xe(e), o = we(t);
  if (isNaN(o))
    return /* @__PURE__ */ new Date(NaN);
  if (!o)
    return a;
  var n = a.getDate(), i = new Date(a.getTime());
  i.setMonth(a.getMonth() + o + 1, 0);
  var l = i.getDate();
  return n >= l ? i : (a.setFullYear(i.getFullYear(), i.getMonth(), n), a);
}
function nL(e, t) {
  if (ve(2, arguments), !t || It(t) !== "object")
    return /* @__PURE__ */ new Date(NaN);
  var a = t.years ? we(t.years) : 0, o = t.months ? we(t.months) : 0, n = t.weeks ? we(t.weeks) : 0, i = t.days ? we(t.days) : 0, l = t.hours ? we(t.hours) : 0, c = t.minutes ? we(t.minutes) : 0, s = t.seconds ? we(t.seconds) : 0, h = xe(e), m = o || a ? Pt(h, o + a * 12) : h, p = i || n ? Wt(m, i + n * 7) : m, f = c + l * 60, g = s + f * 60, w = g * 1e3, q = new Date(p.getTime() + w);
  return q;
}
function P$(e, t) {
  ve(2, arguments);
  var a = xe(e).getTime(), o = we(t);
  return new Date(a + o);
}
var q$ = {};
function Ut() {
  return q$;
}
function br(e, t) {
  var a, o, n, i, l, c, s, h;
  ve(1, arguments);
  var m = Ut(), p = we((a = (o = (n = (i = t == null ? void 0 : t.weekStartsOn) !== null && i !== void 0 ? i : t == null || (l = t.locale) === null || l === void 0 || (c = l.options) === null || c === void 0 ? void 0 : c.weekStartsOn) !== null && n !== void 0 ? n : m.weekStartsOn) !== null && o !== void 0 ? o : (s = m.locale) === null || s === void 0 || (h = s.options) === null || h === void 0 ? void 0 : h.weekStartsOn) !== null && a !== void 0 ? a : 0);
  if (!(p >= 0 && p <= 6))
    throw new RangeError("weekStartsOn must be between 0 and 6 inclusively");
  var f = xe(e), g = f.getDay(), w = (g < p ? 7 : 0) + g - p;
  return f.setDate(f.getDate() - w), f.setHours(0, 0, 0, 0), f;
}
function Lx(e) {
  return ve(1, arguments), br(e, {
    weekStartsOn: 1
  });
}
function T$(e) {
  ve(1, arguments);
  var t = xe(e), a = t.getFullYear(), o = /* @__PURE__ */ new Date(0);
  o.setFullYear(a + 1, 0, 4), o.setHours(0, 0, 0, 0);
  var n = Lx(o), i = /* @__PURE__ */ new Date(0);
  i.setFullYear(a, 0, 4), i.setHours(0, 0, 0, 0);
  var l = Lx(i);
  return t.getTime() >= n.getTime() ? a + 1 : t.getTime() >= l.getTime() ? a : a - 1;
}
function D$(e) {
  ve(1, arguments);
  var t = T$(e), a = /* @__PURE__ */ new Date(0);
  a.setFullYear(t, 0, 4), a.setHours(0, 0, 0, 0);
  var o = Lx(a);
  return o;
}
function Sx(e) {
  var t = new Date(Date.UTC(e.getFullYear(), e.getMonth(), e.getDate(), e.getHours(), e.getMinutes(), e.getSeconds(), e.getMilliseconds()));
  return t.setUTCFullYear(e.getFullYear()), e.getTime() - t.getTime();
}
function qw(e) {
  ve(1, arguments);
  var t = xe(e);
  return t.setHours(0, 0, 0, 0), t;
}
var _$ = 864e5;
function B$(e, t) {
  ve(2, arguments);
  var a = qw(e), o = qw(t), n = a.getTime() - Sx(a), i = o.getTime() - Sx(o);
  return Math.round((n - i) / _$);
}
function z$(e, t) {
  ve(2, arguments);
  var a = we(t), o = a * 3;
  return Pt(e, o);
}
function hb(e, t) {
  ve(2, arguments);
  var a = we(t);
  return Pt(e, a * 12);
}
var pb = 6e4, yb = 36e5, H$ = 1e3;
function oL(e) {
  return ve(1, arguments), e instanceof Date || It(e) === "object" && Object.prototype.toString.call(e) === "[object Date]";
}
function o1(e) {
  if (ve(1, arguments), !oL(e) && typeof e != "number")
    return !1;
  var t = xe(e);
  return !isNaN(Number(t));
}
function Tw(e) {
  ve(1, arguments);
  var t = xe(e), a = Math.floor(t.getMonth() / 3) + 1;
  return a;
}
function rL(e, t) {
  var a;
  ve(1, arguments);
  var o = e || {}, n = xe(o.start), i = xe(o.end), l = i.getTime();
  if (!(n.getTime() <= l))
    throw new RangeError("Invalid interval");
  var c = [], s = n;
  s.setHours(0, 0, 0, 0);
  var h = Number((a = t == null ? void 0 : t.step) !== null && a !== void 0 ? a : 1);
  if (h < 1 || isNaN(h))
    throw new RangeError("`options.step` must be a number greater than 1");
  for (; s.getTime() <= l; )
    c.push(xe(s)), s.setDate(s.getDate() + h), s.setHours(0, 0, 0, 0);
  return c;
}
function l1(e) {
  ve(1, arguments);
  var t = xe(e), a = t.getMonth(), o = a - a % 3;
  return t.setMonth(o, 1), t.setHours(0, 0, 0, 0), t;
}
function j$(e) {
  ve(1, arguments);
  var t = e || {}, a = xe(t.start), o = xe(t.end), n = o.getTime();
  if (!(a.getTime() <= n))
    throw new RangeError("Invalid interval");
  var i = l1(a), l = l1(o);
  n = l.getTime();
  for (var c = [], s = i; s.getTime() <= n; )
    c.push(xe(s)), s = z$(s, 1);
  return c;
}
function V$(e) {
  ve(1, arguments);
  var t = xe(e), a = t.getFullYear();
  return t.setFullYear(a + 1, 0, 0), t.setHours(23, 59, 59, 999), t;
}
function O$(e) {
  ve(1, arguments);
  var t = xe(e), a = /* @__PURE__ */ new Date(0);
  return a.setFullYear(t.getFullYear(), 0, 1), a.setHours(0, 0, 0, 0), a;
}
function $$(e, t) {
  var a, o, n, i, l, c, s, h;
  ve(1, arguments);
  var m = Ut(), p = we((a = (o = (n = (i = t == null ? void 0 : t.weekStartsOn) !== null && i !== void 0 ? i : t == null || (l = t.locale) === null || l === void 0 || (c = l.options) === null || c === void 0 ? void 0 : c.weekStartsOn) !== null && n !== void 0 ? n : m.weekStartsOn) !== null && o !== void 0 ? o : (s = m.locale) === null || s === void 0 || (h = s.options) === null || h === void 0 ? void 0 : h.weekStartsOn) !== null && a !== void 0 ? a : 0);
  if (!(p >= 0 && p <= 6))
    throw new RangeError("weekStartsOn must be between 0 and 6 inclusively");
  var f = xe(e), g = f.getDay(), w = (g < p ? -7 : 0) + 6 - (g - p);
  return f.setDate(f.getDate() + w), f.setHours(23, 59, 59, 999), f;
}
function Dw(e) {
  ve(1, arguments);
  var t = xe(e), a = t.getMonth(), o = a - a % 3 + 3;
  return t.setMonth(o, 0), t.setHours(23, 59, 59, 999), t;
}
function iL(e, t) {
  ve(2, arguments);
  var a = we(t);
  return P$(e, -a);
}
var R$ = 864e5;
function F$(e) {
  ve(1, arguments);
  var t = xe(e), a = t.getTime();
  t.setUTCMonth(0, 1), t.setUTCHours(0, 0, 0, 0);
  var o = t.getTime(), n = a - o;
  return Math.floor(n / R$) + 1;
}
function zr(e) {
  ve(1, arguments);
  var t = 1, a = xe(e), o = a.getUTCDay(), n = (o < t ? 7 : 0) + o - t;
  return a.setUTCDate(a.getUTCDate() - n), a.setUTCHours(0, 0, 0, 0), a;
}
function lL(e) {
  ve(1, arguments);
  var t = xe(e), a = t.getUTCFullYear(), o = /* @__PURE__ */ new Date(0);
  o.setUTCFullYear(a + 1, 0, 4), o.setUTCHours(0, 0, 0, 0);
  var n = zr(o), i = /* @__PURE__ */ new Date(0);
  i.setUTCFullYear(a, 0, 4), i.setUTCHours(0, 0, 0, 0);
  var l = zr(i);
  return t.getTime() >= n.getTime() ? a + 1 : t.getTime() >= l.getTime() ? a : a - 1;
}
function U$(e) {
  ve(1, arguments);
  var t = lL(e), a = /* @__PURE__ */ new Date(0);
  a.setUTCFullYear(t, 0, 4), a.setUTCHours(0, 0, 0, 0);
  var o = zr(a);
  return o;
}
var E$ = 6048e5;
function cL(e) {
  ve(1, arguments);
  var t = xe(e), a = zr(t).getTime() - U$(t).getTime();
  return Math.round(a / E$) + 1;
}
function wr(e, t) {
  var a, o, n, i, l, c, s, h;
  ve(1, arguments);
  var m = Ut(), p = we((a = (o = (n = (i = t == null ? void 0 : t.weekStartsOn) !== null && i !== void 0 ? i : t == null || (l = t.locale) === null || l === void 0 || (c = l.options) === null || c === void 0 ? void 0 : c.weekStartsOn) !== null && n !== void 0 ? n : m.weekStartsOn) !== null && o !== void 0 ? o : (s = m.locale) === null || s === void 0 || (h = s.options) === null || h === void 0 ? void 0 : h.weekStartsOn) !== null && a !== void 0 ? a : 0);
  if (!(p >= 0 && p <= 6))
    throw new RangeError("weekStartsOn must be between 0 and 6 inclusively");
  var f = xe(e), g = f.getUTCDay(), w = (g < p ? 7 : 0) + g - p;
  return f.setUTCDate(f.getUTCDate() - w), f.setUTCHours(0, 0, 0, 0), f;
}
function kb(e, t) {
  var a, o, n, i, l, c, s, h;
  ve(1, arguments);
  var m = xe(e), p = m.getUTCFullYear(), f = Ut(), g = we((a = (o = (n = (i = t == null ? void 0 : t.firstWeekContainsDate) !== null && i !== void 0 ? i : t == null || (l = t.locale) === null || l === void 0 || (c = l.options) === null || c === void 0 ? void 0 : c.firstWeekContainsDate) !== null && n !== void 0 ? n : f.firstWeekContainsDate) !== null && o !== void 0 ? o : (s = f.locale) === null || s === void 0 || (h = s.options) === null || h === void 0 ? void 0 : h.firstWeekContainsDate) !== null && a !== void 0 ? a : 1);
  if (!(g >= 1 && g <= 7))
    throw new RangeError("firstWeekContainsDate must be between 1 and 7 inclusively");
  var w = /* @__PURE__ */ new Date(0);
  w.setUTCFullYear(p + 1, 0, g), w.setUTCHours(0, 0, 0, 0);
  var q = wr(w, t), _ = /* @__PURE__ */ new Date(0);
  _.setUTCFullYear(p, 0, g), _.setUTCHours(0, 0, 0, 0);
  var b = wr(_, t);
  return m.getTime() >= q.getTime() ? p + 1 : m.getTime() >= b.getTime() ? p : p - 1;
}
function W$(e, t) {
  var a, o, n, i, l, c, s, h;
  ve(1, arguments);
  var m = Ut(), p = we((a = (o = (n = (i = t == null ? void 0 : t.firstWeekContainsDate) !== null && i !== void 0 ? i : t == null || (l = t.locale) === null || l === void 0 || (c = l.options) === null || c === void 0 ? void 0 : c.firstWeekContainsDate) !== null && n !== void 0 ? n : m.firstWeekContainsDate) !== null && o !== void 0 ? o : (s = m.locale) === null || s === void 0 || (h = s.options) === null || h === void 0 ? void 0 : h.firstWeekContainsDate) !== null && a !== void 0 ? a : 1), f = kb(e, t), g = /* @__PURE__ */ new Date(0);
  g.setUTCFullYear(f, 0, p), g.setUTCHours(0, 0, 0, 0);
  var w = wr(g, t);
  return w;
}
var N$ = 6048e5;
function dL(e, t) {
  ve(1, arguments);
  var a = xe(e), o = wr(a, t).getTime() - W$(a, t).getTime();
  return Math.round(o / N$) + 1;
}
function Re(e, t) {
  for (var a = e < 0 ? "-" : "", o = Math.abs(e).toString(); o.length < t; )
    o = "0" + o;
  return a + o;
}
var Z$ = {
  // Year
  y: function(t, a) {
    var o = t.getUTCFullYear(), n = o > 0 ? o : 1 - o;
    return Re(a === "yy" ? n % 100 : n, a.length);
  },
  // Month
  M: function(t, a) {
    var o = t.getUTCMonth();
    return a === "M" ? String(o + 1) : Re(o + 1, 2);
  },
  // Day of the month
  d: function(t, a) {
    return Re(t.getUTCDate(), a.length);
  },
  // AM or PM
  a: function(t, a) {
    var o = t.getUTCHours() / 12 >= 1 ? "pm" : "am";
    switch (a) {
      case "a":
      case "aa":
        return o.toUpperCase();
      case "aaa":
        return o;
      case "aaaaa":
        return o[0];
      case "aaaa":
      default:
        return o === "am" ? "a.m." : "p.m.";
    }
  },
  // Hour [1-12]
  h: function(t, a) {
    return Re(t.getUTCHours() % 12 || 12, a.length);
  },
  // Hour [0-23]
  H: function(t, a) {
    return Re(t.getUTCHours(), a.length);
  },
  // Minute
  m: function(t, a) {
    return Re(t.getUTCMinutes(), a.length);
  },
  // Second
  s: function(t, a) {
    return Re(t.getUTCSeconds(), a.length);
  },
  // Fraction of second
  S: function(t, a) {
    var o = a.length, n = t.getUTCMilliseconds(), i = Math.floor(n * Math.pow(10, o - 3));
    return Re(i, a.length);
  }
};
const Jt = Z$;
var Tr = {
  am: "am",
  pm: "pm",
  midnight: "midnight",
  noon: "noon",
  morning: "morning",
  afternoon: "afternoon",
  evening: "evening",
  night: "night"
}, Y$ = {
  // Era
  G: function(t, a, o) {
    var n = t.getUTCFullYear() > 0 ? 1 : 0;
    switch (a) {
      case "G":
      case "GG":
      case "GGG":
        return o.era(n, {
          width: "abbreviated"
        });
      case "GGGGG":
        return o.era(n, {
          width: "narrow"
        });
      case "GGGG":
      default:
        return o.era(n, {
          width: "wide"
        });
    }
  },
  // Year
  y: function(t, a, o) {
    if (a === "yo") {
      var n = t.getUTCFullYear(), i = n > 0 ? n : 1 - n;
      return o.ordinalNumber(i, {
        unit: "year"
      });
    }
    return Jt.y(t, a);
  },
  // Local week-numbering year
  Y: function(t, a, o, n) {
    var i = kb(t, n), l = i > 0 ? i : 1 - i;
    if (a === "YY") {
      var c = l % 100;
      return Re(c, 2);
    }
    return a === "Yo" ? o.ordinalNumber(l, {
      unit: "year"
    }) : Re(l, a.length);
  },
  // ISO week-numbering year
  R: function(t, a) {
    var o = lL(t);
    return Re(o, a.length);
  },
  // Extended year. This is a single number designating the year of this calendar system.
  // The main difference between `y` and `u` localizers are B.C. years:
  // | Year | `y` | `u` |
  // |------|-----|-----|
  // | AC 1 |   1 |   1 |
  // | BC 1 |   1 |   0 |
  // | BC 2 |   2 |  -1 |
  // Also `yy` always returns the last two digits of a year,
  // while `uu` pads single digit years to 2 characters and returns other years unchanged.
  u: function(t, a) {
    var o = t.getUTCFullYear();
    return Re(o, a.length);
  },
  // Quarter
  Q: function(t, a, o) {
    var n = Math.ceil((t.getUTCMonth() + 1) / 3);
    switch (a) {
      case "Q":
        return String(n);
      case "QQ":
        return Re(n, 2);
      case "Qo":
        return o.ordinalNumber(n, {
          unit: "quarter"
        });
      case "QQQ":
        return o.quarter(n, {
          width: "abbreviated",
          context: "formatting"
        });
      case "QQQQQ":
        return o.quarter(n, {
          width: "narrow",
          context: "formatting"
        });
      case "QQQQ":
      default:
        return o.quarter(n, {
          width: "wide",
          context: "formatting"
        });
    }
  },
  // Stand-alone quarter
  q: function(t, a, o) {
    var n = Math.ceil((t.getUTCMonth() + 1) / 3);
    switch (a) {
      case "q":
        return String(n);
      case "qq":
        return Re(n, 2);
      case "qo":
        return o.ordinalNumber(n, {
          unit: "quarter"
        });
      case "qqq":
        return o.quarter(n, {
          width: "abbreviated",
          context: "standalone"
        });
      case "qqqqq":
        return o.quarter(n, {
          width: "narrow",
          context: "standalone"
        });
      case "qqqq":
      default:
        return o.quarter(n, {
          width: "wide",
          context: "standalone"
        });
    }
  },
  // Month
  M: function(t, a, o) {
    var n = t.getUTCMonth();
    switch (a) {
      case "M":
      case "MM":
        return Jt.M(t, a);
      case "Mo":
        return o.ordinalNumber(n + 1, {
          unit: "month"
        });
      case "MMM":
        return o.month(n, {
          width: "abbreviated",
          context: "formatting"
        });
      case "MMMMM":
        return o.month(n, {
          width: "narrow",
          context: "formatting"
        });
      case "MMMM":
      default:
        return o.month(n, {
          width: "wide",
          context: "formatting"
        });
    }
  },
  // Stand-alone month
  L: function(t, a, o) {
    var n = t.getUTCMonth();
    switch (a) {
      case "L":
        return String(n + 1);
      case "LL":
        return Re(n + 1, 2);
      case "Lo":
        return o.ordinalNumber(n + 1, {
          unit: "month"
        });
      case "LLL":
        return o.month(n, {
          width: "abbreviated",
          context: "standalone"
        });
      case "LLLLL":
        return o.month(n, {
          width: "narrow",
          context: "standalone"
        });
      case "LLLL":
      default:
        return o.month(n, {
          width: "wide",
          context: "standalone"
        });
    }
  },
  // Local week of year
  w: function(t, a, o, n) {
    var i = dL(t, n);
    return a === "wo" ? o.ordinalNumber(i, {
      unit: "week"
    }) : Re(i, a.length);
  },
  // ISO week of year
  I: function(t, a, o) {
    var n = cL(t);
    return a === "Io" ? o.ordinalNumber(n, {
      unit: "week"
    }) : Re(n, a.length);
  },
  // Day of the month
  d: function(t, a, o) {
    return a === "do" ? o.ordinalNumber(t.getUTCDate(), {
      unit: "date"
    }) : Jt.d(t, a);
  },
  // Day of year
  D: function(t, a, o) {
    var n = F$(t);
    return a === "Do" ? o.ordinalNumber(n, {
      unit: "dayOfYear"
    }) : Re(n, a.length);
  },
  // Day of week
  E: function(t, a, o) {
    var n = t.getUTCDay();
    switch (a) {
      case "E":
      case "EE":
      case "EEE":
        return o.day(n, {
          width: "abbreviated",
          context: "formatting"
        });
      case "EEEEE":
        return o.day(n, {
          width: "narrow",
          context: "formatting"
        });
      case "EEEEEE":
        return o.day(n, {
          width: "short",
          context: "formatting"
        });
      case "EEEE":
      default:
        return o.day(n, {
          width: "wide",
          context: "formatting"
        });
    }
  },
  // Local day of week
  e: function(t, a, o, n) {
    var i = t.getUTCDay(), l = (i - n.weekStartsOn + 8) % 7 || 7;
    switch (a) {
      case "e":
        return String(l);
      case "ee":
        return Re(l, 2);
      case "eo":
        return o.ordinalNumber(l, {
          unit: "day"
        });
      case "eee":
        return o.day(i, {
          width: "abbreviated",
          context: "formatting"
        });
      case "eeeee":
        return o.day(i, {
          width: "narrow",
          context: "formatting"
        });
      case "eeeeee":
        return o.day(i, {
          width: "short",
          context: "formatting"
        });
      case "eeee":
      default:
        return o.day(i, {
          width: "wide",
          context: "formatting"
        });
    }
  },
  // Stand-alone local day of week
  c: function(t, a, o, n) {
    var i = t.getUTCDay(), l = (i - n.weekStartsOn + 8) % 7 || 7;
    switch (a) {
      case "c":
        return String(l);
      case "cc":
        return Re(l, a.length);
      case "co":
        return o.ordinalNumber(l, {
          unit: "day"
        });
      case "ccc":
        return o.day(i, {
          width: "abbreviated",
          context: "standalone"
        });
      case "ccccc":
        return o.day(i, {
          width: "narrow",
          context: "standalone"
        });
      case "cccccc":
        return o.day(i, {
          width: "short",
          context: "standalone"
        });
      case "cccc":
      default:
        return o.day(i, {
          width: "wide",
          context: "standalone"
        });
    }
  },
  // ISO day of week
  i: function(t, a, o) {
    var n = t.getUTCDay(), i = n === 0 ? 7 : n;
    switch (a) {
      case "i":
        return String(i);
      case "ii":
        return Re(i, a.length);
      case "io":
        return o.ordinalNumber(i, {
          unit: "day"
        });
      case "iii":
        return o.day(n, {
          width: "abbreviated",
          context: "formatting"
        });
      case "iiiii":
        return o.day(n, {
          width: "narrow",
          context: "formatting"
        });
      case "iiiiii":
        return o.day(n, {
          width: "short",
          context: "formatting"
        });
      case "iiii":
      default:
        return o.day(n, {
          width: "wide",
          context: "formatting"
        });
    }
  },
  // AM or PM
  a: function(t, a, o) {
    var n = t.getUTCHours(), i = n / 12 >= 1 ? "pm" : "am";
    switch (a) {
      case "a":
      case "aa":
        return o.dayPeriod(i, {
          width: "abbreviated",
          context: "formatting"
        });
      case "aaa":
        return o.dayPeriod(i, {
          width: "abbreviated",
          context: "formatting"
        }).toLowerCase();
      case "aaaaa":
        return o.dayPeriod(i, {
          width: "narrow",
          context: "formatting"
        });
      case "aaaa":
      default:
        return o.dayPeriod(i, {
          width: "wide",
          context: "formatting"
        });
    }
  },
  // AM, PM, midnight, noon
  b: function(t, a, o) {
    var n = t.getUTCHours(), i;
    switch (n === 12 ? i = Tr.noon : n === 0 ? i = Tr.midnight : i = n / 12 >= 1 ? "pm" : "am", a) {
      case "b":
      case "bb":
        return o.dayPeriod(i, {
          width: "abbreviated",
          context: "formatting"
        });
      case "bbb":
        return o.dayPeriod(i, {
          width: "abbreviated",
          context: "formatting"
        }).toLowerCase();
      case "bbbbb":
        return o.dayPeriod(i, {
          width: "narrow",
          context: "formatting"
        });
      case "bbbb":
      default:
        return o.dayPeriod(i, {
          width: "wide",
          context: "formatting"
        });
    }
  },
  // in the morning, in the afternoon, in the evening, at night
  B: function(t, a, o) {
    var n = t.getUTCHours(), i;
    switch (n >= 17 ? i = Tr.evening : n >= 12 ? i = Tr.afternoon : n >= 4 ? i = Tr.morning : i = Tr.night, a) {
      case "B":
      case "BB":
      case "BBB":
        return o.dayPeriod(i, {
          width: "abbreviated",
          context: "formatting"
        });
      case "BBBBB":
        return o.dayPeriod(i, {
          width: "narrow",
          context: "formatting"
        });
      case "BBBB":
      default:
        return o.dayPeriod(i, {
          width: "wide",
          context: "formatting"
        });
    }
  },
  // Hour [1-12]
  h: function(t, a, o) {
    if (a === "ho") {
      var n = t.getUTCHours() % 12;
      return n === 0 && (n = 12), o.ordinalNumber(n, {
        unit: "hour"
      });
    }
    return Jt.h(t, a);
  },
  // Hour [0-23]
  H: function(t, a, o) {
    return a === "Ho" ? o.ordinalNumber(t.getUTCHours(), {
      unit: "hour"
    }) : Jt.H(t, a);
  },
  // Hour [0-11]
  K: function(t, a, o) {
    var n = t.getUTCHours() % 12;
    return a === "Ko" ? o.ordinalNumber(n, {
      unit: "hour"
    }) : Re(n, a.length);
  },
  // Hour [1-24]
  k: function(t, a, o) {
    var n = t.getUTCHours();
    return n === 0 && (n = 24), a === "ko" ? o.ordinalNumber(n, {
      unit: "hour"
    }) : Re(n, a.length);
  },
  // Minute
  m: function(t, a, o) {
    return a === "mo" ? o.ordinalNumber(t.getUTCMinutes(), {
      unit: "minute"
    }) : Jt.m(t, a);
  },
  // Second
  s: function(t, a, o) {
    return a === "so" ? o.ordinalNumber(t.getUTCSeconds(), {
      unit: "second"
    }) : Jt.s(t, a);
  },
  // Fraction of second
  S: function(t, a) {
    return Jt.S(t, a);
  },
  // Timezone (ISO-8601. If offset is 0, output is always `'Z'`)
  X: function(t, a, o, n) {
    var i = n._originalDate || t, l = i.getTimezoneOffset();
    if (l === 0)
      return "Z";
    switch (a) {
      case "X":
        return Bw(l);
      case "XXXX":
      case "XX":
        return vr(l);
      case "XXXXX":
      case "XXX":
      default:
        return vr(l, ":");
    }
  },
  // Timezone (ISO-8601. If offset is 0, output is `'+00:00'` or equivalent)
  x: function(t, a, o, n) {
    var i = n._originalDate || t, l = i.getTimezoneOffset();
    switch (a) {
      case "x":
        return Bw(l);
      case "xxxx":
      case "xx":
        return vr(l);
      case "xxxxx":
      case "xxx":
      default:
        return vr(l, ":");
    }
  },
  // Timezone (GMT)
  O: function(t, a, o, n) {
    var i = n._originalDate || t, l = i.getTimezoneOffset();
    switch (a) {
      case "O":
      case "OO":
      case "OOO":
        return "GMT" + _w(l, ":");
      case "OOOO":
      default:
        return "GMT" + vr(l, ":");
    }
  },
  // Timezone (specific non-location)
  z: function(t, a, o, n) {
    var i = n._originalDate || t, l = i.getTimezoneOffset();
    switch (a) {
      case "z":
      case "zz":
      case "zzz":
        return "GMT" + _w(l, ":");
      case "zzzz":
      default:
        return "GMT" + vr(l, ":");
    }
  },
  // Seconds timestamp
  t: function(t, a, o, n) {
    var i = n._originalDate || t, l = Math.floor(i.getTime() / 1e3);
    return Re(l, a.length);
  },
  // Milliseconds timestamp
  T: function(t, a, o, n) {
    var i = n._originalDate || t, l = i.getTime();
    return Re(l, a.length);
  }
};
function _w(e, t) {
  var a = e > 0 ? "-" : "+", o = Math.abs(e), n = Math.floor(o / 60), i = o % 60;
  if (i === 0)
    return a + String(n);
  var l = t || "";
  return a + String(n) + l + Re(i, 2);
}
function Bw(e, t) {
  if (e % 60 === 0) {
    var a = e > 0 ? "-" : "+";
    return a + Re(Math.abs(e) / 60, 2);
  }
  return vr(e, t);
}
function vr(e, t) {
  var a = t || "", o = e > 0 ? "-" : "+", n = Math.abs(e), i = Re(Math.floor(n / 60), 2), l = Re(n % 60, 2);
  return o + i + a + l;
}
const G$ = Y$;
var zw = function(t, a) {
  switch (t) {
    case "P":
      return a.date({
        width: "short"
      });
    case "PP":
      return a.date({
        width: "medium"
      });
    case "PPP":
      return a.date({
        width: "long"
      });
    case "PPPP":
    default:
      return a.date({
        width: "full"
      });
  }
}, sL = function(t, a) {
  switch (t) {
    case "p":
      return a.time({
        width: "short"
      });
    case "pp":
      return a.time({
        width: "medium"
      });
    case "ppp":
      return a.time({
        width: "long"
      });
    case "pppp":
    default:
      return a.time({
        width: "full"
      });
  }
}, X$ = function(t, a) {
  var o = t.match(/(P+)(p+)?/) || [], n = o[1], i = o[2];
  if (!i)
    return zw(t, a);
  var l;
  switch (n) {
    case "P":
      l = a.dateTime({
        width: "short"
      });
      break;
    case "PP":
      l = a.dateTime({
        width: "medium"
      });
      break;
    case "PPP":
      l = a.dateTime({
        width: "long"
      });
      break;
    case "PPPP":
    default:
      l = a.dateTime({
        width: "full"
      });
      break;
  }
  return l.replace("{{date}}", zw(n, a)).replace("{{time}}", sL(i, a));
}, K$ = {
  p: sL,
  P: X$
};
const B9 = K$;
var Q$ = ["D", "DD"], J$ = ["YY", "YYYY"];
function uL(e) {
  return Q$.indexOf(e) !== -1;
}
function hL(e) {
  return J$.indexOf(e) !== -1;
}
function Cx(e, t, a) {
  if (e === "YYYY")
    throw new RangeError("Use `yyyy` instead of `YYYY` (in `".concat(t, "`) for formatting years to the input `").concat(a, "`; see: https://github.com/date-fns/date-fns/blob/master/docs/unicodeTokens.md"));
  if (e === "YY")
    throw new RangeError("Use `yy` instead of `YY` (in `".concat(t, "`) for formatting years to the input `").concat(a, "`; see: https://github.com/date-fns/date-fns/blob/master/docs/unicodeTokens.md"));
  if (e === "D")
    throw new RangeError("Use `d` instead of `D` (in `".concat(t, "`) for formatting days of the month to the input `").concat(a, "`; see: https://github.com/date-fns/date-fns/blob/master/docs/unicodeTokens.md"));
  if (e === "DD")
    throw new RangeError("Use `dd` instead of `DD` (in `".concat(t, "`) for formatting days of the month to the input `").concat(a, "`; see: https://github.com/date-fns/date-fns/blob/master/docs/unicodeTokens.md"));
}
var eR = {
  lessThanXSeconds: {
    one: "less than a second",
    other: "less than {{count}} seconds"
  },
  xSeconds: {
    one: "1 second",
    other: "{{count}} seconds"
  },
  halfAMinute: "half a minute",
  lessThanXMinutes: {
    one: "less than a minute",
    other: "less than {{count}} minutes"
  },
  xMinutes: {
    one: "1 minute",
    other: "{{count}} minutes"
  },
  aboutXHours: {
    one: "about 1 hour",
    other: "about {{count}} hours"
  },
  xHours: {
    one: "1 hour",
    other: "{{count}} hours"
  },
  xDays: {
    one: "1 day",
    other: "{{count}} days"
  },
  aboutXWeeks: {
    one: "about 1 week",
    other: "about {{count}} weeks"
  },
  xWeeks: {
    one: "1 week",
    other: "{{count}} weeks"
  },
  aboutXMonths: {
    one: "about 1 month",
    other: "about {{count}} months"
  },
  xMonths: {
    one: "1 month",
    other: "{{count}} months"
  },
  aboutXYears: {
    one: "about 1 year",
    other: "about {{count}} years"
  },
  xYears: {
    one: "1 year",
    other: "{{count}} years"
  },
  overXYears: {
    one: "over 1 year",
    other: "over {{count}} years"
  },
  almostXYears: {
    one: "almost 1 year",
    other: "almost {{count}} years"
  }
}, tR = function(t, a, o) {
  var n, i = eR[t];
  return typeof i == "string" ? n = i : a === 1 ? n = i.one : n = i.other.replace("{{count}}", a.toString()), o != null && o.addSuffix ? o.comparison && o.comparison > 0 ? "in " + n : n + " ago" : n;
};
const aR = tR;
function c9(e) {
  return function() {
    var t = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {}, a = t.width ? String(t.width) : e.defaultWidth, o = e.formats[a] || e.formats[e.defaultWidth];
    return o;
  };
}
var nR = {
  full: "EEEE, MMMM do, y",
  long: "MMMM do, y",
  medium: "MMM d, y",
  short: "MM/dd/yyyy"
}, oR = {
  full: "h:mm:ss a zzzz",
  long: "h:mm:ss a z",
  medium: "h:mm:ss a",
  short: "h:mm a"
}, rR = {
  full: "{{date}} 'at' {{time}}",
  long: "{{date}} 'at' {{time}}",
  medium: "{{date}}, {{time}}",
  short: "{{date}}, {{time}}"
}, iR = {
  date: c9({
    formats: nR,
    defaultWidth: "full"
  }),
  time: c9({
    formats: oR,
    defaultWidth: "full"
  }),
  dateTime: c9({
    formats: rR,
    defaultWidth: "full"
  })
};
const lR = iR;
var cR = {
  lastWeek: "'last' eeee 'at' p",
  yesterday: "'yesterday at' p",
  today: "'today at' p",
  tomorrow: "'tomorrow at' p",
  nextWeek: "eeee 'at' p",
  other: "P"
}, dR = function(t, a, o, n) {
  return cR[t];
};
const sR = dR;
function Qr(e) {
  return function(t, a) {
    var o = a != null && a.context ? String(a.context) : "standalone", n;
    if (o === "formatting" && e.formattingValues) {
      var i = e.defaultFormattingWidth || e.defaultWidth, l = a != null && a.width ? String(a.width) : i;
      n = e.formattingValues[l] || e.formattingValues[i];
    } else {
      var c = e.defaultWidth, s = a != null && a.width ? String(a.width) : e.defaultWidth;
      n = e.values[s] || e.values[c];
    }
    var h = e.argumentCallback ? e.argumentCallback(t) : t;
    return n[h];
  };
}
var uR = {
  narrow: ["B", "A"],
  abbreviated: ["BC", "AD"],
  wide: ["Before Christ", "Anno Domini"]
}, hR = {
  narrow: ["1", "2", "3", "4"],
  abbreviated: ["Q1", "Q2", "Q3", "Q4"],
  wide: ["1st quarter", "2nd quarter", "3rd quarter", "4th quarter"]
}, pR = {
  narrow: ["J", "F", "M", "A", "M", "J", "J", "A", "S", "O", "N", "D"],
  abbreviated: ["Jan", "Feb", "Mar", "Apr", "May", "Jun", "Jul", "Aug", "Sep", "Oct", "Nov", "Dec"],
  wide: ["January", "February", "March", "April", "May", "June", "July", "August", "September", "October", "November", "December"]
}, yR = {
  narrow: ["S", "M", "T", "W", "T", "F", "S"],
  short: ["Su", "Mo", "Tu", "We", "Th", "Fr", "Sa"],
  abbreviated: ["Sun", "Mon", "Tue", "Wed", "Thu", "Fri", "Sat"],
  wide: ["Sunday", "Monday", "Tuesday", "Wednesday", "Thursday", "Friday", "Saturday"]
}, kR = {
  narrow: {
    am: "a",
    pm: "p",
    midnight: "mi",
    noon: "n",
    morning: "morning",
    afternoon: "afternoon",
    evening: "evening",
    night: "night"
  },
  abbreviated: {
    am: "AM",
    pm: "PM",
    midnight: "midnight",
    noon: "noon",
    morning: "morning",
    afternoon: "afternoon",
    evening: "evening",
    night: "night"
  },
  wide: {
    am: "a.m.",
    pm: "p.m.",
    midnight: "midnight",
    noon: "noon",
    morning: "morning",
    afternoon: "afternoon",
    evening: "evening",
    night: "night"
  }
}, fR = {
  narrow: {
    am: "a",
    pm: "p",
    midnight: "mi",
    noon: "n",
    morning: "in the morning",
    afternoon: "in the afternoon",
    evening: "in the evening",
    night: "at night"
  },
  abbreviated: {
    am: "AM",
    pm: "PM",
    midnight: "midnight",
    noon: "noon",
    morning: "in the morning",
    afternoon: "in the afternoon",
    evening: "in the evening",
    night: "at night"
  },
  wide: {
    am: "a.m.",
    pm: "p.m.",
    midnight: "midnight",
    noon: "noon",
    morning: "in the morning",
    afternoon: "in the afternoon",
    evening: "in the evening",
    night: "at night"
  }
}, vR = function(t, a) {
  var o = Number(t), n = o % 100;
  if (n > 20 || n < 10)
    switch (n % 10) {
      case 1:
        return o + "st";
      case 2:
        return o + "nd";
      case 3:
        return o + "rd";
    }
  return o + "th";
}, mR = {
  ordinalNumber: vR,
  era: Qr({
    values: uR,
    defaultWidth: "wide"
  }),
  quarter: Qr({
    values: hR,
    defaultWidth: "wide",
    argumentCallback: function(t) {
      return t - 1;
    }
  }),
  month: Qr({
    values: pR,
    defaultWidth: "wide"
  }),
  day: Qr({
    values: yR,
    defaultWidth: "wide"
  }),
  dayPeriod: Qr({
    values: kR,
    defaultWidth: "wide",
    formattingValues: fR,
    defaultFormattingWidth: "wide"
  })
};
const gR = mR;
function Jr(e) {
  return function(t) {
    var a = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {}, o = a.width, n = o && e.matchPatterns[o] || e.matchPatterns[e.defaultMatchWidth], i = t.match(n);
    if (!i)
      return null;
    var l = i[0], c = o && e.parsePatterns[o] || e.parsePatterns[e.defaultParseWidth], s = Array.isArray(c) ? xR(c, function(p) {
      return p.test(l);
    }) : MR(c, function(p) {
      return p.test(l);
    }), h;
    h = e.valueCallback ? e.valueCallback(s) : s, h = a.valueCallback ? a.valueCallback(h) : h;
    var m = t.slice(l.length);
    return {
      value: h,
      rest: m
    };
  };
}
function MR(e, t) {
  for (var a in e)
    if (e.hasOwnProperty(a) && t(e[a]))
      return a;
}
function xR(e, t) {
  for (var a = 0; a < e.length; a++)
    if (t(e[a]))
      return a;
}
function bR(e) {
  return function(t) {
    var a = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {}, o = t.match(e.matchPattern);
    if (!o)
      return null;
    var n = o[0], i = t.match(e.parsePattern);
    if (!i)
      return null;
    var l = e.valueCallback ? e.valueCallback(i[0]) : i[0];
    l = a.valueCallback ? a.valueCallback(l) : l;
    var c = t.slice(n.length);
    return {
      value: l,
      rest: c
    };
  };
}
var wR = /^(\d+)(th|st|nd|rd)?/i, IR = /\d+/i, LR = {
  narrow: /^(b|a)/i,
  abbreviated: /^(b\.?\s?c\.?|b\.?\s?c\.?\s?e\.?|a\.?\s?d\.?|c\.?\s?e\.?)/i,
  wide: /^(before christ|before common era|anno domini|common era)/i
}, SR = {
  any: [/^b/i, /^(a|c)/i]
}, CR = {
  narrow: /^[1234]/i,
  abbreviated: /^q[1234]/i,
  wide: /^[1234](th|st|nd|rd)? quarter/i
}, AR = {
  any: [/1/i, /2/i, /3/i, /4/i]
}, PR = {
  narrow: /^[jfmasond]/i,
  abbreviated: /^(jan|feb|mar|apr|may|jun|jul|aug|sep|oct|nov|dec)/i,
  wide: /^(january|february|march|april|may|june|july|august|september|october|november|december)/i
}, qR = {
  narrow: [/^j/i, /^f/i, /^m/i, /^a/i, /^m/i, /^j/i, /^j/i, /^a/i, /^s/i, /^o/i, /^n/i, /^d/i],
  any: [/^ja/i, /^f/i, /^mar/i, /^ap/i, /^may/i, /^jun/i, /^jul/i, /^au/i, /^s/i, /^o/i, /^n/i, /^d/i]
}, TR = {
  narrow: /^[smtwf]/i,
  short: /^(su|mo|tu|we|th|fr|sa)/i,
  abbreviated: /^(sun|mon|tue|wed|thu|fri|sat)/i,
  wide: /^(sunday|monday|tuesday|wednesday|thursday|friday|saturday)/i
}, DR = {
  narrow: [/^s/i, /^m/i, /^t/i, /^w/i, /^t/i, /^f/i, /^s/i],
  any: [/^su/i, /^m/i, /^tu/i, /^w/i, /^th/i, /^f/i, /^sa/i]
}, _R = {
  narrow: /^(a|p|mi|n|(in the|at) (morning|afternoon|evening|night))/i,
  any: /^([ap]\.?\s?m\.?|midnight|noon|(in the|at) (morning|afternoon|evening|night))/i
}, BR = {
  any: {
    am: /^a/i,
    pm: /^p/i,
    midnight: /^mi/i,
    noon: /^no/i,
    morning: /morning/i,
    afternoon: /afternoon/i,
    evening: /evening/i,
    night: /night/i
  }
}, zR = {
  ordinalNumber: bR({
    matchPattern: wR,
    parsePattern: IR,
    valueCallback: function(t) {
      return parseInt(t, 10);
    }
  }),
  era: Jr({
    matchPatterns: LR,
    defaultMatchWidth: "wide",
    parsePatterns: SR,
    defaultParseWidth: "any"
  }),
  quarter: Jr({
    matchPatterns: CR,
    defaultMatchWidth: "wide",
    parsePatterns: AR,
    defaultParseWidth: "any",
    valueCallback: function(t) {
      return t + 1;
    }
  }),
  month: Jr({
    matchPatterns: PR,
    defaultMatchWidth: "wide",
    parsePatterns: qR,
    defaultParseWidth: "any"
  }),
  day: Jr({
    matchPatterns: TR,
    defaultMatchWidth: "wide",
    parsePatterns: DR,
    defaultParseWidth: "any"
  }),
  dayPeriod: Jr({
    matchPatterns: _R,
    defaultMatchWidth: "any",
    parsePatterns: BR,
    defaultParseWidth: "any"
  })
};
const HR = zR;
var jR = {
  code: "en-US",
  formatDistance: aR,
  formatLong: lR,
  formatRelative: sR,
  localize: gR,
  match: HR,
  options: {
    weekStartsOn: 0,
    firstWeekContainsDate: 1
  }
};
const pL = jR;
var VR = /[yYQqMLwIdDecihHKkms]o|(\w)\1*|''|'(''|[^'])+('|$)|./g, OR = /P+p+|P+|p+|''|'(''|[^'])+('|$)|./g, $R = /^'([^]*?)'?$/, RR = /''/g, FR = /[a-zA-Z]/;
function na(e, t, a) {
  var o, n, i, l, c, s, h, m, p, f, g, w, q, _, b, L, j, I;
  ve(2, arguments);
  var C = String(t), B = Ut(), U = (o = (n = a == null ? void 0 : a.locale) !== null && n !== void 0 ? n : B.locale) !== null && o !== void 0 ? o : pL, de = we((i = (l = (c = (s = a == null ? void 0 : a.firstWeekContainsDate) !== null && s !== void 0 ? s : a == null || (h = a.locale) === null || h === void 0 || (m = h.options) === null || m === void 0 ? void 0 : m.firstWeekContainsDate) !== null && c !== void 0 ? c : B.firstWeekContainsDate) !== null && l !== void 0 ? l : (p = B.locale) === null || p === void 0 || (f = p.options) === null || f === void 0 ? void 0 : f.firstWeekContainsDate) !== null && i !== void 0 ? i : 1);
  if (!(de >= 1 && de <= 7))
    throw new RangeError("firstWeekContainsDate must be between 1 and 7 inclusively");
  var ae = we((g = (w = (q = (_ = a == null ? void 0 : a.weekStartsOn) !== null && _ !== void 0 ? _ : a == null || (b = a.locale) === null || b === void 0 || (L = b.options) === null || L === void 0 ? void 0 : L.weekStartsOn) !== null && q !== void 0 ? q : B.weekStartsOn) !== null && w !== void 0 ? w : (j = B.locale) === null || j === void 0 || (I = j.options) === null || I === void 0 ? void 0 : I.weekStartsOn) !== null && g !== void 0 ? g : 0);
  if (!(ae >= 0 && ae <= 6))
    throw new RangeError("weekStartsOn must be between 0 and 6 inclusively");
  if (!U.localize)
    throw new RangeError("locale must contain localize property");
  if (!U.formatLong)
    throw new RangeError("locale must contain formatLong property");
  var S = xe(e);
  if (!o1(S))
    throw new RangeError("Invalid time value");
  var V = Sx(S), Z = iL(S, V), re = {
    firstWeekContainsDate: de,
    weekStartsOn: ae,
    locale: U,
    _originalDate: S
  }, F = C.match(OR).map(function(A) {
    var $ = A[0];
    if ($ === "p" || $ === "P") {
      var R = B9[$];
      return R(A, U.formatLong);
    }
    return A;
  }).join("").match(VR).map(function(A) {
    if (A === "''")
      return "'";
    var $ = A[0];
    if ($ === "'")
      return UR(A);
    var R = G$[$];
    if (R)
      return !(a != null && a.useAdditionalWeekYearTokens) && hL(A) && Cx(A, t, String(e)), !(a != null && a.useAdditionalDayOfYearTokens) && uL(A) && Cx(A, t, String(e)), R(Z, A, U.localize, re);
    if ($.match(FR))
      throw new RangeError("Format string contains an unescaped latin alphabet character `" + $ + "`");
    return A;
  }).join("");
  return F;
}
function UR(e) {
  var t = e.match($R);
  return t ? t[1].replace(RR, "'") : e;
}
function ER(e, t) {
  if (e == null)
    throw new TypeError("assign requires that input parameter not be null or undefined");
  for (var a in t)
    Object.prototype.hasOwnProperty.call(t, a) && (e[a] = t[a]);
  return e;
}
function WR(e) {
  ve(1, arguments);
  var t = xe(e), a = t.getDay();
  return a;
}
function NR(e) {
  ve(1, arguments);
  var t = xe(e), a = t.getFullYear(), o = t.getMonth(), n = /* @__PURE__ */ new Date(0);
  return n.setFullYear(a, o + 1, 0), n.setHours(0, 0, 0, 0), n.getDate();
}
function qt(e) {
  ve(1, arguments);
  var t = xe(e), a = t.getHours();
  return a;
}
var ZR = 6048e5;
function YR(e) {
  ve(1, arguments);
  var t = xe(e), a = Lx(t).getTime() - D$(t).getTime();
  return Math.round(a / ZR) + 1;
}
function $t(e) {
  ve(1, arguments);
  var t = xe(e), a = t.getMinutes();
  return a;
}
function He(e) {
  ve(1, arguments);
  var t = xe(e), a = t.getMonth();
  return a;
}
function Hr(e) {
  ve(1, arguments);
  var t = xe(e), a = t.getSeconds();
  return a;
}
function GR(e, t) {
  var a, o, n, i, l, c, s, h;
  ve(1, arguments);
  var m = xe(e), p = m.getFullYear(), f = Ut(), g = we((a = (o = (n = (i = t == null ? void 0 : t.firstWeekContainsDate) !== null && i !== void 0 ? i : t == null || (l = t.locale) === null || l === void 0 || (c = l.options) === null || c === void 0 ? void 0 : c.firstWeekContainsDate) !== null && n !== void 0 ? n : f.firstWeekContainsDate) !== null && o !== void 0 ? o : (s = f.locale) === null || s === void 0 || (h = s.options) === null || h === void 0 ? void 0 : h.firstWeekContainsDate) !== null && a !== void 0 ? a : 1);
  if (!(g >= 1 && g <= 7))
    throw new RangeError("firstWeekContainsDate must be between 1 and 7 inclusively");
  var w = /* @__PURE__ */ new Date(0);
  w.setFullYear(p + 1, 0, g), w.setHours(0, 0, 0, 0);
  var q = br(w, t), _ = /* @__PURE__ */ new Date(0);
  _.setFullYear(p, 0, g), _.setHours(0, 0, 0, 0);
  var b = br(_, t);
  return m.getTime() >= q.getTime() ? p + 1 : m.getTime() >= b.getTime() ? p : p - 1;
}
function XR(e, t) {
  var a, o, n, i, l, c, s, h;
  ve(1, arguments);
  var m = Ut(), p = we((a = (o = (n = (i = t == null ? void 0 : t.firstWeekContainsDate) !== null && i !== void 0 ? i : t == null || (l = t.locale) === null || l === void 0 || (c = l.options) === null || c === void 0 ? void 0 : c.firstWeekContainsDate) !== null && n !== void 0 ? n : m.firstWeekContainsDate) !== null && o !== void 0 ? o : (s = m.locale) === null || s === void 0 || (h = s.options) === null || h === void 0 ? void 0 : h.firstWeekContainsDate) !== null && a !== void 0 ? a : 1), f = GR(e, t), g = /* @__PURE__ */ new Date(0);
  g.setFullYear(f, 0, p), g.setHours(0, 0, 0, 0);
  var w = br(g, t);
  return w;
}
var KR = 6048e5;
function QR(e, t) {
  ve(1, arguments);
  var a = xe(e), o = br(a, t).getTime() - XR(a, t).getTime();
  return Math.round(o / KR) + 1;
}
function qe(e) {
  return ve(1, arguments), xe(e).getFullYear();
}
function c1(e, t) {
  ve(2, arguments);
  var a = xe(e), o = xe(t);
  return a.getTime() > o.getTime();
}
function d1(e, t) {
  ve(2, arguments);
  var a = xe(e), o = xe(t);
  return a.getTime() < o.getTime();
}
function Br(e, t) {
  ve(2, arguments);
  var a = xe(e), o = xe(t);
  return a.getTime() === o.getTime();
}
function Hw(e, t) {
  (t == null || t > e.length) && (t = e.length);
  for (var a = 0, o = new Array(t); a < t; a++)
    o[a] = e[a];
  return o;
}
function JR(e, t) {
  if (e) {
    if (typeof e == "string")
      return Hw(e, t);
    var a = Object.prototype.toString.call(e).slice(8, -1);
    if (a === "Object" && e.constructor && (a = e.constructor.name), a === "Map" || a === "Set")
      return Array.from(e);
    if (a === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(a))
      return Hw(e, t);
  }
}
function jw(e, t) {
  var a = typeof Symbol < "u" && e[Symbol.iterator] || e["@@iterator"];
  if (!a) {
    if (Array.isArray(e) || (a = JR(e)) || t && e && typeof e.length == "number") {
      a && (e = a);
      var o = 0, n = function() {
      };
      return {
        s: n,
        n: function() {
          return o >= e.length ? {
            done: !0
          } : {
            done: !1,
            value: e[o++]
          };
        },
        e: function(h) {
          throw h;
        },
        f: n
      };
    }
    throw new TypeError(`Invalid attempt to iterate non-iterable instance.
In order to be iterable, non-array objects must have a [Symbol.iterator]() method.`);
  }
  var i = !0, l = !1, c;
  return {
    s: function() {
      a = a.call(e);
    },
    n: function() {
      var h = a.next();
      return i = h.done, h;
    },
    e: function(h) {
      l = !0, c = h;
    },
    f: function() {
      try {
        !i && a.return != null && a.return();
      } finally {
        if (l)
          throw c;
      }
    }
  };
}
function fe(e) {
  if (e === void 0)
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  return e;
}
function z9(e, t) {
  return z9 = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function(o, n) {
    return o.__proto__ = n, o;
  }, z9(e, t);
}
function je(e, t) {
  if (typeof t != "function" && t !== null)
    throw new TypeError("Super expression must either be null or a function");
  e.prototype = Object.create(t && t.prototype, {
    constructor: {
      value: e,
      writable: !0,
      configurable: !0
    }
  }), Object.defineProperty(e, "prototype", {
    writable: !1
  }), t && z9(e, t);
}
function Ax(e) {
  return Ax = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function(a) {
    return a.__proto__ || Object.getPrototypeOf(a);
  }, Ax(e);
}
function yL() {
  try {
    var e = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {
    }));
  } catch {
  }
  return (yL = function() {
    return !!e;
  })();
}
function eF(e, t) {
  if (t && (It(t) === "object" || typeof t == "function"))
    return t;
  if (t !== void 0)
    throw new TypeError("Derived constructors may only return object or undefined");
  return fe(e);
}
function Ve(e) {
  var t = yL();
  return function() {
    var o = Ax(e), n;
    if (t) {
      var i = Ax(this).constructor;
      n = Reflect.construct(o, arguments, i);
    } else
      n = o.apply(this, arguments);
    return eF(this, n);
  };
}
function Be(e, t) {
  if (!(e instanceof t))
    throw new TypeError("Cannot call a class as a function");
}
function tF(e, t) {
  if (It(e) != "object" || !e)
    return e;
  var a = e[Symbol.toPrimitive];
  if (a !== void 0) {
    var o = a.call(e, t || "default");
    if (It(o) != "object")
      return o;
    throw new TypeError("@@toPrimitive must return a primitive value.");
  }
  return (t === "string" ? String : Number)(e);
}
function kL(e) {
  var t = tF(e, "string");
  return It(t) == "symbol" ? t : t + "";
}
function Vw(e, t) {
  for (var a = 0; a < t.length; a++) {
    var o = t[a];
    o.enumerable = o.enumerable || !1, o.configurable = !0, "value" in o && (o.writable = !0), Object.defineProperty(e, kL(o.key), o);
  }
}
function ze(e, t, a) {
  return t && Vw(e.prototype, t), a && Vw(e, a), Object.defineProperty(e, "prototype", {
    writable: !1
  }), e;
}
function ye(e, t, a) {
  return t = kL(t), t in e ? Object.defineProperty(e, t, {
    value: a,
    enumerable: !0,
    configurable: !0,
    writable: !0
  }) : e[t] = a, e;
}
var aF = 10, fL = /* @__PURE__ */ function() {
  function e() {
    Be(this, e), ye(this, "priority", void 0), ye(this, "subPriority", 0);
  }
  return ze(e, [{
    key: "validate",
    value: function(a, o) {
      return !0;
    }
  }]), e;
}(), nF = /* @__PURE__ */ function(e) {
  je(a, e);
  var t = Ve(a);
  function a(o, n, i, l, c) {
    var s;
    return Be(this, a), s = t.call(this), s.value = o, s.validateValue = n, s.setValue = i, s.priority = l, c && (s.subPriority = c), s;
  }
  return ze(a, [{
    key: "validate",
    value: function(n, i) {
      return this.validateValue(n, this.value, i);
    }
  }, {
    key: "set",
    value: function(n, i, l) {
      return this.setValue(n, i, this.value, l);
    }
  }]), a;
}(fL), oF = /* @__PURE__ */ function(e) {
  je(a, e);
  var t = Ve(a);
  function a() {
    var o;
    Be(this, a);
    for (var n = arguments.length, i = new Array(n), l = 0; l < n; l++)
      i[l] = arguments[l];
    return o = t.call.apply(t, [this].concat(i)), ye(fe(o), "priority", aF), ye(fe(o), "subPriority", -1), o;
  }
  return ze(a, [{
    key: "set",
    value: function(n, i) {
      if (i.timestampIsSet)
        return n;
      var l = /* @__PURE__ */ new Date(0);
      return l.setFullYear(n.getUTCFullYear(), n.getUTCMonth(), n.getUTCDate()), l.setHours(n.getUTCHours(), n.getUTCMinutes(), n.getUTCSeconds(), n.getUTCMilliseconds()), l;
    }
  }]), a;
}(fL), $e = /* @__PURE__ */ function() {
  function e() {
    Be(this, e), ye(this, "incompatibleTokens", void 0), ye(this, "priority", void 0), ye(this, "subPriority", void 0);
  }
  return ze(e, [{
    key: "run",
    value: function(a, o, n, i) {
      var l = this.parse(a, o, n, i);
      return l ? {
        setter: new nF(l.value, this.validate, this.set, this.priority, this.subPriority),
        rest: l.rest
      } : null;
    }
  }, {
    key: "validate",
    value: function(a, o, n) {
      return !0;
    }
  }]), e;
}(), rF = /* @__PURE__ */ function(e) {
  je(a, e);
  var t = Ve(a);
  function a() {
    var o;
    Be(this, a);
    for (var n = arguments.length, i = new Array(n), l = 0; l < n; l++)
      i[l] = arguments[l];
    return o = t.call.apply(t, [this].concat(i)), ye(fe(o), "priority", 140), ye(fe(o), "incompatibleTokens", ["R", "u", "t", "T"]), o;
  }
  return ze(a, [{
    key: "parse",
    value: function(n, i, l) {
      switch (i) {
        case "G":
        case "GG":
        case "GGG":
          return l.era(n, {
            width: "abbreviated"
          }) || l.era(n, {
            width: "narrow"
          });
        case "GGGGG":
          return l.era(n, {
            width: "narrow"
          });
        case "GGGG":
        default:
          return l.era(n, {
            width: "wide"
          }) || l.era(n, {
            width: "abbreviated"
          }) || l.era(n, {
            width: "narrow"
          });
      }
    }
  }, {
    key: "set",
    value: function(n, i, l) {
      return i.era = l, n.setUTCFullYear(l, 0, 1), n.setUTCHours(0, 0, 0, 0), n;
    }
  }]), a;
}($e), Je = {
  month: /^(1[0-2]|0?\d)/,
  // 0 to 12
  date: /^(3[0-1]|[0-2]?\d)/,
  // 0 to 31
  dayOfYear: /^(36[0-6]|3[0-5]\d|[0-2]?\d?\d)/,
  // 0 to 366
  week: /^(5[0-3]|[0-4]?\d)/,
  // 0 to 53
  hour23h: /^(2[0-3]|[0-1]?\d)/,
  // 0 to 23
  hour24h: /^(2[0-4]|[0-1]?\d)/,
  // 0 to 24
  hour11h: /^(1[0-1]|0?\d)/,
  // 0 to 11
  hour12h: /^(1[0-2]|0?\d)/,
  // 0 to 12
  minute: /^[0-5]?\d/,
  // 0 to 59
  second: /^[0-5]?\d/,
  // 0 to 59
  singleDigit: /^\d/,
  // 0 to 9
  twoDigits: /^\d{1,2}/,
  // 0 to 99
  threeDigits: /^\d{1,3}/,
  // 0 to 999
  fourDigits: /^\d{1,4}/,
  // 0 to 9999
  anyDigitsSigned: /^-?\d+/,
  singleDigitSigned: /^-?\d/,
  // 0 to 9, -0 to -9
  twoDigitsSigned: /^-?\d{1,2}/,
  // 0 to 99, -0 to -99
  threeDigitsSigned: /^-?\d{1,3}/,
  // 0 to 999, -0 to -999
  fourDigitsSigned: /^-?\d{1,4}/
  // 0 to 9999, -0 to -9999
}, jt = {
  basicOptionalMinutes: /^([+-])(\d{2})(\d{2})?|Z/,
  basic: /^([+-])(\d{2})(\d{2})|Z/,
  basicOptionalSeconds: /^([+-])(\d{2})(\d{2})((\d{2}))?|Z/,
  extended: /^([+-])(\d{2}):(\d{2})|Z/,
  extendedOptionalSeconds: /^([+-])(\d{2}):(\d{2})(:(\d{2}))?|Z/
};
function et(e, t) {
  return e && {
    value: t(e.value),
    rest: e.rest
  };
}
function Ke(e, t) {
  var a = t.match(e);
  return a ? {
    value: parseInt(a[0], 10),
    rest: t.slice(a[0].length)
  } : null;
}
function Vt(e, t) {
  var a = t.match(e);
  if (!a)
    return null;
  if (a[0] === "Z")
    return {
      value: 0,
      rest: t.slice(1)
    };
  var o = a[1] === "+" ? 1 : -1, n = a[2] ? parseInt(a[2], 10) : 0, i = a[3] ? parseInt(a[3], 10) : 0, l = a[5] ? parseInt(a[5], 10) : 0;
  return {
    value: o * (n * yb + i * pb + l * H$),
    rest: t.slice(a[0].length)
  };
}
function vL(e) {
  return Ke(Je.anyDigitsSigned, e);
}
function Qe(e, t) {
  switch (e) {
    case 1:
      return Ke(Je.singleDigit, t);
    case 2:
      return Ke(Je.twoDigits, t);
    case 3:
      return Ke(Je.threeDigits, t);
    case 4:
      return Ke(Je.fourDigits, t);
    default:
      return Ke(new RegExp("^\\d{1," + e + "}"), t);
  }
}
function Px(e, t) {
  switch (e) {
    case 1:
      return Ke(Je.singleDigitSigned, t);
    case 2:
      return Ke(Je.twoDigitsSigned, t);
    case 3:
      return Ke(Je.threeDigitsSigned, t);
    case 4:
      return Ke(Je.fourDigitsSigned, t);
    default:
      return Ke(new RegExp("^-?\\d{1," + e + "}"), t);
  }
}
function fb(e) {
  switch (e) {
    case "morning":
      return 4;
    case "evening":
      return 17;
    case "pm":
    case "noon":
    case "afternoon":
      return 12;
    case "am":
    case "midnight":
    case "night":
    default:
      return 0;
  }
}
function mL(e, t) {
  var a = t > 0, o = a ? t : 1 - t, n;
  if (o <= 50)
    n = e || 100;
  else {
    var i = o + 50, l = Math.floor(i / 100) * 100, c = e >= i % 100;
    n = e + l - (c ? 100 : 0);
  }
  return a ? n : 1 - n;
}
function gL(e) {
  return e % 400 === 0 || e % 4 === 0 && e % 100 !== 0;
}
var iF = /* @__PURE__ */ function(e) {
  je(a, e);
  var t = Ve(a);
  function a() {
    var o;
    Be(this, a);
    for (var n = arguments.length, i = new Array(n), l = 0; l < n; l++)
      i[l] = arguments[l];
    return o = t.call.apply(t, [this].concat(i)), ye(fe(o), "priority", 130), ye(fe(o), "incompatibleTokens", ["Y", "R", "u", "w", "I", "i", "e", "c", "t", "T"]), o;
  }
  return ze(a, [{
    key: "parse",
    value: function(n, i, l) {
      var c = function(h) {
        return {
          year: h,
          isTwoDigitYear: i === "yy"
        };
      };
      switch (i) {
        case "y":
          return et(Qe(4, n), c);
        case "yo":
          return et(l.ordinalNumber(n, {
            unit: "year"
          }), c);
        default:
          return et(Qe(i.length, n), c);
      }
    }
  }, {
    key: "validate",
    value: function(n, i) {
      return i.isTwoDigitYear || i.year > 0;
    }
  }, {
    key: "set",
    value: function(n, i, l) {
      var c = n.getUTCFullYear();
      if (l.isTwoDigitYear) {
        var s = mL(l.year, c);
        return n.setUTCFullYear(s, 0, 1), n.setUTCHours(0, 0, 0, 0), n;
      }
      var h = !("era" in i) || i.era === 1 ? l.year : 1 - l.year;
      return n.setUTCFullYear(h, 0, 1), n.setUTCHours(0, 0, 0, 0), n;
    }
  }]), a;
}($e), lF = /* @__PURE__ */ function(e) {
  je(a, e);
  var t = Ve(a);
  function a() {
    var o;
    Be(this, a);
    for (var n = arguments.length, i = new Array(n), l = 0; l < n; l++)
      i[l] = arguments[l];
    return o = t.call.apply(t, [this].concat(i)), ye(fe(o), "priority", 130), ye(fe(o), "incompatibleTokens", ["y", "R", "u", "Q", "q", "M", "L", "I", "d", "D", "i", "t", "T"]), o;
  }
  return ze(a, [{
    key: "parse",
    value: function(n, i, l) {
      var c = function(h) {
        return {
          year: h,
          isTwoDigitYear: i === "YY"
        };
      };
      switch (i) {
        case "Y":
          return et(Qe(4, n), c);
        case "Yo":
          return et(l.ordinalNumber(n, {
            unit: "year"
          }), c);
        default:
          return et(Qe(i.length, n), c);
      }
    }
  }, {
    key: "validate",
    value: function(n, i) {
      return i.isTwoDigitYear || i.year > 0;
    }
  }, {
    key: "set",
    value: function(n, i, l, c) {
      var s = kb(n, c);
      if (l.isTwoDigitYear) {
        var h = mL(l.year, s);
        return n.setUTCFullYear(h, 0, c.firstWeekContainsDate), n.setUTCHours(0, 0, 0, 0), wr(n, c);
      }
      var m = !("era" in i) || i.era === 1 ? l.year : 1 - l.year;
      return n.setUTCFullYear(m, 0, c.firstWeekContainsDate), n.setUTCHours(0, 0, 0, 0), wr(n, c);
    }
  }]), a;
}($e), cF = /* @__PURE__ */ function(e) {
  je(a, e);
  var t = Ve(a);
  function a() {
    var o;
    Be(this, a);
    for (var n = arguments.length, i = new Array(n), l = 0; l < n; l++)
      i[l] = arguments[l];
    return o = t.call.apply(t, [this].concat(i)), ye(fe(o), "priority", 130), ye(fe(o), "incompatibleTokens", ["G", "y", "Y", "u", "Q", "q", "M", "L", "w", "d", "D", "e", "c", "t", "T"]), o;
  }
  return ze(a, [{
    key: "parse",
    value: function(n, i) {
      return Px(i === "R" ? 4 : i.length, n);
    }
  }, {
    key: "set",
    value: function(n, i, l) {
      var c = /* @__PURE__ */ new Date(0);
      return c.setUTCFullYear(l, 0, 4), c.setUTCHours(0, 0, 0, 0), zr(c);
    }
  }]), a;
}($e), dF = /* @__PURE__ */ function(e) {
  je(a, e);
  var t = Ve(a);
  function a() {
    var o;
    Be(this, a);
    for (var n = arguments.length, i = new Array(n), l = 0; l < n; l++)
      i[l] = arguments[l];
    return o = t.call.apply(t, [this].concat(i)), ye(fe(o), "priority", 130), ye(fe(o), "incompatibleTokens", ["G", "y", "Y", "R", "w", "I", "i", "e", "c", "t", "T"]), o;
  }
  return ze(a, [{
    key: "parse",
    value: function(n, i) {
      return Px(i === "u" ? 4 : i.length, n);
    }
  }, {
    key: "set",
    value: function(n, i, l) {
      return n.setUTCFullYear(l, 0, 1), n.setUTCHours(0, 0, 0, 0), n;
    }
  }]), a;
}($e), sF = /* @__PURE__ */ function(e) {
  je(a, e);
  var t = Ve(a);
  function a() {
    var o;
    Be(this, a);
    for (var n = arguments.length, i = new Array(n), l = 0; l < n; l++)
      i[l] = arguments[l];
    return o = t.call.apply(t, [this].concat(i)), ye(fe(o), "priority", 120), ye(fe(o), "incompatibleTokens", ["Y", "R", "q", "M", "L", "w", "I", "d", "D", "i", "e", "c", "t", "T"]), o;
  }
  return ze(a, [{
    key: "parse",
    value: function(n, i, l) {
      switch (i) {
        case "Q":
        case "QQ":
          return Qe(i.length, n);
        case "Qo":
          return l.ordinalNumber(n, {
            unit: "quarter"
          });
        case "QQQ":
          return l.quarter(n, {
            width: "abbreviated",
            context: "formatting"
          }) || l.quarter(n, {
            width: "narrow",
            context: "formatting"
          });
        case "QQQQQ":
          return l.quarter(n, {
            width: "narrow",
            context: "formatting"
          });
        case "QQQQ":
        default:
          return l.quarter(n, {
            width: "wide",
            context: "formatting"
          }) || l.quarter(n, {
            width: "abbreviated",
            context: "formatting"
          }) || l.quarter(n, {
            width: "narrow",
            context: "formatting"
          });
      }
    }
  }, {
    key: "validate",
    value: function(n, i) {
      return i >= 1 && i <= 4;
    }
  }, {
    key: "set",
    value: function(n, i, l) {
      return n.setUTCMonth((l - 1) * 3, 1), n.setUTCHours(0, 0, 0, 0), n;
    }
  }]), a;
}($e), uF = /* @__PURE__ */ function(e) {
  je(a, e);
  var t = Ve(a);
  function a() {
    var o;
    Be(this, a);
    for (var n = arguments.length, i = new Array(n), l = 0; l < n; l++)
      i[l] = arguments[l];
    return o = t.call.apply(t, [this].concat(i)), ye(fe(o), "priority", 120), ye(fe(o), "incompatibleTokens", ["Y", "R", "Q", "M", "L", "w", "I", "d", "D", "i", "e", "c", "t", "T"]), o;
  }
  return ze(a, [{
    key: "parse",
    value: function(n, i, l) {
      switch (i) {
        case "q":
        case "qq":
          return Qe(i.length, n);
        case "qo":
          return l.ordinalNumber(n, {
            unit: "quarter"
          });
        case "qqq":
          return l.quarter(n, {
            width: "abbreviated",
            context: "standalone"
          }) || l.quarter(n, {
            width: "narrow",
            context: "standalone"
          });
        case "qqqqq":
          return l.quarter(n, {
            width: "narrow",
            context: "standalone"
          });
        case "qqqq":
        default:
          return l.quarter(n, {
            width: "wide",
            context: "standalone"
          }) || l.quarter(n, {
            width: "abbreviated",
            context: "standalone"
          }) || l.quarter(n, {
            width: "narrow",
            context: "standalone"
          });
      }
    }
  }, {
    key: "validate",
    value: function(n, i) {
      return i >= 1 && i <= 4;
    }
  }, {
    key: "set",
    value: function(n, i, l) {
      return n.setUTCMonth((l - 1) * 3, 1), n.setUTCHours(0, 0, 0, 0), n;
    }
  }]), a;
}($e), hF = /* @__PURE__ */ function(e) {
  je(a, e);
  var t = Ve(a);
  function a() {
    var o;
    Be(this, a);
    for (var n = arguments.length, i = new Array(n), l = 0; l < n; l++)
      i[l] = arguments[l];
    return o = t.call.apply(t, [this].concat(i)), ye(fe(o), "incompatibleTokens", ["Y", "R", "q", "Q", "L", "w", "I", "D", "i", "e", "c", "t", "T"]), ye(fe(o), "priority", 110), o;
  }
  return ze(a, [{
    key: "parse",
    value: function(n, i, l) {
      var c = function(h) {
        return h - 1;
      };
      switch (i) {
        case "M":
          return et(Ke(Je.month, n), c);
        case "MM":
          return et(Qe(2, n), c);
        case "Mo":
          return et(l.ordinalNumber(n, {
            unit: "month"
          }), c);
        case "MMM":
          return l.month(n, {
            width: "abbreviated",
            context: "formatting"
          }) || l.month(n, {
            width: "narrow",
            context: "formatting"
          });
        case "MMMMM":
          return l.month(n, {
            width: "narrow",
            context: "formatting"
          });
        case "MMMM":
        default:
          return l.month(n, {
            width: "wide",
            context: "formatting"
          }) || l.month(n, {
            width: "abbreviated",
            context: "formatting"
          }) || l.month(n, {
            width: "narrow",
            context: "formatting"
          });
      }
    }
  }, {
    key: "validate",
    value: function(n, i) {
      return i >= 0 && i <= 11;
    }
  }, {
    key: "set",
    value: function(n, i, l) {
      return n.setUTCMonth(l, 1), n.setUTCHours(0, 0, 0, 0), n;
    }
  }]), a;
}($e), pF = /* @__PURE__ */ function(e) {
  je(a, e);
  var t = Ve(a);
  function a() {
    var o;
    Be(this, a);
    for (var n = arguments.length, i = new Array(n), l = 0; l < n; l++)
      i[l] = arguments[l];
    return o = t.call.apply(t, [this].concat(i)), ye(fe(o), "priority", 110), ye(fe(o), "incompatibleTokens", ["Y", "R", "q", "Q", "M", "w", "I", "D", "i", "e", "c", "t", "T"]), o;
  }
  return ze(a, [{
    key: "parse",
    value: function(n, i, l) {
      var c = function(h) {
        return h - 1;
      };
      switch (i) {
        case "L":
          return et(Ke(Je.month, n), c);
        case "LL":
          return et(Qe(2, n), c);
        case "Lo":
          return et(l.ordinalNumber(n, {
            unit: "month"
          }), c);
        case "LLL":
          return l.month(n, {
            width: "abbreviated",
            context: "standalone"
          }) || l.month(n, {
            width: "narrow",
            context: "standalone"
          });
        case "LLLLL":
          return l.month(n, {
            width: "narrow",
            context: "standalone"
          });
        case "LLLL":
        default:
          return l.month(n, {
            width: "wide",
            context: "standalone"
          }) || l.month(n, {
            width: "abbreviated",
            context: "standalone"
          }) || l.month(n, {
            width: "narrow",
            context: "standalone"
          });
      }
    }
  }, {
    key: "validate",
    value: function(n, i) {
      return i >= 0 && i <= 11;
    }
  }, {
    key: "set",
    value: function(n, i, l) {
      return n.setUTCMonth(l, 1), n.setUTCHours(0, 0, 0, 0), n;
    }
  }]), a;
}($e);
function yF(e, t, a) {
  ve(2, arguments);
  var o = xe(e), n = we(t), i = dL(o, a) - n;
  return o.setUTCDate(o.getUTCDate() - i * 7), o;
}
var kF = /* @__PURE__ */ function(e) {
  je(a, e);
  var t = Ve(a);
  function a() {
    var o;
    Be(this, a);
    for (var n = arguments.length, i = new Array(n), l = 0; l < n; l++)
      i[l] = arguments[l];
    return o = t.call.apply(t, [this].concat(i)), ye(fe(o), "priority", 100), ye(fe(o), "incompatibleTokens", ["y", "R", "u", "q", "Q", "M", "L", "I", "d", "D", "i", "t", "T"]), o;
  }
  return ze(a, [{
    key: "parse",
    value: function(n, i, l) {
      switch (i) {
        case "w":
          return Ke(Je.week, n);
        case "wo":
          return l.ordinalNumber(n, {
            unit: "week"
          });
        default:
          return Qe(i.length, n);
      }
    }
  }, {
    key: "validate",
    value: function(n, i) {
      return i >= 1 && i <= 53;
    }
  }, {
    key: "set",
    value: function(n, i, l, c) {
      return wr(yF(n, l, c), c);
    }
  }]), a;
}($e);
function fF(e, t) {
  ve(2, arguments);
  var a = xe(e), o = we(t), n = cL(a) - o;
  return a.setUTCDate(a.getUTCDate() - n * 7), a;
}
var vF = /* @__PURE__ */ function(e) {
  je(a, e);
  var t = Ve(a);
  function a() {
    var o;
    Be(this, a);
    for (var n = arguments.length, i = new Array(n), l = 0; l < n; l++)
      i[l] = arguments[l];
    return o = t.call.apply(t, [this].concat(i)), ye(fe(o), "priority", 100), ye(fe(o), "incompatibleTokens", ["y", "Y", "u", "q", "Q", "M", "L", "w", "d", "D", "e", "c", "t", "T"]), o;
  }
  return ze(a, [{
    key: "parse",
    value: function(n, i, l) {
      switch (i) {
        case "I":
          return Ke(Je.week, n);
        case "Io":
          return l.ordinalNumber(n, {
            unit: "week"
          });
        default:
          return Qe(i.length, n);
      }
    }
  }, {
    key: "validate",
    value: function(n, i) {
      return i >= 1 && i <= 53;
    }
  }, {
    key: "set",
    value: function(n, i, l) {
      return zr(fF(n, l));
    }
  }]), a;
}($e), mF = [31, 28, 31, 30, 31, 30, 31, 31, 30, 31, 30, 31], gF = [31, 29, 31, 30, 31, 30, 31, 31, 30, 31, 30, 31], MF = /* @__PURE__ */ function(e) {
  je(a, e);
  var t = Ve(a);
  function a() {
    var o;
    Be(this, a);
    for (var n = arguments.length, i = new Array(n), l = 0; l < n; l++)
      i[l] = arguments[l];
    return o = t.call.apply(t, [this].concat(i)), ye(fe(o), "priority", 90), ye(fe(o), "subPriority", 1), ye(fe(o), "incompatibleTokens", ["Y", "R", "q", "Q", "w", "I", "D", "i", "e", "c", "t", "T"]), o;
  }
  return ze(a, [{
    key: "parse",
    value: function(n, i, l) {
      switch (i) {
        case "d":
          return Ke(Je.date, n);
        case "do":
          return l.ordinalNumber(n, {
            unit: "date"
          });
        default:
          return Qe(i.length, n);
      }
    }
  }, {
    key: "validate",
    value: function(n, i) {
      var l = n.getUTCFullYear(), c = gL(l), s = n.getUTCMonth();
      return c ? i >= 1 && i <= gF[s] : i >= 1 && i <= mF[s];
    }
  }, {
    key: "set",
    value: function(n, i, l) {
      return n.setUTCDate(l), n.setUTCHours(0, 0, 0, 0), n;
    }
  }]), a;
}($e), xF = /* @__PURE__ */ function(e) {
  je(a, e);
  var t = Ve(a);
  function a() {
    var o;
    Be(this, a);
    for (var n = arguments.length, i = new Array(n), l = 0; l < n; l++)
      i[l] = arguments[l];
    return o = t.call.apply(t, [this].concat(i)), ye(fe(o), "priority", 90), ye(fe(o), "subpriority", 1), ye(fe(o), "incompatibleTokens", ["Y", "R", "q", "Q", "M", "L", "w", "I", "d", "E", "i", "e", "c", "t", "T"]), o;
  }
  return ze(a, [{
    key: "parse",
    value: function(n, i, l) {
      switch (i) {
        case "D":
        case "DD":
          return Ke(Je.dayOfYear, n);
        case "Do":
          return l.ordinalNumber(n, {
            unit: "date"
          });
        default:
          return Qe(i.length, n);
      }
    }
  }, {
    key: "validate",
    value: function(n, i) {
      var l = n.getUTCFullYear(), c = gL(l);
      return c ? i >= 1 && i <= 366 : i >= 1 && i <= 365;
    }
  }, {
    key: "set",
    value: function(n, i, l) {
      return n.setUTCMonth(0, l), n.setUTCHours(0, 0, 0, 0), n;
    }
  }]), a;
}($e);
function vb(e, t, a) {
  var o, n, i, l, c, s, h, m;
  ve(2, arguments);
  var p = Ut(), f = we((o = (n = (i = (l = a == null ? void 0 : a.weekStartsOn) !== null && l !== void 0 ? l : a == null || (c = a.locale) === null || c === void 0 || (s = c.options) === null || s === void 0 ? void 0 : s.weekStartsOn) !== null && i !== void 0 ? i : p.weekStartsOn) !== null && n !== void 0 ? n : (h = p.locale) === null || h === void 0 || (m = h.options) === null || m === void 0 ? void 0 : m.weekStartsOn) !== null && o !== void 0 ? o : 0);
  if (!(f >= 0 && f <= 6))
    throw new RangeError("weekStartsOn must be between 0 and 6 inclusively");
  var g = xe(e), w = we(t), q = g.getUTCDay(), _ = w % 7, b = (_ + 7) % 7, L = (b < f ? 7 : 0) + w - q;
  return g.setUTCDate(g.getUTCDate() + L), g;
}
var bF = /* @__PURE__ */ function(e) {
  je(a, e);
  var t = Ve(a);
  function a() {
    var o;
    Be(this, a);
    for (var n = arguments.length, i = new Array(n), l = 0; l < n; l++)
      i[l] = arguments[l];
    return o = t.call.apply(t, [this].concat(i)), ye(fe(o), "priority", 90), ye(fe(o), "incompatibleTokens", ["D", "i", "e", "c", "t", "T"]), o;
  }
  return ze(a, [{
    key: "parse",
    value: function(n, i, l) {
      switch (i) {
        case "E":
        case "EE":
        case "EEE":
          return l.day(n, {
            width: "abbreviated",
            context: "formatting"
          }) || l.day(n, {
            width: "short",
            context: "formatting"
          }) || l.day(n, {
            width: "narrow",
            context: "formatting"
          });
        case "EEEEE":
          return l.day(n, {
            width: "narrow",
            context: "formatting"
          });
        case "EEEEEE":
          return l.day(n, {
            width: "short",
            context: "formatting"
          }) || l.day(n, {
            width: "narrow",
            context: "formatting"
          });
        case "EEEE":
        default:
          return l.day(n, {
            width: "wide",
            context: "formatting"
          }) || l.day(n, {
            width: "abbreviated",
            context: "formatting"
          }) || l.day(n, {
            width: "short",
            context: "formatting"
          }) || l.day(n, {
            width: "narrow",
            context: "formatting"
          });
      }
    }
  }, {
    key: "validate",
    value: function(n, i) {
      return i >= 0 && i <= 6;
    }
  }, {
    key: "set",
    value: function(n, i, l, c) {
      return n = vb(n, l, c), n.setUTCHours(0, 0, 0, 0), n;
    }
  }]), a;
}($e), wF = /* @__PURE__ */ function(e) {
  je(a, e);
  var t = Ve(a);
  function a() {
    var o;
    Be(this, a);
    for (var n = arguments.length, i = new Array(n), l = 0; l < n; l++)
      i[l] = arguments[l];
    return o = t.call.apply(t, [this].concat(i)), ye(fe(o), "priority", 90), ye(fe(o), "incompatibleTokens", ["y", "R", "u", "q", "Q", "M", "L", "I", "d", "D", "E", "i", "c", "t", "T"]), o;
  }
  return ze(a, [{
    key: "parse",
    value: function(n, i, l, c) {
      var s = function(m) {
        var p = Math.floor((m - 1) / 7) * 7;
        return (m + c.weekStartsOn + 6) % 7 + p;
      };
      switch (i) {
        case "e":
        case "ee":
          return et(Qe(i.length, n), s);
        case "eo":
          return et(l.ordinalNumber(n, {
            unit: "day"
          }), s);
        case "eee":
          return l.day(n, {
            width: "abbreviated",
            context: "formatting"
          }) || l.day(n, {
            width: "short",
            context: "formatting"
          }) || l.day(n, {
            width: "narrow",
            context: "formatting"
          });
        case "eeeee":
          return l.day(n, {
            width: "narrow",
            context: "formatting"
          });
        case "eeeeee":
          return l.day(n, {
            width: "short",
            context: "formatting"
          }) || l.day(n, {
            width: "narrow",
            context: "formatting"
          });
        case "eeee":
        default:
          return l.day(n, {
            width: "wide",
            context: "formatting"
          }) || l.day(n, {
            width: "abbreviated",
            context: "formatting"
          }) || l.day(n, {
            width: "short",
            context: "formatting"
          }) || l.day(n, {
            width: "narrow",
            context: "formatting"
          });
      }
    }
  }, {
    key: "validate",
    value: function(n, i) {
      return i >= 0 && i <= 6;
    }
  }, {
    key: "set",
    value: function(n, i, l, c) {
      return n = vb(n, l, c), n.setUTCHours(0, 0, 0, 0), n;
    }
  }]), a;
}($e), IF = /* @__PURE__ */ function(e) {
  je(a, e);
  var t = Ve(a);
  function a() {
    var o;
    Be(this, a);
    for (var n = arguments.length, i = new Array(n), l = 0; l < n; l++)
      i[l] = arguments[l];
    return o = t.call.apply(t, [this].concat(i)), ye(fe(o), "priority", 90), ye(fe(o), "incompatibleTokens", ["y", "R", "u", "q", "Q", "M", "L", "I", "d", "D", "E", "i", "e", "t", "T"]), o;
  }
  return ze(a, [{
    key: "parse",
    value: function(n, i, l, c) {
      var s = function(m) {
        var p = Math.floor((m - 1) / 7) * 7;
        return (m + c.weekStartsOn + 6) % 7 + p;
      };
      switch (i) {
        case "c":
        case "cc":
          return et(Qe(i.length, n), s);
        case "co":
          return et(l.ordinalNumber(n, {
            unit: "day"
          }), s);
        case "ccc":
          return l.day(n, {
            width: "abbreviated",
            context: "standalone"
          }) || l.day(n, {
            width: "short",
            context: "standalone"
          }) || l.day(n, {
            width: "narrow",
            context: "standalone"
          });
        case "ccccc":
          return l.day(n, {
            width: "narrow",
            context: "standalone"
          });
        case "cccccc":
          return l.day(n, {
            width: "short",
            context: "standalone"
          }) || l.day(n, {
            width: "narrow",
            context: "standalone"
          });
        case "cccc":
        default:
          return l.day(n, {
            width: "wide",
            context: "standalone"
          }) || l.day(n, {
            width: "abbreviated",
            context: "standalone"
          }) || l.day(n, {
            width: "short",
            context: "standalone"
          }) || l.day(n, {
            width: "narrow",
            context: "standalone"
          });
      }
    }
  }, {
    key: "validate",
    value: function(n, i) {
      return i >= 0 && i <= 6;
    }
  }, {
    key: "set",
    value: function(n, i, l, c) {
      return n = vb(n, l, c), n.setUTCHours(0, 0, 0, 0), n;
    }
  }]), a;
}($e);
function LF(e, t) {
  ve(2, arguments);
  var a = we(t);
  a % 7 === 0 && (a = a - 7);
  var o = 1, n = xe(e), i = n.getUTCDay(), l = a % 7, c = (l + 7) % 7, s = (c < o ? 7 : 0) + a - i;
  return n.setUTCDate(n.getUTCDate() + s), n;
}
var SF = /* @__PURE__ */ function(e) {
  je(a, e);
  var t = Ve(a);
  function a() {
    var o;
    Be(this, a);
    for (var n = arguments.length, i = new Array(n), l = 0; l < n; l++)
      i[l] = arguments[l];
    return o = t.call.apply(t, [this].concat(i)), ye(fe(o), "priority", 90), ye(fe(o), "incompatibleTokens", ["y", "Y", "u", "q", "Q", "M", "L", "w", "d", "D", "E", "e", "c", "t", "T"]), o;
  }
  return ze(a, [{
    key: "parse",
    value: function(n, i, l) {
      var c = function(h) {
        return h === 0 ? 7 : h;
      };
      switch (i) {
        case "i":
        case "ii":
          return Qe(i.length, n);
        case "io":
          return l.ordinalNumber(n, {
            unit: "day"
          });
        case "iii":
          return et(l.day(n, {
            width: "abbreviated",
            context: "formatting"
          }) || l.day(n, {
            width: "short",
            context: "formatting"
          }) || l.day(n, {
            width: "narrow",
            context: "formatting"
          }), c);
        case "iiiii":
          return et(l.day(n, {
            width: "narrow",
            context: "formatting"
          }), c);
        case "iiiiii":
          return et(l.day(n, {
            width: "short",
            context: "formatting"
          }) || l.day(n, {
            width: "narrow",
            context: "formatting"
          }), c);
        case "iiii":
        default:
          return et(l.day(n, {
            width: "wide",
            context: "formatting"
          }) || l.day(n, {
            width: "abbreviated",
            context: "formatting"
          }) || l.day(n, {
            width: "short",
            context: "formatting"
          }) || l.day(n, {
            width: "narrow",
            context: "formatting"
          }), c);
      }
    }
  }, {
    key: "validate",
    value: function(n, i) {
      return i >= 1 && i <= 7;
    }
  }, {
    key: "set",
    value: function(n, i, l) {
      return n = LF(n, l), n.setUTCHours(0, 0, 0, 0), n;
    }
  }]), a;
}($e), CF = /* @__PURE__ */ function(e) {
  je(a, e);
  var t = Ve(a);
  function a() {
    var o;
    Be(this, a);
    for (var n = arguments.length, i = new Array(n), l = 0; l < n; l++)
      i[l] = arguments[l];
    return o = t.call.apply(t, [this].concat(i)), ye(fe(o), "priority", 80), ye(fe(o), "incompatibleTokens", ["b", "B", "H", "k", "t", "T"]), o;
  }
  return ze(a, [{
    key: "parse",
    value: function(n, i, l) {
      switch (i) {
        case "a":
        case "aa":
        case "aaa":
          return l.dayPeriod(n, {
            width: "abbreviated",
            context: "formatting"
          }) || l.dayPeriod(n, {
            width: "narrow",
            context: "formatting"
          });
        case "aaaaa":
          return l.dayPeriod(n, {
            width: "narrow",
            context: "formatting"
          });
        case "aaaa":
        default:
          return l.dayPeriod(n, {
            width: "wide",
            context: "formatting"
          }) || l.dayPeriod(n, {
            width: "abbreviated",
            context: "formatting"
          }) || l.dayPeriod(n, {
            width: "narrow",
            context: "formatting"
          });
      }
    }
  }, {
    key: "set",
    value: function(n, i, l) {
      return n.setUTCHours(fb(l), 0, 0, 0), n;
    }
  }]), a;
}($e), AF = /* @__PURE__ */ function(e) {
  je(a, e);
  var t = Ve(a);
  function a() {
    var o;
    Be(this, a);
    for (var n = arguments.length, i = new Array(n), l = 0; l < n; l++)
      i[l] = arguments[l];
    return o = t.call.apply(t, [this].concat(i)), ye(fe(o), "priority", 80), ye(fe(o), "incompatibleTokens", ["a", "B", "H", "k", "t", "T"]), o;
  }
  return ze(a, [{
    key: "parse",
    value: function(n, i, l) {
      switch (i) {
        case "b":
        case "bb":
        case "bbb":
          return l.dayPeriod(n, {
            width: "abbreviated",
            context: "formatting"
          }) || l.dayPeriod(n, {
            width: "narrow",
            context: "formatting"
          });
        case "bbbbb":
          return l.dayPeriod(n, {
            width: "narrow",
            context: "formatting"
          });
        case "bbbb":
        default:
          return l.dayPeriod(n, {
            width: "wide",
            context: "formatting"
          }) || l.dayPeriod(n, {
            width: "abbreviated",
            context: "formatting"
          }) || l.dayPeriod(n, {
            width: "narrow",
            context: "formatting"
          });
      }
    }
  }, {
    key: "set",
    value: function(n, i, l) {
      return n.setUTCHours(fb(l), 0, 0, 0), n;
    }
  }]), a;
}($e), PF = /* @__PURE__ */ function(e) {
  je(a, e);
  var t = Ve(a);
  function a() {
    var o;
    Be(this, a);
    for (var n = arguments.length, i = new Array(n), l = 0; l < n; l++)
      i[l] = arguments[l];
    return o = t.call.apply(t, [this].concat(i)), ye(fe(o), "priority", 80), ye(fe(o), "incompatibleTokens", ["a", "b", "t", "T"]), o;
  }
  return ze(a, [{
    key: "parse",
    value: function(n, i, l) {
      switch (i) {
        case "B":
        case "BB":
        case "BBB":
          return l.dayPeriod(n, {
            width: "abbreviated",
            context: "formatting"
          }) || l.dayPeriod(n, {
            width: "narrow",
            context: "formatting"
          });
        case "BBBBB":
          return l.dayPeriod(n, {
            width: "narrow",
            context: "formatting"
          });
        case "BBBB":
        default:
          return l.dayPeriod(n, {
            width: "wide",
            context: "formatting"
          }) || l.dayPeriod(n, {
            width: "abbreviated",
            context: "formatting"
          }) || l.dayPeriod(n, {
            width: "narrow",
            context: "formatting"
          });
      }
    }
  }, {
    key: "set",
    value: function(n, i, l) {
      return n.setUTCHours(fb(l), 0, 0, 0), n;
    }
  }]), a;
}($e), qF = /* @__PURE__ */ function(e) {
  je(a, e);
  var t = Ve(a);
  function a() {
    var o;
    Be(this, a);
    for (var n = arguments.length, i = new Array(n), l = 0; l < n; l++)
      i[l] = arguments[l];
    return o = t.call.apply(t, [this].concat(i)), ye(fe(o), "priority", 70), ye(fe(o), "incompatibleTokens", ["H", "K", "k", "t", "T"]), o;
  }
  return ze(a, [{
    key: "parse",
    value: function(n, i, l) {
      switch (i) {
        case "h":
          return Ke(Je.hour12h, n);
        case "ho":
          return l.ordinalNumber(n, {
            unit: "hour"
          });
        default:
          return Qe(i.length, n);
      }
    }
  }, {
    key: "validate",
    value: function(n, i) {
      return i >= 1 && i <= 12;
    }
  }, {
    key: "set",
    value: function(n, i, l) {
      var c = n.getUTCHours() >= 12;
      return c && l < 12 ? n.setUTCHours(l + 12, 0, 0, 0) : !c && l === 12 ? n.setUTCHours(0, 0, 0, 0) : n.setUTCHours(l, 0, 0, 0), n;
    }
  }]), a;
}($e), TF = /* @__PURE__ */ function(e) {
  je(a, e);
  var t = Ve(a);
  function a() {
    var o;
    Be(this, a);
    for (var n = arguments.length, i = new Array(n), l = 0; l < n; l++)
      i[l] = arguments[l];
    return o = t.call.apply(t, [this].concat(i)), ye(fe(o), "priority", 70), ye(fe(o), "incompatibleTokens", ["a", "b", "h", "K", "k", "t", "T"]), o;
  }
  return ze(a, [{
    key: "parse",
    value: function(n, i, l) {
      switch (i) {
        case "H":
          return Ke(Je.hour23h, n);
        case "Ho":
          return l.ordinalNumber(n, {
            unit: "hour"
          });
        default:
          return Qe(i.length, n);
      }
    }
  }, {
    key: "validate",
    value: function(n, i) {
      return i >= 0 && i <= 23;
    }
  }, {
    key: "set",
    value: function(n, i, l) {
      return n.setUTCHours(l, 0, 0, 0), n;
    }
  }]), a;
}($e), DF = /* @__PURE__ */ function(e) {
  je(a, e);
  var t = Ve(a);
  function a() {
    var o;
    Be(this, a);
    for (var n = arguments.length, i = new Array(n), l = 0; l < n; l++)
      i[l] = arguments[l];
    return o = t.call.apply(t, [this].concat(i)), ye(fe(o), "priority", 70), ye(fe(o), "incompatibleTokens", ["h", "H", "k", "t", "T"]), o;
  }
  return ze(a, [{
    key: "parse",
    value: function(n, i, l) {
      switch (i) {
        case "K":
          return Ke(Je.hour11h, n);
        case "Ko":
          return l.ordinalNumber(n, {
            unit: "hour"
          });
        default:
          return Qe(i.length, n);
      }
    }
  }, {
    key: "validate",
    value: function(n, i) {
      return i >= 0 && i <= 11;
    }
  }, {
    key: "set",
    value: function(n, i, l) {
      var c = n.getUTCHours() >= 12;
      return c && l < 12 ? n.setUTCHours(l + 12, 0, 0, 0) : n.setUTCHours(l, 0, 0, 0), n;
    }
  }]), a;
}($e), _F = /* @__PURE__ */ function(e) {
  je(a, e);
  var t = Ve(a);
  function a() {
    var o;
    Be(this, a);
    for (var n = arguments.length, i = new Array(n), l = 0; l < n; l++)
      i[l] = arguments[l];
    return o = t.call.apply(t, [this].concat(i)), ye(fe(o), "priority", 70), ye(fe(o), "incompatibleTokens", ["a", "b", "h", "H", "K", "t", "T"]), o;
  }
  return ze(a, [{
    key: "parse",
    value: function(n, i, l) {
      switch (i) {
        case "k":
          return Ke(Je.hour24h, n);
        case "ko":
          return l.ordinalNumber(n, {
            unit: "hour"
          });
        default:
          return Qe(i.length, n);
      }
    }
  }, {
    key: "validate",
    value: function(n, i) {
      return i >= 1 && i <= 24;
    }
  }, {
    key: "set",
    value: function(n, i, l) {
      var c = l <= 24 ? l % 24 : l;
      return n.setUTCHours(c, 0, 0, 0), n;
    }
  }]), a;
}($e), BF = /* @__PURE__ */ function(e) {
  je(a, e);
  var t = Ve(a);
  function a() {
    var o;
    Be(this, a);
    for (var n = arguments.length, i = new Array(n), l = 0; l < n; l++)
      i[l] = arguments[l];
    return o = t.call.apply(t, [this].concat(i)), ye(fe(o), "priority", 60), ye(fe(o), "incompatibleTokens", ["t", "T"]), o;
  }
  return ze(a, [{
    key: "parse",
    value: function(n, i, l) {
      switch (i) {
        case "m":
          return Ke(Je.minute, n);
        case "mo":
          return l.ordinalNumber(n, {
            unit: "minute"
          });
        default:
          return Qe(i.length, n);
      }
    }
  }, {
    key: "validate",
    value: function(n, i) {
      return i >= 0 && i <= 59;
    }
  }, {
    key: "set",
    value: function(n, i, l) {
      return n.setUTCMinutes(l, 0, 0), n;
    }
  }]), a;
}($e), zF = /* @__PURE__ */ function(e) {
  je(a, e);
  var t = Ve(a);
  function a() {
    var o;
    Be(this, a);
    for (var n = arguments.length, i = new Array(n), l = 0; l < n; l++)
      i[l] = arguments[l];
    return o = t.call.apply(t, [this].concat(i)), ye(fe(o), "priority", 50), ye(fe(o), "incompatibleTokens", ["t", "T"]), o;
  }
  return ze(a, [{
    key: "parse",
    value: function(n, i, l) {
      switch (i) {
        case "s":
          return Ke(Je.second, n);
        case "so":
          return l.ordinalNumber(n, {
            unit: "second"
          });
        default:
          return Qe(i.length, n);
      }
    }
  }, {
    key: "validate",
    value: function(n, i) {
      return i >= 0 && i <= 59;
    }
  }, {
    key: "set",
    value: function(n, i, l) {
      return n.setUTCSeconds(l, 0), n;
    }
  }]), a;
}($e), HF = /* @__PURE__ */ function(e) {
  je(a, e);
  var t = Ve(a);
  function a() {
    var o;
    Be(this, a);
    for (var n = arguments.length, i = new Array(n), l = 0; l < n; l++)
      i[l] = arguments[l];
    return o = t.call.apply(t, [this].concat(i)), ye(fe(o), "priority", 30), ye(fe(o), "incompatibleTokens", ["t", "T"]), o;
  }
  return ze(a, [{
    key: "parse",
    value: function(n, i) {
      var l = function(s) {
        return Math.floor(s * Math.pow(10, -i.length + 3));
      };
      return et(Qe(i.length, n), l);
    }
  }, {
    key: "set",
    value: function(n, i, l) {
      return n.setUTCMilliseconds(l), n;
    }
  }]), a;
}($e), jF = /* @__PURE__ */ function(e) {
  je(a, e);
  var t = Ve(a);
  function a() {
    var o;
    Be(this, a);
    for (var n = arguments.length, i = new Array(n), l = 0; l < n; l++)
      i[l] = arguments[l];
    return o = t.call.apply(t, [this].concat(i)), ye(fe(o), "priority", 10), ye(fe(o), "incompatibleTokens", ["t", "T", "x"]), o;
  }
  return ze(a, [{
    key: "parse",
    value: function(n, i) {
      switch (i) {
        case "X":
          return Vt(jt.basicOptionalMinutes, n);
        case "XX":
          return Vt(jt.basic, n);
        case "XXXX":
          return Vt(jt.basicOptionalSeconds, n);
        case "XXXXX":
          return Vt(jt.extendedOptionalSeconds, n);
        case "XXX":
        default:
          return Vt(jt.extended, n);
      }
    }
  }, {
    key: "set",
    value: function(n, i, l) {
      return i.timestampIsSet ? n : new Date(n.getTime() - l);
    }
  }]), a;
}($e), VF = /* @__PURE__ */ function(e) {
  je(a, e);
  var t = Ve(a);
  function a() {
    var o;
    Be(this, a);
    for (var n = arguments.length, i = new Array(n), l = 0; l < n; l++)
      i[l] = arguments[l];
    return o = t.call.apply(t, [this].concat(i)), ye(fe(o), "priority", 10), ye(fe(o), "incompatibleTokens", ["t", "T", "X"]), o;
  }
  return ze(a, [{
    key: "parse",
    value: function(n, i) {
      switch (i) {
        case "x":
          return Vt(jt.basicOptionalMinutes, n);
        case "xx":
          return Vt(jt.basic, n);
        case "xxxx":
          return Vt(jt.basicOptionalSeconds, n);
        case "xxxxx":
          return Vt(jt.extendedOptionalSeconds, n);
        case "xxx":
        default:
          return Vt(jt.extended, n);
      }
    }
  }, {
    key: "set",
    value: function(n, i, l) {
      return i.timestampIsSet ? n : new Date(n.getTime() - l);
    }
  }]), a;
}($e), OF = /* @__PURE__ */ function(e) {
  je(a, e);
  var t = Ve(a);
  function a() {
    var o;
    Be(this, a);
    for (var n = arguments.length, i = new Array(n), l = 0; l < n; l++)
      i[l] = arguments[l];
    return o = t.call.apply(t, [this].concat(i)), ye(fe(o), "priority", 40), ye(fe(o), "incompatibleTokens", "*"), o;
  }
  return ze(a, [{
    key: "parse",
    value: function(n) {
      return vL(n);
    }
  }, {
    key: "set",
    value: function(n, i, l) {
      return [new Date(l * 1e3), {
        timestampIsSet: !0
      }];
    }
  }]), a;
}($e), $F = /* @__PURE__ */ function(e) {
  je(a, e);
  var t = Ve(a);
  function a() {
    var o;
    Be(this, a);
    for (var n = arguments.length, i = new Array(n), l = 0; l < n; l++)
      i[l] = arguments[l];
    return o = t.call.apply(t, [this].concat(i)), ye(fe(o), "priority", 20), ye(fe(o), "incompatibleTokens", "*"), o;
  }
  return ze(a, [{
    key: "parse",
    value: function(n) {
      return vL(n);
    }
  }, {
    key: "set",
    value: function(n, i, l) {
      return [new Date(l), {
        timestampIsSet: !0
      }];
    }
  }]), a;
}($e), RF = {
  G: new rF(),
  y: new iF(),
  Y: new lF(),
  R: new cF(),
  u: new dF(),
  Q: new sF(),
  q: new uF(),
  M: new hF(),
  L: new pF(),
  w: new kF(),
  I: new vF(),
  d: new MF(),
  D: new xF(),
  E: new bF(),
  e: new wF(),
  c: new IF(),
  i: new SF(),
  a: new CF(),
  b: new AF(),
  B: new PF(),
  h: new qF(),
  H: new TF(),
  K: new DF(),
  k: new _F(),
  m: new BF(),
  s: new zF(),
  S: new HF(),
  X: new jF(),
  x: new VF(),
  t: new OF(),
  T: new $F()
}, FF = /[yYQqMLwIdDecihHKkms]o|(\w)\1*|''|'(''|[^'])+('|$)|./g, UF = /P+p+|P+|p+|''|'(''|[^'])+('|$)|./g, EF = /^'([^]*?)'?$/, WF = /''/g, NF = /\S/, ZF = /[a-zA-Z]/;
function H9(e, t, a, o) {
  var n, i, l, c, s, h, m, p, f, g, w, q, _, b, L, j, I, C;
  ve(3, arguments);
  var B = String(e), U = String(t), de = Ut(), ae = (n = (i = o == null ? void 0 : o.locale) !== null && i !== void 0 ? i : de.locale) !== null && n !== void 0 ? n : pL;
  if (!ae.match)
    throw new RangeError("locale must contain match property");
  var S = we((l = (c = (s = (h = o == null ? void 0 : o.firstWeekContainsDate) !== null && h !== void 0 ? h : o == null || (m = o.locale) === null || m === void 0 || (p = m.options) === null || p === void 0 ? void 0 : p.firstWeekContainsDate) !== null && s !== void 0 ? s : de.firstWeekContainsDate) !== null && c !== void 0 ? c : (f = de.locale) === null || f === void 0 || (g = f.options) === null || g === void 0 ? void 0 : g.firstWeekContainsDate) !== null && l !== void 0 ? l : 1);
  if (!(S >= 1 && S <= 7))
    throw new RangeError("firstWeekContainsDate must be between 1 and 7 inclusively");
  var V = we((w = (q = (_ = (b = o == null ? void 0 : o.weekStartsOn) !== null && b !== void 0 ? b : o == null || (L = o.locale) === null || L === void 0 || (j = L.options) === null || j === void 0 ? void 0 : j.weekStartsOn) !== null && _ !== void 0 ? _ : de.weekStartsOn) !== null && q !== void 0 ? q : (I = de.locale) === null || I === void 0 || (C = I.options) === null || C === void 0 ? void 0 : C.weekStartsOn) !== null && w !== void 0 ? w : 0);
  if (!(V >= 0 && V <= 6))
    throw new RangeError("weekStartsOn must be between 0 and 6 inclusively");
  if (U === "")
    return B === "" ? xe(a) : /* @__PURE__ */ new Date(NaN);
  var Z = {
    firstWeekContainsDate: S,
    weekStartsOn: V,
    locale: ae
  }, re = [new oF()], F = U.match(UF).map(function(ce) {
    var K = ce[0];
    if (K in B9) {
      var me = B9[K];
      return me(ce, ae.formatLong);
    }
    return ce;
  }).join("").match(FF), A = [], $ = jw(F), R;
  try {
    var J = function() {
      var K = R.value;
      !(o != null && o.useAdditionalWeekYearTokens) && hL(K) && Cx(K, U, e), !(o != null && o.useAdditionalDayOfYearTokens) && uL(K) && Cx(K, U, e);
      var me = K[0], he = RF[me];
      if (he) {
        var Y = he.incompatibleTokens;
        if (Array.isArray(Y)) {
          var oe = A.find(function(ue) {
            return Y.includes(ue.token) || ue.token === me;
          });
          if (oe)
            throw new RangeError("The format string mustn't contain `".concat(oe.fullToken, "` and `").concat(K, "` at the same time"));
        } else if (he.incompatibleTokens === "*" && A.length > 0)
          throw new RangeError("The format string mustn't contain `".concat(K, "` and any other token at the same time"));
        A.push({
          token: me,
          fullToken: K
        });
        var Me = he.run(B, K, ae.match, Z);
        if (!Me)
          return {
            v: /* @__PURE__ */ new Date(NaN)
          };
        re.push(Me.setter), B = Me.rest;
      } else {
        if (me.match(ZF))
          throw new RangeError("Format string contains an unescaped latin alphabet character `" + me + "`");
        if (K === "''" ? K = "'" : me === "'" && (K = YF(K)), B.indexOf(K) === 0)
          B = B.slice(K.length);
        else
          return {
            v: /* @__PURE__ */ new Date(NaN)
          };
      }
    };
    for ($.s(); !(R = $.n()).done; ) {
      var M = J();
      if (It(M) === "object")
        return M.v;
    }
  } catch (ce) {
    $.e(ce);
  } finally {
    $.f();
  }
  if (B.length > 0 && NF.test(B))
    return /* @__PURE__ */ new Date(NaN);
  var k = re.map(function(ce) {
    return ce.priority;
  }).sort(function(ce, K) {
    return K - ce;
  }).filter(function(ce, K, me) {
    return me.indexOf(ce) === K;
  }).map(function(ce) {
    return re.filter(function(K) {
      return K.priority === ce;
    }).sort(function(K, me) {
      return me.subPriority - K.subPriority;
    });
  }).map(function(ce) {
    return ce[0];
  }), O = xe(a);
  if (isNaN(O.getTime()))
    return /* @__PURE__ */ new Date(NaN);
  var E = iL(O, Sx(O)), te = {}, se = jw(k), T;
  try {
    for (se.s(); !(T = se.n()).done; ) {
      var x = T.value;
      if (!x.validate(E, Z))
        return /* @__PURE__ */ new Date(NaN);
      var ie = x.set(E, te, Z);
      Array.isArray(ie) ? (E = ie[0], ER(te, ie[1])) : E = ie;
    }
  } catch (ce) {
    se.e(ce);
  } finally {
    se.f();
  }
  return E;
}
function YF(e) {
  return e.match(EF)[1].replace(WF, "'");
}
function Ow(e, t) {
  ve(2, arguments);
  var a = l1(e), o = l1(t);
  return a.getTime() === o.getTime();
}
function GF(e, t) {
  ve(2, arguments);
  var a = we(t);
  return Wt(e, -a);
}
function XF(e, t) {
  var a;
  ve(1, arguments);
  var o = we((a = t == null ? void 0 : t.additionalDigits) !== null && a !== void 0 ? a : 2);
  if (o !== 2 && o !== 1 && o !== 0)
    throw new RangeError("additionalDigits must be 0, 1 or 2");
  if (!(typeof e == "string" || Object.prototype.toString.call(e) === "[object String]"))
    return /* @__PURE__ */ new Date(NaN);
  var n = eU(e), i;
  if (n.date) {
    var l = tU(n.date, o);
    i = aU(l.restDateString, l.year);
  }
  if (!i || isNaN(i.getTime()))
    return /* @__PURE__ */ new Date(NaN);
  var c = i.getTime(), s = 0, h;
  if (n.time && (s = nU(n.time), isNaN(s)))
    return /* @__PURE__ */ new Date(NaN);
  if (n.timezone) {
    if (h = oU(n.timezone), isNaN(h))
      return /* @__PURE__ */ new Date(NaN);
  } else {
    var m = new Date(c + s), p = /* @__PURE__ */ new Date(0);
    return p.setFullYear(m.getUTCFullYear(), m.getUTCMonth(), m.getUTCDate()), p.setHours(m.getUTCHours(), m.getUTCMinutes(), m.getUTCSeconds(), m.getUTCMilliseconds()), p;
  }
  return new Date(c + s + h);
}
var S1 = {
  dateTimeDelimiter: /[T ]/,
  timeZoneDelimiter: /[Z ]/i,
  timezone: /([Z+-].*)$/
}, KF = /^-?(?:(\d{3})|(\d{2})(?:-?(\d{2}))?|W(\d{2})(?:-?(\d{1}))?|)$/, QF = /^(\d{2}(?:[.,]\d*)?)(?::?(\d{2}(?:[.,]\d*)?))?(?::?(\d{2}(?:[.,]\d*)?))?$/, JF = /^([+-])(\d{2})(?::?(\d{2}))?$/;
function eU(e) {
  var t = {}, a = e.split(S1.dateTimeDelimiter), o;
  if (a.length > 2)
    return t;
  if (/:/.test(a[0]) ? o = a[0] : (t.date = a[0], o = a[1], S1.timeZoneDelimiter.test(t.date) && (t.date = e.split(S1.timeZoneDelimiter)[0], o = e.substr(t.date.length, e.length))), o) {
    var n = S1.timezone.exec(o);
    n ? (t.time = o.replace(n[1], ""), t.timezone = n[1]) : t.time = o;
  }
  return t;
}
function tU(e, t) {
  var a = new RegExp("^(?:(\\d{4}|[+-]\\d{" + (4 + t) + "})|(\\d{2}|[+-]\\d{" + (2 + t) + "})$)"), o = e.match(a);
  if (!o)
    return {
      year: NaN,
      restDateString: ""
    };
  var n = o[1] ? parseInt(o[1]) : null, i = o[2] ? parseInt(o[2]) : null;
  return {
    year: i === null ? n : i * 100,
    restDateString: e.slice((o[1] || o[2]).length)
  };
}
function aU(e, t) {
  if (t === null)
    return /* @__PURE__ */ new Date(NaN);
  var a = e.match(KF);
  if (!a)
    return /* @__PURE__ */ new Date(NaN);
  var o = !!a[4], n = e1(a[1]), i = e1(a[2]) - 1, l = e1(a[3]), c = e1(a[4]), s = e1(a[5]) - 1;
  if (o)
    return dU(t, c, s) ? rU(t, c, s) : /* @__PURE__ */ new Date(NaN);
  var h = /* @__PURE__ */ new Date(0);
  return !lU(t, i, l) || !cU(t, n) ? /* @__PURE__ */ new Date(NaN) : (h.setUTCFullYear(t, i, Math.max(n, l)), h);
}
function e1(e) {
  return e ? parseInt(e) : 1;
}
function nU(e) {
  var t = e.match(QF);
  if (!t)
    return NaN;
  var a = d9(t[1]), o = d9(t[2]), n = d9(t[3]);
  return sU(a, o, n) ? a * yb + o * pb + n * 1e3 : NaN;
}
function d9(e) {
  return e && parseFloat(e.replace(",", ".")) || 0;
}
function oU(e) {
  if (e === "Z")
    return 0;
  var t = e.match(JF);
  if (!t)
    return 0;
  var a = t[1] === "+" ? -1 : 1, o = parseInt(t[2]), n = t[3] && parseInt(t[3]) || 0;
  return uU(o, n) ? a * (o * yb + n * pb) : NaN;
}
function rU(e, t, a) {
  var o = /* @__PURE__ */ new Date(0);
  o.setUTCFullYear(e, 0, 4);
  var n = o.getUTCDay() || 7, i = (t - 1) * 7 + a + 1 - n;
  return o.setUTCDate(o.getUTCDate() + i), o;
}
var iU = [31, null, 31, 30, 31, 30, 31, 31, 30, 31, 30, 31];
function ML(e) {
  return e % 400 === 0 || e % 4 === 0 && e % 100 !== 0;
}
function lU(e, t, a) {
  return t >= 0 && t <= 11 && a >= 1 && a <= (iU[t] || (ML(e) ? 29 : 28));
}
function cU(e, t) {
  return t >= 1 && t <= (ML(e) ? 366 : 365);
}
function dU(e, t, a) {
  return t >= 1 && t <= 53 && a >= 0 && a <= 6;
}
function sU(e, t, a) {
  return e === 24 ? t === 0 && a === 0 : a >= 0 && a < 60 && t >= 0 && t < 60 && e >= 0 && e < 25;
}
function uU(e, t) {
  return t >= 0 && t <= 59;
}
function xL(e, t) {
  ve(2, arguments);
  var a = xe(e), o = we(t), n = a.getFullYear(), i = a.getDate(), l = /* @__PURE__ */ new Date(0);
  l.setFullYear(n, o, 15), l.setHours(0, 0, 0, 0);
  var c = NR(l);
  return a.setMonth(o, Math.min(i, c)), a;
}
function Ge(e, t) {
  if (ve(2, arguments), It(t) !== "object" || t === null)
    throw new RangeError("values parameter must be an object");
  var a = xe(e);
  return isNaN(a.getTime()) ? /* @__PURE__ */ new Date(NaN) : (t.year != null && a.setFullYear(t.year), t.month != null && (a = xL(a, t.month)), t.date != null && a.setDate(we(t.date)), t.hours != null && a.setHours(we(t.hours)), t.minutes != null && a.setMinutes(we(t.minutes)), t.seconds != null && a.setSeconds(we(t.seconds)), t.milliseconds != null && a.setMilliseconds(we(t.milliseconds)), a);
}
function bL(e, t) {
  ve(2, arguments);
  var a = xe(e), o = we(t);
  return a.setHours(o), a;
}
function mb(e, t) {
  ve(2, arguments);
  var a = xe(e), o = we(t);
  return a.setMilliseconds(o), a;
}
function wL(e, t) {
  ve(2, arguments);
  var a = xe(e), o = we(t);
  return a.setMinutes(o), a;
}
function gb(e, t) {
  ve(2, arguments);
  var a = xe(e), o = we(t);
  return a.setSeconds(o), a;
}
function Ot(e, t) {
  ve(2, arguments);
  var a = xe(e), o = we(t);
  return isNaN(a.getTime()) ? /* @__PURE__ */ new Date(NaN) : (a.setFullYear(o), a);
}
function jr(e, t) {
  ve(2, arguments);
  var a = we(t);
  return Pt(e, -a);
}
function hU(e, t) {
  if (ve(2, arguments), !t || It(t) !== "object")
    return /* @__PURE__ */ new Date(NaN);
  var a = t.years ? we(t.years) : 0, o = t.months ? we(t.months) : 0, n = t.weeks ? we(t.weeks) : 0, i = t.days ? we(t.days) : 0, l = t.hours ? we(t.hours) : 0, c = t.minutes ? we(t.minutes) : 0, s = t.seconds ? we(t.seconds) : 0, h = jr(e, o + a * 12), m = GF(h, i + n * 7), p = c + l * 60, f = s + p * 60, g = f * 1e3, w = new Date(m.getTime() - g);
  return w;
}
function IL(e, t) {
  ve(2, arguments);
  var a = we(t);
  return hb(e, -a);
}
function Gr() {
  return d(), y(
    "svg",
    {
      xmlns: "http://www.w3.org/2000/svg",
      viewBox: "0 0 32 32",
      fill: "currentColor",
      "aria-hidden": "true",
      class: "dp__icon"
    },
    [
      D("path", {
        d: "M29.333 8c0-2.208-1.792-4-4-4h-18.667c-2.208 0-4 1.792-4 4v18.667c0 2.208 1.792 4 4 4h18.667c2.208 0 4-1.792 4-4v-18.667zM26.667 8v18.667c0 0.736-0.597 1.333-1.333 1.333 0 0-18.667 0-18.667 0-0.736 0-1.333-0.597-1.333-1.333 0 0 0-18.667 0-18.667 0-0.736 0.597-1.333 1.333-1.333 0 0 18.667 0 18.667 0 0.736 0 1.333 0.597 1.333 1.333z"
      }),
      D("path", {
        d: "M20 2.667v5.333c0 0.736 0.597 1.333 1.333 1.333s1.333-0.597 1.333-1.333v-5.333c0-0.736-0.597-1.333-1.333-1.333s-1.333 0.597-1.333 1.333z"
      }),
      D("path", {
        d: "M9.333 2.667v5.333c0 0.736 0.597 1.333 1.333 1.333s1.333-0.597 1.333-1.333v-5.333c0-0.736-0.597-1.333-1.333-1.333s-1.333 0.597-1.333 1.333z"
      }),
      D("path", {
        d: "M4 14.667h24c0.736 0 1.333-0.597 1.333-1.333s-0.597-1.333-1.333-1.333h-24c-0.736 0-1.333 0.597-1.333 1.333s0.597 1.333 1.333 1.333z"
      })
    ]
  );
}
Gr.compatConfig = {
  MODE: 3
};
function LL() {
  return d(), y(
    "svg",
    {
      xmlns: "http://www.w3.org/2000/svg",
      viewBox: "0 0 32 32",
      fill: "currentColor",
      "aria-hidden": "true",
      class: "dp__icon"
    },
    [
      D("path", {
        d: "M23.057 7.057l-16 16c-0.52 0.52-0.52 1.365 0 1.885s1.365 0.52 1.885 0l16-16c0.52-0.52 0.52-1.365 0-1.885s-1.365-0.52-1.885 0z"
      }),
      D("path", {
        d: "M7.057 8.943l16 16c0.52 0.52 1.365 0.52 1.885 0s0.52-1.365 0-1.885l-16-16c-0.52-0.52-1.365-0.52-1.885 0s-0.52 1.365 0 1.885z"
      })
    ]
  );
}
LL.compatConfig = {
  MODE: 3
};
function Mb() {
  return d(), y(
    "svg",
    {
      xmlns: "http://www.w3.org/2000/svg",
      viewBox: "0 0 32 32",
      fill: "currentColor",
      "aria-hidden": "true",
      class: "dp__icon"
    },
    [
      D("path", {
        d: "M20.943 23.057l-7.057-7.057c0 0 7.057-7.057 7.057-7.057 0.52-0.52 0.52-1.365 0-1.885s-1.365-0.52-1.885 0l-8 8c-0.521 0.521-0.521 1.365 0 1.885l8 8c0.52 0.52 1.365 0.52 1.885 0s0.52-1.365 0-1.885z"
      })
    ]
  );
}
Mb.compatConfig = {
  MODE: 3
};
function xb() {
  return d(), y(
    "svg",
    {
      xmlns: "http://www.w3.org/2000/svg",
      viewBox: "0 0 32 32",
      fill: "currentColor",
      "aria-hidden": "true",
      class: "dp__icon"
    },
    [
      D("path", {
        d: "M12.943 24.943l8-8c0.521-0.521 0.521-1.365 0-1.885l-8-8c-0.52-0.52-1.365-0.52-1.885 0s-0.52 1.365 0 1.885l7.057 7.057c0 0-7.057 7.057-7.057 7.057-0.52 0.52-0.52 1.365 0 1.885s1.365 0.52 1.885 0z"
      })
    ]
  );
}
xb.compatConfig = {
  MODE: 3
};
function bb() {
  return d(), y(
    "svg",
    {
      xmlns: "http://www.w3.org/2000/svg",
      viewBox: "0 0 32 32",
      fill: "currentColor",
      "aria-hidden": "true",
      class: "dp__icon"
    },
    [
      D("path", {
        d: "M16 1.333c-8.095 0-14.667 6.572-14.667 14.667s6.572 14.667 14.667 14.667c8.095 0 14.667-6.572 14.667-14.667s-6.572-14.667-14.667-14.667zM16 4c6.623 0 12 5.377 12 12s-5.377 12-12 12c-6.623 0-12-5.377-12-12s5.377-12 12-12z"
      }),
      D("path", {
        d: "M14.667 8v8c0 0.505 0.285 0.967 0.737 1.193l5.333 2.667c0.658 0.329 1.46 0.062 1.789-0.596s0.062-1.46-0.596-1.789l-4.596-2.298c0 0 0-7.176 0-7.176 0-0.736-0.597-1.333-1.333-1.333s-1.333 0.597-1.333 1.333z"
      })
    ]
  );
}
bb.compatConfig = {
  MODE: 3
};
function wb() {
  return d(), y(
    "svg",
    {
      xmlns: "http://www.w3.org/2000/svg",
      viewBox: "0 0 32 32",
      fill: "currentColor",
      "aria-hidden": "true",
      class: "dp__icon"
    },
    [
      D("path", {
        d: "M24.943 19.057l-8-8c-0.521-0.521-1.365-0.521-1.885 0l-8 8c-0.52 0.52-0.52 1.365 0 1.885s1.365 0.52 1.885 0l7.057-7.057c0 0 7.057 7.057 7.057 7.057 0.52 0.52 1.365 0.52 1.885 0s0.52-1.365 0-1.885z"
      })
    ]
  );
}
wb.compatConfig = {
  MODE: 3
};
function Ib() {
  return d(), y(
    "svg",
    {
      xmlns: "http://www.w3.org/2000/svg",
      viewBox: "0 0 32 32",
      fill: "currentColor",
      "aria-hidden": "true",
      class: "dp__icon"
    },
    [
      D("path", {
        d: "M7.057 12.943l8 8c0.521 0.521 1.365 0.521 1.885 0l8-8c0.52-0.52 0.52-1.365 0-1.885s-1.365-0.52-1.885 0l-7.057 7.057c0 0-7.057-7.057-7.057-7.057-0.52-0.52-1.365-0.52-1.885 0s-0.52 1.365 0 1.885z"
      })
    ]
  );
}
Ib.compatConfig = {
  MODE: 3
};
function Lb(e) {
  return e && e.__esModule && Object.prototype.hasOwnProperty.call(e, "default") ? e.default : e;
}
var SL = { exports: {} };
(function(e) {
  function t(a) {
    return a && a.__esModule ? a : {
      default: a
    };
  }
  e.exports = t, e.exports.__esModule = !0, e.exports.default = e.exports;
})(SL);
var pU = SL.exports, j9 = { exports: {} };
(function(e, t) {
  Object.defineProperty(t, "__esModule", {
    value: !0
  }), t.default = a;
  function a(o) {
    if (o === null || o === !0 || o === !1)
      return NaN;
    var n = Number(o);
    return isNaN(n) ? n : n < 0 ? Math.ceil(n) : Math.floor(n);
  }
  e.exports = t.default;
})(j9, j9.exports);
var yU = j9.exports;
const kU = /* @__PURE__ */ Lb(yU);
var V9 = { exports: {} };
(function(e, t) {
  Object.defineProperty(t, "__esModule", {
    value: !0
  }), t.default = a;
  function a(o) {
    var n = new Date(Date.UTC(o.getFullYear(), o.getMonth(), o.getDate(), o.getHours(), o.getMinutes(), o.getSeconds(), o.getMilliseconds()));
    return n.setUTCFullYear(o.getFullYear()), o.getTime() - n.getTime();
  }
  e.exports = t.default;
})(V9, V9.exports);
var fU = V9.exports;
const $w = /* @__PURE__ */ Lb(fU);
function vU(e, t) {
  var a = xU(t);
  return a.formatToParts ? gU(a, e) : MU(a, e);
}
var mU = {
  year: 0,
  month: 1,
  day: 2,
  hour: 3,
  minute: 4,
  second: 5
};
function gU(e, t) {
  try {
    for (var a = e.formatToParts(t), o = [], n = 0; n < a.length; n++) {
      var i = mU[a[n].type];
      i >= 0 && (o[i] = parseInt(a[n].value, 10));
    }
    return o;
  } catch (l) {
    if (l instanceof RangeError)
      return [NaN];
    throw l;
  }
}
function MU(e, t) {
  var a = e.format(t).replace(/\u200E/g, ""), o = /(\d+)\/(\d+)\/(\d+),? (\d+):(\d+):(\d+)/.exec(a);
  return [o[3], o[1], o[2], o[4], o[5], o[6]];
}
var s9 = {};
function xU(e) {
  if (!s9[e]) {
    var t = new Intl.DateTimeFormat("en-US", {
      hour12: !1,
      timeZone: "America/New_York",
      year: "numeric",
      month: "numeric",
      day: "2-digit",
      hour: "2-digit",
      minute: "2-digit",
      second: "2-digit"
    }).format(/* @__PURE__ */ new Date("2014-06-25T04:00:00.123Z")), a = t === "06/25/2014, 00:00:00" || t === "‎06‎/‎25‎/‎2014‎ ‎00‎:‎00‎:‎00";
    s9[e] = a ? new Intl.DateTimeFormat("en-US", {
      hour12: !1,
      timeZone: e,
      year: "numeric",
      month: "numeric",
      day: "2-digit",
      hour: "2-digit",
      minute: "2-digit",
      second: "2-digit"
    }) : new Intl.DateTimeFormat("en-US", {
      hourCycle: "h23",
      timeZone: e,
      year: "numeric",
      month: "numeric",
      day: "2-digit",
      hour: "2-digit",
      minute: "2-digit",
      second: "2-digit"
    });
  }
  return s9[e];
}
function Sb(e, t, a, o, n, i, l) {
  var c = /* @__PURE__ */ new Date(0);
  return c.setUTCFullYear(e, t, a), c.setUTCHours(o, n, i, l), c;
}
var Rw = 36e5, bU = 6e4, u9 = {
  timezone: /([Z+-].*)$/,
  timezoneZ: /^(Z)$/,
  timezoneHH: /^([+-]\d{2})$/,
  timezoneHHMM: /^([+-]\d{2}):?(\d{2})$/
};
function Cb(e, t, a) {
  var o, n;
  if (e === "" || (o = u9.timezoneZ.exec(e), o))
    return 0;
  var i;
  if (o = u9.timezoneHH.exec(e), o)
    return i = parseInt(o[1], 10), Fw(i) ? -(i * Rw) : NaN;
  if (o = u9.timezoneHHMM.exec(e), o) {
    i = parseInt(o[1], 10);
    var l = parseInt(o[2], 10);
    return Fw(i, l) ? (n = Math.abs(i) * Rw + l * bU, i > 0 ? -n : n) : NaN;
  }
  if (LU(e)) {
    t = new Date(t || Date.now());
    var c = a ? t : wU(t), s = O9(c, e), h = a ? s : IU(t, s, e);
    return -h;
  }
  return NaN;
}
function wU(e) {
  return Sb(
    e.getFullYear(),
    e.getMonth(),
    e.getDate(),
    e.getHours(),
    e.getMinutes(),
    e.getSeconds(),
    e.getMilliseconds()
  );
}
function O9(e, t) {
  var a = vU(e, t), o = Sb(
    a[0],
    a[1] - 1,
    a[2],
    a[3] % 24,
    a[4],
    a[5],
    0
  ).getTime(), n = e.getTime(), i = n % 1e3;
  return n -= i >= 0 ? i : 1e3 + i, o - n;
}
function IU(e, t, a) {
  var o = e.getTime(), n = o - t, i = O9(new Date(n), a);
  if (t === i)
    return t;
  n -= i - t;
  var l = O9(new Date(n), a);
  return i === l ? i : Math.max(i, l);
}
function Fw(e, t) {
  return -23 <= e && e <= 23 && (t == null || 0 <= t && t <= 59);
}
var Uw = {};
function LU(e) {
  if (Uw[e])
    return !0;
  try {
    return new Intl.DateTimeFormat(void 0, { timeZone: e }), Uw[e] = !0, !0;
  } catch {
    return !1;
  }
}
var CL = /(Z|[+-]\d{2}(?::?\d{2})?| UTC| [a-zA-Z]+\/[a-zA-Z_]+(?:\/[a-zA-Z_]+)?)$/, h9 = 36e5, Ew = 6e4, SU = 2, pt = {
  dateTimePattern: /^([0-9W+-]+)(T| )(.*)/,
  datePattern: /^([0-9W+-]+)(.*)/,
  plainTime: /:/,
  // year tokens
  YY: /^(\d{2})$/,
  YYY: [
    /^([+-]\d{2})$/,
    // 0 additional digits
    /^([+-]\d{3})$/,
    // 1 additional digit
    /^([+-]\d{4})$/
    // 2 additional digits
  ],
  YYYY: /^(\d{4})/,
  YYYYY: [
    /^([+-]\d{4})/,
    // 0 additional digits
    /^([+-]\d{5})/,
    // 1 additional digit
    /^([+-]\d{6})/
    // 2 additional digits
  ],
  // date tokens
  MM: /^-(\d{2})$/,
  DDD: /^-?(\d{3})$/,
  MMDD: /^-?(\d{2})-?(\d{2})$/,
  Www: /^-?W(\d{2})$/,
  WwwD: /^-?W(\d{2})-?(\d{1})$/,
  HH: /^(\d{2}([.,]\d*)?)$/,
  HHMM: /^(\d{2}):?(\d{2}([.,]\d*)?)$/,
  HHMMSS: /^(\d{2}):?(\d{2}):?(\d{2}([.,]\d*)?)$/,
  // time zone tokens (to identify the presence of a tz)
  timeZone: CL
};
function $9(e, t) {
  if (arguments.length < 1)
    throw new TypeError("1 argument required, but only " + arguments.length + " present");
  if (e === null)
    return /* @__PURE__ */ new Date(NaN);
  var a = t || {}, o = a.additionalDigits == null ? SU : kU(a.additionalDigits);
  if (o !== 2 && o !== 1 && o !== 0)
    throw new RangeError("additionalDigits must be 0, 1 or 2");
  if (e instanceof Date || typeof e == "object" && Object.prototype.toString.call(e) === "[object Date]")
    return new Date(e.getTime());
  if (typeof e == "number" || Object.prototype.toString.call(e) === "[object Number]")
    return new Date(e);
  if (!(typeof e == "string" || Object.prototype.toString.call(e) === "[object String]"))
    return /* @__PURE__ */ new Date(NaN);
  var n = CU(e), i = AU(n.date, o), l = i.year, c = i.restDateString, s = PU(c, l);
  if (isNaN(s))
    return /* @__PURE__ */ new Date(NaN);
  if (s) {
    var h = s.getTime(), m = 0, p;
    if (n.time && (m = qU(n.time), isNaN(m)))
      return /* @__PURE__ */ new Date(NaN);
    if (n.timeZone || a.timeZone) {
      if (p = Cb(n.timeZone || a.timeZone, new Date(h + m)), isNaN(p))
        return /* @__PURE__ */ new Date(NaN);
    } else
      p = $w(new Date(h + m)), p = $w(new Date(h + m + p));
    return new Date(h + m + p);
  } else
    return /* @__PURE__ */ new Date(NaN);
}
function CU(e) {
  var t = {}, a = pt.dateTimePattern.exec(e), o;
  if (a ? (t.date = a[1], o = a[3]) : (a = pt.datePattern.exec(e), a ? (t.date = a[1], o = a[2]) : (t.date = null, o = e)), o) {
    var n = pt.timeZone.exec(o);
    n ? (t.time = o.replace(n[1], ""), t.timeZone = n[1].trim()) : t.time = o;
  }
  return t;
}
function AU(e, t) {
  var a = pt.YYY[t], o = pt.YYYYY[t], n;
  if (n = pt.YYYY.exec(e) || o.exec(e), n) {
    var i = n[1];
    return {
      year: parseInt(i, 10),
      restDateString: e.slice(i.length)
    };
  }
  if (n = pt.YY.exec(e) || a.exec(e), n) {
    var l = n[1];
    return {
      year: parseInt(l, 10) * 100,
      restDateString: e.slice(l.length)
    };
  }
  return {
    year: null
  };
}
function PU(e, t) {
  if (t === null)
    return null;
  var a, o, n, i;
  if (e.length === 0)
    return o = /* @__PURE__ */ new Date(0), o.setUTCFullYear(t), o;
  if (a = pt.MM.exec(e), a)
    return o = /* @__PURE__ */ new Date(0), n = parseInt(a[1], 10) - 1, Nw(t, n) ? (o.setUTCFullYear(t, n), o) : /* @__PURE__ */ new Date(NaN);
  if (a = pt.DDD.exec(e), a) {
    o = /* @__PURE__ */ new Date(0);
    var l = parseInt(a[1], 10);
    return _U(t, l) ? (o.setUTCFullYear(t, 0, l), o) : /* @__PURE__ */ new Date(NaN);
  }
  if (a = pt.MMDD.exec(e), a) {
    o = /* @__PURE__ */ new Date(0), n = parseInt(a[1], 10) - 1;
    var c = parseInt(a[2], 10);
    return Nw(t, n, c) ? (o.setUTCFullYear(t, n, c), o) : /* @__PURE__ */ new Date(NaN);
  }
  if (a = pt.Www.exec(e), a)
    return i = parseInt(a[1], 10) - 1, Zw(t, i) ? Ww(t, i) : /* @__PURE__ */ new Date(NaN);
  if (a = pt.WwwD.exec(e), a) {
    i = parseInt(a[1], 10) - 1;
    var s = parseInt(a[2], 10) - 1;
    return Zw(t, i, s) ? Ww(t, i, s) : /* @__PURE__ */ new Date(NaN);
  }
  return null;
}
function qU(e) {
  var t, a, o;
  if (t = pt.HH.exec(e), t)
    return a = parseFloat(t[1].replace(",", ".")), p9(a) ? a % 24 * h9 : NaN;
  if (t = pt.HHMM.exec(e), t)
    return a = parseInt(t[1], 10), o = parseFloat(t[2].replace(",", ".")), p9(a, o) ? a % 24 * h9 + o * Ew : NaN;
  if (t = pt.HHMMSS.exec(e), t) {
    a = parseInt(t[1], 10), o = parseInt(t[2], 10);
    var n = parseFloat(t[3].replace(",", "."));
    return p9(a, o, n) ? a % 24 * h9 + o * Ew + n * 1e3 : NaN;
  }
  return null;
}
function Ww(e, t, a) {
  t = t || 0, a = a || 0;
  var o = /* @__PURE__ */ new Date(0);
  o.setUTCFullYear(e, 0, 4);
  var n = o.getUTCDay() || 7, i = t * 7 + a + 1 - n;
  return o.setUTCDate(o.getUTCDate() + i), o;
}
var TU = [31, 28, 31, 30, 31, 30, 31, 31, 30, 31, 30, 31], DU = [31, 29, 31, 30, 31, 30, 31, 31, 30, 31, 30, 31];
function AL(e) {
  return e % 400 === 0 || e % 4 === 0 && e % 100 !== 0;
}
function Nw(e, t, a) {
  if (t < 0 || t > 11)
    return !1;
  if (a != null) {
    if (a < 1)
      return !1;
    var o = AL(e);
    if (o && a > DU[t] || !o && a > TU[t])
      return !1;
  }
  return !0;
}
function _U(e, t) {
  if (t < 1)
    return !1;
  var a = AL(e);
  return !(a && t > 366 || !a && t > 365);
}
function Zw(e, t, a) {
  return !(t < 0 || t > 52 || a != null && (a < 0 || a > 6));
}
function p9(e, t, a) {
  return !(e != null && (e < 0 || e >= 25) || t != null && (t < 0 || t >= 60) || a != null && (a < 0 || a >= 60));
}
var R9 = { exports: {} }, F9 = { exports: {} };
(function(e, t) {
  Object.defineProperty(t, "__esModule", {
    value: !0
  }), t.default = a;
  function a(o, n) {
    if (o == null)
      throw new TypeError("assign requires that input parameter not be null or undefined");
    for (var i in n)
      Object.prototype.hasOwnProperty.call(n, i) && (o[i] = n[i]);
    return o;
  }
  e.exports = t.default;
})(F9, F9.exports);
var BU = F9.exports;
(function(e, t) {
  var a = pU.default;
  Object.defineProperty(t, "__esModule", {
    value: !0
  }), t.default = n;
  var o = a(BU);
  function n(i) {
    return (0, o.default)({}, i);
  }
  e.exports = t.default;
})(R9, R9.exports);
var zU = R9.exports;
const HU = /* @__PURE__ */ Lb(zU);
function jU(e, t, a) {
  var o = $9(e, a), n = Cb(t, o, !0), i = new Date(o.getTime() - n), l = /* @__PURE__ */ new Date(0);
  return l.setFullYear(i.getUTCFullYear(), i.getUTCMonth(), i.getUTCDate()), l.setHours(i.getUTCHours(), i.getUTCMinutes(), i.getUTCSeconds(), i.getUTCMilliseconds()), l;
}
function VU(e, t, a) {
  if (typeof e == "string" && !e.match(CL)) {
    var o = HU(a);
    return o.timeZone = t, $9(e, o);
  }
  var n = $9(e, a), i = Sb(
    n.getFullYear(),
    n.getMonth(),
    n.getDate(),
    n.getHours(),
    n.getMinutes(),
    n.getSeconds(),
    n.getMilliseconds()
  ).getTime(), l = Cb(t, new Date(i));
  return new Date(i + l);
}
function Yw(e) {
  return (t) => new Intl.DateTimeFormat(e, { weekday: "short", timeZone: "UTC" }).format(/* @__PURE__ */ new Date(`2017-01-0${t}T00:00:00+00:00`)).slice(0, 2);
}
function OU(e) {
  return (t) => na(/* @__PURE__ */ new Date(`2017-01-0${t}T00:00:00+00:00`), "EEEEEE", { locale: e });
}
const $U = (e, t, a) => {
  const o = [1, 2, 3, 4, 5, 6, 7];
  let n;
  if (e !== null)
    try {
      n = o.map(OU(e));
    } catch {
      n = o.map(Yw(t));
    }
  else
    n = o.map(Yw(t));
  const i = n.slice(0, a), l = n.slice(a + 1, n.length);
  return [n[a]].concat(...l).concat(...i);
}, Ab = (e, t) => {
  const a = [];
  for (let o = +e[0]; o <= +e[1]; o++)
    a.push({ value: +o, text: `${o}` });
  return t ? a.reverse() : a;
}, PL = (e, t, a) => {
  const o = [1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12].map((i) => {
    const l = i < 10 ? `0${i}` : i;
    return /* @__PURE__ */ new Date(`2017-${l}-01T00:00:00+00:00`);
  });
  if (e !== null)
    try {
      const i = a === "long" ? "MMMM" : "MMM";
      return o.map((l, c) => {
        const s = na(l, i, { locale: e });
        return {
          text: s.charAt(0).toUpperCase() + s.substring(1),
          value: c
        };
      });
    } catch {
    }
  const n = new Intl.DateTimeFormat(t, { month: a, timeZone: "UTC" });
  return o.map((i, l) => {
    const c = n.format(i);
    return {
      text: c.charAt(0).toUpperCase() + c.substring(1),
      value: l
    };
  });
}, RU = (e) => [12, 1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12, 1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11][e], nt = (e) => {
  const t = u(e);
  return t != null && t.$el ? t == null ? void 0 : t.$el : t;
}, FU = (e) => Object.assign({ type: "dot" }, e), qL = (e) => Array.isArray(e) ? !!e[0] && !!e[1] : !1, qx = {
  prop: (e) => `"${e}" prop must be enabled!`,
  dateArr: (e) => `You need to use array as "model-value" binding in order to support "${e}"`
}, rt = (e) => e, Gw = (e) => e === 0 ? e : !e || isNaN(+e) ? null : +e, Xw = (e) => e === null, UU = (e) => {
  if (e)
    return [...e.querySelectorAll("input, button, select, textarea, a[href]")][0];
}, EU = (e) => {
  const t = [], a = (o) => o.filter((n) => n);
  for (let o = 0; o < e.length; o += 3) {
    const n = [e[o], e[o + 1], e[o + 2]];
    t.push(a(n));
  }
  return t;
}, s1 = (e, t, a) => {
  const o = a != null, n = t != null;
  if (!o && !n)
    return !1;
  const i = +a, l = +t;
  return o && n ? +e > i || +e < l : o ? +e > i : n ? +e < l : !1;
}, Vr = (e, t) => EU(e).map((a) => a.map((o) => {
  const { active: n, disabled: i, isBetween: l, highlighted: c } = t(o);
  return {
    ...o,
    active: n,
    disabled: i,
    className: {
      dp__overlay_cell_active: n,
      dp__overlay_cell: !n,
      dp__overlay_cell_disabled: i,
      dp__overlay_cell_pad: !0,
      dp__overlay_cell_active_disabled: i && n,
      dp__cell_in_between: l,
      "dp--highlighted": c
    }
  };
})), oa = (e, t, a = !1) => {
  e && t.allowStopPropagation && (a && e.stopImmediatePropagation(), e.stopPropagation());
}, WU = () => [
  "a[href]",
  "area[href]",
  "input:not([disabled]):not([type='hidden'])",
  "select:not([disabled])",
  "textarea:not([disabled])",
  "button:not([disabled])",
  "[tabindex]:not([tabindex='-1'])",
  "[data-datepicker-instance]"
].join(", ");
function NU(e, t) {
  let a = [...document.querySelectorAll(WU())];
  a = a.filter((n) => !e.contains(n) || n.hasAttribute("data-datepicker-instance"));
  const o = a.indexOf(e);
  if (o >= 0 && (t ? o - 1 >= 0 : o + 1 <= a.length))
    return a[o + (t ? -1 : 1)];
}
const ZU = (e, t) => {
  let a;
  return function(...o) {
    clearTimeout(a), a = setTimeout(() => {
      e(...o);
    }, t);
  };
}, Kw = (e, t, a, o, n) => {
  const i = H9(e, t.slice(0, e.length), /* @__PURE__ */ new Date());
  return o1(i) && oL(i) ? o || n ? i : Ge(i, {
    hours: +a.hours,
    minutes: +(a == null ? void 0 : a.minutes),
    seconds: +(a == null ? void 0 : a.seconds),
    milliseconds: 0
  }) : null;
}, YU = (e, t, a, o, n) => {
  const i = Array.isArray(a) ? a[0] : a;
  if (typeof t == "string")
    return Kw(e, t, i, o, n);
  if (Array.isArray(t)) {
    let l = null;
    for (const c of t)
      if (l = Kw(e, c, i, o, n), l)
        break;
    return l;
  }
  return typeof t == "function" ? t(e) : null;
}, ne = (e) => e ? new Date(e) : /* @__PURE__ */ new Date(), GU = (e, t, a) => {
  if (t) {
    const n = (e.getMonth() + 1).toString().padStart(2, "0"), i = e.getDate().toString().padStart(2, "0"), l = e.getHours().toString().padStart(2, "0"), c = e.getMinutes().toString().padStart(2, "0"), s = a ? e.getSeconds().toString().padStart(2, "0") : "00";
    return `${e.getFullYear()}-${n}-${i}T${l}:${c}:${s}.000Z`;
  }
  const o = Date.UTC(
    e.getUTCFullYear(),
    e.getUTCMonth(),
    e.getUTCDate(),
    e.getUTCHours(),
    e.getUTCMinutes(),
    e.getUTCSeconds()
  );
  return new Date(o).toISOString();
}, ut = (e) => {
  let t = ne(JSON.parse(JSON.stringify(e)));
  return t = bL(t, 0), t = wL(t, 0), t = gb(t, 0), t = mb(t, 0), t;
}, ra = (e, t, a, o) => {
  let n = e ? ne(e) : ne();
  return (t || t === 0) && (n = bL(n, +t)), (a || a === 0) && (n = wL(n, +a)), (o || o === 0) && (n = gb(n, +o)), mb(n, 0);
}, ct = (e, t) => !e || !t ? !1 : d1(ut(e), ut(t)), Oe = (e, t) => !e || !t ? !1 : Br(ut(e), ut(t)), st = (e, t) => !e || !t ? !1 : c1(ut(e), ut(t)), Gx = (e, t, a) => e != null && e[0] && e != null && e[1] ? st(a, e[0]) && ct(a, e[1]) : e != null && e[0] && t ? st(a, e[0]) && ct(a, t) || ct(a, e[0]) && st(a, t) : !1, At = (e) => {
  const t = Ge(new Date(e), { date: 1 });
  return ut(t);
}, y9 = (e, t, a) => t && (a || a === 0) ? Object.fromEntries(
  ["hours", "minutes", "seconds"].map((o) => o === t ? [o, a] : [o, isNaN(+e[o]) ? void 0 : +e[o]])
) : {
  hours: isNaN(+e.hours) ? void 0 : +e.hours,
  minutes: isNaN(+e.minutes) ? void 0 : +e.minutes,
  seconds: isNaN(+e.seconds) ? void 0 : +e.seconds
}, Mr = (e) => ({
  hours: qt(e),
  minutes: $t(e),
  seconds: Hr(e)
}), TL = (e, t) => {
  if (t) {
    const a = qe(ne(t));
    if (a > e)
      return 12;
    if (a === e)
      return He(ne(t));
  }
}, DL = (e, t) => {
  if (t) {
    const a = qe(ne(t));
    return a < e ? -1 : a === e ? He(ne(t)) : void 0;
  }
}, Or = (e) => {
  if (e)
    return qe(ne(e));
}, Tt = (e, t) => t ? jU(e, t) : e, _L = (e, t) => t ? VU(e, t) : e, XU = (e) => e instanceof Date ? e : XF(e), BL = (e, t) => {
  const a = st(e, t) ? t : e, o = st(t, e) ? t : e;
  return rL({ start: a, end: o });
}, KU = (e) => {
  const t = Pt(e, 1);
  return { month: He(t), year: qe(t) };
}, mx = (e, t, a) => {
  const o = br(Tt(e, t), { weekStartsOn: +a }), n = $$(Tt(e, t), { weekStartsOn: +a });
  return [o, n];
}, zL = (e, t) => {
  const a = {
    hours: qt(ne()),
    minutes: $t(ne()),
    seconds: t ? Hr(ne()) : 0
  };
  return Object.assign(a, e);
}, aa = (e, t, a) => [Ge(ne(e), { date: 1 }), Ge(ne(), { month: t, year: a, date: 1 })], Nt = (e, t, a) => {
  let o = e ? ne(e) : ne();
  return (t || t === 0) && (o = xL(o, t)), a && (o = Ot(o, a)), o;
}, HL = (e, t, a, o, n) => {
  if (!o || n && !t || !n && !a)
    return !1;
  const i = n ? Pt(e, 1) : jr(e, 1), l = [He(i), qe(i)];
  return n ? !JU(...l, t) : !QU(...l, a);
}, QU = (e, t, a) => ct(...aa(a, e, t)) || Oe(...aa(a, e, t)), JU = (e, t, a) => st(...aa(a, e, t)) || Oe(...aa(a, e, t)), jL = (e, t, a, o, n, i, l) => {
  if (typeof t == "function" && !l)
    return t(e);
  const c = a ? { locale: a } : void 0;
  return Array.isArray(e) ? `${na(e[0], i, c)}${n && !e[1] ? "" : o}${e[1] ? na(e[1], i, c) : ""}` : na(e, i, c);
}, Dr = (e) => {
  if (e)
    return null;
  throw new Error(qx.prop("partial-range"));
}, C1 = (e, t) => {
  if (t)
    return e();
  throw new Error(qx.prop("range"));
}, U9 = (e) => Array.isArray(e) ? o1(e[0]) && (e[1] ? o1(e[1]) : !0) : e ? o1(e) : !1, eE = (e, t) => Ge(t ?? ne(), {
  hours: +e.hours || 0,
  minutes: +e.minutes || 0,
  seconds: +e.seconds || 0
}), k9 = (e, t, a, o) => {
  if (!e)
    return !0;
  if (o) {
    const n = a === "max" ? d1(e, t) : c1(e, t), i = { seconds: 0, milliseconds: 0 };
    return n || Br(Ge(e, i), Ge(t, i));
  }
  return a === "max" ? e.getTime() <= t.getTime() : e.getTime() >= t.getTime();
}, f9 = (e, t, a) => e ? eE(e, t) : ne(a ?? t), Qw = (e, t, a, o, n) => {
  if (Array.isArray(o)) {
    const l = f9(e, o[0], t), c = f9(e, o[1], t);
    return k9(o[0], l, a, !!t) && k9(o[1], c, a, !!t) && n;
  }
  const i = f9(e, o, t);
  return k9(o, i, a, !!t) && n;
}, v9 = (e) => Ge(ne(), Mr(e)), tE = (e, t) => Array.isArray(e) ? e.map((a) => ne(a)).filter((a) => qe(ne(a)) === t).map((a) => He(a)) : [], VL = (e, t, a) => typeof e == "function" ? e({ month: t, year: a }) : !!e.months.find((o) => o.month === t && o.year === a), Pb = (e, t) => typeof e == "function" ? e(t) : e.years.includes(t), t1 = u1({
  menuFocused: !1,
  shiftKeyInMenu: !1
}), OL = () => {
  const e = (a) => {
    t1.menuFocused = a;
  }, t = (a) => {
    t1.shiftKeyInMenu !== a && (t1.shiftKeyInMenu = a);
  };
  return {
    control: N(() => ({ shiftKeyInMenu: t1.shiftKeyInMenu, menuFocused: t1.menuFocused })),
    setMenuFocused: e,
    setShiftKey: t
  };
}, Ne = u1({
  monthYear: [],
  calendar: [],
  time: [],
  actionRow: [],
  selectionGrid: [],
  timePicker: {
    0: [],
    1: []
  },
  monthPicker: []
}), m9 = W(null), A1 = W(!1), g9 = W(!1), M9 = W(!1), x9 = W(!1), ht = W(0), it = W(0), la = () => {
  const e = N(() => A1.value ? [...Ne.selectionGrid, Ne.actionRow].filter((p) => p.length) : g9.value ? [
    ...Ne.timePicker[0],
    ...Ne.timePicker[1],
    x9.value ? [] : [m9.value],
    Ne.actionRow
  ].filter((p) => p.length) : M9.value ? [...Ne.monthPicker, Ne.actionRow] : [Ne.monthYear, ...Ne.calendar, Ne.time, Ne.actionRow].filter((p) => p.length)), t = (p) => {
    ht.value = p ? ht.value + 1 : ht.value - 1;
    let f = null;
    e.value[it.value] && (f = e.value[it.value][ht.value]), f || (ht.value = p ? ht.value - 1 : ht.value + 1);
  }, a = (p) => {
    it.value === 0 && !p || it.value === e.value.length && p || (it.value = p ? it.value + 1 : it.value - 1, e.value[it.value] ? e.value[it.value] && !e.value[it.value][ht.value] && ht.value !== 0 && (ht.value = e.value[it.value].length - 1) : it.value = p ? it.value - 1 : it.value + 1);
  }, o = (p) => {
    let f = null;
    e.value[it.value] && (f = e.value[it.value][ht.value]), f ? f.focus({ preventScroll: !A1.value }) : ht.value = p ? ht.value - 1 : ht.value + 1;
  }, n = () => {
    t(!0), o(!0);
  }, i = () => {
    t(!1), o(!1);
  }, l = () => {
    a(!1), o(!0);
  }, c = () => {
    a(!0), o(!0);
  }, s = (p, f) => {
    Ne[f] = p;
  }, h = (p, f) => {
    Ne[f] = p;
  }, m = () => {
    ht.value = 0, it.value = 0;
  };
  return {
    buildMatrix: s,
    buildMultiLevelMatrix: h,
    setTimePickerBackRef: (p) => {
      m9.value = p;
    },
    setSelectionGrid: (p) => {
      A1.value = p, m(), p || (Ne.selectionGrid = []);
    },
    setTimePicker: (p, f = !1) => {
      g9.value = p, x9.value = f, m(), p || (Ne.timePicker[0] = [], Ne.timePicker[1] = []);
    },
    setTimePickerElements: (p, f = 0) => {
      Ne.timePicker[f] = p;
    },
    arrowRight: n,
    arrowLeft: i,
    arrowUp: l,
    arrowDown: c,
    clearArrowNav: () => {
      Ne.monthYear = [], Ne.calendar = [], Ne.time = [], Ne.actionRow = [], Ne.selectionGrid = [], Ne.timePicker[0] = [], Ne.timePicker[1] = [], A1.value = !1, g9.value = !1, x9.value = !1, M9.value = !1, m(), m9.value = null;
    },
    setMonthPicker: (p) => {
      M9.value = p, m();
    },
    refSets: Ne
    // exposed for testing
  };
}, Jw = (e) => ({
  menuAppearTop: "dp-menu-appear-top",
  menuAppearBottom: "dp-menu-appear-bottom",
  open: "dp-slide-down",
  close: "dp-slide-up",
  next: "calendar-next",
  previous: "calendar-prev",
  vNext: "dp-slide-up",
  vPrevious: "dp-slide-down",
  ...e ?? {}
}), aE = (e) => ({
  toggleOverlay: "Toggle overlay",
  menu: "Datepicker menu",
  input: "Datepicker input",
  calendarWrap: "Calendar wrapper",
  calendarDays: "Calendar days",
  openTimePicker: "Open time picker",
  closeTimePicker: "Close time Picker",
  incrementValue: (t) => `Increment ${t}`,
  decrementValue: (t) => `Decrement ${t}`,
  openTpOverlay: (t) => `Open ${t} overlay`,
  amPmButton: "Switch AM/PM mode",
  openYearsOverlay: "Open years overlay",
  openMonthsOverlay: "Open months overlay",
  nextMonth: "Next month",
  prevMonth: "Previous month",
  nextYear: "Next year",
  prevYear: "Previous year",
  day: () => "",
  ...e ?? {}
}), eI = (e) => e ? typeof e == "boolean" ? e ? 2 : 0 : +e >= 2 ? +e : 2 : 0, nE = (e) => {
  const t = typeof e == "object" && e, a = {
    static: !0,
    solo: !1
  };
  if (!e)
    return { ...a, count: eI(!1) };
  const o = t ? e : {}, n = t ? o.count ?? !0 : e, i = eI(n);
  return Object.assign(a, o, { count: i });
}, oE = (e, t, a) => e || (typeof a == "string" ? a : t), rE = (e) => typeof e == "boolean" ? e ? Jw({}) : !1 : Jw(e), iE = (e) => {
  const t = {
    enterSubmit: !0,
    tabSubmit: !0,
    openMenu: !0,
    selectOnFocus: !1,
    rangeSeparator: " - "
  };
  return typeof e == "object" ? { ...t, ...e ?? {}, enabled: !0 } : { ...t, enabled: e };
}, lE = (e) => ({
  months: [],
  years: [],
  times: { hours: [], minutes: [], seconds: [] },
  ...e ?? {}
}), cE = (e) => ({
  showSelect: !0,
  showCancel: !0,
  showNow: !1,
  showPreview: !0,
  ...e ?? {}
}), dE = (e) => {
  const t = { input: !1 };
  return typeof e == "object" ? { ...t, ...e ?? {}, enabled: !0 } : {
    enabled: e,
    ...t
  };
}, sE = (e) => ({ allowStopPropagation: !0, closeOnScroll: !1, modeHeight: 255, allowPreventDefault: !1, closeOnClearValue: !0, closeOnAutoApply: !0, noSwipe: !1, keepActionRow: !1, onClickOutside: void 0, tabOutClosesMenu: !0, ...e ?? {} }), uE = (e, t, a) => {
  const o = {
    dates: Array.isArray(e) ? e.map((n) => ne(n)) : [],
    years: [],
    months: [],
    quarters: [],
    weeks: [],
    weekdays: t,
    options: { highlightDisabled: a }
  };
  return typeof e == "function" ? e : { ...o, ...e ?? {} };
}, hE = (e) => typeof e == "object" ? {
  type: e.type,
  hideOnOffsetDates: e.hideOnOffsetDates ?? !1
} : {
  type: e,
  hideOnOffsetDates: !1
}, tt = (e) => {
  const t = () => {
    const b = e.enableSeconds ? ":ss" : "";
    return e.is24 ? `HH:mm${b}` : `hh:mm${b} aa`;
  }, a = () => e.format ? e.format : e.monthPicker ? "MM/yyyy" : e.timePicker ? t() : e.weekPicker ? "MM/dd/yyyy" : e.yearPicker ? "yyyy" : e.quarterPicker ? "QQQ/yyyy" : e.enableTimePicker ? `MM/dd/yyyy, ${t()}` : "MM/dd/yyyy", o = (b) => zL(b, e.enableSeconds), n = () => e.range ? e.startTime && Array.isArray(e.startTime) ? [o(e.startTime[0]), o(e.startTime[1])] : null : e.startTime && !Array.isArray(e.startTime) ? o(e.startTime) : null, i = N(() => nE(e.multiCalendars)), l = N(() => n()), c = N(() => aE(e.ariaLabels)), s = N(() => lE(e.filters)), h = N(() => rE(e.transitions)), m = N(() => cE(e.actionRow)), p = N(
    () => oE(e.previewFormat, e.format, a())
  ), f = N(() => iE(e.textInput)), g = N(() => dE(e.inline)), w = N(() => sE(e.config)), q = N(
    () => uE(e.highlight, e.highlightWeekDays, e.highlightDisabledDays)
  ), _ = N(() => hE(e.weekNumbers));
  return {
    defaultedTransitions: h,
    defaultedMultiCalendars: i,
    defaultedStartTime: l,
    defaultedAriaLabels: c,
    defaultedFilters: s,
    defaultedActionRow: m,
    defaultedPreviewFormat: p,
    defaultedTextInput: f,
    defaultedInline: g,
    defaultedConfig: w,
    defaultedHighlight: q,
    defaultedWeekNumbers: _,
    getDefaultPattern: a,
    getDefaultStartTime: n
  };
}, pE = (e, t, a) => {
  const o = W(), { defaultedTextInput: n, getDefaultPattern: i } = tt(t), l = W(""), c = ia(t, "format");
  ot(o, () => {
    e("internal-model-change", o.value);
  }), ot(c, () => {
    F();
  });
  const s = (k) => _L(k, t.timezone), h = (k) => Tt(k, t.timezone), m = (k, O, E = !1) => jL(
    k,
    t.format,
    t.formatLocale,
    n.value.rangeSeparator,
    t.modelAuto,
    O ?? i(),
    E
  ), p = (k) => k ? t.modelType ? $(k) : {
    hours: qt(k),
    minutes: $t(k),
    seconds: t.enableSeconds ? Hr(k) : 0
  } : null, f = (k) => t.modelType ? $(k) : { month: He(k), year: qe(k) }, g = (k) => Array.isArray(k) ? t.multiDates ? k.map((O) => w(O, Ot(ne(), O))) : C1(
    () => [
      Ot(ne(), k[0]),
      k[1] ? Ot(ne(), k[1]) : Dr(t.partialRange)
    ],
    t.range
  ) : Ot(ne(), +k), w = (k, O) => (typeof k == "string" || typeof k == "number") && t.modelType ? A(k) : O, q = (k) => Array.isArray(k) ? [
    w(
      k[0],
      ra(null, +k[0].hours, +k[0].minutes, k[0].seconds)
    ),
    w(
      k[1],
      ra(null, +k[1].hours, +k[1].minutes, k[1].seconds)
    )
  ] : w(k, ra(null, k.hours, k.minutes, k.seconds)), _ = (k) => Array.isArray(k) ? t.multiDates ? k.map((O) => w(O, Nt(null, +O.month, +O.year))) : C1(
    () => [
      w(k[0], Nt(null, +k[0].month, +k[0].year)),
      w(
        k[1],
        k[1] ? Nt(null, +k[1].month, +k[1].year) : Dr(t.partialRange)
      )
    ],
    t.range
  ) : w(k, Nt(null, +k.month, +k.year)), b = (k) => {
    if (Array.isArray(k))
      return k.map((O) => A(O));
    throw new Error(qx.dateArr("multi-dates"));
  }, L = (k) => {
    if (Array.isArray(k))
      return [ne(k[0]), ne(k[1])];
    throw new Error(qx.dateArr("week-picker"));
  }, j = (k) => t.modelAuto ? Array.isArray(k) ? [A(k[0]), A(k[1])] : t.autoApply ? [A(k)] : [A(k), null] : Array.isArray(k) ? C1(
    () => [
      A(k[0]),
      k[1] ? A(k[1]) : Dr(t.partialRange)
    ],
    t.range
  ) : A(k), I = () => {
    Array.isArray(o.value) && t.range && o.value.length === 1 && o.value.push(Dr(t.partialRange));
  }, C = () => {
    const k = o.value;
    return [
      $(k[0]),
      k[1] ? $(k[1]) : Dr(t.partialRange)
    ];
  }, B = () => o.value[1] ? C() : $(rt(o.value[0])), U = () => (o.value || []).map((k) => $(k)), de = () => (I(), t.modelAuto ? B() : t.multiDates ? U() : Array.isArray(o.value) ? C1(() => C(), t.range) : $(rt(o.value))), ae = (k) => !k || Array.isArray(k) && !k.length ? null : t.timePicker ? q(rt(k)) : t.monthPicker ? _(rt(k)) : t.yearPicker ? g(rt(k)) : t.multiDates ? b(rt(k)) : t.weekPicker ? L(rt(k)) : j(rt(k)), S = (k) => {
    const O = ae(k);
    U9(rt(O)) ? (o.value = rt(O), F()) : (o.value = null, l.value = "");
  }, V = () => {
    const k = (O) => na(O, n.value.format);
    return `${k(o.value[0])} ${n.value.rangeSeparator} ${o.value[1] ? k(o.value[1]) : ""}`;
  }, Z = () => a.value && o.value ? Array.isArray(o.value) ? V() : na(o.value, n.value.format) : m(o.value), re = () => o.value ? t.multiDates ? o.value.map((k) => m(k)).join("; ") : n.value.enabled && typeof n.value.format == "string" ? Z() : m(o.value) : "", F = () => {
    !t.format || typeof t.format == "string" || n.value.enabled && typeof n.value.format == "string" ? l.value = re() : l.value = t.format(o.value);
  }, A = (k) => {
    if (t.utc) {
      const O = new Date(k);
      return t.utc === "preserve" ? new Date(O.getTime() + O.getTimezoneOffset() * 6e4) : O;
    }
    return t.modelType ? t.modelType === "date" || t.modelType === "timestamp" ? h(new Date(k)) : t.modelType === "format" && (typeof t.format == "string" || !t.format) ? H9(k, i(), /* @__PURE__ */ new Date()) : h(H9(k, t.modelType, /* @__PURE__ */ new Date())) : h(new Date(k));
  }, $ = (k) => k ? t.utc ? GU(k, t.utc === "preserve", t.enableSeconds) : t.modelType ? t.modelType === "timestamp" ? +s(k) : t.modelType === "format" && (typeof t.format == "string" || !t.format) ? m(s(k)) : m(s(k), t.modelType, !0) : s(k) : "", R = (k, O = !1) => {
    if (e("update:model-value", k), t.emitTimezone && O) {
      const E = Array.isArray(k) ? k.map((te) => Tt(rt(te)), t.emitTimezone) : Tt(rt(k), t.emitTimezone);
      e("update:model-timezone-value", E);
    }
  }, J = (k) => Array.isArray(o.value) ? t.multiDates ? o.value.map((O) => k(O)) : [
    k(o.value[0]),
    o.value[1] ? k(o.value[1]) : Dr(t.partialRange)
  ] : k(rt(o.value)), M = (k) => R(rt(J(k)));
  return {
    inputValue: l,
    internalModelValue: o,
    checkBeforeEmit: () => o.value ? t.range ? t.partialRange ? o.value.length >= 1 : o.value.length === 2 : !!o.value : !1,
    parseExternalModelValue: S,
    formatInputValue: F,
    emitModelValue: () => (F(), t.monthPicker ? M(f) : t.timePicker ? M(p) : t.yearPicker ? M(qe) : t.weekPicker ? R(
      o.value.map((k) => $(k)),
      !0
    ) : R(de(), !0))
  };
}, yE = (e, t) => {
  const { defaultedFilters: a } = tt(e), { validateMonthYearInRange: o } = Cr(e), n = (h, m) => {
    let p = h;
    return a.value.months.includes(He(p)) ? (p = m ? Pt(h, 1) : jr(h, 1), n(p, m)) : p;
  }, i = (h, m) => {
    let p = h;
    return a.value.years.includes(qe(p)) ? (p = m ? hb(h, 1) : IL(h, 1), i(p, m)) : p;
  }, l = (h, m = !1) => {
    const p = Ge(/* @__PURE__ */ new Date(), { month: e.month, year: e.year });
    let f = h ? Pt(p, 1) : jr(p, 1);
    e.disableYearSelect && (f = Ot(f, e.year));
    let g = He(f), w = qe(f);
    a.value.months.includes(g) && (f = n(f, h), g = He(f), w = qe(f)), a.value.years.includes(w) && (f = i(f, h), w = qe(f)), o(g, w, h, e.preventMinMaxNavigation) && c(g, w, m);
  }, c = (h, m, p) => {
    t("update-month-year", { month: h, year: m, fromNav: p });
  }, s = N(() => (h) => HL(
    Ge(/* @__PURE__ */ new Date(), { month: e.month, year: e.year }),
    e.maxDate,
    e.minDate,
    e.preventMinMaxNavigation,
    h
  ));
  return { handleMonthYearChange: l, isDisabled: s, updateMonthYear: c };
};
var _r = /* @__PURE__ */ ((e) => (e.center = "center", e.left = "left", e.right = "right", e))(_r || {}), Ct = /* @__PURE__ */ ((e) => (e.month = "month", e.year = "year", e))(Ct || {}), mr = /* @__PURE__ */ ((e) => (e.top = "top", e.bottom = "bottom", e))(mr || {}), xr = /* @__PURE__ */ ((e) => (e.header = "header", e.calendar = "calendar", e.timePicker = "timePicker", e))(xr || {}), Ht = /* @__PURE__ */ ((e) => (e.month = "month", e.year = "year", e.calendar = "calendar", e.time = "time", e.minutes = "minutes", e.hours = "hours", e.seconds = "seconds", e))(Ht || {});
const kE = ({
  menuRef: e,
  menuRefInner: t,
  inputRef: a,
  pickerWrapperRef: o,
  inline: n,
  emit: i,
  props: l,
  slots: c
}) => {
  const s = W({}), h = W(!1), m = W({
    top: "0",
    left: "0"
  }), p = W(!1), f = ia(l, "teleportCenter");
  ot(f, () => {
    m.value = JSON.parse(JSON.stringify({})), I();
  });
  const g = (A) => {
    if (l.teleport) {
      const $ = A.getBoundingClientRect();
      return {
        left: $.left + window.scrollX,
        top: $.top + window.scrollY
      };
    }
    return { top: 0, left: 0 };
  }, w = (A, $) => {
    m.value.left = `${A + $ - s.value.width}px`;
  }, q = (A) => {
    m.value.left = `${A}px`;
  }, _ = (A, $) => {
    l.position === _r.left && q(A), l.position === _r.right && w(A, $), l.position === _r.center && (m.value.left = `${A + $ / 2 - s.value.width / 2}px`);
  }, b = (A) => {
    const { width: $, height: R } = A.getBoundingClientRect(), { top: J, left: M } = l.altPosition ? l.altPosition(A) : g(A);
    return { top: +J, left: +M, width: $, height: R };
  }, L = () => {
    m.value.left = "50%", m.value.top = "50%", m.value.transform = "translate(-50%, -50%)", m.value.position = "fixed", delete m.value.opacity;
  }, j = () => {
    const A = nt(a), { top: $, left: R, transform: J } = l.altPosition(A);
    m.value = { top: `${$}px`, left: `${R}px`, transform: J ?? "" };
  }, I = (A = !0) => {
    var $;
    if (!n.value.enabled) {
      if (f.value)
        return L();
      if (l.altPosition !== null)
        return j();
      if (A) {
        const R = l.teleport ? ($ = t.value) == null ? void 0 : $.$el : e.value;
        R && (s.value = R.getBoundingClientRect()), i("recalculate-position");
      }
      return V();
    }
  }, C = ({ inputEl: A, left: $, width: R }) => {
    window.screen.width > 768 && !h.value && _($, R), de(A);
  }, B = (A) => {
    const { top: $, left: R, height: J, width: M } = b(A);
    m.value.top = `${J + $ + +l.offset}px`, p.value = !1, h.value || (m.value.left = `${R + M / 2 - s.value.width / 2}px`), C({ inputEl: A, left: R, width: M });
  }, U = (A) => {
    const { top: $, left: R, width: J } = b(A);
    m.value.top = `${$ - +l.offset - s.value.height}px`, p.value = !0, C({ inputEl: A, left: R, width: J });
  }, de = (A) => {
    if (l.autoPosition) {
      const { left: $, width: R } = b(A), { left: J, right: M } = s.value;
      if (!h.value) {
        if (Math.abs(J) !== Math.abs(M)) {
          if (J <= 0)
            return h.value = !0, q($);
          if (M >= document.documentElement.clientWidth)
            return h.value = !0, w($, R);
        }
        return _($, R);
      }
    }
  }, ae = () => {
    const A = nt(a);
    if (A) {
      const { height: $ } = s.value, { top: R, height: J } = A.getBoundingClientRect(), M = window.innerHeight - R - J, k = R;
      return $ <= M ? mr.bottom : $ > M && $ <= k ? mr.top : M >= k ? mr.bottom : mr.top;
    }
    return mr.bottom;
  }, S = (A) => ae() === mr.bottom ? B(A) : U(A), V = () => {
    const A = nt(a);
    if (A)
      return l.autoPosition ? S(A) : B(A);
  }, Z = function(A) {
    if (A) {
      const $ = A.scrollHeight > A.clientHeight, R = window.getComputedStyle(A).overflowY.indexOf("hidden") !== -1;
      return $ && !R;
    }
    return !0;
  }, re = function(A) {
    return !A || A === document.body || A.nodeType === Node.DOCUMENT_FRAGMENT_NODE ? window : Z(A) ? A : re(A.parentNode);
  }, F = (A) => {
    if (A)
      switch (l.position) {
        case _r.left:
          return { left: 0, transform: "translateX(0)" };
        case _r.right:
          return { left: `${A.width}px`, transform: "translateX(-100%)" };
        default:
          return { left: `${A.width / 2}px`, transform: "translateX(-50%)" };
      }
    return {};
  };
  return {
    openOnTop: p,
    menuStyle: m,
    xCorrect: h,
    setMenuPosition: I,
    getScrollableParent: re,
    shadowRender: (A, $) => {
      var R, J, M;
      const k = document.createElement("div"), O = (R = nt(a)) == null ? void 0 : R.getBoundingClientRect();
      k.setAttribute("id", "dp--temp-container");
      const E = (J = o.value) != null && J.clientWidth ? o.value : document.body;
      E.append(k);
      const te = F(O), se = L9(
        A,
        {
          ...$,
          shadow: !0,
          style: { opacity: 0, position: "absolute", ...te }
        },
        Object.fromEntries(
          Object.keys(c).filter((T) => ["right-sidebar", "left-sidebar"].includes(T)).map((T) => [T, c[T]])
        )
      );
      Hb(se, k), s.value = (M = se.el) == null ? void 0 : M.getBoundingClientRect(), Hb(null, k), E.removeChild(k);
    }
  };
}, ea = [
  { name: "clock-icon", use: ["time", "calendar", "shared"] },
  { name: "arrow-left", use: ["month-year", "calendar", "shared", "year-mode"] },
  { name: "arrow-right", use: ["month-year", "calendar", "shared", "year-mode"] },
  { name: "arrow-up", use: ["time", "calendar", "month-year", "shared"] },
  { name: "arrow-down", use: ["time", "calendar", "month-year", "shared"] },
  { name: "calendar-icon", use: ["month-year", "time", "calendar", "shared", "year-mode"] },
  { name: "day", use: ["calendar", "shared"] },
  { name: "month-overlay-value", use: ["calendar", "month-year", "shared"] },
  { name: "year-overlay-value", use: ["calendar", "month-year", "shared", "year-mode"] },
  { name: "year-overlay", use: ["month-year", "shared"] },
  { name: "month-overlay", use: ["month-year", "shared"] },
  { name: "month-overlay-header", use: ["month-year", "shared"] },
  { name: "year-overlay-header", use: ["month-year", "shared"] },
  { name: "hours-overlay-value", use: ["calendar", "time", "shared"] },
  { name: "minutes-overlay-value", use: ["calendar", "time", "shared"] },
  { name: "seconds-overlay-value", use: ["calendar", "time", "shared"] },
  { name: "hours", use: ["calendar", "time", "shared"] },
  { name: "minutes", use: ["calendar", "time", "shared"] },
  { name: "month", use: ["calendar", "month-year", "shared"] },
  { name: "year", use: ["calendar", "month-year", "shared", "year-mode"] },
  { name: "action-buttons", use: ["action"] },
  { name: "action-preview", use: ["action"] },
  { name: "calendar-header", use: ["calendar", "shared"] },
  { name: "marker-tooltip", use: ["calendar", "shared"] },
  { name: "action-extra", use: ["menu"] },
  { name: "time-picker-overlay", use: ["calendar", "time", "shared"] },
  { name: "am-pm-button", use: ["calendar", "time", "shared"] },
  { name: "left-sidebar", use: ["menu"] },
  { name: "right-sidebar", use: ["menu"] },
  { name: "month-year", use: ["month-year", "shared"] },
  { name: "time-picker", use: ["menu", "shared"] },
  { name: "action-row", use: ["action"] },
  { name: "marker", use: ["calendar", "shared"] },
  { name: "quarter", use: ["shared"] }
], fE = [{ name: "trigger" }, { name: "input-icon" }, { name: "clear-icon" }, { name: "dp-input" }], vE = {
  all: () => ea,
  monthYear: () => ea.filter((e) => e.use.includes("month-year")),
  input: () => fE,
  timePicker: () => ea.filter((e) => e.use.includes("time")),
  action: () => ea.filter((e) => e.use.includes("action")),
  calendar: () => ea.filter((e) => e.use.includes("calendar")),
  menu: () => ea.filter((e) => e.use.includes("menu")),
  shared: () => ea.filter((e) => e.use.includes("shared")),
  yearMode: () => ea.filter((e) => e.use.includes("year-mode"))
}, gt = (e, t, a) => {
  const o = [];
  return vE[t]().forEach((n) => {
    e[n.name] && o.push(n.name);
  }), a != null && a.length && a.forEach((n) => {
    n.slot && o.push(n.slot);
  }), o;
}, v1 = (e) => {
  const t = N(() => (o) => e.value ? o ? e.value.open : e.value.close : ""), a = N(() => (o) => e.value ? o ? e.value.menuAppearTop : e.value.menuAppearBottom : "");
  return { transitionName: t, showTransition: !!e.value, menuTransition: a };
}, m1 = (e, t) => {
  const a = ne(Tt(/* @__PURE__ */ new Date(), e.timezone)), o = W([{ month: He(a), year: qe(a) }]), n = u1({
    hours: e.range ? [qt(a), qt(a)] : qt(a),
    minutes: e.range ? [$t(a), $t(a)] : $t(a),
    seconds: e.range ? [0, 0] : 0
  }), i = N({
    get: () => e.internalModelValue,
    set: (s) => {
      !e.readonly && !e.disabled && t("update:internal-model-value", s);
    }
  }), l = N(
    () => (s) => o.value[s] ? o.value[s].month : 0
  ), c = N(
    () => (s) => o.value[s] ? o.value[s].year : 0
  );
  return {
    calendars: o,
    time: n,
    modelValue: i,
    month: l,
    year: c
  };
}, mE = (e, t) => {
  const { defaultedMultiCalendars: a, defaultedHighlight: o } = tt(t), { isDisabled: n, matchDate: i } = Cr(t), l = W(null), c = W(ne(Tt(/* @__PURE__ */ new Date(), t.timezone))), s = (M) => {
    !M.current && t.hideOffsetDates || (l.value = M.value);
  }, h = () => {
    l.value = null;
  }, m = (M) => Array.isArray(e.value) && t.range && e.value[0] && l.value ? M ? st(l.value, e.value[0]) : ct(l.value, e.value[0]) : !0, p = (M, k) => {
    const O = () => e.value ? k ? e.value[0] || null : e.value[1] : null, E = e.value && Array.isArray(e.value) ? O() : null;
    return Oe(ne(M.value), E);
  }, f = (M) => {
    const k = Array.isArray(e.value) ? e.value[0] : null;
    return M ? !ct(l.value ?? null, k) : !0;
  }, g = (M, k = !0) => (t.range || t.weekPicker) && Array.isArray(e.value) && e.value.length === 2 ? t.hideOffsetDates && !M.current ? !1 : Oe(ne(M.value), e.value[k ? 0 : 1]) : t.range ? p(M, k) && f(k) || Oe(M.value, Array.isArray(e.value) ? e.value[0] : null) && m(k) : !1, w = (M, k, O) => Array.isArray(e.value) && e.value[0] && e.value.length === 1 ? M ? !1 : O ? st(e.value[0], k.value) : ct(e.value[0], k.value) : !1, q = (M) => !e.value || t.hideOffsetDates && !M.current ? !1 : t.range ? t.modelAuto && Array.isArray(e.value) ? Oe(M.value, e.value[0] ? e.value[0] : c.value) : !1 : t.multiDates && Array.isArray(e.value) ? e.value.some((k) => Oe(k, M.value)) : Oe(M.value, e.value ? e.value : c.value), _ = (M) => {
    if (t.autoRange || t.weekPicker) {
      if (l.value) {
        if (t.hideOffsetDates && !M.current)
          return !1;
        const k = Wt(l.value, +t.autoRange), O = mx(ne(l.value), t.timezone, t.weekStart);
        return t.weekPicker ? Oe(O[1], ne(M.value)) : Oe(k, ne(M.value));
      }
      return !1;
    }
    return !1;
  }, b = (M) => {
    if (t.autoRange || t.weekPicker) {
      if (l.value) {
        const k = Wt(l.value, +t.autoRange);
        if (t.hideOffsetDates && !M.current)
          return !1;
        const O = mx(ne(l.value), t.timezone, t.weekStart);
        return t.weekPicker ? st(M.value, O[0]) && ct(M.value, O[1]) : st(M.value, l.value) && ct(M.value, k);
      }
      return !1;
    }
    return !1;
  }, L = (M) => {
    if (t.autoRange || t.weekPicker) {
      if (l.value) {
        if (t.hideOffsetDates && !M.current)
          return !1;
        const k = mx(ne(l.value), t.timezone, t.weekStart);
        return t.weekPicker ? Oe(k[0], M.value) : Oe(l.value, M.value);
      }
      return !1;
    }
    return !1;
  }, j = (M) => Gx(e.value, l.value, M.value), I = () => t.modelAuto && Array.isArray(t.internalModelValue) ? !!t.internalModelValue[0] : !1, C = () => t.modelAuto ? qL(t.internalModelValue) : !0, B = (M) => {
    if (Array.isArray(e.value) && e.value.length || t.weekPicker)
      return !1;
    const k = t.range ? !g(M) && !g(M, !1) : !0;
    return !n(M.value) && !q(M) && !(!M.current && t.hideOffsetDates) && k;
  }, U = (M) => t.range ? t.modelAuto ? I() && q(M) : !1 : q(M), de = (M) => {
    var k;
    return o.value ? typeof o.value == "function" ? o.value(M.value) : i(
      M.value,
      (k = t.arrMapValues) != null && k.highlightedDates ? t.arrMapValues.highlightedDates : o.value.dates
    ) : !1;
  }, ae = (M) => {
    const k = n(M.value);
    return k && (typeof o.value == "function" ? !o.value(M.value, k) : !o.value.options.highlightDisabled);
  }, S = (M) => {
    var k;
    return typeof o.value == "function" ? o.value(M.value) : (k = o.value.weekdays) == null ? void 0 : k.includes(M.value.getDay());
  }, V = (M) => (t.range || t.weekPicker) && (!(a.value.count > 0) || M.current) && C() && !(!M.current && t.hideOffsetDates) && !q(M) ? j(M) : !1, Z = (M) => {
    const { isRangeStart: k, isRangeEnd: O } = A(M), E = t.range ? k || O : !1;
    return {
      dp__cell_offset: !M.current,
      dp__pointer: !t.disabled && !(!M.current && t.hideOffsetDates) && !n(M.value),
      dp__cell_disabled: n(M.value),
      dp__cell_highlight: !ae(M) && (de(M) || S(M)) && !U(M) && !E && !L(M) && !(V(M) && t.weekPicker) && !O,
      dp__cell_highlight_active: !ae(M) && (de(M) || S(M)) && U(M),
      dp__today: !t.noToday && Oe(M.value, c.value) && M.current
    };
  }, re = (M) => ({
    dp__active_date: U(M),
    dp__date_hover: B(M)
  }), F = (M) => ({
    ...$(M),
    ...R(M),
    dp__range_between_week: V(M) && t.weekPicker
  }), A = (M) => {
    const k = a.value.count > 0 ? M.current && g(M) && C() : g(M) && C(), O = a.value.count > 0 ? M.current && g(M, !1) && C() : g(M, !1) && C();
    return { isRangeStart: k, isRangeEnd: O };
  }, $ = (M) => {
    const { isRangeStart: k, isRangeEnd: O } = A(M);
    return {
      dp__range_start: k,
      dp__range_end: O,
      dp__range_between: V(M) && !t.weekPicker,
      dp__date_hover_start: w(B(M), M, !0),
      dp__date_hover_end: w(B(M), M, !1)
    };
  }, R = (M) => ({
    ...$(M),
    dp__cell_auto_range: b(M),
    dp__cell_auto_range_start: L(M),
    dp__cell_auto_range_end: _(M)
  }), J = (M) => t.range ? t.autoRange ? R(M) : t.modelAuto ? { ...re(M), ...$(M) } : $(M) : t.weekPicker ? F(M) : re(M);
  return {
    setHoverDate: s,
    clearHoverDate: h,
    getDayClassData: (M) => t.hideOffsetDates && !M.current ? {} : {
      ...Z(M),
      ...J(M),
      [t.dayClass ? t.dayClass(M.value) : ""]: !0,
      [t.calendarCellClassName]: !!t.calendarCellClassName
    }
  };
}, Cr = (e) => {
  const { defaultedFilters: t, defaultedHighlight: a } = tt(e), o = () => {
    if (e.timezone)
      return e.timezone;
    if (e.utc)
      return "UTC";
  }, n = (S) => {
    const V = ut(i(ne(S))).toISOString(), [Z] = V.split("T");
    return Z;
  }, i = (S) => e.utc === "preserve" ? _L(S, o()) : Tt(S, o()), l = (S) => {
    var V;
    const Z = e.maxDate ? st(S, i(ne(e.maxDate))) : !1, re = e.minDate ? ct(S, i(ne(e.minDate))) : !1, F = m(
      i(S),
      (V = e.arrMapValues) != null && V.disabledDates ? e.arrMapValues.disabledDates : e.disabledDates
    ), A = t.value.months.map((k) => +k).includes(He(S)), $ = e.disabledWeekDays.length ? e.disabledWeekDays.some((k) => +k === WR(S)) : !1, R = f(S), J = qe(S), M = J < +e.yearRange[0] || J > +e.yearRange[1];
    return !(Z || re || F || A || M || $ || R);
  }, c = (S, V) => ct(...aa(e.minDate, S, V)) || Oe(...aa(e.minDate, S, V)), s = (S, V) => st(...aa(e.maxDate, S, V)) || Oe(...aa(e.maxDate, S, V)), h = (S, V, Z) => {
    let re = !1;
    return e.maxDate && Z && s(S, V) && (re = !0), e.minDate && !Z && c(S, V) && (re = !0), re;
  }, m = (S, V) => S ? V instanceof Map ? !!V.get(n(S)) : Array.isArray(V) ? V.some((Z) => Oe(i(ne(Z)), S)) : V ? V(ne(JSON.parse(JSON.stringify(S)))) : !1 : !0, p = (S, V, Z, re) => {
    let F = !1;
    return re ? e.minDate && e.maxDate ? F = h(S, V, Z) : (e.minDate && c(S, V) || e.maxDate && s(S, V)) && (F = !0) : F = !0, F;
  }, f = (S) => {
    var V, Z, re, F, A;
    return Array.isArray(e.allowedDates) && !((V = e.allowedDates) != null && V.length) ? !0 : (Z = e.arrMapValues) != null && Z.allowedDates ? !m(S, (re = e.arrMapValues) == null ? void 0 : re.allowedDates) : (F = e.allowedDates) != null && F.length ? !((A = e.allowedDates) != null && A.some(
      ($) => Oe(ut($), i(ut(S)))
    )) : !1;
  }, g = (S) => !l(S), w = (S) => e.noDisabledRange ? !rL({ start: S[0], end: S[1] }).some((V) => g(V)) : !0, q = (S, V, Z = 0) => {
    if (Array.isArray(V) && V[Z]) {
      const re = B$(S, V[Z]), F = BL(V[Z], S), A = F.length === 1 ? 0 : F.filter((R) => g(R)).length, $ = Math.abs(re) - A;
      if (e.minRange && e.maxRange)
        return $ >= +e.minRange && $ <= +e.maxRange;
      if (e.minRange)
        return $ >= +e.minRange;
      if (e.maxRange)
        return $ <= +e.maxRange;
    }
    return !0;
  }, _ = (S) => new Map(S.map((V) => [n(V), !0])), b = (S) => Array.isArray(S) && S.length > 0, L = () => {
    const S = {
      disabledDates: null,
      allowedDates: null,
      highlightedDates: null
    };
    return b(e.allowedDates) && (S.allowedDates = _(e.allowedDates)), typeof a.value != "function" && b(a.value.dates) && (S.highlightedDates = _(a.value.dates)), b(e.disabledDates) && (S.disabledDates = _(e.disabledDates)), S;
  }, j = () => !e.enableTimePicker || e.monthPicker || e.yearPicker || e.ignoreTimeValidation, I = (S) => Array.isArray(S) ? [S[0] ? v9(S[0]) : null, S[1] ? v9(S[1]) : null] : v9(S), C = (S, V, Z) => S.find(
    (re) => +re.hours === qt(V) && re.minutes === "*" ? !0 : +re.minutes === $t(V) && +re.hours === qt(V)
  ) && Z, B = (S, V, Z) => {
    const [re, F] = S, [A, $] = V;
    return !C(re, A, Z) && !C(F, $, Z) && Z;
  }, U = (S, V) => {
    const Z = Array.isArray(V) ? V : [V];
    return Array.isArray(e.disabledTimes) ? Array.isArray(e.disabledTimes[0]) ? B(e.disabledTimes, Z, S) : !Z.some((re) => C(e.disabledTimes, re, S)) : S;
  }, de = (S, V) => {
    const Z = Array.isArray(V) ? [Mr(V[0]), V[1] ? Mr(V[1]) : void 0] : Mr(V), re = !e.disabledTimes(Z);
    return S && re;
  }, ae = (S, V) => e.disabledTimes ? Array.isArray(e.disabledTimes) ? U(V, S) : de(V, S) : V;
  return {
    isDisabled: g,
    validateDate: l,
    validateMonthYearInRange: p,
    isDateRangeAllowed: w,
    checkMinMaxRange: q,
    matchDate: m,
    mapDatesArrToMap: L,
    isValidTime: (S) => {
      let V = !0;
      if (!S || j())
        return !0;
      const Z = !e.minDate && !e.maxDate ? I(S) : S;
      return (e.maxTime || e.maxDate) && (V = Qw(
        e.maxTime,
        e.maxDate,
        "max",
        rt(Z),
        V
      )), (e.minTime || e.minDate) && (V = Qw(
        e.minTime,
        e.minDate,
        "min",
        rt(Z),
        V
      )), ae(S, V);
    }
  };
}, Xx = () => {
  const e = N(() => (o, n) => o == null ? void 0 : o.includes(n)), t = N(() => (o, n) => o.count ? o.solo ? !0 : n === 0 : !0), a = N(() => (o, n) => o.count ? o.solo ? !0 : n === o.count - 1 : !0);
  return { hideNavigationButtons: e, showLeftIcon: t, showRightIcon: a };
}, gE = (e, t, a) => {
  const o = W(0), n = u1({
    [xr.timePicker]: !e.enableTimePicker || e.timePicker || e.monthPicker,
    [xr.calendar]: !1,
    [xr.header]: !1
  }), i = N(() => e.monthPicker), l = (p) => {
    var f;
    if ((f = e.flow) != null && f.length) {
      if (!p && i.value)
        return m();
      n[p] = !0, Object.keys(n).filter((g) => !n[g]).length || m();
    }
  }, c = () => {
    var p;
    (p = e.flow) != null && p.length && o.value !== -1 && (o.value += 1, t("flow-step", o.value), m());
  }, s = () => {
    o.value = -1;
  }, h = (p, f, ...g) => {
    e.flow[o.value] === p && a.value && a.value[f](...g);
  }, m = () => {
    h(Ht.month, "toggleMonthPicker", !0), h(Ht.year, "toggleYearPicker", !0), h(Ht.calendar, "toggleTimePicker", !1, !0), h(Ht.time, "toggleTimePicker", !0, !0);
    const p = e.flow[o.value];
    (p === Ht.hours || p === Ht.minutes || p === Ht.seconds) && h(p, "toggleTimePicker", !0, !0, p);
  };
  return { childMount: l, updateFlowStep: c, resetFlow: s, flowStep: o };
}, Kx = {
  multiCalendars: { type: [Boolean, Number, String, Object], default: void 0 },
  modelValue: { type: [String, Date, Array, Object, Number], default: null },
  modelType: { type: String, default: null },
  position: { type: String, default: "center" },
  dark: { type: Boolean, default: !1 },
  format: {
    type: [String, Function],
    default: () => null
  },
  autoPosition: { type: Boolean, default: !0 },
  altPosition: { type: Function, default: null },
  transitions: { type: [Boolean, Object], default: !0 },
  formatLocale: { type: Object, default: null },
  utc: { type: [Boolean, String], default: !1 },
  ariaLabels: { type: Object, default: () => ({}) },
  offset: { type: [Number, String], default: 10 },
  hideNavigation: { type: Array, default: () => [] },
  timezone: { type: String, default: null },
  emitTimezone: { type: String, default: null },
  vertical: { type: Boolean, default: !1 },
  disableMonthYearSelect: { type: Boolean, default: !1 },
  disableYearSelect: { type: Boolean, default: !1 },
  menuClassName: { type: String, default: null },
  dayClass: { type: Function, default: null },
  yearRange: { type: Array, default: () => [1900, 2100] },
  calendarCellClassName: { type: String, default: null },
  enableTimePicker: { type: Boolean, default: !0 },
  autoApply: { type: Boolean, default: !1 },
  disabledDates: { type: [Array, Function], default: () => [] },
  monthNameFormat: { type: String, default: "short" },
  startDate: { type: [Date, String], default: null },
  startTime: { type: [Object, Array], default: null },
  hideOffsetDates: { type: Boolean, default: !1 },
  autoRange: { type: [Number, String], default: null },
  noToday: { type: Boolean, default: !1 },
  disabledWeekDays: { type: Array, default: () => [] },
  allowedDates: { type: Array, default: null },
  nowButtonLabel: { type: String, default: "Now" },
  markers: { type: Array, default: () => [] },
  escClose: { type: Boolean, default: !0 },
  spaceConfirm: { type: Boolean, default: !0 },
  monthChangeOnArrows: { type: Boolean, default: !0 },
  presetDates: { type: Array, default: () => [] },
  flow: { type: Array, default: () => [] },
  partialFlow: { type: Boolean, default: !1 },
  preventMinMaxNavigation: { type: Boolean, default: !1 },
  minRange: { type: [Number, String], default: null },
  maxRange: { type: [Number, String], default: null },
  multiDatesLimit: { type: [Number, String], default: null },
  reverseYears: { type: Boolean, default: !1 },
  weekPicker: { type: Boolean, default: !1 },
  filters: { type: Object, default: () => ({}) },
  arrowNavigation: { type: Boolean, default: !1 },
  disableTimeRangeValidation: { type: Boolean, default: !1 },
  highlight: {
    type: [Array, Function, Object],
    default: null
  },
  highlightWeekDays: {
    type: Array,
    default: null
  },
  highlightDisabledDays: { type: Boolean, default: !1 },
  teleport: { type: [String, Boolean, Object], default: null },
  teleportCenter: { type: Boolean, default: !1 },
  locale: { type: String, default: "en-Us" },
  weekNumName: { type: String, default: "W" },
  weekStart: { type: [Number, String], default: 1 },
  weekNumbers: {
    type: [String, Function, Object],
    default: null
  },
  calendarClassName: { type: String, default: null },
  monthChangeOnScroll: { type: [Boolean, String], default: !0 },
  dayNames: {
    type: [Function, Array],
    default: null
  },
  monthPicker: { type: Boolean, default: !1 },
  customProps: { type: Object, default: null },
  yearPicker: { type: Boolean, default: !1 },
  modelAuto: { type: Boolean, default: !1 },
  selectText: { type: String, default: "Select" },
  cancelText: { type: String, default: "Cancel" },
  previewFormat: {
    type: [String, Function],
    default: () => ""
  },
  multiDates: { type: Boolean, default: !1 },
  partialRange: { type: Boolean, default: !0 },
  ignoreTimeValidation: { type: Boolean, default: !1 },
  minDate: { type: [Date, String], default: null },
  maxDate: { type: [Date, String], default: null },
  minTime: { type: Object, default: null },
  maxTime: { type: Object, default: null },
  name: { type: String, default: null },
  placeholder: { type: String, default: "" },
  hideInputIcon: { type: Boolean, default: !1 },
  clearable: { type: Boolean, default: !0 },
  state: { type: Boolean, default: null },
  required: { type: Boolean, default: !1 },
  autocomplete: { type: String, default: "off" },
  inputClassName: { type: String, default: null },
  fixedStart: { type: Boolean, default: !1 },
  fixedEnd: { type: Boolean, default: !1 },
  timePicker: { type: Boolean, default: !1 },
  enableSeconds: { type: Boolean, default: !1 },
  is24: { type: Boolean, default: !0 },
  noHoursOverlay: { type: Boolean, default: !1 },
  noMinutesOverlay: { type: Boolean, default: !1 },
  noSecondsOverlay: { type: Boolean, default: !1 },
  hoursGridIncrement: { type: [String, Number], default: 1 },
  minutesGridIncrement: { type: [String, Number], default: 5 },
  secondsGridIncrement: { type: [String, Number], default: 5 },
  hoursIncrement: { type: [Number, String], default: 1 },
  minutesIncrement: { type: [Number, String], default: 1 },
  secondsIncrement: { type: [Number, String], default: 1 },
  range: { type: Boolean, default: !1 },
  uid: { type: String, default: null },
  disabled: { type: Boolean, default: !1 },
  readonly: { type: Boolean, default: !1 },
  inline: { type: [Boolean, Object], default: !1 },
  textInput: { type: [Boolean, Object], default: !1 },
  noDisabledRange: { type: Boolean, default: !1 },
  sixWeeks: { type: [Boolean, String], default: !1 },
  actionRow: { type: Object, default: () => ({}) },
  focusStartDate: { type: Boolean, default: !1 },
  disabledTimes: { type: [Function, Array], default: void 0 },
  showLastInRange: { type: Boolean, default: !0 },
  timePickerInline: { type: Boolean, default: !1 },
  calendar: { type: Function, default: null },
  config: { type: Object, default: void 0 },
  quarterPicker: { type: Boolean, default: !1 },
  yearFirst: { type: Boolean, default: !1 }
}, Dt = {
  ...Kx,
  shadow: { type: Boolean, default: !1 },
  flowStep: { type: Number, default: 0 },
  internalModelValue: { type: [Date, Array], default: null },
  arrMapValues: { type: Object, default: () => ({}) },
  noOverlayFocus: { type: Boolean, default: !1 }
}, ME = {
  key: 1,
  class: "dp__input_wrap"
}, xE = ["id", "name", "inputmode", "placeholder", "disabled", "readonly", "required", "value", "autocomplete", "aria-label", "aria-disabled", "aria-invalid"], bE = {
  key: 2,
  class: "dp__clear_icon"
}, wE = /* @__PURE__ */ dt({
  compatConfig: {
    MODE: 3
  },
  __name: "DatepickerInput",
  props: {
    isMenuOpen: { type: Boolean, default: !1 },
    inputValue: { type: String, default: "" },
    ...Kx
  },
  emits: [
    "clear",
    "open",
    "update:input-value",
    "set-input-date",
    "close",
    "select-date",
    "set-empty-date",
    "toggle",
    "focus-prev",
    "focus",
    "blur",
    "real-blur"
  ],
  setup(e, { expose: t, emit: a }) {
    const o = a, n = e, {
      defaultedTextInput: i,
      defaultedAriaLabels: l,
      defaultedInline: c,
      defaultedConfig: s,
      getDefaultPattern: h,
      getDefaultStartTime: m
    } = tt(n), { checkMinMaxRange: p } = Cr(n), f = W(), g = W(null), w = W(!1), q = W(!1), _ = N(
      () => ({
        dp__pointer: !n.disabled && !n.readonly && !i.value.enabled,
        dp__disabled: n.disabled,
        dp__input_readonly: !i.value.enabled,
        dp__input: !0,
        dp__input_icon_pad: !n.hideInputIcon,
        dp__input_valid: !!n.state,
        dp__input_invalid: n.state === !1,
        dp__input_focus: w.value || n.isMenuOpen,
        dp__input_reg: !i.value.enabled,
        [n.inputClassName]: !!n.inputClassName
      })
    ), b = () => {
      o("set-input-date", null), n.autoApply && (o("set-empty-date"), f.value = null);
    }, L = (F) => {
      const A = m();
      return YU(
        F,
        i.value.format ?? h(),
        A ?? zL({}, n.enableSeconds),
        n.inputValue,
        q.value
      );
    }, j = (F) => {
      const { rangeSeparator: A } = i.value, [$, R] = F.split(`${A}`);
      if ($) {
        const J = L($.trim()), M = R ? L(R.trim()) : null, k = J && M ? [J, M] : [J];
        p(M, k, 0) && (f.value = J ? k : null);
      }
    }, I = () => {
      q.value = !0;
    }, C = (F) => {
      if (n.range)
        j(F);
      else if (n.multiDates) {
        const A = F.split(";");
        f.value = A.map(($) => L($.trim())).filter(($) => $);
      } else
        f.value = L(F);
    }, B = (F) => {
      var A;
      const $ = typeof F == "string" ? F : (A = F.target) == null ? void 0 : A.value;
      $ !== "" ? (i.value.openMenu && !n.isMenuOpen && o("open"), C($), o("set-input-date", f.value)) : b(), q.value = !1, o("update:input-value", $);
    }, U = (F) => {
      i.value.enabled ? (C(F.target.value), i.value.enterSubmit && U9(f.value) && n.inputValue !== "" ? (o("set-input-date", f.value, !0), f.value = null) : i.value.enterSubmit && n.inputValue === "" && (f.value = null, o("clear"))) : S(F);
    }, de = (F) => {
      i.value.enabled && i.value.tabSubmit && C(F.target.value), i.value.tabSubmit && U9(f.value) && n.inputValue !== "" ? (o("set-input-date", f.value, !0, !0), f.value = null) : i.value.tabSubmit && n.inputValue === "" && (f.value = null, o("clear", !0));
    }, ae = () => {
      var F;
      w.value = !0, o("focus"), i.value.enabled && i.value.selectOnFocus && ((F = g.value) == null || F.select());
    }, S = (F) => {
      F.preventDefault(), oa(F, s.value, !0), i.value.enabled && i.value.openMenu && !c.value.input && !n.isMenuOpen ? o("open") : i.value.enabled || o("toggle");
    }, V = () => {
      o("real-blur"), w.value = !1, (!n.isMenuOpen || c.value.enabled && c.value.input) && o("blur"), n.autoApply && i.value.enabled && f.value && !n.isMenuOpen && (o("set-input-date", f.value), o("select-date"), f.value = null);
    }, Z = (F) => {
      oa(F, s.value, !0), o("clear");
    }, re = (F) => {
      if (!i.value.enabled) {
        if (F.code === "Tab")
          return;
        F.preventDefault();
      }
    };
    return t({
      focusInput: () => {
        var F;
        (F = g.value) == null || F.focus({ preventScroll: !0 });
      },
      setParsedDate: (F) => {
        f.value = F;
      }
    }), (F, A) => {
      var $;
      return d(), y("div", { onClick: S }, [
        F.$slots.trigger && !F.$slots["dp-input"] && !u(c).enabled ? ee(F.$slots, "trigger", { key: 0 }) : v("", !0),
        !F.$slots.trigger && (!u(c).enabled || u(c).input) ? (d(), y("div", ME, [
          F.$slots["dp-input"] && !F.$slots.trigger && !u(c).enabled ? ee(F.$slots, "dp-input", {
            key: 0,
            value: e.inputValue,
            isMenuOpen: e.isMenuOpen,
            onInput: B,
            onEnter: U,
            onTab: de,
            onClear: Z,
            onBlur: V,
            onKeypress: re,
            onPaste: I,
            openMenu: () => F.$emit("open"),
            closeMenu: () => F.$emit("close"),
            toggleMenu: () => F.$emit("toggle")
          }) : v("", !0),
          F.$slots["dp-input"] ? v("", !0) : (d(), y("input", {
            key: 1,
            id: F.uid ? `dp-input-${F.uid}` : void 0,
            ref_key: "inputRef",
            ref: g,
            name: F.name,
            class: Pe(_.value),
            inputmode: u(i).enabled ? "text" : "none",
            placeholder: F.placeholder,
            disabled: F.disabled,
            readonly: F.readonly,
            required: F.required,
            value: e.inputValue,
            autocomplete: F.autocomplete,
            "aria-label": ($ = u(l)) == null ? void 0 : $.input,
            "aria-disabled": F.disabled || void 0,
            "aria-invalid": F.state === !1 ? !0 : void 0,
            onInput: B,
            onKeydown: [
              Ae(U, ["enter"]),
              Ae(de, ["tab"]),
              re
            ],
            onBlur: V,
            onFocus: ae,
            onKeypress: re,
            onPaste: I
          }, null, 42, xE)),
          D("div", {
            onClick: A[2] || (A[2] = (R) => o("toggle"))
          }, [
            F.$slots["input-icon"] && !F.hideInputIcon ? (d(), y("span", {
              key: 0,
              class: "dp__input_icon",
              onClick: A[0] || (A[0] = (R) => o("toggle"))
            }, [
              ee(F.$slots, "input-icon")
            ])) : v("", !0),
            !F.$slots["input-icon"] && !F.hideInputIcon && !F.$slots["dp-input"] ? (d(), Q(u(Gr), {
              key: 1,
              class: "dp__input_icon dp__input_icons",
              onClick: A[1] || (A[1] = (R) => o("toggle"))
            })) : v("", !0)
          ]),
          F.$slots["clear-icon"] && e.inputValue && F.clearable && !F.disabled && !F.readonly ? (d(), y("span", bE, [
            ee(F.$slots, "clear-icon", { clear: Z })
          ])) : v("", !0),
          F.clearable && !F.$slots["clear-icon"] && e.inputValue && !F.disabled && !F.readonly ? (d(), Q(u(LL), {
            key: 3,
            class: "dp__clear_icon dp__input_icons",
            onClick: A[3] || (A[3] = Ue((R) => Z(R), ["prevent"]))
          })) : v("", !0)
        ])) : v("", !0)
      ]);
    };
  }
}), IE = ["title"], LE = { class: "dp__action_buttons" }, SE = ["disabled"], CE = /* @__PURE__ */ dt({
  compatConfig: {
    MODE: 3
  },
  __name: "ActionRow",
  props: {
    menuMount: { type: Boolean, default: !1 },
    calendarWidth: { type: Number, default: 0 },
    ...Dt
  },
  emits: ["close-picker", "select-date", "select-now", "invalid-select"],
  setup(e, { emit: t }) {
    const a = t, o = e, {
      defaultedActionRow: n,
      defaultedPreviewFormat: i,
      defaultedMultiCalendars: l,
      defaultedTextInput: c,
      defaultedInline: s,
      getDefaultPattern: h
    } = tt(o), { isValidTime: m } = Cr(o), { buildMatrix: p } = la(), f = W(null), g = W(null);
    at(() => {
      o.arrowNavigation && p([nt(f), nt(g)], "actionRow");
    });
    const w = N(() => o.range && !o.partialRange && o.internalModelValue ? o.internalModelValue.length === 2 : !0), q = N(() => !_.value || !b.value || !w.value), _ = N(() => !o.enableTimePicker || o.ignoreTimeValidation ? !0 : m(o.internalModelValue)), b = N(() => o.monthPicker ? o.range && Array.isArray(o.internalModelValue) ? !o.internalModelValue.filter((S) => !de(S)).length : de(o.internalModelValue) : !0), L = () => {
      const S = i.value;
      return o.timePicker || o.monthPicker, S(rt(o.internalModelValue));
    }, j = () => {
      const S = o.internalModelValue;
      return l.value.count > 0 ? `${I(S[0])} - ${I(S[1])}` : [I(S[0]), I(S[1])];
    }, I = (S) => jL(
      S,
      i.value,
      o.formatLocale,
      c.value.rangeSeparator,
      o.modelAuto,
      h()
    ), C = N(() => !o.internalModelValue || !o.menuMount ? "" : typeof i.value == "string" ? Array.isArray(o.internalModelValue) ? o.internalModelValue.length === 2 && o.internalModelValue[1] ? j() : o.multiDates ? o.internalModelValue.map((S) => `${I(S)}`) : o.modelAuto ? `${I(o.internalModelValue[0])}` : `${I(o.internalModelValue[0])} -` : I(o.internalModelValue) : L()), B = () => o.multiDates ? "; " : " - ", U = N(
      () => Array.isArray(C.value) ? C.value.join(B()) : C.value
    ), de = (S) => {
      if (!o.monthPicker)
        return !0;
      let V = !0;
      const Z = ne(At(S));
      if (o.minDate && o.maxDate) {
        const re = ne(At(o.minDate)), F = ne(At(o.maxDate));
        return st(Z, re) && ct(Z, F) || Oe(Z, re) || Oe(Z, F);
      }
      if (o.minDate) {
        const re = ne(At(o.minDate));
        V = st(Z, re) || Oe(Z, re);
      }
      if (o.maxDate) {
        const re = ne(At(o.maxDate));
        V = ct(Z, re) || Oe(Z, re);
      }
      return V;
    }, ae = () => {
      _.value && b.value && w.value ? a("select-date") : a("invalid-select");
    };
    return (S, V) => (d(), y("div", {
      class: "dp__action_row",
      style: yt(e.calendarWidth ? { width: `${e.calendarWidth}px` } : {})
    }, [
      S.$slots["action-row"] ? ee(S.$slots, "action-row", P(H({ key: 0 }, {
        internalModelValue: S.internalModelValue,
        disabled: q.value,
        selectDate: () => S.$emit("select-date"),
        closePicker: () => S.$emit("close-picker")
      }))) : (d(), y(ge, { key: 1 }, [
        u(n).showPreview ? (d(), y("div", {
          key: 0,
          class: "dp__selection_preview",
          title: U.value
        }, [
          S.$slots["action-preview"] ? ee(S.$slots, "action-preview", {
            key: 0,
            value: S.internalModelValue
          }) : v("", !0),
          S.$slots["action-preview"] ? v("", !0) : (d(), y(ge, { key: 1 }, [
            wt(G(U.value), 1)
          ], 64))
        ], 8, IE)) : v("", !0),
        D("div", LE, [
          S.$slots["action-buttons"] ? ee(S.$slots, "action-buttons", {
            key: 0,
            value: S.internalModelValue
          }) : v("", !0),
          S.$slots["action-buttons"] ? v("", !0) : (d(), y(ge, { key: 1 }, [
            !u(s).enabled && u(n).showCancel ? (d(), y("button", {
              key: 0,
              ref_key: "cancelButtonRef",
              ref: f,
              type: "button",
              class: "dp__action_button dp__action_cancel",
              onClick: V[0] || (V[0] = (Z) => S.$emit("close-picker")),
              onKeydown: [
                V[1] || (V[1] = Ae((Z) => S.$emit("close-picker"), ["enter"])),
                V[2] || (V[2] = Ae((Z) => S.$emit("close-picker"), ["space"]))
              ]
            }, G(S.cancelText), 545)) : v("", !0),
            u(n).showNow ? (d(), y("button", {
              key: 1,
              ref_key: "cancelButtonRef",
              ref: f,
              type: "button",
              class: "dp__action_button dp__action_cancel",
              onClick: V[3] || (V[3] = (Z) => S.$emit("select-now")),
              onKeydown: [
                V[4] || (V[4] = Ae((Z) => S.$emit("select-now"), ["enter"])),
                V[5] || (V[5] = Ae((Z) => S.$emit("select-now"), ["space"]))
              ]
            }, G(S.nowButtonLabel), 545)) : v("", !0),
            u(n).showSelect ? (d(), y("button", {
              key: 2,
              ref_key: "selectButtonRef",
              ref: g,
              type: "button",
              class: "dp__action_button dp__action_select",
              disabled: q.value,
              onKeydown: [
                Ae(ae, ["enter"]),
                Ae(ae, ["space"])
              ],
              onClick: ae
            }, G(S.selectText), 41, SE)) : v("", !0)
          ], 64))
        ])
      ], 64))
    ], 4));
  }
}), AE = ["onKeydown"], PE = { class: "dp__selection_grid_header" }, qE = ["aria-selected", "aria-disabled", "onClick", "onKeydown", "onMouseover"], TE = ["aria-label"], g1 = /* @__PURE__ */ dt({
  __name: "SelectionOverlay",
  props: {
    items: {},
    type: {},
    isLast: { type: Boolean },
    arrowNavigation: { type: Boolean },
    skipButtonRef: { type: Boolean },
    headerRefs: {},
    hideNavigation: {},
    escClose: { type: Boolean },
    useRelative: { type: Boolean },
    height: {},
    textInput: { type: [Boolean, Object] },
    config: {},
    noOverlayFocus: { type: Boolean },
    focusValue: {}
  },
  emits: ["selected", "toggle", "reset-flow", "hover-value"],
  setup(e, { expose: t, emit: a }) {
    const { setSelectionGrid: o, buildMultiLevelMatrix: n, setMonthPicker: i } = la(), l = a, c = e, { defaultedAriaLabels: s, defaultedTextInput: h, defaultedConfig: m } = tt(
      c
    ), { hideNavigationButtons: p } = Xx(), f = W(!1), g = W(null), w = W(null), q = W([]), _ = W(), b = W(null), L = W(0), j = W(null);
    JL(() => {
      g.value = null;
    }), at(() => {
      Gt().then(() => V()), c.noOverlayFocus || C(), I(!0);
    }), $r(() => I(!1));
    const I = (M) => {
      var k;
      c.arrowNavigation && ((k = c.headerRefs) != null && k.length ? i(M) : o(M));
    }, C = () => {
      var M;
      const k = nt(w);
      k && (h.value.enabled || (g.value ? (M = g.value) == null || M.focus({ preventScroll: !0 }) : k.focus({ preventScroll: !0 })), f.value = k.clientHeight < k.scrollHeight);
    }, B = N(
      () => ({
        dp__overlay: !0,
        "dp--overlay-absolute": !c.useRelative,
        "dp--overlay-relative": c.useRelative
      })
    ), U = N(
      () => c.useRelative ? { height: `${c.height}px`, width: "260px" } : void 0
    ), de = N(() => ({
      dp__overlay_col: !0
    })), ae = N(
      () => ({
        dp__btn: !0,
        dp__button: !0,
        dp__overlay_action: !0,
        dp__over_action_scroll: f.value,
        dp__button_bottom: c.isLast
      })
    ), S = N(() => {
      var M, k;
      return {
        dp__overlay_container: !0,
        dp__container_flex: ((M = c.items) == null ? void 0 : M.length) <= 6,
        dp__container_block: ((k = c.items) == null ? void 0 : k.length) > 6
      };
    });
    ot(
      () => c.items,
      () => V(),
      { deep: !0 }
    );
    const V = () => {
      Gt().then(() => {
        const M = nt(g), k = nt(w), O = nt(b), E = nt(j), te = O ? O.getBoundingClientRect().height : 0;
        k && (k.getBoundingClientRect().height ? L.value = k.getBoundingClientRect().height - te : L.value = m.value.modeHeight - te), M && E && (E.scrollTop = M.offsetTop - E.offsetTop - (L.value / 2 - M.getBoundingClientRect().height) - te);
      });
    }, Z = (M) => {
      M.disabled || l("selected", M.value);
    }, re = () => {
      l("toggle"), l("reset-flow");
    }, F = () => {
      c.escClose && re();
    }, A = (M, k, O, E) => {
      M && ((k.active || k.value === c.focusValue) && (g.value = M), c.arrowNavigation && (Array.isArray(q.value[O]) ? q.value[O][E] = M : q.value[O] = [M], $()));
    }, $ = () => {
      var M, k;
      const O = (M = c.headerRefs) != null && M.length ? [c.headerRefs].concat(q.value) : q.value.concat([c.skipButtonRef ? [] : [b.value]]);
      n(rt(O), (k = c.headerRefs) != null && k.length ? "monthPicker" : "selectionGrid");
    }, R = (M) => {
      c.arrowNavigation || oa(M, m.value, !0);
    }, J = (M) => {
      _.value = M, l("hover-value", M);
    };
    return t({ focusGrid: C }), (M, k) => {
      var O;
      return d(), y("div", {
        ref_key: "gridWrapRef",
        ref: w,
        class: Pe(B.value),
        style: yt(U.value),
        role: "dialog",
        tabindex: "0",
        onKeydown: [
          Ae(Ue(F, ["prevent"]), ["esc"]),
          k[0] || (k[0] = Ae(Ue((E) => R(E), ["prevent"]), ["left"])),
          k[1] || (k[1] = Ae(Ue((E) => R(E), ["prevent"]), ["up"])),
          k[2] || (k[2] = Ae(Ue((E) => R(E), ["prevent"]), ["down"])),
          k[3] || (k[3] = Ae(Ue((E) => R(E), ["prevent"]), ["right"]))
        ]
      }, [
        D("div", {
          ref_key: "containerRef",
          ref: j,
          class: Pe(S.value),
          role: "grid",
          style: yt({ height: `${L.value}px` })
        }, [
          D("div", PE, [
            ee(M.$slots, "header")
          ]),
          M.$slots.overlay ? ee(M.$slots, "overlay", { key: 0 }) : (d(!0), y(ge, { key: 1 }, Ie(M.items, (E, te) => (d(), y("div", {
            key: te,
            class: Pe(["dp__overlay_row", { dp__flex_row: M.items.length >= 3 }]),
            role: "row"
          }, [
            (d(!0), y(ge, null, Ie(E, (se, T) => (d(), y("div", {
              key: se.value,
              ref_for: !0,
              ref: (x) => A(x, se, te, T),
              role: "gridcell",
              class: Pe(de.value),
              "aria-selected": se.active,
              "aria-disabled": se.disabled || void 0,
              tabindex: "0",
              onClick: (x) => Z(se),
              onKeydown: [
                Ae(Ue((x) => Z(se), ["prevent"]), ["enter"]),
                Ae(Ue((x) => Z(se), ["prevent"]), ["space"])
              ],
              onMouseover: (x) => J(se.value)
            }, [
              D("div", {
                class: Pe(se.className)
              }, [
                M.$slots.item ? ee(M.$slots, "item", {
                  key: 0,
                  item: se
                }) : v("", !0),
                M.$slots.item ? v("", !0) : (d(), y(ge, { key: 1 }, [
                  wt(G(se.text), 1)
                ], 64))
              ], 2)
            ], 42, qE))), 128))
          ], 2))), 128))
        ], 6),
        M.$slots["button-icon"] ? Zt((d(), y("button", {
          key: 0,
          ref_key: "toggleButton",
          ref: b,
          type: "button",
          "aria-label": (O = u(s)) == null ? void 0 : O.toggleOverlay,
          class: Pe(ae.value),
          tabindex: "0",
          onClick: re,
          onKeydown: [
            Ae(re, ["enter"]),
            Ae(re, ["tab"])
          ]
        }, [
          ee(M.$slots, "button-icon")
        ], 42, TE)), [
          [Yt, !u(p)(M.hideNavigation, M.type)]
        ]) : v("", !0)
      ], 46, AE);
    };
  }
}), Qx = /* @__PURE__ */ dt({
  __name: "InstanceWrap",
  props: {
    multiCalendars: {},
    stretch: { type: Boolean }
  },
  setup(e) {
    const t = e, a = N(
      () => t.multiCalendars > 0 ? [...Array(t.multiCalendars).keys()] : [0]
    ), o = N(() => ({
      dp__instance_calendar: t.multiCalendars > 0
    }));
    return (n, i) => (d(), y("div", {
      class: Pe({
        dp__menu_inner: !n.stretch,
        "dp--menu--inner-stretched": n.stretch,
        dp__flex_display: n.multiCalendars > 0
      })
    }, [
      (d(!0), y(ge, null, Ie(a.value, (l, c) => (d(), y("div", {
        key: l,
        class: Pe(o.value)
      }, [
        ee(n.$slots, "default", {
          instance: l,
          index: c
        })
      ], 2))), 128))
    ], 2));
  }
}), DE = ["aria-label", "aria-disabled"], r1 = /* @__PURE__ */ dt({
  compatConfig: {
    MODE: 3
  },
  __name: "ArrowBtn",
  props: {
    ariaLabel: {},
    disabled: { type: Boolean }
  },
  emits: ["activate", "set-ref"],
  setup(e, { emit: t }) {
    const a = t, o = W(null);
    return at(() => a("set-ref", o)), (n, i) => (d(), y("button", {
      ref_key: "elRef",
      ref: o,
      type: "button",
      class: "dp__btn dp--arrow-btn-nav",
      tabindex: "0",
      "aria-label": n.ariaLabel,
      "aria-disabled": n.disabled || void 0,
      onClick: i[0] || (i[0] = (l) => n.$emit("activate")),
      onKeydown: [
        i[1] || (i[1] = Ae(Ue((l) => n.$emit("activate"), ["prevent"]), ["enter"])),
        i[2] || (i[2] = Ae(Ue((l) => n.$emit("activate"), ["prevent"]), ["space"]))
      ]
    }, [
      D("span", {
        class: Pe(["dp__inner_nav", { dp__inner_nav_disabled: n.disabled }])
      }, [
        ee(n.$slots, "default")
      ], 2)
    ], 40, DE));
  }
}), _E = { class: "dp--year-mode-picker" }, BE = ["aria-label"], $L = /* @__PURE__ */ dt({
  __name: "YearModePicker",
  props: {
    ...Dt,
    showYearPicker: { type: Boolean, default: !1 },
    items: { type: Array, default: () => [] },
    instance: { type: Number, default: 0 },
    year: { type: Number, default: 0 },
    isDisabled: { type: Function, default: () => !1 }
  },
  emits: ["toggle-year-picker", "year-select", "handle-year"],
  setup(e, { emit: t }) {
    const a = t, o = e, { showRightIcon: n, showLeftIcon: i } = Xx(), { defaultedConfig: l, defaultedMultiCalendars: c, defaultedAriaLabels: s, defaultedTransitions: h } = tt(o), { showTransition: m, transitionName: p } = v1(h), f = (q = !1, _) => {
      a("toggle-year-picker", { flow: q, show: _ });
    }, g = (q) => {
      a("year-select", q);
    }, w = (q = !1) => {
      a("handle-year", q);
    };
    return (q, _) => {
      var b, L, j;
      return d(), y("div", _E, [
        u(i)(u(c), e.instance) ? (d(), Q(r1, {
          key: 0,
          ref: "mpPrevIconRef",
          "aria-label": (b = u(s)) == null ? void 0 : b.prevYear,
          disabled: e.isDisabled(!1),
          onActivate: _[0] || (_[0] = (I) => w(!1))
        }, {
          default: ke(() => [
            q.$slots["arrow-left"] ? ee(q.$slots, "arrow-left", { key: 0 }) : v("", !0),
            q.$slots["arrow-left"] ? v("", !0) : (d(), Q(u(Mb), { key: 1 }))
          ]),
          _: 3
        }, 8, ["aria-label", "disabled"])) : v("", !0),
        D("button", {
          ref: "mpYearButtonRef",
          class: "dp__btn dp--year-select",
          type: "button",
          "aria-label": (L = u(s)) == null ? void 0 : L.openYearsOverlay,
          onClick: _[1] || (_[1] = () => f(!1)),
          onKeydown: _[2] || (_[2] = Ae(() => f(!1), ["enter"]))
        }, [
          q.$slots.year ? ee(q.$slots, "year", {
            key: 0,
            year: e.year
          }) : v("", !0),
          q.$slots.year ? v("", !0) : (d(), y(ge, { key: 1 }, [
            wt(G(e.year), 1)
          ], 64))
        ], 40, BE),
        u(n)(u(c), e.instance) ? (d(), Q(r1, {
          key: 1,
          ref: "mpNextIconRef",
          "aria-label": (j = u(s)) == null ? void 0 : j.nextYear,
          disabled: e.isDisabled(!0),
          onActivate: _[3] || (_[3] = (I) => w(!0))
        }, {
          default: ke(() => [
            q.$slots["arrow-right"] ? ee(q.$slots, "arrow-right", { key: 0 }) : v("", !0),
            q.$slots["arrow-right"] ? v("", !0) : (d(), Q(u(xb), { key: 1 }))
          ]),
          _: 3
        }, 8, ["aria-label", "disabled"])) : v("", !0),
        be(Rr, {
          name: u(p)(e.showYearPicker),
          css: u(m)
        }, {
          default: ke(() => [
            e.showYearPicker ? (d(), Q(g1, {
              key: 0,
              items: e.items,
              "text-input": q.textInput,
              "esc-close": q.escClose,
              config: q.config,
              "is-last": q.autoApply && !u(l).keepActionRow,
              "hide-navigation": q.hideNavigation,
              type: "year",
              onToggle: f,
              onSelected: _[4] || (_[4] = (I) => g(I))
            }, kt({
              "button-icon": ke(() => [
                q.$slots["calendar-icon"] ? ee(q.$slots, "calendar-icon", { key: 0 }) : v("", !0),
                q.$slots["calendar-icon"] ? v("", !0) : (d(), Q(u(Gr), { key: 1 }))
              ]),
              _: 2
            }, [
              q.$slots["year-overlay-value"] ? {
                name: "item",
                fn: ke(({ item: I }) => [
                  ee(q.$slots, "year-overlay-value", {
                    text: I.text,
                    value: I.value
                  })
                ]),
                key: "0"
              } : void 0
            ]), 1032, ["items", "text-input", "esc-close", "config", "is-last", "hide-navigation"])) : v("", !0)
          ]),
          _: 3
        }, 8, ["name", "css"])
      ]);
    };
  }
}), qb = (e, t, a) => {
  if (t.value && Array.isArray(t.value))
    if (t.value.some((o) => Oe(e, o))) {
      const o = t.value.filter((n) => !Oe(n, e));
      t.value = o.length ? o : null;
    } else
      (a && +a > t.value.length || !a) && t.value.push(e);
  else
    t.value = [e];
}, Tb = (e, t, a) => {
  let o = e.value ? e.value.slice() : [];
  return o.length === 2 && o[1] !== null && (o = []), o.length ? ct(t, o[0]) ? (o.unshift(t), a("range-start", o[0]), a("range-start", o[1])) : (o[1] = t, a("range-end", t)) : (o = [t], a("range-start", t)), e.value = o, o;
}, Jx = (e, t, a, o) => {
  e[0] && e[1] && a && t("auto-apply"), e[0] && !e[1] && o && a && t("auto-apply");
}, RL = (e) => {
  Array.isArray(e.value) && e.value.length <= 2 && e.range ? e.modelValue.value = e.value.map((t) => Tt(ne(t), e.timezone)) : Array.isArray(e.value) || (e.modelValue.value = Tt(ne(e.value), e.timezone));
}, FL = ({
  multiCalendars: e,
  highlight: t,
  calendars: a,
  modelValue: o,
  props: n,
  year: i,
  month: l,
  emit: c
}) => {
  const s = N(() => Ab(n.yearRange, n.reverseYears)), h = W([!1]), m = N(() => (I, C) => {
    const B = Ge(At(/* @__PURE__ */ new Date()), {
      month: l.value(I),
      year: i.value(I)
    });
    return HL(B, n.maxDate, n.minDate, n.preventMinMaxNavigation, C);
  }), p = () => {
    for (let I = 0; I < e.value.count; I++)
      if (I === 0)
        a.value[I] = a.value[0];
      else {
        const C = Ge(ne(), a.value[I - 1]);
        a.value[I] = { month: He(C), year: qe(hb(C, 1)) };
      }
  }, f = (I) => {
    if (!I)
      return p();
    const C = Ge(ne(), a.value[I]);
    return a.value[0].year = qe(IL(C, e.value.count - 1)), p();
  }, g = (I) => n.focusStartDate ? I[0] : I[1] ? I[1] : I[0], w = () => {
    if (o.value) {
      const I = Array.isArray(o.value) ? g(o.value) : o.value;
      a.value[0] = { month: He(I), year: qe(I) };
    }
  };
  at(() => {
    w(), e.value.count && p();
  });
  const q = (I, C) => {
    a.value[C].year = I, e.value.count && !e.value.solo && f(C);
  }, _ = N(() => (I) => Vr(s.value, (C) => {
    const B = i.value(I) === C.value, U = s1(C.value, Or(n.minDate), Or(n.maxDate)), de = Pb(t.value, C.value);
    return { active: B, disabled: U, highlighted: de };
  })), b = (I, C) => {
    q(I, C), j(C);
  }, L = (I, C = !1) => {
    if (!m.value(I, C)) {
      const B = C ? i.value(I) + 1 : i.value(I) - 1;
      q(B, I);
    }
  }, j = (I, C = !1, B) => {
    C || c("reset-flow"), B !== void 0 ? h.value[I] = B : h.value[I] = !h.value[I], h.value || c("overlay-closed");
  };
  return {
    isDisabled: m,
    groupedYears: _,
    showYearPicker: h,
    selectYear: q,
    toggleYearPicker: j,
    handleYearSelect: b,
    handleYear: L
  };
}, zE = (e, t) => {
  const { defaultedMultiCalendars: a, defaultedAriaLabels: o, defaultedTransitions: n, defaultedConfig: i, defaultedHighlight: l } = tt(e), { modelValue: c, year: s, month: h, calendars: m } = m1(e, t), p = N(() => PL(e.formatLocale, e.locale, e.monthNameFormat)), f = W(null), {
    selectYear: g,
    groupedYears: w,
    showYearPicker: q,
    toggleYearPicker: _,
    handleYearSelect: b,
    handleYear: L,
    isDisabled: j
  } = FL({
    modelValue: c,
    multiCalendars: a,
    highlight: l,
    calendars: m,
    year: s,
    month: h,
    props: e,
    emit: t
  });
  at(() => {
    e.startDate && (c.value && e.focusStartDate || !c.value) && g(qe(ne(e.startDate)), 0);
  });
  const I = (R) => R ? { month: He(R), year: qe(R) } : { month: null, year: null }, C = () => c.value ? Array.isArray(c.value) ? c.value.map((R) => I(R)) : I(c.value) : I(), B = (R, J) => {
    const M = m.value[R], k = C();
    return Array.isArray(k) ? k.some((O) => O.year === (M == null ? void 0 : M.year) && O.month === J) : (M == null ? void 0 : M.year) === k.year && J === k.month;
  }, U = (R, J, M) => {
    var k, O;
    const E = C();
    return Array.isArray(E) ? s.value(J) === ((k = E[M]) == null ? void 0 : k.year) && R === ((O = E[M]) == null ? void 0 : O.month) : !1;
  }, de = (R, J) => {
    if (e.range) {
      const M = C();
      if (Array.isArray(c.value) && Array.isArray(M)) {
        const k = U(R, J, 0) || U(R, J, 1), O = Nt(At(ne()), R, s.value(J));
        return Gx(c.value, f.value, O) && !k;
      }
      return !1;
    }
    return !1;
  }, ae = N(() => (R) => Vr(p.value, (J) => {
    const M = B(R, J.value), k = s1(
      J.value,
      TL(s.value(R), e.minDate),
      DL(s.value(R), e.maxDate)
    ) || tE(e.disabledDates, s.value(R)).includes(J.value), O = de(J.value, R), E = VL(l.value, J.value, s.value(R));
    return { active: M, disabled: k, isBetween: O, highlighted: E };
  })), S = (R, J) => Nt(At(ne()), R, s.value(J)), V = (R, J) => {
    const M = c.value ? c.value : At(/* @__PURE__ */ new Date());
    c.value = Nt(M, R, s.value(J)), t("auto-apply");
  }, Z = (R, J) => {
    const M = Tb(c, S(R, J), t);
    Jx(M, t, e.autoApply, e.modelAuto);
  }, re = (R, J) => {
    qb(S(R, J), c, e.multiDatesLimit), t("auto-apply", !0);
  }, F = (R, J) => (m.value[J].month = R, $(J, m.value[J].year, R), e.multiDates ? re(R, J) : e.range ? Z(R, J) : V(R, J)), A = (R, J) => {
    g(R, J), $(J, R, null);
  }, $ = (R, J, M) => {
    let k = M;
    if (!k && k !== 0) {
      const O = C();
      k = Array.isArray(O) ? O[R].month : O.month;
    }
    t("update-month-year", { instance: R, year: J, month: k });
  };
  return {
    groupedMonths: ae,
    groupedYears: w,
    year: s,
    isDisabled: j,
    defaultedMultiCalendars: a,
    defaultedAriaLabels: o,
    defaultedTransitions: n,
    defaultedConfig: i,
    showYearPicker: q,
    modelValue: c,
    presetDate: (R, J) => {
      RL({ value: R, modelValue: c, range: e.range, timezone: J ? void 0 : e.timezone }), t("auto-apply");
    },
    setHoverDate: (R, J) => {
      f.value = S(R, J);
    },
    selectMonth: F,
    selectYear: A,
    toggleYearPicker: _,
    handleYearSelect: b,
    handleYear: L,
    getModelMonthYear: C
  };
}, HE = /* @__PURE__ */ dt({
  compatConfig: {
    MODE: 3
  },
  __name: "MonthPicker",
  props: {
    ...Dt
  },
  emits: [
    "update:internal-model-value",
    "overlay-closed",
    "reset-flow",
    "range-start",
    "range-end",
    "auto-apply",
    "update-month-year",
    "mount"
  ],
  setup(e, { expose: t, emit: a }) {
    const o = a, n = Lr(), i = gt(n, "yearMode"), l = e;
    at(() => {
      l.shadow || o("mount", null);
    });
    const {
      groupedMonths: c,
      groupedYears: s,
      year: h,
      isDisabled: m,
      defaultedMultiCalendars: p,
      defaultedConfig: f,
      showYearPicker: g,
      modelValue: w,
      presetDate: q,
      setHoverDate: _,
      selectMonth: b,
      selectYear: L,
      toggleYearPicker: j,
      handleYearSelect: I,
      handleYear: C,
      getModelMonthYear: B
    } = zE(l, o);
    return t({ getSidebarProps: () => ({
      modelValue: w,
      year: h,
      getModelMonthYear: B,
      selectMonth: b,
      selectYear: L,
      handleYear: C
    }), presetDate: q, toggleYearPicker: (U) => j(0, U) }), (U, de) => (d(), Q(Qx, {
      "multi-calendars": u(p).count,
      stretch: ""
    }, {
      default: ke(({ instance: ae }) => [
        U.$slots["month-year"] ? ee(U.$slots, "month-year", P(H({ key: 0 }, {
          year: u(h),
          months: u(c)(ae),
          years: u(s)(ae),
          selectMonth: u(b),
          selectYear: u(L),
          instance: ae
        }))) : (d(), Q(g1, {
          key: 1,
          items: u(c)(ae),
          "arrow-navigation": U.arrowNavigation,
          "is-last": U.autoApply && !u(f).keepActionRow,
          "esc-close": U.escClose,
          height: u(f).modeHeight,
          config: U.config,
          "no-overlay-focus": !!(U.noOverlayFocus || U.textInput),
          "use-relative": "",
          type: "month",
          onSelected: (S) => u(b)(S, ae),
          onHoverValue: (S) => u(_)(S, ae)
        }, {
          header: ke(() => [
            be($L, H(U.$props, {
              items: u(s)(ae),
              instance: ae,
              "show-year-picker": u(g)[ae],
              year: u(h)(ae),
              "is-disabled": (S) => u(m)(ae, S),
              onHandleYear: (S) => u(C)(ae, S),
              onYearSelect: (S) => u(I)(S, ae),
              onToggleYearPicker: (S) => u(j)(ae, S == null ? void 0 : S.flow, S == null ? void 0 : S.show)
            }), kt({ _: 2 }, [
              Ie(u(i), (S, V) => ({
                name: S,
                fn: ke((Z) => [
                  ee(U.$slots, S, P(X(Z)))
                ])
              }))
            ]), 1040, ["items", "instance", "show-year-picker", "year", "is-disabled", "onHandleYear", "onYearSelect", "onToggleYearPicker"])
          ]),
          _: 2
        }, 1032, ["items", "arrow-navigation", "is-last", "esc-close", "height", "config", "no-overlay-focus", "onSelected", "onHoverValue"]))
      ]),
      _: 3
    }, 8, ["multi-calendars"]));
  }
}), jE = (e, t) => {
  const { modelValue: a } = m1(e, t), o = W(null), { defaultedHighlight: n, defaultedFilters: i } = tt(e), l = W();
  at(() => {
    e.startDate && (a.value && e.focusStartDate || !a.value) && (l.value = qe(ne(e.startDate)));
  });
  const c = (p) => Array.isArray(a.value) ? a.value.some((f) => qe(f) === p) : a.value ? qe(a.value) === p : !1, s = (p) => e.range && Array.isArray(a.value) ? Gx(a.value, o.value, m(p)) : !1, h = N(() => Vr(Ab(e.yearRange, e.reverseYears), (p) => {
    const f = c(p.value), g = s1(p.value, Or(e.minDate), Or(e.maxDate)) || i.value.years.includes(p.value), w = s(p.value) && !f, q = Pb(n.value, p.value);
    return { active: f, disabled: g, isBetween: w, highlighted: q };
  })), m = (p) => Ot(At(/* @__PURE__ */ new Date()), p);
  return {
    groupedYears: h,
    modelValue: a,
    focusYear: l,
    setHoverValue: (p) => {
      o.value = Ot(At(/* @__PURE__ */ new Date()), p);
    },
    selectYear: (p) => {
      var f;
      if (e.multiDates)
        return a.value ? Array.isArray(a.value) && (((f = a.value) == null ? void 0 : f.map((g) => qe(g))).includes(p) ? a.value = a.value.filter((g) => qe(g) !== p) : a.value.push(Ot(ut(ne()), p))) : a.value = [Ot(ut(ne()), p)], t("auto-apply", !0);
      if (e.range) {
        const g = Tb(a, m(p), t);
        return Jx(g, t, e.autoApply, e.modelAuto);
      }
      a.value = m(p), t("auto-apply");
    }
  };
}, VE = /* @__PURE__ */ dt({
  compatConfig: {
    MODE: 3
  },
  __name: "YearPicker",
  props: {
    ...Dt
  },
  emits: ["update:internal-model-value", "reset-flow", "range-start", "range-end", "auto-apply"],
  setup(e, { expose: t, emit: a }) {
    const o = a, n = e, { groupedYears: i, modelValue: l, focusYear: c, selectYear: s, setHoverValue: h } = jE(n, o), { defaultedConfig: m } = tt(n);
    return t({ getSidebarProps: () => ({
      modelValue: l,
      selectYear: s
    }) }), (p, f) => (d(), y("div", null, [
      p.$slots["month-year"] ? ee(p.$slots, "month-year", P(H({ key: 0 }, {
        years: u(i),
        selectYear: u(s)
      }))) : (d(), Q(g1, {
        key: 1,
        items: u(i),
        "is-last": p.autoApply && !u(m).keepActionRow,
        height: u(m).modeHeight,
        config: p.config,
        "no-overlay-focus": !!(p.noOverlayFocus || p.textInput),
        "focus-value": u(c),
        type: "year",
        "use-relative": "",
        onSelected: u(s),
        onHoverValue: u(h)
      }, kt({ _: 2 }, [
        p.$slots["year-overlay-value"] ? {
          name: "item",
          fn: ke(({ item: g }) => [
            ee(p.$slots, "year-overlay-value", {
              text: g.text,
              value: g.value
            })
          ]),
          key: "0"
        } : void 0
      ]), 1032, ["items", "is-last", "height", "config", "no-overlay-focus", "focus-value", "onSelected", "onHoverValue"]))
    ]));
  }
}), OE = {
  key: 0,
  class: "dp__time_input"
}, $E = ["aria-label", "onKeydown", "onClick"], RE = /* @__PURE__ */ D("span", { class: "dp__tp_inline_btn_bar dp__tp_btn_in_l" }, null, -1), FE = /* @__PURE__ */ D("span", { class: "dp__tp_inline_btn_bar dp__tp_btn_in_r" }, null, -1), UE = ["aria-label", "disabled", "onKeydown", "onClick"], EE = ["aria-label", "onKeydown", "onClick"], WE = /* @__PURE__ */ D("span", { class: "dp__tp_inline_btn_bar dp__tp_btn_in_l" }, null, -1), NE = /* @__PURE__ */ D("span", { class: "dp__tp_inline_btn_bar dp__tp_btn_in_r" }, null, -1), ZE = { key: 0 }, YE = ["aria-label", "onKeydown"], GE = /* @__PURE__ */ dt({
  compatConfig: {
    MODE: 3
  },
  __name: "TimeInput",
  props: {
    hours: { type: Number, default: 0 },
    minutes: { type: Number, default: 0 },
    seconds: { type: Number, default: 0 },
    closeTimePickerBtn: { type: Object, default: null },
    order: { type: Number, default: 0 },
    disabledTimesConfig: { type: Function, default: null },
    validateTime: { type: Function, default: () => !1 },
    ...Dt
  },
  emits: [
    "set-hours",
    "set-minutes",
    "update:hours",
    "update:minutes",
    "update:seconds",
    "reset-flow",
    "mounted",
    "overlay-closed",
    "am-pm-change"
  ],
  setup(e, { expose: t, emit: a }) {
    const o = a, n = e, { setTimePickerElements: i, setTimePickerBackRef: l } = la(), { defaultedAriaLabels: c, defaultedTransitions: s, defaultedFilters: h, defaultedConfig: m } = tt(n), { transitionName: p, showTransition: f } = v1(s), g = u1({
      hours: !1,
      minutes: !1,
      seconds: !1
    }), w = W("AM"), q = W(null), _ = W([]);
    at(() => {
      o("mounted");
    });
    const b = (x) => Ge(/* @__PURE__ */ new Date(), {
      hours: x.hours,
      minutes: x.minutes,
      seconds: n.enableSeconds ? x.seconds : 0,
      milliseconds: 0
    }), L = N(
      () => (x) => F(x, n[x]) || I(x, n[x])
    ), j = N(() => ({ hours: n.hours, minutes: n.minutes, seconds: n.seconds })), I = (x, ie) => n.range && !n.disableTimeRangeValidation ? !n.validateTime(x, ie) : !1, C = (x, ie) => {
      if (n.range && !n.disableTimeRangeValidation) {
        const ce = ie ? +n[`${x}Increment`] : -+n[`${x}Increment`], K = n[x] + ce;
        return !n.validateTime(x, K);
      }
      return !1;
    }, B = N(() => (x) => !$(+n[x] + +n[`${x}Increment`], x) || C(x, !0)), U = N(() => (x) => !$(+n[x] - +n[`${x}Increment`], x) || C(x, !1)), de = (x, ie) => nL(Ge(ne(), x), ie), ae = (x, ie) => hU(Ge(ne(), x), ie), S = N(
      () => ({
        dp__time_col: !0,
        dp__time_col_block: !n.timePickerInline,
        dp__time_col_reg_block: !n.enableSeconds && n.is24 && !n.timePickerInline,
        dp__time_col_reg_inline: !n.enableSeconds && n.is24 && n.timePickerInline,
        dp__time_col_reg_with_button: !n.enableSeconds && !n.is24,
        dp__time_col_sec: n.enableSeconds && n.is24,
        dp__time_col_sec_with_button: n.enableSeconds && !n.is24
      })
    ), V = N(() => {
      const x = [{ type: "hours" }, { type: "", separator: !0 }, { type: "minutes" }];
      return n.enableSeconds ? x.concat([{ type: "", separator: !0 }, { type: "seconds" }]) : x;
    }), Z = N(() => V.value.filter((x) => !x.separator)), re = N(() => (x) => {
      if (x === "hours") {
        const ie = O(+n.hours);
        return { text: ie < 10 ? `0${ie}` : `${ie}`, value: ie };
      }
      return { text: n[x] < 10 ? `0${n[x]}` : `${n[x]}`, value: n[x] };
    }), F = (x, ie) => {
      var ce;
      if (!n.disabledTimesConfig)
        return !1;
      const K = n.disabledTimesConfig(n.order, x === "hours" ? ie : void 0);
      return K[x] ? !!((ce = K[x]) != null && ce.includes(ie)) : !0;
    }, A = (x) => {
      const ie = n.is24 ? 24 : 12, ce = x === "hours" ? ie : 60, K = +n[`${x}GridIncrement`], me = x === "hours" && !n.is24 ? K : 0, he = [];
      for (let Y = me; Y < ce; Y += K)
        he.push({ value: Y, text: Y < 10 ? `0${Y}` : `${Y}` });
      return x === "hours" && !n.is24 && he.push({ value: 0, text: "12" }), Vr(he, (Y) => ({ active: !1, disabled: h.value.times[x].includes(Y.value) || !$(Y.value, x) || F(x, Y.value) || I(x, Y.value) }));
    }, $ = (x, ie) => {
      const ce = n.minTime ? b(y9(n.minTime)) : null, K = n.maxTime ? b(y9(n.maxTime)) : null, me = b(y9(j.value, ie, x));
      return ce && K ? (d1(me, K) || Br(me, K)) && (c1(me, ce) || Br(me, ce)) : ce ? c1(me, ce) || Br(me, ce) : K ? d1(me, K) || Br(me, K) : !0;
    }, R = (x) => n[`no${x[0].toUpperCase() + x.slice(1)}Overlay`], J = (x) => {
      R(x) || (g[x] = !g[x], g[x] || o("overlay-closed"));
    }, M = (x) => x === "hours" ? qt : x === "minutes" ? $t : Hr, k = (x, ie = !0) => {
      const ce = ie ? de : ae, K = ie ? +n[`${x}Increment`] : -+n[`${x}Increment`];
      $(+n[x] + K, x) && o(
        `update:${x}`,
        M(x)(ce({ [x]: +n[x] }, { [x]: +n[`${x}Increment`] }))
      );
    }, O = (x) => n.is24 ? x : (x >= 12 ? w.value = "PM" : w.value = "AM", RU(x)), E = () => {
      w.value === "PM" ? (w.value = "AM", o("update:hours", n.hours - 12)) : (w.value = "PM", o("update:hours", n.hours + 12)), o("am-pm-change", w.value);
    }, te = (x) => {
      g[x] = !0;
    }, se = (x, ie, ce) => {
      if (x && n.arrowNavigation) {
        Array.isArray(_.value[ie]) ? _.value[ie][ce] = x : _.value[ie] = [x];
        const K = _.value.reduce(
          (me, he) => he.map((Y, oe) => [...me[oe] || [], he[oe]]),
          []
        );
        l(n.closeTimePickerBtn), q.value && (K[1] = K[1].concat(q.value)), i(K, n.order);
      }
    }, T = (x, ie) => (J(x), x === "hours" && !n.is24 ? o(`update:${x}`, w.value === "PM" ? ie + 12 : ie) : o(`update:${x}`, ie));
    return t({ openChildCmp: te }), (x, ie) => {
      var ce;
      return x.disabled ? v("", !0) : (d(), y("div", OE, [
        (d(!0), y(ge, null, Ie(V.value, (K, me) => {
          var he, Y, oe;
          return d(), y("div", {
            key: me,
            class: Pe(S.value)
          }, [
            K.separator ? (d(), y(ge, { key: 0 }, [
              wt(" : ")
            ], 64)) : (d(), y(ge, { key: 1 }, [
              D("button", {
                ref_for: !0,
                ref: (Me) => se(Me, me, 0),
                type: "button",
                class: Pe({
                  dp__btn: !0,
                  dp__inc_dec_button: !x.timePickerInline,
                  dp__inc_dec_button_inline: x.timePickerInline,
                  dp__tp_inline_btn_top: x.timePickerInline,
                  dp__inc_dec_button_disabled: B.value(K.type)
                }),
                "aria-label": (he = u(c)) == null ? void 0 : he.incrementValue(K.type),
                tabindex: "0",
                onKeydown: [
                  Ae(Ue((Me) => k(K.type), ["prevent"]), ["enter"]),
                  Ae(Ue((Me) => k(K.type), ["prevent"]), ["space"])
                ],
                onClick: (Me) => k(K.type)
              }, [
                n.timePickerInline ? (d(), y(ge, { key: 1 }, [
                  RE,
                  FE
                ], 64)) : (d(), y(ge, { key: 0 }, [
                  x.$slots["arrow-up"] ? ee(x.$slots, "arrow-up", { key: 0 }) : v("", !0),
                  x.$slots["arrow-up"] ? v("", !0) : (d(), Q(u(wb), { key: 1 }))
                ], 64))
              ], 42, $E),
              D("button", {
                ref_for: !0,
                ref: (Me) => se(Me, me, 1),
                type: "button",
                "aria-label": (Y = u(c)) == null ? void 0 : Y.openTpOverlay(K.type),
                class: Pe({
                  dp__time_display: !0,
                  dp__time_display_block: !x.timePickerInline,
                  dp__time_display_inline: x.timePickerInline,
                  "dp--time-invalid": L.value(K.type),
                  "dp--time-overlay-btn": !L.value(K.type)
                }),
                disabled: R(K.type),
                tabindex: "0",
                onKeydown: [
                  Ae(Ue((Me) => J(K.type), ["prevent"]), ["enter"]),
                  Ae(Ue((Me) => J(K.type), ["prevent"]), ["space"])
                ],
                onClick: (Me) => J(K.type)
              }, [
                x.$slots[K.type] ? ee(x.$slots, K.type, {
                  key: 0,
                  text: re.value(K.type).text,
                  value: re.value(K.type).value
                }) : v("", !0),
                x.$slots[K.type] ? v("", !0) : (d(), y(ge, { key: 1 }, [
                  wt(G(re.value(K.type).text), 1)
                ], 64))
              ], 42, UE),
              D("button", {
                ref_for: !0,
                ref: (Me) => se(Me, me, 2),
                type: "button",
                class: Pe({
                  dp__btn: !0,
                  dp__inc_dec_button: !x.timePickerInline,
                  dp__inc_dec_button_inline: x.timePickerInline,
                  dp__tp_inline_btn_bottom: x.timePickerInline,
                  dp__inc_dec_button_disabled: U.value(K.type)
                }),
                "aria-label": (oe = u(c)) == null ? void 0 : oe.decrementValue(K.type),
                tabindex: "0",
                onKeydown: [
                  Ae(Ue((Me) => k(K.type, !1), ["prevent"]), ["enter"]),
                  Ae(Ue((Me) => k(K.type, !1), ["prevent"]), ["space"])
                ],
                onClick: (Me) => k(K.type, !1)
              }, [
                n.timePickerInline ? (d(), y(ge, { key: 1 }, [
                  WE,
                  NE
                ], 64)) : (d(), y(ge, { key: 0 }, [
                  x.$slots["arrow-down"] ? ee(x.$slots, "arrow-down", { key: 0 }) : v("", !0),
                  x.$slots["arrow-down"] ? v("", !0) : (d(), Q(u(Ib), { key: 1 }))
                ], 64))
              ], 42, EE)
            ], 64))
          ], 2);
        }), 128)),
        x.is24 ? v("", !0) : (d(), y("div", ZE, [
          x.$slots["am-pm-button"] ? ee(x.$slots, "am-pm-button", {
            key: 0,
            toggle: E,
            value: w.value
          }) : v("", !0),
          x.$slots["am-pm-button"] ? v("", !0) : (d(), y("button", {
            key: 1,
            ref_key: "amPmButton",
            ref: q,
            type: "button",
            class: "dp__pm_am_button",
            role: "button",
            "aria-label": (ce = u(c)) == null ? void 0 : ce.amPmButton,
            tabindex: "0",
            onClick: E,
            onKeydown: [
              Ae(Ue(E, ["prevent"]), ["enter"]),
              Ae(Ue(E, ["prevent"]), ["space"])
            ]
          }, G(w.value), 41, YE))
        ])),
        (d(!0), y(ge, null, Ie(Z.value, (K, me) => (d(), Q(Rr, {
          key: me,
          name: u(p)(g[K.type]),
          css: u(f)
        }, {
          default: ke(() => [
            g[K.type] ? (d(), Q(g1, {
              key: 0,
              items: A(K.type),
              "is-last": x.autoApply && !u(m).keepActionRow,
              "esc-close": x.escClose,
              type: K.type,
              "text-input": x.textInput,
              config: x.config,
              "arrow-navigation": x.arrowNavigation,
              onSelected: (he) => T(K.type, he),
              onToggle: (he) => J(K.type),
              onResetFlow: ie[0] || (ie[0] = (he) => x.$emit("reset-flow"))
            }, kt({
              "button-icon": ke(() => [
                x.$slots["clock-icon"] ? ee(x.$slots, "clock-icon", { key: 0 }) : v("", !0),
                x.$slots["clock-icon"] ? v("", !0) : (d(), Q(mt(x.timePickerInline ? u(Gr) : u(bb)), { key: 1 }))
              ]),
              _: 2
            }, [
              x.$slots[`${K.type}-overlay-value`] ? {
                name: "item",
                fn: ke(({ item: he }) => [
                  ee(x.$slots, `${K.type}-overlay-value`, {
                    text: he.text,
                    value: he.value
                  })
                ]),
                key: "0"
              } : void 0
            ]), 1032, ["items", "is-last", "esc-close", "type", "text-input", "config", "arrow-navigation", "onSelected", "onToggle"])) : v("", !0)
          ]),
          _: 2
        }, 1032, ["name", "css"]))), 128))
      ]));
    };
  }
}), XE = { class: "dp--tp-wrap" }, KE = ["aria-label", "tabindex"], QE = ["tabindex"], JE = ["aria-label"], UL = /* @__PURE__ */ dt({
  compatConfig: {
    MODE: 3
  },
  __name: "TimePicker",
  props: {
    hours: { type: [Number, Array], default: 0 },
    minutes: { type: [Number, Array], default: 0 },
    seconds: { type: [Number, Array], default: 0 },
    disabledTimesConfig: { type: Function, default: null },
    validateTime: {
      type: Function,
      default: () => !1
    },
    ...Dt
  },
  emits: [
    "update:hours",
    "update:minutes",
    "update:seconds",
    "mount",
    "reset-flow",
    "overlay-opened",
    "overlay-closed",
    "am-pm-change"
  ],
  setup(e, { expose: t, emit: a }) {
    const o = a, n = e, { buildMatrix: i, setTimePicker: l } = la(), c = Lr(), { defaultedTransitions: s, defaultedAriaLabels: h, defaultedTextInput: m, defaultedConfig: p } = tt(n), { transitionName: f, showTransition: g } = v1(s), { hideNavigationButtons: w } = Xx(), q = W(null), _ = W(null), b = W([]), L = W(null);
    at(() => {
      o("mount"), !n.timePicker && n.arrowNavigation ? i([nt(q.value)], "time") : l(!0, n.timePicker);
    });
    const j = N(() => n.range && n.modelAuto ? qL(n.internalModelValue) : !0), I = W(!1), C = (A) => ({
      hours: Array.isArray(n.hours) ? n.hours[A] : n.hours,
      minutes: Array.isArray(n.minutes) ? n.minutes[A] : n.minutes,
      seconds: Array.isArray(n.seconds) ? n.seconds[A] : n.seconds
    }), B = N(() => {
      const A = [];
      if (n.range)
        for (let $ = 0; $ < 2; $++)
          A.push(C($));
      else
        A.push(C(0));
      return A;
    }), U = (A, $ = !1, R = "") => {
      $ || o("reset-flow"), I.value = A, o(A ? "overlay-opened" : "overlay-closed"), n.arrowNavigation && l(A), Gt(() => {
        R !== "" && b.value[0] && b.value[0].openChildCmp(R);
      });
    }, de = N(() => ({
      dp__btn: !0,
      dp__button: !0,
      dp__button_bottom: n.autoApply && !p.value.keepActionRow
    })), ae = gt(c, "timePicker"), S = (A, $, R) => n.range ? $ === 0 ? [A, B.value[1][R]] : [B.value[0][R], A] : A, V = (A) => {
      o("update:hours", A);
    }, Z = (A) => {
      o("update:minutes", A);
    }, re = (A) => {
      o("update:seconds", A);
    }, F = () => {
      if (L.value && !m.value.enabled && !n.noOverlayFocus) {
        const A = UU(L.value);
        A && A.focus({ preventScroll: !0 });
      }
    };
    return t({ toggleTimePicker: U }), (A, $) => {
      var R;
      return d(), y("div", XE, [
        !A.timePicker && !A.timePickerInline ? Zt((d(), y("button", {
          key: 0,
          ref_key: "openTimePickerBtn",
          ref: q,
          type: "button",
          class: Pe(de.value),
          "aria-label": (R = u(h)) == null ? void 0 : R.openTimePicker,
          tabindex: A.noOverlayFocus ? void 0 : 0,
          onKeydown: [
            $[0] || ($[0] = Ae((J) => U(!0), ["enter"])),
            $[1] || ($[1] = Ae((J) => U(!0), ["space"]))
          ],
          onClick: $[2] || ($[2] = (J) => U(!0))
        }, [
          A.$slots["clock-icon"] ? ee(A.$slots, "clock-icon", { key: 0 }) : v("", !0),
          A.$slots["clock-icon"] ? v("", !0) : (d(), Q(u(bb), { key: 1 }))
        ], 42, KE)), [
          [Yt, !u(w)(A.hideNavigation, "time")]
        ]) : v("", !0),
        be(Rr, {
          name: u(f)(I.value),
          css: u(g) && !A.timePickerInline
        }, {
          default: ke(() => {
            var J;
            return [
              I.value || A.timePicker || A.timePickerInline ? (d(), y("div", {
                key: 0,
                ref_key: "overlayRef",
                ref: L,
                class: Pe({
                  dp__overlay: !A.timePickerInline,
                  "dp--overlay-absolute": !n.timePicker && !A.timePickerInline,
                  "dp--overlay-relative": n.timePicker
                }),
                style: yt(A.timePicker ? { height: `${u(p).modeHeight}px` } : void 0),
                tabindex: A.timePickerInline ? void 0 : 0
              }, [
                D("div", {
                  class: Pe(
                    A.timePickerInline ? "dp__time_picker_inline_container" : "dp__overlay_container dp__container_flex dp__time_picker_overlay_container"
                  ),
                  style: { display: "flex" }
                }, [
                  A.$slots["time-picker-overlay"] ? ee(A.$slots, "time-picker-overlay", {
                    key: 0,
                    hours: e.hours,
                    minutes: e.minutes,
                    seconds: e.seconds,
                    setHours: V,
                    setMinutes: Z,
                    setSeconds: re
                  }) : v("", !0),
                  A.$slots["time-picker-overlay"] ? v("", !0) : (d(), y("div", {
                    key: 1,
                    class: Pe(A.timePickerInline ? "dp__flex" : "dp__overlay_row dp__flex_row")
                  }, [
                    (d(!0), y(ge, null, Ie(B.value, (M, k) => Zt((d(), Q(GE, H({ key: k }, {
                      ...A.$props,
                      order: k,
                      hours: M.hours,
                      minutes: M.minutes,
                      seconds: M.seconds,
                      closeTimePickerBtn: _.value,
                      disabledTimesConfig: e.disabledTimesConfig,
                      disabled: k === 0 ? A.fixedStart : A.fixedEnd
                    }, {
                      ref_for: !0,
                      ref_key: "timeInputRefs",
                      ref: b,
                      "validate-time": (O, E) => e.validateTime(O, S(E, k, O)),
                      "onUpdate:hours": (O) => V(S(O, k, "hours")),
                      "onUpdate:minutes": (O) => Z(S(O, k, "minutes")),
                      "onUpdate:seconds": (O) => re(S(O, k, "seconds")),
                      onMounted: F,
                      onOverlayClosed: F,
                      onAmPmChange: $[3] || ($[3] = (O) => A.$emit("am-pm-change", O))
                    }), kt({ _: 2 }, [
                      Ie(u(ae), (O, E) => ({
                        name: O,
                        fn: ke((te) => [
                          ee(A.$slots, O, P(X(te)))
                        ])
                      }))
                    ]), 1040, ["validate-time", "onUpdate:hours", "onUpdate:minutes", "onUpdate:seconds"])), [
                      [Yt, k === 0 ? !0 : j.value]
                    ])), 128))
                  ], 2)),
                  !A.timePicker && !A.timePickerInline ? Zt((d(), y("button", {
                    key: 2,
                    ref_key: "closeTimePickerBtn",
                    ref: _,
                    type: "button",
                    class: Pe(de.value),
                    "aria-label": (J = u(h)) == null ? void 0 : J.closeTimePicker,
                    tabindex: "0",
                    onKeydown: [
                      $[4] || ($[4] = Ae((M) => U(!1), ["enter"])),
                      $[5] || ($[5] = Ae((M) => U(!1), ["space"]))
                    ],
                    onClick: $[6] || ($[6] = (M) => U(!1))
                  }, [
                    A.$slots["calendar-icon"] ? ee(A.$slots, "calendar-icon", { key: 0 }) : v("", !0),
                    A.$slots["calendar-icon"] ? v("", !0) : (d(), Q(u(Gr), { key: 1 }))
                  ], 42, JE)), [
                    [Yt, !u(w)(A.hideNavigation, "time")]
                  ]) : v("", !0)
                ], 2)
              ], 14, QE)) : v("", !0)
            ];
          }),
          _: 3
        }, 8, ["name", "css"])
      ]);
    };
  }
}), EL = (e, t, a, o) => {
  const n = (b, L) => Array.isArray(t[b]) ? t[b][L] : t[b], i = (b) => e.enableSeconds ? Array.isArray(t.seconds) ? t.seconds[b] : t.seconds : 0, l = (b, L) => b ? L !== void 0 ? ra(b, n("hours", L), n("minutes", L), i(L)) : ra(b, t.hours, t.minutes, i()) : gb(ne(), i(L)), c = (b, L) => {
    t[b] = L;
  }, s = (b, L) => {
    const j = Object.fromEntries(
      Object.keys(t).map((I) => I === b ? [I, L] : [I, t[I]].slice())
    );
    if (e.range && !e.disableTimeRangeValidation) {
      const I = (B) => a.value ? ra(
        a.value[B],
        j.hours[B],
        j.minutes[B],
        j.seconds[B]
      ) : null, C = (B) => mb(a.value[B], 0);
      return !(Oe(I(0), I(1)) && (c1(I(0), C(1)) || d1(I(1), C(0))));
    }
    return !0;
  }, h = (b, L) => {
    s(b, L) && (c(b, L), o && o());
  }, m = (b) => {
    h("hours", b);
  }, p = (b) => {
    h("minutes", b);
  }, f = (b) => {
    h("seconds", b);
  }, g = (b, L, j, I) => {
    L && m(b), !L && !j && p(b), j && f(b), a.value && I(a.value);
  }, w = (b) => {
    if (b) {
      const L = Array.isArray(b), j = L ? [+b[0].hours, +b[1].hours] : +b.hours, I = L ? [+b[0].minutes, +b[1].minutes] : +b.minutes, C = L ? [+b[0].seconds, +b[1].seconds] : +b.seconds;
      c("hours", j), c("minutes", I), e.enableSeconds && c("seconds", C);
    }
  }, q = (b, L) => {
    const j = {
      hours: Array.isArray(t.hours) ? t.hours[b] : t.hours,
      disabledArr: []
    };
    return (L || L === 0) && (j.hours = L), Array.isArray(e.disabledTimes) && (j.disabledArr = e.range && Array.isArray(e.disabledTimes[b]) ? e.disabledTimes[b] : e.disabledTimes), j;
  }, _ = N(() => (b, L) => {
    var j;
    if (Array.isArray(e.disabledTimes)) {
      const { disabledArr: I, hours: C } = q(b, L), B = I.filter((U) => +U.hours === C);
      return ((j = B[0]) == null ? void 0 : j.minutes) === "*" ? { hours: [C], minutes: void 0, seconds: void 0 } : {
        hours: [],
        minutes: (B == null ? void 0 : B.map((U) => +U.minutes)) ?? [],
        seconds: (B == null ? void 0 : B.map((U) => U.seconds ? +U.seconds : void 0)) ?? []
      };
    }
    return { hours: [], minutes: [], seconds: [] };
  });
  return {
    setTime: c,
    updateHours: m,
    updateMinutes: p,
    updateSeconds: f,
    getSetDateTime: l,
    updateTimeValues: g,
    getSecondsValue: i,
    assignStartTime: w,
    validateTime: s,
    disabledTimesConfig: _
  };
}, eW = (e, t) => {
  const { modelValue: a, time: o } = m1(e, t), { defaultedStartTime: n } = tt(e), { updateTimeValues: i, getSetDateTime: l, setTime: c, assignStartTime: s, disabledTimesConfig: h, validateTime: m } = EL(e, o, a), p = (L) => {
    const { hours: j, minutes: I, seconds: C } = L;
    return { hours: +j, minutes: +I, seconds: C ? +C : 0 };
  }, f = () => {
    if (e.startTime) {
      if (Array.isArray(e.startTime)) {
        const j = p(e.startTime[0]), I = p(e.startTime[1]);
        return [Ge(ne(), j), Ge(ne(), I)];
      }
      const L = p(e.startTime);
      return Ge(ne(), L);
    }
    return e.range ? [null, null] : null;
  }, g = () => {
    if (e.range) {
      const [L, j] = f();
      a.value = [l(L, 0), l(j, 1)];
    } else
      a.value = l(f());
  }, w = (L) => Array.isArray(L) ? [Mr(ne(L[0])), Mr(ne(L[1]))] : [Mr(L ?? ne())], q = (L, j, I) => {
    c("hours", L), c("minutes", j), c("seconds", e.enableSeconds ? I : 0);
  }, _ = () => {
    const [L, j] = w(a.value);
    return e.range ? q(
      [L.hours, j.hours],
      [L.minutes, j.minutes],
      [L.seconds, j.minutes]
    ) : q(L.hours, L.minutes, L.seconds);
  };
  at(() => {
    if (!e.shadow)
      return s(n.value), a.value ? _() : g();
  });
  const b = () => {
    Array.isArray(a.value) ? a.value = a.value.map((L, j) => L && l(L, j)) : a.value = l(a.value), t("time-update");
  };
  return {
    modelValue: a,
    time: o,
    disabledTimesConfig: h,
    updateTime: (L, j = !0, I = !1) => {
      i(L, j, I, b);
    },
    validateTime: m
  };
}, tW = /* @__PURE__ */ dt({
  compatConfig: {
    MODE: 3
  },
  __name: "TimePickerSolo",
  props: {
    ...Dt
  },
  emits: ["update:internal-model-value", "time-update", "am-pm-change"],
  setup(e, { expose: t, emit: a }) {
    const o = a, n = e, i = Lr(), l = gt(i, "timePicker"), { time: c, modelValue: s, disabledTimesConfig: h, updateTime: m, validateTime: p } = eW(n, o);
    return t({ getSidebarProps: () => ({
      modelValue: s,
      time: c,
      updateTime: m
    }) }), (f, g) => (d(), Q(Qx, {
      "multi-calendars": 0,
      stretch: ""
    }, {
      default: ke(() => [
        be(UL, H(f.$props, {
          hours: u(c).hours,
          minutes: u(c).minutes,
          seconds: u(c).seconds,
          "internal-model-value": f.internalModelValue,
          "disabled-times-config": u(h),
          "validate-time": u(p),
          "onUpdate:hours": g[0] || (g[0] = (w) => u(m)(w)),
          "onUpdate:minutes": g[1] || (g[1] = (w) => u(m)(w, !1)),
          "onUpdate:seconds": g[2] || (g[2] = (w) => u(m)(w, !1, !0)),
          onAmPmChange: g[3] || (g[3] = (w) => f.$emit("am-pm-change", w))
        }), kt({ _: 2 }, [
          Ie(u(l), (w, q) => ({
            name: w,
            fn: ke((_) => [
              ee(f.$slots, w, P(X(_)))
            ])
          }))
        ]), 1040, ["hours", "minutes", "seconds", "internal-model-value", "disabled-times-config", "validate-time"])
      ]),
      _: 3
    }));
  }
}), aW = { class: "dp__month_year_row" }, nW = ["aria-label", "onClick", "onKeydown"], oW = /* @__PURE__ */ dt({
  compatConfig: {
    MODE: 3
  },
  __name: "DpHeader",
  props: {
    month: { type: Number, default: 0 },
    year: { type: Number, default: 0 },
    instance: { type: Number, default: 0 },
    years: { type: Array, default: () => [] },
    months: { type: Array, default: () => [] },
    ...Dt
  },
  emits: ["update-month-year", "mount", "reset-flow", "overlay-closed"],
  setup(e, { expose: t, emit: a }) {
    const o = a, n = e, {
      defaultedTransitions: i,
      defaultedAriaLabels: l,
      defaultedMultiCalendars: c,
      defaultedFilters: s,
      defaultedConfig: h,
      defaultedHighlight: m
    } = tt(n), { transitionName: p, showTransition: f } = v1(i), { buildMatrix: g } = la(), { handleMonthYearChange: w, isDisabled: q, updateMonthYear: _ } = yE(n, o), { showLeftIcon: b, showRightIcon: L } = Xx(), j = W(!1), I = W(!1), C = W([null, null, null, null]);
    at(() => {
      o("mount");
    });
    const B = (k) => ({
      get: () => n[k],
      set: (O) => {
        const E = k === Ct.month ? Ct.year : Ct.month;
        o("update-month-year", { [k]: O, [E]: n[E] }), k === Ct.month ? F(!0) : A(!0);
      }
    }), U = N(B(Ct.month)), de = N(B(Ct.year)), ae = N(() => (k) => ({
      month: n.month,
      year: n.year,
      items: k === Ct.month ? n.months : n.years,
      instance: n.instance,
      updateMonthYear: _,
      toggle: k === Ct.month ? F : A
    })), S = N(() => n.months.find((O) => O.value === n.month) || { text: "", value: 0 }), V = N(() => Vr(n.months, (k) => {
      const O = n.month === k.value, E = s1(
        k.value,
        TL(n.year, n.minDate),
        DL(n.year, n.maxDate)
      ) || s.value.months.includes(k.value), te = VL(m.value, k.value, n.year);
      return { active: O, disabled: E, highlighted: te };
    })), Z = N(() => Vr(n.years, (k) => {
      const O = n.year === k.value, E = s1(k.value, Or(n.minDate), Or(n.maxDate)) || s.value.years.includes(k.value), te = Pb(m.value, k.value);
      return { active: O, disabled: E, highlighted: te };
    })), re = (k, O) => {
      O !== void 0 ? k.value = O : k.value = !k.value, k.value || o("overlay-closed");
    }, F = (k = !1, O) => {
      $(k), re(j, O);
    }, A = (k = !1, O) => {
      $(k), re(I, O);
    }, $ = (k) => {
      k || o("reset-flow");
    }, R = (k, O) => {
      n.arrowNavigation && (C.value[O] = nt(k), g(C.value, "monthYear"));
    }, J = N(() => {
      var k, O;
      return [
        {
          type: Ct.month,
          index: 1,
          toggle: F,
          modelValue: U.value,
          updateModelValue: (E) => U.value = E,
          text: S.value.text,
          showSelectionGrid: j.value,
          items: V.value,
          ariaLabel: (k = l.value) == null ? void 0 : k.openMonthsOverlay
        },
        {
          type: Ct.year,
          index: 2,
          toggle: A,
          modelValue: de.value,
          updateModelValue: (E) => de.value = E,
          text: n.year,
          showSelectionGrid: I.value,
          items: Z.value,
          ariaLabel: (O = l.value) == null ? void 0 : O.openYearsOverlay
        }
      ];
    }), M = N(() => n.disableYearSelect ? [J.value[0]] : n.yearFirst ? [...J.value].reverse() : J.value);
    return t({
      toggleMonthPicker: F,
      toggleYearPicker: A,
      handleMonthYearChange: w
    }), (k, O) => {
      var E, te, se;
      return d(), y("div", aW, [
        k.$slots["month-year"] ? ee(k.$slots, "month-year", P(H({ key: 0 }, { month: e.month, year: e.year, months: e.months, years: e.years, updateMonthYear: u(_), handleMonthYearChange: u(w), instance: e.instance }))) : (d(), y(ge, { key: 1 }, [
          u(b)(u(c), e.instance) && !k.vertical ? (d(), Q(r1, {
            key: 0,
            "aria-label": (E = u(l)) == null ? void 0 : E.prevMonth,
            disabled: u(q)(!1),
            onActivate: O[0] || (O[0] = (T) => u(w)(!1, !0)),
            onSetRef: O[1] || (O[1] = (T) => R(T, 0))
          }, {
            default: ke(() => [
              k.$slots["arrow-left"] ? ee(k.$slots, "arrow-left", { key: 0 }) : v("", !0),
              k.$slots["arrow-left"] ? v("", !0) : (d(), Q(u(Mb), { key: 1 }))
            ]),
            _: 3
          }, 8, ["aria-label", "disabled"])) : v("", !0),
          D("div", {
            class: Pe(["dp__month_year_wrap", {
              dp__year_disable_select: k.disableYearSelect
            }])
          }, [
            (d(!0), y(ge, null, Ie(M.value, (T, x) => (d(), y(ge, {
              key: T.type
            }, [
              D("button", {
                ref_for: !0,
                ref: (ie) => R(ie, x + 1),
                type: "button",
                class: "dp__btn dp__month_year_select",
                tabindex: "0",
                "aria-label": T.ariaLabel,
                onClick: T.toggle,
                onKeydown: [
                  Ae(Ue(T.toggle, ["prevent"]), ["enter"]),
                  Ae(Ue(T.toggle, ["prevent"]), ["space"])
                ]
              }, [
                k.$slots[T.type] ? ee(k.$slots, T.type, {
                  key: 0,
                  text: T.text,
                  value: n[T.type]
                }) : v("", !0),
                k.$slots[T.type] ? v("", !0) : (d(), y(ge, { key: 1 }, [
                  wt(G(T.text), 1)
                ], 64))
              ], 40, nW),
              be(Rr, {
                name: u(p)(T.showSelectionGrid),
                css: u(f)
              }, {
                default: ke(() => [
                  T.showSelectionGrid ? (d(), Q(g1, {
                    key: 0,
                    items: T.items,
                    "arrow-navigation": k.arrowNavigation,
                    "hide-navigation": k.hideNavigation,
                    "is-last": k.autoApply && !u(h).keepActionRow,
                    "skip-button-ref": !1,
                    config: k.config,
                    type: T.type,
                    "header-refs": [],
                    "esc-close": k.escClose,
                    "text-input": k.textInput,
                    onSelected: T.updateModelValue,
                    onToggle: T.toggle
                  }, kt({
                    "button-icon": ke(() => [
                      k.$slots["calendar-icon"] ? ee(k.$slots, "calendar-icon", { key: 0 }) : v("", !0),
                      k.$slots["calendar-icon"] ? v("", !0) : (d(), Q(u(Gr), { key: 1 }))
                    ]),
                    _: 2
                  }, [
                    k.$slots[`${T.type}-overlay-value`] ? {
                      name: "item",
                      fn: ke(({ item: ie }) => [
                        ee(k.$slots, `${T.type}-overlay-value`, {
                          text: ie.text,
                          value: ie.value
                        })
                      ]),
                      key: "0"
                    } : void 0,
                    k.$slots[`${T.type}-overlay`] ? {
                      name: "overlay",
                      fn: ke(() => [
                        ee(k.$slots, `${T.type}-overlay`, P(X(ae.value(T.type))))
                      ]),
                      key: "1"
                    } : void 0,
                    k.$slots[`${T.type}-overlay-header`] ? {
                      name: "header",
                      fn: ke(() => [
                        ee(k.$slots, `${T.type}-overlay-header`, {
                          toggle: T.toggle
                        })
                      ]),
                      key: "2"
                    } : void 0
                  ]), 1032, ["items", "arrow-navigation", "hide-navigation", "is-last", "config", "type", "esc-close", "text-input", "onSelected", "onToggle"])) : v("", !0)
                ]),
                _: 2
              }, 1032, ["name", "css"])
            ], 64))), 128))
          ], 2),
          u(b)(u(c), e.instance) && k.vertical ? (d(), Q(r1, {
            key: 1,
            "aria-label": (te = u(l)) == null ? void 0 : te.prevMonth,
            disabled: u(q)(!1),
            onActivate: O[2] || (O[2] = (T) => u(w)(!1, !0))
          }, {
            default: ke(() => [
              k.$slots["arrow-up"] ? ee(k.$slots, "arrow-up", { key: 0 }) : v("", !0),
              k.$slots["arrow-up"] ? v("", !0) : (d(), Q(u(wb), { key: 1 }))
            ]),
            _: 3
          }, 8, ["aria-label", "disabled"])) : v("", !0),
          u(L)(u(c), e.instance) ? (d(), Q(r1, {
            key: 2,
            ref: "rightIcon",
            disabled: u(q)(!0),
            "aria-label": (se = u(l)) == null ? void 0 : se.nextMonth,
            onActivate: O[3] || (O[3] = (T) => u(w)(!0, !0)),
            onSetRef: O[4] || (O[4] = (T) => R(T, k.disableYearSelect ? 2 : 3))
          }, {
            default: ke(() => [
              k.$slots[k.vertical ? "arrow-down" : "arrow-right"] ? ee(k.$slots, k.vertical ? "arrow-down" : "arrow-right", { key: 0 }) : v("", !0),
              k.$slots[k.vertical ? "arrow-down" : "arrow-right"] ? v("", !0) : (d(), Q(mt(k.vertical ? u(Ib) : u(xb)), { key: 1 }))
            ]),
            _: 3
          }, 8, ["disabled", "aria-label"])) : v("", !0)
        ], 64))
      ]);
    };
  }
}), rW = ["aria-label"], iW = {
  class: "dp__calendar_header",
  role: "row"
}, lW = {
  key: 0,
  class: "dp__calendar_header_item",
  role: "gridcell"
}, cW = /* @__PURE__ */ D("div", { class: "dp__calendar_header_separator" }, null, -1), dW = ["aria-label"], sW = {
  key: 0,
  role: "gridcell",
  class: "dp__calendar_item dp__week_num"
}, uW = { class: "dp__cell_inner" }, hW = ["id", "aria-selected", "aria-disabled", "aria-label", "onClick", "onKeydown", "onMouseenter", "onMouseleave"], pW = /* @__PURE__ */ dt({
  compatConfig: {
    MODE: 3
  },
  __name: "DpCalendar",
  props: {
    mappedDates: { type: Array, default: () => [] },
    instance: { type: Number, default: 0 },
    month: { type: Number, default: 0 },
    year: { type: Number, default: 0 },
    ...Dt
  },
  emits: [
    "select-date",
    "set-hover-date",
    "handle-scroll",
    "mount",
    "handle-swipe",
    "handle-space",
    "tooltip-open",
    "tooltip-close"
  ],
  setup(e, { expose: t, emit: a }) {
    const o = a, n = e, { buildMultiLevelMatrix: i } = la(), {
      defaultedTransitions: l,
      defaultedConfig: c,
      defaultedAriaLabels: s,
      defaultedMultiCalendars: h,
      defaultedWeekNumbers: m
    } = tt(n), p = W(null), f = W({
      bottom: "",
      left: "",
      transform: ""
    }), g = W([]), w = W(null), q = W(!0), _ = W(""), b = W({ startX: 0, endX: 0, startY: 0, endY: 0 }), L = W([]), j = W({ left: "50%" }), I = N(() => n.calendar ? n.calendar(n.mappedDates) : n.mappedDates), C = N(() => n.dayNames ? Array.isArray(n.dayNames) ? n.dayNames : n.dayNames(n.locale, +n.weekStart) : $U(n.formatLocale, n.locale, +n.weekStart));
    at(() => {
      o("mount", { cmp: "calendar", refs: g }), c.value.noSwipe || w.value && (w.value.addEventListener("touchstart", A, { passive: !1 }), w.value.addEventListener("touchend", $, { passive: !1 }), w.value.addEventListener("touchmove", R, { passive: !1 })), n.monthChangeOnScroll && w.value && w.value.addEventListener("wheel", k, { passive: !1 });
    });
    const B = (T) => T ? n.vertical ? "vNext" : "next" : n.vertical ? "vPrevious" : "previous", U = (T, x) => {
      if (n.transitions) {
        const ie = ut(Nt(ne(), n.month, n.year));
        _.value = st(ut(Nt(ne(), T, x)), ie) ? l.value[B(!0)] : l.value[B(!1)], q.value = !1, Gt(() => {
          q.value = !0;
        });
      }
    }, de = N(
      () => ({
        [n.calendarClassName]: !!n.calendarClassName
      })
    ), ae = N(() => (T) => {
      const x = FU(T);
      return {
        dp__marker_dot: x.type === "dot",
        dp__marker_line: x.type === "line"
      };
    }), S = N(() => (T) => Oe(T, p.value)), V = N(() => ({
      dp__calendar: !0,
      dp__calendar_next: h.value.count > 0 && n.instance !== 0
    })), Z = N(() => (T) => n.hideOffsetDates ? T.current : !0), re = async (T, x, ie) => {
      var ce, K;
      if (o("set-hover-date", T), (K = (ce = T.marker) == null ? void 0 : ce.tooltip) != null && K.length) {
        const me = nt(g.value[x][ie]);
        if (me) {
          const { width: he, height: Y } = me.getBoundingClientRect();
          p.value = T.value;
          let oe = { left: `${he / 2}px` }, Me = -50;
          if (await Gt(), L.value[0]) {
            const { left: ue, width: Fe } = L.value[0].getBoundingClientRect();
            ue < 0 && (oe = { left: "0" }, Me = 0, j.value.left = `${he / 2}px`), window.innerWidth < ue + Fe && (oe = { right: "0" }, Me = 0, j.value.left = `${Fe - he / 2}px`);
          }
          f.value = {
            bottom: `${Y}px`,
            ...oe,
            transform: `translateX(${Me}%)`
          }, o("tooltip-open", T.marker);
        }
      }
    }, F = (T) => {
      p.value && (p.value = null, f.value = JSON.parse(JSON.stringify({ bottom: "", left: "", transform: "" })), o("tooltip-close", T.marker));
    }, A = (T) => {
      b.value.startX = T.changedTouches[0].screenX, b.value.startY = T.changedTouches[0].screenY;
    }, $ = (T) => {
      b.value.endX = T.changedTouches[0].screenX, b.value.endY = T.changedTouches[0].screenY, J();
    }, R = (T) => {
      n.vertical && !n.inline && T.preventDefault();
    }, J = () => {
      const T = n.vertical ? "Y" : "X";
      Math.abs(b.value[`start${T}`] - b.value[`end${T}`]) > 10 && o("handle-swipe", b.value[`start${T}`] > b.value[`end${T}`] ? "right" : "left");
    }, M = (T, x, ie) => {
      T && (Array.isArray(g.value[x]) ? g.value[x][ie] = T : g.value[x] = [T]), n.arrowNavigation && i(g.value, "calendar");
    }, k = (T) => {
      n.monthChangeOnScroll && (T.preventDefault(), o("handle-scroll", T));
    }, O = (T) => m.value.type === "local" ? QR(T.value, { weekStartsOn: +n.weekStart }) : m.value.type === "iso" ? YR(T.value) : typeof m.value.type == "function" ? m.value.type(T.value) : "", E = (T) => {
      const x = T[0];
      return m.value.hideOnOffsetDates ? T.some((ie) => ie.current) ? O(x) : "" : O(x);
    }, te = (T, x) => {
      oa(T, c.value), o("select-date", x);
    }, se = (T) => {
      oa(T, c.value);
    };
    return t({ triggerTransition: U }), (T, x) => {
      var ie;
      return d(), y("div", {
        class: Pe(V.value)
      }, [
        D("div", {
          ref_key: "calendarWrapRef",
          ref: w,
          role: "grid",
          class: Pe(de.value),
          "aria-label": (ie = u(s)) == null ? void 0 : ie.calendarWrap
        }, [
          (d(), y(ge, { key: 0 }, [
            D("div", iW, [
              T.weekNumbers ? (d(), y("div", lW, G(T.weekNumName), 1)) : v("", !0),
              (d(!0), y(ge, null, Ie(C.value, (ce, K) => (d(), y("div", {
                key: K,
                class: "dp__calendar_header_item",
                role: "gridcell"
              }, [
                T.$slots["calendar-header"] ? ee(T.$slots, "calendar-header", {
                  key: 0,
                  day: ce,
                  index: K
                }) : v("", !0),
                T.$slots["calendar-header"] ? v("", !0) : (d(), y(ge, { key: 1 }, [
                  wt(G(ce), 1)
                ], 64))
              ]))), 128))
            ]),
            cW,
            be(Rr, {
              name: _.value,
              css: !!T.transitions
            }, {
              default: ke(() => {
                var ce;
                return [
                  q.value ? (d(), y("div", {
                    key: 0,
                    class: "dp__calendar",
                    role: "rowgroup",
                    "aria-label": ((ce = u(s)) == null ? void 0 : ce.calendarDays) || void 0
                  }, [
                    (d(!0), y(ge, null, Ie(I.value, (K, me) => (d(), y("div", {
                      key: me,
                      class: "dp__calendar_row",
                      role: "row"
                    }, [
                      T.weekNumbers ? (d(), y("div", sW, [
                        D("div", uW, G(E(K.days)), 1)
                      ])) : v("", !0),
                      (d(!0), y(ge, null, Ie(K.days, (he, Y) => {
                        var oe, Me, ue;
                        return d(), y("div", {
                          id: he.value.toISOString().split("T")[0],
                          ref_for: !0,
                          ref: (Fe) => M(Fe, me, Y),
                          key: Y + me,
                          role: "gridcell",
                          class: "dp__calendar_item",
                          "aria-selected": he.classData.dp__active_date || he.classData.dp__range_start || he.classData.dp__range_start,
                          "aria-disabled": he.classData.dp__cell_disabled || void 0,
                          "aria-label": (Me = (oe = u(s)) == null ? void 0 : oe.day) == null ? void 0 : Me.call(oe, he),
                          tabindex: "0",
                          onClick: Ue((Fe) => te(Fe, he), ["prevent"]),
                          onKeydown: [
                            Ae((Fe) => T.$emit("select-date", he), ["enter"]),
                            Ae((Fe) => T.$emit("handle-space", he), ["space"])
                          ],
                          onMouseenter: (Fe) => re(he, me, Y),
                          onMouseleave: (Fe) => F(he)
                        }, [
                          D("div", {
                            class: Pe(["dp__cell_inner", he.classData])
                          }, [
                            T.$slots.day && Z.value(he) ? ee(T.$slots, "day", {
                              key: 0,
                              day: +he.text,
                              date: he.value
                            }) : v("", !0),
                            T.$slots.day ? v("", !0) : (d(), y(ge, { key: 1 }, [
                              wt(G(he.text), 1)
                            ], 64)),
                            he.marker && Z.value(he) ? (d(), y(ge, { key: 2 }, [
                              T.$slots.marker ? ee(T.$slots, "marker", {
                                key: 0,
                                marker: he.marker,
                                day: +he.text,
                                date: he.value
                              }) : (d(), y("div", {
                                key: 1,
                                class: Pe(ae.value(he.marker)),
                                style: yt(he.marker.color ? { backgroundColor: he.marker.color } : {})
                              }, null, 6))
                            ], 64)) : v("", !0),
                            S.value(he.value) ? (d(), y("div", {
                              key: 3,
                              ref_for: !0,
                              ref_key: "activeTooltip",
                              ref: L,
                              class: "dp__marker_tooltip",
                              style: yt(f.value)
                            }, [
                              (ue = he.marker) != null && ue.tooltip ? (d(), y("div", {
                                key: 0,
                                class: "dp__tooltip_content",
                                onClick: se
                              }, [
                                (d(!0), y(ge, null, Ie(he.marker.tooltip, (Fe, ft) => (d(), y("div", {
                                  key: ft,
                                  class: "dp__tooltip_text"
                                }, [
                                  T.$slots["marker-tooltip"] ? ee(T.$slots, "marker-tooltip", {
                                    key: 0,
                                    tooltip: Fe,
                                    day: he.value
                                  }) : v("", !0),
                                  T.$slots["marker-tooltip"] ? v("", !0) : (d(), y(ge, { key: 1 }, [
                                    D("div", {
                                      class: "dp__tooltip_mark",
                                      style: yt(Fe.color ? { backgroundColor: Fe.color } : {})
                                    }, null, 4),
                                    D("div", null, G(Fe.text), 1)
                                  ], 64))
                                ]))), 128)),
                                D("div", {
                                  class: "dp__arrow_bottom_tp",
                                  style: yt(j.value)
                                }, null, 4)
                              ])) : v("", !0)
                            ], 4)) : v("", !0)
                          ], 2)
                        ], 40, hW);
                      }), 128))
                    ]))), 128))
                  ], 8, dW)) : v("", !0)
                ];
              }),
              _: 3
            }, 8, ["name", "css"])
          ], 64))
        ], 10, rW)
      ], 2);
    };
  }
}), tI = (e) => Array.isArray(e), yW = (e, t, a, o) => {
  const n = W([]), { modelValue: i, calendars: l, time: c } = m1(e, t), { defaultedMultiCalendars: s, defaultedStartTime: h } = tt(e), { validateMonthYearInRange: m, isDisabled: p, isDateRangeAllowed: f, checkMinMaxRange: g } = Cr(e), { updateTimeValues: w, getSetDateTime: q, setTime: _, assignStartTime: b, validateTime: L, disabledTimesConfig: j } = EL(e, c, i, o), I = N(
    () => (z) => l.value[z] ? l.value[z].month : 0
  ), C = N(
    () => (z) => l.value[z] ? l.value[z].year : 0
  ), B = (z, le, Le) => {
    var De, Xe;
    l.value[z] || (l.value[z] = { month: 0, year: 0 }), l.value[z].month = Xw(le) ? (De = l.value[z]) == null ? void 0 : De.month : le, l.value[z].year = Xw(Le) ? (Xe = l.value[z]) == null ? void 0 : Xe.year : Le;
  }, U = () => {
    e.autoApply && t("select-date");
  };
  ot(i, (z, le) => {
    JSON.stringify(z) !== JSON.stringify(le) && S();
  }), at(() => {
    e.shadow || (i.value || (k(), h.value && b(h.value)), S(!0), e.focusStartDate && e.startDate && k());
  });
  const de = N(() => {
    var z;
    return (z = e.flow) != null && z.length && !e.partialFlow ? e.flowStep === e.flow.length : !0;
  }), ae = () => {
    e.autoApply && de.value && t("auto-apply", e.partialFlow);
  }, S = (z = !1) => {
    if (i.value)
      return Array.isArray(i.value) ? (n.value = i.value, $(z)) : Z(i.value, z);
    if (s.value.count && z && !e.startDate)
      return V(ne(), z);
  }, V = (z, le = !1) => {
    if ((!s.value.count || !s.value.static || le) && B(0, He(z), qe(z)), s.value.count && (!s.value.solo || !i.value))
      for (let Le = 1; Le < s.value.count; Le++) {
        const De = Ge(ne(), { month: I.value(Le - 1), year: C.value(Le - 1) }), Xe = nL(De, { months: 1 });
        l.value[Le] = { month: He(Xe), year: qe(Xe) };
      }
  }, Z = (z, le) => {
    V(z), _("hours", qt(z)), _("minutes", $t(z)), _("seconds", Hr(z)), s.value.count && le && M();
  }, re = (z) => {
    if (s.value.count) {
      if (s.value.solo)
        return 0;
      const le = He(z[0]), Le = He(z[1]);
      return Math.abs(Le - le) < s.value.count ? 0 : 1;
    }
    return 1;
  }, F = (z, le) => {
    z[1] && e.showLastInRange ? V(z[re(z)], le) : V(z[0], le);
    const Le = (De, Xe) => [
      De(z[0]),
      z[1] ? De(z[1]) : c[Xe][1]
    ];
    _("hours", Le(qt, "hours")), _("minutes", Le($t, "minutes")), _("seconds", Le(Hr, "seconds"));
  }, A = (z, le) => {
    if ((e.range || e.weekPicker) && !e.multiDates)
      return F(z, le);
    if (e.multiDates && le) {
      const Le = z[z.length - 1];
      return Z(Le, le);
    }
  }, $ = (z) => {
    const le = i.value;
    A(le, z), s.value.count && s.value.solo && M();
  }, R = (z, le) => {
    const Le = Ge(ne(), { month: I.value(le), year: C.value(le) }), De = z < 0 ? Pt(Le, 1) : jr(Le, 1);
    m(He(De), qe(De), z < 0, e.preventMinMaxNavigation) && (B(le, He(De), qe(De)), t("update-month-year", { instance: le, month: He(De), year: qe(De) }), s.value.count && !s.value.solo && J(le), a());
  }, J = (z) => {
    for (let le = z - 1; le >= 0; le--) {
      const Le = jr(Ge(ne(), { month: I.value(le + 1), year: C.value(le + 1) }), 1);
      B(le, He(Le), qe(Le));
    }
    for (let le = z + 1; le <= s.value.count - 1; le++) {
      const Le = Pt(Ge(ne(), { month: I.value(le - 1), year: C.value(le - 1) }), 1);
      B(le, He(Le), qe(Le));
    }
  }, M = () => {
    if (Array.isArray(i.value) && i.value.length === 2) {
      const z = ne(
        ne(i.value[1] ? i.value[1] : Pt(i.value[0], 1))
      ), [le, Le] = [He(i.value[0]), qe(i.value[0])], [De, Xe] = [He(i.value[1]), qe(i.value[1])];
      (le !== De || le === De && Le !== Xe) && s.value.solo && B(1, He(z), qe(z));
    } else
      i.value && !Array.isArray(i.value) && (B(0, He(i.value), qe(i.value)), V(ne()));
  }, k = () => {
    e.startDate && (B(0, He(ne(e.startDate)), qe(ne(e.startDate))), s.value.count && J(0));
  }, O = ZU((z, le) => {
    e.monthChangeOnScroll && R(e.monthChangeOnScroll !== "inverse" ? -z.deltaY : z.deltaY, le);
  }, 50), E = (z, le, Le = !1) => {
    e.monthChangeOnArrows && e.vertical === Le && te(z, le);
  }, te = (z, le) => {
    R(z === "right" ? -1 : 1, le);
  }, se = (z) => e.markers.find(
    (le) => Oe(XU(z.value), Tt(ne(le.date), e.timezone))
  ), T = (z, le) => {
    switch (e.sixWeeks === !0 ? "append" : e.sixWeeks) {
      case "prepend":
        return [!0, !1];
      case "center":
        return [z == 0, !0];
      case "fair":
        return [z == 0 || le > z, !0];
      case "append":
        return [!1, !1];
      default:
        return [!1, !1];
    }
  }, x = (z, le, Le, De) => {
    if (e.sixWeeks && z.length < 6) {
      const Xe = 6 - z.length, Bt = (le.getDay() + 7 - De) % 7, Qt = 6 - (Le.getDay() + 7 - De) % 7, [pe, Ce] = T(Bt, Qt);
      for (let Se = 1; Se <= Xe; Se++)
        if (Ce ? !!(Se % 2) == pe : pe) {
          const xt = z[0].days[0], Et = ie(Wt(xt.value, -7), He(le));
          z.unshift({ days: Et });
        } else {
          const xt = z[z.length - 1], Et = xt.days[xt.days.length - 1], n9 = ie(Wt(Et.value, 1), He(le));
          z.push({ days: n9 });
        }
    }
    return z;
  }, ie = (z, le) => {
    const Le = ne(z), De = [];
    for (let Xe = 0; Xe < 7; Xe++) {
      const Bt = Wt(Le, Xe), Qt = He(Bt) !== le;
      De.push({
        text: e.hideOffsetDates && Qt ? "" : Bt.getDate(),
        value: Bt,
        current: !Qt,
        classData: {}
      });
    }
    return De;
  }, ce = (z, le) => {
    const Le = [], De = new Date(le, z), Xe = new Date(le, z + 1, 0), Bt = e.weekStart, Qt = br(De, { weekStartsOn: Bt }), pe = (Ce) => {
      const Se = ie(Ce, z);
      if (Le.push({ days: Se }), !Le[Le.length - 1].days.some(
        (xt) => Oe(ut(xt.value), ut(Xe))
      )) {
        const xt = Wt(Ce, 7);
        pe(xt);
      }
    };
    return pe(Qt), x(Le, De, Xe, Bt);
  }, K = (z) => (i.value = mx(ne(z.value), e.timezone, e.weekStart), t("date-update", z.value), ae()), me = (z) => {
    const le = ra(ne(z.value), c.hours, c.minutes, qr());
    t("date-update", le), e.multiDates ? qb(le, i, e.multiDatesLimit) : i.value = le, o(), Gt().then(() => {
      ae();
    });
  }, he = (z) => e.noDisabledRange ? BL(n.value[0], z).some((le) => p(le)) : !1, Y = () => {
    n.value = i.value ? i.value.slice() : [], n.value.length === 2 && !(e.fixedStart || e.fixedEnd) && (n.value = []);
  }, oe = (z, le) => {
    const Le = [ne(z.value), Wt(ne(z.value), +e.autoRange)];
    f(Le) ? (le && Me(z.value), n.value = Le) : t("invalid-date", z.value);
  }, Me = (z) => {
    const le = He(ne(z)), Le = qe(ne(z));
    if (B(0, le, Le), s.value.count > 0)
      for (let De = 1; De < s.value.count; De++) {
        const Xe = KU(
          Ge(ne(z), { year: I.value(De - 1), month: C.value(De - 1) })
        );
        B(De, Xe.month, Xe.year);
      }
  }, ue = (z) => Array.isArray(i.value) && i.value.length === 2 ? e.fixedStart && (st(z, i.value[0]) || Oe(z, i.value[0])) ? [i.value[0], z] : e.fixedEnd && (ct(z, i.value[1]) || Oe(z, i.value[1])) ? [z, i.value[1]] : (t("invalid-fixed-range", z), i.value) : [], Fe = (z) => {
    if (he(z.value) || !g(z.value, i.value, e.fixedStart ? 0 : 1))
      return t("invalid-date", z.value);
    n.value = ue(ne(z.value));
  }, ft = (z, le) => {
    if (Y(), e.autoRange)
      return oe(z, le);
    if (e.fixedStart || e.fixedEnd)
      return Fe(z);
    n.value[0] ? g(ne(z.value), i.value) && !he(z.value) ? ct(ne(z.value), ne(n.value[0])) ? (n.value.unshift(ne(z.value)), t("range-end", n.value[0])) : (n.value[1] = ne(z.value), t("range-end", n.value[1])) : (e.autoApply && t("auto-apply-invalid", z.value), t("invalid-date", z.value)) : (n.value[0] = ne(z.value), t("range-start", n.value[0]));
  }, qr = (z = !0) => e.enableSeconds ? Array.isArray(c.seconds) ? z ? c.seconds[0] : c.seconds[1] : c.seconds : 0, Kt = (z) => {
    n.value[z] = ra(
      n.value[z],
      c.hours[z],
      c.minutes[z],
      qr(z !== 1)
    );
  }, M1 = () => {
    var z, le;
    n.value[0] && n.value[1] && +((z = n.value) == null ? void 0 : z[0]) > +((le = n.value) == null ? void 0 : le[1]) && (n.value.reverse(), t("range-start", n.value[0]), t("range-end", n.value[1]));
  }, x1 = () => {
    n.value.length && (n.value[0] && !n.value[1] ? Kt(0) : (Kt(0), Kt(1), o()), M1(), i.value = n.value.slice(), Jx(n.value, t, e.autoApply, e.modelAuto));
  }, e9 = (z, le = !1) => {
    if (p(z.value) || !z.current && e.hideOffsetDates)
      return t("invalid-date", z.value);
    if (e.weekPicker)
      return K(z);
    if (!e.range)
      return me(z);
    tI(c.hours) && tI(c.minutes) && !e.multiDates && (ft(z, le), x1());
  }, Xr = (z, le) => {
    var Le;
    B(z, le.month, le.year), s.value.count && !s.value.solo && J(z), t("update-month-year", { instance: z, month: le.month, year: le.year }), a(s.value.solo ? z : void 0);
    const De = (Le = e.flow) != null && Le.length ? e.flow[e.flowStep] : void 0;
    !le.fromNav && (De === Ht.month || De === Ht.year) && o();
  }, Mt = (z, le) => {
    RL({ value: z, modelValue: i, range: e.range, timezone: le ? void 0 : e.timezone }), U(), e.multiCalendars && Gt().then(() => S(!0));
  }, t9 = () => {
    e.range ? i.value && Array.isArray(i.value) && i.value[0] ? i.value = ct(ne(), i.value[0]) ? [ne(), i.value[0]] : [i.value[0], ne()] : i.value = [ne()] : i.value = ne(), U();
  }, a9 = () => {
    if (Array.isArray(i.value))
      if (e.multiDates) {
        const z = b1();
        i.value[i.value.length - 1] = q(z);
      } else
        i.value = i.value.map((z, le) => z && q(z, le));
    else
      i.value = q(i.value);
    t("time-update");
  }, b1 = () => Array.isArray(i.value) && i.value.length ? i.value[i.value.length - 1] : null;
  return {
    calendars: l,
    modelValue: i,
    month: I,
    year: C,
    time: c,
    disabledTimesConfig: j,
    validateTime: L,
    getCalendarDays: ce,
    getMarker: se,
    handleScroll: O,
    handleSwipe: te,
    handleArrow: E,
    selectDate: e9,
    updateMonthYear: Xr,
    presetDate: Mt,
    selectCurrentDate: t9,
    updateTime: (z, le = !0, Le = !1) => {
      w(z, le, Le, a9);
    }
  };
}, kW = { key: 0 }, fW = /* @__PURE__ */ dt({
  __name: "DatePicker",
  props: {
    ...Dt
  },
  emits: [
    "tooltip-open",
    "tooltip-close",
    "mount",
    "update:internal-model-value",
    "update-flow-step",
    "reset-flow",
    "auto-apply",
    "focus-menu",
    "select-date",
    "range-start",
    "range-end",
    "invalid-fixed-range",
    "time-update",
    "am-pm-change",
    "time-picker-open",
    "time-picker-close",
    "recalculate-position",
    "update-month-year",
    "auto-apply-invalid",
    "date-update",
    "invalid-date"
  ],
  setup(e, { expose: t, emit: a }) {
    const o = a, n = e, {
      calendars: i,
      month: l,
      year: c,
      modelValue: s,
      time: h,
      disabledTimesConfig: m,
      validateTime: p,
      getCalendarDays: f,
      getMarker: g,
      handleArrow: w,
      handleScroll: q,
      handleSwipe: _,
      selectDate: b,
      updateMonthYear: L,
      presetDate: j,
      selectCurrentDate: I,
      updateTime: C
    } = yW(n, o, M, k), B = Lr(), { setHoverDate: U, getDayClassData: de, clearHoverDate: ae } = mE(s, n), { defaultedMultiCalendars: S } = tt(n), V = W([]), Z = W([]), re = W(null), F = gt(B, "calendar"), A = gt(B, "monthYear"), $ = gt(B, "timePicker"), R = (E) => {
      n.shadow || o("mount", E);
    };
    ot(
      i,
      () => {
        n.shadow || setTimeout(() => {
          o("recalculate-position");
        }, 0);
      },
      { deep: !0 }
    );
    const J = N(() => (E) => f(l.value(E), c.value(E)).map((te) => ({
      ...te,
      days: te.days.map((se) => (se.marker = g(se), se.classData = de(se), se))
    })));
    function M(E) {
      var te;
      E || E === 0 ? (te = Z.value[E]) == null || te.triggerTransition(l.value(E), c.value(E)) : Z.value.forEach((se, T) => se.triggerTransition(l.value(T), c.value(T)));
    }
    function k() {
      o("update-flow-step");
    }
    const O = (E, te = !1) => {
      b(E, te), n.spaceConfirm && o("select-date");
    };
    return t({
      clearHoverDate: ae,
      presetDate: j,
      selectCurrentDate: I,
      toggleMonthPicker: (E, te, se = 0) => {
        var T;
        (T = V.value[se]) == null || T.toggleMonthPicker(E, te);
      },
      toggleYearPicker: (E, te, se = 0) => {
        var T;
        (T = V.value[se]) == null || T.toggleYearPicker(E, te);
      },
      toggleTimePicker: (E, te, se) => {
        var T;
        (T = re.value) == null || T.toggleTimePicker(E, te, se);
      },
      handleArrow: w,
      updateMonthYear: L,
      getSidebarProps: () => ({
        modelValue: s,
        month: l,
        year: c,
        time: h,
        updateTime: C,
        updateMonthYear: L,
        selectDate: b,
        presetDate: j
      })
    }), (E, te) => (d(), y(ge, null, [
      be(Qx, {
        "multi-calendars": u(S).count
      }, {
        default: ke(({ instance: se, index: T }) => [
          E.disableMonthYearSelect ? v("", !0) : (d(), Q(oW, H({
            key: 0,
            ref: (x) => {
              x && (V.value[T] = x);
            },
            months: u(PL)(E.formatLocale, E.locale, E.monthNameFormat),
            years: u(Ab)(E.yearRange, E.reverseYears),
            month: u(l)(se),
            year: u(c)(se),
            instance: se
          }, E.$props, {
            onMount: te[0] || (te[0] = (x) => R(u(xr).header)),
            onResetFlow: te[1] || (te[1] = (x) => E.$emit("reset-flow")),
            onUpdateMonthYear: (x) => u(L)(se, x),
            onOverlayClosed: te[2] || (te[2] = (x) => E.$emit("focus-menu"))
          }), kt({ _: 2 }, [
            Ie(u(A), (x, ie) => ({
              name: x,
              fn: ke((ce) => [
                ee(E.$slots, x, P(X(ce)))
              ])
            }))
          ]), 1040, ["months", "years", "month", "year", "instance", "onUpdateMonthYear"])),
          be(pW, H({
            ref: (x) => {
              x && (Z.value[T] = x);
            },
            "mapped-dates": J.value(se),
            month: u(l)(se),
            year: u(c)(se),
            instance: se
          }, E.$props, {
            onSelectDate: (x) => u(b)(x, se !== 1),
            onHandleSpace: (x) => O(x, se !== 1),
            onSetHoverDate: te[3] || (te[3] = (x) => u(U)(x)),
            onHandleScroll: (x) => u(q)(x, se),
            onHandleSwipe: (x) => u(_)(x, se),
            onMount: te[4] || (te[4] = (x) => R(u(xr).calendar)),
            onResetFlow: te[5] || (te[5] = (x) => E.$emit("reset-flow")),
            onTooltipOpen: te[6] || (te[6] = (x) => E.$emit("tooltip-open", x)),
            onTooltipClose: te[7] || (te[7] = (x) => E.$emit("tooltip-close", x))
          }), kt({ _: 2 }, [
            Ie(u(F), (x, ie) => ({
              name: x,
              fn: ke((ce) => [
                ee(E.$slots, x, P(X({ ...ce })))
              ])
            }))
          ]), 1040, ["mapped-dates", "month", "year", "instance", "onSelectDate", "onHandleSpace", "onHandleScroll", "onHandleSwipe"])
        ]),
        _: 3
      }, 8, ["multi-calendars"]),
      E.enableTimePicker ? (d(), y("div", kW, [
        E.$slots["time-picker"] ? ee(E.$slots, "time-picker", P(H({ key: 0 }, { time: u(h), updateTime: u(C) }))) : (d(), Q(UL, H({
          key: 1,
          ref_key: "timePickerRef",
          ref: re
        }, E.$props, {
          hours: u(h).hours,
          minutes: u(h).minutes,
          seconds: u(h).seconds,
          "internal-model-value": E.internalModelValue,
          "disabled-times-config": u(m),
          "validate-time": u(p),
          onMount: te[8] || (te[8] = (se) => R(u(xr).timePicker)),
          "onUpdate:hours": te[9] || (te[9] = (se) => u(C)(se)),
          "onUpdate:minutes": te[10] || (te[10] = (se) => u(C)(se, !1)),
          "onUpdate:seconds": te[11] || (te[11] = (se) => u(C)(se, !1, !0)),
          onResetFlow: te[12] || (te[12] = (se) => E.$emit("reset-flow")),
          onOverlayClosed: te[13] || (te[13] = (se) => E.$emit("time-picker-close")),
          onOverlayOpened: te[14] || (te[14] = (se) => E.$emit("time-picker-open", se)),
          onAmPmChange: te[15] || (te[15] = (se) => E.$emit("am-pm-change", se))
        }), kt({ _: 2 }, [
          Ie(u($), (se, T) => ({
            name: se,
            fn: ke((x) => [
              ee(E.$slots, se, P(X(x)))
            ])
          }))
        ]), 1040, ["hours", "minutes", "seconds", "internal-model-value", "disabled-times-config", "validate-time"]))
      ])) : v("", !0)
    ], 64));
  }
}), vW = (e, t) => {
  const a = W(), { defaultedMultiCalendars: o, defaultedConfig: n, defaultedHighlight: i } = tt(e), { modelValue: l, year: c, month: s, calendars: h } = m1(e, t), { isDisabled: m } = Cr(e), { selectYear: p, groupedYears: f, showYearPicker: g, isDisabled: w, toggleYearPicker: q, handleYearSelect: _, handleYear: b } = FL({
    modelValue: l,
    multiCalendars: o,
    highlight: i,
    calendars: h,
    month: s,
    year: c,
    props: e,
    emit: t
  }), L = (ae, S) => [ae, S].map((V) => na(V, "MMMM", { locale: e.formatLocale })).join("-"), j = N(() => (ae) => l.value ? Array.isArray(l.value) ? l.value.some((S) => Ow(ae, S)) : Ow(l.value, ae) : !1), I = (ae) => {
    if (e.range) {
      if (Array.isArray(l.value)) {
        const S = Oe(ae, l.value[0]) || Oe(ae, l.value[1]);
        return Gx(l.value, a.value, ae) && !S;
      }
      return !1;
    }
    return !1;
  }, C = N(() => (ae) => {
    const S = Ge(/* @__PURE__ */ new Date(), { year: c.value(ae) });
    return j$({
      start: O$(S),
      end: V$(S)
    }).map((V) => {
      const Z = l1(V), re = Dw(V), F = m(V), A = I(Z), $ = typeof i.value == "function" ? i.value({ quarter: Tw(Z), year: qe(Z) }) : !!i.value.quarters.find(
        (R) => R.quarter === Tw(Z) && R.year === qe(Z)
      );
      return {
        text: L(Z, re),
        value: Z,
        active: j.value(Z),
        highlighted: $,
        disabled: F,
        isBetween: A
      };
    });
  }), B = (ae) => {
    qb(ae, l, e.multiDatesLimit), t("auto-apply", !0);
  }, U = (ae) => {
    const S = Tb(l, ae, t);
    Jx(S, t, e.autoApply, e.modelAuto);
  }, de = (ae) => {
    l.value = ae, t("auto-apply");
  };
  return {
    defaultedConfig: n,
    defaultedMultiCalendars: o,
    groupedYears: f,
    year: c,
    isDisabled: w,
    quarters: C,
    showYearPicker: g,
    modelValue: l,
    setHoverDate: (ae) => {
      a.value = ae;
    },
    selectYear: p,
    selectQuarter: (ae, S, V) => {
      if (!V)
        return h.value[S].month = He(Dw(ae)), e.multiDates ? B(ae) : e.range ? U(ae) : de(ae);
    },
    toggleYearPicker: q,
    handleYearSelect: _,
    handleYear: b
  };
}, mW = { class: "dp--quarter-items" }, gW = ["disabled", "onClick", "onMouseover"], MW = /* @__PURE__ */ dt({
  compatConfig: {
    MODE: 3
  },
  __name: "QuarterPicker",
  props: {
    ...Dt
  },
  emits: [
    "update:internal-model-value",
    "reset-flow",
    "overlay-closed",
    "auto-apply",
    "range-start",
    "range-end"
  ],
  setup(e, { expose: t, emit: a }) {
    const o = a, n = e, i = Lr(), l = gt(i, "yearMode"), {
      defaultedMultiCalendars: c,
      defaultedConfig: s,
      groupedYears: h,
      year: m,
      isDisabled: p,
      quarters: f,
      modelValue: g,
      showYearPicker: w,
      setHoverDate: q,
      selectQuarter: _,
      toggleYearPicker: b,
      handleYearSelect: L,
      handleYear: j
    } = vW(n, o);
    return t({ getSidebarProps: () => ({
      modelValue: g,
      year: m,
      selectQuarter: _,
      handleYearSelect: L,
      handleYear: j
    }) }), (I, C) => (d(), Q(Qx, {
      "multi-calendars": u(c).count,
      stretch: ""
    }, {
      default: ke(({ instance: B }) => [
        D("div", {
          class: "dp-quarter-picker-wrap",
          style: yt({ minHeight: `${u(s).modeHeight}px` })
        }, [
          D("div", null, [
            be($L, H(I.$props, {
              items: u(h)(B),
              instance: B,
              "show-year-picker": u(w)[B],
              year: u(m)(B),
              "is-disabled": (U) => u(p)(B, U),
              onHandleYear: (U) => u(j)(B, U),
              onYearSelect: (U) => u(L)(U, B),
              onToggleYearPicker: (U) => u(b)(B, U == null ? void 0 : U.flow, U == null ? void 0 : U.show)
            }), kt({ _: 2 }, [
              Ie(u(l), (U, de) => ({
                name: U,
                fn: ke((ae) => [
                  ee(I.$slots, U, P(X(ae)))
                ])
              }))
            ]), 1040, ["items", "instance", "show-year-picker", "year", "is-disabled", "onHandleYear", "onYearSelect", "onToggleYearPicker"])
          ]),
          D("div", mW, [
            (d(!0), y(ge, null, Ie(u(f)(B), (U, de) => (d(), y("div", { key: de }, [
              D("button", {
                type: "button",
                class: Pe(["dp--qr-btn", {
                  "dp--qr-btn-active": U.active,
                  "dp--qr-btn-between": U.isBetween,
                  "dp--qr-btn-disabled": U.disabled,
                  "dp--highlighted": U.highlighted
                }]),
                disabled: U.disabled,
                onClick: (ae) => u(_)(U.value, B, U.disabled),
                onMouseover: (ae) => u(q)(U.value)
              }, [
                I.$slots.quarter ? ee(I.$slots, "quarter", {
                  key: 0,
                  value: U.value,
                  text: U.text
                }) : (d(), y(ge, { key: 1 }, [
                  wt(G(U.text), 1)
                ], 64))
              ], 42, gW)
            ]))), 128))
          ])
        ], 4)
      ]),
      _: 3
    }, 8, ["multi-calendars"]));
  }
}), xW = ["id"], bW = {
  key: 0,
  class: "dp__sidebar_left"
}, wW = {
  key: 1,
  class: "dp--preset-dates"
}, IW = ["onClick", "onKeydown"], LW = {
  key: 2,
  class: "dp__sidebar_right"
}, SW = {
  key: 3,
  class: "dp__action_extra"
}, aI = /* @__PURE__ */ dt({
  compatConfig: {
    MODE: 3
  },
  __name: "DatepickerMenu",
  props: {
    ...Kx,
    shadow: { type: Boolean, default: !1 },
    openOnTop: { type: Boolean, default: !1 },
    internalModelValue: { type: [Date, Array], default: null },
    arrMapValues: { type: Object, default: () => ({}) },
    noOverlayFocus: { type: Boolean, default: !1 }
  },
  emits: [
    "close-picker",
    "select-date",
    "auto-apply",
    "time-update",
    "flow-step",
    "update-month-year",
    "invalid-select",
    "update:internal-model-value",
    "recalculate-position",
    "invalid-fixed-range",
    "tooltip-open",
    "tooltip-close",
    "time-picker-open",
    "time-picker-close",
    "am-pm-change",
    "range-start",
    "range-end",
    "auto-apply-invalid",
    "date-update",
    "invalid-date"
  ],
  setup(e, { expose: t, emit: a }) {
    const o = a, n = e, i = N(() => {
      const { openOnTop: Y, ...oe } = n;
      return {
        ...oe,
        flowStep: de.value,
        noOverlayFocus: n.noOverlayFocus
      };
    }), { setMenuFocused: l, setShiftKey: c, control: s } = OL(), h = Lr(), { defaultedTextInput: m, defaultedInline: p, defaultedConfig: f } = tt(n), g = W(null), w = W(0), q = W(null), _ = W(null), b = W(!1), L = W(null);
    at(() => {
      if (!n.shadow) {
        b.value = !0, j(), window.addEventListener("resize", j);
        const Y = nt(q);
        if (Y && !m.value.enabled && !p.value.enabled && (l(!0), re()), Y) {
          const oe = (Me) => {
            f.value.allowPreventDefault && Me.preventDefault(), oa(Me, f.value, !0);
          };
          Y.addEventListener("pointerdown", oe), Y.addEventListener("mousedown", oe);
        }
      }
    }), $r(() => {
      window.removeEventListener("resize", j);
    });
    const j = () => {
      const Y = nt(_);
      Y && (w.value = Y.getBoundingClientRect().width);
    }, { arrowRight: I, arrowLeft: C, arrowDown: B, arrowUp: U } = la(), { flowStep: de, updateFlowStep: ae, childMount: S, resetFlow: V } = gE(n, o, L), Z = N(() => n.monthPicker ? HE : n.yearPicker ? VE : n.timePicker ? tW : n.quarterPicker ? MW : fW), re = () => {
      const Y = nt(q);
      Y && Y.focus({ preventScroll: !0 });
    }, F = N(() => {
      var Y;
      return ((Y = L.value) == null ? void 0 : Y.getSidebarProps()) || {};
    }), A = () => {
      n.openOnTop && o("recalculate-position");
    }, $ = gt(h, "action"), R = N(() => n.monthPicker || n.yearPicker ? gt(h, "monthYear") : n.timePicker ? gt(h, "timePicker") : gt(h, "shared")), J = N(() => n.openOnTop ? "dp__arrow_bottom" : "dp__arrow_top"), M = N(() => ({
      dp__menu_disabled: n.disabled,
      dp__menu_readonly: n.readonly
    })), k = N(
      () => ({
        dp__menu: !0,
        dp__menu_index: !p.value.enabled,
        dp__relative: p.value.enabled,
        [n.menuClassName]: !!n.menuClassName
      })
    ), O = (Y) => {
      oa(Y, f.value, !0);
    }, E = () => {
      n.escClose && o("close-picker");
    }, te = (Y) => {
      if (n.arrowNavigation) {
        if (Y === "up")
          return U();
        if (Y === "down")
          return B();
        if (Y === "left")
          return C();
        if (Y === "right")
          return I();
      } else
        Y === "left" || Y === "up" ? ce("handleArrow", "left", 0, Y === "up") : ce("handleArrow", "right", 0, Y === "down");
    }, se = (Y) => {
      c(Y.shiftKey), !n.disableMonthYearSelect && Y.code === "Tab" && Y.target.classList.contains("dp__menu") && s.value.shiftKeyInMenu && (Y.preventDefault(), oa(Y, f.value, !0), o("close-picker"));
    }, T = () => {
      re(), o("time-picker-close");
    }, x = (Y) => {
      var oe, Me, ue;
      (oe = L.value) == null || oe.toggleTimePicker(!1, !1), (Me = L.value) == null || Me.toggleMonthPicker(!1, !1, Y), (ue = L.value) == null || ue.toggleYearPicker(!1, !1, Y);
    }, ie = (Y, oe = 0) => {
      var Me, ue, Fe;
      return Y === "month" ? (Me = L.value) == null ? void 0 : Me.toggleMonthPicker(!1, !0, oe) : Y === "year" ? (ue = L.value) == null ? void 0 : ue.toggleYearPicker(!1, !0, oe) : Y === "time" ? (Fe = L.value) == null ? void 0 : Fe.toggleTimePicker(!0, !1) : x(oe);
    }, ce = (Y, ...oe) => {
      var Me, ue;
      (Me = L.value) != null && Me[Y] && ((ue = L.value) == null || ue[Y](...oe));
    }, K = () => {
      ce("selectCurrentDate");
    }, me = (Y, oe) => {
      ce("presetDate", Y, oe);
    }, he = () => {
      ce("clearHoverDate");
    };
    return t({
      updateMonthYear: (Y, oe) => {
        ce("updateMonthYear", Y, oe);
      },
      switchView: ie
    }), (Y, oe) => {
      var Me;
      return d(), y("div", {
        id: Y.uid ? `dp-menu-${Y.uid}` : void 0,
        ref_key: "dpMenuRef",
        ref: q,
        tabindex: "0",
        role: "dialog",
        class: Pe(k.value),
        onMouseleave: he,
        onClick: O,
        onKeydown: [
          Ae(E, ["esc"]),
          oe[18] || (oe[18] = Ae(Ue((ue) => te("left"), ["prevent"]), ["left"])),
          oe[19] || (oe[19] = Ae(Ue((ue) => te("up"), ["prevent"]), ["up"])),
          oe[20] || (oe[20] = Ae(Ue((ue) => te("down"), ["prevent"]), ["down"])),
          oe[21] || (oe[21] = Ae(Ue((ue) => te("right"), ["prevent"]), ["right"])),
          se
        ]
      }, [
        (Y.disabled || Y.readonly) && u(p).enabled ? (d(), y("div", {
          key: 0,
          class: Pe(M.value)
        }, null, 2)) : v("", !0),
        !u(p).enabled && !Y.teleportCenter ? (d(), y("div", {
          key: 1,
          class: Pe(J.value)
        }, null, 2)) : v("", !0),
        D("div", {
          ref_key: "innerMenuRef",
          ref: _,
          class: Pe({
            dp__menu_content_wrapper: ((Me = Y.presetDates) == null ? void 0 : Me.length) || !!Y.$slots["left-sidebar"] || !!Y.$slots["right-sidebar"]
          }),
          style: yt({ "--dp-menu-width": `${w.value}px` })
        }, [
          Y.$slots["left-sidebar"] ? (d(), y("div", bW, [
            ee(Y.$slots, "left-sidebar", P(X(F.value)))
          ])) : v("", !0),
          Y.presetDates.length ? (d(), y("div", wW, [
            (d(!0), y(ge, null, Ie(Y.presetDates, (ue, Fe) => (d(), y(ge, { key: Fe }, [
              ue.slot ? ee(Y.$slots, ue.slot, {
                key: 0,
                presetDate: me,
                label: ue.label,
                value: ue.value
              }) : (d(), y("button", {
                key: 1,
                type: "button",
                style: yt(ue.style || {}),
                class: "dp__btn dp--preset-range",
                onClick: Ue((ft) => me(ue.value, ue.noTz), ["prevent"]),
                onKeydown: [
                  Ae(Ue((ft) => me(ue.value, ue.noTz), ["prevent"]), ["enter"]),
                  Ae(Ue((ft) => me(ue.value, ue.noTz), ["prevent"]), ["space"])
                ]
              }, G(ue.label), 45, IW))
            ], 64))), 128))
          ])) : v("", !0),
          D("div", {
            ref_key: "calendarWrapperRef",
            ref: g,
            class: "dp__instance_calendar",
            role: "document"
          }, [
            (d(), Q(mt(Z.value), H({
              ref_key: "dynCmpRef",
              ref: L
            }, i.value, {
              "flow-step": u(de),
              onMount: u(S),
              onUpdateFlowStep: u(ae),
              onResetFlow: u(V),
              onFocusMenu: re,
              onSelectDate: oe[0] || (oe[0] = (ue) => Y.$emit("select-date")),
              onDateUpdate: oe[1] || (oe[1] = (ue) => Y.$emit("date-update", ue)),
              onTooltipOpen: oe[2] || (oe[2] = (ue) => Y.$emit("tooltip-open", ue)),
              onTooltipClose: oe[3] || (oe[3] = (ue) => Y.$emit("tooltip-close", ue)),
              onAutoApply: oe[4] || (oe[4] = (ue) => Y.$emit("auto-apply", ue)),
              onRangeStart: oe[5] || (oe[5] = (ue) => Y.$emit("range-start", ue)),
              onRangeEnd: oe[6] || (oe[6] = (ue) => Y.$emit("range-end", ue)),
              onInvalidFixedRange: oe[7] || (oe[7] = (ue) => Y.$emit("invalid-fixed-range", ue)),
              onTimeUpdate: oe[8] || (oe[8] = (ue) => Y.$emit("time-update")),
              onAmPmChange: oe[9] || (oe[9] = (ue) => Y.$emit("am-pm-change", ue)),
              onTimePickerOpen: oe[10] || (oe[10] = (ue) => Y.$emit("time-picker-open", ue)),
              onTimePickerClose: T,
              onRecalculatePosition: A,
              onUpdateMonthYear: oe[11] || (oe[11] = (ue) => Y.$emit("update-month-year", ue)),
              onAutoApplyInvalid: oe[12] || (oe[12] = (ue) => Y.$emit("auto-apply-invalid", ue)),
              onInvalidDate: oe[13] || (oe[13] = (ue) => Y.$emit("invalid-date", ue)),
              "onUpdate:internalModelValue": oe[14] || (oe[14] = (ue) => Y.$emit("update:internal-model-value", ue))
            }), kt({ _: 2 }, [
              Ie(R.value, (ue, Fe) => ({
                name: ue,
                fn: ke((ft) => [
                  ee(Y.$slots, ue, P(X({ ...ft })))
                ])
              }))
            ]), 1040, ["flow-step", "onMount", "onUpdateFlowStep", "onResetFlow"]))
          ], 512),
          Y.$slots["right-sidebar"] ? (d(), y("div", LW, [
            ee(Y.$slots, "right-sidebar", P(X(F.value)))
          ])) : v("", !0),
          Y.$slots["action-extra"] ? (d(), y("div", SW, [
            Y.$slots["action-extra"] ? ee(Y.$slots, "action-extra", {
              key: 0,
              selectCurrentDate: K
            }) : v("", !0)
          ])) : v("", !0)
        ], 6),
        !Y.autoApply || u(f).keepActionRow ? (d(), Q(CE, H({
          key: 2,
          "menu-mount": b.value
        }, i.value, {
          "calendar-width": w.value,
          onClosePicker: oe[15] || (oe[15] = (ue) => Y.$emit("close-picker")),
          onSelectDate: oe[16] || (oe[16] = (ue) => Y.$emit("select-date")),
          onInvalidSelect: oe[17] || (oe[17] = (ue) => Y.$emit("invalid-select")),
          onSelectNow: K
        }), kt({ _: 2 }, [
          Ie(u($), (ue, Fe) => ({
            name: ue,
            fn: ke((ft) => [
              ee(Y.$slots, ue, P(X({ ...ft })))
            ])
          }))
        ]), 1040, ["menu-mount", "calendar-width"])) : v("", !0)
      ], 42, xW);
    };
  }
}), CW = typeof window < "u" ? window : void 0, b9 = () => {
}, AW = (e) => eS() ? (tS(e), !0) : !1, PW = (e, t, a, o) => {
  if (!e)
    return b9;
  let n = b9;
  const i = ot(
    () => u(e),
    (c) => {
      n(), c && (c.addEventListener(t, a, o), n = () => {
        c.removeEventListener(t, a, o), n = b9;
      });
    },
    { immediate: !0, flush: "post" }
  ), l = () => {
    i(), n();
  };
  return AW(l), l;
}, qW = (e, t, a, o = {}) => {
  const { window: n = CW, event: i = "pointerdown" } = o;
  return n ? PW(n, i, (l) => {
    const c = nt(e), s = nt(t);
    !c || !s || c === l.target || l.composedPath().includes(c) || l.composedPath().includes(s) || a(l);
  }, { passive: !0 }) : void 0;
}, TW = /* @__PURE__ */ dt({
  compatConfig: {
    MODE: 3
  },
  __name: "VueDatePicker",
  props: {
    ...Kx
  },
  emits: [
    "update:model-value",
    "update:model-timezone-value",
    "text-submit",
    "closed",
    "cleared",
    "open",
    "focus",
    "blur",
    "internal-model-change",
    "recalculate-position",
    "flow-step",
    "update-month-year",
    "invalid-select",
    "invalid-fixed-range",
    "tooltip-open",
    "tooltip-close",
    "time-picker-open",
    "time-picker-close",
    "am-pm-change",
    "range-start",
    "range-end",
    "date-update",
    "invalid-date"
  ],
  setup(e, { expose: t, emit: a }) {
    const o = a, n = e, i = Lr(), l = W(!1), c = ia(n, "modelValue"), s = ia(n, "timezone"), h = W(null), m = W(null), p = W(null), f = W(!1), g = W(null), w = W(!1), q = W(!1), { setMenuFocused: _, setShiftKey: b } = OL(), { clearArrowNav: L } = la(), { mapDatesArrToMap: j, validateDate: I, isValidTime: C } = Cr(n), { defaultedTransitions: B, defaultedTextInput: U, defaultedInline: de, defaultedConfig: ae } = tt(n), { menuTransition: S, showTransition: V } = v1(B);
    at(() => {
      te(n.modelValue), Gt().then(() => {
        if (!de.value.enabled) {
          const pe = M(g.value);
          pe == null || pe.addEventListener("scroll", Y), window == null || window.addEventListener("resize", oe);
        }
      }), de.value.enabled && (l.value = !0), window == null || window.addEventListener("keyup", Me), window == null || window.addEventListener("keydown", ue);
    });
    const Z = N(() => j());
    $r(() => {
      if (!de.value.enabled) {
        const pe = M(g.value);
        pe == null || pe.removeEventListener("scroll", Y), window == null || window.removeEventListener("resize", oe);
      }
      window == null || window.removeEventListener("keyup", Me), window == null || window.removeEventListener("keydown", ue);
    });
    const re = gt(i, "all", n.presetDates), F = gt(i, "input");
    ot(
      [c, s],
      () => {
        te(c.value);
      },
      { deep: !0 }
    );
    const { openOnTop: A, menuStyle: $, xCorrect: R, setMenuPosition: J, getScrollableParent: M, shadowRender: k } = kE({
      menuRef: h,
      menuRefInner: m,
      inputRef: p,
      pickerWrapperRef: g,
      inline: de,
      emit: o,
      props: n,
      slots: i
    }), {
      inputValue: O,
      internalModelValue: E,
      parseExternalModelValue: te,
      emitModelValue: se,
      formatInputValue: T,
      checkBeforeEmit: x
    } = pE(o, n, f), ie = N(
      () => ({
        dp__main: !0,
        dp__theme_dark: n.dark,
        dp__theme_light: !n.dark,
        dp__flex_display: de.value.enabled,
        dp__flex_display_with_input: de.value.input
      })
    ), ce = N(() => n.dark ? "dp__theme_dark" : "dp__theme_light"), K = N(() => ({
      to: typeof n.teleport == "boolean" ? "body" : n.teleport,
      disabled: !n.teleport || de.value.enabled
    })), me = N(() => ({ class: "dp__outer_menu_wrap" })), he = N(() => de.value.enabled && (n.timePicker || n.monthPicker || n.yearPicker || n.quarterPicker)), Y = () => {
      l.value && (ae.value.closeOnScroll ? Mt() : J());
    }, oe = () => {
      l.value && J();
    }, Me = (pe) => {
      pe.key === "Tab" && !de.value.enabled && !n.teleport && ae.value.tabOutClosesMenu && (g.value.contains(document.activeElement) || Mt()), q.value = pe.shiftKey;
    }, ue = (pe) => {
      q.value = pe.shiftKey;
    }, Fe = () => {
      !n.disabled && !n.readonly && (k(aI, n), J(!1), l.value = !0, l.value && o("open"), l.value || Xr(), te(n.modelValue));
    }, ft = () => {
      var pe;
      O.value = "", Xr(), (pe = p.value) == null || pe.setParsedDate(null), o("update:model-value", null), o("update:model-timezone-value", null), o("cleared"), ae.value.closeOnClearValue && Mt();
    }, qr = () => {
      const pe = E.value;
      return !pe || !Array.isArray(pe) && I(pe) ? !0 : Array.isArray(pe) ? n.multiDates || pe.length === 2 && I(pe[0]) && I(pe[1]) ? !0 : n.partialRange && !n.timePicker ? I(pe[0]) : !1 : !1;
    }, Kt = () => {
      x() && qr() ? (se(), Mt()) : o("invalid-select", E.value);
    }, M1 = (pe) => {
      x1(), se(), ae.value.closeOnAutoApply && !pe && Mt();
    }, x1 = () => {
      p.value && U.value.enabled && p.value.setParsedDate(E.value);
    }, e9 = (pe = !1) => {
      n.autoApply && C(E.value) && qr() && (n.range && Array.isArray(E.value) ? (n.partialRange || E.value.length === 2) && M1(pe) : M1(pe));
    }, Xr = () => {
      U.value.enabled || (E.value = null);
    }, Mt = () => {
      de.value.enabled || (l.value && (l.value = !1, R.value = !1, _(!1), b(!1), L(), o("closed"), O.value && te(c.value)), Xr(), o("blur"));
    }, t9 = (pe, Ce, Se = !1) => {
      if (!pe) {
        E.value = null;
        return;
      }
      const xt = Array.isArray(pe) ? !pe.some((n9) => !I(n9)) : I(pe), Et = C(pe);
      xt && Et && (E.value = pe, Ce && (w.value = Se, Kt(), o("text-submit")));
    }, a9 = () => {
      n.autoApply && C(E.value) && se(), x1();
    }, b1 = () => l.value ? Mt() : Fe(), z = (pe) => {
      E.value = pe;
    }, le = () => {
      U.value.enabled && (f.value = !0, T()), o("focus");
    }, Le = () => {
      if (U.value.enabled && (f.value = !1, te(n.modelValue), w.value)) {
        const pe = NU(g.value, q.value);
        pe == null || pe.focus();
      }
      o("blur");
    }, De = (pe) => {
      m.value && m.value.updateMonthYear(0, {
        month: Gw(pe.month),
        year: Gw(pe.year)
      });
    }, Xe = (pe) => {
      te(pe ?? n.modelValue);
    }, Bt = (pe, Ce) => {
      var Se;
      (Se = m.value) == null || Se.switchView(pe, Ce);
    }, Qt = (pe) => ae.value.onClickOutside ? ae.value.onClickOutside(pe) : Mt();
    return qW(h, p, () => Qt(qr)), t({
      closeMenu: Mt,
      selectDate: Kt,
      clearValue: ft,
      openMenu: Fe,
      onScroll: Y,
      formatInputValue: T,
      // exposed for testing purposes
      updateInternalModelValue: z,
      // modify internal modelValue
      setMonthYear: De,
      parseModel: Xe,
      switchView: Bt,
      toggleMenu: b1
    }), (pe, Ce) => (d(), y("div", {
      ref_key: "pickerWrapperRef",
      ref: g,
      class: Pe(ie.value),
      "data-datepicker-instance": ""
    }, [
      be(wE, H({
        ref_key: "inputRef",
        ref: p,
        "input-value": u(O),
        "onUpdate:inputValue": Ce[0] || (Ce[0] = (Se) => C9(O) ? O.value = Se : null),
        "is-menu-open": l.value
      }, pe.$props, {
        onClear: ft,
        onOpen: Fe,
        onSetInputDate: t9,
        onSetEmptyDate: u(se),
        onSelectDate: Kt,
        onToggle: b1,
        onClose: Mt,
        onFocus: le,
        onBlur: Le,
        onRealBlur: Ce[1] || (Ce[1] = (Se) => f.value = !1)
      }), kt({ _: 2 }, [
        Ie(u(F), (Se, xt) => ({
          name: Se,
          fn: ke((Et) => [
            ee(pe.$slots, Se, P(X(Et)))
          ])
        }))
      ]), 1040, ["input-value", "is-menu-open", "onSetEmptyDate"]),
      be(QL, P(X(K.value)), {
        default: ke(() => [
          be(Rr, {
            name: u(S)(u(A)),
            css: u(V) && !u(de).enabled
          }, {
            default: ke(() => [
              l.value ? (d(), y("div", H({
                key: 0,
                ref_key: "dpWrapMenuRef",
                ref: h
              }, me.value, {
                class: { "dp--menu-wrapper": !u(de).enabled },
                style: u(de).enabled ? void 0 : u($)
              }), [
                be(aI, H({
                  ref_key: "dpMenuRef",
                  ref: m
                }, pe.$props, {
                  "internal-model-value": u(E),
                  "onUpdate:internalModelValue": Ce[2] || (Ce[2] = (Se) => C9(E) ? E.value = Se : null),
                  class: { [ce.value]: !0, "dp--menu-wrapper": pe.teleport },
                  "open-on-top": u(A),
                  "arr-map-values": Z.value,
                  "no-overlay-focus": he.value,
                  onClosePicker: Mt,
                  onSelectDate: Kt,
                  onAutoApply: e9,
                  onTimeUpdate: a9,
                  onFlowStep: Ce[3] || (Ce[3] = (Se) => pe.$emit("flow-step", Se)),
                  onUpdateMonthYear: Ce[4] || (Ce[4] = (Se) => pe.$emit("update-month-year", Se)),
                  onInvalidSelect: Ce[5] || (Ce[5] = (Se) => pe.$emit("invalid-select", u(E))),
                  onAutoApplyInvalid: Ce[6] || (Ce[6] = (Se) => pe.$emit("invalid-select", Se)),
                  onInvalidFixedRange: Ce[7] || (Ce[7] = (Se) => pe.$emit("invalid-fixed-range", Se)),
                  onRecalculatePosition: u(J),
                  onTooltipOpen: Ce[8] || (Ce[8] = (Se) => pe.$emit("tooltip-open", Se)),
                  onTooltipClose: Ce[9] || (Ce[9] = (Se) => pe.$emit("tooltip-close", Se)),
                  onTimePickerOpen: Ce[10] || (Ce[10] = (Se) => pe.$emit("time-picker-open", Se)),
                  onTimePickerClose: Ce[11] || (Ce[11] = (Se) => pe.$emit("time-picker-close", Se)),
                  onAmPmChange: Ce[12] || (Ce[12] = (Se) => pe.$emit("am-pm-change", Se)),
                  onRangeStart: Ce[13] || (Ce[13] = (Se) => pe.$emit("range-start", Se)),
                  onRangeEnd: Ce[14] || (Ce[14] = (Se) => pe.$emit("range-end", Se)),
                  onDateUpdate: Ce[15] || (Ce[15] = (Se) => pe.$emit("date-update", Se)),
                  onInvalidDate: Ce[16] || (Ce[16] = (Se) => pe.$emit("invalid-date", Se))
                }), kt({ _: 2 }, [
                  Ie(u(re), (Se, xt) => ({
                    name: Se,
                    fn: ke((Et) => [
                      ee(pe.$slots, Se, P(X({ ...Et })))
                    ])
                  }))
                ]), 1040, ["internal-model-value", "class", "open-on-top", "arr-map-values", "no-overlay-focus", "onRecalculatePosition"])
              ], 16)) : v("", !0)
            ]),
            _: 3
          }, 8, ["name", "css"])
        ]),
        _: 3
      }, 16)
    ], 2));
  }
}), Db = /* @__PURE__ */ (() => {
  const e = TW;
  return e.install = (t) => {
    t.component("Vue3DatePicker", e);
  }, e;
})(), DW = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  default: Db
}, Symbol.toStringTag, { value: "Module" }));
Object.entries(DW).forEach(([e, t]) => {
  e !== "default" && (Db[e] = t);
});
const LG = {
  __name: "Datepicker",
  props: {
    globalConfig: {
      type: Object
    },
    pt: {
      type: Object
    },
    modelValue: {
      type: [String, Number, Object]
    },
    langs: {
      type: Array
    },
    prefix: {
      type: [String, Boolean],
      default: !1
    },
    suffix: {
      type: [String, Boolean],
      default: !1
    },
    long: {
      type: Boolean,
      default: !1
    },
    lowercase: {
      type: Boolean,
      default: !1
    },
    nospace: {
      type: Boolean,
      default: !1
    },
    regex: {
      type: [String, Boolean],
      default: !1
    },
    disabled: {
      type: Boolean,
      default: !1
    },
    placeholder: {
      type: [String, Object, Boolean],
      default: !1
    },
    mode: {
      type: String,
      default: "edit"
    },
    label: {
      type: [String, Boolean],
      default: !1
    },
    labelInside: {
      type: Boolean,
      default: !1
    },
    labelLang: {
      type: [String, Boolean],
      default: !1
    },
    multiPosition: {
      type: [String, Boolean],
      default: !1,
      validator: (e) => [!1, "first", "middle", "last"].includes(e)
    },
    caption: {
      type: [String, Boolean],
      default: !1
    },
    size: {
      type: String,
      default: 11
    },
    padding: {
      type: String,
      default: "default"
    },
    rounded: {
      type: String,
      default: "full"
    },
    context: {
      type: String,
      validator: function(e) {
        return ["dark", "neutral", "light"].indexOf(e) !== -1;
      }
    },
    locale: {
      type: String,
      default: "en"
    },
    status: {
      type: [String, Boolean],
      default: !1
    },
    statusMessage: {
      type: [String, Boolean],
      default: !1
    },
    // how long to wait with emitting input event after typing has stopped
    debounce: {
      type: Number,
      default: 750
    },
    // saving state indicator - init | saving | saved | error
    saveState: {
      // manual
      type: [String, Boolean],
      default: !1
    },
    autoState: {
      // auto -> 'formSaveState' store necessary
      type: Boolean,
      default: !1
    },
    fullWidth: {
      type: Boolean,
      default: !1
    },
    VueDatePickerConfig: {
      type: Object,
      default: () => ({ inline: !0 })
    },
    lang: {
      type: String,
      default: "en"
    }
  },
  emits: [
    "update:modelValue",
    "keyup",
    "enter",
    "focus",
    "blur",
    "input-debounced",
    "mouseup"
  ],
  setup(e, { emit: t }) {
    const a = e, o = t, n = ia(a, "modelValue"), i = W(!1), l = N(() => a.labelInside && a.size >= 11 ? "inside" : "outside");
    N(() => a.placeholder && !n.value && !i.value);
    const c = ib.debounce(function(f, g) {
      h(f);
    }, a.debounce);
    function s(f) {
      console.log("onInput", f), m(f), c(f);
    }
    function h(f) {
      o("input-debounced", f);
    }
    function m(f) {
      o("update:modelValue", f);
    }
    const { ep: p } = Te({ props: a, locals: { focused: i }, defaults: A$ });
    return (f, g) => (d(), y("div", P(X(u(p).root)), [
      a.label && l.value === "outside" ? (d(), y("span", P(H({ key: 0 }, u(p).labelOuter)), G(a.label), 17)) : v("", !0),
      be(u(Db), H({
        id: "auto",
        modelValue: n.value,
        "onUpdate:modelValue": g[0] || (g[0] = (w) => n.value = w)
      }, e.VueDatePickerConfig, {
        locale: e.lang,
        onDateUpdate: s
      }), null, 16, ["modelValue", "locale"])
    ], 16));
  }
}, _W = {
  composer: {
    props: {
      title: {
        default: "Heading",
        control: "input"
      },
      fullWidth: {
        default: !1,
        options: [!0, !1],
        control: "switch"
      }
    }
  },
  pt: {
    root: {
      _common: "fixed inset-0 z-50 flex items-center justify-center bg-black bg-opacity-50 backdrop-blur-sm",
      propsStateBased: {}
    },
    dialog: {
      _common: "min-w-64 max-h-[90vh] bg-white dark:bg-neutral-950 dark:text-neutral-200 dark:border dark:border-neutral-800 p-4",
      propsStateBased: {
        rounded: {
          none: "",
          "2xl": "rounded-2xl"
        },
        fullWidth: {
          true: "max-w-full",
          false: "max-w-[600px]"
        }
      }
    },
    title: {
      _common: "text-2xl font-bold",
      propsStateBased: {}
    },
    body: {
      _common: "",
      propsStateBased: {}
    }
  }
}, BW = { class: "mb-4 flex flex-row items-center justify-between" }, SG = {
  __name: "Dialog",
  props: {
    globalConfig: {
      type: Object
    },
    pt: {
      type: Object
    },
    rounded: {
      type: String,
      default: "2xl"
    },
    fullWidth: {
      type: Boolean,
      default: !1
    },
    title: {
      type: [Boolean, String],
      default: !1
    },
    closeButton: {
      type: Boolean,
      default: !0
    }
  },
  emits: ["close", "outerClick"],
  setup(e, { emit: t }) {
    const a = e, o = t, { ep: n } = Te({ props: a, locals: {}, defaults: _W }), i = W(null);
    function l(c) {
      i.value.contains(c.target) || o("outerClick");
    }
    return at(async () => {
      console.log("mounted"), setTimeout(() => {
        window.addEventListener("click", l);
      }, 100);
    }), $r(() => {
      window.removeEventListener("click", l);
    }), (c, s) => (d(), y("div", P(X(u(n).root)), [
      D("div", H({
        ref_key: "elDialog",
        ref: i
      }, u(n).dialog), [
        ee(c.$slots, "default", {}, () => [
          c.$slots.title || e.title || e.closeButton ? ee(c.$slots, "header", { key: 0 }, () => [
            D("div", BW, [
              ee(c.$slots, "title", {}, () => [
                e.title ? (d(), y("h2", P(H({ key: 0 }, u(n).title)), G(e.title), 17)) : v("", !0)
              ]),
              e.closeButton ? (d(), Q(bt, {
                key: 0,
                class: "shrink-0",
                icon: "X",
                iconStrokeWidth: 3,
                label: "lala",
                circle: "",
                variant: "secondary",
                kind: "solid",
                size: 8,
                onAction: s[0] || (s[0] = (h) => o("close"))
              })) : v("", !0)
            ])
          ]) : v("", !0),
          ee(c.$slots, "body", {}, () => [
            D("div", P(X(u(n).body)), "lalala", 16)
          ])
        ])
      ], 16)
    ], 16));
  }
}, zW = {
  composer: {
    compositions: [
      { id: "default", name: "default" },
      { id: "empty", name: "empty" },
      { id: "loading", name: "loading" }
    ],
    props: {
      items: {
        default: [
          {
            title: "Omakase & Night Skies: Dinner and Helicopter Tour",
            description: "Elevate your sushi experience—literally and figuratively—with a helicopter ride over Dubai followed by a 7-course Omakase dinner at the Burj Al Arab.",
            image: {
              src: "https://picsum.photos/800/800?random=1",
              aspect: "portrait",
              fit: "cover"
            },
            price: "6,500",
            pricePrefix: "AED",
            priceSuffix: ""
          },
          {
            title: "Meet & greet sushi master",
            description: "Have a chat with our sushi god",
            image: {
              src: "https://picsum.photos/800/600?random=2",
              aspect: "portrait",
              fit: "cover"
            },
            price: "2,500",
            pricePrefix: "AED",
            priceSuffix: ""
          },
          {
            title: "Private course",
            description: "You are the chef",
            image: {
              src: "https://picsum.photos/800/800?random=3",
              aspect: "portrait",
              fit: "cover"
            },
            price: "5,000",
            pricePrefix: "AED",
            priceSuffix: ""
          },
          {
            title: "Monetary",
            description: "You choose the value!",
            image: {
              src: "https://picsum.photos/1200/800?random=4",
              aspect: "portrait",
              fit: "cover"
            },
            price: "500 - 10,000",
            pricePrefix: "AED",
            priceSuffix: ""
          },
          {
            title: "2 week intensive course with sushi master in our beach restaurant",
            description: "Learn the art of sushi making in our beach restaurant. You will be taught by our sushi master and will be able to enjoy your creations afterwards.",
            image: {
              src: "https://picsum.photos/800/400?random=5",
              aspect: "portrait",
              fit: "cover"
            },
            price: "50,000",
            pricePrefix: "AED",
            priceSuffix: ""
          },
          {
            title: "Private course for 2",
            description: "Don't want to share your sushi with strangers? We get it.",
            image: {
              src: "https://picsum.photos/800/400?random=6",
              aspect: "portrait",
              fit: "cover"
            },
            price: "8,000",
            pricePrefix: "AED",
            priceSuffix: ""
          },
          {
            title: "Omakase & Night Skies: Dinner and Helicopter Tour",
            description: "",
            image: {
              src: "https://picsum.photos/800/1200?random=7",
              aspect: "portrait",
              fit: "cover"
            },
            price: "6,500",
            pricePrefix: "AED",
            priceSuffix: ""
          },
          {
            title: "Omakase & Night Skies: Dinner and Helicopter Tour",
            description: "",
            image: {
              src: "https://picsum.photos/800/500?random=8",
              aspect: "portrait",
              fit: "cover"
            },
            price: "6,500",
            pricePrefix: "AED",
            priceSuffix: ""
          },
          {
            title: "Omakase & Night Skies: Dinner and Helicopter Tour",
            description: "",
            image: {
              src: "https://picsum.photos/500/800?random=9",
              aspect: "portrait",
              fit: "cover"
            },
            price: "6,500",
            pricePrefix: "AED",
            priceSuffix: ""
          }
        ],
        control: "input"
      },
      productItem: {
        rounded: {
          default: !1,
          options: [!1, !0],
          control: "switch"
        },
        frame: {
          default: !1,
          options: [!1, !0],
          control: "switch"
        },
        image: {
          aspect: {
            default: "square",
            options: [
              "auto",
              "square",
              "1/1",
              "landscape",
              "16/9",
              "4/3",
              "3/2",
              "2/1",
              "portrait",
              "9/16",
              "3/4",
              "2/3",
              "1/2"
            ],
            control: "select"
          },
          fit: {
            default: "cover",
            options: ["none", "cover", "contain"],
            control: "select"
          }
        }
      },
      layout: {
        default: "grid",
        options: ["grid", "masonry", "list"],
        control: "select"
      }
    }
  },
  pt: {
    root: {
      _common: "@container w-full",
      propsStateBased: {}
    },
    wrap: {
      _common: "",
      propsStateBased: {
        layout: {
          grid: "grid grid-cols-2 @2xl:grid-cols-3 @4xl:grid-cols-4 gap-2 sm:gap-4",
          masonry: "columns-2 @2xl:columns-3 @4xl:columns-4 space-y-4",
          list: "flex flex-col gap-4 items-center"
        }
      }
    },
    productItem: {
      propsStateBased: {
        layout: {
          grid: "",
          masonry: "",
          list: { layout: "horizontal" }
        }
      }
    }
  }
}, HW = {
  composer: {
    props: {
      title: {
        default: `Omakase & Night Skies:
Dinner and Helicopter Tour`,
        control: "input"
      },
      description: {
        default: "Elevate your sushi experience—literally and figuratively—with a helicopter ride over Dubai followed by a 7-course Omakase dinner at the Burj Al Arab.",
        control: "input"
      },
      image: {
        default: {
          src: "https://picsum.photos/800/800",
          aspect: "square",
          fit: "cover"
        },
        control: "input"
      },
      price: {
        default: "100",
        control: "input"
      },
      pricePrefix: {
        default: "AED",
        control: "input"
      },
      priceSuffix: {
        default: "",
        control: "input"
      },
      rounded: {
        default: !1,
        options: [!1, !0],
        control: "switch"
      },
      frame: {
        default: !1,
        options: [!1, !0],
        control: "switch"
      },
      layout: {
        default: "vertical",
        options: ["vertical", "horizontal"],
        control: "select"
      }
    }
  },
  pt: {
    root: {
      _common: "group flex w-full cursor-pointer overflow-hidden bg-white dark:bg-neutral-900 p-0 transition-all duration-700 ease-in-out",
      propsStateBased: {
        frame: {
          true: {
            _common: "border border-neutral-100 hover:border-neutral-200 dark:border-neutral-800",
            rounded: {
              true: "rounded-2xl",
              false: "rounded-none"
            }
          }
        },
        layout: {
          vertical: "flex-col max-w-sm gap-0",
          horizontal: "flex-row-reverse min-h-40 max-h-52 max-w-xl gap-2"
        }
      }
    },
    imageWrap: {
      _common: "overflow-hidden shrink-0",
      propsStateBased: {
        layout: {
          vertical: "w-full",
          horizontal: "w-44 h-full"
        },
        rounded: {
          true: {
            frame: {
              true: "",
              false: "rounded-2xl"
            }
          },
          false: "rounded-none"
        }
      }
    },
    image: {
      _common: "shrink-0 group-hover:scale-105 group-hover:opacity-90 transition-all duration-700 ease-in-out block",
      propsStateBased: {
        layout: {
          vertical: {
            classImg: "w-full"
          },
          horizontal: {
            classImg: "w-44 h-full"
          }
        }
      }
    },
    content: {
      _common: "mt-0 flex grow flex-col justify-between",
      propsStateBased: {
        frame: {
          true: "p-3",
          false: "py-3"
        }
      }
    },
    title: {
      _common: "whitespace-pre-wrap text-lg font-bold font-heading leading-6 text-neutral-800 dark:text-neutral-100 group-hover:underline"
    },
    description: {
      _common: "mt-1 mb-2 line-clamp-2 overflow-hidden overflow-ellipsis text-sm text-neutral-400 font-body"
    },
    priceContainer: {
      _common: "mt-1 flex flex-row items-baseline font-body",
      propsStateBased: {
        layout: {
          vertical: "justify-start",
          horizontal: "justify-start"
        }
      }
    },
    priceWrap: {
      _common: "bg-neutral-100 dark:bg-neutral-800 px-1.5 py-0.5",
      propsStateBased: {
        rounded: {
          true: "rounded-md",
          false: "rounded-none"
        }
      }
    },
    pricePrefix: {
      _common: "mr-1 text-xs text-neutral-400 dark:text-neutral-500"
    },
    price: {
      _common: "text-lg text-neutral-500 dark:text-neutral-300"
    },
    priceSuffix: {
      _common: "mx-1 text-xs text-neutral-400 dark:text-neutral-500"
    }
  }
}, jW = {
  composer: {
    props: {
      src: {
        default: "https://picsum.photos/4000/3000",
        control: "input"
      },
      aspect: {
        default: "auto",
        options: ["auto", "square", "16/9", "4/3", "3/2", "2/1", "1/1", "portrait", "landscape"],
        control: "select"
      },
      fit: {
        default: "cover",
        options: ["none", "cover", "contain"],
        control: "select"
      }
    }
  },
  pt: {
    picture: {
      _common: "block",
      propsStateBased: {
        aspect: {
          auto: "aspect-auto",
          square: "aspect-square",
          "16/9": "aspect-[16/9]",
          "9/16": "aspect-[9/16]",
          "4/3": "aspect-[4/3]",
          "3/4": "aspect-[3/4]",
          "3/2": "aspect-[3/2]",
          "2/3": "aspect-[2/3]",
          "2/1": "aspect-[2/1]",
          "1/2": "aspect-[1/2]",
          "1/1": "aspect-[1/1]",
          portrait: "aspect-[3/4]",
          landscape: "aspect-[4/3]"
        },
        fit: {
          // none: "object-none",
          cover: "object-cover w-full h-full",
          contain: "object-contain"
        }
      }
    },
    img: {
      // _common: "block w-full h-full",
      _common: "block",
      propsStateBased: {
        aspect: {
          auto: "aspect-auto",
          square: "aspect-square",
          "16/9": "aspect-[16/9]",
          "9/16": "aspect-[9/16]",
          "4/3": "aspect-[4/3]",
          "3/4": "aspect-[3/4]",
          "3/2": "aspect-[3/2]",
          "2/3": "aspect-[2/3]",
          "2/1": "aspect-[2/1]",
          "1/2": "aspect-[1/2]",
          "1/1": "aspect-[1/1]",
          portrait: "aspect-[3/4]",
          landscape: "aspect-[4/3]"
        },
        fit: {
          // none: "object-none",
          cover: "object-cover w-full h-full",
          // cover: "w-full h-full"
          contain: "object-contain"
        }
      }
    }
  }
}, VW = ["srcset", "type", "media"], OW = ["src"], Ar = {
  __name: "Image",
  props: {
    src: {
      type: String,
      required: !0
    },
    sources: {
      type: Array
    },
    aspect: {
      type: String,
      default: "auto"
    },
    fit: {
      type: String,
      default: "none"
    },
    classImg: {
      type: String
    }
  },
  setup(e) {
    const t = e, { ep: a } = Te({ props: t, defaults: jW });
    return (o, n) => (d(), y("picture", P(X(u(a).picture)), [
      (d(!0), y(ge, null, Ie(e.sources, (i, l) => (d(), y("source", {
        key: l,
        srcset: i.srcset,
        type: i.type,
        media: i.media
      }, null, 8, VW))), 128)),
      D("img", H(u(a).img, {
        class: e.classImg,
        src: e.src
      }), null, 16, OW)
    ], 16));
  }
}, $W = {
  __name: "ProductItem",
  props: {
    image: {
      type: Object,
      required: !0
    },
    title: {
      type: String,
      required: !0
    },
    description: {
      type: String
    },
    price: {
      type: String
    },
    pricePrefix: {
      type: String
    },
    priceSuffix: {
      type: String
    },
    rounded: {
      type: Boolean,
      default: !1
    },
    frame: {
      type: Boolean,
      default: !1
    },
    layout: {
      type: String,
      default: "vertical"
      // vertical, horizontal
    },
    link: {
      type: Object
    }
  },
  emits: ["click"],
  setup(e, { emit: t }) {
    const a = e, o = t, { ep: n } = Te({ props: a, defaults: HW });
    function i() {
      o("click");
    }
    return (l, c) => {
      var h;
      const s = Dx("RouterLink");
      return d(), Q(s, H({
        to: ((h = e.link) == null ? void 0 : h.route) || {}
      }, u(n).root, { onClick: i }), {
        default: ke(() => [
          D("div", P(X(u(n).imageWrap)), [
            be(Ar, P(X({ ...e.image, ...u(n).image })), null, 16)
          ], 16),
          D("div", P(X(u(n).content)), [
            D("div", null, [
              D("h3", P(X(u(n).title)), G(e.title), 17),
              e.description ? (d(), y("p", P(H({ key: 0 }, u(n).description)), G(e.description), 17)) : v("", !0)
            ]),
            e.price || e.pricePrefix || e.priceSuffix ? (d(), y("div", P(H({ key: 0 }, u(n).priceContainer)), [
              D("div", P(X(u(n).priceWrap)), [
                e.pricePrefix ? (d(), y("span", P(H({ key: 0 }, u(n).pricePrefix)), G(e.pricePrefix), 17)) : v("", !0),
                e.price ? (d(), y("span", P(H({ key: 1 }, u(n).price)), G(e.price), 17)) : v("", !0),
                e.priceSuffix ? (d(), y("span", P(H({ key: 2 }, u(n).priceSuffix)), G(e.priceSuffix), 17)) : v("", !0)
              ], 16)
            ], 16)) : v("", !0)
          ], 16)
        ]),
        _: 1
      }, 16, ["to"]);
    };
  }
};
var RW = rb, nI = Ft;
function WL(e, t, a, o, n, i) {
  return nI(e) && nI(t) && (i.set(t, e), RW(e, t, void 0, WL, i), i.delete(t)), e;
}
var FW = WL, UW = rb, EW = BI, WW = EW(function(e, t, a, o) {
  UW(e, t, a, o);
}), NW = WW, ZW = DI, YW = _I, GW = FW, XW = NW, KW = YW(function(e) {
  return e.push(void 0, GW), ZW(XW, void 0, e);
}), QW = KW;
const JW = /* @__PURE__ */ _x(QW), eN = {
  composer: {
    props: {
      lucide: {
        default: "Loader2",
        control: "input"
      },
      lucideSize: {
        default: 24,
        control: "input"
      },
      lucideColor: {
        default: "currentColor",
        control: "input"
      },
      lucideStrokeWidth: {
        default: 2.5,
        control: "input"
      },
      center: {
        default: !1,
        options: [!1, !0],
        control: "switch"
      }
    }
  },
  pt: {
    root: {
      _common: "",
      propsStateBased: {
        center: {
          true: "flex flex-center w-full"
        }
      }
    }
  }
}, _b = {
  __name: "Progress",
  props: {
    lucide: {
      type: String,
      default: "Loader2"
    },
    lucideSize: {
      type: Number,
      default: 24
    },
    lucideColor: {
      type: String,
      default: "currentColor"
    },
    lucideStrokeWidth: {
      type: Number,
      default: 2.5
    },
    center: {
      type: Boolean,
      default: !1
    }
  },
  setup(e) {
    const t = e, { ep: a } = Te({ props: t, defaults: eN });
    return (o, n) => (d(), y("div", P(X(u(a).root)), [
      be(We, H(t, { spin: "" }), null, 16)
    ], 16));
  }
}, tN = {
  key: 0,
  class: ""
}, aN = {
  key: 1,
  class: "w-full text-center"
}, nN = { class: "" }, oN = {
  __name: "ProductItemList",
  props: {
    items: {
      type: Array,
      required: !0
    },
    productItem: {
      type: Object
    },
    layout: {
      type: String,
      default: "grid"
      // grid, masonry, list
    },
    noItemsLabel: {
      type: String,
      default: "no items"
    },
    loading: {
      type: Boolean,
      default: !1
    }
  },
  emits: "productItemClick",
  setup(e, { emit: t }) {
    const a = e, o = t, { ep: n } = Te({ props: a, defaults: zW });
    function i(c) {
      return Fx({}, c, a.productItem, n.value.productItem);
    }
    function l(c) {
      o("productItemClick", c);
    }
    return (c, s) => (d(), y("div", P(X(u(n).root)), [
      e.loading ? (d(), y("div", tN, [
        be(_b, { center: "" })
      ])) : v("", !0),
      !e.loading && e.items.length === 0 ? (d(), y("div", aN, [
        D("span", nN, G(e.noItemsLabel), 1)
      ])) : v("", !0),
      e.items.length > 0 ? (d(), y("div", P(H({ key: 2 }, u(n).wrap)), [
        (d(!0), y(ge, null, Ie(e.items, (h) => (d(), Q($W, H({
          key: h.id
        }, i(h), {
          onClick: (m) => l(h)
        }), null, 16, ["onClick"]))), 128))
      ], 16)) : v("", !0)
    ], 16));
  }
}, rN = {
  composer: {
    props: {
      label: {
        default: "label",
        control: "input"
      },
      modelValue: {
        default: "option-2",
        control: "input"
      },
      options: {
        default: [
          {
            label: "option 1",
            labelSecondary: "label 2",
            sublabel: "sublabel 1",
            value: "option-1"
          },
          {
            label: "option 2",
            sublabel: "sublabel 2",
            value: "option-2"
          },
          {
            label: "option 3",
            sublabel: "sublabel 3",
            value: "option-3",
            disabled: !0
          },
          {
            label: "option 4",
            value: "option-4"
          }
        ],
        control: "input"
      },
      caption: {
        default: "caption with additional information",
        control: "input"
      },
      // status: {
      //   default: false, //"error",
      //   control: "select",
      //   options: [false, "success", "error", "progress"],
      // },
      size: {
        default: 11,
        control: "select",
        options: [24, 20, 16, 14, 12, 11, 10, 9, 8]
      },
      // statusMessage: {
      //   default: "status message",
      //   control: "input",
      // },
      disabled: {
        default: !1,
        control: "switch"
      },
      layout: {
        default: "vertical",
        control: "select",
        options: ["horizontal", "vertical", "grid"]
      },
      fullWidth: {
        default: !1,
        options: [!0, !1],
        control: "switch"
      }
    }
  },
  pt: {
    options: {
      _common: "gap-2",
      propsStateBased: {
        layout: {
          horizontal: "flex flex-row",
          vertical: "flex flex-col",
          grid: "grid grid-cols-2 gap-2"
        },
        fullWidth: {
          true: "w-full",
          false: "min-w-[300px]"
        }
      }
    },
    option: {
      _common: "flex grow flex-row justify-between overflow-hidden transition-all duration-300 ease-in-out w-full",
      propsStateBased: {
        size: {
          24: "h-24 rounded-xl",
          20: "h-20 rounded-xl",
          16: "h-16 rounded-xl",
          14: "h-14 rounded-xl",
          12: "h-12 rounded-xl",
          11: "h-11 rounded-xl",
          // default
          10: "h-10 rounded-lg",
          9: "h-9 rounded-lg",
          8: "h-8 rounded-lg"
        },
        filled: {
          true: "bg-neutral-100",
          false: "outline outline-neutral-300 dark:outline-neutral-800"
        },
        disabled: {
          true: "dark:bg-neutral-800 cursor-not-allowed",
          false: {
            _common: "cursor-pointer",
            filled: {
              true: "hover:bg-neutral-200",
              false: "hover:outline-neutral-400"
            }
          }
        }
      }
    },
    optionSelected: {
      _common: "flex grow flex-row justify-between overflow-hidden transition-all duration-300 ease-in-out w-full",
      propsStateBased: {
        size: {
          24: "h-24 rounded-xl",
          20: "h-20 rounded-xl",
          16: "h-16 rounded-xl",
          14: "h-14 rounded-xl",
          12: "h-12 rounded-xl",
          11: "h-11 rounded-xl",
          // default
          10: "h-10 rounded-lg",
          9: "h-9 rounded-lg",
          8: "h-8 rounded-lg"
        },
        filled: {
          true: "outline outline-2 outline-neutral-500 bg-neutral-100 dark:bg-neutral-800 dark:outline-neutral-400",
          false: "outline outline-2 outline-neutral-500 dark:outline-neutral-200"
        }
      }
    },
    optionDisabled: {
      _common: "flex grow flex-row justify-between overflow-hidden transition-all duration-300 ease-in-out w-full",
      propsStateBased: {
        size: {
          24: "h-24 rounded-xl",
          20: "h-20 rounded-xl",
          16: "h-16 rounded-xl",
          14: "h-14 rounded-xl",
          12: "h-12 rounded-xl",
          11: "h-11 rounded-xl",
          // default
          10: "h-10 rounded-lg",
          9: "h-9 rounded-lg",
          8: "h-8 rounded-lg"
        },
        filled: {
          true: "bg-neutral-50",
          false: "outline outline-2 outline-neutral-50"
        }
      }
    },
    optionLabels: {
      _common: "flex flex-col px-4 gap-0 justify-center",
      propsStateBased: {
        layout: {
          horizontal: "",
          vertical: "",
          grid: "w-full items-center"
        }
      }
    },
    optionLabel: {
      _common: "font-bold",
      propsStateBased: {
        disabled: {
          true: "text-neutral-200 dark:text-neutral-600",
          false: "text-neutral-900 dark:text-neutral-100"
        }
      }
    },
    optionLabelSecondary: {
      _common: "font-bold",
      propsStateBased: {
        disabled: {
          true: "text-neutral-200",
          false: "text-neutral-900"
        }
      }
    },
    optionSublabel: {
      _common: "leading-3 text-xs",
      propsStateBased: {
        disabled: {
          true: "text-neutral-200",
          false: "text-neutral-400"
        }
      }
    },
    labelOuter: {
      _common: "inline-block text-base font-bold text-neutral-600 dark:text-neutral-500 font-element"
    },
    innerElementsLeft: {
      _common: "flex flex-row",
      propsStateBased: {
        size: {
          14: "ml-1.5 gap-1.5 py-1.5",
          12: "ml-1.5 gap-1.5 py-1.5",
          11: "ml-1.5 gap-1.5 py-1.5",
          10: "ml-1 gap-1 py-1",
          9: "ml-1 gap-1 py-1",
          8: "ml-1 gap-1 py-1"
        }
      }
    },
    innerElementsRight: {
      _common: "flex flex-row h-full items-center px-4",
      propsStateBased: {}
    },
    modeViewValue: {
      _common: "text-neutral-900 dark:text-neutral-100"
    }
  }
}, iN = {
  key: 0,
  class: "flex flex-col"
}, lN = {
  key: 0,
  class: "mb-1 flex flex-row items-end justify-between"
}, cN = ["onClick"], dN = {
  key: 1,
  class: ""
}, sN = { class: "mt-1 text-sm text-neutral-400" }, uN = {
  key: 1,
  class: "flex flex-col"
}, CG = {
  __name: "Radio",
  props: {
    globalConfig: {
      type: Object
    },
    pt: {
      type: Object
    },
    modelValue: {
      type: String
    },
    options: {
      type: Array,
      default: () => []
    },
    disabled: {
      type: Boolean,
      default: !1
    },
    mode: {
      type: String,
      default: "edit"
    },
    label: {
      type: [String, Boolean],
      default: !1
    },
    caption: {
      type: [String, Boolean],
      default: !1
    },
    size: {
      type: String,
      default: 11
    },
    rounded: {
      type: String,
      default: "full"
    },
    context: {
      type: String,
      validator: function(e) {
        return ["dark", "neutral", "light"].indexOf(e) !== -1;
      }
    },
    filled: {
      type: Boolean,
      default: !1
    },
    collapsible: {
      type: Boolean,
      default: !1
    },
    layout: {
      type: String,
      default: "vertical"
      // horizontal, vertical, grid
    },
    fullWidth: {
      type: Boolean,
      default: !1
    }
  },
  emits: ["update:modelValue"],
  setup(e, { emit: t }) {
    const a = e, o = t, { ep: n } = Te({ props: a, locals: {}, defaults: rN }), i = N(() => {
      const c = a.options.find((s) => s.value === a.modelValue);
      return c ? c.label : "";
    });
    function l(c) {
      a.disabled || o("update:modelValue", c.value);
    }
    return (c, s) => (d(), y("div", P(X(u(n).root)), [
      a.mode == "edit" ? (d(), y("div", iN, [
        a.label ? (d(), y("div", lN, [
          a.label ? (d(), y("span", P(H({ key: 0 }, u(n).labelOuter)), G(a.label), 17)) : v("", !0)
        ])) : v("", !0),
        D("div", P(X(u(n).options)), [
          (d(!0), y(ge, null, Ie(e.options, (h, m) => (d(), y("div", {
            class: "flex",
            key: h.value
          }, [
            D("div", H({
              ...h.value !== e.modelValue && { ...u(n).option },
              ...h.value === e.modelValue && { ...u(n).optionSelected },
              ...h.disabled && { ...u(n).optionDisabled }
            }, {
              onClick: (p) => l(h)
            }), [
              D("div", P(X(u(n).optionLabels)), [
                D("span", P(X(u(n).optionLabel)), G(h.label), 17),
                h.sublabel ? (d(), y("span", P(H({ key: 0 }, u(n).optionSublabel)), G(h.sublabel), 17)) : v("", !0)
              ], 16),
              h.labelSecondary && e.layout !== "grid" ? (d(), y("div", P(H({ key: 0 }, u(n).innerElementsRight)), [
                D("span", P(X(u(n).optionLabelSecondary)), G(h.labelSecondary), 17)
              ], 16)) : v("", !0)
            ], 16, cN)
          ]))), 128))
        ], 16),
        e.caption || c.$slots.caption ? (d(), y("div", dN, [
          ee(c.$slots, "caption", {}, () => [
            D("p", sN, G(e.caption), 1)
          ])
        ])) : v("", !0)
      ])) : v("", !0),
      a.mode == "view" ? (d(), y("div", uN, [
        a.label ? (d(), y("span", P(H({ key: 0 }, u(n).inputLabel)), G(a.label), 17)) : v("", !0),
        D("p", P(X(u(n).modeViewValue)), G(i.value), 17)
      ])) : v("", !0)
    ], 16));
  }
}, hN = {
  composer: {
    props: {
      modelValue: {
        default: !1,
        control: "switch"
      },
      size: {
        default: 6,
        //11,
        control: "select",
        options: [14, 12, 11, 10, 9, 8, 7, 6]
      },
      rounded: {
        default: "full",
        options: ["full", "md"],
        control: "select"
      },
      disabled: {
        default: !1,
        control: "switch"
      },
      label: {
        default: "label",
        control: "input"
      },
      labelStart: {
        default: "label",
        control: "input"
      },
      labelEnd: {
        default: "label",
        control: "input"
      },
      sublabelStart: {
        default: "sublabel",
        control: "input"
      },
      sublabelEnd: {
        default: "sublabel",
        control: "input"
      },
      caption: {
        default: "caption with additional information",
        control: "input"
      }
    }
  },
  pt: {
    root: {},
    switchWrap: {
      _common: "flex flex-row items-center justify-start gap-4"
    },
    switch: {
      _common: "bg-neutral-200 dark:bg-neutral-800 cursor-pointer flex flex-row items-center relative",
      propsStateBased: {
        rounded: {
          full: {
            _common: "rounded-full",
            size: {
              14: "h-14 w-28",
              12: "h-12 w-[5.75rem]",
              11: "h-11 w-20",
              // default
              10: "h-10 w-[4.5rem]",
              9: "h-9 w-16",
              8: "h-8 w-14",
              7: "h-7 w-12",
              6: "h-6 w-10"
            }
          },
          md: {
            size: {
              14: "h-14 w-28 rounded-xl",
              12: "h-12 w-24 rounded-xl",
              11: "h-11 w-20 rounded-xl",
              // default
              10: "h-10 w-20 rounded-lg",
              9: "h-9 w-16 rounded-lg",
              8: "h-8 w-14 rounded-lg",
              7: "h-7 w-12 rounded-lg",
              6: "h-6 w-10 rounded-lg"
            }
          }
        }
      }
    },
    switchToggle: {
      _common: "absolute transition-all duration-300 ease-in-out",
      propsStateBased: {
        rounded: {
          full: {
            _common: "rounded-full",
            size: {
              14: "size-11",
              12: "size-9",
              11: "size-8",
              // default
              10: "size-[1.875rem]",
              9: "size-7",
              8: "size-6",
              7: "size-5",
              6: "size-4"
            }
          },
          md: {
            size: {
              14: "size-14",
              12: "size-12",
              11: "size-8",
              // default
              10: "size-10",
              9: "size-9",
              8: "size-6",
              7: "size-5",
              6: "size-4"
            }
          }
        },
        modelValue: {
          false: {
            _common: "bg-neutral-400 dark:bg-neutral-600",
            size: {
              14: "left-2",
              12: "left-2",
              11: "left-2",
              // default
              10: "left-1.5",
              9: "left-1",
              8: "left-1",
              7: "left-1",
              6: "left-1"
            }
          },
          true: {
            _common: "bg-neutral-800 dark:bg-neutral-100",
            size: {
              14: "left-[3.75rem]",
              12: "left-12",
              11: "left-10",
              // default
              10: "left-9",
              9: "left-8",
              8: "left-7",
              7: "left-6",
              6: "left-5"
            }
          }
        }
      }
    },
    labelOuter: {
      _common: "inline-block text-base font-bold text-neutral-600 dark:text-neutral-500 font-element"
    },
    labelStart: {
      _common: "inline-block text-base font-bold text-neutral-600 dark:text-neutral-500 font-element"
    },
    labelStartWrap: {
      _common: "flex flex-col gap-0"
    },
    labelEndWrap: {
      _common: "flex flex-col gap-0"
    },
    labelEnd: {
      _common: "inline-block text-base font-bold text-neutral-600 dark:text-neutral-500 font-element"
    },
    sublabelStart: {
      _common: "leading-3 text-sm text-neutral-500"
    },
    sublabelEnd: {
      _common: "leading-3 text-sm text-neutral-500"
    },
    modeViewValue: {
      _common: "text-neutral-900 dark:text-neutral-100"
    }
  }
}, pN = {
  key: 0,
  class: "flex flex-col"
}, yN = {
  key: 0,
  class: "mb-1 flex flex-row items-end justify-between"
}, kN = {
  key: 1,
  class: ""
}, fN = { class: "mt-1 text-sm text-neutral-400 dark:text-neutral-700" }, vN = {
  key: 1,
  class: "flex flex-col"
}, AG = {
  __name: "Switch",
  props: {
    globalConfig: {
      type: Object
    },
    pt: {
      type: Object
    },
    modelValue: {
      type: Boolean,
      default: !1
    },
    disabled: {
      type: Boolean,
      default: !1
    },
    mode: {
      type: String,
      default: "edit"
    },
    label: {
      type: [String, Boolean],
      default: !1
    },
    labelStart: {
      type: [String, Boolean],
      default: !1
    },
    labelEnd: {
      type: [String, Boolean],
      default: !1
    },
    sublabelStart: {
      type: [String, Boolean],
      default: !1
    },
    sublabelEnd: {
      type: [String, Boolean],
      default: !1
    },
    caption: {
      type: [String, Boolean],
      default: !1
    },
    size: {
      type: String,
      default: 11
    },
    rounded: {
      type: String,
      default: "full"
    },
    context: {
      type: String,
      validator: function(e) {
        return ["dark", "neutral", "light"].indexOf(e) !== -1;
      }
    }
  },
  emits: ["update:modelValue"],
  setup(e, { emit: t }) {
    const a = e, o = t, { ep: n } = Te({ props: a, locals: {}, defaults: hN });
    function i() {
      o("update:modelValue", !a.modelValue);
    }
    return (l, c) => (d(), y("div", P(X(u(n).root)), [
      a.mode == "edit" ? (d(), y("div", pN, [
        a.label ? (d(), y("div", yN, [
          a.label ? (d(), y("span", P(H({ key: 0 }, u(n).labelOuter)), G(a.label), 17)) : v("", !0)
        ])) : v("", !0),
        D("div", P(X(u(n).switchWrap)), [
          a.labelStart || a.sublabelStart ? (d(), y("div", P(H({ key: 0 }, u(n).labelStartWrap)), [
            a.labelStart ? (d(), y("span", P(H({ key: 0 }, u(n).labelStart)), G(a.labelStart), 17)) : v("", !0),
            a.sublabelStart ? (d(), y("span", P(H({ key: 1 }, u(n).sublabelStart)), G(a.sublabelStart), 17)) : v("", !0)
          ], 16)) : v("", !0),
          D("div", H(u(n).switch, { onClick: i }), [
            D("div", P(X(u(n).switchToggle)), null, 16)
          ], 16),
          a.labelEnd || a.sublabelEnd ? (d(), y("div", P(H({ key: 1 }, u(n).labelEndWrap)), [
            a.labelEnd ? (d(), y("span", P(H({ key: 0 }, u(n).labelEnd)), G(a.labelEnd), 17)) : v("", !0),
            a.sublabelEnd ? (d(), y("span", P(H({ key: 1 }, u(n).sublabelEnd)), G(a.sublabelEnd), 17)) : v("", !0)
          ], 16)) : v("", !0)
        ], 16),
        e.caption || l.$slots.caption ? (d(), y("div", kN, [
          ee(l.$slots, "caption", {}, () => [
            D("p", fN, G(e.caption), 1)
          ])
        ])) : v("", !0)
      ])) : v("", !0),
      a.mode == "view" ? (d(), y("div", vN, [
        a.label || a.labelEnd || a.labelStart ? (d(), y("span", P(H({ key: 0 }, u(n).inputLabel)), G(a.label || a.labelEnd || a.labelStart), 17)) : v("", !0),
        D("p", P(X(u(n).modeViewValue)), G(a.modelValue), 17)
      ])) : v("", !0)
    ], 16));
  }
}, mN = {
  composer: {
    props: {
      table: {
        control: "input",
        default: {
          head: [
            [
              { checkbox: !0 },
              { c: "id", align: "left" },
              { c: "status" },
              { c: "name" },
              { c: "age" },
              { c: "email" },
              { c: "phone" },
              { c: "street" },
              { c: "city" },
              { c: "country" },
              { c: "postal" },
              { c: "created" },
              { c: "updated" }
            ]
          ],
          body: [
            [
              { checkbox: !0, id: "a" },
              { c: "1" },
              { c: "success" },
              { c: "John Doe" },
              { c: "25" },
              { c: "johndoe@outlook.com" },
              { c: "1234567890" },
              { c: "123 Main St" },
              { c: "New York" },
              { c: "USA" },
              { c: "12345" },
              { c: "2022-01-01" },
              { c: "2022-01-01" }
            ],
            [
              { checkbox: !0, id: "b" },
              { c: "2" },
              { c: "success" },
              { c: "Jane Doe" },
              { c: "23" },
              { c: "janedoe@gmail.com" },
              { c: "1234567890" },
              { c: "456 Elm St" },
              { c: "Los Angeles" },
              { c: "USA" },
              { c: "67890" },
              { c: "2022-02-02" },
              { c: "2022-02-02" }
            ],
            [
              { checkbox: !0, id: "c" },
              { c: "3" },
              { c: "success" },
              { c: "Joe Doe" },
              { c: "30" },
              { c: "joedoe@yahoo.com" },
              { c: "1234567890" },
              { c: "789 Oak St" },
              { c: "Chicago" },
              { c: "USA" },
              { c: "54321" },
              { c: "2022-03-03" },
              { c: "2022-03-03" }
            ],
            [
              { checkbox: !0, id: "d" },
              { c: "4" },
              { c: "success" },
              { c: "Jill Doe" },
              { c: "28" },
              { c: "jilldoe@hotmail.com" },
              { c: "1234567890" },
              { c: "321 Pine St" },
              { c: "Houston" },
              { c: "USA" },
              { c: "09876" },
              { c: "2022-04-04" },
              { c: "2022-04-04" }
            ],
            [
              { checkbox: !0, id: "e" },
              { c: "5" },
              { c: "success" },
              { c: "Jack Doe" },
              { c: "35" },
              { c: "jackdoe@outlook.com" },
              { c: "1234567890" },
              { c: "654 Maple St" },
              { c: "Miami" },
              { c: "USA" },
              { c: "13579" },
              { c: "2022-05-05" },
              { c: "2022-05-05" }
            ]
          ],
          foot: [
            [
              { checkbox: !0 },
              { c: "5" },
              { c: "-" },
              { c: "-" },
              { c: "-" },
              { c: "-" },
              { c: "-" },
              { c: "-" },
              { c: "-" },
              { c: "-" },
              { c: "-" },
              { c: "-" },
              { c: "-" }
            ]
          ]
        }
      },
      columnsSticky: {
        control: "input",
        default: 3
      }
    }
  },
  pt: {
    root: {
      _common: "h-full flex flex-col gap-4",
      propsStateBased: {
        fullWidth: {
          true: "w-full",
          false: "w-auto"
        }
      }
    },
    table: {
      _common: "table-fixed",
      propsStateBased: {
        fullWidth: {
          true: "min-w-full",
          false: ""
        }
      }
    }
  }
}, gN = { class: "hover:xbg-neutral-100 dark:xhover:bg-neutral-950 transition-all duration-200 ease-in-out first:rounded-l-xl last:rounded-r-xl" }, MN = ["onClick"], xN = { key: 2 }, bN = { key: 3 }, wN = { key: 4 }, IN = { key: 5 }, LN = { key: 6 }, SN = {
  __name: "TableRow",
  props: {
    table: Object,
    tc: Object,
    row: Array,
    columnsSticky: Number,
    styles: Object,
    checkedRows: Object,
    hoveredRow: Number,
    onClick: Function,
    elTableWrap: Object,
    tbodyTrIndex: Number
  },
  emits: ["click", "checkedRow"],
  setup(e, { emit: t }) {
    const a = t;
    return (o, n) => {
      const i = Dx("RouterLink");
      return d(), y("tr", gN, [
        (d(!0), y(ge, null, Ie(e.row, (l, c) => (d(), y("td", {
          class: Pe([
            e.tc.body.td,
            { "text-neutral-300 dark:text-neutral-800": l.ignored },
            { "text-neutral-600 dark:text-neutral-300": !l.ignored },
            { "w-0 pr-0": l.warning },
            { "w-0 pr-0": l.checkbox },
            { "font-mono": l.mono },
            { "font-bold": l.bold },
            `text-${e.table.head[0][c].align ? e.table.head[0][c].align : "right"}`,
            { "bg-neutral-50 dark:bg-neutral-950": c < e.columnsSticky }
          ]),
          style: yt(e.styles[c]),
          key: c
        }, [
          D("span", {
            class: Pe([
              {
                "hover:xunderline cursor-pointer rounded-lg px-2 py-1 transition-all duration-300 ease-in-out hover:bg-neutral-150 dark:hover:bg-neutral-800 dark:hover:text-neutral-50": l.routerLink || l.link
              },
              { "cursor-copy hover:text-neutral-300": l.clickToCopy }
            ]),
            onClick: (s) => a("click", l)
          }, [
            l.routerLink ? (d(), Q(i, {
              key: 0,
              class: Pe({ "whitespace-pre-wrap ": l.wrap }),
              to: l.routerLink,
              replace: l.routerLink.replace || !1
            }, {
              default: ke(() => [
                wt(G(l.c), 1)
              ]),
              _: 2
            }, 1032, ["class", "to", "replace"])) : v("", !0),
            l.checkbox ? (d(), Q(HI, {
              key: 1,
              modelValue: e.checkedRows[l.id],
              "onUpdate:modelValue": [(s) => e.checkedRows[l.id] = s, (s) => a("checkedRow", { id: l.id, index: e.tbodyTrIndex, value: s })],
              rounded: "md",
              size: 5
            }, null, 8, ["modelValue", "onUpdate:modelValue"])) : v("", !0),
            l.truncate ? (d(), y("span", xN, G(o.truncateAddress(l.c)), 1)) : l.warning === !0 ? (d(), y("span", bN, "⚠️")) : l.warning === !1 ? (d(), y("span", wN)) : l.c === !1 ? (d(), y("span", IN, "false")) : !l.c && l.c !== 0 && !l.component && !l.checkbox ? (d(), y("span", LN)) : l.routerLink ? v("", !0) : (d(), y("span", {
              key: 7,
              class: Pe({ "whitespace-pre-wrap": l.wrap })
            }, G(l.c), 3)),
            l.component ? (d(), Q(mt(l.component), H({ key: 8 }, l.args, S9(l.listeners)), null, 16)) : v("", !0)
          ], 10, MN)
        ], 6))), 128))
      ]);
    };
  }
}, CN = {
  key: 0,
  class: "mb-4"
}, AN = {
  key: 0,
  class: ""
}, PN = ["onClick"], qN = { class: "" }, TN = { key: 1 }, DN = ["colspan"], _N = { key: 2 }, BN = ["colspan"], zN = ["colspan"], HN = { key: 4 }, jN = { key: 0 }, VN = {
  key: 1,
  class: ""
}, ON = {
  key: 1,
  class: "fixed right-0 top-0 z-50 border border-red-500 bg-white dark:bg-neutral-950"
}, w9 = 49, PG = {
  __name: "Table",
  props: {
    modelValue: {
      type: Array,
      default: () => []
    },
    table: Object,
    loading: {
      type: Boolean,
      default: !1
    },
    router: {
      type: Object
    },
    // stick first N columns to left
    columnsSticky: {
      type: Number,
      default: 0
    },
    // necessary when using columns sticky
    fullWidth: {
      type: Boolean,
      default: !1
    },
    orderByColumnInitial: {
      type: Number,
      default: null
    },
    orderDirectionInitial: {
      type: String,
      default: "asc"
    },
    toolbar: {
      type: Boolean,
      default: !1
    },
    toolbarSearch: {
      type: Boolean,
      default: !1
    },
    debug: {
      type: Boolean,
      default: !1
    }
  },
  emits: ["update:modelValue"],
  setup(e, { emit: t }) {
    const a = e, o = t, n = W(0), i = W(0), l = W(0), c = W(0), s = W([]), h = W(!1), m = W(0), p = W(null), f = W(null), g = W(null), w = W(!1), q = W(null), _ = W(null), b = W({}), L = N(
      () => Object.keys(b.value).filter((T) => b.value[T] === !0)
    ), j = W(null), I = W(!1), C = W(a.orderByColumnInitial), B = W(a.orderDirectionInitial), U = W(null), de = W({
      head: {
        th: "px-2 py-2 text-xs font-medium text-neutral-500 dark:text-neutral-500 uppercase tracking-wider"
      },
      body: {
        td: "px-2 py-3 whitespace-nowrap text-sm"
      },
      foot: {
        td: "px-2 py-2 font-bold whitespace-nowrap text-sm"
      }
    });
    function ae(T) {
      T.link && window.open(T.link.url, T.link.target || "_blank"), T.clickToCopy && this.copyToClipboard(T.c);
    }
    const { ep: S } = Te({ props: a, defaults: mN }), V = new ResizeObserver((T) => {
      for (let x of T)
        x.target.tagName === "TABLE" && m.value++;
    }), Z = N(() => {
      if (!a.table.body)
        return [];
      if (!U.value)
        return a.table.body;
      const T = U.value.toLowerCase().trim();
      return a.table.body.filter((x) => x.some((ie) => {
        var he, Y;
        const ce = ie.id || "", K = ((he = ie.c) == null ? void 0 : he.toString().toLowerCase().trim()) || "", me = ((Y = ie.sortString) == null ? void 0 : Y.toString().toLowerCase().trim()) || "";
        return ce.includes(T) || K.includes(T) || me.includes(T);
      }));
    }), re = N(() => Z.value ? ub(
      Z.value,
      [
        (x) => {
          const ie = x[C.value];
          if (!ie)
            return null;
          const ce = ie.hasOwnProperty("sortString") ? ie.sortString : ie.c, K = "￿", me = "\0";
          return ce == null || ce === "" ? B.value === "asc" ? K : me : typeof ce == "boolean" ? ce === !0 ? K : me : ce.toString().toLowerCase();
        }
      ],
      [B.value]
    ).map((x) => ({
      id: x[0].id,
      rowColumns: x
      // render: isRowVisible(row),
    })) : []), F = N(() => re.value ? re.value.slice(
      l.value,
      l.value + n.value
    ) : []), A = N(() => re.value ? re.value.length : 0), $ = N(() => a.table.head ? a.table.head[0].length : 0), R = N(() => {
      const T = [];
      for (let x = 0; x < l.value; x++)
        T.push({ id: `filler-${x}` });
      return T;
    }), J = N(() => {
      const T = [], x = A.value - F.value.length - R.value.length;
      for (let ie = 0; ie < x; ie++)
        T.push({ id: `filler-${ie}` });
      return T;
    }), M = N(() => {
      m.value;
      const T = {};
      if (!p.value || p.value.rows.length === 0)
        return T;
      const x = p.value.rows;
      if (!(x != null && x[0]))
        return T;
      const ie = x[0].cells.length;
      for (let ce = 0; ce < ie; ce++)
        if (ce < a.columnsSticky) {
          let K = 0;
          for (let me = 0; me < ce; me++)
            K += x[0].cells[me].offsetWidth;
          T[ce] = {
            left: `${K}px`,
            position: "sticky",
            width: "1px"
          };
        }
      return T;
    });
    function k() {
      var T;
      if ((T = p.value.tBodies) != null && T[0] && g.value) {
        const x = p.value.tBodies[0].rows[j.value];
        if (x) {
          const ie = x.getBoundingClientRect();
          g.value.style.top = `${ie.top + window.scrollY - 1}px`, g.value.style.height = `${ie.height + 2}px`, g.value.style.width = `${f.value.offsetWidth + 4}px`, g.value.style.left = `${f.value.offsetLeft + window.scrollX - 2}px`;
        }
      }
    }
    function O({ columnIndex: T }) {
      C.value === T ? B.value = B.value === "asc" ? "desc" : "asc" : (C.value = T, B.value = "asc");
    }
    function E() {
      const T = f.value.scrollTop;
      l.value = Math.floor(T / w9), c.value = l.value + n.value;
    }
    const te = E;
    function se({ id: T, index: x, value: ie }) {
      if (h.value) {
        const ce = Math.min(_.value, x), K = Math.max(_.value, x);
        for (let me = ce; me <= K; me++) {
          const he = re.value[me].id;
          b.value[he] = ie;
        }
      } else
        b.value[T] = ie;
      q.value = T, _.value = x;
    }
    return ot(w, (T) => {
      T ? (b.value = {}, a.table.body.forEach((x, ie) => {
        x.forEach((ce) => {
          ce.checkbox && (b.value[ce.id] = !0);
        });
      })) : b.value = {};
    }), ot(L, (T) => {
      o("update:modelValue", T);
    }), ot(
      a.modelValue,
      (T) => {
        Object.entries(a.modelValue).forEach(([x, ie]) => {
          b.value[ie] = !0;
        });
      },
      { immediate: !0 }
    ), ot(j, (T) => {
      k();
    }), at(async () => {
      await Gt(), p.value && V.observe(p.value), f.value.addEventListener("scroll", te), n.value = Math.ceil(window.innerHeight / w9), c.value = l.value + n.value, i.value = n.value;
    }), $r(() => {
      p.value && V.unobserve(p.value), f.value && f.value.removeEventListener("scroll", te);
    }), VI("Shift", (T) => {
      h.value = T === "down";
    }), (T, x) => {
      var ie, ce, K, me;
      return d(), y("div", P(X(u(S).root)), [
        e.toolbar ? (d(), y("div", CN, [
          e.toolbarSearch ? (d(), Q(Wx, {
            key: 0,
            modelValue: U.value,
            "onUpdate:modelValue": x[0] || (x[0] = (he) => U.value = he),
            focusOnSlashKey: "",
            prefixTransparent: ""
          }, {
            prefix: ke(() => [
              be(We, {
                class: "size-5 text-neutral-300",
                lucide: "Search",
                lucideStrokeWidth: 3
              })
            ]),
            _: 1
          }, 8, ["modelValue"])) : v("", !0)
        ])) : v("", !0),
        Zt(D("div", {
          ref_key: "elFocusBox",
          ref: g,
          class: "pointer-events-none absolute z-10 rounded-lg border-2 border-neutral-300 dark:border-neutral-700"
        }, null, 512), [
          [Yt, I.value]
        ]),
        D("div", {
          ref_key: "elTableWrap",
          ref: f,
          class: "h-full min-h-0 overflow-x-auto overflow-y-auto"
        }, [
          e.table ? (d(), y("table", H({
            key: 0,
            ref_key: "elTable",
            ref: p
          }, u(S).table), [
            e.table.head ? (d(), y("thead", AN, [
              (d(!0), y(ge, null, Ie(e.table.head, (he, Y) => (d(), y("tr", { key: Y }, [
                (d(!0), y(ge, null, Ie(he, (oe, Me) => (d(), y("th", {
                  class: Pe(["sticky top-0 z-10 bg-neutral-100 align-bottom last:rounded-r-xl dark:bg-neutral-900", [
                    de.value.head.th,
                    `text-${oe.align ? oe.align : "right"}`,
                    { "first:rounded-l-xl": e.columnsSticky === 0 },
                    { "first:rounded-tl-xl": e.columnsSticky > 0 }
                  ]]),
                  style: yt(M.value[Me]),
                  key: Me
                }, [
                  oe.checkbox ? (d(), Q(HI, {
                    key: 0,
                    modelValue: w.value,
                    "onUpdate:modelValue": x[1] || (x[1] = (ue) => w.value = ue),
                    rounded: "md",
                    size: 5
                  }, null, 8, ["modelValue"])) : v("", !0),
                  oe.checkbox ? v("", !0) : (d(), y("span", {
                    key: 1,
                    class: Pe(["inline-flex select-none flex-row items-center gap-1 whitespace-nowrap rounded-lg px-2 py-1 font-semibold transition-all duration-300 ease-in-out hover:cursor-pointer hover:bg-neutral-200 dark:hover:bg-neutral-700", [
                      {
                        "bg-neutral-200 dark:bg-neutral-900 dark:outline dark:outline-neutral-700": C.value === Me
                      }
                    ]]),
                    onClick: (ue) => O({ columnIndex: Me })
                  }, [
                    C.value === Me && B.value == "asc" ? (d(), Q(We, {
                      key: 0,
                      lucide: "ArrowUp",
                      lucideStrokeWidth: 3,
                      class: "inline-block h-3 w-3"
                    })) : v("", !0),
                    C.value === Me && B.value == "desc" ? (d(), Q(We, {
                      key: 1,
                      lucide: "ArrowDown",
                      lucideStrokeWidth: 3,
                      class: "inline-block h-3 w-3"
                    })) : v("", !0),
                    D("span", qN, G(oe.c), 1)
                  ], 10, PN))
                ], 6))), 128))
              ]))), 128))
            ])) : v("", !0),
            e.loading && ((ie = e.table.head) != null && ie[0]) ? (d(), y("tbody", TN, [
              D("tr", null, [
                D("td", {
                  colspan: e.table.head[0].length,
                  class: "p-6"
                }, [
                  be(_b, {
                    class: "text-neutral-500",
                    center: ""
                  })
                ], 8, DN)
              ])
            ])) : v("", !0),
            !e.loading && re.value.length === 0 && ((ce = e.table.head) != null && ce[0]) ? (d(), y("tbody", _N, [
              D("tr", null, [
                D("td", {
                  colspan: e.table.head[0].length,
                  class: "p-6 text-center"
                }, "nothing here 😔", 8, BN)
              ])
            ])) : v("", !0),
            !e.loading && F.value.length > 0 ? (d(), y("tbody", {
              key: 3,
              class: "divide-sand divide-y dark:divide-neutral-800",
              onMouseenter: x[2] || (x[2] = (he) => I.value = !0),
              onMouseleave: x[3] || (x[3] = (he) => I.value = !1)
            }, [
              (d(!0), y(ge, null, Ie(re.value, (he, Y) => (d(), y(ge, {
                key: he.id
              }, [
                Y >= l.value - i.value && Y < c.value + i.value ? (d(), Q(SN, {
                  key: 0,
                  table: e.table,
                  tc: de.value,
                  row: he.rowColumns,
                  columnsSticky: e.columnsSticky,
                  styles: M.value,
                  checkedRows: b.value,
                  hoveredRow: j.value,
                  render: !0,
                  elTableWrap: f.value,
                  tbodyTrIndex: Y,
                  onClick: ae,
                  onCheckedRow: se,
                  onMouseover: (oe) => j.value = Y
                }, null, 8, ["table", "tc", "row", "columnsSticky", "styles", "checkedRows", "hoveredRow", "elTableWrap", "tbodyTrIndex", "onMouseover"])) : (d(), y("tr", {
                  key: 1,
                  style: yt({ height: `${w9}px` })
                }, [
                  D("td", {
                    colspan: $.value.value
                  }, null, 8, zN)
                ], 4))
              ], 64))), 128))
            ], 32)) : v("", !0),
            !e.loading && e.table.foot ? (d(), y("tfoot", HN, [
              (d(!0), y(ge, null, Ie(e.table.foot, (he, Y) => (d(), y("tr", { key: Y }, [
                (d(!0), y(ge, null, Ie(he, (oe, Me) => (d(), y("td", {
                  class: Pe(["bg-white dark:bg-neutral-800", [
                    de.value.foot.td,
                    { "text-left": e.table.head[0][Me].align === "left" },
                    { "text-center": e.table.head[0][Me].align === "center" },
                    { "text-right": e.table.head[0][Me].align === "right" },
                    { "text-right": !e.table.head[0][Me].align && !oe.checkbox },
                    { "text-center": oe.checkbox }
                  ]]),
                  style: yt(M.value[Me]),
                  key: Me
                }, [
                  oe.checkbox ? (d(), y("span", jN, G(L.value.length), 1)) : v("", !0),
                  oe.checkbox ? v("", !0) : (d(), y("span", VN, G(oe.c), 1))
                ], 6))), 128))
              ]))), 128))
            ])) : v("", !0)
          ], 16)) : v("", !0)
        ], 512),
        e.debug ? (d(), y("div", ON, [
          D("pre", null, G({
            startIndex: l.value,
            endIndex: c.value,
            rowsRendered: n.value,
            rowsBuffered: i.value,
            orderByColumn: C.value,
            orderDirection: B.value,
            tableVisibleRows: s.value,
            tableBodyFilteredSortedRendered: (me = (K = F.value[0]) == null ? void 0 : K[0]) == null ? void 0 : me.id,
            tableBodyFilteredSortedFillerRowsBefore: R.value.length,
            tableBodyFilteredSortedFillerRowsAfter: J.value.length,
            tableBodyFilteredSortedTotalRows: A.value,
            tableTotalColumns: $.value,
            modelValue: e.modelValue,
            checkedRows: b.value
          }), 1)
        ])) : v("", !0)
      ], 16);
    };
  }
}, $N = {
  composer: {
    props: {}
  },
  pt: {
    root: {
      _common: "@container m-auto max-w-7xl px-2 sm:px-4 2xl:px-0",
      propsStateBased: {
        debug: {
          true: "border border-red-500"
        }
      }
    }
  }
}, RN = { class: "w-full" }, ca = /* @__PURE__ */ Object.assign({
  inheritAttrs: !1
}, {
  __name: "LayoutContainer",
  props: {},
  setup(e) {
    const t = e, { ep: a } = Te({ props: t, defaults: $N });
    return (o, n) => (d(), y("div", RN, [
      D("div", P(X(u(a).root)), [
        ee(o.$slots, "default")
      ], 16)
    ]));
  }
}), FN = {
  composer: {
    props: {
      logo: {
        src: {
          default: "https://storage.googleapis.com/platformaone-sites-files-commerce-original-production/logos/19e952c9-0e16-4a2c-b2e7-55a63c9d80b1",
          control: "input"
        }
      },
      line1: {
        default: "text line 1",
        control: "input"
      },
      line2: {
        default: "text line 2",
        control: "input"
      },
      phone: {
        default: "+420 777 321 431",
        control: "input"
      },
      email: {
        default: "lala@example.com",
        control: "input"
      },
      contactsAsIcons: {
        default: !1,
        options: [!0, !1],
        control: "switch"
      },
      facebook: {
        default: "platformaone",
        control: "input"
      },
      instagram: {
        default: "platformaone",
        control: "input"
      },
      socialsAsIcons: {
        default: !1,
        options: [!0, !1],
        control: "switch"
      },
      align: {
        default: "start",
        options: ["start", "center", "end"],
        control: "select"
      }
    }
  },
  pt: {
    root: {
      _common: "w-full",
      propsStateBased: {}
    },
    wrap: {
      _common: "w-full flex flex-col",
      propsStateBased: {
        align: {
          start: "items-start",
          center: "items-center",
          end: "items-end"
        }
      }
    },
    logo: {
      _common: "",
      propsStateBased: {},
      props: {
        classImg: "w-auto h-5 mb-4"
      }
    },
    contactsAndSocials: {
      _common: "mt-4 flex gap-4",
      propsStateBased: {
        contactsAsIcons: {
          true: {
            socialsAsIcons: {
              true: "flex-row",
              false: "flex-col"
            }
          },
          false: "flex-col"
        }
      }
    },
    contacts: {
      _common: "flex",
      propsStateBased: {
        contactsAsIcons: {
          true: "flex-row gap-4",
          false: "flex-col gap-0"
        },
        align: {
          start: "items-start",
          center: "items-center",
          end: "items-end"
        }
      }
    },
    socials: {
      _common: "flex flex-row",
      propsStateBased: {
        socialsAsIcons: {
          true: "flex-row gap-4",
          false: "flex-col gap-0"
        },
        align: {
          start: "items-start",
          center: "items-center",
          end: "items-end"
        }
      }
    }
  }
}, UN = {
  composer: {
    props: {
      text: {
        default: "You will receive printable A4 size PDF immediately after payment to e-mail address used during checkout.",
        control: "input"
      },
      as: {
        default: "div",
        control: "select",
        options: ["div", "span", "p", "h1", "h2", "h3", "h4", "h5", "h6"]
      }
    }
  },
  pt: {
    root: {
      _common: "whitespace-pre-wrap",
      propsStateBased: {}
    }
  }
}, Ir = {
  __name: "Text",
  props: {
    globalConfig: {
      type: Object
    },
    pt: {
      type: Object
    },
    text: {
      type: String,
      default: ""
    },
    as: {
      type: String,
      default: "div",
      validator: (e) => ["div", "span", "p", "h1", "h2", "h3", "h4", "h5", "h6"].includes(e)
    }
  },
  setup(e) {
    const t = e, { ep: a } = Te({ props: t, locals: {}, defaults: UN });
    return (o, n) => (d(), Q(mt(e.as), P(X(u(a).root)), {
      default: ke(() => [
        ee(o.$slots, "default", {}, () => [
          wt(G(e.text), 1)
        ])
      ]),
      _: 3
    }, 16));
  }
}, EN = ["href"], WN = {
  key: 1,
  class: ""
}, NN = ["href"], ZN = {
  key: 1,
  class: ""
}, YN = ["href"], GN = {
  key: 1,
  class: ""
}, XN = ["href"], KN = {
  key: 1,
  class: ""
}, qG = {
  __name: "SectionFooter",
  props: {
    logo: {
      type: [Boolean, String],
      default: !1
    },
    line1: {
      type: [Boolean, String],
      default: !1
    },
    line2: {
      type: [Boolean, String],
      default: !1
    },
    phone: {
      type: [Boolean, String],
      default: !1
    },
    email: {
      type: [Boolean, String],
      default: !1
    },
    contactsAsIcons: {
      type: Boolean,
      default: !1
    },
    facebook: {
      type: [Boolean, String],
      default: !1
    },
    instagram: {
      type: [Boolean, String],
      default: !1
    },
    socialsAsIcons: {
      type: Boolean,
      default: !1
    },
    align: {
      type: String,
      default: "start",
      validator: (e) => ["start", "center", "end"].includes(e)
    }
  },
  setup(e) {
    const t = e, { ep: a } = Te({ props: t, defaults: FN });
    return (o, n) => (d(), y("div", P(X(u(a).root)), [
      be(ca, null, {
        default: ke(() => [
          D("div", P(X(u(a).wrap)), [
            D("div", null, [
              e.logo ? (d(), Q(Ar, P(H({ key: 0 }, { ...e.logo, ...u(a).logo })), null, 16)) : v("", !0)
            ]),
            e.line1 ? (d(), Q(Ir, {
              key: 0,
              text: e.line1
            }, null, 8, ["text"])) : v("", !0),
            e.line2 ? (d(), Q(Ir, {
              key: 1,
              text: e.line2
            }, null, 8, ["text"])) : v("", !0),
            D("div", P(X(u(a).contactsAndSocials)), [
              D("div", P(X(u(a).contacts)), [
                D("a", {
                  href: `mailto:${e.email}`,
                  target: "_blank"
                }, [
                  e.contactsAsIcons ? (d(), Q(We, {
                    key: 0,
                    lucide: "AtSign"
                  })) : v("", !0),
                  e.contactsAsIcons ? v("", !0) : (d(), y("span", WN, G(e.email), 1))
                ], 8, EN),
                D("a", {
                  href: `tel:${e.phone}`,
                  target: "_blank"
                }, [
                  e.contactsAsIcons ? (d(), Q(We, {
                    key: 0,
                    lucide: "Phone"
                  })) : v("", !0),
                  e.contactsAsIcons ? v("", !0) : (d(), y("span", ZN, G(e.phone), 1))
                ], 8, NN)
              ], 16),
              D("div", P(X(u(a).socials)), [
                D("a", {
                  href: `https://facebook.com/${e.facebook}`,
                  target: "_blank"
                }, [
                  e.socialsAsIcons ? (d(), Q(We, {
                    key: 0,
                    lucide: "Facebook"
                  })) : v("", !0),
                  e.socialsAsIcons ? v("", !0) : (d(), y("span", GN, "facebook"))
                ], 8, YN),
                D("a", {
                  href: `https://instagram.com/${e.instagram}`,
                  target: "_blank"
                }, [
                  e.socialsAsIcons ? (d(), Q(We, {
                    key: 0,
                    lucide: "Instagram"
                  })) : v("", !0),
                  e.socialsAsIcons ? v("", !0) : (d(), y("span", KN, "instagram"))
                ], 8, XN)
              ], 16)
            ], 16)
          ], 16)
        ]),
        _: 1
      })
    ], 16));
  }
}, QN = {
  composer: {
    props: {
      items: {
        default: [
          {
            src: "https://picsum.photos/800/800?random=1"
          },
          {
            src: "https://picsum.photos/800/600?random=2"
          },
          {
            src: "https://picsum.photos/800/800?random=3"
          },
          {
            src: "https://picsum.photos/1200/800?random=4"
          },
          {
            src: "https://picsum.photos/800/400?random=5"
          },
          {
            src: "https://picsum.photos/800/400?random=6"
          },
          {
            src: "https://picsum.photos/800/1200?random=7"
          },
          {
            src: "https://picsum.photos/800/500?random=8"
          },
          {
            src: "https://picsum.photos/500/800?random=9"
          }
        ],
        control: "input"
      },
      Image: {
        aspect: {
          default: "square",
          options: [
            "auto",
            "square",
            "1/1",
            "landscape",
            "16/9",
            "4/3",
            "3/2",
            "2/1",
            "portrait",
            "9/16",
            "3/4",
            "2/3",
            "1/2"
          ],
          control: "select"
        },
        fit: {
          default: "cover",
          options: ["none", "cover", "contain"],
          control: "select"
        }
      },
      layout: {
        default: "masonry",
        options: ["grid", "masonry", "list"],
        control: "select"
      }
    }
  },
  pt: {
    root: {
      _common: "w-full",
      propsStateBased: {}
    }
  }
}, JN = {
  composer: {
    // compositions: [{id: "default", name: "default"}],
    props: {
      items: {
        default: [
          {
            src: "https://picsum.photos/800/800?random=1"
          },
          {
            src: "https://picsum.photos/800/600?random=2"
          },
          {
            src: "https://picsum.photos/800/800?random=3"
          },
          {
            src: "https://picsum.photos/1200/800?random=4"
          },
          {
            src: "https://picsum.photos/800/400?random=5"
          },
          {
            src: "https://picsum.photos/800/400?random=6"
          },
          {
            src: "https://picsum.photos/800/1200?random=7"
          },
          {
            src: "https://picsum.photos/800/500?random=8"
          },
          {
            src: "https://picsum.photos/500/800?random=9"
          }
        ],
        control: "input"
      },
      Image: {
        aspect: {
          default: "square",
          options: [
            "auto",
            "square",
            "1/1",
            "landscape",
            "16/9",
            "4/3",
            "3/2",
            "2/1",
            "portrait",
            "9/16",
            "3/4",
            "2/3",
            "1/2"
          ],
          control: "select"
        },
        fit: {
          default: "cover",
          options: ["none", "cover", "contain"],
          control: "select"
        }
      },
      layout: {
        default: "grid",
        options: ["grid", "masonry", "list"],
        control: "select"
      }
    }
  },
  pt: {
    root: {
      _common: "@container w-full",
      propsStateBased: {}
    },
    wrap: {
      _common: "",
      propsStateBased: {
        layout: {
          grid: "grid grid-cols-2 @2xl:grid-cols-3 @4xl:grid-cols-4 gap-2 @sm:gap-4",
          masonry: "columns-2 @2xl:columns-3 space-y-2 gap-x-2 @md:space-y-4 @md:gap-x-4",
          list: "flex flex-col gap-4 items-center"
        }
      }
    },
    productItem: {
      propsStateBased: {
        layout: {
          grid: "",
          masonry: "",
          list: { layout: "horizontal" }
        }
      }
    }
  }
}, eZ = {
  key: 0,
  class: ""
}, tZ = {
  key: 1,
  class: "w-full text-center"
}, aZ = { class: "" }, nZ = {
  __name: "ImageList",
  props: {
    items: {
      type: Array,
      required: !0
    },
    Image: {
      type: Object
    },
    layout: {
      type: String,
      default: "grid"
      // grid, masonry, list
    },
    noItemsLabel: {
      type: String,
      default: "no items"
    },
    loading: {
      type: Boolean,
      default: !1
    }
  },
  emits: "ImageClick",
  setup(e, { emit: t }) {
    const a = e, o = t, { ep: n } = Te({ props: a, defaults: JN });
    function i(c) {
      return Fx({}, c, a.Image, n.value.Image);
    }
    function l(c) {
      o("ImageClick", c);
    }
    return (c, s) => (d(), y("div", P(X(u(n).root)), [
      e.loading ? (d(), y("div", eZ, [
        be(_b, { center: "" })
      ])) : v("", !0),
      !e.loading && e.items.length === 0 ? (d(), y("div", tZ, [
        D("span", aZ, G(e.noItemsLabel), 1)
      ])) : v("", !0),
      e.items.length > 0 ? (d(), y("div", P(H({ key: 2 }, u(n).wrap)), [
        (d(!0), y(ge, null, Ie(e.items, (h) => (d(), Q(Ar, H({
          key: h.id
        }, i(h), {
          onClick: (m) => l(h)
        }), null, 16, ["onClick"]))), 128))
      ], 16)) : v("", !0)
    ], 16));
  }
}, TG = {
  __name: "SectionGallery",
  props: {
    items: {
      type: Array
    },
    Image: {
      type: Object
    },
    layout: {
      type: String,
      default: "grid"
      // grid, masonry, list
    }
  },
  setup(e) {
    const t = e, { ep: a } = Te({ props: t, defaults: QN });
    return (o, n) => (d(), y("div", P(X(u(a).root)), [
      be(ca, null, {
        default: ke(() => [
          be(nZ, P(X(t)), null, 16)
        ]),
        _: 1
      })
    ], 16));
  }
}, oZ = {
  composer: {
    props: {
      logo: {
        src: {
          default: "https://storage.googleapis.com/platformaone-sites-files-commerce-original-production/logos/19e952c9-0e16-4a2c-b2e7-55a63c9d80b1",
          control: "input"
        }
      },
      logoAlign: {
        default: "center",
        options: ["start", "center", "end"],
        control: "select"
      }
    }
  },
  pt: {
    root: {
      _common: "w-full",
      propsStateBased: {}
    },
    wrap: {
      _common: "w-full flex flex-row",
      propsStateBased: {
        logoAlign: {
          start: "justify-start",
          center: "justify-center",
          end: "justify-end"
        }
      }
    },
    logo: {
      _common: "py-6",
      propsStateBased: {},
      props: {
        classImg: "w-52 h-auto"
      }
    }
  }
}, DG = {
  __name: "SectionHeader",
  props: {
    logo: {
      type: [Boolean, String],
      default: !1
    },
    logoAlign: {
      type: String,
      default: "start",
      validator: (e) => ["start", "center", "end"].includes(e)
    }
  },
  setup(e) {
    const t = e, { ep: a } = Te({ props: t, defaults: oZ });
    return (o, n) => (d(), y("div", P(X(u(a).root)), [
      be(ca, null, {
        default: ke(() => [
          D("div", P(X(u(a).wrap)), [
            e.logo ? (d(), Q(Ar, P(H({ key: 0 }, { ...e.logo, ...u(a).logo })), null, 16)) : v("", !0)
          ], 16)
        ]),
        _: 1
      })
    ], 16));
  }
}, rZ = {
  composer: {
    compositions: [
      { id: "default", name: "default" },
      { id: "no-image", name: "no image" },
      { id: "headline-only", name: "headline only" },
      { id: "text-only", name: "text only" },
      { id: "image-end", name: "image end" }
    ],
    props: {
      headline: {
        default: "Headline",
        control: "input"
      },
      text: {
        default: "I'm baby blue bottle biodiesel raclette, affogato fixie banjo fit organic godard gastropub. DIY hammock humblebrag same pour-over, locavore coloring book small batch. Adaptogen affogato PBR&B, man bun hot chicken bespoke farm-to-table neutral milk hotel vinyl lo-fi migas +1 cornhole. Wolf banh mi pinterest snackwave lomo brunch. Sartorial cray DIY, grailed banjo succulents biodiesel kinfolk edison bulb selfies pickled literally godard snackwave food truck. Bushwick mlkshk sus, food truck knausgaard sustainable blackbird spyplane.",
        control: "input"
      },
      image: {
        src: {
          default: "https://source.unsplash.com/random/1920x1080",
          control: "input"
        },
        aspect: {
          default: "square",
          options: ["auto", "square", "16/9", "4/3", "3/2", "2/1", "1/1", "portrait", "landscape"],
          control: "select"
        },
        fit: {
          default: "cover",
          options: ["none", "cover", "contain"],
          control: "select"
        }
      },
      cta: {
        label: {
          default: "CTA",
          control: "input"
        }
      },
      imagePositionHorizontal: {
        default: "start",
        options: ["start", "end"],
        control: "select"
      }
    }
  },
  pt: {
    root: {
      _common: "w-full py-8",
      propsStateBased: {}
    },
    wrap: {
      _common: "flex gap-8 flex-col items-start justify-start",
      propsStateBased: {
        imagePositionHorizontal: {
          start: "@md:flex-row",
          end: "@md:flex-row-reverse"
        }
      }
    },
    headline: {
      _common: "text-4xl font-bold font-heading",
      propsStateBased: {}
    },
    text: {
      _common: "mt-2 text-lg font-body",
      propsStateBased: {}
    },
    cta: {
      _common: "mt-6",
      propsStateBased: {}
    },
    Image: {
      _common: "@md:w-1/2 shrink-0",
      propsStateBased: {}
    },
    content: {
      _common: "",
      propsStateBased: {}
    }
  }
}, _G = {
  __name: "SectionHeadlineTextImageCTA",
  props: {
    headline: {
      type: [Boolean, String],
      default: !1
    },
    text: {
      type: [Boolean, String],
      default: !1
    },
    image: {
      type: [Boolean, Object],
      default: !1
    },
    cta: {
      type: [Boolean, String],
      default: !1
    },
    imagePositionHorizontal: {
      type: String,
      default: "start"
    }
  },
  setup(e) {
    const t = e, { ep: a } = Te({ props: t, defaults: rZ });
    return (o, n) => (d(), y("div", P(X(u(a).root)), [
      be(ca, null, {
        default: ke(() => [
          D("div", P(X(u(a).wrap)), [
            e.image ? (d(), Q(Ar, P(H({ key: 0 }, { ...e.image, ...u(a).Image })), null, 16)) : v("", !0),
            D("div", P(X(o.content)), [
              e.headline ? (d(), Q(Ir, H({ key: 0 }, u(a).headline, { text: e.headline }), null, 16, ["text"])) : v("", !0),
              e.text ? (d(), Q(Ir, H({ key: 1 }, u(a).text, { text: e.text }), null, 16, ["text"])) : v("", !0),
              e.cta ? (d(), Q(bt, P(H({ key: 2 }, { ...e.cta, ...u(a).cta })), null, 16)) : v("", !0)
            ], 16)
          ], 16)
        ]),
        _: 1
      })
    ], 16));
  }
}, iZ = {
  composer: {
    props: {
      logo: {
        src: {
          default: "https://storage.googleapis.com/platformaone-sites-files-commerce-original-production/logos/19e952c9-0e16-4a2c-b2e7-55a63c9d80b1",
          control: "input"
        }
      },
      title: {
        default: "Hero Title",
        control: "input"
      },
      subtitle: {
        default: "Subtitle",
        control: "input"
      },
      cta: {
        label: {
          default: "CTA",
          control: "input"
        }
      },
      backgroundImageSrc: {
        default: "https://source.unsplash.com/random/1920x1080",
        control: "input"
      }
    }
  },
  pt: {
    root: {
      _common: "w-full bg-cover h-[30vh] flex flex-col justify-center items-start",
      propsStateBased: {}
    },
    logo: {
      _common: "",
      propsStateBased: {},
      props: {
        classImg: "w-52 mb-5"
      }
    },
    title: {
      _common: "text-5xl font-bold text-white font-heading",
      propsStateBased: {}
    },
    subtitle: {
      _common: "text-2xl text-white font-body",
      propsStateBased: {}
    },
    cta: {
      _common: "mt-6",
      propsStateBased: {}
    }
  }
}, BG = {
  __name: "SectionHero",
  props: {
    logo: {
      type: [Boolean, String],
      default: !1
    },
    title: {
      type: [Boolean, String],
      default: !1
    },
    subtitle: {
      type: [Boolean, String],
      default: !1
    },
    cta: {
      type: [Boolean, String],
      default: !1
    },
    backgroundImageSrc: {
      type: [Boolean, String],
      default: !1
    }
  },
  setup(e) {
    const t = e, { ep: a } = Te({ props: t, defaults: iZ }), o = {
      backgroundImage: `url(${t.backgroundImageSrc})`
    };
    return (n, i) => (d(), y("div", H(u(a).root, { style: o }), [
      be(ca, null, {
        default: ke(() => [
          e.logo ? (d(), Q(Ar, P(H({ key: 0 }, { ...e.logo, ...u(a).logo })), null, 16)) : v("", !0),
          e.title ? (d(), Q(Ir, H({ key: 1 }, u(a).title, { text: e.title }), null, 16, ["text"])) : v("", !0),
          e.subtitle ? (d(), Q(Ir, H({ key: 2 }, u(a).subtitle, { text: e.subtitle }), null, 16, ["text"])) : v("", !0),
          e.cta ? (d(), Q(bt, P(H({ key: 3 }, { ...e.cta, ...u(a).cta })), null, 16)) : v("", !0)
        ]),
        _: 1
      })
    ], 16));
  }
}, lZ = {
  composer: {
    props: {
      title: {
        default: `Omakase & Night Skies:
Dinner and Helicopter Tour`,
        control: "input"
      },
      description: {
        default: "Elevate your sushi experience—literally and figuratively—with a helicopter ride over Dubai followed by a 7-course Omakase dinner at the Burj Al Arab.",
        control: "input"
      },
      image: {
        default: {
          src: "https://picsum.photos/800/800",
          aspect: "square",
          fit: "cover"
        },
        control: "input"
      },
      rounded: {
        default: !1,
        options: [!1, !0],
        control: "switch"
      }
    }
  },
  pt: {
    root: {
      _common: "group grid grid-cols-1 lg:grid-cols-2 gap-4 md:gap-8 2xl:gap-16 w-full p-0",
      propsStateBased: {}
    },
    imageWrap: {
      _common: "block",
      propsStateBased: {}
    },
    image: {
      _common: "shrink-0 block overflow-hidden",
      propsStateBased: {
        rounded: {
          true: "rounded-2xl",
          false: "rounded-none"
        }
      }
    },
    content: {
      // _common: "mt-0 flex flex-col p-3 max-w-lg",
    },
    title: {
      _common: "whitespace-pre-wrap text-3xl font-bold leading-9 text-neutral-800 dark:text-neutral-100 font-heading"
    },
    description: {
      _common: "mt-4 text-lg text-neutral-400 font-body"
    }
  }
}, zG = {
  __name: "SectionProductItemDetail",
  props: {
    image: {
      type: Object,
      required: !0
    },
    title: {
      type: String,
      required: !0
    },
    description: {
      type: String
    },
    rounded: {
      type: Boolean,
      default: !1
    }
  },
  setup(e) {
    const t = e, { ep: a } = Te({ props: t, defaults: lZ });
    return (o, n) => (d(), Q(ca, null, {
      default: ke(() => [
        D("div", P(X(u(a).root)), [
          D("div", P(X(u(a).imageWrap)), [
            be(Ar, H({ src: o.imageSrc }, { ...e.image, ...u(a).image }), null, 16, ["src"])
          ], 16),
          D("div", P(X(u(a).content)), [
            D("div", null, [
              D("h2", P(X(u(a).title)), G(e.title), 17),
              D("p", P(X(u(a).description)), G(e.description), 17)
            ]),
            D("div", P(X(u(a).actions)), [
              ee(o.$slots, "actions")
            ], 16)
          ], 16)
        ], 16)
      ]),
      _: 3
    }));
  }
}, cZ = {
  composer: {
    props: {
      items: {
        default: [
          {
            title: "Omakase & Night Skies: Dinner and Helicopter Tour",
            description: "Elevate your sushi experience—literally and figuratively—with a helicopter ride over Dubai followed by a 7-course Omakase dinner at the Burj Al Arab.",
            image: {
              src: "https://picsum.photos/800/800?random=1",
              aspect: "portrait",
              fit: "cover"
            },
            price: "6,500",
            pricePrefix: "AED",
            priceSuffix: ""
          },
          {
            title: "Meet & greet sushi master",
            description: "Have a chat with our sushi god",
            image: {
              src: "https://picsum.photos/800/600?random=2",
              aspect: "portrait",
              fit: "cover"
            },
            price: "2,500",
            pricePrefix: "AED",
            priceSuffix: ""
          },
          {
            title: "Private course",
            description: "You are the chef",
            image: {
              src: "https://picsum.photos/800/800?random=3",
              aspect: "portrait",
              fit: "cover"
            },
            price: "5,000",
            pricePrefix: "AED",
            priceSuffix: ""
          },
          {
            title: "Monetary",
            description: "You choose the value!",
            image: {
              src: "https://picsum.photos/1200/800?random=4",
              aspect: "portrait",
              fit: "cover"
            },
            price: "500 - 10,000",
            pricePrefix: "AED",
            priceSuffix: ""
          },
          {
            title: "2 week intensive course with sushi master in our beach restaurant",
            description: "Learn the art of sushi making in our beach restaurant. You will be taught by our sushi master and will be able to enjoy your creations afterwards.",
            image: {
              src: "https://picsum.photos/800/400?random=5",
              aspect: "portrait",
              fit: "cover"
            },
            price: "50,000",
            pricePrefix: "AED",
            priceSuffix: ""
          },
          {
            title: "Private course for 2",
            description: "Don't want to share your sushi with strangers? We get it.",
            image: {
              src: "https://picsum.photos/800/400?random=6",
              aspect: "portrait",
              fit: "cover"
            },
            price: "8,000",
            pricePrefix: "AED",
            priceSuffix: ""
          },
          {
            title: "Omakase & Night Skies: Dinner and Helicopter Tour",
            description: "",
            image: {
              src: "https://picsum.photos/800/1200?random=7",
              aspect: "portrait",
              fit: "cover"
            },
            price: "6,500",
            pricePrefix: "AED",
            priceSuffix: ""
          },
          {
            title: "Omakase & Night Skies: Dinner and Helicopter Tour",
            description: "",
            image: {
              src: "https://picsum.photos/800/500?random=8",
              aspect: "portrait",
              fit: "cover"
            },
            price: "6,500",
            pricePrefix: "AED",
            priceSuffix: ""
          },
          {
            title: "Omakase & Night Skies: Dinner and Helicopter Tour",
            description: "",
            image: {
              src: "https://picsum.photos/500/800?random=9",
              aspect: "portrait",
              fit: "cover"
            },
            price: "6,500",
            pricePrefix: "AED",
            priceSuffix: ""
          }
        ],
        control: "input"
      },
      loading: {
        default: !1,
        options: [!1, !0],
        control: "switch"
      }
    }
  },
  pt: {
    root: {
      _common: "group grid grid-cols-1 lg:grid-cols-2 gap-4 md:gap-8 2xl:gap-16 w-full p-0",
      propsStateBased: {}
    },
    imageWrap: {
      _common: "block",
      propsStateBased: {}
    },
    image: {
      _common: "shrink-0 block overflow-hidden",
      propsStateBased: {
        rounded: {
          true: "rounded-2xl",
          false: "rounded-none"
        }
      }
    },
    content: {
      _common: "mt-0 flex flex-col p-3 max-w-lg"
    },
    title: {
      _common: "whitespace-pre-wrap text-3xl font-bold leading-9 text-neutral-800 dark:text-neutral-100"
    },
    description: {
      _common: "mt-4 text-lg text-neutral-400"
    }
  }
}, dZ = {
  key: 0,
  class: "mt-4 flex flex-center"
}, HG = {
  __name: "SectionProductItemList",
  props: {
    items: {
      type: Array
    },
    showAllButtonShow: {
      type: Boolean,
      default: !1
    },
    showAllButtonLabel: {
      type: String,
      default: "show all"
    },
    noItemsLabel: {
      type: String
    },
    loading: {
      type: Boolean,
      default: !1
    },
    layout: {
      type: String,
      default: "grid",
      validator: (e) => ["grid", "list", "masonry"].includes(e)
    }
  },
  emits: ["showAllButtonClick"],
  setup(e) {
    const t = e;
    return Te({ props: t, defaults: cZ }), (a, o) => (d(), Q(ca, null, {
      default: ke(() => [
        be(oN, P(X(t)), null, 16),
        e.showAllButtonShow && e.items.length > 0 ? (d(), y("div", dZ, [
          be(bt, {
            variant: "secondary",
            label: e.showAllButtonLabel,
            onClick: o[0] || (o[0] = (n) => a.$emit("showAllButtonClick"))
          }, null, 8, ["label"])
        ])) : v("", !0)
      ]),
      _: 1
    }));
  }
}, sZ = {
  composer: {
    props: {
      height: {
        default: 11,
        options: [
          6,
          7,
          8,
          9,
          10,
          11,
          // default
          12,
          14,
          16,
          20,
          24,
          28,
          32,
          36,
          40,
          44,
          48,
          52,
          56,
          60,
          64,
          72,
          80,
          96,
          "25vh",
          "50vh",
          "75vh",
          "screen",
          "svh",
          "lvh",
          "dvh"
        ],
        control: "select"
      }
    }
  },
  pt: {
    root: {
      _common: "w-full",
      propsStateBased: {
        height: {
          6: "h-6",
          7: "h-7",
          8: "h-8",
          9: "h-9",
          10: "h-10",
          11: "h-11",
          // default
          12: "h-12",
          14: "h-14",
          16: "h-16",
          20: "h-20",
          24: "h-24",
          28: "h-28",
          32: "h-32",
          36: "h-36",
          40: "h-40",
          44: "h-44",
          48: "h-48",
          52: "h-52",
          56: "h-56",
          60: "h-60",
          64: "h-64",
          72: "h-72",
          80: "h-80",
          96: "h-96",
          "25vh": "h-25vh",
          "50vh": "h-50vh",
          "75vh": "h-75vh",
          screen: "h-screen",
          svh: "h-svh",
          lvh: "h-lvh",
          dvh: "h-dvh"
        }
      }
    }
  }
}, jG = {
  __name: "SectionSpacer",
  props: {
    height: {
      type: [String, Number],
      default: 11
    }
  },
  setup(e) {
    const t = e, { ep: a } = Te({ props: t, defaults: sZ });
    return (o, n) => (d(), y("div", P(X(u(a).root)), null, 16));
  }
}, uZ = {
  composer: {
    props: {
      label: {
        default: "label",
        control: "input"
      },
      modelValue: {
        default: "",
        control: "input"
      },
      placeholder: {
        default: "select something",
        control: "input"
      },
      options: {
        default: [
          {
            label: "option 1",
            labelSecondary: "label 2",
            sublabel: "sublabel 1",
            value: "option-1"
          },
          {
            label: "option 2",
            sublabel: "sublabel 2",
            value: "option-2"
          },
          {
            label: "option 3",
            sublabel: "sublabel 3",
            value: "option-3",
            disabled: !0
          },
          {
            label: "option 4",
            value: "option-4"
          },
          {
            label: "option 5",
            value: "option-5"
          },
          {
            label: "option 6",
            value: "option-6"
          },
          {
            label: "option 7",
            value: "option-7"
          },
          {
            label: "option 8",
            value: "option-8"
          }
        ],
        control: "input"
      },
      caption: {
        default: "caption with additional information",
        control: "input"
      },
      // status: {
      //   default: false, //"error",
      //   control: "select",
      //   options: [false, "success", "error", "progress"],
      // },
      size: {
        default: 11,
        control: "select",
        options: [24, 20, 16, 14, 12, 11, 10, 9, 8]
      },
      // statusMessage: {
      //   default: "status message",
      //   control: "input",
      // },
      disabled: {
        default: !1,
        control: "switch"
      },
      layout: {
        default: "vertical",
        control: "select",
        options: ["horizontal", "vertical", "grid"]
      },
      fullWidth: {
        default: !1,
        options: [!0, !1],
        control: "switch"
      }
    }
  },
  pt: {
    selectWrapper: {
      _common: "flex min-h-11 w-full cursor-pointer flex-row items-center gap-2 rounded-xl bg-neutral-150 p-2 transition-all duration-300 ease-in-out hover:bg-neutral-200 dark:bg-neutral-800 dark:hover:bg-neutral-700"
    },
    selectedValueLabel: {
      _common: "text-neutral-800 dark:text-neutral-100"
    },
    placeholder: {
      _common: "text-neutral-400 dark:text-neutral-500"
    },
    chevron: {
      _common: "pointer-events-none shrink-0 text-neutral-400 dark:text-neutral-600"
    },
    optionsContainer: {
      _common: "absolute left-0 right-0 top-full z-50 mt-1 flex max-h-64 flex-col gap-0 rounded-2xl border border-neutral-200 bg-white p-2 dark:border-neutral-800 dark:bg-neutral-950"
    },
    option: {
      _common: "flex w-full cursor-pointer flex-row items-center justify-between rounded-lg p-2 transition-all duration-300 ease-in-out hover:bg-neutral-200 dark:hover:bg-neutral-800"
    },
    optionMultiSelected: {
      _common: "flex w-full cursor-pointer flex-row items-center justify-between rounded-lg p-2 transition-all duration-300 ease-in-out hover:bg-neutral-200 dark:hover:bg-neutral-800 bg-neutral-150 dark:bg-neutral-600"
    },
    optionLabel: {
      _common: "pointer-events-none select-none text-neutral-900 dark:text-neutral-100"
    },
    optionCheckIcon: {
      _common: "pointer-events-none text-neutral-900 dark:text-neutral-100"
    },
    labelOuter: {
      _common: "inline-block text-base font-bold text-neutral-600 dark:text-neutral-500 font-element"
    },
    caption: {
      _common: "mt-1 text-sm text-neutral-400 dark:text-neutral-700"
    },
    modeViewValue: {
      _common: "text-neutral-900 dark:text-neutral-100"
    }
  }
}, hZ = {
  key: 0,
  class: "relative flex flex-col"
}, pZ = {
  key: 0,
  class: "mb-1 flex flex-row items-end justify-between"
}, yZ = { class: "pointer-events-none flex grow select-none flex-row items-center justify-start pl-1 text-left" }, kZ = {
  key: 1,
  class: "flex flex-row flex-wrap gap-2"
}, fZ = { class: "flex flex-col gap-1 overflow-y-scroll" }, vZ = ["onClick"], mZ = {
  key: 1,
  class: ""
}, gZ = {
  key: 2,
  class: "flex flex-col"
}, MZ = {
  key: 2,
  class: "mt-2 flex flex-row flex-wrap gap-2"
}, xZ = ["onClick"], VG = {
  __name: "Select",
  props: {
    globalConfig: {
      type: Object
    },
    pt: {
      type: Object
    },
    modelValue: {
      type: String
    },
    options: {
      type: Array,
      default: () => []
    },
    multi: {
      type: Boolean,
      // selecting mutliple items (array)
      default: !1
    },
    disabled: {
      type: Boolean,
      default: !1
    },
    mode: {
      type: String,
      default: "edit"
    },
    label: {
      type: [String, Boolean],
      default: !1
    },
    placeholder: {
      type: [String, Boolean],
      default: !1
    },
    caption: {
      type: [String, Boolean],
      default: !1
    },
    size: {
      type: Number,
      default: 11
    },
    rounded: {
      type: String,
      default: "full"
    },
    context: {
      type: String,
      validator: function(e) {
        return ["dark", "neutral", "light"].indexOf(e) !== -1;
      }
    },
    filled: {
      type: Boolean,
      default: !1
    },
    collapsible: {
      type: Boolean,
      default: !1
    },
    layout: {
      type: String,
      default: "vertical"
      // horizontal, vertical, grid
    },
    fullWidth: {
      type: Boolean,
      default: !1
    },
    filter: {
      type: Boolean,
      default: !1
    },
    sort: {
      type: Boolean,
      default: !1
    }
  },
  emits: ["update:modelValue"],
  setup(e, { expose: t, emit: a }) {
    const o = e, n = a, { ep: i } = Te({ props: o, locals: {}, defaults: uZ }), l = W(""), c = W(!1), s = W(null), h = W(null);
    W(null);
    const m = N(() => {
      const b = o.options.find((L) => L.value === o.modelValue);
      return b ? b.label : "";
    }), p = N(() => o.sort ? ub(o.options, [(b) => b.label.toLowerCase()], ["asc"]) : o.options), f = N(() => {
      if (!l.value)
        return p.value;
      const b = l.value.toLowerCase().trim();
      return p.value.filter((L) => {
        const j = L.label.toLowerCase().trim(), I = L.sublabel ? L.sublabel.toLowerCase().trim() : "", C = L.value.toLowerCase().trim();
        return j.includes(b) || I.includes(b) || C.includes(b);
      });
    }), g = N(() => f.value.filter((b) => {
      var L;
      return (L = o.modelValue) == null ? void 0 : L.includes(b.value);
    }));
    function w(b) {
      if (o.disabled)
        return;
      o.multi || (c.value = !1);
      let L = Ix(i1(o.modelValue));
      console.log({ modelValueCloned: L }), o.multi ? (L = L || [], L.includes(b.value) ? L.splice(L.indexOf(b.value), 1) : L.push(b.value)) : L = b.value, n("update:modelValue", L);
    }
    function q(b) {
      s.value.contains(b.target) || h.value.contains(b.target) || (console.log("outer click triggered"), c.value = !1);
    }
    function _(b) {
      var L;
      return o.multi && ((L = o.modelValue) != null && L.includes(b.value)) ? i.value.optionMultiSelected : i.value.option;
    }
    return ot(c, (b) => {
      b ? window.addEventListener("click", q) : window.removeEventListener("click", q);
    }), t({
      filterOptions: l
      // to be able to reset the filter from parent
    }), (b, L) => {
      var j;
      return d(), y("div", P(X(u(i).root)), [
        o.mode == "edit" ? (d(), y("div", hZ, [
          o.label ? (d(), y("div", pZ, [
            o.label ? (d(), y("span", P(H({ key: 0 }, u(i).labelOuter)), G(o.label), 17)) : v("", !0)
          ])) : v("", !0),
          D("div", H({
            ref_key: "elSelectWrapper",
            ref: s
          }, u(i).selectWrapper, {
            onClick: L[0] || (L[0] = (I) => c.value = !c.value)
          }), [
            D("div", yZ, [
              m.value ? (d(), y("span", P(H({ key: 0 }, u(i).selectedValueLabel)), G(m.value), 17)) : v("", !0),
              o.multi && o.modelValue ? (d(), y("div", kZ, [
                (d(!0), y(ge, null, Ie(o.modelValue, (I) => (d(), Q(bx, {
                  key: I,
                  label: e.options.find((C) => C.value === I).label,
                  variant: "primary",
                  size: 6,
                  clickable: ""
                }, null, 8, ["label"]))), 128))
              ])) : v("", !0),
              !m.value && !(e.multi && ((j = o.modelValue) != null && j.length)) ? (d(), y("span", P(H({ key: 2 }, u(i).placeholder)), G(o.placeholder || "select ..."), 17)) : v("", !0)
            ]),
            Zt(be(We, H(u(i).chevron, {
              lucide: "ChevronDown",
              lucideStrokeWidth: 3.5,
              size: 24
            }), null, 16), [
              [Yt, !c.value]
            ]),
            Zt(be(We, H(u(i).chevron, {
              lucide: "ChevronUp",
              lucideStrokeWidth: 3.5,
              size: 24
            }), null, 16), [
              [Yt, c.value]
            ])
          ], 16),
          c.value ? (d(), y("div", H({
            key: 1,
            ref_key: "elOptionsContainer",
            ref: h
          }, u(i).optionsContainer), [
            e.filter ? (d(), Q(Wx, {
              key: 0,
              class: "mb-2 w-full",
              modelValue: l.value,
              "onUpdate:modelValue": L[1] || (L[1] = (I) => l.value = I),
              placeholder: "search",
              size: 8,
              focus: "",
              fullWidth: ""
            }, null, 8, ["modelValue"])) : v("", !0),
            D("div", fZ, [
              (d(!0), y(ge, null, Ie(f.value, (I) => {
                var C;
                return d(), y("div", H(_(I), {
                  key: I.value,
                  onClick: (B) => w(I)
                }), [
                  D("span", P(X(u(i).optionLabel)), G(I.label), 17),
                  e.multi && ((C = e.modelValue) != null && C.includes(I.value)) ? (d(), Q(We, H({
                    key: 0,
                    lucide: "Check",
                    lucideStrokeWidth: "3.5",
                    size: 16
                  }, u(i).optionCheckIcon), null, 16)) : v("", !0)
                ], 16, vZ);
              }), 128))
            ])
          ], 16)) : v("", !0)
        ])) : v("", !0),
        e.caption || b.$slots.caption ? (d(), y("div", mZ, [
          ee(b.$slots, "caption", {}, () => [
            D("p", P(X(u(i).caption)), G(e.caption), 17)
          ])
        ])) : v("", !0),
        o.mode == "view" ? (d(), y("div", gZ, [
          o.label ? (d(), y("span", P(H({ key: 0 }, u(i).inputLabel)), G(o.label), 17)) : v("", !0),
          e.multi ? v("", !0) : (d(), y("p", P(H({ key: 1 }, u(i).modeViewValue)), G(m.value), 17)),
          e.multi ? (d(), y("div", MZ, [
            (d(!0), y(ge, null, Ie(g.value, (I) => (d(), y("div", {
              class: "",
              key: I.value,
              onClick: (C) => w(I)
            }, [
              be(bx, {
                label: I.label,
                variant: "secondary",
                size: 8,
                clickable: ""
              }, null, 8, ["label"])
            ], 8, xZ))), 128))
          ])) : v("", !0)
        ])) : v("", !0)
      ], 16);
    };
  }
}, bZ = {
  composer: {
    props: {
      text: {
        default: "You will receive printable A4 size PDF immediately after payment to e-mail address used during checkout.",
        control: "input"
      },
      icon: {
        default: "Info",
        control: "input"
      },
      iconSet: {
        options: ["lucide"],
        default: "lucide",
        control: "select"
      },
      iconStrokeWidth: {
        options: [0.5, 0.75, 1, 1.25, 1.5, 1.75, 2, 2.25, 2.5, 2.75, 3, 3.5, 4, 5],
        default: 2,
        control: "select"
      },
      layout: {
        options: ["horizontal", "vertical"],
        default: "horizontal",
        control: "select"
      }
    }
  },
  pt: {
    root: {
      _common: "flex gap-2 bg-neutral-100 p-2 rounded-md",
      propsStateBased: {
        layout: {
          horizontal: "flex-row",
          vertical: "flex-col"
        },
        fullWidth: {
          true: "w-full",
          false: "min-w-[300px]"
        }
      }
    },
    icon: {
      _common: "shrink-0 w-5 h-5 text-neutral-400"
    },
    content: {
      _common: "text-sm text-neutral-500"
    }
  }
}, OG = {
  __name: "TextBox",
  props: {
    globalConfig: {
      type: Object
    },
    pt: {
      type: Object
    },
    text: {
      type: String,
      default: ""
    },
    rounded: {
      type: String,
      default: "full"
    },
    filled: {
      type: Boolean,
      default: !1
    },
    icon: {
      type: [String, Boolean],
      default: !1
    },
    iconSet: {
      type: String,
      default: "lucide"
    },
    iconStrokeWidth: {
      type: Number,
      default: 2
    },
    layout: {
      type: String,
      default: "horizontal"
    }
  },
  emits: ["update:modelValue"],
  setup(e, { emit: t }) {
    const a = e, { ep: o } = Te({ props: a, locals: {}, defaults: bZ });
    return (n, i) => (d(), y("div", P(X(u(o).root)), [
      e.icon && e.iconSet == "lucide" ? (d(), Q(We, H({ key: 0 }, u(o).icon, {
        lucide: e.icon,
        "lucide-stroke-width": e.iconStrokeWidth
      }), null, 16, ["lucide", "lucide-stroke-width"])) : v("", !0),
      be(Ir, P(X(u(o).content)), {
        default: ke(() => [
          wt(G(e.text), 1)
        ]),
        _: 1
      }, 16)
    ], 16));
  }
}, wZ = {
  composer: {
    props: {
      title: {
        default: "Toast title",
        control: "input"
      },
      message: {
        default: "Additional message",
        control: "input"
      }
    }
  },
  pt: {
    root: {
      _common: "",
      propsStateBased: {
        autoposition: {
          true: "fixed left-1/2 bottom-2 transform -translateX-1/2",
          false: ""
        }
      }
    },
    icon: {
      _common: ""
    },
    content: {
      _common: ""
    }
  }
};
function IZ(e, t) {
  return d(), y("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    fill: "currentColor",
    "aria-hidden": "true",
    "data-slot": "icon"
  }, [
    D("path", {
      "fill-rule": "evenodd",
      d: "M2.25 12c0-5.385 4.365-9.75 9.75-9.75s9.75 4.365 9.75 9.75-4.365 9.75-9.75 9.75S2.25 17.385 2.25 12Zm13.36-1.814a.75.75 0 1 0-1.22-.872l-3.236 4.53L9.53 12.22a.75.75 0 0 0-1.06 1.06l2.25 2.25a.75.75 0 0 0 1.14-.094l3.75-5.25Z",
      "clip-rule": "evenodd"
    })
  ]);
}
function LZ(e, t) {
  return d(), y("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    fill: "currentColor",
    "aria-hidden": "true",
    "data-slot": "icon"
  }, [
    D("path", {
      "fill-rule": "evenodd",
      d: "M2.25 12c0-5.385 4.365-9.75 9.75-9.75s9.75 4.365 9.75 9.75-4.365 9.75-9.75 9.75S2.25 17.385 2.25 12ZM12 8.25a.75.75 0 0 1 .75.75v3.75a.75.75 0 0 1-1.5 0V9a.75.75 0 0 1 .75-.75Zm0 8.25a.75.75 0 1 0 0-1.5.75.75 0 0 0 0 1.5Z",
      "clip-rule": "evenodd"
    })
  ]);
}
function SZ(e, t) {
  return d(), y("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    fill: "currentColor",
    "aria-hidden": "true",
    "data-slot": "icon"
  }, [
    D("path", {
      "fill-rule": "evenodd",
      d: "M2.25 12c0-5.385 4.365-9.75 9.75-9.75s9.75 4.365 9.75 9.75-4.365 9.75-9.75 9.75S2.25 17.385 2.25 12Zm8.706-1.442c1.146-.573 2.437.463 2.126 1.706l-.709 2.836.042-.02a.75.75 0 0 1 .67 1.34l-.04.022c-1.147.573-2.438-.463-2.127-1.706l.71-2.836-.042.02a.75.75 0 1 1-.671-1.34l.041-.022ZM12 9a.75.75 0 1 0 0-1.5.75.75 0 0 0 0 1.5Z",
      "clip-rule": "evenodd"
    })
  ]);
}
function CZ(e, t) {
  return d(), y("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    fill: "currentColor",
    "aria-hidden": "true",
    "data-slot": "icon"
  }, [
    D("path", {
      "fill-rule": "evenodd",
      d: "M12 2.25c-5.385 0-9.75 4.365-9.75 9.75s4.365 9.75 9.75 9.75 9.75-4.365 9.75-9.75S17.385 2.25 12 2.25Zm-1.72 6.97a.75.75 0 1 0-1.06 1.06L10.94 12l-1.72 1.72a.75.75 0 1 0 1.06 1.06L12 13.06l1.72 1.72a.75.75 0 1 0 1.06-1.06L13.06 12l1.72-1.72a.75.75 0 1 0-1.06-1.06L12 10.94l-1.72-1.72Z",
      "clip-rule": "evenodd"
    })
  ]);
}
const AZ = { class: "flex max-w-xs shrink-0 flex-row items-center gap-2 rounded-full bg-neutral-800 py-3 pl-3 pr-4" }, PZ = { class: "" }, qZ = { class: "leading-5" }, TZ = {
  key: 0,
  class: "whitespace-nowrap font-semibold text-white"
}, DZ = {
  key: 1,
  class: "whitespace-nowrap pr-2 text-neutral-400"
}, _Z = {
  __name: "Toast",
  props: {
    globalConfig: {
      type: Object
    },
    pt: {
      type: Object
    },
    text: {
      type: String,
      default: ""
    },
    rounded: {
      type: String,
      default: "full"
    },
    filled: {
      type: Boolean,
      default: !1
    },
    icon: {
      type: [String, Boolean],
      default: !1
    },
    iconSet: {
      type: String,
      default: "lucide"
    },
    iconStrokeWidth: {
      type: Number,
      default: 2
    },
    layout: {
      type: String,
      default: "horizontal"
    },
    title: {
      type: [Boolean, String],
      default: !1
    },
    message: {
      type: [Boolean, String],
      default: !1
    },
    type: {
      type: String,
      default: "info"
    },
    autoposition: {
      type: Boolean,
      default: !1
    },
    autohide: {
      type: [Boolean, Number],
      default: 5e3
      // ms
    }
  },
  emits: ["update:modelValue"],
  setup(e, { emit: t }) {
    const a = e, { ep: o } = Te({ props: a, locals: {}, defaults: wZ }), n = W(!0), i = W("animate-fadeInUp");
    function l() {
      a.autohide && setTimeout(() => {
        i.value = "animate-fadeOutDown", console.log("setting fade out", a.autohide), setTimeout(() => {
          n.value = !1;
        }, 300);
      }, a.autohide);
    }
    return l(), (c, s) => n.value ? (d(), y("div", H({
      key: 0,
      class: i.value
    }, u(o).root, {
      onClick: s[0] || (s[0] = (...h) => c.onClick && c.onClick(...h))
    }), [
      D("div", AZ, [
        D("div", PZ, [
          e.type === "info" ? (d(), Q(u(SZ), {
            key: 0,
            class: "size-6 shrink-0 text-blue-400"
          })) : v("", !0),
          e.type === "success" ? (d(), Q(u(IZ), {
            key: 1,
            class: "size-6 shrink-0 text-green-400"
          })) : v("", !0),
          e.type === "warning" ? (d(), Q(u(LZ), {
            key: 2,
            class: "size-6 shrink-0 text-orange-400"
          })) : v("", !0),
          e.type === "error" ? (d(), Q(u(CZ), {
            key: 3,
            class: "size-6 shrink-0 text-red-400"
          })) : v("", !0)
        ]),
        D("div", qZ, [
          e.title ? (d(), y("span", TZ, G(e.title), 1)) : v("", !0),
          e.message ? (d(), y("p", DZ, G(e.message), 1)) : v("", !0)
        ])
      ])
    ], 16)) : v("", !0);
  }
}, BZ = {
  composer: {
    props: {
      modelValue: {
        default: !1,
        control: "switch"
      },
      size: {
        default: 6,
        //11,
        control: "select",
        options: [14, 12, 11, 10, 9, 8, 7, 6]
      },
      rounded: {
        default: !1,
        options: [!1, "full", "md", "sm"],
        control: "select"
      },
      disabled: {
        default: !1,
        control: "switch"
      },
      label: {
        default: "label",
        control: "input"
      },
      labelStart: {
        default: "label",
        control: "input"
      },
      labelEnd: {
        default: "label",
        control: "input"
      },
      sublabelStart: {
        default: "sublabel",
        control: "input"
      },
      sublabelEnd: {
        default: "sublabel",
        control: "input"
      },
      caption: {
        default: "caption with additional information",
        control: "input"
      }
    }
  },
  pt: {
    root: {},
    toggleWrap: {
      _common: "flex flex-row items-center justify-start gap-4"
    },
    toggle: {
      _common: "transition-all ease-in-out duration-300 cursor-pointer flex flex-row flex-center relative hover:opacity-50 dark:text-neutral-400",
      propsStateBased: {
        modelValue: {
          false: {
            _common: "hover:bg-neutral-100 dark:hover:bg-neutral-800"
          },
          true: {
            _common: "bg-neutral-200 dark:bg-neutral-800"
          }
        },
        rounded: {
          false: {
            _common: "",
            size: {
              14: "size-14",
              12: "size-12",
              11: "size-11",
              // default
              10: "size-10",
              9: "size-9",
              8: "size-8",
              7: "size-7",
              6: "size-6"
            }
          },
          full: {
            _common: "rounded-full",
            size: {
              14: "size-14",
              12: "size-12",
              11: "size-11",
              // default
              10: "size-10",
              9: "size-9",
              8: "size-8",
              7: "size-7",
              6: "size-6"
            }
          },
          md: {
            size: {
              14: "size-14 rounded-xl",
              12: "size-12 rounded-xl",
              11: "size-11 rounded-xl",
              // default
              10: "size-10 rounded-lg",
              9: "size-9 rounded-lg",
              8: "size-8 rounded-lg",
              7: "size-7 rounded-lg",
              6: "size-6 rounded-lg"
            }
          },
          sm: {
            size: {
              14: "size-14 rounded-md",
              12: "size-12 rounded-md",
              11: "size-11 rounded-md",
              // default
              10: "size-10 rounded-md",
              9: "size-9 rounded-md",
              8: "size-8 rounded-md",
              7: "size-7 rounded-md",
              6: "size-6 rounded-md"
            }
          }
        }
      }
    },
    labelOuter: {
      _common: "inline-block text-base font-bold text-neutral-600 dark:text-neutral-500 font-element"
    },
    labelStart: {
      _common: "inline-block text-base font-bold text-neutral-600 dark:text-neutral-500 font-element"
    },
    labelStartWrap: {
      _common: "flex flex-col gap-0"
    },
    labelEndWrap: {
      _common: "flex flex-col gap-0"
    },
    labelEnd: {
      _common: "inline-block text-base font-bold text-neutral-600 dark:text-neutral-500 font-element"
    },
    sublabelStart: {
      _common: "leading-3 text-sm text-neutral-500"
    },
    sublabelEnd: {
      _common: "leading-3 text-sm text-neutral-500"
    },
    modeViewValue: {
      _common: "text-neutral-900 dark:text-neutral-100"
    }
  }
}, zZ = {
  key: 0,
  class: "flex flex-col"
}, HZ = {
  key: 0,
  class: "mb-1 flex flex-row items-end justify-between"
}, jZ = {
  key: 1,
  class: ""
}, VZ = { class: "mt-1 text-sm text-neutral-400 dark:text-neutral-700" }, OZ = {
  key: 1,
  class: "flex flex-col"
}, $G = {
  __name: "Toggle",
  props: {
    globalConfig: {
      type: Object
    },
    pt: {
      type: Object
    },
    modelValue: {
      type: Boolean,
      default: !1
    },
    disabled: {
      type: Boolean,
      default: !1
    },
    mode: {
      type: String,
      default: "edit"
    },
    label: {
      type: [String, Boolean],
      default: !1
    },
    labelStart: {
      type: [String, Boolean],
      default: !1
    },
    labelEnd: {
      type: [String, Boolean],
      default: !1
    },
    sublabelStart: {
      type: [String, Boolean],
      default: !1
    },
    sublabelEnd: {
      type: [String, Boolean],
      default: !1
    },
    caption: {
      type: [String, Boolean],
      default: !1
    },
    size: {
      type: Number,
      default: 11
    },
    rounded: {
      type: [String, Boolean],
      default: !1
    },
    context: {
      type: String,
      validator: function(e) {
        return ["dark", "neutral", "light"].indexOf(e) !== -1;
      }
    }
  },
  emits: ["update:modelValue"],
  setup(e, { emit: t }) {
    const a = e, o = t, { ep: n } = Te({ props: a, locals: {}, defaults: BZ });
    function i() {
      console.log("onClickToggle"), o("update:modelValue", !a.modelValue);
    }
    return (l, c) => (d(), y("div", P(X(u(n).root)), [
      a.mode == "edit" ? (d(), y("div", zZ, [
        a.label ? (d(), y("div", HZ, [
          a.label ? (d(), y("span", P(H({ key: 0 }, u(n).labelOuter)), G(a.label), 17)) : v("", !0)
        ])) : v("", !0),
        D("div", P(X(u(n).toggleWrap)), [
          a.labelStart || a.sublabelStart ? (d(), y("div", P(H({ key: 0 }, u(n).labelStartWrap)), [
            a.labelStart ? (d(), y("span", P(H({ key: 0 }, u(n).labelStart)), G(a.labelStart), 17)) : v("", !0),
            a.sublabelStart ? (d(), y("span", P(H({ key: 1 }, u(n).sublabelStart)), G(a.sublabelStart), 17)) : v("", !0)
          ], 16)) : v("", !0),
          D("div", H(u(n).toggle, { onClick: i }), [
            ee(l.$slots, "default")
          ], 16),
          a.labelEnd || a.sublabelEnd ? (d(), y("div", P(H({ key: 1 }, u(n).labelEndWrap)), [
            a.labelEnd ? (d(), y("span", P(H({ key: 0 }, u(n).labelEnd)), G(a.labelEnd), 17)) : v("", !0),
            a.sublabelEnd ? (d(), y("span", P(H({ key: 1 }, u(n).sublabelEnd)), G(a.sublabelEnd), 17)) : v("", !0)
          ], 16)) : v("", !0)
        ], 16),
        e.caption || l.$slots.caption ? (d(), y("div", jZ, [
          ee(l.$slots, "caption", {}, () => [
            D("p", VZ, G(e.caption), 1)
          ])
        ])) : v("", !0)
      ])) : v("", !0),
      a.mode == "view" ? (d(), y("div", OZ, [
        a.label || a.labelEnd || a.labelStart ? (d(), y("span", P(H({ key: 0 }, u(n).inputLabel)), G(a.label || a.labelEnd || a.labelStart), 17)) : v("", !0),
        D("p", P(X(u(n).modeViewValue)), G(a.modelValue), 17)
      ])) : v("", !0)
    ], 16));
  }
}, $Z = {
  composer: {
    props: {}
  },
  pt: {
    root: {
      _common: "flex flex-row justify-center"
    },
    panel: {
      _common: "mb-4 bg-neutral-200 rounded-full inline-flex flex-row px-2 items-center h-14 transition-all duration-500 ease-in-out bg-opacity-30 backdrop-blur-sm gap-2",
      propsStateBased: {
        fullWidth: {
          true: "w-full",
          false: "w-auto"
        }
      }
    }
  }
}, RZ = {
  __name: "MenuFloating",
  props: {
    fullWidth: {
      type: Boolean,
      default: !1
    }
  },
  emits: [],
  setup(e, { emit: t }) {
    const a = e, { ep: o } = Te({ props: a, defaults: $Z });
    return (n, i) => (d(), Q(ca, null, {
      default: ke(() => [
        D("div", P(X(u(o).root)), [
          D("div", P(X(u(o).panel)), [
            ee(n.$slots, "buttons")
          ], 16)
        ], 16)
      ]),
      _: 3
    }));
  }
};
process.env.NODE_ENV !== "production" ? Symbol("pinia") : (
  /* istanbul ignore next */
  Symbol()
);
var oI;
(function(e) {
  e.direct = "direct", e.patchObject = "patch object", e.patchFunction = "patch function";
})(oI || (oI = {}));
const FZ = typeof window < "u";
process.env.NODE_ENV !== "production" && process.env.NODE_ENV;
process.env.NODE_ENV !== "production" ? Symbol("pinia:skipHydration") : (
  /* istanbul ignore next */
  Symbol()
);
function UZ(e) {
  {
    e = i1(e);
    const t = {};
    for (const a in e) {
      const o = e[a];
      (C9(o) || aS(o)) && (t[a] = // ---
      ia(e, a));
    }
    return t;
  }
}
const EZ = {
  composer: {
    props: {}
  },
  pt: {
    root: {
      _common: "fixed bottom-2 left-2 right-2 z-[5000] m-auto flex flex-col-reverse items-center justify-center gap-2 transition-all duration-300 ease-in-out",
      propsStateBased: {}
    }
  }
}, RG = {
  __name: "Notifications",
  props: {
    appNotificationsStore: {
      type: Function,
      required: !0
    }
  },
  setup(e) {
    const t = e, { notifications: a } = UZ(t.appNotificationsStore), { ep: o } = Te({ props: t, defaults: EZ });
    return (n, i) => (d(), y("div", P(X(u(o).root)), [
      (d(!0), y(ge, null, Ie(u(a), (l) => (d(), y("div", {
        key: l.id
      }, [
        be(_Z, {
          title: l.title,
          message: l.message,
          type: l.type,
          autohide: l.delay,
          autoposition: !1
        }, null, 8, ["title", "message", "type", "autohide"])
      ]))), 128))
    ], 16));
  }
}, Bb = {
  composer: {
    props: {
      items: {
        default: [
          {
            id: "dashboard",
            title: "Dashboard",
            icon: "Home",
            route: "/admin",
            active: !0
          },
          { id: "users", title: "Users", xicon: "users", route: "/admin/users", active: !1 },
          {
            id: "settings",
            title: "Settings",
            xicon: "cog",
            route: "/admin/settings",
            active: !1
          },
          {
            id: "settings",
            title: "Settings",
            xicon: "cog",
            route: "/admin/settings",
            active: !1
          },
          {
            id: "settings",
            title: "Settings",
            xicon: "cog",
            route: "/admin/settings",
            active: !1
          },
          {
            id: "settings",
            title: "Settings",
            xicon: "cog",
            route: "/admin/settings",
            active: !1
          },
          {
            id: "settings",
            title: "Settings",
            xicon: "cog",
            route: "/admin/settings",
            active: !1
          },
          {
            id: "settings",
            title: "Settings",
            xicon: "cog",
            route: "/admin/settings",
            active: !1
          },
          {
            id: "settings",
            title: "Settings",
            xicon: "cog",
            route: "/admin/settings",
            active: !1
          },
          {
            id: "settings",
            title: "Settings",
            xicon: "cog",
            route: "/admin/settings",
            active: !1
          },
          {
            id: "settings",
            title: "Settings",
            xicon: "cog",
            route: "/admin/settings",
            active: !1
          },
          {
            id: "settings",
            title: "Settings",
            xicon: "cog",
            route: "/admin/settings",
            active: !1
          },
          {
            id: "settings",
            title: "Settings",
            xicon: "cog",
            route: "/admin/settings",
            active: !1
          },
          {
            id: "settings",
            title: "Settings",
            xicon: "cog",
            route: "/admin/settings",
            active: !1
          },
          {
            id: "settings",
            title: "Settings",
            xicon: "cog",
            route: "/admin/settings",
            active: !1
          }
        ],
        control: "input"
      }
    }
  },
  pt: {
    root: {
      _common: "flex flex-col items-start @container grow overflow-y-scroll mt-4 mb-4 md:mt-10 md:mb-10",
      propsStateBased: {}
    },
    items: {
      _common: "flex flex-col gap-0 w-full"
    },
    itemWrap: {
      _common: "rounded-lg hover:bg-neutral-150 dark:hover:bg-neutral-900 w-full px-2 py-2 ease-in-out transition-all duration-300 flex flex-row justify-center @[8rem]:justify-start"
    },
    itemWrapActive: {
      _common: "rounded-lg w-full px-2 py-2 ease-in-out transition-all duration-300 flex flex-row justify-center @[8rem]:justify-start"
    },
    item: {
      _common: "flex cursor-pointer flex-row items-center gap-2 text-xl font-medium text-neutral-400 dark:text-neutral-800 hover:text-neutral-600 dark:hover:text-neutral-600 ease-in-out transition-all duration-300 relative"
    },
    itemActive: {
      _common: "flex cursor-pointer flex-row items-center gap-2 text-xl font-medium text-neutral-900 dark:text-neutral-200"
    },
    itemIcon: {
      _common: "size-5 text-neutral-400 dark:text-neutral-600 shrink-0"
    },
    itemIconActive: {
      _common: "size-5 text-neutral-800 dark:text-neutral-200 shrink-0"
    },
    itemTitle: {
      _common: "hidden @[8rem]:inline text-neutral-400 dark:text-neutral-600 dark:hover:text-neutral-500 whitespace-nowrap",
      propsStateBased: {}
    },
    itemTitleActive: {
      _common: "hidden @[8rem]:inline text-neutral-800 dark:text-neutral-200 whitespace-nowrap"
    }
  }
}, WZ = {
  composer: {
    props: {
      sidebarWidthCollapsed: {
        default: 60,
        control: "input"
      },
      sidebarWidthExpanded: {
        default: 220,
        control: "input"
      },
      sidebarMenuItems: Bb.composer.props.items
    }
  },
  pt: {
    root: {
      _common: "w-full h-screen md:bg-neutral-50 dark:md:bg-neutral-950 p-0 md:p-4",
      propsStateBased: {}
    },
    sidebarMain: {
      _common: "flex flex-row gap-0 h-full",
      propsStateBased: {}
    },
    sidebar: {
      _common: "pr-3 relative transition-all duration-500 ease-in-out shrink-0 overflow-hidden hidden md:block",
      propsStateBased: {}
    },
    resizeHandle: {
      _common: "h-12 w-2 bg-neutral-200 dark:bg-neutral-900 cursor-pointer rounded-full hover:bg-neutral-400 dark:hover:bg-neutral-700 transition-all duration-300 ease-in-out",
      propsStateBased: {}
    },
    main: {
      _common: "bg-white dark:bg-black md:rounded-2xl md:border md:border-neutral-200 dark:md:bg-black dark:md:border-none grow",
      propsStateBased: {
        mainScrollable: {
          true: "md:overflow-y-scroll",
          false: "md:overflow-y-hidden"
        },
        mainPadding: {
          // pb-20 is to fit floating menu on mobile
          true: "p-4 pb-20 md:pb-4",
          false: "p-0 pb-20 md:pb-0"
        }
      }
    }
  }
}, NZ = {
  composer: {
    props: {
      menuItems: Bb.composer.props.items
    }
  },
  pt: {
    root: {
      _common: "flex flex-col justify-between grow max-h-full gap-0 md:h-full",
      propsStateBased: {}
    },
    projectSelectorAndMenuItems: {
      _common: "flex flex-col grow gap-10 max-h-full"
    }
  }
}, ZZ = {
  composer: {
    props: {}
  },
  pt: {
    root: {
      _common: "relative @container z-10",
      propsStateBased: {}
    },
    projectActive: {
      _common: "h-15 flex flex-row items-center justify-between rounded-2xl @[8rem]:border @[8rem]:border-neutral-200 dark:@[8rem]:border-neutral-900 p-0 @[8rem]:p-2 cursor-pointer transition-all duration-300 ease-in-out @[8rem]:active:bg-neutral-200 dark:@[8rem]:active:bg-neutral-800",
      propsStateBased: {
        showProjectsList: {
          true: "@[8rem]:bg-neutral-200 dark:@[8rem]:bg-neutral-900",
          false: "hover:bg-white dark:hover:bg-black"
        }
      }
    },
    selectorChevrons: {
      _common: "pointer-events-none hidden h-6 w-6 shrink-0 text-neutral-400 dark:text-neutral-600 @[8rem]:block"
    },
    project: {
      _common: "flex flex-row items-center gap-2 overflow-x-hidden",
      propsStateBased: {}
    },
    projectsList: {
      _common: "absolute w-full min-w-52 max-h-96 mt-2 flex flex-col gap-0 bg-white dark:bg-black rounded-2xl p-1 border border-neutral-200 dark:border-neutral-900 shadow-xl shadow-neutral-500/10"
    },
    projectsListItem: {
      _common: "flex p-1 flex-row items-center gap-2 hover:bg-neutral-150 dark:hover:bg-neutral-950 rounded-xl cursor-pointer transition-all duration-300 ease-in-out"
    }
  }
}, YZ = /* @__PURE__ */ D("div", { class: "h-11 w-11 shrink-0 rounded-lg bg-neutral-300 dark:bg-neutral-800" }, null, -1), GZ = { class: "mt-0.5 hidden flex-col gap-0 leading-4 @[8rem]:flex" }, XZ = { class: "text-md select-none font-medium text-neutral-900 dark:text-neutral-200" }, KZ = { class: "select-none whitespace-nowrap text-xs text-neutral-400" }, QZ = { class: "overflow-y-scroll" }, JZ = {
  key: 0,
  class: "py-2"
}, eY = /* @__PURE__ */ D("hr", { class: "dark:border-neutral-800" }, null, -1), tY = [
  eY
], aY = ["onClick"], nY = /* @__PURE__ */ D("div", { class: "h-11 w-11 shrink-0 rounded-lg bg-neutral-300 dark:bg-neutral-800" }, null, -1), oY = { class: "mt-0.5 flex flex-col gap-0 leading-4" }, rY = { class: "text-md select-none font-medium text-neutral-900 dark:text-neutral-200" }, iY = { class: "select-none text-xs text-neutral-400 dark:text-neutral-500" }, lY = {
  __name: "AdminSidebarProjectSelector",
  props: {
    projects: {
      type: Array,
      default: () => [
        // {
        //   id: 1,
        //   title: "Project 1",
        //   subtitle: "Project Description",
        //   active: true,
        // },
        // {
        //   id: 2,
        //   title: "Project 2",
        //   subtitle: "Project Description",
        //   active: false,
        // },
        // {
        //   id: 3,
        //   title: "Project 3",
        //   subtitle: "Project Description",
        //   active: false,
        // },
      ]
    }
  },
  emits: ["projectSelected"],
  setup(e, { emit: t }) {
    const a = e, o = t, n = W(null), i = W(null), l = W(!1), c = W(null), s = N(() => a.projects ? a.projects.find((q) => q.active) : null), h = N(() => a.projects ? a.projects.filter((q) => !q.active) : []), m = N(() => c.value ? h.value.filter((q) => {
      if (q.id === "separator")
        return !1;
      const _ = c.value.toLowerCase().trim(), b = q.title.toLowerCase().trim(), L = q.subtitle.toLowerCase().trim();
      return b.includes(_) || L.includes(_);
    }) : h.value);
    function p() {
      console.log("onClickProjectActive"), l.value = !l.value;
    }
    function f(q, _) {
      console.log("onClickProject", q, _ == null ? void 0 : _.metaKey), (_ == null ? void 0 : _.metaKey) === !1 && (l.value = !1), o("projectSelected", { project: q, e: _ }), s.value.active = !1;
    }
    function g(q) {
      q.target !== n.value && (q.metaKey || (l.value = !1));
    }
    ot(l, (q) => {
      q ? window.addEventListener("click", g) : window.removeEventListener("click", g);
    });
    const { ep: w } = Te({ props: a, defaults: ZZ, locals: { showProjectsList: l } });
    return (q, _) => (d(), y("div", P(X(u(w).root)), [
      D("div", H({
        ref_key: "elProjectActive",
        ref: n
      }, u(w).projectActive, { onClick: p }), [
        s.value ? (d(), y("div", H({
          key: 0,
          class: "pointer-events-none"
        }, u(w).project), [
          YZ,
          D("div", GZ, [
            D("span", XZ, G(s.value.title), 1),
            D("span", KZ, G(s.value.subtitle), 1)
          ])
        ], 16)) : v("", !0),
        Zt(be(We, H({ lucide: "ChevronsUpDown" }, u(w).selectorChevrons), null, 16), [
          [Yt, !l.value]
        ]),
        Zt(be(We, H({ lucide: "ChevronsDownUp" }, u(w).selectorChevrons), null, 16), [
          [Yt, l.value]
        ])
      ], 16),
      l.value ? (d(), y("div", P(H({ key: 0 }, u(w).projectsList)), [
        be(Wx, {
          ref_key: "elFilter",
          ref: i,
          modelValue: c.value,
          "onUpdate:modelValue": _[0] || (_[0] = (b) => c.value = b),
          placeholder: "filter projects",
          class: "mb-2",
          focus: !0,
          fullWidth: ""
        }, null, 8, ["modelValue"]),
        D("div", QZ, [
          (d(!0), y(ge, null, Ie(m.value, (b) => (d(), y("div", {
            key: b.id
          }, [
            b.id === "separator" ? (d(), y("div", JZ, tY)) : (d(), y("div", H({ key: 1 }, u(w).projectsListItem, {
              onClick: (L) => f(b, L)
            }), [
              nY,
              D("div", oY, [
                D("span", rY, G(b.title), 1),
                D("span", iY, G(b.subtitle), 1)
              ])
            ], 16, aY))
          ]))), 128))
        ])
      ], 16)) : v("", !0)
    ], 16));
  }
}, cY = {
  key: 1,
  class: "size-5 shrink-0 rounded-md bg-neutral-300 dark:bg-neutral-900"
}, dY = {
  __name: "AdminSidebarMenu",
  props: {
    items: {
      type: Array,
      default: () => []
    }
  },
  emits: ["itemClick"],
  setup(e, { emit: t }) {
    const a = e, o = t, { ep: n } = Te({ props: a, defaults: Bb });
    function i(h) {
      return h.active ? n.value.itemActive : n.value.item;
    }
    function l(h) {
      return h.active ? n.value.itemWrapActive : n.value.itemWrap;
    }
    function c(h) {
      return h.active ? n.value.itemIconActive : n.value.itemIcon;
    }
    function s(h) {
      return h.active ? n.value.itemTitleActive : n.value.itemTitle;
    }
    return (h, m) => {
      const p = Dx("RouterLink");
      return d(), y("div", P(X(u(n).root)), [
        D("div", P(X(u(n).items)), [
          (d(!0), y(ge, null, Ie(e.items, (f) => (d(), y("span", H(l(f), {
            key: f.id
          }), [
            be(p, H({ class: "block" }, i(f), {
              to: f.route,
              onClick: (g) => o("itemClick", f)
            }), {
              default: ke(() => [
                f.icon ? (d(), Q(We, H({ key: 0 }, c(f), {
                  lucide: f.icon,
                  lucideStrokeWidth: 2.5
                }), null, 16, ["lucide"])) : v("", !0),
                f.icon ? v("", !0) : (d(), y("span", cY)),
                D("span", P(X(s(f))), G(f.title), 17)
              ]),
              _: 2
            }, 1040, ["to", "onClick"])
          ], 16))), 128))
        ], 16)
      ], 16);
    };
  }
}, sY = {
  composer: {
    props: {}
  },
  pt: {
    root: {
      _common: "relative @container",
      propsStateBased: {}
    },
    userBox: {
      _common: "flex transition-all duration-300 ease-in-out @[8rem]:hover:bg-neutral-150 dark:hover:bg-neutral-800 cursor-pointer flex-row gap-2 rounded-full p-1 ",
      propsStateBased: {}
    },
    userBoxImage: {
      _common: "pointer-events-none h-11 w-11 shrink-0 select-none rounded-full bg-neutral-300 dark:bg-neutral-800"
    },
    userBoxTitleSubtitle: {
      _common: "pointer-events-none mt-1.5 hidden select-none flex-col gap-0 leading-4 @[8rem]:flex"
    },
    userBoxTitle: {
      _common: "text-md whitespace-nowrap font-medium text-neutral-900 dark:text-neutral-400"
    },
    userBoxSubtitle: {
      _common: "whitespace-nowrap text-xs text-neutral-400 dark:text-neutral-600"
    },
    popup: {
      _common: "absolute bottom-14 w-full min-w-52 flex flex-col gap-0 bg-white dark:bg-black rounded-2xl p-1 border border-neutral-200 dark:border-neutral-800 shadow-xl shadow-neutral-500/10 dark:shadow-neutral-800/10"
    }
  }
}, uY = ["src"], hY = {
  __name: "AdminSidebarUser",
  props: {
    title: {
      type: String,
      default: "User Name"
    },
    subtitle: {
      type: String,
      default: "User email"
    },
    imageURL: {
      type: String,
      default: ""
    }
  },
  setup(e) {
    const t = e, a = W(null), o = W(null), n = W(!1), { ep: i } = Te({ props: t, defaults: sY });
    function l() {
      console.log("onClickUserBox"), n.value = !n.value;
    }
    function c(s) {
      !a.value || !o.value || a.value.contains(s.target) || o.value.contains(s.target) || (n.value = !1);
    }
    return ot(n, (s) => {
      s ? window.addEventListener("click", c) : window.removeEventListener("click", c);
    }), (s, h) => (d(), y("div", P(X(u(i).root)), [
      n.value ? (d(), y("div", H({
        key: 0,
        ref_key: "elPopup",
        ref: o
      }, u(i).popup), [
        ee(s.$slots, "popup")
      ], 16)) : v("", !0),
      D("div", H({
        ref_key: "elUserBox",
        ref: a
      }, u(i).userBox, { onClick: l }), [
        e.imageURL ? (d(), y("img", H({ key: 0 }, u(i).userBoxImage, { src: e.imageURL }), null, 16, uY)) : v("", !0),
        e.imageURL ? v("", !0) : (d(), y("div", P(H({ key: 1 }, u(i).userBoxImage)), null, 16)),
        D("div", P(X(u(i).userBoxTitleSubtitle)), [
          D("span", P(X(u(i).userBoxTitle)), G(e.title), 17),
          D("span", P(X(u(i).userBoxSubtitle)), G(e.subtitle), 17)
        ], 16)
      ], 16)
    ], 16));
  }
}, rI = {
  __name: "AdminSidebar",
  props: {
    menuItems: {
      type: Array,
      default: () => []
    },
    user: {
      type: Object
    },
    projects: {
      type: Array
    },
    showProjectSelector: {
      type: Boolean,
      default: !0
    }
  },
  emits: ["projectSelected", "menuItemClick"],
  setup(e, { emit: t }) {
    const a = e, o = t, { ep: n } = Te({ props: a, defaults: NZ });
    return (i, l) => (d(), y("div", P(X(u(n).root)), [
      ee(i.$slots, "logo"),
      e.showProjectSelector ? (d(), Q(lY, {
        key: 0,
        projects: e.projects,
        onProjectSelected: l[0] || (l[0] = (c) => o("projectSelected", c))
      }, null, 8, ["projects"])) : v("", !0),
      be(dY, {
        items: e.menuItems,
        onItemClick: l[1] || (l[1] = (c) => o("menuItemClick", c))
      }, null, 8, ["items"]),
      ee(i.$slots, "additionalContent"),
      be(hY, P(X(e.user)), {
        popup: ke(() => [
          ee(i.$slots, "userPopup")
        ]),
        _: 3
      }, 16)
    ], 16));
  }
}, pY = { class: "absolute bottom-0 right-2 top-0 flex flex-col justify-center" }, yY = {
  key: 0,
  class: "flex grow flex-col justify-between overflow-hidden rounded-3xl border border-neutral-200 bg-white p-4"
}, kY = { class: "pointer-events-auto z-50 flex w-full flex-center md:hidden" }, fY = {
  key: 0,
  class: "absolute inset-0 z-40 bg-neutral-900 bg-opacity-90 backdrop-blur-sm"
}, FG = {
  __name: "ViewAdmin",
  props: {
    sidebarWidthCollapsed: {
      type: Number,
      default: 60
    },
    sidebarWidthExpanded: {
      type: Number,
      default: 220
    },
    sidebarShowProjectSelector: {
      type: Boolean,
      default: !0
    },
    sidebarProjects: {
      type: Array
    },
    sidebarMenuItems: {
      type: Array,
      default: () => []
    },
    sidebarUser: Object,
    mainScrollable: {
      type: Boolean,
      default: !0
    },
    mainPadding: {
      type: Boolean,
      default: !0
    },
    menuShowBackButton: {
      type: Boolean,
      default: !0
    }
  },
  emits: ["clickResizeHandle", "projectSelected", "sidebarMenuItemClick"],
  setup(e, { emit: t }) {
    const a = e, o = t, { ep: n } = Te({ props: a, defaults: WZ }), i = W("expanded"), l = W(!1), c = N(() => i.value === "expanded" ? a.sidebarWidthExpanded : a.sidebarWidthCollapsed), s = () => {
      i.value = i.value === "expanded" ? "collapsed" : "expanded", o("clickResizeHandle", i.value);
    }, h = (p) => {
      console.log("onSidebarMenuItemClick", p), o("sidebarMenuItemClick", p), l.value = !1;
    }, m = () => {
      l.value = !l.value;
    };
    return (p, f) => (d(), y("div", P(X(u(n).root)), [
      D("div", P(X(u(n).sidebarMain)), [
        D("div", H(u(n).sidebar, {
          style: { width: c.value + "px" }
        }), [
          ee(p.$slots, "sidebar", {}, () => [
            be(rI, {
              projects: e.sidebarProjects,
              menuItems: e.sidebarMenuItems,
              user: e.sidebarUser,
              showProjectSelector: e.sidebarShowProjectSelector,
              onProjectSelected: f[0] || (f[0] = (g) => o("projectSelected", g))
            }, {
              logo: ke(() => [
                ee(p.$slots, "logo")
              ]),
              additionalContent: ke(() => [
                ee(p.$slots, "additionalContent")
              ]),
              userPopup: ke(() => [
                ee(p.$slots, "userPopup")
              ]),
              _: 3
            }, 8, ["projects", "menuItems", "user", "showProjectSelector"])
          ]),
          D("div", pY, [
            D("div", H(u(n).resizeHandle, { onClick: s }), null, 16)
          ])
        ], 16),
        D("div", {
          class: Pe([
            {
              "fixed inset-0 z-50 flex flex-col justify-end gap-2 p-2 pb-0 md:hidden": l.value
            },
            {
              "fixed bottom-0 left-0 right-0 z-50 flex flex-col justify-end gap-2 p-2 pb-0 md:hidden": !l.value
            }
          ])
        }, [
          l.value ? (d(), y("div", yY, [
            ee(p.$slots, "sidebar", {}, () => [
              be(rI, {
                menuItems: e.sidebarMenuItems,
                user: e.sidebarUser,
                showProjectSelector: e.sidebarShowProjectSelector,
                onMenuItemClick: h
              }, {
                logo: ke(() => [
                  ee(p.$slots, "logo")
                ]),
                additionalContent: ke(() => [
                  ee(p.$slots, "additionalContent")
                ]),
                userPopup: ke(() => [
                  ee(p.$slots, "userPopup")
                ]),
                _: 3
              }, 8, ["menuItems", "user", "showProjectSelector"])
            ])
          ])) : v("", !0),
          D("div", kY, [
            be(RZ, null, {
              buttons: ke(() => [
                e.menuShowBackButton ? (d(), Q(bt, {
                  key: 0,
                  circle: "",
                  icon: "ArrowLeft",
                  variant: "secondary",
                  iconStrokeWidth: 3,
                  onAction: f[1] || (f[1] = (g) => p.$router.back())
                })) : v("", !0),
                be(bt, {
                  circle: "",
                  icon: "Ellipsis",
                  variant: "primary",
                  kind: "solid",
                  iconStrokeWidth: 3,
                  onAction: m
                })
              ]),
              _: 1
            })
          ])
        ], 2),
        l.value ? (d(), y("div", fY)) : v("", !0),
        D("div", P(X(u(n).main)), [
          ee(p.$slots, "main")
        ], 16)
      ], 16)
    ], 16));
  }
};
function vY() {
  for (var e = 0, t, a, o = ""; e < arguments.length; )
    (t = arguments[e++]) && (a = NL(t)) && (o && (o += " "), o += a);
  return o;
}
function NL(e) {
  if (typeof e == "string")
    return e;
  for (var t, a = "", o = 0; o < e.length; o++)
    e[o] && (t = NL(e[o])) && (a && (a += " "), a += t);
  return a;
}
var zb = "-";
function mY(e) {
  var t = MY(e), a = e.conflictingClassGroups, o = e.conflictingClassGroupModifiers, n = o === void 0 ? {} : o;
  function i(c) {
    var s = c.split(zb);
    return s[0] === "" && s.length !== 1 && s.shift(), ZL(s, t) || gY(c);
  }
  function l(c, s) {
    var h = a[c] || [];
    return s && n[c] ? [].concat(h, n[c]) : h;
  }
  return {
    getClassGroupId: i,
    getConflictingClassGroupIds: l
  };
}
function ZL(e, t) {
  var l;
  if (e.length === 0)
    return t.classGroupId;
  var a = e[0], o = t.nextPart.get(a), n = o ? ZL(e.slice(1), o) : void 0;
  if (n)
    return n;
  if (t.validators.length !== 0) {
    var i = e.join(zb);
    return (l = t.validators.find(function(c) {
      var s = c.validator;
      return s(i);
    })) == null ? void 0 : l.classGroupId;
  }
}
var iI = /^\[(.+)\]$/;
function gY(e) {
  if (iI.test(e)) {
    var t = iI.exec(e)[1], a = t == null ? void 0 : t.substring(0, t.indexOf(":"));
    if (a)
      return "arbitrary.." + a;
  }
}
function MY(e) {
  var t = e.theme, a = e.prefix, o = {
    nextPart: /* @__PURE__ */ new Map(),
    validators: []
  }, n = bY(Object.entries(e.classGroups), a);
  return n.forEach(function(i) {
    var l = i[0], c = i[1];
    E9(c, o, l, t);
  }), o;
}
function E9(e, t, a, o) {
  e.forEach(function(n) {
    if (typeof n == "string") {
      var i = n === "" ? t : lI(t, n);
      i.classGroupId = a;
      return;
    }
    if (typeof n == "function") {
      if (xY(n)) {
        E9(n(o), t, a, o);
        return;
      }
      t.validators.push({
        validator: n,
        classGroupId: a
      });
      return;
    }
    Object.entries(n).forEach(function(l) {
      var c = l[0], s = l[1];
      E9(s, lI(t, c), a, o);
    });
  });
}
function lI(e, t) {
  var a = e;
  return t.split(zb).forEach(function(o) {
    a.nextPart.has(o) || a.nextPart.set(o, {
      nextPart: /* @__PURE__ */ new Map(),
      validators: []
    }), a = a.nextPart.get(o);
  }), a;
}
function xY(e) {
  return e.isThemeGetter;
}
function bY(e, t) {
  return t ? e.map(function(a) {
    var o = a[0], n = a[1], i = n.map(function(l) {
      return typeof l == "string" ? t + l : typeof l == "object" ? Object.fromEntries(Object.entries(l).map(function(c) {
        var s = c[0], h = c[1];
        return [t + s, h];
      })) : l;
    });
    return [o, i];
  }) : e;
}
function wY(e) {
  if (e < 1)
    return {
      get: function() {
      },
      set: function() {
      }
    };
  var t = 0, a = /* @__PURE__ */ new Map(), o = /* @__PURE__ */ new Map();
  function n(i, l) {
    a.set(i, l), t++, t > e && (t = 0, o = a, a = /* @__PURE__ */ new Map());
  }
  return {
    get: function(l) {
      var c = a.get(l);
      if (c !== void 0)
        return c;
      if ((c = o.get(l)) !== void 0)
        return n(l, c), c;
    },
    set: function(l, c) {
      a.has(l) ? a.set(l, c) : n(l, c);
    }
  };
}
var YL = "!";
function IY(e) {
  var t = e.separator || ":", a = t.length === 1, o = t[0], n = t.length;
  return function(l) {
    for (var c = [], s = 0, h = 0, m, p = 0; p < l.length; p++) {
      var f = l[p];
      if (s === 0) {
        if (f === o && (a || l.slice(p, p + n) === t)) {
          c.push(l.slice(h, p)), h = p + n;
          continue;
        }
        if (f === "/") {
          m = p;
          continue;
        }
      }
      f === "[" ? s++ : f === "]" && s--;
    }
    var g = c.length === 0 ? l : l.substring(h), w = g.startsWith(YL), q = w ? g.substring(1) : g, _ = m && m > h ? m - h : void 0;
    return {
      modifiers: c,
      hasImportantModifier: w,
      baseClassName: q,
      maybePostfixModifierPosition: _
    };
  };
}
function LY(e) {
  if (e.length <= 1)
    return e;
  var t = [], a = [];
  return e.forEach(function(o) {
    var n = o[0] === "[";
    n ? (t.push.apply(t, a.sort().concat([o])), a = []) : a.push(o);
  }), t.push.apply(t, a.sort()), t;
}
function SY(e) {
  return {
    cache: wY(e.cacheSize),
    splitModifiers: IY(e),
    ...mY(e)
  };
}
var CY = /\s+/;
function AY(e, t) {
  var a = t.splitModifiers, o = t.getClassGroupId, n = t.getConflictingClassGroupIds, i = /* @__PURE__ */ new Set();
  return e.trim().split(CY).map(function(l) {
    var c = a(l), s = c.modifiers, h = c.hasImportantModifier, m = c.baseClassName, p = c.maybePostfixModifierPosition, f = o(p ? m.substring(0, p) : m), g = !!p;
    if (!f) {
      if (!p)
        return {
          isTailwindClass: !1,
          originalClassName: l
        };
      if (f = o(m), !f)
        return {
          isTailwindClass: !1,
          originalClassName: l
        };
      g = !1;
    }
    var w = LY(s).join(":"), q = h ? w + YL : w;
    return {
      isTailwindClass: !0,
      modifierId: q,
      classGroupId: f,
      originalClassName: l,
      hasPostfixModifier: g
    };
  }).reverse().filter(function(l) {
    if (!l.isTailwindClass)
      return !0;
    var c = l.modifierId, s = l.classGroupId, h = l.hasPostfixModifier, m = c + s;
    return i.has(m) ? !1 : (i.add(m), n(s, h).forEach(function(p) {
      return i.add(c + p);
    }), !0);
  }).reverse().map(function(l) {
    return l.originalClassName;
  }).join(" ");
}
function PY() {
  for (var e = arguments.length, t = new Array(e), a = 0; a < e; a++)
    t[a] = arguments[a];
  var o, n, i, l = c;
  function c(h) {
    var m = t[0], p = t.slice(1), f = p.reduce(function(g, w) {
      return w(g);
    }, m());
    return o = SY(f), n = o.cache.get, i = o.cache.set, l = s, s(h);
  }
  function s(h) {
    var m = n(h);
    if (m)
      return m;
    var p = AY(h, o);
    return i(h, p), p;
  }
  return function() {
    return l(vY.apply(null, arguments));
  };
}
function Ze(e) {
  var t = function(o) {
    return o[e] || [];
  };
  return t.isThemeGetter = !0, t;
}
var GL = /^\[(?:([a-z-]+):)?(.+)\]$/i, qY = /^\d+\/\d+$/, TY = /* @__PURE__ */ new Set(["px", "full", "screen"]), DY = /^(\d+(\.\d+)?)?(xs|sm|md|lg|xl)$/, _Y = /\d+(%|px|r?em|[sdl]?v([hwib]|min|max)|pt|pc|in|cm|mm|cap|ch|ex|r?lh|cq(w|h|i|b|min|max))|\b(calc|min|max|clamp)\(.+\)|^0$/, BY = /^-?((\d+)?\.?(\d+)[a-z]+|0)_-?((\d+)?\.?(\d+)[a-z]+|0)/;
function St(e) {
  return gr(e) || TY.has(e) || qY.test(e) || W9(e);
}
function W9(e) {
  return Pr(e, "length", $Y);
}
function zY(e) {
  return Pr(e, "size", XL);
}
function HY(e) {
  return Pr(e, "position", XL);
}
function jY(e) {
  return Pr(e, "url", RY);
}
function P1(e) {
  return Pr(e, "number", gr);
}
function gr(e) {
  return !Number.isNaN(Number(e));
}
function VY(e) {
  return e.endsWith("%") && gr(e.slice(0, -1));
}
function a1(e) {
  return cI(e) || Pr(e, "number", cI);
}
function _e(e) {
  return GL.test(e);
}
function n1() {
  return !0;
}
function ta(e) {
  return DY.test(e);
}
function OY(e) {
  return Pr(e, "", FY);
}
function Pr(e, t, a) {
  var o = GL.exec(e);
  return o ? o[1] ? o[1] === t : a(o[2]) : !1;
}
function $Y(e) {
  return _Y.test(e);
}
function XL() {
  return !1;
}
function RY(e) {
  return e.startsWith("url(");
}
function cI(e) {
  return Number.isInteger(Number(e));
}
function FY(e) {
  return BY.test(e);
}
function UY() {
  var e = Ze("colors"), t = Ze("spacing"), a = Ze("blur"), o = Ze("brightness"), n = Ze("borderColor"), i = Ze("borderRadius"), l = Ze("borderSpacing"), c = Ze("borderWidth"), s = Ze("contrast"), h = Ze("grayscale"), m = Ze("hueRotate"), p = Ze("invert"), f = Ze("gap"), g = Ze("gradientColorStops"), w = Ze("gradientColorStopPositions"), q = Ze("inset"), _ = Ze("margin"), b = Ze("opacity"), L = Ze("padding"), j = Ze("saturate"), I = Ze("scale"), C = Ze("sepia"), B = Ze("skew"), U = Ze("space"), de = Ze("translate"), ae = function() {
    return ["auto", "contain", "none"];
  }, S = function() {
    return ["auto", "hidden", "clip", "visible", "scroll"];
  }, V = function() {
    return ["auto", _e, t];
  }, Z = function() {
    return [_e, t];
  }, re = function() {
    return ["", St];
  }, F = function() {
    return ["auto", gr, _e];
  }, A = function() {
    return ["bottom", "center", "left", "left-bottom", "left-top", "right", "right-bottom", "right-top", "top"];
  }, $ = function() {
    return ["solid", "dashed", "dotted", "double", "none"];
  }, R = function() {
    return ["normal", "multiply", "screen", "overlay", "darken", "lighten", "color-dodge", "color-burn", "hard-light", "soft-light", "difference", "exclusion", "hue", "saturation", "color", "luminosity", "plus-lighter"];
  }, J = function() {
    return ["start", "end", "center", "between", "around", "evenly", "stretch"];
  }, M = function() {
    return ["", "0", _e];
  }, k = function() {
    return ["auto", "avoid", "all", "avoid-page", "page", "left", "right", "column"];
  }, O = function() {
    return [gr, P1];
  }, E = function() {
    return [gr, _e];
  };
  return {
    cacheSize: 500,
    theme: {
      colors: [n1],
      spacing: [St],
      blur: ["none", "", ta, _e],
      brightness: O(),
      borderColor: [e],
      borderRadius: ["none", "", "full", ta, _e],
      borderSpacing: Z(),
      borderWidth: re(),
      contrast: O(),
      grayscale: M(),
      hueRotate: E(),
      invert: M(),
      gap: Z(),
      gradientColorStops: [e],
      gradientColorStopPositions: [VY, W9],
      inset: V(),
      margin: V(),
      opacity: O(),
      padding: Z(),
      saturate: O(),
      scale: O(),
      sepia: M(),
      skew: E(),
      space: Z(),
      translate: Z()
    },
    classGroups: {
      // Layout
      /**
       * Aspect Ratio
       * @see https://tailwindcss.com/docs/aspect-ratio
       */
      aspect: [{
        aspect: ["auto", "square", "video", _e]
      }],
      /**
       * Container
       * @see https://tailwindcss.com/docs/container
       */
      container: ["container"],
      /**
       * Columns
       * @see https://tailwindcss.com/docs/columns
       */
      columns: [{
        columns: [ta]
      }],
      /**
       * Break After
       * @see https://tailwindcss.com/docs/break-after
       */
      "break-after": [{
        "break-after": k()
      }],
      /**
       * Break Before
       * @see https://tailwindcss.com/docs/break-before
       */
      "break-before": [{
        "break-before": k()
      }],
      /**
       * Break Inside
       * @see https://tailwindcss.com/docs/break-inside
       */
      "break-inside": [{
        "break-inside": ["auto", "avoid", "avoid-page", "avoid-column"]
      }],
      /**
       * Box Decoration Break
       * @see https://tailwindcss.com/docs/box-decoration-break
       */
      "box-decoration": [{
        "box-decoration": ["slice", "clone"]
      }],
      /**
       * Box Sizing
       * @see https://tailwindcss.com/docs/box-sizing
       */
      box: [{
        box: ["border", "content"]
      }],
      /**
       * Display
       * @see https://tailwindcss.com/docs/display
       */
      display: ["block", "inline-block", "inline", "flex", "inline-flex", "table", "inline-table", "table-caption", "table-cell", "table-column", "table-column-group", "table-footer-group", "table-header-group", "table-row-group", "table-row", "flow-root", "grid", "inline-grid", "contents", "list-item", "hidden"],
      /**
       * Floats
       * @see https://tailwindcss.com/docs/float
       */
      float: [{
        float: ["right", "left", "none"]
      }],
      /**
       * Clear
       * @see https://tailwindcss.com/docs/clear
       */
      clear: [{
        clear: ["left", "right", "both", "none"]
      }],
      /**
       * Isolation
       * @see https://tailwindcss.com/docs/isolation
       */
      isolation: ["isolate", "isolation-auto"],
      /**
       * Object Fit
       * @see https://tailwindcss.com/docs/object-fit
       */
      "object-fit": [{
        object: ["contain", "cover", "fill", "none", "scale-down"]
      }],
      /**
       * Object Position
       * @see https://tailwindcss.com/docs/object-position
       */
      "object-position": [{
        object: [].concat(A(), [_e])
      }],
      /**
       * Overflow
       * @see https://tailwindcss.com/docs/overflow
       */
      overflow: [{
        overflow: S()
      }],
      /**
       * Overflow X
       * @see https://tailwindcss.com/docs/overflow
       */
      "overflow-x": [{
        "overflow-x": S()
      }],
      /**
       * Overflow Y
       * @see https://tailwindcss.com/docs/overflow
       */
      "overflow-y": [{
        "overflow-y": S()
      }],
      /**
       * Overscroll Behavior
       * @see https://tailwindcss.com/docs/overscroll-behavior
       */
      overscroll: [{
        overscroll: ae()
      }],
      /**
       * Overscroll Behavior X
       * @see https://tailwindcss.com/docs/overscroll-behavior
       */
      "overscroll-x": [{
        "overscroll-x": ae()
      }],
      /**
       * Overscroll Behavior Y
       * @see https://tailwindcss.com/docs/overscroll-behavior
       */
      "overscroll-y": [{
        "overscroll-y": ae()
      }],
      /**
       * Position
       * @see https://tailwindcss.com/docs/position
       */
      position: ["static", "fixed", "absolute", "relative", "sticky"],
      /**
       * Top / Right / Bottom / Left
       * @see https://tailwindcss.com/docs/top-right-bottom-left
       */
      inset: [{
        inset: [q]
      }],
      /**
       * Right / Left
       * @see https://tailwindcss.com/docs/top-right-bottom-left
       */
      "inset-x": [{
        "inset-x": [q]
      }],
      /**
       * Top / Bottom
       * @see https://tailwindcss.com/docs/top-right-bottom-left
       */
      "inset-y": [{
        "inset-y": [q]
      }],
      /**
       * Start
       * @see https://tailwindcss.com/docs/top-right-bottom-left
       */
      start: [{
        start: [q]
      }],
      /**
       * End
       * @see https://tailwindcss.com/docs/top-right-bottom-left
       */
      end: [{
        end: [q]
      }],
      /**
       * Top
       * @see https://tailwindcss.com/docs/top-right-bottom-left
       */
      top: [{
        top: [q]
      }],
      /**
       * Right
       * @see https://tailwindcss.com/docs/top-right-bottom-left
       */
      right: [{
        right: [q]
      }],
      /**
       * Bottom
       * @see https://tailwindcss.com/docs/top-right-bottom-left
       */
      bottom: [{
        bottom: [q]
      }],
      /**
       * Left
       * @see https://tailwindcss.com/docs/top-right-bottom-left
       */
      left: [{
        left: [q]
      }],
      /**
       * Visibility
       * @see https://tailwindcss.com/docs/visibility
       */
      visibility: ["visible", "invisible", "collapse"],
      /**
       * Z-Index
       * @see https://tailwindcss.com/docs/z-index
       */
      z: [{
        z: ["auto", a1]
      }],
      // Flexbox and Grid
      /**
       * Flex Basis
       * @see https://tailwindcss.com/docs/flex-basis
       */
      basis: [{
        basis: V()
      }],
      /**
       * Flex Direction
       * @see https://tailwindcss.com/docs/flex-direction
       */
      "flex-direction": [{
        flex: ["row", "row-reverse", "col", "col-reverse"]
      }],
      /**
       * Flex Wrap
       * @see https://tailwindcss.com/docs/flex-wrap
       */
      "flex-wrap": [{
        flex: ["wrap", "wrap-reverse", "nowrap"]
      }],
      /**
       * Flex
       * @see https://tailwindcss.com/docs/flex
       */
      flex: [{
        flex: ["1", "auto", "initial", "none", _e]
      }],
      /**
       * Flex Grow
       * @see https://tailwindcss.com/docs/flex-grow
       */
      grow: [{
        grow: M()
      }],
      /**
       * Flex Shrink
       * @see https://tailwindcss.com/docs/flex-shrink
       */
      shrink: [{
        shrink: M()
      }],
      /**
       * Order
       * @see https://tailwindcss.com/docs/order
       */
      order: [{
        order: ["first", "last", "none", a1]
      }],
      /**
       * Grid Template Columns
       * @see https://tailwindcss.com/docs/grid-template-columns
       */
      "grid-cols": [{
        "grid-cols": [n1]
      }],
      /**
       * Grid Column Start / End
       * @see https://tailwindcss.com/docs/grid-column
       */
      "col-start-end": [{
        col: ["auto", {
          span: ["full", a1]
        }, _e]
      }],
      /**
       * Grid Column Start
       * @see https://tailwindcss.com/docs/grid-column
       */
      "col-start": [{
        "col-start": F()
      }],
      /**
       * Grid Column End
       * @see https://tailwindcss.com/docs/grid-column
       */
      "col-end": [{
        "col-end": F()
      }],
      /**
       * Grid Template Rows
       * @see https://tailwindcss.com/docs/grid-template-rows
       */
      "grid-rows": [{
        "grid-rows": [n1]
      }],
      /**
       * Grid Row Start / End
       * @see https://tailwindcss.com/docs/grid-row
       */
      "row-start-end": [{
        row: ["auto", {
          span: [a1]
        }, _e]
      }],
      /**
       * Grid Row Start
       * @see https://tailwindcss.com/docs/grid-row
       */
      "row-start": [{
        "row-start": F()
      }],
      /**
       * Grid Row End
       * @see https://tailwindcss.com/docs/grid-row
       */
      "row-end": [{
        "row-end": F()
      }],
      /**
       * Grid Auto Flow
       * @see https://tailwindcss.com/docs/grid-auto-flow
       */
      "grid-flow": [{
        "grid-flow": ["row", "col", "dense", "row-dense", "col-dense"]
      }],
      /**
       * Grid Auto Columns
       * @see https://tailwindcss.com/docs/grid-auto-columns
       */
      "auto-cols": [{
        "auto-cols": ["auto", "min", "max", "fr", _e]
      }],
      /**
       * Grid Auto Rows
       * @see https://tailwindcss.com/docs/grid-auto-rows
       */
      "auto-rows": [{
        "auto-rows": ["auto", "min", "max", "fr", _e]
      }],
      /**
       * Gap
       * @see https://tailwindcss.com/docs/gap
       */
      gap: [{
        gap: [f]
      }],
      /**
       * Gap X
       * @see https://tailwindcss.com/docs/gap
       */
      "gap-x": [{
        "gap-x": [f]
      }],
      /**
       * Gap Y
       * @see https://tailwindcss.com/docs/gap
       */
      "gap-y": [{
        "gap-y": [f]
      }],
      /**
       * Justify Content
       * @see https://tailwindcss.com/docs/justify-content
       */
      "justify-content": [{
        justify: ["normal"].concat(J())
      }],
      /**
       * Justify Items
       * @see https://tailwindcss.com/docs/justify-items
       */
      "justify-items": [{
        "justify-items": ["start", "end", "center", "stretch"]
      }],
      /**
       * Justify Self
       * @see https://tailwindcss.com/docs/justify-self
       */
      "justify-self": [{
        "justify-self": ["auto", "start", "end", "center", "stretch"]
      }],
      /**
       * Align Content
       * @see https://tailwindcss.com/docs/align-content
       */
      "align-content": [{
        content: ["normal"].concat(J(), ["baseline"])
      }],
      /**
       * Align Items
       * @see https://tailwindcss.com/docs/align-items
       */
      "align-items": [{
        items: ["start", "end", "center", "baseline", "stretch"]
      }],
      /**
       * Align Self
       * @see https://tailwindcss.com/docs/align-self
       */
      "align-self": [{
        self: ["auto", "start", "end", "center", "stretch", "baseline"]
      }],
      /**
       * Place Content
       * @see https://tailwindcss.com/docs/place-content
       */
      "place-content": [{
        "place-content": [].concat(J(), ["baseline"])
      }],
      /**
       * Place Items
       * @see https://tailwindcss.com/docs/place-items
       */
      "place-items": [{
        "place-items": ["start", "end", "center", "baseline", "stretch"]
      }],
      /**
       * Place Self
       * @see https://tailwindcss.com/docs/place-self
       */
      "place-self": [{
        "place-self": ["auto", "start", "end", "center", "stretch"]
      }],
      // Spacing
      /**
       * Padding
       * @see https://tailwindcss.com/docs/padding
       */
      p: [{
        p: [L]
      }],
      /**
       * Padding X
       * @see https://tailwindcss.com/docs/padding
       */
      px: [{
        px: [L]
      }],
      /**
       * Padding Y
       * @see https://tailwindcss.com/docs/padding
       */
      py: [{
        py: [L]
      }],
      /**
       * Padding Start
       * @see https://tailwindcss.com/docs/padding
       */
      ps: [{
        ps: [L]
      }],
      /**
       * Padding End
       * @see https://tailwindcss.com/docs/padding
       */
      pe: [{
        pe: [L]
      }],
      /**
       * Padding Top
       * @see https://tailwindcss.com/docs/padding
       */
      pt: [{
        pt: [L]
      }],
      /**
       * Padding Right
       * @see https://tailwindcss.com/docs/padding
       */
      pr: [{
        pr: [L]
      }],
      /**
       * Padding Bottom
       * @see https://tailwindcss.com/docs/padding
       */
      pb: [{
        pb: [L]
      }],
      /**
       * Padding Left
       * @see https://tailwindcss.com/docs/padding
       */
      pl: [{
        pl: [L]
      }],
      /**
       * Margin
       * @see https://tailwindcss.com/docs/margin
       */
      m: [{
        m: [_]
      }],
      /**
       * Margin X
       * @see https://tailwindcss.com/docs/margin
       */
      mx: [{
        mx: [_]
      }],
      /**
       * Margin Y
       * @see https://tailwindcss.com/docs/margin
       */
      my: [{
        my: [_]
      }],
      /**
       * Margin Start
       * @see https://tailwindcss.com/docs/margin
       */
      ms: [{
        ms: [_]
      }],
      /**
       * Margin End
       * @see https://tailwindcss.com/docs/margin
       */
      me: [{
        me: [_]
      }],
      /**
       * Margin Top
       * @see https://tailwindcss.com/docs/margin
       */
      mt: [{
        mt: [_]
      }],
      /**
       * Margin Right
       * @see https://tailwindcss.com/docs/margin
       */
      mr: [{
        mr: [_]
      }],
      /**
       * Margin Bottom
       * @see https://tailwindcss.com/docs/margin
       */
      mb: [{
        mb: [_]
      }],
      /**
       * Margin Left
       * @see https://tailwindcss.com/docs/margin
       */
      ml: [{
        ml: [_]
      }],
      /**
       * Space Between X
       * @see https://tailwindcss.com/docs/space
       */
      "space-x": [{
        "space-x": [U]
      }],
      /**
       * Space Between X Reverse
       * @see https://tailwindcss.com/docs/space
       */
      "space-x-reverse": ["space-x-reverse"],
      /**
       * Space Between Y
       * @see https://tailwindcss.com/docs/space
       */
      "space-y": [{
        "space-y": [U]
      }],
      /**
       * Space Between Y Reverse
       * @see https://tailwindcss.com/docs/space
       */
      "space-y-reverse": ["space-y-reverse"],
      // Sizing
      /**
       * Width
       * @see https://tailwindcss.com/docs/width
       */
      w: [{
        w: ["auto", "min", "max", "fit", _e, t]
      }],
      /**
       * Min-Width
       * @see https://tailwindcss.com/docs/min-width
       */
      "min-w": [{
        "min-w": ["min", "max", "fit", _e, St]
      }],
      /**
       * Max-Width
       * @see https://tailwindcss.com/docs/max-width
       */
      "max-w": [{
        "max-w": ["0", "none", "full", "min", "max", "fit", "prose", {
          screen: [ta]
        }, ta, _e]
      }],
      /**
       * Height
       * @see https://tailwindcss.com/docs/height
       */
      h: [{
        h: [_e, t, "auto", "min", "max", "fit"]
      }],
      /**
       * Min-Height
       * @see https://tailwindcss.com/docs/min-height
       */
      "min-h": [{
        "min-h": ["min", "max", "fit", _e, St]
      }],
      /**
       * Max-Height
       * @see https://tailwindcss.com/docs/max-height
       */
      "max-h": [{
        "max-h": [_e, t, "min", "max", "fit"]
      }],
      // Typography
      /**
       * Font Size
       * @see https://tailwindcss.com/docs/font-size
       */
      "font-size": [{
        text: ["base", ta, W9]
      }],
      /**
       * Font Smoothing
       * @see https://tailwindcss.com/docs/font-smoothing
       */
      "font-smoothing": ["antialiased", "subpixel-antialiased"],
      /**
       * Font Style
       * @see https://tailwindcss.com/docs/font-style
       */
      "font-style": ["italic", "not-italic"],
      /**
       * Font Weight
       * @see https://tailwindcss.com/docs/font-weight
       */
      "font-weight": [{
        font: ["thin", "extralight", "light", "normal", "medium", "semibold", "bold", "extrabold", "black", P1]
      }],
      /**
       * Font Family
       * @see https://tailwindcss.com/docs/font-family
       */
      "font-family": [{
        font: [n1]
      }],
      /**
       * Font Variant Numeric
       * @see https://tailwindcss.com/docs/font-variant-numeric
       */
      "fvn-normal": ["normal-nums"],
      /**
       * Font Variant Numeric
       * @see https://tailwindcss.com/docs/font-variant-numeric
       */
      "fvn-ordinal": ["ordinal"],
      /**
       * Font Variant Numeric
       * @see https://tailwindcss.com/docs/font-variant-numeric
       */
      "fvn-slashed-zero": ["slashed-zero"],
      /**
       * Font Variant Numeric
       * @see https://tailwindcss.com/docs/font-variant-numeric
       */
      "fvn-figure": ["lining-nums", "oldstyle-nums"],
      /**
       * Font Variant Numeric
       * @see https://tailwindcss.com/docs/font-variant-numeric
       */
      "fvn-spacing": ["proportional-nums", "tabular-nums"],
      /**
       * Font Variant Numeric
       * @see https://tailwindcss.com/docs/font-variant-numeric
       */
      "fvn-fraction": ["diagonal-fractions", "stacked-fractons"],
      /**
       * Letter Spacing
       * @see https://tailwindcss.com/docs/letter-spacing
       */
      tracking: [{
        tracking: ["tighter", "tight", "normal", "wide", "wider", "widest", _e]
      }],
      /**
       * Line Clamp
       * @see https://tailwindcss.com/docs/line-clamp
       */
      "line-clamp": [{
        "line-clamp": ["none", gr, P1]
      }],
      /**
       * Line Height
       * @see https://tailwindcss.com/docs/line-height
       */
      leading: [{
        leading: ["none", "tight", "snug", "normal", "relaxed", "loose", _e, St]
      }],
      /**
       * List Style Image
       * @see https://tailwindcss.com/docs/list-style-image
       */
      "list-image": [{
        "list-image": ["none", _e]
      }],
      /**
       * List Style Type
       * @see https://tailwindcss.com/docs/list-style-type
       */
      "list-style-type": [{
        list: ["none", "disc", "decimal", _e]
      }],
      /**
       * List Style Position
       * @see https://tailwindcss.com/docs/list-style-position
       */
      "list-style-position": [{
        list: ["inside", "outside"]
      }],
      /**
       * Placeholder Color
       * @deprecated since Tailwind CSS v3.0.0
       * @see https://tailwindcss.com/docs/placeholder-color
       */
      "placeholder-color": [{
        placeholder: [e]
      }],
      /**
       * Placeholder Opacity
       * @see https://tailwindcss.com/docs/placeholder-opacity
       */
      "placeholder-opacity": [{
        "placeholder-opacity": [b]
      }],
      /**
       * Text Alignment
       * @see https://tailwindcss.com/docs/text-align
       */
      "text-alignment": [{
        text: ["left", "center", "right", "justify", "start", "end"]
      }],
      /**
       * Text Color
       * @see https://tailwindcss.com/docs/text-color
       */
      "text-color": [{
        text: [e]
      }],
      /**
       * Text Opacity
       * @see https://tailwindcss.com/docs/text-opacity
       */
      "text-opacity": [{
        "text-opacity": [b]
      }],
      /**
       * Text Decoration
       * @see https://tailwindcss.com/docs/text-decoration
       */
      "text-decoration": ["underline", "overline", "line-through", "no-underline"],
      /**
       * Text Decoration Style
       * @see https://tailwindcss.com/docs/text-decoration-style
       */
      "text-decoration-style": [{
        decoration: [].concat($(), ["wavy"])
      }],
      /**
       * Text Decoration Thickness
       * @see https://tailwindcss.com/docs/text-decoration-thickness
       */
      "text-decoration-thickness": [{
        decoration: ["auto", "from-font", St]
      }],
      /**
       * Text Underline Offset
       * @see https://tailwindcss.com/docs/text-underline-offset
       */
      "underline-offset": [{
        "underline-offset": ["auto", _e, St]
      }],
      /**
       * Text Decoration Color
       * @see https://tailwindcss.com/docs/text-decoration-color
       */
      "text-decoration-color": [{
        decoration: [e]
      }],
      /**
       * Text Transform
       * @see https://tailwindcss.com/docs/text-transform
       */
      "text-transform": ["uppercase", "lowercase", "capitalize", "normal-case"],
      /**
       * Text Overflow
       * @see https://tailwindcss.com/docs/text-overflow
       */
      "text-overflow": ["truncate", "text-ellipsis", "text-clip"],
      /**
       * Text Indent
       * @see https://tailwindcss.com/docs/text-indent
       */
      indent: [{
        indent: Z()
      }],
      /**
       * Vertical Alignment
       * @see https://tailwindcss.com/docs/vertical-align
       */
      "vertical-align": [{
        align: ["baseline", "top", "middle", "bottom", "text-top", "text-bottom", "sub", "super", _e]
      }],
      /**
       * Whitespace
       * @see https://tailwindcss.com/docs/whitespace
       */
      whitespace: [{
        whitespace: ["normal", "nowrap", "pre", "pre-line", "pre-wrap", "break-spaces"]
      }],
      /**
       * Word Break
       * @see https://tailwindcss.com/docs/word-break
       */
      break: [{
        break: ["normal", "words", "all", "keep"]
      }],
      /**
       * Hyphens
       * @see https://tailwindcss.com/docs/hyphens
       */
      hyphens: [{
        hyphens: ["none", "manual", "auto"]
      }],
      /**
       * Content
       * @see https://tailwindcss.com/docs/content
       */
      content: [{
        content: ["none", _e]
      }],
      // Backgrounds
      /**
       * Background Attachment
       * @see https://tailwindcss.com/docs/background-attachment
       */
      "bg-attachment": [{
        bg: ["fixed", "local", "scroll"]
      }],
      /**
       * Background Clip
       * @see https://tailwindcss.com/docs/background-clip
       */
      "bg-clip": [{
        "bg-clip": ["border", "padding", "content", "text"]
      }],
      /**
       * Background Opacity
       * @deprecated since Tailwind CSS v3.0.0
       * @see https://tailwindcss.com/docs/background-opacity
       */
      "bg-opacity": [{
        "bg-opacity": [b]
      }],
      /**
       * Background Origin
       * @see https://tailwindcss.com/docs/background-origin
       */
      "bg-origin": [{
        "bg-origin": ["border", "padding", "content"]
      }],
      /**
       * Background Position
       * @see https://tailwindcss.com/docs/background-position
       */
      "bg-position": [{
        bg: [].concat(A(), [HY])
      }],
      /**
       * Background Repeat
       * @see https://tailwindcss.com/docs/background-repeat
       */
      "bg-repeat": [{
        bg: ["no-repeat", {
          repeat: ["", "x", "y", "round", "space"]
        }]
      }],
      /**
       * Background Size
       * @see https://tailwindcss.com/docs/background-size
       */
      "bg-size": [{
        bg: ["auto", "cover", "contain", zY]
      }],
      /**
       * Background Image
       * @see https://tailwindcss.com/docs/background-image
       */
      "bg-image": [{
        bg: ["none", {
          "gradient-to": ["t", "tr", "r", "br", "b", "bl", "l", "tl"]
        }, jY]
      }],
      /**
       * Background Color
       * @see https://tailwindcss.com/docs/background-color
       */
      "bg-color": [{
        bg: [e]
      }],
      /**
       * Gradient Color Stops From Position
       * @see https://tailwindcss.com/docs/gradient-color-stops
       */
      "gradient-from-pos": [{
        from: [w]
      }],
      /**
       * Gradient Color Stops Via Position
       * @see https://tailwindcss.com/docs/gradient-color-stops
       */
      "gradient-via-pos": [{
        via: [w]
      }],
      /**
       * Gradient Color Stops To Position
       * @see https://tailwindcss.com/docs/gradient-color-stops
       */
      "gradient-to-pos": [{
        to: [w]
      }],
      /**
       * Gradient Color Stops From
       * @see https://tailwindcss.com/docs/gradient-color-stops
       */
      "gradient-from": [{
        from: [g]
      }],
      /**
       * Gradient Color Stops Via
       * @see https://tailwindcss.com/docs/gradient-color-stops
       */
      "gradient-via": [{
        via: [g]
      }],
      /**
       * Gradient Color Stops To
       * @see https://tailwindcss.com/docs/gradient-color-stops
       */
      "gradient-to": [{
        to: [g]
      }],
      // Borders
      /**
       * Border Radius
       * @see https://tailwindcss.com/docs/border-radius
       */
      rounded: [{
        rounded: [i]
      }],
      /**
       * Border Radius Start
       * @see https://tailwindcss.com/docs/border-radius
       */
      "rounded-s": [{
        "rounded-s": [i]
      }],
      /**
       * Border Radius End
       * @see https://tailwindcss.com/docs/border-radius
       */
      "rounded-e": [{
        "rounded-e": [i]
      }],
      /**
       * Border Radius Top
       * @see https://tailwindcss.com/docs/border-radius
       */
      "rounded-t": [{
        "rounded-t": [i]
      }],
      /**
       * Border Radius Right
       * @see https://tailwindcss.com/docs/border-radius
       */
      "rounded-r": [{
        "rounded-r": [i]
      }],
      /**
       * Border Radius Bottom
       * @see https://tailwindcss.com/docs/border-radius
       */
      "rounded-b": [{
        "rounded-b": [i]
      }],
      /**
       * Border Radius Left
       * @see https://tailwindcss.com/docs/border-radius
       */
      "rounded-l": [{
        "rounded-l": [i]
      }],
      /**
       * Border Radius Start Start
       * @see https://tailwindcss.com/docs/border-radius
       */
      "rounded-ss": [{
        "rounded-ss": [i]
      }],
      /**
       * Border Radius Start End
       * @see https://tailwindcss.com/docs/border-radius
       */
      "rounded-se": [{
        "rounded-se": [i]
      }],
      /**
       * Border Radius End End
       * @see https://tailwindcss.com/docs/border-radius
       */
      "rounded-ee": [{
        "rounded-ee": [i]
      }],
      /**
       * Border Radius End Start
       * @see https://tailwindcss.com/docs/border-radius
       */
      "rounded-es": [{
        "rounded-es": [i]
      }],
      /**
       * Border Radius Top Left
       * @see https://tailwindcss.com/docs/border-radius
       */
      "rounded-tl": [{
        "rounded-tl": [i]
      }],
      /**
       * Border Radius Top Right
       * @see https://tailwindcss.com/docs/border-radius
       */
      "rounded-tr": [{
        "rounded-tr": [i]
      }],
      /**
       * Border Radius Bottom Right
       * @see https://tailwindcss.com/docs/border-radius
       */
      "rounded-br": [{
        "rounded-br": [i]
      }],
      /**
       * Border Radius Bottom Left
       * @see https://tailwindcss.com/docs/border-radius
       */
      "rounded-bl": [{
        "rounded-bl": [i]
      }],
      /**
       * Border Width
       * @see https://tailwindcss.com/docs/border-width
       */
      "border-w": [{
        border: [c]
      }],
      /**
       * Border Width X
       * @see https://tailwindcss.com/docs/border-width
       */
      "border-w-x": [{
        "border-x": [c]
      }],
      /**
       * Border Width Y
       * @see https://tailwindcss.com/docs/border-width
       */
      "border-w-y": [{
        "border-y": [c]
      }],
      /**
       * Border Width Start
       * @see https://tailwindcss.com/docs/border-width
       */
      "border-w-s": [{
        "border-s": [c]
      }],
      /**
       * Border Width End
       * @see https://tailwindcss.com/docs/border-width
       */
      "border-w-e": [{
        "border-e": [c]
      }],
      /**
       * Border Width Top
       * @see https://tailwindcss.com/docs/border-width
       */
      "border-w-t": [{
        "border-t": [c]
      }],
      /**
       * Border Width Right
       * @see https://tailwindcss.com/docs/border-width
       */
      "border-w-r": [{
        "border-r": [c]
      }],
      /**
       * Border Width Bottom
       * @see https://tailwindcss.com/docs/border-width
       */
      "border-w-b": [{
        "border-b": [c]
      }],
      /**
       * Border Width Left
       * @see https://tailwindcss.com/docs/border-width
       */
      "border-w-l": [{
        "border-l": [c]
      }],
      /**
       * Border Opacity
       * @see https://tailwindcss.com/docs/border-opacity
       */
      "border-opacity": [{
        "border-opacity": [b]
      }],
      /**
       * Border Style
       * @see https://tailwindcss.com/docs/border-style
       */
      "border-style": [{
        border: [].concat($(), ["hidden"])
      }],
      /**
       * Divide Width X
       * @see https://tailwindcss.com/docs/divide-width
       */
      "divide-x": [{
        "divide-x": [c]
      }],
      /**
       * Divide Width X Reverse
       * @see https://tailwindcss.com/docs/divide-width
       */
      "divide-x-reverse": ["divide-x-reverse"],
      /**
       * Divide Width Y
       * @see https://tailwindcss.com/docs/divide-width
       */
      "divide-y": [{
        "divide-y": [c]
      }],
      /**
       * Divide Width Y Reverse
       * @see https://tailwindcss.com/docs/divide-width
       */
      "divide-y-reverse": ["divide-y-reverse"],
      /**
       * Divide Opacity
       * @see https://tailwindcss.com/docs/divide-opacity
       */
      "divide-opacity": [{
        "divide-opacity": [b]
      }],
      /**
       * Divide Style
       * @see https://tailwindcss.com/docs/divide-style
       */
      "divide-style": [{
        divide: $()
      }],
      /**
       * Border Color
       * @see https://tailwindcss.com/docs/border-color
       */
      "border-color": [{
        border: [n]
      }],
      /**
       * Border Color X
       * @see https://tailwindcss.com/docs/border-color
       */
      "border-color-x": [{
        "border-x": [n]
      }],
      /**
       * Border Color Y
       * @see https://tailwindcss.com/docs/border-color
       */
      "border-color-y": [{
        "border-y": [n]
      }],
      /**
       * Border Color Top
       * @see https://tailwindcss.com/docs/border-color
       */
      "border-color-t": [{
        "border-t": [n]
      }],
      /**
       * Border Color Right
       * @see https://tailwindcss.com/docs/border-color
       */
      "border-color-r": [{
        "border-r": [n]
      }],
      /**
       * Border Color Bottom
       * @see https://tailwindcss.com/docs/border-color
       */
      "border-color-b": [{
        "border-b": [n]
      }],
      /**
       * Border Color Left
       * @see https://tailwindcss.com/docs/border-color
       */
      "border-color-l": [{
        "border-l": [n]
      }],
      /**
       * Divide Color
       * @see https://tailwindcss.com/docs/divide-color
       */
      "divide-color": [{
        divide: [n]
      }],
      /**
       * Outline Style
       * @see https://tailwindcss.com/docs/outline-style
       */
      "outline-style": [{
        outline: [""].concat($())
      }],
      /**
       * Outline Offset
       * @see https://tailwindcss.com/docs/outline-offset
       */
      "outline-offset": [{
        "outline-offset": [_e, St]
      }],
      /**
       * Outline Width
       * @see https://tailwindcss.com/docs/outline-width
       */
      "outline-w": [{
        outline: [St]
      }],
      /**
       * Outline Color
       * @see https://tailwindcss.com/docs/outline-color
       */
      "outline-color": [{
        outline: [e]
      }],
      /**
       * Ring Width
       * @see https://tailwindcss.com/docs/ring-width
       */
      "ring-w": [{
        ring: re()
      }],
      /**
       * Ring Width Inset
       * @see https://tailwindcss.com/docs/ring-width
       */
      "ring-w-inset": ["ring-inset"],
      /**
       * Ring Color
       * @see https://tailwindcss.com/docs/ring-color
       */
      "ring-color": [{
        ring: [e]
      }],
      /**
       * Ring Opacity
       * @see https://tailwindcss.com/docs/ring-opacity
       */
      "ring-opacity": [{
        "ring-opacity": [b]
      }],
      /**
       * Ring Offset Width
       * @see https://tailwindcss.com/docs/ring-offset-width
       */
      "ring-offset-w": [{
        "ring-offset": [St]
      }],
      /**
       * Ring Offset Color
       * @see https://tailwindcss.com/docs/ring-offset-color
       */
      "ring-offset-color": [{
        "ring-offset": [e]
      }],
      // Effects
      /**
       * Box Shadow
       * @see https://tailwindcss.com/docs/box-shadow
       */
      shadow: [{
        shadow: ["", "inner", "none", ta, OY]
      }],
      /**
       * Box Shadow Color
       * @see https://tailwindcss.com/docs/box-shadow-color
       */
      "shadow-color": [{
        shadow: [n1]
      }],
      /**
       * Opacity
       * @see https://tailwindcss.com/docs/opacity
       */
      opacity: [{
        opacity: [b]
      }],
      /**
       * Mix Blend Mode
       * @see https://tailwindcss.com/docs/mix-blend-mode
       */
      "mix-blend": [{
        "mix-blend": R()
      }],
      /**
       * Background Blend Mode
       * @see https://tailwindcss.com/docs/background-blend-mode
       */
      "bg-blend": [{
        "bg-blend": R()
      }],
      // Filters
      /**
       * Filter
       * @deprecated since Tailwind CSS v3.0.0
       * @see https://tailwindcss.com/docs/filter
       */
      filter: [{
        filter: ["", "none"]
      }],
      /**
       * Blur
       * @see https://tailwindcss.com/docs/blur
       */
      blur: [{
        blur: [a]
      }],
      /**
       * Brightness
       * @see https://tailwindcss.com/docs/brightness
       */
      brightness: [{
        brightness: [o]
      }],
      /**
       * Contrast
       * @see https://tailwindcss.com/docs/contrast
       */
      contrast: [{
        contrast: [s]
      }],
      /**
       * Drop Shadow
       * @see https://tailwindcss.com/docs/drop-shadow
       */
      "drop-shadow": [{
        "drop-shadow": ["", "none", ta, _e]
      }],
      /**
       * Grayscale
       * @see https://tailwindcss.com/docs/grayscale
       */
      grayscale: [{
        grayscale: [h]
      }],
      /**
       * Hue Rotate
       * @see https://tailwindcss.com/docs/hue-rotate
       */
      "hue-rotate": [{
        "hue-rotate": [m]
      }],
      /**
       * Invert
       * @see https://tailwindcss.com/docs/invert
       */
      invert: [{
        invert: [p]
      }],
      /**
       * Saturate
       * @see https://tailwindcss.com/docs/saturate
       */
      saturate: [{
        saturate: [j]
      }],
      /**
       * Sepia
       * @see https://tailwindcss.com/docs/sepia
       */
      sepia: [{
        sepia: [C]
      }],
      /**
       * Backdrop Filter
       * @deprecated since Tailwind CSS v3.0.0
       * @see https://tailwindcss.com/docs/backdrop-filter
       */
      "backdrop-filter": [{
        "backdrop-filter": ["", "none"]
      }],
      /**
       * Backdrop Blur
       * @see https://tailwindcss.com/docs/backdrop-blur
       */
      "backdrop-blur": [{
        "backdrop-blur": [a]
      }],
      /**
       * Backdrop Brightness
       * @see https://tailwindcss.com/docs/backdrop-brightness
       */
      "backdrop-brightness": [{
        "backdrop-brightness": [o]
      }],
      /**
       * Backdrop Contrast
       * @see https://tailwindcss.com/docs/backdrop-contrast
       */
      "backdrop-contrast": [{
        "backdrop-contrast": [s]
      }],
      /**
       * Backdrop Grayscale
       * @see https://tailwindcss.com/docs/backdrop-grayscale
       */
      "backdrop-grayscale": [{
        "backdrop-grayscale": [h]
      }],
      /**
       * Backdrop Hue Rotate
       * @see https://tailwindcss.com/docs/backdrop-hue-rotate
       */
      "backdrop-hue-rotate": [{
        "backdrop-hue-rotate": [m]
      }],
      /**
       * Backdrop Invert
       * @see https://tailwindcss.com/docs/backdrop-invert
       */
      "backdrop-invert": [{
        "backdrop-invert": [p]
      }],
      /**
       * Backdrop Opacity
       * @see https://tailwindcss.com/docs/backdrop-opacity
       */
      "backdrop-opacity": [{
        "backdrop-opacity": [b]
      }],
      /**
       * Backdrop Saturate
       * @see https://tailwindcss.com/docs/backdrop-saturate
       */
      "backdrop-saturate": [{
        "backdrop-saturate": [j]
      }],
      /**
       * Backdrop Sepia
       * @see https://tailwindcss.com/docs/backdrop-sepia
       */
      "backdrop-sepia": [{
        "backdrop-sepia": [C]
      }],
      // Tables
      /**
       * Border Collapse
       * @see https://tailwindcss.com/docs/border-collapse
       */
      "border-collapse": [{
        border: ["collapse", "separate"]
      }],
      /**
       * Border Spacing
       * @see https://tailwindcss.com/docs/border-spacing
       */
      "border-spacing": [{
        "border-spacing": [l]
      }],
      /**
       * Border Spacing X
       * @see https://tailwindcss.com/docs/border-spacing
       */
      "border-spacing-x": [{
        "border-spacing-x": [l]
      }],
      /**
       * Border Spacing Y
       * @see https://tailwindcss.com/docs/border-spacing
       */
      "border-spacing-y": [{
        "border-spacing-y": [l]
      }],
      /**
       * Table Layout
       * @see https://tailwindcss.com/docs/table-layout
       */
      "table-layout": [{
        table: ["auto", "fixed"]
      }],
      /**
       * Caption Side
       * @see https://tailwindcss.com/docs/caption-side
       */
      caption: [{
        caption: ["top", "bottom"]
      }],
      // Transitions and Animation
      /**
       * Tranisition Property
       * @see https://tailwindcss.com/docs/transition-property
       */
      transition: [{
        transition: ["none", "all", "", "colors", "opacity", "shadow", "transform", _e]
      }],
      /**
       * Transition Duration
       * @see https://tailwindcss.com/docs/transition-duration
       */
      duration: [{
        duration: E()
      }],
      /**
       * Transition Timing Function
       * @see https://tailwindcss.com/docs/transition-timing-function
       */
      ease: [{
        ease: ["linear", "in", "out", "in-out", _e]
      }],
      /**
       * Transition Delay
       * @see https://tailwindcss.com/docs/transition-delay
       */
      delay: [{
        delay: E()
      }],
      /**
       * Animation
       * @see https://tailwindcss.com/docs/animation
       */
      animate: [{
        animate: ["none", "spin", "ping", "pulse", "bounce", _e]
      }],
      // Transforms
      /**
       * Transform
       * @see https://tailwindcss.com/docs/transform
       */
      transform: [{
        transform: ["", "gpu", "none"]
      }],
      /**
       * Scale
       * @see https://tailwindcss.com/docs/scale
       */
      scale: [{
        scale: [I]
      }],
      /**
       * Scale X
       * @see https://tailwindcss.com/docs/scale
       */
      "scale-x": [{
        "scale-x": [I]
      }],
      /**
       * Scale Y
       * @see https://tailwindcss.com/docs/scale
       */
      "scale-y": [{
        "scale-y": [I]
      }],
      /**
       * Rotate
       * @see https://tailwindcss.com/docs/rotate
       */
      rotate: [{
        rotate: [a1, _e]
      }],
      /**
       * Translate X
       * @see https://tailwindcss.com/docs/translate
       */
      "translate-x": [{
        "translate-x": [de]
      }],
      /**
       * Translate Y
       * @see https://tailwindcss.com/docs/translate
       */
      "translate-y": [{
        "translate-y": [de]
      }],
      /**
       * Skew X
       * @see https://tailwindcss.com/docs/skew
       */
      "skew-x": [{
        "skew-x": [B]
      }],
      /**
       * Skew Y
       * @see https://tailwindcss.com/docs/skew
       */
      "skew-y": [{
        "skew-y": [B]
      }],
      /**
       * Transform Origin
       * @see https://tailwindcss.com/docs/transform-origin
       */
      "transform-origin": [{
        origin: ["center", "top", "top-right", "right", "bottom-right", "bottom", "bottom-left", "left", "top-left", _e]
      }],
      // Interactivity
      /**
       * Accent Color
       * @see https://tailwindcss.com/docs/accent-color
       */
      accent: [{
        accent: ["auto", e]
      }],
      /**
       * Appearance
       * @see https://tailwindcss.com/docs/appearance
       */
      appearance: ["appearance-none"],
      /**
       * Cursor
       * @see https://tailwindcss.com/docs/cursor
       */
      cursor: [{
        cursor: ["auto", "default", "pointer", "wait", "text", "move", "help", "not-allowed", "none", "context-menu", "progress", "cell", "crosshair", "vertical-text", "alias", "copy", "no-drop", "grab", "grabbing", "all-scroll", "col-resize", "row-resize", "n-resize", "e-resize", "s-resize", "w-resize", "ne-resize", "nw-resize", "se-resize", "sw-resize", "ew-resize", "ns-resize", "nesw-resize", "nwse-resize", "zoom-in", "zoom-out", _e]
      }],
      /**
       * Caret Color
       * @see https://tailwindcss.com/docs/just-in-time-mode#caret-color-utilities
       */
      "caret-color": [{
        caret: [e]
      }],
      /**
       * Pointer Events
       * @see https://tailwindcss.com/docs/pointer-events
       */
      "pointer-events": [{
        "pointer-events": ["none", "auto"]
      }],
      /**
       * Resize
       * @see https://tailwindcss.com/docs/resize
       */
      resize: [{
        resize: ["none", "y", "x", ""]
      }],
      /**
       * Scroll Behavior
       * @see https://tailwindcss.com/docs/scroll-behavior
       */
      "scroll-behavior": [{
        scroll: ["auto", "smooth"]
      }],
      /**
       * Scroll Margin
       * @see https://tailwindcss.com/docs/scroll-margin
       */
      "scroll-m": [{
        "scroll-m": Z()
      }],
      /**
       * Scroll Margin X
       * @see https://tailwindcss.com/docs/scroll-margin
       */
      "scroll-mx": [{
        "scroll-mx": Z()
      }],
      /**
       * Scroll Margin Y
       * @see https://tailwindcss.com/docs/scroll-margin
       */
      "scroll-my": [{
        "scroll-my": Z()
      }],
      /**
       * Scroll Margin Start
       * @see https://tailwindcss.com/docs/scroll-margin
       */
      "scroll-ms": [{
        "scroll-ms": Z()
      }],
      /**
       * Scroll Margin End
       * @see https://tailwindcss.com/docs/scroll-margin
       */
      "scroll-me": [{
        "scroll-me": Z()
      }],
      /**
       * Scroll Margin Top
       * @see https://tailwindcss.com/docs/scroll-margin
       */
      "scroll-mt": [{
        "scroll-mt": Z()
      }],
      /**
       * Scroll Margin Right
       * @see https://tailwindcss.com/docs/scroll-margin
       */
      "scroll-mr": [{
        "scroll-mr": Z()
      }],
      /**
       * Scroll Margin Bottom
       * @see https://tailwindcss.com/docs/scroll-margin
       */
      "scroll-mb": [{
        "scroll-mb": Z()
      }],
      /**
       * Scroll Margin Left
       * @see https://tailwindcss.com/docs/scroll-margin
       */
      "scroll-ml": [{
        "scroll-ml": Z()
      }],
      /**
       * Scroll Padding
       * @see https://tailwindcss.com/docs/scroll-padding
       */
      "scroll-p": [{
        "scroll-p": Z()
      }],
      /**
       * Scroll Padding X
       * @see https://tailwindcss.com/docs/scroll-padding
       */
      "scroll-px": [{
        "scroll-px": Z()
      }],
      /**
       * Scroll Padding Y
       * @see https://tailwindcss.com/docs/scroll-padding
       */
      "scroll-py": [{
        "scroll-py": Z()
      }],
      /**
       * Scroll Padding Start
       * @see https://tailwindcss.com/docs/scroll-padding
       */
      "scroll-ps": [{
        "scroll-ps": Z()
      }],
      /**
       * Scroll Padding End
       * @see https://tailwindcss.com/docs/scroll-padding
       */
      "scroll-pe": [{
        "scroll-pe": Z()
      }],
      /**
       * Scroll Padding Top
       * @see https://tailwindcss.com/docs/scroll-padding
       */
      "scroll-pt": [{
        "scroll-pt": Z()
      }],
      /**
       * Scroll Padding Right
       * @see https://tailwindcss.com/docs/scroll-padding
       */
      "scroll-pr": [{
        "scroll-pr": Z()
      }],
      /**
       * Scroll Padding Bottom
       * @see https://tailwindcss.com/docs/scroll-padding
       */
      "scroll-pb": [{
        "scroll-pb": Z()
      }],
      /**
       * Scroll Padding Left
       * @see https://tailwindcss.com/docs/scroll-padding
       */
      "scroll-pl": [{
        "scroll-pl": Z()
      }],
      /**
       * Scroll Snap Align
       * @see https://tailwindcss.com/docs/scroll-snap-align
       */
      "snap-align": [{
        snap: ["start", "end", "center", "align-none"]
      }],
      /**
       * Scroll Snap Stop
       * @see https://tailwindcss.com/docs/scroll-snap-stop
       */
      "snap-stop": [{
        snap: ["normal", "always"]
      }],
      /**
       * Scroll Snap Type
       * @see https://tailwindcss.com/docs/scroll-snap-type
       */
      "snap-type": [{
        snap: ["none", "x", "y", "both"]
      }],
      /**
       * Scroll Snap Type Strictness
       * @see https://tailwindcss.com/docs/scroll-snap-type
       */
      "snap-strictness": [{
        snap: ["mandatory", "proximity"]
      }],
      /**
       * Touch Action
       * @see https://tailwindcss.com/docs/touch-action
       */
      touch: [{
        touch: ["auto", "none", "pinch-zoom", "manipulation", {
          pan: ["x", "left", "right", "y", "up", "down"]
        }]
      }],
      /**
       * User Select
       * @see https://tailwindcss.com/docs/user-select
       */
      select: [{
        select: ["none", "text", "all", "auto"]
      }],
      /**
       * Will Change
       * @see https://tailwindcss.com/docs/will-change
       */
      "will-change": [{
        "will-change": ["auto", "scroll", "contents", "transform", _e]
      }],
      // SVG
      /**
       * Fill
       * @see https://tailwindcss.com/docs/fill
       */
      fill: [{
        fill: [e, "none"]
      }],
      /**
       * Stroke Width
       * @see https://tailwindcss.com/docs/stroke-width
       */
      "stroke-w": [{
        stroke: [St, P1]
      }],
      /**
       * Stroke
       * @see https://tailwindcss.com/docs/stroke
       */
      stroke: [{
        stroke: [e, "none"]
      }],
      // Accessibility
      /**
       * Screen Readers
       * @see https://tailwindcss.com/docs/screen-readers
       */
      sr: ["sr-only", "not-sr-only"]
    },
    conflictingClassGroups: {
      overflow: ["overflow-x", "overflow-y"],
      overscroll: ["overscroll-x", "overscroll-y"],
      inset: ["inset-x", "inset-y", "start", "end", "top", "right", "bottom", "left"],
      "inset-x": ["right", "left"],
      "inset-y": ["top", "bottom"],
      flex: ["basis", "grow", "shrink"],
      gap: ["gap-x", "gap-y"],
      p: ["px", "py", "ps", "pe", "pt", "pr", "pb", "pl"],
      px: ["pr", "pl"],
      py: ["pt", "pb"],
      m: ["mx", "my", "ms", "me", "mt", "mr", "mb", "ml"],
      mx: ["mr", "ml"],
      my: ["mt", "mb"],
      "font-size": ["leading"],
      "fvn-normal": ["fvn-ordinal", "fvn-slashed-zero", "fvn-figure", "fvn-spacing", "fvn-fraction"],
      "fvn-ordinal": ["fvn-normal"],
      "fvn-slashed-zero": ["fvn-normal"],
      "fvn-figure": ["fvn-normal"],
      "fvn-spacing": ["fvn-normal"],
      "fvn-fraction": ["fvn-normal"],
      rounded: ["rounded-s", "rounded-e", "rounded-t", "rounded-r", "rounded-b", "rounded-l", "rounded-ss", "rounded-se", "rounded-ee", "rounded-es", "rounded-tl", "rounded-tr", "rounded-br", "rounded-bl"],
      "rounded-s": ["rounded-ss", "rounded-es"],
      "rounded-e": ["rounded-se", "rounded-ee"],
      "rounded-t": ["rounded-tl", "rounded-tr"],
      "rounded-r": ["rounded-tr", "rounded-br"],
      "rounded-b": ["rounded-br", "rounded-bl"],
      "rounded-l": ["rounded-tl", "rounded-bl"],
      "border-spacing": ["border-spacing-x", "border-spacing-y"],
      "border-w": ["border-w-s", "border-w-e", "border-w-t", "border-w-r", "border-w-b", "border-w-l"],
      "border-w-x": ["border-w-r", "border-w-l"],
      "border-w-y": ["border-w-t", "border-w-b"],
      "border-color": ["border-color-t", "border-color-r", "border-color-b", "border-color-l"],
      "border-color-x": ["border-color-r", "border-color-l"],
      "border-color-y": ["border-color-t", "border-color-b"],
      "scroll-m": ["scroll-mx", "scroll-my", "scroll-ms", "scroll-me", "scroll-mt", "scroll-mr", "scroll-mb", "scroll-ml"],
      "scroll-mx": ["scroll-mr", "scroll-ml"],
      "scroll-my": ["scroll-mt", "scroll-mb"],
      "scroll-p": ["scroll-px", "scroll-py", "scroll-ps", "scroll-pe", "scroll-pt", "scroll-pr", "scroll-pb", "scroll-pl"],
      "scroll-px": ["scroll-pr", "scroll-pl"],
      "scroll-py": ["scroll-pt", "scroll-pb"]
    },
    conflictingClassGroupModifiers: {
      "font-size": ["leading"]
    }
  };
}
var dI = /* @__PURE__ */ PY(UY);
function _t(e) {
  var h, m;
  const a = uI().type.__name, o = e.defaults, n = e.localProps, i = ((h = n.globalConfig) == null ? void 0 : h[a]) || ((m = N9("one-ui-config")) == null ? void 0 : m[a]), l = N(() => {
    let p = { ...n };
    return delete p.globalConfig, Fx({}, o == null ? void 0 : o.props, i == null ? void 0 : i.props, p);
  });
  JW(o.classes, i == null ? void 0 : i.classes);
  const c = Object.entries(l.value).map(([p, f]) => {
    if (typeof f == "boolean" && (f = f.toString()), f && !(f instanceof Object) && typeof f != "number")
      return `${p}${f.charAt(0).toUpperCase() + f.slice(1)}`;
  }).filter(Boolean);
  return N(() => {
    let p = l.value;
    return Object.entries(o.classes).forEach(([f, g]) => {
      var w, q;
      p[f] = {}, p[f].class = dI(
        g.commonClasses,
        (q = (w = i == null ? void 0 : i.classes) == null ? void 0 : w[f]) == null ? void 0 : q.commonClasses
      ), g.propsClasses && Object.entries(g.propsClasses).forEach(([_, b]) => {
        b._common && (p[f].class += ` ${b._common}`);
        const L = l.value[_], j = b[L];
        if (j instanceof Object) {
          j._common && (p[f].class += ` ${j._common}`);
          let I = !0;
          Object.entries(j).forEach(([C, B]) => {
            var U, de, ae, S, V;
            c.includes(C) && (I = !1, p[f].class += ` ${dI(
              B,
              (V = (S = (ae = (de = (U = i == null ? void 0 : i.classes) == null ? void 0 : U[f]) == null ? void 0 : de.propsClasses) == null ? void 0 : ae[_]) == null ? void 0 : S[L]) == null ? void 0 : V[C]
            )}`);
          }), I && (p[f].class += ` ${j._default}`);
        } else
          p[f].class += ` ${j}`;
      });
    }), p;
  });
}
const Tx = {
  __name: "OIcon",
  props: {
    name: {
      type: String
    },
    lucide: {
      type: String
    }
  },
  setup(e) {
    const t = /* @__PURE__ */ Object.assign({ "../icons/Progress.svg": () => import("./Progress-0e7f1674.js") }), a = e, o = N(() => {
      if (a.lucide)
        return pI[a.lucide];
      {
        const n = `${a.name}.svg`;
        return console.log({ icons: t, iconFileName: n }), console.log(t[`../icons/${n}`]), hI(() => t[`../icons/${n}`]());
      }
    });
    return (n, i) => (d(), Q(mt(o.value)));
  }
}, UG = {
  __name: "OButton",
  props: {
    /**
     * label
     */
    label: {
      type: [Boolean, String]
    },
    /**
     * label for secondary action
     */
    labelSecondary: {
      type: String
    },
    /**
     * button has double action (eg. delete button requires confirmation click)
     */
    doubleAction: {
      type: Boolean
    },
    /**
     * size (font + padding) [small | medium | large]
     */
    size: {
      type: String
    },
    /**
     * padding (only padding) [none | small | default | large]
     */
    padding: {
      type: String
    },
    /**
     * corner rounding [none | slight | full]
     */
    // TODO: could be: 'rectangular', 'rounded', 'pill'
    rounded: {
      type: String
    },
    /**
     * contextual background [dark | neutral | light]
     */
    context: {
      type: String,
      validator: function(e) {
        return ["dark", "neutral", "light"].indexOf(e) !== -1;
      }
    },
    /**
     * used for presetting props & overriding styles in Storybook. In userland, use provide('one-ui-config', {}) instead
     */
    globalConfig: {
      type: Object
    },
    locale: {
      type: String
    },
    /**
     * shape [solid | ghost | naked | plain]
     */
    kind: {
      type: String
    },
    /**
     * current status - mostly communicated as color [primary | secondary | success | error | disabled | [...custom globalConfig defined]]
     */
    status: {
      type: String
    },
    /**
     * progress (for showing loading indicator)
     */
    progress: {
      type: Boolean
    },
    /**
     * icon (for showing icon only)
     */
    icon: {
      type: Boolean
    },
    /**
     * icon from Lucide.dev (for showing icon)
     */
    iconLucide: {
      type: [Boolean, String]
    },
    /**
     * disabled
     */
    disabled: {
      type: Boolean
    }
  },
  emits: ["action"],
  setup(e, { emit: t }) {
    const a = e, o = t, n = {
      // default props need to be defined here, if defined in defineProps(), VUE will then set those even if undefined, therefore it will mess up the merging of local, global and user defined prop values
      props: {
        kind: "solid",
        status: "primary",
        rounded: "full",
        padding: "default",
        doubleAction: !1,
        icon: !1,
        disabled: !1
      },
      classes: {
        wrapper: {
          commonClasses: ""
          //"p-4 border",
        },
        button: {
          commonClasses: "flex flex-row justify-center items-center gap-2 font-element font-semibold transition-all duration-250 ease-in-out",
          propsClasses: {
            rounded: {
              none: "rounded-none",
              slight: "rounded-lg",
              full: "rounded-full"
            },
            padding: {
              large: "h-[52px] px-7",
              default: "h-[44px] px-4",
              small: "py-1 px-2",
              none: "p-0"
            },
            kind: {
              ghost: "outline outline-2 -outline-offset-2"
            },
            status: {
              // _common: "", // applied to all
              primary: {
                kindSolid: "bg-neutral-900 context-dark:bg-neutral-500 hover:bg-neutral-700 active:bg-neutral-900 text-white dark:bg-neutral-600 dark:text-neutral-200 dark:hover:bg-neutral-700 dark:active:bg-neutral-800",
                // roundedNone: "outline-red-500 outline outline-2 outline-offset-4", //just for testing purposes, if button is not rounded
                kindGhost: "outline-neutral-900 hover:outline-neutral-400 active:outline-neutral-900",
                kindNaked: "hover:bg-neutral-200 dark:hover:bg-neutral-800 active:bg-neutral-300",
                kindPlain: "text-neutral-900 hover:text-neutral-500 active:text-neutral-900"
              },
              secondary: {
                kindSolid: "bg-neutral-200 hover:bg-neutral-300 active:bg-neutral-400",
                kindGhost: "outline-neutral-200 hover:outline-neutral-400 active:outline-neutral-600",
                kindNaked: "text-neutral-500 hover:bg-neutral-200 active:bg-neutral-300",
                kindPlain: "text-neutral-500 hover:text-neutral-600 active:text-neutral-900"
              },
              success: {
                kindSolid: "bg-green-500 hover:bg-green-400 active:bg-green-500",
                kindGhost: "outline-green-500 hover:outline-green-400 active:outline-green-600",
                kindNaked: "text-green-500 hover:bg-green-100 active:bg-green-200",
                kindPlain: "text-green-500 hover:text-green-400 active:text-green-500"
              },
              error: {
                kindSolid: "bg-red-500 hover:bg-red-400 active:bg-red-500",
                kindGhost: "outline-red-500 hover:outline-red-400 active:outline-red-600",
                kindNaked: "text-red-500 hover:bg-red-100 dark:hover:bg-red-900 active:bg-red-200",
                kindPlain: "text-red-500 hover:text-red-400 active:text-red-500"
              },
              disabled: {
                _common: "cursor-not-allowed",
                // _common applied to all
                // _default: "", // _default applied when none of the following (kindSolid, kindGhost, kindNaked, kindPlain) is matched
                kindSolid: "bg-neutral-100 text-neutral-300",
                kindGhost: "bg-transparent outline-neutral-200 text-neutral-200",
                kindNaked: "bg-transparent text-neutral-200",
                kindPlain: "bg-transparent text-neutral-200"
              }
            }
          }
        }
      }
    };
    n.classes.wrapper.commonClasses += ` context-${a.context}`;
    const i = _t({ localProps: a, defaults: n }), l = W(i.value.label || !1);
    ot(
      () => a.label,
      (h) => {
        l.value = h;
      },
      {
        immediate: !0
      }
    ), ot(i, (h) => {
    });
    const c = W(0);
    function s() {
      i.value.disabled || (i.value.doubleAction ? (c.value++, c.value == 1 ? l.value = i.value.labelSecondary : c.value == 2 && (o("action"), c.value = 0)) : o("action"));
    }
    return (h, m) => (d(), y("div", P(X(u(i).wrapper)), [
      D("button", H(u(i).button, { onClick: s }), [
        u(i).progress ? (d(), Q(Tx, {
          key: 0,
          class: "animate-spin",
          name: "Progress"
        })) : v("", !0),
        u(i).iconLucide ? (d(), Q(Tx, {
          key: 1,
          lucide: u(i).iconLucide
        }, null, 8, ["lucide"])) : v("", !0),
        l.value && !u(i).icon ? (d(), y("span", P(H({ key: 2 }, u(i).text)), G(l.value), 17)) : u(i).icon ? v("", !0) : (d(), y("span", P(H({ key: 3 }, u(i).text)), G(u(Ux).get("element-button", null, u(i).locale)), 17))
      ], 16)
    ], 16));
  }
};
let q1;
const EY = new Uint8Array(16);
function WY() {
  if (!q1 && (q1 = typeof crypto < "u" && crypto.getRandomValues && crypto.getRandomValues.bind(crypto), !q1))
    throw new Error("crypto.getRandomValues() not supported. See https://github.com/uuidjs/uuid#getrandomvalues-not-supported");
  return q1(EY);
}
const lt = [];
for (let e = 0; e < 256; ++e)
  lt.push((e + 256).toString(16).slice(1));
function NY(e, t = 0) {
  return lt[e[t + 0]] + lt[e[t + 1]] + lt[e[t + 2]] + lt[e[t + 3]] + "-" + lt[e[t + 4]] + lt[e[t + 5]] + "-" + lt[e[t + 6]] + lt[e[t + 7]] + "-" + lt[e[t + 8]] + lt[e[t + 9]] + "-" + lt[e[t + 10]] + lt[e[t + 11]] + lt[e[t + 12]] + lt[e[t + 13]] + lt[e[t + 14]] + lt[e[t + 15]];
}
const ZY = typeof crypto < "u" && crypto.randomUUID && crypto.randomUUID.bind(crypto), sI = {
  randomUUID: ZY
};
function YY(e, t, a) {
  if (sI.randomUUID && !t && !e)
    return sI.randomUUID();
  e = e || {};
  const o = e.random || (e.rng || WY)();
  if (o[6] = o[6] & 15 | 64, o[8] = o[8] & 63 | 128, t) {
    a = a || 0;
    for (let n = 0; n < 16; ++n)
      t[a + n] = o[n];
    return t;
  }
  return NY(o);
}
const GY = {
  key: 0,
  class: "flex flex-col"
}, XY = {
  key: 1,
  class: "flex flex-col"
}, EG = {
  __name: "OInput",
  props: {
    /**
     * value
     */
    modelValue: {
      type: String
    },
    /**
     * langs
     */
    langs: {
      type: Array
    },
    /**
     * long (multiline)
     */
    long: {
      type: Boolean
    },
    /**
     * lowercase
     */
    lowercase: {
      type: Boolean
    },
    /**
     * nospace
     */
    nospace: {
      type: Boolean
    },
    regex: {
      type: [String, Boolean]
    },
    disabled: {
      type: Boolean
    },
    /** placeholder */
    placeholder: {
      type: String
    },
    /**
     * mode [view | edit]
     */
    mode: {
      type: String
    },
    /**
     * label
     */
    label: {
      type: String
    },
    /**
     * size (font + padding) [small | medium | large]
     */
    size: {
      type: String
    },
    /**
     * padding (only padding) [none | small | default | large]
     */
    padding: {
      type: String
    },
    /**
     * corner rounding [none | slight | full]
     */
    rounded: {
      type: String
    },
    /**
     * contextual background [dark | neutral | light]
     */
    context: {
      type: String,
      validator: function(e) {
        return ["dark", "neutral", "light"].indexOf(e) !== -1;
      }
    },
    /**
     * used for presetting props & overriding styles in Storybook. In userland, use provide('one-ui-config', {}) instead
     */
    globalConfig: {
      type: Object
    },
    locale: {
      type: String
    },
    /**
     * current status - mostly communicated as color [primary | secondary | success | error | disabled | [...custom globalConfig defined]]
     */
    status: {
      type: String
    },
    // how long to wait with emitting input event after typing has stopped
    debounce: {
      type: Number
    },
    // saving state indicator - init | saving | saved | error
    saveState: {
      // manual
      type: String
    },
    autoState: {
      // auto -> 'formSaveState' store necessary
      type: Boolean
    }
  },
  emits: [
    "update:modelValue",
    "keyup",
    "enter",
    "focus",
    "blur",
    "input-debounced",
    "mouseup"
  ],
  setup(e, { emit: t }) {
    const a = e, o = t, n = {
      // default props need to be defined here, if defined in defineProps(), VUE will then set those even if undefined, therefore it will mess up the merging of local, global and user defined prop values
      props: {
        status: "primary",
        rounded: "full",
        mode: "edit",
        padding: "default",
        lowercase: !1,
        nospace: !1,
        regex: !1,
        disabled: !1,
        debounce: 750,
        saveState: "init",
        autoState: !1
      },
      classes: {
        wrapper: {
          commonClasses: "@container"
          //"p-4 border",
        },
        container: {
          commonClasses: "shadow-[0_1px_0px_0px,0_-1px_0px_0px] @sm:shadow-none shadow-neutral-200 @sm:outline @sm:outline-1 @sm:outline-neutral-200 @sm:hover:outline-neutral-300 px-4 py-4 min-h-[58px] @sm:rounded-lg flex flex-col justify-center mt-2"
        },
        // input: {
        //   commonClasses:
        //     "font-element font-semibold transition-all duration-250 ease-in-out border dark:border-neutral-700 dark:bg-neutral-800 font-element",
        //   propsClasses: {
        //     padding: {
        //       large: "h-[52px] px-7",
        //       default: "h-[44px] px-2",
        //       small: "py-1 px-2",
        //       none: "p-0",
        //     },
        //   },
        // },
        inputField: {
          commonClasses: "",
          propsClasses: {
            mode: {
              edit: "",
              view: "pl-4 whitespace-pre-wrap"
            }
          }
        },
        inputLabel: {
          commonClasses: "font-bold text-neutral-600 pl-4 font-element"
        },
        placeholder: {
          commonClasses: "font-normal text-neutral-400 absolute pointer-events-none font-element"
        }
      }
    };
    n.classes.wrapper.commonClasses += ` context-${a.context}`;
    const i = _t({ localProps: a, defaults: n }), l = ia(a, "modelValue"), c = W(!1), s = N(() => a.placeholder && !l.value && !c.value), h = ib.debounce(function(C, B) {
      j(C, B);
    }, a.debounce), m = YY();
    function p(C) {
      const B = C;
      if (!a.placeholder)
        B ? s.value[B] = !1 : s.value = !1;
      else {
        let U = !0;
        B ? (a.modelValue && a.modelValue[B] && a.modelValue[B].length > 0 && (U = !1), s.value[B] = U) : setTimeout(() => {
          a.modelValue && a.modelValue.length > 0 && (U = !1), s.value = U;
        }, 50);
      }
    }
    function f() {
      a.autoState && (a.langs ? a.langs.forEach((C) => {
        s.value[C] = !1, p(C);
      }) : p());
    }
    function g(C) {
      o("keyup", C);
    }
    function w(C) {
      o("enter", C);
    }
    function q() {
      c.value = !0, o("focus");
    }
    function _() {
      c.value = !1, o("blur");
    }
    function b(C) {
      o("mouseup", C);
    }
    function L(C, B) {
      console.log("Input.vue: onInput", C, B), p(B), I(C, B), h(C, B);
    }
    function j(C, B) {
      let U = a.langs ? l : C, de = B ? `${m}-${B}` : m;
      o("input-debounced", U, { fieldId: de, lang: B });
    }
    function I(C, B) {
      let U = a.langs ? l : C;
      console.log("emitInput()", C, l, U);
      let de = B ? `${m}-${B}` : m;
      o("update:modelValue", U, { fieldId: de, lang: B });
    }
    return at(async () => {
    }), f(), (C, B) => (d(), y("div", P(X(u(i).wrapper)), [
      u(i).mode == "edit" ? (d(), y("div", GY, [
        u(i).label ? (d(), y("span", P(H({ key: 0 }, u(i).inputLabel)), G(u(i).label), 17)) : v("", !0),
        D("div", P(X(u(i).container)), [
          s.value ? (d(), y("span", P(H({ key: 0 }, u(i).placeholder)), G(a.placeholder), 17)) : v("", !0),
          be(jI, H(u(i).inputField, {
            modelValue: l.value,
            "onUpdate:modelValue": [
              B[0] || (B[0] = (U) => l.value = U),
              L
            ],
            multiline: e.long,
            lowercase: e.lowercase,
            nospace: e.nospace,
            regex: e.regex,
            disabled: e.disabled,
            mode: e.mode,
            onPaste: L,
            onKeyup: g,
            onFocus: q,
            onBlur: _,
            onEnter: w,
            onMouseup: b
          }), null, 16, ["modelValue", "multiline", "lowercase", "nospace", "regex", "disabled", "mode"])
        ], 16)
      ])) : v("", !0),
      u(i).mode == "view" ? (d(), y("div", XY, [
        u(i).label ? (d(), y("span", P(H({ key: 0 }, u(i).inputLabel)), G(u(i).label), 17)) : v("", !0),
        D("p", P(X(u(i).inputField)), G(a.modelValue), 17)
      ])) : v("", !0)
    ], 16));
  }
}, KY = { class: "flex flex-col" }, QY = ["value"], JY = /* @__PURE__ */ D("option", { value: "" }, "---", -1), eG = ["value"], tG = { key: 1 }, WG = {
  __name: "OSelect",
  props: {
    /**
     * value
     */
    modelValue: {
      type: [String, Number]
    },
    /** options */
    options: {
      type: Array
    },
    /**
     * mode [view | edit]
     */
    mode: {
      type: String
    },
    /**
     * label
     */
    label: {
      type: String
    },
    /**
     * size (font + padding) [small | medium | large]
     */
    size: {
      type: String
    },
    /**
     * corner rounding [none | slight | full]
     */
    rounded: {
      type: String
    },
    /**
     * contextual background [dark | neutral | light]
     */
    context: {
      type: String,
      validator: function(e) {
        return ["dark", "neutral", "light"].indexOf(e) !== -1;
      }
    },
    /**
     * used for presetting props & overriding styles in Storybook. In userland, use provide('one-ui-config', {}) instead
     */
    globalConfig: {
      type: Object
    },
    locale: {
      type: String
    },
    /**
     * current status - mostly communicated as color [primary | secondary | success | error | disabled | [...custom globalConfig defined]]
     */
    status: {
      type: String
    }
  },
  emits: ["update:modelValue"],
  setup(e, { emit: t }) {
    const a = e, o = t, n = {
      // default props need to be defined here, if defined in defineProps(), VUE will then set those even if undefined, therefore it will mess up the merging of local, global and user defined prop values
      props: {
        status: "primary",
        rounded: "full"
      },
      classes: {
        wrapper: {
          commonClasses: ""
          //"p-4 border",
        },
        select: {
          commonClasses: "bg-transparent font-element font-semibold h-[52px] px-2 transition-all duration-250 ease-in-out border  dark:border-neutral-700 dark:bg-neutral-800",
          propsClasses: {}
        }
      }
    };
    n.classes.wrapper.commonClasses += ` context-${a.context}`;
    const i = _t({ localProps: a, defaults: n });
    function l(c) {
      console.log("onInput:", c.target.value), o("update:modelValue", c.target.value);
    }
    return (c, s) => (d(), y("div", P(X(u(i).wrapper)), [
      D("div", KY, [
        D("span", null, G(u(i).label), 1),
        e.mode == "edit" ? (d(), y("select", H({ key: 0 }, u(i).select, {
          value: a.modelValue,
          onInput: l
        }), [
          JY,
          (d(!0), y(ge, null, Ie(e.options, (h) => (d(), y("option", {
            value: h.value,
            key: h.value
          }, G(h.label), 9, eG))), 128))
        ], 16, QY)) : v("", !0),
        e.mode == "view" ? (d(), y("span", tG, G(a.modelValue), 1)) : v("", !0)
      ])
    ], 16));
  }
}, aG = { key: 1 }, NG = {
  __name: "OToggle",
  props: {
    /**
     * value
     */
    modelValue: {
      type: Boolean
    },
    /** label */
    label: {
      type: String
    },
    /**
     * mode [view | edit]
     */
    mode: {
      type: String
    },
    /**
     * size (font + padding) [small | medium | large]
     */
    size: {
      type: String
    },
    /**
     * padding (only padding) [none | small | default | large]
     */
    padding: {
      type: String
    },
    /**
     * corner rounding [none | slight | full]
     */
    rounded: {
      type: String
    },
    /**
     * contextual background [dark | neutral | light]
     */
    context: {
      type: String,
      validator: function(e) {
        return ["dark", "neutral", "light"].indexOf(e) !== -1;
      }
    },
    /**
     * used for presetting props & overriding styles in Storybook. In userland, use provide('one-ui-config', {}) instead
     */
    globalConfig: {
      type: Object
    },
    locale: {
      type: String
    },
    /**
     * current status - mostly communicated as color [primary | secondary | success | error | disabled | [...custom globalConfig defined]]
     */
    status: {
      type: String
    }
  },
  emits: ["update:model-value"],
  setup(e, { emit: t }) {
    const a = e, o = t, n = {
      // default props need to be defined here, if defined in defineProps(), VUE will then set those even if undefined, therefore it will mess up the merging of local, global and user defined prop values
      props: {
        status: "primary",
        rounded: "full",
        mode: "edit",
        padding: "default"
      },
      classes: {
        wrapper: {
          commonClasses: "cursor-pointer flex flex-row items-center gap-4"
          //"p-4 border",
        },
        label: {
          commonClasses: ""
        },
        toggle: {
          commonClasses: ""
        },
        toggleHandle: {
          commonClasses: "",
          propsClasses: {
            modelValue: {
              false: "left-1 bg-neutral-400",
              true: "right-1 bg-neutral-900"
            }
          }
        },
        input: {
          commonClasses: "font-element font-semibold transition-all duration-250 ease-in-out border",
          propsClasses: {
            padding: {
              large: "h-[52px] px-7",
              default: "h-[44px] px-2",
              small: "py-1 px-2",
              none: "p-0"
            }
          }
        }
      }
    };
    n.classes.wrapper.commonClasses += ` context-${a.context}`;
    const i = _t({ localProps: a, defaults: n });
    function l() {
      o("update:model-value", !a.modelValue);
    }
    return (c, s) => (d(), y("div", P(X(u(i).wrapper)), [
      u(i).mode == "edit" ? (d(), y("div", {
        key: 0,
        class: "relative h-[34px] w-16 rounded-full border border-neutral-300",
        onClick: l
      }, [
        D("div", {
          class: Pe(["absolute top-1 h-6 w-6 rounded-full", [
            { "left-1 bg-neutral-400": u(i).modelValue === !1 || !u(i).modelValue },
            { "right-1 bg-neutral-900": u(i).modelValue === !0 }
          ]])
        }, null, 2)
      ])) : v("", !0),
      u(i).mode == "view" ? (d(), y("div", aG, [
        u(i).modelValue === !1 || !u(i).modelValue ? (d(), Q(Tx, {
          key: 0,
          lucide: "X"
        })) : v("", !0),
        u(i).modelValue === !0 ? (d(), Q(Tx, {
          key: 1,
          lucide: "Check"
        })) : v("", !0)
      ])) : v("", !0),
      a.label ? (d(), y("span", P(H({ key: 2 }, u(i).label)), G(a.label), 17)) : v("", !0)
    ], 16));
  }
}, ZG = {
  __name: "Tag",
  props: {
    /**
     * label
     */
    label: {
      type: String
    },
    /**
     * size (font + padding) [small | medium | large]
     */
    size: {
      type: String
    },
    /**
     * padding (only padding) [none | small | default | large]
     */
    padding: {
      type: String
    },
    /**
     * corner rounding [none | slight | full]
     */
    rounded: {
      type: String
    },
    /**
     * contextual background [dark | neutral | light]
     */
    context: {
      type: String,
      validator: function(e) {
        return ["dark", "neutral", "light"].indexOf(e) !== -1;
      }
    },
    /**
     * used for presetting props & overriding styles in Storybook. In userland, use provide('one-ui-config', {}) instead
     */
    globalConfig: {
      type: Object
    },
    locale: {
      type: String
    },
    /**
     * shape [solid | ghost | plain]
     */
    kind: {
      type: String
    },
    /**
     * current status - mostly communicated as color [primary | secondary | [...custom globalConfig defined]]
     */
    status: {
      type: String
    }
  },
  setup(e) {
    const t = e, a = {
      // default props need to be defined here, if defined in defineProps(), VUE will then set those even if undefined, therefore it will mess up the merging of local, global and user defined prop values
      props: {
        kind: "solid",
        status: "primary",
        rounded: "slight",
        padding: "default"
      },
      classes: {
        wrapper: {
          commonClasses: "w-auto"
          //"p-4 border",
        },
        tag: {
          commonClasses: "inline-flex flex-row justify-center items-center gap-2 font-element font-semibold transition-all duration-250 ease-in-out",
          propsClasses: {
            rounded: {
              none: "rounded-none",
              slight: "rounded-md",
              full: "rounded-full"
            },
            padding: {
              large: "h-[52px] px-7",
              default: "h-[26px] px-2",
              small: "py-1 px-2",
              none: "p-0"
            },
            kind: {
              ghost: "outline outline-2 -outline-offset-2"
            },
            status: {
              // _common: "", // applied to all
              primary: {
                kindSolid: "bg-neutral-900 context-dark:bg-neutral-500 text-white dark:bg-neutral-600 dark:text-neutral-200",
                kindGhost: "outline-neutral-900",
                kindPlain: "bg-transparent"
              },
              secondary: {
                kindSolid: "bg-neutral-200",
                kindGhost: "outline-neutral-200",
                kindPlain: "bg-transparent"
              }
            }
          }
        },
        text: {
          commonClasses: "uppercase text-[0.8rem] font-bold"
        }
      }
    };
    a.classes.wrapper.commonClasses += ` context-${t.context}`;
    const o = _t({ localProps: t, defaults: a });
    return (n, i) => (d(), y("div", P(X(u(o).wrapper)), [
      D("div", P(X(u(o).tag)), [
        u(o).label ? (d(), y("span", P(H({ key: 0 }, u(o).text)), G(u(o).label), 17)) : (d(), y("span", P(H({ key: 1 }, u(o).text)), G(u(Ux).get("element-tag", null, u(o).locale)), 17))
      ], 16)
    ], 16));
  }
};
const nG = ["data-one-component"], YG = {
  __name: "OVideoYoutube",
  props: {
    code: {
      type: String
    },
    playlist: {
      type: Boolean,
      default: !1
    },
    autoplay: {
      type: Boolean,
      default: !1
    },
    mute: {
      type: Boolean,
      default: !1
    },
    controls: {
      type: Boolean,
      default: !0
    },
    allowFullscreen: {
      type: Boolean,
      default: !0
    },
    loop: {
      type: Boolean,
      default: !0
    },
    moreVideos: {
      type: Boolean,
      default: !1
    },
    // emit 'elapsed' event every N seconds
    elapsedInterval: {
      type: Number,
      default: 1
    }
  },
  emits: [
    "ready",
    "elapsed",
    "unstarted",
    "ended",
    "playing",
    "paused",
    "buffering",
    "cued",
    "stateChange",
    "playbackQualityChange",
    "playbackRateChange",
    "error"
  ],
  setup(e, { emit: t }) {
    const a = e, o = t, n = W(null), i = W(null), l = W(0), c = W(null);
    function s(j) {
      if (j === "playing") {
        const I = {
          interval: a.elapsedInterval,
          videoDuration: l.value,
          videoCurrentTime: Math.round(i.value.getCurrentTime()),
          videoCurrentPosition: Math.round(i.value.getCurrentTime() / l.value * 100)
        };
        I.videoCurrentTime > 0 && (o("elapsed", I), console.log("elapsed", I)), c.value = setTimeout(() => {
          s("playing");
        }, 1e3 * a.elapsedInterval);
      } else
        j === "paused" && clearTimeout(c.value);
    }
    function h(j) {
      console.log("player ready"), l.value = j.target.getDuration();
      const I = {
        videoDuration: l.value
      };
      o("ready", I), console.log("duration", I);
    }
    function m(j) {
      const I = Math.round(j.target.getCurrentTime()), C = Math.round(I / l.value * 100);
      console.log({ videoCurrentTime: I, videoCurrentPosition: C });
      const B = {
        interval: a.elapsedInterval,
        videoDuration: l.value,
        videoCurrentTime: I,
        videoCurrentPosition: C
      };
      switch (j.data) {
        case window.YT.PlayerState.UNSTARTED:
          o("unstarted", B), console.log("unstarted", B);
          break;
        case window.YT.PlayerState.ENDED:
          o("ended", B), console.log("ended", B);
          break;
        case window.YT.PlayerState.PLAYING:
          o("playing", B), s("playing"), console.log("playing", B);
          break;
        case window.YT.PlayerState.PAUSED:
          o("paused", B), s("paused"), console.log("paused", B);
          break;
        case window.YT.PlayerState.BUFFERING:
          o("buffering", B), console.log("buffering", B);
          break;
        case window.YT.PlayerState.CUED:
          o("cued", B), console.log("cued", B);
          break;
      }
      o("stateChange", B);
    }
    function p(j) {
      console.log("playback quality change"), o("playbackQualityChange", j.data);
    }
    function f(j) {
      console.log("playback rate change"), o("playbackRateChange", j.target);
    }
    function g(j) {
      console.log("error"), o("error", j.data);
    }
    function w(j) {
      console.log("api change"), o("apiChange", j.target);
    }
    async function q() {
      if (window.YT && window.YT.Player)
        L();
      else {
        const j = document.createElement("script");
        j.src = "https://www.youtube.com/iframe_api", j.id = "youtube-iframe-api";
        const I = document.getElementsByTagName("script")[0];
        document.getElementById("youtube-iframe-api") ? (await _(), L()) : (I.parentNode.insertBefore(j, I), window.onYouTubeIframeAPIReady = () => {
          L();
        });
      }
    }
    async function _() {
      return new Promise((j) => {
        window.YT && window.YT.Player ? j() : setTimeout(() => {
          _().then(() => {
            j();
          });
        }, 100);
      });
    }
    async function b() {
      q();
    }
    function L() {
      console.log("initializing video", a.code, window.YT), i.value = new window.YT.Player(n.value, {
        videoId: a.code,
        playerVars: {
          playsinline: 1,
          autoplay: a.autoplay,
          mute: a.mute,
          controls: a.controls,
          allowfullscreen: a.allowFullscreen,
          loop: a.loop,
          rel: a.moreVideos
        },
        events: {
          onReady: h,
          onStateChange: m,
          onPlaybackQualityChange: p,
          onPlaybackRateChange: f,
          onError: g,
          onApiChange: w
        }
      });
    }
    return at(() => {
      b();
    }), (j, I) => (d(), y("div", {
      class: "iframe-container",
      "data-one-component": j.$options.name
    }, [
      D("div", {
        ref_key: "playerContainer",
        ref: n
      }, null, 512)
    ], 8, nG));
  }
}, oG = {};
function rG(e, t) {
  return d(), y("tbody", null, [
    ee(e.$slots, "default")
  ]);
}
const iG = /* @__PURE__ */ Ex(oG, [["render", rG]]), lG = {
  __name: "TableCaption",
  props: {
    text: {
      type: String,
      default: ""
    }
  },
  setup(e) {
    const t = e, o = _t({ localProps: t, defaults: {
      // default props need to be defined here, if defined in defineProps(), VUE will then set those even if undefined, therefore it will mess up the merging of local, global and user defined prop values
      props: {},
      classes: {
        paragraph: {
          commonClasses: "text-neutral-400 text-center mt-2",
          propsClasses: {}
        }
      }
    } });
    return (n, i) => (d(), y("div", null, [
      D("p", P(X(u(o).paragraph)), G(t.text), 17)
    ]));
  }
}, cG = {
  __name: "TableCell",
  props: {
    density: {
      type: String
    }
  },
  setup(e) {
    const o = _t({ localProps: e, defaults: {
      // default props need to be defined here, if defined in defineProps(), VUE will then set those even if undefined, therefore it will mess up the merging of local, global and user defined prop values
      props: {
        density: "default"
      },
      classes: {
        td: {
          commonClasses: "border-t border-b px-2 first:pl-2 last:pr-2",
          propsClasses: {
            density: {
              compact: "py-1",
              default: "py-3",
              spacious: "py-5"
            }
          }
        }
      }
    } });
    return (n, i) => (d(), y("td", P(X(u(o).td)), [
      ee(n.$slots, "default")
    ], 16));
  }
}, dG = {
  __name: "TableHead",
  props: {},
  setup(e) {
    const o = _t({ localProps: e, defaults: {
      // default props need to be defined here, if defined in defineProps(), VUE will then set those even if undefined, therefore it will mess up the merging of local, global and user defined prop values
      props: {},
      classes: {
        th: {
          commonClasses: "uppercase text-[0.8rem] text-neutral-400 text-left pb-1 px-2 first:pl-2 last:pr-2",
          propsClasses: {}
        }
      }
    } });
    return (n, i) => (d(), y("th", P(X(u(o).th)), [
      ee(n.$slots, "default")
    ], 16));
  }
}, sG = {};
function uG(e, t) {
  return d(), y("thead", null, [
    ee(e.$slots, "default")
  ]);
}
const hG = /* @__PURE__ */ Ex(sG, [["render", uG]]), I9 = {
  __name: "TableRow",
  props: {},
  setup(e) {
    const o = _t({ localProps: e, defaults: {
      // default props need to be defined here, if defined in defineProps(), VUE will then set those even if undefined, therefore it will mess up the merging of local, global and user defined prop values
      props: {},
      classes: {
        tr: {
          commonClasses: "",
          propsClasses: {}
        }
      }
    } });
    return (n, i) => (d(), y("tr", P(X(u(o).tr)), [
      ee(n.$slots, "default")
    ], 16));
  }
}, pG = {};
function yG(e, t) {
  return d(), y("tfoot", null, [
    ee(e.$slots, "default")
  ]);
}
const kG = /* @__PURE__ */ Ex(pG, [["render", yG]]), fG = {
  __name: "TableFoot",
  props: {},
  setup(e) {
    const o = _t({ localProps: e, defaults: {
      // default props need to be defined here, if defined in defineProps(), VUE will then set those even if undefined, therefore it will mess up the merging of local, global and user defined prop values
      props: {},
      classes: {
        td: {
          commonClasses: "text-neutral-400 px-2 first:pl-2 last:pr-2",
          propsClasses: {}
        }
      }
    } });
    return (n, i) => (d(), y("td", P(X(u(o).td)), [
      ee(n.$slots, "default")
    ], 16));
  }
}, vG = { key: 0 }, mG = { key: 0 }, gG = { key: 1 }, MG = { key: 0 }, GG = {
  __name: "Table",
  props: {
    data: {
      type: Object
    }
  },
  setup(e) {
    const t = e, a = {
      // default props need to be defined here, if defined in defineProps(), VUE will then set those even if undefined, therefore it will mess up the merging of local, global and user defined prop values
      props: {
        kind: "solid",
        status: "primary",
        rounded: "full",
        padding: "default",
        doubleAction: !1,
        icon: !1
      },
      classes: {
        wrapper: {
          commonClasses: "w-full"
          //"p-4 border",
        },
        table: {
          commonClasses: "w-full"
        }
      }
    };
    a.classes.wrapper.commonClasses += ` context-${t.context}`;
    const o = _t({ localProps: t, defaults: a });
    return (n, i) => {
      var c, s, h, m;
      const l = Dx("RouterLink");
      return d(), y("div", P(X(u(o).wrapper)), [
        D("table", P(X(u(o).table)), [
          (c = t.data) != null && c.head ? (d(), Q(hG, { key: 0 }, {
            default: ke(() => [
              (d(!0), y(ge, null, Ie(t.data.head, (p, f) => (d(), Q(I9, { key: f }, {
                default: ke(() => [
                  (d(!0), y(ge, null, Ie(p, (g, w) => (d(), Q(dG, {
                    key: w,
                    class: Pe(g.classes)
                  }, {
                    default: ke(() => [
                      g.value ? (d(), y("div", vG, G(g.value), 1)) : v("", !0),
                      g.component ? (d(), Q(mt(g.component.component), P(H({ key: 1 }, g.component.props)), null, 16)) : v("", !0)
                    ]),
                    _: 2
                  }, 1032, ["class"]))), 128))
                ]),
                _: 2
              }, 1024))), 128))
            ]),
            _: 1
          })) : v("", !0),
          (s = t.data) != null && s.body ? (d(), Q(iG, { key: 1 }, {
            default: ke(() => [
              (d(!0), y(ge, null, Ie(t.data.body, (p, f) => (d(), Q(I9, { key: f }, {
                default: ke(() => [
                  (d(!0), y(ge, null, Ie(p, (g, w) => (d(), Q(cG, {
                    key: w,
                    class: Pe(g.classes)
                  }, {
                    default: ke(() => [
                      g.link && g.link.to ? (d(), Q(l, {
                        key: 0,
                        to: g.link.to
                      }, {
                        default: ke(() => [
                          g.value ? (d(), y("span", mG, G(g.value), 1)) : v("", !0)
                        ]),
                        _: 2
                      }, 1032, ["to"])) : v("", !0),
                      !g.link && g.value ? (d(), y("span", gG, G(g.value), 1)) : v("", !0),
                      g.component ? (d(), Q(mt(g.component.component), H({ key: 2 }, g.component.props, {
                        onClick: (q) => g.component.props.click(g)
                      }), null, 16, ["onClick"])) : v("", !0)
                    ]),
                    _: 2
                  }, 1032, ["class"]))), 128))
                ]),
                _: 2
              }, 1024))), 128))
            ]),
            _: 1
          })) : v("", !0),
          (h = t.data) != null && h.foot ? (d(), Q(kG, { key: 2 }, {
            default: ke(() => [
              (d(!0), y(ge, null, Ie(t.data.foot, (p, f) => (d(), Q(I9, { key: f }, {
                default: ke(() => [
                  (d(!0), y(ge, null, Ie(p, (g, w) => (d(), Q(fG, {
                    key: w,
                    class: Pe(g.classes)
                  }, {
                    default: ke(() => [
                      g.value ? (d(), y("div", MG, G(g.value), 1)) : v("", !0),
                      g.component ? (d(), Q(mt(g.component.component), P(H({ key: 1 }, g.component.props)), null, 16)) : v("", !0)
                    ]),
                    _: 2
                  }, 1032, ["class"]))), 128))
                ]),
                _: 2
              }, 1024))), 128))
            ]),
            _: 1
          })) : v("", !0)
        ], 16),
        (m = t.data) != null && m.caption ? (d(), Q(lG, {
          key: 0,
          text: t.data.caption
        }, null, 8, ["text"])) : v("", !0)
      ], 16);
    };
  }
};
export {
  UG as OButton,
  Tx as OIcon,
  EG as OInput,
  WG as OSelect,
  GG as OTable,
  ZG as OTag,
  NG as OToggle,
  YG as OVideoYoutube,
  bt as OneButton,
  HI as OneCheckbox,
  bx as OneChip,
  bG as OneChips,
  LG as OneDatepicker,
  SG as OneDialog,
  We as OneIcon,
  IG as OneImageCDN,
  Wx as OneInput,
  wG as OneInputMulti,
  ca as OneLayoutContainer,
  RZ as OneMenuFloating,
  RG as OneNotifications,
  oN as OneProductItemList,
  _b as OneProgress,
  CG as OneRadio,
  qG as OneSectionFooter,
  TG as OneSectionGallery,
  DG as OneSectionHeader,
  _G as OneSectionHeadlineTextImageCTA,
  BG as OneSectionHero,
  zG as OneSectionProductItemDetail,
  HG as OneSectionProductItemList,
  jG as OneSectionSpacer,
  VG as OneSelect,
  AG as OneSwitch,
  PG as OneTable,
  Ir as OneText,
  OG as OneTextBox,
  _Z as OneToast,
  $G as OneToggle,
  FG as OneViewAdmin
};
//# sourceMappingURL=framework.one.es.js.map
